var $N = Object.defineProperty;
var wb = (t) => {
  throw TypeError(t);
};
var LN = (t, e, r) => e in t ? $N(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Mr = (t, e, r) => LN(t, typeof e != "symbol" ? e + "" : e, r), Q5 = (t, e, r) => e.has(t) || wb("Cannot " + r);
var or = (t, e, r) => (Q5(t, e, "read from private field"), r ? r.call(t) : e.get(t)), lr = (t, e, r) => e.has(t) ? wb("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), Wf = (t, e, r, i) => (Q5(t, e, "write to private field"), i ? i.call(t, r) : e.set(t, r), r), Le = (t, e, r) => (Q5(t, e, "access private method"), r);
import { jsx as $t, jsxs as Ve, Fragment as Ra } from "react/jsx-runtime";
import * as pt from "react";
import Bt, { useDebugValue as xb, createElement as uA, useRef as Sn, useContext as Kr, createContext as g0, useLayoutEffect as Ug, useEffect as Tn, useInsertionEffect as hA, useCallback as Js, useMemo as en, forwardRef as kn, useId as mr, useState as cn, cloneElement as NN, Children as BN, isValidElement as fA } from "react";
import { Page as jN, pdfjs as dA, Document as UN } from "react-pdf";
import * as gA from "react-dom";
import { createPortal as pA } from "react-dom";
import { DayPicker as HN } from "react-day-picker";
function mA(t) {
  var e, r, i = "";
  if (typeof t == "string" || typeof t == "number") i += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var s = t.length;
    for (e = 0; e < s; e++) t[e] && (r = mA(t[e])) && (i && (i += " "), i += r);
  } else for (r in t) t[r] && (i && (i += " "), i += r);
  return i;
}
function VN() {
  for (var t, e, r = 0, i = "", s = arguments.length; r < s; r++) (t = arguments[r]) && (e = mA(t)) && (i && (i += " "), i += e);
  return i;
}
const B6 = "-", zN = (t) => {
  const e = qN(t), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: i
  } = t;
  return {
    getClassGroupId: (u) => {
      const l = u.split(B6);
      return l[0] === "" && l.length !== 1 && l.shift(), yA(l, e) || XN(u);
    },
    getConflictingClassGroupIds: (u, l) => {
      const f = r[u] || [];
      return l && i[u] ? [...f, ...i[u]] : f;
    }
  };
}, yA = (t, e) => {
  var u;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], i = e.nextPart.get(r), s = i ? yA(t.slice(1), i) : void 0;
  if (s)
    return s;
  if (e.validators.length === 0)
    return;
  const c = t.join(B6);
  return (u = e.validators.find(({
    validator: l
  }) => l(c))) == null ? void 0 : u.classGroupId;
}, Sb = /^\[(.+)\]$/, XN = (t) => {
  if (Sb.test(t)) {
    const e = Sb.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, qN = (t) => {
  const {
    theme: e,
    prefix: r
  } = t, i = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return GN(Object.entries(t.classGroups), r).forEach(([c, u]) => {
    x3(u, i, c, e);
  }), i;
}, x3 = (t, e, r, i) => {
  t.forEach((s) => {
    if (typeof s == "string") {
      const c = s === "" ? e : Cb(e, s);
      c.classGroupId = r;
      return;
    }
    if (typeof s == "function") {
      if (WN(s)) {
        x3(s(i), e, r, i);
        return;
      }
      e.validators.push({
        validator: s,
        classGroupId: r
      });
      return;
    }
    Object.entries(s).forEach(([c, u]) => {
      x3(u, Cb(e, c), r, i);
    });
  });
}, Cb = (t, e) => {
  let r = t;
  return e.split(B6).forEach((i) => {
    r.nextPart.has(i) || r.nextPart.set(i, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(i);
  }), r;
}, WN = (t) => t.isThemeGetter, GN = (t, e) => e ? t.map(([r, i]) => {
  const s = i.map((c) => typeof c == "string" ? e + c : typeof c == "object" ? Object.fromEntries(Object.entries(c).map(([u, l]) => [e + u, l])) : c);
  return [r, s];
}) : t, KN = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  const s = (c, u) => {
    r.set(c, u), e++, e > t && (e = 0, i = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(c) {
      let u = r.get(c);
      if (u !== void 0)
        return u;
      if ((u = i.get(c)) !== void 0)
        return s(c, u), u;
    },
    set(c, u) {
      r.has(c) ? r.set(c, u) : s(c, u);
    }
  };
}, bA = "!", YN = (t) => {
  const {
    separator: e,
    experimentalParseClassName: r
  } = t, i = e.length === 1, s = e[0], c = e.length, u = (l) => {
    const f = [];
    let o = 0, g = 0, p;
    for (let b = 0; b < l.length; b++) {
      let w = l[b];
      if (o === 0) {
        if (w === s && (i || l.slice(b, b + c) === e)) {
          f.push(l.slice(g, b)), g = b + c;
          continue;
        }
        if (w === "/") {
          p = b;
          continue;
        }
      }
      w === "[" ? o++ : w === "]" && o--;
    }
    const n = f.length === 0 ? l : l.substring(g), a = n.startsWith(bA), d = a ? n.substring(1) : n, m = p && p > g ? p - g : void 0;
    return {
      modifiers: f,
      hasImportantModifier: a,
      baseClassName: d,
      maybePostfixModifierPosition: m
    };
  };
  return r ? (l) => r({
    className: l,
    parseClassName: u
  }) : u;
}, ZN = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let r = [];
  return t.forEach((i) => {
    i[0] === "[" ? (e.push(...r.sort(), i), r = []) : r.push(i);
  }), e.push(...r.sort()), e;
}, JN = (t) => ({
  cache: KN(t.cacheSize),
  parseClassName: YN(t),
  ...zN(t)
}), QN = /\s+/, tB = (t, e) => {
  const {
    parseClassName: r,
    getClassGroupId: i,
    getConflictingClassGroupIds: s
  } = e, c = [], u = t.trim().split(QN);
  let l = "";
  for (let f = u.length - 1; f >= 0; f -= 1) {
    const o = u[f], {
      modifiers: g,
      hasImportantModifier: p,
      baseClassName: n,
      maybePostfixModifierPosition: a
    } = r(o);
    let d = !!a, m = i(d ? n.substring(0, a) : n);
    if (!m) {
      if (!d) {
        l = o + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (m = i(n), !m) {
        l = o + (l.length > 0 ? " " + l : l);
        continue;
      }
      d = !1;
    }
    const b = ZN(g).join(":"), w = p ? b + bA : b, v = w + m;
    if (c.includes(v))
      continue;
    c.push(v);
    const h = s(m, d);
    for (let x = 0; x < h.length; ++x) {
      const _ = h[x];
      c.push(w + _);
    }
    l = o + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function eB() {
  let t = 0, e, r, i = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (r = vA(e)) && (i && (i += " "), i += r);
  return i;
}
const vA = (t) => {
  if (typeof t == "string")
    return t;
  let e, r = "";
  for (let i = 0; i < t.length; i++)
    t[i] && (e = vA(t[i])) && (r && (r += " "), r += e);
  return r;
};
function nB(t, ...e) {
  let r, i, s, c = u;
  function u(f) {
    const o = e.reduce((g, p) => p(g), t());
    return r = JN(o), i = r.cache.get, s = r.cache.set, c = l, l(f);
  }
  function l(f) {
    const o = i(f);
    if (o)
      return o;
    const g = tB(f, r);
    return s(f, g), g;
  }
  return function() {
    return c(eB.apply(null, arguments));
  };
}
const Kn = (t) => {
  const e = (r) => r[t] || [];
  return e.isThemeGetter = !0, e;
}, wA = /^\[(?:([a-z-]+):)?(.+)\]$/i, rB = /^\d+\/\d+$/, iB = /* @__PURE__ */ new Set(["px", "full", "screen"]), aB = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, sB = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, oB = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, lB = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, cB = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, zs = (t) => Ru(t) || iB.has(t) || rB.test(t), Po = (t) => p0(t, "length", yB), Ru = (t) => !!t && !Number.isNaN(Number(t)), tm = (t) => p0(t, "number", Ru), r1 = (t) => !!t && Number.isInteger(Number(t)), uB = (t) => t.endsWith("%") && Ru(t.slice(0, -1)), rn = (t) => wA.test(t), Io = (t) => aB.test(t), hB = /* @__PURE__ */ new Set(["length", "size", "percentage"]), fB = (t) => p0(t, hB, xA), dB = (t) => p0(t, "position", xA), gB = /* @__PURE__ */ new Set(["image", "url"]), pB = (t) => p0(t, gB, vB), mB = (t) => p0(t, "", bB), i1 = () => !0, p0 = (t, e, r) => {
  const i = wA.exec(t);
  return i ? i[1] ? typeof e == "string" ? i[1] === e : e.has(i[1]) : r(i[2]) : !1;
}, yB = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  sB.test(t) && !oB.test(t)
), xA = () => !1, bB = (t) => lB.test(t), vB = (t) => cB.test(t), wB = () => {
  const t = Kn("colors"), e = Kn("spacing"), r = Kn("blur"), i = Kn("brightness"), s = Kn("borderColor"), c = Kn("borderRadius"), u = Kn("borderSpacing"), l = Kn("borderWidth"), f = Kn("contrast"), o = Kn("grayscale"), g = Kn("hueRotate"), p = Kn("invert"), n = Kn("gap"), a = Kn("gradientColorStops"), d = Kn("gradientColorStopPositions"), m = Kn("inset"), b = Kn("margin"), w = Kn("opacity"), v = Kn("padding"), h = Kn("saturate"), x = Kn("scale"), _ = Kn("sepia"), M = Kn("skew"), O = Kn("space"), E = Kn("translate"), I = () => ["auto", "contain", "none"], R = () => ["auto", "hidden", "clip", "visible", "scroll"], W = () => ["auto", rn, e], z = () => [rn, e], j = () => ["", zs, Po], $ = () => ["auto", Ru, rn], B = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], C = () => ["solid", "dashed", "dotted", "double", "none"], T = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], F = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], S = () => ["", "0", rn], A = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], U = () => [Ru, rn];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [i1],
      spacing: [zs, Po],
      blur: ["none", "", Io, rn],
      brightness: U(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Io, rn],
      borderSpacing: z(),
      borderWidth: j(),
      contrast: U(),
      grayscale: S(),
      hueRotate: U(),
      invert: S(),
      gap: z(),
      gradientColorStops: [t],
      gradientColorStopPositions: [uB, Po],
      inset: W(),
      margin: W(),
      opacity: U(),
      padding: z(),
      saturate: U(),
      scale: U(),
      sepia: S(),
      skew: U(),
      space: z(),
      translate: z()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", rn]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Io]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": A()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": A()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...B(), rn]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: R()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": R()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": R()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", r1, rn]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: W()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", rn]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: S()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: S()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", r1, rn]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [i1]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", r1, rn]
        }, rn]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": $()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": $()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [i1]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [r1, rn]
        }, rn]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": $()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": $()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", rn]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", rn]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [n]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [n]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [n]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...F()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...F(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...F(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [O]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [O]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", rn, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [rn, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [rn, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Io]
        }, Io]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [rn, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [rn, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [rn, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [rn, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Io, Po]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", tm]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [i1]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", rn]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ru, tm]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", zs, rn]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", rn]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", rn]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...C(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", zs, Po]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", zs, rn]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: z()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", rn]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", rn]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...B(), dB]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", fB]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, pB]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [d]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [d]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [d]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [a]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [a]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [a]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [c]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [c]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [c]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [c]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [c]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [c]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [c]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [c]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [c]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [c]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [c]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [c]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [c]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [c]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [c]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...C(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: C()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [s]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...C()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [zs, rn]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [zs, Po]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [zs, Po]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Io, mB]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [i1]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...T(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": T()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [i]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [f]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Io, rn]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [o]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [g]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [h]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [i]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [f]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [o]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [g]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [h]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [u]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [u]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [u]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", rn]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: U()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", rn]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: U()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", rn]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [r1, rn]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [E]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [E]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", rn]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", rn]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": z()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": z()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": z()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": z()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": z()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": z()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": z()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": z()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": z()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": z()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": z()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": z()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": z()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": z()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": z()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": z()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": z()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": z()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", rn]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [zs, Po, tm]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, xB = /* @__PURE__ */ nB(wB), Ke = (...t) => xB(VN(t));
var Ni = function() {
  return Ni = Object.assign || function(e) {
    for (var r, i = 1, s = arguments.length; i < s; i++) {
      r = arguments[i];
      for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && (e[c] = r[c]);
    }
    return e;
  }, Ni.apply(this, arguments);
};
function Xu(t, e, r) {
  if (r || arguments.length === 2) for (var i = 0, s = e.length, c; i < s; i++)
    (c || !(i in e)) && (c || (c = Array.prototype.slice.call(e, 0, i)), c[i] = e[i]);
  return t.concat(c || Array.prototype.slice.call(e));
}
function SB(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var CB = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, AB = /* @__PURE__ */ SB(
  function(t) {
    return CB.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), ds = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Dn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Yn = "-ms-", I1 = "-moz-", In = "-webkit-", SA = "comm", Hg = "rule", j6 = "decl", _B = "@import", CA = "@keyframes", kB = "@layer", AA = Math.abs, U6 = String.fromCharCode, S3 = Object.assign;
function OB(t, e) {
  return Br(t, 0) ^ 45 ? (((e << 2 ^ Br(t, 0)) << 2 ^ Br(t, 1)) << 2 ^ Br(t, 2)) << 2 ^ Br(t, 3) : 0;
}
function _A(t) {
  return t.trim();
}
function Xs(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function on(t, e, r) {
  return t.replace(e, r);
}
function Hd(t, e, r) {
  return t.indexOf(e, r);
}
function Br(t, e) {
  return t.charCodeAt(e) | 0;
}
function qu(t, e, r) {
  return t.slice(e, r);
}
function fs(t) {
  return t.length;
}
function kA(t) {
  return t.length;
}
function w1(t, e) {
  return e.push(t), t;
}
function TB(t, e) {
  return t.map(e).join("");
}
function Ab(t, e) {
  return t.filter(function(r) {
    return !Xs(r, e);
  });
}
var Vg = 1, Wu = 1, OA = 0, Da = 0, Cr = 0, m0 = "";
function zg(t, e, r, i, s, c, u, l) {
  return { value: t, root: e, parent: r, type: i, props: s, children: c, line: Vg, column: Wu, length: u, return: "", siblings: l };
}
function Ro(t, e) {
  return S3(zg("", null, null, "", null, null, 0, t.siblings), t, { length: -t.length }, e);
}
function hu(t) {
  for (; t.root; )
    t = Ro(t.root, { children: [t] });
  w1(t, t.siblings);
}
function MB() {
  return Cr;
}
function EB() {
  return Cr = Da > 0 ? Br(m0, --Da) : 0, Wu--, Cr === 10 && (Wu = 1, Vg--), Cr;
}
function Za() {
  return Cr = Da < OA ? Br(m0, Da++) : 0, Wu++, Cr === 10 && (Wu = 1, Vg++), Cr;
}
function oc() {
  return Br(m0, Da);
}
function Vd() {
  return Da;
}
function Xg(t, e) {
  return qu(m0, t, e);
}
function C3(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function PB(t) {
  return Vg = Wu = 1, OA = fs(m0 = t), Da = 0, [];
}
function IB(t) {
  return m0 = "", t;
}
function em(t) {
  return _A(Xg(Da - 1, A3(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function FB(t) {
  for (; (Cr = oc()) && Cr < 33; )
    Za();
  return C3(t) > 2 || C3(Cr) > 3 ? "" : " ";
}
function RB(t, e) {
  for (; --e && Za() && !(Cr < 48 || Cr > 102 || Cr > 57 && Cr < 65 || Cr > 70 && Cr < 97); )
    ;
  return Xg(t, Vd() + (e < 6 && oc() == 32 && Za() == 32));
}
function A3(t) {
  for (; Za(); )
    switch (Cr) {
      case t:
        return Da;
      case 34:
      case 39:
        t !== 34 && t !== 39 && A3(Cr);
        break;
      case 40:
        t === 41 && A3(t);
        break;
      case 92:
        Za();
        break;
    }
  return Da;
}
function DB(t, e) {
  for (; Za() && t + Cr !== 57; )
    if (t + Cr === 84 && oc() === 47)
      break;
  return "/*" + Xg(e, Da - 1) + "*" + U6(t === 47 ? t : Za());
}
function $B(t) {
  for (; !C3(oc()); )
    Za();
  return Xg(t, Da);
}
function LB(t) {
  return IB(zd("", null, null, null, [""], t = PB(t), 0, [0], t));
}
function zd(t, e, r, i, s, c, u, l, f) {
  for (var o = 0, g = 0, p = u, n = 0, a = 0, d = 0, m = 1, b = 1, w = 1, v = 0, h = "", x = s, _ = c, M = i, O = h; b; )
    switch (d = v, v = Za()) {
      case 40:
        if (d != 108 && Br(O, p - 1) == 58) {
          Hd(O += on(em(v), "&", "&\f"), "&\f", AA(o ? l[o - 1] : 0)) != -1 && (w = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += em(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += FB(d);
        break;
      case 92:
        O += RB(Vd() - 1, 7);
        continue;
      case 47:
        switch (oc()) {
          case 42:
          case 47:
            w1(NB(DB(Za(), Vd()), e, r, f), f);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * m:
        l[o++] = fs(O) * w;
      case 125 * m:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            b = 0;
          case 59 + g:
            w == -1 && (O = on(O, /\f/g, "")), a > 0 && fs(O) - p && w1(a > 32 ? kb(O + ";", i, r, p - 1, f) : kb(on(O, " ", "") + ";", i, r, p - 2, f), f);
            break;
          case 59:
            O += ";";
          default:
            if (w1(M = _b(O, e, r, o, g, s, l, h, x = [], _ = [], p, c), c), v === 123)
              if (g === 0)
                zd(O, e, M, M, x, c, p, l, _);
              else
                switch (n === 99 && Br(O, 3) === 110 ? 100 : n) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    zd(t, M, M, i && w1(_b(t, M, M, 0, 0, s, l, h, s, x = [], p, _), _), s, _, p, l, i ? x : _);
                    break;
                  default:
                    zd(O, M, M, M, [""], _, 0, l, _);
                }
        }
        o = g = a = 0, m = w = 1, h = O = "", p = u;
        break;
      case 58:
        p = 1 + fs(O), a = d;
      default:
        if (m < 1) {
          if (v == 123)
            --m;
          else if (v == 125 && m++ == 0 && EB() == 125)
            continue;
        }
        switch (O += U6(v), v * m) {
          case 38:
            w = g > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            l[o++] = (fs(O) - 1) * w, w = 1;
            break;
          case 64:
            oc() === 45 && (O += em(Za())), n = oc(), g = p = fs(h = O += $B(Vd())), v++;
            break;
          case 45:
            d === 45 && fs(O) == 2 && (m = 0);
        }
    }
  return c;
}
function _b(t, e, r, i, s, c, u, l, f, o, g, p) {
  for (var n = s - 1, a = s === 0 ? c : [""], d = kA(a), m = 0, b = 0, w = 0; m < i; ++m)
    for (var v = 0, h = qu(t, n + 1, n = AA(b = u[m])), x = t; v < d; ++v)
      (x = _A(b > 0 ? a[v] + " " + h : on(h, /&\f/g, a[v]))) && (f[w++] = x);
  return zg(t, e, r, s === 0 ? Hg : l, f, o, g, p);
}
function NB(t, e, r, i) {
  return zg(t, e, r, SA, U6(MB()), qu(t, 2, -2), 0, i);
}
function kb(t, e, r, i, s) {
  return zg(t, e, r, j6, qu(t, 0, i), qu(t, i + 1, -1), i, s);
}
function TA(t, e, r) {
  switch (OB(t, e)) {
    case 5103:
      return In + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return In + t + t;
    case 4789:
      return I1 + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return In + t + I1 + t + Yn + t + t;
    case 5936:
      switch (Br(t, e + 11)) {
        case 114:
          return In + t + Yn + on(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return In + t + Yn + on(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return In + t + Yn + on(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
    case 6828:
    case 4268:
    case 2903:
      return In + t + Yn + t + t;
    case 6165:
      return In + t + Yn + "flex-" + t + t;
    case 5187:
      return In + t + on(t, /(\w+).+(:[^]+)/, In + "box-$1$2" + Yn + "flex-$1$2") + t;
    case 5443:
      return In + t + Yn + "flex-item-" + on(t, /flex-|-self/g, "") + (Xs(t, /flex-|baseline/) ? "" : Yn + "grid-row-" + on(t, /flex-|-self/g, "")) + t;
    case 4675:
      return In + t + Yn + "flex-line-pack" + on(t, /align-content|flex-|-self/g, "") + t;
    case 5548:
      return In + t + Yn + on(t, "shrink", "negative") + t;
    case 5292:
      return In + t + Yn + on(t, "basis", "preferred-size") + t;
    case 6060:
      return In + "box-" + on(t, "-grow", "") + In + t + Yn + on(t, "grow", "positive") + t;
    case 4554:
      return In + on(t, /([^-])(transform)/g, "$1" + In + "$2") + t;
    case 6187:
      return on(on(on(t, /(zoom-|grab)/, In + "$1"), /(image-set)/, In + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return on(t, /(image-set\([^]*)/, In + "$1$`$1");
    case 4968:
      return on(on(t, /(.+:)(flex-)?(.*)/, In + "box-pack:$3" + Yn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + In + t + t;
    case 4200:
      if (!Xs(t, /flex-|baseline/)) return Yn + "grid-column-align" + qu(t, e) + t;
      break;
    case 2592:
    case 3360:
      return Yn + on(t, "template-", "") + t;
    case 4384:
    case 3616:
      return r && r.some(function(i, s) {
        return e = s, Xs(i.props, /grid-\w+-end/);
      }) ? ~Hd(t + (r = r[e].value), "span", 0) ? t : Yn + on(t, "-start", "") + t + Yn + "grid-row-span:" + (~Hd(r, "span", 0) ? Xs(r, /\d+/) : +Xs(r, /\d+/) - +Xs(t, /\d+/)) + ";" : Yn + on(t, "-start", "") + t;
    case 4896:
    case 4128:
      return r && r.some(function(i) {
        return Xs(i.props, /grid-\w+-start/);
      }) ? t : Yn + on(on(t, "-end", "-span"), "span ", "") + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return on(t, /(.+)-inline(.+)/, In + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (fs(t) - 1 - e > 6)
        switch (Br(t, e + 1)) {
          case 109:
            if (Br(t, e + 4) !== 45)
              break;
          case 102:
            return on(t, /(.+:)(.+)-([^]+)/, "$1" + In + "$2-$3$1" + I1 + (Br(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~Hd(t, "stretch", 0) ? TA(on(t, "stretch", "fill-available"), e, r) + t : t;
        }
      break;
    case 5152:
    case 5920:
      return on(t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(i, s, c, u, l, f, o) {
        return Yn + s + ":" + c + o + (u ? Yn + s + "-span:" + (l ? f : +f - +c) + o : "") + t;
      });
    case 4949:
      if (Br(t, e + 6) === 121)
        return on(t, ":", ":" + In) + t;
      break;
    case 6444:
      switch (Br(t, Br(t, 14) === 45 ? 18 : 11)) {
        case 120:
          return on(t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + In + (Br(t, 14) === 45 ? "inline-" : "") + "box$3$1" + In + "$2$3$1" + Yn + "$2box$3") + t;
        case 100:
          return on(t, ":", ":" + Yn) + t;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return on(t, "scroll-", "scroll-snap-") + t;
  }
  return t;
}
function m2(t, e) {
  for (var r = "", i = 0; i < t.length; i++)
    r += e(t[i], i, t, e) || "";
  return r;
}
function BB(t, e, r, i) {
  switch (t.type) {
    case kB:
      if (t.children.length) break;
    case _B:
    case j6:
      return t.return = t.return || t.value;
    case SA:
      return "";
    case CA:
      return t.return = t.value + "{" + m2(t.children, i) + "}";
    case Hg:
      if (!fs(t.value = t.props.join(","))) return "";
  }
  return fs(r = m2(t.children, i)) ? t.return = t.value + "{" + r + "}" : "";
}
function jB(t) {
  var e = kA(t);
  return function(r, i, s, c) {
    for (var u = "", l = 0; l < e; l++)
      u += t[l](r, i, s, c) || "";
    return u;
  };
}
function UB(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function HB(t, e, r, i) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case j6:
        t.return = TA(t.value, t.length, r);
        return;
      case CA:
        return m2([Ro(t, { value: on(t.value, "@", "@" + In) })], i);
      case Hg:
        if (t.length)
          return TB(r = t.props, function(s) {
            switch (Xs(s, i = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                hu(Ro(t, { props: [on(s, /:(read-\w+)/, ":" + I1 + "$1")] })), hu(Ro(t, { props: [s] })), S3(t, { props: Ab(r, i) });
                break;
              case "::placeholder":
                hu(Ro(t, { props: [on(s, /:(plac\w+)/, ":" + In + "input-$1")] })), hu(Ro(t, { props: [on(s, /:(plac\w+)/, ":" + I1 + "$1")] })), hu(Ro(t, { props: [on(s, /:(plac\w+)/, Yn + "input-$1")] })), hu(Ro(t, { props: [s] })), S3(t, { props: Ab(r, i) });
                break;
            }
            return "";
          });
    }
}
var VB = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, bc = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", MA = "active", EA = "data-styled-version", qg = "6.1.16", H6 = `/*!sc*/
`, y2 = typeof window < "u" && "HTMLElement" in window, zB = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), Ob = /invalid hook call/i, Gf = /* @__PURE__ */ new Set(), XB = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var r = e ? ' with the id of "'.concat(e, '"') : "", i = "The component ".concat(t).concat(r, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, s = console.error;
    try {
      var c = !0;
      console.error = function(u) {
        for (var l = [], f = 1; f < arguments.length; f++) l[f - 1] = arguments[f];
        Ob.test(u) ? (c = !1, Gf.delete(i)) : s.apply(void 0, Xu([u], l, !1));
      }, Sn(), c && !Gf.has(i) && (console.warn(i), Gf.add(i));
    } catch (u) {
      Ob.test(u.message) && Gf.delete(i);
    } finally {
      console.error = s;
    }
  }
}, Wg = Object.freeze([]), Gu = Object.freeze({});
function qB(t, e, r) {
  return r === void 0 && (r = Gu), t.theme !== r.theme && t.theme || e || r.theme;
}
var _3 = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), WB = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, GB = /(^-|-$)/g;
function Tb(t) {
  return t.replace(WB, "-").replace(GB, "");
}
var KB = /(a)(d)/gi, Kf = 52, Mb = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function k3(t) {
  var e, r = "";
  for (e = Math.abs(t); e > Kf; e = e / Kf | 0) r = Mb(e % Kf) + r;
  return (Mb(e % Kf) + r).replace(KB, "$1-$2");
}
var nm, PA = 5381, Zl = function(t, e) {
  for (var r = e.length; r; ) t = 33 * t ^ e.charCodeAt(--r);
  return t;
}, IA = function(t) {
  return Zl(PA, t);
};
function YB(t) {
  return k3(IA(t) >>> 0);
}
function FA(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function rm(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var RA = typeof Symbol == "function" && Symbol.for, DA = RA ? Symbol.for("react.memo") : 60115, ZB = RA ? Symbol.for("react.forward_ref") : 60112, JB = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, QB = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, $A = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, tj = ((nm = {})[ZB] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, nm[DA] = $A, nm);
function Eb(t) {
  return ("type" in (e = t) && e.type.$$typeof) === DA ? $A : "$$typeof" in t ? tj[t.$$typeof] : JB;
  var e;
}
var ej = Object.defineProperty, nj = Object.getOwnPropertyNames, Pb = Object.getOwnPropertySymbols, rj = Object.getOwnPropertyDescriptor, ij = Object.getPrototypeOf, Ib = Object.prototype;
function LA(t, e, r) {
  if (typeof e != "string") {
    if (Ib) {
      var i = ij(e);
      i && i !== Ib && LA(t, i, r);
    }
    var s = nj(e);
    Pb && (s = s.concat(Pb(e)));
    for (var c = Eb(t), u = Eb(e), l = 0; l < s.length; ++l) {
      var f = s[l];
      if (!(f in QB || r && r[f] || u && f in u || c && f in c)) {
        var o = rj(e, f);
        try {
          ej(t, f, o);
        } catch {
        }
      }
    }
  }
  return t;
}
function Ku(t) {
  return typeof t == "function";
}
function V6(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function Ql(t, e) {
  return t && e ? "".concat(t, " ").concat(e) : t || e || "";
}
function Fb(t, e) {
  if (t.length === 0) return "";
  for (var r = t[0], i = 1; i < t.length; i++) r += t[i];
  return r;
}
function Yu(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function O3(t, e, r) {
  if (r === void 0 && (r = !1), !r && !Yu(t) && !Array.isArray(t)) return e;
  if (Array.isArray(e)) for (var i = 0; i < e.length; i++) t[i] = O3(t[i], e[i]);
  else if (Yu(e)) for (var i in e) t[i] = O3(t[i], e[i]);
  return t;
}
function z6(t, e) {
  Object.defineProperty(t, "toString", { value: e });
}
var aj = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function sj() {
  for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
  for (var r = t[0], i = [], s = 1, c = t.length; s < c; s += 1) i.push(t[s]);
  return i.forEach(function(u) {
    r = r.replace(/%[a-z]/, u);
  }), r;
}
function y0(t) {
  for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(e.length > 0 ? " Args: ".concat(e.join(", ")) : "")) : new Error(sj.apply(void 0, Xu([aj[t]], e, !1)).trim());
}
var oj = function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  return t.prototype.indexOfGroup = function(e) {
    for (var r = 0, i = 0; i < e; i++) r += this.groupSizes[i];
    return r;
  }, t.prototype.insertRules = function(e, r) {
    if (e >= this.groupSizes.length) {
      for (var i = this.groupSizes, s = i.length, c = s; e >= c; ) if ((c <<= 1) < 0) throw y0(16, "".concat(e));
      this.groupSizes = new Uint32Array(c), this.groupSizes.set(i), this.length = c;
      for (var u = s; u < c; u++) this.groupSizes[u] = 0;
    }
    for (var l = this.indexOfGroup(e + 1), f = (u = 0, r.length); u < f; u++) this.tag.insertRule(l, r[u]) && (this.groupSizes[e]++, l++);
  }, t.prototype.clearGroup = function(e) {
    if (e < this.length) {
      var r = this.groupSizes[e], i = this.indexOfGroup(e), s = i + r;
      this.groupSizes[e] = 0;
      for (var c = i; c < s; c++) this.tag.deleteRule(i);
    }
  }, t.prototype.getGroup = function(e) {
    var r = "";
    if (e >= this.length || this.groupSizes[e] === 0) return r;
    for (var i = this.groupSizes[e], s = this.indexOfGroup(e), c = s + i, u = s; u < c; u++) r += "".concat(this.tag.getRule(u)).concat(H6);
    return r;
  }, t;
}(), lj = 1 << 30, Xd = /* @__PURE__ */ new Map(), b2 = /* @__PURE__ */ new Map(), qd = 1, Yf = function(t) {
  if (Xd.has(t)) return Xd.get(t);
  for (; b2.has(qd); ) qd++;
  var e = qd++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > lj)) throw y0(16, "".concat(e));
  return Xd.set(t, e), b2.set(e, t), e;
}, cj = function(t, e) {
  qd = e + 1, Xd.set(t, e), b2.set(e, t);
}, uj = "style[".concat(bc, "][").concat(EA, '="').concat(qg, '"]'), hj = new RegExp("^".concat(bc, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), fj = function(t, e, r) {
  for (var i, s = r.split(","), c = 0, u = s.length; c < u; c++) (i = s[c]) && t.registerName(e, i);
}, dj = function(t, e) {
  for (var r, i = ((r = e.textContent) !== null && r !== void 0 ? r : "").split(H6), s = [], c = 0, u = i.length; c < u; c++) {
    var l = i[c].trim();
    if (l) {
      var f = l.match(hj);
      if (f) {
        var o = 0 | parseInt(f[1], 10), g = f[2];
        o !== 0 && (cj(g, o), fj(t, g, f[3]), t.getTag().insertRules(o, s)), s.length = 0;
      } else s.push(l);
    }
  }
}, Rb = function(t) {
  for (var e = document.querySelectorAll(uj), r = 0, i = e.length; r < i; r++) {
    var s = e[r];
    s && s.getAttribute(bc) !== MA && (dj(t, s), s.parentNode && s.parentNode.removeChild(s));
  }
};
function gj() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var NA = function(t) {
  var e = document.head, r = t || e, i = document.createElement("style"), s = function(l) {
    var f = Array.from(l.querySelectorAll("style[".concat(bc, "]")));
    return f[f.length - 1];
  }(r), c = s !== void 0 ? s.nextSibling : null;
  i.setAttribute(bc, MA), i.setAttribute(EA, qg);
  var u = gj();
  return u && i.setAttribute("nonce", u), r.insertBefore(i, c), i;
}, pj = function() {
  function t(e) {
    this.element = NA(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(r) {
      if (r.sheet) return r.sheet;
      for (var i = document.styleSheets, s = 0, c = i.length; s < c; s++) {
        var u = i[s];
        if (u.ownerNode === r) return u;
      }
      throw y0(17);
    }(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(e, r) {
    try {
      return this.sheet.insertRule(r, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.prototype.getRule = function(e) {
    var r = this.sheet.cssRules[e];
    return r && r.cssText ? r.cssText : "";
  }, t;
}(), mj = function() {
  function t(e) {
    this.element = NA(e), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(e, r) {
    if (e <= this.length && e >= 0) {
      var i = document.createTextNode(r);
      return this.element.insertBefore(i, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
}(), yj = function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(e, r) {
    return e <= this.length && (this.rules.splice(e, 0, r), this.length++, !0);
  }, t.prototype.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
}(), Db = y2, bj = { isServer: !y2, useCSSOMInjection: !zB }, BA = function() {
  function t(e, r, i) {
    e === void 0 && (e = Gu), r === void 0 && (r = {});
    var s = this;
    this.options = Ni(Ni({}, bj), e), this.gs = r, this.names = new Map(i), this.server = !!e.isServer, !this.server && y2 && Db && (Db = !1, Rb(this)), z6(this, function() {
      return function(c) {
        for (var u = c.getTag(), l = u.length, f = "", o = function(p) {
          var n = function(w) {
            return b2.get(w);
          }(p);
          if (n === void 0) return "continue";
          var a = c.names.get(n), d = u.getGroup(p);
          if (a === void 0 || !a.size || d.length === 0) return "continue";
          var m = "".concat(bc, ".g").concat(p, '[id="').concat(n, '"]'), b = "";
          a !== void 0 && a.forEach(function(w) {
            w.length > 0 && (b += "".concat(w, ","));
          }), f += "".concat(d).concat(m, '{content:"').concat(b, '"}').concat(H6);
        }, g = 0; g < l; g++) o(g);
        return f;
      }(s);
    });
  }
  return t.registerId = function(e) {
    return Yf(e);
  }, t.prototype.rehydrate = function() {
    !this.server && y2 && Rb(this);
  }, t.prototype.reconstructWithOptions = function(e, r) {
    return r === void 0 && (r = !0), new t(Ni(Ni({}, this.options), e), this.gs, r && this.names || void 0);
  }, t.prototype.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (e = function(r) {
      var i = r.useCSSOMInjection, s = r.target;
      return r.isServer ? new yj(s) : i ? new pj(s) : new mj(s);
    }(this.options), new oj(e)));
    var e;
  }, t.prototype.hasNameForId = function(e, r) {
    return this.names.has(e) && this.names.get(e).has(r);
  }, t.prototype.registerName = function(e, r) {
    if (Yf(e), this.names.has(e)) this.names.get(e).add(r);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(r), this.names.set(e, i);
    }
  }, t.prototype.insertRules = function(e, r, i) {
    this.registerName(e, r), this.getTag().insertRules(Yf(e), i);
  }, t.prototype.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.prototype.clearRules = function(e) {
    this.getTag().clearGroup(Yf(e)), this.clearNames(e);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
}(), vj = /&/g, wj = /^\s*\/\/.*$/gm;
function jA(t, e) {
  return t.map(function(r) {
    return r.type === "rule" && (r.value = "".concat(e, " ").concat(r.value), r.value = r.value.replaceAll(",", ",".concat(e, " ")), r.props = r.props.map(function(i) {
      return "".concat(e, " ").concat(i);
    })), Array.isArray(r.children) && r.type !== "@keyframes" && (r.children = jA(r.children, e)), r;
  });
}
function xj(t) {
  var e, r, i, s = Gu, c = s.options, u = c === void 0 ? Gu : c, l = s.plugins, f = l === void 0 ? Wg : l, o = function(n, a, d) {
    return d.startsWith(r) && d.endsWith(r) && d.replaceAll(r, "").length > 0 ? ".".concat(e) : n;
  }, g = f.slice();
  g.push(function(n) {
    n.type === Hg && n.value.includes("&") && (n.props[0] = n.props[0].replace(vj, r).replace(i, o));
  }), u.prefix && g.push(HB), g.push(BB);
  var p = function(n, a, d, m) {
    a === void 0 && (a = ""), d === void 0 && (d = ""), m === void 0 && (m = "&"), e = m, r = a, i = new RegExp("\\".concat(r, "\\b"), "g");
    var b = n.replace(wj, ""), w = LB(d || a ? "".concat(d, " ").concat(a, " { ").concat(b, " }") : b);
    u.namespace && (w = jA(w, u.namespace));
    var v = [];
    return m2(w, jB(g.concat(UB(function(h) {
      return v.push(h);
    })))), v;
  };
  return p.hash = f.length ? f.reduce(function(n, a) {
    return a.name || y0(15), Zl(n, a.name);
  }, PA).toString() : "", p;
}
var Sj = new BA(), T3 = xj(), UA = Bt.createContext({ shouldForwardProp: void 0, styleSheet: Sj, stylis: T3 });
UA.Consumer;
Bt.createContext(void 0);
function $b() {
  return Kr(UA);
}
var Lb = function() {
  function t(e, r) {
    var i = this;
    this.inject = function(s, c) {
      c === void 0 && (c = T3);
      var u = i.name + c.hash;
      s.hasNameForId(i.id, u) || s.insertRules(i.id, u, c(i.rules, u, "@keyframes"));
    }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = r, z6(this, function() {
      throw y0(12, String(i.name));
    });
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = T3), this.name + e.hash;
  }, t;
}(), Cj = function(t) {
  return t >= "A" && t <= "Z";
};
function Nb(t) {
  for (var e = "", r = 0; r < t.length; r++) {
    var i = t[r];
    if (r === 1 && i === "-" && t[0] === "-") return t;
    Cj(i) ? e += "-" + i.toLowerCase() : e += i;
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
var HA = function(t) {
  return t == null || t === !1 || t === "";
}, VA = function(t) {
  var e, r, i = [];
  for (var s in t) {
    var c = t[s];
    t.hasOwnProperty(s) && !HA(c) && (Array.isArray(c) && c.isCss || Ku(c) ? i.push("".concat(Nb(s), ":"), c, ";") : Yu(c) ? i.push.apply(i, Xu(Xu(["".concat(s, " {")], VA(c), !1), ["}"], !1)) : i.push("".concat(Nb(s), ": ").concat((e = s, (r = c) == null || typeof r == "boolean" || r === "" ? "" : typeof r != "number" || r === 0 || e in VB || e.startsWith("--") ? String(r).trim() : "".concat(r, "px")), ";")));
  }
  return i;
};
function lc(t, e, r, i) {
  if (HA(t)) return [];
  if (V6(t)) return [".".concat(t.styledComponentId)];
  if (Ku(t)) {
    if (!Ku(c = t) || c.prototype && c.prototype.isReactComponent || !e) return [t];
    var s = t(e);
    return process.env.NODE_ENV === "production" || typeof s != "object" || Array.isArray(s) || s instanceof Lb || Yu(s) || s === null || console.error("".concat(FA(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), lc(s, e, r, i);
  }
  var c;
  return t instanceof Lb ? r ? (t.inject(r, i), [t.getName(i)]) : [t] : Yu(t) ? VA(t) : Array.isArray(t) ? Array.prototype.concat.apply(Wg, t.map(function(u) {
    return lc(u, e, r, i);
  })) : [t.toString()];
}
function Aj(t) {
  for (var e = 0; e < t.length; e += 1) {
    var r = t[e];
    if (Ku(r) && !V6(r)) return !1;
  }
  return !0;
}
var _j = IA(qg), kj = function() {
  function t(e, r, i) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (i === void 0 || i.isStatic) && Aj(e), this.componentId = r, this.baseHash = Zl(_j, r), this.baseStyle = i, BA.registerId(r);
  }
  return t.prototype.generateAndInjectStyles = function(e, r, i) {
    var s = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, r, i) : "";
    if (this.isStatic && !i.hash) if (this.staticRulesId && r.hasNameForId(this.componentId, this.staticRulesId)) s = Ql(s, this.staticRulesId);
    else {
      var c = Fb(lc(this.rules, e, r, i)), u = k3(Zl(this.baseHash, c) >>> 0);
      if (!r.hasNameForId(this.componentId, u)) {
        var l = i(c, ".".concat(u), void 0, this.componentId);
        r.insertRules(this.componentId, u, l);
      }
      s = Ql(s, u), this.staticRulesId = u;
    }
    else {
      for (var f = Zl(this.baseHash, i.hash), o = "", g = 0; g < this.rules.length; g++) {
        var p = this.rules[g];
        if (typeof p == "string") o += p, process.env.NODE_ENV !== "production" && (f = Zl(f, p));
        else if (p) {
          var n = Fb(lc(p, e, r, i));
          f = Zl(f, n + g), o += n;
        }
      }
      if (o) {
        var a = k3(f >>> 0);
        r.hasNameForId(this.componentId, a) || r.insertRules(this.componentId, a, i(o, ".".concat(a), void 0, this.componentId)), s = Ql(s, a);
      }
    }
    return s;
  }, t;
}(), zA = Bt.createContext(void 0);
zA.Consumer;
var im = {}, Bb = /* @__PURE__ */ new Set();
function Oj(t, e, r) {
  var i = V6(t), s = t, c = !rm(t), u = e.attrs, l = u === void 0 ? Wg : u, f = e.componentId, o = f === void 0 ? function(x, _) {
    var M = typeof x != "string" ? "sc" : Tb(x);
    im[M] = (im[M] || 0) + 1;
    var O = "".concat(M, "-").concat(YB(qg + M + im[M]));
    return _ ? "".concat(_, "-").concat(O) : O;
  }(e.displayName, e.parentComponentId) : f, g = e.displayName, p = g === void 0 ? function(x) {
    return rm(x) ? "styled.".concat(x) : "Styled(".concat(FA(x), ")");
  }(t) : g, n = e.displayName && e.componentId ? "".concat(Tb(e.displayName), "-").concat(e.componentId) : e.componentId || o, a = i && s.attrs ? s.attrs.concat(l).filter(Boolean) : l, d = e.shouldForwardProp;
  if (i && s.shouldForwardProp) {
    var m = s.shouldForwardProp;
    if (e.shouldForwardProp) {
      var b = e.shouldForwardProp;
      d = function(x, _) {
        return m(x, _) && b(x, _);
      };
    } else d = m;
  }
  var w = new kj(r, n, i ? s.componentStyle : void 0);
  function v(x, _) {
    return function(M, O, E) {
      var I = M.attrs, R = M.componentStyle, W = M.defaultProps, z = M.foldedComponentIds, j = M.styledComponentId, $ = M.target, B = Bt.useContext(zA), C = $b(), T = M.shouldForwardProp || C.shouldForwardProp;
      process.env.NODE_ENV !== "production" && xb(j);
      var F = qB(O, B, W) || Gu, S = function(H, Q, N) {
        for (var V, Y = Ni(Ni({}, Q), { className: void 0, theme: N }), Z = 0; Z < H.length; Z += 1) {
          var rt = Ku(V = H[Z]) ? V(Y) : V;
          for (var st in rt) Y[st] = st === "className" ? Ql(Y[st], rt[st]) : st === "style" ? Ni(Ni({}, Y[st]), rt[st]) : rt[st];
        }
        return Q.className && (Y.className = Ql(Y.className, Q.className)), Y;
      }(I, O, F), A = S.as || $, U = {};
      for (var K in S) S[K] === void 0 || K[0] === "$" || K === "as" || K === "theme" && S.theme === F || (K === "forwardedAs" ? U.as = S.forwardedAs : T && !T(K, A) || (U[K] = S[K], T || process.env.NODE_ENV !== "development" || AB(K) || Bb.has(K) || !_3.has(A) || (Bb.add(K), console.warn('styled-components: it looks like an unknown prop "'.concat(K, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var X = function(H, Q) {
        var N = $b(), V = H.generateAndInjectStyles(Q, N.styleSheet, N.stylis);
        return process.env.NODE_ENV !== "production" && xb(V), V;
      }(R, S);
      process.env.NODE_ENV !== "production" && M.warnTooManyClasses && M.warnTooManyClasses(X);
      var L = Ql(z, j);
      return X && (L += " " + X), S.className && (L += " " + S.className), U[rm(A) && !_3.has(A) ? "class" : "className"] = L, E && (U.ref = E), uA(A, U);
    }(h, x, _);
  }
  v.displayName = p;
  var h = Bt.forwardRef(v);
  return h.attrs = a, h.componentStyle = w, h.displayName = p, h.shouldForwardProp = d, h.foldedComponentIds = i ? Ql(s.foldedComponentIds, s.styledComponentId) : "", h.styledComponentId = n, h.target = i ? s.target : t, Object.defineProperty(h, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(x) {
    this._foldedDefaultProps = i ? function(_) {
      for (var M = [], O = 1; O < arguments.length; O++) M[O - 1] = arguments[O];
      for (var E = 0, I = M; E < I.length; E++) O3(_, I[E], !0);
      return _;
    }({}, s.defaultProps, x) : x;
  } }), process.env.NODE_ENV !== "production" && (XB(p, n), h.warnTooManyClasses = /* @__PURE__ */ function(x, _) {
    var M = {}, O = !1;
    return function(E) {
      if (!O && (M[E] = !0, Object.keys(M).length >= 200)) {
        var I = _ ? ' with the id of "'.concat(_, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(x).concat(I, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), O = !0, M = {};
      }
    };
  }(p, n)), z6(h, function() {
    return ".".concat(h.styledComponentId);
  }), c && LA(h, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), h;
}
function jb(t, e) {
  for (var r = [t[0]], i = 0, s = e.length; i < s; i += 1) r.push(e[i], t[i + 1]);
  return r;
}
var Ub = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function De(t) {
  for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
  if (Ku(t) || Yu(t)) return Ub(lc(jb(Wg, Xu([t], e, !0))));
  var i = t;
  return e.length === 0 && i.length === 1 && typeof i[0] == "string" ? lc(i) : Ub(lc(jb(i, e)));
}
function M3(t, e, r) {
  if (r === void 0 && (r = Gu), !e) throw y0(1, e);
  var i = function(s) {
    for (var c = [], u = 1; u < arguments.length; u++) c[u - 1] = arguments[u];
    return t(e, r, De.apply(void 0, Xu([s], c, !1)));
  };
  return i.attrs = function(s) {
    return M3(t, e, Ni(Ni({}, r), { attrs: Array.prototype.concat(r.attrs, s).filter(Boolean) }));
  }, i.withConfig = function(s) {
    return M3(t, e, Ni(Ni({}, r), s));
  }, i;
}
var XA = function(t) {
  return M3(Oj, t);
}, Wn = XA;
_3.forEach(function(t) {
  Wn[t] = XA(t);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var Zf = "__sc-".concat(bc, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[Zf] || (window[Zf] = 0), window[Zf] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[Zf] += 1);
const ls = {
  xs: 0,
  sm: 600,
  md: 990,
  lg: 1340,
  xl: 1920
}, zn = {
  min: {
    xs: De`
        (min-width: ${ls.xs}px)
        `,
    sm: De`
        (min-width: ${ls.sm}px)
        `,
    md: De`
        (min-width: ${ls.md}px)
        `,
    lg: De`
        (min-width: ${ls.lg}px)
        `,
    xl: De`
        (min-width: ${ls.xl}px)
        `
  },
  max: {
    xs: De`
        (max-width: ${ls.xs}px)
        `,
    sm: De`
        (max-width: ${ls.sm}px)
        `,
    md: De`
        (max-width: ${ls.md}px)
        `,
    lg: De`
        (max-width: ${ls.lg}px)
        `,
    xl: De`
        (max-width: ${ls.xl}px)
        `
  }
}, Un = (t) => {
  var e;
  return ((e = t[0]) == null ? void 0 : e.toString()) ?? "";
};
Un(De`var(--ssui-theme-color-primary-50)`), Un(De`var(--ssui-theme-color-primary-100)`), Un(De`var(--ssui-theme-color-primary-150)`), Un(De`var(--ssui-theme-color-primary-200)`), Un(De`var(--ssui-theme-color-primary-250)`), Un(De`var(--ssui-theme-color-primary-300)`), Un(De`var(--ssui-theme-color-primary-400)`), Un(De`var(--ssui-theme-color-primary-500)`), Un(De`var(--ssui-theme-color-primary-600)`), Un(De`var(--ssui-theme-color-primary-700)`), Un(De`var(--ssui-theme-color-primary-800)`);
const Hn = {
  colors: {
    purple: {
      shade50: Un(De`var(--ssui-color-purple-50)`),
      shade100: Un(De`var(--ssui-color-purple-100)`),
      shade150: Un(De`var(--ssui-color-purple-150)`),
      shade200: Un(De`var(--ssui-color-purple-200)`),
      shade250: Un(De`var(--ssui-color-purple-250)`),
      shade300: Un(De`var(--ssui-color-purple-300)`),
      shade400: Un(De`var(--ssui-color-purple-400)`),
      shade500: Un(De`var(--ssui-color-purple-500)`),
      shade600: Un(De`var(--ssui-color-purple-600)`),
      shade700: Un(De`var(--ssui-color-purple-700)`),
      shade800: Un(De`var(--ssui-color-purple-800)`)
    },
    red: {
      shade200: Un(De`var(--ssui-color-red-200)`),
      shade300: Un(De`var(--ssui-color-red-300)`),
      shade500: Un(De`var(--ssui-color-red-500)`)
    },
    green: {
      shade200: Un(De`var(--ssui-color-green-200)`),
      shade700: Un(De`var(--ssui-color-green-700)`)
    }
  },
  mixins: {
    fonts: {
      h1: De`
        font-family: var(--ssui-font-family-display);
        font-weight: 700;
        font-size: var(--ssui-typo--h1_mob--size);
        line-height: var(--ssui-typo--h1_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h1_reg--size);
          line-height: var(--ssui-typo--h1_reg--line-height);
        }
      `,
      h2: De`
        font-family: var(--ssui-font-family-display);
        font-weight: 700;
        font-size: var(--ssui-typo--h2_mob--size);
        line-height: var(--ssui-typo--h2_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h2_reg--size);
          line-height: var(--ssui-typo--h2_reg--line-height);
        }
      `,
      h3: De`
        font-family: var(--ssui-font-family-display);
        font-weight: 700;
        font-size: var(--ssui-typo--h3_mob--size);
        line-height: var(--ssui-typo--h3_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h3_reg--size);
          line-height: var(--ssui-typo--h3_reg--line-height);
        }
      `,
      h4: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--h4_mob--size);
        line-height: var(--ssui-typo--h4_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h4_reg--size);
          line-height: var(--ssui-typo--h4_reg--line-height);
        }
      `,
      h4l: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--h4_mob--size);
        line-height: var(--ssui-typo--h4_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h4_reg--size);
          line-height: var(--ssui-typo--h4_reg--line-height);
        }
      `,
      h5: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--h5_mob--size);
        line-height: var(--ssui-typo--h5_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h5_reg--size);
          line-height: var(--ssui-typo--h5_reg--line-height);
        }
      `,
      h5l: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--h5_mob--size);
        line-height: var(--ssui-typo--h5_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--h5_reg--size);
          line-height: var(--ssui-typo--h5_reg--line-height);
        }
      `,
      st1: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--st1_mob--size);
        line-height: var(--ssui-typo--st1_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--st1_reg--size);
          line-height: var(--ssui-typo--st1_reg--line-height);
        }
      `,
      st2: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--st2_mob--size);
        line-height: var(--ssui-typo--st2_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--st2_reg--size);
          line-height: var(--ssui-typo--st2_reg--line-height);
        }
      `,
      st3: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--st3_mob--size);
        line-height: var(--ssui-typo--st3_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--st3_reg--size);
          line-height: var(--ssui-typo--st3_reg--line-height);
        }
      `,
      body1: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--body1_mob--size);
        line-height: var(--ssui-typo--body1_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--body1_reg--size);
          line-height: var(--ssui-typo--body1_reg--line-height);
        }
      `,
      body1Bold: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--body1_mob--size);
        line-height: var(--ssui-typo--body1_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--body1_reg--size);
          line-height: var(--ssui-typo--body1_reg--line-height);
        }
      `,
      body2: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--body2_mob--size);
        line-height: var(--ssui-typo--body2_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--body2_reg--size);
          line-height: var(--ssui-typo--body2_reg--line-height);
        }
      `,
      body3: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--body3_mob--size);
        line-height: var(--ssui-typo--body3_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--body3_reg--size);
          line-height: var(--ssui-typo--body3_reg--line-height);
        }
      `,
      detail: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--detail_mob--size);
        line-height: var(--ssui-typo--detail_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--detail_reg--size);
          line-height: var(--ssui-typo--detail_reg--line-height);
        }
      `,
      detailBold: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--detail_mob--size);
        line-height: var(--ssui-typo--detail_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--detail_reg--size);
          line-height: var(--ssui-typo--detail_reg--line-height);
        }
      `,
      petit: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 400;
        font-size: var(--ssui-typo--petit_mob--size);
        line-height: var(--ssui-typo--petit_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--petit_reg--size);
          line-height: var(--ssui-typo--petit_reg--line-height);
        }
      `,
      petitBold: De`
        font-family: var(--ssui-font-family-body);
        font-weight: 700;
        font-size: var(--ssui-typo--petit_mob--size);
        line-height: var(--ssui-typo--petit_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--petit_reg--size);
          line-height: var(--ssui-typo--petit_reg--line-height);
        }
      `,
      numbers1: De`
        font-family: var(--ssui-font-family-display);
        font-weight: 700;
        font-size: var(--ssui-typo--numbers1_mob--size);
        line-height: var(--ssui-typo--numbers1_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--numbers1_reg--size);
          line-height: var(--ssui-typo--numbers1_reg--line-height);
        }
      `,
      numbers2: De`
        font-family: var(--ssui-font-family-display);
        font-weight: 700;
        font-size: var(--ssui-typo--numbers2_mob--size);
        line-height: var(--ssui-typo--numbers2_mob--line-height);

        @media only screen and ${zn.min.md} {
          font-size: var(--ssui-typo--numbers2_reg--size);
          line-height: var(--ssui-typo--numbers2_reg--line-height);
        }
      `,
      buttonPrimary: De`
        font-family: var(--ssui-font-family-body);
        font-size: 0.875rem;
        font-weight: 700;
        line-height: 1.125rem;
        letter-spacing: 0.0625rem;
        text-transform: uppercase;

        @media only screen and ${zn.min.md} {
          // same as base as of now
        }
      `,
      buttonSecondary1: De`
        font-family: var(--ssui-font-family-body);
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.125rem;
        text-decoration-line: underline;

        @media only screen and ${zn.min.md} {
          font-size: 1rem;
          line-height: 1.375rem;
        }
      `,
      buttonSecondary2: De`
        font-family: var(--ssui-font-family-body);
        font-size: 0.75rem;
        font-weight: 700;
        line-height: 1rem;
        text-decoration-line: underline;

        @media only screen and ${zn.min.md} {
          font-size: 0.875rem;
          line-height: 1.125rem;
        }
      `,
      buttonSecondary3: De`
        font-family: var(--ssui-font-family-body);
        font-size: 0.625rem;
        font-weight: 700;
        line-height: 0.875rem;
        text-decoration-line: underline;

        @media only screen and ${zn.min.md} {
          font-size: 0.75rem;
          line-height: 1rem;
        }
      `
    }
  }
}, X6 = g0({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), Gg = g0({}), Kg = g0(null), Yg = typeof document < "u", Zg = Yg ? Ug : Tn, qA = g0({ strict: !1 }), q6 = (t) => t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), Tj = "framerAppearId", WA = "data-" + q6(Tj);
function Mj(t, e, r, i) {
  const { visualElement: s } = Kr(Gg), c = Kr(qA), u = Kr(Kg), l = Kr(X6).reducedMotion, f = Sn();
  i = i || c.renderer, !f.current && i && (f.current = i(t, {
    visualState: e,
    parent: s,
    props: r,
    presenceContext: u,
    blockInitialAnimation: u ? u.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const o = f.current;
  hA(() => {
    o && o.update(r, u);
  });
  const g = Sn(!!(r[WA] && !window.HandoffComplete));
  return Zg(() => {
    o && (o.render(), g.current && o.animationState && o.animationState.animateChanges());
  }), Tn(() => {
    o && (o.updateFeatures(), !g.current && o.animationState && o.animationState.animateChanges(), g.current && (g.current = !1, window.HandoffComplete = !0));
  }), o;
}
function Au(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Ej(t, e, r) {
  return Js(
    (i) => {
      i && t.mount && t.mount(i), e && (i ? e.mount(i) : e.unmount()), r && (typeof r == "function" ? r(i) : Au(r) && (r.current = i));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function th(t) {
  return typeof t == "string" || Array.isArray(t);
}
function Jg(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const W6 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], G6 = ["initial", ...W6];
function Qg(t) {
  return Jg(t.animate) || G6.some((e) => th(t[e]));
}
function GA(t) {
  return !!(Qg(t) || t.variants);
}
function Pj(t, e) {
  if (Qg(t)) {
    const { initial: r, animate: i } = t;
    return {
      initial: r === !1 || th(r) ? r : void 0,
      animate: th(i) ? i : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function Ij(t) {
  const { initial: e, animate: r } = Pj(t, Kr(Gg));
  return en(() => ({ initial: e, animate: r }), [Hb(e), Hb(r)]);
}
function Hb(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Vb = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, eh = {};
for (const t in Vb)
  eh[t] = {
    isEnabled: (e) => Vb[t].some((r) => !!e[r])
  };
function Fj(t) {
  for (const e in t)
    eh[e] = {
      ...eh[e],
      ...t[e]
    };
}
const K6 = g0({}), KA = g0({}), Rj = Symbol.for("motionComponentSymbol");
function Dj({ preloadedFeatures: t, createVisualElement: e, useRender: r, useVisualState: i, Component: s }) {
  t && Fj(t);
  function c(l, f) {
    let o;
    const g = {
      ...Kr(X6),
      ...l,
      layoutId: $j(l)
    }, { isStatic: p } = g, n = Ij(l), a = i(l, p);
    if (!p && Yg) {
      n.visualElement = Mj(s, a, g, e);
      const d = Kr(KA), m = Kr(qA).strict;
      n.visualElement && (o = n.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        g,
        m,
        t,
        d
      ));
    }
    return pt.createElement(
      Gg.Provider,
      { value: n },
      o && n.visualElement ? pt.createElement(o, { visualElement: n.visualElement, ...g }) : null,
      r(s, l, Ej(a, n.visualElement, f), a, p, n.visualElement)
    );
  }
  const u = kn(c);
  return u[Rj] = s, u;
}
function $j({ layoutId: t }) {
  const e = Kr(K6).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function Lj(t) {
  function e(i, s = {}) {
    return Dj(t(i, s));
  }
  if (typeof Proxy > "u")
    return e;
  const r = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, s) => (r.has(s) || r.set(s, e(s)), r.get(s))
  });
}
const Nj = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Y6(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Nj.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(t))
    )
  );
}
const v2 = {};
function Bj(t) {
  Object.assign(v2, t);
}
const Eh = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Mc = new Set(Eh);
function YA(t, { layout: e, layoutId: r }) {
  return Mc.has(t) || t.startsWith("origin") || (e || r !== void 0) && (!!v2[t] || t === "opacity");
}
const fi = (t) => !!(t && t.getVelocity), jj = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Uj = Eh.length;
function Hj(t, { enableHardwareAcceleration: e = !0, allowTransformNone: r = !0 }, i, s) {
  let c = "";
  for (let u = 0; u < Uj; u++) {
    const l = Eh[u];
    if (t[l] !== void 0) {
      const f = jj[l] || l;
      c += `${f}(${t[l]}) `;
    }
  }
  return e && !t.z && (c += "translateZ(0)"), c = c.trim(), s ? c = s(t, i ? "" : c) : r && i && (c = "none"), c;
}
const ZA = (t) => (e) => typeof e == "string" && e.startsWith(t), JA = ZA("--"), E3 = ZA("var(--"), Vj = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, zj = (t, e) => e && typeof t == "number" ? e.transform(t) : t, rl = (t, e, r) => Math.min(Math.max(r, t), e), Ec = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, F1 = {
  ...Ec,
  transform: (t) => rl(0, 1, t)
}, Jf = {
  ...Ec,
  default: 1
}, R1 = (t) => Math.round(t * 1e5) / 1e5, tp = /(-)?([\d]*\.?[\d])+/g, QA = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, Xj = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Ph(t) {
  return typeof t == "string";
}
const Ih = (t) => ({
  test: (e) => Ph(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Do = Ih("deg"), ws = Ih("%"), Ge = Ih("px"), qj = Ih("vh"), Wj = Ih("vw"), zb = {
  ...ws,
  parse: (t) => ws.parse(t) / 100,
  transform: (t) => ws.transform(t * 100)
}, Xb = {
  ...Ec,
  transform: Math.round
}, t_ = {
  // Border props
  borderWidth: Ge,
  borderTopWidth: Ge,
  borderRightWidth: Ge,
  borderBottomWidth: Ge,
  borderLeftWidth: Ge,
  borderRadius: Ge,
  radius: Ge,
  borderTopLeftRadius: Ge,
  borderTopRightRadius: Ge,
  borderBottomRightRadius: Ge,
  borderBottomLeftRadius: Ge,
  // Positioning props
  width: Ge,
  maxWidth: Ge,
  height: Ge,
  maxHeight: Ge,
  size: Ge,
  top: Ge,
  right: Ge,
  bottom: Ge,
  left: Ge,
  // Spacing props
  padding: Ge,
  paddingTop: Ge,
  paddingRight: Ge,
  paddingBottom: Ge,
  paddingLeft: Ge,
  margin: Ge,
  marginTop: Ge,
  marginRight: Ge,
  marginBottom: Ge,
  marginLeft: Ge,
  // Transform props
  rotate: Do,
  rotateX: Do,
  rotateY: Do,
  rotateZ: Do,
  scale: Jf,
  scaleX: Jf,
  scaleY: Jf,
  scaleZ: Jf,
  skew: Do,
  skewX: Do,
  skewY: Do,
  distance: Ge,
  translateX: Ge,
  translateY: Ge,
  translateZ: Ge,
  x: Ge,
  y: Ge,
  z: Ge,
  perspective: Ge,
  transformPerspective: Ge,
  opacity: F1,
  originX: zb,
  originY: zb,
  originZ: Ge,
  // Misc
  zIndex: Xb,
  // SVG
  fillOpacity: F1,
  strokeOpacity: F1,
  numOctaves: Xb
};
function Z6(t, e, r, i) {
  const { style: s, vars: c, transform: u, transformOrigin: l } = t;
  let f = !1, o = !1, g = !0;
  for (const p in e) {
    const n = e[p];
    if (JA(p)) {
      c[p] = n;
      continue;
    }
    const a = t_[p], d = zj(n, a);
    if (Mc.has(p)) {
      if (f = !0, u[p] = d, !g)
        continue;
      n !== (a.default || 0) && (g = !1);
    } else p.startsWith("origin") ? (o = !0, l[p] = d) : s[p] = d;
  }
  if (e.transform || (f || i ? s.transform = Hj(t.transform, r, g, i) : s.transform && (s.transform = "none")), o) {
    const { originX: p = "50%", originY: n = "50%", originZ: a = 0 } = l;
    s.transformOrigin = `${p} ${n} ${a}`;
  }
}
const J6 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function e_(t, e, r) {
  for (const i in e)
    !fi(e[i]) && !YA(i, r) && (t[i] = e[i]);
}
function Gj({ transformTemplate: t }, e, r) {
  return en(() => {
    const i = J6();
    return Z6(i, e, { enableHardwareAcceleration: !r }, t), Object.assign({}, i.vars, i.style);
  }, [e]);
}
function Kj(t, e, r) {
  const i = t.style || {}, s = {};
  return e_(s, i, t), Object.assign(s, Gj(t, e, r)), t.transformValues ? t.transformValues(s) : s;
}
function Yj(t, e, r) {
  const i = {}, s = Kj(t, e, r);
  return t.drag && t.dragListener !== !1 && (i.draggable = !1, s.userSelect = s.WebkitUserSelect = s.WebkitTouchCallout = "none", s.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (i.tabIndex = 0), i.style = s, i;
}
const Zj = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function w2(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || Zj.has(t);
}
let n_ = (t) => !w2(t);
function Jj(t) {
  t && (n_ = (e) => e.startsWith("on") ? !w2(e) : t(e));
}
try {
  Jj(require("@emotion/is-prop-valid").default);
} catch {
}
function Qj(t, e, r) {
  const i = {};
  for (const s in t)
    s === "values" && typeof t.values == "object" || (n_(s) || r === !0 && w2(s) || !e && !w2(s) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && s.startsWith("onDrag")) && (i[s] = t[s]);
  return i;
}
function qb(t, e, r) {
  return typeof t == "string" ? t : Ge.transform(e + r * t);
}
function tU(t, e, r) {
  const i = qb(e, t.x, t.width), s = qb(r, t.y, t.height);
  return `${i} ${s}`;
}
const eU = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, nU = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function rU(t, e, r = 1, i = 0, s = !0) {
  t.pathLength = 1;
  const c = s ? eU : nU;
  t[c.offset] = Ge.transform(-i);
  const u = Ge.transform(e), l = Ge.transform(r);
  t[c.array] = `${u} ${l}`;
}
function Q6(t, {
  attrX: e,
  attrY: r,
  attrScale: i,
  originX: s,
  originY: c,
  pathLength: u,
  pathSpacing: l = 1,
  pathOffset: f = 0,
  // This is object creation, which we try to avoid per-frame.
  ...o
}, g, p, n) {
  if (Z6(t, o, g, n), p) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: a, style: d, dimensions: m } = t;
  a.transform && (m && (d.transform = a.transform), delete a.transform), m && (s !== void 0 || c !== void 0 || d.transform) && (d.transformOrigin = tU(m, s !== void 0 ? s : 0.5, c !== void 0 ? c : 0.5)), e !== void 0 && (a.x = e), r !== void 0 && (a.y = r), i !== void 0 && (a.scale = i), u !== void 0 && rU(a, u, l, f, !1);
}
const r_ = () => ({
  ...J6(),
  attrs: {}
}), t7 = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function iU(t, e, r, i) {
  const s = en(() => {
    const c = r_();
    return Q6(c, e, { enableHardwareAcceleration: !1 }, t7(i), t.transformTemplate), {
      ...c.attrs,
      style: { ...c.style }
    };
  }, [e]);
  if (t.style) {
    const c = {};
    e_(c, t.style, t), s.style = { ...c, ...s.style };
  }
  return s;
}
function aU(t = !1) {
  return (r, i, s, { latestValues: c }, u) => {
    const f = (Y6(r) ? iU : Yj)(i, c, u, r), g = {
      ...Qj(i, typeof r == "string", t),
      ...f,
      ref: s
    }, { children: p } = i, n = en(() => fi(p) ? p.get() : p, [p]);
    return uA(r, {
      ...g,
      children: n
    });
  };
}
function i_(t, { style: e, vars: r }, i, s) {
  Object.assign(t.style, e, s && s.getProjectionStyles(i));
  for (const c in r)
    t.style.setProperty(c, r[c]);
}
const a_ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function s_(t, e, r, i) {
  i_(t, e, void 0, i);
  for (const s in e.attrs)
    t.setAttribute(a_.has(s) ? s : q6(s), e.attrs[s]);
}
function e7(t, e) {
  const { style: r } = t, i = {};
  for (const s in r)
    (fi(r[s]) || e.style && fi(e.style[s]) || YA(s, t)) && (i[s] = r[s]);
  return i;
}
function o_(t, e) {
  const r = e7(t, e);
  for (const i in t)
    if (fi(t[i]) || fi(e[i])) {
      const s = Eh.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[s] = t[i];
    }
  return r;
}
function n7(t, e, r, i = {}, s = {}) {
  return typeof e == "function" && (e = e(r !== void 0 ? r : t.custom, i, s)), typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function" && (e = e(r !== void 0 ? r : t.custom, i, s)), e;
}
function ep(t) {
  const e = Sn(null);
  return e.current === null && (e.current = t()), e.current;
}
const x2 = (t) => Array.isArray(t), sU = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), oU = (t) => x2(t) ? t[t.length - 1] || 0 : t;
function Wd(t) {
  const e = fi(t) ? t.get() : t;
  return sU(e) ? e.toValue() : e;
}
function lU({ scrapeMotionValuesFromProps: t, createRenderState: e, onMount: r }, i, s, c) {
  const u = {
    latestValues: cU(i, s, c, t),
    renderState: e()
  };
  return r && (u.mount = (l) => r(i, l, u)), u;
}
const l_ = (t) => (e, r) => {
  const i = Kr(Gg), s = Kr(Kg), c = () => lU(t, e, i, s);
  return r ? c() : ep(c);
};
function cU(t, e, r, i) {
  const s = {}, c = i(t, {});
  for (const n in c)
    s[n] = Wd(c[n]);
  let { initial: u, animate: l } = t;
  const f = Qg(t), o = GA(t);
  e && o && !f && t.inherit !== !1 && (u === void 0 && (u = e.initial), l === void 0 && (l = e.animate));
  let g = r ? r.initial === !1 : !1;
  g = g || u === !1;
  const p = g ? l : u;
  return p && typeof p != "boolean" && !Jg(p) && (Array.isArray(p) ? p : [p]).forEach((a) => {
    const d = n7(t, a);
    if (!d)
      return;
    const { transitionEnd: m, transition: b, ...w } = d;
    for (const v in w) {
      let h = w[v];
      if (Array.isArray(h)) {
        const x = g ? h.length - 1 : 0;
        h = h[x];
      }
      h !== null && (s[v] = h);
    }
    for (const v in m)
      s[v] = m[v];
  }), s;
}
const cr = (t) => t;
class Wb {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(e) {
    if (!this.scheduled.has(e))
      return this.scheduled.add(e), this.order.push(e), !0;
  }
  remove(e) {
    const r = this.order.indexOf(e);
    r !== -1 && (this.order.splice(r, 1), this.scheduled.delete(e));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function uU(t) {
  let e = new Wb(), r = new Wb(), i = 0, s = !1, c = !1;
  const u = /* @__PURE__ */ new WeakSet(), l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, o = !1, g = !1) => {
      const p = g && s, n = p ? e : r;
      return o && u.add(f), n.add(f) && p && s && (i = e.order.length), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      r.remove(f), u.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (s) {
        c = !0;
        return;
      }
      if (s = !0, [e, r] = [r, e], r.clear(), i = e.order.length, i)
        for (let o = 0; o < i; o++) {
          const g = e.order[o];
          g(f), u.has(g) && (l.schedule(g), t());
        }
      s = !1, c && (c = !1, l.process(f));
    }
  };
  return l;
}
const Qf = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], hU = 40;
function fU(t, e) {
  let r = !1, i = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, c = Qf.reduce((p, n) => (p[n] = uU(() => r = !0), p), {}), u = (p) => c[p].process(s), l = () => {
    const p = performance.now();
    r = !1, s.delta = i ? 1e3 / 60 : Math.max(Math.min(p - s.timestamp, hU), 1), s.timestamp = p, s.isProcessing = !0, Qf.forEach(u), s.isProcessing = !1, r && e && (i = !1, t(l));
  }, f = () => {
    r = !0, i = !0, s.isProcessing || t(l);
  };
  return { schedule: Qf.reduce((p, n) => {
    const a = c[n];
    return p[n] = (d, m = !1, b = !1) => (r || f(), a.schedule(d, m, b)), p;
  }, {}), cancel: (p) => Qf.forEach((n) => c[n].cancel(p)), state: s, steps: c };
}
const { schedule: Nn, cancel: Ja, state: ni, steps: am } = fU(typeof requestAnimationFrame < "u" ? requestAnimationFrame : cr, !0), dU = {
  useVisualState: l_({
    scrapeMotionValuesFromProps: o_,
    createRenderState: r_,
    onMount: (t, e, { renderState: r, latestValues: i }) => {
      Nn.read(() => {
        try {
          r.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
        } catch {
          r.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), Nn.render(() => {
        Q6(r, i, { enableHardwareAcceleration: !1 }, t7(e.tagName), t.transformTemplate), s_(e, r);
      });
    }
  })
}, gU = {
  useVisualState: l_({
    scrapeMotionValuesFromProps: e7,
    createRenderState: J6
  })
};
function pU(t, { forwardMotionProps: e = !1 }, r, i) {
  return {
    ...Y6(t) ? dU : gU,
    preloadedFeatures: r,
    useRender: aU(e),
    createVisualElement: i,
    Component: t
  };
}
function Qs(t, e, r, i = { passive: !0 }) {
  return t.addEventListener(e, r, i), () => t.removeEventListener(e, r);
}
const c_ = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function np(t, e = "page") {
  return {
    point: {
      x: t[e + "X"],
      y: t[e + "Y"]
    }
  };
}
const mU = (t) => (e) => c_(e) && t(e, np(e));
function ro(t, e, r, i) {
  return Qs(t, e, mU(r), i);
}
const yU = (t, e) => (r) => e(t(r)), Xo = (...t) => t.reduce(yU);
function u_(t) {
  let e = null;
  return () => {
    const r = () => {
      e = null;
    };
    return e === null ? (e = t, r) : !1;
  };
}
const Gb = u_("dragHorizontal"), Kb = u_("dragVertical");
function h_(t) {
  let e = !1;
  if (t === "y")
    e = Kb();
  else if (t === "x")
    e = Gb();
  else {
    const r = Gb(), i = Kb();
    r && i ? e = () => {
      r(), i();
    } : (r && r(), i && i());
  }
  return e;
}
function f_() {
  const t = h_(!0);
  return t ? (t(), !1) : !0;
}
class pl {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function Yb(t, e) {
  const r = "pointer" + (e ? "enter" : "leave"), i = "onHover" + (e ? "Start" : "End"), s = (c, u) => {
    if (c.pointerType === "touch" || f_())
      return;
    const l = t.getProps();
    t.animationState && l.whileHover && t.animationState.setActive("whileHover", e), l[i] && Nn.update(() => l[i](c, u));
  };
  return ro(t.current, r, s, {
    passive: !t.getProps()[i]
  });
}
class bU extends pl {
  mount() {
    this.unmount = Xo(Yb(this.node, !0), Yb(this.node, !1));
  }
  unmount() {
  }
}
class vU extends pl {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Xo(Qs(this.node.current, "focus", () => this.onFocus()), Qs(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const d_ = (t, e) => e ? t === e ? !0 : d_(t, e.parentElement) : !1;
function sm(t, e) {
  if (!e)
    return;
  const r = new PointerEvent("pointer" + t);
  e(r, np(r));
}
class wU extends pl {
  constructor() {
    super(...arguments), this.removeStartListeners = cr, this.removeEndListeners = cr, this.removeAccessibleListeners = cr, this.startPointerPress = (e, r) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const i = this.node.getProps(), c = ro(window, "pointerup", (l, f) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: o, onTapCancel: g, globalTapTarget: p } = this.node.getProps();
        Nn.update(() => {
          !p && !d_(this.node.current, l.target) ? g && g(l, f) : o && o(l, f);
        });
      }, { passive: !(i.onTap || i.onPointerUp) }), u = ro(window, "pointercancel", (l, f) => this.cancelPress(l, f), { passive: !(i.onTapCancel || i.onPointerCancel) });
      this.removeEndListeners = Xo(c, u), this.startPress(e, r);
    }, this.startAccessiblePress = () => {
      const e = (c) => {
        if (c.key !== "Enter" || this.isPressing)
          return;
        const u = (l) => {
          l.key !== "Enter" || !this.checkPressEnd() || sm("up", (f, o) => {
            const { onTap: g } = this.node.getProps();
            g && Nn.update(() => g(f, o));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Qs(this.node.current, "keyup", u), sm("down", (l, f) => {
          this.startPress(l, f);
        });
      }, r = Qs(this.node.current, "keydown", e), i = () => {
        this.isPressing && sm("cancel", (c, u) => this.cancelPress(c, u));
      }, s = Qs(this.node.current, "blur", i);
      this.removeAccessibleListeners = Xo(r, s);
    };
  }
  startPress(e, r) {
    this.isPressing = !0;
    const { onTapStart: i, whileTap: s } = this.node.getProps();
    s && this.node.animationState && this.node.animationState.setActive("whileTap", !0), i && Nn.update(() => i(e, r));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !f_();
  }
  cancelPress(e, r) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: i } = this.node.getProps();
    i && Nn.update(() => i(e, r));
  }
  mount() {
    const e = this.node.getProps(), r = ro(e.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(e.onTapStart || e.onPointerStart) }), i = Qs(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Xo(r, i);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const P3 = /* @__PURE__ */ new WeakMap(), om = /* @__PURE__ */ new WeakMap(), xU = (t) => {
  const e = P3.get(t.target);
  e && e(t);
}, SU = (t) => {
  t.forEach(xU);
};
function CU({ root: t, ...e }) {
  const r = t || document;
  om.has(r) || om.set(r, {});
  const i = om.get(r), s = JSON.stringify(e);
  return i[s] || (i[s] = new IntersectionObserver(SU, { root: t, ...e })), i[s];
}
function AU(t, e, r) {
  const i = CU(e);
  return P3.set(t, r), i.observe(t), () => {
    P3.delete(t), i.unobserve(t);
  };
}
const _U = {
  some: 0,
  all: 1
};
class kU extends pl {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: r, margin: i, amount: s = "some", once: c } = e, u = {
      root: r ? r.current : void 0,
      rootMargin: i,
      threshold: typeof s == "number" ? s : _U[s]
    }, l = (f) => {
      const { isIntersecting: o } = f;
      if (this.isInView === o || (this.isInView = o, c && !o && this.hasEnteredView))
        return;
      o && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", o);
      const { onViewportEnter: g, onViewportLeave: p } = this.node.getProps(), n = o ? g : p;
      n && n(f);
    };
    return AU(this.node.current, u, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: r } = this.node;
    ["amount", "margin", "root"].some(OU(e, r)) && this.startObserver();
  }
  unmount() {
  }
}
function OU({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (r) => t[r] !== e[r];
}
const TU = {
  inView: {
    Feature: kU
  },
  tap: {
    Feature: wU
  },
  focus: {
    Feature: vU
  },
  hover: {
    Feature: bU
  }
};
function g_(t, e) {
  if (!Array.isArray(e))
    return !1;
  const r = e.length;
  if (r !== t.length)
    return !1;
  for (let i = 0; i < r; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function MU(t) {
  const e = {};
  return t.values.forEach((r, i) => e[i] = r.get()), e;
}
function EU(t) {
  const e = {};
  return t.values.forEach((r, i) => e[i] = r.getVelocity()), e;
}
function rp(t, e, r) {
  const i = t.getProps();
  return n7(i, e, r !== void 0 ? r : i.custom, MU(t), EU(t));
}
let Fh = cr, ha = cr;
process.env.NODE_ENV !== "production" && (Fh = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, ha = (t, e) => {
  if (!t)
    throw new Error(e);
});
const io = (t) => t * 1e3, xs = (t) => t / 1e3, PU = {
  current: !1
}, p_ = (t) => Array.isArray(t) && typeof t[0] == "number";
function m_(t) {
  return !!(!t || typeof t == "string" && y_[t] || p_(t) || Array.isArray(t) && t.every(m_));
}
const x1 = ([t, e, r, i]) => `cubic-bezier(${t}, ${e}, ${r}, ${i})`, y_ = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: x1([0, 0.65, 0.55, 1]),
  circOut: x1([0.55, 0, 1, 0.45]),
  backIn: x1([0.31, 0.01, 0.66, -0.59]),
  backOut: x1([0.33, 1.53, 0.69, 0.99])
};
function b_(t) {
  if (t)
    return p_(t) ? x1(t) : Array.isArray(t) ? t.map(b_) : y_[t];
}
function IU(t, e, r, { delay: i = 0, duration: s, repeat: c = 0, repeatType: u = "loop", ease: l, times: f } = {}) {
  const o = { [e]: r };
  f && (o.offset = f);
  const g = b_(l);
  return Array.isArray(g) && (o.easing = g), t.animate(o, {
    delay: i,
    duration: s,
    easing: Array.isArray(g) ? "linear" : g,
    fill: "both",
    iterations: c + 1,
    direction: u === "reverse" ? "alternate" : "normal"
  });
}
function FU(t, { repeat: e, repeatType: r = "loop" }) {
  const i = e && r !== "loop" && e % 2 === 1 ? 0 : t.length - 1;
  return t[i];
}
const v_ = (t, e, r) => (((1 - 3 * r + 3 * e) * t + (3 * r - 6 * e)) * t + 3 * e) * t, RU = 1e-7, DU = 12;
function $U(t, e, r, i, s) {
  let c, u, l = 0;
  do
    u = e + (r - e) / 2, c = v_(u, i, s) - t, c > 0 ? r = u : e = u;
  while (Math.abs(c) > RU && ++l < DU);
  return u;
}
function Rh(t, e, r, i) {
  if (t === e && r === i)
    return cr;
  const s = (c) => $U(c, 0, 1, t, r);
  return (c) => c === 0 || c === 1 ? c : v_(s(c), e, i);
}
const LU = Rh(0.42, 0, 1, 1), NU = Rh(0, 0, 0.58, 1), w_ = Rh(0.42, 0, 0.58, 1), x_ = (t) => Array.isArray(t) && typeof t[0] != "number", S_ = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, C_ = (t) => (e) => 1 - t(1 - e), r7 = (t) => 1 - Math.sin(Math.acos(t)), A_ = C_(r7), BU = S_(r7), __ = Rh(0.33, 1.53, 0.69, 0.99), i7 = C_(__), jU = S_(i7), UU = (t) => (t *= 2) < 1 ? 0.5 * i7(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Zb = {
  linear: cr,
  easeIn: LU,
  easeInOut: w_,
  easeOut: NU,
  circIn: r7,
  circInOut: BU,
  circOut: A_,
  backIn: i7,
  backInOut: jU,
  backOut: __,
  anticipate: UU
}, Jb = (t) => {
  if (Array.isArray(t)) {
    ha(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, r, i, s] = t;
    return Rh(e, r, i, s);
  } else if (typeof t == "string")
    return ha(Zb[t] !== void 0, `Invalid easing type '${t}'`), Zb[t];
  return t;
}, a7 = (t, e) => (r) => !!(Ph(r) && Xj.test(r) && r.startsWith(t) || e && Object.prototype.hasOwnProperty.call(r, e)), k_ = (t, e, r) => (i) => {
  if (!Ph(i))
    return i;
  const [s, c, u, l] = i.match(tp);
  return {
    [t]: parseFloat(s),
    [e]: parseFloat(c),
    [r]: parseFloat(u),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, HU = (t) => rl(0, 255, t), lm = {
  ...Ec,
  transform: (t) => Math.round(HU(t))
}, tc = {
  test: a7("rgb", "red"),
  parse: k_("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: r, alpha: i = 1 }) => "rgba(" + lm.transform(t) + ", " + lm.transform(e) + ", " + lm.transform(r) + ", " + R1(F1.transform(i)) + ")"
};
function VU(t) {
  let e = "", r = "", i = "", s = "";
  return t.length > 5 ? (e = t.substring(1, 3), r = t.substring(3, 5), i = t.substring(5, 7), s = t.substring(7, 9)) : (e = t.substring(1, 2), r = t.substring(2, 3), i = t.substring(3, 4), s = t.substring(4, 5), e += e, r += r, i += i, s += s), {
    red: parseInt(e, 16),
    green: parseInt(r, 16),
    blue: parseInt(i, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const I3 = {
  test: a7("#"),
  parse: VU,
  transform: tc.transform
}, _u = {
  test: a7("hsl", "hue"),
  parse: k_("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: r, alpha: i = 1 }) => "hsla(" + Math.round(t) + ", " + ws.transform(R1(e)) + ", " + ws.transform(R1(r)) + ", " + R1(F1.transform(i)) + ")"
}, xi = {
  test: (t) => tc.test(t) || I3.test(t) || _u.test(t),
  parse: (t) => tc.test(t) ? tc.parse(t) : _u.test(t) ? _u.parse(t) : I3.parse(t),
  transform: (t) => Ph(t) ? t : t.hasOwnProperty("red") ? tc.transform(t) : _u.transform(t)
}, er = (t, e, r) => -r * t + r * e + t;
function cm(t, e, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + (e - t) * 6 * r : r < 1 / 2 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
}
function zU({ hue: t, saturation: e, lightness: r, alpha: i }) {
  t /= 360, e /= 100, r /= 100;
  let s = 0, c = 0, u = 0;
  if (!e)
    s = c = u = r;
  else {
    const l = r < 0.5 ? r * (1 + e) : r + e - r * e, f = 2 * r - l;
    s = cm(f, l, t + 1 / 3), c = cm(f, l, t), u = cm(f, l, t - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(c * 255),
    blue: Math.round(u * 255),
    alpha: i
  };
}
const um = (t, e, r) => {
  const i = t * t;
  return Math.sqrt(Math.max(0, r * (e * e - i) + i));
}, XU = [I3, tc, _u], qU = (t) => XU.find((e) => e.test(t));
function Qb(t) {
  const e = qU(t);
  ha(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`);
  let r = e.parse(t);
  return e === _u && (r = zU(r)), r;
}
const O_ = (t, e) => {
  const r = Qb(t), i = Qb(e), s = { ...r };
  return (c) => (s.red = um(r.red, i.red, c), s.green = um(r.green, i.green, c), s.blue = um(r.blue, i.blue, c), s.alpha = er(r.alpha, i.alpha, c), tc.transform(s));
};
function WU(t) {
  var e, r;
  return isNaN(t) && Ph(t) && (((e = t.match(tp)) === null || e === void 0 ? void 0 : e.length) || 0) + (((r = t.match(QA)) === null || r === void 0 ? void 0 : r.length) || 0) > 0;
}
const T_ = {
  regex: Vj,
  countKey: "Vars",
  token: "${v}",
  parse: cr
}, M_ = {
  regex: QA,
  countKey: "Colors",
  token: "${c}",
  parse: xi.parse
}, E_ = {
  regex: tp,
  countKey: "Numbers",
  token: "${n}",
  parse: Ec.parse
};
function hm(t, { regex: e, countKey: r, token: i, parse: s }) {
  const c = t.tokenised.match(e);
  c && (t["num" + r] = c.length, t.tokenised = t.tokenised.replace(e, i), t.values.push(...c.map(s)));
}
function S2(t) {
  const e = t.toString(), r = {
    value: e,
    tokenised: e,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return r.value.includes("var(--") && hm(r, T_), hm(r, M_), hm(r, E_), r;
}
function P_(t) {
  return S2(t).values;
}
function I_(t) {
  const { values: e, numColors: r, numVars: i, tokenised: s } = S2(t), c = e.length;
  return (u) => {
    let l = s;
    for (let f = 0; f < c; f++)
      f < i ? l = l.replace(T_.token, u[f]) : f < i + r ? l = l.replace(M_.token, xi.transform(u[f])) : l = l.replace(E_.token, R1(u[f]));
    return l;
  };
}
const GU = (t) => typeof t == "number" ? 0 : t;
function KU(t) {
  const e = P_(t);
  return I_(t)(e.map(GU));
}
const il = {
  test: WU,
  parse: P_,
  createTransformer: I_,
  getAnimatableNone: KU
}, F_ = (t, e) => (r) => `${r > 0 ? e : t}`;
function R_(t, e) {
  return typeof t == "number" ? (r) => er(t, e, r) : xi.test(t) ? O_(t, e) : t.startsWith("var(") ? F_(t, e) : $_(t, e);
}
const D_ = (t, e) => {
  const r = [...t], i = r.length, s = t.map((c, u) => R_(c, e[u]));
  return (c) => {
    for (let u = 0; u < i; u++)
      r[u] = s[u](c);
    return r;
  };
}, YU = (t, e) => {
  const r = { ...t, ...e }, i = {};
  for (const s in r)
    t[s] !== void 0 && e[s] !== void 0 && (i[s] = R_(t[s], e[s]));
  return (s) => {
    for (const c in i)
      r[c] = i[c](s);
    return r;
  };
}, $_ = (t, e) => {
  const r = il.createTransformer(e), i = S2(t), s = S2(e);
  return i.numVars === s.numVars && i.numColors === s.numColors && i.numNumbers >= s.numNumbers ? Xo(D_(i.values, s.values), r) : (Fh(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), F_(t, e));
}, Zu = (t, e, r) => {
  const i = e - t;
  return i === 0 ? 1 : (r - t) / i;
}, tv = (t, e) => (r) => er(t, e, r);
function ZU(t) {
  return typeof t == "number" ? tv : typeof t == "string" ? xi.test(t) ? O_ : $_ : Array.isArray(t) ? D_ : typeof t == "object" ? YU : tv;
}
function JU(t, e, r) {
  const i = [], s = r || ZU(t[0]), c = t.length - 1;
  for (let u = 0; u < c; u++) {
    let l = s(t[u], t[u + 1]);
    if (e) {
      const f = Array.isArray(e) ? e[u] || cr : e;
      l = Xo(f, l);
    }
    i.push(l);
  }
  return i;
}
function s7(t, e, { clamp: r = !0, ease: i, mixer: s } = {}) {
  const c = t.length;
  if (ha(c === e.length, "Both input and output ranges must be the same length"), c === 1)
    return () => e[0];
  t[0] > t[c - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const u = JU(e, i, s), l = u.length, f = (o) => {
    let g = 0;
    if (l > 1)
      for (; g < t.length - 2 && !(o < t[g + 1]); g++)
        ;
    const p = Zu(t[g], t[g + 1], o);
    return u[g](p);
  };
  return r ? (o) => f(rl(t[0], t[c - 1], o)) : f;
}
function L_(t, e) {
  const r = t[t.length - 1];
  for (let i = 1; i <= e; i++) {
    const s = Zu(0, e, i);
    t.push(er(r, 1, s));
  }
}
function N_(t) {
  const e = [0];
  return L_(e, t.length - 1), e;
}
function QU(t, e) {
  return t.map((r) => r * e);
}
function tH(t, e) {
  return t.map(() => e || w_).splice(0, t.length - 1);
}
function C2({ duration: t = 300, keyframes: e, times: r, ease: i = "easeInOut" }) {
  const s = x_(i) ? i.map(Jb) : Jb(i), c = {
    done: !1,
    value: e[0]
  }, u = QU(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    r && r.length === e.length ? r : N_(e),
    t
  ), l = s7(u, e, {
    ease: Array.isArray(s) ? s : tH(e, s)
  });
  return {
    calculatedDuration: t,
    next: (f) => (c.value = l(f), c.done = f >= t, c)
  };
}
function B_(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const eH = 5;
function j_(t, e, r) {
  const i = Math.max(e - eH, 0);
  return B_(r - t(i), e - i);
}
const ev = 1e-3, nH = 0.01, nv = 10, rH = 0.05, iH = 1;
function aH({ duration: t = 800, bounce: e = 0.25, velocity: r = 0, mass: i = 1 }) {
  let s, c;
  Fh(t <= io(nv), "Spring duration must be 10 seconds or less");
  let u = 1 - e;
  u = rl(rH, iH, u), t = rl(nH, nv, xs(t)), u < 1 ? (s = (o) => {
    const g = o * u, p = g * t, n = g - r, a = F3(o, u), d = Math.exp(-p);
    return ev - n / a * d;
  }, c = (o) => {
    const p = o * u * t, n = p * r + r, a = Math.pow(u, 2) * Math.pow(o, 2) * t, d = Math.exp(-p), m = F3(Math.pow(o, 2), u);
    return (-s(o) + ev > 0 ? -1 : 1) * ((n - a) * d) / m;
  }) : (s = (o) => {
    const g = Math.exp(-o * t), p = (o - r) * t + 1;
    return -1e-3 + g * p;
  }, c = (o) => {
    const g = Math.exp(-o * t), p = (r - o) * (t * t);
    return g * p;
  });
  const l = 5 / t, f = oH(s, c, l);
  if (t = io(t), isNaN(f))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const o = Math.pow(f, 2) * i;
    return {
      stiffness: o,
      damping: u * 2 * Math.sqrt(i * o),
      duration: t
    };
  }
}
const sH = 12;
function oH(t, e, r) {
  let i = r;
  for (let s = 1; s < sH; s++)
    i = i - t(i) / e(i);
  return i;
}
function F3(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const lH = ["duration", "bounce"], cH = ["stiffness", "damping", "mass"];
function rv(t, e) {
  return e.some((r) => t[r] !== void 0);
}
function uH(t) {
  let e = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!rv(t, cH) && rv(t, lH)) {
    const r = aH(t);
    e = {
      ...e,
      ...r,
      mass: 1
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function o7({ keyframes: t, restDelta: e, restSpeed: r, ...i }) {
  const s = t[0], c = t[t.length - 1], u = { done: !1, value: s }, { stiffness: l, damping: f, mass: o, duration: g, velocity: p, isResolvedFromDuration: n } = uH({
    ...i,
    velocity: -xs(i.velocity || 0)
  }), a = p || 0, d = f / (2 * Math.sqrt(l * o)), m = c - s, b = xs(Math.sqrt(l / o)), w = Math.abs(m) < 5;
  r || (r = w ? 0.01 : 2), e || (e = w ? 5e-3 : 0.5);
  let v;
  if (d < 1) {
    const h = F3(b, d);
    v = (x) => {
      const _ = Math.exp(-d * b * x);
      return c - _ * ((a + d * b * m) / h * Math.sin(h * x) + m * Math.cos(h * x));
    };
  } else if (d === 1)
    v = (h) => c - Math.exp(-b * h) * (m + (a + b * m) * h);
  else {
    const h = b * Math.sqrt(d * d - 1);
    v = (x) => {
      const _ = Math.exp(-d * b * x), M = Math.min(h * x, 300);
      return c - _ * ((a + d * b * m) * Math.sinh(M) + h * m * Math.cosh(M)) / h;
    };
  }
  return {
    calculatedDuration: n && g || null,
    next: (h) => {
      const x = v(h);
      if (n)
        u.done = h >= g;
      else {
        let _ = a;
        h !== 0 && (d < 1 ? _ = j_(v, h, x) : _ = 0);
        const M = Math.abs(_) <= r, O = Math.abs(c - x) <= e;
        u.done = M && O;
      }
      return u.value = u.done ? c : x, u;
    }
  };
}
function iv({ keyframes: t, velocity: e = 0, power: r = 0.8, timeConstant: i = 325, bounceDamping: s = 10, bounceStiffness: c = 500, modifyTarget: u, min: l, max: f, restDelta: o = 0.5, restSpeed: g }) {
  const p = t[0], n = {
    done: !1,
    value: p
  }, a = (E) => l !== void 0 && E < l || f !== void 0 && E > f, d = (E) => l === void 0 ? f : f === void 0 || Math.abs(l - E) < Math.abs(f - E) ? l : f;
  let m = r * e;
  const b = p + m, w = u === void 0 ? b : u(b);
  w !== b && (m = w - p);
  const v = (E) => -m * Math.exp(-E / i), h = (E) => w + v(E), x = (E) => {
    const I = v(E), R = h(E);
    n.done = Math.abs(I) <= o, n.value = n.done ? w : R;
  };
  let _, M;
  const O = (E) => {
    a(n.value) && (_ = E, M = o7({
      keyframes: [n.value, d(n.value)],
      velocity: j_(h, E, n.value),
      damping: s,
      stiffness: c,
      restDelta: o,
      restSpeed: g
    }));
  };
  return O(0), {
    calculatedDuration: null,
    next: (E) => {
      let I = !1;
      return !M && _ === void 0 && (I = !0, x(E), O(E)), _ !== void 0 && E > _ ? M.next(E - _) : (!I && x(E), n);
    }
  };
}
const hH = (t) => {
  const e = ({ timestamp: r }) => t(r);
  return {
    start: () => Nn.update(e, !0),
    stop: () => Ja(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => ni.isProcessing ? ni.timestamp : performance.now()
  };
}, R3 = 2e4;
function D3(t) {
  let e = 0;
  const r = 50;
  let i = t.next(e);
  for (; !i.done && e < R3; )
    e += r, i = t.next(e);
  return e >= R3 ? 1 / 0 : e;
}
const fH = {
  decay: iv,
  inertia: iv,
  tween: C2,
  keyframes: C2,
  spring: o7
};
function A2({ autoplay: t = !0, delay: e = 0, driver: r = hH, keyframes: i, type: s = "keyframes", repeat: c = 0, repeatDelay: u = 0, repeatType: l = "loop", onPlay: f, onStop: o, onComplete: g, onUpdate: p, ...n }) {
  let a = 1, d = !1, m, b;
  const w = () => {
    b = new Promise((U) => {
      m = U;
    });
  };
  w();
  let v;
  const h = fH[s] || C2;
  let x;
  h !== C2 && typeof i[0] != "number" && (process.env.NODE_ENV !== "production" && ha(i.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${i}`), x = s7([0, 100], i, {
    clamp: !1
  }), i = [0, 100]);
  const _ = h({ ...n, keyframes: i });
  let M;
  l === "mirror" && (M = h({
    ...n,
    keyframes: [...i].reverse(),
    velocity: -(n.velocity || 0)
  }));
  let O = "idle", E = null, I = null, R = null;
  _.calculatedDuration === null && c && (_.calculatedDuration = D3(_));
  const { calculatedDuration: W } = _;
  let z = 1 / 0, j = 1 / 0;
  W !== null && (z = W + u, j = z * (c + 1) - u);
  let $ = 0;
  const B = (U) => {
    if (I === null)
      return;
    a > 0 && (I = Math.min(I, U)), a < 0 && (I = Math.min(U - j / a, I)), E !== null ? $ = E : $ = Math.round(U - I) * a;
    const K = $ - e * (a >= 0 ? 1 : -1), X = a >= 0 ? K < 0 : K > j;
    $ = Math.max(K, 0), O === "finished" && E === null && ($ = j);
    let L = $, H = _;
    if (c) {
      const Y = Math.min($, j) / z;
      let Z = Math.floor(Y), rt = Y % 1;
      !rt && Y >= 1 && (rt = 1), rt === 1 && Z--, Z = Math.min(Z, c + 1), !!(Z % 2) && (l === "reverse" ? (rt = 1 - rt, u && (rt -= u / z)) : l === "mirror" && (H = M)), L = rl(0, 1, rt) * z;
    }
    const Q = X ? { done: !1, value: i[0] } : H.next(L);
    x && (Q.value = x(Q.value));
    let { done: N } = Q;
    !X && W !== null && (N = a >= 0 ? $ >= j : $ <= 0);
    const V = E === null && (O === "finished" || O === "running" && N);
    return p && p(Q.value), V && F(), Q;
  }, C = () => {
    v && v.stop(), v = void 0;
  }, T = () => {
    O = "idle", C(), m(), w(), I = R = null;
  }, F = () => {
    O = "finished", g && g(), C(), m();
  }, S = () => {
    if (d)
      return;
    v || (v = r(B));
    const U = v.now();
    f && f(), E !== null ? I = U - E : (!I || O === "finished") && (I = U), O === "finished" && w(), R = I, E = null, O = "running", v.start();
  };
  t && S();
  const A = {
    then(U, K) {
      return b.then(U, K);
    },
    get time() {
      return xs($);
    },
    set time(U) {
      U = io(U), $ = U, E !== null || !v || a === 0 ? E = U : I = v.now() - U / a;
    },
    get duration() {
      const U = _.calculatedDuration === null ? D3(_) : _.calculatedDuration;
      return xs(U);
    },
    get speed() {
      return a;
    },
    set speed(U) {
      U === a || !v || (a = U, A.time = xs($));
    },
    get state() {
      return O;
    },
    play: S,
    pause: () => {
      O = "paused", E = $;
    },
    stop: () => {
      d = !0, O !== "idle" && (O = "idle", o && o(), T());
    },
    cancel: () => {
      R !== null && B(R), T();
    },
    complete: () => {
      O = "finished";
    },
    sample: (U) => (I = 0, B(U))
  };
  return A;
}
function U_(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const dH = U_(() => Object.hasOwnProperty.call(Element.prototype, "animate")), gH = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), td = 10, pH = 2e4, mH = (t, e) => e.type === "spring" || t === "backgroundColor" || !m_(e.ease);
function yH(t, e, { onUpdate: r, onComplete: i, ...s }) {
  if (!(dH() && gH.has(e) && !s.repeatDelay && s.repeatType !== "mirror" && s.damping !== 0 && s.type !== "inertia"))
    return !1;
  let u = !1, l, f, o = !1;
  const g = () => {
    f = new Promise((h) => {
      l = h;
    });
  };
  g();
  let { keyframes: p, duration: n = 300, ease: a, times: d } = s;
  if (mH(e, s)) {
    const h = A2({
      ...s,
      repeat: 0,
      delay: 0
    });
    let x = { done: !1, value: p[0] };
    const _ = [];
    let M = 0;
    for (; !x.done && M < pH; )
      x = h.sample(M), _.push(x.value), M += td;
    d = void 0, p = _, n = M - td, a = "linear";
  }
  const m = IU(t.owner.current, e, p, {
    ...s,
    duration: n,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: a,
    times: d
  }), b = () => {
    o = !1, m.cancel();
  }, w = () => {
    o = !0, Nn.update(b), l(), g();
  };
  return m.onfinish = () => {
    o || (t.set(FU(p, s)), i && i(), w());
  }, {
    then(h, x) {
      return f.then(h, x);
    },
    attachTimeline(h) {
      return m.timeline = h, m.onfinish = null, cr;
    },
    get time() {
      return xs(m.currentTime || 0);
    },
    set time(h) {
      m.currentTime = io(h);
    },
    get speed() {
      return m.playbackRate;
    },
    set speed(h) {
      m.playbackRate = h;
    },
    get duration() {
      return xs(n);
    },
    play: () => {
      u || (m.play(), Ja(b));
    },
    pause: () => m.pause(),
    stop: () => {
      if (u = !0, m.playState === "idle")
        return;
      const { currentTime: h } = m;
      if (h) {
        const x = A2({
          ...s,
          autoplay: !1
        });
        t.setWithVelocity(x.sample(h - td).value, x.sample(h).value, td);
      }
      w();
    },
    complete: () => {
      o || m.finish();
    },
    cancel: w
  };
}
function bH({ keyframes: t, delay: e, onUpdate: r, onComplete: i }) {
  const s = () => (r && r(t[t.length - 1]), i && i(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: cr,
    pause: cr,
    stop: cr,
    then: (c) => (c(), Promise.resolve()),
    cancel: cr,
    complete: cr
  });
  return e ? A2({
    keyframes: [0, 1],
    duration: 0,
    delay: e,
    onComplete: s
  }) : s();
}
const vH = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, wH = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), xH = {
  type: "keyframes",
  duration: 0.8
}, SH = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, CH = (t, { keyframes: e }) => e.length > 2 ? xH : Mc.has(t) ? t.startsWith("scale") ? wH(e[1]) : vH : SH, $3 = (t, e) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(il.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url(")), AH = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function _H(t) {
  const [e, r] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [i] = r.match(tp) || [];
  if (!i)
    return t;
  const s = r.replace(i, "");
  let c = AH.has(e) ? 1 : 0;
  return i !== r && (c *= 100), e + "(" + c + s + ")";
}
const kH = /([a-z-]*)\(.*?\)/g, L3 = {
  ...il,
  getAnimatableNone: (t) => {
    const e = t.match(kH);
    return e ? e.map(_H).join(" ") : t;
  }
}, OH = {
  ...t_,
  // Color props
  color: xi,
  backgroundColor: xi,
  outlineColor: xi,
  fill: xi,
  stroke: xi,
  // Border props
  borderColor: xi,
  borderTopColor: xi,
  borderRightColor: xi,
  borderBottomColor: xi,
  borderLeftColor: xi,
  filter: L3,
  WebkitFilter: L3
}, l7 = (t) => OH[t];
function H_(t, e) {
  let r = l7(t);
  return r !== L3 && (r = il), r.getAnimatableNone ? r.getAnimatableNone(e) : void 0;
}
const V_ = (t) => /^0[^.\s]+$/.test(t);
function TH(t) {
  if (typeof t == "number")
    return t === 0;
  if (t !== null)
    return t === "none" || t === "0" || V_(t);
}
function MH(t, e, r, i) {
  const s = $3(e, r);
  let c;
  Array.isArray(r) ? c = [...r] : c = [null, r];
  const u = i.from !== void 0 ? i.from : t.get();
  let l;
  const f = [];
  for (let o = 0; o < c.length; o++)
    c[o] === null && (c[o] = o === 0 ? u : c[o - 1]), TH(c[o]) && f.push(o), typeof c[o] == "string" && c[o] !== "none" && c[o] !== "0" && (l = c[o]);
  if (s && f.length && l)
    for (let o = 0; o < f.length; o++) {
      const g = f[o];
      c[g] = H_(e, l);
    }
  return c;
}
function EH({ when: t, delay: e, delayChildren: r, staggerChildren: i, staggerDirection: s, repeat: c, repeatType: u, repeatDelay: l, from: f, elapsed: o, ...g }) {
  return !!Object.keys(g).length;
}
function c7(t, e) {
  return t[e] || t.default || t;
}
const PH = {
  skipAnimations: !1
}, u7 = (t, e, r, i = {}) => (s) => {
  const c = c7(i, t) || {}, u = c.delay || i.delay || 0;
  let { elapsed: l = 0 } = i;
  l = l - io(u);
  const f = MH(e, t, r, c), o = f[0], g = f[f.length - 1], p = $3(t, o), n = $3(t, g);
  Fh(p === n, `You are trying to animate ${t} from "${o}" to "${g}". ${o} is not an animatable value - to enable this animation set ${o} to a value animatable to ${g} via the \`style\` property.`);
  let a = {
    keyframes: f,
    velocity: e.getVelocity(),
    ease: "easeOut",
    ...c,
    delay: -l,
    onUpdate: (d) => {
      e.set(d), c.onUpdate && c.onUpdate(d);
    },
    onComplete: () => {
      s(), c.onComplete && c.onComplete();
    }
  };
  if (EH(c) || (a = {
    ...a,
    ...CH(t, a)
  }), a.duration && (a.duration = io(a.duration)), a.repeatDelay && (a.repeatDelay = io(a.repeatDelay)), !p || !n || PU.current || c.type === !1 || PH.skipAnimations)
    return bH(a);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !i.isHandoff && e.owner && e.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !e.owner.getProps().onUpdate
  ) {
    const d = yH(e, t, a);
    if (d)
      return d;
  }
  return A2(a);
};
function _2(t) {
  return !!(fi(t) && t.add);
}
const z_ = (t) => /^\-?\d*\.?\d+$/.test(t);
function h7(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function ip(t, e) {
  const r = t.indexOf(e);
  r > -1 && t.splice(r, 1);
}
class f7 {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return h7(this.subscriptions, e), () => ip(this.subscriptions, e);
  }
  notify(e, r, i) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](e, r, i);
      else
        for (let c = 0; c < s; c++) {
          const u = this.subscriptions[c];
          u && u(e, r, i);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const av = /* @__PURE__ */ new Set();
function d7(t, e, r) {
  t || av.has(e) || (console.warn(e), av.add(e));
}
const IH = (t) => !isNaN(parseFloat(t)), D1 = {
  current: void 0
};
class FH {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, r = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (i, s = !0) => {
      this.prev = this.current, this.current = i;
      const { delta: c, timestamp: u } = ni;
      this.lastUpdated !== u && (this.timeDelta = c, this.lastUpdated = u, Nn.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), s && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => Nn.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: i }) => {
      i !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = IH(this.current), this.owner = r.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && d7(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, r) {
    this.events[e] || (this.events[e] = new f7());
    const i = this.events[e].add(r);
    return e === "change" ? () => {
      i(), Nn.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : i;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, r) {
    this.passiveEffect = e, this.stopPassiveEffect = r;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, r = !0) {
    !r || !this.passiveEffect ? this.updateAndNotify(e, r) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, r, i) {
    this.set(r), this.prev = e, this.timeDelta = i;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e) {
    this.updateAndNotify(e), this.prev = e, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return D1.current && D1.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      B_(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((r) => {
      this.hasAnimated = !0, this.animation = e(r), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function vc(t, e) {
  return new FH(t, e);
}
const X_ = (t) => (e) => e.test(t), RH = {
  test: (t) => t === "auto",
  parse: (t) => t
}, q_ = [Ec, Ge, ws, Do, Wj, qj, RH], a1 = (t) => q_.find(X_(t)), DH = [...q_, xi, il], $H = (t) => DH.find(X_(t));
function LH(t, e, r) {
  t.hasValue(e) ? t.getValue(e).set(r) : t.addValue(e, vc(r));
}
function NH(t, e) {
  const r = rp(t, e);
  let { transitionEnd: i = {}, transition: s = {}, ...c } = r ? t.makeTargetAnimatable(r, !1) : {};
  c = { ...c, ...i };
  for (const u in c) {
    const l = oU(c[u]);
    LH(t, u, l);
  }
}
function BH(t, e, r) {
  var i, s;
  const c = Object.keys(e).filter((l) => !t.hasValue(l)), u = c.length;
  if (u)
    for (let l = 0; l < u; l++) {
      const f = c[l], o = e[f];
      let g = null;
      Array.isArray(o) && (g = o[0]), g === null && (g = (s = (i = r[f]) !== null && i !== void 0 ? i : t.readValue(f)) !== null && s !== void 0 ? s : e[f]), g != null && (typeof g == "string" && (z_(g) || V_(g)) ? g = parseFloat(g) : !$H(g) && il.test(o) && (g = H_(f, o)), t.addValue(f, vc(g, { owner: t })), r[f] === void 0 && (r[f] = g), g !== null && t.setBaseTarget(f, g));
    }
}
function jH(t, e) {
  return e ? (e[t] || e.default || e).from : void 0;
}
function UH(t, e, r) {
  const i = {};
  for (const s in t) {
    const c = jH(s, e);
    if (c !== void 0)
      i[s] = c;
    else {
      const u = r.getValue(s);
      u && (i[s] = u.get());
    }
  }
  return i;
}
function HH({ protectedKeys: t, needsAnimating: e }, r) {
  const i = t.hasOwnProperty(r) && e[r] !== !0;
  return e[r] = !1, i;
}
function VH(t, e) {
  const r = t.get();
  if (Array.isArray(e)) {
    for (let i = 0; i < e.length; i++)
      if (e[i] !== r)
        return !0;
  } else
    return r !== e;
}
function g7(t, e, { delay: r = 0, transitionOverride: i, type: s } = {}) {
  let { transition: c = t.getDefaultTransition(), transitionEnd: u, ...l } = t.makeTargetAnimatable(e);
  const f = t.getValue("willChange");
  i && (c = i);
  const o = [], g = s && t.animationState && t.animationState.getState()[s];
  for (const p in l) {
    const n = t.getValue(p), a = l[p];
    if (!n || a === void 0 || g && HH(g, p))
      continue;
    const d = {
      delay: r,
      elapsed: 0,
      ...c7(c || {}, p)
    };
    if (window.HandoffAppearAnimations) {
      const w = t.getProps()[WA];
      if (w) {
        const v = window.HandoffAppearAnimations(w, p, n, Nn);
        v !== null && (d.elapsed = v, d.isHandoff = !0);
      }
    }
    let m = !d.isHandoff && !VH(n, a);
    if (d.type === "spring" && (n.getVelocity() || d.velocity) && (m = !1), n.animation && (m = !1), m)
      continue;
    n.start(u7(p, n, a, t.shouldReduceMotion && Mc.has(p) ? { type: !1 } : d));
    const b = n.animation;
    _2(f) && (f.add(p), b.then(() => f.remove(p))), o.push(b);
  }
  return u && Promise.all(o).then(() => {
    u && NH(t, u);
  }), o;
}
function N3(t, e, r = {}) {
  const i = rp(t, e, r.custom);
  let { transition: s = t.getDefaultTransition() || {} } = i || {};
  r.transitionOverride && (s = r.transitionOverride);
  const c = i ? () => Promise.all(g7(t, i, r)) : () => Promise.resolve(), u = t.variantChildren && t.variantChildren.size ? (f = 0) => {
    const { delayChildren: o = 0, staggerChildren: g, staggerDirection: p } = s;
    return zH(t, e, o + f, g, p, r);
  } : () => Promise.resolve(), { when: l } = s;
  if (l) {
    const [f, o] = l === "beforeChildren" ? [c, u] : [u, c];
    return f().then(() => o());
  } else
    return Promise.all([c(), u(r.delay)]);
}
function zH(t, e, r = 0, i = 0, s = 1, c) {
  const u = [], l = (t.variantChildren.size - 1) * i, f = s === 1 ? (o = 0) => o * i : (o = 0) => l - o * i;
  return Array.from(t.variantChildren).sort(XH).forEach((o, g) => {
    o.notify("AnimationStart", e), u.push(N3(o, e, {
      ...c,
      delay: r + f(g)
    }).then(() => o.notify("AnimationComplete", e)));
  }), Promise.all(u);
}
function XH(t, e) {
  return t.sortNodePosition(e);
}
function qH(t, e, r = {}) {
  t.notify("AnimationStart", e);
  let i;
  if (Array.isArray(e)) {
    const s = e.map((c) => N3(t, c, r));
    i = Promise.all(s);
  } else if (typeof e == "string")
    i = N3(t, e, r);
  else {
    const s = typeof e == "function" ? rp(t, e, r.custom) : e;
    i = Promise.all(g7(t, s, r));
  }
  return i.then(() => t.notify("AnimationComplete", e));
}
const WH = [...W6].reverse(), GH = W6.length;
function KH(t) {
  return (e) => Promise.all(e.map(({ animation: r, options: i }) => qH(t, r, i)));
}
function YH(t) {
  let e = KH(t);
  const r = JH();
  let i = !0;
  const s = (f, o) => {
    const g = rp(t, o);
    if (g) {
      const { transition: p, transitionEnd: n, ...a } = g;
      f = { ...f, ...a, ...n };
    }
    return f;
  };
  function c(f) {
    e = f(t);
  }
  function u(f, o) {
    const g = t.getProps(), p = t.getVariantContext(!0) || {}, n = [], a = /* @__PURE__ */ new Set();
    let d = {}, m = 1 / 0;
    for (let w = 0; w < GH; w++) {
      const v = WH[w], h = r[v], x = g[v] !== void 0 ? g[v] : p[v], _ = th(x), M = v === o ? h.isActive : null;
      M === !1 && (m = w);
      let O = x === p[v] && x !== g[v] && _;
      if (O && i && t.manuallyAnimateOnMount && (O = !1), h.protectedKeys = { ...d }, // If it isn't active and hasn't *just* been set as inactive
      !h.isActive && M === null || // If we didn't and don't have any defined prop for this animation type
      !x && !h.prevProp || // Or if the prop doesn't define an animation
      Jg(x) || typeof x == "boolean")
        continue;
      let I = ZH(h.prevProp, x) || // If we're making this variant active, we want to always make it active
      v === o && h.isActive && !O && _ || // If we removed a higher-priority variant (i is in reverse order)
      w > m && _, R = !1;
      const W = Array.isArray(x) ? x : [x];
      let z = W.reduce(s, {});
      M === !1 && (z = {});
      const { prevResolvedValues: j = {} } = h, $ = {
        ...j,
        ...z
      }, B = (C) => {
        I = !0, a.has(C) && (R = !0, a.delete(C)), h.needsAnimating[C] = !0;
      };
      for (const C in $) {
        const T = z[C], F = j[C];
        if (d.hasOwnProperty(C))
          continue;
        let S = !1;
        x2(T) && x2(F) ? S = !g_(T, F) : S = T !== F, S ? T !== void 0 ? B(C) : a.add(C) : T !== void 0 && a.has(C) ? B(C) : h.protectedKeys[C] = !0;
      }
      h.prevProp = x, h.prevResolvedValues = z, h.isActive && (d = { ...d, ...z }), i && t.blockInitialAnimation && (I = !1), I && (!O || R) && n.push(...W.map((C) => ({
        animation: C,
        options: { type: v, ...f }
      })));
    }
    if (a.size) {
      const w = {};
      a.forEach((v) => {
        const h = t.getBaseTarget(v);
        h !== void 0 && (w[v] = h);
      }), n.push({ animation: w });
    }
    let b = !!n.length;
    return i && (g.initial === !1 || g.initial === g.animate) && !t.manuallyAnimateOnMount && (b = !1), i = !1, b ? e(n) : Promise.resolve();
  }
  function l(f, o, g) {
    var p;
    if (r[f].isActive === o)
      return Promise.resolve();
    (p = t.variantChildren) === null || p === void 0 || p.forEach((a) => {
      var d;
      return (d = a.animationState) === null || d === void 0 ? void 0 : d.setActive(f, o);
    }), r[f].isActive = o;
    const n = u(g, f);
    for (const a in r)
      r[a].protectedKeys = {};
    return n;
  }
  return {
    animateChanges: u,
    setActive: l,
    setAnimateFunction: c,
    getState: () => r
  };
}
function ZH(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !g_(e, t) : !1;
}
function Nl(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function JH() {
  return {
    animate: Nl(!0),
    whileInView: Nl(),
    whileHover: Nl(),
    whileTap: Nl(),
    whileDrag: Nl(),
    whileFocus: Nl(),
    exit: Nl()
  };
}
class QH extends pl {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = YH(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    this.unmount(), Jg(e) && (this.unmount = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: r } = this.node.prevProps || {};
    e !== r && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let tV = 0;
class eV extends pl {
  constructor() {
    super(...arguments), this.id = tV++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: r, custom: i } = this.node.presenceContext, { isPresent: s } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === s)
      return;
    const c = this.node.animationState.setActive("exit", !e, { custom: i ?? this.node.getProps().custom });
    r && !e && c.then(() => r(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const nV = {
  animation: {
    Feature: QH
  },
  exit: {
    Feature: eV
  }
}, sv = (t, e) => Math.abs(t - e);
function rV(t, e) {
  const r = sv(t.x, e.x), i = sv(t.y, e.y);
  return Math.sqrt(r ** 2 + i ** 2);
}
class W_ {
  constructor(e, r, { transformPagePoint: i, contextWindow: s, dragSnapToOrigin: c = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const p = dm(this.lastMoveEventInfo, this.history), n = this.startEvent !== null, a = rV(p.offset, { x: 0, y: 0 }) >= 3;
      if (!n && !a)
        return;
      const { point: d } = p, { timestamp: m } = ni;
      this.history.push({ ...d, timestamp: m });
      const { onStart: b, onMove: w } = this.handlers;
      n || (b && b(this.lastMoveEvent, p), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, p);
    }, this.handlePointerMove = (p, n) => {
      this.lastMoveEvent = p, this.lastMoveEventInfo = fm(n, this.transformPagePoint), Nn.update(this.updatePoint, !0);
    }, this.handlePointerUp = (p, n) => {
      this.end();
      const { onEnd: a, onSessionEnd: d, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const b = dm(p.type === "pointercancel" ? this.lastMoveEventInfo : fm(n, this.transformPagePoint), this.history);
      this.startEvent && a && a(p, b), d && d(p, b);
    }, !c_(e))
      return;
    this.dragSnapToOrigin = c, this.handlers = r, this.transformPagePoint = i, this.contextWindow = s || window;
    const u = np(e), l = fm(u, this.transformPagePoint), { point: f } = l, { timestamp: o } = ni;
    this.history = [{ ...f, timestamp: o }];
    const { onSessionStart: g } = r;
    g && g(e, dm(l, this.history)), this.removeListeners = Xo(ro(this.contextWindow, "pointermove", this.handlePointerMove), ro(this.contextWindow, "pointerup", this.handlePointerUp), ro(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ja(this.updatePoint);
  }
}
function fm(t, e) {
  return e ? { point: e(t.point) } : t;
}
function ov(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function dm({ point: t }, e) {
  return {
    point: t,
    delta: ov(t, G_(e)),
    offset: ov(t, iV(e)),
    velocity: aV(e, 0.1)
  };
}
function iV(t) {
  return t[0];
}
function G_(t) {
  return t[t.length - 1];
}
function aV(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let r = t.length - 1, i = null;
  const s = G_(t);
  for (; r >= 0 && (i = t[r], !(s.timestamp - i.timestamp > io(e))); )
    r--;
  if (!i)
    return { x: 0, y: 0 };
  const c = xs(s.timestamp - i.timestamp);
  if (c === 0)
    return { x: 0, y: 0 };
  const u = {
    x: (s.x - i.x) / c,
    y: (s.y - i.y) / c
  };
  return u.x === 1 / 0 && (u.x = 0), u.y === 1 / 0 && (u.y = 0), u;
}
function fa(t) {
  return t.max - t.min;
}
function B3(t, e = 0, r = 0.01) {
  return Math.abs(t - e) <= r;
}
function lv(t, e, r, i = 0.5) {
  t.origin = i, t.originPoint = er(e.min, e.max, t.origin), t.scale = fa(r) / fa(e), (B3(t.scale, 1, 1e-4) || isNaN(t.scale)) && (t.scale = 1), t.translate = er(r.min, r.max, t.origin) - t.originPoint, (B3(t.translate) || isNaN(t.translate)) && (t.translate = 0);
}
function $1(t, e, r, i) {
  lv(t.x, e.x, r.x, i ? i.originX : void 0), lv(t.y, e.y, r.y, i ? i.originY : void 0);
}
function cv(t, e, r) {
  t.min = r.min + e.min, t.max = t.min + fa(e);
}
function sV(t, e, r) {
  cv(t.x, e.x, r.x), cv(t.y, e.y, r.y);
}
function uv(t, e, r) {
  t.min = e.min - r.min, t.max = t.min + fa(e);
}
function L1(t, e, r) {
  uv(t.x, e.x, r.x), uv(t.y, e.y, r.y);
}
function oV(t, { min: e, max: r }, i) {
  return e !== void 0 && t < e ? t = i ? er(e, t, i.min) : Math.max(t, e) : r !== void 0 && t > r && (t = i ? er(r, t, i.max) : Math.min(t, r)), t;
}
function hv(t, e, r) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: r !== void 0 ? t.max + r - (t.max - t.min) : void 0
  };
}
function lV(t, { top: e, left: r, bottom: i, right: s }) {
  return {
    x: hv(t.x, r, s),
    y: hv(t.y, e, i)
  };
}
function fv(t, e) {
  let r = e.min - t.min, i = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([r, i] = [i, r]), { min: r, max: i };
}
function cV(t, e) {
  return {
    x: fv(t.x, e.x),
    y: fv(t.y, e.y)
  };
}
function uV(t, e) {
  let r = 0.5;
  const i = fa(t), s = fa(e);
  return s > i ? r = Zu(e.min, e.max - i, t.min) : i > s && (r = Zu(t.min, t.max - s, e.min)), rl(0, 1, r);
}
function hV(t, e) {
  const r = {};
  return e.min !== void 0 && (r.min = e.min - t.min), e.max !== void 0 && (r.max = e.max - t.min), r;
}
const j3 = 0.35;
function fV(t = j3) {
  return t === !1 ? t = 0 : t === !0 && (t = j3), {
    x: dv(t, "left", "right"),
    y: dv(t, "top", "bottom")
  };
}
function dv(t, e, r) {
  return {
    min: gv(t, e),
    max: gv(t, r)
  };
}
function gv(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const pv = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), ku = () => ({
  x: pv(),
  y: pv()
}), mv = () => ({ min: 0, max: 0 }), vr = () => ({
  x: mv(),
  y: mv()
});
function _a(t) {
  return [t("x"), t("y")];
}
function K_({ top: t, left: e, right: r, bottom: i }) {
  return {
    x: { min: e, max: r },
    y: { min: t, max: i }
  };
}
function dV({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function gV(t, e) {
  if (!e)
    return t;
  const r = e({ x: t.left, y: t.top }), i = e({ x: t.right, y: t.bottom });
  return {
    top: r.y,
    left: r.x,
    bottom: i.y,
    right: i.x
  };
}
function gm(t) {
  return t === void 0 || t === 1;
}
function U3({ scale: t, scaleX: e, scaleY: r }) {
  return !gm(t) || !gm(e) || !gm(r);
}
function Hl(t) {
  return U3(t) || Y_(t) || t.z || t.rotate || t.rotateX || t.rotateY;
}
function Y_(t) {
  return yv(t.x) || yv(t.y);
}
function yv(t) {
  return t && t !== "0%";
}
function k2(t, e, r) {
  const i = t - r, s = e * i;
  return r + s;
}
function bv(t, e, r, i, s) {
  return s !== void 0 && (t = k2(t, s, i)), k2(t, r, i) + e;
}
function H3(t, e = 0, r = 1, i, s) {
  t.min = bv(t.min, e, r, i, s), t.max = bv(t.max, e, r, i, s);
}
function Z_(t, { x: e, y: r }) {
  H3(t.x, e.translate, e.scale, e.originPoint), H3(t.y, r.translate, r.scale, r.originPoint);
}
function pV(t, e, r, i = !1) {
  const s = r.length;
  if (!s)
    return;
  e.x = e.y = 1;
  let c, u;
  for (let l = 0; l < s; l++) {
    c = r[l], u = c.projectionDelta;
    const f = c.instance;
    f && f.style && f.style.display === "contents" || (i && c.options.layoutScroll && c.scroll && c !== c.root && Ou(t, {
      x: -c.scroll.offset.x,
      y: -c.scroll.offset.y
    }), u && (e.x *= u.x.scale, e.y *= u.y.scale, Z_(t, u)), i && Hl(c.latestValues) && Ou(t, c.latestValues));
  }
  e.x = vv(e.x), e.y = vv(e.y);
}
function vv(t) {
  return Number.isInteger(t) || t > 1.0000000000001 || t < 0.999999999999 ? t : 1;
}
function Lo(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function wv(t, e, [r, i, s]) {
  const c = e[s] !== void 0 ? e[s] : 0.5, u = er(t.min, t.max, c);
  H3(t, e[r], e[i], u, e.scale);
}
const mV = ["x", "scaleX", "originX"], yV = ["y", "scaleY", "originY"];
function Ou(t, e) {
  wv(t.x, e, mV), wv(t.y, e, yV);
}
function J_(t, e) {
  return K_(gV(t.getBoundingClientRect(), e));
}
function bV(t, e, r) {
  const i = J_(t, r), { scroll: s } = e;
  return s && (Lo(i.x, s.offset.x), Lo(i.y, s.offset.y)), i;
}
const Q_ = ({ current: t }) => t ? t.ownerDocument.defaultView : null, vV = /* @__PURE__ */ new WeakMap();
class wV {
  constructor(e) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = vr(), this.visualElement = e;
  }
  start(e, { snapToCursor: r = !1 } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const s = (g) => {
      const { dragSnapToOrigin: p } = this.getProps();
      p ? this.pauseAnimation() : this.stopAnimation(), r && this.snapToCursor(np(g, "page").point);
    }, c = (g, p) => {
      const { drag: n, dragPropagation: a, onDragStart: d } = this.getProps();
      if (n && !a && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = h_(n), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), _a((b) => {
        let w = this.getAxisMotionValue(b).get() || 0;
        if (ws.test(w)) {
          const { projection: v } = this.visualElement;
          if (v && v.layout) {
            const h = v.layout.layoutBox[b];
            h && (w = fa(h) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[b] = w;
      }), d && Nn.update(() => d(g, p), !1, !0);
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, u = (g, p) => {
      const { dragPropagation: n, dragDirectionLock: a, onDirectionLock: d, onDrag: m } = this.getProps();
      if (!n && !this.openGlobalLock)
        return;
      const { offset: b } = p;
      if (a && this.currentDirection === null) {
        this.currentDirection = xV(b), this.currentDirection !== null && d && d(this.currentDirection);
        return;
      }
      this.updateAxis("x", p.point, b), this.updateAxis("y", p.point, b), this.visualElement.render(), m && m(g, p);
    }, l = (g, p) => this.stop(g, p), f = () => _a((g) => {
      var p;
      return this.getAnimationState(g) === "paused" && ((p = this.getAxisMotionValue(g).animation) === null || p === void 0 ? void 0 : p.play());
    }), { dragSnapToOrigin: o } = this.getProps();
    this.panSession = new W_(e, {
      onSessionStart: s,
      onStart: c,
      onMove: u,
      onSessionEnd: l,
      resumeAnimation: f
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: o,
      contextWindow: Q_(this.visualElement)
    });
  }
  stop(e, r) {
    const i = this.isDragging;
    if (this.cancel(), !i)
      return;
    const { velocity: s } = r;
    this.startAnimation(s);
    const { onDragEnd: c } = this.getProps();
    c && Nn.update(() => c(e, r));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: r } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: i } = this.getProps();
    !i && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), r && r.setActive("whileDrag", !1);
  }
  updateAxis(e, r, i) {
    const { drag: s } = this.getProps();
    if (!i || !ed(e, s, this.currentDirection))
      return;
    const c = this.getAxisMotionValue(e);
    let u = this.originPoint[e] + i[e];
    this.constraints && this.constraints[e] && (u = oV(u, this.constraints[e], this.elastic[e])), c.set(u);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: r, dragElastic: i } = this.getProps(), s = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, c = this.constraints;
    r && Au(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && s ? this.constraints = lV(s.layoutBox, r) : this.constraints = !1, this.elastic = fV(i), c !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && _a((u) => {
      this.getAxisMotionValue(u) && (this.constraints[u] = hV(s.layoutBox[u], this.constraints[u]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: r } = this.getProps();
    if (!e || !Au(e))
      return !1;
    const i = e.current;
    ha(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    const c = bV(i, s.root, this.visualElement.getTransformPagePoint());
    let u = cV(s.layout.layoutBox, c);
    if (r) {
      const l = r(dV(u));
      this.hasMutatedConstraints = !!l, l && (u = K_(l));
    }
    return u;
  }
  startAnimation(e) {
    const { drag: r, dragMomentum: i, dragElastic: s, dragTransition: c, dragSnapToOrigin: u, onDragTransitionEnd: l } = this.getProps(), f = this.constraints || {}, o = _a((g) => {
      if (!ed(g, r, this.currentDirection))
        return;
      let p = f && f[g] || {};
      u && (p = { min: 0, max: 0 });
      const n = s ? 200 : 1e6, a = s ? 40 : 1e7, d = {
        type: "inertia",
        velocity: i ? e[g] : 0,
        bounceStiffness: n,
        bounceDamping: a,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...c,
        ...p
      };
      return this.startAxisValueAnimation(g, d);
    });
    return Promise.all(o).then(l);
  }
  startAxisValueAnimation(e, r) {
    const i = this.getAxisMotionValue(e);
    return i.start(u7(e, i, 0, r));
  }
  stopAnimation() {
    _a((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    _a((e) => {
      var r;
      return (r = this.getAxisMotionValue(e).animation) === null || r === void 0 ? void 0 : r.pause();
    });
  }
  getAnimationState(e) {
    var r;
    return (r = this.getAxisMotionValue(e).animation) === null || r === void 0 ? void 0 : r.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const r = "_drag" + e.toUpperCase(), i = this.visualElement.getProps(), s = i[r];
    return s || this.visualElement.getValue(e, (i.initial ? i.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    _a((r) => {
      const { drag: i } = this.getProps();
      if (!ed(r, i, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, c = this.getAxisMotionValue(r);
      if (s && s.layout) {
        const { min: u, max: l } = s.layout.layoutBox[r];
        c.set(e[r] - er(u, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: r } = this.getProps(), { projection: i } = this.visualElement;
    if (!Au(r) || !i || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    _a((u) => {
      const l = this.getAxisMotionValue(u);
      if (l) {
        const f = l.get();
        s[u] = uV({ min: f, max: f }, this.constraints[u]);
      }
    });
    const { transformTemplate: c } = this.visualElement.getProps();
    this.visualElement.current.style.transform = c ? c({}, "") : "none", i.root && i.root.updateScroll(), i.updateLayout(), this.resolveConstraints(), _a((u) => {
      if (!ed(u, e, null))
        return;
      const l = this.getAxisMotionValue(u), { min: f, max: o } = this.constraints[u];
      l.set(er(f, o, s[u]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    vV.set(this.visualElement, this);
    const e = this.visualElement.current, r = ro(e, "pointerdown", (f) => {
      const { drag: o, dragListener: g = !0 } = this.getProps();
      o && g && this.start(f);
    }), i = () => {
      const { dragConstraints: f } = this.getProps();
      Au(f) && (this.constraints = this.resolveRefConstraints());
    }, { projection: s } = this.visualElement, c = s.addEventListener("measure", i);
    s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), i();
    const u = Qs(window, "resize", () => this.scalePositionWithinConstraints()), l = s.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: o }) => {
      this.isDragging && o && (_a((g) => {
        const p = this.getAxisMotionValue(g);
        p && (this.originPoint[g] += f[g].translate, p.set(p.get() + f[g].translate));
      }), this.visualElement.render());
    });
    return () => {
      u(), r(), c(), l && l();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: r = !1, dragDirectionLock: i = !1, dragPropagation: s = !1, dragConstraints: c = !1, dragElastic: u = j3, dragMomentum: l = !0 } = e;
    return {
      ...e,
      drag: r,
      dragDirectionLock: i,
      dragPropagation: s,
      dragConstraints: c,
      dragElastic: u,
      dragMomentum: l
    };
  }
}
function ed(t, e, r) {
  return (e === !0 || e === t) && (r === null || r === t);
}
function xV(t, e = 10) {
  let r = null;
  return Math.abs(t.y) > e ? r = "y" : Math.abs(t.x) > e && (r = "x"), r;
}
class SV extends pl {
  constructor(e) {
    super(e), this.removeGroupControls = cr, this.removeListeners = cr, this.controls = new wV(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || cr;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const xv = (t) => (e, r) => {
  t && Nn.update(() => t(e, r));
};
class CV extends pl {
  constructor() {
    super(...arguments), this.removePointerDownListener = cr;
  }
  onPointerDown(e) {
    this.session = new W_(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Q_(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: r, onPan: i, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: xv(e),
      onStart: xv(r),
      onMove: i,
      onEnd: (c, u) => {
        delete this.session, s && Nn.update(() => s(c, u));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ro(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function AV() {
  const t = Kr(Kg);
  if (t === null)
    return [!0, null];
  const { isPresent: e, onExitComplete: r, register: i } = t, s = mr();
  return Tn(() => i(s), []), !e && r ? [!1, () => r && r(s)] : [!0];
}
const Gd = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Sv(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const s1 = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (Ge.test(t))
        t = parseFloat(t);
      else
        return t;
    const r = Sv(t, e.target.x), i = Sv(t, e.target.y);
    return `${r}% ${i}%`;
  }
}, _V = {
  correct: (t, { treeScale: e, projectionDelta: r }) => {
    const i = t, s = il.parse(t);
    if (s.length > 5)
      return i;
    const c = il.createTransformer(t), u = typeof s[0] != "number" ? 1 : 0, l = r.x.scale * e.x, f = r.y.scale * e.y;
    s[0 + u] /= l, s[1 + u] /= f;
    const o = er(l, f, 0.5);
    return typeof s[2 + u] == "number" && (s[2 + u] /= o), typeof s[3 + u] == "number" && (s[3 + u] /= o), c(s);
  }
};
class kV extends Bt.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: r, switchLayoutGroup: i, layoutId: s } = this.props, { projection: c } = e;
    Bj(OV), c && (r.group && r.group.add(c), i && i.register && s && i.register(c), c.root.didUpdate(), c.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), c.setOptions({
      ...c.options,
      onExitComplete: () => this.safeToRemove()
    })), Gd.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: r, visualElement: i, drag: s, isPresent: c } = this.props, u = i.projection;
    return u && (u.isPresent = c, s || e.layoutDependency !== r || r === void 0 ? u.willUpdate() : this.safeToRemove(), e.isPresent !== c && (c ? u.promote() : u.relegate() || Nn.postRender(() => {
      const l = u.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), queueMicrotask(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: r, switchLayoutGroup: i } = this.props, { projection: s } = e;
    s && (s.scheduleCheckAfterUnmount(), r && r.group && r.group.remove(s), i && i.deregister && i.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function tk(t) {
  const [e, r] = AV(), i = Kr(K6);
  return Bt.createElement(kV, { ...t, layoutGroup: i, switchLayoutGroup: Kr(KA), isPresent: e, safeToRemove: r });
}
const OV = {
  borderRadius: {
    ...s1,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: s1,
  borderTopRightRadius: s1,
  borderBottomLeftRadius: s1,
  borderBottomRightRadius: s1,
  boxShadow: _V
}, ek = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], TV = ek.length, Cv = (t) => typeof t == "string" ? parseFloat(t) : t, Av = (t) => typeof t == "number" || Ge.test(t);
function MV(t, e, r, i, s, c) {
  s ? (t.opacity = er(
    0,
    // TODO Reinstate this if only child
    r.opacity !== void 0 ? r.opacity : 1,
    EV(i)
  ), t.opacityExit = er(e.opacity !== void 0 ? e.opacity : 1, 0, PV(i))) : c && (t.opacity = er(e.opacity !== void 0 ? e.opacity : 1, r.opacity !== void 0 ? r.opacity : 1, i));
  for (let u = 0; u < TV; u++) {
    const l = `border${ek[u]}Radius`;
    let f = _v(e, l), o = _v(r, l);
    if (f === void 0 && o === void 0)
      continue;
    f || (f = 0), o || (o = 0), f === 0 || o === 0 || Av(f) === Av(o) ? (t[l] = Math.max(er(Cv(f), Cv(o), i), 0), (ws.test(o) || ws.test(f)) && (t[l] += "%")) : t[l] = o;
  }
  (e.rotate || r.rotate) && (t.rotate = er(e.rotate || 0, r.rotate || 0, i));
}
function _v(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const EV = nk(0, 0.5, A_), PV = nk(0.5, 0.95, cr);
function nk(t, e, r) {
  return (i) => i < t ? 0 : i > e ? 1 : r(Zu(t, e, i));
}
function kv(t, e) {
  t.min = e.min, t.max = e.max;
}
function Aa(t, e) {
  kv(t.x, e.x), kv(t.y, e.y);
}
function Ov(t, e, r, i, s) {
  return t -= e, t = k2(t, 1 / r, i), s !== void 0 && (t = k2(t, 1 / s, i)), t;
}
function IV(t, e = 0, r = 1, i = 0.5, s, c = t, u = t) {
  if (ws.test(e) && (e = parseFloat(e), e = er(u.min, u.max, e / 100) - u.min), typeof e != "number")
    return;
  let l = er(c.min, c.max, i);
  t === c && (l -= e), t.min = Ov(t.min, e, r, l, s), t.max = Ov(t.max, e, r, l, s);
}
function Tv(t, e, [r, i, s], c, u) {
  IV(t, e[r], e[i], e[s], e.scale, c, u);
}
const FV = ["x", "scaleX", "originX"], RV = ["y", "scaleY", "originY"];
function Mv(t, e, r, i) {
  Tv(t.x, e, FV, r ? r.x : void 0, i ? i.x : void 0), Tv(t.y, e, RV, r ? r.y : void 0, i ? i.y : void 0);
}
function Ev(t) {
  return t.translate === 0 && t.scale === 1;
}
function rk(t) {
  return Ev(t.x) && Ev(t.y);
}
function DV(t, e) {
  return t.x.min === e.x.min && t.x.max === e.x.max && t.y.min === e.y.min && t.y.max === e.y.max;
}
function ik(t, e) {
  return Math.round(t.x.min) === Math.round(e.x.min) && Math.round(t.x.max) === Math.round(e.x.max) && Math.round(t.y.min) === Math.round(e.y.min) && Math.round(t.y.max) === Math.round(e.y.max);
}
function Pv(t) {
  return fa(t.x) / fa(t.y);
}
class $V {
  constructor() {
    this.members = [];
  }
  add(e) {
    h7(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (ip(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const r = this.members[this.members.length - 1];
      r && this.promote(r);
    }
  }
  relegate(e) {
    const r = this.members.findIndex((s) => e === s);
    if (r === 0)
      return !1;
    let i;
    for (let s = r; s >= 0; s--) {
      const c = this.members[s];
      if (c.isPresent !== !1) {
        i = c;
        break;
      }
    }
    return i ? (this.promote(i), !0) : !1;
  }
  promote(e, r) {
    const i = this.lead;
    if (e !== i && (this.prevLead = i, this.lead = e, e.show(), i)) {
      i.instance && i.scheduleRender(), e.scheduleRender(), e.resumeFrom = i, r && (e.resumeFrom.preserveOpacity = !0), i.snapshot && (e.snapshot = i.snapshot, e.snapshot.latestValues = i.animationValues || i.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: s } = e.options;
      s === !1 && i.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: r, resumingFrom: i } = e;
      r.onExitComplete && r.onExitComplete(), i && i.options.onExitComplete && i.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Iv(t, e, r) {
  let i = "";
  const s = t.x.translate / e.x, c = t.y.translate / e.y;
  if ((s || c) && (i = `translate3d(${s}px, ${c}px, 0) `), (e.x !== 1 || e.y !== 1) && (i += `scale(${1 / e.x}, ${1 / e.y}) `), r) {
    const { rotate: f, rotateX: o, rotateY: g } = r;
    f && (i += `rotate(${f}deg) `), o && (i += `rotateX(${o}deg) `), g && (i += `rotateY(${g}deg) `);
  }
  const u = t.x.scale * e.x, l = t.y.scale * e.y;
  return (u !== 1 || l !== 1) && (i += `scale(${u}, ${l})`), i || "none";
}
const LV = (t, e) => t.depth - e.depth;
class NV {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    h7(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    ip(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(LV), this.isDirty = !1, this.children.forEach(e);
  }
}
function BV(t, e) {
  const r = performance.now(), i = ({ timestamp: s }) => {
    const c = s - r;
    c >= e && (Ja(i), t(c - e));
  };
  return Nn.read(i, !0), () => Ja(i);
}
function jV(t) {
  window.MotionDebug && window.MotionDebug.record(t);
}
function ak(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
function p7(t, e, r) {
  const i = fi(t) ? t : vc(t);
  return i.start(u7("", i, e, r)), i.animation;
}
const Fv = ["", "X", "Y", "Z"], UV = { visibility: "hidden" }, Rv = 1e3;
let HV = 0;
const Vl = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function sk({ attachResizeListener: t, defaultParent: e, measureScroll: r, checkIsScrollRoot: i, resetTransform: s }) {
  return class {
    constructor(u = {}, l = e == null ? void 0 : e()) {
      this.id = HV++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Vl.totalNodes = Vl.resolvedTargetDeltas = Vl.recalculatedProjection = 0, this.nodes.forEach(XV), this.nodes.forEach(YV), this.nodes.forEach(ZV), this.nodes.forEach(qV), jV(Vl);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = u, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let f = 0; f < this.path.length; f++)
        this.path[f].shouldResetTransform = !0;
      this.root === this && (this.nodes = new NV());
    }
    addEventListener(u, l) {
      return this.eventHandlers.has(u) || this.eventHandlers.set(u, new f7()), this.eventHandlers.get(u).add(l);
    }
    notifyListeners(u, ...l) {
      const f = this.eventHandlers.get(u);
      f && f.notify(...l);
    }
    hasListeners(u) {
      return this.eventHandlers.has(u);
    }
    /**
     * Lifecycles
     */
    mount(u, l = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = ak(u), this.instance = u;
      const { layoutId: f, layout: o, visualElement: g } = this.options;
      if (g && !g.current && g.mount(u), this.root.nodes.add(this), this.parent && this.parent.children.add(this), l && (o || f) && (this.isLayoutDirty = !0), t) {
        let p;
        const n = () => this.root.updateBlockedByResize = !1;
        t(u, () => {
          this.root.updateBlockedByResize = !0, p && p(), p = BV(n, 250), Gd.hasAnimatedSinceResize && (Gd.hasAnimatedSinceResize = !1, this.nodes.forEach($v));
        });
      }
      f && this.root.registerSharedNode(f, this), this.options.animate !== !1 && g && (f || o) && this.addEventListener("didUpdate", ({ delta: p, hasLayoutChanged: n, hasRelativeTargetChanged: a, layout: d }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || g.getDefaultTransition() || nz, { onLayoutAnimationStart: b, onLayoutAnimationComplete: w } = g.getProps(), v = !this.targetLayout || !ik(this.targetLayout, d) || a, h = !n && a;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || h || n && (v || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(p, h);
          const x = {
            ...c7(m, "layout"),
            onPlay: b,
            onComplete: w
          };
          (g.shouldReduceMotion || this.options.layoutRoot) && (x.delay = 0, x.type = !1), this.startAnimation(x);
        } else
          n || $v(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = d;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const u = this.getStack();
      u && u.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ja(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(JV), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: u } = this.options;
      return u && u.getProps().transformTemplate;
    }
    willUpdate(u = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let g = 0; g < this.path.length; g++) {
        const p = this.path[g];
        p.shouldResetTransform = !0, p.updateScroll("snapshot"), p.options.layoutRoot && p.willUpdate(!1);
      }
      const { layoutId: l, layout: f } = this.options;
      if (l === void 0 && !f)
        return;
      const o = this.getTransformTemplate();
      this.prevTransformTemplateValue = o ? o(this.latestValues, "") : void 0, this.updateSnapshot(), u && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Dv);
        return;
      }
      this.isUpdating || this.nodes.forEach(GV), this.isUpdating = !1, this.nodes.forEach(KV), this.nodes.forEach(VV), this.nodes.forEach(zV), this.clearAllSnapshots();
      const l = performance.now();
      ni.delta = rl(0, 1e3 / 60, l - ni.timestamp), ni.timestamp = l, ni.isProcessing = !0, am.update.process(ni), am.preRender.process(ni), am.render.process(ni), ni.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(WV), this.sharedNodes.forEach(QV);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Nn.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Nn.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let f = 0; f < this.path.length; f++)
          this.path[f].updateScroll();
      const u = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = vr(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, u ? u.layoutBox : void 0);
    }
    updateScroll(u = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === u && (l = !1), l && (this.scroll = {
        animationId: this.root.animationId,
        phase: u,
        isRoot: i(this.instance),
        offset: r(this.instance)
      });
    }
    resetTransform() {
      if (!s)
        return;
      const u = this.isLayoutDirty || this.shouldResetTransform, l = this.projectionDelta && !rk(this.projectionDelta), f = this.getTransformTemplate(), o = f ? f(this.latestValues, "") : void 0, g = o !== this.prevTransformTemplateValue;
      u && (l || Hl(this.latestValues) || g) && (s(this.instance, o), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(u = !0) {
      const l = this.measurePageBox();
      let f = this.removeElementScroll(l);
      return u && (f = this.removeTransform(f)), rz(f), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: f,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: u } = this.options;
      if (!u)
        return vr();
      const l = u.measureViewportBox(), { scroll: f } = this.root;
      return f && (Lo(l.x, f.offset.x), Lo(l.y, f.offset.y)), l;
    }
    removeElementScroll(u) {
      const l = vr();
      Aa(l, u);
      for (let f = 0; f < this.path.length; f++) {
        const o = this.path[f], { scroll: g, options: p } = o;
        if (o !== this.root && g && p.layoutScroll) {
          if (g.isRoot) {
            Aa(l, u);
            const { scroll: n } = this.root;
            n && (Lo(l.x, -n.offset.x), Lo(l.y, -n.offset.y));
          }
          Lo(l.x, g.offset.x), Lo(l.y, g.offset.y);
        }
      }
      return l;
    }
    applyTransform(u, l = !1) {
      const f = vr();
      Aa(f, u);
      for (let o = 0; o < this.path.length; o++) {
        const g = this.path[o];
        !l && g.options.layoutScroll && g.scroll && g !== g.root && Ou(f, {
          x: -g.scroll.offset.x,
          y: -g.scroll.offset.y
        }), Hl(g.latestValues) && Ou(f, g.latestValues);
      }
      return Hl(this.latestValues) && Ou(f, this.latestValues), f;
    }
    removeTransform(u) {
      const l = vr();
      Aa(l, u);
      for (let f = 0; f < this.path.length; f++) {
        const o = this.path[f];
        if (!o.instance || !Hl(o.latestValues))
          continue;
        U3(o.latestValues) && o.updateSnapshot();
        const g = vr(), p = o.measurePageBox();
        Aa(g, p), Mv(l, o.latestValues, o.snapshot ? o.snapshot.layoutBox : void 0, g);
      }
      return Hl(this.latestValues) && Mv(l, this.latestValues), l;
    }
    setTargetDelta(u) {
      this.targetDelta = u, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(u) {
      this.options = {
        ...this.options,
        ...u,
        crossfade: u.crossfade !== void 0 ? u.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== ni.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(u = !1) {
      var l;
      const f = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = f.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = f.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = f.isSharedProjectionDirty);
      const o = !!this.resumingFrom || this !== f;
      if (!(u || o && this.isSharedProjectionDirty || this.isProjectionDirty || !((l = this.parent) === null || l === void 0) && l.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: p, layoutId: n } = this.options;
      if (!(!this.layout || !(p || n))) {
        if (this.resolvedRelativeTargetAt = ni.timestamp, !this.targetDelta && !this.relativeTarget) {
          const a = this.getClosestProjectingParent();
          a && a.layout && this.animationProgress !== 1 ? (this.relativeParent = a, this.forceRelativeParentToResolveTarget(), this.relativeTarget = vr(), this.relativeTargetOrigin = vr(), L1(this.relativeTargetOrigin, this.layout.layoutBox, a.layout.layoutBox), Aa(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = vr(), this.targetWithTransforms = vr()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), sV(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Aa(this.target, this.layout.layoutBox), Z_(this.target, this.targetDelta)) : Aa(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const a = this.getClosestProjectingParent();
            a && !!a.resumingFrom == !!this.resumingFrom && !a.options.layoutScroll && a.target && this.animationProgress !== 1 ? (this.relativeParent = a, this.forceRelativeParentToResolveTarget(), this.relativeTarget = vr(), this.relativeTargetOrigin = vr(), L1(this.relativeTargetOrigin, this.target, a.target), Aa(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Vl.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || U3(this.parent.latestValues) || Y_(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var u;
      const l = this.getLead(), f = !!this.resumingFrom || this !== l;
      let o = !0;
      if ((this.isProjectionDirty || !((u = this.parent) === null || u === void 0) && u.isProjectionDirty) && (o = !1), f && (this.isSharedProjectionDirty || this.isTransformDirty) && (o = !1), this.resolvedRelativeTargetAt === ni.timestamp && (o = !1), o)
        return;
      const { layout: g, layoutId: p } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(g || p))
        return;
      Aa(this.layoutCorrected, this.layout.layoutBox);
      const n = this.treeScale.x, a = this.treeScale.y;
      pV(this.layoutCorrected, this.treeScale, this.path, f), l.layout && !l.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (l.target = l.layout.layoutBox);
      const { target: d } = l;
      if (!d) {
        this.projectionTransform && (this.projectionDelta = ku(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = ku(), this.projectionDeltaWithTransform = ku());
      const m = this.projectionTransform;
      $1(this.projectionDelta, this.layoutCorrected, d, this.latestValues), this.projectionTransform = Iv(this.projectionDelta, this.treeScale), (this.projectionTransform !== m || this.treeScale.x !== n || this.treeScale.y !== a) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d)), Vl.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(u = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), u) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(u, l = !1) {
      const f = this.snapshot, o = f ? f.latestValues : {}, g = { ...this.latestValues }, p = ku();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const n = vr(), a = f ? f.source : void 0, d = this.layout ? this.layout.source : void 0, m = a !== d, b = this.getStack(), w = !b || b.members.length <= 1, v = !!(m && !w && this.options.crossfade === !0 && !this.path.some(ez));
      this.animationProgress = 0;
      let h;
      this.mixTargetDelta = (x) => {
        const _ = x / 1e3;
        Lv(p.x, u.x, _), Lv(p.y, u.y, _), this.setTargetDelta(p), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (L1(n, this.layout.layoutBox, this.relativeParent.layout.layoutBox), tz(this.relativeTarget, this.relativeTargetOrigin, n, _), h && DV(this.relativeTarget, h) && (this.isProjectionDirty = !1), h || (h = vr()), Aa(h, this.relativeTarget)), m && (this.animationValues = g, MV(g, o, this.latestValues, _, v, w)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = _;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(u) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ja(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Nn.update(() => {
        Gd.hasAnimatedSinceResize = !0, this.currentAnimation = p7(0, Rv, {
          ...u,
          onUpdate: (l) => {
            this.mixTargetDelta(l), u.onUpdate && u.onUpdate(l);
          },
          onComplete: () => {
            u.onComplete && u.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const u = this.getStack();
      u && u.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Rv), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const u = this.getLead();
      let { targetWithTransforms: l, target: f, layout: o, latestValues: g } = u;
      if (!(!l || !f || !o)) {
        if (this !== u && this.layout && o && ok(this.options.animationType, this.layout.layoutBox, o.layoutBox)) {
          f = this.target || vr();
          const p = fa(this.layout.layoutBox.x);
          f.x.min = u.target.x.min, f.x.max = f.x.min + p;
          const n = fa(this.layout.layoutBox.y);
          f.y.min = u.target.y.min, f.y.max = f.y.min + n;
        }
        Aa(l, f), Ou(l, g), $1(this.projectionDeltaWithTransform, this.layoutCorrected, l, g);
      }
    }
    registerSharedNode(u, l) {
      this.sharedNodes.has(u) || this.sharedNodes.set(u, new $V()), this.sharedNodes.get(u).add(l);
      const o = l.options.initialPromotionConfig;
      l.promote({
        transition: o ? o.transition : void 0,
        preserveFollowOpacity: o && o.shouldPreserveFollowOpacity ? o.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const u = this.getStack();
      return u ? u.lead === this : !0;
    }
    getLead() {
      var u;
      const { layoutId: l } = this.options;
      return l ? ((u = this.getStack()) === null || u === void 0 ? void 0 : u.lead) || this : this;
    }
    getPrevLead() {
      var u;
      const { layoutId: l } = this.options;
      return l ? (u = this.getStack()) === null || u === void 0 ? void 0 : u.prevLead : void 0;
    }
    getStack() {
      const { layoutId: u } = this.options;
      if (u)
        return this.root.sharedNodes.get(u);
    }
    promote({ needsReset: u, transition: l, preserveFollowOpacity: f } = {}) {
      const o = this.getStack();
      o && o.promote(this, f), u && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const u = this.getStack();
      return u ? u.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: u } = this.options;
      if (!u)
        return;
      let l = !1;
      const { latestValues: f } = u;
      if ((f.rotate || f.rotateX || f.rotateY || f.rotateZ) && (l = !0), !l)
        return;
      const o = {};
      for (let g = 0; g < Fv.length; g++) {
        const p = "rotate" + Fv[g];
        f[p] && (o[p] = f[p], u.setStaticValue(p, 0));
      }
      u.render();
      for (const g in o)
        u.setStaticValue(g, o[g]);
      u.scheduleRender();
    }
    getProjectionStyles(u) {
      var l, f;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return UV;
      const o = {
        visibility: ""
      }, g = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, o.opacity = "", o.pointerEvents = Wd(u == null ? void 0 : u.pointerEvents) || "", o.transform = g ? g(this.latestValues, "") : "none", o;
      const p = this.getLead();
      if (!this.projectionDelta || !this.layout || !p.target) {
        const m = {};
        return this.options.layoutId && (m.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, m.pointerEvents = Wd(u == null ? void 0 : u.pointerEvents) || ""), this.hasProjected && !Hl(this.latestValues) && (m.transform = g ? g({}, "") : "none", this.hasProjected = !1), m;
      }
      const n = p.animationValues || p.latestValues;
      this.applyTransformsToTarget(), o.transform = Iv(this.projectionDeltaWithTransform, this.treeScale, n), g && (o.transform = g(n, o.transform));
      const { x: a, y: d } = this.projectionDelta;
      o.transformOrigin = `${a.origin * 100}% ${d.origin * 100}% 0`, p.animationValues ? o.opacity = p === this ? (f = (l = n.opacity) !== null && l !== void 0 ? l : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : n.opacityExit : o.opacity = p === this ? n.opacity !== void 0 ? n.opacity : "" : n.opacityExit !== void 0 ? n.opacityExit : 0;
      for (const m in v2) {
        if (n[m] === void 0)
          continue;
        const { correct: b, applyTo: w } = v2[m], v = o.transform === "none" ? n[m] : b(n[m], p);
        if (w) {
          const h = w.length;
          for (let x = 0; x < h; x++)
            o[w[x]] = v;
        } else
          o[m] = v;
      }
      return this.options.layoutId && (o.pointerEvents = p === this ? Wd(u == null ? void 0 : u.pointerEvents) || "" : "none"), o;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((u) => {
        var l;
        return (l = u.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
      }), this.root.nodes.forEach(Dv), this.root.sharedNodes.clear();
    }
  };
}
function VV(t) {
  t.updateLayout();
}
function zV(t) {
  var e;
  const r = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && r && t.hasListeners("didUpdate")) {
    const { layoutBox: i, measuredBox: s } = t.layout, { animationType: c } = t.options, u = r.source !== t.layout.source;
    c === "size" ? _a((p) => {
      const n = u ? r.measuredBox[p] : r.layoutBox[p], a = fa(n);
      n.min = i[p].min, n.max = n.min + a;
    }) : ok(c, r.layoutBox, i) && _a((p) => {
      const n = u ? r.measuredBox[p] : r.layoutBox[p], a = fa(i[p]);
      n.max = n.min + a, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[p].max = t.relativeTarget[p].min + a);
    });
    const l = ku();
    $1(l, i, r.layoutBox);
    const f = ku();
    u ? $1(f, t.applyTransform(s, !0), r.measuredBox) : $1(f, i, r.layoutBox);
    const o = !rk(l);
    let g = !1;
    if (!t.resumeFrom) {
      const p = t.getClosestProjectingParent();
      if (p && !p.resumeFrom) {
        const { snapshot: n, layout: a } = p;
        if (n && a) {
          const d = vr();
          L1(d, r.layoutBox, n.layoutBox);
          const m = vr();
          L1(m, i, a.layoutBox), ik(d, m) || (g = !0), p.options.layoutRoot && (t.relativeTarget = m, t.relativeTargetOrigin = d, t.relativeParent = p);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: i,
      snapshot: r,
      delta: f,
      layoutDelta: l,
      hasLayoutChanged: o,
      hasRelativeTargetChanged: g
    });
  } else if (t.isLead()) {
    const { onExitComplete: i } = t.options;
    i && i();
  }
  t.options.transition = void 0;
}
function XV(t) {
  Vl.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function qV(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function WV(t) {
  t.clearSnapshot();
}
function Dv(t) {
  t.clearMeasurements();
}
function GV(t) {
  t.isLayoutDirty = !1;
}
function KV(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function $v(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function YV(t) {
  t.resolveTargetDelta();
}
function ZV(t) {
  t.calcProjection();
}
function JV(t) {
  t.resetRotation();
}
function QV(t) {
  t.removeLeadSnapshot();
}
function Lv(t, e, r) {
  t.translate = er(e.translate, 0, r), t.scale = er(e.scale, 1, r), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Nv(t, e, r, i) {
  t.min = er(e.min, r.min, i), t.max = er(e.max, r.max, i);
}
function tz(t, e, r, i) {
  Nv(t.x, e.x, r.x, i), Nv(t.y, e.y, r.y, i);
}
function ez(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const nz = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Bv = (t) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(t), jv = Bv("applewebkit/") && !Bv("chrome/") ? Math.round : cr;
function Uv(t) {
  t.min = jv(t.min), t.max = jv(t.max);
}
function rz(t) {
  Uv(t.x), Uv(t.y);
}
function ok(t, e, r) {
  return t === "position" || t === "preserve-aspect" && !B3(Pv(e), Pv(r), 0.2);
}
const iz = sk({
  attachResizeListener: (t, e) => Qs(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), pm = {
  current: void 0
}, lk = sk({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!pm.current) {
      const t = new iz({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), pm.current = t;
    }
    return pm.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), az = {
  pan: {
    Feature: CV
  },
  drag: {
    Feature: SV,
    ProjectionNode: lk,
    MeasureLayout: tk
  }
}, sz = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function oz(t) {
  const e = sz.exec(t);
  if (!e)
    return [,];
  const [, r, i] = e;
  return [r, i];
}
const lz = 4;
function V3(t, e, r = 1) {
  ha(r <= lz, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [i, s] = oz(t);
  if (!i)
    return;
  const c = window.getComputedStyle(e).getPropertyValue(i);
  if (c) {
    const u = c.trim();
    return z_(u) ? parseFloat(u) : u;
  } else return E3(s) ? V3(s, e, r + 1) : s;
}
function cz(t, { ...e }, r) {
  const i = t.current;
  if (!(i instanceof Element))
    return { target: e, transitionEnd: r };
  r && (r = { ...r }), t.values.forEach((s) => {
    const c = s.get();
    if (!E3(c))
      return;
    const u = V3(c, i);
    u && s.set(u);
  });
  for (const s in e) {
    const c = e[s];
    if (!E3(c))
      continue;
    const u = V3(c, i);
    u && (e[s] = u, r || (r = {}), r[s] === void 0 && (r[s] = c));
  }
  return { target: e, transitionEnd: r };
}
const uz = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), ck = (t) => uz.has(t), hz = (t) => Object.keys(t).some(ck), nd = (t) => t === Ec || t === Ge, Hv = (t, e) => parseFloat(t.split(", ")[e]), Vv = (t, e) => (r, { transform: i }) => {
  if (i === "none" || !i)
    return 0;
  const s = i.match(/^matrix3d\((.+)\)$/);
  if (s)
    return Hv(s[1], e);
  {
    const c = i.match(/^matrix\((.+)\)$/);
    return c ? Hv(c[1], t) : 0;
  }
}, fz = /* @__PURE__ */ new Set(["x", "y", "z"]), dz = Eh.filter((t) => !fz.has(t));
function gz(t) {
  const e = [];
  return dz.forEach((r) => {
    const i = t.getValue(r);
    i !== void 0 && (e.push([r, i.get()]), i.set(r.startsWith("scale") ? 1 : 0));
  }), e.length && t.render(), e;
}
const Ju = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: r = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(r),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: r = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(r),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: Vv(4, 13),
  y: Vv(5, 14)
};
Ju.translateX = Ju.x;
Ju.translateY = Ju.y;
const pz = (t, e, r) => {
  const i = e.measureViewportBox(), s = e.current, c = getComputedStyle(s), { display: u } = c, l = {};
  u === "none" && e.setStaticValue("display", t.display || "block"), r.forEach((o) => {
    l[o] = Ju[o](i, c);
  }), e.render();
  const f = e.measureViewportBox();
  return r.forEach((o) => {
    const g = e.getValue(o);
    g && g.jump(l[o]), t[o] = Ju[o](f, c);
  }), t;
}, mz = (t, e, r = {}, i = {}) => {
  e = { ...e }, i = { ...i };
  const s = Object.keys(e).filter(ck);
  let c = [], u = !1;
  const l = [];
  if (s.forEach((f) => {
    const o = t.getValue(f);
    if (!t.hasValue(f))
      return;
    let g = r[f], p = a1(g);
    const n = e[f];
    let a;
    if (x2(n)) {
      const d = n.length, m = n[0] === null ? 1 : 0;
      g = n[m], p = a1(g);
      for (let b = m; b < d && n[b] !== null; b++)
        a ? ha(a1(n[b]) === a, "All keyframes must be of the same type") : (a = a1(n[b]), ha(a === p || nd(p) && nd(a), "Keyframes must be of the same dimension as the current value"));
    } else
      a = a1(n);
    if (p !== a)
      if (nd(p) && nd(a)) {
        const d = o.get();
        typeof d == "string" && o.set(parseFloat(d)), typeof n == "string" ? e[f] = parseFloat(n) : Array.isArray(n) && a === Ge && (e[f] = n.map(parseFloat));
      } else p != null && p.transform && (a != null && a.transform) && (g === 0 || n === 0) ? g === 0 ? o.set(a.transform(g)) : e[f] = p.transform(n) : (u || (c = gz(t), u = !0), l.push(f), i[f] = i[f] !== void 0 ? i[f] : e[f], o.jump(n));
  }), l.length) {
    const f = l.indexOf("height") >= 0 ? window.pageYOffset : null, o = pz(e, t, l);
    return c.length && c.forEach(([g, p]) => {
      t.getValue(g).set(p);
    }), t.render(), Yg && f !== null && window.scrollTo({ top: f }), { target: o, transitionEnd: i };
  } else
    return { target: e, transitionEnd: i };
};
function yz(t, e, r, i) {
  return hz(e) ? mz(t, e, r, i) : { target: e, transitionEnd: i };
}
const bz = (t, e, r, i) => {
  const s = cz(t, e, i);
  return e = s.target, i = s.transitionEnd, yz(t, e, r, i);
}, z3 = { current: null }, uk = { current: !1 };
function vz() {
  if (uk.current = !0, !!Yg)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => z3.current = t.matches;
      t.addListener(e), e();
    } else
      z3.current = !1;
}
function wz(t, e, r) {
  const { willChange: i } = e;
  for (const s in e) {
    const c = e[s], u = r[s];
    if (fi(c))
      t.addValue(s, c), _2(i) && i.add(s), process.env.NODE_ENV === "development" && d7(c.version === "10.18.0", `Attempting to mix Framer Motion versions ${c.version} with 10.18.0 may not work as expected.`);
    else if (fi(u))
      t.addValue(s, vc(c, { owner: t })), _2(i) && i.remove(s);
    else if (u !== c)
      if (t.hasValue(s)) {
        const l = t.getValue(s);
        !l.hasAnimated && l.set(c);
      } else {
        const l = t.getStaticValue(s);
        t.addValue(s, vc(l !== void 0 ? l : c, { owner: t }));
      }
  }
  for (const s in r)
    e[s] === void 0 && t.removeValue(s);
  return e;
}
const nh = /* @__PURE__ */ new WeakMap(), hk = Object.keys(eh), xz = hk.length, zv = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], Sz = G6.length;
class Cz {
  constructor({ parent: e, props: r, presenceContext: i, reducedMotionConfig: s, visualState: c }, u = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Nn.render(this.render, !1, !0);
    const { latestValues: l, renderState: f } = c;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = r.initial ? { ...l } : {}, this.renderState = f, this.parent = e, this.props = r, this.presenceContext = i, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = s, this.options = u, this.isControllingVariants = Qg(r), this.isVariantNode = GA(r), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: o, ...g } = this.scrapeMotionValuesFromProps(r, {});
    for (const p in g) {
      const n = g[p];
      l[p] !== void 0 && fi(n) && (n.set(l[p], !1), _2(o) && o.add(p));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, r) {
    return {};
  }
  mount(e) {
    this.current = e, nh.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, i) => this.bindToMotionValue(i, r)), uk.current || vz(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : z3.current, process.env.NODE_ENV !== "production" && d7(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    nh.delete(this.current), this.projection && this.projection.unmount(), Ja(this.notifyUpdate), Ja(this.render), this.valueSubscriptions.forEach((e) => e()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features)
      this.features[e].unmount();
    this.current = null;
  }
  bindToMotionValue(e, r) {
    const i = Mc.has(e), s = r.on("change", (u) => {
      this.latestValues[e] = u, this.props.onUpdate && Nn.update(this.notifyUpdate, !1, !0), i && this.projection && (this.projection.isTransformDirty = !0);
    }), c = r.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(e, () => {
      s(), c();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  loadFeatures({ children: e, ...r }, i, s, c) {
    let u, l;
    if (process.env.NODE_ENV !== "production" && s && i) {
      const f = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      r.ignoreStrict ? Fh(!1, f) : ha(!1, f);
    }
    for (let f = 0; f < xz; f++) {
      const o = hk[f], { isEnabled: g, Feature: p, ProjectionNode: n, MeasureLayout: a } = eh[o];
      n && (u = n), g(r) && (!this.features[o] && p && (this.features[o] = new p(this)), a && (l = a));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && u) {
      this.projection = new u(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: f, layout: o, drag: g, dragConstraints: p, layoutScroll: n, layoutRoot: a } = r;
      this.projection.setOptions({
        layoutId: f,
        layout: o,
        alwaysMeasureLayout: !!g || p && Au(p),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof o == "string" ? o : "both",
        initialPromotionConfig: c,
        layoutScroll: n,
        layoutRoot: a
      });
    }
    return l;
  }
  updateFeatures() {
    for (const e in this.features) {
      const r = this.features[e];
      r.isMounted ? r.update() : (r.mount(), r.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : vr();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, r) {
    this.latestValues[e] = r;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(e, r = !0) {
    return this.makeTargetAnimatableFromInstance(e, this.props, r);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, r) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = r;
    for (let i = 0; i < zv.length; i++) {
      const s = zv[i];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const c = e["on" + s];
      c && (this.propEventSubscriptions[s] = this.on(s, c));
    }
    this.prevMotionValues = wz(this, this.scrapeMotionValuesFromProps(e, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(e = !1) {
    if (e)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const i = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (i.initial = this.props.initial), i;
    }
    const r = {};
    for (let i = 0; i < Sz; i++) {
      const s = G6[i], c = this.props[s];
      (th(c) || c === !1) && (r[s] = c);
    }
    return r;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const r = this.getClosestVariantNode();
    if (r)
      return r.variantChildren && r.variantChildren.add(e), () => r.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, r) {
    r !== this.values.get(e) && (this.removeValue(e), this.bindToMotionValue(e, r)), this.values.set(e, r), this.latestValues[e] = r.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const r = this.valueSubscriptions.get(e);
    r && (r(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, r) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let i = this.values.get(e);
    return i === void 0 && r !== void 0 && (i = vc(r, { owner: this }), this.addValue(e, i)), i;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e) {
    var r;
    return this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (r = this.getBaseTargetFromProps(this.props, e)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, e, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, r) {
    this.baseTarget[e] = r;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var r;
    const { initial: i } = this.props, s = typeof i == "string" || typeof i == "object" ? (r = n7(this.props, i)) === null || r === void 0 ? void 0 : r[e] : void 0;
    if (i && s !== void 0)
      return s;
    const c = this.getBaseTargetFromProps(this.props, e);
    return c !== void 0 && !fi(c) ? c : this.initialValues[e] !== void 0 && s === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, r) {
    return this.events[e] || (this.events[e] = new f7()), this.events[e].add(r);
  }
  notify(e, ...r) {
    this.events[e] && this.events[e].notify(...r);
  }
}
class fk extends Cz {
  sortInstanceNodePosition(e, r) {
    return e.compareDocumentPosition(r) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, r) {
    return e.style ? e.style[r] : void 0;
  }
  removeValueFromRenderState(e, { vars: r, style: i }) {
    delete r[e], delete i[e];
  }
  makeTargetAnimatableFromInstance({ transition: e, transitionEnd: r, ...i }, { transformValues: s }, c) {
    let u = UH(i, e || {}, this);
    if (s && (r && (r = s(r)), i && (i = s(i)), u && (u = s(u))), c) {
      BH(this, i, u);
      const l = bz(this, i, u, r);
      r = l.transitionEnd, i = l.target;
    }
    return {
      transition: e,
      transitionEnd: r,
      ...i
    };
  }
}
function Az(t) {
  return window.getComputedStyle(t);
}
class dk extends fk {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(e, r) {
    if (Mc.has(r)) {
      const i = l7(r);
      return i && i.default || 0;
    } else {
      const i = Az(e), s = (JA(r) ? i.getPropertyValue(r) : i[r]) || 0;
      return typeof s == "string" ? s.trim() : s;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: r }) {
    return J_(e, r);
  }
  build(e, r, i, s) {
    Z6(e, r, i, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, r) {
    return e7(e, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    fi(e) && (this.childSubscription = e.on("change", (r) => {
      this.current && (this.current.textContent = `${r}`);
    }));
  }
  renderInstance(e, r, i, s) {
    i_(e, r, i, s);
  }
}
class gk extends fk {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(e, r) {
    return e[r];
  }
  readValueFromInstance(e, r) {
    if (Mc.has(r)) {
      const i = l7(r);
      return i && i.default || 0;
    }
    return r = a_.has(r) ? r : q6(r), e.getAttribute(r);
  }
  measureInstanceViewportBox() {
    return vr();
  }
  scrapeMotionValuesFromProps(e, r) {
    return o_(e, r);
  }
  build(e, r, i, s) {
    Q6(e, r, i, this.isSVGTag, s.transformTemplate);
  }
  renderInstance(e, r, i, s) {
    s_(e, r, i, s);
  }
  mount(e) {
    this.isSVGTag = t7(e.tagName), super.mount(e);
  }
}
const _z = (t, e) => Y6(t) ? new gk(e, { enableHardwareAcceleration: !1 }) : new dk(e, { enableHardwareAcceleration: !0 }), kz = {
  layout: {
    ProjectionNode: lk,
    MeasureLayout: tk
  }
}, Oz = {
  ...nV,
  ...TU,
  ...az,
  ...kz
}, bn = /* @__PURE__ */ Lj((t, e) => pU(t, e, Oz, _z));
function pk() {
  const t = Sn(!1);
  return Zg(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function Tz() {
  const t = pk(), [e, r] = cn(0), i = Js(() => {
    t.current && r(e + 1);
  }, [e]);
  return [Js(() => Nn.postRender(i), [i]), e];
}
class Mz extends pt.Component {
  getSnapshotBeforeUpdate(e) {
    const r = this.props.childRef.current;
    if (r && e.isPresent && !this.props.isPresent) {
      const i = this.props.sizeRef.current;
      i.height = r.offsetHeight || 0, i.width = r.offsetWidth || 0, i.top = r.offsetTop, i.left = r.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Ez({ children: t, isPresent: e }) {
  const r = mr(), i = Sn(null), s = Sn({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return hA(() => {
    const { width: c, height: u, top: l, left: f } = s.current;
    if (e || !i.current || !c || !u)
      return;
    i.current.dataset.motionPopId = r;
    const o = document.createElement("style");
    return document.head.appendChild(o), o.sheet && o.sheet.insertRule(`
          [data-motion-pop-id="${r}"] {
            position: absolute !important;
            width: ${c}px !important;
            height: ${u}px !important;
            top: ${l}px !important;
            left: ${f}px !important;
          }
        `), () => {
      document.head.removeChild(o);
    };
  }, [e]), pt.createElement(Mz, { isPresent: e, childRef: i, sizeRef: s }, pt.cloneElement(t, { ref: i }));
}
const mm = ({ children: t, initial: e, isPresent: r, onExitComplete: i, custom: s, presenceAffectsLayout: c, mode: u }) => {
  const l = ep(Pz), f = mr(), o = en(
    () => ({
      id: f,
      initial: e,
      isPresent: r,
      custom: s,
      onExitComplete: (g) => {
        l.set(g, !0);
        for (const p of l.values())
          if (!p)
            return;
        i && i();
      },
      register: (g) => (l.set(g, !1), () => l.delete(g))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    c ? void 0 : [r]
  );
  return en(() => {
    l.forEach((g, p) => l.set(p, !1));
  }, [r]), pt.useEffect(() => {
    !r && !l.size && i && i();
  }, [r]), u === "popLayout" && (t = pt.createElement(Ez, { isPresent: r }, t)), pt.createElement(Kg.Provider, { value: o }, t);
};
function Pz() {
  return /* @__PURE__ */ new Map();
}
function Iz(t) {
  return Tn(() => () => t(), []);
}
const zl = (t) => t.key || "";
function Fz(t, e) {
  t.forEach((r) => {
    const i = zl(r);
    e.set(i, r);
  });
}
function Rz(t) {
  const e = [];
  return BN.forEach(t, (r) => {
    fA(r) && e.push(r);
  }), e;
}
const Pc = ({ children: t, custom: e, initial: r = !0, onExitComplete: i, exitBeforeEnter: s, presenceAffectsLayout: c = !0, mode: u = "sync" }) => {
  ha(!s, "Replace exitBeforeEnter with mode='wait'");
  const l = Kr(K6).forceRender || Tz()[0], f = pk(), o = Rz(t);
  let g = o;
  const p = Sn(/* @__PURE__ */ new Map()).current, n = Sn(g), a = Sn(/* @__PURE__ */ new Map()).current, d = Sn(!0);
  if (Zg(() => {
    d.current = !1, Fz(o, a), n.current = g;
  }), Iz(() => {
    d.current = !0, a.clear(), p.clear();
  }), d.current)
    return pt.createElement(pt.Fragment, null, g.map((v) => pt.createElement(mm, { key: zl(v), isPresent: !0, initial: r ? void 0 : !1, presenceAffectsLayout: c, mode: u }, v)));
  g = [...g];
  const m = n.current.map(zl), b = o.map(zl), w = m.length;
  for (let v = 0; v < w; v++) {
    const h = m[v];
    b.indexOf(h) === -1 && !p.has(h) && p.set(h, void 0);
  }
  return u === "wait" && p.size && (g = []), p.forEach((v, h) => {
    if (b.indexOf(h) !== -1)
      return;
    const x = a.get(h);
    if (!x)
      return;
    const _ = m.indexOf(h);
    let M = v;
    if (!M) {
      const O = () => {
        p.delete(h);
        const E = Array.from(a.keys()).filter((I) => !b.includes(I));
        if (E.forEach((I) => a.delete(I)), n.current = o.filter((I) => {
          const R = zl(I);
          return (
            // filter out the node exiting
            R === h || // filter out the leftover children
            E.includes(R)
          );
        }), !p.size) {
          if (f.current === !1)
            return;
          l(), i && i();
        }
      };
      M = pt.createElement(mm, { key: zl(x), isPresent: !1, onExitComplete: O, custom: e, presenceAffectsLayout: c, mode: u }, x), p.set(h, M);
    }
    g.splice(_, 0, M);
  }), g = g.map((v) => {
    const h = v.key;
    return p.has(h) ? v : pt.createElement(mm, { key: zl(v), isPresent: !0, presenceAffectsLayout: c, mode: u }, v);
  }), process.env.NODE_ENV !== "production" && u === "wait" && g.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), pt.createElement(pt.Fragment, null, p.size ? g : g.map((v) => NN(v)));
};
function mk(t) {
  const e = ep(() => vc(t)), { isStatic: r } = Kr(X6);
  if (r) {
    const [, i] = cn(t);
    Tn(() => e.on("change", i), []);
  }
  return e;
}
const Dz = (t) => t && typeof t == "object" && t.mix, $z = (t) => Dz(t) ? t.mix : void 0;
function Lz(...t) {
  const e = !Array.isArray(t[0]), r = e ? 0 : -1, i = t[0 + r], s = t[1 + r], c = t[2 + r], u = t[3 + r], l = s7(s, c, {
    mixer: $z(c[0]),
    ...u
  });
  return e ? l(i) : l;
}
function yk(t, e) {
  const r = mk(e()), i = () => r.set(e());
  return i(), Zg(() => {
    const s = () => Nn.update(i, !1, !0), c = t.map((u) => u.on("change", s));
    return () => {
      c.forEach((u) => u()), Ja(i);
    };
  }), r;
}
function Nz(t) {
  D1.current = [], t();
  const e = yk(D1.current, t);
  return D1.current = void 0, e;
}
function Bz(t, e, r, i) {
  if (typeof t == "function")
    return Nz(t);
  const s = typeof e == "function" ? e : Lz(e, r, i);
  return Array.isArray(t) ? Xv(t, s) : Xv([t], ([c]) => s(c));
}
function Xv(t, e) {
  const r = ep(() => []);
  return yk(t, () => {
    r.length = 0;
    const i = t.length;
    for (let s = 0; s < i; s++)
      r[s] = t[s].get();
    return e(r);
  });
}
function bk(t, e, r) {
  var i;
  if (typeof t == "string") {
    let s = document;
    r ? ((i = r[t]) !== null && i !== void 0 || (r[t] = s.querySelectorAll(t)), t = r[t]) : t = s.querySelectorAll(t);
  } else t instanceof Element && (t = [t]);
  return Array.from(t || []);
}
function jz(t, e) {
  let r;
  const i = () => {
    const { currentTime: s } = e, u = (s === null ? 0 : s.value) / 100;
    r !== u && t(u), r = u;
  };
  return Nn.update(i, !0), () => Ja(i);
}
const Uz = U_(() => window.ScrollTimeline !== void 0);
class vk {
  constructor(e) {
    this.animations = e.filter(Boolean);
  }
  then(e, r) {
    return Promise.all(this.animations).then(e).catch(r);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, r) {
    for (let i = 0; i < this.animations.length; i++)
      this.animations[i][e] = r;
  }
  attachTimeline(e) {
    const r = this.animations.map((i) => {
      if (Uz() && i.attachTimeline)
        i.attachTimeline(e);
      else
        return i.pause(), jz((s) => {
          i.time = i.duration * s;
        }, e);
    });
    return () => {
      r.forEach((i, s) => {
        i && i(), this.animations[s].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get duration() {
    let e = 0;
    for (let r = 0; r < this.animations.length; r++)
      e = Math.max(e, this.animations[r].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((r) => r[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  stop() {
    this.runAll("stop");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function Hz(t) {
  return typeof t == "object" && !Array.isArray(t);
}
function Vz(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, r = ak(t) ? new gk(e, {
    enableHardwareAcceleration: !1
  }) : new dk(e, {
    enableHardwareAcceleration: !0
  });
  r.mount(t), nh.set(t, r);
}
function zz(t, e = 100) {
  const r = o7({ keyframes: [0, e], ...t }), i = Math.min(D3(r), R3);
  return {
    type: "keyframes",
    ease: (s) => r.next(i * s).value / e,
    duration: xs(i)
  };
}
function qv(t, e, r, i) {
  var s;
  return typeof e == "number" ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, t + parseFloat(e)) : e === "<" ? r : (s = i.get(e)) !== null && s !== void 0 ? s : t;
}
const Xz = (t, e, r) => {
  const i = e - t;
  return ((r - t) % i + i) % i + t;
};
function qz(t, e) {
  return x_(t) ? t[Xz(0, t.length, e)] : t;
}
function Wz(t, e, r) {
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    s.at > e && s.at < r && (ip(t, s), i--);
  }
}
function Gz(t, e, r, i, s, c) {
  Wz(t, s, c);
  for (let u = 0; u < e.length; u++)
    t.push({
      value: e[u],
      at: er(s, c, i[u]),
      easing: qz(r, u)
    });
}
function Kz(t, e) {
  return t.at === e.at ? t.value === null ? 1 : e.value === null ? -1 : 0 : t.at - e.at;
}
const Yz = "easeInOut";
function Zz(t, { defaultTransition: e = {}, ...r } = {}, i) {
  const s = e.duration || 0.3, c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), l = {}, f = /* @__PURE__ */ new Map();
  let o = 0, g = 0, p = 0;
  for (let n = 0; n < t.length; n++) {
    const a = t[n];
    if (typeof a == "string") {
      f.set(a, g);
      continue;
    } else if (!Array.isArray(a)) {
      f.set(a.name, qv(g, a.at, o, f));
      continue;
    }
    let [d, m, b = {}] = a;
    b.at !== void 0 && (g = qv(g, b.at, o, f));
    let w = 0;
    const v = (h, x, _, M = 0, O = 0) => {
      const E = Jz(h), { delay: I = 0, times: R = N_(E), type: W = "keyframes", ...z } = x;
      let { ease: j = e.ease || "easeOut", duration: $ } = x;
      const B = typeof I == "function" ? I(M, O) : I, C = E.length;
      if (C <= 2 && W === "spring") {
        let A = 100;
        if (C === 2 && eX(E)) {
          const X = E[1] - E[0];
          A = Math.abs(X);
        }
        const U = { ...z };
        $ !== void 0 && (U.duration = io($));
        const K = zz(U, A);
        j = K.ease, $ = K.duration;
      }
      $ ?? ($ = s);
      const T = g + B, F = T + $;
      R.length === 1 && R[0] === 0 && (R[1] = 1);
      const S = R.length - E.length;
      S > 0 && L_(R, S), E.length === 1 && E.unshift(null), Gz(_, E, j, R, T, F), w = Math.max(B + $, w), p = Math.max(F, p);
    };
    if (fi(d)) {
      const h = Wv(d, u);
      v(m, b, Gv("default", h));
    } else {
      const h = bk(d, i, l), x = h.length;
      for (let _ = 0; _ < x; _++) {
        m = m, b = b;
        const M = h[_], O = Wv(M, u);
        for (const E in m)
          v(m[E], Qz(b, E), Gv(E, O), _, x);
      }
    }
    o = g, g += w;
  }
  return u.forEach((n, a) => {
    for (const d in n) {
      const m = n[d];
      m.sort(Kz);
      const b = [], w = [], v = [];
      for (let x = 0; x < m.length; x++) {
        const { at: _, value: M, easing: O } = m[x];
        b.push(M), w.push(Zu(0, p, _)), v.push(O || "easeOut");
      }
      w[0] !== 0 && (w.unshift(0), b.unshift(b[0]), v.unshift(Yz)), w[w.length - 1] !== 1 && (w.push(1), b.push(null)), c.has(a) || c.set(a, {
        keyframes: {},
        transition: {}
      });
      const h = c.get(a);
      h.keyframes[d] = b, h.transition[d] = {
        ...e,
        duration: p,
        ease: v,
        times: w,
        ...r
      };
    }
  }), c;
}
function Wv(t, e) {
  return !e.has(t) && e.set(t, {}), e.get(t);
}
function Gv(t, e) {
  return e[t] || (e[t] = []), e[t];
}
function Jz(t) {
  return Array.isArray(t) ? t : [t];
}
function Qz(t, e) {
  return t[e] ? { ...t, ...t[e] } : { ...t };
}
const tX = (t) => typeof t == "number", eX = (t) => t.every(tX);
function wk(t, e, r, i) {
  const s = bk(t), c = s.length;
  ha(!!c, "No valid element provided.");
  const u = [];
  for (let l = 0; l < c; l++) {
    const f = s[l];
    nh.has(f) || Vz(f);
    const o = nh.get(f), g = { ...r };
    typeof g.delay == "function" && (g.delay = g.delay(l, c)), u.push(...g7(o, { ...e, transition: g }, {}));
  }
  return new vk(u);
}
const nX = (t) => Array.isArray(t) && Array.isArray(t[0]);
function rX(t, e, r) {
  const i = [];
  return Zz(t, e, r).forEach(({ keyframes: c, transition: u }, l) => {
    let f;
    fi(l) ? f = p7(l, c.default, u.default) : f = wk(l, c, u), i.push(f);
  }), new vk(i);
}
const iX = (t) => {
  function e(r, i, s) {
    let c;
    return nX(r) ? c = rX(r, i, t) : Hz(i) ? c = wk(r, i, s) : c = p7(r, i, s), c;
  }
  return e;
}, aX = iX(), sX = (t, e, r) => {
  const i = e + r, s = t / i, c = Math.ceil(s), u = Math.floor(s), l = c * i - t, f = t - u * i, o = l / c, g = f / u;
  return o < g ? -1 * o : g;
}, oX = (t, e, r) => {
  if (e === 0 || r === 0) return;
  const i = t * 2, s = i * Math.PI, c = (e - i) * 2, u = (r - i) * 2;
  return s + c + u;
}, ym = 6, Kv = 4, bm = 8, o1 = 2, lX = ({ containerRef: t, className: e, variants: r }) => {
  const [i, s] = cn({ width: 0, height: 0 });
  Tn(() => {
    if (!t.current) return;
    const f = new ResizeObserver((o) => {
      s({ width: o[0].contentRect.width, height: o[0].contentRect.height });
    });
    return f.observe(t.current), () => f.disconnect();
  }, [t]);
  const c = i.width ? i.width - o1 * 2 : 0, u = i.height ? i.height - o1 * 2 : 0, l = en(() => {
    const f = oX(bm, c, u);
    return f ? ym + sX(f, Kv, ym) : ym;
  }, [u, c]);
  return /* @__PURE__ */ $t("svg", { className: e, width: "100%", height: "100%", role: "presentation", children: /* @__PURE__ */ $t(
    bn.rect,
    {
      transition: { duration: 0 },
      variants: r,
      x: o1,
      y: o1,
      width: c,
      height: u,
      fill: "none",
      rx: bm,
      ry: bm,
      stroke: "currentColor",
      strokeWidth: o1,
      strokeDasharray: `${Kv} ${l}`,
      strokeDashoffset: 0
    }
  ) });
}, q7t = kn(
  ({
    children: t,
    contentLayout: e = "vertical",
    icon: r = "add",
    className: i,
    ...s
  }, c) => {
    const u = mr(), l = Sn(null), f = {
      button: {
        tap: {
          color: Hn.colors.purple.shade500,
          scale: 0.985
        }
      },
      content: {
        tap: {
          color: Hn.colors.purple.shade500
        }
      },
      backgroundBorder: {
        initial: {
          color: "var(--ssui-color-grey-300)"
        },
        hover: {
          color: Hn.colors.purple.shade400,
          strokeDasharray: "0"
        },
        tap: {
          color: Hn.colors.purple.shade400,
          strokeDasharray: "0"
        }
      },
      text: {
        tap: {
          color: Hn.colors.purple.shade500
        },
        hover: {
          color: Hn.colors.purple.shade500
        }
      }
    };
    return /* @__PURE__ */ Ve(
      bn.button,
      {
        ref: c,
        initial: "initial",
        whileHover: s.disabled ? "disabled" : "hover",
        whileFocus: s.disabled ? "disabled" : "hover",
        whileTap: s.disabled ? "disabled" : "tap",
        variants: f.button,
        "aria-labelledby": u,
        className: Ke(
          "group relative cursor-pointer select-none overflow-hidden border-none bg-none focus-visible:outline-none disabled:cursor-default",
          i
        ),
        ...s,
        children: [
          /* @__PURE__ */ $t(bn.div, { className: "absolute inset-0", ref: l, children: /* @__PURE__ */ $t(lX, { containerRef: l, variants: f.backgroundBorder }) }),
          /* @__PURE__ */ Ve(
            bn.div,
            {
              variants: f.content,
              className: Ke("grid place-content-center place-items-center gap-2 rounded-lg px-4 py-2", {
                "grid-flow-col": e === "horizontal"
              }),
              children: [
                /* @__PURE__ */ $t(
                  bn.span,
                  {
                    variants: f.text,
                    className: "text-center text-lg font-bold text-grey-900 group-disabled:text-grey-600",
                    id: u,
                    children: t
                  }
                ),
                /* @__PURE__ */ $t(bn.div, { className: "grid aspect-square h-6 w-6 place-content-center place-items-center rounded-full bg-primary-500 text-white shadow-sm group-disabled:bg-grey-600", children: /* @__PURE__ */ $t(hr, { iconName: r, size: "small" }) })
              ]
            }
          )
        ]
      }
    );
  }
), W7t = kn(
  ({
    children: t,
    kind: e = "contained",
    size: r = "medium",
    color: i = "primary",
    disabled: s,
    loading: c,
    ...u
  }, l) => /* @__PURE__ */ Ve(
    bn.button,
    {
      disabled: s,
      "aria-busy": c,
      type: "button",
      ...u,
      ref: l,
      whileTap: { scale: s ? 1 : 0.95 },
      className: Ke(
        "relative flex select-none items-center justify-center text-nowrap rounded-full font-semi-bold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
        { "h-6 px-3 text-xs": r === "small" },
        { "h-8 px-4 text-sm": r === "medium" },
        { "bg-primary-400 text-white hover:bg-primary-300": e === "contained" && i === "primary" },
        { "bg-grey-800 text-white hover:bg-grey-700": e === "contained" && i === "neutral" },
        { "bg-red-600 text-white hover:bg-red-500": e === "contained" && i === "destructive" },
        { "border-[1px]": e === "outlined" },
        { "px-[calc(0.75rem-1px)]": e === "outlined" && r === "small" },
        { "px-[calc(1rem-1px)]": e === "outlined" && r === "medium" },
        { "border-primary-400 text-primary-400 hover:bg-primary-100": e === "outlined" && i === "primary" },
        { "border-grey-800 text-grey-800 hover:bg-grey-100": e === "outlined" && i === "neutral" },
        {
          "border-red-600 text-red-600 hover:bg-red-100": e === "outlined" && i === "destructive"
        },
        { "h-4 rounded-sm px-0 hover:bg-transparent": e === "text" },
        { "hover:opacity-80": e === "text" && !s },
        { "text-primary-400": e === "text" && i === "primary" },
        { "text-grey-800": e === "text" && i === "neutral" },
        { "text-red-600": e === "text" && i === "destructive" },
        { "focus-visible:outline-primary-400": i === "primary" },
        { "focus-visible:outline-grey-800": i === "neutral" },
        { "focus-visible:outline-red-600": i === "destructive" },
        { "bg-grey-200 text-grey-400 hover:bg-grey-200": e === "contained" && s },
        { "border-grey-200 text-grey-300 hover:bg-transparent": e === "outlined" && s },
        { "text-grey-300 hover:bg-transparent hover:bg-none": e === "text" && s },
        { "text-transparent": c },
        u.className
      ),
      children: [
        t,
        c && /* @__PURE__ */ $t(
          w9t,
          {
            className: Ke(
              "absolute",
              { "text-white": e === "contained" },
              { "text-primary-400": e === "outlined" && i === "primary" },
              { "text-grey-800": e === "outlined" && i === "neutral" },
              { "text-red-600": e === "outlined" && i === "destructive" },
              { "text-primary-400": e === "text" && i === "primary" },
              { "text-grey-800": e === "text" && i === "neutral" },
              { "text-red-600": e === "text" && i === "destructive" },
              { "text-grey-400": e === "contained" && s },
              { "text-grey-300": e === "outlined" && s },
              { "text-grey-300": e === "text" && s }
            ),
            size: e === "text" || r === "small" ? 16 : 20
          }
        )
      ]
    }
  )
), G7t = kn(
  ({
    children: t,
    icon: e = "arrow-right",
    iconPosition: r = "right",
    className: i,
    ...s
  }, c) => {
    const u = mr(), l = {
      content: {
        initial: {
          background: "var(--ssui-color-white)"
        },
        hover: {
          background: "var(--ssui-color-grey-100)"
        },
        focus: {
          outline: `2px solid ${Hn.colors.purple.shade400}`
        },
        tap: {
          background: "var(--ssui-color-grey-200)"
        }
      }
    };
    return /* @__PURE__ */ Ve(
      bn.button,
      {
        className: Ke(
          "grid cursor-pointer grid-cols-[auto_auto] items-center gap-2 rounded-lg border-none bg-white p-5 text-base text-grey-900 shadow-sm outline-offset-2 focus-visible:outline-none",
          { "justify-start": r === "left", "justify-between": r === "right" },
          i
        ),
        initial: "initial",
        whileHover: "hover",
        whileFocus: "focus",
        whileTap: "tap",
        variants: l.content,
        transition: {
          type: "spring",
          duration: 0.2
        },
        ref: c,
        "aria-labelledby": u,
        ...s,
        children: [
          /* @__PURE__ */ $t(
            "span",
            {
              className: Ke("row-start-1 row-end-2", { "col-span-1 col-start-2": r === "left" }),
              id: u,
              children: t
            }
          ),
          /* @__PURE__ */ $t(
            hr,
            {
              iconName: e,
              className: Ke("row-start-1 row-end-2 text-primary-500", {
                "col-span-1 col-start-1": r === "left"
              }),
              size: 22
            }
          )
        ]
      }
    );
  }
), cX = (t) => +t;
function uX(t) {
  return t * t;
}
function hX(t) {
  return t * (2 - t);
}
function Yv(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}
function fX(t) {
  return t * t * t;
}
function dX(t) {
  return --t * t * t + 1;
}
function Zv(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var m7 = 3, gX = function t(e) {
  e = +e;
  function r(i) {
    return Math.pow(i, e);
  }
  return r.exponent = t, r;
}(m7), pX = function t(e) {
  e = +e;
  function r(i) {
    return 1 - Math.pow(1 - i, e);
  }
  return r.exponent = t, r;
}(m7), Jv = function t(e) {
  e = +e;
  function r(i) {
    return ((i *= 2) <= 1 ? Math.pow(i, e) : 2 - Math.pow(2 - i, e)) / 2;
  }
  return r.exponent = t, r;
}(m7), xk = Math.PI, Sk = xk / 2;
function mX(t) {
  return +t == 1 ? 1 : 1 - Math.cos(t * Sk);
}
function yX(t) {
  return Math.sin(t * Sk);
}
function Qv(t) {
  return (1 - Math.cos(xk * t)) / 2;
}
function al(t) {
  return (Math.pow(2, -10 * t) - 9765625e-10) * 1.0009775171065494;
}
function bX(t) {
  return al(1 - +t);
}
function vX(t) {
  return 1 - al(t);
}
function tw(t) {
  return ((t *= 2) <= 1 ? al(1 - t) : 2 - al(t - 1)) / 2;
}
function wX(t) {
  return 1 - Math.sqrt(1 - t * t);
}
function xX(t) {
  return Math.sqrt(1 - --t * t);
}
function ew(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}
var X3 = 4 / 11, SX = 6 / 11, CX = 8 / 11, AX = 3 / 4, _X = 9 / 11, kX = 10 / 11, OX = 15 / 16, TX = 21 / 22, MX = 63 / 64, rd = 1 / X3 / X3;
function EX(t) {
  return 1 - rh(1 - t);
}
function rh(t) {
  return (t = +t) < X3 ? rd * t * t : t < CX ? rd * (t -= SX) * t + AX : t < kX ? rd * (t -= _X) * t + OX : rd * (t -= TX) * t + MX;
}
function PX(t) {
  return ((t *= 2) <= 1 ? 1 - rh(1 - t) : rh(t - 1) + 1) / 2;
}
var y7 = 1.70158, IX = function t(e) {
  e = +e;
  function r(i) {
    return (i = +i) * i * (e * (i - 1) + i);
  }
  return r.overshoot = t, r;
}(y7), FX = function t(e) {
  e = +e;
  function r(i) {
    return --i * i * ((i + 1) * e + i) + 1;
  }
  return r.overshoot = t, r;
}(y7), nw = function t(e) {
  e = +e;
  function r(i) {
    return ((i *= 2) < 1 ? i * i * ((e + 1) * i - e) : (i -= 2) * i * ((e + 1) * i + e) + 2) / 2;
  }
  return r.overshoot = t, r;
}(y7), Qu = 2 * Math.PI, b7 = 1, v7 = 0.3, RX = function t(e, r) {
  var i = Math.asin(1 / (e = Math.max(1, e))) * (r /= Qu);
  function s(c) {
    return e * al(- --c) * Math.sin((i - c) / r);
  }
  return s.amplitude = function(c) {
    return t(c, r * Qu);
  }, s.period = function(c) {
    return t(e, c);
  }, s;
}(b7, v7), rw = function t(e, r) {
  var i = Math.asin(1 / (e = Math.max(1, e))) * (r /= Qu);
  function s(c) {
    return 1 - e * al(c = +c) * Math.sin((c + i) / r);
  }
  return s.amplitude = function(c) {
    return t(c, r * Qu);
  }, s.period = function(c) {
    return t(e, c);
  }, s;
}(b7, v7), DX = function t(e, r) {
  var i = Math.asin(1 / (e = Math.max(1, e))) * (r /= Qu);
  function s(c) {
    return ((c = c * 2 - 1) < 0 ? e * al(-c) * Math.sin((i - c) / r) : 2 - e * al(c) * Math.sin((i + c) / r)) / 2;
  }
  return s.amplitude = function(c) {
    return t(c, r * Qu);
  }, s.period = function(c) {
    return t(e, c);
  }, s;
}(b7, v7);
const $X = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  easeBack: nw,
  easeBackIn: IX,
  easeBackInOut: nw,
  easeBackOut: FX,
  easeBounce: rh,
  easeBounceIn: EX,
  easeBounceInOut: PX,
  easeBounceOut: rh,
  easeCircle: ew,
  easeCircleIn: wX,
  easeCircleInOut: ew,
  easeCircleOut: xX,
  easeCubic: Zv,
  easeCubicIn: fX,
  easeCubicInOut: Zv,
  easeCubicOut: dX,
  easeElastic: rw,
  easeElasticIn: RX,
  easeElasticInOut: DX,
  easeElasticOut: rw,
  easeExp: tw,
  easeExpIn: bX,
  easeExpInOut: tw,
  easeExpOut: vX,
  easeLinear: cX,
  easePoly: Jv,
  easePolyIn: gX,
  easePolyInOut: Jv,
  easePolyOut: pX,
  easeQuad: Yv,
  easeQuadIn: uX,
  easeQuadInOut: Yv,
  easeQuadOut: hX,
  easeSin: Qv,
  easeSinIn: mX,
  easeSinInOut: Qv,
  easeSinOut: yX
}, Symbol.toStringTag, { value: "Module" }));
function LX(t, e) {
  for (var r = -1, i = t == null ? 0 : t.length, s = Array(i); ++r < i; )
    s[r] = e(t[r], r, t);
  return s;
}
var w7 = LX, NX = Array.isArray, La = NX, BX = typeof ds == "object" && ds && ds.Object === Object && ds, Ck = BX, jX = Ck, UX = typeof self == "object" && self && self.Object === Object && self, HX = jX || UX || Function("return this")(), Ms = HX, VX = Ms, zX = VX.Symbol, Dh = zX, iw = Dh, Ak = Object.prototype, XX = Ak.hasOwnProperty, qX = Ak.toString, l1 = iw ? iw.toStringTag : void 0;
function WX(t) {
  var e = XX.call(t, l1), r = t[l1];
  try {
    t[l1] = void 0;
    var i = !0;
  } catch {
  }
  var s = qX.call(t);
  return i && (e ? t[l1] = r : delete t[l1]), s;
}
var GX = WX, KX = Object.prototype, YX = KX.toString;
function ZX(t) {
  return YX.call(t);
}
var JX = ZX, aw = Dh, QX = GX, tq = JX, eq = "[object Null]", nq = "[object Undefined]", sw = aw ? aw.toStringTag : void 0;
function rq(t) {
  return t == null ? t === void 0 ? nq : eq : sw && sw in Object(t) ? QX(t) : tq(t);
}
var ml = rq;
function iq(t) {
  return t != null && typeof t == "object";
}
var yl = iq, aq = ml, sq = yl, oq = "[object Symbol]";
function lq(t) {
  return typeof t == "symbol" || sq(t) && aq(t) == oq;
}
var $h = lq, cq = La, uq = $h, hq = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fq = /^\w*$/;
function dq(t, e) {
  if (cq(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || uq(t) ? !0 : fq.test(t) || !hq.test(t) || e != null && t in Object(e);
}
var x7 = dq;
function gq(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Es = gq;
const O2 = /* @__PURE__ */ Dn(Es);
var pq = ml, mq = Es, yq = "[object AsyncFunction]", bq = "[object Function]", vq = "[object GeneratorFunction]", wq = "[object Proxy]";
function xq(t) {
  if (!mq(t))
    return !1;
  var e = pq(t);
  return e == bq || e == vq || e == yq || e == wq;
}
var _k = xq, Sq = Ms, Cq = Sq["__core-js_shared__"], Aq = Cq, vm = Aq, ow = function() {
  var t = /[^.]+$/.exec(vm && vm.keys && vm.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function _q(t) {
  return !!ow && ow in t;
}
var kq = _q, Oq = Function.prototype, Tq = Oq.toString;
function Mq(t) {
  if (t != null) {
    try {
      return Tq.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var kk = Mq, Eq = _k, Pq = kq, Iq = Es, Fq = kk, Rq = /[\\^$.*+?()[\]{}|]/g, Dq = /^\[object .+?Constructor\]$/, $q = Function.prototype, Lq = Object.prototype, Nq = $q.toString, Bq = Lq.hasOwnProperty, jq = RegExp(
  "^" + Nq.call(Bq).replace(Rq, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Uq(t) {
  if (!Iq(t) || Pq(t))
    return !1;
  var e = Eq(t) ? jq : Dq;
  return e.test(Fq(t));
}
var Hq = Uq;
function Vq(t, e) {
  return t == null ? void 0 : t[e];
}
var zq = Vq, Xq = Hq, qq = zq;
function Wq(t, e) {
  var r = qq(t, e);
  return Xq(r) ? r : void 0;
}
var Ic = Wq, Gq = Ic, Kq = Gq(Object, "create"), ap = Kq, lw = ap;
function Yq() {
  this.__data__ = lw ? lw(null) : {}, this.size = 0;
}
var Zq = Yq;
function Jq(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Qq = Jq, tW = ap, eW = "__lodash_hash_undefined__", nW = Object.prototype, rW = nW.hasOwnProperty;
function iW(t) {
  var e = this.__data__;
  if (tW) {
    var r = e[t];
    return r === eW ? void 0 : r;
  }
  return rW.call(e, t) ? e[t] : void 0;
}
var aW = iW, sW = ap, oW = Object.prototype, lW = oW.hasOwnProperty;
function cW(t) {
  var e = this.__data__;
  return sW ? e[t] !== void 0 : lW.call(e, t);
}
var uW = cW, hW = ap, fW = "__lodash_hash_undefined__";
function dW(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = hW && e === void 0 ? fW : e, this;
}
var gW = dW, pW = Zq, mW = Qq, yW = aW, bW = uW, vW = gW;
function b0(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
b0.prototype.clear = pW;
b0.prototype.delete = mW;
b0.prototype.get = yW;
b0.prototype.has = bW;
b0.prototype.set = vW;
var wW = b0;
function xW() {
  this.__data__ = [], this.size = 0;
}
var SW = xW;
function CW(t, e) {
  return t === e || t !== t && e !== e;
}
var v0 = CW, AW = v0;
function _W(t, e) {
  for (var r = t.length; r--; )
    if (AW(t[r][0], e))
      return r;
  return -1;
}
var sp = _W, kW = sp, OW = Array.prototype, TW = OW.splice;
function MW(t) {
  var e = this.__data__, r = kW(e, t);
  if (r < 0)
    return !1;
  var i = e.length - 1;
  return r == i ? e.pop() : TW.call(e, r, 1), --this.size, !0;
}
var EW = MW, PW = sp;
function IW(t) {
  var e = this.__data__, r = PW(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var FW = IW, RW = sp;
function DW(t) {
  return RW(this.__data__, t) > -1;
}
var $W = DW, LW = sp;
function NW(t, e) {
  var r = this.__data__, i = LW(r, t);
  return i < 0 ? (++this.size, r.push([t, e])) : r[i][1] = e, this;
}
var BW = NW, jW = SW, UW = EW, HW = FW, VW = $W, zW = BW;
function w0(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
w0.prototype.clear = jW;
w0.prototype.delete = UW;
w0.prototype.get = HW;
w0.prototype.has = VW;
w0.prototype.set = zW;
var op = w0, XW = Ic, qW = Ms, WW = XW(qW, "Map"), S7 = WW, cw = wW, GW = op, KW = S7;
function YW() {
  this.size = 0, this.__data__ = {
    hash: new cw(),
    map: new (KW || GW)(),
    string: new cw()
  };
}
var ZW = YW;
function JW(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var QW = JW, tG = QW;
function eG(t, e) {
  var r = t.__data__;
  return tG(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var lp = eG, nG = lp;
function rG(t) {
  var e = nG(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var iG = rG, aG = lp;
function sG(t) {
  return aG(this, t).get(t);
}
var oG = sG, lG = lp;
function cG(t) {
  return lG(this, t).has(t);
}
var uG = cG, hG = lp;
function fG(t, e) {
  var r = hG(this, t), i = r.size;
  return r.set(t, e), this.size += r.size == i ? 0 : 1, this;
}
var dG = fG, gG = ZW, pG = iG, mG = oG, yG = uG, bG = dG;
function x0(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
x0.prototype.clear = gG;
x0.prototype.delete = pG;
x0.prototype.get = mG;
x0.prototype.has = yG;
x0.prototype.set = bG;
var C7 = x0, Ok = C7, vG = "Expected a function";
function A7(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(vG);
  var r = function() {
    var i = arguments, s = e ? e.apply(this, i) : i[0], c = r.cache;
    if (c.has(s))
      return c.get(s);
    var u = t.apply(this, i);
    return r.cache = c.set(s, u) || c, u;
  };
  return r.cache = new (A7.Cache || Ok)(), r;
}
A7.Cache = Ok;
var Tk = A7;
const Mk = /* @__PURE__ */ Dn(Tk);
var wG = Tk, xG = 500;
function SG(t) {
  var e = wG(t, function(i) {
    return r.size === xG && r.clear(), i;
  }), r = e.cache;
  return e;
}
var CG = SG, AG = CG, _G = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, kG = /\\(\\)?/g, OG = AG(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(_G, function(r, i, s, c) {
    e.push(s ? c.replace(kG, "$1") : i || r);
  }), e;
}), TG = OG, uw = Dh, MG = w7, EG = La, PG = $h, hw = uw ? uw.prototype : void 0, fw = hw ? hw.toString : void 0;
function Ek(t) {
  if (typeof t == "string")
    return t;
  if (EG(t))
    return MG(t, Ek) + "";
  if (PG(t))
    return fw ? fw.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var IG = Ek, FG = IG;
function RG(t) {
  return t == null ? "" : FG(t);
}
var Pk = RG, DG = La, $G = x7, LG = TG, NG = Pk;
function BG(t, e) {
  return DG(t) ? t : $G(t, e) ? [t] : LG(NG(t));
}
var cp = BG, jG = $h;
function UG(t) {
  if (typeof t == "string" || jG(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var Lh = UG, HG = cp, VG = Lh;
function zG(t, e) {
  e = HG(e, t);
  for (var r = 0, i = e.length; t != null && r < i; )
    t = t[VG(e[r++])];
  return r && r == i ? t : void 0;
}
var up = zG, XG = op;
function qG() {
  this.__data__ = new XG(), this.size = 0;
}
var WG = qG;
function GG(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var KG = GG;
function YG(t) {
  return this.__data__.get(t);
}
var ZG = YG;
function JG(t) {
  return this.__data__.has(t);
}
var QG = JG, tK = op, eK = S7, nK = C7, rK = 200;
function iK(t, e) {
  var r = this.__data__;
  if (r instanceof tK) {
    var i = r.__data__;
    if (!eK || i.length < rK - 1)
      return i.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new nK(i);
  }
  return r.set(t, e), this.size = r.size, this;
}
var aK = iK, sK = op, oK = WG, lK = KG, cK = ZG, uK = QG, hK = aK;
function S0(t) {
  var e = this.__data__ = new sK(t);
  this.size = e.size;
}
S0.prototype.clear = oK;
S0.prototype.delete = lK;
S0.prototype.get = cK;
S0.prototype.has = uK;
S0.prototype.set = hK;
var Ik = S0, fK = "__lodash_hash_undefined__";
function dK(t) {
  return this.__data__.set(t, fK), this;
}
var gK = dK;
function pK(t) {
  return this.__data__.has(t);
}
var mK = pK, yK = C7, bK = gK, vK = mK;
function T2(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new yK(); ++e < r; )
    this.add(t[e]);
}
T2.prototype.add = T2.prototype.push = bK;
T2.prototype.has = vK;
var Fk = T2;
function wK(t, e) {
  for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var xK = wK;
function SK(t, e) {
  return t.has(e);
}
var Rk = SK, CK = Fk, AK = xK, _K = Rk, kK = 1, OK = 2;
function TK(t, e, r, i, s, c) {
  var u = r & kK, l = t.length, f = e.length;
  if (l != f && !(u && f > l))
    return !1;
  var o = c.get(t), g = c.get(e);
  if (o && g)
    return o == e && g == t;
  var p = -1, n = !0, a = r & OK ? new CK() : void 0;
  for (c.set(t, e), c.set(e, t); ++p < l; ) {
    var d = t[p], m = e[p];
    if (i)
      var b = u ? i(m, d, p, e, t, c) : i(d, m, p, t, e, c);
    if (b !== void 0) {
      if (b)
        continue;
      n = !1;
      break;
    }
    if (a) {
      if (!AK(e, function(w, v) {
        if (!_K(a, v) && (d === w || s(d, w, r, i, c)))
          return a.push(v);
      })) {
        n = !1;
        break;
      }
    } else if (!(d === m || s(d, m, r, i, c))) {
      n = !1;
      break;
    }
  }
  return c.delete(t), c.delete(e), n;
}
var Dk = TK, MK = Ms, EK = MK.Uint8Array, PK = EK;
function IK(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(i, s) {
    r[++e] = [s, i];
  }), r;
}
var FK = IK;
function RK(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(i) {
    r[++e] = i;
  }), r;
}
var _7 = RK, dw = Dh, gw = PK, DK = v0, $K = Dk, LK = FK, NK = _7, BK = 1, jK = 2, UK = "[object Boolean]", HK = "[object Date]", VK = "[object Error]", zK = "[object Map]", XK = "[object Number]", qK = "[object RegExp]", WK = "[object Set]", GK = "[object String]", KK = "[object Symbol]", YK = "[object ArrayBuffer]", ZK = "[object DataView]", pw = dw ? dw.prototype : void 0, wm = pw ? pw.valueOf : void 0;
function JK(t, e, r, i, s, c, u) {
  switch (r) {
    case ZK:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case YK:
      return !(t.byteLength != e.byteLength || !c(new gw(t), new gw(e)));
    case UK:
    case HK:
    case XK:
      return DK(+t, +e);
    case VK:
      return t.name == e.name && t.message == e.message;
    case qK:
    case GK:
      return t == e + "";
    case zK:
      var l = LK;
    case WK:
      var f = i & BK;
      if (l || (l = NK), t.size != e.size && !f)
        return !1;
      var o = u.get(t);
      if (o)
        return o == e;
      i |= jK, u.set(t, e);
      var g = $K(l(t), l(e), i, s, c, u);
      return u.delete(t), g;
    case KK:
      if (wm)
        return wm.call(t) == wm.call(e);
  }
  return !1;
}
var QK = JK;
function tY(t, e) {
  for (var r = -1, i = e.length, s = t.length; ++r < i; )
    t[s + r] = e[r];
  return t;
}
var k7 = tY, eY = k7, nY = La;
function rY(t, e, r) {
  var i = e(t);
  return nY(t) ? i : eY(i, r(t));
}
var $k = rY;
function iY(t, e) {
  for (var r = -1, i = t == null ? 0 : t.length, s = 0, c = []; ++r < i; ) {
    var u = t[r];
    e(u, r, t) && (c[s++] = u);
  }
  return c;
}
var aY = iY;
function sY() {
  return [];
}
var Lk = sY, oY = aY, lY = Lk, cY = Object.prototype, uY = cY.propertyIsEnumerable, mw = Object.getOwnPropertySymbols, hY = mw ? function(t) {
  return t == null ? [] : (t = Object(t), oY(mw(t), function(e) {
    return uY.call(t, e);
  }));
} : lY, Nk = hY;
function fY(t, e) {
  for (var r = -1, i = Array(t); ++r < t; )
    i[r] = e(r);
  return i;
}
var dY = fY, gY = ml, pY = yl, mY = "[object Arguments]";
function yY(t) {
  return pY(t) && gY(t) == mY;
}
var bY = yY, yw = bY, vY = yl, Bk = Object.prototype, wY = Bk.hasOwnProperty, xY = Bk.propertyIsEnumerable, SY = yw(/* @__PURE__ */ function() {
  return arguments;
}()) ? yw : function(t) {
  return vY(t) && wY.call(t, "callee") && !xY.call(t, "callee");
}, hp = SY, M2 = { exports: {} };
function CY() {
  return !1;
}
var AY = CY;
M2.exports;
(function(t, e) {
  var r = Ms, i = AY, s = e && !e.nodeType && e, c = s && !0 && t && !t.nodeType && t, u = c && c.exports === s, l = u ? r.Buffer : void 0, f = l ? l.isBuffer : void 0, o = f || i;
  t.exports = o;
})(M2, M2.exports);
var O7 = M2.exports, _Y = 9007199254740991, kY = /^(?:0|[1-9]\d*)$/;
function OY(t, e) {
  var r = typeof t;
  return e = e ?? _Y, !!e && (r == "number" || r != "symbol" && kY.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var fp = OY, TY = 9007199254740991;
function MY(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= TY;
}
var T7 = MY, EY = ml, PY = T7, IY = yl, FY = "[object Arguments]", RY = "[object Array]", DY = "[object Boolean]", $Y = "[object Date]", LY = "[object Error]", NY = "[object Function]", BY = "[object Map]", jY = "[object Number]", UY = "[object Object]", HY = "[object RegExp]", VY = "[object Set]", zY = "[object String]", XY = "[object WeakMap]", qY = "[object ArrayBuffer]", WY = "[object DataView]", GY = "[object Float32Array]", KY = "[object Float64Array]", YY = "[object Int8Array]", ZY = "[object Int16Array]", JY = "[object Int32Array]", QY = "[object Uint8Array]", tZ = "[object Uint8ClampedArray]", eZ = "[object Uint16Array]", nZ = "[object Uint32Array]", Zn = {};
Zn[GY] = Zn[KY] = Zn[YY] = Zn[ZY] = Zn[JY] = Zn[QY] = Zn[tZ] = Zn[eZ] = Zn[nZ] = !0;
Zn[FY] = Zn[RY] = Zn[qY] = Zn[DY] = Zn[WY] = Zn[$Y] = Zn[LY] = Zn[NY] = Zn[BY] = Zn[jY] = Zn[UY] = Zn[HY] = Zn[VY] = Zn[zY] = Zn[XY] = !1;
function rZ(t) {
  return IY(t) && PY(t.length) && !!Zn[EY(t)];
}
var iZ = rZ;
function aZ(t) {
  return function(e) {
    return t(e);
  };
}
var dp = aZ, E2 = { exports: {} };
E2.exports;
(function(t, e) {
  var r = Ck, i = e && !e.nodeType && e, s = i && !0 && t && !t.nodeType && t, c = s && s.exports === i, u = c && r.process, l = function() {
    try {
      var f = s && s.require && s.require("util").types;
      return f || u && u.binding && u.binding("util");
    } catch {
    }
  }();
  t.exports = l;
})(E2, E2.exports);
var M7 = E2.exports, sZ = iZ, oZ = dp, bw = M7, vw = bw && bw.isTypedArray, lZ = vw ? oZ(vw) : sZ, E7 = lZ, cZ = dY, uZ = hp, hZ = La, fZ = O7, dZ = fp, gZ = E7, pZ = Object.prototype, mZ = pZ.hasOwnProperty;
function yZ(t, e) {
  var r = hZ(t), i = !r && uZ(t), s = !r && !i && fZ(t), c = !r && !i && !s && gZ(t), u = r || i || s || c, l = u ? cZ(t.length, String) : [], f = l.length;
  for (var o in t)
    (e || mZ.call(t, o)) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (o == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (o == "offset" || o == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    c && (o == "buffer" || o == "byteLength" || o == "byteOffset") || // Skip index properties.
    dZ(o, f))) && l.push(o);
  return l;
}
var jk = yZ, bZ = Object.prototype;
function vZ(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || bZ;
  return t === r;
}
var P7 = vZ;
function wZ(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Uk = wZ, xZ = Uk, SZ = xZ(Object.keys, Object), CZ = SZ, AZ = P7, _Z = CZ, kZ = Object.prototype, OZ = kZ.hasOwnProperty;
function TZ(t) {
  if (!AZ(t))
    return _Z(t);
  var e = [];
  for (var r in Object(t))
    OZ.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var Hk = TZ, MZ = _k, EZ = T7;
function PZ(t) {
  return t != null && EZ(t.length) && !MZ(t);
}
var C0 = PZ, IZ = jk, FZ = Hk, RZ = C0;
function DZ(t) {
  return RZ(t) ? IZ(t) : FZ(t);
}
var I7 = DZ, $Z = $k, LZ = Nk, NZ = I7;
function BZ(t) {
  return $Z(t, NZ, LZ);
}
var jZ = BZ, ww = jZ, UZ = 1, HZ = Object.prototype, VZ = HZ.hasOwnProperty;
function zZ(t, e, r, i, s, c) {
  var u = r & UZ, l = ww(t), f = l.length, o = ww(e), g = o.length;
  if (f != g && !u)
    return !1;
  for (var p = f; p--; ) {
    var n = l[p];
    if (!(u ? n in e : VZ.call(e, n)))
      return !1;
  }
  var a = c.get(t), d = c.get(e);
  if (a && d)
    return a == e && d == t;
  var m = !0;
  c.set(t, e), c.set(e, t);
  for (var b = u; ++p < f; ) {
    n = l[p];
    var w = t[n], v = e[n];
    if (i)
      var h = u ? i(v, w, n, e, t, c) : i(w, v, n, t, e, c);
    if (!(h === void 0 ? w === v || s(w, v, r, i, c) : h)) {
      m = !1;
      break;
    }
    b || (b = n == "constructor");
  }
  if (m && !b) {
    var x = t.constructor, _ = e.constructor;
    x != _ && "constructor" in t && "constructor" in e && !(typeof x == "function" && x instanceof x && typeof _ == "function" && _ instanceof _) && (m = !1);
  }
  return c.delete(t), c.delete(e), m;
}
var XZ = zZ, qZ = Ic, WZ = Ms, GZ = qZ(WZ, "DataView"), KZ = GZ, YZ = Ic, ZZ = Ms, JZ = YZ(ZZ, "Promise"), QZ = JZ, tJ = Ic, eJ = Ms, nJ = tJ(eJ, "Set"), Vk = nJ, rJ = Ic, iJ = Ms, aJ = rJ(iJ, "WeakMap"), sJ = aJ, q3 = KZ, W3 = S7, G3 = QZ, K3 = Vk, Y3 = sJ, zk = ml, A0 = kk, xw = "[object Map]", oJ = "[object Object]", Sw = "[object Promise]", Cw = "[object Set]", Aw = "[object WeakMap]", _w = "[object DataView]", lJ = A0(q3), cJ = A0(W3), uJ = A0(G3), hJ = A0(K3), fJ = A0(Y3), Xl = zk;
(q3 && Xl(new q3(new ArrayBuffer(1))) != _w || W3 && Xl(new W3()) != xw || G3 && Xl(G3.resolve()) != Sw || K3 && Xl(new K3()) != Cw || Y3 && Xl(new Y3()) != Aw) && (Xl = function(t) {
  var e = zk(t), r = e == oJ ? t.constructor : void 0, i = r ? A0(r) : "";
  if (i)
    switch (i) {
      case lJ:
        return _w;
      case cJ:
        return xw;
      case uJ:
        return Sw;
      case hJ:
        return Cw;
      case fJ:
        return Aw;
    }
  return e;
});
var Xk = Xl, xm = Ik, dJ = Dk, gJ = QK, pJ = XZ, kw = Xk, Ow = La, Tw = O7, mJ = E7, yJ = 1, Mw = "[object Arguments]", Ew = "[object Array]", id = "[object Object]", bJ = Object.prototype, Pw = bJ.hasOwnProperty;
function vJ(t, e, r, i, s, c) {
  var u = Ow(t), l = Ow(e), f = u ? Ew : kw(t), o = l ? Ew : kw(e);
  f = f == Mw ? id : f, o = o == Mw ? id : o;
  var g = f == id, p = o == id, n = f == o;
  if (n && Tw(t)) {
    if (!Tw(e))
      return !1;
    u = !0, g = !1;
  }
  if (n && !g)
    return c || (c = new xm()), u || mJ(t) ? dJ(t, e, r, i, s, c) : gJ(t, e, f, r, i, s, c);
  if (!(r & yJ)) {
    var a = g && Pw.call(t, "__wrapped__"), d = p && Pw.call(e, "__wrapped__");
    if (a || d) {
      var m = a ? t.value() : t, b = d ? e.value() : e;
      return c || (c = new xm()), s(m, b, r, i, c);
    }
  }
  return n ? (c || (c = new xm()), pJ(t, e, r, i, s, c)) : !1;
}
var wJ = vJ, xJ = wJ, Iw = yl;
function qk(t, e, r, i, s) {
  return t === e ? !0 : t == null || e == null || !Iw(t) && !Iw(e) ? t !== t && e !== e : xJ(t, e, r, i, qk, s);
}
var F7 = qk, SJ = Ik, CJ = F7, AJ = 1, _J = 2;
function kJ(t, e, r, i) {
  var s = r.length, c = s, u = !i;
  if (t == null)
    return !c;
  for (t = Object(t); s--; ) {
    var l = r[s];
    if (u && l[2] ? l[1] !== t[l[0]] : !(l[0] in t))
      return !1;
  }
  for (; ++s < c; ) {
    l = r[s];
    var f = l[0], o = t[f], g = l[1];
    if (u && l[2]) {
      if (o === void 0 && !(f in t))
        return !1;
    } else {
      var p = new SJ();
      if (i)
        var n = i(o, g, f, t, e, p);
      if (!(n === void 0 ? CJ(g, o, AJ | _J, i, p) : n))
        return !1;
    }
  }
  return !0;
}
var OJ = kJ, TJ = Es;
function MJ(t) {
  return t === t && !TJ(t);
}
var Wk = MJ, EJ = Wk, PJ = I7;
function IJ(t) {
  for (var e = PJ(t), r = e.length; r--; ) {
    var i = e[r], s = t[i];
    e[r] = [i, s, EJ(s)];
  }
  return e;
}
var FJ = IJ;
function RJ(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
var Gk = RJ, DJ = OJ, $J = FJ, LJ = Gk;
function NJ(t) {
  var e = $J(t);
  return e.length == 1 && e[0][2] ? LJ(e[0][0], e[0][1]) : function(r) {
    return r === t || DJ(r, t, e);
  };
}
var BJ = NJ, jJ = up;
function UJ(t, e, r) {
  var i = t == null ? void 0 : jJ(t, e);
  return i === void 0 ? r : i;
}
var HJ = UJ;
function VJ(t, e) {
  return t != null && e in Object(t);
}
var zJ = VJ, XJ = cp, qJ = hp, WJ = La, GJ = fp, KJ = T7, YJ = Lh;
function ZJ(t, e, r) {
  e = XJ(e, t);
  for (var i = -1, s = e.length, c = !1; ++i < s; ) {
    var u = YJ(e[i]);
    if (!(c = t != null && r(t, u)))
      break;
    t = t[u];
  }
  return c || ++i != s ? c : (s = t == null ? 0 : t.length, !!s && KJ(s) && GJ(u, s) && (WJ(t) || qJ(t)));
}
var JJ = ZJ, QJ = zJ, tQ = JJ;
function eQ(t, e) {
  return t != null && tQ(t, e, QJ);
}
var Kk = eQ, nQ = F7, rQ = HJ, iQ = Kk, aQ = x7, sQ = Wk, oQ = Gk, lQ = Lh, cQ = 1, uQ = 2;
function hQ(t, e) {
  return aQ(t) && sQ(e) ? oQ(lQ(t), e) : function(r) {
    var i = rQ(r, t);
    return i === void 0 && i === e ? iQ(r, t) : nQ(e, i, cQ | uQ);
  };
}
var fQ = hQ;
function dQ(t) {
  return t;
}
var Nh = dQ;
const _0 = /* @__PURE__ */ Dn(Nh);
function gQ(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var pQ = gQ, mQ = up;
function yQ(t) {
  return function(e) {
    return mQ(e, t);
  };
}
var bQ = yQ, vQ = pQ, wQ = bQ, xQ = x7, SQ = Lh;
function CQ(t) {
  return xQ(t) ? vQ(SQ(t)) : wQ(t);
}
var Yk = CQ;
const Zk = /* @__PURE__ */ Dn(Yk);
var AQ = BJ, _Q = fQ, kQ = Nh, OQ = La, TQ = Yk;
function MQ(t) {
  return typeof t == "function" ? t : t == null ? kQ : typeof t == "object" ? OQ(t) ? _Q(t[0], t[1]) : AQ(t) : TQ(t);
}
var gp = MQ;
function EQ(t) {
  return function(e, r, i) {
    for (var s = -1, c = Object(e), u = i(e), l = u.length; l--; ) {
      var f = u[t ? l : ++s];
      if (r(c[f], f, c) === !1)
        break;
    }
    return e;
  };
}
var PQ = EQ, IQ = PQ, FQ = IQ(), RQ = FQ, DQ = RQ, $Q = I7;
function LQ(t, e) {
  return t && DQ(t, e, $Q);
}
var NQ = LQ, BQ = C0;
function jQ(t, e) {
  return function(r, i) {
    if (r == null)
      return r;
    if (!BQ(r))
      return t(r, i);
    for (var s = r.length, c = e ? s : -1, u = Object(r); (e ? c-- : ++c < s) && i(u[c], c, u) !== !1; )
      ;
    return r;
  };
}
var UQ = jQ, HQ = NQ, VQ = UQ, zQ = VQ(HQ), XQ = zQ, qQ = XQ, WQ = C0;
function GQ(t, e) {
  var r = -1, i = WQ(t) ? Array(t.length) : [];
  return qQ(t, function(s, c, u) {
    i[++r] = e(s, c, u);
  }), i;
}
var KQ = GQ;
function YQ(t, e) {
  var r = t.length;
  for (t.sort(e); r--; )
    t[r] = t[r].value;
  return t;
}
var ZQ = YQ, Fw = $h;
function JQ(t, e) {
  if (t !== e) {
    var r = t !== void 0, i = t === null, s = t === t, c = Fw(t), u = e !== void 0, l = e === null, f = e === e, o = Fw(e);
    if (!l && !o && !c && t > e || c && u && f && !l && !o || i && u && f || !r && f || !s)
      return 1;
    if (!i && !c && !o && t < e || o && r && s && !i && !c || l && r && s || !u && s || !f)
      return -1;
  }
  return 0;
}
var QQ = JQ, ttt = QQ;
function ett(t, e, r) {
  for (var i = -1, s = t.criteria, c = e.criteria, u = s.length, l = r.length; ++i < u; ) {
    var f = ttt(s[i], c[i]);
    if (f) {
      if (i >= l)
        return f;
      var o = r[i];
      return f * (o == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
var ntt = ett, Sm = w7, rtt = up, itt = gp, att = KQ, stt = ZQ, ott = dp, ltt = ntt, ctt = Nh, utt = La;
function htt(t, e, r) {
  e.length ? e = Sm(e, function(c) {
    return utt(c) ? function(u) {
      return rtt(u, c.length === 1 ? c[0] : c);
    } : c;
  }) : e = [ctt];
  var i = -1;
  e = Sm(e, ott(itt));
  var s = att(t, function(c, u, l) {
    var f = Sm(e, function(o) {
      return o(c);
    });
    return { criteria: f, index: ++i, value: c };
  });
  return stt(s, function(c, u) {
    return ltt(c, u, r);
  });
}
var ftt = htt, dtt = ftt, Rw = La;
function gtt(t, e, r, i) {
  return t == null ? [] : (Rw(e) || (e = e == null ? [] : [e]), r = i ? void 0 : r, Rw(r) || (r = r == null ? [] : [r]), dtt(t, e, r));
}
var ptt = gtt;
const pp = /* @__PURE__ */ Dn(ptt);
var mtt = Uk, ytt = mtt(Object.getPrototypeOf, Object), Jk = ytt, btt = ml, vtt = Jk, wtt = yl, xtt = "[object Object]", Stt = Function.prototype, Ctt = Object.prototype, Qk = Stt.toString, Att = Ctt.hasOwnProperty, _tt = Qk.call(Object);
function ktt(t) {
  if (!wtt(t) || btt(t) != xtt)
    return !1;
  var e = vtt(t);
  if (e === null)
    return !0;
  var r = Att.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Qk.call(r) == _tt;
}
var Ott = ktt;
const Ur = /* @__PURE__ */ Dn(Ott);
function R7(t, e, r) {
  t.prototype = e.prototype = r, r.constructor = t;
}
function tO(t, e) {
  var r = Object.create(t.prototype);
  for (var i in e) r[i] = e[i];
  return r;
}
function Bh() {
}
var ih = 0.7, P2 = 1 / ih, Du = "\\s*([+-]?\\d+)\\s*", ah = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Ss = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Ttt = /^#([0-9a-f]{3,8})$/, Mtt = new RegExp(`^rgb\\(${Du},${Du},${Du}\\)$`), Ett = new RegExp(`^rgb\\(${Ss},${Ss},${Ss}\\)$`), Ptt = new RegExp(`^rgba\\(${Du},${Du},${Du},${ah}\\)$`), Itt = new RegExp(`^rgba\\(${Ss},${Ss},${Ss},${ah}\\)$`), Ftt = new RegExp(`^hsl\\(${ah},${Ss},${Ss}\\)$`), Rtt = new RegExp(`^hsla\\(${ah},${Ss},${Ss},${ah}\\)$`), Dw = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
R7(Bh, sh, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: $w,
  // Deprecated! Use color.formatHex.
  formatHex: $w,
  formatHex8: Dtt,
  formatHsl: $tt,
  formatRgb: Lw,
  toString: Lw
});
function $w() {
  return this.rgb().formatHex();
}
function Dtt() {
  return this.rgb().formatHex8();
}
function $tt() {
  return eO(this).formatHsl();
}
function Lw() {
  return this.rgb().formatRgb();
}
function sh(t) {
  var e, r;
  return t = (t + "").trim().toLowerCase(), (e = Ttt.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), r === 6 ? Nw(e) : r === 3 ? new Bi(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : r === 8 ? ad(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : r === 4 ? ad(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = Mtt.exec(t)) ? new Bi(e[1], e[2], e[3], 1) : (e = Ett.exec(t)) ? new Bi(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = Ptt.exec(t)) ? ad(e[1], e[2], e[3], e[4]) : (e = Itt.exec(t)) ? ad(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = Ftt.exec(t)) ? Uw(e[1], e[2] / 100, e[3] / 100, 1) : (e = Rtt.exec(t)) ? Uw(e[1], e[2] / 100, e[3] / 100, e[4]) : Dw.hasOwnProperty(t) ? Nw(Dw[t]) : t === "transparent" ? new Bi(NaN, NaN, NaN, 0) : null;
}
function Nw(t) {
  return new Bi(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function ad(t, e, r, i) {
  return i <= 0 && (t = e = r = NaN), new Bi(t, e, r, i);
}
function Ltt(t) {
  return t instanceof Bh || (t = sh(t)), t ? (t = t.rgb(), new Bi(t.r, t.g, t.b, t.opacity)) : new Bi();
}
function Z3(t, e, r, i) {
  return arguments.length === 1 ? Ltt(t) : new Bi(t, e, r, i ?? 1);
}
function Bi(t, e, r, i) {
  this.r = +t, this.g = +e, this.b = +r, this.opacity = +i;
}
R7(Bi, Z3, tO(Bh, {
  brighter(t) {
    return t = t == null ? P2 : Math.pow(P2, t), new Bi(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? ih : Math.pow(ih, t), new Bi(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Bi(cc(this.r), cc(this.g), cc(this.b), I2(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Bw,
  // Deprecated! Use color.formatHex.
  formatHex: Bw,
  formatHex8: Ntt,
  formatRgb: jw,
  toString: jw
}));
function Bw() {
  return `#${ec(this.r)}${ec(this.g)}${ec(this.b)}`;
}
function Ntt() {
  return `#${ec(this.r)}${ec(this.g)}${ec(this.b)}${ec((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function jw() {
  const t = I2(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${cc(this.r)}, ${cc(this.g)}, ${cc(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function I2(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function cc(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function ec(t) {
  return t = cc(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Uw(t, e, r, i) {
  return i <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Ka(t, e, r, i);
}
function eO(t) {
  if (t instanceof Ka) return new Ka(t.h, t.s, t.l, t.opacity);
  if (t instanceof Bh || (t = sh(t)), !t) return new Ka();
  if (t instanceof Ka) return t;
  t = t.rgb();
  var e = t.r / 255, r = t.g / 255, i = t.b / 255, s = Math.min(e, r, i), c = Math.max(e, r, i), u = NaN, l = c - s, f = (c + s) / 2;
  return l ? (e === c ? u = (r - i) / l + (r < i) * 6 : r === c ? u = (i - e) / l + 2 : u = (e - r) / l + 4, l /= f < 0.5 ? c + s : 2 - c - s, u *= 60) : l = f > 0 && f < 1 ? 0 : u, new Ka(u, l, f, t.opacity);
}
function Btt(t, e, r, i) {
  return arguments.length === 1 ? eO(t) : new Ka(t, e, r, i ?? 1);
}
function Ka(t, e, r, i) {
  this.h = +t, this.s = +e, this.l = +r, this.opacity = +i;
}
R7(Ka, Btt, tO(Bh, {
  brighter(t) {
    return t = t == null ? P2 : Math.pow(P2, t), new Ka(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? ih : Math.pow(ih, t), new Ka(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, r = this.l, i = r + (r < 0.5 ? r : 1 - r) * e, s = 2 * r - i;
    return new Bi(
      Cm(t >= 240 ? t - 240 : t + 120, s, i),
      Cm(t, s, i),
      Cm(t < 120 ? t + 240 : t - 120, s, i),
      this.opacity
    );
  },
  clamp() {
    return new Ka(Hw(this.h), sd(this.s), sd(this.l), I2(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = I2(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Hw(this.h)}, ${sd(this.s) * 100}%, ${sd(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Hw(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function sd(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function Cm(t, e, r) {
  return (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e) * 255;
}
const D7 = (t) => () => t;
function jtt(t, e) {
  return function(r) {
    return t + r * e;
  };
}
function Utt(t, e, r) {
  return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function(i) {
    return Math.pow(t + i * e, r);
  };
}
function Htt(t) {
  return (t = +t) == 1 ? nO : function(e, r) {
    return r - e ? Utt(e, r, t) : D7(isNaN(e) ? r : e);
  };
}
function nO(t, e) {
  var r = e - t;
  return r ? jtt(t, r) : D7(isNaN(t) ? e : t);
}
const Vw = function t(e) {
  var r = Htt(e);
  function i(s, c) {
    var u = r((s = Z3(s)).r, (c = Z3(c)).r), l = r(s.g, c.g), f = r(s.b, c.b), o = nO(s.opacity, c.opacity);
    return function(g) {
      return s.r = u(g), s.g = l(g), s.b = f(g), s.opacity = o(g), s + "";
    };
  }
  return i.gamma = t, i;
}(1);
function Vtt(t, e) {
  e || (e = []);
  var r = t ? Math.min(e.length, t.length) : 0, i = e.slice(), s;
  return function(c) {
    for (s = 0; s < r; ++s) i[s] = t[s] * (1 - c) + e[s] * c;
    return i;
  };
}
function ztt(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Xtt(t, e) {
  var r = e ? e.length : 0, i = t ? Math.min(r, t.length) : 0, s = new Array(i), c = new Array(r), u;
  for (u = 0; u < i; ++u) s[u] = Ps(t[u], e[u]);
  for (; u < r; ++u) c[u] = e[u];
  return function(l) {
    for (u = 0; u < i; ++u) c[u] = s[u](l);
    return c;
  };
}
function qtt(t, e) {
  var r = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(i) {
    return r.setTime(t * (1 - i) + e * i), r;
  };
}
function F2(t, e) {
  return t = +t, e = +e, function(r) {
    return t * (1 - r) + e * r;
  };
}
function Wtt(t, e) {
  var r = {}, i = {}, s;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (s in e)
    s in t ? r[s] = Ps(t[s], e[s]) : i[s] = e[s];
  return function(c) {
    for (s in r) i[s] = r[s](c);
    return i;
  };
}
var J3 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Am = new RegExp(J3.source, "g");
function Gtt(t) {
  return function() {
    return t;
  };
}
function Ktt(t) {
  return function(e) {
    return t(e) + "";
  };
}
function Ytt(t, e) {
  var r = J3.lastIndex = Am.lastIndex = 0, i, s, c, u = -1, l = [], f = [];
  for (t = t + "", e = e + ""; (i = J3.exec(t)) && (s = Am.exec(e)); )
    (c = s.index) > r && (c = e.slice(r, c), l[u] ? l[u] += c : l[++u] = c), (i = i[0]) === (s = s[0]) ? l[u] ? l[u] += s : l[++u] = s : (l[++u] = null, f.push({ i: u, x: F2(i, s) })), r = Am.lastIndex;
  return r < e.length && (c = e.slice(r), l[u] ? l[u] += c : l[++u] = c), l.length < 2 ? f[0] ? Ktt(f[0].x) : Gtt(e) : (e = f.length, function(o) {
    for (var g = 0, p; g < e; ++g) l[(p = f[g]).i] = p.x(o);
    return l.join("");
  });
}
function Ps(t, e) {
  var r = typeof e, i;
  return e == null || r === "boolean" ? D7(e) : (r === "number" ? F2 : r === "string" ? (i = sh(e)) ? (e = i, Vw) : Ytt : e instanceof sh ? Vw : e instanceof Date ? qtt : ztt(e) ? Vtt : Array.isArray(e) ? Xtt : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? Wtt : F2)(t, e);
}
function $7(t, e) {
  return t = +t, e = +e, function(r) {
    return Math.round(t * (1 - r) + e * r);
  };
}
function Ztt(t, e) {
  e === void 0 && (e = t, t = Ps);
  for (var r = 0, i = e.length - 1, s = e[0], c = new Array(i < 0 ? 0 : i); r < i; ) c[r] = t(s, s = e[++r]);
  return function(u) {
    var l = Math.max(0, Math.min(i - 1, Math.floor(u *= i)));
    return c[l](u - l);
  };
}
var R2 = function(t) {
  if (t !== null)
    switch (typeof t) {
      case "undefined":
        return !1;
      case "number":
        return !isNaN(t) && t !== Number.POSITIVE_INFINITY && t !== Number.NEGATIVE_INFINITY;
      case "string":
        return !0;
      case "boolean":
        return !1;
      case "object":
        return t instanceof Date || Array.isArray(t) || Ur(t);
      case "function":
        return !0;
    }
  return !1;
}, rO = function(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  return function(i) {
    return i < r ? t : e;
  };
}, iO = function(t, e) {
  return function(r) {
    return r >= 1 ? e : function() {
      var i = typeof t == "function" ? t.apply(this, arguments) : t, s = typeof e == "function" ? e.apply(this, arguments) : e;
      return Ps(i, s)(r);
    };
  };
}, aO = function(t, e) {
  var r = function(o, g) {
    return o === g || !R2(o) || !R2(g) ? rO(o, g) : typeof o == "function" || typeof g == "function" ? iO(o, g) : typeof o == "object" && Ur(o) || typeof g == "object" && Ur(g) ? aO(o, g) : Ps(o, g);
  }, i = function(o) {
    return Array.isArray(o) ? pp(o, "key") : o;
  }, s = {}, c = {}, u = t, l = e, f;
  (u === null || typeof u != "object") && (u = {}), (l === null || typeof l != "object") && (l = {});
  for (f in l)
    f in u ? s[f] = r(i(u[f]), i(l[f])) : c[f] = l[f];
  return function(o) {
    for (f in s)
      c[f] = s[f](o);
    return c;
  };
}, Jtt = function(t, e) {
  var r = function(i) {
    return typeof i == "string" ? i.replace(/,/g, "") : i;
  };
  return Ps(r(t), r(e));
}, Qtt = function(t, e) {
  return t === e || !R2(t) || !R2(e) ? rO(t, e) : typeof t == "function" || typeof e == "function" ? iO(t, e) : Ur(t) || Ur(e) ? aO(t, e) : typeof t == "string" || typeof e == "string" ? Jtt(t, e) : Ps(t, e);
}, t0 = 0, S1 = 0, c1 = 0, sO = 1e3, D2, C1, $2 = 0, wc = 0, mp = 0, oh = typeof performance == "object" && performance.now ? performance : Date, oO = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function L2() {
  return wc || (oO(tet), wc = oh.now() + mp);
}
function tet() {
  wc = 0;
}
function Q3() {
  this._call = this._time = this._next = null;
}
Q3.prototype = lO.prototype = {
  constructor: Q3,
  restart: function(t, e, r) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    r = (r == null ? L2() : +r) + (e == null ? 0 : +e), !this._next && C1 !== this && (C1 ? C1._next = this : D2 = this, C1 = this), this._call = t, this._time = r, t9();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, t9());
  }
};
function lO(t, e, r) {
  var i = new Q3();
  return i.restart(t, e, r), i;
}
function eet() {
  L2(), ++t0;
  for (var t = D2, e; t; )
    (e = wc - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --t0;
}
function zw() {
  wc = ($2 = oh.now()) + mp, t0 = S1 = 0;
  try {
    eet();
  } finally {
    t0 = 0, ret(), wc = 0;
  }
}
function net() {
  var t = oh.now(), e = t - $2;
  e > sO && (mp -= e, $2 = t);
}
function ret() {
  for (var t, e = D2, r, i = 1 / 0; e; )
    e._call ? (i > e._time && (i = e._time), t = e, e = e._next) : (r = e._next, e._next = null, e = t ? t._next = r : D2 = r);
  C1 = t, t9(i);
}
function t9(t) {
  if (!t0) {
    S1 && (S1 = clearTimeout(S1));
    var e = t - wc;
    e > 24 ? (t < 1 / 0 && (S1 = setTimeout(zw, t - oh.now() - mp)), c1 && (c1 = clearInterval(c1))) : (c1 || ($2 = oh.now(), c1 = setInterval(net, sO)), t0 = 1, oO(zw));
  }
}
function iet(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function aet(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function set(t, e, r) {
  return e && aet(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var Xw = /* @__PURE__ */ function() {
  function t() {
    var e = this;
    iet(this, t), this.shouldAnimate = void 0, this.subscribers = void 0, this.activeSubscriptions = void 0, this.timer = void 0, this.loop = function() {
      e.subscribers.forEach(function(r) {
        r.callback(L2() - r.startTime, r.duration);
      });
    }, this.shouldAnimate = !0, this.subscribers = [], this.timer = null, this.activeSubscriptions = 0;
  }
  return set(t, [{
    key: "bypassAnimation",
    value: function() {
      this.shouldAnimate = !1;
    }
  }, {
    key: "resumeAnimation",
    value: function() {
      this.shouldAnimate = !0;
    }
  }, {
    key: "start",
    value: function() {
      this.timer || (this.timer = lO(this.loop));
    }
  }, {
    key: "stop",
    value: function() {
      this.timer && (this.timer.stop(), this.timer = null);
    }
  }, {
    key: "subscribe",
    value: function(r, i) {
      var s = this.subscribers.push({
        startTime: L2(),
        callback: r,
        duration: this.shouldAnimate ? i : 0
      });
      return this.activeSubscriptions++, this.start(), s;
    }
  }, {
    key: "unsubscribe",
    value: function(r) {
      r !== null && this.subscribers[r - 1] && (delete this.subscribers[r - 1], this.activeSubscriptions--), this.activeSubscriptions === 0 && this.stop();
    }
  }]), t;
}(), jh = /* @__PURE__ */ Bt.createContext({
  transitionTimer: new Xw(),
  animationTimer: new Xw()
});
jh.displayName = "TimerContext";
function oet(t, e) {
  return fet(t) || het(t, e) || uet(t, e) || cet();
}
function cet() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uet(t, e) {
  if (t) {
    if (typeof t == "string") return qw(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qw(t, e);
  }
}
function qw(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function het(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var i = [], s = !0, c = !1, u, l;
    try {
      for (r = r.call(t); !(s = (u = r.next()).done) && (i.push(u.value), !(e && i.length === e)); s = !0)
        ;
    } catch (f) {
      c = !0, l = f;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (c) throw l;
      }
    }
    return i;
  }
}
function fet(t) {
  if (Array.isArray(t)) return t;
}
var det = function(t) {
  var e = t.charAt(0).toUpperCase() + t.slice(1);
  return "ease".concat(e);
}, get = 1e3, pet = function(t) {
  var e = t.duration, r = e === void 0 ? get : e, i = t.easing, s = i === void 0 ? "quadInOut" : i, c = t.delay, u = c === void 0 ? 0 : c, l = t.data, f = t.children, o = t.onEnd, g = Bt.useState({
    data: Array.isArray(l) ? l[0] : l,
    animationInfo: {
      progress: 0,
      animating: !1
    }
  }), p = oet(g, 2), n = p[0], a = p[1], d = Bt.useContext(jh).animationTimer, m = Bt.useRef(Array.isArray(l) ? l.slice(1) : []), b = Bt.useRef(null), w = Bt.useRef(void 0), v = $X[det(s)];
  Bt.useEffect(function() {
    return m.current.length && h(), function() {
      w.current ? d.unsubscribe(w.current) : d.stop();
    };
  }, []), Bt.useEffect(function() {
    b.current && n.animationInfo && n.animationInfo.progress < 1 ? a({
      data: b.current(1),
      animationInfo: {
        progress: 1,
        animating: !1,
        terminating: !0
      }
    }) : (d.unsubscribe(w.current), m.current = Array.isArray(l) ? l : [l], h());
  }, [l]);
  var h = function() {
    if (m.current.length) {
      var _ = m.current[0];
      b.current = Qtt(n.data, _), u ? setTimeout(function() {
        w.current = d.subscribe(x, r);
      }, u) : w.current = d.subscribe(x, r);
    } else o && o();
  }, x = function(_) {
    if (b.current) {
      var M = r ? _ / r : 1;
      if (M >= 1) {
        a({
          data: b.current(1),
          animationInfo: {
            progress: 1,
            animating: !1,
            terminating: !0
          }
        }), w.current && d.unsubscribe(w.current), m.current.shift(), h();
        return;
      }
      a({
        data: b.current(v(M)),
        animationInfo: {
          progress: M,
          animating: M < 1
        }
      });
    }
  };
  return f(n.data, n.animationInfo);
}, met = Pk, yet = 0;
function bet(t) {
  var e = ++yet;
  return met(t) + e;
}
var vet = bet;
const cO = /* @__PURE__ */ Dn(vet);
function wet(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
var xet = wet, Cet = xet, Ww = Math.max;
function Aet(t, e, r) {
  return e = Ww(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var i = arguments, s = -1, c = Ww(i.length - e, 0), u = Array(c); ++s < c; )
      u[s] = i[e + s];
    s = -1;
    for (var l = Array(e + 1); ++s < e; )
      l[s] = i[s];
    return l[e] = r(u), Cet(t, this, l);
  };
}
var uO = Aet;
function _et(t) {
  return function() {
    return t;
  };
}
var ket = _et, Oet = Ic, Tet = function() {
  try {
    var t = Oet(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), hO = Tet, Met = ket, Gw = hO, Eet = Nh, Pet = Gw ? function(t, e) {
  return Gw(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Met(e),
    writable: !0
  });
} : Eet, Iet = Pet, Fet = 800, Ret = 16, Det = Date.now;
function $et(t) {
  var e = 0, r = 0;
  return function() {
    var i = Det(), s = Ret - (i - r);
    if (r = i, s > 0) {
      if (++e >= Fet)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var Let = $et, Net = Iet, Bet = Let, jet = Bet(Net), fO = jet, Uet = Nh, Het = uO, Vet = fO;
function zet(t, e) {
  return Vet(Het(t, e, Uet), t + "");
}
var Xet = zet, qet = v0, Wet = C0, Get = fp, Ket = Es;
function Yet(t, e, r) {
  if (!Ket(r))
    return !1;
  var i = typeof e;
  return (i == "number" ? Wet(r) && Get(e, r.length) : i == "string" && e in r) ? qet(r[e], t) : !1;
}
var Zet = Yet;
function Jet(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var Qet = Jet, tnt = Es, ent = P7, nnt = Qet, rnt = Object.prototype, int = rnt.hasOwnProperty;
function ant(t) {
  if (!tnt(t))
    return nnt(t);
  var e = ent(t), r = [];
  for (var i in t)
    i == "constructor" && (e || !int.call(t, i)) || r.push(i);
  return r;
}
var snt = ant, ont = jk, lnt = snt, cnt = C0;
function unt(t) {
  return cnt(t) ? ont(t, !0) : lnt(t);
}
var dO = unt, hnt = Xet, fnt = v0, dnt = Zet, gnt = dO, gO = Object.prototype, pnt = gO.hasOwnProperty, mnt = hnt(function(t, e) {
  t = Object(t);
  var r = -1, i = e.length, s = i > 2 ? e[2] : void 0;
  for (s && dnt(e[0], e[1], s) && (i = 1); ++r < i; )
    for (var c = e[r], u = gnt(c), l = -1, f = u.length; ++l < f; ) {
      var o = u[l], g = t[o];
      (g === void 0 || fnt(g, gO[o]) && !pnt.call(t, o)) && (t[o] = c[o]);
    }
  return t;
}), ynt = mnt;
const Ie = /* @__PURE__ */ Dn(ynt);
function bnt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function vnt(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function wnt(t, e, r) {
  return e && vnt(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function xnt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && e9(t, e);
}
function e9(t, e) {
  return e9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, e9(t, e);
}
function Snt(t) {
  var e = _nt();
  return function() {
    var i = N2(t), s;
    if (e) {
      var c = N2(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return Cnt(this, s);
  };
}
function Cnt(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ant(t);
}
function Ant(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _nt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function N2(t) {
  return N2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, N2(t);
}
var pO = /* @__PURE__ */ function(t) {
  xnt(r, t);
  var e = Snt(r);
  function r(i) {
    var s;
    return bnt(this, r), s = e.call(this, i), s.map = void 0, s.index = void 0, s.portalRegister = function() {
      return ++s.index;
    }, s.portalUpdate = function(c, u) {
      s.map[c] = u, s.forceUpdate();
    }, s.portalDeregister = function(c) {
      delete s.map[c], s.forceUpdate();
    }, s.map = {}, s.index = 1, s;
  }
  return wnt(r, [{
    key: "getChildren",
    value: function() {
      var s = this;
      return Object.keys(this.map).map(function(c) {
        var u = s.map[c];
        return u && /* @__PURE__ */ Bt.cloneElement(u, {
          key: c
        });
      });
    }
    // Overridden in victory-core-native
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ Bt.createElement("svg", this.props, this.getChildren());
    }
  }]), r;
}(Bt.Component);
pO.displayName = "Portal";
var L7 = /* @__PURE__ */ Bt.createContext({});
L7.displayName = "PortalContext";
var Kw = hO;
function knt(t, e, r) {
  e == "__proto__" && Kw ? Kw(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var Ont = knt, Tnt = Ont, Mnt = v0, Ent = Object.prototype, Pnt = Ent.hasOwnProperty;
function Int(t, e, r) {
  var i = t[e];
  (!(Pnt.call(t, e) && Mnt(i, r)) || r === void 0 && !(e in t)) && Tnt(t, e, r);
}
var Fnt = Int, Rnt = Fnt, Dnt = cp, $nt = fp, Yw = Es, Lnt = Lh;
function Nnt(t, e, r, i) {
  if (!Yw(t))
    return t;
  e = Dnt(e, t);
  for (var s = -1, c = e.length, u = c - 1, l = t; l != null && ++s < c; ) {
    var f = Lnt(e[s]), o = r;
    if (f === "__proto__" || f === "constructor" || f === "prototype")
      return t;
    if (s != u) {
      var g = l[f];
      o = i ? i(g, f, l) : void 0, o === void 0 && (o = Yw(g) ? g : $nt(e[s + 1]) ? [] : {});
    }
    Rnt(l, f, o), l = l[f];
  }
  return t;
}
var Bnt = Nnt, jnt = up, Unt = Bnt, Hnt = cp;
function Vnt(t, e, r) {
  for (var i = -1, s = e.length, c = {}; ++i < s; ) {
    var u = e[i], l = jnt(t, u);
    r(l, u) && Unt(c, Hnt(u, t), l);
  }
  return c;
}
var mO = Vnt, znt = mO, Xnt = Kk;
function qnt(t, e) {
  return znt(t, e, function(r, i) {
    return Xnt(t, i);
  });
}
var Wnt = qnt, Zw = Dh, Gnt = hp, Knt = La, Jw = Zw ? Zw.isConcatSpreadable : void 0;
function Ynt(t) {
  return Knt(t) || Gnt(t) || !!(Jw && t && t[Jw]);
}
var Znt = Ynt, Jnt = k7, Qnt = Znt;
function yO(t, e, r, i, s) {
  var c = -1, u = t.length;
  for (r || (r = Qnt), s || (s = []); ++c < u; ) {
    var l = t[c];
    e > 0 && r(l) ? e > 1 ? yO(l, e - 1, r, i, s) : Jnt(s, l) : i || (s[s.length] = l);
  }
  return s;
}
var trt = yO, ert = trt;
function nrt(t) {
  var e = t == null ? 0 : t.length;
  return e ? ert(t, 1) : [];
}
var rrt = nrt, irt = rrt, art = uO, srt = fO;
function ort(t) {
  return srt(art(t, void 0, irt), t + "");
}
var lrt = ort, crt = Wnt, urt = lrt, hrt = urt(function(t, e) {
  return t == null ? {} : crt(t, e);
}), frt = hrt;
const lh = /* @__PURE__ */ Dn(frt);
function drt(t, e) {
  var r = e !== "x", i = Qa(t);
  return r ? [t.height - i.bottom, i.top] : [i.left, t.width - i.right];
}
function grt(t, e) {
  if (e === "x") {
    var r = jr(t.startAngle || 0), i = jr(t.endAngle || 360);
    return [r, i];
  }
  return [t.innerRadius || 0, yrt(t)];
}
function bO(t) {
  return Object.entries(t).reduce(function(e, r) {
    return e[r[1]] = r[0], e;
  }, {});
}
function yp(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = {};
  for (var i in t)
    e.indexOf(i) >= 0 || Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
  return r;
}
function N7(t) {
  var e = function(a) {
    return a !== void 0;
  }, r = t._x, i = t._x1, s = t._x0, c = t._voronoiX, u = t._y, l = t._y1, f = t._y0, o = t._voronoiY, g = e(i) ? i : r, p = e(l) ? l : u, n = {
    x: e(c) ? c : g,
    x0: e(s) ? s : r,
    y: e(o) ? o : p,
    y0: e(f) ? f : u
  };
  return Ie({}, n, t);
}
function Uh(t, e) {
  var r = t.scale, i = t.polar, s = t.horizontal, c = N7(e), u = t.origin || {
    x: 0,
    y: 0
  }, l = s ? r.y(c.y) : r.x(c.x), f = s ? r.y(c.y0) : r.x(c.x0), o = s ? r.x(c.x) : r.y(c.y), g = s ? r.x(c.x0) : r.y(c.y0);
  return {
    x: i ? o * Math.cos(l) + u.x : l,
    x0: i ? g * Math.cos(f) + u.x : f,
    y: i ? -o * Math.sin(l) + u.y : o,
    y0: i ? -g * Math.sin(f) + u.x : g
  };
}
function Qa(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "padding", r = t[e], i = typeof r == "number" ? r : 0, s = typeof r == "object" ? r : {};
  return {
    top: s.top || i,
    bottom: s.bottom || i,
    left: s.left || i,
    right: s.right || i
  };
}
function vO(t) {
  var e = t && t.type && t.type.role;
  return e === "tooltip";
}
function prt(t, e) {
  var r = t.theme, i = r === void 0 ? {} : r, s = t.labelComponent, c = i[e] && i[e].style || {};
  if (!vO(s))
    return c;
  var u = i.tooltip && i.tooltip.style || {}, l = Ie({}, u, c.labels);
  return Ie({}, {
    labels: l
  }, c);
}
function mrt(t, e) {
  var r = "100%", i = "100%";
  if (!t)
    return Ie({
      parent: {
        height: i,
        width: r
      }
    }, e);
  var s = t.data, c = t.labels, u = t.parent, l = e && e.parent || {}, f = e && e.labels || {}, o = e && e.data || {};
  return {
    parent: Ie({}, u, l, {
      width: r,
      height: i
    }),
    labels: Ie({}, c, f),
    data: Ie({}, s, o)
  };
}
function Te(t, e) {
  return Cn(t) ? t(e) : t;
}
function Fr(t, e) {
  return e.disableInlineStyles ? {} : !t || !Object.keys(t).some(function(r) {
    return Cn(t[r]);
  }) ? t : Object.keys(t).reduce(function(r, i) {
    return r[i] = Te(t[i], e), r;
  }, {});
}
function jr(t) {
  return typeof t == "number" ? t * (Math.PI / 180) : t;
}
function B7(t) {
  return typeof t == "number" ? t / (Math.PI / 180) : t;
}
function yrt(t) {
  var e = Qa(t), r = e.left, i = e.right, s = e.top, c = e.bottom, u = t.width, l = t.height;
  return Math.min(u - r - i, l - s - c) / 2;
}
function j7(t) {
  var e = t.width, r = t.height, i = Qa(t), s = i.top, c = i.bottom, u = i.left, l = i.right, f = Math.min(e - u - l, r - s - c) / 2, o = e / 2 + u - l, g = r / 2 + s - c;
  return {
    x: o + f > e ? f + u - l : o,
    y: g + f > r ? f + s - c : g
  };
}
function $a(t, e) {
  return t.range && t.range[e] ? t.range[e] : t.range && Array.isArray(t.range) ? t.range : t.polar ? grt(t, e) : drt(t, e);
}
function ch(t) {
  return t == null;
}
function Cn(t) {
  return typeof t == "function";
}
function U7(t) {
  return Cn(t) ? t : t == null ? function(e) {
    return e;
  } : Zk(t);
}
function qo(t, e, r) {
  var i = t.theme && t.theme[r] ? t.theme[r] : {}, s = yp(i, ["style"]), c = vrt(t), u = c === void 0 ? {} : {
    horizontal: c
  };
  return Ie(u, t, s, e);
}
function brt(t, e) {
  var r = t === "x" ? "y" : "x";
  return e ? r : t;
}
function wO(t, e, r) {
  var i = e ? t : 0, s = e || t;
  s || (s = 0);
  var c = s - i, u = Math.abs(c), l = c / u || 1, f = r || 1, o = Math.max(Math.ceil(u / f), 0);
  return Array.from(Array(o), function(g, p) {
    return i + p * l * f;
  });
}
function k0(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function(o, g) {
    return (
      // @ts-expect-error These defaults are hard to type
      o.concat(g)
    );
  }, c = ["data", "domain", "categories", "polar", "startAngle", "endAngle", "minDomain", "maxDomain", "horizontal"], u = function(o, g, p) {
    return o.reduce(function(n, a, d) {
      var m = n, b = a.type && a.type.role, w = a.props.name || "".concat(b, "-").concat(g[d]);
      if (a.props && a.props.children) {
        var v = Object.assign({}, a.props, lh(r, c)), h = a.type && a.type.role === "stack" && Cn(a.type.getChildren) ? a.type.getChildren(v) : Bt.Children.toArray(a.props.children).map(function(O) {
          var E = Object.assign({}, O.props, lh(v, c));
          return /* @__PURE__ */ Bt.cloneElement(O, E);
        }), x = h.map(function(O, E) {
          return "".concat(w, "-").concat(E);
        }), _ = u(h, x, a);
        m = s(m, _);
      } else {
        var M = e(a, w, p);
        M && (m = s(m, M));
      }
      return m;
    }, i);
  }, l = t.filter(fA), f = l.map(function(o, g) {
    return g;
  });
  return u(l, f);
}
function vrt(t) {
  if (t.horizontal !== void 0 || !t.children)
    return t.horizontal;
  var e = function(r) {
    return r.reduce(function(i, s) {
      var c = s.props || {};
      return i || c.horizontal || !c.children ? i || c.horizontal : e(Bt.Children.toArray(c.children));
    }, !1);
  };
  return e(Bt.Children.toArray(t.children));
}
function Qw(t, e) {
  return Crt(t) || Srt(t, e) || xrt(t, e) || wrt();
}
function wrt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xrt(t, e) {
  if (t) {
    if (typeof t == "string") return tx(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return tx(t, e);
  }
}
function tx(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function Srt(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var i = [], s = !0, c = !1, u, l;
    try {
      for (r = r.call(t); !(s = (u = r.next()).done) && (i.push(u.value), !(e && i.length === e)); s = !0)
        ;
    } catch (f) {
      c = !0, l = f;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (c) throw l;
      }
    }
    return i;
  }
}
function Crt(t) {
  if (Array.isArray(t)) return t;
}
function ex(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function Art(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ex(Object(r), !0).forEach(function(i) {
      _rt(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ex(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function _rt(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var xO = {
  startsWith: ["data-", "aria-"],
  exactMatch: []
}, krt = function(t) {
  var e = !1;
  return xO.startsWith.forEach(function(r) {
    var i = new RegExp("\\b(".concat(r, ")(\\w|-)+"), "g");
    i.test(t) && (e = !0);
  }), e;
}, Ort = function(t) {
  return xO.exactMatch.includes(t);
}, Trt = function(t) {
  return !!(krt(t) || Ort(t));
};
function od(t, e) {
  if (t == null)
    throw new Error(e);
}
var O0 = function(t) {
  var e = Art({}, t);
  return Object.fromEntries(Object.entries(e).filter(function(r) {
    var i = Qw(r, 1), s = i[0];
    return Trt(s);
  }).map(function(r) {
    var i = Qw(r, 2), s = i[0], c = i[1];
    return [s, Te(c, t)];
  }));
}, Mrt = function(t, e) {
  return /* @__PURE__ */ pt.cloneElement(t, O0(e));
};
function B2() {
  return B2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, B2.apply(this, arguments);
}
function nx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function fu(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? nx(Object(r), !0).forEach(function(i) {
      Ert(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : nx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function Ert(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Prt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Irt(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Frt(t, e, r) {
  return e && Irt(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Rrt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && n9(t, e);
}
function n9(t, e) {
  return n9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, n9(t, e);
}
function Drt(t) {
  var e = Nrt();
  return function() {
    var i = j2(t), s;
    if (e) {
      var c = j2(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return $rt(this, s);
  };
}
function $rt(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lrt(t);
}
function Lrt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Nrt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function j2(t) {
  return j2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, j2(t);
}
var Is = /* @__PURE__ */ function(t) {
  Rrt(r, t);
  var e = Drt(r);
  function r(i) {
    var s;
    return Prt(this, r), s = e.call(this, i), s.containerId = void 0, s.portalRef = void 0, s.containerRef = void 0, s.shouldHandleWheel = void 0, s.savePortalRef = function(c) {
      return s.portalRef = c, c;
    }, s.portalUpdate = function(c, u) {
      return s.portalRef.portalUpdate(c, u);
    }, s.portalRegister = function() {
      return s.portalRef.portalRegister();
    }, s.portalDeregister = function(c) {
      return s.portalRef.portalDeregister(c);
    }, s.saveContainerRef = function(c) {
      return Cn(s.props.containerRef) && s.props.containerRef(c), s.containerRef = c, c;
    }, s.handleWheel = function(c) {
      return c.preventDefault();
    }, s.containerId = !O2(i) || i.containerId === void 0 ? cO("victory-container-") : i.containerId, s.shouldHandleWheel = !!(i && i.events && i.events.onWheel), s;
  }
  return Frt(r, [{
    key: "componentDidMount",
    value: function() {
      this.shouldHandleWheel && this.containerRef && this.containerRef.addEventListener("wheel", this.handleWheel);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.shouldHandleWheel && this.containerRef && this.containerRef.removeEventListener("wheel", this.handleWheel);
    }
  }, {
    key: "getIdForElement",
    value: function(s) {
      return "".concat(this.containerId, "-").concat(s);
    }
    // overridden in custom containers
  }, {
    key: "getChildren",
    value: function(s) {
      return s.children;
    }
    // Get props defined by the Open UI Automation (OUIA) 1.0-RC spec
    // See https://ouia.readthedocs.io/en/latest/README.html#ouia-component
  }, {
    key: "getOUIAProps",
    value: function(s) {
      var c = s.ouiaId, u = s.ouiaSafe, l = s.ouiaType;
      return fu(fu(fu({}, c && {
        "data-ouia-component-id": c
      }), l && {
        "data-ouia-component-type": l
      }), u !== void 0 && {
        "data-ouia-safe": u
      });
    }
  }, {
    key: "renderContainer",
    value: function(s, c, u) {
      var l = s.title, f = s.desc, o = s.portalComponent, g = s.className, p = s.width, n = s.height, a = s.portalZIndex, d = s.responsive, m = this.getChildren(s), b = d ? {
        width: "100%",
        height: "100%"
      } : {
        width: p,
        height: n
      }, w = Object.assign({
        pointerEvents: "none",
        touchAction: "none",
        position: "relative"
      }, b), v = Object.assign({
        zIndex: a,
        position: "absolute",
        top: 0,
        left: 0
      }, b), h = Object.assign({
        pointerEvents: "all"
      }, b), x = Object.assign({
        overflow: "visible"
      }, b), _ = {
        width: p,
        height: n,
        viewBox: c.viewBox,
        preserveAspectRatio: c.preserveAspectRatio,
        style: x
      };
      return /* @__PURE__ */ Bt.createElement(L7.Provider, {
        value: {
          portalUpdate: this.portalUpdate,
          portalRegister: this.portalRegister,
          portalDeregister: this.portalDeregister
        }
      }, /* @__PURE__ */ Bt.createElement("div", B2({
        style: Ie({}, u, w),
        className: g,
        ref: this.saveContainerRef
      }, this.getOUIAProps(s)), /* @__PURE__ */ Bt.createElement("svg", B2({}, c, {
        style: h
      }), l ? /* @__PURE__ */ Bt.createElement("title", {
        id: this.getIdForElement("title")
      }, l) : null, f ? /* @__PURE__ */ Bt.createElement("desc", {
        id: this.getIdForElement("desc")
      }, f) : null, m), /* @__PURE__ */ Bt.createElement("div", {
        style: v
      }, /* @__PURE__ */ Bt.cloneElement(o, fu(fu({}, _), {}, {
        ref: this.savePortalRef
      })))));
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, c = s.width, u = s.height, l = s.responsive, f = s.events, o = s.title, g = s.desc, p = s.tabIndex, n = s.preserveAspectRatio, a = s.role, d = l ? this.props.style : yp(this.props.style, ["height", "width"]), m = O0(this.props), b = Object.assign(fu({
        width: c,
        height: u,
        tabIndex: p,
        role: a,
        "aria-labelledby": [o && this.getIdForElement("title"), this.props["aria-labelledby"]].filter(Boolean).join(" ") || void 0,
        "aria-describedby": [g && this.getIdForElement("desc"), this.props["aria-describedby"]].filter(Boolean).join(" ") || void 0,
        viewBox: l ? "0 0 ".concat(c, " ").concat(u) : void 0,
        preserveAspectRatio: l ? n : void 0
      }, m), f);
      return this.renderContainer(this.props, b, d);
    }
  }]), r;
}(Bt.Component);
Is.displayName = "VictoryContainer";
Is.role = "container";
Is.defaultProps = {
  className: "VictoryContainer",
  portalComponent: /* @__PURE__ */ Bt.createElement(pO, null),
  portalZIndex: 99,
  responsive: !0,
  role: "img"
};
Is.contextType = jh;
var Brt = Hk, jrt = Xk, Urt = hp, Hrt = La, Vrt = C0, zrt = O7, Xrt = P7, qrt = E7, Wrt = "[object Map]", Grt = "[object Set]", Krt = Object.prototype, Yrt = Krt.hasOwnProperty;
function Zrt(t) {
  if (t == null)
    return !0;
  if (Vrt(t) && (Hrt(t) || typeof t == "string" || typeof t.splice == "function" || zrt(t) || qrt(t) || Urt(t)))
    return !t.length;
  var e = jrt(t);
  if (e == Wrt || e == Grt)
    return !t.size;
  if (Xrt(t))
    return !Brt(t).length;
  for (var r in t)
    if (Yrt.call(t, r))
      return !1;
  return !0;
}
var Jrt = Zrt;
const ar = /* @__PURE__ */ Dn(Jrt);
function SO(t) {
  process.env.NODE_ENV !== "production" && console && console.warn && console.warn(t);
}
function Qrt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tit(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function eit(t, e, r) {
  return e && tit(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function nit(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && r9(t, e);
}
function r9(t, e) {
  return r9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, r9(t, e);
}
function rit(t) {
  var e = sit();
  return function() {
    var i = U2(t), s;
    if (e) {
      var c = U2(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return iit(this, s);
  };
}
function iit(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ait(t);
}
function ait(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function sit() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function U2(t) {
  return U2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, U2(t);
}
var sl = /* @__PURE__ */ function(t) {
  nit(r, t);
  var e = rit(r);
  function r() {
    var i;
    Qrt(this, r);
    for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
      c[u] = arguments[u];
    return i = e.call.apply(e, [this].concat(c)), i.checkedContext = void 0, i.portalKey = void 0, i.renderInPlace = void 0, i.element = void 0, i;
  }
  return eit(r, [{
    key: "componentDidMount",
    value: function() {
      if (!this.checkedContext) {
        if (typeof this.context.portalUpdate != "function") {
          var s = "`renderInPortal` is not supported outside of `VictoryContainer`. Component will be rendered in place";
          SO(s), this.renderInPlace = !0;
        }
        this.checkedContext = !0;
      }
      this.forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.renderInPlace || (this.portalKey = this.portalKey || this.context.portalRegister(), this.context.portalUpdate(this.portalKey, this.element));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.context && this.context.portalDeregister && this.context.portalDeregister(this.portalKey);
    }
    // Overridden in victory-core-native
  }, {
    key: "renderPortal",
    value: function(s) {
      return this.renderInPlace ? s : (this.element = s, null);
    }
  }, {
    key: "render",
    value: function() {
      var s = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children, c = this.props.groupComponent, u = s && s.props || {}, l = u.groupComponent ? {
        groupComponent: c,
        standalone: !1
      } : {}, f = Ie(l, u, yp(this.props, ["children", "groupComponent"])), o = s && /* @__PURE__ */ Bt.cloneElement(s, f);
      return this.renderPortal(o);
    }
  }]), r;
}(Bt.Component);
sl.displayName = "VictoryPortal";
sl.role = "portal";
sl.defaultProps = {
  groupComponent: /* @__PURE__ */ Bt.createElement("g", null)
};
sl.contextType = L7;
var oit = ["desc", "id", "tabIndex", "origin"];
function H2() {
  return H2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, H2.apply(this, arguments);
}
function rx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function lit(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rx(Object(r), !0).forEach(function(i) {
      cit(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : rx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function cit(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function uit(t, e) {
  if (t == null) return {};
  var r = hit(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function hit(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
var CO = /* @__PURE__ */ kn(function(t, e) {
  var r, i = t.desc, s = t.id, c = t.tabIndex;
  t.origin;
  var u = uit(t, oit), l = lit({
    vectorEffect: "non-scaling-stroke",
    id: (r = Te(s, t)) === null || r === void 0 ? void 0 : r.toString(),
    tabIndex: Te(c, t)
  }, u);
  return i ? /* @__PURE__ */ Bt.createElement("rect", H2({}, l, {
    ref: e
  }), /* @__PURE__ */ Bt.createElement("desc", null, i)) : /* @__PURE__ */ Bt.createElement("rect", H2({}, l, {
    ref: e
  }));
}), fit = ["children", "desc", "id", "origin", "tabIndex", "title"];
function ix(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function dit(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ix(Object(r), !0).forEach(function(i) {
      git(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ix(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function git(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function pit(t, e) {
  if (t == null) return {};
  var r = mit(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function mit(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
var yit = function(t) {
  var e, r = t.children, i = t.desc, s = t.id;
  t.origin;
  var c = t.tabIndex, u = t.title, l = pit(t, fit), f = dit({
    id: (e = Te(s, t)) === null || e === void 0 ? void 0 : e.toString(),
    tabIndex: Te(c, t)
  }, l);
  return /* @__PURE__ */ Bt.createElement("text", f, u && /* @__PURE__ */ Bt.createElement("title", null, u), i && /* @__PURE__ */ Bt.createElement("desc", null, i), r);
}, bit = ["desc", "id", "tabIndex", "origin"];
function ax(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function vit(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ax(Object(r), !0).forEach(function(i) {
      wit(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ax(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function wit(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function xit(t, e) {
  if (t == null) return {};
  var r = Sit(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function Sit(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
var Cit = function(t) {
  var e;
  t.desc;
  var r = t.id, i = t.tabIndex;
  t.origin;
  var s = xit(t, bit), c = vit({
    id: (e = Te(r, t)) === null || e === void 0 ? void 0 : e.toString(),
    tabIndex: Te(i, t)
  }, s);
  return /* @__PURE__ */ Bt.createElement("tspan", c);
};
function Ait(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e._y >= 0 ? 1 : -1, i = t.style && t.style.labels || {};
  return e.verticalAnchor || i.verticalAnchor ? e.verticalAnchor || i.verticalAnchor : t.horizontal ? "middle" : r >= 0 ? "end" : "start";
}
function _it(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.style, i = t.horizontal, s = e._y >= 0 ? 1 : -1, c = r && r.labels || {};
  return e.verticalAnchor || c.verticalAnchor ? e.verticalAnchor || c.verticalAnchor : i ? s >= 0 ? "start" : "end" : "middle";
}
function kit(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.style && t.style.labels || {};
  return e.angle === void 0 ? r.angle : e.angle;
}
function Oit(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.horizontal, i = t.style, s = i.labels || {}, c = Te(s.padding, t) || 0, u = e._y < 0 ? -1 : 1;
  return {
    x: r ? u * c : 0,
    y: r ? 0 : -1 * u * c
  };
}
function Tit(t, e) {
  if (t.polar)
    return {};
  var r = Oit(t, e);
  return {
    dx: r.x,
    dy: r.y
  };
}
function Mit(t, e) {
  var r = t.polar, i = Uh(t, e), s = i.x, c = i.y;
  if (!r)
    return {
      x: s,
      y: c
    };
  var u = Eit(t, e);
  return {
    x: s + u.x,
    y: c + u.y
  };
}
function Eit(t, e) {
  var r = t.style, i = uh(t, e), s = r.labels || {}, c = Te(s.padding, t) || 0, u = jr(i);
  return {
    x: c * Math.cos(u),
    y: -c * Math.sin(u)
  };
}
function H7(t) {
  var e = t.labelComponent, r = t.labelPlacement, i = t.polar, s = i ? "perpendicular" : "vertical";
  return r || e.props && e.props.labelPlacement || s;
}
function Pit(t) {
  return t < 45 || t > 315 ? "right" : t >= 45 && t <= 135 ? "top" : t > 135 && t < 225 ? "left" : "bottom";
}
function AO(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
  return e.label !== void 0 ? e.label : Array.isArray(t.labels) ? t.labels[r] : t.labels;
}
function V7(t, e) {
  var r = H7(t);
  return r === "perpendicular" || r === "vertical" && (e === 90 || e === 270) ? "middle" : e <= 90 || e > 270 ? "start" : "end";
}
function _O(t, e) {
  var r = H7(t), i = Pit(e);
  return r === "parallel" || i === "left" || i === "right" ? "middle" : i === "top" ? "end" : "start";
}
function z7(t, e) {
  var r = t.labelPlacement, i = t.datum;
  if (!r || r === "vertical")
    return 0;
  var s = e !== void 0 ? e % 360 : uh(t, i), c = s > 90 && s < 180 || s > 270 ? 1 : -1, u = 0;
  s === 0 || s === 180 ? u = 90 : s > 0 && s < 180 ? u = 90 - s : s > 180 && s < 360 && (u = 270 - s);
  var l = r === "perpendicular" ? 0 : 90;
  return u + c * l;
}
function uh(t, e) {
  var r = N7(e), i = r.x;
  return B7(t.scale.x(i)) % 360;
}
function Iit(t, e) {
  var r = t.scale, i = t.data, s = t.style, c = t.horizontal, u = t.polar, l = t.width, f = t.height, o = t.theme, g = t.labelComponent, p = t.disableInlineStyles, n = i[e], a = uh(t, n), d = u ? V7(t, a) : _it(t, n), m = u ? _O(t, a) : Ait(t, n), b = kit(t, n), w = AO(t, n, e), v = H7(t), h = Mit(t, n), x = h.x, _ = h.y, M = Tit(t, n), O = M.dx, E = M.dy, I = {
    angle: b,
    data: i,
    datum: n,
    disableInlineStyles: p,
    horizontal: c,
    index: e,
    polar: u,
    scale: r,
    labelPlacement: v,
    text: w,
    textAnchor: d,
    verticalAnchor: m,
    x,
    y: _,
    dx: O,
    dy: E,
    width: l,
    height: f,
    style: s.labels
  };
  if (!vO(g))
    return I;
  var R = o && o.tooltip || {};
  return Ie({}, I, yp(R, ["style"]));
}
var i9 = function(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
    r[i - 1] = arguments[i];
  if (r.length > 0)
    return r.reduce(function(l, f) {
      return [l, i9(f)].join(" ");
    }, i9(t)).trim();
  if (t == null || typeof t == "string")
    return t;
  var s = [];
  for (var c in t)
    if (t.hasOwnProperty(c)) {
      var u = t[c];
      s.push("".concat(c, "(").concat(u, ")"));
    }
  return s.join(" ").trim();
};
function Fit(t, e) {
  return $it(t) || Dit(t, e) || kO(t, e) || Rit();
}
function Rit() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dit(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var i = [], s = !0, c = !1, u, l;
    try {
      for (r = r.call(t); !(s = (u = r.next()).done) && (i.push(u.value), !(e && i.length === e)); s = !0)
        ;
    } catch (f) {
      c = !0, l = f;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (c) throw l;
      }
    }
    return i;
  }
}
function $it(t) {
  if (Array.isArray(t)) return t;
}
function Lit(t) {
  return jit(t) || Bit(t) || kO(t) || Nit();
}
function Nit() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kO(t, e) {
  if (t) {
    if (typeof t == "string") return a9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return a9(t, e);
  }
}
function Bit(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function jit(t) {
  if (Array.isArray(t)) return a9(t);
}
function a9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
var sx = {
  "American Typewriter": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.4203125, 0.3296875, 0.6, 0.6375, 0.8015625, 0.8203125, 0.1875, 0.45625, 0.45625, 0.6375, 0.5, 0.2734375, 0.309375, 0.2734375, 0.4390625, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.2734375, 0.2734375, 0.5, 0.5, 0.5, 0.6, 0.6921875, 0.7640625, 0.6921875, 0.6375, 0.728125, 0.6734375, 0.6203125, 0.7109375, 0.784375, 0.3828125, 0.6421875, 0.7859375, 0.6375, 0.9484375, 0.7640625, 0.65625, 0.6375, 0.65625, 0.7296875, 0.6203125, 0.6375, 0.7109375, 0.740625, 0.940625, 0.784375, 0.7578125, 0.6203125, 0.4375, 0.5, 0.4375, 0.5, 0.5, 0.4921875, 0.5734375, 0.5890625, 0.5109375, 0.6, 0.528125, 0.43125, 0.5578125, 0.6375, 0.3109375, 0.40625, 0.6234375, 0.309375, 0.928125, 0.6375, 0.546875, 0.6, 0.58125, 0.4921875, 0.4921875, 0.4, 0.6203125, 0.625, 0.825, 0.6375, 0.640625, 0.528125, 0.5, 0.5, 0.5, 0.6671875],
    avg: 0.5793421052631578
  },
  Arial: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.278125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.584375, 0.584375, 0.584375, 0.55625, 1.015625, 0.6703125, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.278125, 0.278125, 0.4703125, 0.584375, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.3125, 0.55625, 0.55625, 0.2234375, 0.2703125, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.346875, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.528733552631579
  },
  "Arial Black": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33125, 0.334375, 0.5, 0.6609375, 0.6671875, 1, 0.890625, 0.278125, 0.390625, 0.390625, 0.55625, 0.6609375, 0.334375, 0.334375, 0.334375, 0.28125, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.334375, 0.6609375, 0.6609375, 0.6609375, 0.6109375, 0.7453125, 0.78125, 0.778125, 0.778125, 0.778125, 0.7234375, 0.6671875, 0.834375, 0.834375, 0.390625, 0.6671875, 0.834375, 0.6671875, 0.9453125, 0.834375, 0.834375, 0.7234375, 0.834375, 0.78125, 0.7234375, 0.7234375, 0.834375, 0.7796875, 1.003125, 0.78125, 0.78125, 0.7234375, 0.390625, 0.28125, 0.390625, 0.6609375, 0.5125, 0.334375, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.41875, 0.6671875, 0.6671875, 0.334375, 0.384375, 0.6671875, 0.334375, 1, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.4703125, 0.6109375, 0.4453125, 0.6671875, 0.6140625, 0.946875, 0.6671875, 0.615625, 0.55625, 0.390625, 0.278125, 0.390625, 0.6609375],
    avg: 0.6213157894736842
  },
  Baskerville: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.25, 0.40625, 0.6671875, 0.490625, 0.875, 0.7015625, 0.178125, 0.2453125, 0.246875, 0.4171875, 0.6671875, 0.25, 0.3125, 0.25, 0.521875, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.6671875, 0.6671875, 0.6671875, 0.396875, 0.9171875, 0.684375, 0.615625, 0.71875, 0.7609375, 0.625, 0.553125, 0.771875, 0.803125, 0.3546875, 0.515625, 0.78125, 0.6046875, 0.928125, 0.75, 0.8234375, 0.5625, 0.96875, 0.7296875, 0.5421875, 0.6984375, 0.771875, 0.7296875, 0.9484375, 0.771875, 0.678125, 0.6359375, 0.3640625, 0.521875, 0.3640625, 0.46875, 0.5125, 0.334375, 0.46875, 0.521875, 0.428125, 0.521875, 0.4375, 0.3890625, 0.4765625, 0.53125, 0.25, 0.359375, 0.4640625, 0.240625, 0.803125, 0.53125, 0.5, 0.521875, 0.521875, 0.365625, 0.334375, 0.2921875, 0.521875, 0.4640625, 0.678125, 0.4796875, 0.465625, 0.428125, 0.4796875, 0.5109375, 0.4796875, 0.6671875],
    avg: 0.5323519736842108
  },
  Courier: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  "Courier New": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6015296052631579
  },
  cursive: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1921875, 0.24375, 0.40625, 0.5671875, 0.3984375, 0.721875, 0.909375, 0.2328125, 0.434375, 0.365625, 0.4734375, 0.5578125, 0.19375, 0.3484375, 0.19375, 0.7734375, 0.503125, 0.4171875, 0.5453125, 0.45, 0.6046875, 0.4703125, 0.5984375, 0.55625, 0.503125, 0.5546875, 0.20625, 0.2, 0.5625, 0.5546875, 0.546875, 0.403125, 0.70625, 0.734375, 0.7078125, 0.64375, 0.85, 0.753125, 0.75, 0.6484375, 1.0765625, 0.44375, 0.5359375, 0.8359375, 0.653125, 1.0109375, 1.1515625, 0.6796875, 0.6984375, 1.0625, 0.8234375, 0.5125, 0.9234375, 0.8546875, 0.70625, 0.9109375, 0.7421875, 0.715625, 0.6015625, 0.4640625, 0.3359375, 0.4109375, 0.5421875, 0.5421875, 0.4328125, 0.5125, 0.5, 0.3859375, 0.7375, 0.359375, 0.75625, 0.540625, 0.5328125, 0.3203125, 0.5296875, 0.5015625, 0.484375, 0.7890625, 0.5640625, 0.4203125, 0.703125, 0.471875, 0.4734375, 0.35, 0.4125, 0.5640625, 0.471875, 0.6484375, 0.5296875, 0.575, 0.4140625, 0.415625, 0.20625, 0.3796875, 0.5421875],
    avg: 0.5604440789473684
  },
  fantasy: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.2625, 0.3265625, 0.6109375, 0.534375, 0.7625, 0.7828125, 0.2, 0.4359375, 0.4359375, 0.3765625, 0.5109375, 0.2796875, 0.4609375, 0.2796875, 0.5296875, 0.6640625, 0.253125, 0.521875, 0.4765625, 0.6640625, 0.490625, 0.528125, 0.5546875, 0.496875, 0.5421875, 0.2796875, 0.2796875, 0.5625, 0.4609375, 0.5625, 0.4828125, 0.609375, 0.740625, 0.7234375, 0.740625, 0.8265625, 0.7234375, 0.6171875, 0.7359375, 0.765625, 0.240625, 0.5453125, 0.715625, 0.6078125, 0.8640625, 0.653125, 0.9125, 0.6484375, 0.946875, 0.6921875, 0.653125, 0.6953125, 0.8015625, 0.58125, 0.784375, 0.671875, 0.6265625, 0.690625, 0.4359375, 0.5296875, 0.4359375, 0.53125, 0.5, 0.2875, 0.5375, 0.603125, 0.4984375, 0.60625, 0.53125, 0.434375, 0.6421875, 0.56875, 0.209375, 0.4671875, 0.5484375, 0.2203125, 0.709375, 0.55, 0.5984375, 0.6140625, 0.5765625, 0.40625, 0.4734375, 0.3734375, 0.559375, 0.4421875, 0.6421875, 0.4890625, 0.578125, 0.4484375, 0.2546875, 0.2203125, 0.2546875, 0.55],
    avg: 0.536496710526316
  },
  Geneva: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3328125, 0.3046875, 0.5, 0.6671875, 0.6671875, 0.90625, 0.728125, 0.3046875, 0.446875, 0.446875, 0.5078125, 0.6671875, 0.3046875, 0.3796875, 0.3046875, 0.5390625, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.3046875, 0.3046875, 0.6671875, 0.6671875, 0.6671875, 0.56875, 0.871875, 0.728125, 0.6375, 0.6515625, 0.7015625, 0.5765625, 0.5546875, 0.675, 0.690625, 0.2421875, 0.4921875, 0.6640625, 0.584375, 0.7890625, 0.709375, 0.7359375, 0.584375, 0.78125, 0.60625, 0.60625, 0.640625, 0.6671875, 0.728125, 0.946875, 0.6109375, 0.6109375, 0.5765625, 0.446875, 0.5390625, 0.446875, 0.6671875, 0.6671875, 0.5921875, 0.5546875, 0.6109375, 0.546875, 0.603125, 0.5765625, 0.390625, 0.6109375, 0.584375, 0.2359375, 0.334375, 0.5390625, 0.2359375, 0.8953125, 0.584375, 0.60625, 0.603125, 0.603125, 0.3875, 0.509375, 0.44375, 0.584375, 0.565625, 0.78125, 0.53125, 0.571875, 0.5546875, 0.4515625, 0.246875, 0.4515625, 0.6671875],
    avg: 0.5762664473684211
  },
  Georgia: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2421875, 0.33125, 0.4125, 0.64375, 0.6109375, 0.81875, 0.7109375, 0.215625, 0.375, 0.375, 0.4734375, 0.64375, 0.2703125, 0.375, 0.2703125, 0.46875, 0.6140625, 0.4296875, 0.559375, 0.553125, 0.565625, 0.5296875, 0.5671875, 0.503125, 0.596875, 0.5671875, 0.3125, 0.3125, 0.64375, 0.64375, 0.64375, 0.4796875, 0.9296875, 0.715625, 0.6546875, 0.6421875, 0.75, 0.6546875, 0.6, 0.7265625, 0.815625, 0.390625, 0.51875, 0.7203125, 0.6046875, 0.928125, 0.7671875, 0.7453125, 0.6109375, 0.7453125, 0.7234375, 0.5625, 0.61875, 0.7578125, 0.70625, 0.99375, 0.7125, 0.6640625, 0.6015625, 0.375, 0.46875, 0.375, 0.64375, 0.65, 0.5, 0.5046875, 0.56875, 0.4546875, 0.575, 0.484375, 0.39375, 0.509375, 0.5828125, 0.29375, 0.3671875, 0.546875, 0.2875, 0.88125, 0.5921875, 0.5390625, 0.571875, 0.5640625, 0.4109375, 0.4328125, 0.3453125, 0.5765625, 0.5203125, 0.75625, 0.50625, 0.5171875, 0.4453125, 0.43125, 0.375, 0.43125, 0.64375],
    avg: 0.5551809210526316
  },
  "Gill Sans": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2765625, 0.271875, 0.3546875, 0.584375, 0.5421875, 0.6765625, 0.625, 0.1890625, 0.3234375, 0.3234375, 0.4171875, 0.584375, 0.2203125, 0.3234375, 0.2203125, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.2203125, 0.2296875, 0.584375, 0.584375, 0.584375, 0.334375, 1.0109375, 0.6671875, 0.5640625, 0.709375, 0.75, 0.5, 0.4703125, 0.740625, 0.7296875, 0.25, 0.3125, 0.65625, 0.490625, 0.78125, 0.78125, 0.8234375, 0.5109375, 0.8234375, 0.6046875, 0.459375, 0.6046875, 0.709375, 0.6046875, 1.0421875, 0.709375, 0.6046875, 0.646875, 0.334375, 0.28125, 0.334375, 0.4703125, 0.5828125, 0.334375, 0.428125, 0.5, 0.4390625, 0.5109375, 0.4796875, 0.296875, 0.428125, 0.5, 0.2203125, 0.2265625, 0.5, 0.2203125, 0.771875, 0.5, 0.553125, 0.5, 0.5, 0.3984375, 0.3859375, 0.334375, 0.5, 0.4390625, 0.7203125, 0.5, 0.4390625, 0.4171875, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.4933717105263159
  },
  Helvetica: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2765625, 0.3546875, 0.5546875, 0.5546875, 0.8890625, 0.665625, 0.190625, 0.3328125, 0.3328125, 0.3890625, 0.5828125, 0.2765625, 0.3328125, 0.2765625, 0.3015625, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.2765625, 0.2765625, 0.584375, 0.5828125, 0.584375, 0.5546875, 1.0140625, 0.665625, 0.665625, 0.721875, 0.721875, 0.665625, 0.609375, 0.7765625, 0.721875, 0.2765625, 0.5, 0.665625, 0.5546875, 0.8328125, 0.721875, 0.7765625, 0.665625, 0.7765625, 0.721875, 0.665625, 0.609375, 0.721875, 0.665625, 0.94375, 0.665625, 0.665625, 0.609375, 0.2765625, 0.3546875, 0.2765625, 0.4765625, 0.5546875, 0.3328125, 0.5546875, 0.5546875, 0.5, 0.5546875, 0.5546875, 0.2765625, 0.5546875, 0.5546875, 0.221875, 0.240625, 0.5, 0.221875, 0.8328125, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.3328125, 0.5, 0.2765625, 0.5546875, 0.5, 0.721875, 0.5, 0.5, 0.5, 0.3546875, 0.259375, 0.353125, 0.5890625],
    avg: 0.5279276315789471
  },
  "Helvetica Neue": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.259375, 0.4265625, 0.55625, 0.55625, 1, 0.6453125, 0.278125, 0.2703125, 0.26875, 0.353125, 0.6, 0.278125, 0.3890625, 0.278125, 0.36875, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.6, 0.6, 0.6, 0.55625, 0.8, 0.6625, 0.6859375, 0.7234375, 0.7046875, 0.6125, 0.575, 0.759375, 0.7234375, 0.259375, 0.5203125, 0.6703125, 0.55625, 0.871875, 0.7234375, 0.7609375, 0.6484375, 0.7609375, 0.6859375, 0.6484375, 0.575, 0.7234375, 0.6140625, 0.9265625, 0.6125, 0.6484375, 0.6125, 0.259375, 0.36875, 0.259375, 0.6, 0.5, 0.25625, 0.5375, 0.59375, 0.5375, 0.59375, 0.5375, 0.2984375, 0.575, 0.55625, 0.2234375, 0.2375, 0.5203125, 0.2234375, 0.853125, 0.55625, 0.575, 0.59375, 0.59375, 0.334375, 0.5, 0.315625, 0.55625, 0.5, 0.759375, 0.51875, 0.5, 0.48125, 0.334375, 0.2234375, 0.334375, 0.6],
    avg: 0.5279440789473684
  },
  "Hoefler Text": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2359375, 0.2234375, 0.3921875, 0.7125, 0.49375, 0.8859375, 0.771875, 0.2125, 0.3078125, 0.309375, 0.375, 0.4234375, 0.234375, 0.3125, 0.234375, 0.3, 0.5828125, 0.365625, 0.434375, 0.3921875, 0.5234375, 0.3984375, 0.5125, 0.4328125, 0.46875, 0.5125, 0.234375, 0.234375, 0.515625, 0.4234375, 0.515625, 0.340625, 0.7609375, 0.7359375, 0.6359375, 0.721875, 0.8125, 0.6375, 0.5875, 0.8078125, 0.853125, 0.4296875, 0.503125, 0.78125, 0.609375, 0.9609375, 0.8515625, 0.8140625, 0.6125, 0.8140625, 0.71875, 0.49375, 0.7125, 0.76875, 0.771875, 1.125, 0.7765625, 0.7734375, 0.65625, 0.321875, 0.3078125, 0.321875, 0.3546875, 0.5, 0.3375, 0.446875, 0.5359375, 0.45, 0.5296875, 0.4546875, 0.425, 0.4921875, 0.54375, 0.2671875, 0.240625, 0.5390625, 0.25, 0.815625, 0.5375, 0.5234375, 0.5390625, 0.5421875, 0.365625, 0.36875, 0.35625, 0.5171875, 0.5015625, 0.75, 0.5, 0.509375, 0.44375, 0.2421875, 0.14375, 0.2421875, 0.35],
    avg: 0.5116447368421051
  },
  Montserrat: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2625, 0.2609375, 0.3734375, 0.696875, 0.615625, 0.8296875, 0.6703125, 0.203125, 0.3296875, 0.3296875, 0.3875, 0.575, 0.2125, 0.3828125, 0.2125, 0.3953125, 0.6625, 0.3625, 0.56875, 0.5640625, 0.6625, 0.5671875, 0.609375, 0.5890625, 0.6390625, 0.609375, 0.2125, 0.2125, 0.575, 0.575, 0.575, 0.5671875, 1.034375, 0.7171875, 0.7546875, 0.7203125, 0.8265625, 0.6703125, 0.634375, 0.7734375, 0.8140625, 0.303125, 0.5078125, 0.7125, 0.5890625, 0.95625, 0.8140625, 0.8390625, 0.71875, 0.8390625, 0.7234375, 0.615625, 0.575, 0.7921875, 0.6984375, 1.1125, 0.65625, 0.6359375, 0.6515625, 0.31875, 0.396875, 0.31875, 0.5765625, 0.5, 0.6, 0.590625, 0.678125, 0.5640625, 0.678125, 0.6046875, 0.375, 0.6875, 0.678125, 0.2703125, 0.365625, 0.6015625, 0.2703125, 1.0625, 0.678125, 0.628125, 0.678125, 0.678125, 0.4015625, 0.4890625, 0.40625, 0.6734375, 0.5421875, 0.8796875, 0.534375, 0.5671875, 0.5125, 0.334375, 0.2953125, 0.334375, 0.575],
    avg: 0.571792763157895
  },
  monospace: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  Overpass: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2296875, 0.2765625, 0.4203125, 0.68125, 0.584375, 0.8515625, 0.7015625, 0.2203125, 0.3453125, 0.3453125, 0.53125, 0.63125, 0.2234375, 0.3953125, 0.2234375, 0.509375, 0.65, 0.4046875, 0.6171875, 0.60625, 0.6484375, 0.60625, 0.6015625, 0.5375, 0.615625, 0.6015625, 0.2234375, 0.2234375, 0.63125, 0.63125, 0.63125, 0.5015625, 0.8203125, 0.696875, 0.6671875, 0.65, 0.6859375, 0.6015625, 0.559375, 0.690625, 0.7078125, 0.2953125, 0.565625, 0.678125, 0.58125, 0.8046875, 0.7109375, 0.740625, 0.6421875, 0.740625, 0.6765625, 0.6046875, 0.590625, 0.696875, 0.6640625, 0.853125, 0.65, 0.6671875, 0.6625, 0.3734375, 0.509375, 0.3734375, 0.63125, 0.5125, 0.4, 0.5328125, 0.5625, 0.51875, 0.5625, 0.546875, 0.3359375, 0.5625, 0.565625, 0.25625, 0.3203125, 0.55, 0.265625, 0.85, 0.565625, 0.5671875, 0.5625, 0.5625, 0.4046875, 0.4765625, 0.3796875, 0.565625, 0.521875, 0.7265625, 0.53125, 0.5390625, 0.5125, 0.3671875, 0.275, 0.3671875, 0.63125],
    avg: 0.5430756578947369
  },
  Palatino: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.278125, 0.371875, 0.60625, 0.5, 0.840625, 0.778125, 0.209375, 0.334375, 0.334375, 0.390625, 0.60625, 0.2578125, 0.334375, 0.25, 0.60625, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.60625, 0.60625, 0.60625, 0.4453125, 0.7484375, 0.778125, 0.6109375, 0.709375, 0.775, 0.6109375, 0.55625, 0.7640625, 0.8328125, 0.3375, 0.346875, 0.7265625, 0.6109375, 0.946875, 0.83125, 0.7875, 0.6046875, 0.7875, 0.66875, 0.525, 0.6140625, 0.778125, 0.7234375, 1, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.60625, 0.334375, 0.60625, 0.5, 0.334375, 0.5, 0.565625, 0.4453125, 0.6109375, 0.4796875, 0.340625, 0.55625, 0.5828125, 0.2921875, 0.2671875, 0.5640625, 0.2921875, 0.8828125, 0.5828125, 0.546875, 0.6015625, 0.5609375, 0.3953125, 0.425, 0.3265625, 0.603125, 0.565625, 0.834375, 0.5171875, 0.55625, 0.5, 0.334375, 0.60625, 0.334375, 0.60625],
    avg: 0.5408552631578947
  },
  RedHatText: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2328125, 0.2203125, 0.35625, 0.6890625, 0.55, 0.7390625, 0.6703125, 0.2140625, 0.4015625, 0.4015625, 0.4546875, 0.53125, 0.2203125, 0.45625, 0.2203125, 0.515625, 0.6609375, 0.3078125, 0.5484375, 0.5875, 0.61875, 0.5703125, 0.6203125, 0.559375, 0.6140625, 0.6203125, 0.2203125, 0.2234375, 0.465625, 0.534375, 0.465625, 0.5125, 0.7671875, 0.6609375, 0.6703125, 0.7265625, 0.728125, 0.6203125, 0.6109375, 0.8, 0.73125, 0.253125, 0.6, 0.6125, 0.6078125, 0.8625, 0.7390625, 0.8109375, 0.6546875, 0.809375, 0.6484375, 0.6234375, 0.6171875, 0.7125, 0.6609375, 0.8984375, 0.6546875, 0.646875, 0.60625, 0.3625, 0.5203125, 0.3625, 0.540625, 0.4609375, 0.5234375, 0.5265625, 0.584375, 0.509375, 0.5828125, 0.5578125, 0.3703125, 0.5828125, 0.553125, 0.2234375, 0.24375, 0.4890625, 0.2234375, 0.8453125, 0.553125, 0.58125, 0.584375, 0.5828125, 0.353125, 0.453125, 0.378125, 0.553125, 0.5015625, 0.6984375, 0.4875, 0.4984375, 0.459375, 0.3953125, 0.2921875, 0.3953125, 0.58125],
    avg: 0.5341940789473685
  },
  "sans-serif": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.303125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.5859375, 0.584375, 0.5859375, 0.55625, 1.015625, 0.6671875, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.35625, 0.278125, 0.478125, 0.55625, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.278125, 0.55625, 0.55625, 0.2234375, 0.2421875, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.334375, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.35625, 0.2609375, 0.3546875, 0.590625],
    avg: 0.5293256578947368
  },
  Seravek: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.296875, 0.4171875, 0.6734375, 0.4953125, 0.9125, 0.740625, 0.2421875, 0.3375, 0.3375, 0.409375, 0.60625, 0.2609375, 0.35625, 0.25625, 0.41875, 0.5921875, 0.3515625, 0.475, 0.4875, 0.5375, 0.509375, 0.5484375, 0.4546875, 0.5421875, 0.5484375, 0.25625, 0.2546875, 0.5875, 0.6171875, 0.5875, 0.4578125, 0.8140625, 0.6765625, 0.5703125, 0.6109375, 0.684375, 0.5109375, 0.4953125, 0.678125, 0.6859375, 0.2625, 0.2625, 0.5859375, 0.4734375, 0.846875, 0.709375, 0.740625, 0.509375, 0.740625, 0.584375, 0.5015625, 0.528125, 0.675, 0.5953125, 0.9453125, 0.596875, 0.540625, 0.540625, 0.359375, 0.4203125, 0.359375, 0.5109375, 0.421875, 0.4046875, 0.5015625, 0.5421875, 0.446875, 0.5453125, 0.484375, 0.38125, 0.5140625, 0.5546875, 0.240625, 0.2640625, 0.490625, 0.2765625, 0.8625, 0.5546875, 0.546875, 0.5453125, 0.5453125, 0.3625, 0.41875, 0.3890625, 0.5453125, 0.4703125, 0.7546875, 0.4921875, 0.4609375, 0.453125, 0.4015625, 0.2640625, 0.4015625, 0.58125],
    avg: 0.5044078947368421
  },
  serif: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.278125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.7234375, 0.6109375, 0.890625, 0.7234375, 0.7234375, 0.55625, 0.7234375, 0.6671875, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.340625, 0.334375, 0.4703125, 0.5, 0.3453125, 0.4453125, 0.5, 0.4453125, 0.5, 0.4453125, 0.3828125, 0.5, 0.5, 0.278125, 0.3359375, 0.5, 0.278125, 0.778125, 0.5, 0.5, 0.5, 0.5, 0.3375, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5126315789473684
  },
  Tahoma: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3109375, 0.3328125, 0.4015625, 0.728125, 0.546875, 0.9765625, 0.70625, 0.2109375, 0.3828125, 0.3828125, 0.546875, 0.728125, 0.303125, 0.3640625, 0.303125, 0.3953125, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.3546875, 0.3546875, 0.728125, 0.728125, 0.728125, 0.475, 0.909375, 0.6109375, 0.590625, 0.6015625, 0.6796875, 0.5625, 0.521875, 0.66875, 0.6765625, 0.3734375, 0.4171875, 0.6046875, 0.4984375, 0.771875, 0.66875, 0.7078125, 0.5515625, 0.7078125, 0.6375, 0.5578125, 0.5875, 0.65625, 0.60625, 0.903125, 0.58125, 0.5890625, 0.559375, 0.3828125, 0.39375, 0.3828125, 0.728125, 0.5625, 0.546875, 0.525, 0.553125, 0.4625, 0.553125, 0.5265625, 0.3546875, 0.553125, 0.5578125, 0.2296875, 0.328125, 0.51875, 0.2296875, 0.840625, 0.5578125, 0.54375, 0.553125, 0.553125, 0.3609375, 0.446875, 0.3359375, 0.5578125, 0.4984375, 0.7421875, 0.4953125, 0.4984375, 0.4453125, 0.48125, 0.3828125, 0.48125, 0.728125],
    avg: 0.5384374999999998
  },
  "Times New Roman": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.73125, 0.6109375, 0.890625, 0.7375, 0.7234375, 0.55625, 0.7234375, 0.6765625, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.28125, 0.334375, 0.4703125, 0.51875, 0.334375, 0.4453125, 0.503125, 0.4453125, 0.503125, 0.4453125, 0.4359375, 0.5, 0.5, 0.278125, 0.35625, 0.50625, 0.278125, 0.778125, 0.5, 0.5, 0.5046875, 0.5, 0.340625, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5134375
  },
  "Trebuchet MS": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3015625, 0.3671875, 0.325, 0.53125, 0.525, 0.6015625, 0.70625, 0.1609375, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.3671875, 0.771875, 0.590625, 0.5671875, 0.5984375, 0.6140625, 0.5359375, 0.525, 0.6765625, 0.6546875, 0.2796875, 0.4765625, 0.5765625, 0.5078125, 0.7109375, 0.6390625, 0.675, 0.5578125, 0.7421875, 0.5828125, 0.48125, 0.58125, 0.6484375, 0.5875, 0.853125, 0.5578125, 0.5703125, 0.5515625, 0.3671875, 0.3578125, 0.3671875, 0.525, 0.53125, 0.525, 0.5265625, 0.5578125, 0.4953125, 0.5578125, 0.546875, 0.375, 0.503125, 0.546875, 0.2859375, 0.3671875, 0.5046875, 0.2953125, 0.83125, 0.546875, 0.5375, 0.5578125, 0.5578125, 0.3890625, 0.40625, 0.396875, 0.546875, 0.490625, 0.7453125, 0.5015625, 0.49375, 0.475, 0.3671875, 0.525, 0.3671875, 0.525],
    avg: 0.5085197368421052
  },
  Verdana: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.35, 0.39375, 0.459375, 0.81875, 0.6359375, 1.0765625, 0.759375, 0.26875, 0.4546875, 0.4546875, 0.6359375, 0.81875, 0.3640625, 0.4546875, 0.3640625, 0.4703125, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.4546875, 0.4546875, 0.81875, 0.81875, 0.81875, 0.546875, 1, 0.684375, 0.6859375, 0.6984375, 0.771875, 0.6328125, 0.575, 0.7765625, 0.7515625, 0.421875, 0.4546875, 0.69375, 0.5578125, 0.84375, 0.7484375, 0.7875, 0.603125, 0.7875, 0.7, 0.684375, 0.6171875, 0.7328125, 0.684375, 0.9890625, 0.6859375, 0.615625, 0.6859375, 0.4546875, 0.46875, 0.4546875, 0.81875, 0.6421875, 0.6359375, 0.6015625, 0.6234375, 0.521875, 0.6234375, 0.596875, 0.384375, 0.6234375, 0.6328125, 0.275, 0.3765625, 0.5921875, 0.275, 0.9734375, 0.6328125, 0.6078125, 0.6234375, 0.6234375, 0.43125, 0.521875, 0.3953125, 0.6328125, 0.5921875, 0.81875, 0.5921875, 0.5921875, 0.5265625, 0.6359375, 0.4546875, 0.6359375, 0.81875],
    avg: 0.6171875000000003
  }
}, ox = {
  mm: 3.8,
  sm: 38,
  pt: 1.33,
  pc: 16,
  in: 96,
  px: 1
}, lx = {
  em: 1,
  ex: 0.5
}, OO = {
  heightOverlapCoef: 1.05,
  // Coefficient for height value to prevent overlap.
  lineCapitalCoef: 1.15
  // Coefficient for height value. Reserve space for capital chars.
}, TO = {
  lineHeight: 1,
  letterSpacing: "0px",
  fontSize: 0,
  angle: 0,
  fontFamily: ""
}, Uit = function(t) {
  return t * Math.PI / 180;
}, Hit = function(t) {
  var e = t.split(",").map(function(i) {
    return i.replace(/'|"/g, "");
  }), r = e.find(function(i) {
    return sx[i];
  }) || "Helvetica";
  return sx[r];
}, X7 = function(t) {
  return Array.isArray(t) ? t : t.toString().split(/\r\n|\r|\n/g);
}, V2 = function(t, e, r) {
  var i = Uit(r);
  return Math.abs(Math.cos(i) * t) + Math.abs(Math.sin(i) * e);
}, s9 = function(t, e) {
  var r, i = (r = t.match(/[a-zA-Z%]+/)) === null || r === void 0 ? void 0 : r[0], s = Number(t.match(/[0-9.,]+/)), c;
  return i ? ox.hasOwnProperty(i) ? c = s * ox[i] : lx.hasOwnProperty(i) ? c = (e ? s * e : s * TO.fontSize) * lx[i] : c = s : c = s || 0, c;
}, q7 = function(t, e) {
  var r = Array.isArray(t) ? t[e] : t, i = Ie({}, r, TO);
  return Object.assign({}, i, {
    fontFamily: i.fontFamily,
    letterSpacing: typeof i.letterSpacing == "number" ? i.letterSpacing : s9(String(i.letterSpacing), i.fontSize),
    fontSize: typeof i.fontSize == "number" ? i.fontSize : s9(String(i.fontSize))
  });
}, Vit = function(t, e) {
  if (t === void 0 || t === "" || t === null)
    return 0;
  var r = X7(t).map(function(i, s) {
    var c = i.toString().length, u = q7(e, s), l = u.fontSize, f = u.letterSpacing, o = u.fontFamily, g = Hit(o), p = i.toString().split("").map(function(n) {
      return n.charCodeAt(0) < g.widths.length ? g.widths[n.charCodeAt(0)] : g.avg;
    }).reduce(function(n, a) {
      return a + n;
    }, 0) * l;
    return p + f * Math.max(c - 1, 0);
  });
  return Math.max.apply(Math, Lit(r));
}, zit = function(t, e) {
  return t === void 0 || t === "" || t === null ? 0 : X7(t).reduce(function(r, i, s) {
    var c = q7(e, s), u = i.toString().match(/[(A-Z)(0-9)]/), l = u ? c.fontSize * OO.lineCapitalCoef : c.fontSize;
    return r + c.lineHeight * l;
  }, 0);
}, Xit = function(t, e) {
  var r = Array.isArray(e) ? e[0] && e[0].angle : e && e.angle, i = zit(t, e), s = Vit(t, e), c = r ? V2(s, i, r) : s, u = r ? V2(i, s, r) : i;
  return {
    width: c,
    height: u * OO.heightOverlapCoef
  };
}, _m = Mk(function() {
  var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttribute("xlink", "http://www.w3.org/1999/xlink"), t.setAttribute("width", "300"), t.setAttribute("height", "300"), t.setAttribute("viewBox", "0 0 300 300"), t.setAttribute("aria-hidden", "true");
  var e = document.createElementNS("http://www.w3.org/2000/svg", "text");
  return t.appendChild(e), t.style.position = "fixed", t.style.top = "-9999px", t.style.left = "-9999px", document.body.appendChild(t), e;
}), cx = function(t) {
  return t ? "".concat(t.angle, ":").concat(t.fontFamily, ":").concat(t.fontSize, ":").concat(t.letterSpacing, ":").concat(t.lineHeight) : "null";
}, qit = Mk(function(t, e) {
  var r = _m();
  if (!r.isConnected) {
    var i, s;
    (i = (s = _m.cache).clear) === null || i === void 0 || i.call(s), r = _m();
  }
  var c = X7(t), u = 0;
  for (var l of c.entries()) {
    var f = Fit(l, 2), o = f[0], g = f[1], p = document.createElementNS("http://www.w3.org/2000/svg", "tspan"), n = q7(e, o);
    p.style.fontFamily = n.fontFamily, p.style.fontSize = "".concat(n.fontSize, "px"), p.style.lineHeight = n.lineHeight, p.style.fontFamily = n.fontFamily, p.style.letterSpacing = n.letterSpacing, p.textContent = g, p.setAttribute("x", "0"), p.setAttribute("y", "".concat(u)), r.appendChild(p), u += n.lineHeight * p.getBoundingClientRect().height;
  }
  var a = r.getBoundingClientRect(), d = a.width;
  return r.innerHTML = "", {
    width: e != null && e.angle ? V2(d, u, e == null ? void 0 : e.angle) : d,
    height: e != null && e.angle ? V2(u, d, e == null ? void 0 : e.angle) : u
  };
}, function(t, e) {
  var r = Array.isArray(t) ? t.join() : t, i = Array.isArray(e) ? e.map(cx).join() : cx(e);
  return "".concat(r, "::").concat(i);
}), Wit = {
  impl: function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
    return !i || r ? Xit(t, e) : qit(t, e);
  }
}, z2 = function(t, e) {
  return Wit.impl(t, e);
};
function ux(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function X2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ux(Object(r), !0).forEach(function(i) {
      Git(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ux(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function Git(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function N1(t) {
  return Jit(t) || Zit(t) || Yit(t) || Kit();
}
function Kit() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yit(t, e) {
  if (t) {
    if (typeof t == "string") return o9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o9(t, e);
  }
}
function Zit(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Jit(t) {
  if (Array.isArray(t)) return o9(t);
}
function o9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
var uc = {
  fill: "#252525",
  fontSize: 14,
  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
  stroke: "transparent"
}, hx = function(t, e) {
  if (!t.datum)
    return 0;
  var r = Uh(t, t.datum);
  return r[e];
}, fx = function(t) {
  var e = t && t.fontSize;
  if (typeof e == "number")
    return e;
  if (e == null)
    return uc.fontSize;
  if (typeof e == "string") {
    var r = Number(e.replace("px", ""));
    return isNaN(r) ? (SO("fontSize should be expressed as a number of pixels"), uc.fontSize) : r;
  }
  return uc.fontSize;
}, _i = function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Array.isArray(t) ? t[e] || t[0] : t;
}, MO = function(t) {
  var e = t.backgroundStyle, r = t.backgroundPadding;
  return Array.isArray(e) && !ar(e) || Array.isArray(r) && !ar(r);
}, Qit = function(t, e) {
  if (e.disableInlineStyles) {
    var r = Fr(t, e);
    return {
      // Font size is necessary to calculate the y position of the label
      fontSize: fx(r)
    };
  }
  var i = function(s) {
    var c = Fr(s ? Ie({}, s, uc) : uc, e);
    return Object.assign({}, c, {
      fontSize: fx(c)
    });
  };
  return Array.isArray(t) && !ar(t) ? t.map(function(s) {
    return i(s);
  }) : i(t);
}, tat = function(t, e) {
  if (t)
    return Array.isArray(t) && !ar(t) ? t.map(function(r) {
      return Fr(r, e);
    }) : Fr(t, e);
}, eat = function(t) {
  if (t.backgroundPadding && Array.isArray(t.backgroundPadding))
    return t.backgroundPadding.map(function(r) {
      var i = Te(r, t);
      return Qa({
        padding: i
      });
    });
  var e = Te(t.backgroundPadding, t);
  return Qa({
    padding: e
  });
}, nat = function(t) {
  var e = Te(t.lineHeight, t);
  return Array.isArray(e) && ar(e) ? [1] : e;
}, rat = function(t, e) {
  if (t != null) {
    if (Array.isArray(t))
      return t.map(function(i) {
        return Te(i, e);
      });
    var r = Te(t, e);
    if (r != null)
      return Array.isArray(r) ? r : "".concat(r).split(`
`);
  }
}, iat = function(t, e, r) {
  var i = t.dy ? Te(t.dy, t) : 0, s = t.inline ? 1 : t.text.length, c = Te(t.capHeight, t), u = e ? Te(e, t) : "middle", l = N1(Array(s).keys()).map(function(g) {
    return _i(t.style, g).fontSize;
  }), f = N1(Array(s).keys()).map(function(g) {
    return _i(r, g);
  });
  if (u === "start")
    return i + (c / 2 + f[0] / 2) * l[0];
  if (t.inline)
    return u === "end" ? i + (c / 2 - f[0] / 2) * l[0] : i + c / 2 * l[0];
  if (s === 1)
    return u === "end" ? i + (c / 2 + (0.5 - s) * f[0]) * l[0] : i + (c / 2 + (0.5 - s / 2) * f[0]) * l[0];
  var o = N1(Array(s).keys()).reduce(function(g, p) {
    return g + (c / 2 + (0.5 - s) * f[p]) * l[p] / s;
  }, 0);
  return u === "end" ? i + o : i + o / 2 + c / 2 * f[s - 1] * l[s - 1];
}, aat = function(t, e, r) {
  var i = t.polar, s = _i(t.style), c = i ? z7(t) : 0, u = s.angle === void 0 ? Te(t.angle, t) : s.angle, l = u === void 0 ? c : u, f = t.transform || s.transform, o = f && Te(f, t), g = l && {
    rotate: [l, e, r]
  };
  return o || l ? i9(o, g) : void 0;
}, EO = function(t, e) {
  var r = t.direction, i = t.textAnchor, s = t.x, c = t.dx;
  if (r === "rtl")
    return s - e;
  switch (i) {
    case "middle":
      return Math.round(s - e / 2);
    case "end":
      return Math.round(s - e);
    default:
      return s + (c || 0);
  }
}, PO = function(t, e) {
  var r = t.verticalAnchor, i = t.y, s = t.originalDy, c = s === void 0 ? 0 : s, u = i + c;
  switch (r) {
    case "start":
      return Math.floor(u);
    case "end":
      return Math.ceil(u - e);
    default:
      return Math.floor(u - e / 2);
  }
}, sat = function(t, e) {
  var r = t.dx, i = r === void 0 ? 0 : r, s = t.transform, c = t.backgroundComponent, u = t.backgroundStyle, l = t.inline, f = t.backgroundPadding, o = t.capHeight, g = e.map(function(b) {
    return b.textSize;
  }), p = l ? Math.max.apply(Math, N1(g.map(function(b) {
    return b.height;
  }))) : g.reduce(function(b, w, v) {
    var h = v ? 0 : o / 2;
    return b + w.height * (e[v].lineHeight - h);
  }, 0), n = l ? g.reduce(function(b, w, v) {
    var h = v ? i : 0;
    return b + w.width + h;
  }, 0) : Math.max.apply(Math, N1(g.map(function(b) {
    return b.width;
  }))), a = EO(t, n), d = PO(t, p), m = {
    key: "background",
    height: p + f.top + f.bottom,
    style: u,
    transform: s,
    width: n + f.left + f.right,
    x: l ? a - f.left : a + i - f.left,
    y: d
  };
  return /* @__PURE__ */ Bt.cloneElement(c, Ie({}, c.props, m));
}, oat = function(t, e, r) {
  var i = t.textAnchor, s = e.map(function(l) {
    return l.widthWithPadding;
  }), c = s.reduce(function(l, f) {
    return l + f;
  }, 0), u = -c / 2;
  switch (i) {
    case "start":
      return s.reduce(function(l, f, o) {
        return o < r ? l + f : l;
      }, 0);
    case "end":
      return s.reduce(function(l, f, o) {
        return o > r ? l - f : l;
      }, 0);
    default:
      return s.reduce(function(l, f, o) {
        var g = o < r ? f : 0;
        return o === r ? l + f / 2 : l + g;
      }, u);
  }
}, lat = function(t, e) {
  var r = t.dy, i = t.dx, s = t.transform, c = t.backgroundStyle, u = t.backgroundPadding, l = t.backgroundComponent, f = t.inline, o = t.y, g = e.map(function(p, n) {
    var a = _i(e, n - 1), d = p.textSize, m = p.fontSize * p.lineHeight, b = Math.ceil(m), w = _i(u, n), v = _i(u, n - 1), h = f && i || 0, x = n && !f ? a.fontSize * a.lineHeight + v.top + v.bottom : r - m * 0.5 - (p.fontSize - p.capHeight);
    return {
      textHeight: b,
      labelSize: d,
      heightWithPadding: b + w.top + w.bottom,
      widthWithPadding: d.width + w.left + w.right + h,
      y: o,
      fontSize: p.fontSize,
      dy: x
    };
  });
  return g.map(function(p, n) {
    var a = EO(t, p.labelSize.width), d = g.slice(0, n + 1).reduce(function(x, _) {
      return x + _.dy;
    }, o), m = _i(u, n), b = p.heightWithPadding, w = f ? oat(t, g, n) + a - m.left : a, v = f ? PO(t, b) - m.top : d, h = {
      key: "tspan-background-".concat(n),
      height: b,
      style: _i(c, n),
      width: p.widthWithPadding,
      transform: s,
      x: w - m.left,
      y: v
    };
    return /* @__PURE__ */ Bt.cloneElement(l, Ie({}, l.props, h));
  });
}, cat = function(t, e) {
  return MO(t) ? lat(t, e) : sat(t, e);
}, uat = function(t, e, r) {
  var i = _i(t, e), s = _i(t, e - 1), c = s.fontSize * s.lineHeight, u = i.fontSize * i.lineHeight, l = s.fontSize - s.capHeight, f = i.fontSize - i.capHeight, o = c - s.fontSize / 2 + i.fontSize / 2 - c / 2 + u / 2 - f / 2 + l / 2;
  return MO(r) ? o + i.backgroundPadding.top + s.backgroundPadding.bottom : o;
}, hat = function(t, e, r) {
  var i = e.inline, s = _i(t, r);
  return r && !i ? uat(t, r, e) : i ? r === 0 ? s.backgroundPadding.top : void 0 : s.backgroundPadding.top;
}, fat = function(t) {
  var e = rat(t.text, t), r = Qit(t.style, Object.assign({}, t, {
    text: e
  })), i = tat(t.backgroundStyle, Object.assign({}, t, {
    text: e,
    style: r
  })), s = eat(Object.assign({}, t, {
    text: e,
    style: r,
    backgroundStyle: i
  })), c = Te(t.id, t);
  return Object.assign({}, t, {
    backgroundStyle: i,
    backgroundPadding: s,
    style: r,
    text: e,
    id: c
  });
}, dat = function(t) {
  var e = Te(t.ariaLabel, t), r = _i(t.style), i = nat(t), s = t.direction ? Te(t.direction, t) : "inherit", c = t.textAnchor ? Te(t.textAnchor, t) : r.textAnchor || "start", u = t.verticalAnchor ? Te(t.verticalAnchor, t) : r.verticalAnchor || "middle", l = t.dx ? Te(t.dx, t) : 0, f = iat(t, u, i), o = t.x !== void 0 ? t.x : hx(t, "x"), g = t.y !== void 0 ? t.y : hx(t, "y"), p = aat(t, o, g);
  return Object.assign({}, t, {
    ariaLabel: e,
    lineHeight: i,
    direction: s,
    textAnchor: c,
    verticalAnchor: u,
    dx: l,
    dy: f,
    originalDy: Te(t.dy, t),
    transform: p,
    x: o,
    y: g
  });
}, gat = function(t, e) {
  var r = t.ariaLabel, i = t.inline, s = t.className, c = t.title, u = t.events, l = t.direction, f = t.text, o = t.textAnchor, g = t.dx, p = t.dy, n = t.transform, a = t.x, d = t.y, m = t.desc, b = t.id, w = t.tabIndex, v = t.tspanComponent, h = t.textComponent, x = O0(t), _ = X2(X2({
    "aria-label": r,
    key: "text"
  }, u), {}, {
    direction: l,
    dx: g,
    x: a,
    y: d + p,
    transform: n,
    className: s,
    title: c,
    desc: Te(m, t),
    tabIndex: Te(w, t),
    id: b
  }, x), M = f.map(function(O, E) {
    var I = e[E].style, R = {
      key: "".concat(b, "-key-").concat(E),
      x: i ? void 0 : a,
      dx: i ? g + e[E].backgroundPadding.left : g,
      dy: hat(e, t, E),
      textAnchor: I.textAnchor || o,
      style: I,
      children: O
    };
    return /* @__PURE__ */ Bt.cloneElement(v, R);
  });
  return /* @__PURE__ */ Bt.cloneElement(h, _, M);
}, pat = {
  backgroundComponent: /* @__PURE__ */ Bt.createElement(CO, null),
  groupComponent: /* @__PURE__ */ Bt.createElement("g", null),
  direction: "inherit",
  textComponent: /* @__PURE__ */ Bt.createElement(yit, null),
  tspanComponent: /* @__PURE__ */ Bt.createElement(Cit, null),
  capHeight: 0.71,
  // Magic number from d3.
  lineHeight: 1
}, ts = function(t) {
  var e = fat(X2(X2({}, pat), t));
  if (e.text === null || e.text === void 0)
    return null;
  var r = dat(e), i = r.text, s = r.style, c = r.capHeight, u = r.backgroundPadding, l = r.lineHeight, f = i.map(function(a, d) {
    var m = _i(s, d), b = s9("".concat(c, "em"), m.fontSize), w = _i(l, d);
    return {
      style: m,
      fontSize: m.fontSize || uc.fontSize,
      capHeight: b,
      text: a,
      // TODO: This looks like a bug:
      textSize: z2(a, m),
      lineHeight: w,
      backgroundPadding: _i(u, d)
    };
  }), o = gat(r, f);
  if (e.backgroundStyle) {
    var g = cat(r, f), p = [g, o], n = /* @__PURE__ */ Bt.cloneElement(e.groupComponent, {}, p);
    return e.renderInPortal ? /* @__PURE__ */ Bt.createElement(sl, null, n) : n;
  }
  return e.renderInPortal ? /* @__PURE__ */ Bt.createElement(sl, null, o) : o;
};
ts.displayName = "VictoryLabel";
ts.role = "label";
ts.defaultStyles = uc;
function q2(t) {
  return vat(t) || bat(t) || yat(t) || mat();
}
function mat() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yat(t, e) {
  if (t) {
    if (typeof t == "string") return l9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return l9(t, e);
  }
}
function bat(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function vat(t) {
  if (Array.isArray(t)) return l9(t);
}
function l9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function IO(t) {
  return Array.isArray(t) && t.length > 0;
}
function W2(t) {
  return Array.isArray(t) && t.some(function(e) {
    return typeof e == "string";
  });
}
function ol(t) {
  return Array.isArray(t) && t.some(function(e) {
    return e instanceof Date;
  });
}
function wat(t) {
  return IO(t) && t.every(function(e) {
    return typeof e == "string";
  });
}
function G2(t, e) {
  return t && e ? t.filter(function(r) {
    return !e.includes(r);
  }) : [];
}
function dx(t) {
  return IO(t) && t.every(Array.isArray);
}
function FO(t) {
  return t.filter(function(e) {
    return e !== void 0;
  });
}
function es(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
    r[i - 1] = arguments[i];
  var s = t.concat(r);
  return ol(s) ? new Date(Math.max.apply(Math, q2(s))) : Math.max.apply(Math, q2(s));
}
function da(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
    r[i - 1] = arguments[i];
  var s = t.concat(r);
  return ol(s) ? new Date(Math.min.apply(Math, q2(s))) : Math.min.apply(Math, q2(s));
}
function RO(t, e) {
  return (t.key || e).toString();
}
function gx(t) {
  return t.reduce(function(e, r, i) {
    var s = RO(r, i);
    return e[s] = r, e;
  }, {});
}
function px(t, e) {
  var r = !1, i = Object.keys(t).reduce(function(s, c) {
    return c in e || (r = !0, s[c] = !0), s;
  }, {});
  return r && i;
}
function xat(t, e) {
  var r = t && gx(t), i = e && gx(e);
  return {
    entering: r && px(i, r),
    exiting: i && px(r, i)
  };
}
function c9(t) {
  return t.type && t.type.getData ? t.type.getData(t.props) : t.props && t.props.data || !1;
}
function DO(t, e) {
  var r = !1, i = !1, s = function(l, f) {
    if (!f || l.type !== f.type)
      return {};
    var o = xat(c9(l), c9(f)) || {}, g = o.entering, p = o.exiting;
    return r = r || !!p, i = i || !!g, {
      entering: g || !1,
      exiting: p || !1
    };
  }, c = function(l, f) {
    return l.map(function(o, g) {
      return o && o.props && o.props.children && f[g] ? c(Bt.Children.toArray(l[g].props.children), Bt.Children.toArray(f[g].props.children)) : s(o, f[g]);
    });
  }, u = c(Bt.Children.toArray(t), Bt.Children.toArray(e));
  return {
    nodesWillExit: r,
    nodesWillEnter: i,
    childrenTransitions: u,
    // TODO: This may need to be refactored for the following situation.
    //       The component receives new props, and the data provided
    //       is a perfect match for the previous data and domain except
    //       for new nodes. In this case, we wouldn't want a delay before
    //       the new nodes appear.
    nodesShouldEnter: !1
  };
}
function Sat(t, e) {
  var r = t.onEnter && t.onEnter.after ? t.onEnter.after : _0;
  return {
    data: e.map(function(i, s) {
      return Object.assign({}, i, r(i, s, e));
    })
  };
}
function Cat(t, e, r, i) {
  var s = Object.assign({}, t, {
    onEnd: i
  });
  if (s && s.onLoad && !s.onLoad.duration)
    return {
      animate: s,
      data: r
    };
  var c = s.onLoad && s.onLoad.before ? s.onLoad.before : _0, u = r.map(function(l, f) {
    return Object.assign({}, l, c(l, f, r));
  });
  return {
    animate: s,
    data: u,
    clipWidth: 0
  };
}
function Aat(t, e, r) {
  var i = Object.assign({}, t, {
    onEnd: r
  }), s = e;
  if (i && i.onLoad && !i.onLoad.duration)
    return {
      animate: t,
      data: e
    };
  var c = t.onLoad && t.onLoad.after ? t.onLoad.after : _0;
  return s = e.map(function(u, l) {
    return Object.assign({}, u, c(u, l, e));
  }), {
    animate: i,
    data: s
  };
}
function _at(t, e, r, i, s) {
  var c = t && t.onExit, u = Object.assign({}, t, c), l = r;
  if (i) {
    t.onEnd = s;
    var f = t.onExit && t.onExit.before ? t.onExit.before : _0;
    l = r.map(function(o, g) {
      var p = (o.key || g).toString();
      return i[p] ? Object.assign({}, o, f(o, g, r)) : o;
    });
  }
  return {
    animate: u,
    data: l
  };
}
function kat(t, e, r, i, s) {
  var c = t, u = r;
  if (i) {
    c = Object.assign({}, t, {
      onEnd: s
    });
    var l = t.onEnter && t.onEnter.before ? t.onEnter.before : _0;
    u = r.map(function(f, o) {
      var g = (f.key || o).toString();
      return i[g] ? Object.assign({}, f, l(f, o, r)) : f;
    });
  }
  return {
    animate: c,
    data: u
  };
}
function Oat(t, e, r, i) {
  var s = t && t.onEnter, c = Object.assign({}, t, s), u = e;
  if (r) {
    c.onEnd = i;
    var l = c.onEnter && c.onEnter.after ? c.onEnter.after : _0;
    u = e.map(function(f, o) {
      var g = RO(f, o);
      return r[g] ? Object.assign({}, f, l(f, o, e)) : f;
    });
  }
  return {
    animate: c,
    data: u
  };
}
function $O(t, e, r) {
  var i = e && e.nodesWillExit, s = e && e.nodesWillEnter, c = e && e.nodesShouldEnter, u = e && e.nodesShouldLoad, l = e && e.nodesDoneLoad, f = e && e.childrenTransitions || [], o = {
    enter: t.animate && t.animate.onEnter && t.animate.onEnter.duration,
    exit: t.animate && t.animate.onExit && t.animate.onExit.duration,
    load: t.animate && t.animate.onLoad && t.animate.onLoad.duration,
    move: t.animate && t.animate.duration
  }, g = function(d, m, b) {
    return u ? Aat(b, m, function() {
      r({
        nodesShouldLoad: !1,
        nodesDoneLoad: !0
      });
    }) : Cat(b, d, m, function() {
      r({
        nodesDoneLoad: !0
      });
    });
  }, p = function(d, m, b, w) {
    return _at(w, m, b, d, function() {
      r({
        nodesWillExit: !1
      });
    });
  }, n = function(d, m, b, w) {
    return c ? Oat(w, b, d, function() {
      r({
        nodesWillEnter: !1
      });
    }) : kat(w, m, b, d, function() {
      r({
        nodesShouldEnter: !0
      });
    });
  }, a = function(d, m) {
    var b = d.props.animate;
    if (!d.type)
      return {};
    var w = d.props && d.props.polar && d.type.defaultPolarTransitions || d.type.defaultTransitions;
    if (w) {
      var v = b[m] && b[m].duration;
      return v !== void 0 ? v : w[m] && w[m].duration;
    }
    return {};
  };
  return function(m, b) {
    var w = c9(m) || [], v = Ie({}, t.animate, m.props.animate), h = m.props.polar && m.type.defaultPolarTransitions || m.type.defaultTransitions;
    v.onExit = Ie({}, v.onExit, h && h.onExit), v.onEnter = Ie({}, v.onEnter, h && h.onEnter), v.onLoad = Ie({}, v.onLoad, h && h.onLoad);
    var x = f[b] || f[0];
    if (l) {
      if (i) {
        var O = x && x.exiting, E = o.exit !== void 0 ? o.exit : a(m, "onExit"), I = O ? {
          duration: E
        } : {
          delay: E
        };
        return p(O, m, w, Object.assign({}, v, I));
      } else if (s) {
        var R = x && x.entering, W = o.enter !== void 0 ? o.enter : a(m, "onEnter"), z = o.move !== void 0 ? o.move : m.props.animate && m.props.animate.duration, j = {
          duration: c && R ? W : z
        };
        return n(R, m, w, Object.assign({}, v, j));
      } else if (!e && v && v.onExit)
        return Sat(v, w);
    } else {
      var _ = o.load !== void 0 ? o.load : a(m, "onLoad"), M = {
        duration: _
      };
      return g(m, w, Object.assign({}, v, M));
    }
    return {
      animate: v,
      data: w
    };
  };
}
var Tat = typeof Element < "u", Mat = typeof Map == "function", Eat = typeof Set == "function", Pat = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Kd(t, e) {
  if (t === e) return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor) return !1;
    var r, i, s;
    if (Array.isArray(t)) {
      if (r = t.length, r != e.length) return !1;
      for (i = r; i-- !== 0; )
        if (!Kd(t[i], e[i])) return !1;
      return !0;
    }
    var c;
    if (Mat && t instanceof Map && e instanceof Map) {
      if (t.size !== e.size) return !1;
      for (c = t.entries(); !(i = c.next()).done; )
        if (!e.has(i.value[0])) return !1;
      for (c = t.entries(); !(i = c.next()).done; )
        if (!Kd(i.value[1], e.get(i.value[0]))) return !1;
      return !0;
    }
    if (Eat && t instanceof Set && e instanceof Set) {
      if (t.size !== e.size) return !1;
      for (c = t.entries(); !(i = c.next()).done; )
        if (!e.has(i.value[0])) return !1;
      return !0;
    }
    if (Pat && ArrayBuffer.isView(t) && ArrayBuffer.isView(e)) {
      if (r = t.length, r != e.length) return !1;
      for (i = r; i-- !== 0; )
        if (t[i] !== e[i]) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof e.valueOf == "function") return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof e.toString == "function") return t.toString() === e.toString();
    if (s = Object.keys(t), r = s.length, r !== Object.keys(e).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, s[i])) return !1;
    if (Tat && t instanceof Element) return !1;
    for (i = r; i-- !== 0; )
      if (!((s[i] === "_owner" || s[i] === "__v" || s[i] === "__o") && t.$$typeof) && !Kd(t[s[i]], e[s[i]]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
var Iat = function(e, r) {
  try {
    return Kd(e, r);
  } catch (i) {
    if ((i.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw i;
  }
};
const Wo = /* @__PURE__ */ Dn(Iat);
function u9() {
  return u9 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, u9.apply(this, arguments);
}
function Fat(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Rat(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Dat(t, e, r) {
  return e && Rat(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function $at(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && h9(t, e);
}
function h9(t, e) {
  return h9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, h9(t, e);
}
function Lat(t) {
  var e = jat();
  return function() {
    var i = K2(t), s;
    if (e) {
      var c = K2(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return Nat(this, s);
  };
}
function Nat(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Bat(t);
}
function Bat(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function jat() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function K2(t) {
  return K2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, K2(t);
}
var W7 = /* @__PURE__ */ function(t) {
  $at(r, t);
  var e = Lat(r);
  function r(i, s) {
    var c;
    Fat(this, r), c = e.call(this, i, s), c.continuous = void 0, c.timer = void 0, c.transitionProps = void 0, c.state = {
      nodesShouldLoad: !1,
      nodesDoneLoad: !1
    };
    var u = c.props.children, l = u.props.polar;
    return c.continuous = !l && u.type && u.type.continuous === !0, c.timer = c.context.transitionTimer, c;
  }
  return Dat(r, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        nodesShouldLoad: !0
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function(s) {
      var c = this;
      return Wo(this.props, s) || (this.timer.bypassAnimation(), this.setState(this.getTransitionState(this.props, s), function() {
        return c.timer.resumeAnimation();
      })), !0;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.timer.stop();
    }
  }, {
    key: "getTransitionState",
    value: function(s, c) {
      var u = s.animate;
      if (u) {
        if (u.parentState) {
          var l = u.parentState, f = l.nodesWillExit ? s : null;
          return {
            oldProps: f,
            nextProps: c
          };
        }
      } else return {};
      var o = Bt.Children.toArray(s.children), g = Bt.Children.toArray(c.children), p = DO(o, g), n = p.nodesWillExit, a = p.nodesWillEnter, d = p.childrenTransitions, m = p.nodesShouldEnter;
      return {
        nodesWillExit: n,
        nodesWillEnter: a,
        childrenTransitions: d,
        nodesShouldEnter: m,
        oldProps: n ? s : null,
        nextProps: c
      };
    }
  }, {
    key: "getDomainFromChildren",
    value: function(s, c) {
      var u = function(p) {
        return p.reduce(function(n, a) {
          if (a.type && Cn(a.type.getDomain)) {
            var d = a.props && a.type.getDomain(a.props, c);
            return d ? n.concat(d) : n;
          } else if (a.props && a.props.children)
            return n.concat(u(Bt.Children.toArray(a.props.children)));
          return n;
        }, []);
      }, l = Bt.Children.toArray(s.children)[0], f = l.props || {}, o = Array.isArray(f.domain) ? f.domain : f.domain && f.domain[c];
      if (!f.children && o)
        return o;
      var g = u([l]);
      return g.length === 0 ? [0, 1] : [da(g), es(g)];
    }
  }, {
    key: "pickProps",
    value: function() {
      return this.state ? this.state.nodesWillExit ? this.state.oldProps || this.props : this.props : this.props;
    }
  }, {
    key: "pickDomainProps",
    value: function(s) {
      var c, u = (c = s.animate) === null || c === void 0 ? void 0 : c.parentState;
      return u && u.nodesWillExit ? (this.continuous || u.continuous) && (u.nextProps || this.state.nextProps) || s : this.continuous && this.state.nodesWillExit && this.state.nextProps || s;
    }
  }, {
    key: "getClipWidth",
    value: function(s, c) {
      var u = function() {
        var f = $a(c.props, "x");
        return f ? Math.abs(f[1] - f[0]) : s.width;
      }, l = this.transitionProps ? this.transitionProps.clipWidth : void 0;
      return l !== void 0 ? l : u();
    }
  }, {
    key: "render",
    value: function() {
      var s, c = this, u = this.pickProps(), l = (s = this.props.animate) !== null && s !== void 0 && s.getTransitions ? this.props.animate.getTransitions : $O(u, this.state, function(b) {
        return c.setState(b);
      }), f = Bt.Children.toArray(u.children)[0], o = l(f);
      this.transitionProps = o;
      var g = {
        x: this.getDomainFromChildren(this.pickDomainProps(u), "x"),
        y: this.getDomainFromChildren(u, "y")
      }, p = this.getClipWidth(u, f), n = Ie({
        domain: g,
        clipWidth: p
      }, o, f.props), a = u.animationWhitelist || [], d = a.concat(["clipWidth"]), m = d.length ? lh(n, d) : n;
      return /* @__PURE__ */ Bt.createElement(pet, u9({}, n.animate, {
        data: m
      }), function(b) {
        if (f.props.groupComponent) {
          var w = c.continuous ? /* @__PURE__ */ Bt.cloneElement(f.props.groupComponent, {
            clipWidth: b.clipWidth || 0
          }) : f.props.groupComponent;
          return /* @__PURE__ */ Bt.cloneElement(f, Ie({
            animate: null,
            animating: !0,
            groupComponent: w
          }, b, n));
        }
        return /* @__PURE__ */ Bt.cloneElement(f, Ie({
          animate: null,
          animating: !0
        }, b, n));
      });
    }
  }]), r;
}(Bt.Component);
W7.displayName = "VictoryTransition";
W7.contextType = jh;
var Uat = ["desc", "id", "tabIndex", "origin"];
function Y2() {
  return Y2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Y2.apply(this, arguments);
}
function mx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function Hat(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mx(Object(r), !0).forEach(function(i) {
      Vat(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : mx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function Vat(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zat(t, e) {
  if (t == null) return {};
  var r = Xat(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function Xat(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
var qat = /* @__PURE__ */ kn(function(t, e) {
  var r, i = t.desc, s = t.id, c = t.tabIndex;
  t.origin;
  var u = zat(t, Uat), l = Hat({
    vectorEffect: "non-scaling-stroke",
    id: (r = Te(s, t)) === null || r === void 0 ? void 0 : r.toString(),
    tabIndex: Te(c, t)
  }, u);
  return i ? /* @__PURE__ */ Bt.createElement("circle", Y2({}, l, {
    ref: e
  }), /* @__PURE__ */ Bt.createElement("desc", null, i)) : /* @__PURE__ */ Bt.createElement("circle", Y2({}, l, {
    ref: e
  }));
}), A1 = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"], vi = "#252525", km = "#969696", Wat = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif", Gat = "normal", Kat = 14, Qi = {
  width: 450,
  height: 300,
  padding: 50,
  colorScale: A1
}, Er = {
  fontFamily: Wat,
  fontSize: Kat,
  letterSpacing: Gat,
  padding: 10,
  fill: vi,
  stroke: "transparent"
}, Yat = Object.assign({
  textAnchor: "middle"
}, Er), Zat = "round", Jat = "round", Qat = {
  area: Object.assign({
    style: {
      data: {
        fill: vi
      },
      labels: Er
    }
  }, Qi),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: vi,
        strokeWidth: 1,
        strokeLinecap: Zat,
        strokeLinejoin: Jat
      },
      axisLabel: Object.assign({}, Yat, {
        padding: 25
      }),
      grid: {
        fill: "none",
        stroke: "none",
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      },
      tickLabels: Er
    }
  }, Qi),
  bar: Object.assign({
    style: {
      data: {
        fill: vi,
        padding: 8,
        strokeWidth: 0
      },
      labels: Er
    }
  }, Qi),
  boxplot: Object.assign({
    style: {
      max: {
        padding: 8,
        stroke: vi,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, Er, {
        padding: 3
      }),
      median: {
        padding: 8,
        stroke: vi,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, Er, {
        padding: 3
      }),
      min: {
        padding: 8,
        stroke: vi,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, Er, {
        padding: 3
      }),
      q1: {
        padding: 8,
        fill: km
      },
      q1Labels: Object.assign({}, Er, {
        padding: 3
      }),
      q3: {
        padding: 8,
        fill: km
      },
      q3Labels: Object.assign({}, Er, {
        padding: 3
      })
    },
    boxWidth: 20
  }, Qi),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: vi,
        strokeWidth: 1
      },
      labels: Object.assign({}, Er, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: vi
    }
  }, Qi),
  chart: Qi,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        stroke: vi,
        strokeWidth: 2
      },
      labels: Er
    }
  }, Qi),
  group: Object.assign({
    colorScale: A1
  }, Qi),
  histogram: Object.assign({
    style: {
      data: {
        fill: km,
        stroke: vi,
        strokeWidth: 2
      },
      labels: Er
    }
  }, Qi),
  legend: {
    colorScale: A1,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: Er,
      title: Object.assign({}, Er, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: vi,
        strokeWidth: 2
      },
      labels: Er
    }
  }, Qi),
  pie: {
    style: {
      data: {
        padding: 10,
        stroke: "transparent",
        strokeWidth: 1
      },
      labels: Object.assign({}, Er, {
        padding: 20
      })
    },
    colorScale: A1,
    width: 400,
    height: 400,
    padding: 50
  },
  scatter: Object.assign({
    style: {
      data: {
        fill: vi,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Er
    }
  }, Qi),
  stack: Object.assign({
    colorScale: A1
  }, Qi),
  tooltip: {
    style: Object.assign({}, Er, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: vi,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, Er, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: vi,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, Qi)
}, Hh = {
  grayscale: Qat
}, tst = ["desc", "id", "tabIndex", "origin"];
function Z2() {
  return Z2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Z2.apply(this, arguments);
}
function yx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function est(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yx(Object(r), !0).forEach(function(i) {
      nst(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : yx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function nst(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function rst(t, e) {
  if (t == null) return {};
  var r = ist(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function ist(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
var G7 = /* @__PURE__ */ kn(function(t, e) {
  var r, i = t.desc, s = t.id, c = t.tabIndex;
  t.origin;
  var u = rst(t, tst), l = est({
    id: (r = Te(s, t)) === null || r === void 0 ? void 0 : r.toString(),
    tabIndex: Te(c, t)
  }, u);
  return i ? /* @__PURE__ */ Bt.createElement("path", Z2({}, l, {
    ref: e
  }), /* @__PURE__ */ Bt.createElement("desc", null, i)) : /* @__PURE__ */ Bt.createElement("path", Z2({}, l, {
    ref: e
  }));
});
function bx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function ld(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bx(Object(r), !0).forEach(function(i) {
      ast(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : bx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function ast(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var sst = function(t) {
  var e = t.cx, r = t.cy, i = t.r, s = t.startAngle, c = t.endAngle, u = t.closedPath, l = Math.abs(c - s) / 2 + s, f = e + i * Math.cos(jr(s)), o = r - i * Math.sin(jr(s)), g = e + i * Math.cos(jr(l)), p = r - i * Math.sin(jr(l)), n = e + i * Math.cos(jr(c)), a = r - i * Math.sin(jr(c)), d = l - s <= 180 ? 0 : 1, m = c - l <= 180 ? 0 : 1, b = u ? " M ".concat(e, ", ").concat(r, " L ").concat(f, ", ").concat(o) : "M ".concat(f, ", ").concat(o), w = "A ".concat(i, ", ").concat(i, ", 0, ").concat(d, ", 0, ").concat(g, ", ").concat(p), v = "A ".concat(i, ", ").concat(i, ", 0, ").concat(m, ", 0, ").concat(n, ", ").concat(a), h = u ? "Z" : "";
  return "".concat(b, " ").concat(w, " ").concat(v, " ").concat(h);
}, ost = function(t) {
  var e = Te(t.ariaLabel, t), r = Te(t.desc, t), i = Te(t.id, t), s = Fr(Object.assign({
    stroke: "black",
    fill: "none"
  }, t.style), t), c = Te(t.tabIndex, t);
  return Object.assign({}, t, {
    ariaLabel: e,
    desc: r,
    id: i,
    style: s,
    tabIndex: c
  });
}, lst = {
  pathComponent: /* @__PURE__ */ Bt.createElement(G7, null),
  role: "presentation",
  shapeRendering: "auto"
}, vx = function(t) {
  var e = ost(ld(ld({}, lst), t));
  return /* @__PURE__ */ Bt.cloneElement(e.pathComponent, ld(ld({}, e.events), {}, {
    "aria-label": e.ariaLabel,
    d: sst(e),
    style: e.style,
    desc: e.desc,
    tabIndex: e.tabIndex,
    className: e.className,
    role: e.role,
    shapeRendering: e.shapeRendering,
    transform: e.transform,
    clipPath: e.clipPath
  }));
};
function wx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function du(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wx(Object(r), !0).forEach(function(i) {
      cst(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : wx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function cst(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var ust = function(t) {
  var e = Te(t.id, t);
  return Object.assign({}, t, {
    id: e
  });
}, hst = {
  circleComponent: /* @__PURE__ */ Bt.createElement(qat, null),
  rectComponent: /* @__PURE__ */ Bt.createElement(CO, null),
  role: "presentation",
  shapeRendering: "auto"
}, fst = function(t) {
  var e = ust(du(du({}, hst), t));
  return e.polar ? /* @__PURE__ */ Bt.cloneElement(e.circleComponent, du(du({}, e.events), {}, {
    style: e.style,
    role: e.role,
    shapeRendering: e.shapeRendering,
    cx: e.x,
    cy: e.y,
    r: e.height,
    className: e.className
  })) : /* @__PURE__ */ Bt.cloneElement(e.rectComponent, du(du({}, e.events), {}, {
    style: e.style,
    role: e.role,
    shapeRendering: e.shapeRendering,
    x: e.x,
    y: e.y,
    rx: e.rx,
    ry: e.ry,
    width: e.width,
    height: e.height,
    className: e.className
  }));
}, dst = ["desc", "id", "tabIndex", "origin"];
function J2() {
  return J2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, J2.apply(this, arguments);
}
function xx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function gst(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xx(Object(r), !0).forEach(function(i) {
      pst(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function pst(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function mst(t, e) {
  if (t == null) return {};
  var r = yst(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function yst(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
var bst = /* @__PURE__ */ kn(function(t, e) {
  var r, i = t.desc, s = t.id, c = t.tabIndex;
  t.origin;
  var u = mst(t, dst), l = gst({
    vectorEffect: "non-scaling-stroke",
    id: (r = Te(s, t)) === null || r === void 0 ? void 0 : r.toString(),
    tabIndex: Te(c, t)
  }, u);
  return i ? /* @__PURE__ */ Bt.createElement("line", J2({}, l, {
    ref: e
  }), /* @__PURE__ */ Bt.createElement("desc", null, i)) : /* @__PURE__ */ Bt.createElement("line", J2({}, l, {
    ref: e
  }));
});
function Sx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function cd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sx(Object(r), !0).forEach(function(i) {
      vst(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Sx(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function vst(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var wst = function(t) {
  var e = Te(t.ariaLabel, t), r = Te(t.desc, t), i = Te(t.id, t), s = Fr(Object.assign({
    stroke: "black"
  }, t.style), t), c = Te(t.tabIndex, t);
  return Object.assign({}, t, {
    ariaLabel: e,
    desc: r,
    id: i,
    style: s,
    tabIndex: c
  });
}, xst = {
  lineComponent: /* @__PURE__ */ Bt.createElement(bst, null),
  role: "presentation",
  shapeRendering: "auto"
}, Cs = function(t) {
  var e = wst(cd(cd({}, xst), t));
  return /* @__PURE__ */ Bt.cloneElement(e.lineComponent, cd(cd({}, e.events), {}, {
    "aria-label": e.ariaLabel,
    style: e.style,
    desc: e.desc,
    tabIndex: e.tabIndex,
    className: e.className,
    role: e.role,
    shapeRendering: e.shapeRendering,
    x1: e.x1,
    x2: e.x2,
    y1: e.y1,
    y2: e.y2,
    transform: e.transform,
    clipPath: e.clipPath
  }));
};
function Sst(t, e, r, i) {
  for (var s = t.length, c = r + (i ? 1 : -1); i ? c-- : ++c < s; )
    if (e(t[c], c, t))
      return c;
  return -1;
}
var Cst = Sst;
function Ast(t) {
  return t !== t;
}
var _st = Ast;
function kst(t, e, r) {
  for (var i = r - 1, s = t.length; ++i < s; )
    if (t[i] === e)
      return i;
  return -1;
}
var Ost = kst, Tst = Cst, Mst = _st, Est = Ost;
function Pst(t, e, r) {
  return e === e ? Est(t, e, r) : Tst(t, Mst, r);
}
var Ist = Pst, Fst = Ist;
function Rst(t, e) {
  var r = t == null ? 0 : t.length;
  return !!r && Fst(t, e, 0) > -1;
}
var Dst = Rst;
function $st(t, e, r) {
  for (var i = -1, s = t == null ? 0 : t.length; ++i < s; )
    if (r(e, t[i]))
      return !0;
  return !1;
}
var Lst = $st;
function Nst() {
}
var Bst = Nst, Om = Vk, jst = Bst, Ust = _7, Hst = 1 / 0, Vst = Om && 1 / Ust(new Om([, -0]))[1] == Hst ? function(t) {
  return new Om(t);
} : jst, zst = Vst, Xst = Fk, qst = Dst, Wst = Lst, Gst = Rk, Kst = zst, Yst = _7, Zst = 200;
function Jst(t, e, r) {
  var i = -1, s = qst, c = t.length, u = !0, l = [], f = l;
  if (r)
    u = !1, s = Wst;
  else if (c >= Zst) {
    var o = e ? null : Kst(t);
    if (o)
      return Yst(o);
    u = !1, s = Gst, f = new Xst();
  } else
    f = e ? [] : l;
  t:
    for (; ++i < c; ) {
      var g = t[i], p = e ? e(g) : g;
      if (g = r || g !== 0 ? g : 0, u && p === p) {
        for (var n = f.length; n--; )
          if (f[n] === p)
            continue t;
        e && f.push(p), l.push(g);
      } else s(f, p, r) || (f !== l && f.push(p), l.push(g));
    }
  return l;
}
var LO = Jst, Qst = LO;
function tot(t) {
  return t && t.length ? Qst(t) : [];
}
var eot = tot;
const xc = /* @__PURE__ */ Dn(eot);
var not = "Expected a function";
function rot(t) {
  if (typeof t != "function")
    throw new TypeError(not);
  return function() {
    var e = arguments;
    switch (e.length) {
      case 0:
        return !t.call(this);
      case 1:
        return !t.call(this, e[0]);
      case 2:
        return !t.call(this, e[0], e[1]);
      case 3:
        return !t.call(this, e[0], e[1], e[2]);
    }
    return !t.apply(this, e);
  };
}
var iot = rot, aot = k7, sot = Jk, oot = Nk, lot = Lk, cot = Object.getOwnPropertySymbols, uot = cot ? function(t) {
  for (var e = []; t; )
    aot(e, oot(t)), t = sot(t);
  return e;
} : lot, hot = uot, fot = $k, dot = hot, got = dO;
function pot(t) {
  return fot(t, got, dot);
}
var mot = pot, yot = w7, bot = gp, vot = mO, wot = mot;
function xot(t, e) {
  if (t == null)
    return {};
  var r = yot(wot(t), function(i) {
    return [i];
  });
  return e = bot(e), vot(t, r, function(i, s) {
    return e(i, s[0]);
  });
}
var NO = xot;
const Q2 = /* @__PURE__ */ Dn(NO);
var Sot = gp, Cot = iot, Aot = NO;
function _ot(t, e) {
  return Aot(t, Cot(Sot(e)));
}
var kot = _ot;
const BO = /* @__PURE__ */ Dn(kot);
function ud(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function jO(t) {
  return Eot(t) || Mot(t) || Tot(t) || Oot();
}
function Oot() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tot(t, e) {
  if (t) {
    if (typeof t == "string") return f9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return f9(t, e);
  }
}
function Mot(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Eot(t) {
  if (Array.isArray(t)) return f9(t);
}
function f9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
var K7 = /^onGlobal(.*)$/;
function UO(t, e, r, i) {
  var s = this, c = function(p) {
    var n = function() {
      var d = p.reduce(function(m, b) {
        if (b.target !== void 0) {
          var w = Array.isArray(b.target) ? b.target.includes(e) : "".concat(b.target) === "".concat(e);
          return w ? m.concat(b) : m;
        }
        return m.concat(b);
      }, []);
      return r !== void 0 && e !== "parent" ? d.filter(function(m) {
        var b = m.eventKey, w = function(v) {
          return v ? "".concat(v) === "".concat(r) : !0;
        };
        return Array.isArray(b) ? b.some(function(v) {
          return w(v);
        }) : w(b);
      }) : d;
    }, a = n();
    return Array.isArray(a) && a.reduce(function(d, m) {
      return m ? Object.assign(d, m.eventHandlers) : d;
    }, {});
  }, u = function() {
    if (Array.isArray(s.componentEvents)) {
      var p;
      return Array.isArray(t.events) ? (p = s.componentEvents).concat.apply(p, jO(t.events)) : s.componentEvents;
    }
    return t.events;
  }, l = u(), f = l && Cn(i) ? i(c(l), e) : void 0;
  if (!t.sharedEvents)
    return f;
  var o = t.sharedEvents.getEvents, g = t.sharedEvents.events && o(c(t.sharedEvents.events), e);
  return Object.assign({}, g, f);
}
function HO(t, e, r, i) {
  var s = this;
  if (ar(t))
    return {};
  var c = i || this.baseProps, u = function(p, n) {
    var a = p.childName, d = p.target, m = p.key, b = n === "props" ? c : s.state || {}, w = a == null || !b[a] ? b : b[a];
    return m === "parent" ? w.parent : w[m] && w[m][d];
  }, l = function(p, n) {
    var a = e === "parent" ? p.childName : p.childName || r, d = p.target || e, m = function(h) {
      return d === "parent" ? "parent" : p.eventKey === "all" ? c[h] ? Object.keys(c[h]).filter(function(x) {
        return x !== "parent";
      }) : Object.keys(c).filter(function(x) {
        return x !== "parent";
      }) : p.eventKey === void 0 && n === "parent" ? c[h] ? Object.keys(c[h]) : Object.keys(c) : p.eventKey !== void 0 ? p.eventKey : n;
    }, b = function(h, x) {
      var _ = s.state || {};
      if (!Cn(p.mutation))
        return _;
      var M = u({
        childName: x,
        key: h,
        target: d
      }, "props"), O = u({
        childName: x,
        key: h,
        target: d
      }, "state"), E = p.mutation(Object.assign({}, M, O), c), I = _[x] || {}, R = function(j) {
        return j[h] && j[h][d] && delete j[h][d], j[h] && !Object.keys(j[h]).length && delete j[h], j;
      }, W = function(j) {
        return d === "parent" ? Object.assign(j, ud({}, h, Object.assign(j[h] || {}, E))) : Object.assign(j, ud({}, h, Object.assign(j[h] || {}, ud({}, d, E))));
      }, z = function(j) {
        return E ? W(j) : R(j);
      };
      return x != null ? Object.assign(_, ud({}, x, z(I))) : z(_);
    }, w = function(h) {
      var x = m(h);
      return Array.isArray(x) ? x.reduce(function(_, M) {
        return Object.assign(_, b(M, h));
      }, {}) : b(x, h);
    }, v = a === "all" ? Object.keys(c).filter(function(h) {
      return h !== "parent";
    }) : a;
    return Array.isArray(v) ? v.reduce(function(h, x) {
      return Object.assign(h, w(x));
    }, {}) : w(v);
  }, f = function(p, n) {
    return Array.isArray(p) ? p.reduce(function(a, d) {
      return Object.assign({}, a, l(d, n));
    }, {}) : l(p, n);
  }, o = function(p) {
    var n = function(m) {
      return Cn(m.callback) && m.callback;
    }, a = Array.isArray(p) ? p.map(function(m) {
      return n(m);
    }) : [n(p)], d = a.filter(function(m) {
      return m !== !1;
    });
    return d.length ? function() {
      return d.forEach(function(m) {
        return m();
      });
    } : void 0;
  }, g = function(p, n, a, d) {
    var m = t[d](p, n, a, s);
    if (!ar(m)) {
      var b = o(m);
      s.setState(f(m, a), b);
    }
  };
  return Object.keys(t).reduce(function(p, n) {
    return p[n] = g, p;
  }, {});
}
function VO(t, e, r) {
  return t ? Object.keys(t).reduce(function(i, s) {
    var c = function(u) {
      return t[s](u, r, e, s);
    };
    return i[s] = c, i;
  }, {}) : {};
}
function zO(t, e, r) {
  var i = this.state || {};
  return r ? i[r] && i[r][t] && i[r][t][e] : t === "parent" ? i[t] && i[t][e] || i[t] : i[t] && i[t][e];
}
function Pot(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0;
  return i.reduce(function(s, c) {
    var u = r[c], l = XO(t, e[c], r[c], c);
    return s[c] = l || u, Q2(s, function(f) {
      return !ar(f);
    });
  }, {});
}
function XO(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0, s = Object.keys(e);
  return s.reduce(function(c, u) {
    var l = r[u] || {}, f = e[u] || {};
    if (u === "parent") {
      var o = {
        eventKey: u,
        target: "parent"
      }, g = Cx(t, f, l, o);
      c[u] = g !== void 0 ? Object.assign({}, l, g) : l;
    } else {
      var p = xc(Object.keys(f).concat(Object.keys(l)));
      c[u] = p.reduce(function(n, a) {
        var d = {
          eventKey: u,
          target: a,
          childName: i
        }, m = Cx(t, f[a], l[a], d);
        return n[a] = m !== void 0 ? Object.assign({}, l[a], m) : l[a], Q2(n, function(b) {
          return !ar(b);
        });
      }, {});
    }
    return Q2(c, function(n) {
      return !ar(n);
    });
  }, {});
}
function Cx(t, e, r, i) {
  var s = function(f, o) {
    if (typeof f[o] == "string")
      return f[o] === "all" || f[o] === i[o];
    if (Array.isArray(f[o])) {
      var g = f[o].map(function(p) {
        return "".concat(p);
      });
      return g.includes(i[o]);
    }
    return !1;
  }, c = Array.isArray(t) ? t : [t];
  i.childName && (c = t.filter(function(f) {
    return s(f, "childName");
  }));
  var u = c.filter(function(f) {
    return s(f, "target");
  });
  if (!ar(u)) {
    var l = u.filter(function(f) {
      return s(f, "eventKey");
    });
    if (!ar(l))
      return l.reduce(function(f, o) {
        var g = o && Cn(o.mutation) ? o.mutation : function() {
        }, p = g(Object.assign({}, e, r));
        return Object.assign({}, f, p);
      }, {});
  }
}
function Y7(t, e) {
  var r = Array.isArray(e) && e.reduce(function(i, s) {
    var c = t[s], u = c && c.type && c.type.defaultEvents, l = Cn(u) ? u(c.props) : u;
    return Array.isArray(l) ? i.concat.apply(i, jO(l)) : i;
  }, []);
  return r && r.length ? r : void 0;
}
function tg(t) {
  var e = t.match(K7);
  return e && e[1] && e[1].toLowerCase();
}
var qO = function(t) {
  return Q2(t, function(e, r) {
    return K7.test(r);
  });
}, WO = function(t) {
  return BO(t, function(e, r) {
    return K7.test(r);
  });
}, GO = function(t) {
  return Object.assign(t, {
    nativeEvent: t
  });
};
function hd(t) {
  return Dot(t) || Rot(t) || Fot(t) || Iot();
}
function Iot() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fot(t, e) {
  if (t) {
    if (typeof t == "string") return d9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return d9(t, e);
  }
}
function Rot(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Dot(t) {
  if (Array.isArray(t)) return d9(t);
}
function d9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function $ot(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Lot(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Not(t, e, r) {
  return e && Lot(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Bot(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && g9(t, e);
}
function g9(t, e) {
  return g9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, g9(t, e);
}
function jot(t) {
  var e = Hot();
  return function() {
    var i = eg(t), s;
    if (e) {
      var c = eg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return Uot(this, s);
  };
}
function Uot(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Yd(t);
}
function Yd(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Hot() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function eg(t) {
  return eg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, eg(t);
}
var Vot = function(t) {
  return !ch(t._x) && !ch(t._y);
}, zot = [{
  name: "parent",
  index: "parent"
}, {
  name: "data"
}, {
  name: "labels"
}];
function Z7(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = /* @__PURE__ */ function(i) {
    Bot(c, i);
    var s = jot(c);
    function c(u) {
      var l;
      return $ot(this, c), l = s.call(this, u), l.state = {}, l.getEventState = zO.bind(Yd(l)), l.getScopedEvents = HO.bind(Yd(l)), l.getEvents = function(f, o, g) {
        return UO.call(Yd(l), f, o, g, l.getScopedEvents);
      }, l.externalMutations = l.getExternalMutations(l.props), l.calculatedState = l.getStateChanges(l.props), l.globalEvents = {}, l.prevGlobalEventKeys = [], l.boundGlobalEvents = {}, l.cacheValues(l.getCalculatedValues(u)), l;
    }
    return Not(c, [{
      key: "shouldComponentUpdate",
      value: function(l) {
        var f = this.getExternalMutations(l), o = this.props.animating || this.props.animate, g = !Wo(f, this.externalMutations);
        if (o || g)
          return this.cacheValues(this.getCalculatedValues(l)), this.externalMutations = f, this.applyExternalMutations(l, f), !0;
        var p = this.getStateChanges(l);
        return Wo(this.calculatedState, p) ? Wo(this.props, l) ? !1 : (this.cacheValues(this.getCalculatedValues(l)), !0) : (this.cacheValues(this.getCalculatedValues(l)), !0);
      }
    }, {
      key: "componentDidMount",
      value: function() {
        var l = this, f = Object.keys(this.globalEvents);
        f.forEach(function(o) {
          return l.addGlobalListener(o);
        }), this.prevGlobalEventKeys = f;
      }
    }, {
      key: "componentDidUpdate",
      value: function(l) {
        var f = this, o = this.getStateChanges(l);
        this.calculatedState = o;
        var g = Object.keys(this.globalEvents), p = G2(this.prevGlobalEventKeys, g);
        p.forEach(function(a) {
          return f.removeGlobalListener(a);
        });
        var n = G2(g, this.prevGlobalEventKeys);
        n.forEach(function(a) {
          return f.addGlobalListener(a);
        }), this.prevGlobalEventKeys = g;
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        var l = this;
        this.prevGlobalEventKeys.forEach(function(f) {
          return l.removeGlobalListener(f);
        });
      }
    }, {
      key: "addGlobalListener",
      value: function(l) {
        var f = this, o = function(g) {
          var p = f.globalEvents[l];
          return p && p(GO(g));
        };
        this.boundGlobalEvents[l] = o, window.addEventListener(tg(l), o);
      }
    }, {
      key: "removeGlobalListener",
      value: function(l) {
        window.removeEventListener(tg(l), this.boundGlobalEvents[l]);
      }
      // compile all state changes from own and parent state. Order doesn't matter, as any state
      // state change should trigger a re-render
    }, {
      key: "getStateChanges",
      value: function(l) {
        var f = this;
        if (!this.hasEvents)
          return {};
        var o = function(n, a) {
          var d = Ie({}, f.getEventState(n, a), f.getSharedEventState(n, a));
          return ar(d) ? void 0 : d;
        }, g = e.components || zot, p = g.map(function(n) {
          if (!(!l.standalone && n.name === "parent"))
            return n.index !== void 0 ? o(n.index, n.name) : f.dataKeys.map(function(a) {
              return o(a, n.name);
            }).filter(Boolean);
        }).filter(Boolean);
        return p;
      }
    }, {
      key: "applyExternalMutations",
      value: function(l, f) {
        if (!ar(f)) {
          var o = l.externalEventMutations.reduce(function(p, n) {
            return Cn(n.callback) ? p.concat(n.callback) : p;
          }, []), g = o.length ? function() {
            o.forEach(function(p) {
              return p();
            });
          } : void 0;
          this.setState(f, g);
        }
      }
    }, {
      key: "getCalculatedValues",
      value: function(l) {
        var f = l.sharedEvents, o = t.expectedComponents, g = Y7(l, o), p = f && Cn(f.getEventState) ? f.getEventState : function() {
        }, n = this.getBaseProps(l, p), a = Object.keys(n).filter(function(b) {
          return b !== "parent";
        }), d = l.events || l.sharedEvents || g, m = this.getAllEvents(l);
        return {
          componentEvents: g,
          getSharedEventState: p,
          baseProps: n,
          dataKeys: a,
          hasEvents: d,
          events: m
        };
      }
    }, {
      key: "getExternalMutations",
      value: function(l) {
        var f = l.sharedEvents, o = l.externalEventMutations;
        return ar(o) || f ? void 0 : XO(o, this.baseProps, this.state);
      }
    }, {
      key: "cacheValues",
      value: function(l) {
        var f = this;
        Object.keys(l).forEach(function(o) {
          f[o] = l[o];
        });
      }
    }, {
      key: "getBaseProps",
      value: function(l, f) {
        var o = f || this.getSharedEventState.bind(this), g = o("parent", "parent"), p = this.getEventState("parent", "parent"), n = Ie({}, p, g), a = n.parentControlledProps, d = a ? lh(n, a) : {}, m = Ie({}, d, l);
        return typeof t.getBaseProps == "function" ? t.getBaseProps(m) : {};
      }
    }, {
      key: "getAllEvents",
      value: function(l) {
        if (Array.isArray(this.componentEvents)) {
          var f;
          return Array.isArray(l.events) ? (f = this.componentEvents).concat.apply(f, hd(l.events)) : this.componentEvents;
        }
        return l.events;
      }
    }, {
      key: "getComponentProps",
      value: function(l, f, o) {
        var g = this.props.name || t.role, p = this.dataKeys && this.dataKeys[o] || o, n = "".concat(g, "-").concat(f, "-").concat(p), a = this.baseProps[p] && this.baseProps[p][f] || this.baseProps[p];
        if (!(!a && !this.hasEvents)) {
          var d = l && typeof l == "object" && "props" in l ? l.props : void 0;
          if (this.hasEvents) {
            var m = this.getEvents(this.props, f, p), b = Ie({
              index: o,
              key: n
            }, this.getEventState(p, f), this.getSharedEventState(p, f), d, a, {
              id: n
            }), w = Ie({}, VO(m, p, b), b.events);
            return Object.assign({}, b, {
              events: w
            });
          }
          return Ie({
            index: o,
            key: n
          }, d, a, {
            id: n
          });
        }
      }
    }, {
      key: "renderContainer",
      value: function(l, f) {
        var o = l.type && l.type.role === "container", g = o ? this.getComponentProps(l, "parent", "parent") : {};
        return g.events && (this.globalEvents = qO(g.events), g.events = WO(g.events)), /* @__PURE__ */ Bt.cloneElement(l, g, f);
      }
    }, {
      key: "animateComponent",
      value: function(l, f) {
        var o, g = typeof l.animate == "object" && ((o = l.animate) === null || o === void 0 ? void 0 : o.animationWhitelist) || f, p = this.constructor;
        return /* @__PURE__ */ Bt.createElement(W7, {
          animate: l.animate,
          animationWhitelist: g
        }, /* @__PURE__ */ Bt.createElement(p, l));
      }
      // Used by `VictoryLine` and `VictoryArea`
    }, {
      key: "renderContinuousData",
      value: function(l) {
        var f = this, o = l.dataComponent, g = l.labelComponent, p = l.groupComponent, n = this.dataKeys.filter(function(b) {
          return b !== "all";
        }), a = n.reduce(function(b, w) {
          var v = b, h = f.getComponentProps(g, "labels", w);
          return h && h.text !== void 0 && h.text !== null && (v = v.concat(/* @__PURE__ */ Bt.cloneElement(g, h))), v;
        }, []), d = this.getComponentProps(o, "data", "all"), m = [/* @__PURE__ */ Bt.cloneElement(o, d)].concat(hd(a));
        return this.renderContainer(p, m);
      }
    }, {
      key: "renderData",
      value: function(l) {
        var f = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Vot, g = l.dataComponent, p = l.labelComponent, n = l.groupComponent, a = this.dataKeys.reduce(function(b, w, v) {
          var h = f.getComponentProps(g, "data", v);
          return o(h.datum) && b.push(/* @__PURE__ */ Bt.cloneElement(g, h)), b;
        }, []), d = this.dataKeys.map(function(b, w) {
          var v = f.getComponentProps(p, "labels", w);
          if (v.text !== void 0 && v.text !== null)
            return /* @__PURE__ */ Bt.cloneElement(p, v);
        }).filter(Boolean), m = [].concat(hd(a), hd(d));
        return this.renderContainer(n, m);
      }
    }]), c;
  }(t);
  return r;
}
var Xot = ml, qot = yl, Wot = "[object Date]";
function Got(t) {
  return qot(t) && Xot(t) == Wot;
}
var Kot = Got, Yot = Kot, Zot = dp, Ax = M7, _x = Ax && Ax.isDate, Jot = _x ? Zot(_x) : Yot, Qot = Jot;
const KO = /* @__PURE__ */ Dn(Qot);
var tlt = v0;
function elt(t, e) {
  for (var r = -1, i = t.length, s = 0, c = []; ++r < i; ) {
    var u = t[r], l = e ? e(u) : u;
    if (!r || !tlt(l, f)) {
      var f = l;
      c[s++] = u === 0 ? 0 : u;
    }
  }
  return c;
}
var nlt = elt, rlt = nlt;
function ilt(t) {
  return t && t.length ? rlt(t) : [];
}
var alt = ilt;
const slt = /* @__PURE__ */ Dn(alt);
function olt(t) {
  return t === void 0;
}
var llt = olt;
const clt = /* @__PURE__ */ Dn(llt);
var ult = F7;
function hlt(t, e) {
  return ult(t, e);
}
var flt = hlt;
const dlt = /* @__PURE__ */ Dn(flt);
function Go(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function glt(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function J7(t) {
  let e, r, i;
  t.length !== 2 ? (e = Go, r = (l, f) => Go(t(l), f), i = (l, f) => t(l) - f) : (e = t === Go || t === glt ? t : plt, r = t, i = t);
  function s(l, f, o = 0, g = l.length) {
    if (o < g) {
      if (e(f, f) !== 0) return g;
      do {
        const p = o + g >>> 1;
        r(l[p], f) < 0 ? o = p + 1 : g = p;
      } while (o < g);
    }
    return o;
  }
  function c(l, f, o = 0, g = l.length) {
    if (o < g) {
      if (e(f, f) !== 0) return g;
      do {
        const p = o + g >>> 1;
        r(l[p], f) <= 0 ? o = p + 1 : g = p;
      } while (o < g);
    }
    return o;
  }
  function u(l, f, o = 0, g = l.length) {
    const p = s(l, f, o, g - 1);
    return p > o && i(l[p - 1], f) > -i(l[p], f) ? p - 1 : p;
  }
  return { left: s, center: u, right: c };
}
function plt() {
  return 0;
}
function YO(t) {
  return t === null ? NaN : +t;
}
function* mlt(t, e) {
  for (let r of t)
    r != null && (r = +r) >= r && (yield r);
}
const ylt = J7(Go), Vh = ylt.right;
J7(YO).center;
class kx extends Map {
  constructor(e, r = wlt) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), e != null) for (const [i, s] of e) this.set(i, s);
  }
  get(e) {
    return super.get(Ox(this, e));
  }
  has(e) {
    return super.has(Ox(this, e));
  }
  set(e, r) {
    return super.set(blt(this, e), r);
  }
  delete(e) {
    return super.delete(vlt(this, e));
  }
}
function Ox({ _intern: t, _key: e }, r) {
  const i = e(r);
  return t.has(i) ? t.get(i) : r;
}
function blt({ _intern: t, _key: e }, r) {
  const i = e(r);
  return t.has(i) ? t.get(i) : (t.set(i, r), r);
}
function vlt({ _intern: t, _key: e }, r) {
  const i = e(r);
  return t.has(i) && (r = t.get(i), t.delete(i)), r;
}
function wlt(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function xlt(t = Go) {
  if (t === Go) return ZO;
  if (typeof t != "function") throw new TypeError("compare is not a function");
  return (e, r) => {
    const i = t(e, r);
    return i || i === 0 ? i : (t(r, r) === 0) - (t(e, e) === 0);
  };
}
function ZO(t, e) {
  return (t == null || !(t >= t)) - (e == null || !(e >= e)) || (t < e ? -1 : t > e ? 1 : 0);
}
const Slt = Math.sqrt(50), Clt = Math.sqrt(10), Alt = Math.sqrt(2);
function ng(t, e, r) {
  const i = (e - t) / Math.max(0, r), s = Math.floor(Math.log10(i)), c = i / Math.pow(10, s), u = c >= Slt ? 10 : c >= Clt ? 5 : c >= Alt ? 2 : 1;
  let l, f, o;
  return s < 0 ? (o = Math.pow(10, -s) / u, l = Math.round(t * o), f = Math.round(e * o), l / o < t && ++l, f / o > e && --f, o = -o) : (o = Math.pow(10, s) * u, l = Math.round(t / o), f = Math.round(e / o), l * o < t && ++l, f * o > e && --f), f < l && 0.5 <= r && r < 2 ? ng(t, e, r * 2) : [l, f, o];
}
function p9(t, e, r) {
  if (e = +e, t = +t, r = +r, !(r > 0)) return [];
  if (t === e) return [t];
  const i = e < t, [s, c, u] = i ? ng(e, t, r) : ng(t, e, r);
  if (!(c >= s)) return [];
  const l = c - s + 1, f = new Array(l);
  if (i)
    if (u < 0) for (let o = 0; o < l; ++o) f[o] = (c - o) / -u;
    else for (let o = 0; o < l; ++o) f[o] = (c - o) * u;
  else if (u < 0) for (let o = 0; o < l; ++o) f[o] = (s + o) / -u;
  else for (let o = 0; o < l; ++o) f[o] = (s + o) * u;
  return f;
}
function m9(t, e, r) {
  return e = +e, t = +t, r = +r, ng(t, e, r)[2];
}
function y9(t, e, r) {
  e = +e, t = +t, r = +r;
  const i = e < t, s = i ? m9(e, t, r) : m9(t, e, r);
  return (i ? -1 : 1) * (s < 0 ? 1 / -s : s);
}
function Tx(t, e) {
  let r;
  for (const i of t)
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  return r;
}
function Mx(t, e) {
  let r;
  for (const i of t)
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  return r;
}
function JO(t, e, r = 0, i = 1 / 0, s) {
  if (e = Math.floor(e), r = Math.floor(Math.max(0, r)), i = Math.floor(Math.min(t.length - 1, i)), !(r <= e && e <= i)) return t;
  for (s = s === void 0 ? ZO : xlt(s); i > r; ) {
    if (i - r > 600) {
      const f = i - r + 1, o = e - r + 1, g = Math.log(f), p = 0.5 * Math.exp(2 * g / 3), n = 0.5 * Math.sqrt(g * p * (f - p) / f) * (o - f / 2 < 0 ? -1 : 1), a = Math.max(r, Math.floor(e - o * p / f + n)), d = Math.min(i, Math.floor(e + (f - o) * p / f + n));
      JO(t, e, a, d, s);
    }
    const c = t[e];
    let u = r, l = i;
    for (u1(t, r, e), s(t[i], c) > 0 && u1(t, r, i); u < l; ) {
      for (u1(t, u, l), ++u, --l; s(t[u], c) < 0; ) ++u;
      for (; s(t[l], c) > 0; ) --l;
    }
    s(t[r], c) === 0 ? u1(t, r, l) : (++l, u1(t, l, i)), l <= e && (r = l + 1), e <= l && (i = l - 1);
  }
  return t;
}
function u1(t, e, r) {
  const i = t[e];
  t[e] = t[r], t[r] = i;
}
function _lt(t, e, r) {
  if (t = Float64Array.from(mlt(t)), !(!(i = t.length) || isNaN(e = +e))) {
    if (e <= 0 || i < 2) return Mx(t);
    if (e >= 1) return Tx(t);
    var i, s = (i - 1) * e, c = Math.floor(s), u = Tx(JO(t, c).subarray(0, c + 1)), l = Mx(t.subarray(c + 1));
    return u + (l - u) * (s - c);
  }
}
function klt(t, e, r = YO) {
  if (!(!(i = t.length) || isNaN(e = +e))) {
    if (e <= 0 || i < 2) return +r(t[0], 0, t);
    if (e >= 1) return +r(t[i - 1], i - 1, t);
    var i, s = (i - 1) * e, c = Math.floor(s), u = +r(t[c], c, t), l = +r(t[c + 1], c + 1, t);
    return u + (l - u) * (s - c);
  }
}
function Olt(t, e, r) {
  t = +t, e = +e, r = (s = arguments.length) < 2 ? (e = t, t = 0, 1) : s < 3 ? 1 : +r;
  for (var i = -1, s = Math.max(0, Math.ceil((e - t) / r)) | 0, c = new Array(s); ++i < s; )
    c[i] = t + i * r;
  return c;
}
function Na(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function mo(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const b9 = Symbol("implicit");
function Q7() {
  var t = new kx(), e = [], r = [], i = b9;
  function s(c) {
    let u = t.get(c);
    if (u === void 0) {
      if (i !== b9) return i;
      t.set(c, u = e.push(c) - 1);
    }
    return r[u % r.length];
  }
  return s.domain = function(c) {
    if (!arguments.length) return e.slice();
    e = [], t = new kx();
    for (const u of c)
      t.has(u) || t.set(u, e.push(u) - 1);
    return s;
  }, s.range = function(c) {
    return arguments.length ? (r = Array.from(c), s) : r.slice();
  }, s.unknown = function(c) {
    return arguments.length ? (i = c, s) : i;
  }, s.copy = function() {
    return Q7(e, r).unknown(i);
  }, Na.apply(s, arguments), s;
}
function t4() {
  var t = Q7().unknown(void 0), e = t.domain, r = t.range, i = 0, s = 1, c, u, l = !1, f = 0, o = 0, g = 0.5;
  delete t.unknown;
  function p() {
    var n = e().length, a = s < i, d = a ? s : i, m = a ? i : s;
    c = (m - d) / Math.max(1, n - f + o * 2), l && (c = Math.floor(c)), d += (m - d - c * (n - f)) * g, u = c * (1 - f), l && (d = Math.round(d), u = Math.round(u));
    var b = Olt(n).map(function(w) {
      return d + c * w;
    });
    return r(a ? b.reverse() : b);
  }
  return t.domain = function(n) {
    return arguments.length ? (e(n), p()) : e();
  }, t.range = function(n) {
    return arguments.length ? ([i, s] = n, i = +i, s = +s, p()) : [i, s];
  }, t.rangeRound = function(n) {
    return [i, s] = n, i = +i, s = +s, l = !0, p();
  }, t.bandwidth = function() {
    return u;
  }, t.step = function() {
    return c;
  }, t.round = function(n) {
    return arguments.length ? (l = !!n, p()) : l;
  }, t.padding = function(n) {
    return arguments.length ? (f = Math.min(1, o = +n), p()) : f;
  }, t.paddingInner = function(n) {
    return arguments.length ? (f = Math.min(1, n), p()) : f;
  }, t.paddingOuter = function(n) {
    return arguments.length ? (o = +n, p()) : o;
  }, t.align = function(n) {
    return arguments.length ? (g = Math.max(0, Math.min(1, n)), p()) : g;
  }, t.copy = function() {
    return t4(e(), [i, s]).round(l).paddingInner(f).paddingOuter(o).align(g);
  }, Na.apply(p(), arguments);
}
function QO(t) {
  var e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function() {
    return QO(e());
  }, t;
}
function Tlt() {
  return QO(t4.apply(null, arguments).paddingInner(1));
}
function Mlt(t) {
  return function() {
    return t;
  };
}
function rg(t) {
  return +t;
}
var Ex = [0, 1];
function Ti(t) {
  return t;
}
function v9(t, e) {
  return (e -= t = +t) ? function(r) {
    return (r - t) / e;
  } : Mlt(isNaN(e) ? NaN : 0.5);
}
function Elt(t, e) {
  var r;
  return t > e && (r = t, t = e, e = r), function(i) {
    return Math.max(t, Math.min(e, i));
  };
}
function Plt(t, e, r) {
  var i = t[0], s = t[1], c = e[0], u = e[1];
  return s < i ? (i = v9(s, i), c = r(u, c)) : (i = v9(i, s), c = r(c, u)), function(l) {
    return c(i(l));
  };
}
function Ilt(t, e, r) {
  var i = Math.min(t.length, e.length) - 1, s = new Array(i), c = new Array(i), u = -1;
  for (t[i] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++u < i; )
    s[u] = v9(t[u], t[u + 1]), c[u] = r(e[u], e[u + 1]);
  return function(l) {
    var f = Vh(t, l, 1, i) - 1;
    return c[f](s[f](l));
  };
}
function zh(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function bp() {
  var t = Ex, e = Ex, r = Ps, i, s, c, u = Ti, l, f, o;
  function g() {
    var n = Math.min(t.length, e.length);
    return u !== Ti && (u = Elt(t[0], t[n - 1])), l = n > 2 ? Ilt : Plt, f = o = null, p;
  }
  function p(n) {
    return n == null || isNaN(n = +n) ? c : (f || (f = l(t.map(i), e, r)))(i(u(n)));
  }
  return p.invert = function(n) {
    return u(s((o || (o = l(e, t.map(i), F2)))(n)));
  }, p.domain = function(n) {
    return arguments.length ? (t = Array.from(n, rg), g()) : t.slice();
  }, p.range = function(n) {
    return arguments.length ? (e = Array.from(n), g()) : e.slice();
  }, p.rangeRound = function(n) {
    return e = Array.from(n), r = $7, g();
  }, p.clamp = function(n) {
    return arguments.length ? (u = n ? !0 : Ti, g()) : u !== Ti;
  }, p.interpolate = function(n) {
    return arguments.length ? (r = n, g()) : r;
  }, p.unknown = function(n) {
    return arguments.length ? (c = n, p) : c;
  }, function(n, a) {
    return i = n, s = a, g();
  };
}
function e4() {
  return bp()(Ti, Ti);
}
function Flt(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function ig(t, e) {
  if ((r = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var r, i = t.slice(0, r);
  return [
    i.length > 1 ? i[0] + i.slice(2) : i,
    +t.slice(r + 1)
  ];
}
function e0(t) {
  return t = ig(Math.abs(t)), t ? t[1] : NaN;
}
function Rlt(t, e) {
  return function(r, i) {
    for (var s = r.length, c = [], u = 0, l = t[0], f = 0; s > 0 && l > 0 && (f + l + 1 > i && (l = Math.max(1, i - f)), c.push(r.substring(s -= l, s + l)), !((f += l + 1) > i)); )
      l = t[u = (u + 1) % t.length];
    return c.reverse().join(e);
  };
}
function Dlt(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(r) {
      return t[+r];
    });
  };
}
var $lt = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function hh(t) {
  if (!(e = $lt.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new n4({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
hh.prototype = n4.prototype;
function n4(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
n4.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function Llt(t) {
  t: for (var e = t.length, r = 1, i = -1, s; r < e; ++r)
    switch (t[r]) {
      case ".":
        i = s = r;
        break;
      case "0":
        i === 0 && (i = r), s = r;
        break;
      default:
        if (!+t[r]) break t;
        i > 0 && (i = 0);
        break;
    }
  return i > 0 ? t.slice(0, i) + t.slice(s + 1) : t;
}
var tT;
function Nlt(t, e) {
  var r = ig(t, e);
  if (!r) return t + "";
  var i = r[0], s = r[1], c = s - (tT = Math.max(-8, Math.min(8, Math.floor(s / 3))) * 3) + 1, u = i.length;
  return c === u ? i : c > u ? i + new Array(c - u + 1).join("0") : c > 0 ? i.slice(0, c) + "." + i.slice(c) : "0." + new Array(1 - c).join("0") + ig(t, Math.max(0, e + c - 1))[0];
}
function Px(t, e) {
  var r = ig(t, e);
  if (!r) return t + "";
  var i = r[0], s = r[1];
  return s < 0 ? "0." + new Array(-s).join("0") + i : i.length > s + 1 ? i.slice(0, s + 1) + "." + i.slice(s + 1) : i + new Array(s - i.length + 2).join("0");
}
const Ix = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: Flt,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Px(t * 100, e),
  r: Px,
  s: Nlt,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function Fx(t) {
  return t;
}
var Rx = Array.prototype.map, Dx = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Blt(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? Fx : Rlt(Rx.call(t.grouping, Number), t.thousands + ""), r = t.currency === void 0 ? "" : t.currency[0] + "", i = t.currency === void 0 ? "" : t.currency[1] + "", s = t.decimal === void 0 ? "." : t.decimal + "", c = t.numerals === void 0 ? Fx : Dlt(Rx.call(t.numerals, String)), u = t.percent === void 0 ? "%" : t.percent + "", l = t.minus === void 0 ? "−" : t.minus + "", f = t.nan === void 0 ? "NaN" : t.nan + "";
  function o(p) {
    p = hh(p);
    var n = p.fill, a = p.align, d = p.sign, m = p.symbol, b = p.zero, w = p.width, v = p.comma, h = p.precision, x = p.trim, _ = p.type;
    _ === "n" ? (v = !0, _ = "g") : Ix[_] || (h === void 0 && (h = 12), x = !0, _ = "g"), (b || n === "0" && a === "=") && (b = !0, n = "0", a = "=");
    var M = m === "$" ? r : m === "#" && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "", O = m === "$" ? i : /[%p]/.test(_) ? u : "", E = Ix[_], I = /[defgprs%]/.test(_);
    h = h === void 0 ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, h)) : Math.max(0, Math.min(20, h));
    function R(W) {
      var z = M, j = O, $, B, C;
      if (_ === "c")
        j = E(W) + j, W = "";
      else {
        W = +W;
        var T = W < 0 || 1 / W < 0;
        if (W = isNaN(W) ? f : E(Math.abs(W), h), x && (W = Llt(W)), T && +W == 0 && d !== "+" && (T = !1), z = (T ? d === "(" ? d : l : d === "-" || d === "(" ? "" : d) + z, j = (_ === "s" ? Dx[8 + tT / 3] : "") + j + (T && d === "(" ? ")" : ""), I) {
          for ($ = -1, B = W.length; ++$ < B; )
            if (C = W.charCodeAt($), 48 > C || C > 57) {
              j = (C === 46 ? s + W.slice($ + 1) : W.slice($)) + j, W = W.slice(0, $);
              break;
            }
        }
      }
      v && !b && (W = e(W, 1 / 0));
      var F = z.length + W.length + j.length, S = F < w ? new Array(w - F + 1).join(n) : "";
      switch (v && b && (W = e(S + W, S.length ? w - j.length : 1 / 0), S = ""), a) {
        case "<":
          W = z + W + j + S;
          break;
        case "=":
          W = z + S + W + j;
          break;
        case "^":
          W = S.slice(0, F = S.length >> 1) + z + W + j + S.slice(F);
          break;
        default:
          W = S + z + W + j;
          break;
      }
      return c(W);
    }
    return R.toString = function() {
      return p + "";
    }, R;
  }
  function g(p, n) {
    var a = o((p = hh(p), p.type = "f", p)), d = Math.max(-8, Math.min(8, Math.floor(e0(n) / 3))) * 3, m = Math.pow(10, -d), b = Dx[8 + d / 3];
    return function(w) {
      return a(m * w) + b;
    };
  }
  return {
    format: o,
    formatPrefix: g
  };
}
var fd, r4, eT;
jlt({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function jlt(t) {
  return fd = Blt(t), r4 = fd.format, eT = fd.formatPrefix, fd;
}
function Ult(t) {
  return Math.max(0, -e0(Math.abs(t)));
}
function Hlt(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(e0(e) / 3))) * 3 - e0(Math.abs(t)));
}
function Vlt(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, e0(e) - e0(t)) + 1;
}
function nT(t, e, r, i) {
  var s = y9(t, e, r), c;
  switch (i = hh(i ?? ",f"), i.type) {
    case "s": {
      var u = Math.max(Math.abs(t), Math.abs(e));
      return i.precision == null && !isNaN(c = Hlt(s, u)) && (i.precision = c), eT(i, u);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      i.precision == null && !isNaN(c = Vlt(s, Math.max(Math.abs(t), Math.abs(e)))) && (i.precision = c - (i.type === "e"));
      break;
    }
    case "f":
    case "%": {
      i.precision == null && !isNaN(c = Ult(s)) && (i.precision = c - (i.type === "%") * 2);
      break;
    }
  }
  return r4(i);
}
function bl(t) {
  var e = t.domain;
  return t.ticks = function(r) {
    var i = e();
    return p9(i[0], i[i.length - 1], r ?? 10);
  }, t.tickFormat = function(r, i) {
    var s = e();
    return nT(s[0], s[s.length - 1], r ?? 10, i);
  }, t.nice = function(r) {
    r == null && (r = 10);
    var i = e(), s = 0, c = i.length - 1, u = i[s], l = i[c], f, o, g = 10;
    for (l < u && (o = u, u = l, l = o, o = s, s = c, c = o); g-- > 0; ) {
      if (o = m9(u, l, r), o === f)
        return i[s] = u, i[c] = l, e(i);
      if (o > 0)
        u = Math.floor(u / o) * o, l = Math.ceil(l / o) * o;
      else if (o < 0)
        u = Math.ceil(u * o) / o, l = Math.floor(l * o) / o;
      else
        break;
      f = o;
    }
    return t;
  }, t;
}
function i4() {
  var t = e4();
  return t.copy = function() {
    return zh(t, i4());
  }, Na.apply(t, arguments), bl(t);
}
function rT(t) {
  var e;
  function r(i) {
    return i == null || isNaN(i = +i) ? e : i;
  }
  return r.invert = r, r.domain = r.range = function(i) {
    return arguments.length ? (t = Array.from(i, rg), r) : t.slice();
  }, r.unknown = function(i) {
    return arguments.length ? (e = i, r) : e;
  }, r.copy = function() {
    return rT(t).unknown(e);
  }, t = arguments.length ? Array.from(t, rg) : [0, 1], bl(r);
}
function iT(t, e) {
  t = t.slice();
  var r = 0, i = t.length - 1, s = t[r], c = t[i], u;
  return c < s && (u = r, r = i, i = u, u = s, s = c, c = u), t[r] = e.floor(s), t[i] = e.ceil(c), t;
}
function $x(t) {
  return Math.log(t);
}
function Lx(t) {
  return Math.exp(t);
}
function zlt(t) {
  return -Math.log(-t);
}
function Xlt(t) {
  return -Math.exp(-t);
}
function qlt(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function Wlt(t) {
  return t === 10 ? qlt : t === Math.E ? Math.exp : (e) => Math.pow(t, e);
}
function Glt(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), (e) => Math.log(e) / t);
}
function Nx(t) {
  return (e, r) => -t(-e, r);
}
function a4(t) {
  const e = t($x, Lx), r = e.domain;
  let i = 10, s, c;
  function u() {
    return s = Glt(i), c = Wlt(i), r()[0] < 0 ? (s = Nx(s), c = Nx(c), t(zlt, Xlt)) : t($x, Lx), e;
  }
  return e.base = function(l) {
    return arguments.length ? (i = +l, u()) : i;
  }, e.domain = function(l) {
    return arguments.length ? (r(l), u()) : r();
  }, e.ticks = (l) => {
    const f = r();
    let o = f[0], g = f[f.length - 1];
    const p = g < o;
    p && ([o, g] = [g, o]);
    let n = s(o), a = s(g), d, m;
    const b = l == null ? 10 : +l;
    let w = [];
    if (!(i % 1) && a - n < b) {
      if (n = Math.floor(n), a = Math.ceil(a), o > 0) {
        for (; n <= a; ++n)
          for (d = 1; d < i; ++d)
            if (m = n < 0 ? d / c(-n) : d * c(n), !(m < o)) {
              if (m > g) break;
              w.push(m);
            }
      } else for (; n <= a; ++n)
        for (d = i - 1; d >= 1; --d)
          if (m = n > 0 ? d / c(-n) : d * c(n), !(m < o)) {
            if (m > g) break;
            w.push(m);
          }
      w.length * 2 < b && (w = p9(o, g, b));
    } else
      w = p9(n, a, Math.min(a - n, b)).map(c);
    return p ? w.reverse() : w;
  }, e.tickFormat = (l, f) => {
    if (l == null && (l = 10), f == null && (f = i === 10 ? "s" : ","), typeof f != "function" && (!(i % 1) && (f = hh(f)).precision == null && (f.trim = !0), f = r4(f)), l === 1 / 0) return f;
    const o = Math.max(1, i * l / e.ticks().length);
    return (g) => {
      let p = g / c(Math.round(s(g)));
      return p * i < i - 0.5 && (p *= i), p <= o ? f(g) : "";
    };
  }, e.nice = () => r(iT(r(), {
    floor: (l) => c(Math.floor(s(l))),
    ceil: (l) => c(Math.ceil(s(l)))
  })), e;
}
function aT() {
  const t = a4(bp()).domain([1, 10]);
  return t.copy = () => zh(t, aT()).base(t.base()), Na.apply(t, arguments), t;
}
function Bx(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function jx(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function s4(t) {
  var e = 1, r = t(Bx(e), jx(e));
  return r.constant = function(i) {
    return arguments.length ? t(Bx(e = +i), jx(e)) : e;
  }, bl(r);
}
function sT() {
  var t = s4(bp());
  return t.copy = function() {
    return zh(t, sT()).constant(t.constant());
  }, Na.apply(t, arguments);
}
function Ux(t) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
  };
}
function Klt(t) {
  return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
}
function Ylt(t) {
  return t < 0 ? -t * t : t * t;
}
function o4(t) {
  var e = t(Ti, Ti), r = 1;
  function i() {
    return r === 1 ? t(Ti, Ti) : r === 0.5 ? t(Klt, Ylt) : t(Ux(r), Ux(1 / r));
  }
  return e.exponent = function(s) {
    return arguments.length ? (r = +s, i()) : r;
  }, bl(e);
}
function l4() {
  var t = o4(bp());
  return t.copy = function() {
    return zh(t, l4()).exponent(t.exponent());
  }, Na.apply(t, arguments), t;
}
function Zlt() {
  return l4.apply(null, arguments).exponent(0.5);
}
function Hx(t) {
  return Math.sign(t) * t * t;
}
function Jlt(t) {
  return Math.sign(t) * Math.sqrt(Math.abs(t));
}
function oT() {
  var t = e4(), e = [0, 1], r = !1, i;
  function s(c) {
    var u = Jlt(t(c));
    return isNaN(u) ? i : r ? Math.round(u) : u;
  }
  return s.invert = function(c) {
    return t.invert(Hx(c));
  }, s.domain = function(c) {
    return arguments.length ? (t.domain(c), s) : t.domain();
  }, s.range = function(c) {
    return arguments.length ? (t.range((e = Array.from(c, rg)).map(Hx)), s) : e.slice();
  }, s.rangeRound = function(c) {
    return s.range(c).round(!0);
  }, s.round = function(c) {
    return arguments.length ? (r = !!c, s) : r;
  }, s.clamp = function(c) {
    return arguments.length ? (t.clamp(c), s) : t.clamp();
  }, s.unknown = function(c) {
    return arguments.length ? (i = c, s) : i;
  }, s.copy = function() {
    return oT(t.domain(), e).round(r).clamp(t.clamp()).unknown(i);
  }, Na.apply(s, arguments), bl(s);
}
function lT() {
  var t = [], e = [], r = [], i;
  function s() {
    var u = 0, l = Math.max(1, e.length);
    for (r = new Array(l - 1); ++u < l; ) r[u - 1] = klt(t, u / l);
    return c;
  }
  function c(u) {
    return u == null || isNaN(u = +u) ? i : e[Vh(r, u)];
  }
  return c.invertExtent = function(u) {
    var l = e.indexOf(u);
    return l < 0 ? [NaN, NaN] : [
      l > 0 ? r[l - 1] : t[0],
      l < r.length ? r[l] : t[t.length - 1]
    ];
  }, c.domain = function(u) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let l of u) l != null && !isNaN(l = +l) && t.push(l);
    return t.sort(Go), s();
  }, c.range = function(u) {
    return arguments.length ? (e = Array.from(u), s()) : e.slice();
  }, c.unknown = function(u) {
    return arguments.length ? (i = u, c) : i;
  }, c.quantiles = function() {
    return r.slice();
  }, c.copy = function() {
    return lT().domain(t).range(e).unknown(i);
  }, Na.apply(c, arguments);
}
function cT() {
  var t = 0, e = 1, r = 1, i = [0.5], s = [0, 1], c;
  function u(f) {
    return f != null && f <= f ? s[Vh(i, f, 0, r)] : c;
  }
  function l() {
    var f = -1;
    for (i = new Array(r); ++f < r; ) i[f] = ((f + 1) * e - (f - r) * t) / (r + 1);
    return u;
  }
  return u.domain = function(f) {
    return arguments.length ? ([t, e] = f, t = +t, e = +e, l()) : [t, e];
  }, u.range = function(f) {
    return arguments.length ? (r = (s = Array.from(f)).length - 1, l()) : s.slice();
  }, u.invertExtent = function(f) {
    var o = s.indexOf(f);
    return o < 0 ? [NaN, NaN] : o < 1 ? [t, i[0]] : o >= r ? [i[r - 1], e] : [i[o - 1], i[o]];
  }, u.unknown = function(f) {
    return arguments.length && (c = f), u;
  }, u.thresholds = function() {
    return i.slice();
  }, u.copy = function() {
    return cT().domain([t, e]).range(s).unknown(c);
  }, Na.apply(bl(u), arguments);
}
function uT() {
  var t = [0.5], e = [0, 1], r, i = 1;
  function s(c) {
    return c != null && c <= c ? e[Vh(t, c, 0, i)] : r;
  }
  return s.domain = function(c) {
    return arguments.length ? (t = Array.from(c), i = Math.min(t.length, e.length - 1), s) : t.slice();
  }, s.range = function(c) {
    return arguments.length ? (e = Array.from(c), i = Math.min(t.length, e.length - 1), s) : e.slice();
  }, s.invertExtent = function(c) {
    var u = e.indexOf(c);
    return [t[u - 1], t[u]];
  }, s.unknown = function(c) {
    return arguments.length ? (r = c, s) : r;
  }, s.copy = function() {
    return uT().domain(t).range(e).unknown(r);
  }, Na.apply(s, arguments);
}
const Tm = /* @__PURE__ */ new Date(), Mm = /* @__PURE__ */ new Date();
function Rr(t, e, r, i) {
  function s(c) {
    return t(c = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+c)), c;
  }
  return s.floor = (c) => (t(c = /* @__PURE__ */ new Date(+c)), c), s.ceil = (c) => (t(c = new Date(c - 1)), e(c, 1), t(c), c), s.round = (c) => {
    const u = s(c), l = s.ceil(c);
    return c - u < l - c ? u : l;
  }, s.offset = (c, u) => (e(c = /* @__PURE__ */ new Date(+c), u == null ? 1 : Math.floor(u)), c), s.range = (c, u, l) => {
    const f = [];
    if (c = s.ceil(c), l = l == null ? 1 : Math.floor(l), !(c < u) || !(l > 0)) return f;
    let o;
    do
      f.push(o = /* @__PURE__ */ new Date(+c)), e(c, l), t(c);
    while (o < c && c < u);
    return f;
  }, s.filter = (c) => Rr((u) => {
    if (u >= u) for (; t(u), !c(u); ) u.setTime(u - 1);
  }, (u, l) => {
    if (u >= u)
      if (l < 0) for (; ++l <= 0; )
        for (; e(u, -1), !c(u); )
          ;
      else for (; --l >= 0; )
        for (; e(u, 1), !c(u); )
          ;
  }), r && (s.count = (c, u) => (Tm.setTime(+c), Mm.setTime(+u), t(Tm), t(Mm), Math.floor(r(Tm, Mm))), s.every = (c) => (c = Math.floor(c), !isFinite(c) || !(c > 0) ? null : c > 1 ? s.filter(i ? (u) => i(u) % c === 0 : (u) => s.count(0, u) % c === 0) : s)), s;
}
const ag = Rr(() => {
}, (t, e) => {
  t.setTime(+t + e);
}, (t, e) => e - t);
ag.every = (t) => (t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? Rr((e) => {
  e.setTime(Math.floor(e / t) * t);
}, (e, r) => {
  e.setTime(+e + r * t);
}, (e, r) => (r - e) / t) : ag);
ag.range;
const to = 1e3, Ea = to * 60, eo = Ea * 60, oo = eo * 24, c4 = oo * 7, Vx = oo * 30, Em = oo * 365, nc = Rr((t) => {
  t.setTime(t - t.getMilliseconds());
}, (t, e) => {
  t.setTime(+t + e * to);
}, (t, e) => (e - t) / to, (t) => t.getUTCSeconds());
nc.range;
const u4 = Rr((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * to);
}, (t, e) => {
  t.setTime(+t + e * Ea);
}, (t, e) => (e - t) / Ea, (t) => t.getMinutes());
u4.range;
const h4 = Rr((t) => {
  t.setUTCSeconds(0, 0);
}, (t, e) => {
  t.setTime(+t + e * Ea);
}, (t, e) => (e - t) / Ea, (t) => t.getUTCMinutes());
h4.range;
const f4 = Rr((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * to - t.getMinutes() * Ea);
}, (t, e) => {
  t.setTime(+t + e * eo);
}, (t, e) => (e - t) / eo, (t) => t.getHours());
f4.range;
const d4 = Rr((t) => {
  t.setUTCMinutes(0, 0, 0);
}, (t, e) => {
  t.setTime(+t + e * eo);
}, (t, e) => (e - t) / eo, (t) => t.getUTCHours());
d4.range;
const Xh = Rr(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Ea) / oo,
  (t) => t.getDate() - 1
);
Xh.range;
const vp = Rr((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / oo, (t) => t.getUTCDate() - 1);
vp.range;
const hT = Rr((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / oo, (t) => Math.floor(t / oo));
hT.range;
function Fc(t) {
  return Rr((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, (e, r) => {
    e.setDate(e.getDate() + r * 7);
  }, (e, r) => (r - e - (r.getTimezoneOffset() - e.getTimezoneOffset()) * Ea) / c4);
}
const wp = Fc(0), sg = Fc(1), Qlt = Fc(2), tct = Fc(3), n0 = Fc(4), ect = Fc(5), nct = Fc(6);
wp.range;
sg.range;
Qlt.range;
tct.range;
n0.range;
ect.range;
nct.range;
function Rc(t) {
  return Rr((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, r) => {
    e.setUTCDate(e.getUTCDate() + r * 7);
  }, (e, r) => (r - e) / c4);
}
const xp = Rc(0), og = Rc(1), rct = Rc(2), ict = Rc(3), r0 = Rc(4), act = Rc(5), sct = Rc(6);
xp.range;
og.range;
rct.range;
ict.range;
r0.range;
act.range;
sct.range;
const g4 = Rr((t) => {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setMonth(t.getMonth() + e);
}, (t, e) => e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12, (t) => t.getMonth());
g4.range;
const p4 = Rr((t) => {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCMonth(t.getUTCMonth() + e);
}, (t, e) => e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12, (t) => t.getUTCMonth());
p4.range;
const lo = Rr((t) => {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setFullYear(t.getFullYear() + e);
}, (t, e) => e.getFullYear() - t.getFullYear(), (t) => t.getFullYear());
lo.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : Rr((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, r) => {
  e.setFullYear(e.getFullYear() + r * t);
});
lo.range;
const co = Rr((t) => {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, (t, e) => e.getUTCFullYear() - t.getUTCFullYear(), (t) => t.getUTCFullYear());
co.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : Rr((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCFullYear(e.getUTCFullYear() + r * t);
});
co.range;
function fT(t, e, r, i, s, c) {
  const u = [
    [nc, 1, to],
    [nc, 5, 5 * to],
    [nc, 15, 15 * to],
    [nc, 30, 30 * to],
    [c, 1, Ea],
    [c, 5, 5 * Ea],
    [c, 15, 15 * Ea],
    [c, 30, 30 * Ea],
    [s, 1, eo],
    [s, 3, 3 * eo],
    [s, 6, 6 * eo],
    [s, 12, 12 * eo],
    [i, 1, oo],
    [i, 2, 2 * oo],
    [r, 1, c4],
    [e, 1, Vx],
    [e, 3, 3 * Vx],
    [t, 1, Em]
  ];
  function l(o, g, p) {
    const n = g < o;
    n && ([o, g] = [g, o]);
    const a = p && typeof p.range == "function" ? p : f(o, g, p), d = a ? a.range(o, +g + 1) : [];
    return n ? d.reverse() : d;
  }
  function f(o, g, p) {
    const n = Math.abs(g - o) / p, a = J7(([, , b]) => b).right(u, n);
    if (a === u.length) return t.every(y9(o / Em, g / Em, p));
    if (a === 0) return ag.every(Math.max(y9(o, g, p), 1));
    const [d, m] = u[n / u[a - 1][2] < u[a][2] / n ? a - 1 : a];
    return d.every(m);
  }
  return [l, f];
}
const [oct, lct] = fT(co, p4, xp, hT, d4, h4), [cct, uct] = fT(lo, g4, wp, Xh, f4, u4);
function Pm(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function Im(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function h1(t, e, r) {
  return { y: t, m: e, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function hct(t) {
  var e = t.dateTime, r = t.date, i = t.time, s = t.periods, c = t.days, u = t.shortDays, l = t.months, f = t.shortMonths, o = f1(s), g = d1(s), p = f1(c), n = d1(c), a = f1(u), d = d1(u), m = f1(l), b = d1(l), w = f1(f), v = d1(f), h = {
    a: T,
    A: F,
    b: S,
    B: A,
    c: null,
    d: Kx,
    e: Kx,
    f: Rct,
    g: zct,
    G: qct,
    H: Pct,
    I: Ict,
    j: Fct,
    L: dT,
    m: Dct,
    M: $ct,
    p: U,
    q: K,
    Q: Jx,
    s: Qx,
    S: Lct,
    u: Nct,
    U: Bct,
    V: jct,
    w: Uct,
    W: Hct,
    x: null,
    X: null,
    y: Vct,
    Y: Xct,
    Z: Wct,
    "%": Zx
  }, x = {
    a: X,
    A: L,
    b: H,
    B: Q,
    c: null,
    d: Yx,
    e: Yx,
    f: Zct,
    g: out,
    G: cut,
    H: Gct,
    I: Kct,
    j: Yct,
    L: pT,
    m: Jct,
    M: Qct,
    p: N,
    q: V,
    Q: Jx,
    s: Qx,
    S: tut,
    u: eut,
    U: nut,
    V: rut,
    w: iut,
    W: aut,
    x: null,
    X: null,
    y: sut,
    Y: lut,
    Z: uut,
    "%": Zx
  }, _ = {
    a: R,
    A: W,
    b: z,
    B: j,
    c: $,
    d: Wx,
    e: Wx,
    f: Oct,
    g: qx,
    G: Xx,
    H: Gx,
    I: Gx,
    j: Cct,
    L: kct,
    m: Sct,
    M: Act,
    p: I,
    q: xct,
    Q: Mct,
    s: Ect,
    S: _ct,
    u: mct,
    U: yct,
    V: bct,
    w: pct,
    W: vct,
    x: B,
    X: C,
    y: qx,
    Y: Xx,
    Z: wct,
    "%": Tct
  };
  h.x = M(r, h), h.X = M(i, h), h.c = M(e, h), x.x = M(r, x), x.X = M(i, x), x.c = M(e, x);
  function M(Y, Z) {
    return function(rt) {
      var st = [], mt = -1, yt = 0, at = Y.length, nt, q, D;
      for (rt instanceof Date || (rt = /* @__PURE__ */ new Date(+rt)); ++mt < at; )
        Y.charCodeAt(mt) === 37 && (st.push(Y.slice(yt, mt)), (q = zx[nt = Y.charAt(++mt)]) != null ? nt = Y.charAt(++mt) : q = nt === "e" ? " " : "0", (D = Z[nt]) && (nt = D(rt, q)), st.push(nt), yt = mt + 1);
      return st.push(Y.slice(yt, mt)), st.join("");
    };
  }
  function O(Y, Z) {
    return function(rt) {
      var st = h1(1900, void 0, 1), mt = E(st, Y, rt += "", 0), yt, at;
      if (mt != rt.length) return null;
      if ("Q" in st) return new Date(st.Q);
      if ("s" in st) return new Date(st.s * 1e3 + ("L" in st ? st.L : 0));
      if (Z && !("Z" in st) && (st.Z = 0), "p" in st && (st.H = st.H % 12 + st.p * 12), st.m === void 0 && (st.m = "q" in st ? st.q : 0), "V" in st) {
        if (st.V < 1 || st.V > 53) return null;
        "w" in st || (st.w = 1), "Z" in st ? (yt = Im(h1(st.y, 0, 1)), at = yt.getUTCDay(), yt = at > 4 || at === 0 ? og.ceil(yt) : og(yt), yt = vp.offset(yt, (st.V - 1) * 7), st.y = yt.getUTCFullYear(), st.m = yt.getUTCMonth(), st.d = yt.getUTCDate() + (st.w + 6) % 7) : (yt = Pm(h1(st.y, 0, 1)), at = yt.getDay(), yt = at > 4 || at === 0 ? sg.ceil(yt) : sg(yt), yt = Xh.offset(yt, (st.V - 1) * 7), st.y = yt.getFullYear(), st.m = yt.getMonth(), st.d = yt.getDate() + (st.w + 6) % 7);
      } else ("W" in st || "U" in st) && ("w" in st || (st.w = "u" in st ? st.u % 7 : "W" in st ? 1 : 0), at = "Z" in st ? Im(h1(st.y, 0, 1)).getUTCDay() : Pm(h1(st.y, 0, 1)).getDay(), st.m = 0, st.d = "W" in st ? (st.w + 6) % 7 + st.W * 7 - (at + 5) % 7 : st.w + st.U * 7 - (at + 6) % 7);
      return "Z" in st ? (st.H += st.Z / 100 | 0, st.M += st.Z % 100, Im(st)) : Pm(st);
    };
  }
  function E(Y, Z, rt, st) {
    for (var mt = 0, yt = Z.length, at = rt.length, nt, q; mt < yt; ) {
      if (st >= at) return -1;
      if (nt = Z.charCodeAt(mt++), nt === 37) {
        if (nt = Z.charAt(mt++), q = _[nt in zx ? Z.charAt(mt++) : nt], !q || (st = q(Y, rt, st)) < 0) return -1;
      } else if (nt != rt.charCodeAt(st++))
        return -1;
    }
    return st;
  }
  function I(Y, Z, rt) {
    var st = o.exec(Z.slice(rt));
    return st ? (Y.p = g.get(st[0].toLowerCase()), rt + st[0].length) : -1;
  }
  function R(Y, Z, rt) {
    var st = a.exec(Z.slice(rt));
    return st ? (Y.w = d.get(st[0].toLowerCase()), rt + st[0].length) : -1;
  }
  function W(Y, Z, rt) {
    var st = p.exec(Z.slice(rt));
    return st ? (Y.w = n.get(st[0].toLowerCase()), rt + st[0].length) : -1;
  }
  function z(Y, Z, rt) {
    var st = w.exec(Z.slice(rt));
    return st ? (Y.m = v.get(st[0].toLowerCase()), rt + st[0].length) : -1;
  }
  function j(Y, Z, rt) {
    var st = m.exec(Z.slice(rt));
    return st ? (Y.m = b.get(st[0].toLowerCase()), rt + st[0].length) : -1;
  }
  function $(Y, Z, rt) {
    return E(Y, e, Z, rt);
  }
  function B(Y, Z, rt) {
    return E(Y, r, Z, rt);
  }
  function C(Y, Z, rt) {
    return E(Y, i, Z, rt);
  }
  function T(Y) {
    return u[Y.getDay()];
  }
  function F(Y) {
    return c[Y.getDay()];
  }
  function S(Y) {
    return f[Y.getMonth()];
  }
  function A(Y) {
    return l[Y.getMonth()];
  }
  function U(Y) {
    return s[+(Y.getHours() >= 12)];
  }
  function K(Y) {
    return 1 + ~~(Y.getMonth() / 3);
  }
  function X(Y) {
    return u[Y.getUTCDay()];
  }
  function L(Y) {
    return c[Y.getUTCDay()];
  }
  function H(Y) {
    return f[Y.getUTCMonth()];
  }
  function Q(Y) {
    return l[Y.getUTCMonth()];
  }
  function N(Y) {
    return s[+(Y.getUTCHours() >= 12)];
  }
  function V(Y) {
    return 1 + ~~(Y.getUTCMonth() / 3);
  }
  return {
    format: function(Y) {
      var Z = M(Y += "", h);
      return Z.toString = function() {
        return Y;
      }, Z;
    },
    parse: function(Y) {
      var Z = O(Y += "", !1);
      return Z.toString = function() {
        return Y;
      }, Z;
    },
    utcFormat: function(Y) {
      var Z = M(Y += "", x);
      return Z.toString = function() {
        return Y;
      }, Z;
    },
    utcParse: function(Y) {
      var Z = O(Y += "", !0);
      return Z.toString = function() {
        return Y;
      }, Z;
    }
  };
}
var zx = { "-": "", _: " ", 0: "0" }, Vr = /^\s*\d+/, fct = /^%/, dct = /[\\^$*+?|[\]().{}]/g;
function _n(t, e, r) {
  var i = t < 0 ? "-" : "", s = (i ? -t : t) + "", c = s.length;
  return i + (c < r ? new Array(r - c + 1).join(e) + s : s);
}
function gct(t) {
  return t.replace(dct, "\\$&");
}
function f1(t) {
  return new RegExp("^(?:" + t.map(gct).join("|") + ")", "i");
}
function d1(t) {
  return new Map(t.map((e, r) => [e.toLowerCase(), r]));
}
function pct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 1));
  return i ? (t.w = +i[0], r + i[0].length) : -1;
}
function mct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 1));
  return i ? (t.u = +i[0], r + i[0].length) : -1;
}
function yct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.U = +i[0], r + i[0].length) : -1;
}
function bct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.V = +i[0], r + i[0].length) : -1;
}
function vct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.W = +i[0], r + i[0].length) : -1;
}
function Xx(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 4));
  return i ? (t.y = +i[0], r + i[0].length) : -1;
}
function qx(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.y = +i[0] + (+i[0] > 68 ? 1900 : 2e3), r + i[0].length) : -1;
}
function wct(t, e, r) {
  var i = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(r, r + 6));
  return i ? (t.Z = i[1] ? 0 : -(i[2] + (i[3] || "00")), r + i[0].length) : -1;
}
function xct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 1));
  return i ? (t.q = i[0] * 3 - 3, r + i[0].length) : -1;
}
function Sct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.m = i[0] - 1, r + i[0].length) : -1;
}
function Wx(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.d = +i[0], r + i[0].length) : -1;
}
function Cct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 3));
  return i ? (t.m = 0, t.d = +i[0], r + i[0].length) : -1;
}
function Gx(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.H = +i[0], r + i[0].length) : -1;
}
function Act(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.M = +i[0], r + i[0].length) : -1;
}
function _ct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 2));
  return i ? (t.S = +i[0], r + i[0].length) : -1;
}
function kct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 3));
  return i ? (t.L = +i[0], r + i[0].length) : -1;
}
function Oct(t, e, r) {
  var i = Vr.exec(e.slice(r, r + 6));
  return i ? (t.L = Math.floor(i[0] / 1e3), r + i[0].length) : -1;
}
function Tct(t, e, r) {
  var i = fct.exec(e.slice(r, r + 1));
  return i ? r + i[0].length : -1;
}
function Mct(t, e, r) {
  var i = Vr.exec(e.slice(r));
  return i ? (t.Q = +i[0], r + i[0].length) : -1;
}
function Ect(t, e, r) {
  var i = Vr.exec(e.slice(r));
  return i ? (t.s = +i[0], r + i[0].length) : -1;
}
function Kx(t, e) {
  return _n(t.getDate(), e, 2);
}
function Pct(t, e) {
  return _n(t.getHours(), e, 2);
}
function Ict(t, e) {
  return _n(t.getHours() % 12 || 12, e, 2);
}
function Fct(t, e) {
  return _n(1 + Xh.count(lo(t), t), e, 3);
}
function dT(t, e) {
  return _n(t.getMilliseconds(), e, 3);
}
function Rct(t, e) {
  return dT(t, e) + "000";
}
function Dct(t, e) {
  return _n(t.getMonth() + 1, e, 2);
}
function $ct(t, e) {
  return _n(t.getMinutes(), e, 2);
}
function Lct(t, e) {
  return _n(t.getSeconds(), e, 2);
}
function Nct(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function Bct(t, e) {
  return _n(wp.count(lo(t) - 1, t), e, 2);
}
function gT(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? n0(t) : n0.ceil(t);
}
function jct(t, e) {
  return t = gT(t), _n(n0.count(lo(t), t) + (lo(t).getDay() === 4), e, 2);
}
function Uct(t) {
  return t.getDay();
}
function Hct(t, e) {
  return _n(sg.count(lo(t) - 1, t), e, 2);
}
function Vct(t, e) {
  return _n(t.getFullYear() % 100, e, 2);
}
function zct(t, e) {
  return t = gT(t), _n(t.getFullYear() % 100, e, 2);
}
function Xct(t, e) {
  return _n(t.getFullYear() % 1e4, e, 4);
}
function qct(t, e) {
  var r = t.getDay();
  return t = r >= 4 || r === 0 ? n0(t) : n0.ceil(t), _n(t.getFullYear() % 1e4, e, 4);
}
function Wct(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + _n(e / 60 | 0, "0", 2) + _n(e % 60, "0", 2);
}
function Yx(t, e) {
  return _n(t.getUTCDate(), e, 2);
}
function Gct(t, e) {
  return _n(t.getUTCHours(), e, 2);
}
function Kct(t, e) {
  return _n(t.getUTCHours() % 12 || 12, e, 2);
}
function Yct(t, e) {
  return _n(1 + vp.count(co(t), t), e, 3);
}
function pT(t, e) {
  return _n(t.getUTCMilliseconds(), e, 3);
}
function Zct(t, e) {
  return pT(t, e) + "000";
}
function Jct(t, e) {
  return _n(t.getUTCMonth() + 1, e, 2);
}
function Qct(t, e) {
  return _n(t.getUTCMinutes(), e, 2);
}
function tut(t, e) {
  return _n(t.getUTCSeconds(), e, 2);
}
function eut(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function nut(t, e) {
  return _n(xp.count(co(t) - 1, t), e, 2);
}
function mT(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? r0(t) : r0.ceil(t);
}
function rut(t, e) {
  return t = mT(t), _n(r0.count(co(t), t) + (co(t).getUTCDay() === 4), e, 2);
}
function iut(t) {
  return t.getUTCDay();
}
function aut(t, e) {
  return _n(og.count(co(t) - 1, t), e, 2);
}
function sut(t, e) {
  return _n(t.getUTCFullYear() % 100, e, 2);
}
function out(t, e) {
  return t = mT(t), _n(t.getUTCFullYear() % 100, e, 2);
}
function lut(t, e) {
  return _n(t.getUTCFullYear() % 1e4, e, 4);
}
function cut(t, e) {
  var r = t.getUTCDay();
  return t = r >= 4 || r === 0 ? r0(t) : r0.ceil(t), _n(t.getUTCFullYear() % 1e4, e, 4);
}
function uut() {
  return "+0000";
}
function Zx() {
  return "%";
}
function Jx(t) {
  return +t;
}
function Qx(t) {
  return Math.floor(+t / 1e3);
}
var gu, yT, bT;
hut({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function hut(t) {
  return gu = hct(t), yT = gu.format, gu.parse, bT = gu.utcFormat, gu.utcParse, gu;
}
function fut(t) {
  return new Date(t);
}
function dut(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function m4(t, e, r, i, s, c, u, l, f, o) {
  var g = e4(), p = g.invert, n = g.domain, a = o(".%L"), d = o(":%S"), m = o("%I:%M"), b = o("%I %p"), w = o("%a %d"), v = o("%b %d"), h = o("%B"), x = o("%Y");
  function _(M) {
    return (f(M) < M ? a : l(M) < M ? d : u(M) < M ? m : c(M) < M ? b : i(M) < M ? s(M) < M ? w : v : r(M) < M ? h : x)(M);
  }
  return g.invert = function(M) {
    return new Date(p(M));
  }, g.domain = function(M) {
    return arguments.length ? n(Array.from(M, dut)) : n().map(fut);
  }, g.ticks = function(M) {
    var O = n();
    return t(O[0], O[O.length - 1], M ?? 10);
  }, g.tickFormat = function(M, O) {
    return O == null ? _ : o(O);
  }, g.nice = function(M) {
    var O = n();
    return (!M || typeof M.range != "function") && (M = e(O[0], O[O.length - 1], M ?? 10)), M ? n(iT(O, M)) : g;
  }, g.copy = function() {
    return zh(g, m4(t, e, r, i, s, c, u, l, f, o));
  }, g;
}
function gut() {
  return Na.apply(m4(cct, uct, lo, g4, wp, Xh, f4, u4, nc, yT).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function put() {
  return Na.apply(m4(oct, lct, co, p4, xp, vp, d4, h4, nc, bT).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Sp() {
  var t = 0, e = 1, r, i, s, c, u = Ti, l = !1, f;
  function o(p) {
    return p == null || isNaN(p = +p) ? f : u(s === 0 ? 0.5 : (p = (c(p) - r) * s, l ? Math.max(0, Math.min(1, p)) : p));
  }
  o.domain = function(p) {
    return arguments.length ? ([t, e] = p, r = c(t = +t), i = c(e = +e), s = r === i ? 0 : 1 / (i - r), o) : [t, e];
  }, o.clamp = function(p) {
    return arguments.length ? (l = !!p, o) : l;
  }, o.interpolator = function(p) {
    return arguments.length ? (u = p, o) : u;
  };
  function g(p) {
    return function(n) {
      var a, d;
      return arguments.length ? ([a, d] = n, u = p(a, d), o) : [u(0), u(1)];
    };
  }
  return o.range = g(Ps), o.rangeRound = g($7), o.unknown = function(p) {
    return arguments.length ? (f = p, o) : f;
  }, function(p) {
    return c = p, r = p(t), i = p(e), s = r === i ? 0 : 1 / (i - r), o;
  };
}
function vl(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function vT() {
  var t = bl(Sp()(Ti));
  return t.copy = function() {
    return vl(t, vT());
  }, mo.apply(t, arguments);
}
function wT() {
  var t = a4(Sp()).domain([1, 10]);
  return t.copy = function() {
    return vl(t, wT()).base(t.base());
  }, mo.apply(t, arguments);
}
function xT() {
  var t = s4(Sp());
  return t.copy = function() {
    return vl(t, xT()).constant(t.constant());
  }, mo.apply(t, arguments);
}
function y4() {
  var t = o4(Sp());
  return t.copy = function() {
    return vl(t, y4()).exponent(t.exponent());
  }, mo.apply(t, arguments);
}
function mut() {
  return y4.apply(null, arguments).exponent(0.5);
}
function ST() {
  var t = [], e = Ti;
  function r(i) {
    if (i != null && !isNaN(i = +i)) return e((Vh(t, i, 1) - 1) / (t.length - 1));
  }
  return r.domain = function(i) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let s of i) s != null && !isNaN(s = +s) && t.push(s);
    return t.sort(Go), r;
  }, r.interpolator = function(i) {
    return arguments.length ? (e = i, r) : e;
  }, r.range = function() {
    return t.map((i, s) => e(s / (t.length - 1)));
  }, r.quantiles = function(i) {
    return Array.from({ length: i + 1 }, (s, c) => _lt(t, c / i));
  }, r.copy = function() {
    return ST(e).domain(t);
  }, mo.apply(r, arguments);
}
function Cp() {
  var t = 0, e = 0.5, r = 1, i = 1, s, c, u, l, f, o = Ti, g, p = !1, n;
  function a(m) {
    return isNaN(m = +m) ? n : (m = 0.5 + ((m = +g(m)) - c) * (i * m < i * c ? l : f), o(p ? Math.max(0, Math.min(1, m)) : m));
  }
  a.domain = function(m) {
    return arguments.length ? ([t, e, r] = m, s = g(t = +t), c = g(e = +e), u = g(r = +r), l = s === c ? 0 : 0.5 / (c - s), f = c === u ? 0 : 0.5 / (u - c), i = c < s ? -1 : 1, a) : [t, e, r];
  }, a.clamp = function(m) {
    return arguments.length ? (p = !!m, a) : p;
  }, a.interpolator = function(m) {
    return arguments.length ? (o = m, a) : o;
  };
  function d(m) {
    return function(b) {
      var w, v, h;
      return arguments.length ? ([w, v, h] = b, o = Ztt(m, [w, v, h]), a) : [o(0), o(0.5), o(1)];
    };
  }
  return a.range = d(Ps), a.rangeRound = d($7), a.unknown = function(m) {
    return arguments.length ? (n = m, a) : n;
  }, function(m) {
    return g = m, s = m(t), c = m(e), u = m(r), l = s === c ? 0 : 0.5 / (c - s), f = c === u ? 0 : 0.5 / (u - c), i = c < s ? -1 : 1, a;
  };
}
function CT() {
  var t = bl(Cp()(Ti));
  return t.copy = function() {
    return vl(t, CT());
  }, mo.apply(t, arguments);
}
function AT() {
  var t = a4(Cp()).domain([0.1, 1, 10]);
  return t.copy = function() {
    return vl(t, AT()).base(t.base());
  }, mo.apply(t, arguments);
}
function _T() {
  var t = s4(Cp());
  return t.copy = function() {
    return vl(t, _T()).constant(t.constant());
  }, mo.apply(t, arguments);
}
function b4() {
  var t = o4(Cp());
  return t.copy = function() {
    return vl(t, b4()).exponent(t.exponent());
  }, mo.apply(t, arguments);
}
function yut() {
  return b4.apply(null, arguments).exponent(0.5);
}
const but = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: t4,
  scaleDiverging: CT,
  scaleDivergingLog: AT,
  scaleDivergingPow: b4,
  scaleDivergingSqrt: yut,
  scaleDivergingSymlog: _T,
  scaleIdentity: rT,
  scaleImplicit: b9,
  scaleLinear: i4,
  scaleLog: aT,
  scaleOrdinal: Q7,
  scalePoint: Tlt,
  scalePow: l4,
  scaleQuantile: lT,
  scaleQuantize: cT,
  scaleRadial: oT,
  scaleSequential: vT,
  scaleSequentialLog: wT,
  scaleSequentialPow: y4,
  scaleSequentialQuantile: ST,
  scaleSequentialSqrt: mut,
  scaleSequentialSymlog: xT,
  scaleSqrt: Zlt,
  scaleSymlog: sT,
  scaleThreshold: uT,
  scaleTime: gut,
  scaleUtc: put,
  tickFormat: nT
}, Symbol.toStringTag, { value: "Module" }));
var vut = ["linear", "time", "log", "sqrt"];
function wut(t) {
  var e = function(r) {
    return r && r[0].toUpperCase() + r.slice(1);
  };
  return "scale".concat(e(t));
}
function kT(t) {
  return typeof t == "function" ? Cn(t.copy) && Cn(t.domain) && Cn(t.range) : typeof t == "string" ? vut.includes(t) : !1;
}
function OT(t, e) {
  if (t.scale) {
    if (t.scale.x || t.scale.y)
      return !!t.scale[e];
  } else return !1;
  return !0;
}
function xut(t, e) {
  if (OT(t, e)) {
    var r = t.scale[e] || t.scale;
    return typeof r == "string" ? r : MT(r);
  }
}
function Sut(t, e) {
  var r;
  if (t.domain && t.domain[e] ? r = t.domain[e] : t.domain && Array.isArray(t.domain) && (r = t.domain), !!r)
    return ol(r) ? "time" : "linear";
}
function TT(t, e) {
  if (!t.data)
    return "linear";
  var r = U7(t[e]), i = t.data.map(function(s) {
    var c = Ur(r(s)) ? r(s)[e] : r(s);
    return c !== void 0 ? c : s[e];
  });
  return ol(i) ? "time" : "linear";
}
function fh(t) {
  if (kT(t)) {
    var e = wut(t);
    return but[e]();
  }
  return i4();
}
function ll(t, e) {
  var r = w9(t, e);
  if (r)
    return typeof r == "string" ? fh(r) : r;
  var i = Sut(t, e) || TT(t, e);
  return fh(i);
}
function w9(t, e) {
  if (OT(t, e)) {
    var r = t.scale[e] || t.scale;
    if (kT(r))
      return Cn(r) ? r : fh(r);
  }
}
function lg(t, e) {
  return xut(t, e) || TT(t, e);
}
var Cut = [
  {
    name: "quantile",
    method: "quantiles"
  },
  {
    name: "log",
    method: "base"
  }
  // TODO(2214): Re-evaluate (1) duck typing approach, and (2) if duck typing,
  //   do we need a different approach? (Multiple keys? Stringifying functions?)
  // https://github.com/FormidableLabs/victory/issues/2214
  // Below are matches that don't seem to otherwise occur in Victory code base.
  // { name: "ordinal", method: "unknown" },
  // { name: "pow-sqrt", method: "exponent" },
  // { name: "quantize-threshold", method: "invertExtent" }
];
function MT(t) {
  if (typeof t == "string")
    return t;
  var e = Cut.filter(function(r) {
    return t[r.method] !== void 0;
  })[0];
  return e ? e.name : void 0;
}
var Aut = "@@__IMMUTABLE_ITERABLE__@@", _ut = "@@__IMMUTABLE_RECORD__@@", kut = "@@__IMMUTABLE_LIST__@@";
function qh(t) {
  return !!(t && t[Aut]);
}
function Out(t) {
  return !!(t && t[_ut]);
}
function Tut(t) {
  return qh(t) || Out(t);
}
function Mut(t) {
  return !!(t && t[kut]);
}
function ET(t, e) {
  return qh(t) ? t.reduce(function(r, i, s) {
    var c = i;
    return e && e[s] && (c = ET(i)), r[s] = c, r;
  }, Mut(t) ? [] : {}) : t;
}
function B1(t) {
  return Fut(t) || Iut(t) || Put(t) || Eut();
}
function Eut() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Put(t, e) {
  if (t) {
    if (typeof t == "string") return x9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return x9(t, e);
  }
}
function Iut(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Fut(t) {
  if (Array.isArray(t)) return x9(t);
}
function x9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function S9(t) {
  var e = {
    errorX: !0,
    errorY: !0
  };
  return Tut(t) ? ET(t, e) : t;
}
function Rut(t) {
  return qh(t) ? t.size : t.length;
}
function tS(t, e) {
  var r = Ur(t.domain) ? t.domain[e] : t.domain, i = r || ll(t, e).domain(), s = t.samples || 1, c = Math.max.apply(Math, B1(i)), u = Math.min.apply(Math, B1(i)), l = (c - u) / s, f = wO(u, c, l);
  return f[f.length - 1] === c ? f : f.concat(c);
}
function PT(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "ascending";
  if (!e)
    return t;
  var i = e;
  (e === "x" || e === "y") && (i = "_".concat(e));
  var s = r === "ascending" ? "asc" : "desc";
  return pp(t, i, s);
}
function Dut(t, e) {
  var r = 1 / Number.MAX_SAFE_INTEGER, i = {
    x: lg(e, "x"),
    y: lg(e, "y")
  };
  if (i.x !== "log" && i.y !== "log")
    return t;
  var s = function(u, l) {
    return i[l] === "log" ? u["_".concat(l)] !== 0 : !0;
  }, c = function(u) {
    var l = s(u, "x") ? u._x : r, f = s(u, "y") ? u._y : r, o = s(u, "y0") ? u._y0 : r;
    return Object.assign({}, u, {
      _x: l,
      _y: f,
      _y0: o
    });
  };
  return t.map(function(u) {
    return s(u, "x") && s(u, "y") && s(u, "y0") ? u : c(u);
  });
}
function $ut(t) {
  return Cn(t) ? t : t == null ? function() {
  } : Zk(t);
}
function Lut(t, e) {
  var r = !!t.eventKey, i = $ut(t.eventKey);
  return e.map(function(s, c) {
    if (s.eventKey !== void 0)
      return s;
    if (r) {
      var u = i(s, c);
      return u !== void 0 ? Object.assign({
        eventKey: u
      }, s) : s;
    }
    return s;
  });
}
function Nut(t, e, r) {
  var i = function(d) {
    return d !== void 0;
  }, s = da(e.x), c = es(e.x), u = da(e.y), l = es(e.y), f = function(d) {
    return function(m) {
      return i(m) && m < d;
    };
  }, o = function(d) {
    return function(m) {
      return i(m) && m > d;
    };
  }, g = f(s), p = f(u), n = o(c), a = o(l);
  return t.map(function(d) {
    var m = d._x, b = d._y, w = d._y0, v = d._y1;
    (g(m) || n(m)) && (m = null);
    var h = i(w) ? w : r, x = i(v) ? v : b;
    return i(x) ? (!i(h) && (p(x) || a(x)) && (b = null), (p(h) && p(x) || a(h) && a(x)) && (b = w = v = null), p(h) && !p(x) && (w = u), a(h) && !a(x) && (w = l), Object.assign({}, d, BO({
      _x: m,
      _y: b,
      _y0: w,
      _y1: v
    }, clt))) : d;
  });
}
function Fm(t, e) {
  var r = IT(t, e), i = FT(t, e), s = jut(t, e), c = xc([].concat(B1(r), B1(i), B1(s)));
  return c.length === 0 ? null : c.reduce(function(u, l, f) {
    return u[l] = f + 1, u;
  }, {});
}
function eS(t, e, r) {
  var i = Array.isArray(t) || qh(t);
  if (!i || Rut(t) < 1)
    return [];
  var s = ["x", "y", "y0"];
  r = Array.isArray(r) ? r : s;
  var c = function(n) {
    return U7(e[n] !== void 0 ? e[n] : n);
  }, u = r.reduce(function(n, a) {
    return n[a] = c(a), n;
  }, {}), l = dlt(r, s) && e.x === "_x" && e.y === "_y" && e.y0 === "_y0", f;
  l === !1 && (f = {
    x: r.indexOf("x") !== -1 ? Fm(e, "x") : void 0,
    y: r.indexOf("y") !== -1 ? Fm(e, "y") : void 0,
    y0: r.indexOf("y0") !== -1 ? Fm(e, "y") : void 0
  });
  var o = l ? t : t.reduce(function(n, a, d) {
    var m = S9(a), b = {
      x: d,
      y: m
    }, w = r.reduce(function(h, x) {
      var _ = u[x](m), M = _ !== void 0 ? _ : b[x];
      return M !== void 0 && (typeof M == "string" && f[x] ? (h["".concat(x, "Name")] = M, h["_".concat(x)] = f[x][M]) : h["_".concat(x)] = M), h;
    }, {}), v = Object.assign({}, w, m);
    return ar(v) || n.push(v), n;
  }, []), g = PT(o, e.sortKey, e.sortOrder), p = Dut(g, e);
  return Lut(e, p);
}
function But(t) {
  var e = tS(t, "x"), r = tS(t, "y"), i = e.map(function(s, c) {
    return {
      x: s,
      y: r[c]
    };
  });
  return i;
}
function v4(t, e) {
  return t.categories && !Array.isArray(t.categories) ? t.categories[e] : t.categories;
}
function wl(t) {
  return t.data ? eS(t.data, t) : eS(But(t), t);
}
function IT(t, e) {
  var r = t.tickValues, i = t.tickFormat, s;
  return !r || !Array.isArray(r) && !r[e] ? s = i && Array.isArray(i) ? i : [] : s = r[e] || r, s.filter(function(c) {
    return typeof c == "string";
  });
}
function FT(t, e) {
  if (!t.categories)
    return [];
  var r = v4(t, e), i = r && r.filter(function(s) {
    return typeof s == "string";
  });
  return i ? FO(i) : [];
}
function jut(t, e) {
  var r = Array.isArray(t.data) || qh(t.data);
  if (!r)
    return [];
  var i = t[e] === void 0 ? e : t[e], s = U7(i), c = t.data.reduce(function(f, o) {
    return f.push(S9(o)), f;
  }, []), u = PT(c, t.sortKey, t.sortOrder), l = u.reduce(function(f, o) {
    var g = S9(o);
    return f.push(s(g)), f;
  }, []).filter(function(f) {
    return typeof f == "string";
  });
  return l.reduce(function(f, o) {
    return o != null && f.indexOf(o) === -1 && f.push(o), f;
  }, []);
}
function RT(t) {
  var e = function(c) {
    return c && c.type ? c.type.role : "";
  }, r = e(t);
  if (r === "portal") {
    var i = Bt.Children.toArray(t.props.children);
    r = i.length ? e(i[0]) : "";
  }
  var s = ["area", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"];
  return s.includes(r);
}
function nS(t) {
  return zut(t) || Vut(t) || Hut(t) || Uut();
}
function Uut() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hut(t, e) {
  if (t) {
    if (typeof t == "string") return C9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C9(t, e);
  }
}
function Vut(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function zut(t) {
  if (Array.isArray(t)) return C9(t);
}
function C9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function Xut(t, e, r) {
  var i = lg(e, r);
  if (i !== "log")
    return t;
  var s = function(c) {
    var u = c[0] < 0 || c[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER, l = c[0] === 0 ? u : c[0], f = c[1] === 0 ? u : c[1];
    return [l, f];
  };
  return s(t);
}
function qut(t, e) {
  var r = function(i) {
    return Array.isArray(i) ? {
      left: i[0],
      right: i[1]
    } : {
      left: i,
      right: i
    };
  };
  return Ur(t.domainPadding) ? r(t.domainPadding[e]) : r(t.domainPadding);
}
function Wut(t, e) {
  var r = "_".concat(e);
  return t.flat().map(function(i) {
    return i[r] && i[r][1] !== void 0 ? i[r][1] : i[r];
  });
}
function rS(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "min", i = function(l) {
    return r === "max" ? Math.max.apply(Math, nS(l)) : Math.min.apply(Math, nS(l));
  }, s = r === "max" ? -1 / 0 : 1 / 0, c = !1, u = t.flat().reduce(function(l, f) {
    var o = f["_".concat(e, "0")] !== void 0 ? f["_".concat(e, "0")] : f["_".concat(e)], g = f["_".concat(e, "1")] !== void 0 ? f["_".concat(e, "1")] : f["_".concat(e)], p = i([o, g]);
    return c = c || o instanceof Date || g instanceof Date, i([l, p]);
  }, s);
  return c ? new Date(u) : u;
}
function Gut(t, e, r) {
  if (!e.domainPadding)
    return t;
  var i = $c(e, r), s = Dc(e, r), c = qut(e, r);
  if (!c.left && !c.right)
    return t;
  var u = da(t), l = es(t), f = brt(r, e.horizontal), o = $a(e, f), g = Math.abs(o[0] - o[1]), p = Math.max(g - c.left - c.right, 1), n = Math.abs(l.valueOf() - u.valueOf()) / p * g, a = {
    left: n * c.left / g,
    right: n * c.right / g
  }, d = {
    min: u.valueOf() - a.left,
    max: l.valueOf() + a.right
  }, m = Ur(e.singleQuadrantDomainPadding) ? e.singleQuadrantDomainPadding[r] : e.singleQuadrantDomainPadding, b = u >= 0 && d.min <= 0 || l <= 0 && d.max >= 0, w = function(M, O) {
    var E = O === "min" && u >= 0 && M <= 0 || O === "max" && l <= 0 && M >= 0;
    return E ? 0 : M;
  };
  if (b && m !== !1) {
    var v = {
      // @ts-expect-error `max/min` might be dates
      left: Math.abs(l - u) * c.left / g,
      // @ts-expect-error `max/min` might be dates
      right: Math.abs(l - u) * c.right / g
    }, h = {
      min: w(u.valueOf() - v.left, "min"),
      max: w(l.valueOf() + v.right, "max")
    }, x = {
      left: Math.abs(h.max - h.min) * c.left / g,
      right: Math.abs(h.max - h.min) * c.right / g
    };
    d = {
      min: w(u.valueOf() - x.left, "min"),
      max: w(l.valueOf() + x.right, "max")
    };
  }
  var _ = {
    min: i !== void 0 ? i : d.min,
    max: s !== void 0 ? s : d.max
  };
  return u instanceof Date || l instanceof Date ? uo(new Date(_.min), new Date(_.max)) : uo(_.min, _.max);
}
function w4(t, e) {
  var r = Cn(t) ? t : S4, i = Cn(e) ? e : x4;
  return function(s, c) {
    var u = C4(s, c);
    if (u)
      return i(u, s, c);
    var l = v4(s, c), f = l ? Yut(s, c, l) : r(s, c);
    return f ? i(f, s, c) : void 0;
  };
}
function x4(t, e, r) {
  return Xut(Gut(t, e, r), e, r);
}
function Kut(t, e) {
  return w4()(t, e);
}
function Yut(t, e, r) {
  var i = r || v4(t, e), s = t.polar, c = t.startAngle, u = c === void 0 ? 0 : c, l = t.endAngle, f = l === void 0 ? 360 : l;
  if (i) {
    var o = $c(t, e), g = Dc(t, e), p = W2(i) ? FT(t, e) : [], n = p.length === 0 ? null : p.reduce(function(w, v, h) {
      return w[v] = h + 1, w;
    }, {}), a = n ? i.map(function(w) {
      return n[w];
    }) : i, d = o !== void 0 ? o : da(a), m = g !== void 0 ? g : es(a), b = uo(d, m);
    return s && e === "x" && Math.abs(u - f) === 360 ? A4(b, a) : b;
  }
}
function S4(t, e, r) {
  var i = r || wl(t), s = t.polar, c = t.startAngle, u = c === void 0 ? 0 : c, l = t.endAngle, f = l === void 0 ? 360 : l, o = $c(t, e), g = Dc(t, e);
  if (i.length < 1)
    return o !== void 0 && g !== void 0 ? uo(o, g) : void 0;
  var p = o !== void 0 ? o : rS(i, e, "min"), n = g !== void 0 ? g : rS(i, e, "max"), a = uo(p, n);
  return s && e === "x" && Math.abs(u - f) === 360 ? A4(a, Wut(i, e)) : a;
}
function uo(t, e) {
  var r = function(i) {
    var s = (
      // eslint-disable-next-line no-magic-numbers
      i === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10)
    ), c = 1, u = i instanceof Date ? new Date(Number(i) - c) : Number(i) - s, l = i instanceof Date ? new Date(Number(i) + c) : Number(i) + s;
    return i === 0 ? [0, l] : [u, l];
  };
  return Number(t) === Number(e) ? r(e) : [t, e];
}
function C4(t, e) {
  var r = $c(t, e), i = Dc(t, e);
  if (Ur(t.domain) && t.domain[e])
    return t.domain[e];
  if (Array.isArray(t.domain))
    return t.domain;
  if (r !== void 0 && i !== void 0)
    return uo(r, i);
}
function A9(t, e) {
  var r = C4(t, e);
  if (r)
    return r;
  var i = wl(t), s = i.reduce(function(f, o) {
    return o._y0 < f ? o._y0 : f;
  }, 1 / 0), c = function(f) {
    if (e === "x")
      return f;
    var o = s !== 1 / 0 ? s : 0, g = Dc(t, e), p = $c(t, e), n = g !== void 0 ? g : es(f, o), a = p !== void 0 ? p : da(f, o);
    return uo(a, n);
  }, u = function() {
    return S4(t, e, i);
  }, l = function(f) {
    return x4(c(f), t, e);
  };
  return w4(u, l)(t, e);
}
function Dc(t, e) {
  return Ur(t.maxDomain) && t.maxDomain[e] !== void 0 ? t.maxDomain[e] : typeof t.maxDomain == "number" || KO(t.maxDomain) ? t.maxDomain : void 0;
}
function $c(t, e) {
  return Ur(t.minDomain) && t.minDomain[e] !== void 0 ? t.minDomain[e] : typeof t.minDomain == "number" || KO(t.minDomain) ? t.minDomain : void 0;
}
function A4(t, e) {
  var r = slt(e.sort(function(s, c) {
    return s - c;
  })), i = r[1] - r[0];
  return [t[0], t[1] + i];
}
function DT(t) {
  var e = function(c) {
    return c && c.type ? c.type.role : "";
  }, r = e(t);
  if (r === "portal") {
    var i = Bt.Children.toArray(t.props.children);
    r = i.length ? e(i[0]) : "";
  }
  var s = ["area", "axis", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"];
  return s.includes(r);
}
function Tu(t) {
  return t0t(t) || Qut(t) || Jut(t) || Zut();
}
function Zut() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Jut(t, e) {
  if (t) {
    if (typeof t == "string") return _9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _9(t, e);
  }
}
function Qut(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function t0t(t) {
  if (Array.isArray(t)) return _9(t);
}
function _9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function e0t(t) {
  return t;
}
function Ba(t) {
  var e = t.dependentAxis;
  return e ? "y" : "x";
}
function $T(t, e) {
  var r = e || e0t, i = function(s) {
    return s.reduce(function(c, u) {
      return u.type && u.type.role === "axis" && r(u) ? c.concat(u) : u.props && u.props.children ? c.concat(i(Bt.Children.toArray(u.props.children))) : c;
    }, []);
  };
  return i(t);
}
function LT(t, e) {
  var r = function(i) {
    var s = i.type.getAxis(i.props);
    return s === e;
  };
  return $T(t, r)[0];
}
function iS(t, e) {
  var r = function(s) {
    return e === "dependent" ? s.props.dependentAxis : !s.props.dependentAxis;
  }, i = function(s) {
    return s.reduce(function(c, u) {
      if (u.type && u.type.role === "axis" && r(u))
        return c.concat(u);
      if (u.props && u.props.children) {
        var l = i(Bt.Children.toArray(u.props.children));
        return l.length > 0 ? c.concat(u) : c;
      }
      return c;
    }, []);
  };
  return i(t);
}
function NT(t) {
  var e = function(r) {
    var i = Math.min.apply(Math, Tu(r)), s = Math.max.apply(Math, Tu(r));
    return s < 0 ? s : Math.max(0, i);
  };
  return {
    x: ol(t.x) ? new Date(Math.min.apply(Math, Tu(t.x))) : e(t.x),
    y: ol(t.y) ? new Date(Math.min.apply(Math, Tu(t.y))) : e(t.y)
  };
}
function aS(t, e) {
  var r = function() {
    return t <= 0 && Math.max.apply(Math, Tu(e)) <= 0 ? "negative" : "positive";
  };
  return ol(e) ? "positive" : r();
}
function Ap(t) {
  var e = t.orientation || (t.dependentAxis ? "left" : "bottom"), r = {
    top: !1,
    bottom: !1,
    left: !0,
    right: !0
  };
  return r[e];
}
function _p(t) {
  return t.tickValues !== void 0 && W2(t.tickValues);
}
function n0t(t) {
  var e = t.tickValues, r = Ba(t), i = t.stringMap && t.stringMap[r], s = e && !ol(e) ? function(o) {
    return o;
  } : void 0;
  if (!i)
    return _p(t) ? function(o, g) {
      return e[g];
    } : s;
  var c = i && bO(i), u = pp(Object.values(i), function(o) {
    return o;
  }), l = u.map(function(o) {
    return c[o];
  }), f = [""].concat(Tu(l), [""]);
  return function(o) {
    return f[o];
  };
}
function r0t(t) {
  var e = Ba(t), r = t.stringMap && t.stringMap[e], i = Array.isArray(t.categories) ? t.categories : t.categories && t.categories[e], s = i && wat(i) ? i.map(function(u) {
    return r[u];
  }) : void 0, c = r && Object.values(r);
  return s && s.length !== 0 ? s : c;
}
function _4(t) {
  var e = t.tickValues, r = t.tickFormat;
  if ((e == null ? void 0 : e.length) === 0)
    return [];
  var i = Ba(t), s = t.stringMap && t.stringMap[i], c = function() {
    if (!(!r || !Array.isArray(r)))
      return W2(r) ? r.map(function(o, g) {
        return g;
      }) : r;
  }, u = e;
  s && (u = r0t(t)), e && W2(e) && (u = s ? e.map(function(o) {
    return s[o];
  }) : wO(1, e.length + 1));
  var l = u ? xc(u) : c(), f = function(o) {
    var g = [], p = t.domain && t.domain[i] || t.domain;
    if (o)
      return o.forEach(function(n, a) {
        Array.isArray(p) ? n >= da(p) && n <= es(p) && g.push({
          value: n,
          index: a
        }) : g.push({
          value: n,
          index: a
        });
      }), g;
  };
  return Array.isArray(l) && l.length ? f(l) : void 0;
}
function BT(t, e) {
  var r = t.tickFormat, i = Ba(t), s = t.stringMap && t.stringMap[i];
  if (r) {
    if (r && Array.isArray(r)) {
      var l = _4(t), f = l == null ? void 0 : l.map(function(p) {
        return p.index;
      }), o = r.filter(function(p, n) {
        return f == null ? void 0 : f.includes(n);
      });
      return function(p, n) {
        return o[n];
      };
    } else if (r && Cn(r)) {
      var g = function(p, n, a) {
        var d = bO(s), m = a.map(function(b) {
          return d[b];
        });
        return t.tickFormat(d[p], n, m);
      };
      return s ? g : r;
    }
  } else {
    var c = n0t(t), u = e.tickFormat && Cn(e.tickFormat) ? e.tickFormat() : function(p) {
      return p;
    };
    return c || u;
  }
  return function(p) {
    return p;
  };
}
function sS(t, e) {
  if (!e || !Array.isArray(t) || t.length <= e)
    return t;
  var r = Math.floor(t.length / e);
  return t.filter(function(i, s) {
    return s % r === 0;
  });
}
function jT(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = t.tickCount, s = _4(t);
  if ((s == null ? void 0 : s.length) === 0)
    return [""];
  var c = s ? s.map(function(p) {
    return p.value;
  }) : void 0;
  if (c)
    return sS(c, i);
  if (e.ticks && Cn(e.ticks)) {
    var u = i || 5, l = e.ticks(u), f = Array.isArray(l) && l.length ? l : e.domain(), o = sS(f, i);
    if (r) {
      var g = o.filter(function(p) {
        return p !== 0;
      });
      return g.length ? g : o;
    }
    return o;
  }
  return e.domain();
}
function i0t(t, e) {
  var r = t.polar, i = t.startAngle, s = i === void 0 ? 0 : i, c = t.endAngle, u = c === void 0 ? 360 : c, l = _4(t), f = l && (l == null ? void 0 : l.length) !== 0 ? l.map(function(h) {
    return h.value;
  }) : void 0;
  if (Array.isArray(f)) {
    var o = $c(t, e), g = Dc(t, e), p = _p(t), n = f.map(function(h) {
      return Number(h);
    }), a = p ? 1 : da(n), d = p ? f.length : es(n), m = o !== void 0 ? o : a, b = g !== void 0 ? g : d, w = uo(m, b), v = r && e === "x" && Math.abs(s - u) === 360 ? A4(w, n) : w;
    return Ap(t) && !r && v.reverse(), v;
  }
}
function T0(t, e) {
  var r = Ba(t);
  if (!(e && e !== r))
    return w4(i0t)(t, r);
}
function UT(t, e) {
  if (t.axisValue) {
    var r = e === "x" ? "y" : "x", i = O2(t.scale) && Cn(t.scale[r]) ? t.scale[r] : void 0;
    if (i) {
      var s = e === "x" ? "y" : "x", c = O2(t.stringMap) && t.stringMap[s], u = c && typeof t.axisValue == "string" ? c[t.axisValue] : t.axisValue;
      return i(u);
    }
  }
}
function kp(t, e) {
  if (!O2(t.theme))
    return qo(t, e, "axis");
  var r = "axis";
  if (t.dependentAxis && t.theme.dependentAxis ? r = "dependentAxis" : !t.dependentAxis && t.theme.independentAxis && (r = "independentAxis"), r === "axis")
    return qo(t, e, "axis");
  var i = Ie({}, t.theme[r], t.theme.axis), s = Object.assign({}, t.theme, {
    axis: i
  });
  return qo(Object.assign({}, t, {
    theme: s
  }), e, "axis");
}
function a0t(t) {
  var e = Bt.useRef();
  return Bt.useEffect(function() {
    e.current = t;
  }), e.current;
}
function oS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function lS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? oS(Object(r), !0).forEach(function(i) {
      s0t(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : oS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function s0t(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function o0t(t, e) {
  return h0t(t) || u0t(t, e) || c0t(t, e) || l0t();
}
function l0t() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c0t(t, e) {
  if (t) {
    if (typeof t == "string") return cS(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cS(t, e);
  }
}
function cS(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function u0t(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var i = [], s = !0, c = !1, u, l;
    try {
      for (r = r.call(t); !(s = (u = r.next()).done) && (i.push(u.value), !(e && i.length === e)); s = !0)
        ;
    } catch (f) {
      c = !0, l = f;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (c) throw l;
      }
    }
    return i;
  }
}
function h0t(t) {
  if (Array.isArray(t)) return t;
}
var f0t = {
  nodesShouldLoad: !1,
  nodesDoneLoad: !1,
  animating: !0
}, d0t = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : f0t, e = Bt.useState(t), r = o0t(e, 2), i = r[0], s = r[1], c = Bt.useCallback(function(o) {
    s(function(g) {
      return lS(lS({}, g), o);
    });
  }, [s]), u = Bt.useCallback(function(o, g, p) {
    if (!(o != null && o.animate))
      return g.props.animate;
    var n = function() {
      var w = i && i.childrenTransitions;
      return w = dx(w) ? w[p] : w, Ie({
        childrenTransitions: w
      }, i);
    }, a = o.animate && o.animate.getTransitions, d = n(), m = o.animate && o.animate.parentState || d;
    if (!a) {
      var b = $O(o, d, function(w) {
        return c(w);
      });
      a = function(w) {
        return b(w, p);
      };
    }
    return Ie({
      getTransitions: a,
      parentState: m
    }, o.animate, g.props.animate);
  }, [i, c]), l = Bt.useCallback(function(o, g) {
    if (o != null && o.animate)
      if (o.animate.parentState) {
        var p = o.animate.parentState.nodesWillExit, n = p ? o : null, a = Ie({
          oldProps: n,
          nextProps: g
        }, o.animate.parentState);
        c(a);
      } else {
        var d = Bt.Children.toArray(o.children), m = Bt.Children.toArray(g.children), b = function(O) {
          var E = function(I) {
            return I.type && I.type.continuous;
          };
          return Array.isArray(O) ? O.some(E) : E(O);
        }, w = !o.polar && d.some(function(O) {
          var E;
          return b(O) || (O == null || (E = O.props) === null || E === void 0 ? void 0 : E.children) && b(O.props.children);
        }), v = DO(d, m), h = v.nodesWillExit, x = v.nodesWillEnter, _ = v.childrenTransitions, M = v.nodesShouldEnter;
        c({
          nodesWillExit: h,
          nodesWillEnter: x,
          nodesShouldEnter: M,
          childrenTransitions: dx(_) ? _[0] : _,
          oldProps: h ? o : void 0,
          nextProps: g,
          continuous: w
        });
      }
  }, [c]), f = Bt.useCallback(function(o) {
    return i && i.nodesWillExit && i.oldProps || o;
  }, [i]);
  return {
    state: i,
    setState: c,
    getAnimationProps: u,
    setAnimationState: l,
    getProps: f
  };
};
function Fo(t) {
  return function() {
    return t;
  };
}
const uS = Math.abs, ti = Math.atan2, Bl = Math.cos, g0t = Math.max, Rm = Math.min, cs = Math.sin, Mu = Math.sqrt, $i = 1e-12, dh = Math.PI, cg = dh / 2, p0t = 2 * dh;
function m0t(t) {
  return t > 1 ? 0 : t < -1 ? dh : Math.acos(t);
}
function hS(t) {
  return t >= 1 ? cg : t <= -1 ? -cg : Math.asin(t);
}
const k9 = Math.PI, O9 = 2 * k9, ql = 1e-6, y0t = O9 - ql;
function HT(t) {
  this._ += t[0];
  for (let e = 1, r = t.length; e < r; ++e)
    this._ += arguments[e] + t[e];
}
function b0t(t) {
  let e = Math.floor(t);
  if (!(e >= 0)) throw new Error(`invalid digits: ${t}`);
  if (e > 15) return HT;
  const r = 10 ** e;
  return function(i) {
    this._ += i[0];
    for (let s = 1, c = i.length; s < c; ++s)
      this._ += Math.round(arguments[s] * r) / r + i[s];
  };
}
class v0t {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? HT : b0t(e);
  }
  moveTo(e, r) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, r) {
    this._append`L${this._x1 = +e},${this._y1 = +r}`;
  }
  quadraticCurveTo(e, r, i, s) {
    this._append`Q${+e},${+r},${this._x1 = +i},${this._y1 = +s}`;
  }
  bezierCurveTo(e, r, i, s, c, u) {
    this._append`C${+e},${+r},${+i},${+s},${this._x1 = +c},${this._y1 = +u}`;
  }
  arcTo(e, r, i, s, c) {
    if (e = +e, r = +r, i = +i, s = +s, c = +c, c < 0) throw new Error(`negative radius: ${c}`);
    let u = this._x1, l = this._y1, f = i - e, o = s - r, g = u - e, p = l - r, n = g * g + p * p;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = r}`;
    else if (n > ql) if (!(Math.abs(p * f - o * g) > ql) || !c)
      this._append`L${this._x1 = e},${this._y1 = r}`;
    else {
      let a = i - u, d = s - l, m = f * f + o * o, b = a * a + d * d, w = Math.sqrt(m), v = Math.sqrt(n), h = c * Math.tan((k9 - Math.acos((m + n - b) / (2 * w * v))) / 2), x = h / v, _ = h / w;
      Math.abs(x - 1) > ql && this._append`L${e + x * g},${r + x * p}`, this._append`A${c},${c},0,0,${+(p * a > g * d)},${this._x1 = e + _ * f},${this._y1 = r + _ * o}`;
    }
  }
  arc(e, r, i, s, c, u) {
    if (e = +e, r = +r, i = +i, u = !!u, i < 0) throw new Error(`negative radius: ${i}`);
    let l = i * Math.cos(s), f = i * Math.sin(s), o = e + l, g = r + f, p = 1 ^ u, n = u ? s - c : c - s;
    this._x1 === null ? this._append`M${o},${g}` : (Math.abs(this._x1 - o) > ql || Math.abs(this._y1 - g) > ql) && this._append`L${o},${g}`, i && (n < 0 && (n = n % O9 + O9), n > y0t ? this._append`A${i},${i},0,1,${p},${e - l},${r - f}A${i},${i},0,1,${p},${this._x1 = o},${this._y1 = g}` : n > ql && this._append`A${i},${i},0,${+(n >= k9)},${p},${this._x1 = e + i * Math.cos(c)},${this._y1 = r + i * Math.sin(c)}`);
  }
  rect(e, r, i, s) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}h${i = +i}v${+s}h${-i}Z`;
  }
  toString() {
    return this._;
  }
}
function w0t(t) {
  let e = 3;
  return t.digits = function(r) {
    if (!arguments.length) return e;
    if (r == null)
      e = null;
    else {
      const i = Math.floor(r);
      if (!(i >= 0)) throw new RangeError(`invalid digits: ${r}`);
      e = i;
    }
    return t;
  }, () => new v0t(e);
}
function x0t(t) {
  return t.innerRadius;
}
function S0t(t) {
  return t.outerRadius;
}
function C0t(t) {
  return t.startAngle;
}
function A0t(t) {
  return t.endAngle;
}
function _0t(t) {
  return t && t.padAngle;
}
function k0t(t, e, r, i, s, c, u, l) {
  var f = r - t, o = i - e, g = u - s, p = l - c, n = p * f - g * o;
  if (!(n * n < $i))
    return n = (g * (e - c) - p * (t - s)) / n, [t + n * f, e + n * o];
}
function dd(t, e, r, i, s, c, u) {
  var l = t - r, f = e - i, o = (u ? c : -c) / Mu(l * l + f * f), g = o * f, p = -o * l, n = t + g, a = e + p, d = r + g, m = i + p, b = (n + d) / 2, w = (a + m) / 2, v = d - n, h = m - a, x = v * v + h * h, _ = s - c, M = n * m - d * a, O = (h < 0 ? -1 : 1) * Mu(g0t(0, _ * _ * x - M * M)), E = (M * h - v * O) / x, I = (-M * v - h * O) / x, R = (M * h + v * O) / x, W = (-M * v + h * O) / x, z = E - b, j = I - w, $ = R - b, B = W - w;
  return z * z + j * j > $ * $ + B * B && (E = R, I = W), {
    cx: E,
    cy: I,
    x01: -g,
    y01: -p,
    x11: E * (s / _ - 1),
    y11: I * (s / _ - 1)
  };
}
function O0t() {
  var t = x0t, e = S0t, r = Fo(0), i = null, s = C0t, c = A0t, u = _0t, l = null, f = w0t(o);
  function o() {
    var g, p, n = +t.apply(this, arguments), a = +e.apply(this, arguments), d = s.apply(this, arguments) - cg, m = c.apply(this, arguments) - cg, b = uS(m - d), w = m > d;
    if (l || (l = g = f()), a < n && (p = a, a = n, n = p), !(a > $i)) l.moveTo(0, 0);
    else if (b > p0t - $i)
      l.moveTo(a * Bl(d), a * cs(d)), l.arc(0, 0, a, d, m, !w), n > $i && (l.moveTo(n * Bl(m), n * cs(m)), l.arc(0, 0, n, m, d, w));
    else {
      var v = d, h = m, x = d, _ = m, M = b, O = b, E = u.apply(this, arguments) / 2, I = E > $i && (i ? +i.apply(this, arguments) : Mu(n * n + a * a)), R = Rm(uS(a - n) / 2, +r.apply(this, arguments)), W = R, z = R, j, $;
      if (I > $i) {
        var B = hS(I / n * cs(E)), C = hS(I / a * cs(E));
        (M -= B * 2) > $i ? (B *= w ? 1 : -1, x += B, _ -= B) : (M = 0, x = _ = (d + m) / 2), (O -= C * 2) > $i ? (C *= w ? 1 : -1, v += C, h -= C) : (O = 0, v = h = (d + m) / 2);
      }
      var T = a * Bl(v), F = a * cs(v), S = n * Bl(_), A = n * cs(_);
      if (R > $i) {
        var U = a * Bl(h), K = a * cs(h), X = n * Bl(x), L = n * cs(x), H;
        if (b < dh)
          if (H = k0t(T, F, X, L, U, K, S, A)) {
            var Q = T - H[0], N = F - H[1], V = U - H[0], Y = K - H[1], Z = 1 / cs(m0t((Q * V + N * Y) / (Mu(Q * Q + N * N) * Mu(V * V + Y * Y))) / 2), rt = Mu(H[0] * H[0] + H[1] * H[1]);
            W = Rm(R, (n - rt) / (Z - 1)), z = Rm(R, (a - rt) / (Z + 1));
          } else
            W = z = 0;
      }
      O > $i ? z > $i ? (j = dd(X, L, T, F, a, z, w), $ = dd(U, K, S, A, a, z, w), l.moveTo(j.cx + j.x01, j.cy + j.y01), z < R ? l.arc(j.cx, j.cy, z, ti(j.y01, j.x01), ti($.y01, $.x01), !w) : (l.arc(j.cx, j.cy, z, ti(j.y01, j.x01), ti(j.y11, j.x11), !w), l.arc(0, 0, a, ti(j.cy + j.y11, j.cx + j.x11), ti($.cy + $.y11, $.cx + $.x11), !w), l.arc($.cx, $.cy, z, ti($.y11, $.x11), ti($.y01, $.x01), !w))) : (l.moveTo(T, F), l.arc(0, 0, a, v, h, !w)) : l.moveTo(T, F), !(n > $i) || !(M > $i) ? l.lineTo(S, A) : W > $i ? (j = dd(S, A, U, K, n, -W, w), $ = dd(T, F, X, L, n, -W, w), l.lineTo(j.cx + j.x01, j.cy + j.y01), W < R ? l.arc(j.cx, j.cy, W, ti(j.y01, j.x01), ti($.y01, $.x01), !w) : (l.arc(j.cx, j.cy, W, ti(j.y01, j.x01), ti(j.y11, j.x11), !w), l.arc(0, 0, n, ti(j.cy + j.y11, j.cx + j.x11), ti($.cy + $.y11, $.cx + $.x11), w), l.arc($.cx, $.cy, W, ti($.y11, $.x11), ti($.y01, $.x01), !w))) : l.arc(0, 0, n, _, x, w);
    }
    if (l.closePath(), g) return l = null, g + "" || null;
  }
  return o.centroid = function() {
    var g = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2, p = (+s.apply(this, arguments) + +c.apply(this, arguments)) / 2 - dh / 2;
    return [Bl(p) * g, cs(p) * g];
  }, o.innerRadius = function(g) {
    return arguments.length ? (t = typeof g == "function" ? g : Fo(+g), o) : t;
  }, o.outerRadius = function(g) {
    return arguments.length ? (e = typeof g == "function" ? g : Fo(+g), o) : e;
  }, o.cornerRadius = function(g) {
    return arguments.length ? (r = typeof g == "function" ? g : Fo(+g), o) : r;
  }, o.padRadius = function(g) {
    return arguments.length ? (i = g == null ? null : typeof g == "function" ? g : Fo(+g), o) : i;
  }, o.startAngle = function(g) {
    return arguments.length ? (s = typeof g == "function" ? g : Fo(+g), o) : s;
  }, o.endAngle = function(g) {
    return arguments.length ? (c = typeof g == "function" ? g : Fo(+g), o) : c;
  }, o.padAngle = function(g) {
    return arguments.length ? (u = typeof g == "function" ? g : Fo(+g), o) : u;
  }, o.context = function(g) {
    return arguments.length ? (l = g ?? null, o) : l;
  }, o;
}
function fS(t, e, r) {
  var i = e.a, s = e.d, c = e.e, u = e.f;
  return r === "y" ? s * t + u : i * t + c;
}
function T0t(t) {
  return t.getScreenCTM().inverse();
}
function VT(t) {
  return !!(t && t.identifier !== void 0);
}
function M0t(t) {
  return t.changedTouches && t.changedTouches.length > 0;
}
function zT(t) {
  if (!VT(t.nativeEvent)) {
    var e = function(r) {
      return r.nodeName === "svg" ? r : r.parentNode ? e(r.parentNode) : r;
    };
    return e(t.target);
  }
}
function E0t(t, e) {
  if (VT(t.nativeEvent))
    return {
      x: t.nativeEvent.locationX,
      y: t.nativeEvent.locationY
    };
  var r = M0t(t) ? t.changedTouches[0] : t, i = T0t(e || zT(r));
  return {
    x: fS(r.clientX, i, "x"),
    y: fS(r.clientY, i, "y")
  };
}
var P0t = gp, I0t = LO;
function F0t(t, e) {
  return t && t.length ? I0t(t, P0t(e)) : [];
}
var R0t = F0t;
const D0t = /* @__PURE__ */ Dn(R0t);
function Ya(t) {
  return B0t(t) || N0t(t) || L0t(t) || $0t();
}
function $0t() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function L0t(t, e) {
  if (t) {
    if (typeof t == "string") return T9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return T9(t, e);
  }
}
function N0t(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function B0t(t) {
  if (Array.isArray(t)) return T9(t);
}
function T9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function j0t(t, e, r) {
  var i = t.datasets, s = t.horizontal, c = s ? $a(t, "y") : $a(t, "x"), u = Math.abs(c[1] - c[0]), l = r !== void 0 ? r : Array.isArray(i[0]) && i[0].length || 1, f = e || i.length, o = f * l, g = 0.5;
  return Math.round(g * u / o);
}
function U0t(t, e, r) {
  if (!(t.polar || e !== "x")) {
    var i = r.filter(function(n) {
      return n.type && n.type.role && n.type.role === "group";
    });
    if (!(i.length < 1)) {
      var s = i[0].props, c = s.offset, u = s.children;
      if (c) {
        var l = Array.isArray(u) && u[0];
        if (l) {
          var f = l.props.barWidth, o = l.props.data && l.props.data.length || 1;
          if (l && l.type.role === "stack") {
            var g = l.props.children && l.props.children[0];
            if (!g)
              return;
            f = g.props.barWidth, o = l.props.children.length;
          }
          var p = f || j0t(t, u.length, o);
          return {
            x: p * u.length / 2 + (c - p * ((u.length - 1) / 2))
          };
        }
      }
    }
  }
}
function H0t(t, e, r) {
  var i = r ? r.slice(0) : Bt.Children.toArray(t.children), s = t.data ? wl(t) : void 0, c = t.polar, u = t.startAngle, l = t.endAngle, f = t.categories, o = t.minDomain, g = t.maxDomain, p = t.horizontal, n = {
    horizontal: p,
    polar: c,
    startAngle: u,
    endAngle: l,
    minDomain: o,
    maxDomain: g,
    categories: f
  }, a = s ? Object.assign(n, {
    data: s
  }) : n, d = function(v) {
    var h = Object.assign({}, v.props, a);
    if (DT(v)) {
      if (v.type && Cn(v.type.getDomain))
        return v.props && v.type.getDomain(h, e);
    } else return null;
    return Kut(h, e);
  }, m = k0(i, d, t), b = m.length === 0 ? 0 : da(m), w = m.length === 0 ? 1 : es(m);
  return [b, w];
}
function V0t(t, e, r) {
  var i = r || Bt.Children.toArray(t.children), s = C4(t, e), c = U0t(t, e, i), u;
  if (s)
    u = s;
  else {
    var l = $c(t, e), f = Dc(t, e), o = (t.data || t.y) && wl(t), g = o ? S4(t, e, o) : [], p = H0t(t, e, i), n = l || da([].concat(Ya(g), Ya(p))), a = f || es([].concat(Ya(g), Ya(p)));
    u = uo(n, a);
  }
  return x4(u, Object.assign({
    domainPadding: c
  }, t), e);
}
function dS(t, e, r) {
  if (t.data)
    return ll(t, e);
  var i = Bt.Children.toArray(t.children), s = function(u) {
    var l = Object.assign({}, u.props, {
      horizontal: t.horizontal
    });
    return lg(l, e);
  }, c = xc(k0(i, s, t));
  return c.length > 1 ? fh("linear") : fh(c[0]);
}
function z0t(t) {
  var e = ["groupComponent", "containerComponent", "labelComponent"], r = Y7(t, e), i = t.events;
  return Array.isArray(r) && (i = Array.isArray(t.events) ? r.concat.apply(r, Ya(t.events)) : r), i || [];
}
function X0t(t, e) {
  var r = function(i) {
    var s = i.props || {};
    if (!DT(i) || !s.categories)
      return null;
    var c = s.categories && !Array.isArray(s.categories) ? s.categories[e] : s.props.categories, u = c && c.filter(function(l) {
      return typeof l == "string";
    });
    return u ? FO(u) : [];
  };
  return k0(t.slice(0), r);
}
function q0t(t) {
  var e = function(s) {
    var c = s.props || {}, u;
    if (RT(s))
      s.type && Cn(s.type.getData) ? u = s.type.getData(c) : u = wl(c);
    else return null;
    return u.map(function(l) {
      return {
        x: l.xName,
        y: l.yName
      };
    });
  }, r = {
    x: [],
    y: []
  }, i = function(s, c) {
    var u = Array.isArray(c) ? c.map(function(f) {
      return f.x;
    }).filter(Boolean) : c.x, l = Array.isArray(c) ? c.map(function(f) {
      return f.y;
    }).filter(Boolean) : c.y;
    return {
      x: u !== void 0 ? s.x.concat(u) : s.x,
      y: l !== void 0 ? s.y.concat(l) : s.y
    };
  };
  return k0(t.slice(0), e, {}, r, i);
}
function gS(t, e, r) {
  var i = Ur(t.categories) ? t.categories[e] : t.categories, s = LT(r, e), c = s ? IT(s.props, e) : [], u = i || X0t(r, e);
  return xc([].concat(Ya(u), Ya(c)).flat());
}
function XT(t, e) {
  var r = e || Bt.Children.toArray(t.children), i = gS(t, "x", r), s = gS(t, "y", r), c = q0t(r);
  return {
    x: xc([].concat(Ya(i), Ya(c.x)).flat()),
    y: xc([].concat(Ya(s), Ya(c.y)).flat())
  };
}
function W0t(t, e, r) {
  var i = t.categories && !Array.isArray(t.categories) ? t.categories.x : t.categories, s = t.categories && !Array.isArray(t.categories) ? t.categories.y : t.categories, c = !i || !s, u = c ? r || XT(t, e) : {}, l = i || u.x, f = s || u.y;
  return {
    x: l.length > 0 ? l : void 0,
    y: f.length > 0 ? f : void 0
  };
}
function G0t(t) {
  return J0t(t) || Z0t(t) || Y0t(t) || K0t();
}
function K0t() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y0t(t, e) {
  if (t) {
    if (typeof t == "string") return M9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return M9(t, e);
  }
}
function Z0t(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function J0t(t) {
  if (Array.isArray(t)) return M9(t);
}
function M9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function Zd(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var k4 = {
  top: -1,
  left: -1,
  right: 1,
  bottom: 1
}, ug = function(t) {
  return t != null;
}, Q0t = function(t, e) {
  var r = t.orientation, i = t.horizontal;
  if (r) {
    var s = {
      top: "x",
      bottom: "x",
      left: "y",
      right: "y"
    };
    return s[r];
  }
  var c = e === "x" ? "y" : "x";
  return i ? c : e;
}, t1t = function(t) {
  var e = Ba(t), r = Q0t(t, e), i = ll(t, e), s = t.domain && t.domain[e], c = s || T0(t) || i.domain();
  return i.range($a(t, r)), i.domain(c), i;
}, e1t = function(t) {
  var e = t.theme, r = t.dependentAxis, i = e && e.axis && e.axis.style, s = r ? "dependentAxis" : "independentAxis", c = e && e[s] && e[s].style, u = function() {
    var l = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
    return l.reduce(function(f, o) {
      return f[o] = Ie({}, c[o], i[o]), f;
    }, {});
  };
  return i && c ? u() : c || i;
}, qT = function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.style || {}, i = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: Ie(r.parent, e.parent, i),
    axis: Ie({}, r.axis, e.axis),
    axisLabel: Ie({}, r.axisLabel, e.axisLabel),
    grid: Ie({}, r.grid, e.grid),
    ticks: Ie({}, r.ticks, e.ticks),
    tickLabels: Ie({}, r.tickLabels, e.tickLabels)
  };
}, n1t = function(t, e, r) {
  var i = t.position, s = t.transform;
  return {
    x1: s.x,
    y1: s.y,
    x2: s.x + i.x2,
    y2: s.y + i.y2,
    style: e,
    datum: r
  };
}, r1t = function(t, e, r, i, s) {
  var c = t.position, u = t.transform;
  return {
    style: e,
    x: u.x + c.x,
    y: u.y + c.y,
    verticalAnchor: r.verticalAnchor,
    textAnchor: r.textAnchor,
    angle: e.angle,
    text: s,
    datum: i
  };
}, i1t = function(t, e, r) {
  var i = t.edge, s = t.transform;
  return {
    x1: s.x,
    y1: s.y,
    x2: i.x + s.x,
    y2: i.y + s.y,
    style: e,
    datum: r
  };
}, a1t = function(t, e, r) {
  var i = e.style, s = e.padding, c = e.isVertical, u = t.width, l = t.height;
  return {
    style: i.axis,
    x1: c ? r.x : s.left + r.x,
    x2: c ? r.x : u - s.right + r.x,
    y1: c ? s.top + r.y : r.y,
    y2: c ? l - s.bottom + r.y : r.y
  };
}, s1t = function(t, e) {
  return {
    tickStyle: Fr(t.ticks, e),
    labelStyle: Fr(t.tickLabels, e),
    gridStyle: Fr(t.grid, e)
  };
}, o1t = function(t, e, r) {
  var i = e.style, s = e.orientation, c = e.padding, u = e.labelPadding, l = e.isVertical, f = k4[s], o = c.left + c.right, g = c.top + c.bottom, p = f < 0 ? "end" : "start", n = i.axisLabel, a = l ? -90 : 0, d = l ? r.x + f * u : (t.width - o) / 2 + c.left + r.x, m = l ? (t.height - g) / 2 + c.top + r.y : f * u + r.y;
  return {
    x: d,
    y: m,
    verticalAnchor: n.verticalAnchor || p,
    textAnchor: n.textAnchor || "middle",
    angle: n.angle === void 0 ? a : n.angle,
    style: n,
    text: t.label
  };
}, l1t = function(t, e) {
  var r = {
    top: "end",
    left: "end",
    right: "start",
    bottom: "start"
  }, i = r[t];
  return {
    textAnchor: e ? i : "middle",
    verticalAnchor: e ? "middle" : i
  };
}, c1t = function(t, e) {
  var r = e.axisLabel || {};
  if (r.padding !== void 0 && r.padding !== null)
    return r.padding;
  var i = Ap(t), s = r.fontSize || 14;
  return t.label ? s * (i ? 2.3 : 1.6) : 0;
}, pS = function(t, e, r) {
  var i = e || "positive", s = {
    positive: {
      x: "bottom",
      y: "left"
    },
    negative: {
      x: "top",
      y: "right"
    }
  }, c = {
    positive: {
      x: "left",
      y: "bottom"
    },
    negative: {
      x: "right",
      y: "top"
    }
  };
  return r ? c[i][t] : s[i][t];
}, u1t = function(t, e) {
  var r = e.style, i = e.scale, s = e.orientation, c = e.padding, u = e.axis, l = e.ticks, f = e.stringTicks, o = e.isVertical, g = e.labelPadding, p = t.polar, n = t.horizontal, a = {
    scale: Zd({}, u, i),
    polar: p,
    horizontal: n,
    ticks: l,
    stringTicks: f
  }, d = s === "right" ? c.right : c.left, m = s === "top" ? c.top : c.bottom, b = t.offsetX !== null && t.offsetX !== void 0 ? t.offsetX : d, w = t.offsetY !== null && t.offsetY !== void 0 ? t.offsetY : m, v = r.axisLabel.fontSize || 14, h = l.map(function(E, I) {
    var R = f ? t.tickValues[E - 1] : E, W = Fr(r.ticks, Object.assign({}, a, {
      tick: R,
      index: I
    }));
    return W.size || 0;
  }), x = v + 2 * Math.max.apply(Math, G0t(h)) + g, _ = 1.2 * v, M = o ? x : _, O = o ? _ : x;
  return {
    x: b ?? M,
    y: w ?? O
  };
}, Bo = function(t, e) {
  return t instanceof Date && e instanceof Date ? t.getTime() === e.getTime() : t === e;
}, h1t = function(t, e) {
  var r = e.scale, i = e.origin, s = e.orientation, c = e.orientations, u = e.domain, l = e.padding, f = l.top, o = l.bottom, g = l.left, p = l.right, n = {
    x: s === "bottom" || s === "top" ? s : c.x,
    y: s === "left" || s === "right" ? s : c.y
  }, a = {
    x: n.y === "left" ? g : p,
    y: n.x === "bottom" ? o : f
  }, d = {
    x: n.y === "left" ? 0 : t.width,
    y: n.x === "bottom" ? t.height : 0
  }, m = {
    x: Bo(i.x, u.x[0]) || Bo(i.x, u.x[1]) ? 0 : r.x(i.x),
    y: Bo(i.y, u.y[0]) || Bo(i.y, u.y[1]) ? 0 : r.y(i.y)
  }, b = m.x ? Math.abs(d.x - m.x) : a.x, w = m.y ? Math.abs(d.y - m.y) : a.y, v = ug(t.offsetX) ? t.offsetX : b, h = ug(t.offsetY) ? t.offsetY : w;
  return {
    x: v,
    y: h
  };
}, f1t = function(t, e) {
  var r = e.scale, i = e.origin, s = e.orientation, c = e.orientations, u = e.domain, l = e.padding, f = l.top, o = l.bottom, g = l.left, p = l.right, n = {
    y: s === "bottom" || s === "top" ? s : c.x,
    x: s === "left" || s === "right" ? s : c.y
  }, a = {
    x: n.y === "bottom" ? o : f,
    y: n.x === "left" ? g : p
  }, d = {
    y: n.x === "left" ? 0 : t.width,
    x: n.y === "bottom" ? t.height : 0
  }, m = {
    x: Bo(i.x, u.x[0]) || Bo(i.x, u.x[1]) ? 0 : r.x(i.x),
    y: Bo(i.y, u.y[0]) || Bo(i.y, u.y[1]) ? 0 : r.y(i.y)
  }, b = m.x ? Math.abs(d.x - m.x) : a.x, w = m.y ? Math.abs(d.y - m.y) : a.y, v = ug(t.offsetX) ? t.offsetX : w, h = ug(t.offsetY) ? t.offsetY : b;
  return {
    x: v,
    y: h
  };
}, d1t = function(t, e, r) {
  var i = e.orientation, s = e.axis, c = UT(t, s);
  return {
    top: {
      x: 0,
      y: c !== void 0 ? c : r.y
    },
    bottom: {
      x: 0,
      y: c !== void 0 ? c : t.height - r.y
    },
    left: {
      x: c !== void 0 ? c : r.x,
      y: 0
    },
    right: {
      x: c !== void 0 ? c : t.width - r.x,
      y: 0
    }
  }[i];
}, g1t = function(t, e, r) {
  var i = t.tickStyle, s = t.labelStyle, c = i.size || 0, u = i.padding || 0, l = s.padding || 0, f = c + u + l, o = k4[e];
  return {
    x: r ? o * f : 0,
    x2: r ? o * c : 0,
    y: r ? 0 : o * f,
    y2: r ? 0 : o * c
  };
}, p1t = function(t, e, r) {
  return {
    x: r ? e.x : t + e.x,
    y: r ? t + e.y : e.y
  };
}, m1t = function(t, e) {
  var r = e.orientation, i = e.padding, s = e.isVertical, c = -k4[r], u = s ? c * (t.width - (i.left + i.right)) : 0, l = s ? 0 : c * (t.height - (i.top + i.bottom));
  return {
    x: u,
    y: l
  };
}, y1t = function(t, e) {
  var r = t.padding, i = t.orientation, s = t.crossAxis, c = i === "right" ? r.right : r.left, u = i === "top" ? r.top : r.bottom;
  return {
    x: s ? e.x - c : 0,
    y: s ? e.y - u : 0
  };
}, b1t = function(t, e) {
  var r;
  return e.domain.x && e.domain.y ? r = t.horizontal ? f1t(t, e) : h1t(t, e) : r = u1t(t, e), {
    globalTransform: d1t(t, e, r),
    gridOffset: y1t(e, r),
    gridEdge: m1t(t, e)
  };
}, v1t = function(t) {
  if (t.orientation)
    return t.orientation;
  var e = {
    dependent: t.horizontal ? "bottom" : "left",
    independent: t.horizontal ? "left" : "bottom"
  };
  return t.dependentAxis ? e.dependent : e.independent;
}, w1t = function(t) {
  var e = e1t(t), r = qT(t, e), i = Qa(t), s = c1t(t, r), c = _p(t) ? t.tickValues : void 0, u = Ba(t), l = T0(t), f = t1t(t), o = u === "x" ? l : void 0, g = u === "y" ? l : void 0, p = u === "x" ? f : void 0, n = u === "y" ? f : void 0, a = !(t.crossAxis === !1 || t.standalone === !0), d = jT(t, f, a), m = BT(t, f), b = {
    x: $a(t, "x"),
    y: $a(t, "y")
  }, w = {
    x: t.domain && t.domain.x ? t.domain.x : o,
    y: t.domain && t.domain.y ? t.domain.y : g
  }, v = {
    x: t.domain && t.domain.x ? ll(t, "x").domain(t.domain.x).range(t.horizontal ? b.y : b.x) : p,
    y: t.domain && t.domain.y ? ll(t, "y").domain(t.domain.y).range(t.horizontal ? b.x : b.y) : n
  }, h = w.x && w.y ? NT(w) : void 0, x = h ? {
    x: aS(h.x, w.x),
    y: aS(h.y, w.y)
  } : void 0, _ = x ? {
    x: pS("x", x.y, t.horizontal),
    y: pS("y", x.x, t.horizontal)
  } : void 0, M = _ ? t.orientation || _[u] : v1t(t), O = Ap(Object.assign({}, t, {
    orientation: M
  })), E = l1t(M, O);
  return {
    anchors: E,
    axis: u,
    crossAxis: a,
    domain: w,
    isVertical: O,
    labelPadding: s,
    orientation: M,
    orientations: _,
    origin: h,
    padding: i,
    scale: v,
    stringTicks: c,
    style: r,
    tickFormat: m,
    ticks: d
  };
}, x1t = function(t, e) {
  var r = kp(t, e), i = w1t(r), s = i.axis, c = i.style, u = i.orientation, l = i.isVertical, f = i.scale, o = i.ticks, g = i.tickFormat, p = i.anchors, n = i.domain, a = i.stringTicks, d = s === "x" ? "y" : "x", m = r.width, b = r.height, w = r.standalone, v = r.theme, h = r.polar, x = r.padding, _ = r.horizontal, M = b1t(r, i), O = M.globalTransform, E = M.gridOffset, I = M.gridEdge, R = {
    scale: Zd({}, s, f[s]),
    polar: h,
    horizontal: _,
    ticks: o,
    stringTicks: a
  }, W = a1t(r, i, O), z = o1t(r, i, O), j = {
    parent: Object.assign({
      style: c.parent,
      ticks: o,
      standalone: w,
      theme: v,
      width: m,
      height: b,
      padding: x,
      domain: n
    }, R)
  }, $ = {
    dimension: d,
    range: Zd({}, d, $a(r, d)),
    scale: r.scale && r.scale[d] ? Zd({}, d, r.scale[d]) : void 0
  };
  return o.reduce(function(B, C, T) {
    var F, S, A, U = a ? a[T] : C, K = g(C, T, o), X = s1t(c, Object.assign({}, R, {
      tick: U,
      tickValue: C,
      index: T,
      text: K
    })), L = {
      position: g1t(X, u, l),
      transform: p1t((F = f[s]) === null || F === void 0 ? void 0 : F.call(f, C), O, l)
    }, H = {
      edge: I,
      transform: {
        x: l ? -E.x + O.x : ((S = f[s]) === null || S === void 0 ? void 0 : S.call(f, C)) + O.x,
        y: l ? ((A = f[s]) === null || A === void 0 ? void 0 : A.call(f, C)) + O.y : E.y + O.y
      }
    };
    return B[T] = {
      axis: Object.assign({
        dimension: s
      }, R, W),
      axisLabel: Object.assign({}, R, z),
      ticks: Object.assign({}, R, n1t(L, X.tickStyle, C)),
      tickLabels: Object.assign({}, R, r1t(L, X.labelStyle, p, C, K)),
      grid: Object.assign({}, R, $, i1t(H, X.gridStyle, C))
    }, B;
  }, j);
};
function S1t(t) {
  return k1t(t) || _1t(t) || A1t(t) || C1t();
}
function C1t() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function A1t(t, e) {
  if (t) {
    if (typeof t == "string") return E9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return E9(t, e);
  }
}
function _1t(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function k1t(t) {
  if (Array.isArray(t)) return E9(t);
}
function E9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function O1t(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function T1t(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function M1t(t, e, r) {
  return e && T1t(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function E1t(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && P9(t, e);
}
function P9(t, e) {
  return P9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, P9(t, e);
}
function P1t(t) {
  var e = R1t();
  return function() {
    var i = hg(t), s;
    if (e) {
      var c = hg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return I1t(this, s);
  };
}
function I1t(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return F1t(t);
}
function F1t(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function R1t() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function hg(t) {
  return hg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hg(t);
}
var WT = {
  width: 450,
  height: 300,
  padding: 50
}, D1t = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
}, ns = /* @__PURE__ */ function(t) {
  E1t(r, t);
  var e = P1t(r);
  function r() {
    return O1t(this, r), e.apply(this, arguments);
  }
  return M1t(r, [{
    key: "renderLine",
    value: function(s) {
      var c = s.axisComponent, u = this.getComponentProps(c, "axis", 0);
      return /* @__PURE__ */ Bt.cloneElement(c, u);
    }
  }, {
    key: "renderLabel",
    value: function(s) {
      var c = s.axisLabelComponent, u = s.label;
      if (!u)
        return null;
      var l = this.getComponentProps(c, "axisLabel", 0);
      return /* @__PURE__ */ Bt.cloneElement(c, l);
    }
  }, {
    key: "renderGridAndTicks",
    value: function(s) {
      var c = this, u = s.tickComponent, l = s.tickLabelComponent, f = s.gridComponent, o = s.name, g = function(p) {
        var n = p.style, a = n === void 0 ? {} : n, d = p.events, m = d === void 0 ? {} : d, b = a.stroke !== "transparent" && a.stroke !== "none" && a.strokeWidth !== 0;
        return b || !ar(m);
      };
      return this.dataKeys.map(function(p, n) {
        var a = c.getComponentProps(u, "ticks", n), d = /* @__PURE__ */ Bt.cloneElement(u, a), m = g(d.props) ? d : void 0, b = c.getComponentProps(f, "grid", n), w = /* @__PURE__ */ Bt.cloneElement(f, b), v = g(w.props) ? w : void 0, h = c.getComponentProps(l, "tickLabels", n), x = /* @__PURE__ */ Bt.cloneElement(l, h), _ = [v, m, x].filter(Boolean);
        return /* @__PURE__ */ Bt.cloneElement(s.groupComponent, {
          key: "".concat(o, "-tick-group-").concat(p)
        }, _);
      });
    }
  }, {
    key: "fixLabelOverlap",
    value: function(s, c) {
      var u = Ap(c), l = u ? c.height : c.width, f = function(b) {
        return b.type && b.type.role === "label";
      }, o = s.map(function(b) {
        return b.props.children;
      }).reduce(function(b, w) {
        return b.concat(w);
      }, []).filter(f).map(function(b) {
        return b.props;
      }), g = function(b) {
        return typeof b == "object" ? Object.assign({}, {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }, b) : {
          top: b,
          right: b,
          bottom: b,
          left: b
        };
      }, p = o.reduce(function(b, w) {
        var v = g(w.style.padding), h = z2(w.text, {
          angle: w.angle,
          fontSize: w.style.fontSize,
          letterSpacing: w.style.letterSpacing,
          fontFamily: w.style.fontFamily
        });
        return b + (u ? h.height + v.top + v.bottom : h.width + v.right + v.left);
      }, 0), n = Math.floor(l * s.length / p), a = Math.ceil(s.length / n) || 1, d = function(b) {
        return b.props.children.filter(f).reduce(function(w, v) {
          return (u ? v.props.y : v.props.x) || 0;
        }, 0);
      }, m = s.sort(
        function(b, w) {
          return u ? d(w) - d(b) : d(b) - d(w);
        }
        // ordinary axis has left-right orientation
      );
      return m.filter(function(b, w) {
        return w % a === 0;
      });
    }
    // Overridden in native versions
  }, {
    key: "shouldAnimate",
    value: function() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function() {
      var s = Ws.animationWhitelist, c = kp(this.props, WT), u = O0(this.props);
      if (this.shouldAnimate())
        return this.animateComponent(c, s);
      var l = this.renderGridAndTicks(c), f = c.fixLabelOverlap ? this.fixLabelOverlap(l, c) : l, o = [this.renderLine(c), this.renderLabel(c)].concat(S1t(f)), g = /* @__PURE__ */ Bt.cloneElement(c.containerComponent, u);
      return c.standalone ? this.renderContainer(g, o) : /* @__PURE__ */ Bt.cloneElement(c.groupComponent, u, o);
    }
  }]), r;
}(Bt.Component);
ns.animationWhitelist = ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"];
ns.displayName = "VictoryAxis";
ns.role = "axis";
ns.defaultTransitions = {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
};
ns.defaultProps = {
  axisComponent: /* @__PURE__ */ Bt.createElement(Cs, null),
  axisLabelComponent: /* @__PURE__ */ Bt.createElement(ts, null),
  tickLabelComponent: /* @__PURE__ */ Bt.createElement(ts, null),
  tickComponent: /* @__PURE__ */ Bt.createElement(Cs, null),
  gridComponent: /* @__PURE__ */ Bt.createElement(Cs, null),
  standalone: !0,
  theme: Hh.grayscale,
  containerComponent: /* @__PURE__ */ Bt.createElement(Is, null),
  groupComponent: /* @__PURE__ */ Bt.createElement("g", {
    role: "presentation"
  }),
  fixLabelOverlap: !1
};
ns.getDomain = T0;
ns.getAxis = Ba;
ns.getStyles = function(t) {
  return qT(t);
};
ns.getBaseProps = function(t) {
  return x1t(t, WT);
};
ns.expectedComponents = ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"];
var Ws = Z7(ns, D1t), $1t = function(t, e) {
  var r = function(c) {
    var u = MT(t.scale[c]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0, l = u, f = da(t.domain[c]), o = es(t.domain[c]);
    return f < 0 && o <= 0 ? l = o : f >= 0 && o > 0 && (l = f), e["_".concat(c)] instanceof Date ? new Date(l) : l;
  }, i = e._y0 !== void 0 ? e._y0 : r("y"), s = e._x0 !== void 0 ? e._x0 : r("x");
  return Uh(t, Object.assign({}, e, {
    _y0: i,
    _x0: s
  }));
}, L1t = function(t) {
  var e = t.polar, r = prt(t, "bar"), i = t.disableInlineStyles ? {} : mrt(t.style, r), s = t.range || {
    x: $a(t, "x"),
    y: $a(t, "y")
  }, c = {
    x: A9(t, "x"),
    y: A9(t, "y")
  }, u = {
    x: ll(t, "x").domain(c.x).range(t.horizontal ? s.y : s.x),
    y: ll(t, "y").domain(c.y).range(t.horizontal ? s.x : s.y)
  }, l = e ? t.origin || j7(t) : void 0, f = wl(t);
  return f = Nut(f, c, 0), {
    style: i,
    data: f,
    scale: u,
    domain: c,
    origin: l
  };
}, N1t = function(t, e) {
  var r = qo(t, e, "bar"), i = Object.assign({}, r, L1t(r)), s = i.alignment, c = i.barRatio, u = i.cornerRadius, l = i.data, f = i.disableInlineStyles, o = i.domain, g = i.events, p = i.height, n = i.horizontal, a = i.origin, d = i.padding, m = i.polar, b = i.scale, w = i.sharedEvents, v = i.standalone, h = i.style, x = i.theme, _ = i.width, M = i.labels, O = i.name, E = i.barWidth, I = i.getPath, R = {
    parent: {
      horizontal: n,
      domain: o,
      scale: b,
      width: _,
      height: p,
      data: l,
      standalone: v,
      name: O,
      theme: x,
      polar: m,
      origin: a,
      padding: d,
      style: h.parent
    }
  };
  return l.reduce(function(W, z, j) {
    var $ = ch(z.eventKey) ? j : z.eventKey, B = $1t(i, z), C = B.x, T = B.y, F = B.y0, S = B.x0, A = {
      alignment: s,
      barRatio: c,
      barWidth: E,
      cornerRadius: u,
      data: l,
      datum: z,
      disableInlineStyles: f,
      getPath: I,
      horizontal: n,
      index: j,
      polar: m,
      origin: a,
      scale: b,
      style: h.data,
      width: _,
      height: p,
      x: C,
      y: T,
      y0: F,
      x0: S
    };
    W[$] = {
      data: A
    };
    var U = AO(i, z, j);
    return (U != null || M && (g || w)) && (W[$].labels = Iit(i, j)), W;
  }, R);
}, B1t = 8, j1t = function(t, e) {
  var r = e.scale, i = e.data, s = e.style;
  if (t)
    return Te(t, e);
  if (s.width)
    return s.width;
  var c = r.x.range(), u = Math.abs(c[1] - c[0]), l = i.length + 2, f = e.barRatio || 0.5, o = f * (i.length < 2 ? B1t : u / l);
  return Math.max(1, o);
}, U1t = function(t, e) {
  var r = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  }, i = function(s, c) {
    ch(t[s]) ? ch(t[c]) || (r[s] = Te(t[c], e)) : r[s] = Te(t[s], e);
  };
  return i("topLeft", "top"), i("topRight", "top"), i("bottomLeft", "bottom"), i("bottomRight", "bottom"), r;
};
function H1t(t) {
  return Ur(t);
}
var V1t = function(t, e) {
  var r = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };
  return t ? H1t(t) ? U1t(t, e) : (r.topLeft = Te(t, e), r.topRight = Te(t, e), r) : r;
}, z1t = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
  if (e.disableInlineStyles)
    return {};
  var r = t.fill || "black", i = {
    fill: "black",
    stroke: r
  };
  return Fr(Object.assign(i, t), e);
}, ps = function(t, e) {
  return {
    x: t,
    y: e,
    distance: function(r) {
      return Math.sqrt(Math.pow(this.x - r.x, 2) + Math.pow(this.y - r.y, 2));
    },
    // vector addition in 2d plane
    add: function(r) {
      return ps(this.x + r.x, this.y + r.y);
    },
    // vector subtraction in 2d
    // returns p0 - p1
    subtract: function(r) {
      return ps(this.x - r.x, this.y - r.y);
    },
    // multiply a 2d point by a scalar
    scalarMult: function(r) {
      return ps(this.x * r, this.y * r);
    },
    scalarDivide: function(r) {
      if (r === 0)
        throw new Error("Division by 0 error");
      return ps(this.x / r, this.y / r);
    },
    equals: function(r) {
      return this.x === r.x && this.y === r.y;
    }
  };
}, fg = function(t, e) {
  return {
    center: t,
    radius: e,
    hasIntersection: function(r) {
      var i = this.center, s = r.center, c = this.radius, u = r.radius, l = i.distance(s);
      return !(l > c + u || l < Math.abs(c - u));
    },
    equals: function(r) {
      var i = this.center, s = r.center, c = this.radius, u = r.radius;
      return c === u && i.equals(s);
    },
    // Source: http://paulbourke.net/geometry/circlesphere/
    // "Intersection of two circles" by Paul Bourke
    // Left-most point is returned as 0th element of array
    // Right-most point is returned as 1st elemennt of array
    intersection: function(r) {
      var i = this.center, s = r.center, c = this.radius, u = r.radius, l = i.distance(s);
      if (!this.hasIntersection(r) || this.equals(r))
        return [];
      var f = (Math.pow(c, 2) - Math.pow(u, 2) + Math.pow(l, 2)) / (2 * l), o = Math.sqrt(Math.pow(c, 2) - Math.pow(f, 2)), g = i.add(s.subtract(i).scalarMult(f).scalarDivide(l)), p = i.x, n = i.y, a = s.x, d = s.y, m = g.x, b = g.y, w = [ps(m - o * (d - n) / l, b + o * (a - p) / l), ps(m + o * (d - n) / l, b - o * (a - p) / l)];
      return w.sort(function(v, h) {
        return v.x - h.x;
      }), w;
    },
    solveX: function(r) {
      var i = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(r - this.center.y, 2));
      return [this.center.x - i, this.center.x + i];
    },
    solveY: function(r) {
      var i = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(r - this.center.x, 2));
      return [this.center.y - i, this.center.y + i];
    }
  };
};
function mS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function yS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mS(Object(r), !0).forEach(function(i) {
      X1t(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : mS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function X1t(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ka(t) {
  return K1t(t) || G1t(t) || W1t(t) || q1t();
}
function q1t() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W1t(t, e) {
  if (t) {
    if (typeof t == "string") return I9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return I9(t, e);
  }
}
function G1t(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function K1t(t) {
  if (Array.isArray(t)) return I9(t);
}
function I9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
var O4 = function(t, e) {
  var r = t.x, i = t.x0, s = t.y, c = t.y0, u = t.horizontal, l = t.alignment || "middle", f = l === "middle" ? e / 2 : e, o = u ? -1 : 1;
  return u ? {
    x0: i,
    x1: r,
    y0: l === "start" ? s : s - o * f,
    y1: l === "end" ? s : s + o * f
  } : {
    x0: l === "start" ? r : r - o * f,
    x1: l === "end" ? r : r + o * f,
    y0: c,
    y1: s
  };
}, rc = function(t, e) {
  var r = t.data, i = t.scale, s = r[e]._x1 === void 0 ? "_x" : "_x1";
  return i.x(r[e][s]);
}, Y1t = function(t, e) {
  var r = t.scale, i = r.y.range(), s = Math.max.apply(Math, ka(i)), c = Math.abs(r.x.range()[1] - r.x.range()[0]);
  return e / (2 * Math.PI * s) * c;
}, bS = function(t) {
  return -1 * t + Math.PI / 2;
}, Z1t = function(t, e) {
  var r = t.getPath;
  if (typeof r == "function") {
    var i = yS(yS({}, t), O4(t, e));
    return r(i);
  }
}, J1t = function(t, e) {
  var r = t.data, i = t.scale, s = t.alignment, c = rc(t, e), u = Math.abs(i.x.range()[1] - i.x.range()[0]), l = e === 0 ? rc(t, r.length - 1) - Math.PI * 2 : rc(t, e - 1);
  return e === 0 && u < 2 * Math.PI ? i.x.range()[0] : s === "start" || s === "end" ? s === "start" ? l : c : (c + l) / 2;
}, Q1t = function(t, e) {
  var r = t.data, i = t.scale, s = t.alignment, c = rc(t, e), u = Math.abs(i.x.range()[1] - i.x.range()[0]), l = i.x.range()[1] === 2 * Math.PI ? rc(t, 0) + Math.PI * 2 : i.x.range()[1], f = e === r.length - 1 ? rc(t, 0) + Math.PI * 2 : rc(t, e + 1);
  return e === r.length - 1 && u < 2 * Math.PI ? l : s === "start" || s === "end" ? s === "start" ? c : f : (c + f) / 2;
}, GT = function(t, e, r) {
  var i = "".concat(e.topLeft, " ").concat(e.topLeft, " ").concat(r), s = "".concat(e.topRight, " ").concat(e.topRight, " ").concat(r), c = "".concat(e.bottomLeft, " ").concat(e.bottomLeft, " ").concat(r), u = "".concat(e.bottomRight, " ").concat(e.bottomRight, " ").concat(r), l = ["M", "A ".concat(c, ","), "L", "A ".concat(i, ","), "L", "A ".concat(s, ","), "L", "A ".concat(u, ",")], f = l.reduce(function(o, g, p) {
    return "".concat(o).concat(g, " ").concat(t[p].x, ", ").concat(t[p].y, ` 
`);
  }, "");
  return "".concat(f, " z");
}, tht = function(t, e, r) {
  var i = t.x0, s = t.x1, c = t.y0, u = t.y1, l = function(f) {
    var o = f === "Left", g = o ? 1 : -1, p = o ? i : s, n = {
      x: p + g * r["bottom".concat(f)],
      y: c
    }, a = {
      x: p,
      y: c - e * r["bottom".concat(f)]
    }, d = {
      x: p,
      y: u + e * r["top".concat(f)]
    }, m = {
      x: p + g * r["top".concat(f)],
      y: u
    }, b = e === 1 ? c - r["bottom".concat(f)] < u + r["top".concat(f)] : c + r["bottom".concat(f)] > u - r["top".concat(f)];
    if (b) {
      var w = ps(p + g * r["top".concat(f)], u + e * r["top".concat(f)]), v = fg(w, r["top".concat(f)]), h = ps(p + g * r["bottom".concat(f)], c - e * r["bottom".concat(f)]), x = fg(h, r["bottom".concat(f)]), _ = v.intersection(x), M = _.length > 0;
      if (M) {
        var O = _[o ? 0 : 1];
        a = {
          x: O.x,
          y: O.y
        }, d = {
          x: O.x,
          y: O.y
        };
      } else {
        var E = r["top".concat(f)] > r["bottom".concat(f)];
        if (E) {
          var I = v.solveX(c)[o ? 0 : 1];
          n = {
            x: I,
            y: c
          }, a = {
            x: I,
            y: c
          }, d = {
            x: I,
            y: c
          };
        } else {
          var R = x.solveX(u)[o ? 0 : 1];
          a = {
            x: R,
            y: u
          }, d = {
            x: R,
            y: u
          }, m = {
            x: R,
            y: u
          };
        }
      }
    }
    var W = [n, a, d, m];
    return o ? W : W.reverse();
  };
  return l("Left").concat(l("Right"));
}, eht = function(t, e, r) {
  var i = t.y0, s = t.y1, c = t.x0 < t.x1 ? t.x0 : t.x1, u = t.x0 < t.x1 ? t.x1 : t.x0, l = function(g) {
    var p = g === "top", n = p ? -1 : 1, a = p ? s : i, d = {
      x: c,
      y: a - n * r["".concat(g, "Left")]
    }, m = {
      x: c + r["".concat(g, "Left")],
      y: a
    }, b = {
      x: u - r["".concat(g, "Right")],
      y: a
    }, w = {
      x: u,
      y: a - n * r["".concat(g, "Right")]
    }, v = m.x > b.x;
    if (v) {
      var h = ps(c + r["".concat(g, "Left")], a - n * r["".concat(g, "Left")]), x = fg(h, r["".concat(g, "Left")]), _ = ps(u - r["".concat(g, "Right")], a - n * r["".concat(g, "Right")]), M = fg(_, r["".concat(g, "Right")]), O = x.intersection(M), E = O.length > 0;
      if (E) {
        var I = O[e > 0 ? 1 : 0];
        m = {
          x: I.x,
          y: I.y
        }, b = {
          x: I.x,
          y: I.y
        };
      } else {
        var R = r["".concat(g, "Right")] > r["".concat(g, "Left")];
        if (R) {
          var W = M.solveY(c)[p ? 0 : 1];
          d = {
            x: c,
            y: W
          }, m = {
            x: c,
            y: W
          }, b = {
            x: c,
            y: W
          };
        } else {
          var z = x.solveY(u)[p ? 0 : 1];
          w = {
            x: u,
            y: z
          }, b = {
            x: u,
            y: z
          }, m = {
            x: u,
            y: z
          };
        }
      }
    }
    return [d, m, b, w];
  }, f = l("top"), o = l("bottom");
  return [o[1], o[0]].concat(ka(f), [
    // eslint-disable-next-line no-magic-numbers
    o[3],
    o[2]
  ]);
}, nht = function(t, e, r) {
  var i = O4(t, e), s = i.y0 > i.y1 ? 1 : -1, c = s > 0 ? "0 0 1" : "0 0 0", u = tht(i, s, r);
  return GT(u, r, c);
}, rht = function(t, e, r) {
  var i = O4(t, e), s = i.x0 < i.x1 ? 1 : -1, c = "0 0 1", u = {
    topRight: s > 0 ? r.topLeft : r.bottomLeft,
    bottomRight: s > 0 ? r.topRight : r.bottomRight,
    bottomLeft: s > 0 ? r.bottomRight : r.topRight,
    topLeft: s > 0 ? r.bottomLeft : r.topLeft
  }, l = eht(i, s, u);
  return GT(l, u, c);
}, iht = function(t, e) {
  var r = t.datum, i = t.scale, s = t.index, c = t.alignment, u = t.style, l = i.y(r._y0 || 0), f = i.y(r._y1 !== void 0 ? r._y1 : r._y), o = i.x(r._x1 !== void 0 ? r._x1 : r._x), g, p;
  if (u.width) {
    var n = Y1t(t, u.width), a = c === "middle" ? n / 2 : n;
    g = c === "start" ? o : o - a, p = c === "end" ? o : o + a;
  } else
    g = J1t(t, Number(s)), p = Q1t(t, Number(s));
  var d = function(M) {
    var O = O0t().innerRadius(l).outerRadius(f).startAngle(bS(g)).endAngle(bS(p)).cornerRadius(e[M]);
    return O();
  }, m = function(M) {
    var O = d("".concat(M, "Right")), E = O.match(/[A-Z]/g) || [], I = O.split(/[A-Z]/).slice(1), R = E.indexOf("L"), W = d("".concat(M, "Left")), z = W.match(/[A-Z]/g) || [], j = W.split(/[A-Z]/).slice(1), $ = z.indexOf("L");
    return {
      rightMoves: E,
      rightCoords: I,
      rightMiddle: R,
      leftMoves: z,
      leftCoords: j,
      leftMiddle: $
    };
  }, b = function() {
    var M = e.topRight, O = e.topLeft, E = f * Math.abs(p - g), I = m("top"), R = I.rightMoves, W = I.rightCoords, z = I.rightMiddle, j = I.leftMoves, $ = I.leftCoords, B = I.leftMiddle, C, T;
    if (M === O || E < 2 * M + 2 * O)
      C = M > O ? R : j, T = M > O ? W : $;
    else {
      var F = function(Q) {
        return Q < 3;
      }, S = O > M && F(z) ? 1 : 2, A;
      if (M > O) {
        var U = F(z) ? B : B - 2;
        A = F(B) ? B - 1 : U;
      } else {
        var K = F(B) ? 1 : 2;
        A = F(z) ? K : B - 2;
      }
      C = [].concat(ka(R.slice(0, S)), ka(j.slice(A))), T = [].concat(ka(W.slice(0, S)), ka($.slice(A)));
    }
    var X = C.indexOf("L"), L = C.slice(0, X), H = T.slice(0, X);
    return L.map(function(Q, N) {
      return {
        command: Q,
        coords: H[N].split(",")
      };
    });
  }, w = function() {
    var M = e.bottomRight, O = e.bottomLeft, E = l * Math.abs(p - g), I = m("bottom"), R = I.rightMoves, W = I.rightCoords, z = I.rightMiddle, j = I.leftMoves, $ = I.leftCoords, B = I.leftMiddle, C, T;
    if (M === O || E < 2 * M + 2 * O)
      C = M > O ? R : j, T = M > O ? W : $;
    else {
      var F = function(L, H) {
        return L.length - H < 4;
      }, S = M > O ? F(R, z) : F(j, B), A = S ? -1 : -3;
      C = [].concat(ka(j.slice(0, B + 2)), ka(R.slice(A))), T = [].concat(ka($.slice(0, B + 2)), ka(W.slice(A)));
    }
    var U = C.indexOf("L"), K = C.slice(U, -1), X = T.slice(U, -1);
    return K.map(function(L, H) {
      return {
        command: L,
        coords: X[H].split(",")
      };
    });
  }, v = b(), h = w(), x = [].concat(ka(v), ka(h)), _ = x.reduce(function(M, O) {
    return "".concat(M).concat(O.command, " ").concat(O.coords.join());
  }, "");
  return "".concat(_, " z");
}, aht = function(t, e, r) {
  return t.getPath ? Z1t(t, e) : t.horizontal ? rht(t, e, r) : nht(t, e, r);
}, sht = function(t, e) {
  return iht(t, e);
};
function vS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function gd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vS(Object(r), !0).forEach(function(i) {
      oht(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function oht(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var lht = function(t) {
  var e = z1t(t.style, t), r = j1t(t.barWidth, Object.assign({}, t, {
    style: e
  })), i = V1t(t.cornerRadius, Object.assign({}, t, {
    style: e,
    barWidth: r
  })), s = Te(t.ariaLabel, t), c = Te(t.desc, t), u = Te(t.id, t), l = Te(t.tabIndex, t);
  return Object.assign({}, t, {
    ariaLabel: s,
    style: e,
    barWidth: r,
    cornerRadius: i,
    desc: c,
    id: u,
    tabIndex: l
  });
}, cht = {
  pathComponent: /* @__PURE__ */ Bt.createElement(G7, null),
  role: "presentation",
  shapeRendering: "auto"
}, uht = /* @__PURE__ */ kn(function(e, r) {
  var i = lht(gd(gd({}, cht), e)), s = i.polar, c = i.origin, u = i.style, l = i.barWidth, f = i.cornerRadius, o = s ? sht(i, f) : aht(i, l, f), g = s && c ? "translate(".concat(c.x, ", ").concat(c.y, ")") : void 0;
  return i.pathComponent ? /* @__PURE__ */ Bt.cloneElement(i.pathComponent, gd(gd({}, i.events), {}, {
    "aria-label": i.ariaLabel,
    style: u,
    d: o,
    className: i.className,
    clipPath: i.clipPath,
    desc: i.desc,
    index: i.index,
    role: i.role,
    shapeRendering: i.shapeRendering,
    transform: i.transform || g,
    tabIndex: i.tabIndex,
    ref: r
  })) : null;
});
function hht(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fht(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function dht(t, e, r) {
  return e && fht(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function ght(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && F9(t, e);
}
function F9(t, e) {
  return F9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, F9(t, e);
}
function pht(t) {
  var e = bht();
  return function() {
    var i = dg(t), s;
    if (e) {
      var c = dg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return mht(this, s);
  };
}
function mht(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yht(t);
}
function yht(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function bht() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function dg(t) {
  return dg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, dg(t);
}
var KT = {
  width: 450,
  height: 300,
  padding: 50
}, vht = [{
  x: 1,
  y: 1
}, {
  x: 2,
  y: 2
}, {
  x: 3,
  y: 3
}, {
  x: 4,
  y: 4
}], Fs = /* @__PURE__ */ function(t) {
  ght(r, t);
  var e = pht(r);
  function r() {
    return hht(this, r), e.apply(this, arguments);
  }
  return dht(r, [{
    key: "shouldAnimate",
    value: (
      // Overridden in native versions
      function() {
        return !!this.props.animate;
      }
    )
  }, {
    key: "render",
    value: function() {
      var s = R9.animationWhitelist, c = R9.role, u = qo(this.props, KT, c);
      if (this.shouldAnimate())
        return this.animateComponent(u, s);
      var l = this.renderData(u), f = u.standalone ? this.renderContainer(u.containerComponent, l) : l;
      return Mrt(f, u);
    }
  }]), r;
}(Bt.Component);
Fs.animationWhitelist = ["data", "domain", "height", "padding", "style", "width"];
Fs.displayName = "VictoryBar";
Fs.role = "bar";
Fs.defaultTransitions = {
  onLoad: {
    duration: 2e3,
    before: function() {
      return {
        _y: 0,
        _y1: 0,
        _y0: 0
      };
    },
    after: function(t) {
      return {
        _y: t._y,
        _y1: t._y1,
        _y0: t._y0
      };
    }
  },
  onExit: {
    duration: 500,
    before: function() {
      return {
        _y: 0,
        yOffset: 0
      };
    }
  },
  onEnter: {
    duration: 500,
    before: function() {
      return {
        _y: 0,
        _y1: 0,
        _y0: 0
      };
    },
    after: function(t) {
      return {
        _y: t._y,
        _y1: t._y1,
        _y0: t._y0
      };
    }
  }
};
Fs.defaultProps = {
  containerComponent: /* @__PURE__ */ Bt.createElement(Is, null),
  data: vht,
  dataComponent: /* @__PURE__ */ Bt.createElement(uht, null),
  groupComponent: /* @__PURE__ */ Bt.createElement("g", {
    role: "presentation"
  }),
  labelComponent: /* @__PURE__ */ Bt.createElement(ts, null),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: Hh.grayscale
};
Fs.getDomain = A9;
Fs.getData = wl;
Fs.getBaseProps = function(t) {
  return N1t(t, KT);
};
Fs.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
var R9 = Z7(Fs), wht = Ms, xht = function() {
  return wht.Date.now();
}, Sht = xht, Cht = /\s/;
function Aht(t) {
  for (var e = t.length; e-- && Cht.test(t.charAt(e)); )
    ;
  return e;
}
var _ht = Aht, kht = _ht, Oht = /^\s+/;
function Tht(t) {
  return t && t.slice(0, kht(t) + 1).replace(Oht, "");
}
var Mht = Tht, Eht = Mht, wS = Es, Pht = $h, xS = NaN, Iht = /^[-+]0x[0-9a-f]+$/i, Fht = /^0b[01]+$/i, Rht = /^0o[0-7]+$/i, Dht = parseInt;
function $ht(t) {
  if (typeof t == "number")
    return t;
  if (Pht(t))
    return xS;
  if (wS(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = wS(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = Eht(t);
  var r = Fht.test(t);
  return r || Rht.test(t) ? Dht(t.slice(2), r ? 2 : 8) : Iht.test(t) ? xS : +t;
}
var Lht = $ht, Nht = Es, Dm = Sht, SS = Lht, Bht = "Expected a function", jht = Math.max, Uht = Math.min;
function Hht(t, e, r) {
  var i, s, c, u, l, f, o = 0, g = !1, p = !1, n = !0;
  if (typeof t != "function")
    throw new TypeError(Bht);
  e = SS(e) || 0, Nht(r) && (g = !!r.leading, p = "maxWait" in r, c = p ? jht(SS(r.maxWait) || 0, e) : c, n = "trailing" in r ? !!r.trailing : n);
  function a(M) {
    var O = i, E = s;
    return i = s = void 0, o = M, u = t.apply(E, O), u;
  }
  function d(M) {
    return o = M, l = setTimeout(w, e), g ? a(M) : u;
  }
  function m(M) {
    var O = M - f, E = M - o, I = e - O;
    return p ? Uht(I, c - E) : I;
  }
  function b(M) {
    var O = M - f, E = M - o;
    return f === void 0 || O >= e || O < 0 || p && E >= c;
  }
  function w() {
    var M = Dm();
    if (b(M))
      return v(M);
    l = setTimeout(w, m(M));
  }
  function v(M) {
    return l = void 0, n && i ? a(M) : (i = s = void 0, u);
  }
  function h() {
    l !== void 0 && clearTimeout(l), o = 0, i = f = s = l = void 0;
  }
  function x() {
    return l === void 0 ? u : v(Dm());
  }
  function _() {
    var M = Dm(), O = b(M);
    if (i = arguments, s = this, f = M, O) {
      if (l === void 0)
        return d(f);
      if (p)
        return clearTimeout(l), l = setTimeout(w, e), a(f);
    }
    return l === void 0 && (l = setTimeout(w, e)), u;
  }
  return _.cancel = h, _.flush = x, _;
}
var Vht = Hht, zht = Vht, Xht = Es, qht = "Expected a function";
function Wht(t, e, r) {
  var i = !0, s = !0;
  if (typeof t != "function")
    throw new TypeError(qht);
  return Xht(r) && (i = "leading" in r ? !!r.leading : i, s = "trailing" in r ? !!r.trailing : s), zht(t, e, {
    leading: i,
    maxWait: e,
    trailing: s
  });
}
var Ght = Wht;
const Kht = /* @__PURE__ */ Dn(Ght);
function Yht(t) {
  for (var e = -1, r = t == null ? 0 : t.length, i = {}; ++e < r; ) {
    var s = t[e];
    i[s[0]] = s[1];
  }
  return i;
}
var Zht = Yht;
const Jht = /* @__PURE__ */ Dn(Zht);
var D9 = { exports: {} };
(function(t, e) {
  e = t.exports = r, e.getSerialize = i;
  function r(s, c, u, l) {
    return JSON.stringify(s, i(c, l), u);
  }
  function i(s, c) {
    var u = [], l = [];
    return c == null && (c = function(f, o) {
      return u[0] === o ? "[Circular ~]" : "[Circular ~." + l.slice(0, u.indexOf(o)).join(".") + "]";
    }), function(f, o) {
      if (u.length > 0) {
        var g = u.indexOf(this);
        ~g ? u.splice(g + 1) : u.push(this), ~g ? l.splice(g, 1 / 0, f) : l.push(f), ~u.indexOf(o) && (o = c.call(this, f, o));
      } else u.push(o);
      return s == null ? o : s.call(this, f, o);
    };
  }
})(D9, D9.exports);
var Qht = D9.exports;
const tft = /* @__PURE__ */ Dn(Qht);
function eft(t, e) {
  return ift(t) || rft(t, e) || YT(t, e) || nft();
}
function nft() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rft(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var i = [], s = !0, c = !1, u, l;
    try {
      for (r = r.call(t); !(s = (u = r.next()).done) && (i.push(u.value), !(e && i.length === e)); s = !0)
        ;
    } catch (f) {
      c = !0, l = f;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (c) throw l;
      }
    }
    return i;
  }
}
function ift(t) {
  if (Array.isArray(t)) return t;
}
function aft(t) {
  return lft(t) || oft(t) || YT(t) || sft();
}
function sft() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YT(t, e) {
  if (t) {
    if (typeof t == "string") return $9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $9(t, e);
  }
}
function oft(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function lft(t) {
  if (Array.isArray(t)) return $9(t);
}
function $9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function cft(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uft(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function hft(t, e, r) {
  return e && uft(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function fft(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && L9(t, e);
}
function L9(t, e) {
  return L9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, L9(t, e);
}
function dft(t) {
  var e = pft();
  return function() {
    var i = gg(t), s;
    if (e) {
      var c = gg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return gft(this, s);
  };
}
function gft(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return N9(t);
}
function N9(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function pft() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function gg(t) {
  return gg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gg(t);
}
var Wh = /* @__PURE__ */ function(t) {
  fft(r, t);
  var e = dft(r);
  function r(i) {
    var s;
    return cft(this, r), s = e.call(this, i), s.getScopedEvents = void 0, s.getEventState = void 0, s.baseProps = void 0, s.sharedEventsCache = void 0, s.globalEvents = void 0, s.prevGlobalEventKeys = void 0, s.boundGlobalEvents = void 0, s.getScopedEvents = HO.bind(N9(s)), s.getEventState = zO.bind(N9(s)), s.state = s.state || {}, s.sharedEventsCache = {}, s.globalEvents = {}, s.prevGlobalEventKeys = [], s.boundGlobalEvents = {}, s.baseProps = s.getBaseProps(i), s;
  }
  return hft(r, [{
    key: "shouldComponentUpdate",
    value: function(s) {
      if (!Wo(this.props, s)) {
        this.baseProps = this.getBaseProps(s);
        var c = this.getExternalMutations(s, this.baseProps);
        this.applyExternalMutations(s, c);
      }
      return !0;
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var s = this, c = Object.keys(this.globalEvents);
      c.forEach(function(u) {
        return s.addGlobalListener(u);
      }), this.prevGlobalEventKeys = c;
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var s = this, c = Object.keys(this.globalEvents), u = G2(this.prevGlobalEventKeys, c);
      u.forEach(function(f) {
        return s.removeGlobalListener(f);
      });
      var l = G2(c, this.prevGlobalEventKeys);
      l.forEach(function(f) {
        return s.addGlobalListener(f);
      }), this.prevGlobalEventKeys = c;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var s = this;
      this.prevGlobalEventKeys.forEach(function(c) {
        return s.removeGlobalListener(c);
      });
    }
  }, {
    key: "addGlobalListener",
    value: function(s) {
      var c = this, u = function(l) {
        var f = c.globalEvents[s];
        return f && f(GO(l));
      };
      this.boundGlobalEvents[s] = u, window.addEventListener(tg(s), u);
    }
  }, {
    key: "removeGlobalListener",
    value: function(s) {
      window.removeEventListener(tg(s), this.boundGlobalEvents[s]);
    }
  }, {
    key: "getAllEvents",
    value: function(s) {
      var c = ["container", "groupComponent"], u = Y7(s, c);
      return Array.isArray(u) ? Array.isArray(s.events) ? u.concat.apply(u, aft(s.events)) : u : s.events;
    }
  }, {
    key: "applyExternalMutations",
    value: function(s, c) {
      if (!ar(c)) {
        var u = s.externalEventMutations.reduce(function(f, o) {
          return Cn(o.callback) ? f.concat(o.callback) : f;
        }, []), l = u.length ? function() {
          u.forEach(function(f) {
            return f();
          });
        } : void 0;
        this.setState(c, l);
      }
    }
  }, {
    key: "getExternalMutations",
    value: function(s, c) {
      return ar(s.externalEventMutations) ? void 0 : Pot(s.externalEventMutations, c, this.state, Object.keys(c));
    }
  }, {
    key: "cacheSharedEvents",
    value: function(s, c, u) {
      this.sharedEventsCache[s] = [c, u];
    }
  }, {
    key: "getCachedSharedEvents",
    value: function(s, c) {
      var u = this.sharedEventsCache[s] || [], l = eft(u, 2), f = l[0], o = l[1];
      if (f && Wo(c, o))
        return f;
    }
  }, {
    key: "getBaseProps",
    value: function(s) {
      var c = s.container, u = Bt.Children.toArray(this.props.children), l = this.getBasePropsFromChildren(u), f = c ? c.props : {};
      return Object.assign({}, l, {
        parent: f
      });
    }
  }, {
    key: "getBasePropsFromChildren",
    value: function(s) {
      var c = function(l, f) {
        if (l.type && Cn(l.type.getBaseProps)) {
          var o = l.props && l.type.getBaseProps(l.props);
          return o ? [[f, o]] : null;
        }
        return null;
      }, u = k0(s, c);
      return Jht(u);
    }
  }, {
    key: "getNewChildren",
    value: function(s, c) {
      var u = this, l = s.events, f = s.eventKey, o = function(n, a) {
        return n.reduce(function(d, m, b) {
          if (m.props.children) {
            var w = Bt.Children.toArray(m.props.children), v = a.slice(b, b + w.length), h = /* @__PURE__ */ Bt.cloneElement(m, m.props, o(w, v));
            return d.concat(h);
          } else if (a[b] !== "parent" && m.type && Cn(m.type.getBaseProps)) {
            var x = m.props.name || a[b], _ = Array.isArray(l) && l.filter(function(E) {
              return E.target === "parent" ? !1 : Array.isArray(E.childName) ? E.childName.indexOf(x) > -1 : E.childName === x || E.childName === "all";
            }), M = [x, c, _, tft(u.state[x])], O = u.getCachedSharedEvents(x, M) || {
              events: _,
              // partially apply child name and baseProps,
              getEvents: function(E, I) {
                return u.getScopedEvents(E, I, x, c);
              },
              // partially apply child name
              getEventState: function(E, I) {
                return u.getEventState(E, I, x);
              }
            };
            return u.cacheSharedEvents(x, O, M), d.concat(/* @__PURE__ */ Bt.cloneElement(m, Object.assign({
              key: "events-".concat(x),
              sharedEvents: O,
              eventKey: f,
              name: x
            }, m.props)));
          }
          return d.concat(m);
        }, []);
      }, g = Object.keys(c), p = Bt.Children.toArray(s.children);
      return o(p, g);
    }
  }, {
    key: "getContainer",
    value: function(s, c, u) {
      var l = this, f = this.getNewChildren(s, c), o = Array.isArray(u) ? u.filter(function(h) {
        return h.target === "parent";
      }) : [], g = o.length > 0 ? {
        events: o,
        // partially apply childName (null) and baseProps,
        getEvents: function(h, x) {
          return l.getScopedEvents(h, x, null, c);
        },
        getEventState: this.getEventState
      } : null, p = s.container || s.groupComponent, n = p.type && p.type.role, a = p.props || {}, d = UO.bind(this), m = g && d({
        sharedEvents: g
      }, "parent"), b = Ie({}, this.getEventState("parent", "parent"), a, c.parent, {
        children: f
      }), w = Ie({}, VO(m, "parent", b), a.events);
      this.globalEvents = qO(w);
      var v = WO(w);
      return n === "container" ? /* @__PURE__ */ Bt.cloneElement(p, Object.assign({}, b, {
        events: v
      })) : /* @__PURE__ */ Bt.cloneElement(p, v, f);
    }
  }, {
    key: "render",
    value: function() {
      var s = this.getAllEvents(this.props);
      return s ? this.getContainer(this.props, this.baseProps, s) : /* @__PURE__ */ Bt.cloneElement(this.props.container, {
        children: this.props.children
      });
    }
  }]), r;
}(Bt.Component);
Wh.displayName = "VictorySharedEvents";
Wh.role = "shared-event-wrapper";
Wh.contextType = jh;
Wh.defaultProps = {
  groupComponent: /* @__PURE__ */ Bt.createElement("g", null)
};
var ji = function(t, e, r) {
  return r === "x" ? t * Math.cos(e) : -t * Math.sin(e);
}, ZT = function(t) {
  var e = t.dependentAxis ? "radial" : "angular", r = e === "angular" ? "radial" : "angular";
  return t.horizontal ? r : e;
}, mft = function(t, e) {
  var r = function(i) {
    return e(i) % (2 * Math.PI);
  };
  return D0t(t, r);
}, T4 = function(t, e) {
  return {
    tickStyle: Fr(t.ticks, e),
    labelStyle: Fr(t.tickLabels, e),
    gridStyle: Fr(t.grid, e)
  };
}, yft = function(t) {
  var e, r, i = t.theme, s = i === void 0 ? {} : i, c = t.dependentAxis, u = s.polarAxis && s.polarAxis.style || s.axis && s.axis.style, l = c ? "polarDependentAxis" : "polarIndependentAxis", f = c ? "dependentAxis" : "independentAxis", o = (s == null || (e = s[l]) === null || e === void 0 ? void 0 : e.style) || (s == null || (r = s[f]) === null || r === void 0 ? void 0 : r.style), g = function() {
    var p = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
    return p.reduce(function(n, a) {
      return n[a] = Ie({}, o == null ? void 0 : o[a], u == null ? void 0 : u[a]), n;
    }, {});
  };
  return u && o ? g() : o || u;
}, JT = function(t) {
  var e = Qa(t), r = e.left, i = e.right, s = e.top, c = e.bottom, u = t.width, l = t.height;
  if (u === void 0 || l === void 0)
    throw new Error("VictoryPolarAxis: width and height properties are required for standalone axes.");
  return Math.min(u - r - i, l - s - c) / 2;
}, QT = function(t, e) {
  if (t.range && t.range[e])
    return t.range[e];
  if (t.range && Array.isArray(t.range))
    return t.range;
  var r = ZT(t);
  if (r === "angular") {
    var i = jr(t.startAngle), s = jr(t.endAngle);
    return [i, s];
  }
  var c = JT(t);
  return [t.innerRadius || 0, c];
}, tM = function(t) {
  var e = Ba(t), r = ll(t, e), i = T0(t, e) || r.domain(), s = QT(t, e);
  return r.range(s), r.domain(i), r;
}, eM = function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t.disableInlineStyles)
    return {};
  var r = t.style || {}, i = {
    height: "auto",
    width: "100%"
  };
  return {
    parent: Ie(i, r.parent, e.parent),
    axis: Ie({}, r.axis, e.axis),
    axisLabel: Ie({}, r.axisLabel, e.axisLabel),
    grid: Ie({}, r.grid, e.grid),
    ticks: Ie({}, r.ticks, e.ticks),
    tickLabels: Ie({}, r.tickLabels, e.tickLabels)
  };
}, Op = function(t) {
  var e = t.axisAngle, r = t.startAngle, i = t.dependentAxis, s = Ba(t), c = UT(t, s);
  return c === void 0 || !i ? e === void 0 ? r : e : B7(c);
}, bft = function(t, e, r, i) {
  var s = e.axisType, c = e.radius, u = e.scale, l = e.style, f = e.stringTicks, o = e.ticks, g = e.tickFormat, p = e.origin, n = g(r, i, o), a = f ? f[i] : r, d = T4(l, {
    tick: a,
    tickValue: r,
    index: i,
    ticks: o,
    stringTicks: f,
    radius: c,
    scale: u,
    axisType: s,
    text: n
  }), m = d.tickStyle, b = s === "radial" ? Op(t) : void 0, w = m.padding || m.size || 0, v = jr(90 - b), h = s === "angular" ? u(r) : jr(-1 * b), x = s === "angular" ? c : u(r);
  return s === "angular" ? {
    index: i,
    datum: a,
    style: m,
    x1: ji(x, h, "x") + p.x,
    y1: ji(x, h, "y") + p.y,
    x2: ji(x + w, h, "x") + p.x,
    y2: ji(x + w, h, "y") + p.y
  } : {
    index: i,
    datum: a,
    style: m,
    x1: x * Math.cos(h) + Math.cos(v) * w + p.x,
    x2: x * Math.cos(h) - Math.cos(v) * w + p.x,
    y1: x * Math.sin(h) + Math.sin(v) * w + p.y,
    y2: x * Math.sin(h) - Math.sin(v) * w + p.y
  };
}, vft = function(t, e, r, i) {
  var s = e.axisType, c = e.radius, u = e.tickFormat, l = e.style, f = e.scale, o = e.ticks, g = e.stringTicks, p = e.origin, n = u(r, i, o), a = g ? g[i] : r, d = T4(l, {
    text: n,
    tick: a,
    tickValue: r,
    index: i,
    ticks: o,
    stringTicks: g,
    radius: c,
    scale: f,
    axisType: s
  }), m = d.labelStyle, b = t.tickLabelComponent, w = b != null && b.props.labelPlacement ? b.props.labelPlacement : t.labelPlacement, v = m.padding || 0, h = 0, x = s === "radial" ? Op(t) : void 0, _ = s === "angular" ? B7(f(r)) : x + h, M = m.angle === void 0 ? z7(Object.assign({}, t, {
    labelPlacement: w
  }), _) : m.angle, O = s === "angular" ? c + v : f(r), E = m.textAnchor || V7(Object.assign({}, t, {
    labelPlacement: w
  }), _);
  return {
    index: i,
    datum: a,
    style: m,
    angle: M,
    textAnchor: E,
    text: n,
    x: O * Math.cos(jr(_)) + p.x,
    y: -O * Math.sin(jr(_)) + p.y
  };
}, wft = function(t, e, r, i) {
  var s = e.axisType, c = e.radius, u = e.style, l = e.scale, f = e.stringTicks, o = e.ticks, g = e.tickFormat, p = e.origin, n = g(r, i, o), a = t.startAngle, d = t.endAngle, m = t.innerRadius, b = m === void 0 ? 0 : m, w = f ? f[i] : r, v = T4(u, {
    tick: w,
    tickValue: r,
    index: i,
    ticks: o,
    stringTicks: f,
    radius: c,
    scale: l,
    axisType: s,
    text: n
  }), h = v.gridStyle, x = l(r);
  return s === "angular" ? {
    index: i,
    datum: w,
    style: h,
    x1: ji(c, x, "x") + p.x,
    y1: ji(c, x, "y") + p.y,
    x2: ji(b, x, "x") + p.x,
    y2: ji(b, x, "y") + p.y
  } : {
    style: h,
    index: i,
    datum: w,
    cx: p.x,
    cy: p.y,
    r: l(r),
    startAngle: a,
    endAngle: d
  };
}, xft = function(t, e) {
  var r = e.axisType, i = e.radius, s = e.style, c = e.origin, u = t.axisLabelComponent;
  if (r !== "radial")
    return {};
  var l = u != null && u.props.labelPlacement ? u.props.labelPlacement : t.labelPlacement, f = s && s.axisLabel || {}, o = r === "radial" ? Op(t) : void 0, g = f.angle === void 0 ? z7(Object.assign({}, t, {
    labelPlacement: l
  }), o) : f.angle, p = i + (f.padding || 0), n = f.textAnchor || V7(Object.assign({}, t, {
    labelPlacement: l
  }), o), a = f.verticalAnchor || _O(Object.assign({}, t, {
    labelPlacement: l
  }), o);
  return {
    style: f,
    angle: g,
    textAnchor: n,
    verticalAnchor: a,
    text: t.label,
    x: ji(p, jr(o), "x") + c.x,
    y: ji(p, jr(o), "y") + c.y
  };
}, Sft = function(t, e) {
  var r = e.style, i = e.axisType, s = e.radius, c = e.origin, u = t.startAngle, l = t.endAngle, f = t.innerRadius, o = f === void 0 ? 0 : f, g = i === "radial" ? jr(Op(t)) : void 0;
  return i === "radial" ? {
    style: r.axis,
    x1: ji(o, g, "x") + c.x,
    x2: ji(s, g, "x") + c.x,
    y1: ji(o, g, "y") + c.y,
    y2: ji(s, g, "y") + c.y
  } : {
    style: r.axis,
    cx: c.x,
    cy: c.y,
    r: s,
    startAngle: u,
    endAngle: l
  };
}, Cft = function(t) {
  var e = Object.assign({
    polar: !0
  }, t), r = yft(e), i = eM(e, r), s = Qa(e), c = Ba(e), u = ZT(e), l = _p(e) ? e.tickValues : void 0, f = T0(e, c), o = QT(e, c), g = tM(e), p = jT(e, g), n = u === "angular" ? mft(p, g) : p, a = BT(e, g), d = JT(e), m = j7(e);
  return {
    axis: c,
    style: i,
    padding: s,
    stringTicks: l,
    axisType: u,
    scale: g,
    ticks: n,
    tickFormat: a,
    domain: f,
    range: o,
    radius: d,
    origin: m
  };
}, Aft = function(t, e) {
  var r = kp(t, e), i = Cft(r), s = i.style, c = i.scale, u = i.ticks, l = i.domain, f = r.width, o = r.height, g = r.standalone, p = r.theme, n = r.name, a = Sft(r, i), d = xft(r, i), m = {
    parent: {
      style: s.parent,
      ticks: u,
      scale: c,
      width: f,
      height: o,
      domain: l,
      standalone: g,
      theme: p,
      name: n
    }
  };
  return u.reduce(function(b, w, v) {
    return b[v] = {
      axis: a,
      axisLabel: d,
      ticks: bft(r, i, w, v),
      tickLabels: vft(r, i, w, v),
      grid: wft(r, i, w, v)
    }, b;
  }, m);
};
function $m(t) {
  return Tft(t) || Oft(t) || kft(t) || _ft();
}
function _ft() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kft(t, e) {
  if (t) {
    if (typeof t == "string") return B9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return B9(t, e);
  }
}
function Oft(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Tft(t) {
  if (Array.isArray(t)) return B9(t);
}
function B9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function Mft(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Eft(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Pft(t, e, r) {
  return e && Eft(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Ift(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && j9(t, e);
}
function j9(t, e) {
  return j9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, j9(t, e);
}
function Fft(t) {
  var e = $ft();
  return function() {
    var i = pg(t), s;
    if (e) {
      var c = pg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return Rft(this, s);
  };
}
function Rft(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Dft(t);
}
function Dft(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function $ft() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function pg(t) {
  return pg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, pg(t);
}
var M4 = {
  width: 450,
  height: 300,
  padding: 50
}, ja = /* @__PURE__ */ function(t) {
  Ift(r, t);
  var e = Fft(r);
  function r() {
    return Mft(this, r), e.apply(this, arguments);
  }
  return Pft(r, [{
    key: "renderAxisLine",
    value: function(s) {
      var c = s.dependentAxis, u = c ? s.axisComponent : s.circularAxisComponent, l = this.getComponentProps(u, "axis", 0);
      return /* @__PURE__ */ Bt.cloneElement(u, l);
    }
  }, {
    key: "renderLabel",
    value: function(s) {
      var c = s.axisLabelComponent, u = s.dependentAxis, l = s.label;
      if (!l || !u)
        return null;
      var f = this.getComponentProps(c, "axisLabel", 0);
      return /* @__PURE__ */ Bt.cloneElement(c, f);
    }
  }, {
    key: "renderAxis",
    value: function(s) {
      var c = this, u = s.tickComponent, l = s.tickLabelComponent, f = s.name, o = function(v) {
        var h = v.style, x = h === void 0 ? {} : h, _ = v.events, M = _ === void 0 ? {} : _, O = x.stroke !== "transparent" && x.stroke !== "none" && x.strokeWidth !== 0;
        return O || !ar(M);
      }, g = s.dependentAxis ? "radial" : "angular", p = g === "radial" ? s.circularGridComponent : s.gridComponent, n = this.dataKeys.map(function(v, h) {
        var x = Object.assign({
          key: "".concat(f, "-tick-").concat(v)
        }, c.getComponentProps(u, "ticks", h)), _ = /* @__PURE__ */ Bt.cloneElement(u, x);
        return o(_.props) ? _ : void 0;
      }).filter(Boolean), a = this.dataKeys.map(function(v, h) {
        var x = Object.assign({
          key: "".concat(f, "-grid-").concat(v)
        }, c.getComponentProps(p, "grid", h)), _ = /* @__PURE__ */ Bt.cloneElement(p, x);
        return o(_.props) ? _ : void 0;
      }).filter(Boolean), d = this.dataKeys.map(function(v, h) {
        var x = Object.assign({
          key: "".concat(f, "-tick-").concat(v)
        }, c.getComponentProps(l, "tickLabels", h));
        return /* @__PURE__ */ Bt.cloneElement(l, x);
      }), m = this.renderAxisLine(s), b = this.renderLabel(s), w = [m, b].concat($m(n), $m(a), $m(d));
      return this.renderGroup(s, w);
    }
    // Overridden in victory-native
  }, {
    key: "renderGroup",
    value: function(s, c) {
      var u = s.groupComponent;
      return /* @__PURE__ */ Bt.cloneElement(u, {}, c);
    }
  }, {
    key: "shouldAnimate",
    value: function() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function() {
      var s = U9.animationWhitelist, c = kp(this.props, M4);
      if (this.shouldAnimate())
        return this.animateComponent(c, s);
      var u = this.renderAxis(c);
      return c.standalone ? this.renderContainer(c.containerComponent, u) : u;
    }
  }]), r;
}(Bt.Component);
ja.animationWhitelist = ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"];
ja.displayName = "VictoryAxis";
ja.role = "axis";
ja.defaultTransitions = {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
};
ja.defaultProps = {
  axisComponent: /* @__PURE__ */ Bt.createElement(Cs, null),
  axisLabelComponent: /* @__PURE__ */ Bt.createElement(ts, null),
  circularAxisComponent: /* @__PURE__ */ Bt.createElement(vx, null),
  circularGridComponent: /* @__PURE__ */ Bt.createElement(vx, null),
  containerComponent: /* @__PURE__ */ Bt.createElement(Is, null),
  endAngle: 360,
  gridComponent: /* @__PURE__ */ Bt.createElement(Cs, null),
  groupComponent: /* @__PURE__ */ Bt.createElement("g", {
    role: "presentation"
  }),
  labelPlacement: "parallel",
  startAngle: 0,
  standalone: !0,
  theme: Hh.grayscale,
  tickComponent: /* @__PURE__ */ Bt.createElement(Cs, null),
  tickLabelComponent: /* @__PURE__ */ Bt.createElement(ts, null)
};
ja.getDomain = T0;
ja.getAxis = Ba;
ja.getScale = tM;
ja.getStyles = function(t) {
  return eM(t, M4.style);
};
ja.getBaseProps = function(t) {
  return Aft(t, M4);
};
ja.expectedComponents = ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"];
var Lft = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
}, U9 = Z7(ja, Lft), Nft = {
  width: 450,
  height: 300,
  padding: 50
};
function Bft(t, e, r) {
  var i = r.domain, s = r.scale, c = r.stringMap, u = r.categories, l = r.horizontal;
  return {
    stringMap: c,
    horizontal: l,
    categories: u,
    startAngle: e.startAngle,
    endAngle: e.endAngle,
    innerRadius: e.innerRadius,
    domain: i,
    scale: s
  };
}
function jft(t, e) {
  var r = t.backgroundComponent, i = t.polar ? e.range.y[1] : e.range.y[0] - e.range.y[1], s = e.range.x[1] - e.range.x[0], c = t.horizontal ? e.scale.y.range()[0] : e.scale.x.range()[0], u = t.horizontal ? e.scale.x.range()[1] : e.scale.y.range()[1], l = t.polar ? e.origin.x : c, f = t.polar ? e.origin.y : u, o = t.name || "chart", g = {
    height: i,
    polar: t.polar,
    scale: e.scale,
    style: t.style.background,
    x: l,
    y: f,
    key: "".concat(o, "-background"),
    width: s
  };
  return /* @__PURE__ */ Bt.cloneElement(r, Ie({}, r.props, g));
}
function Uft(t, e, r) {
  var i = $T([t]);
  if (i.length > 0)
    return Bft(i[0], e, r);
  var s = r.categories, c = r.domain, u = r.range, l = r.scale, f = r.stringMap, o = r.horizontal;
  return {
    categories: s,
    domain: c,
    range: u,
    scale: l,
    stringMap: f,
    horizontal: o
  };
}
function Hft(t) {
  var e = t.style && t.style.parent;
  return {
    parent: Ie({}, e, {
      height: "100%",
      width: "100%",
      userSelect: "none"
    })
  };
}
function nM(t, e) {
  var r = Hft(t), i = qo(t, Nft, "chart"), s = i.horizontal, c = i.polar, u = XT(i, e), l = W0t(i, e, u), f = zft(i, e, u), o = {
    x: CS(Object.assign({}, i, {
      categories: l
    }), "x", e),
    y: CS(Object.assign({}, i, {
      categories: l
    }), "y", e)
  }, g = {
    x: $a(i, "x"),
    y: $a(i, "y")
  }, p = {
    x: w9(i, "x") || dS(i, "x"),
    y: w9(i, "y") || dS(i, "y")
  }, n = {
    x: p.x.domain(o.x).range(s ? g.y : g.x),
    y: p.y.domain(o.y).range(s ? g.x : g.y)
  }, a = c ? j7(i) : NT(o), d = Qa(i);
  return {
    categories: l,
    domain: o,
    range: g,
    horizontal: s,
    scale: n,
    stringMap: f,
    style: r,
    origin: a,
    padding: d
  };
}
function Vft(t, e, r) {
  var i = e || rM(t), s = r || nM(t, i), c = s.style.parent, u = t.height, l = t.polar, f = t.theme, o = t.width, g = s.origin, p = s.horizontal, n = t.name || "chart";
  return i.filter(Bt.isValidElement).map(function(a, d) {
    var m = a.type && a.type.role, b = Array.isArray(a.props.style) ? a.props.style : Ie({}, a.props.style, {
      parent: c
    }), w = Uft(a, t, s), v = a.props.name || "".concat(n, "-").concat(m, "-").concat(d), h = Ie({
      horizontal: p,
      height: u,
      polar: l,
      theme: f,
      width: o,
      style: b,
      name: v,
      origin: l ? g : void 0,
      padding: s.padding,
      key: "".concat(v, "-key-").concat(d),
      standalone: !1
    }, w);
    return /* @__PURE__ */ Bt.cloneElement(a, h);
  });
}
var rM = function(t, e) {
  var r = Bt.Children.toArray(t.children);
  if (r.length === 0)
    r.push(e.independent, e.dependent);
  else {
    var i = {
      dependent: iS(r, "dependent"),
      independent: iS(r, "independent")
    };
    i.dependent.length === 0 && i.independent.length === 0 && (r = t.prependDefaultAxes ? [e.independent, e.dependent].concat(r) : r.concat([e.independent, e.dependent]));
  }
  return r;
}, CS = function(t, e, r) {
  var i = r || Bt.Children.toArray(t.children), s = V0t(t, e, i), c = LT(i, e), u = c && c.props && c.props.invertAxis;
  return u ? s.concat().reverse() : s;
}, zft = function(t, e, r) {
  var i = !r.x || r.x.length === 0 ? null : r.x.reduce(function(c, u, l) {
    return c[u] = l + 1, c;
  }, {}), s = !r.y || r.y.length === 0 ? null : r.y.reduce(function(c, u, l) {
    return c[u] = l + 1, c;
  }, {});
  return {
    x: i,
    y: s
  };
};
function AS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function _S(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? AS(Object(r), !0).forEach(function(i) {
      Xft(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : AS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function Xft(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var qft = {
  width: 450,
  height: 300,
  padding: 50
}, Wft = {
  backgroundComponent: /* @__PURE__ */ Bt.createElement(fst, null),
  containerComponent: /* @__PURE__ */ Bt.createElement(Is, null),
  defaultAxes: {
    independent: /* @__PURE__ */ Bt.createElement(Ws, null),
    dependent: /* @__PURE__ */ Bt.createElement(Ws, {
      dependentAxis: !0
    })
  },
  defaultPolarAxes: {
    independent: /* @__PURE__ */ Bt.createElement(U9, null),
    dependent: /* @__PURE__ */ Bt.createElement(U9, {
      dependentAxis: !0
    })
  },
  groupComponent: /* @__PURE__ */ Bt.createElement("g", null),
  standalone: !0,
  theme: Hh.grayscale
}, Gft = function(t) {
  var e = Bt.useMemo(function() {
    return _S(_S({}, Wft), t);
  }, [t]), r = "chart", i = d0t(), s = i.getAnimationProps, c = i.setAnimationState, u = i.getProps, l = u(e), f = qo(l, qft, r), o = f.desc, g = f.eventKey, p = f.containerComponent, n = f.standalone, a = f.groupComponent, d = f.externalEventMutations, m = f.width, b = f.height, w = f.theme, v = f.polar, h = f.name, x = f.title, _ = l.polar ? f.defaultPolarAxes : f.defaultAxes, M = Bt.useMemo(function() {
    return rM(f, _);
  }, [f, _]), O = Bt.useMemo(function() {
    return nM(f, M);
  }, [f, M]), E = O.domain, I = O.scale, R = O.style, W = O.origin, z = O.horizontal, j = Bt.useMemo(function() {
    var F = Vft(l, M, O), S = F.map(function(U, K) {
      var X = Object.assign({
        animate: s(l, U, K)
      }, U.props);
      return /* @__PURE__ */ Bt.cloneElement(U, X);
    });
    if (l.style && l.style.background) {
      var A = jft(l, O);
      S.unshift(A);
    }
    return S;
  }, [s, M, l, O]), $ = Bt.useMemo(function() {
    return n ? {
      desc: o,
      domain: E,
      width: m,
      height: b,
      horizontal: z,
      name: h,
      origin: v ? W : void 0,
      polar: v,
      theme: w,
      title: x,
      scale: I,
      standalone: n,
      style: R.parent
    } : {};
  }, [o, E, b, z, h, W, v, I, n, R, x, w, m]), B = Bt.useMemo(function() {
    if (n) {
      var F = Ie({}, p.props, $, O0(e));
      return /* @__PURE__ */ Bt.cloneElement(p, F);
    }
    return a;
  }, [a, n, p, $, e]), C = Bt.useMemo(function() {
    return z0t(l);
  }, [l]), T = a0t(e);
  return Bt.useEffect(function() {
    return function() {
      e.animate && c(T, e);
    };
  }, [c, T, e]), ar(C) ? /* @__PURE__ */ Bt.cloneElement(B, B.props, j) : /* @__PURE__ */ Bt.createElement(Wh, {
    container: B,
    eventKey: g,
    events: C,
    externalEventMutations: d
  }, j);
}, E4 = /* @__PURE__ */ Bt.memo(Gft, Wo);
E4.displayName = "VictoryChart";
E4.expectedComponents = ["groupComponent", "containerComponent"];
function kS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function Jl(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kS(Object(r), !0).forEach(function(i) {
      Kft(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : kS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function Kft(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var Yft = function(t) {
  var e = t.pointerWidth, r = t.cornerRadius, i = t.orientation, s = t.width, c = t.height, u = t.center, l = i === "bottom" ? 1 : -1, f = t.x + (t.dx || 0), o = t.y + (t.dy || 0), g = u.x, p = u.y, n = p + l * (c / 2), a = p - l * (c / 2), d = g + s / 2, m = g - s / 2, b = l * (o - n) < 0 ? 0 : t.pointerLength, w = i === "bottom" ? "0 0 0" : "0 0 1", v = "".concat(r, " ").concat(r, " ").concat(w);
  return "M ".concat(g - e / 2, ", ").concat(n, `
    L `).concat(b ? f : g + e / 2, ", ").concat(b ? o : n, `
    L `).concat(g + e / 2, ", ").concat(n, `
    L `).concat(d - r, ", ").concat(n, `
    A `).concat(v, " ").concat(d, ", ").concat(n - l * r, `
    L `).concat(d, ", ").concat(a + l * r, `
    A `).concat(v, " ").concat(d - r, ", ").concat(a, `
    L `).concat(m + r, ", ").concat(a, `
    A `).concat(v, " ").concat(m, ", ").concat(a + l * r, `
    L `).concat(m, ", ").concat(n - l * r, `
    A `).concat(v, " ").concat(m + r, ", ").concat(n, `
    z`);
}, Zft = function(t) {
  var e = t.pointerWidth, r = t.cornerRadius, i = t.orientation, s = t.width, c = t.height, u = t.center, l = i === "left" ? 1 : -1, f = t.x + (t.dx || 0), o = t.y + (t.dy || 0), g = u.x, p = u.y, n = g - l * (s / 2), a = g + l * (s / 2), d = p + c / 2, m = p - c / 2, b = l * (f - n) > 0 ? 0 : t.pointerLength, w = i === "left" ? "0 0 0" : "0 0 1", v = "".concat(r, " ").concat(r, " ").concat(w);
  return "M ".concat(n, ", ").concat(p - e / 2, `
    L `).concat(b ? f : n, ", ").concat(b ? o : p + e / 2, `
    L `).concat(n, ", ").concat(p + e / 2, `
    L `).concat(n, ", ").concat(d - r, `
    A `).concat(v, " ").concat(n + l * r, ", ").concat(d, `
    L `).concat(a - l * r, ", ").concat(d, `
    A `).concat(v, " ").concat(a, ", ").concat(d - r, `
    L `).concat(a, ", ").concat(m + r, `
    A `).concat(v, " ").concat(a - l * r, ", ").concat(m, `
    L `).concat(n + l * r, ", ").concat(m, `
    A `).concat(v, " ").concat(n, ", ").concat(m + r, `
    z`);
}, Jft = function(t) {
  var e = t.orientation || "top";
  return e === "left" || e === "right" ? Zft(t) : Yft(t);
}, Qft = function(t) {
  var e = Te(t.id, t), r = Fr(t.style, t);
  return Jl(Jl({}, t), {}, {
    id: e,
    style: r
  });
}, tdt = {
  pathComponent: /* @__PURE__ */ Bt.createElement(G7, null),
  role: "presentation",
  shapeRendering: "auto"
}, edt = function(t) {
  var e = Qft(Jl(Jl({}, tdt), t)), r = O0(e);
  od(e.height, "Flyout props[height] is undefined"), od(e.width, "Flyout props[width] is undefined"), od(e.x, "Flyout props[x] is undefined"), od(e.y, "Flyout props[y] is undefined");
  var i = {
    center: e.center || {
      x: 0,
      y: 0
    },
    cornerRadius: e.cornerRadius || 0,
    dx: e.dx,
    dy: e.dy,
    height: e.height,
    orientation: e.orientation || "top",
    pointerLength: e.pointerLength || 0,
    pointerWidth: e.pointerWidth || 0,
    width: e.width,
    x: e.x,
    y: e.y
  };
  return /* @__PURE__ */ Bt.cloneElement(e.pathComponent, Jl(Jl(Jl({}, e.events), r), {}, {
    style: e.style,
    d: Jft(i),
    className: e.className,
    shapeRendering: e.shapeRendering,
    role: e.role,
    transform: e.transform,
    clipPath: e.clipPath
  }));
};
function ndt(t) {
  return sdt(t) || adt(t) || idt(t) || rdt();
}
function rdt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function idt(t, e) {
  if (t) {
    if (typeof t == "string") return H9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return H9(t, e);
  }
}
function adt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function sdt(t) {
  if (Array.isArray(t)) return H9(t);
}
function H9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function OS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function TS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? OS(Object(r), !0).forEach(function(i) {
      odt(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : OS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function odt(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ldt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function cdt(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function udt(t, e, r) {
  return e && cdt(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function hdt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && V9(t, e);
}
function V9(t, e) {
  return V9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, V9(t, e);
}
function fdt(t) {
  var e = pdt();
  return function() {
    var i = mg(t), s;
    if (e) {
      var c = mg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return ddt(this, s);
  };
}
function ddt(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gdt(t);
}
function gdt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function pdt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function mg(t) {
  return mg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, mg(t);
}
var mdt = {
  cornerRadius: 5,
  pointerLength: 10,
  pointerWidth: 10
}, Gh = /* @__PURE__ */ function(t) {
  hdt(r, t);
  var e = fdt(r);
  function r(i) {
    var s;
    return ldt(this, r), s = e.call(this, i), s.id = void 0, s.id = i.id === void 0 ? cO("tooltip-") : i.id, s;
  }
  return udt(r, [{
    key: "getDefaultOrientation",
    value: function(s) {
      var c = s.datum, u = s.horizontal, l = s.polar;
      if (!l) {
        var f = u ? "right" : "top", o = u ? "left" : "bottom";
        return c && c.y < 0 ? o : f;
      }
      return this.getPolarOrientation(s);
    }
  }, {
    key: "getPolarOrientation",
    value: function(s) {
      var c = uh(s, s.datum), u = s.labelPlacement || "vertical";
      return u === "vertical" ? this.getVerticalOrientations(c) : u === "parallel" ? c < 90 || c > 270 ? "right" : "left" : c > 180 ? "bottom" : "top";
    }
  }, {
    key: "getVerticalOrientations",
    value: function(s) {
      return s < 45 || s > 315 ? "right" : s >= 45 && s <= 135 ? "top" : s > 135 && s < 225 ? "left" : "bottom";
    }
  }, {
    key: "getStyles",
    value: function(s) {
      var c = s.theme || Hh.grayscale, u = c && c.tooltip && c.tooltip.style ? c.tooltip.style : {}, l = Array.isArray(s.style) ? s.style.map(function(n) {
        return Ie({}, n, u);
      }) : Ie({}, s.style, u), f = c && c.tooltip && c.tooltip.flyoutStyle ? c.tooltip.flyoutStyle : {}, o = s.flyoutStyle ? Ie({}, s.flyoutStyle, f) : f, g = Array.isArray(l) ? l.map(function(n) {
        return Fr(n, s);
      }) : Fr(l, s), p = Fr(o, Object.assign({}, s, {
        style: g
      }));
      return {
        style: g,
        flyoutStyle: p
      };
    }
  }, {
    key: "getEvaluatedProps",
    value: function(s) {
      var c = s.cornerRadius, u = s.centerOffset, l = s.dx, f = s.dy, o = Te(s.active, s), g = Te(s.text, Object.assign({}, s, {
        active: o
      }));
      g == null && (g = ""), typeof g == "number" && (g = g.toString());
      var p = this.getStyles(Object.assign({}, s, {
        active: o,
        text: g
      })), n = p.style, a = p.flyoutStyle, d = Te(s.orientation, Object.assign({}, s, {
        active: o,
        text: g,
        style: n,
        flyoutStyle: a
      })) || this.getDefaultOrientation(s), m = Te(s.flyoutPadding, Object.assign({}, s, {
        active: o,
        text: g,
        style: n,
        flyoutStyle: a,
        orientation: d
      })) || this.getLabelPadding(n), b = Qa({
        padding: m
      }), w = Te(s.pointerWidth, Object.assign({}, s, {
        active: o,
        text: g,
        style: n,
        flyoutStyle: a,
        orientation: d
      })), v = Te(s.pointerLength, Object.assign({}, s, {
        active: o,
        text: g,
        style: n,
        flyoutStyle: a,
        orientation: d
      })), h = z2(g, n), x = this.getDimensions(Object.assign({}, s, {
        style: n,
        flyoutStyle: a,
        active: o,
        text: g,
        orientation: d,
        flyoutPadding: b,
        pointerWidth: w,
        pointerLength: v
      }), h), _ = x.flyoutHeight, M = x.flyoutWidth, O = Object.assign({}, s, {
        active: o,
        text: g,
        style: n,
        flyoutStyle: a,
        orientation: d,
        flyoutHeight: _,
        flyoutWidth: M,
        flyoutPadding: b,
        pointerWidth: w,
        pointerLength: v
      }), E = Ur(u) && (u == null ? void 0 : u.x) !== void 0 ? Te(u.x, O) : 0, I = Ur(u) && (u == null ? void 0 : u.y) !== void 0 ? Te(u.y, O) : 0;
      return TS(TS({}, O), {}, {
        centerOffset: {
          x: E,
          y: I
        },
        dx: l !== void 0 ? Te(l, O) : 0,
        dy: f !== void 0 ? Te(f, O) : 0,
        cornerRadius: Te(c, O)
      });
    }
  }, {
    key: "getCalculatedValues",
    value: function(s) {
      var c = s.style, u = s.text, l = s.flyoutStyle, f = s.flyoutHeight, o = s.flyoutWidth, g = z2(u, c), p = {
        height: f,
        width: o
      }, n = this.getFlyoutCenter(s, p), a = this.getTransform(s);
      return {
        style: c,
        flyoutStyle: l,
        labelSize: g,
        flyoutDimensions: p,
        flyoutCenter: n,
        transform: a
      };
    }
  }, {
    key: "getTransform",
    value: function(s) {
      var c = s.x, u = s.y, l = s.style, f = l || {}, o = f.angle || s.angle || this.getDefaultAngle(s);
      return o ? "rotate(".concat(o, " ").concat(c, " ").concat(u, ")") : void 0;
    }
  }, {
    key: "getDefaultAngle",
    value: function(s) {
      var c = s.polar, u = s.labelPlacement, l = s.orientation, f = s.datum;
      if (!c || !u || u === "vertical")
        return 0;
      var o = uh(s, f), g = o > 90 && o < 180 || o > 270 ? 1 : -1, p = u === "perpendicular" ? 0 : 90, n = 0;
      return o === 0 || o === 180 ? n = l === "top" && o === 180 ? 270 : 90 : o > 0 && o < 180 ? n = 90 - o : o > 180 && o < 360 && (n = 270 - o), n + g * p;
    }
  }, {
    key: "constrainTooltip",
    value: function(s, c, u) {
      var l = s.x, f = s.y, o = u.width, g = u.height, p = {
        x: [0, c.width],
        y: [0, c.height]
      }, n = {
        x: [l - o / 2, l + o / 2],
        y: [f - g / 2, f + g / 2]
      }, a = {
        x: [n.x[0] < p.x[0] ? p.x[0] - n.x[0] : 0, n.x[1] > p.x[1] ? n.x[1] - p.x[1] : 0],
        y: [n.y[0] < p.y[0] ? p.y[0] - n.y[0] : 0, n.y[1] > p.y[1] ? n.y[1] - p.y[1] : 0]
      };
      return {
        x: Math.round(l + a.x[0] - a.x[1]),
        y: Math.round(f + a.y[0] - a.y[1])
      };
    }
    // eslint-disable-next-line complexity
  }, {
    key: "getFlyoutCenter",
    value: function(s, c) {
      var u = s.x, l = s.y, f = s.dx, o = s.dy, g = s.pointerLength, p = s.orientation, n = s.constrainToVisibleArea, a = s.centerOffset, d = c.height, m = c.width, b = p === "left" ? -1 : 1, w = p === "bottom" ? -1 : 1, v = {
        x: p === "left" || p === "right" ? u + b * (g + m / 2 + b * f) : u + f,
        y: p === "top" || p === "bottom" ? l - w * (g + d / 2 - w * o) : l + o
      }, h = {
        x: Ur(s.center) && s.center.x !== void 0 ? s.center.x : v.x,
        y: Ur(s.center) && s.center.y !== void 0 ? s.center.y : v.y
      }, x = {
        x: h.x + a.x,
        y: h.y + a.y
      };
      return n ? this.constrainTooltip(x, s, c) : x;
    }
  }, {
    key: "getLabelPadding",
    value: function(s) {
      if (!s)
        return 0;
      var c = Array.isArray(s) ? s.map(function(u) {
        return u.padding;
      }) : [s.padding];
      return Math.max.apply(Math, ndt(c).concat([0]));
    }
  }, {
    key: "getDimensions",
    value: function(s, c) {
      var u = s.orientation, l = s.pointerLength, f = s.pointerWidth, o = s.flyoutHeight, g = s.flyoutWidth, p = s.flyoutPadding, n = Te(s.cornerRadius, s), a = function() {
        var m = c.height + p.top + p.bottom, b = u === "top" || u === "bottom" ? 2 * n : 2 * n + f;
        return Math.max(b, m);
      }, d = function() {
        var m = c.width + p.left + p.right, b = u === "left" || u === "right" ? 2 * n + l : 2 * n;
        return Math.max(b, m);
      };
      return {
        flyoutHeight: o ? Te(o, s) : a(),
        flyoutWidth: g ? Te(g, s) : d()
      };
    }
  }, {
    key: "getLabelProps",
    value: function(s, c) {
      var u = c.flyoutCenter, l = c.style, f = c.labelSize, o = c.dy, g = o === void 0 ? 0 : o, p = c.dx, n = p === void 0 ? 0 : p, a = s.text, d = s.datum, m = s.activePoints, b = s.labelComponent, w = s.index, v = s.flyoutPadding, h = (Array.isArray(l) && l.length ? l[0].textAnchor : l.textAnchor) || "middle", x = function() {
        if (h === "middle")
          return u.x;
        var _ = h === "end" ? -1 : 1;
        return u.x - _ * (f.width / 2);
      };
      return Ie({}, b.props, {
        key: "".concat(this.id, "-label-").concat(w),
        text: a,
        datum: d,
        activePoints: m,
        textAnchor: h,
        dy: g,
        dx: n,
        style: l,
        x: x() + (v.left - v.right) / 2,
        y: u.y + (v.top - v.bottom) / 2,
        verticalAnchor: "middle",
        angle: l.angle
      });
    }
  }, {
    key: "getPointerOrientation",
    value: function(s, c, u) {
      var l = {
        bottom: c.y + u.height / 2,
        top: c.y - u.height / 2,
        left: c.x - u.width / 2,
        right: c.x + u.width / 2
      }, f = [{
        side: "top",
        val: l.top > s.y ? l.top - s.y : -1
      }, {
        side: "bottom",
        val: l.bottom < s.y ? s.y - l.bottom : -1
      }, {
        side: "right",
        val: l.right < s.x ? s.x - l.right : -1
      }, {
        side: "left",
        val: l.left > s.x ? l.left - s.x : -1
      }];
      return pp(f, "val", "desc")[0].side;
    }
  }, {
    key: "getFlyoutProps",
    value: function(s, c) {
      var u = c.flyoutDimensions, l = c.flyoutStyle, f = c.flyoutCenter, o = s.x, g = s.y, p = s.dx, n = s.dy, a = s.datum, d = s.activePoints, m = s.index, b = s.pointerLength, w = s.pointerWidth, v = s.cornerRadius, h = s.events, x = s.flyoutComponent, _ = Te(s.pointerOrientation, s);
      return Ie({}, x.props, {
        x: o,
        y: g,
        dx: p,
        dy: n,
        datum: a,
        activePoints: d,
        index: m,
        pointerLength: b,
        pointerWidth: w,
        cornerRadius: v,
        events: h,
        orientation: _ || this.getPointerOrientation({
          x: o,
          y: g
        }, f, u),
        key: "".concat(this.id, "-tooltip-").concat(m),
        width: u.width,
        height: u.height,
        style: l,
        center: f
      });
    }
    // Overridden in victory-core-native
  }, {
    key: "renderTooltip",
    value: function(s) {
      var c = Te(s.active, s), u = s.renderInPortal;
      if (!c)
        return u ? /* @__PURE__ */ Bt.createElement(sl, null) : null;
      var l = this.getEvaluatedProps(s), f = l.flyoutComponent, o = l.labelComponent, g = l.groupComponent, p = this.getCalculatedValues(l), n = [/* @__PURE__ */ Bt.cloneElement(f, this.getFlyoutProps(l, p)), /* @__PURE__ */ Bt.cloneElement(o, this.getLabelProps(l, p))], a = /* @__PURE__ */ Bt.cloneElement(g, {
        role: "presentation",
        transform: p.transform
      }, n);
      return u ? /* @__PURE__ */ Bt.createElement(sl, null, a) : a;
    }
  }, {
    key: "render",
    value: function() {
      var s = qo(this.props, mdt, "tooltip");
      return this.renderTooltip(s);
    }
  }]), r;
}(Bt.Component);
Gh.displayName = "VictoryTooltip";
Gh.role = "tooltip";
Gh.defaultProps = {
  active: !1,
  renderInPortal: !0,
  labelComponent: /* @__PURE__ */ Bt.createElement(ts, null),
  flyoutComponent: /* @__PURE__ */ Bt.createElement(edt, null),
  groupComponent: /* @__PURE__ */ Bt.createElement("g", null)
};
Gh.defaultEvents = function(t) {
  var e = t.activateData ? [{
    target: "labels",
    mutation: function() {
      return {
        active: !0
      };
    }
  }, {
    target: "data",
    mutation: function() {
      return {
        active: !0
      };
    }
  }] : [{
    target: "labels",
    mutation: function() {
      return {
        active: !0
      };
    }
  }], r = t.activateData ? [{
    target: "labels",
    mutation: function() {
      return {
        active: void 0
      };
    }
  }, {
    target: "data",
    mutation: function() {
      return {
        active: void 0
      };
    }
  }] : [{
    target: "labels",
    mutation: function() {
      return {
        active: void 0
      };
    }
  }];
  return [{
    target: "data",
    eventHandlers: {
      onMouseOver: function() {
        return e;
      },
      onFocus: function() {
        return e;
      },
      onTouchStart: function() {
        return e;
      },
      onMouseOut: function() {
        return r;
      },
      onBlur: function() {
        return r;
      },
      onTouchEnd: function() {
        return r;
      }
    }
  }];
};
var ydt = ml, bdt = yl, vdt = "[object RegExp]";
function wdt(t) {
  return bdt(t) && ydt(t) == vdt;
}
var xdt = wdt, Sdt = xdt, Cdt = dp, MS = M7, ES = MS && MS.isRegExp, Adt = ES ? Cdt(ES) : Sdt, _dt = Adt;
const kdt = /* @__PURE__ */ Dn(_dt);
var iM = {}, aM = { exports: {} };
(function(t, e) {
  (function(r, i) {
    t.exports = i();
  })(ds, function() {
    var r = Math.pow(2, -52), i = new Uint32Array(512), s = function(w) {
      var v = w.length >> 1;
      if (v > 0 && typeof w[0] != "number")
        throw new Error("Expected coords to contain numbers.");
      this.coords = w;
      var h = Math.max(2 * v - 5, 0);
      this._triangles = new Uint32Array(h * 3), this._halfedges = new Int32Array(h * 3), this._hashSize = Math.ceil(Math.sqrt(v)), this._hullPrev = new Uint32Array(v), this._hullNext = new Uint32Array(v), this._hullTri = new Uint32Array(v), this._hullHash = new Int32Array(this._hashSize).fill(-1), this._ids = new Uint32Array(v), this._dists = new Float64Array(v), this.update();
    };
    s.from = function(w, v, h) {
      v === void 0 && (v = d), h === void 0 && (h = m);
      for (var x = w.length, _ = new Float64Array(x * 2), M = 0; M < x; M++) {
        var O = w[M];
        _[2 * M] = v(O), _[2 * M + 1] = h(O);
      }
      return new s(_);
    }, s.prototype.update = function() {
      for (var w = this, v = w.coords, h = w._hullPrev, x = w._hullNext, _ = w._hullTri, M = w._hullHash, O = v.length >> 1, E = 1 / 0, I = 1 / 0, R = -1 / 0, W = -1 / 0, z = 0; z < O; z++) {
        var j = v[2 * z], $ = v[2 * z + 1];
        j < E && (E = j), $ < I && (I = $), j > R && (R = j), $ > W && (W = $), this._ids[z] = z;
      }
      for (var B = (E + R) / 2, C = (I + W) / 2, T = 1 / 0, F, S, A, U = 0; U < O; U++) {
        var K = u(B, C, v[2 * U], v[2 * U + 1]);
        K < T && (F = U, T = K);
      }
      var X = v[2 * F], L = v[2 * F + 1];
      T = 1 / 0;
      for (var H = 0; H < O; H++)
        if (H !== F) {
          var Q = u(X, L, v[2 * H], v[2 * H + 1]);
          Q < T && Q > 0 && (S = H, T = Q);
        }
      for (var N = v[2 * S], V = v[2 * S + 1], Y = 1 / 0, Z = 0; Z < O; Z++)
        if (!(Z === F || Z === S)) {
          var rt = g(X, L, N, V, v[2 * Z], v[2 * Z + 1]);
          rt < Y && (A = Z, Y = rt);
        }
      var st = v[2 * A], mt = v[2 * A + 1];
      if (Y === 1 / 0) {
        for (var yt = 0; yt < O; yt++)
          this._dists[yt] = v[2 * yt] - v[0] || v[2 * yt + 1] - v[1];
        n(this._ids, this._dists, 0, O - 1);
        for (var at = new Uint32Array(O), nt = 0, q = 0, D = -1 / 0; q < O; q++) {
          var G = this._ids[q];
          this._dists[G] > D && (at[nt++] = G, D = this._dists[G]);
        }
        this.hull = at.subarray(0, nt), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
        return;
      }
      if (f(X, L, N, V, st, mt)) {
        var et = S, J = N, it = V;
        S = A, N = st, V = mt, A = et, st = J, mt = it;
      }
      var lt = p(X, L, N, V, st, mt);
      this._cx = lt.x, this._cy = lt.y;
      for (var ot = 0; ot < O; ot++)
        this._dists[ot] = u(v[2 * ot], v[2 * ot + 1], lt.x, lt.y);
      n(this._ids, this._dists, 0, O - 1), this._hullStart = F;
      var ut = 3;
      x[F] = h[A] = S, x[S] = h[F] = A, x[A] = h[S] = F, _[F] = 0, _[S] = 1, _[A] = 2, M.fill(-1), M[this._hashKey(X, L)] = F, M[this._hashKey(N, V)] = S, M[this._hashKey(st, mt)] = A, this.trianglesLen = 0, this._addTriangle(F, S, A, -1, -1, -1);
      for (var ct = 0, gt = void 0, dt = void 0; ct < this._ids.length; ct++) {
        var bt = this._ids[ct], vt = v[2 * bt], xt = v[2 * bt + 1];
        if (!(ct > 0 && Math.abs(vt - gt) <= r && Math.abs(xt - dt) <= r) && (gt = vt, dt = xt, !(bt === F || bt === S || bt === A))) {
          for (var St = 0, Mt = 0, Et = this._hashKey(vt, xt); Mt < this._hashSize && (St = M[(Et + Mt) % this._hashSize], !(St !== -1 && St !== x[St])); Mt++)
            ;
          St = h[St];
          for (var Ft = St, Wt = void 0; Wt = x[Ft], !f(vt, xt, v[2 * Ft], v[2 * Ft + 1], v[2 * Wt], v[2 * Wt + 1]); )
            if (Ft = Wt, Ft === St) {
              Ft = -1;
              break;
            }
          if (Ft !== -1) {
            var Kt = this._addTriangle(Ft, bt, x[Ft], -1, -1, _[Ft]);
            _[bt] = this._legalize(Kt + 2), _[Ft] = Kt, ut++;
            for (var qt = x[Ft]; Wt = x[qt], f(vt, xt, v[2 * qt], v[2 * qt + 1], v[2 * Wt], v[2 * Wt + 1]); )
              Kt = this._addTriangle(qt, bt, Wt, _[bt], -1, _[qt]), _[bt] = this._legalize(Kt + 2), x[qt] = qt, ut--, qt = Wt;
            if (Ft === St)
              for (; Wt = h[Ft], f(vt, xt, v[2 * Wt], v[2 * Wt + 1], v[2 * Ft], v[2 * Ft + 1]); )
                Kt = this._addTriangle(Wt, bt, Ft, -1, _[Ft], _[Wt]), this._legalize(Kt + 2), _[Wt] = Kt, x[Ft] = Ft, ut--, Ft = Wt;
            this._hullStart = h[bt] = Ft, x[Ft] = h[qt] = bt, x[bt] = qt, M[this._hashKey(vt, xt)] = bt, M[this._hashKey(v[2 * Ft], v[2 * Ft + 1])] = Ft;
          }
        }
      }
      this.hull = new Uint32Array(ut);
      for (var It = 0, re = this._hullStart; It < ut; It++)
        this.hull[It] = re, re = x[re];
      this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }, s.prototype._hashKey = function(w, v) {
      return Math.floor(c(w - this._cx, v - this._cy) * this._hashSize) % this._hashSize;
    }, s.prototype._legalize = function(w) {
      for (var v = this, h = v._triangles, x = v._halfedges, _ = v.coords, M = 0, O = 0; ; ) {
        var E = x[w], I = w - w % 3;
        if (O = I + (w + 2) % 3, E === -1) {
          if (M === 0)
            break;
          w = i[--M];
          continue;
        }
        var R = E - E % 3, W = I + (w + 1) % 3, z = R + (E + 2) % 3, j = h[O], $ = h[w], B = h[W], C = h[z], T = o(
          _[2 * j],
          _[2 * j + 1],
          _[2 * $],
          _[2 * $ + 1],
          _[2 * B],
          _[2 * B + 1],
          _[2 * C],
          _[2 * C + 1]
        );
        if (T) {
          h[w] = C, h[E] = j;
          var F = x[z];
          if (F === -1) {
            var S = this._hullStart;
            do {
              if (this._hullTri[S] === z) {
                this._hullTri[S] = w;
                break;
              }
              S = this._hullPrev[S];
            } while (S !== this._hullStart);
          }
          this._link(w, F), this._link(E, x[O]), this._link(O, z);
          var A = R + (E + 1) % 3;
          M < i.length && (i[M++] = A);
        } else {
          if (M === 0)
            break;
          w = i[--M];
        }
      }
      return O;
    }, s.prototype._link = function(w, v) {
      this._halfedges[w] = v, v !== -1 && (this._halfedges[v] = w);
    }, s.prototype._addTriangle = function(w, v, h, x, _, M) {
      var O = this.trianglesLen;
      return this._triangles[O] = w, this._triangles[O + 1] = v, this._triangles[O + 2] = h, this._link(O, x), this._link(O + 1, _), this._link(O + 2, M), this.trianglesLen += 3, O;
    };
    function c(b, w) {
      var v = b / (Math.abs(b) + Math.abs(w));
      return (w > 0 ? 3 - v : 1 + v) / 4;
    }
    function u(b, w, v, h) {
      var x = b - v, _ = w - h;
      return x * x + _ * _;
    }
    function l(b, w, v, h, x, _) {
      var M = (h - w) * (x - b), O = (v - b) * (_ - w);
      return Math.abs(M - O) >= 33306690738754716e-32 * Math.abs(M + O) ? M - O : 0;
    }
    function f(b, w, v, h, x, _) {
      var M = l(x, _, b, w, v, h) || l(b, w, v, h, x, _) || l(v, h, x, _, b, w);
      return M < 0;
    }
    function o(b, w, v, h, x, _, M, O) {
      var E = b - M, I = w - O, R = v - M, W = h - O, z = x - M, j = _ - O, $ = E * E + I * I, B = R * R + W * W, C = z * z + j * j;
      return E * (W * C - B * j) - I * (R * C - B * z) + $ * (R * j - W * z) < 0;
    }
    function g(b, w, v, h, x, _) {
      var M = v - b, O = h - w, E = x - b, I = _ - w, R = M * M + O * O, W = E * E + I * I, z = 0.5 / (M * I - O * E), j = (I * R - O * W) * z, $ = (M * W - E * R) * z;
      return j * j + $ * $;
    }
    function p(b, w, v, h, x, _) {
      var M = v - b, O = h - w, E = x - b, I = _ - w, R = M * M + O * O, W = E * E + I * I, z = 0.5 / (M * I - O * E), j = b + (I * R - O * W) * z, $ = w + (M * W - E * R) * z;
      return { x: j, y: $ };
    }
    function n(b, w, v, h) {
      if (h - v <= 20)
        for (var x = v + 1; x <= h; x++) {
          for (var _ = b[x], M = w[_], O = x - 1; O >= v && w[b[O]] > M; )
            b[O + 1] = b[O--];
          b[O + 1] = _;
        }
      else {
        var E = v + h >> 1, I = v + 1, R = h;
        a(b, E, I), w[b[v]] > w[b[h]] && a(b, v, h), w[b[I]] > w[b[h]] && a(b, I, h), w[b[v]] > w[b[I]] && a(b, v, I);
        for (var W = b[I], z = w[W]; ; ) {
          do
            I++;
          while (w[b[I]] < z);
          do
            R--;
          while (w[b[R]] > z);
          if (R < I)
            break;
          a(b, I, R);
        }
        b[v + 1] = b[R], b[R] = W, h - I + 1 >= R - v ? (n(b, w, I, h), n(b, w, v, R - 1)) : (n(b, w, v, R - 1), n(b, w, I, h));
      }
    }
    function a(b, w, v) {
      var h = b[w];
      b[w] = b[v], b[v] = h;
    }
    function d(b) {
      return b[0];
    }
    function m(b) {
      return b[1];
    }
    return s;
  });
})(aM);
var Odt = aM.exports;
(function(t) {
  t.__esModule = !0, t.default = void 0;
  var e = r(Odt);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return o[0];
  }
  function s(o) {
    return o[1];
  }
  function c(o) {
    for (var g = o.triangles, p = o.coords, n = 0; n < g.length; n += 3) {
      var a = 2 * g[n], d = 2 * g[n + 1], m = 2 * g[n + 2], b = (p[m] - p[a]) * (p[d + 1] - p[a + 1]) - (p[d] - p[a]) * (p[m + 1] - p[a + 1]);
      if (b > 1e-10)
        return !1;
    }
    return !0;
  }
  function u(o, g, p) {
    return [o + Math.sin(o + g) * p, g + Math.cos(o - g) * p];
  }
  function l(o, g, p, n) {
    for (var a = o.length, d = new Float64Array(a * 2), m = 0; m < a; ++m) {
      var b = o[m];
      d[m * 2] = g.call(n, b, m, o), d[m * 2 + 1] = p.call(n, b, m, o);
    }
    return d;
  }
  var f = /* @__PURE__ */ function() {
    function o(p) {
      var n = new e.default(p);
      this.inedges = new Int32Array(p.length / 2), this._hullIndex = new Int32Array(p.length / 2), this.points = n.coords, this._init(n);
    }
    var g = o.prototype;
    return g._init = function(n) {
      var a = n, d = this.points;
      if (a.hull && a.hull.length > 2 && c(a)) {
        this.collinear = Int32Array.from({
          length: d.length / 2
        }, function(C, T) {
          return T;
        }).sort(function(C, T) {
          return d[2 * C] - d[2 * T] || d[2 * C + 1] - d[2 * T + 1];
        });
        for (var m = this.collinear[0], b = this.collinear[this.collinear.length - 1], w = [d[2 * m], d[2 * m + 1], d[2 * b], d[2 * b + 1]], v = 1e-8 * // eslint-disable-line no-magic-numbers
        Math.sqrt(Math.pow(w[3] - w[1], 2) + Math.pow(w[2] - w[0], 2)), h = 0, x = d.length / 2; h < x; ++h) {
          var _ = u(d[2 * h], d[2 * h + 1], v);
          d[2 * h] = _[0], d[2 * h + 1] = _[1];
        }
        n = new e.default(d);
      }
      for (var M = this.halfedges = n.halfedges, O = this.hull = n.hull, E = this.triangles = n.triangles, I = this.inedges.fill(-1), R = this._hullIndex.fill(-1), W = 0, z = M.length; W < z; ++W) {
        var j = E[W % 3 === 2 ? W - 2 : W + 1];
        (M[W] === -1 || I[j] === -1) && (I[j] = W);
      }
      for (var $ = 0, B = O.length; $ < B; ++$)
        R[O[$]] = $;
      O.length <= 2 && O.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = O[0], this.triangles[1] = O[1], this.triangles[2] = O[1], I[O[0]] = 1, O.length === 2 && (I[O[1]] = 0));
    }, g.neighbors = function(n) {
      var a = [], d = this.inedges, m = this.hull, b = this._hullIndex, w = this.halfedges, v = this.triangles, h = d[n];
      if (h === -1) return a;
      var x = h, _ = -1;
      do {
        if (_ = v[x], a.push(_), x = x % 3 === 2 ? x - 2 : x + 1, v[x] !== n) break;
        if (x = w[x], x === -1) {
          var M = m[(b[n] + 1) % m.length];
          M !== _ && a.push(M);
          break;
        }
      } while (x !== h);
      return a;
    }, g.find = function(n, a, d) {
      if (d === void 0 && (d = 0), n = +n, n !== n || (a = +a, a !== a)) return -1;
      for (var m = d, b; (b = this._step(d, n, a)) >= 0 && b !== d && b !== m; )
        d = b;
      return b;
    }, g._step = function(n, a, d) {
      var m = this.inedges, b = this.points;
      if (m[n] === -1 || !b.length) return (n + 1) % (b.length >> 1);
      for (var w = n, v = Math.pow(a - b[n * 2], 2) + Math.pow(d - b[n * 2 + 1], 2), _ = this.neighbors(n), h = Array.isArray(_), x = 0, _ = h ? _ : _[Symbol.iterator](); ; ) {
        var M;
        if (h) {
          if (x >= _.length) break;
          M = _[x++];
        } else {
          if (x = _.next(), x.done) break;
          M = x.value;
        }
        var O = M, E = Math.pow(a - b[O * 2], 2) + Math.pow(d - b[O * 2 + 1], 2);
        E < v && (v = E, w = O);
      }
      return w;
    }, o;
  }();
  t.default = f, f.from = function(o, g, p, n) {
    return g === void 0 && (g = i), p === void 0 && (p = s), new f(l(o, g, p, n));
  };
})(iM);
const Tdt = /* @__PURE__ */ Dn(iM);
function g1(t) {
  return Idt(t) || Pdt(t) || Edt(t) || Mdt();
}
function Mdt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Edt(t, e) {
  if (t) {
    if (typeof t == "string") return z9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return z9(t, e);
  }
}
function Pdt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Idt(t) {
  if (Array.isArray(t)) return z9(t);
}
function z9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function Fdt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Rdt(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Ddt(t, e, r) {
  return e && Rdt(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var $dt = 32, Ldt = /* @__PURE__ */ function() {
  function t() {
    var e = this;
    Fdt(this, t), this.onMouseLeave = function(r, i) {
      var s, c = i.activePoints || [];
      e.onDeactivated(i, c);
      var u = c.length ? c.map(function(l) {
        return e.getInactiveMutations(i, l);
      }) : [];
      return (s = e.getParentMutation([])).concat.apply(s, g1(u));
    }, this.handleMouseMove = function(r, i) {
      var s = i.activePoints || [], c = i.parentSVG || zT(r), u = E0t(r, c);
      if (!e.withinBounds(i, u)) {
        var l;
        e.onDeactivated(i, s);
        var f = s.length ? s.map(function(b) {
          return e.getInactiveMutations(i, b);
        }) : [];
        return (l = e.getParentMutation([], u, c)).concat.apply(l, g1(f));
      }
      var o = e.getVoronoiPoints(i, u), g = o.points, p = g === void 0 ? [] : g, n = o.index, a = e.getParentMutation(p, u, c, n);
      if (s.length && Wo(p, s))
        return a;
      e.onActivated(i, p), e.onDeactivated(i, s);
      var d = p.length ? p.map(function(b) {
        return e.getActiveMutations(i, b);
      }) : [], m = s.length ? s.map(function(b) {
        return e.getInactiveMutations(i, b);
      }) : [];
      return a.concat.apply(a, g1(m).concat(g1(d)));
    }, this.onMouseMove = Kht(this.handleMouseMove, $dt, {
      leading: !0,
      trailing: !1
    });
  }
  return Ddt(t, [{
    key: "withinBounds",
    value: function(r, i) {
      var s = r.width, c = r.height, u = r.polar, l = r.origin, f = r.scale, o = Qa(r, "voronoiPadding"), g = i.x, p = i.y;
      if (u) {
        var n = Math.pow(g - l.x, 2) + Math.pow(p - l.y, 2), a = Math.max.apply(Math, g1(f.y.range()));
        return n < Math.pow(a, 2);
      }
      return g >= o.left && g <= s - o.right && p >= o.top && p <= c - o.bottom;
    }
  }, {
    key: "getDatasets",
    value: function(r) {
      var i = {
        x: da(r.domain.x),
        y: da(r.domain.y)
      }, s = Bt.Children.toArray(r.children), c = function(f, o, g) {
        var p = g && g.type && g.type.continuous, n = g ? g.props && g.props.style : r.style;
        return f.map(function(a, d) {
          var m = N7(a), b = m.x, w = m.y, v = m.y0, h = m.x0, x = (Number(b) + Number(h)) / 2, _ = (Number(w) + Number(v)) / 2;
          return Object.assign({
            _voronoiX: r.voronoiDimension === "y" ? i.x : x,
            _voronoiY: r.voronoiDimension === "x" ? i.y : _,
            eventKey: d,
            childName: o,
            continuous: p,
            style: n
          }, a);
        });
      };
      if (r.data)
        return c(r.data);
      var u = function(f) {
        var o = wl(f);
        return Array.isArray(o) && o.length > 0 ? o : void 0;
      }, l = function(f, o) {
        var g = f.props || {}, p = g.name || o, n = r.voronoiBlacklist || [], a = n.filter(function(v) {
          return !!v && typeof v.valueOf() == "string";
        }), d = n.filter(kdt), m = d.some(function(v) {
          return v.test(p);
        });
        if (!RT(f) || a.includes(p) || m)
          return null;
        var b = f.type && Cn(f.type.getData) ? f.type.getData : u, w = b(f.props);
        return w ? c(w, p, f) : null;
      };
      return k0(s, l, r);
    }
  }, {
    key: "findPoints",
    value: function(r, i) {
      return r.filter(function(s) {
        return i._voronoiX === s._voronoiX && i._voronoiY === s._voronoiY;
      });
    }
  }, {
    key: "withinRadius",
    value: function(r, i, s) {
      if (!r)
        return !1;
      if (!s)
        return !0;
      var c = i.x, u = i.y, l = Math.pow(c - r[0], 2) + Math.pow(u - r[1], 2);
      return l < Math.pow(s, 2);
    }
  }, {
    key: "getVoronoiPoints",
    value: function(r, i) {
      var s = this.getDatasets(r), c = s.map(function(g) {
        var p = Uh(r, g), n = p.x, a = p.y;
        return [n, a];
      }), u = Tdt.from(c), l = u.find(i.x, i.y), f = this.withinRadius(c[l], i, r.radius), o = f ? this.findPoints(s, s[l]) : [];
      return {
        points: o,
        index: l
      };
    }
  }, {
    key: "getActiveMutations",
    value: function(r, i) {
      var s = i.childName, c = i.continuous, u = r.activateData, l = r.activateLabels, f = r.labels;
      if (!u && !l)
        return [];
      var o = u ? ["data"] : [], g = f && !l ? o : o.concat("labels");
      return ar(g) ? [] : g.map(function(p) {
        var n = c === !0 && p === "data" ? "all" : i.eventKey;
        return {
          childName: s,
          eventKey: n,
          target: p,
          mutation: function() {
            return {
              active: !0
            };
          }
        };
      });
    }
  }, {
    key: "getInactiveMutations",
    value: function(r, i) {
      var s = i.childName, c = i.continuous, u = r.activateData, l = r.activateLabels, f = r.labels;
      if (!u && !l)
        return [];
      var o = u ? ["data"] : [], g = f && !l ? o : o.concat("labels");
      return ar(g) ? [] : g.map(function(p) {
        var n = c && p === "data" ? "all" : i.eventKey;
        return {
          childName: s,
          eventKey: n,
          target: p,
          mutation: function() {
            return null;
          }
        };
      });
    }
    // eslint-disable-next-line max-params
  }, {
    key: "getParentMutation",
    value: function(r, i, s, c) {
      return [{
        target: "parent",
        eventKey: "parent",
        mutation: function() {
          return {
            activePoints: r,
            mousePosition: i,
            parentSVG: s,
            vIndex: c
          };
        }
      }];
    }
  }, {
    key: "onActivated",
    value: function(r, i) {
      Cn(r.onActivated) && r.onActivated(i, r);
    }
  }, {
    key: "onDeactivated",
    value: function(r, i) {
      Cn(r.onDeactivated) && r.onDeactivated(i, r);
    }
  }]), t;
}(), pd = new Ldt(), Ndt = ["childName", "eventKey", "style", "continuous"];
function Bdt(t) {
  return Vdt(t) || Hdt(t) || Udt(t) || jdt();
}
function jdt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Udt(t, e) {
  if (t) {
    if (typeof t == "string") return X9(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return X9(t, e);
  }
}
function Hdt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Vdt(t) {
  if (Array.isArray(t)) return X9(t);
}
function X9(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function zdt(t, e) {
  if (t == null) return {};
  var r = Xdt(t, e), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(t);
    for (s = 0; s < c.length; s++)
      i = c[s], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function Xdt(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(e.indexOf(s) >= 0) && (r[s] = t[s]);
  return r;
}
function PS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function md(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? PS(Object(r), !0).forEach(function(i) {
      qdt(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : PS(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function qdt(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Wdt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Gdt(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Kdt(t, e, r) {
  return e && Gdt(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Ydt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && q9(t, e);
}
function q9(t, e) {
  return q9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, q9(t, e);
}
function Zdt(t) {
  var e = t2t();
  return function() {
    var i = yg(t), s;
    if (e) {
      var c = yg(this).constructor;
      s = Reflect.construct(i, arguments, c);
    } else
      s = i.apply(this, arguments);
    return Jdt(this, s);
  };
}
function Jdt(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qdt(t);
}
function Qdt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function t2t() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function yg(t) {
  return yg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, yg(t);
}
function e2t(t) {
  var e;
  return e = /* @__PURE__ */ function(r) {
    Ydt(s, r);
    var i = Zdt(s);
    function s() {
      return Wdt(this, s), i.apply(this, arguments);
    }
    return Kdt(s, [{
      key: "getDimension",
      value: function(u) {
        var l = u.horizontal, f = u.voronoiDimension;
        return !l || !f ? f : f === "x" ? "y" : "x";
      }
    }, {
      key: "getPoint",
      value: function(u) {
        var l = ["_x", "_x1", "_x0", "_y", "_y1", "_y0"];
        return lh(u, l);
      }
    }, {
      key: "getLabelPosition",
      value: function(u, l, f) {
        var o = u.mousePosition, g = u.mouseFollowTooltips, p = this.getDimension(u), n = this.getPoint(f[0]), a = Uh(u, n), d = g ? o : void 0;
        if (!p || f.length < 2)
          return md(md({}, a), {}, {
            center: Ie({}, l.center, d)
          });
        var m = p === "y" ? o.x : a.x, b = p === "x" ? o.y : a.y;
        return d = g ? o : {
          x: m,
          y: b
        }, {
          x: m,
          y: b,
          center: Ie({}, l.center, d)
        };
      }
    }, {
      key: "getStyle",
      value: function(u, l, f) {
        var o = u.labels, g = u.labelComponent, p = u.theme, n = g.props || {}, a = p && p.voronoi && p.voronoi.style ? p.voronoi.style : {}, d = f === "flyout" ? n.flyoutStyle : n.style;
        return l.reduce(function(m, b, w) {
          var v = Ie({}, n, {
            datum: b,
            active: !0
          }), h = Cn(o) ? o(v) : void 0, x = h !== void 0 ? "".concat(h).split(`
`) : [], _ = b.style && b.style[f] || {}, M = Array.isArray(d) ? d[w] : d, O = Fr(Ie({}, M, _, a[f]), v), E = x.length ? x.map(function() {
            return O;
          }) : [O];
          return m.concat(E);
        }, []);
      }
    }, {
      key: "getDefaultLabelProps",
      value: function(u, l) {
        var f = u.voronoiDimension, o = u.horizontal, g = u.mouseFollowTooltips, p = this.getPoint(l[0]), n = f && l.length > 1, a = p._y1 !== void 0 ? p._y1 : p._y, d = a < 0 ? "left" : "right", m = a < 0 ? "bottom" : "top", b = o ? d : m, w = g ? void 0 : b;
        return {
          orientation: w,
          pointerLength: n ? 0 : void 0,
          constrainToVisibleArea: n || g ? !0 : void 0
        };
      }
    }, {
      key: "getLabelProps",
      value: function(u, l) {
        var f = u.labels, o = u.scale, g = u.labelComponent, p = u.theme, n = u.width, a = u.height, d = g.props || {}, m = l.reduce(function(O, E) {
          var I = Ie({}, d, {
            datum: E,
            active: !0
          }), R = Cn(f) ? f(I) : null;
          return R == null ? O : O.concat("".concat(R).split(`
`));
        }, []), b = l[0], w = b.childName, v = b.eventKey;
        b.style, b.continuous;
        var h = zdt(b, Ndt), x = u.name === w ? w : "".concat(u.name, "-").concat(w), _ = Ie({
          key: "".concat(x, "-").concat(v, "-voronoi-tooltip"),
          id: "".concat(x, "-").concat(v, "-voronoi-tooltip"),
          active: !0,
          renderInPortal: !1,
          activePoints: l,
          datum: h,
          scale: o,
          theme: p
        }, d, {
          text: m,
          width: n,
          height: a,
          style: this.getStyle(u, l, "labels"),
          flyoutStyle: this.getStyle(u, l, "flyout")[0]
        }, this.getDefaultLabelProps(u, l)), M = this.getLabelPosition(u, _, l);
        return Ie({}, M, _);
      }
    }, {
      key: "getTooltip",
      value: function(u) {
        var l = u.labels, f = u.activePoints, o = u.labelComponent;
        if (!l)
          return null;
        if (Array.isArray(f) && f.length) {
          var g = this.getLabelProps(u, f), p = g.text, n = Array.isArray(p) ? p.filter(Boolean).length : p;
          return n ? /* @__PURE__ */ Bt.cloneElement(o, g) : null;
        }
        return null;
      }
      // Overrides method in VictoryContainer
    }, {
      key: "getChildren",
      value: function(u) {
        return [].concat(Bdt(Bt.Children.toArray(u.children)), [this.getTooltip(u)]);
      }
    }]), s;
  }(t), e.displayName = "VictoryVoronoiContainer", e.defaultProps = md(md({}, Is.defaultProps), {}, {
    activateData: !0,
    activateLabels: !0,
    labelComponent: /* @__PURE__ */ Bt.createElement(Gh, null),
    voronoiPadding: 5
  }), e.defaultEvents = function(r) {
    return [{
      target: "parent",
      eventHandlers: {
        onMouseLeave: function(i, s) {
          return r.disable ? {} : pd.onMouseLeave(i, s);
        },
        onTouchCancel: function(i, s) {
          return r.disable ? {} : pd.onMouseLeave(i, s);
        },
        onMouseMove: function(i, s) {
          return r.disable ? {} : pd.onMouseMove(i, s);
        },
        onTouchMove: function(i, s) {
          return r.disable ? {} : pd.onMouseMove(i, s);
        }
      }
    }, {
      target: "data",
      eventHandlers: r.disable ? {} : {
        onMouseOver: function() {
          return null;
        },
        onMouseOut: function() {
          return null;
        },
        onMouseMove: function() {
          return null;
        }
      }
    }];
  }, e;
}
var n2t = e2t(Is);
const Kh = {
  colors: {
    grey400: "#707070",
    grey300: "#D5D6D8",
    grey250: "#E5E6E8"
  }
}, yd = /* @__PURE__ */ $t(Cs, { style: { stroke: Kh.colors.grey250, strokeWidth: 1 } }), r2t = (t) => t === "center" ? "middle" : t, IS = ({ labelColor: t, labelSize: e, labelAnchor: r, ...i }) => /* @__PURE__ */ $t(
  ts,
  {
    ...i,
    className: Ke("[&>tspan]:!font-norlys-text", i.className),
    style: {
      fill: t ?? Kh.colors.grey400,
      fontSize: e ?? 12,
      textAnchor: r ? r2t(r) : "start"
    }
  }
), i2t = /* @__PURE__ */ $t(
  Cs,
  {
    style: {
      stroke: Kh.colors.grey250
    }
  }
), bd = /* @__PURE__ */ $t(Cs, { style: { stroke: "none" } }), a2t = /* @__PURE__ */ $t(
  Cs,
  {
    style: {
      stroke: Kh.colors.grey300,
      strokeDasharray: "6,6 "
    }
  }
), vd = ({ ...t }) => /* @__PURE__ */ $t(ts, { ...t, style: { fill: "none" } }), s2t = (t) => {
  const e = { ...t };
  return delete e._voronoiX, delete e._voronoiY, delete e._x, delete e._y, delete e.childName, delete e.continuous, delete e.eventKey, delete e.style, delete e["<prototype>"], e;
}, o2t = (t, e) => {
  const [r, i] = cn(
    t && !(t != null && t.highlightedBar) && t.initialBar ? { ...t.initialBar, eventKey: void 0 } : null
  ), s = Sn(null), c = Sn(!1), u = en(() => (t == null ? void 0 : t.highlightedBar) === void 0, [t == null ? void 0 : t.highlightedBar]), l = en(() => (t == null ? void 0 : t.highlightedBar) !== void 0 ? t.highlightedBar : r, [t == null ? void 0 : t.highlightedBar, r]), f = () => {
    var w;
    const b = ((w = s.current) == null ? void 0 : w[e]) !== (l == null ? void 0 : l[e]);
    if (!(!t || !s.current || !b)) {
      if (t.onHighlightBar) {
        const v = s2t(s.current);
        t.onHighlightBar(v);
      }
      u && i(s.current);
    }
  };
  return {
    setActiveBar: (b) => s.current = b[0],
    highlightedBar: l,
    handleOnMouseMove: () => {
      c.current && f();
    },
    handleOnTouchMove: () => {
      f();
    },
    handleOnClick: () => {
      f();
    },
    handleOnMouseLeave: () => c.current = !1,
    handleOnMouseUp: () => c.current = !1,
    handleOnMouseDown: () => c.current = !0
  };
}, l2t = () => {
  const t = Sn(null), [e, r] = cn({
    height: 0,
    width: 0
  });
  return Tn(() => {
    const i = new ResizeObserver((s) => {
      const c = s[0].contentBoxSize[0].blockSize ?? 0, u = s[0].contentBoxSize[0].inlineSize ?? 0;
      (u !== 0 || c !== 0) && r({
        height: c,
        width: u
      });
    });
    return t.current && i.observe(t.current), () => {
      i.disconnect();
    };
  }, []), {
    chartRef: t,
    width: e.width,
    height: e.height
  };
}, K7t = ({
  data: t,
  yKey: e,
  xKey: r,
  xAxis: i,
  yAxis: s,
  fill: c = "#000000",
  barRatio: u = 0.625,
  highlight: l,
  title: f,
  padding: o
}) => {
  const { chartRef: g, width: p, height: n } = l2t(), {
    setActiveBar: a,
    highlightedBar: d,
    handleOnMouseMove: m,
    handleOnTouchMove: b,
    handleOnClick: w,
    handleOnMouseLeave: v,
    handleOnMouseUp: h,
    handleOnMouseDown: x
  } = o2t(l, r), _ = (I) => l && d && d[r] === I[r] ? M(I) : c ? typeof c == "function" ? c(I) : c : "", M = (I) => l != null && l.fill ? typeof l.fill == "function" ? l.fill(I) : l.fill : "", O = en(() => p / t.length / 2, [t.length, p]), E = en(() => ({
    top: 50,
    right: 50,
    bottom: 50,
    left: 50,
    ...o
  }), [o]);
  return /* @__PURE__ */ $t(
    "div",
    {
      ref: g,
      onMouseDown: x,
      onMouseUp: h,
      onMouseLeave: v,
      onTouchMove: b,
      onMouseMove: m,
      onClick: w,
      className: Ke("h-full min-h-0 w-full min-w-0", { "cursor-pointer": l }),
      children: /* @__PURE__ */ Ve(
        E4,
        {
          height: n,
          width: p,
          domainPadding: {
            x: O,
            y: s != null && s.domain ? 0 : 10
          },
          domain: { x: i == null ? void 0 : i.domain, y: s == null ? void 0 : s.domain },
          padding: E,
          title: f,
          containerComponent: /* @__PURE__ */ $t(n2t, { voronoiDimension: "x", onActivated: (I) => l && a(I) }),
          children: [
            /* @__PURE__ */ $t(
              Ws,
              {
                tickCount: i == null ? void 0 : i.tickCount,
                orientation: i == null ? void 0 : i.position,
                axisComponent: bd,
                tickLabelComponent: /* @__PURE__ */ $t(vd, {}),
                gridComponent: a2t,
                crossAxis: !0
              }
            ),
            /* @__PURE__ */ $t(
              Ws,
              {
                tickCount: s == null ? void 0 : s.tickCount,
                orientation: s == null ? void 0 : s.position,
                axisComponent: bd,
                tickLabelComponent: /* @__PURE__ */ $t(vd, {}),
                gridComponent: i2t,
                dependentAxis: !0
              }
            ),
            /* @__PURE__ */ $t(
              R9,
              {
                data: t,
                x: r.toString(),
                y: e.toString(),
                cornerRadius: (I) => {
                  const { barWidth: R } = I;
                  return R / 2;
                },
                barRatio: u,
                style: {
                  data: {
                    fill: ({ datum: I }) => _(I)
                  }
                }
              }
            ),
            /* @__PURE__ */ $t(
              Ws,
              {
                orientation: i == null ? void 0 : i.position,
                tickFormat: (I) => {
                  var R;
                  return ((R = i == null ? void 0 : i.tickFormat) == null ? void 0 : R.call(i, I)) ?? I;
                },
                tickCount: i == null ? void 0 : i.tickCount,
                tickLabelComponent: /* @__PURE__ */ $t(
                  IS,
                  {
                    labelColor: i == null ? void 0 : i.tickLabelColor,
                    labelSize: i == null ? void 0 : i.tickLabelSize,
                    labelAnchor: i == null ? void 0 : i.tickLabelAnchor
                  }
                ),
                axisComponent: yd,
                gridComponent: bd,
                style: {
                  ticks: {
                    stroke: Kh.colors.grey300,
                    size: 5
                  }
                }
              }
            ),
            /* @__PURE__ */ $t(
              Ws,
              {
                orientation: s == null ? void 0 : s.position,
                tickFormat: (I) => {
                  var R;
                  return ((R = s == null ? void 0 : s.tickFormat) == null ? void 0 : R.call(s, I)) ?? I;
                },
                tickCount: s == null ? void 0 : s.tickCount,
                tickLabelComponent: /* @__PURE__ */ $t(
                  IS,
                  {
                    labelColor: s == null ? void 0 : s.tickLabelColor,
                    labelSize: s == null ? void 0 : s.tickLabelSize,
                    labelAnchor: s == null ? void 0 : s.tickLabelAnchor
                  }
                ),
                axisComponent: yd,
                gridComponent: bd,
                dependentAxis: !0
              }
            ),
            /* @__PURE__ */ $t(
              Ws,
              {
                orientation: (i == null ? void 0 : i.position) === "top" ? "bottom" : "top",
                axisComponent: yd,
                tickLabelComponent: /* @__PURE__ */ $t(vd, {})
              }
            ),
            /* @__PURE__ */ $t(
              Ws,
              {
                orientation: (s == null ? void 0 : s.position) === "left" ? "right" : "left",
                axisComponent: yd,
                tickLabelComponent: /* @__PURE__ */ $t(vd, {}),
                dependentAxis: !0
              }
            )
          ]
        }
      )
    }
  );
}, c2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12.571 4.75a.75.75 0 0 0-1.5 0v6.321H4.75a.75.75 0 0 0 0 1.5h6.321v6.321a.75.75 0 0 0 1.5 0v-6.32h6.321a.75.75 0 0 0 0-1.5h-6.32V4.75Z", clipRule: "evenodd" })), u2t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.47 7.2V13.7479C11.47 13.8583 11.5595 13.9479 11.67 13.9479H12.62C12.7305 13.9479 12.82 13.8583 12.82 13.7479V7.2C12.82 7.08954 12.7305 7 12.62 7H11.67C11.5595 7 11.47 7.08954 11.47 7.2Z" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.254 15.9781C13.254 16.6221 12.764 17.1261 12.12 17.1261C11.49 17.1261 11 16.6221 11 15.9781C11 15.3061 11.49 14.8301 12.12 14.8301C12.764 14.8301 13.254 15.3061 13.254 15.9781Z" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM19.6 12C19.6 16.1974 16.1974 19.6 12 19.6C7.80264 19.6 4.4 16.1974 4.4 12C4.4 7.80264 7.80264 4.4 12 4.4C16.1974 4.4 19.6 7.80264 19.6 12Z" })), h2t = (t) => /* @__PURE__ */ pt.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M37.49,30.37L23.21,5.89c-.67-1.15-1.87-1.84-3.21-1.84s-2.54.69-3.21,1.84L2.51,30.37c-.68,1.16-.68,2.56-.01,3.72.67,1.17,1.88,1.86,3.22,1.86h28.56c1.35,0,2.55-.7,3.22-1.86.67-1.17.67-2.56-.01-3.72ZM35.77,33.09c-.31.54-.87.86-1.49.86H5.72c-.62,0-1.18-.32-1.49-.86s-.31-1.18,0-1.72L18.52,6.9c.31-.53.86-.85,1.48-.85s1.17.32,1.48.85l14.28,24.48c.31.54.32,1.18,0,1.72Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M20,12c-.55,0-1,.45-1,1v12c0,.55.45,1,1,1s1-.45,1-1v-12c0-.55-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 20, cy: 29, r: 1 })), f2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M18.03 14.03a.75.75 0 1 0-1.06-1.06l-4.72 4.72V4.5a.75.75 0 0 0-1.5 0v13.19l-4.72-4.72a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l6-6Z", clipRule: "evenodd" })), d2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M10.22 18.28a.75.75 0 1 0 1.06-1.06L6.56 12.5h13.19a.75.75 0 0 0 0-1.5H6.56l4.72-4.72a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 0 0 0 1.06l6 6Z", clipRule: "evenodd" })), g2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M13.53 5.47a.75.75 0 1 0-1.06 1.06l4.72 4.72H4a.75.75 0 0 0 0 1.5h13.19l-4.72 4.72a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6Z", clipRule: "evenodd" })), p2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M4.97 9.97a.75.75 0 1 0 1.06 1.06l4.72-4.72V19.5a.75.75 0 0 0 1.5 0V6.31l4.72 4.72a.75.75 0 1 0 1.06-1.06l-6-6a.75.75 0 0 0-1.06 0l-6 6Z", clipRule: "evenodd" })), m2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M18.53 21.75H5.47c-.47 0-.88-.32-1.01-.77L1.12 9.99c0-.57.47-1.04 1.04-1.04h19.67c.57 0 1.04.46 1.04 1.04l-.03.22L19.53 21c-.12.44-.54.75-1 .75ZM5.81 20.26h12.38l3.01-9.8H2.8l3.01 9.8Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M12 10.15c-.41 0-.75-.34-.75-.75V2c0-.41.34-.75.75-.75s.75.34.75.75v7.4c0 .41-.34.75-.75.75Zm0 8c-.41 0-.75-.34-.75-.75V13c0-.41.34-.75.75-.75s.75.34.75.75v4.4c0 .41-.34.75-.75.75Zm-4 0c-.41 0-.75-.34-.75-.75V13c0-.41.34-.75.75-.75s.75.34.75.75v4.4c0 .41-.34.75-.75.75Zm8 0c-.41 0-.75-.34-.75-.75V13c0-.41.34-.75.75-.75s.75.34.75.75v4.4c0 .41-.34.75-.75.75Z" })), y2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M28,6h-2v-3c0-.55-.45-1-1-1h-10c-.55,0-1,.45-1,1v3h-2c-.55,0-1,.45-1,1v30c0,.55.45,1,1,1h16c.55,0,1-.45,1-1V7c0-.55-.45-1-1-1ZM16,4h8v2h-8v-2ZM27,36h-14V8h14v28Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M24.17,14h-8.33c-.46,0-.83.43-.83.95v18.1c0,.53.37.95.83.95h8.33c.46,0,.83-.43.83-.95V14.95c0-.53-.37-.95-.83-.95ZM23,32h-6v-16h6v16Z" })), b2t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M13.6 18.4H11.2C10.87 18.4 10.6 18.67 10.6 19C10.6 19.33 10.87 19.6 11.2 19.6H13.6C13.93 19.6 14.2 19.33 14.2 19C14.2 18.67 13.93 18.4 13.6 18.4Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M12.4 12.742C11.116 12.742 10.234 13.522 10.198 13.558C9.952 13.78 9.934 14.152 10.15 14.398C10.372 14.644 10.75 14.668 10.996 14.452C10.996 14.452 11.584 13.942 12.4 13.942C13.216 13.942 13.792 14.446 13.798 14.446C13.912 14.548 14.056 14.602 14.2 14.602C14.362 14.602 14.524 14.536 14.644 14.404C14.866 14.158 14.848 13.78 14.602 13.558C14.566 13.522 13.684 12.742 12.4 12.742Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M15.748 11.65C15.688 11.608 14.254 10.6 12.304 10.6C10.354 10.6 9.07 11.632 9.016 11.68C8.764 11.89 8.728 12.268 8.938 12.52C9.148 12.772 9.526 12.808 9.784 12.598C9.796 12.592 10.78 11.8 12.304 11.8C13.828 11.8 15.046 12.622 15.052 12.628C15.16 12.7 15.28 12.742 15.4 12.742C15.586 12.742 15.772 12.652 15.892 12.49C16.084 12.22 16.024 11.848 15.754 11.65H15.748Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M17.2 1H7.6C7.27 1 7 1.27 7 1.6V22C7 22.33 7.27 22.6 7.6 22.6H17.2C17.53 22.6 17.8 22.33 17.8 22V1.6C17.8 1.27 17.53 1 17.2 1ZM16.6 21.4H8.2V2.2H16.6V21.4Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M12.4 17.2C12.7314 17.2 13 16.9314 13 16.6C13 16.2686 12.7314 16 12.4 16C12.0686 16 11.8 16.2686 11.8 16.6C11.8 16.9314 12.0686 17.2 12.4 17.2Z" })), v2t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "Payment method=Betalingsservice" }, /* @__PURE__ */ pt.createElement("path", { id: "Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M12.2469 8.23658C11.9651 7.56128 11.2549 7.0264 10.4986 7H3.28526L2.74847 9.32329L2.64266 9.83486H12.4205C12.5265 9.28892 12.456 8.71658 12.2469 8.23658ZM22.3509 9.83486L22.9931 7H15.8666C14.4161 7.17141 13.1068 8.50269 12.73 9.83486H22.3509ZM4.55917 13.4341H1.80762L1.90524 12.9556L2.48539 10.5029H12.2281C11.9572 11.1782 11.2632 11.7051 10.561 11.8529V11.8687C11.0625 11.9715 11.4312 12.4939 11.5098 12.9556C11.514 12.9893 11.519 13.023 11.524 13.057L11.524 13.0571L11.524 13.0572L11.524 13.0572C11.5417 13.1774 11.5598 13.3005 11.545 13.4341H4.55917ZM21.5968 11.6287C21.2093 10.927 20.453 10.5556 19.672 10.5029H12.5534C12.456 11.099 12.502 11.7922 12.7648 12.3145C13.0821 13.0136 13.8463 13.3999 14.6002 13.4341H21.868C21.9844 12.8249 21.895 12.1589 21.5968 11.6287ZM21.7233 14.0967C21.3353 15.4393 20.103 16.8205 18.5988 16.9734L17.8613 17H11.1069L11.125 16.9314L11.8535 14.0967H21.7233ZM8.89129 16.9392C10.2195 16.6675 11.274 15.3364 11.4855 14.0967H1.65063L1.10581 16.4777L1 17C1 17 8.27022 17.0009 8.38164 17C8.62783 16.9979 8.89129 16.9392 8.89129 16.9392Z" }))), w2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M9.917 17.208a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625v-7.5a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v7.5Zm2.916 0a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625v-7.5a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v7.5Z" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M15.062 5.542h4.021a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625H18.02l.023 13.517a.624.624 0 0 1-.625.625l-10.809.025a.624.624 0 0 1-.625-.625L5.96 6.792H4.917a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.02A3.127 3.127 0 0 1 12 3.042a3.127 3.127 0 0 1 3.062 2.5Zm-7.854 1.25v12.917h9.584V6.792H7.208Zm6.559-1.25A1.879 1.879 0 0 0 12 4.292a1.88 1.88 0 0 0-1.767 1.25h3.534Z", clipRule: "evenodd" })), x2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M32,8h-1v-1.51c0-1.37-1.12-2.49-2.49-2.49h-1.02c-1.37,0-2.49,1.12-2.49,2.49v1.51h-2v-1.51c0-1.37-1.12-2.49-2.49-2.49h-1.02c-1.37,0-2.49,1.12-2.49,2.49v1.51h-2v-1.51c0-1.37-1.12-2.49-2.49-2.49h-1.02c-1.37,0-2.49,1.12-2.49,2.49v1.51h-1c-2.21,0-4,1.79-4,4v20c0,2.21,1.79,4,4,4h24c2.21,0,4-1.79,4-4V12c0-2.21-1.79-4-4-4ZM27,6.49c0-.27.22-.49.49-.49h1.02c.27,0,.49.22.49.49v1.51h-2v-1.51ZM27,10h2v1.51c0,.27-.22.49-.49.49h-1.02c-.27,0-.49-.22-.49-.49v-1.51ZM19,6.49c0-.27.22-.49.49-.49h1.02c.27,0,.49.22.49.49v1.51h-2v-1.51ZM19,10h2v1.51c0,.27-.22.49-.49.49h-1.02c-.27,0-.49-.22-.49-.49v-1.51ZM11,6.49c0-.27.22-.49.49-.49h1.02c.27,0,.49.22.49.49v1.51h-2v-1.51ZM11,10h2v1.51c0,.27-.22.49-.49.49h-1.02c-.27,0-.49-.22-.49-.49v-1.51ZM34,32c0,1.1-.9,2-2,2H8c-1.1,0-2-.9-2-2V12c0-1.1.9-2,2-2h1v1.51c0,1.37,1.12,2.49,2.49,2.49h1.02c1.37,0,2.49-1.12,2.49-2.49v-1.51h2v1.51c0,1.37,1.12,2.49,2.49,2.49h1.02c1.37,0,2.49-1.12,2.49-2.49v-1.51h2v1.51c0,1.37,1.12,2.49,2.49,2.49h1.02c1.37,0,2.49-1.12,2.49-2.49v-1.51h1c1.1,0,2,.9,2,2v20Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M12,21h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M12,25h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M12,29h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M18,17h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M18,21h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M18,25h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M18,29h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M24,17h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M24,21h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M24,25h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M24,29h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M30,17h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M30,21h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M30,25h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M30,29h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z" })), S2t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M19.283 18.6539L15.923 15.0839C15.755 14.9039 15.485 14.8379 15.245 14.9399L13.337 15.7559L9.23899 9.0359L10.877 7.6739C11.039 7.5119 11.093 7.2659 11.021 7.0499L9.43099 2.5019C9.23299 1.8899 8.45299 1.6079 7.91299 1.9559L5.59099 3.3719C2.95699 4.9799 3.49699 8.2859 7.45699 14.7839C10.103 18.9119 13.133 23.7899 16.745 21.6719L19.073 20.2559C19.625 19.9379 19.739 19.1159 19.289 18.6599L19.283 18.6539ZM16.121 20.6459C13.601 22.2719 10.703 17.6579 8.48299 14.1599C3.53299 6.0359 5.34499 4.9259 6.22099 4.3979L8.37499 3.0839L9.76099 7.0559L8.08699 8.4419C7.85899 8.6279 7.79899 8.9639 7.95499 9.2219L12.599 16.8419C12.761 17.0819 13.073 17.1779 13.337 17.0639L15.335 16.2119L18.275 19.3379L16.121 20.6519V20.6459Z" })), C2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M35,11h-10.22l-.81-3.24c-.11-.45-.51-.76-.97-.76h-8c-.46,0-.86.31-.97.76l-.81,3.24H3c-.55,0-1,.45-1,1v20c0,.55.45,1,1,1h32c.55,0,1-.45,1-1V12c0-.55-.45-1-1-1ZM15.78,9h6.44l.5,2h-7.44l.5-2ZM34,31H4V13h30v18Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M19,15c-3.86,0-7,3.14-7,7s3.14,7,7,7,7-3.14,7-7-3.14-7-7-7ZM19,27c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5Z" })), A2t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "Payment method=By card" }, /* @__PURE__ */ pt.createElement("path", { id: "card", fillRule: "evenodd", clipRule: "evenodd", d: "M4 7C3.44772 7 3 7.44771 3 8V10H21V8C21 7.44772 20.5523 7 20 7H4ZM21 12H3V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V12ZM5 14H9V15H5V14ZM16 14H10V15H16V14Z" }))), _2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M34,2H13c-2.21,0-4,1.79-4,4v8h-3c-2.21,0-4,1.79-4,4v10c0,2.21,1.79,4,4,4h4.58l5.43,5.43c.33.34.78.51,1.23.51.23,0,.45-.04.67-.13.66-.27,1.08-.91,1.08-1.61v-4.19h8c2.21,0,4-1.79,4-4v-8h3c2.21,0,4-1.79,4-4V6c0-2.21-1.79-4-4-4ZM29,28c0,1.1-.9,2-2,2h-9c-.55,0-1,.45-1,1v4.59l-5.29-5.29c-.19-.19-.44-.29-.71-.29h-5c-1.1,0-2-.9-2-2v-10c0-1.1.9-2,2-2h3c0,2.21,1.8,4,4,4h8v4.19c0,.71.42,1.34,1.08,1.61.22.09.45.13.67.13.45,0,.9-.18,1.23-.51l5.02-5.02v7.58ZM36,16c0,1.1-.9,2-2,2h-5s0,0,0,0c-.27,0-.52.11-.71.29l-5.29,5.29v-4.59c0-.55-.45-1-1-1h-9c-1.1,0-2-.9-2-2,0,0,0,0,0,0V6c0-1.1.9-2,2-2h21c1.1,0,2,.9,2,2v10Z" })), k2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12.5 4.75c-4.743 0-8.25 2.963-8.25 6.25 0 1.23.473 2.392 1.32 3.383.18.21.23.503.129.76L4.332 18.65l4.539-1.844a.75.75 0 0 1 .505-.021c.962.3 2.016.466 3.124.466 4.743 0 8.25-2.963 8.25-6.25s-3.507-6.25-8.25-6.25ZM2.75 11c0-4.445 4.552-7.75 9.75-7.75s9.75 3.305 9.75 7.75-4.552 7.75-9.75 7.75c-1.16 0-2.274-.16-3.309-.456l-5.909 2.4a.75.75 0 0 1-.98-.966l1.842-4.725C3.268 13.847 2.75 12.478 2.75 11Z", clipRule: "evenodd" })), O2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M27,18h-14c-2.76,0-5,2.24-5,5s2.24,5,5,5h14c2.76,0,5-2.24,5-5s-2.24-5-5-5ZM27,26h-14c-1.65,0-3-1.35-3-3s1.35-3,3-3h14c1.65,0,3,1.35,3,3s-1.35,3-3,3Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 15, cy: 23, r: 2 }), /* @__PURE__ */ pt.createElement("circle", { cx: 25, cy: 23, r: 2 }), /* @__PURE__ */ pt.createElement("path", { d: "M37,18c-.55,0-1,.45-1,1v.77c-1.46-3.83-4.85-6.95-9.21-8.57-.61-1.56-2.36-3.78-5.79-4.15v-1.34c.6-.35,1-.98,1-1.72,0-1.1-.9-2-2-2s-2,.9-2,2c0,.74.4,1.38,1,1.72v1.34c-3.43.37-5.18,2.59-5.79,4.15-4.36,1.62-7.75,4.73-9.21,8.57v-.77c0-.55-.45-1-1-1s-1,.45-1,1v10c0,.55.45,1,1,1s1-.45,1-1v-.77c2.15,5.66,8.51,9.77,16,9.77s13.85-4.11,16-9.77v.77c0,.55.45,1,1,1s1-.45,1-1v-10c0-.55-.45-1-1-1ZM20,9c1.9,0,3.1.66,3.86,1.39-1.24-.24-2.53-.39-3.86-.39s-2.62.14-3.86.39c.76-.73,1.96-1.39,3.86-1.39ZM20,36c-8.15,0-14.79-5.38-14.79-12,0-4.93,3.68-9.17,8.93-11.01.07,0,.12-.04.19-.07,1.75-.59,3.66-.92,5.67-.92s3.85.32,5.58.89c.08.04.15.06.23.08,5.27,1.84,8.97,6.09,8.97,11.03,0,6.62-6.63,12-14.79,12Z" })), T2t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.045 4.66155C16.508 4.96254 16.6394 5.58192 16.3384 6.04498L9.83844 16.045C9.67406 16.2979 9.4043 16.4631 9.10432 16.4945C8.80434 16.526 8.50618 16.4204 8.29289 16.2071L3.79289 11.7071C3.40237 11.3166 3.40237 10.6834 3.79289 10.2929C4.18342 9.90236 4.81658 9.90236 5.20711 10.2929L8.83427 13.9201L14.6616 4.95501C14.9625 4.49195 15.5819 4.36056 16.045 4.66155Z" })), M2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M19.442 5.394a.75.75 0 0 1 .164 1.048l-8.026 11a.75.75 0 0 1-1.087.134L4.52 12.59a.75.75 0 1 1 .962-1.152l5.359 4.472 7.554-10.353a.75.75 0 0 1 1.048-.164Z", clipRule: "evenodd" })), E2t = (t) => /* @__PURE__ */ pt.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20,4c-8.82,0-16,7.18-16,16s7.18,16,16,16,16-7.18,16-16S28.82,4,20,4ZM20,34c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M27.5,12.13c-.48-.27-1.09-.11-1.36.37l-7.35,12.86-5.07-5.07c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l6,6c.19.19.44.29.71.29.04,0,.09,0,.13,0,.31-.04.58-.22.74-.5l8-14c.27-.48.11-1.09-.37-1.36Z" })), P2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M5.09 9.866A.875.875 0 0 1 6.347 8.65L12 14.484l5.653-5.835a.875.875 0 0 1 1.257 1.217l-6.192 6.393a1 1 0 0 1-1.436 0L5.09 9.866Z" })), I2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M14.134 5.09a.875.875 0 0 1 1.217 1.257L9.516 12l5.835 5.653a.875.875 0 0 1-1.217 1.257L7.74 12.718a1 1 0 0 1 0-1.436l6.393-6.192Z" })), F2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M9.866 18.91a.875.875 0 1 1-1.217-1.257L14.484 12 8.65 6.347A.875.875 0 0 1 9.866 5.09l6.393 6.192a1 1 0 0 1 0 1.436l-3.13 3.032-3.263 3.16Z" })), R2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M18.91 14.134a.875.875 0 0 1-1.257 1.217L12 9.516 6.347 15.35a.875.875 0 0 1-1.257-1.217l6.192-6.393a1 1 0 0 1 1.436 0l6.192 6.393Z" })), D2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12 19.6a7.6 7.6 0 1 0 0-15.2 7.6 7.6 0 0 0 0 15.2Zm0 1.4a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", clipRule: "evenodd" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12 6.8a.7.7 0 0 1 .7.7v4.125l4.188 2.792a.7.7 0 1 1-.776 1.165l-4.5-3A.7.7 0 0 1 11.3 12V7.5a.7.7 0 0 1 .7-.7Z", clipRule: "evenodd" })), $2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M6.53 5.47a.75.75 0 0 0-1.06 1.06l5.126 5.127-5.126 5.126a.75.75 0 1 0 1.06 1.061l5.127-5.127 5.126 5.127a.75.75 0 1 0 1.061-1.06l-5.127-5.127 5.127-5.127a.75.75 0 0 0-1.06-1.06l-5.127 5.126L6.53 5.47Z", clipRule: "evenodd" })), L2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M34,8H6c-2.21,0-4,1.79-4,4v16c0,2.21,1.79,4,4,4h28c2.21,0,4-1.79,4-4v-16c0-2.21-1.79-4-4-4ZM6,10h28c1.1,0,2,.9,2,2v2H4v-2c0-1.1.9-2,2-2ZM36,28c0,1.1-.9,2-2,2H6c-1.1,0-2-.9-2-2v-12h32v12Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M7,26h11c.55,0,1-.45,1-1s-.45-1-1-1H7c-.55,0-1,.45-1,1s.45,1,1,1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M22,26h5c.55,0,1-.45,1-1s-.45-1-1-1h-5c-.55,0-1,.45-1,1s.45,1,1,1Z" })), N2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12 3.962a5.917 5.917 0 0 0-5.9 5.47 3.183 3.183 0 0 1 2.264 3.047v1.819a3.183 3.183 0 0 1-2.28 3.052v1.215c0 .436.105.585.204.665.144.115.484.252 1.268.252h2.776A1.819 1.819 0 0 1 12 18.389h.91a1.818 1.818 0 0 1 0 3.636H12a1.819 1.819 0 0 1-1.667-1.09v.047H7.556c-.884 0-1.654-.14-2.205-.581-.595-.476-.768-1.16-.768-1.836v-1.142A3.183 3.183 0 0 1 2 14.298v-1.819A3.183 3.183 0 0 1 4.602 9.35a7.417 7.417 0 0 1 14.796 0A3.183 3.183 0 0 1 22 12.48v1.818a3.182 3.182 0 0 1-6.364 0v-1.819c0-1.438.954-2.653 2.264-3.047a5.917 5.917 0 0 0-5.9-5.47ZM6.864 14.298v-1.819a1.682 1.682 0 1 0-3.364 0v1.819a1.682 1.682 0 0 0 3.364 0ZM12 19.888h.91a.318.318 0 1 1 0 .637H12a.318.318 0 1 1 0-.636Zm8.5-7.409v1.819a1.682 1.682 0 0 1-3.364 0v-1.819a1.682 1.682 0 1 1 3.364 0Z", clipRule: "evenodd" })), B2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M28.58,2H11.42c-1.88,0-3.42,1.54-3.42,3.42v29.15c0,1.13.31,2.01.93,2.61.6.58,1.45.86,2.52.82,2-.07,4.84-.86,4.87-.87,2.44-.44,4.92-.44,7.27-.02.35.09,3.34.89,4.85.89.07,0,.13,0,.19,0,1.89-.1,3.36-1.6,3.36-3.42V5.42c0-1.89-1.53-3.42-3.42-3.42ZM30,34.57c0,.77-.63,1.38-1.47,1.43-.82.06-3.16-.48-4.5-.84-1.32-.24-2.66-.36-4-.36s-2.76.13-4.15.38c-.03,0-2.73.75-4.5.82-.35,0-.81-.02-1.06-.26-.26-.25-.32-.77-.32-1.17V5.42c0-.79.64-1.42,1.42-1.42h17.17c.78,0,1.42.64,1.42,1.42v29.15Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 13, cy: 10, r: 1 }), /* @__PURE__ */ pt.createElement("circle", { cx: 16, cy: 10, r: 1 }), /* @__PURE__ */ pt.createElement("circle", { cx: 19, cy: 10, r: 1 }), /* @__PURE__ */ pt.createElement("path", { d: "M27,9h-4c-.55,0-1,.45-1,1s.45,1,1,1h4c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 13, cy: 14, r: 1 }), /* @__PURE__ */ pt.createElement("circle", { cx: 16, cy: 14, r: 1 }), /* @__PURE__ */ pt.createElement("circle", { cx: 19, cy: 14, r: 1 }), /* @__PURE__ */ pt.createElement("path", { d: "M27,13h-4c-.55,0-1,.45-1,1s.45,1,1,1h4c.55,0,1-.45,1-1s-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 13, cy: 18, r: 1 }), /* @__PURE__ */ pt.createElement("circle", { cx: 16, cy: 18, r: 1 }), /* @__PURE__ */ pt.createElement("circle", { cx: 19, cy: 18, r: 1 }), /* @__PURE__ */ pt.createElement("path", { d: "M27,17h-4c-.55,0-1,.45-1,1s.45,1,1,1h4c.55,0,1-.45,1-1s-.45-1-1-1Z" })), j2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20.46,37.9s-.04,0-.07,0c-.43-.03-.79-.33-.9-.74l-2.98-11.11-11.46-1c-.43-.04-.78-.34-.88-.76-.1-.42.07-.85.43-1.08L32.83,5.12c.37-.24.85-.21,1.18.08.33.28.45.75.28,1.15l-12.91,30.94c-.16.37-.52.62-.92.62ZM8.15,23.3l9.24.81c.42.04.77.33.88.74l2.4,8.96,10.55-25.28-23.07,14.78Z" })), U2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", width: "24px", viewBox: "0 -960 960 960", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M360-250h240q12.77 0 21.38-8.62Q630-267.23 630-280t-8.62-21.38Q612.77-310 600-310H360q-12.77 0-21.38 8.62Q330-292.77 330-280t8.62 21.38Q347.23-250 360-250Zm0-160h240q12.77 0 21.38-8.62Q630-427.23 630-440t-8.62-21.38Q612.77-470 600-470H360q-12.77 0-21.38 8.62Q330-452.77 330-440t8.62 21.38Q347.23-410 360-410ZM252.31-100Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21h287.77q14.46 0 27.81 5.62 13.34 5.61 23.19 15.46l167.84 167.84q9.85 9.85 15.46 23.19 5.62 13.35 5.62 27.81v447.77Q780-142 759-121q-21 21-51.31 21H252.31ZM540-656.16V-800H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-620H576.16q-15.47 0-25.81-10.35Q540-640.69 540-656.16ZM240-800v180-180V-160v-640Z" })), H2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M18.2803 9.96967C18.5732 10.2626 18.5732 10.7374 18.2803 11.0303L12.2803 17.0303C11.9874 17.3232 11.5126 17.3232 11.2197 17.0303L5.21967 11.0303C4.92678 10.7374 4.92678 10.2626 5.21967 9.96967C5.51256 9.67678 5.98744 9.67678 6.28033 9.96967L11 14.6893L11 1.5C11 1.08579 11.3358 0.75 11.75 0.75C12.1642 0.75 12.5 1.08579 12.5 1.5L12.5 14.6893L17.2197 9.96967C17.5126 9.67678 17.9874 9.67678 18.2803 9.96967Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M19.25 19.75C19.6642 19.75 20 19.4142 20 19C20 18.5858 19.6642 18.25 19.25 18.25H4.75C4.33579 18.25 4 18.5858 4 19C4 19.4142 4.33579 19.75 4.75 19.75H19.25Z" })), V2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M10.1999 10.9997C10.2999 11.0997 10.3999 11.0997 10.5999 11.0997C10.8999 11.0997 11.0999 10.9997 11.2999 10.8997L14.4999 6.39969H12.5999L13.8999 4.79969C14.1999 4.39969 14.0999 3.99969 13.7999 3.69969C13.3999 3.39969 12.9999 3.49969 12.6999 3.79969L9.3999 7.89969H11.4999L9.9999 9.99969C9.7999 10.2997 9.8999 10.7997 10.1999 10.9997Z" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4 18.3004C17.313 18.3874 16.0149 19.1557 13.2421 19.3539C13.6235 20.1974 14.3028 21.0385 15.5 21.5997C15.9 21.7997 16 22.1997 15.9 22.5997C15.6 22.9997 15.4 23.0997 15.1 23.0997C15 23.0997 14.9 23.0997 14.8 22.9997C13.0477 22.1501 12.0849 20.7648 11.6121 19.3977C8.10661 19.3329 6.40002 18.1004 6.40002 18.1004C6.20002 18.0004 6.10002 17.7004 6.10002 17.5004V6.00039C6.10002 6.00039 6.00002 4.00039 7.50002 2.50039C8.50002 1.40039 10 0.900391 11.9 0.900391C13.8 0.900391 15.2 1.40039 16.3 2.50039C17.7 4.00039 17.7 6.00039 17.7 6.10039V17.7004C17.7 18.0004 17.6 18.2004 17.4 18.3004ZM16.2 17.2004C15.6854 17.4577 14.5824 17.7885 12.8278 17.8775C12.787 17.576 12.7732 17.3017 12.7718 17.0732C13.7872 16.7295 14.5192 15.7299 14.5999 14.6C14.5999 13.2 13.3999 12 11.9999 12C10.5999 12 9.3999 13.2 9.3999 14.6C9.3999 15.7323 10.1849 16.7338 11.2257 17.0754C11.224 17.3307 11.2377 17.6035 11.2702 17.8875C9.3418 17.8074 8.14314 17.372 7.60002 17.1004V5.90039C7.60002 5.90039 7.60002 4.40039 8.60002 3.40039C9.30002 2.70039 10.4 2.30039 11.9 2.30039C13.4 2.30039 14.5 2.70039 15.2 3.40039C16.2 4.50039 16.2 6.00039 16.2 6.00039V17.2004ZM10.8999 14.6C10.8999 14 11.3999 13.5 11.9999 13.5C12.5999 13.5 12.9999 14 13.0999 14.6C13.0999 15.2 12.5999 15.7 11.9999 15.7C11.3999 15.7 10.8999 15.2 10.8999 14.6Z" })), z2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M17 3.604a.75.75 0 0 0-1.06 0L4.273 15.272a.75.75 0 0 0-.22.507l-.106 3.5a.75.75 0 0 0 .773.773l3.5-.107a.75.75 0 0 0 .507-.219L20.395 8.06a.75.75 0 0 0 0-1.06L17 3.603ZM7.38 14.287l9.091-9.092 2.334 2.334-9.092 9.091-2.333-2.333Zm-1.061 1.061-.774.774-.073 2.406 2.406-.073.774-.774-2.333-2.333Z", clipRule: "evenodd" })), X2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M14.783 1.458a.6.6 0 0 1 .32.705l-1.996 7.116H18a.6.6 0 0 1 .49.945L9.965 22.346a.6.6 0 0 1-1.068-.508l1.996-7.113-4.89.018a.6.6 0 0 1-.493-.945l8.526-12.142a.6.6 0 0 1 .748-.198Zm-7.626 12.08 4.525-.016a.6.6 0 0 1 .58.762l-1.265 4.508 5.847-8.313h-4.528a.6.6 0 0 1-.578-.762l1.263-4.5-5.844 8.322Z", clipRule: "evenodd" })), q2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M.25 6A.75.75 0 0 1 1 5.25h22a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-.75.75H1A.75.75 0 0 1 .25 19V6Zm1.5 11.54V7.584l6.492 5.312L1.75 17.54Zm1.586.71h17.328l-6.108-4.371-2.081 1.702a.75.75 0 0 1-.95 0l-2.08-1.703-6.109 4.372Zm12.422-5.355 6.492 4.646V7.583l-6.492 5.312ZM12 14.03 3.1 6.75h17.8L12 14.031Z", clipRule: "evenodd" })), W2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M19.75 4H13a.75.75 0 0 0 0 1.5h4.94l-6.72 6.72a.75.75 0 1 0 1.06 1.06L19 6.56v4.94a.75.75 0 0 0 1.5 0V4.75a.75.75 0 0 0-.75-.75ZM5.5 7.75a.25.25 0 0 1 .25-.25H9.5a.75.75 0 0 0 0-1.5H5.75A1.75 1.75 0 0 0 4 7.75v10c0 .966.784 1.75 1.75 1.75h11a1.75 1.75 0 0 0 1.75-1.75V14a.75.75 0 0 0-1.5 0v3.75a.25.25 0 0 1-.25.25h-11a.25.25 0 0 1-.25-.25v-10Z", clipRule: "evenodd" })), G2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M10.3,37.02c-.35,0-.7-.1-1-.31-.63-.44-.9-1.22-.68-1.96l3.34-10.86-8.79-6.74c-.61-.46-.84-1.23-.59-1.96s.9-1.19,1.66-1.19h10.77l3.31-10.74c.23-.74.9-1.24,1.68-1.24s1.45.5,1.68,1.24t0,0l3.31,10.74h10.77c.76,0,1.42.47,1.66,1.19s.01,1.49-.59,1.96l-8.79,6.74,3.34,10.86c.23.73-.05,1.52-.68,1.96-.63.44-1.46.42-2.07-.05l-8.63-6.61-8.63,6.62c-.31.24-.69.36-1.07.36ZM20,27.78c.21,0,.43.07.61.21l8.62,6.61-3.32-10.79c-.12-.4.02-.83.35-1.09l8.77-6.72h-10.79c-.44,0-.83-.29-.96-.71l-3.29-10.68-3.29,10.68c-.13.42-.52.71-.96.71H4.97l8.77,6.72c.33.25.47.69.35,1.09l-3.32,10.79,8.62-6.61c.18-.14.39-.21.61-.21ZM19.77,3.85h0s0,0,0,0Z" })), K2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M26,11c1.65,0,3-1.35,3-3s-1.35-3-3-3-3,1.35-3,3c0,.6.18,1.16.49,1.63-.64,1.24-1.49,3.28-1.49,5.37h-1v-7.18c1.16-.41,2-1.51,2-2.82,0-1.65-1.35-3-3-3s-3,1.35-3,3c0,1.3.84,2.4,2,2.82v7.18h-1c0-2.09-.85-4.13-1.49-5.37.31-.47.49-1.03.49-1.63,0-1.65-1.35-3-3-3s-3,1.35-3,3,1.35,3,3,3c.31,0,.6-.06.88-.15.51,1.06,1.12,2.62,1.12,4.15h-1c-.55,0-1,.45-1,1v2c-.55,0-1,.45-1,1v18c0,.55.45,1,1,1s1-.45,1-1v-17h10v17c0,.55.45,1,1,1s1-.45,1-1v-18c0-.55-.45-1-1-1v-2c0-.55-.45-1-1-1h-1c0-1.53.6-3.09,1.12-4.15.28.09.57.15.88.15ZM13,8c0-.55.45-1,1-1s1,.45,1,1-.45,1-1,1-1-.45-1-1ZM20,4c.55,0,1,.45,1,1s-.45,1-1,1-1-.45-1-1,.45-1,1-1ZM16,18v-1h8v1h-8ZM26,7c.55,0,1,.45,1,1s-.45,1-1,1-1-.45-1-1,.45-1,1-1Z" })), Y2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 6C9.5 6.82843 8.82843 7.5 8 7.5C7.17157 7.5 6.5 6.82843 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6ZM10.9055 6.75C10.5725 8.04392 9.39788 9 8 9C6.60212 9 5.42755 8.04392 5.09451 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H5.09451C5.42755 3.95608 6.60212 3 8 3C9.39788 3 10.5725 3.95608 10.9055 5.25H22C22.4142 5.25 22.75 5.58579 22.75 6C22.75 6.41421 22.4142 6.75 22 6.75H10.9055ZM22 11.25H19.9055C19.5725 9.95608 18.3979 9 17 9C15.6021 9 14.4275 9.95608 14.0945 11.25H3C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H14.0945C14.4275 14.0439 15.6021 15 17 15C18.3979 15 19.5725 14.0439 19.9055 12.75H22C22.4142 12.75 22.75 12.4142 22.75 12C22.75 11.5858 22.4142 11.25 22 11.25ZM10.9055 17.25H22C22.4142 17.25 22.75 17.5858 22.75 18C22.75 18.4142 22.4142 18.75 22 18.75H10.9055C10.5725 20.0439 9.39788 21 8 21C6.60212 21 5.42755 20.0439 5.09451 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18C2.25 17.5858 2.58579 17.25 3 17.25H5.09451C5.42755 15.9561 6.60212 15 8 15C9.39788 15 10.5725 15.9561 10.9055 17.25ZM17 13.5C17.8284 13.5 18.5 12.8284 18.5 12C18.5 11.1716 17.8284 10.5 17 10.5C16.1716 10.5 15.5 11.1716 15.5 12C15.5 12.8284 16.1716 13.5 17 13.5ZM9.5 18C9.5 18.8284 8.82843 19.5 8 19.5C7.17157 19.5 6.5 18.8284 6.5 18C6.5 17.1716 7.17157 16.5 8 16.5C8.82843 16.5 9.5 17.1716 9.5 18Z" })), Z2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M9,19.68c-1.17,0-2.09.32-2.79.87l.51-3.57h6.98v-2.95H4.23l-1.13,8.63,2.85,1.04c.55-.81,1.43-1.22,2.42-1.22,1.59,0,2.67,1.17,2.67,2.85s-1.08,2.85-2.69,2.85c-1.47,0-3.02-.97-3.36-2.95l-2.99.92c.83,3.36,3.64,4.97,6.33,4.97,2.99,0,5.89-2,5.89-5.82,0-3.31-2.16-5.64-5.23-5.64Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M22.99,25h3.96c-.31,1.87-1.3,3.44-3.47,3.44-2.6,0-4.1-2.21-4.1-5.66s1.52-5.66,4.01-5.66c1.7,0,2.9,1.01,3.2,3.08l3.25-1.04c-.69-3.41-3.45-5.16-6.54-5.16-4.3,0-7.32,3.41-7.32,8.82s2.85,8.54,6.88,8.54c1.77,0,3.2-.64,4.21-1.8v1.52h2.92v-9.08h-7.01v3Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M34.03,8.7c-2.64-2.53-5.85-2.69-5.99-2.69-.54-.03-1.01.4-1.04.95-.02.55.4,1.02.95,1.04.03,0,2.61.15,4.69,2.14,2.08,1.99,2.36,4.92,2.36,4.94.04.52.48.92,1,.92.03,0,.06,0,.08,0,.55-.04.96-.53.91-1.08-.01-.15-.33-3.69-2.97-6.22Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M27.05,9.93c-.58-.02-1.01.4-1.04.95s.4,1.02.95,1.05c.01,0,1.51.09,2.71,1.24,1.2,1.15,1.37,2.86,1.38,2.88.04.52.48.92,1,.92.03,0,.06,0,.08,0,.55-.05.96-.53.91-1.08,0-.1-.22-2.46-1.98-4.15-1.76-1.69-3.92-1.79-4.01-1.8Z" })), J2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M26,13.96c0-.51-.3-6.73-9.68-11.36-.38-.19-.84-.11-1.15.19-.3.3-.38.77-.19,1.15.07.14,1.63,3.41-.81,5.85l-.9.89c-2.51,2.48-4.33,4.27-6.2,8.94-.32.76-4.84,12.12,8.51,18.28.13.06.28.09.42.09.26,0,.52-.11.72-.3.29-.3.37-.76.18-1.14-.07-.14-1.63-3.41.81-5.85,3.02-3.02,9.29-9.3,8.29-16.75ZM16.29,29.29c-1.9,1.9-2.1,4.11-1.88,5.75-9.4-5.6-5.67-14.24-5.5-14.63,0,0,0-.01,0-.02,0,0,.01-.01.01-.02,1.71-4.28,3.32-5.87,5.75-8.26l.91-.9c1.88-1.88,2.1-4.05,1.89-5.69,6.35,3.89,6.52,8.27,6.52,8.49,0,.02.01.04.01.07,0,.02,0,.05,0,.07.93,6.5-4.91,12.34-7.72,15.15Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M33.99,24.88c-.79-6.35-4.31-8.63-4.46-8.72-.35-.22-.79-.2-1.12.04-.33.24-.48.66-.38,1.05.87,3.47-1.36,9.75-5.63,12.96-3.76,2.82-3.11,6.04-2.23,7.35.1.14.23.26.38.34.32.16.71.23,1.16.23,1.86,0,4.62-1.26,6.7-2.73,4.03-2.85,6.06-6.68,5.58-10.52ZM27.95,33.25c-2.62,2.08-5.29,2.89-6.24,2.89h-.03c-.28-.71-.59-2.45,1.92-4.34,3.71-2.78,6.31-7.75,6.6-12.03.74,1.15,1.5,2.88,1.8,5.35.49,3.89-2.33,6.76-4.06,8.13Z" })), Q2t = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M8.104 12A3.904 3.904 0 0 0 12 15.896 3.904 3.904 0 0 0 15.896 12 3.904 3.904 0 0 0 12 8.104 3.904 3.904 0 0 0 8.104 12Zm1.375 0A2.52 2.52 0 0 1 12 9.48 2.52 2.52 0 0 1 14.52 12 2.52 2.52 0 0 1 12 14.521a2.52 2.52 0 0 1-2.52-2.52Z", clipRule: "evenodd" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M10.753 20.846h2.494v-.01a.69.69 0 0 0 .678-.577l.238-1.503a7.45 7.45 0 0 0 1.082-.45l1.237.9a.697.697 0 0 0 .89-.074l1.76-1.76a.684.684 0 0 0 .073-.89l-.898-1.237a6.56 6.56 0 0 0 .449-1.081l1.512-.239a.69.69 0 0 0 .578-.678v-2.493a.69.69 0 0 0-.578-.679l-1.512-.238a7.465 7.465 0 0 0-.45-1.082l.899-1.237a.695.695 0 0 0-.073-.89l-1.76-1.76a.684.684 0 0 0-.89-.073l-1.237.898a6.56 6.56 0 0 0-1.082-.449l-.238-1.512a.69.69 0 0 0-.678-.578h-2.494a.69.69 0 0 0-.678.578l-.238 1.512a7.45 7.45 0 0 0-1.082.45l-1.238-.899a.695.695 0 0 0-.889.073l-1.76 1.76a.684.684 0 0 0-.073.89l.898 1.237c-.183.348-.33.706-.449 1.082l-1.512.238a.69.69 0 0 0-.578.679v2.493a.69.69 0 0 0 .578.678l1.512.239c.12.375.275.733.45 1.081l-.9 1.238a.695.695 0 0 0 .074.889l1.76 1.76a.684.684 0 0 0 .89.073l1.237-.898c.348.183.706.33 1.082.449l.238 1.512a.69.69 0 0 0 .678.578Zm1.907-1.375h-1.32v.01l-.22-1.367a.688.688 0 0 0-.513-.559 5.71 5.71 0 0 1-1.55-.642.695.695 0 0 0-.76.037l-1.119.807-.935-.935.807-1.118a.679.679 0 0 0 .037-.761c-.294-.477-.505-1-.642-1.55a.688.688 0 0 0-.56-.513l-1.365-.22v-1.32l1.366-.22a.687.687 0 0 0 .559-.513 5.71 5.71 0 0 1 .642-1.55.695.695 0 0 0-.037-.76l-.807-1.119.935-.935 1.119.807a.678.678 0 0 0 .76.037 5.48 5.48 0 0 1 1.55-.642.688.688 0 0 0 .513-.559l.22-1.366h1.32l.22 1.366a.687.687 0 0 0 .513.56 5.71 5.71 0 0 1 1.55.64.69.69 0 0 0 .76-.036l1.119-.807.935.935-.807 1.119a.678.678 0 0 0-.037.76c.294.477.504 1 .642 1.55a.688.688 0 0 0 .56.513l1.365.22v1.32l-1.366.22a.688.688 0 0 0-.56.513 5.708 5.708 0 0 1-.64 1.55.695.695 0 0 0 .036.76l.807 1.119-.935.935-1.119-.807a.68.68 0 0 0-.76-.037c-.477.285-1 .505-1.55.642a.688.688 0 0 0-.513.56l-.22 1.356Z", clipRule: "evenodd" })), tgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M29,18.05v-7.64l1.29,1.29c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-3-3c-.39-.39-1.02-.39-1.41,0l-3,3c-.39.39-.39,1.02,0,1.41s1.02.39,1.41,0l1.29-1.29v7.64c-5.05.5-9,4.77-9,9.95,0,5.51,4.49,10,10,10s10-4.49,10-10c0-5.18-3.95-9.45-9-9.95ZM28,36c-4.41,0-8-3.59-8-8s3.59-8,8-8,8,3.59,8,8-3.59,8-8,8Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M15,25h-2v-3.05c5.05-.5,9-4.77,9-9.95,0-5.51-4.49-10-10-10S2,6.49,2,12c0,5.18,3.95,9.45,9,9.95v3.05h-2c-.55,0-1,.45-1,1s.45,1,1,1h2v3c0,.55.45,1,1,1s1-.45,1-1v-3h2c.55,0,1-.45,1-1s-.45-1-1-1ZM4,12c0-4.41,3.59-8,8-8s8,3.59,8,8-3.59,8-8,8-8-3.59-8-8Z" })), egt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M36,9h-7.07c-.29-2.13-1.54-5-4.93-5-1.99,0-3.25,1-4,2.25-.75-1.25-2.01-2.25-4-2.25-3.38,0-4.63,2.87-4.93,5h-7.07c-.55,0-1,.45-1,1v6c0,.55.45,1,1,1h1v18c0,.55.45,1,1,1h28c.55,0,1-.45,1-1v-18h1c.55,0,1-.45,1-1v-6c0-.55-.45-1-1-1ZM24,6c2.02,0,2.68,1.81,2.9,3h-5.79c.21-1.19.87-3,2.9-3ZM16,6c2.02,0,2.68,1.81,2.9,3h-5.79c.21-1.19.87-3,2.9-3ZM5,11h14v4H5v-4ZM7,17h12v17H7v-17ZM33,34h-12v-17h12v17ZM35,15h-14v-4h14v4Z" })), ngt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M36,29.84v-13.35l1.38-.57c.38-.15.62-.52.62-.92s-.24-.77-.62-.92l-17-7c-.24-.1-.52-.1-.76,0L2.62,14.08c-.38.15-.62.52-.62.92s.24.77.62.92l6.38,2.63v8.45c0,.2.06.39.17.55.24.35,2.54,3.45,10.83,3.45s10.6-3.09,10.83-3.45c.11-.16.17-.36.17-.55v-8.45l3-1.24v12.52l-1.95,5.84c-.1.3-.05.64.14.9.19.26.49.42.81.42h4c.32,0,.62-.15.81-.42.19-.26.24-.6.14-.9l-1.95-5.84ZM20,9.08l14.37,5.92-14.37,5.92-14.37-5.92,14.37-5.92ZM29,26.62c-.62.6-2.96,2.38-9,2.38s-8.4-1.79-9-2.37v-7.25l8.62,3.55c.12.05.25.08.38.08s.26-.03.38-.08l8.62-3.55v7.25ZM34.39,35l.61-1.84.61,1.84h-1.22Z" })), rgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("rect", { y: 4, width: 4, height: 20, rx: 2 }), /* @__PURE__ */ pt.createElement("rect", { x: 16, y: 12, width: 4, height: 12, rx: 2 }), /* @__PURE__ */ pt.createElement("rect", { x: 8, width: 4, height: 24, rx: 2 })), igt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "icon" }, /* @__PURE__ */ pt.createElement("path", { id: "icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M11.5757 2.57576C11.8101 2.34145 12.19 2.34145 12.4243 2.57576L20.2243 10.3758C20.3368 10.4883 20.4 10.6409 20.4 10.8V21C20.4 21.3314 20.1314 21.6 19.8 21.6H4.20001C3.86864 21.6 3.60001 21.3314 3.60001 21V10.8C3.60001 10.6409 3.66322 10.4883 3.77574 10.3758L11.5757 2.57576ZM4.80001 11.0486V20.4H19.2V11.0486L12 3.84855L4.80001 11.0486Z" }))), agt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20,11.05c-5.82,0-8.86,4.27-8.86,8.48,0,3.57,1.13,5.94,3.89,8.09l.6,1.8v4.33c0,.2.06.39.17.55l1.5,2.25c.19.28.5.45.83.45h3.74c.33,0,.65-.17.83-.45l1.5-2.25c.11-.16.17-.36.17-.55v-4.33l.6-1.8c2.76-2.15,3.89-4.52,3.89-8.09,0-4.1-3.56-8.48-8.86-8.48ZM22.37,33.45l-1.03,1.55h-2.67l-1.03-1.55v-4.19c0-.1-.02-.19-.05-.28h4.83c-.03.09-.05.19-.05.28v4.19ZM23.52,26.22c-.16.12-.28.29-.35.48l-.09.28h-6.15l-.09-.28c-.06-.19-.19-.36-.35-.48-2.78-2.09-3.34-4.1-3.34-6.68,0-3.12,2.15-6.48,6.86-6.48,4.04,0,6.86,3.42,6.86,6.48,0,2.58-.56,4.6-3.34,6.68Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M20,9c.55,0,1-.45,1-1V3c0-.55-.45-1-1-1s-1,.45-1,1v5c0,.55.45,1,1,1Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M11.52,11.45c.2.24.48.36.77.36.23,0,.45-.08.64-.23.42-.35.48-.99.12-1.41l-3.21-3.83c-.35-.42-.98-.48-1.41-.12-.42.35-.48.99-.12,1.41l3.21,3.83Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M8.18,18.92c.48,0,.9-.34.98-.83.1-.54-.27-1.06-.81-1.16l-4.92-.87c-.54-.1-1.06.27-1.16.81-.1.54.27,1.06.81,1.16l4.92.87c.06.01.12.02.17.02Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M9.11,25.13l-4.33,2.5c-.48.28-.64.89-.37,1.37.19.32.52.5.87.5.17,0,.34-.04.5-.13l4.33-2.5c.48-.28.64-.89.37-1.37-.28-.48-.89-.64-1.37-.37Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M27.71,11.81c.29,0,.57-.12.77-.36l3.21-3.83c.36-.42.3-1.05-.12-1.41-.42-.36-1.05-.3-1.41.12l-3.21,3.83c-.36.42-.3,1.05.12,1.41.19.16.42.23.64.23Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M36.57,16.06l-4.92.87c-.54.1-.91.61-.81,1.16.08.49.51.83.98.83.06,0,.12,0,.17-.02l4.92-.87c.54-.1.91-.61.81-1.16-.1-.54-.61-.91-1.16-.81Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M35.22,27.63l-4.33-2.5c-.48-.28-1.09-.11-1.37.37-.28.48-.11,1.09.37,1.37l4.33,2.5c.16.09.33.13.5.13.35,0,.68-.18.87-.5.28-.48.11-1.09-.37-1.37Z" })), sgt = (t) => /* @__PURE__ */ pt.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20,4c-8.82,0-16,7.18-16,16s7.18,16,16,16,16-7.18,16-16S28.82,4,20,4ZM20,34c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M20,14c-.55,0-1,.45-1,1v14c0,.55.45,1,1,1s1-.45,1-1v-14c0-.55-.45-1-1-1Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 20, cy: 11, r: 1 })), ogt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M13.25 4.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-.5 14.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0v9.5Z", clipRule: "evenodd" })), lgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm0 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z", clipRule: "evenodd" })), cgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20,3c-7.55,0-11.5,5.53-11.5,11,0,3.97.88,7.31,5.15,10.61l.85,2.55v5.84c0,.2.06.39.17.55l2,3c.19.28.5.45.83.45h5c.33,0,.65-.17.83-.45l2-3c.11-.16.17-.36.17-.55v-5.84l.85-2.55c4.26-3.3,5.15-6.63,5.15-10.61,0-5.31-4.62-11-11.5-11ZM21.96,35h-3.93l-.67-1h5.26l-.67,1ZM23.5,32h-7v-1h7v1ZM16.5,29v-1h7v1h-7ZM17,19h-1c-.81,0-.99-.55-1-.99.01-.46.19-1.01,1-1.01s.99.55,1,1v1ZM21,26h-2v-5h2v5ZM24.9,23.2c-.16.12-.29.29-.35.48l-.77,2.32h-.78v-5h1c2.2,0,3-1.79,3-3s-.8-3-3-3-3,1.79-3,3v1h-2v-1c0-1.21-.8-3-3-3s-3,1.79-3,3,.8,3,3,3h1v5h-.78l-.77-2.32c-.06-.19-.19-.36-.35-.48-3.83-2.87-4.6-5.65-4.6-9.2,0-4.33,2.97-9,9.5-9,5.6,0,9.5,4.74,9.5,9,0,3.55-.77,6.33-4.6,9.2ZM23,19v-.99c.01-.46.19-1.01,1-1.01s.99.55,1,.99c-.01.46-.19,1.01-1,1.01h-1Z" })), ugt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("circle", { cx: 20, cy: 11.996, r: 2, opacity: 0.7, transform: "rotate(90 20 11.996)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 4, cy: 11.996, r: 2, opacity: 0.3, transform: "rotate(90 4 11.996)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 18, cy: 17.996, r: 2, opacity: 0.05, transform: "rotate(90 18 17.996)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 6.004, cy: 17.996, r: 2, opacity: 0.2, transform: "rotate(90 6.004 17.996)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 18, cy: 6, r: 2, opacity: 0.6, transform: "rotate(90 18 6)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 6.004, cy: 6, r: 2, opacity: 0.4, transform: "rotate(90 6.004 6)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 12.004, cy: 20, r: 2, opacity: 0.1, transform: "rotate(90 12.004 20)" }), /* @__PURE__ */ pt.createElement("circle", { cx: 12.004, cy: 4, r: 2, opacity: 0.5, transform: "rotate(90 12.004 4)" })), hgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20,9c-3.31,0-6,2.69-6,6s2.69,6,6,6,6-2.69,6-6-2.69-6-6-6ZM20,19c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M19.99,2c-7.17,0-13,5.83-13,13s11.71,21.98,12.21,22.62c.19.24.48.38.79.38s.6-.14.79-.38c.5-.64,12.21-15.72,12.21-22.62S27.16,2,19.99,2ZM19.99,35.36c-3.68-4.88-11-15.57-11-20.36,0-6.07,4.93-11,11-11s11,4.93,11,11c0,4.78-7.32,15.48-11,20.36Z" })), fgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M6.75 9c0-2.627 2.204-5.25 5.25-5.25 3.086 0 5.25 2.164 5.25 5.25 0 2.527-1.398 5.497-2.889 7.92A37.477 37.477 0 0 1 12 20.307a37.468 37.468 0 0 1-2.361-3.39C8.149 14.5 6.75 11.528 6.75 9.001Zm4.68 12.988L12 21.5l-.57.488a.75.75 0 0 0 1.14 0L12 21.5l.57.488.001-.002.004-.005.015-.017.053-.063a34.169 34.169 0 0 0 .892-1.128 38.949 38.949 0 0 0 2.104-3.067c1.51-2.453 3.111-5.732 3.111-8.706 0-3.914-2.836-6.75-6.75-6.75-3.954 0-6.75 3.377-6.75 6.75 0 2.973 1.602 6.253 3.111 8.706a38.959 38.959 0 0 0 2.799 3.955 21.065 21.065 0 0 0 .25.303l.015.017.004.005v.001h.001ZM12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", clipRule: "evenodd" })), dgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M7.86 9.28h9.394v9.395H6.225V9.28H7.86Zm0-1.225H5.612A.617.617 0 0 0 5 8.667v10.62c0 .335.278.613.613.613h12.253a.617.617 0 0 0 .613-.613V8.667a.617.617 0 0 0-.613-.612h-2.232c.002-.348 0-.89-.014-1.74-.033-2.1-1.78-3.815-3.88-3.815-2.1 0-3.84 1.707-3.88 3.79v1.765Zm6.535 0h-5.31V6.323a2.665 2.665 0 0 1 2.655-2.598 2.668 2.668 0 0 1 2.655 2.615v1.715Z", clipRule: "evenodd" })), ggt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M14.5 8.555H5.613A.617.617 0 0 0 5 9.167v10.62c0 .335.278.613.613.613h12.253a.617.617 0 0 0 .613-.613V9.167a.617.617 0 0 0-.613-.612h-2.14V6.823a2.665 2.665 0 0 1 2.654-2.598 2.668 2.668 0 0 1 2.655 2.615v2.94h1.226v-.625c.005-.067.03-.427 0-2.34C22.228 4.715 20.48 3 18.38 3c-2.1 0-3.84 1.707-3.881 3.79v1.765Zm0 1.225h2.754v9.395H6.225V9.78H14.5Z", clipRule: "evenodd" })), pgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "icon" }, /* @__PURE__ */ pt.createElement("path", { id: "icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M13 20C12.7239 20 12.5 20.2239 12.5 20.5C12.5 20.7761 12.7239 21 13 21H20.5C21.3285 21 22 20.3284 22 19.5V4.5C22 3.67157 21.3285 3 20.5 3L13 3C12.7239 3 12.5 3.22386 12.5 3.5C12.5 3.77614 12.7239 4 13 4L20.5 4C20.7762 4 21 4.22386 21 4.5V19.5C21 19.7761 20.7762 20 20.5 20H13ZM6.74848 16.3292C6.96669 16.5371 7.34575 16.5581 7.59513 16.3763C7.84451 16.1944 7.86978 15.8786 7.65157 15.6707L4.32228 12.5L16.2 12.5C16.5314 12.5 16.8 12.2761 16.8 12C16.8 11.7239 16.5314 11.5 16.2 11.5L4.32228 11.5L7.65157 8.32925C7.86978 8.12143 7.84451 7.80555 7.59513 7.62371C7.34574 7.44187 6.96669 7.46292 6.74848 7.67074L2.54848 11.6707C2.35054 11.8593 2.35054 12.1407 2.54848 12.3292L6.74848 16.3292Z" }))), mgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M21.0021 5.43555H2.99606C2.67206 5.43555 2.41406 5.69955 2.41406 6.01755V18.0235C2.41406 18.3475 2.67806 18.6055 2.99606 18.6055H21.0021C21.3261 18.6055 21.5841 18.3415 21.5841 18.0235V6.01755C21.5841 5.69355 21.3201 5.43555 21.0021 5.43555ZM20.4201 16.6615L14.6301 11.9095L20.4201 7.37355V16.6615ZM11.9961 12.4375L4.42406 6.59955H19.4541L11.9961 12.4375ZM3.57806 7.46355L9.29606 11.8735L3.57806 16.5775V7.46355ZM10.2741 12.6235L11.6361 13.6735C11.7441 13.7575 11.8701 13.7995 12.0021 13.7995C12.1341 13.7995 12.2661 13.7575 12.3741 13.6735L13.6581 12.6655L19.4781 17.4355H4.41806L10.2741 12.6235Z" })), ygt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M19.25 7.5a.75.75 0 0 0 0-1.5H4.75a.75.75 0 0 0 0 1.5h14.5Zm0 3.75a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h14.5Zm0 5.25a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h14.5Z", clipRule: "evenodd" })), bgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "Payment method=Mobilepay, color=Full - purpel" }, /* @__PURE__ */ pt.createElement("g", { id: "Group" }, /* @__PURE__ */ pt.createElement("path", { id: "Vector", d: "M9.85141 21C9.22875 21 8.66734 20.6293 8.42877 20.0605L3.11744 7.38096C2.79249 6.60513 3.165 5.7157 3.94949 5.39426L9.51257 3.11581C9.88928 2.96143 10.3126 2.9614 10.6893 3.11571C11.066 3.27003 11.3653 3.56604 11.5213 3.93862L16.8326 16.6187C17.1571 17.3943 16.7846 18.2832 16.0006 18.6046L10.4375 20.8841C10.2517 20.9605 10.0526 20.9998 9.85141 21ZM10.101 3.81805C10.0078 3.81821 9.91554 3.83656 9.82951 3.87207L4.26616 6.15053C4.09226 6.22176 3.9541 6.3584 3.88209 6.53038C3.81008 6.70236 3.81012 6.89559 3.8822 7.06754L9.19353 19.7479C9.34387 20.1057 9.75867 20.2756 10.1208 20.1279L15.6839 17.8479C15.8578 17.7766 15.996 17.64 16.068 17.468C16.14 17.296 16.14 17.1028 16.0679 16.9308L10.7566 4.25177C10.6466 3.98961 10.388 3.81853 10.101 3.81805Z" }), /* @__PURE__ */ pt.createElement("path", { id: "Vector_2", style: {
  mixBlendMode: "multiply"
}, opacity: 0.5, d: "M11.872 4.77461L11.1072 5.08789L13.2101 10.1085L13.9749 9.79521L11.872 4.77461Z", fill: "url(#paint0_linear_3610_12579)" }), /* @__PURE__ */ pt.createElement("path", { id: "Vector_3", style: {
  mixBlendMode: "multiply"
}, opacity: 0.5, d: "M15.7139 16.0877L16.4788 15.7744L14.0983 10.0913L13.3335 10.4046L15.7139 16.0877Z", fill: "url(#paint1_linear_3610_12579)" }), /* @__PURE__ */ pt.createElement("path", { id: "Vector_4", d: "M14.7481 12.3219C13.1571 12.9743 11.8286 13.8736 10.9589 14.9576L8.71631 9.60164C9.73923 8.42639 11.0413 7.52072 12.5055 6.96594C14.0965 6.31353 15.7039 5.99777 17.0695 6.18175L19.3126 11.5375C17.7489 11.421 16.1804 11.6906 14.7481 12.3219Z" }), /* @__PURE__ */ pt.createElement("g", { id: "Group_2", style: {
  mixBlendMode: "multiply"
}, opacity: 0.25 }, /* @__PURE__ */ pt.createElement("path", { id: "Vector_5", style: {
  mixBlendMode: "multiply"
}, opacity: 0.9, d: "M14.7481 12.3209C13.1571 12.9733 11.8286 13.8726 10.9589 14.9566L8.71631 9.60067C9.73923 8.42541 11.0413 7.51974 12.5055 6.96496C14.0965 6.31256 15.7039 5.99679 17.0695 6.18077L19.3126 11.5365C17.7489 11.42 16.1804 11.6896 14.7481 12.3209Z", fill: "url(#paint2_linear_3610_12579)" }), /* @__PURE__ */ pt.createElement("path", { id: "Vector_6", style: {
  mixBlendMode: "multiply"
}, opacity: 0.7, d: "M14.7481 12.3209C13.1571 12.9733 11.8286 13.8726 10.9589 14.9566L8.71631 9.60067C9.73923 8.42541 11.0413 7.51974 12.5055 6.96496C14.0965 6.31256 15.7039 5.99679 17.0695 6.18077L19.3126 11.5365C17.7489 11.42 16.1804 11.6896 14.7481 12.3209Z", fill: "url(#paint3_linear_3610_12579)" })), /* @__PURE__ */ pt.createElement("path", { id: "Vector_7", d: "M15.4799 13.955C13.7578 13.955 12.1813 14.284 10.9595 14.9558V9.54029C12.3593 8.84177 13.9126 8.49788 15.4799 8.53951C17.2021 8.53951 18.8094 8.85527 20.0001 9.5416V14.9571C18.6006 14.258 17.0473 13.9136 15.4799 13.955Z" }))), /* @__PURE__ */ pt.createElement("defs", null, /* @__PURE__ */ pt.createElement("linearGradient", { id: "paint0_linear_3610_12579", x1: 13.0783, y1: 8.75094, x2: 12.7424, y2: 4.78878, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ pt.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.302, stopColor: "currentColor", stopOpacity: 0.616 }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.608, stopColor: "currentColor", stopOpacity: 0.283 }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.852, stopColor: "currentColor", stopOpacity: 0.076 }), /* @__PURE__ */ pt.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })), /* @__PURE__ */ pt.createElement("linearGradient", { id: "paint1_linear_3610_12579", x1: 14.2968, y1: 11.6078, x2: 14.5074, y2: 16.0469, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ pt.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.302, stopColor: "currentColor", stopOpacity: 0.616 }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.608, stopColor: "currentColor", stopOpacity: 0.283 }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.852, stopColor: "currentColor", stopOpacity: 0.076 }), /* @__PURE__ */ pt.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })), /* @__PURE__ */ pt.createElement("linearGradient", { id: "paint2_linear_3610_12579", x1: 10.1682, y1: 11.9853, x2: 14.3405, y2: 9.10906, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ pt.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.179, stopColor: "currentColor", stopOpacity: 0.872 }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.526, stopColor: "currentColor", stopOpacity: 0.536 }), /* @__PURE__ */ pt.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })), /* @__PURE__ */ pt.createElement("linearGradient", { id: "paint3_linear_3610_12579", x1: 13.7733, y1: 9.21605, x2: 13.5909, y2: 7.74128, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ pt.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ pt.createElement("stop", { offset: 0.643, stopColor: "currentColor", stopOpacity: 0.332 }), /* @__PURE__ */ pt.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })))), vgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M14.8 12.0006C14.8 13.3261 13.7255 14.4006 12.4 14.4006C11.0745 14.4006 10 13.3261 10 12.0006C10 10.6751 11.0745 9.60059 12.4 9.60059C13.7255 9.60059 14.8 10.6751 14.8 12.0006Z" }), /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6011 4.84384C11.6004 4.82959 11.6001 4.81518 11.6001 4.80059V2.40059C11.6001 2.00059 11.9001 1.60059 12.4001 1.60059C12.9001 1.60059 13.2001 1.90059 13.2001 2.40059V4.84412C16.5113 5.20598 19.0536 7.79374 19.447 11.1017C19.4644 11.101 19.482 11.1006 19.5 11.1006H22C22.4 11.1006 22.8 11.4006 22.8 11.9006C22.8 12.4006 22.4 12.7006 22 12.7006H19.5C19.489 12.7006 19.478 12.7004 19.467 12.6999C19.1455 16.0971 16.5046 18.7788 13.2001 19.1554V21.6008C13.1001 22.0008 12.8001 22.4008 12.4001 22.4008C12.0001 22.4008 11.6001 22.1008 11.6001 21.6008V19.1556C8.28383 18.7797 5.5655 16.098 5.23392 12.7006H2.8C2.4 12.7006 2 12.4006 2 11.9006C2 11.4006 2.3 11.1006 2.8 11.1006H5.25473C5.6607 7.79227 8.27826 5.20458 11.6011 4.84384ZM6.69995 12.0008C6.69995 8.80078 9.29995 6.30078 12.4 6.30078C15.5 6.30078 18.1 8.80078 18.1 12.0008C18.1 15.2008 15.6 17.7008 12.4 17.7008C9.19995 17.7008 6.69995 15.2008 6.69995 12.0008Z" })), wgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M34,25c-1.03,0-1.96.4-2.67,1.04l-5.95-3.4c.39-.8.62-1.69.62-2.64,0-1.29-.42-2.49-1.11-3.47l5.36-5.36c.79.52,1.74.83,2.75.83,2.76,0,5-2.24,5-5s-2.24-5-5-5-5,2.24-5,5c0,1.02.31,1.96.83,2.75l-5.36,5.36c-.98-.7-2.18-1.11-3.47-1.11s-2.5.42-3.49,1.13l-5.03-4.19c.32-.58.52-1.23.52-1.93,0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4c.77,0,1.49-.23,2.1-.61l5,4.16c-.69.98-1.1,2.17-1.1,3.45,0,.45.05.89.15,1.31l-3.24,1.62c-.92-1.16-2.32-1.93-3.91-1.93-2.76,0-5,2.24-5,5s2.24,5,5,5,5-2.24,5-5c0-.45-.08-.87-.19-1.29l3.1-1.55c.89,1.43,2.37,2.46,4.09,2.75v4.23c-1.72.45-3,2-3,3.86,0,2.21,1.79,4,4,4s4-1.79,4-4c0-1.86-1.28-3.41-3-3.86v-4.23c1.24-.21,2.35-.79,3.21-1.64l6.02,3.44c-.14.41-.23.83-.23,1.29,0,2.21,1.79,4,4,4s4-1.79,4-4-1.79-4-4-4ZM7,29c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3ZM33,4c1.65,0,3,1.35,3,3s-1.35,3-3,3-3-1.35-3-3,1.35-3,3-3ZM6,9c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2ZM22,34c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM20,24c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4ZM34,31c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z" })), xgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M20.53 4.59a.75.75 0 0 0-1.06-1.06l-2.09 2.09A11.2 11.2 0 0 0 12 4.25c-4.877 0-9.024 3.114-10.7 7.481a.75.75 0 0 0 0 .538 11.811 11.811 0 0 0 4.093 5.338L3.56 19.44a.75.75 0 0 0 1.06 1.06l2.08-2.077A11.2 11.2 0 0 0 12 19.75c4.877 0 9.024-3.114 10.7-7.481a.75.75 0 0 0 0-.538 11.815 11.815 0 0 0-4.023-5.287l1.853-1.853Zm-4.264 2.143A9.709 9.709 0 0 0 12 5.75c-4.115 0-7.66 2.566-9.192 6.25a10.28 10.28 0 0 0 3.662 4.53l1.708-1.709a4.75 4.75 0 0 1 6.643-6.643l1.445-1.445Zm-.393 2.516 1.729-1.73A10.283 10.283 0 0 1 21.192 12c-1.532 3.684-5.077 6.25-9.192 6.25a9.71 9.71 0 0 1-4.185-.944l1.434-1.434a4.75 4.75 0 0 0 6.624-6.624Zm-2.13.008a3.25 3.25 0 0 0-4.487 4.487l4.487-4.487Zm-3.412 5.533 4.459-4.458a3.25 3.25 0 0 1-4.458 4.458Z", clipRule: "evenodd" })), Sgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M28,1.89H12c-2.2,0-4,1.79-4,4v28.01c0,2.2,1.79,4,4,4h16.01c2.2,0,4-1.79,4-4V5.89c0-2.2-1.79-4-4-4ZM12,3.89h16.01c1.1,0,2,.9,2,2v20H10V5.89c0-1.1.9-2,2-2ZM28,35.89H12c-1.1,0-2-.9-2-2v-6h20v6c0,1.1-.9,2-2,2Z" }), /* @__PURE__ */ pt.createElement("ellipse", { cx: 20.01, cy: 31.89, rx: 1.99, ry: 2 })), Cgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M27.89,36h-2.89c-3.94,0-4-5.76-4-6v-1h.25c.41,0,.75-.34.75-.75v-2.51c3.44-.89,6-4.02,6-7.74v-6c.55,0,1-.45,1-1s-.45-1-1-1h-4V3c0-.55-.45-1-1-1s-1,.45-1,1v7h-4V3c0-.55-.45-1-1-1s-1,.45-1,1v7h-4c-.55,0-1,.45-1,1s.45,1,1,1v6c0,3.72,2.56,6.85,6,7.74v2.51c0,.41.34.75.75.75h.25v1c0,2.77,1.25,8,6,8h2.89c.55,0,1-.45,1-1s-.45-1-1-1ZM14,18v-6h12v6c0,3.31-2.69,6-6,6s-6-2.69-6-6Z" })), Agt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "icon" }, /* @__PURE__ */ pt.createElement("path", { id: "icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M2.39999 3.00002C2.39999 2.66865 2.66862 2.40002 2.99999 2.40002H10.2C10.5314 2.40002 10.8 2.66865 10.8 3.00002V10.2C10.8 10.5314 10.5314 10.8 10.2 10.8H2.99999C2.66862 10.8 2.39999 10.5314 2.39999 10.2V3.00002ZM3.59999 3.60002V9.60002H9.59999V3.60002H3.59999ZM13.2 3.00002C13.2 2.66865 13.4686 2.40002 13.8 2.40002H21C21.3314 2.40002 21.6 2.66865 21.6 3.00002V10.2C21.6 10.5314 21.3314 10.8 21 10.8H13.8C13.4686 10.8 13.2 10.5314 13.2 10.2V3.00002ZM14.4 3.60002V9.60002H20.4V3.60002H14.4ZM2.39999 13.8C2.39999 13.4687 2.66862 13.2 2.99999 13.2H10.2C10.5314 13.2 10.8 13.4687 10.8 13.8V21C10.8 21.3314 10.5314 21.6 10.2 21.6H2.99999C2.66862 21.6 2.39999 21.3314 2.39999 21V13.8ZM3.59999 14.4V20.4H9.59999V14.4H3.59999ZM13.2 13.8C13.2 13.4687 13.4686 13.2 13.8 13.2H21C21.3314 13.2 21.6 13.4687 21.6 13.8V21C21.6 21.3314 21.3314 21.6 21 21.6H13.8C13.4686 21.6 13.2 21.3314 13.2 21V13.8ZM14.4 14.4V20.4H20.4V14.4H14.4Z" }))), _gt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "Icon / Profil" }, /* @__PURE__ */ pt.createElement("path", { id: "Vector", d: "M12.06 2.53198C6.79802 2.53198 2.52002 6.80998 2.52002 12.072C3.04202 24.726 21.078 24.726 21.6 12.072C21.6 6.80998 17.322 2.53198 12.06 2.53198ZM12.06 20.412C10.302 20.412 8.67002 19.86 7.32602 18.93C8.37602 14.04 15.756 14.046 16.788 18.936C15.3995 19.8989 13.7497 20.4139 12.06 20.412ZM12 13.8C10.344 13.8 9.00002 12.456 9.00002 10.8C9.13802 6.82798 14.862 6.82798 15 10.8C15 12.456 13.656 13.8 12 13.8ZM17.79 18.114C17.472 17.154 16.536 15.168 14.142 14.406C17.76 12.252 16.266 6.62998 12 6.59998C7.70402 6.62998 6.23402 12.3 9.89402 14.43C7.56002 15.21 6.63602 17.16 6.31802 18.108C0.90002 13.026 4.54802 3.71998 12.06 3.73198C19.572 3.71998 23.22 13.038 17.79 18.114Z" }))), kgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M15.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-.742 4.171a5 5 0 1 0-5.516 0 7.732 7.732 0 0 0-3.639 2.53C4.313 16.303 3.75 18.218 3.75 19.5a.75.75 0 0 0 1.5 0c0-.927.437-2.512 1.522-3.858C7.83 14.327 9.499 13.25 12 13.25s4.17 1.077 5.229 2.392c1.084 1.346 1.521 2.931 1.521 3.858a.75.75 0 0 0 1.5 0c0-1.282-.563-3.197-1.854-4.799a7.732 7.732 0 0 0-3.638-2.53Z", clipRule: "evenodd" })), Ogt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M9.743 8.394c-.06-.416.033-1.111.392-1.682.332-.529.893-.962 1.865-.962.706 0 1.258.227 1.63.587.368.356.62.902.62 1.663 0 .894-.505 1.445-1.257 2.135l-.123.112c-.326.296-.703.64-.997 1.024-.35.457-.623 1.02-.623 1.729v1a.75.75 0 0 0 1.5 0v-1c0-.29.102-.54.314-.817.207-.27.478-.518.82-.83l.123-.113c.747-.685 1.743-1.634 1.743-3.24 0-1.111-.379-2.065-1.076-2.74-.694-.673-1.642-1.01-2.674-1.01-1.528 0-2.55.733-3.135 1.663-.557.887-.715 1.943-.607 2.693a.75.75 0 1 0 1.485-.212ZM13.25 18.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z", clipRule: "evenodd" })), Tgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M37.22,26.95l-4.93-8.54c-.28-.48-.89-.64-1.37-.37-.48.28-.64.89-.37,1.37l4.95,8.57c.56.97.64,2.18.1,3.16-.64,1.16-1.88,1.86-3.31,1.86h-8.89l1.29-1.29c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-3,3c-.39.39-.39,1.02,0,1.41l3,3c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-1.29-1.29h8.89c2.44,0,4.64-1.46,5.42-3.71.5-1.44.26-3.03-.5-4.34Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M23.08,5.93l4.44,7.7-1.77-.47c-.53-.14-1.08.17-1.22.71-.14.53.17,1.08.71,1.22l4.1,1.1c.09.02.17.03.26.03.44,0,.84-.29.96-.74l1.1-4.1c.14-.53-.17-1.08-.71-1.22-.53-.14-1.08.17-1.22.71l-.47,1.77-4.44-7.7c-1.22-2.11-3.58-3.29-5.92-2.84-1.49.28-2.75,1.29-3.51,2.61l-4.93,8.54c-.28.48-.11,1.09.37,1.37.48.28,1.09.11,1.37-.37l4.95-8.57c.56-.97,1.57-1.65,2.69-1.67,1.33-.03,2.55.7,3.27,1.93Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M17.18,33H7.28c-1.12,0-2.21-.53-2.79-1.49-.69-1.14-.67-2.56.04-3.79l4.44-7.7.47,1.77c.12.45.52.74.96.74.09,0,.17-.01.26-.03.53-.14.85-.69.71-1.22l-1.1-4.1c-.14-.53-.69-.85-1.22-.71l-4.1,1.1c-.53.14-.85.69-.71,1.22.12.45.52.74.96.74.09,0,.17-.01.26-.03l1.77-.47-4.44,7.7c-1.22,2.11-1.06,4.75.5,6.55.99,1.15,2.49,1.74,4.01,1.74h9.86c.55,0,1-.45,1-1,0-.55-.45-1-1-1Z" })), Mgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20.4031 12.0003H3.60312C2.27712 12.0003 1.20312 13.0743 1.20312 14.4003V18.0003C1.20312 19.3263 2.27712 20.4003 3.60312 20.4003H20.4031C21.7291 20.4003 22.8031 19.3263 22.8031 18.0003V14.4003C22.8031 13.0743 21.7291 12.0003 20.4031 12.0003ZM21.6031 18.0003C21.6031 18.6603 21.0631 19.2003 20.4031 19.2003H3.60312C2.94312 19.2003 2.40312 18.6603 2.40312 18.0003V14.4003C2.40312 13.7403 2.94312 13.2003 3.60312 13.2003H20.4031C21.0631 13.2003 21.6031 13.7403 21.6031 14.4003V18.0003ZM9.04512 8.64631C8.46912 9.17431 9.25512 10.0563 9.84312 9.54031C9.85512 9.53431 10.7491 8.75431 12.0031 8.75431C13.2571 8.75431 14.1511 9.52831 14.1571 9.53431C14.2154 9.5871 14.2836 9.62789 14.3576 9.65435C14.4317 9.68081 14.5103 9.69242 14.5888 9.68852C14.6674 9.68462 14.7444 9.66529 14.8155 9.63162C14.8866 9.59796 14.9503 9.55062 15.0031 9.49231C15.0559 9.43401 15.0967 9.36587 15.1232 9.2918C15.1496 9.21773 15.1612 9.13917 15.1573 9.06061C15.1534 8.98206 15.1341 8.90503 15.1004 8.83395C15.0668 8.76286 15.0194 8.6991 14.9611 8.64631C14.9131 8.60431 13.7311 7.55431 12.0031 7.55431C10.2751 7.55431 9.09312 8.60431 9.03912 8.64631H9.04512ZM15.7231 7.42831C16.2811 7.45231 16.5511 6.65431 16.0711 6.34231C15.9991 6.28831 14.2531 5.07031 11.8771 5.07031C9.50113 5.07031 7.95312 6.31831 7.89312 6.37231C7.64112 6.58231 7.60512 6.96031 7.81512 7.21231C8.02513 7.46431 8.40312 7.50031 8.66112 7.29031C8.67312 7.27831 9.93313 6.26431 11.8771 6.26431C14.3191 6.32431 15.0991 7.35631 15.7231 7.42831Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M6.96869 5.21375C6.96869 5.21375 8.88269 3.71375 11.8287 3.71375C14.7747 3.71375 17.0547 5.22575 17.0787 5.24375C17.7327 5.67575 18.4047 4.71575 17.7567 4.25375C14.5947 2.12375 9.42869 1.80575 6.21269 4.28375C5.60669 4.77575 6.35069 5.70575 6.96269 5.21975L6.96869 5.21375ZM14.4027 15.5997C13.6167 15.6117 13.6167 16.7877 14.4027 16.7997C15.1887 16.7877 15.1887 15.6117 14.4027 15.5997ZM16.8027 15.5997C16.0167 15.6117 16.0167 16.7877 16.8027 16.7997C17.5887 16.7877 17.5887 15.6117 16.8027 15.5997ZM19.2027 15.5997C18.4167 15.6117 18.4167 16.7877 19.2027 16.7997C19.9887 16.7877 19.9887 15.6117 19.2027 15.5997ZM8.40269 15.5997H4.80269C4.01669 15.6117 4.01069 16.7877 4.80269 16.7997H8.40269C9.18869 16.7877 9.19469 15.6117 8.40269 15.5997Z" })), Egt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M10.5 3.5a7 7 0 0 1 5.479 11.357l3.501 3.502a.75.75 0 1 1-1.06 1.06l-3.495-3.494A7 7 0 1 1 10.5 3.5Zm0 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z", clipRule: "evenodd" })), Pgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M21 6.25409C21 5.90811 20.6834 5.61246 20.3352 5.63133C20.2909 5.63133 16.3338 5.7886 12.4717 2.17156C12.3523 2.06306 12.1966 2.00253 12.0348 2.00172C11.8512 1.98913 11.6676 2.04575 11.5346 2.17156C7.6662 5.7886 3.70911 5.63133 3.67112 5.63133C3.31024 5.59988 3 5.90811 3 6.25409C3.49384 27.2706 20.5188 27.2266 21 6.25409ZM12.0032 20.8732C5.20964 19.8101 4.38656 9.51257 4.28526 6.87685C5.64017 6.78878 8.79951 6.26038 12.0032 3.45482C15.2068 6.26038 18.3662 6.78878 19.7211 6.87685C19.6198 9.51257 18.7967 19.8101 12.0032 20.8732Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M10.5786 10.4436C10.5786 10.8524 10.7559 11.2173 11.0408 11.4752L10.0531 14.7463C9.97081 15.0105 10.1734 15.281 10.452 15.281H13.529C13.8076 15.281 14.0102 15.0105 13.9279 14.7463L12.9402 11.4752C13.7316 10.8273 13.4467 9.34273 12.383 9.09111C11.4333 8.83949 10.5786 9.53773 10.5786 10.4436Z" })), Igt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M20 12a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1 0-1.5h14.5A.75.75 0 0 1 20 12Z" })), Fgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M18.97 5.47a.75.75 0 0 1 1.06 0l2 2a.747.747 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H17.5c-1.562 0-2.082.02-2.622.335-.284.166-.602.434-1.054.909-.364.383-.791.872-1.339 1.51.45.537.826 1.01 1.15 1.417l.232.29c.473.592.814 1 1.14 1.299.309.283.59.454.938.564.364.115.84.176 1.555.176h2.19l-.72-.72a.75.75 0 1 1 1.06-1.06l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H17.5c-.785 0-1.434-.064-2.008-.246a3.891 3.891 0 0 1-1.499-.889c-.424-.389-.833-.887-1.297-1.467a137.25 137.25 0 0 1-.236-.296c-.283-.354-.597-.748-.96-1.187-.363.44-.677.832-.96 1.187v.002l-.236.294c-.464.58-.873 1.079-1.297 1.467a3.91 3.91 0 0 1-1.5.89c-.573.18-1.222.245-2.007.245h-3a.75.75 0 0 1 0-1.5h3c.715 0 1.19-.06 1.555-.176.347-.11.63-.281.938-.564.326-.3.667-.707 1.14-1.299l.231-.29c.325-.408.702-.88 1.15-1.418a41.96 41.96 0 0 0-1.338-1.51c-.452-.474-.77-.742-1.054-.908-.54-.314-1.06-.335-2.622-.335h-3a.75.75 0 1 1 0-1.5h3.148c1.358 0 2.303-.001 3.23.54.466.271.898.66 1.384 1.17.354.371.757.83 1.238 1.389a38.79 38.79 0 0 1 1.238-1.39c.486-.51.918-.898 1.384-1.17.927-.54 1.872-.54 3.23-.54l.148.001h2.19l-.72-.72a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })), Rgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M34,4h-4c-.55,0-1,.45-1,1v30c0,.55.45,1,1,1h4c.55,0,1-.45,1-1V5c0-.55-.45-1-1-1ZM33,34h-2V6h2v28Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M26,11.3h-4c-.55,0-1,.45-1,1v22.7c0,.55.45,1,1,1h4c.55,0,1-.45,1-1V12.3c0-.55-.45-1-1-1ZM25,34h-2V13.3h2v20.7Z" }), /* @__PURE__ */ pt.createElement("rect", { x: 13, y: 19.41, width: 6.04, height: 16.59, rx: 1, ry: 1 }), /* @__PURE__ */ pt.createElement("rect", { x: 5, y: 25.43, width: 6, height: 10.57, rx: 1, ry: 1 })), Dgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "icon" }, /* @__PURE__ */ pt.createElement("path", { id: "icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M4.8 1.80001C4.8 1.46864 5.06863 1.20001 5.4 1.20001H12.6C12.7591 1.20001 12.9117 1.26323 13.0243 1.37575L19.0243 7.37575C19.1368 7.48827 19.2 7.64088 19.2 7.80001V22.2C19.2 22.5314 18.9314 22.8 18.6 22.8H5.4C5.06863 22.8 4.8 22.5314 4.8 22.2V1.80001ZM6 2.40001V21.6H18V8.04854L12.3515 2.40001H6ZM8.4 12.6C8.4 12.2686 8.66863 12 9 12H15C15.3314 12 15.6 12.2686 15.6 12.6V18.6C15.6 18.9314 15.3314 19.2 15 19.2H9C8.66863 19.2 8.4 18.9314 8.4 18.6V12.6ZM9.6 13.2V15H11.4V13.2H9.6ZM12.6 13.2V18H14.4V13.2H12.6ZM11.4 18V16.2H9.6V18H11.4Z" }))), $gt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "#5f6368", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M336.16-453.85v-291.23L222.77-631.69 180-673.85 366.15-860l186.16 186.15-42.77 42.16-113.39-113.39v291.23h-59.99ZM593.46-100 407.31-286.15l42.77-42.16 113.38 113.39v-291.23h60v291.23l113.39-113.39 42.76 42.16L593.46-100Z" })), Lgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { className: "cls-1", fill: "none", d: "M27.41,12.24c-.29-1.08-.72-2.72-3.01-4.44-.24-.18-.46-.32-.66-.43l-.76,3.82c-.09.48-.51.8-.98.8-.07,0-.13,0-.2-.02-.54-.11-.89-.64-.78-1.18l.92-4.58c-.26-.09-.81-.22-1.94-.22s-1.68.13-1.94.22l.92,4.58c.11.54-.24,1.07-.78,1.18-.07.01-.13.02-.2.02-.47,0-.88-.33-.98-.8l-.76-3.82c-.2.11-.42.25-.66.43-2.29,1.72-2.72,3.35-3.01,4.44-.18.69-.46,1.73-1.54,1.76-.05.2-.05.6-.05.9.02.05.05.12.07.14l16.93-.03c.3,0,.77,0,1-.05v-.12c0-.24,0-.62-.03-.82-1.1-.02-1.38-1.07-1.56-1.76Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M23.7,24c2.49-1.4,4.3-4.1,4.3-6.98h-2c0,3.13-2.86,5.98-6,5.98s-6-2.85-6-5.98h-2c0,2.88,1.81,5.58,4.3,6.98-3.2,1.1-7.3,3.89-7.3,11,0,.55.45,1,1,1s1-.45,1-1c0-7.73,5.65-9.31,8-9.63v9.63c0,.55.45,1,1,1s1-.45,1-1v-9.63c2.35.32,8,1.9,8,9.63,0,.55.45,1,1,1s1-.45,1-1c0-7.11-4.11-9.91-7.3-11Z" }), /* @__PURE__ */ pt.createElement("path", { className: "cls-2", d: "M30.39,12.53c-.19-.19-.5-.41-.97-.49-.03-.1-.06-.21-.08-.31-.31-1.19-.9-3.39-3.74-5.53-.74-.55-1.39-.85-1.83-1.01-.03-.05-.07-.1-.11-.15-.57-.71-1.73-1.04-3.66-1.04s-3.09.33-3.66,1.04c-.04.05-.08.1-.11.15-.44.16-1.09.46-1.83,1.01-2.85,2.13-3.43,4.34-3.74,5.53-.03.1-.05.21-.08.31-1.58.27-1.58,2.07-1.58,2.97,0,.05,0,.1.01.14.13.89.81,1.86,1.99,1.86h17c.97,0,3,0,3-2v-.17c0-.79,0-1.68-.61-2.3ZM29,14.82v.12c-.23.05-.7.05-1,.05l-16.93.03s-.05-.09-.07-.14c0-.3,0-.69.05-.9,1.08-.03,1.36-1.07,1.54-1.76.29-1.08.72-2.72,3.01-4.44.24-.18.46-.32.66-.43l.76,3.82c.09.48.51.8.98.8.06,0,.13,0,.2-.02.54-.11.89-.64.78-1.18l-.92-4.58c.26-.09.81-.22,1.94-.22s1.68.13,1.94.22l-.92,4.58c-.11.54.24,1.07.78,1.18.07.01.13.02.2.02.47,0,.88-.33.98-.8l.76-3.82c.2.11.42.25.66.43,2.29,1.72,2.72,3.35,3.01,4.44.18.69.46,1.74,1.56,1.76.04.2.04.58.03.82Z" })), Ngt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M17,17c-2.64,0-4.44,1.6-4.52,1.67-.41.37-.44,1-.08,1.41.36.41,1,.45,1.41.08.01-.01,1.33-1.16,3.18-1.16s3.17,1.14,3.18,1.15c.19.17.43.26.67.26.27,0,.54-.11.74-.33.37-.41.34-1.04-.07-1.41-.08-.07-1.88-1.67-4.52-1.67Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M16.82,13c-3.64,0-5.96,1.9-6.06,1.98-.42.35-.48.98-.13,1.4.35.42.98.48,1.41.13.02-.02,1.89-1.52,4.78-1.52s5.18,1.55,5.2,1.56c.18.12.38.19.58.19.31,0,.62-.15.82-.42.32-.45.22-1.07-.23-1.39-.11-.08-2.76-1.93-6.36-1.93Z" }), /* @__PURE__ */ pt.createElement("circle", { cx: 17, cy: 23, r: 2 }), /* @__PURE__ */ pt.createElement("path", { d: "M37.8,18.4l-3-4c-.19-.25-.49-.4-.8-.4h-3v-5c0-.55-.45-1-1-1H3c-.55,0-1,.45-1,1v20c0,.55.45,1,1,1h3.14c.45,1.72,2,3,3.86,3s3.41-1.28,3.86-3h11.28c.45,1.72,2,3,3.86,3s3.41-1.28,3.86-3h4.14c.55,0,1-.45,1-1v-10c0-.22-.07-.43-.2-.6ZM11.72,30c-.35.59-.98,1-1.72,1s-1.37-.41-1.72-1c-.17-.3-.28-.63-.28-1s.11-.7.28-1c.35-.59.98-1,1.72-1s1.37.41,1.72,1c.17.3.28.63.28,1s-.11.7-.28,1ZM25.14,28h-11.28c-.45-1.72-2-3-3.86-3s-3.41,1.28-3.86,3h-2.14V10h25v15c-1.86,0-3.41,1.28-3.86,3ZM30.72,30c-.35.59-.98,1-1.72,1s-1.37-.41-1.72-1c-.17-.3-.28-.63-.28-1s.11-.7.28-1c.35-.59.98-1,1.72-1,1.1,0,2,.9,2,2,0,.37-.11.7-.28,1ZM36,28h-3.14c-.27-1.04-.95-1.91-1.86-2.44v-9.56h2.5l2.5,3.33v8.67Z" })), Bgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M35 6H5c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1h14v4h-5c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-5v-4h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1m-1 20H6V8h28z" })), jgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "#5f6368", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M480-134.62 313.08-301.54l43.38-43.38L480-221.38l123.54-123.54 43.38 43.38L480-134.62Zm-123.54-478L313.08-656 480-822.92 646.92-656l-43.38 43.38L480-736.16 356.46-612.62Z" })), Ugt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M5.2 8.06537C4.9 7.76577 4.9 7.26643 5.2 6.96682L11.2 0.974704C11.5 0.675099 12 0.675099 12.3 0.974704L18.3 6.96682C18.6 7.26643 18.6 7.76577 18.3 8.06537C18 8.36498 17.5 8.36498 17.2 8.06537L12.5 3.37155V16.5542C12.5 16.9537 12.2 17.3532 11.7 17.3532C11.2 17.3532 10.9 17.0535 10.9 16.5542V3.37155L6.2 8.06537C5.9 8.36498 5.4 8.36498 5.1 8.06537H5.2ZM19.2 19.75C19.6 19.75 20 19.4504 20 18.9511C20 18.4517 19.7 18.1521 19.2 18.1521H4.8C4.4 18.1521 4 18.4517 4 18.9511C4 19.4504 4.3 19.75 4.8 19.75H19.3H19.2Z" })), Hgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M15.77,23.97c.53.13,1.07-.21,1.2-.74.05-.22.6-2.17,3-2.17s3,1.96,3.06,2.18c.11.46.52.76.97.76.08,0,.16,0,.24-.03.54-.13.86-.67.73-1.21-.24-.98-1.14-2.6-2.98-3.33,1.17-.7,1.97-1.97,1.97-3.43,0-2.21-1.79-4-3.99-4s-3.99,1.79-3.99,4c0,1.46.8,2.73,1.97,3.43-1.83.73-2.7,2.37-2.93,3.35-.12.54.21,1.06.75,1.19ZM19.97,14c1.1,0,1.99.9,1.99,2s-.89,2-1.99,2-1.99-.9-1.99-2,.89-2,1.99-2Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M35,7H5c-.55,0-1,.45-1,1v19.94c0,.55.45,1,1,1h14v3.06h-5c-.55,0-1,.45-1,1s.45,1,1,1h12c.55,0,1-.45,1-1s-.45-1-1-1h-5v-3.06h14c.55,0,1-.45,1-1V8c0-.55-.45-1-1-1ZM34,26.94H6V9h28v17.94Z" })), Vgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M12 4.25c-4.877 0-9.024 3.114-10.7 7.481a.75.75 0 0 0 0 .538C2.976 16.636 7.123 19.75 12 19.75c4.877 0 9.024-3.114 10.7-7.481a.75.75 0 0 0 0-.538C21.024 7.364 16.877 4.25 12 4.25Zm0 14c-4.115 0-7.66-2.566-9.192-6.25C4.34 8.316 7.885 5.75 12 5.75s7.66 2.566 9.192 6.25c-1.532 3.684-5.077 6.25-9.192 6.25ZM8.75 12a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM12 7.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Z", clipRule: "evenodd" })), zgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { id: "icon" }, /* @__PURE__ */ pt.createElement("path", { id: "icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M2.40001 5.99998C2.40001 5.33723 2.93727 4.79998 3.60001 4.79998H19.2V7.19998H3.60001C2.93727 7.19998 2.40001 6.66272 2.40001 5.99998ZM20.4 4.19998V7.19998H22.2C22.5314 7.19998 22.8 7.4686 22.8 7.79998V19.8C22.8 20.1313 22.5314 20.4 22.2 20.4H4.20001C2.54316 20.4 1.20001 19.0568 1.20001 17.4V5.99998C1.20001 4.67449 2.27453 3.59998 3.60001 3.59998H19.8C20.1314 3.59998 20.4 3.8686 20.4 4.19998ZM2.40001 17.4V8.0789C2.75302 8.2831 3.16287 8.39998 3.60001 8.39998H21.6V10.8H18.6C16.9432 10.8 15.6 12.1431 15.6 13.8C15.6 15.4568 16.9432 16.8 18.6 16.8H21.6V19.2H4.20001C3.2059 19.2 2.40001 18.3941 2.40001 17.4ZM18.6 12H21.6V15.6H18.6C17.6059 15.6 16.8 14.7941 16.8 13.8C16.8 12.8059 17.6059 12 18.6 12ZM18.6 14.4C18.9314 14.4 19.2 14.1313 19.2 13.8C19.2 13.4686 18.9314 13.2 18.6 13.2C18.2686 13.2 18 13.4686 18 13.8C18 14.1313 18.2686 14.4 18.6 14.4Z" }))), Xgt = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { d: "M21.7804 8.5025C16.3718 4.16657 7.6916 3.49951 2.17983 8.53175C1.64699 9.05838 2.41474 9.90685 2.9705 9.38021C3.00488 9.34511 6.40819 6.12681 11.6908 6.12681C16.9734 6.12681 21.0241 9.38021 21.0642 9.40947C21.6486 9.88344 22.3648 8.99402 21.7862 8.49665L21.7804 8.5025Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M11.7767 8.36206C7.59993 8.36206 4.98155 10.8548 4.87269 10.9601C4.33412 11.4867 5.11333 12.3352 5.66336 11.8086C9.38753 8.52005 14.8707 9.1052 18.3714 11.8378C18.9615 12.3059 19.672 11.4224 19.0933 10.925C18.9672 10.8197 15.9363 8.35621 11.7825 8.35621L11.7767 8.36206Z" }), /* @__PURE__ */ pt.createElement("path", { d: "M11.8627 11.7618C9.26721 11.7618 7.62858 13.3182 7.55982 13.3885C7.02125 13.9151 7.80046 14.7577 8.34476 14.2369C10.4418 12.3469 13.7133 12.7097 15.6671 14.2662C16.2572 14.7401 16.9676 13.8507 16.389 13.3592C16.3088 13.2948 14.4295 11.7676 11.8569 11.7676L11.8627 11.7618ZM11.9944 14.904C9.34169 14.9918 9.34742 18.9122 11.9944 19C14.6472 18.9122 14.6415 14.9918 11.9944 14.904ZM11.9944 17.8297C10.8657 17.8063 10.8657 16.0918 11.9944 16.0743C13.1232 16.0977 13.1232 17.8122 11.9944 17.8297Z" })), qgt = (t) => /* @__PURE__ */ pt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ pt.createElement("path", { fillRule: "evenodd", d: "M20 10.5a7 7 0 0 1-11.357 5.479L5.14 19.48a.75.75 0 1 1-1.06-1.06l3.494-3.495A7 7 0 1 1 20 10.5Zm-1.5 0a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-6.25-2.75a.75.75 0 0 1 1.5 0v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2Z", clipRule: "evenodd" })), Wgt = {
  add: c2t,
  alert: h2t,
  "alert-circle": u2t,
  "arrow-down": f2t,
  "arrow-left": d2t,
  "arrow-right": g2t,
  "arrow-up": p2t,
  betalingsservice: v2t,
  basket: m2t,
  battery: y2t,
  beacon: b2t,
  bin: w2t,
  calendar: x2t,
  call: S2t,
  camera: C2t,
  card: A2t,
  chat: k2t,
  "chatbot-ai": O2t,
  "chat-forum": _2t,
  check: M2t,
  "check-bold": T2t,
  "checkmark-outlined": E2t,
  "chevron-down": P2t,
  "chevron-left": I2t,
  "chevron-right": F2t,
  "chevron-up": R2t,
  clock: D2t,
  close: $2t,
  "credit-card": L2t,
  "customer-service": N2t,
  datacenter: B2t,
  "directional-arrow": j2t,
  document: U2t,
  download: H2t,
  edit: z2t,
  el: X2t,
  email: q2t,
  "e-mobility": V2t,
  "external-link": W2t,
  filter: Y2t,
  "favorites-star": G2t,
  "fiber-cable": K2t,
  "five-g": Z2t,
  gas: J2t,
  gear: Q2t,
  genders: tgt,
  gift: egt,
  "graduation-cap": ngt,
  home: igt,
  "idea-lightbulb": agt,
  info: ogt,
  "info-circle": sgt,
  kebab: lgt,
  lightbulb: cgt,
  loading: ugt,
  location: fgt,
  "location-pin": hgt,
  "lock-closed": dgt,
  "lock-open": ggt,
  logout: pgt,
  mail: mgt,
  menu: ygt,
  "mobile-pay": bgt,
  "my-location": vgt,
  "network-hub": wgt,
  "not-visible": xgt,
  phone: Sgt,
  "power-plug": Cgt,
  products: Agt,
  profile: kgt,
  "profile-alternate": _gt,
  question: Ogt,
  recycle: Tgt,
  router: Mgt,
  search: Egt,
  security: Pgt,
  "semi-check": Igt,
  shuffle: Fgt,
  "signal-medium": Rgt,
  simcard: Dgt,
  "swap-vert": $gt,
  technician: Lgt,
  "truck-connected": Ngt,
  tv: Bgt,
  "unfold-more": jgt,
  upload: Ugt,
  "video-call": Hgt,
  visible: Vgt,
  wallet: zgt,
  wifi: Xgt,
  zoom: qgt,
  graph: rgt
}, Ggt = "_icon_13804_1", Kgt = {
  icon: Ggt
}, Lm = { small: 16, medium: 24, large: 32 }, hr = kn(
  ({ iconName: t, size: e = "medium", ...r }, i) => {
    const s = Wgt[t], c = en(() => {
      switch (e) {
        case "small":
          return Lm.small;
        case "medium":
          return Lm.medium;
        case "large":
          return Lm.large;
        default:
          return e;
      }
    }, [e]);
    return /* @__PURE__ */ $t(
      s,
      {
        ref: i,
        "aria-label": t,
        role: "img",
        ...r,
        height: c,
        width: c,
        className: [Kgt.icon, { ...r }.className].join(" ")
      }
    );
  }
);
var sM = { exports: {} };
(function(t, e) {
  (function(i, s) {
    t.exports = i.pdfjsWorker = s();
  })(globalThis, () => (() => {
    var r = [, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.WorkerTask = l.WorkerMessageHandler = void 0;
      var o = f(2), g = f(3), p = f(4), n = f(6), a = f(10), d = f(68), m = f(73), b = f(104), w = f(105), v = f(72);
      class h {
        constructor(M) {
          this.name = M, this.terminated = !1, this._capability = new o.PromiseCapability();
        }
        get finished() {
          return this._capability.promise;
        }
        finish() {
          this._capability.resolve();
        }
        terminate() {
          this.terminated = !0;
        }
        ensureNotTerminated() {
          if (this.terminated) throw new Error("Worker task was terminated");
        }
      }
      l.WorkerTask = h;
      class x {
        static setup(M, O) {
          let E = !1;
          M.on("test", function(I) {
            E || (E = !0, M.send("test", I instanceof Uint8Array));
          }), M.on("configure", function(I) {
            (0, o.setVerbosityLevel)(I.verbosity);
          }), M.on("GetDocRequest", function(I) {
            return x.createDocumentHandler(I, O);
          });
        }
        static createDocumentHandler(M, O) {
          let E, I = !1, R = null;
          const W = /* @__PURE__ */ new Set(), z = (0, o.getVerbosityLevel)(), { docId: j, apiVersion: $ } = M, B = "3.11.174";
          if ($ !== B) throw new Error(`The API version "${$}" does not match the Worker version "${B}".`);
          const C = [];
          for (const L in []) C.push(L);
          if (C.length) throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + C.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
          const T = j + "_worker";
          let F = new b.MessageHandler(T, j, O);
          function S() {
            if (I) throw new Error("Worker was terminated");
          }
          function A(L) {
            W.add(L);
          }
          function U(L) {
            L.finish(), W.delete(L);
          }
          async function K(L) {
            await E.ensureDoc("checkHeader"), await E.ensureDoc("parseStartXRef"), await E.ensureDoc("parse", [L]), await E.ensureDoc("checkFirstPage", [L]), await E.ensureDoc("checkLastPage", [L]);
            const H = await E.ensureDoc("isPureXfa");
            if (H) {
              const V = new h("loadXfaFonts");
              A(V), await Promise.all([E.loadXfaFonts(F, V).catch((Y) => {
              }).then(() => U(V)), E.loadXfaImages()]);
            }
            const [Q, N] = await Promise.all([E.ensureDoc("numPages"), E.ensureDoc("fingerprints")]);
            return { numPages: Q, fingerprints: N, htmlForXfa: H ? await E.ensureDoc("htmlForXfa") : null };
          }
          function X({ data: L, password: H, disableAutoFetch: Q, rangeChunkSize: N, length: V, docBaseUrl: Y, enableXfa: Z, evaluatorOptions: rt }) {
            const st = { source: null, disableAutoFetch: Q, docBaseUrl: Y, docId: j, enableXfa: Z, evaluatorOptions: rt, handler: F, length: V, password: H, rangeChunkSize: N }, mt = new o.PromiseCapability();
            let yt;
            if (L) {
              try {
                st.source = L, yt = new n.LocalPdfManager(st), mt.resolve(yt);
              } catch (G) {
                mt.reject(G);
              }
              return mt.promise;
            }
            let at, nt = [];
            try {
              at = new w.PDFWorkerStream(F);
            } catch (G) {
              return mt.reject(G), mt.promise;
            }
            const q = at.getFullReader();
            q.headersReady.then(function() {
              if (q.isRangeSupported) {
                st.source = at, st.length = q.contentLength, st.disableAutoFetch || (st.disableAutoFetch = q.isStreamingSupported), yt = new n.NetworkPdfManager(st);
                for (const G of nt) yt.sendProgressiveData(G);
                nt = [], mt.resolve(yt), R = null;
              }
            }).catch(function(G) {
              mt.reject(G), R = null;
            });
            let D = 0;
            return new Promise(function(G, et) {
              const J = function({ value: it, done: lt }) {
                try {
                  if (S(), lt) {
                    yt || function() {
                      const ot = (0, g.arrayBuffersToBytes)(nt);
                      V && ot.length !== V && (0, o.warn)("reported HTTP length is different from actual");
                      try {
                        st.source = ot, yt = new n.LocalPdfManager(st), mt.resolve(yt);
                      } catch (ut) {
                        mt.reject(ut);
                      }
                      nt = [];
                    }(), R = null;
                    return;
                  }
                  D += it.byteLength, q.isStreamingSupported || F.send("DocProgress", { loaded: D, total: Math.max(D, q.contentLength || 0) }), yt ? yt.sendProgressiveData(it) : nt.push(it), q.read().then(J, et);
                } catch (ot) {
                  et(ot);
                }
              };
              q.read().then(J, et);
            }).catch(function(G) {
              mt.reject(G), R = null;
            }), R = function(G) {
              at.cancelAllRequests(G);
            }, mt.promise;
          }
          return F.on("GetPage", function(L) {
            return E.getPage(L.pageIndex).then(function(H) {
              return Promise.all([E.ensure(H, "rotate"), E.ensure(H, "ref"), E.ensure(H, "userUnit"), E.ensure(H, "view")]).then(function([Q, N, V, Y]) {
                return { rotate: Q, ref: N, userUnit: V, view: Y };
              });
            });
          }), F.on("GetPageIndex", function(L) {
            const H = p.Ref.get(L.num, L.gen);
            return E.ensureCatalog("getPageIndex", [H]);
          }), F.on("GetDestinations", function(L) {
            return E.ensureCatalog("destinations");
          }), F.on("GetDestination", function(L) {
            return E.ensureCatalog("getDestination", [L.id]);
          }), F.on("GetPageLabels", function(L) {
            return E.ensureCatalog("pageLabels");
          }), F.on("GetPageLayout", function(L) {
            return E.ensureCatalog("pageLayout");
          }), F.on("GetPageMode", function(L) {
            return E.ensureCatalog("pageMode");
          }), F.on("GetViewerPreferences", function(L) {
            return E.ensureCatalog("viewerPreferences");
          }), F.on("GetOpenAction", function(L) {
            return E.ensureCatalog("openAction");
          }), F.on("GetAttachments", function(L) {
            return E.ensureCatalog("attachments");
          }), F.on("GetDocJSActions", function(L) {
            return E.ensureCatalog("jsActions");
          }), F.on("GetPageJSActions", function({ pageIndex: L }) {
            return E.getPage(L).then(function(H) {
              return E.ensure(H, "jsActions");
            });
          }), F.on("GetOutline", function(L) {
            return E.ensureCatalog("documentOutline");
          }), F.on("GetOptionalContentConfig", function(L) {
            return E.ensureCatalog("optionalContentConfig");
          }), F.on("GetPermissions", function(L) {
            return E.ensureCatalog("permissions");
          }), F.on("GetMetadata", function(L) {
            return Promise.all([E.ensureDoc("documentInfo"), E.ensureCatalog("metadata")]);
          }), F.on("GetMarkInfo", function(L) {
            return E.ensureCatalog("markInfo");
          }), F.on("GetData", function(L) {
            return E.requestLoadedStream().then(function(H) {
              return H.bytes;
            });
          }), F.on("GetAnnotations", function({ pageIndex: L, intent: H }) {
            return E.getPage(L).then(function(Q) {
              const N = new h(`GetAnnotations: page ${L}`);
              return A(N), Q.getAnnotationsData(F, N, H).then((V) => (U(N), V), (V) => {
                throw U(N), V;
              });
            });
          }), F.on("GetFieldObjects", function(L) {
            return E.ensureDoc("fieldObjects");
          }), F.on("HasJSActions", function(L) {
            return E.ensureDoc("hasJSActions");
          }), F.on("GetCalculationOrderIds", function(L) {
            return E.ensureDoc("calculationOrderIds");
          }), F.on("SaveDocument", async function({ isPureXfa: L, numPages: H, annotationStorage: Q, filename: N }) {
            const V = [E.requestLoadedStream(), E.ensureCatalog("acroForm"), E.ensureCatalog("acroFormRef"), E.ensureDoc("startXRef"), E.ensureDoc("xref"), E.ensureDoc("linearization"), E.ensureCatalog("structTreeRoot")], Y = [], Z = L ? null : (0, g.getNewAnnotationsMap)(Q), [rt, st, mt, yt, at, nt, q] = await Promise.all(V), D = at.trailer.getRaw("Root") || null;
            let G;
            if (Z) {
              q ? await q.canUpdateStructTree({ pdfManager: E, newAnnotationsByPage: Z }) && (G = q) : await v.StructTreeRoot.canCreateStructureTree({ catalogRef: D, pdfManager: E, newAnnotationsByPage: Z }) && (G = null);
              const dt = a.AnnotationFactory.generateImages(Q.values(), at, E.evaluatorOptions.isOffscreenCanvasSupported), bt = G === void 0 ? Y : [];
              for (const [vt, xt] of Z) bt.push(E.getPage(vt).then((St) => {
                const Mt = new h(`Save (editor): page ${vt}`);
                return St.saveNewAnnotations(F, Mt, xt, dt).finally(function() {
                  U(Mt);
                });
              }));
              G === null ? Y.push(Promise.all(bt).then(async (vt) => (await v.StructTreeRoot.createStructureTree({ newAnnotationsByPage: Z, xref: at, catalogRef: D, pdfManager: E, newRefs: vt }), vt))) : G && Y.push(Promise.all(bt).then(async (vt) => (await G.updateStructureTree({ newAnnotationsByPage: Z, pdfManager: E, newRefs: vt }), vt)));
            }
            if (L) Y.push(E.serializeXfaData(Q));
            else for (let dt = 0; dt < H; dt++) Y.push(E.getPage(dt).then(function(bt) {
              const vt = new h(`Save: page ${dt}`);
              return bt.save(F, vt, Q).finally(function() {
                U(vt);
              });
            }));
            const et = await Promise.all(Y);
            let J = [], it = null;
            if (L) {
              if (it = et[0], !it) return rt.bytes;
            } else if (J = et.flat(2), J.length === 0) return rt.bytes;
            const lt = mt && st instanceof p.Dict && J.some((dt) => dt.needAppearances), ot = st instanceof p.Dict && st.get("XFA") || null;
            let ut = null, ct = !1;
            if (Array.isArray(ot)) {
              for (let dt = 0, bt = ot.length; dt < bt; dt += 2) ot[dt] === "datasets" && (ut = ot[dt + 1], ct = !0);
              ut === null && (ut = at.getNewTemporaryRef());
            } else ot && (0, o.warn)("Unsupported XFA type.");
            let gt = /* @__PURE__ */ Object.create(null);
            if (at.trailer) {
              const dt = /* @__PURE__ */ Object.create(null), bt = at.trailer.get("Info") || null;
              bt instanceof p.Dict && bt.forEach((vt, xt) => {
                typeof xt == "string" && (dt[vt] = (0, o.stringToPDFString)(xt));
              }), gt = { rootRef: D, encryptRef: at.trailer.getRaw("Encrypt") || null, newRef: at.getNewTemporaryRef(), infoRef: at.trailer.getRaw("Info") || null, info: dt, fileIds: at.trailer.get("ID") || null, startXRef: nt ? yt : at.lastXRefStreamPos ?? yt, filename: N };
            }
            return (0, m.incrementalUpdate)({ originalData: rt.bytes, xrefInfo: gt, newRefs: J, xref: at, hasXfa: !!ot, xfaDatasetsRef: ut, hasXfaDatasetsEntry: ct, needAppearances: lt, acroFormRef: mt, acroForm: st, xfaData: it }).finally(() => {
              at.resetNewTemporaryRef();
            });
          }), F.on("GetOperatorList", function(L, H) {
            const Q = L.pageIndex;
            E.getPage(Q).then(function(N) {
              const V = new h(`GetOperatorList: page ${Q}`);
              A(V);
              const Y = z >= o.VerbosityLevel.INFOS ? Date.now() : 0;
              N.getOperatorList({ handler: F, sink: H, task: V, intent: L.intent, cacheKey: L.cacheKey, annotationStorage: L.annotationStorage }).then(function(Z) {
                U(V), Y && (0, o.info)(`page=${Q + 1} - getOperatorList: time=${Date.now() - Y}ms, len=${Z.length}`), H.close();
              }, function(Z) {
                U(V), V.terminated || H.error(Z);
              });
            });
          }), F.on("GetTextContent", function(L, H) {
            const { pageIndex: Q, includeMarkedContent: N, disableNormalization: V } = L;
            E.getPage(Q).then(function(Y) {
              const Z = new h("GetTextContent: page " + Q);
              A(Z);
              const rt = z >= o.VerbosityLevel.INFOS ? Date.now() : 0;
              Y.extractTextContent({ handler: F, task: Z, sink: H, includeMarkedContent: N, disableNormalization: V }).then(function() {
                U(Z), rt && (0, o.info)(`page=${Q + 1} - getTextContent: time=` + (Date.now() - rt) + "ms"), H.close();
              }, function(st) {
                U(Z), Z.terminated || H.error(st);
              });
            });
          }), F.on("GetStructTree", function(L) {
            return E.getPage(L.pageIndex).then(function(H) {
              return E.ensure(H, "getStructTree");
            });
          }), F.on("FontFallback", function(L) {
            return E.fontFallback(L.id, F);
          }), F.on("Cleanup", function(L) {
            return E.cleanup(!0);
          }), F.on("Terminate", function(L) {
            I = !0;
            const H = [];
            if (E) {
              E.terminate(new o.AbortException("Worker was terminated."));
              const Q = E.cleanup();
              H.push(Q), E = null;
            } else (0, d.clearGlobalCaches)();
            R && R(new o.AbortException("Worker was terminated."));
            for (const Q of W)
              H.push(Q.finished), Q.terminate();
            return Promise.all(H).then(function() {
              F.destroy(), F = null;
            });
          }), F.on("Ready", function(L) {
            (function(Q) {
              function N(Z) {
                S(), F.send("GetDoc", { pdfInfo: Z });
              }
              function V(Z) {
                if (S(), Z instanceof o.PasswordException) {
                  const rt = new h(`PasswordException: response ${Z.code}`);
                  A(rt), F.sendWithPromise("PasswordRequest", Z).then(function({ password: st }) {
                    U(rt), E.updatePassword(st), Y();
                  }).catch(function() {
                    U(rt), F.send("DocException", Z);
                  });
                } else Z instanceof o.InvalidPDFException || Z instanceof o.MissingPDFException || Z instanceof o.UnexpectedResponseException || Z instanceof o.UnknownErrorException ? F.send("DocException", Z) : F.send("DocException", new o.UnknownErrorException(Z.message, Z.toString()));
              }
              function Y() {
                S(), K(!1).then(N, function(Z) {
                  S(), Z instanceof g.XRefParseException ? E.requestLoadedStream().then(function() {
                    S(), K(!0).then(N, V);
                  }) : V(Z);
                });
              }
              S(), X(Q).then(function(Z) {
                if (I)
                  throw Z.terminate(new o.AbortException("Worker was terminated.")), new Error("Worker was terminated");
                E = Z, E.requestLoadedStream(!0).then((rt) => {
                  F.send("DataLoaded", { length: rt.bytes.byteLength });
                });
              }).then(Y, V);
            })(M), M = null;
          }), T;
        }
        static initializeFromPort(M) {
          const O = new b.MessageHandler("worker", "main", M);
          x.setup(O, M), O.send("ready", null);
        }
      }
      l.WorkerMessageHandler = x, typeof window > "u" && !o.isNodeJS && typeof self < "u" && function(M) {
        return typeof M.postMessage == "function" && "onmessage" in M;
      }(self) && x.initializeFromPort(self);
    }, (u, l) => {
      var M, O;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.VerbosityLevel = l.Util = l.UnknownErrorException = l.UnexpectedResponseException = l.TextRenderingMode = l.RenderingIntentFlag = l.PromiseCapability = l.PermissionFlag = l.PasswordResponses = l.PasswordException = l.PageActionEventType = l.OPS = l.MissingPDFException = l.MAX_IMAGE_SIZE_TO_CACHE = l.LINE_FACTOR = l.LINE_DESCENT_FACTOR = l.InvalidPDFException = l.ImageKind = l.IDENTITY_MATRIX = l.FormatError = l.FeatureTest = l.FONT_IDENTITY_MATRIX = l.DocumentActionEventType = l.CMapCompressionType = l.BaseException = l.BASELINE_FACTOR = l.AnnotationType = l.AnnotationReplyType = l.AnnotationPrefix = l.AnnotationMode = l.AnnotationFlag = l.AnnotationFieldFlag = l.AnnotationEditorType = l.AnnotationEditorPrefix = l.AnnotationEditorParamsType = l.AnnotationBorderStyleType = l.AnnotationActionEventType = l.AbortException = void 0, l.assert = function(I, R) {
        I || n(R);
      }, l.bytesToString = m, l.createValidAbsoluteUrl = function(I, R = null, W = null) {
        if (!I) return null;
        try {
          if (W && typeof I == "string") {
            if (W.addDefaultProtocol && I.startsWith("www.")) {
              const j = I.match(/\./g);
              (j == null ? void 0 : j.length) >= 2 && (I = `http://${I}`);
            }
            if (W.tryConvertEncoding) try {
              I = h(I);
            } catch {
            }
          }
          const z = R ? new URL(I, R) : new URL(I);
          if (function($) {
            switch ($ == null ? void 0 : $.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }(z)) return z;
        } catch {
        }
        return null;
      }, l.getModificationDate = function(I = /* @__PURE__ */ new Date()) {
        return [I.getUTCFullYear().toString(), (I.getUTCMonth() + 1).toString().padStart(2, "0"), I.getUTCDate().toString().padStart(2, "0"), I.getUTCHours().toString().padStart(2, "0"), I.getUTCMinutes().toString().padStart(2, "0"), I.getUTCSeconds().toString().padStart(2, "0")].join("");
      }, l.getUuid = function() {
        if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.randomUUID) == "function") return crypto.randomUUID();
        const I = new Uint8Array(32);
        if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.getRandomValues) == "function") crypto.getRandomValues(I);
        else for (let R = 0; R < 32; R++) I[R] = Math.floor(255 * Math.random());
        return m(I);
      }, l.getVerbosityLevel = function() {
        return g;
      }, l.info = function(I) {
        g >= o.INFOS && console.log(`Info: ${I}`);
      }, l.isArrayBuffer = function(I) {
        return typeof I == "object" && (I == null ? void 0 : I.byteLength) !== void 0;
      }, l.isArrayEqual = function(I, R) {
        if (I.length !== R.length) return !1;
        for (let W = 0, z = I.length; W < z; W++) if (I[W] !== R[W]) return !1;
        return !0;
      }, l.isNodeJS = void 0, l.normalizeUnicode = function(I) {
        return x || (x = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, _ = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), I.replaceAll(x, (R, W, z) => W ? W.normalize("NFKC") : _.get(z));
      }, l.objectFromMap = function(I) {
        const R = /* @__PURE__ */ Object.create(null);
        for (const [W, z] of I) R[W] = z;
        return R;
      }, l.objectSize = function(I) {
        return Object.keys(I).length;
      }, l.setVerbosityLevel = function(I) {
        Number.isInteger(I) && (g = I);
      }, l.shadow = a, l.string32 = function(I) {
        return String.fromCharCode(I >> 24 & 255, I >> 16 & 255, I >> 8 & 255, 255 & I);
      }, l.stringToBytes = b, l.stringToPDFString = function(I) {
        if (I[0] >= "ï") {
          let W;
          if (I[0] === "þ" && I[1] === "ÿ" ? W = "utf-16be" : I[0] === "ÿ" && I[1] === "þ" ? W = "utf-16le" : I[0] === "ï" && I[1] === "»" && I[2] === "¿" && (W = "utf-8"), W) try {
            const z = new TextDecoder(W, { fatal: !0 }), j = b(I);
            return z.decode(j);
          } catch (z) {
            p(`stringToPDFString: "${z}".`);
          }
        }
        const R = [];
        for (let W = 0, z = I.length; W < z; W++) {
          const j = v[I.charCodeAt(W)];
          R.push(j ? String.fromCharCode(j) : I.charAt(W));
        }
        return R.join("");
      }, l.stringToUTF8String = h, l.unreachable = n, l.utf8StringToString = function(I) {
        return unescape(encodeURIComponent(I));
      }, l.warn = p;
      const f = !(typeof process != "object" || process + "" != "[object process]" || process.versions.nw || process.versions.electron && process.type && process.type !== "browser");
      l.isNodeJS = f, l.IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0], l.FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0], l.MAX_IMAGE_SIZE_TO_CACHE = 1e7, l.LINE_FACTOR = 1.35, l.LINE_DESCENT_FACTOR = 0.35, l.BASELINE_FACTOR = 0.25925925925925924, l.RenderingIntentFlag = { ANY: 1, DISPLAY: 2, PRINT: 4, SAVE: 8, ANNOTATIONS_FORMS: 16, ANNOTATIONS_STORAGE: 32, ANNOTATIONS_DISABLE: 64, OPLIST: 256 }, l.AnnotationMode = { DISABLE: 0, ENABLE: 1, ENABLE_FORMS: 2, ENABLE_STORAGE: 3 }, l.AnnotationEditorPrefix = "pdfjs_internal_editor_", l.AnnotationEditorType = { DISABLE: -1, NONE: 0, FREETEXT: 3, STAMP: 13, INK: 15 }, l.AnnotationEditorParamsType = { RESIZE: 1, CREATE: 2, FREETEXT_SIZE: 11, FREETEXT_COLOR: 12, FREETEXT_OPACITY: 13, INK_COLOR: 21, INK_THICKNESS: 22, INK_OPACITY: 23 }, l.PermissionFlag = { PRINT: 4, MODIFY_CONTENTS: 8, COPY: 16, MODIFY_ANNOTATIONS: 32, FILL_INTERACTIVE_FORMS: 256, COPY_FOR_ACCESSIBILITY: 512, ASSEMBLE: 1024, PRINT_HIGH_QUALITY: 2048 }, l.TextRenderingMode = { FILL: 0, STROKE: 1, FILL_STROKE: 2, INVISIBLE: 3, FILL_ADD_TO_PATH: 4, STROKE_ADD_TO_PATH: 5, FILL_STROKE_ADD_TO_PATH: 6, ADD_TO_PATH: 7, FILL_STROKE_MASK: 3, ADD_TO_PATH_FLAG: 4 }, l.ImageKind = { GRAYSCALE_1BPP: 1, RGB_24BPP: 2, RGBA_32BPP: 3 }, l.AnnotationType = { TEXT: 1, LINK: 2, FREETEXT: 3, LINE: 4, SQUARE: 5, CIRCLE: 6, POLYGON: 7, POLYLINE: 8, HIGHLIGHT: 9, UNDERLINE: 10, SQUIGGLY: 11, STRIKEOUT: 12, STAMP: 13, CARET: 14, INK: 15, POPUP: 16, FILEATTACHMENT: 17, SOUND: 18, MOVIE: 19, WIDGET: 20, SCREEN: 21, PRINTERMARK: 22, TRAPNET: 23, WATERMARK: 24, THREED: 25, REDACT: 26 }, l.AnnotationReplyType = { GROUP: "Group", REPLY: "R" }, l.AnnotationFlag = { INVISIBLE: 1, HIDDEN: 2, PRINT: 4, NOZOOM: 8, NOROTATE: 16, NOVIEW: 32, READONLY: 64, LOCKED: 128, TOGGLENOVIEW: 256, LOCKEDCONTENTS: 512 }, l.AnnotationFieldFlag = { READONLY: 1, REQUIRED: 2, NOEXPORT: 4, MULTILINE: 4096, PASSWORD: 8192, NOTOGGLETOOFF: 16384, RADIO: 32768, PUSHBUTTON: 65536, COMBO: 131072, EDIT: 262144, SORT: 524288, FILESELECT: 1048576, MULTISELECT: 2097152, DONOTSPELLCHECK: 4194304, DONOTSCROLL: 8388608, COMB: 16777216, RICHTEXT: 33554432, RADIOSINUNISON: 33554432, COMMITONSELCHANGE: 67108864 }, l.AnnotationBorderStyleType = { SOLID: 1, DASHED: 2, BEVELED: 3, INSET: 4, UNDERLINE: 5 }, l.AnnotationActionEventType = { E: "Mouse Enter", X: "Mouse Exit", D: "Mouse Down", U: "Mouse Up", Fo: "Focus", Bl: "Blur", PO: "PageOpen", PC: "PageClose", PV: "PageVisible", PI: "PageInvisible", K: "Keystroke", F: "Format", V: "Validate", C: "Calculate" }, l.DocumentActionEventType = { WC: "WillClose", WS: "WillSave", DS: "DidSave", WP: "WillPrint", DP: "DidPrint" }, l.PageActionEventType = { O: "PageOpen", C: "PageClose" };
      const o = { ERRORS: 0, WARNINGS: 1, INFOS: 5 };
      l.VerbosityLevel = o, l.CMapCompressionType = { NONE: 0, BINARY: 1 }, l.OPS = { dependency: 1, setLineWidth: 2, setLineCap: 3, setLineJoin: 4, setMiterLimit: 5, setDash: 6, setRenderingIntent: 7, setFlatness: 8, setGState: 9, save: 10, restore: 11, transform: 12, moveTo: 13, lineTo: 14, curveTo: 15, curveTo2: 16, curveTo3: 17, closePath: 18, rectangle: 19, stroke: 20, closeStroke: 21, fill: 22, eoFill: 23, fillStroke: 24, eoFillStroke: 25, closeFillStroke: 26, closeEOFillStroke: 27, endPath: 28, clip: 29, eoClip: 30, beginText: 31, endText: 32, setCharSpacing: 33, setWordSpacing: 34, setHScale: 35, setLeading: 36, setFont: 37, setTextRenderingMode: 38, setTextRise: 39, moveText: 40, setLeadingMoveText: 41, setTextMatrix: 42, nextLine: 43, showText: 44, showSpacedText: 45, nextLineShowText: 46, nextLineSetSpacingShowText: 47, setCharWidth: 48, setCharWidthAndBounds: 49, setStrokeColorSpace: 50, setFillColorSpace: 51, setStrokeColor: 52, setStrokeColorN: 53, setFillColor: 54, setFillColorN: 55, setStrokeGray: 56, setFillGray: 57, setStrokeRGBColor: 58, setFillRGBColor: 59, setStrokeCMYKColor: 60, setFillCMYKColor: 61, shadingFill: 62, beginInlineImage: 63, beginImageData: 64, endInlineImage: 65, paintXObject: 66, markPoint: 67, markPointProps: 68, beginMarkedContent: 69, beginMarkedContentProps: 70, endMarkedContent: 71, beginCompat: 72, endCompat: 73, paintFormXObjectBegin: 74, paintFormXObjectEnd: 75, beginGroup: 76, endGroup: 77, beginAnnotation: 80, endAnnotation: 81, paintImageMaskXObject: 83, paintImageMaskXObjectGroup: 84, paintImageXObject: 85, paintInlineImageXObject: 86, paintInlineImageXObjectGroup: 87, paintImageXObjectRepeat: 88, paintImageMaskXObjectRepeat: 89, paintSolidColorImageMask: 90, constructPath: 91 }, l.PasswordResponses = { NEED_PASSWORD: 1, INCORRECT_PASSWORD: 2 };
      let g = o.WARNINGS;
      function p(E) {
        g >= o.WARNINGS && console.log(`Warning: ${E}`);
      }
      function n(E) {
        throw new Error(E);
      }
      function a(E, I, R, W = !1) {
        return Object.defineProperty(E, I, { value: R, enumerable: !W, configurable: !0, writable: !1 }), R;
      }
      const d = function() {
        function I(R, W) {
          this.constructor === I && n("Cannot initialize BaseException."), this.message = R, this.name = W;
        }
        return I.prototype = new Error(), I.constructor = I, I;
      }();
      l.BaseException = d, l.PasswordException = class extends d {
        constructor(I, R) {
          super(I, "PasswordException"), this.code = R;
        }
      }, l.UnknownErrorException = class extends d {
        constructor(I, R) {
          super(I, "UnknownErrorException"), this.details = R;
        }
      }, l.InvalidPDFException = class extends d {
        constructor(I) {
          super(I, "InvalidPDFException");
        }
      }, l.MissingPDFException = class extends d {
        constructor(I) {
          super(I, "MissingPDFException");
        }
      }, l.UnexpectedResponseException = class extends d {
        constructor(I, R) {
          super(I, "UnexpectedResponseException"), this.status = R;
        }
      }, l.FormatError = class extends d {
        constructor(I) {
          super(I, "FormatError");
        }
      }, l.AbortException = class extends d {
        constructor(I) {
          super(I, "AbortException");
        }
      };
      function m(E) {
        typeof E == "object" && (E == null ? void 0 : E.length) !== void 0 || n("Invalid argument for bytesToString");
        const I = E.length, R = 8192;
        if (I < R) return String.fromCharCode.apply(null, E);
        const W = [];
        for (let z = 0; z < I; z += R) {
          const j = Math.min(z + R, I), $ = E.subarray(z, j);
          W.push(String.fromCharCode.apply(null, $));
        }
        return W.join("");
      }
      function b(E) {
        typeof E != "string" && n("Invalid argument for stringToBytes");
        const I = E.length, R = new Uint8Array(I);
        for (let W = 0; W < I; ++W) R[W] = 255 & E.charCodeAt(W);
        return R;
      }
      l.FeatureTest = class {
        static get isLittleEndian() {
          return a(this, "isLittleEndian", function() {
            const R = new Uint8Array(4);
            return R[0] = 1, new Uint32Array(R.buffer, 0, 1)[0] === 1;
          }());
        }
        static get isEvalSupported() {
          return a(this, "isEvalSupported", function() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }());
        }
        static get isOffscreenCanvasSupported() {
          return a(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
        }
        static get platform() {
          return typeof navigator > "u" ? a(this, "platform", { isWin: !1, isMac: !1 }) : a(this, "platform", { isWin: navigator.platform.includes("Win"), isMac: navigator.platform.includes("Mac") });
        }
        static get isCSSRoundSupported() {
          var I, R;
          return a(this, "isCSSRoundSupported", (R = (I = globalThis.CSS) == null ? void 0 : I.supports) == null ? void 0 : R.call(I, "width: round(1.5px, 1px)"));
        }
      };
      const w = [...Array(256).keys()].map((E) => E.toString(16).padStart(2, "0"));
      l.Util = class {
        static makeHexColor(I, R, W) {
          return `#${w[I]}${w[R]}${w[W]}`;
        }
        static scaleMinMax(I, R) {
          let W;
          I[0] ? (I[0] < 0 && (W = R[0], R[0] = R[1], R[1] = W), R[0] *= I[0], R[1] *= I[0], I[3] < 0 && (W = R[2], R[2] = R[3], R[3] = W), R[2] *= I[3], R[3] *= I[3]) : (W = R[0], R[0] = R[2], R[2] = W, W = R[1], R[1] = R[3], R[3] = W, I[1] < 0 && (W = R[2], R[2] = R[3], R[3] = W), R[2] *= I[1], R[3] *= I[1], I[2] < 0 && (W = R[0], R[0] = R[1], R[1] = W), R[0] *= I[2], R[1] *= I[2]), R[0] += I[4], R[1] += I[4], R[2] += I[5], R[3] += I[5];
        }
        static transform(I, R) {
          return [I[0] * R[0] + I[2] * R[1], I[1] * R[0] + I[3] * R[1], I[0] * R[2] + I[2] * R[3], I[1] * R[2] + I[3] * R[3], I[0] * R[4] + I[2] * R[5] + I[4], I[1] * R[4] + I[3] * R[5] + I[5]];
        }
        static applyTransform(I, R) {
          return [I[0] * R[0] + I[1] * R[2] + R[4], I[0] * R[1] + I[1] * R[3] + R[5]];
        }
        static applyInverseTransform(I, R) {
          const W = R[0] * R[3] - R[1] * R[2];
          return [(I[0] * R[3] - I[1] * R[2] + R[2] * R[5] - R[4] * R[3]) / W, (-I[0] * R[1] + I[1] * R[0] + R[4] * R[1] - R[5] * R[0]) / W];
        }
        static getAxialAlignedBoundingBox(I, R) {
          const W = this.applyTransform(I, R), z = this.applyTransform(I.slice(2, 4), R), j = this.applyTransform([I[0], I[3]], R), $ = this.applyTransform([I[2], I[1]], R);
          return [Math.min(W[0], z[0], j[0], $[0]), Math.min(W[1], z[1], j[1], $[1]), Math.max(W[0], z[0], j[0], $[0]), Math.max(W[1], z[1], j[1], $[1])];
        }
        static inverseTransform(I) {
          const R = I[0] * I[3] - I[1] * I[2];
          return [I[3] / R, -I[1] / R, -I[2] / R, I[0] / R, (I[2] * I[5] - I[4] * I[3]) / R, (I[4] * I[1] - I[5] * I[0]) / R];
        }
        static singularValueDecompose2dScale(I) {
          const R = [I[0], I[2], I[1], I[3]], W = I[0] * R[0] + I[1] * R[2], z = I[0] * R[1] + I[1] * R[3], j = I[2] * R[0] + I[3] * R[2], $ = I[2] * R[1] + I[3] * R[3], B = (W + $) / 2, C = Math.sqrt((W + $) ** 2 - 4 * (W * $ - j * z)) / 2, T = B + C || 1, F = B - C || 1;
          return [Math.sqrt(T), Math.sqrt(F)];
        }
        static normalizeRect(I) {
          const R = I.slice(0);
          return I[0] > I[2] && (R[0] = I[2], R[2] = I[0]), I[1] > I[3] && (R[1] = I[3], R[3] = I[1]), R;
        }
        static intersect(I, R) {
          const W = Math.max(Math.min(I[0], I[2]), Math.min(R[0], R[2])), z = Math.min(Math.max(I[0], I[2]), Math.max(R[0], R[2]));
          if (W > z) return null;
          const j = Math.max(Math.min(I[1], I[3]), Math.min(R[1], R[3])), $ = Math.min(Math.max(I[1], I[3]), Math.max(R[1], R[3]));
          return j > $ ? null : [W, j, z, $];
        }
        static bezierBoundingBox(I, R, W, z, j, $, B, C) {
          const T = [], F = [[], []];
          let S, A, U, K, X, L, H, Q;
          for (let Z = 0; Z < 2; ++Z)
            if (Z === 0 ? (A = 6 * I - 12 * W + 6 * j, S = -3 * I + 9 * W - 9 * j + 3 * B, U = 3 * W - 3 * I) : (A = 6 * R - 12 * z + 6 * $, S = -3 * R + 9 * z - 9 * $ + 3 * C, U = 3 * z - 3 * R), Math.abs(S) < 1e-12) {
              if (Math.abs(A) < 1e-12) continue;
              K = -U / A, 0 < K && K < 1 && T.push(K);
            } else
              H = A * A - 4 * U * S, Q = Math.sqrt(H), H < 0 || (X = (-A + Q) / (2 * S), 0 < X && X < 1 && T.push(X), L = (-A - Q) / (2 * S), 0 < L && L < 1 && T.push(L));
          let N, V = T.length;
          const Y = V;
          for (; V--; )
            K = T[V], N = 1 - K, F[0][V] = N * N * N * I + 3 * N * N * K * W + 3 * N * K * K * j + K * K * K * B, F[1][V] = N * N * N * R + 3 * N * N * K * z + 3 * N * K * K * $ + K * K * K * C;
          return F[0][Y] = I, F[1][Y] = R, F[0][Y + 1] = B, F[1][Y + 1] = C, F[0].length = F[1].length = Y + 2, [Math.min(...F[0]), Math.min(...F[1]), Math.max(...F[0]), Math.max(...F[1])];
        }
      };
      const v = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
      function h(E) {
        return decodeURIComponent(escape(E));
      }
      l.PromiseCapability = (O = class {
        constructor() {
          lr(this, M, !1);
          this.promise = new Promise((I, R) => {
            this.resolve = (W) => {
              Wf(this, M, !0), I(W);
            }, this.reject = (W) => {
              Wf(this, M, !0), R(W);
            };
          });
        }
        get settled() {
          return or(this, M);
        }
      }, M = new WeakMap(), O);
      let x = null, _ = null;
      l.AnnotationPrefix = "pdfjs_internal_id_";
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XRefParseException = l.XRefEntryException = l.ParserEOFException = l.PDF_VERSION_REGEXP = l.MissingDataException = void 0, l.arrayBuffersToBytes = function(M) {
        const O = M.length;
        if (O === 0) return new Uint8Array(0);
        if (O === 1) return new Uint8Array(M[0]);
        let E = 0;
        for (let W = 0; W < O; W++) E += M[W].byteLength;
        const I = new Uint8Array(E);
        let R = 0;
        for (let W = 0; W < O; W++) {
          const z = new Uint8Array(M[W]);
          I.set(z, R), R += z.byteLength;
        }
        return I;
      }, l.collectActions = function(M, O, E) {
        const I = /* @__PURE__ */ Object.create(null), R = b({ dict: O, key: "AA", stopWhenFound: !1 });
        if (R) for (let W = R.length - 1; W >= 0; W--) {
          const z = R[W];
          if (z instanceof g.Dict) for (const j of z.getKeys()) {
            const $ = E[j];
            if (!$) continue;
            const B = [];
            v(z.getRaw(j), M, B, new g.RefSet()), B.length > 0 && (I[$] = B);
          }
        }
        if (O.has("A")) {
          const W = [];
          v(O.get("A"), M, W, new g.RefSet()), W.length > 0 && (I.Action = W);
        }
        return (0, o.objectSize)(I) > 0 ? I : null;
      }, l.encodeToXmlString = function(M) {
        const O = [];
        let E = 0;
        for (let I = 0, R = M.length; I < R; I++) {
          const W = M.codePointAt(I);
          if (32 <= W && W <= 126) {
            const z = h[W];
            z && (E < I && O.push(M.substring(E, I)), O.push(z), E = I + 1);
          } else
            E < I && O.push(M.substring(E, I)), O.push(`&#x${W.toString(16).toUpperCase()};`), W > 55295 && (W < 57344 || W > 65533) && I++, E = I + 1;
        }
        return O.length === 0 ? M : (E < M.length && O.push(M.substring(E, M.length)), O.join(""));
      }, l.escapePDFName = function(M) {
        const O = [];
        let E = 0;
        for (let I = 0, R = M.length; I < R; I++) {
          const W = M.charCodeAt(I);
          (W < 33 || W > 126 || W === 35 || W === 40 || W === 41 || W === 60 || W === 62 || W === 91 || W === 93 || W === 123 || W === 125 || W === 47 || W === 37) && (E < I && O.push(M.substring(E, I)), O.push(`#${W.toString(16)}`), E = I + 1);
        }
        return O.length === 0 ? M : (E < M.length && O.push(M.substring(E, M.length)), O.join(""));
      }, l.escapeString = function(M) {
        return M.replaceAll(/([()\\\n\r])/g, (O) => O === `
` ? "\\n" : O === "\r" ? "\\r" : `\\${O}`);
      }, l.getInheritableProperty = b, l.getLookupTableFactory = function(M) {
        let O;
        return function() {
          return M && (O = /* @__PURE__ */ Object.create(null), M(O), M = null), O;
        };
      }, l.getNewAnnotationsMap = function(M) {
        if (!M) return null;
        const O = /* @__PURE__ */ new Map();
        for (const [E, I] of M) {
          if (!E.startsWith(o.AnnotationEditorPrefix)) continue;
          let R = O.get(I.pageIndex);
          R || (R = [], O.set(I.pageIndex, R)), R.push(I);
        }
        return O.size > 0 ? O : null;
      }, l.getRotationMatrix = function(M, O, E) {
        switch (M) {
          case 90:
            return [0, 1, -1, 0, O, 0];
          case 180:
            return [-1, 0, 0, -1, O, E];
          case 270:
            return [0, -1, 1, 0, 0, E];
          default:
            throw new Error("Invalid rotation");
        }
      }, l.isAscii = function(M) {
        return /^[\x00-\x7F]*$/.test(M);
      }, l.isWhiteSpace = function(M) {
        return M === 32 || M === 9 || M === 13 || M === 10;
      }, l.log2 = function(M) {
        return M <= 0 ? 0 : Math.ceil(Math.log2(M));
      }, l.numberToString = function(M) {
        if (Number.isInteger(M)) return M.toString();
        const O = Math.round(100 * M);
        return O % 100 == 0 ? (O / 100).toString() : O % 10 == 0 ? M.toFixed(1) : M.toFixed(2);
      }, l.parseXFAPath = function(M) {
        const O = /(.+)\[(\d+)\]$/;
        return M.split(".").map((E) => {
          const I = E.match(O);
          return I ? { name: I[1], pos: parseInt(I[2], 10) } : { name: E, pos: 0 };
        });
      }, l.readInt8 = function(M, O) {
        return M[O] << 24 >> 24;
      }, l.readUint16 = function(M, O) {
        return M[O] << 8 | M[O + 1];
      }, l.readUint32 = function(M, O) {
        return (M[O] << 24 | M[O + 1] << 16 | M[O + 2] << 8 | M[O + 3]) >>> 0;
      }, l.recoverJsURL = function(M) {
        const O = new RegExp("^\\s*(" + ["app.launchURL", "window.open", "xfa.host.gotoURL"].join("|").replaceAll(".", "\\.") + `)\\((?:'|")([^'"]*)(?:'|")(?:,\\s*(\\w+)\\)|\\))`, "i").exec(M);
        if (O != null && O[2]) {
          const E = O[2];
          let I = !1;
          return O[3] === "true" && O[1] === "app.launchURL" && (I = !0), { url: E, newWindow: I };
        }
        return null;
      }, l.stringToUTF16HexString = function(M) {
        const O = [];
        for (let E = 0, I = M.length; E < I; E++) {
          const R = M.charCodeAt(E);
          O.push((R >> 8 & 255).toString(16).padStart(2, "0"), (255 & R).toString(16).padStart(2, "0"));
        }
        return O.join("");
      }, l.stringToUTF16String = function(M, O = !1) {
        const E = [];
        O && E.push("þÿ");
        for (let I = 0, R = M.length; I < R; I++) {
          const W = M.charCodeAt(I);
          E.push(String.fromCharCode(W >> 8 & 255), String.fromCharCode(255 & W));
        }
        return E.join("");
      }, l.toRomanNumerals = function(M, O = !1) {
        (0, o.assert)(Number.isInteger(M) && M > 0, "The number should be a positive integer.");
        const E = [];
        let I;
        for (; M >= 1e3; )
          M -= 1e3, E.push("M");
        I = M / 100 | 0, M %= 100, E.push(w[I]), I = M / 10 | 0, M %= 10, E.push(w[10 + I]), E.push(w[20 + M]);
        const R = E.join("");
        return O ? R.toLowerCase() : R;
      }, l.validateCSSFont = function(M) {
        const O = /* @__PURE__ */ new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]), { fontFamily: E, fontWeight: I, italicAngle: R } = M;
        if (!x(E, !0)) return !1;
        const W = I ? I.toString() : "";
        M.fontWeight = O.has(W) ? W : "400";
        const z = parseFloat(R);
        return M.italicAngle = isNaN(z) || z < -90 || z > 90 ? "14" : R.toString(), !0;
      }, l.validateFontName = x;
      var o = f(2), g = f(4), p = f(5);
      l.PDF_VERSION_REGEXP = /^[1-9]\.\d$/;
      class n extends o.BaseException {
        constructor(M, O) {
          super(`Missing data [${M}, ${O})`, "MissingDataException"), this.begin = M, this.end = O;
        }
      }
      l.MissingDataException = n;
      class a extends o.BaseException {
        constructor(M) {
          super(M, "ParserEOFException");
        }
      }
      l.ParserEOFException = a;
      class d extends o.BaseException {
        constructor(M) {
          super(M, "XRefEntryException");
        }
      }
      l.XRefEntryException = d;
      class m extends o.BaseException {
        constructor(M) {
          super(M, "XRefParseException");
        }
      }
      l.XRefParseException = m;
      function b({ dict: _, key: M, getArray: O = !1, stopWhenFound: E = !0 }) {
        let I;
        const R = new g.RefSet();
        for (; _ instanceof g.Dict && (!_.objId || !R.has(_.objId)); ) {
          _.objId && R.put(_.objId);
          const W = O ? _.getArray(M) : _.get(M);
          if (W !== void 0) {
            if (E) return W;
            (I || (I = [])).push(W);
          }
          _ = _.get("Parent");
        }
        return I;
      }
      const w = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
      function v(_, M, O, E) {
        if (!_) return;
        let I = null;
        if (_ instanceof g.Ref) {
          if (E.has(_)) return;
          I = _, E.put(I), _ = M.fetch(_);
        }
        if (Array.isArray(_)) for (const R of _) v(R, M, O, E);
        else if (_ instanceof g.Dict) {
          if ((0, g.isName)(_.get("S"), "JavaScript")) {
            const R = _.get("JS");
            let W;
            R instanceof p.BaseStream ? W = R.getString() : typeof R == "string" && (W = R), W && (W = (0, o.stringToPDFString)(W).replaceAll("\0", "")), W && O.push(W);
          }
          v(_.getRaw("Next"), M, O, E);
        }
        I && E.remove(I);
      }
      const h = { 60: "&lt;", 62: "&gt;", 38: "&amp;", 34: "&quot;", 39: "&apos;" };
      function x(_, M = !1) {
        const O = /^("|').*("|')$/.exec(_);
        if (O && O[1] === O[2]) {
          if (new RegExp(`[^\\\\]${O[1]}`).test(_.slice(1, -1)))
            return M && (0, o.warn)(`FontFamily contains unescaped ${O[1]}: ${_}.`), !1;
        } else for (const E of _.split(/[ \t]+/)) if (/^(\d|(-(\d|-)))/.test(E) || !/^[\w-\\]+$/.test(E))
          return M && (0, o.warn)(`FontFamily contains invalid <custom-ident>: ${_}.`), !1;
        return !0;
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.RefSetCache = l.RefSet = l.Ref = l.Name = l.EOF = l.Dict = l.Cmd = l.CIRCULAR_REF = void 0, l.clearPrimitiveCaches = function() {
        n = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), d = /* @__PURE__ */ Object.create(null);
      }, l.isCmd = function(E, I) {
        return E instanceof b && (I === void 0 || E.cmd === I);
      }, l.isDict = function(E, I) {
        return E instanceof v && (I === void 0 || M(E.get("Type"), I));
      }, l.isName = M, l.isRefsEqual = function(E, I) {
        return E.num === I.num && E.gen === I.gen;
      };
      var o = f(2);
      const g = Symbol("CIRCULAR_REF");
      l.CIRCULAR_REF = g;
      const p = Symbol("EOF");
      l.EOF = p;
      let n = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), d = /* @__PURE__ */ Object.create(null);
      class m {
        constructor(E) {
          this.name = E;
        }
        static get(E) {
          return a[E] || (a[E] = new m(E));
        }
      }
      l.Name = m;
      class b {
        constructor(E) {
          this.cmd = E;
        }
        static get(E) {
          return n[E] || (n[E] = new b(E));
        }
      }
      l.Cmd = b;
      const w = function() {
        return w;
      };
      class v {
        constructor(E = null) {
          this._map = /* @__PURE__ */ Object.create(null), this.xref = E, this.objId = null, this.suppressEncryption = !1, this.__nonSerializable__ = w;
        }
        assignXref(E) {
          this.xref = E;
        }
        get size() {
          return Object.keys(this._map).length;
        }
        get(E, I, R) {
          let W = this._map[E];
          return W === void 0 && I !== void 0 && (W = this._map[I], W === void 0 && R !== void 0 && (W = this._map[R])), W instanceof h && this.xref ? this.xref.fetch(W, this.suppressEncryption) : W;
        }
        async getAsync(E, I, R) {
          let W = this._map[E];
          return W === void 0 && I !== void 0 && (W = this._map[I], W === void 0 && R !== void 0 && (W = this._map[R])), W instanceof h && this.xref ? this.xref.fetchAsync(W, this.suppressEncryption) : W;
        }
        getArray(E, I, R) {
          let W = this._map[E];
          if (W === void 0 && I !== void 0 && (W = this._map[I], W === void 0 && R !== void 0 && (W = this._map[R])), W instanceof h && this.xref && (W = this.xref.fetch(W, this.suppressEncryption)), Array.isArray(W)) {
            W = W.slice();
            for (let z = 0, j = W.length; z < j; z++) W[z] instanceof h && this.xref && (W[z] = this.xref.fetch(W[z], this.suppressEncryption));
          }
          return W;
        }
        getRaw(E) {
          return this._map[E];
        }
        getKeys() {
          return Object.keys(this._map);
        }
        getRawValues() {
          return Object.values(this._map);
        }
        set(E, I) {
          this._map[E] = I;
        }
        has(E) {
          return this._map[E] !== void 0;
        }
        forEach(E) {
          for (const I in this._map) E(I, this.get(I));
        }
        static get empty() {
          const E = new v(null);
          return E.set = (I, R) => {
            (0, o.unreachable)("Should not call `set` on the empty dictionary.");
          }, (0, o.shadow)(this, "empty", E);
        }
        static merge({ xref: E, dictArray: I, mergeSubDicts: R = !1 }) {
          const W = new v(E), z = /* @__PURE__ */ new Map();
          for (const j of I) if (j instanceof v) for (const [$, B] of Object.entries(j._map)) {
            let C = z.get($);
            if (C === void 0)
              C = [], z.set($, C);
            else if (!(R && B instanceof v)) continue;
            C.push(B);
          }
          for (const [j, $] of z) {
            if ($.length === 1 || !($[0] instanceof v)) {
              W._map[j] = $[0];
              continue;
            }
            const B = new v(E);
            for (const C of $) for (const [T, F] of Object.entries(C._map)) B._map[T] === void 0 && (B._map[T] = F);
            B.size > 0 && (W._map[j] = B);
          }
          return z.clear(), W.size > 0 ? W : v.empty;
        }
        clone() {
          const E = new v(this.xref);
          for (const I of this.getKeys()) E.set(I, this.getRaw(I));
          return E;
        }
      }
      l.Dict = v;
      class h {
        constructor(E, I) {
          this.num = E, this.gen = I;
        }
        toString() {
          return this.gen === 0 ? `${this.num}R` : `${this.num}R${this.gen}`;
        }
        static fromString(E) {
          const I = d[E];
          if (I) return I;
          const R = /^(\d+)R(\d*)$/.exec(E);
          return R && R[1] !== "0" ? d[E] = new h(parseInt(R[1]), R[2] ? parseInt(R[2]) : 0) : null;
        }
        static get(E, I) {
          const R = I === 0 ? `${E}R` : `${E}R${I}`;
          return d[R] || (d[R] = new h(E, I));
        }
      }
      l.Ref = h;
      class x {
        constructor(E = null) {
          this._set = new Set(E == null ? void 0 : E._set);
        }
        has(E) {
          return this._set.has(E.toString());
        }
        put(E) {
          this._set.add(E.toString());
        }
        remove(E) {
          this._set.delete(E.toString());
        }
        [Symbol.iterator]() {
          return this._set.values();
        }
        clear() {
          this._set.clear();
        }
      }
      l.RefSet = x;
      class _ {
        constructor() {
          this._map = /* @__PURE__ */ new Map();
        }
        get size() {
          return this._map.size;
        }
        get(E) {
          return this._map.get(E.toString());
        }
        has(E) {
          return this._map.has(E.toString());
        }
        put(E, I) {
          this._map.set(E.toString(), I);
        }
        putAlias(E, I) {
          this._map.set(E.toString(), this.get(I));
        }
        [Symbol.iterator]() {
          return this._map.values();
        }
        clear() {
          this._map.clear();
        }
      }
      l.RefSetCache = _;
      function M(O, E) {
        return O instanceof m && (E === void 0 || O.name === E);
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.BaseStream = void 0;
      var o = f(2);
      class g {
        constructor() {
          this.constructor === g && (0, o.unreachable)("Cannot initialize BaseStream.");
        }
        get length() {
          (0, o.unreachable)("Abstract getter `length` accessed");
        }
        get isEmpty() {
          (0, o.unreachable)("Abstract getter `isEmpty` accessed");
        }
        get isDataLoaded() {
          return (0, o.shadow)(this, "isDataLoaded", !0);
        }
        getByte() {
          (0, o.unreachable)("Abstract method `getByte` called");
        }
        getBytes(n) {
          (0, o.unreachable)("Abstract method `getBytes` called");
        }
        peekByte() {
          const n = this.getByte();
          return n !== -1 && this.pos--, n;
        }
        peekBytes(n) {
          const a = this.getBytes(n);
          return this.pos -= a.length, a;
        }
        getUint16() {
          const n = this.getByte(), a = this.getByte();
          return n === -1 || a === -1 ? -1 : (n << 8) + a;
        }
        getInt32() {
          return (this.getByte() << 24) + (this.getByte() << 16) + (this.getByte() << 8) + this.getByte();
        }
        getByteRange(n, a) {
          (0, o.unreachable)("Abstract method `getByteRange` called");
        }
        getString(n) {
          return (0, o.bytesToString)(this.getBytes(n));
        }
        skip(n) {
          this.pos += n || 1;
        }
        reset() {
          (0, o.unreachable)("Abstract method `reset` called");
        }
        moveStart() {
          (0, o.unreachable)("Abstract method `moveStart` called");
        }
        makeSubStream(n, a, d = null) {
          (0, o.unreachable)("Abstract method `makeSubStream` called");
        }
        getBaseStreams() {
          return null;
        }
      }
      l.BaseStream = g;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.NetworkPdfManager = l.LocalPdfManager = void 0;
      var o = f(2), g = f(7), p = f(3), n = f(9), a = f(8);
      class d {
        constructor(b) {
          var w;
          this.constructor === d && (0, o.unreachable)("Cannot initialize BasePdfManager."), this._docBaseUrl = function(h) {
            if (h) {
              const x = (0, o.createValidAbsoluteUrl)(h);
              if (x) return x.href;
              (0, o.warn)(`Invalid absolute docBaseUrl: "${h}".`);
            }
            return null;
          }(b.docBaseUrl), this._docId = b.docId, this._password = b.password, this.enableXfa = b.enableXfa, (w = b.evaluatorOptions).isOffscreenCanvasSupported && (w.isOffscreenCanvasSupported = o.FeatureTest.isOffscreenCanvasSupported), this.evaluatorOptions = b.evaluatorOptions;
        }
        get docId() {
          return this._docId;
        }
        get password() {
          return this._password;
        }
        get docBaseUrl() {
          return this._docBaseUrl;
        }
        get catalog() {
          return this.pdfDocument.catalog;
        }
        ensureDoc(b, w) {
          return this.ensure(this.pdfDocument, b, w);
        }
        ensureXRef(b, w) {
          return this.ensure(this.pdfDocument.xref, b, w);
        }
        ensureCatalog(b, w) {
          return this.ensure(this.pdfDocument.catalog, b, w);
        }
        getPage(b) {
          return this.pdfDocument.getPage(b);
        }
        fontFallback(b, w) {
          return this.pdfDocument.fontFallback(b, w);
        }
        loadXfaFonts(b, w) {
          return this.pdfDocument.loadXfaFonts(b, w);
        }
        loadXfaImages() {
          return this.pdfDocument.loadXfaImages();
        }
        serializeXfaData(b) {
          return this.pdfDocument.serializeXfaData(b);
        }
        cleanup(b = !1) {
          return this.pdfDocument.cleanup(b);
        }
        async ensure(b, w, v) {
          (0, o.unreachable)("Abstract method `ensure` called");
        }
        requestRange(b, w) {
          (0, o.unreachable)("Abstract method `requestRange` called");
        }
        requestLoadedStream(b = !1) {
          (0, o.unreachable)("Abstract method `requestLoadedStream` called");
        }
        sendProgressiveData(b) {
          (0, o.unreachable)("Abstract method `sendProgressiveData` called");
        }
        updatePassword(b) {
          this._password = b;
        }
        terminate(b) {
          (0, o.unreachable)("Abstract method `terminate` called");
        }
      }
      l.LocalPdfManager = class extends d {
        constructor(b) {
          super(b);
          const w = new a.Stream(b.source);
          this.pdfDocument = new n.PDFDocument(this, w), this._loadedStreamPromise = Promise.resolve(w);
        }
        async ensure(b, w, v) {
          const h = b[w];
          return typeof h == "function" ? h.apply(b, v) : h;
        }
        requestRange(b, w) {
          return Promise.resolve();
        }
        requestLoadedStream(b = !1) {
          return this._loadedStreamPromise;
        }
        terminate(b) {
        }
      }, l.NetworkPdfManager = class extends d {
        constructor(b) {
          super(b), this.streamManager = new g.ChunkedStreamManager(b.source, { msgHandler: b.handler, length: b.length, disableAutoFetch: b.disableAutoFetch, rangeChunkSize: b.rangeChunkSize }), this.pdfDocument = new n.PDFDocument(this, this.streamManager.getStream());
        }
        async ensure(b, w, v) {
          try {
            const h = b[w];
            return typeof h == "function" ? h.apply(b, v) : h;
          } catch (h) {
            if (!(h instanceof p.MissingDataException)) throw h;
            return await this.requestRange(h.begin, h.end), this.ensure(b, w, v);
          }
        }
        requestRange(b, w) {
          return this.streamManager.requestRange(b, w);
        }
        requestLoadedStream(b = !1) {
          return this.streamManager.requestAllChunks(b);
        }
        sendProgressiveData(b) {
          this.streamManager.onReceiveData({ chunk: b });
        }
        terminate(b) {
          this.streamManager.abort(b);
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ChunkedStreamManager = l.ChunkedStream = void 0;
      var o = f(3), g = f(2), p = f(8);
      class n extends p.Stream {
        constructor(d, m, b) {
          super(new Uint8Array(d), 0, d, null), this.chunkSize = m, this._loadedChunks = /* @__PURE__ */ new Set(), this.numChunks = Math.ceil(d / m), this.manager = b, this.progressiveDataLength = 0, this.lastSuccessfulEnsureByteChunk = -1;
        }
        getMissingChunks() {
          const d = [];
          for (let m = 0, b = this.numChunks; m < b; ++m) this._loadedChunks.has(m) || d.push(m);
          return d;
        }
        get numChunksLoaded() {
          return this._loadedChunks.size;
        }
        get isDataLoaded() {
          return this.numChunksLoaded === this.numChunks;
        }
        onReceiveData(d, m) {
          const b = this.chunkSize;
          if (d % b != 0) throw new Error(`Bad begin offset: ${d}`);
          const w = d + m.byteLength;
          if (w % b != 0 && w !== this.bytes.length) throw new Error(`Bad end offset: ${w}`);
          this.bytes.set(new Uint8Array(m), d);
          const v = Math.floor(d / b), h = Math.floor((w - 1) / b) + 1;
          for (let x = v; x < h; ++x) this._loadedChunks.add(x);
        }
        onReceiveProgressiveData(d) {
          let m = this.progressiveDataLength;
          const b = Math.floor(m / this.chunkSize);
          this.bytes.set(new Uint8Array(d), m), m += d.byteLength, this.progressiveDataLength = m;
          const w = m >= this.end ? this.numChunks : Math.floor(m / this.chunkSize);
          for (let v = b; v < w; ++v) this._loadedChunks.add(v);
        }
        ensureByte(d) {
          if (d < this.progressiveDataLength) return;
          const m = Math.floor(d / this.chunkSize);
          if (!(m > this.numChunks) && m !== this.lastSuccessfulEnsureByteChunk) {
            if (!this._loadedChunks.has(m)) throw new o.MissingDataException(d, d + 1);
            this.lastSuccessfulEnsureByteChunk = m;
          }
        }
        ensureRange(d, m) {
          if (d >= m || m <= this.progressiveDataLength) return;
          const b = Math.floor(d / this.chunkSize);
          if (b > this.numChunks) return;
          const w = Math.min(Math.floor((m - 1) / this.chunkSize) + 1, this.numChunks);
          for (let v = b; v < w; ++v) if (!this._loadedChunks.has(v)) throw new o.MissingDataException(d, m);
        }
        nextEmptyChunk(d) {
          const m = this.numChunks;
          for (let b = 0; b < m; ++b) {
            const w = (d + b) % m;
            if (!this._loadedChunks.has(w)) return w;
          }
          return null;
        }
        hasChunk(d) {
          return this._loadedChunks.has(d);
        }
        getByte() {
          const d = this.pos;
          return d >= this.end ? -1 : (d >= this.progressiveDataLength && this.ensureByte(d), this.bytes[this.pos++]);
        }
        getBytes(d) {
          const m = this.bytes, b = this.pos, w = this.end;
          if (!d)
            return w > this.progressiveDataLength && this.ensureRange(b, w), m.subarray(b, w);
          let v = b + d;
          return v > w && (v = w), v > this.progressiveDataLength && this.ensureRange(b, v), this.pos = v, m.subarray(b, v);
        }
        getByteRange(d, m) {
          return d < 0 && (d = 0), m > this.end && (m = this.end), m > this.progressiveDataLength && this.ensureRange(d, m), this.bytes.subarray(d, m);
        }
        makeSubStream(d, m, b = null) {
          m ? d + m > this.progressiveDataLength && this.ensureRange(d, d + m) : d >= this.progressiveDataLength && this.ensureByte(d);
          function w() {
          }
          w.prototype = Object.create(this), w.prototype.getMissingChunks = function() {
            const h = this.chunkSize, x = Math.floor(this.start / h), _ = Math.floor((this.end - 1) / h) + 1, M = [];
            for (let O = x; O < _; ++O) this._loadedChunks.has(O) || M.push(O);
            return M;
          }, Object.defineProperty(w.prototype, "isDataLoaded", { get() {
            return this.numChunksLoaded === this.numChunks || this.getMissingChunks().length === 0;
          }, configurable: !0 });
          const v = new w();
          return v.pos = v.start = d, v.end = d + m || this.end, v.dict = b, v;
        }
        getBaseStreams() {
          return [this];
        }
      }
      l.ChunkedStream = n, l.ChunkedStreamManager = class {
        constructor(d, m) {
          this.length = m.length, this.chunkSize = m.rangeChunkSize, this.stream = new n(this.length, this.chunkSize, this), this.pdfNetworkStream = d, this.disableAutoFetch = m.disableAutoFetch, this.msgHandler = m.msgHandler, this.currRequestId = 0, this._chunksNeededByRequest = /* @__PURE__ */ new Map(), this._requestsByChunk = /* @__PURE__ */ new Map(), this._promisesByRequest = /* @__PURE__ */ new Map(), this.progressiveDataLength = 0, this.aborted = !1, this._loadedStreamCapability = new g.PromiseCapability();
        }
        sendRequest(d, m) {
          const b = this.pdfNetworkStream.getRangeReader(d, m);
          b.isStreamingSupported || (b.onProgress = this.onProgress.bind(this));
          let w = [], v = 0;
          return new Promise((h, x) => {
            const _ = ({ value: M, done: O }) => {
              try {
                if (O) {
                  const E = (0, o.arrayBuffersToBytes)(w);
                  w = null, h(E);
                  return;
                }
                v += M.byteLength, b.isStreamingSupported && this.onProgress({ loaded: v }), w.push(M), b.read().then(_, x);
              } catch (E) {
                x(E);
              }
            };
            b.read().then(_, x);
          }).then((h) => {
            this.aborted || this.onReceiveData({ chunk: h, begin: d });
          });
        }
        requestAllChunks(d = !1) {
          if (!d) {
            const m = this.stream.getMissingChunks();
            this._requestChunks(m);
          }
          return this._loadedStreamCapability.promise;
        }
        _requestChunks(d) {
          const m = this.currRequestId++, b = /* @__PURE__ */ new Set();
          this._chunksNeededByRequest.set(m, b);
          for (const h of d) this.stream.hasChunk(h) || b.add(h);
          if (b.size === 0) return Promise.resolve();
          const w = new g.PromiseCapability();
          this._promisesByRequest.set(m, w);
          const v = [];
          for (const h of b) {
            let x = this._requestsByChunk.get(h);
            x || (x = [], this._requestsByChunk.set(h, x), v.push(h)), x.push(m);
          }
          if (v.length > 0) {
            const h = this.groupChunks(v);
            for (const x of h) {
              const _ = x.beginChunk * this.chunkSize, M = Math.min(x.endChunk * this.chunkSize, this.length);
              this.sendRequest(_, M).catch(w.reject);
            }
          }
          return w.promise.catch((h) => {
            if (!this.aborted) throw h;
          });
        }
        getStream() {
          return this.stream;
        }
        requestRange(d, m) {
          m = Math.min(m, this.length);
          const b = this.getBeginChunk(d), w = this.getEndChunk(m), v = [];
          for (let h = b; h < w; ++h) v.push(h);
          return this._requestChunks(v);
        }
        requestRanges(d = []) {
          const m = [];
          for (const b of d) {
            const w = this.getBeginChunk(b.begin), v = this.getEndChunk(b.end);
            for (let h = w; h < v; ++h) m.includes(h) || m.push(h);
          }
          return m.sort(function(b, w) {
            return b - w;
          }), this._requestChunks(m);
        }
        groupChunks(d) {
          const m = [];
          let b = -1, w = -1;
          for (let v = 0, h = d.length; v < h; ++v) {
            const x = d[v];
            b < 0 && (b = x), w >= 0 && w + 1 !== x && (m.push({ beginChunk: b, endChunk: w + 1 }), b = x), v + 1 === d.length && m.push({ beginChunk: b, endChunk: x + 1 }), w = x;
          }
          return m;
        }
        onProgress(d) {
          this.msgHandler.send("DocProgress", { loaded: this.stream.numChunksLoaded * this.chunkSize + d.loaded, total: this.length });
        }
        onReceiveData(d) {
          const m = d.chunk, b = d.begin === void 0, w = b ? this.progressiveDataLength : d.begin, v = w + m.byteLength, h = Math.floor(w / this.chunkSize), x = v < this.length ? Math.floor(v / this.chunkSize) : Math.ceil(v / this.chunkSize);
          b ? (this.stream.onReceiveProgressiveData(m), this.progressiveDataLength = v) : this.stream.onReceiveData(w, m), this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
          const _ = [];
          for (let M = h; M < x; ++M) {
            const O = this._requestsByChunk.get(M);
            if (O) {
              this._requestsByChunk.delete(M);
              for (const E of O) {
                const I = this._chunksNeededByRequest.get(E);
                I.has(M) && I.delete(M), I.size > 0 || _.push(E);
              }
            }
          }
          if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
            let M;
            if (this.stream.numChunksLoaded === 1) {
              const O = this.stream.numChunks - 1;
              this.stream.hasChunk(O) || (M = O);
            } else M = this.stream.nextEmptyChunk(x);
            Number.isInteger(M) && this._requestChunks([M]);
          }
          for (const M of _) {
            const O = this._promisesByRequest.get(M);
            this._promisesByRequest.delete(M), O.resolve();
          }
          this.msgHandler.send("DocProgress", { loaded: this.stream.numChunksLoaded * this.chunkSize, total: this.length });
        }
        onError(d) {
          this._loadedStreamCapability.reject(d);
        }
        getBeginChunk(d) {
          return Math.floor(d / this.chunkSize);
        }
        getEndChunk(d) {
          return Math.floor((d - 1) / this.chunkSize) + 1;
        }
        abort(d) {
          var m;
          this.aborted = !0, (m = this.pdfNetworkStream) == null || m.cancelAllRequests(d);
          for (const b of this._promisesByRequest.values()) b.reject(d);
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.StringStream = l.Stream = l.NullStream = void 0;
      var o = f(5), g = f(2);
      class p extends o.BaseStream {
        constructor(a, d, m, b) {
          super(), this.bytes = a instanceof Uint8Array ? a : new Uint8Array(a), this.start = d || 0, this.pos = this.start, this.end = d + m || this.bytes.length, this.dict = b;
        }
        get length() {
          return this.end - this.start;
        }
        get isEmpty() {
          return this.length === 0;
        }
        getByte() {
          return this.pos >= this.end ? -1 : this.bytes[this.pos++];
        }
        getBytes(a) {
          const d = this.bytes, m = this.pos, b = this.end;
          if (!a) return d.subarray(m, b);
          let w = m + a;
          return w > b && (w = b), this.pos = w, d.subarray(m, w);
        }
        getByteRange(a, d) {
          return a < 0 && (a = 0), d > this.end && (d = this.end), this.bytes.subarray(a, d);
        }
        reset() {
          this.pos = this.start;
        }
        moveStart() {
          this.start = this.pos;
        }
        makeSubStream(a, d, m = null) {
          return new p(this.bytes.buffer, a, d, m);
        }
      }
      l.Stream = p, l.StringStream = class extends p {
        constructor(a) {
          super((0, g.stringToBytes)(a));
        }
      }, l.NullStream = class extends p {
        constructor() {
          super(new Uint8Array(0));
        }
      };
    }, (u, l, f) => {
      var S, W9, U, G9, X;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Page = l.PDFDocument = void 0;
      var o = f(2), g = f(10), p = f(3), n = f(4), a = f(51), d = f(5), m = f(74), b = f(66), w = f(68), v = f(102), h = f(16), x = f(8), _ = f(76), M = f(64), O = f(13), E = f(18), I = f(72), R = f(73), W = f(77), z = f(103);
      const j = [0, 0, 612, 792];
      class $ {
        constructor({ pdfManager: H, xref: Q, pageIndex: N, pageDict: V, ref: Y, globalIdFactory: Z, fontCache: rt, builtInCMapCache: st, standardFontDataCache: mt, globalImageCache: yt, systemFontCache: at, nonBlendModesSet: nt, xfaFactory: q }) {
          lr(this, S);
          this.pdfManager = H, this.pageIndex = N, this.pageDict = V, this.xref = Q, this.ref = Y, this.fontCache = rt, this.builtInCMapCache = st, this.standardFontDataCache = mt, this.globalImageCache = yt, this.systemFontCache = at, this.nonBlendModesSet = nt, this.evaluatorOptions = H.evaluatorOptions, this.resourcesPromise = null, this.xfaFactory = q;
          const D = { obj: 0 };
          this._localIdFactory = class extends Z {
            static createObjId() {
              return `p${N}_${++D.obj}`;
            }
            static getPageObjId() {
              return `p${Y.toString()}`;
            }
          };
        }
        _getInheritableProperty(H, Q = !1) {
          const N = (0, p.getInheritableProperty)({ dict: this.pageDict, key: H, getArray: Q, stopWhenFound: !1 });
          return Array.isArray(N) ? N.length !== 1 && N[0] instanceof n.Dict ? n.Dict.merge({ xref: this.xref, dictArray: N }) : N[0] : N;
        }
        get content() {
          return this.pageDict.getArray("Contents");
        }
        get resources() {
          const H = this._getInheritableProperty("Resources");
          return (0, o.shadow)(this, "resources", H instanceof n.Dict ? H : n.Dict.empty);
        }
        _getBoundingBox(H) {
          if (this.xfaData) return this.xfaData.bbox;
          let Q = this._getInheritableProperty(H, !0);
          if (Array.isArray(Q) && Q.length === 4) {
            if (Q = o.Util.normalizeRect(Q), Q[2] - Q[0] > 0 && Q[3] - Q[1] > 0) return Q;
            (0, o.warn)(`Empty, or invalid, /${H} entry.`);
          }
          return null;
        }
        get mediaBox() {
          return (0, o.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || j);
        }
        get cropBox() {
          return (0, o.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
        }
        get userUnit() {
          let H = this.pageDict.get("UserUnit");
          return (typeof H != "number" || H <= 0) && (H = 1), (0, o.shadow)(this, "userUnit", H);
        }
        get view() {
          const { cropBox: H, mediaBox: Q } = this;
          if (H !== Q && !(0, o.isArrayEqual)(H, Q)) {
            const N = o.Util.intersect(H, Q);
            if (N && N[2] - N[0] > 0 && N[3] - N[1] > 0) return (0, o.shadow)(this, "view", N);
            (0, o.warn)("Empty /CropBox and /MediaBox intersection.");
          }
          return (0, o.shadow)(this, "view", Q);
        }
        get rotate() {
          let H = this._getInheritableProperty("Rotate") || 0;
          return H % 90 != 0 ? H = 0 : H >= 360 ? H %= 360 : H < 0 && (H = (H % 360 + 360) % 360), (0, o.shadow)(this, "rotate", H);
        }
        _onSubStreamError(H, Q) {
          if (!this.evaluatorOptions.ignoreErrors) throw H;
          (0, o.warn)(`getContentStream - ignoring sub-stream (${Q}): "${H}".`);
        }
        getContentStream() {
          return this.pdfManager.ensure(this, "content").then((H) => H instanceof d.BaseStream ? H : Array.isArray(H) ? new E.StreamsSequenceStream(H, this._onSubStreamError.bind(this)) : new x.NullStream());
        }
        get xfaData() {
          return (0, o.shadow)(this, "xfaData", this.xfaFactory ? { bbox: this.xfaFactory.getBoundingBox(this.pageIndex) } : null);
        }
        async saveNewAnnotations(H, Q, N, V) {
          if (this.xfaFactory) throw new Error("XFA: Cannot save new annotations.");
          const Y = new O.PartialEvaluator({ xref: this.xref, handler: H, pageIndex: this.pageIndex, idFactory: this._localIdFactory, fontCache: this.fontCache, builtInCMapCache: this.builtInCMapCache, standardFontDataCache: this.standardFontDataCache, globalImageCache: this.globalImageCache, systemFontCache: this.systemFontCache, options: this.evaluatorOptions }), Z = new n.RefSet(), rt = new n.RefSet();
          Le(this, S, W9).call(this, N, Z, rt);
          const st = this.pageDict, mt = this.annotations.filter((D) => !(D instanceof n.Ref && Z.has(D))), yt = await g.AnnotationFactory.saveNewAnnotations(Y, Q, N, V);
          for (const { ref: D } of yt.annotations) D instanceof n.Ref && !rt.has(D) && mt.push(D);
          const at = st.get("Annots");
          st.set("Annots", mt);
          const nt = [];
          await (0, R.writeObject)(this.ref, st, nt, this.xref), at && st.set("Annots", at);
          const q = yt.dependencies;
          return q.push({ ref: this.ref, data: nt.join("") }, ...yt.annotations), q;
        }
        save(H, Q, N) {
          const V = new O.PartialEvaluator({ xref: this.xref, handler: H, pageIndex: this.pageIndex, idFactory: this._localIdFactory, fontCache: this.fontCache, builtInCMapCache: this.builtInCMapCache, standardFontDataCache: this.standardFontDataCache, globalImageCache: this.globalImageCache, systemFontCache: this.systemFontCache, options: this.evaluatorOptions });
          return this._parsedAnnotations.then(function(Y) {
            const Z = [];
            for (const rt of Y) rt.mustBePrinted(N) && Z.push(rt.save(V, Q, N).catch(function(st) {
              return (0, o.warn)(`save - ignoring annotation data during "${Q.name}" task: "${st}".`), null;
            }));
            return Promise.all(Z).then(function(rt) {
              return rt.filter((st) => !!st);
            });
          });
        }
        loadResources(H) {
          return this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources")), this.resourcesPromise.then(() => new _.ObjectLoader(this.resources, H, this.xref).load());
        }
        getOperatorList({ handler: H, sink: Q, task: N, intent: V, cacheKey: Y, annotationStorage: Z = null }) {
          const rt = this.getContentStream(), st = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]), mt = new O.PartialEvaluator({ xref: this.xref, handler: H, pageIndex: this.pageIndex, idFactory: this._localIdFactory, fontCache: this.fontCache, builtInCMapCache: this.builtInCMapCache, standardFontDataCache: this.standardFontDataCache, globalImageCache: this.globalImageCache, systemFontCache: this.systemFontCache, options: this.evaluatorOptions }), yt = this.xfaFactory ? null : (0, p.getNewAnnotationsMap)(Z);
          let at = null, nt = Promise.resolve(null);
          if (yt) {
            const D = yt.get(this.pageIndex);
            if (D) {
              const G = this.pdfManager.ensureDoc("annotationGlobals");
              let et;
              const J = /* @__PURE__ */ new Set();
              for (const { bitmapId: lt, bitmap: ot } of D) !lt || ot || J.has(lt) || J.add(lt);
              const { isOffscreenCanvasSupported: it } = this.evaluatorOptions;
              if (J.size > 0) {
                const lt = D.slice();
                for (const [ot, ut] of Z) ot.startsWith(o.AnnotationEditorPrefix) && ut.bitmap && J.has(ut.bitmapId) && lt.push(ut);
                et = g.AnnotationFactory.generateImages(lt, this.xref, it);
              } else et = g.AnnotationFactory.generateImages(D, this.xref, it);
              at = new n.RefSet(), Le(this, S, W9).call(this, D, at, null), nt = G.then((lt) => lt ? g.AnnotationFactory.printNewAnnotations(lt, mt, N, D, et) : null);
            }
          }
          const q = Promise.all([rt, st]).then(([D]) => {
            const G = new M.OperatorList(V, Q);
            return H.send("StartRenderPage", { transparency: mt.hasBlendModes(this.resources, this.nonBlendModesSet), pageIndex: this.pageIndex, cacheKey: Y }), mt.getOperatorList({ stream: D, task: N, resources: this.resources, operatorList: G }).then(function() {
              return G;
            });
          });
          return Promise.all([q, this._parsedAnnotations, nt]).then(function([D, G, et]) {
            if (et) {
              G = G.filter((ct) => !(ct.ref && at.has(ct.ref)));
              for (let ct = 0, gt = et.length; ct < gt; ct++) {
                const dt = et[ct];
                if (dt.refToReplace) {
                  const bt = G.findIndex((vt) => vt.ref && (0, n.isRefsEqual)(vt.ref, dt.refToReplace));
                  bt >= 0 && (G.splice(bt, 1, dt), et.splice(ct--, 1), gt--);
                }
              }
              G = G.concat(et);
            }
            if (G.length === 0 || V & o.RenderingIntentFlag.ANNOTATIONS_DISABLE)
              return D.flush(!0), { length: D.totalLength };
            const J = !!(V & o.RenderingIntentFlag.ANNOTATIONS_FORMS), it = !!(V & o.RenderingIntentFlag.ANY), lt = !!(V & o.RenderingIntentFlag.DISPLAY), ot = !!(V & o.RenderingIntentFlag.PRINT), ut = [];
            for (const ct of G) (it || lt && ct.mustBeViewed(Z, J) || ot && ct.mustBePrinted(Z)) && ut.push(ct.getOperatorList(mt, N, V, J, Z).catch(function(gt) {
              return (0, o.warn)(`getOperatorList - ignoring annotation data during "${N.name}" task: "${gt}".`), { opList: null, separateForm: !1, separateCanvas: !1 };
            }));
            return Promise.all(ut).then(function(ct) {
              let gt = !1, dt = !1;
              for (const { opList: bt, separateForm: vt, separateCanvas: xt } of ct)
                D.addOpList(bt), gt || (gt = vt), dt || (dt = xt);
              return D.flush(!0, { form: gt, canvas: dt }), { length: D.totalLength };
            });
          });
        }
        extractTextContent({ handler: H, task: Q, includeMarkedContent: N, disableNormalization: V, sink: Y }) {
          const Z = this.getContentStream(), rt = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
          return Promise.all([Z, rt]).then(([st]) => new O.PartialEvaluator({ xref: this.xref, handler: H, pageIndex: this.pageIndex, idFactory: this._localIdFactory, fontCache: this.fontCache, builtInCMapCache: this.builtInCMapCache, standardFontDataCache: this.standardFontDataCache, globalImageCache: this.globalImageCache, systemFontCache: this.systemFontCache, options: this.evaluatorOptions }).getTextContent({ stream: st, task: Q, resources: this.resources, includeMarkedContent: N, disableNormalization: V, sink: Y, viewBox: this.view }));
        }
        async getStructTree() {
          const H = await this.pdfManager.ensureCatalog("structTreeRoot");
          return H ? (await this._parsedAnnotations, (await this.pdfManager.ensure(this, "_parseStructTree", [H])).serializable) : null;
        }
        _parseStructTree(H) {
          const Q = new I.StructTreePage(H, this.pageDict);
          return Q.parse(this.ref), Q;
        }
        async getAnnotationsData(H, Q, N) {
          const V = await this._parsedAnnotations;
          if (V.length === 0) return V;
          const Y = [], Z = [];
          let rt;
          const st = !!(N & o.RenderingIntentFlag.ANY), mt = !!(N & o.RenderingIntentFlag.DISPLAY), yt = !!(N & o.RenderingIntentFlag.PRINT);
          for (const at of V) {
            const nt = st || mt && at.viewable;
            (nt || yt && at.printable) && Y.push(at.data), at.hasTextContent && nt && (rt || (rt = new O.PartialEvaluator({ xref: this.xref, handler: H, pageIndex: this.pageIndex, idFactory: this._localIdFactory, fontCache: this.fontCache, builtInCMapCache: this.builtInCMapCache, standardFontDataCache: this.standardFontDataCache, globalImageCache: this.globalImageCache, systemFontCache: this.systemFontCache, options: this.evaluatorOptions })), Z.push(at.extractTextContent(rt, Q, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]).catch(function(q) {
              (0, o.warn)(`getAnnotationsData - ignoring textContent during "${Q.name}" task: "${q}".`);
            })));
          }
          return await Promise.all(Z), Y;
        }
        get annotations() {
          const H = this._getInheritableProperty("Annots");
          return (0, o.shadow)(this, "annotations", Array.isArray(H) ? H : []);
        }
        get _parsedAnnotations() {
          const H = this.pdfManager.ensure(this, "annotations").then(async (Q) => {
            if (Q.length === 0) return Q;
            const N = await this.pdfManager.ensureDoc("annotationGlobals");
            if (!N) return [];
            const V = [];
            for (const rt of Q) V.push(g.AnnotationFactory.create(this.xref, rt, N, this._localIdFactory, !1, this.ref).catch(function(st) {
              return (0, o.warn)(`_parsedAnnotations: "${st}".`), null;
            }));
            const Y = [];
            let Z;
            for (const rt of await Promise.all(V)) rt && (rt instanceof g.PopupAnnotation ? (Z || (Z = [])).push(rt) : Y.push(rt));
            return Z && Y.push(...Z), Y;
          });
          return (0, o.shadow)(this, "_parsedAnnotations", H);
        }
        get jsActions() {
          const H = (0, p.collectActions)(this.xref, this.pageDict, o.PageActionEventType);
          return (0, o.shadow)(this, "jsActions", H);
        }
      }
      S = new WeakSet(), W9 = function(H, Q, N) {
        for (const V of H) if (V.id) {
          const Y = n.Ref.fromString(V.id);
          if (!Y) {
            (0, o.warn)(`A non-linked annotation cannot be modified: ${V.id}`);
            continue;
          }
          if (V.deleted) {
            Q.put(Y);
            continue;
          }
          N == null || N.put(Y), V.ref = Y, delete V.id;
        }
      }, l.Page = $;
      const B = new Uint8Array([37, 80, 68, 70, 45]), C = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), T = new Uint8Array([101, 110, 100, 111, 98, 106]);
      function F(L, H, Q = 1024, N = !1) {
        const V = H.length, Y = L.peekBytes(Q), Z = Y.length - V;
        if (Z <= 0) return !1;
        if (N) {
          const rt = V - 1;
          let st = Y.length - 1;
          for (; st >= rt; ) {
            let mt = 0;
            for (; mt < V && Y[st - mt] === H[rt - mt]; ) mt++;
            if (mt >= V)
              return L.pos += st - rt, !0;
            st--;
          }
        } else {
          let rt = 0;
          for (; rt <= Z; ) {
            let st = 0;
            for (; st < V && Y[rt + st] === H[st]; ) st++;
            if (st >= V)
              return L.pos += rt, !0;
            rt++;
          }
        }
        return !1;
      }
      l.PDFDocument = (X = class {
        constructor(H, Q) {
          lr(this, U);
          if (Q.length <= 0) throw new o.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
          this.pdfManager = H, this.stream = Q, this.xref = new z.XRef(Q, H), this._pagePromises = /* @__PURE__ */ new Map(), this._version = null;
          const N = { font: 0 };
          this._globalIdFactory = class {
            static getDocId() {
              return `g_${H.docId}`;
            }
            static createFontId() {
              return "f" + ++N.font;
            }
            static createObjId() {
              (0, o.unreachable)("Abstract method `createObjId` called.");
            }
            static getPageObjId() {
              (0, o.unreachable)("Abstract method `getPageObjId` called.");
            }
          };
        }
        parse(H) {
          this.xref.parse(H), this.catalog = new b.Catalog(this.pdfManager, this.xref);
        }
        get linearization() {
          let H = null;
          try {
            H = h.Linearization.create(this.stream);
          } catch (Q) {
            if (Q instanceof p.MissingDataException) throw Q;
            (0, o.info)(Q);
          }
          return (0, o.shadow)(this, "linearization", H);
        }
        get startXRef() {
          const H = this.stream;
          let Q = 0;
          if (this.linearization)
            H.reset(), F(H, T) && (Q = H.pos + 6 - H.start);
          else {
            const V = C.length;
            let Y = !1, Z = H.end;
            for (; !Y && Z > 0; )
              Z -= 1024 - V, Z < 0 && (Z = 0), H.pos = Z, Y = F(H, C, 1024, !0);
            if (Y) {
              H.skip(9);
              let rt;
              do
                rt = H.getByte();
              while ((0, p.isWhiteSpace)(rt));
              let st = "";
              for (; rt >= 32 && rt <= 57; )
                st += String.fromCharCode(rt), rt = H.getByte();
              Q = parseInt(st, 10), isNaN(Q) && (Q = 0);
            }
          }
          return (0, o.shadow)(this, "startXRef", Q);
        }
        checkHeader() {
          const H = this.stream;
          if (H.reset(), !F(H, B)) return;
          H.moveStart(), H.skip(B.length);
          let Q, N = "";
          for (; (Q = H.getByte()) > 32 && N.length < 7; ) N += String.fromCharCode(Q);
          p.PDF_VERSION_REGEXP.test(N) ? this._version = N : (0, o.warn)(`Invalid PDF header version: ${N}`);
        }
        parseStartXRef() {
          this.xref.setStartXRef(this.startXRef);
        }
        get numPages() {
          let H = 0;
          return H = this.catalog.hasActualNumPages ? this.catalog.numPages : this.xfaFactory ? this.xfaFactory.getNumPages() : this.linearization ? this.linearization.numPages : this.catalog.numPages, (0, o.shadow)(this, "numPages", H);
        }
        _hasOnlyDocumentSignatures(H, Q = 0) {
          return !!Array.isArray(H) && H.every((N) => {
            if (!((N = this.xref.fetchIfRef(N)) instanceof n.Dict)) return !1;
            if (N.has("Kids"))
              return ++Q > 10 ? ((0, o.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached"), !1) : this._hasOnlyDocumentSignatures(N.get("Kids"), Q);
            const V = (0, n.isName)(N.get("FT"), "Sig"), Y = N.get("Rect"), Z = Array.isArray(Y) && Y.every((rt) => rt === 0);
            return V && Z;
          });
        }
        get _xfaStreams() {
          const H = this.catalog.acroForm;
          if (!H) return null;
          const Q = H.get("XFA"), N = { "xdp:xdp": "", template: "", datasets: "", config: "", connectionSet: "", localeSet: "", stylesheet: "", "/xdp:xdp": "" };
          if (Q instanceof d.BaseStream && !Q.isEmpty)
            return N["xdp:xdp"] = Q, N;
          if (!Array.isArray(Q) || Q.length === 0) return null;
          for (let V = 0, Y = Q.length; V < Y; V += 2) {
            let Z;
            if (Z = V === 0 ? "xdp:xdp" : V === Y - 2 ? "/xdp:xdp" : Q[V], !N.hasOwnProperty(Z)) continue;
            const rt = this.xref.fetchIfRef(Q[V + 1]);
            rt instanceof d.BaseStream && !rt.isEmpty && (N[Z] = rt);
          }
          return N;
        }
        get xfaDatasets() {
          const H = this._xfaStreams;
          if (!H) return (0, o.shadow)(this, "xfaDatasets", null);
          for (const Q of ["datasets", "xdp:xdp"]) {
            const N = H[Q];
            if (N) try {
              const V = { [Q]: (0, o.stringToUTF8String)(N.getString()) };
              return (0, o.shadow)(this, "xfaDatasets", new v.DatasetReader(V));
            } catch {
              (0, o.warn)("XFA - Invalid utf-8 string.");
              break;
            }
          }
          return (0, o.shadow)(this, "xfaDatasets", null);
        }
        get xfaData() {
          const H = this._xfaStreams;
          if (!H) return null;
          const Q = /* @__PURE__ */ Object.create(null);
          for (const [N, V] of Object.entries(H)) if (V) try {
            Q[N] = (0, o.stringToUTF8String)(V.getString());
          } catch {
            return (0, o.warn)("XFA - Invalid utf-8 string."), null;
          }
          return Q;
        }
        get xfaFactory() {
          let H;
          return this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && (H = this.xfaData), (0, o.shadow)(this, "xfaFactory", H ? new W.XFAFactory(H) : null);
        }
        get isPureXfa() {
          return !!this.xfaFactory && this.xfaFactory.isValid();
        }
        get htmlForXfa() {
          return this.xfaFactory ? this.xfaFactory.getPages() : null;
        }
        async loadXfaImages() {
          const H = await this.pdfManager.ensureCatalog("xfaImages");
          if (!H) return;
          const Q = H.getKeys();
          await new _.ObjectLoader(H, Q, this.xref).load();
          const V = /* @__PURE__ */ new Map();
          for (const Y of Q) {
            const Z = H.get(Y);
            Z instanceof d.BaseStream && V.set(Y, Z.getBytes());
          }
          this.xfaFactory.setImages(V);
        }
        async loadXfaFonts(H, Q) {
          const N = await this.pdfManager.ensureCatalog("acroForm");
          if (!N) return;
          const V = await N.getAsync("DR");
          if (!(V instanceof n.Dict)) return;
          await new _.ObjectLoader(V, ["Font"], this.xref).load();
          const Z = V.get("Font");
          if (!(Z instanceof n.Dict)) return;
          const rt = Object.assign(/* @__PURE__ */ Object.create(null), this.pdfManager.evaluatorOptions);
          rt.useSystemFonts = !1;
          const st = new O.PartialEvaluator({ xref: this.xref, handler: H, pageIndex: -1, idFactory: this._globalIdFactory, fontCache: this.catalog.fontCache, builtInCMapCache: this.catalog.builtInCMapCache, standardFontDataCache: this.catalog.standardFontDataCache, options: rt }), mt = new M.OperatorList(), yt = [], at = { get font() {
            return yt.at(-1);
          }, set font(et) {
            yt.push(et);
          }, clone() {
            return this;
          } }, nt = /* @__PURE__ */ new Map();
          Z.forEach((et, J) => {
            nt.set(et, J);
          });
          const q = [];
          for (const [et, J] of nt) {
            const it = J.get("FontDescriptor");
            if (!(it instanceof n.Dict)) continue;
            let lt = it.get("FontFamily");
            lt = lt.replaceAll(/[ ]+(\d)/g, "$1");
            const ot = { fontFamily: lt, fontWeight: it.get("FontWeight"), italicAngle: -it.get("ItalicAngle") };
            (0, p.validateCSSFont)(ot) && q.push(st.handleSetFont(V, [n.Name.get(et), 1], null, mt, Q, at, null, ot).catch(function(ut) {
              return (0, o.warn)(`loadXfaFonts: "${ut}".`), null;
            }));
          }
          await Promise.all(q);
          const D = this.xfaFactory.setFonts(yt);
          if (!D) return;
          rt.ignoreErrors = !0, q.length = 0, yt.length = 0;
          const G = /* @__PURE__ */ new Set();
          for (const et of D) (0, a.getXfaFontName)(`${et}-Regular`) || G.add(et);
          G.size && D.push("PdfJS-Fallback");
          for (const et of D) if (!G.has(et)) for (const J of [{ name: "Regular", fontWeight: 400, italicAngle: 0 }, { name: "Bold", fontWeight: 700, italicAngle: 0 }, { name: "Italic", fontWeight: 400, italicAngle: 12 }, { name: "BoldItalic", fontWeight: 700, italicAngle: 12 }]) {
            const it = `${et}-${J.name}`, lt = (0, a.getXfaFontDict)(it);
            q.push(st.handleSetFont(V, [n.Name.get(it), 1], null, mt, Q, at, lt, { fontFamily: et, fontWeight: J.fontWeight, italicAngle: J.italicAngle }).catch(function(ot) {
              return (0, o.warn)(`loadXfaFonts: "${ot}".`), null;
            }));
          }
          await Promise.all(q), this.xfaFactory.appendFonts(yt, G);
        }
        async serializeXfaData(H) {
          return this.xfaFactory ? this.xfaFactory.serializeData(H) : null;
        }
        get version() {
          return this.catalog.version || this._version;
        }
        get formInfo() {
          const H = { hasFields: !1, hasAcroForm: !1, hasXfa: !1, hasSignatures: !1 }, Q = this.catalog.acroForm;
          if (!Q) return (0, o.shadow)(this, "formInfo", H);
          try {
            const N = Q.get("Fields"), V = Array.isArray(N) && N.length > 0;
            H.hasFields = V;
            const Y = Q.get("XFA");
            H.hasXfa = Array.isArray(Y) && Y.length > 0 || Y instanceof d.BaseStream && !Y.isEmpty;
            const Z = !!(1 & Q.get("SigFlags")), rt = Z && this._hasOnlyDocumentSignatures(N);
            H.hasAcroForm = V && !rt, H.hasSignatures = Z;
          } catch (N) {
            if (N instanceof p.MissingDataException) throw N;
            (0, o.warn)(`Cannot fetch form information: "${N}".`);
          }
          return (0, o.shadow)(this, "formInfo", H);
        }
        get documentInfo() {
          const H = { PDFFormatVersion: this.version, Language: this.catalog.lang, EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null, IsLinearized: !!this.linearization, IsAcroFormPresent: this.formInfo.hasAcroForm, IsXFAPresent: this.formInfo.hasXfa, IsCollectionPresent: !!this.catalog.collection, IsSignaturesPresent: this.formInfo.hasSignatures };
          let Q;
          try {
            Q = this.xref.trailer.get("Info");
          } catch (N) {
            if (N instanceof p.MissingDataException) throw N;
            (0, o.info)("The document information dictionary is invalid.");
          }
          if (!(Q instanceof n.Dict)) return (0, o.shadow)(this, "documentInfo", H);
          for (const N of Q.getKeys()) {
            const V = Q.get(N);
            switch (N) {
              case "Title":
              case "Author":
              case "Subject":
              case "Keywords":
              case "Creator":
              case "Producer":
              case "CreationDate":
              case "ModDate":
                if (typeof V == "string") {
                  H[N] = (0, o.stringToPDFString)(V);
                  continue;
                }
                break;
              case "Trapped":
                if (V instanceof n.Name) {
                  H[N] = V;
                  continue;
                }
                break;
              default:
                let Y;
                switch (typeof V) {
                  case "string":
                    Y = (0, o.stringToPDFString)(V);
                    break;
                  case "number":
                  case "boolean":
                    Y = V;
                    break;
                  default:
                    V instanceof n.Name && (Y = V);
                }
                if (Y === void 0) {
                  (0, o.warn)(`Bad value, for custom key "${N}", in Info: ${V}.`);
                  continue;
                }
                H.Custom || (H.Custom = /* @__PURE__ */ Object.create(null)), H.Custom[N] = Y;
                continue;
            }
            (0, o.warn)(`Bad value, for key "${N}", in Info: ${V}.`);
          }
          return (0, o.shadow)(this, "documentInfo", H);
        }
        get fingerprints() {
          function H(Z) {
            return typeof Z == "string" && Z.length > 0 && Z !== "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          }
          function Q(Z) {
            const rt = [];
            for (const st of Z) {
              const mt = st.toString(16);
              rt.push(mt.padStart(2, "0"));
            }
            return rt.join("");
          }
          const N = this.xref.trailer.get("ID");
          let V, Y;
          return Array.isArray(N) && H(N[0]) ? (V = (0, o.stringToBytes)(N[0]), N[1] !== N[0] && H(N[1]) && (Y = (0, o.stringToBytes)(N[1]))) : V = (0, m.calculateMD5)(this.stream.getByteRange(0, 1024), 0, 1024), (0, o.shadow)(this, "fingerprints", [Q(V), Y ? Q(Y) : null]);
        }
        async _getLinearizationPage(H) {
          const { catalog: Q, linearization: N, xref: V } = this, Y = n.Ref.get(N.objectNumberFirst, 0);
          try {
            const Z = await V.fetchAsync(Y);
            if (Z instanceof n.Dict) {
              let rt = Z.getRaw("Type");
              if (rt instanceof n.Ref && (rt = await V.fetchAsync(rt)), (0, n.isName)(rt, "Page") || !Z.has("Type") && !Z.has("Kids"))
                return Q.pageKidsCountCache.has(Y) || Q.pageKidsCountCache.put(Y, 1), Q.pageIndexCache.has(Y) || Q.pageIndexCache.put(Y, 0), [Z, Y];
            }
            throw new o.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
          } catch (Z) {
            return (0, o.warn)(`_getLinearizationPage: "${Z.message}".`), Q.getPageDict(H);
          }
        }
        getPage(H) {
          const Q = this._pagePromises.get(H);
          if (Q) return Q;
          const { catalog: N, linearization: V, xfaFactory: Y } = this;
          let Z;
          return Z = Y ? Promise.resolve([n.Dict.empty, null]) : (V == null ? void 0 : V.pageFirst) === H ? this._getLinearizationPage(H) : N.getPageDict(H), Z = Z.then(([rt, st]) => new $({ pdfManager: this.pdfManager, xref: this.xref, pageIndex: H, pageDict: rt, ref: st, globalIdFactory: this._globalIdFactory, fontCache: N.fontCache, builtInCMapCache: N.builtInCMapCache, standardFontDataCache: N.standardFontDataCache, globalImageCache: N.globalImageCache, systemFontCache: N.systemFontCache, nonBlendModesSet: N.nonBlendModesSet, xfaFactory: Y })), this._pagePromises.set(H, Z), Z;
        }
        async checkFirstPage(H = !1) {
          if (!H) try {
            await this.getPage(0);
          } catch (Q) {
            if (Q instanceof p.XRefEntryException)
              throw this._pagePromises.delete(0), await this.cleanup(), new p.XRefParseException();
          }
        }
        async checkLastPage(H = !1) {
          const { catalog: Q, pdfManager: N } = this;
          Q.setActualNumPages();
          let V;
          try {
            if (await Promise.all([N.ensureDoc("xfaFactory"), N.ensureDoc("linearization"), N.ensureCatalog("numPages")]), this.xfaFactory) return;
            if (V = this.linearization ? this.linearization.numPages : Q.numPages, !Number.isInteger(V)) throw new o.FormatError("Page count is not an integer.");
            if (V <= 1) return;
            await this.getPage(V - 1);
          } catch (Y) {
            if (this._pagePromises.delete(V - 1), await this.cleanup(), Y instanceof p.XRefEntryException && !H) throw new p.XRefParseException();
            (0, o.warn)(`checkLastPage - invalid /Pages tree /Count: ${V}.`);
            let Z;
            try {
              Z = await Q.getAllPageDicts(H);
            } catch (rt) {
              if (rt instanceof p.XRefEntryException && !H) throw new p.XRefParseException();
              Q.setActualNumPages(1);
              return;
            }
            for (const [rt, [st, mt]] of Z) {
              let yt;
              st instanceof Error ? (yt = Promise.reject(st), yt.catch(() => {
              })) : yt = Promise.resolve(new $({ pdfManager: N, xref: this.xref, pageIndex: rt, pageDict: st, ref: mt, globalIdFactory: this._globalIdFactory, fontCache: Q.fontCache, builtInCMapCache: Q.builtInCMapCache, standardFontDataCache: Q.standardFontDataCache, globalImageCache: Q.globalImageCache, systemFontCache: Q.systemFontCache, nonBlendModesSet: Q.nonBlendModesSet, xfaFactory: null })), this._pagePromises.set(rt, yt);
            }
            Q.setActualNumPages(Z.size);
          }
        }
        fontFallback(H, Q) {
          return this.catalog.fontFallback(H, Q);
        }
        async cleanup(H = !1) {
          return this.catalog ? this.catalog.cleanup(H) : (0, w.clearGlobalCaches)();
        }
        get fieldObjects() {
          if (!this.formInfo.hasFields) return (0, o.shadow)(this, "fieldObjects", Promise.resolve(null));
          const H = this.pdfManager.ensureDoc("annotationGlobals").then(async (Q) => {
            if (!Q) return null;
            const N = /* @__PURE__ */ Object.create(null), V = /* @__PURE__ */ new Map();
            for (const Z of this.catalog.acroForm.get("Fields")) Le(this, U, G9).call(this, "", Z, V, Q);
            const Y = [];
            for (const [Z, rt] of V) Y.push(Promise.all(rt).then((st) => {
              (st = st.filter((mt) => !!mt)).length > 0 && (N[Z] = st);
            }));
            return await Promise.all(Y), N;
          });
          return (0, o.shadow)(this, "fieldObjects", H);
        }
        get hasJSActions() {
          const H = this.pdfManager.ensureDoc("_parseHasJSActions");
          return (0, o.shadow)(this, "hasJSActions", H);
        }
        async _parseHasJSActions() {
          const [H, Q] = await Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
          return !!H || !!Q && Object.values(Q).some((N) => N.some((V) => V.actions !== null));
        }
        get calculationOrderIds() {
          const H = this.catalog.acroForm;
          if (!(H != null && H.has("CO"))) return (0, o.shadow)(this, "calculationOrderIds", null);
          const Q = H.get("CO");
          if (!Array.isArray(Q) || Q.length === 0) return (0, o.shadow)(this, "calculationOrderIds", null);
          const N = [];
          for (const V of Q) V instanceof n.Ref && N.push(V.toString());
          return N.length === 0 ? (0, o.shadow)(this, "calculationOrderIds", null) : (0, o.shadow)(this, "calculationOrderIds", N);
        }
        get annotationGlobals() {
          return (0, o.shadow)(this, "annotationGlobals", g.AnnotationFactory.createGlobals(this.pdfManager));
        }
      }, U = new WeakSet(), G9 = function(H, Q, N, V) {
        const Y = this.xref.fetchIfRef(Q);
        if (Y.has("T")) {
          const Z = (0, o.stringToPDFString)(Y.get("T"));
          H = H === "" ? Z : `${H}.${Z}`;
        }
        if (N.has(H) || N.set(H, []), N.get(H).push(g.AnnotationFactory.create(this.xref, Q, V, this._localIdFactory, !0, null).then((Z) => Z == null ? void 0 : Z.getFieldObject()).catch(function(Z) {
          return (0, o.warn)(`#collectFieldObjects: "${Z}".`), null;
        })), Y.has("Kids")) for (const Z of Y.get("Kids")) Le(this, U, G9).call(this, H, Z, N, V);
      }, X);
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PopupAnnotation = l.MarkupAnnotation = l.AnnotationFactory = l.AnnotationBorderStyle = l.Annotation = void 0, l.getQuadPoints = R;
      var o = f(2), g = f(3), p = f(11), n = f(4), a = f(8), d = f(5), m = f(60), b = f(66), w = f(12), v = f(69), h = f(26), x = f(76), _ = f(64), M = f(73), O = f(77);
      l.AnnotationFactory = class {
        static createGlobals(D) {
          return Promise.all([D.ensureCatalog("acroForm"), D.ensureDoc("xfaDatasets"), D.ensureCatalog("structTreeRoot"), D.ensureCatalog("baseUrl"), D.ensureCatalog("attachments")]).then(([G, et, J, it, lt]) => ({ pdfManager: D, acroForm: G instanceof n.Dict ? G : n.Dict.empty, xfaDatasets: et, structTreeRoot: J, baseUrl: it, attachments: lt }), (G) => ((0, o.warn)(`createGlobals: "${G}".`), null));
        }
        static async create(D, G, et, J, it, lt) {
          const ot = it ? await this._getPageIndex(D, G, et.pdfManager) : null;
          return et.pdfManager.ensure(this, "_create", [D, G, et, J, it, ot, lt]);
        }
        static _create(D, G, et, J, it = !1, lt = null, ot = null) {
          const ut = D.fetchIfRef(G);
          if (!(ut instanceof n.Dict)) return;
          const { acroForm: ct, pdfManager: gt } = et, dt = G instanceof n.Ref ? G.toString() : `annot_${J.createObjId()}`;
          let bt = ut.get("Subtype");
          bt = bt instanceof n.Name ? bt.name : null;
          const vt = { xref: D, ref: G, dict: ut, subtype: bt, id: dt, annotationGlobals: et, collectFields: it, needAppearances: !it && ct.get("NeedAppearances") === !0, pageIndex: lt, evaluatorOptions: gt.evaluatorOptions, pageRef: ot };
          switch (bt) {
            case "Link":
              return new U(vt);
            case "Text":
              return new A(vt);
            case "Widget":
              let xt = (0, g.getInheritableProperty)({ dict: ut, key: "FT" });
              switch (xt = xt instanceof n.Name ? xt.name : null, xt) {
                case "Tx":
                  return new C(vt);
                case "Btn":
                  return new T(vt);
                case "Ch":
                  return new F(vt);
                case "Sig":
                  return new S(vt);
              }
              return (0, o.warn)(`Unimplemented widget field type "${xt}", falling back to base field type.`), new B(vt);
            case "Popup":
              return new K(vt);
            case "FreeText":
              return new X(vt);
            case "Line":
              return new L(vt);
            case "Square":
              return new H(vt);
            case "Circle":
              return new Q(vt);
            case "PolyLine":
              return new N(vt);
            case "Polygon":
              return new V(vt);
            case "Caret":
              return new Y(vt);
            case "Ink":
              return new Z(vt);
            case "Highlight":
              return new rt(vt);
            case "Underline":
              return new st(vt);
            case "Squiggly":
              return new mt(vt);
            case "StrikeOut":
              return new yt(vt);
            case "Stamp":
              return new at(vt);
            case "FileAttachment":
              return new nt(vt);
            default:
              return it || (bt ? (0, o.warn)(`Unimplemented annotation type "${bt}", falling back to base annotation.`) : (0, o.warn)("Annotation is missing the required /Subtype.")), new z(vt);
          }
        }
        static async _getPageIndex(D, G, et) {
          try {
            const J = await D.fetchIfRefAsync(G);
            if (!(J instanceof n.Dict)) return -1;
            const it = J.getRaw("P");
            if (it instanceof n.Ref) try {
              return await et.ensureCatalog("getPageIndex", [it]);
            } catch (ot) {
              (0, o.info)(`_getPageIndex -- not a valid page reference: "${ot}".`);
            }
            if (J.has("Kids")) return -1;
            const lt = await et.ensureDoc("numPages");
            for (let ot = 0; ot < lt; ot++) {
              const ut = await et.getPage(ot), ct = await et.ensure(ut, "annotations");
              for (const gt of ct) if (gt instanceof n.Ref && (0, n.isRefsEqual)(gt, G)) return ot;
            }
          } catch (J) {
            (0, o.warn)(`_getPageIndex: "${J}".`);
          }
          return -1;
        }
        static generateImages(D, G, et) {
          if (!et)
            return (0, o.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images."), null;
          let J;
          for (const { bitmapId: it, bitmap: lt } of D) lt && (J || (J = /* @__PURE__ */ new Map()), J.set(it, at.createImage(lt, G)));
          return J;
        }
        static async saveNewAnnotations(D, G, et, J) {
          const it = D.xref;
          let lt;
          const ot = [], ut = [], { isOffscreenCanvasSupported: ct } = D.options;
          for (const gt of et) if (!gt.deleted) switch (gt.annotationType) {
            case o.AnnotationEditorType.FREETEXT:
              if (!lt) {
                const bt = new n.Dict(it);
                bt.set("BaseFont", n.Name.get("Helvetica")), bt.set("Type", n.Name.get("Font")), bt.set("Subtype", n.Name.get("Type1")), bt.set("Encoding", n.Name.get("WinAnsiEncoding"));
                const vt = [];
                lt = it.getNewTemporaryRef(), await (0, M.writeObject)(lt, bt, vt, it), ot.push({ ref: lt, data: vt.join("") });
              }
              ut.push(X.createNewAnnotation(it, gt, ot, { evaluator: D, task: G, baseFontRef: lt }));
              break;
            case o.AnnotationEditorType.INK:
              ut.push(Z.createNewAnnotation(it, gt, ot));
              break;
            case o.AnnotationEditorType.STAMP:
              if (!ct) break;
              const dt = await J.get(gt.bitmapId);
              if (dt.imageStream) {
                const { imageStream: bt, smaskStream: vt } = dt, xt = [];
                if (vt) {
                  const Mt = it.getNewTemporaryRef();
                  await (0, M.writeObject)(Mt, vt, xt, it), ot.push({ ref: Mt, data: xt.join("") }), bt.dict.set("SMask", Mt), xt.length = 0;
                }
                const St = dt.imageRef = it.getNewTemporaryRef();
                await (0, M.writeObject)(St, bt, xt, it), ot.push({ ref: St, data: xt.join("") }), dt.imageStream = dt.smaskStream = null;
              }
              ut.push(at.createNewAnnotation(it, gt, ot, { image: dt }));
          }
          return { annotations: await Promise.all(ut), dependencies: ot };
        }
        static async printNewAnnotations(D, G, et, J, it) {
          if (!J) return null;
          const { options: lt, xref: ot } = G, ut = [];
          for (const ct of J) if (!ct.deleted) switch (ct.annotationType) {
            case o.AnnotationEditorType.FREETEXT:
              ut.push(X.createNewPrintAnnotation(D, ot, ct, { evaluator: G, task: et, evaluatorOptions: lt }));
              break;
            case o.AnnotationEditorType.INK:
              ut.push(Z.createNewPrintAnnotation(D, ot, ct, { evaluatorOptions: lt }));
              break;
            case o.AnnotationEditorType.STAMP:
              if (!lt.isOffscreenCanvasSupported) break;
              const gt = await it.get(ct.bitmapId);
              if (gt.imageStream) {
                const { imageStream: dt, smaskStream: bt } = gt;
                bt && dt.dict.set("SMask", bt), gt.imageRef = new h.JpegStream(dt, dt.length), gt.imageStream = gt.smaskStream = null;
              }
              ut.push(at.createNewPrintAnnotation(D, ot, ct, { image: gt, evaluatorOptions: lt }));
          }
          return Promise.all(ut);
        }
      };
      function E(q, D = new Uint8ClampedArray(3)) {
        if (!Array.isArray(q)) return D;
        const G = D || new Uint8ClampedArray(3);
        switch (q.length) {
          case 0:
            return null;
          case 1:
            return w.ColorSpace.singletons.gray.getRgbItem(q, 0, G, 0), G;
          case 3:
            return w.ColorSpace.singletons.rgb.getRgbItem(q, 0, G, 0), G;
          case 4:
            return w.ColorSpace.singletons.cmyk.getRgbItem(q, 0, G, 0), G;
          default:
            return D;
        }
      }
      function I(q) {
        return Array.from(q, (D) => D / 255);
      }
      function R(q, D) {
        const G = q.getArray("QuadPoints");
        if (!Array.isArray(G) || G.length === 0 || G.length % 8 > 0) return null;
        const et = [];
        for (let J = 0, it = G.length / 8; J < it; J++) {
          let lt = 1 / 0, ot = -1 / 0, ut = 1 / 0, ct = -1 / 0;
          for (let gt = 8 * J, dt = 8 * J + 8; gt < dt; gt += 2) {
            const bt = G[gt], vt = G[gt + 1];
            lt = Math.min(bt, lt), ot = Math.max(bt, ot), ut = Math.min(vt, ut), ct = Math.max(vt, ct);
          }
          if (D !== null && (lt < D[0] || ot > D[2] || ut < D[1] || ct > D[3])) return null;
          et.push([{ x: lt, y: ct }, { x: ot, y: ct }, { x: lt, y: ut }, { x: ot, y: ut }]);
        }
        return et;
      }
      function W(q, D, G) {
        const [et, J, it, lt] = o.Util.getAxialAlignedBoundingBox(D, G);
        if (et === it || J === lt) return [1, 0, 0, 1, q[0], q[1]];
        const ot = (q[2] - q[0]) / (it - et), ut = (q[3] - q[1]) / (lt - J);
        return [ot, 0, 0, ut, q[0] - et * ot, q[1] - J * ut];
      }
      class z {
        constructor(D) {
          const { dict: G, xref: et, annotationGlobals: J } = D;
          this.setTitle(G.get("T")), this.setContents(G.get("Contents")), this.setModificationDate(G.get("M")), this.setFlags(G.get("F")), this.setRectangle(G.getArray("Rect")), this.setColor(G.getArray("C")), this.setBorderStyle(G), this.setAppearance(G), this.setOptionalContent(G);
          const it = G.get("MK");
          this.setBorderAndBackgroundColors(it), this.setRotation(it, G), this.ref = D.ref instanceof n.Ref ? D.ref : null, this._streams = [], this.appearance && this._streams.push(this.appearance);
          const lt = !!(this.flags & o.AnnotationFlag.LOCKED), ot = !!(this.flags & o.AnnotationFlag.LOCKEDCONTENTS);
          if (J.structTreeRoot) {
            let ut = G.get("StructParent");
            ut = Number.isInteger(ut) && ut >= 0 ? ut : -1, J.structTreeRoot.addAnnotationIdToPage(D.pageRef, ut);
          }
          if (this.data = { annotationFlags: this.flags, borderStyle: this.borderStyle, color: this.color, backgroundColor: this.backgroundColor, borderColor: this.borderColor, rotation: this.rotation, contentsObj: this._contents, hasAppearance: !!this.appearance, id: D.id, modificationDate: this.modificationDate, rect: this.rectangle, subtype: D.subtype, hasOwnCanvas: !1, noRotate: !!(this.flags & o.AnnotationFlag.NOROTATE), noHTML: lt && ot }, D.collectFields) {
            const ut = G.get("Kids");
            if (Array.isArray(ut)) {
              const ct = [];
              for (const gt of ut) gt instanceof n.Ref && ct.push(gt.toString());
              ct.length !== 0 && (this.data.kidIds = ct);
            }
            this.data.actions = (0, g.collectActions)(et, G, o.AnnotationActionEventType), this.data.fieldName = this._constructFieldName(G), this.data.pageIndex = D.pageIndex;
          }
          this._isOffscreenCanvasSupported = D.evaluatorOptions.isOffscreenCanvasSupported, this._fallbackFontDict = null, this._needAppearances = !1;
        }
        _hasFlag(D, G) {
          return !!(D & G);
        }
        _isViewable(D) {
          return !this._hasFlag(D, o.AnnotationFlag.INVISIBLE) && !this._hasFlag(D, o.AnnotationFlag.NOVIEW);
        }
        _isPrintable(D) {
          return this._hasFlag(D, o.AnnotationFlag.PRINT) && !this._hasFlag(D, o.AnnotationFlag.HIDDEN) && !this._hasFlag(D, o.AnnotationFlag.INVISIBLE);
        }
        mustBeViewed(D, G) {
          var J;
          const et = (J = D == null ? void 0 : D.get(this.data.id)) == null ? void 0 : J.noView;
          return et !== void 0 ? !et : this.viewable && !this._hasFlag(this.flags, o.AnnotationFlag.HIDDEN);
        }
        mustBePrinted(D) {
          var et;
          const G = (et = D == null ? void 0 : D.get(this.data.id)) == null ? void 0 : et.noPrint;
          return G !== void 0 ? !G : this.printable;
        }
        get viewable() {
          return this.data.quadPoints !== null && (this.flags === 0 || this._isViewable(this.flags));
        }
        get printable() {
          return this.data.quadPoints !== null && this.flags !== 0 && this._isPrintable(this.flags);
        }
        _parseStringHelper(D) {
          const G = typeof D == "string" ? (0, o.stringToPDFString)(D) : "";
          return { str: G, dir: G && (0, m.bidi)(G).dir === "rtl" ? "rtl" : "ltr" };
        }
        setDefaultAppearance(D) {
          const { dict: G, annotationGlobals: et } = D, J = (0, g.getInheritableProperty)({ dict: G, key: "DA" }) || et.acroForm.get("DA");
          this._defaultAppearance = typeof J == "string" ? J : "", this.data.defaultAppearanceData = (0, p.parseDefaultAppearance)(this._defaultAppearance);
        }
        setTitle(D) {
          this._title = this._parseStringHelper(D);
        }
        setContents(D) {
          this._contents = this._parseStringHelper(D);
        }
        setModificationDate(D) {
          this.modificationDate = typeof D == "string" ? D : null;
        }
        setFlags(D) {
          this.flags = Number.isInteger(D) && D > 0 ? D : 0;
        }
        hasFlag(D) {
          return this._hasFlag(this.flags, D);
        }
        setRectangle(D) {
          this.rectangle = Array.isArray(D) && D.length === 4 ? o.Util.normalizeRect(D) : [0, 0, 0, 0];
        }
        setColor(D) {
          this.color = E(D);
        }
        setLineEndings(D) {
          if (this.lineEndings = ["None", "None"], Array.isArray(D) && D.length === 2) for (let G = 0; G < 2; G++) {
            const et = D[G];
            if (et instanceof n.Name) switch (et.name) {
              case "None":
                continue;
              case "Square":
              case "Circle":
              case "Diamond":
              case "OpenArrow":
              case "ClosedArrow":
              case "Butt":
              case "ROpenArrow":
              case "RClosedArrow":
              case "Slash":
                this.lineEndings[G] = et.name;
                continue;
            }
            (0, o.warn)(`Ignoring invalid lineEnding: ${et}`);
          }
        }
        setRotation(D, G) {
          this.rotation = 0;
          let et = D instanceof n.Dict ? D.get("R") || 0 : G.get("Rotate") || 0;
          Number.isInteger(et) && et !== 0 && (et %= 360, et < 0 && (et += 360), et % 90 == 0 && (this.rotation = et));
        }
        setBorderAndBackgroundColors(D) {
          D instanceof n.Dict ? (this.borderColor = E(D.getArray("BC"), null), this.backgroundColor = E(D.getArray("BG"), null)) : this.borderColor = this.backgroundColor = null;
        }
        setBorderStyle(D) {
          if (this.borderStyle = new j(), D instanceof n.Dict) if (D.has("BS")) {
            const G = D.get("BS"), et = G.get("Type");
            (!et || (0, n.isName)(et, "Border")) && (this.borderStyle.setWidth(G.get("W"), this.rectangle), this.borderStyle.setStyle(G.get("S")), this.borderStyle.setDashArray(G.getArray("D")));
          } else if (D.has("Border")) {
            const G = D.getArray("Border");
            Array.isArray(G) && G.length >= 3 && (this.borderStyle.setHorizontalCornerRadius(G[0]), this.borderStyle.setVerticalCornerRadius(G[1]), this.borderStyle.setWidth(G[2], this.rectangle), G.length === 4 && this.borderStyle.setDashArray(G[3], !0));
          } else this.borderStyle.setWidth(0);
        }
        setAppearance(D) {
          this.appearance = null;
          const G = D.get("AP");
          if (!(G instanceof n.Dict)) return;
          const et = G.get("N");
          if (et instanceof d.BaseStream) {
            this.appearance = et;
            return;
          }
          if (!(et instanceof n.Dict)) return;
          const J = D.get("AS");
          if (!(J instanceof n.Name && et.has(J.name))) return;
          const it = et.get(J.name);
          it instanceof d.BaseStream && (this.appearance = it);
        }
        setOptionalContent(D) {
          this.oc = null;
          const G = D.get("OC");
          G instanceof n.Name ? (0, o.warn)("setOptionalContent: Support for /Name-entry is not implemented.") : G instanceof n.Dict && (this.oc = G);
        }
        loadResources(D, G) {
          return G.dict.getAsync("Resources").then((et) => {
            if (et)
              return new x.ObjectLoader(et, D, et.xref).load().then(function() {
                return et;
              });
          });
        }
        async getOperatorList(D, G, et, J, it) {
          const lt = this.data;
          let ot = this.appearance;
          const ut = !!(this.data.hasOwnCanvas && et & o.RenderingIntentFlag.DISPLAY);
          if (!ot) {
            if (!ut) return { opList: new _.OperatorList(), separateForm: !1, separateCanvas: !1 };
            ot = new a.StringStream(""), ot.dict = new n.Dict();
          }
          const ct = ot.dict, gt = await this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], ot), dt = ct.getArray("BBox") || [0, 0, 1, 1], bt = ct.getArray("Matrix") || [1, 0, 0, 1, 0, 0], vt = W(lt.rect, dt, bt), xt = new _.OperatorList();
          let St;
          return this.oc && (St = await D.parseMarkedContentProps(this.oc, null)), St !== void 0 && xt.addOp(o.OPS.beginMarkedContentProps, ["OC", St]), xt.addOp(o.OPS.beginAnnotation, [lt.id, lt.rect, vt, bt, ut]), await D.getOperatorList({ stream: ot, task: G, resources: gt, operatorList: xt, fallbackFontDict: this._fallbackFontDict }), xt.addOp(o.OPS.endAnnotation, []), St !== void 0 && xt.addOp(o.OPS.endMarkedContent, []), this.reset(), { opList: xt, separateForm: !1, separateCanvas: ut };
        }
        async save(D, G, et) {
          return null;
        }
        get hasTextContent() {
          return !1;
        }
        async extractTextContent(D, G, et) {
          if (!this.appearance) return;
          const J = await this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance), it = [], lt = [];
          let ot = null;
          const ut = { desiredSize: Math.Infinity, ready: !0, enqueue(ct, gt) {
            for (const dt of ct.items) dt.str !== void 0 && (ot || (ot = dt.transform.slice(-2)), lt.push(dt.str), dt.hasEOL && (it.push(lt.join("")), lt.length = 0));
          } };
          if (await D.getTextContent({ stream: this.appearance, task: G, resources: J, includeMarkedContent: !0, sink: ut, viewBox: et }), this.reset(), lt.length && it.push(lt.join("")), it.length > 1 || it[0]) {
            const ct = this.appearance.dict, gt = ct.getArray("BBox") || [0, 0, 1, 1], dt = ct.getArray("Matrix") || [1, 0, 0, 1, 0, 0], bt = this.data.rect, vt = W(bt, gt, dt);
            vt[4] -= bt[0], vt[5] -= bt[1], ot = o.Util.applyTransform(ot, vt), ot = o.Util.applyTransform(ot, dt), this.data.textPosition = ot, this.data.textContent = it;
          }
        }
        getFieldObject() {
          return this.data.kidIds ? { id: this.data.id, actions: this.data.actions, name: this.data.fieldName, strokeColor: this.data.borderColor, fillColor: this.data.backgroundColor, type: "", kidIds: this.data.kidIds, page: this.data.pageIndex, rotation: this.rotation } : null;
        }
        reset() {
          for (const D of this._streams) D.reset();
        }
        _constructFieldName(D) {
          if (!D.has("T") && !D.has("Parent"))
            return (0, o.warn)("Unknown field name, falling back to empty field name."), "";
          if (!D.has("Parent")) return (0, o.stringToPDFString)(D.get("T"));
          const G = [];
          D.has("T") && G.unshift((0, o.stringToPDFString)(D.get("T")));
          let et = D;
          const J = new n.RefSet();
          for (D.objId && J.put(D.objId); et.has("Parent") && (et = et.get("Parent"), !(!(et instanceof n.Dict) || et.objId && J.has(et.objId))); )
            et.objId && J.put(et.objId), et.has("T") && G.unshift((0, o.stringToPDFString)(et.get("T")));
          return G.join(".");
        }
      }
      l.Annotation = z;
      class j {
        constructor() {
          this.width = 1, this.style = o.AnnotationBorderStyleType.SOLID, this.dashArray = [3], this.horizontalCornerRadius = 0, this.verticalCornerRadius = 0;
        }
        setWidth(D, G = [0, 0, 0, 0]) {
          if (D instanceof n.Name) this.width = 0;
          else if (typeof D == "number") {
            if (D > 0) {
              const et = (G[2] - G[0]) / 2, J = (G[3] - G[1]) / 2;
              et > 0 && J > 0 && (D > et || D > J) && ((0, o.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${D}`), D = 1);
            }
            this.width = D;
          }
        }
        setStyle(D) {
          if (D instanceof n.Name) switch (D.name) {
            case "S":
              this.style = o.AnnotationBorderStyleType.SOLID;
              break;
            case "D":
              this.style = o.AnnotationBorderStyleType.DASHED;
              break;
            case "B":
              this.style = o.AnnotationBorderStyleType.BEVELED;
              break;
            case "I":
              this.style = o.AnnotationBorderStyleType.INSET;
              break;
            case "U":
              this.style = o.AnnotationBorderStyleType.UNDERLINE;
          }
        }
        setDashArray(D, G = !1) {
          if (Array.isArray(D) && D.length > 0) {
            let et = !0, J = !0;
            for (const it of D) {
              if (!(+it >= 0)) {
                et = !1;
                break;
              }
              it > 0 && (J = !1);
            }
            et && !J ? (this.dashArray = D, G && this.setStyle(n.Name.get("D"))) : this.width = 0;
          } else D && (this.width = 0);
        }
        setHorizontalCornerRadius(D) {
          Number.isInteger(D) && (this.horizontalCornerRadius = D);
        }
        setVerticalCornerRadius(D) {
          Number.isInteger(D) && (this.verticalCornerRadius = D);
        }
      }
      l.AnnotationBorderStyle = j;
      class $ extends z {
        constructor(D) {
          super(D);
          const { dict: G } = D;
          if (G.has("IRT")) {
            const J = G.getRaw("IRT");
            this.data.inReplyTo = J instanceof n.Ref ? J.toString() : null;
            const it = G.get("RT");
            this.data.replyType = it instanceof n.Name ? it.name : o.AnnotationReplyType.REPLY;
          }
          let et = null;
          if (this.data.replyType === o.AnnotationReplyType.GROUP) {
            const J = G.get("IRT");
            this.setTitle(J.get("T")), this.data.titleObj = this._title, this.setContents(J.get("Contents")), this.data.contentsObj = this._contents, J.has("CreationDate") ? (this.setCreationDate(J.get("CreationDate")), this.data.creationDate = this.creationDate) : this.data.creationDate = null, J.has("M") ? (this.setModificationDate(J.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, et = J.getRaw("Popup"), J.has("C") ? (this.setColor(J.getArray("C")), this.data.color = this.color) : this.data.color = null;
          } else
            this.data.titleObj = this._title, this.setCreationDate(G.get("CreationDate")), this.data.creationDate = this.creationDate, et = G.getRaw("Popup"), G.has("C") || (this.data.color = null);
          this.data.popupRef = et instanceof n.Ref ? et.toString() : null, G.has("RC") && (this.data.richText = O.XFAFactory.getRichTextAsHtml(G.get("RC")));
        }
        setCreationDate(D) {
          this.creationDate = typeof D == "string" ? D : null;
        }
        _setDefaultAppearance({ xref: D, extra: G, strokeColor: et, fillColor: J, blendMode: it, strokeAlpha: lt, fillAlpha: ot, pointsCallback: ut }) {
          let ct = Number.MAX_VALUE, gt = Number.MAX_VALUE, dt = Number.MIN_VALUE, bt = Number.MIN_VALUE;
          const vt = ["q"];
          G && vt.push(G), et && vt.push(`${et[0]} ${et[1]} ${et[2]} RG`), J && vt.push(`${J[0]} ${J[1]} ${J[2]} rg`);
          let xt = this.data.quadPoints;
          xt || (xt = [[{ x: this.rectangle[0], y: this.rectangle[3] }, { x: this.rectangle[2], y: this.rectangle[3] }, { x: this.rectangle[0], y: this.rectangle[1] }, { x: this.rectangle[2], y: this.rectangle[1] }]]);
          for (const re of xt) {
            const [le, Ce, ce, xe] = ut(vt, re);
            ct = Math.min(ct, le), dt = Math.max(dt, Ce), gt = Math.min(gt, ce), bt = Math.max(bt, xe);
          }
          vt.push("Q");
          const St = new n.Dict(D), Mt = new n.Dict(D);
          Mt.set("Subtype", n.Name.get("Form"));
          const Et = new a.StringStream(vt.join(" "));
          Et.dict = Mt, St.set("Fm0", Et);
          const Ft = new n.Dict(D);
          it && Ft.set("BM", n.Name.get(it)), typeof lt == "number" && Ft.set("CA", lt), typeof ot == "number" && Ft.set("ca", ot);
          const Wt = new n.Dict(D);
          Wt.set("GS0", Ft);
          const Kt = new n.Dict(D);
          Kt.set("ExtGState", Wt), Kt.set("XObject", St);
          const qt = new n.Dict(D);
          qt.set("Resources", Kt);
          const It = this.data.rect = [ct, gt, dt, bt];
          qt.set("BBox", It), this.appearance = new a.StringStream("/GS0 gs /Fm0 Do"), this.appearance.dict = qt, this._streams.push(this.appearance, Et);
        }
        static async createNewAnnotation(D, G, et, J) {
          const it = G.ref || (G.ref = D.getNewTemporaryRef()), lt = await this.createNewAppearanceStream(G, D, J), ot = [];
          let ut;
          if (lt) {
            const ct = D.getNewTemporaryRef();
            ut = this.createNewDict(G, D, { apRef: ct }), await (0, M.writeObject)(ct, lt, ot, D), et.push({ ref: ct, data: ot.join("") });
          } else ut = this.createNewDict(G, D, {});
          return Number.isInteger(G.parentTreeId) && ut.set("StructParent", G.parentTreeId), ot.length = 0, await (0, M.writeObject)(it, ut, ot, D), { ref: it, data: ot.join("") };
        }
        static async createNewPrintAnnotation(D, G, et, J) {
          const it = await this.createNewAppearanceStream(et, G, J), lt = this.createNewDict(et, G, { ap: it }), ot = new this.prototype.constructor({ dict: lt, xref: G, annotationGlobals: D, evaluatorOptions: J.evaluatorOptions });
          return et.ref && (ot.ref = ot.refToReplace = et.ref), ot;
        }
      }
      l.MarkupAnnotation = $;
      class B extends z {
        constructor(D) {
          var bt;
          super(D);
          const { dict: G, xref: et, annotationGlobals: J } = D, it = this.data;
          this._needAppearances = D.needAppearances, it.annotationType = o.AnnotationType.WIDGET, it.fieldName === void 0 && (it.fieldName = this._constructFieldName(G)), it.actions === void 0 && (it.actions = (0, g.collectActions)(et, G, o.AnnotationActionEventType));
          let lt = (0, g.getInheritableProperty)({ dict: G, key: "V", getArray: !0 });
          it.fieldValue = this._decodeFormValue(lt);
          const ot = (0, g.getInheritableProperty)({ dict: G, key: "DV", getArray: !0 });
          if (it.defaultFieldValue = this._decodeFormValue(ot), lt === void 0 && J.xfaDatasets) {
            const vt = this._title.str;
            vt && (this._hasValueFromXFA = !0, it.fieldValue = lt = J.xfaDatasets.getValue(vt));
          }
          lt === void 0 && it.defaultFieldValue !== null && (it.fieldValue = it.defaultFieldValue), it.alternativeText = (0, o.stringToPDFString)(G.get("TU") || ""), this.setDefaultAppearance(D), it.hasAppearance || (it.hasAppearance = this._needAppearances && it.fieldValue !== void 0 && it.fieldValue !== null);
          const ut = (0, g.getInheritableProperty)({ dict: G, key: "FT" });
          it.fieldType = ut instanceof n.Name ? ut.name : null;
          const ct = (0, g.getInheritableProperty)({ dict: G, key: "DR" }), gt = J.acroForm.get("DR"), dt = (bt = this.appearance) == null ? void 0 : bt.dict.get("Resources");
          this._fieldResources = { localResources: ct, acroFormResources: gt, appearanceResources: dt, mergedResources: n.Dict.merge({ xref: et, dictArray: [ct, dt, gt], mergeSubDicts: !0 }) }, it.fieldFlags = (0, g.getInheritableProperty)({ dict: G, key: "Ff" }), (!Number.isInteger(it.fieldFlags) || it.fieldFlags < 0) && (it.fieldFlags = 0), it.readOnly = this.hasFieldFlag(o.AnnotationFieldFlag.READONLY), it.required = this.hasFieldFlag(o.AnnotationFieldFlag.REQUIRED), it.hidden = this._hasFlag(it.annotationFlags, o.AnnotationFlag.HIDDEN) || this._hasFlag(it.annotationFlags, o.AnnotationFlag.NOVIEW);
        }
        _decodeFormValue(D) {
          return Array.isArray(D) ? D.filter((G) => typeof G == "string").map((G) => (0, o.stringToPDFString)(G)) : D instanceof n.Name ? (0, o.stringToPDFString)(D.name) : typeof D == "string" ? (0, o.stringToPDFString)(D) : null;
        }
        hasFieldFlag(D) {
          return !!(this.data.fieldFlags & D);
        }
        _isViewable(D) {
          return !this._hasFlag(D, o.AnnotationFlag.INVISIBLE);
        }
        mustBeViewed(D, G) {
          return G ? this.viewable : super.mustBeViewed(D, G) && !this._hasFlag(this.flags, o.AnnotationFlag.NOVIEW);
        }
        getRotationMatrix(D) {
          var it;
          let G = (it = D == null ? void 0 : D.get(this.data.id)) == null ? void 0 : it.rotation;
          if (G === void 0 && (G = this.rotation), G === 0) return o.IDENTITY_MATRIX;
          const et = this.data.rect[2] - this.data.rect[0], J = this.data.rect[3] - this.data.rect[1];
          return (0, g.getRotationMatrix)(G, et, J);
        }
        getBorderAndBackgroundAppearances(D) {
          var ot;
          let G = (ot = D == null ? void 0 : D.get(this.data.id)) == null ? void 0 : ot.rotation;
          if (G === void 0 && (G = this.rotation), !this.backgroundColor && !this.borderColor) return "";
          const et = this.data.rect[2] - this.data.rect[0], J = this.data.rect[3] - this.data.rect[1], it = G === 0 || G === 180 ? `0 0 ${et} ${J} re` : `0 0 ${J} ${et} re`;
          let lt = "";
          return this.backgroundColor && (lt = `${(0, p.getPdfColor)(this.backgroundColor, !0)} ${it} f `), this.borderColor && (lt += `${this.borderStyle.width || 1} w ${(0, p.getPdfColor)(this.borderColor, !1)} ${it} S `), lt;
        }
        async getOperatorList(D, G, et, J, it) {
          if (J && !(this instanceof S) && !this.data.noHTML && !this.data.hasOwnCanvas) return { opList: new _.OperatorList(), separateForm: !0, separateCanvas: !1 };
          if (!this._hasText) return super.getOperatorList(D, G, et, J, it);
          const lt = await this._getAppearance(D, G, et, it);
          if (this.appearance && lt === null) return super.getOperatorList(D, G, et, J, it);
          const ot = new _.OperatorList();
          if (!this._defaultAppearance || lt === null) return { opList: ot, separateForm: !1, separateCanvas: !1 };
          const ut = !!(this.data.hasOwnCanvas && et & o.RenderingIntentFlag.DISPLAY), ct = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]], gt = W(this.data.rect, ct, [1, 0, 0, 1, 0, 0]);
          let dt;
          this.oc && (dt = await D.parseMarkedContentProps(this.oc, null)), dt !== void 0 && ot.addOp(o.OPS.beginMarkedContentProps, ["OC", dt]), ot.addOp(o.OPS.beginAnnotation, [this.data.id, this.data.rect, gt, this.getRotationMatrix(it), ut]);
          const bt = new a.StringStream(lt);
          return await D.getOperatorList({ stream: bt, task: G, resources: this._fieldResources.mergedResources, operatorList: ot }), ot.addOp(o.OPS.endAnnotation, []), dt !== void 0 && ot.addOp(o.OPS.endMarkedContent, []), { opList: ot, separateForm: !1, separateCanvas: ut };
        }
        _getMKDict(D) {
          const G = new n.Dict(null);
          return D && G.set("R", D), this.borderColor && G.set("BC", I(this.borderColor)), this.backgroundColor && G.set("BG", I(this.backgroundColor)), G.size > 0 ? G : null;
        }
        amendSavedDict(D, G) {
        }
        async save(D, G, et) {
          const J = et == null ? void 0 : et.get(this.data.id);
          let it = J == null ? void 0 : J.value, lt = J == null ? void 0 : J.rotation;
          if (it === this.data.fieldValue || it === void 0) {
            if (!this._hasValueFromXFA && lt === void 0) return null;
            it || (it = this.data.fieldValue);
          }
          if (lt === void 0 && !this._hasValueFromXFA && Array.isArray(it) && Array.isArray(this.data.fieldValue) && it.length === this.data.fieldValue.length && it.every((Et, Ft) => Et === this.data.fieldValue[Ft])) return null;
          lt === void 0 && (lt = this.rotation);
          let ot = null;
          if (!this._needAppearances && (ot = await this._getAppearance(D, G, o.RenderingIntentFlag.SAVE, et), ot === null))
            return null;
          let ut = !1;
          ot != null && ot.needAppearances && (ut = !0, ot = null);
          const { xref: ct } = D, gt = ct.fetchIfRef(this.ref);
          if (!(gt instanceof n.Dict)) return null;
          const dt = new n.Dict(ct);
          for (const Et of gt.getKeys()) Et !== "AP" && dt.set(Et, gt.getRaw(Et));
          const bt = { path: this.data.fieldName, value: it }, vt = (Et) => (0, g.isAscii)(Et) ? Et : (0, g.stringToUTF16String)(Et, !0);
          dt.set("V", Array.isArray(it) ? it.map(vt) : vt(it)), this.amendSavedDict(et, dt);
          const xt = this._getMKDict(lt);
          xt && dt.set("MK", xt);
          const St = [], Mt = [{ ref: this.ref, data: "", xfa: bt, needAppearances: ut }];
          if (ot !== null) {
            const Et = ct.getNewTemporaryRef(), Ft = new n.Dict(ct);
            dt.set("AP", Ft), Ft.set("N", Et);
            const Wt = this._getSaveFieldResources(ct), Kt = new a.StringStream(ot), qt = Kt.dict = new n.Dict(ct);
            qt.set("Subtype", n.Name.get("Form")), qt.set("Resources", Wt), qt.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
            const It = this.getRotationMatrix(et);
            It !== o.IDENTITY_MATRIX && qt.set("Matrix", It), await (0, M.writeObject)(Et, Kt, St, ct), Mt.push({ ref: Et, data: St.join(""), xfa: null, needAppearances: !1 }), St.length = 0;
          }
          return dt.set("M", `D:${(0, o.getModificationDate)()}`), await (0, M.writeObject)(this.ref, dt, St, ct), Mt[0].data = St.join(""), Mt;
        }
        async _getAppearance(D, G, et, J) {
          if (this.hasFieldFlag(o.AnnotationFieldFlag.PASSWORD)) return null;
          const it = J == null ? void 0 : J.get(this.data.id);
          let lt, ot;
          if (it && (lt = it.formattedValue || it.value, ot = it.rotation), ot === void 0 && lt === void 0 && !this._needAppearances && (!this._hasValueFromXFA || this.appearance)) return null;
          const ut = this.getBorderAndBackgroundAppearances(J);
          if (lt === void 0 && (lt = this.data.fieldValue, !lt))
            return `/Tx BMC q ${ut}Q EMC`;
          if (Array.isArray(lt) && lt.length === 1 && (lt = lt[0]), (0, o.assert)(typeof lt == "string", "Expected `value` to be a string."), lt = lt.trim(), this.data.combo) {
            const re = this.data.options.find(({ exportValue: le }) => lt === le);
            lt = (re == null ? void 0 : re.displayValue) || lt;
          }
          if (lt === "") return `/Tx BMC q ${ut}Q EMC`;
          ot === void 0 && (ot = this.rotation);
          let ct, gt = -1;
          this.data.multiLine ? (ct = lt.split(/\r\n?|\n/).map((re) => re.normalize("NFC")), gt = ct.length) : ct = [lt.replace(/\r\n?|\n/, "").normalize("NFC")];
          let dt = this.data.rect[3] - this.data.rect[1], bt = this.data.rect[2] - this.data.rect[0];
          ot !== 90 && ot !== 270 || ([bt, dt] = [dt, bt]), this._defaultAppearance || (this.data.defaultAppearanceData = (0, p.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
          let vt, xt, St, Mt = await B._getFontData(D, G, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
          const Et = [];
          let Ft = !1;
          for (const re of ct) {
            const le = Mt.encodeString(re);
            le.length > 1 && (Ft = !0), Et.push(le.join(""));
          }
          if (Ft && et & o.RenderingIntentFlag.SAVE) return { needAppearances: !0 };
          if (Ft && this._isOffscreenCanvasSupported) {
            const re = this.data.comb ? "monospace" : "sans-serif", le = new p.FakeUnicodeFont(D.xref, re), Ce = le.createFontResources(ct.join("")), ce = Ce.getRaw("Font");
            if (this._fieldResources.mergedResources.has("Font")) {
              const Oe = this._fieldResources.mergedResources.get("Font");
              for (const He of ce.getKeys()) Oe.set(He, ce.getRaw(He));
            } else this._fieldResources.mergedResources.set("Font", ce);
            const xe = le.fontName.name;
            Mt = await B._getFontData(D, G, { fontName: xe, fontSize: 0 }, Ce);
            for (let Oe = 0, He = Et.length; Oe < He; Oe++) Et[Oe] = (0, g.stringToUTF16String)(ct[Oe]);
            const ve = Object.assign(/* @__PURE__ */ Object.create(null), this.data.defaultAppearanceData);
            this.data.defaultAppearanceData.fontSize = 0, this.data.defaultAppearanceData.fontName = xe, [vt, xt, St] = this._computeFontSize(dt - 2, bt - 4, lt, Mt, gt), this.data.defaultAppearanceData = ve;
          } else
            this._isOffscreenCanvasSupported || (0, o.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly."), [vt, xt, St] = this._computeFontSize(dt - 2, bt - 4, lt, Mt, gt);
          let Wt = Mt.descent;
          Wt = isNaN(Wt) ? o.BASELINE_FACTOR * St : Math.max(o.BASELINE_FACTOR * St, Math.abs(Wt) * xt);
          const Kt = Math.min(Math.floor((dt - xt) / 2), 1), qt = this.data.textAlignment;
          if (this.data.multiLine) return this._getMultilineAppearance(vt, Et, Mt, xt, bt, dt, qt, 2, Kt, Wt, St, J);
          if (this.data.comb) return this._getCombAppearance(vt, Mt, Et[0], xt, bt, dt, 2, Kt, Wt, St, J);
          const It = Kt + Wt;
          return qt === 0 || qt > 2 ? `/Tx BMC q ${ut}BT ` + vt + ` 1 0 0 1 ${(0, g.numberToString)(2)} ${(0, g.numberToString)(It)} Tm (${(0, g.escapeString)(Et[0])}) Tj ET Q EMC` : `/Tx BMC q ${ut}BT ` + vt + ` 1 0 0 1 0 0 Tm ${this._renderText(Et[0], Mt, xt, bt, qt, { shift: 0 }, 2, It)} ET Q EMC`;
        }
        static async _getFontData(D, G, et, J) {
          const it = new _.OperatorList(), lt = { font: null, clone() {
            return this;
          } }, { fontName: ot, fontSize: ut } = et;
          return await D.handleSetFont(J, [ot && n.Name.get(ot), ut], null, it, G, lt, null), lt.font;
        }
        _getTextWidth(D, G) {
          return G.charsToGlyphs(D).reduce((et, J) => et + J.width, 0) / 1e3;
        }
        _computeFontSize(D, G, et, J, it) {
          let { fontSize: lt } = this.data.defaultAppearanceData, ot = (lt || 12) * o.LINE_FACTOR, ut = Math.round(D / ot);
          if (!lt) {
            const ct = (bt) => Math.floor(100 * bt) / 100;
            if (it === -1) {
              const bt = this._getTextWidth(et, J);
              lt = ct(Math.min(D / o.LINE_FACTOR, bt > G ? G / bt : 1 / 0)), ut = 1;
            } else {
              const bt = et.split(/\r\n?|\n/), vt = [];
              for (const St of bt) {
                const Mt = J.encodeString(St).join(""), Et = J.charsToGlyphs(Mt), Ft = J.getCharPositions(Mt);
                vt.push({ line: Mt, glyphs: Et, positions: Ft });
              }
              const xt = (St) => {
                let Mt = 0;
                for (const Et of vt)
                  if (Mt += this._splitLine(null, J, St, G, Et).length * St, Mt > D) return !0;
                return !1;
              };
              for (ut = Math.max(ut, it); ot = D / ut, lt = ct(ot / o.LINE_FACTOR), !!xt(lt); )
                ut++;
            }
            const { fontName: gt, fontColor: dt } = this.data.defaultAppearanceData;
            this._defaultAppearance = (0, p.createDefaultAppearance)({ fontSize: lt, fontName: gt, fontColor: dt });
          }
          return [this._defaultAppearance, lt, D / ut];
        }
        _renderText(D, G, et, J, it, lt, ot, ut) {
          let ct;
          it === 1 ? ct = (J - this._getTextWidth(D, G) * et) / 2 : it === 2 ? ct = J - this._getTextWidth(D, G) * et - ot : ct = ot;
          const gt = (0, g.numberToString)(ct - lt.shift);
          return lt.shift = ct, `${gt} ${ut = (0, g.numberToString)(ut)} Td (${(0, g.escapeString)(D)}) Tj`;
        }
        _getSaveFieldResources(D) {
          var lt;
          const { localResources: G, appearanceResources: et, acroFormResources: J } = this._fieldResources, it = (lt = this.data.defaultAppearanceData) == null ? void 0 : lt.fontName;
          if (!it) return G || n.Dict.empty;
          for (const ot of [G, et]) if (ot instanceof n.Dict) {
            const ut = ot.get("Font");
            if (ut instanceof n.Dict && ut.has(it)) return ot;
          }
          if (J instanceof n.Dict) {
            const ot = J.get("Font");
            if (ot instanceof n.Dict && ot.has(it)) {
              const ut = new n.Dict(D);
              ut.set(it, ot.getRaw(it));
              const ct = new n.Dict(D);
              return ct.set("Font", ut), n.Dict.merge({ xref: D, dictArray: [ct, G], mergeSubDicts: !0 });
            }
          }
          return G || n.Dict.empty;
        }
        getFieldObject() {
          return null;
        }
      }
      class C extends B {
        constructor(D) {
          super(D), this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML, this._hasText = !0;
          const G = D.dict;
          typeof this.data.fieldValue != "string" && (this.data.fieldValue = "");
          let et = (0, g.getInheritableProperty)({ dict: G, key: "Q" });
          (!Number.isInteger(et) || et < 0 || et > 2) && (et = null), this.data.textAlignment = et;
          let J = (0, g.getInheritableProperty)({ dict: G, key: "MaxLen" });
          (!Number.isInteger(J) || J < 0) && (J = 0), this.data.maxLen = J, this.data.multiLine = this.hasFieldFlag(o.AnnotationFieldFlag.MULTILINE), this.data.comb = this.hasFieldFlag(o.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(o.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(o.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(o.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0, this.data.doNotScroll = this.hasFieldFlag(o.AnnotationFieldFlag.DONOTSCROLL);
        }
        get hasTextContent() {
          return !!this.appearance && !this._needAppearances;
        }
        _getCombAppearance(D, G, et, J, it, lt, ot, ut, ct, gt, dt) {
          const bt = it / this.data.maxLen, vt = this.getBorderAndBackgroundAppearances(dt), xt = [], St = G.getCharPositions(et);
          for (const [Et, Ft] of St) xt.push(`(${(0, g.escapeString)(et.substring(Et, Ft))}) Tj`);
          const Mt = xt.join(` ${(0, g.numberToString)(bt)} 0 Td `);
          return `/Tx BMC q ${vt}BT ` + D + ` 1 0 0 1 ${(0, g.numberToString)(ot)} ${(0, g.numberToString)(ut + ct)} Tm ${Mt} ET Q EMC`;
        }
        _getMultilineAppearance(D, G, et, J, it, lt, ot, ut, ct, gt, dt, bt) {
          const vt = [], xt = it - 2 * ut, St = { shift: 0 };
          for (let Ft = 0, Wt = G.length; Ft < Wt; Ft++) {
            const Kt = G[Ft], qt = this._splitLine(Kt, et, J, xt);
            for (let It = 0, re = qt.length; It < re; It++) {
              const le = qt[It], Ce = Ft === 0 && It === 0 ? -ct - (dt - gt) : -dt;
              vt.push(this._renderText(le, et, J, it, ot, St, ut, Ce));
            }
          }
          const Mt = this.getBorderAndBackgroundAppearances(bt), Et = vt.join(`
`);
          return `/Tx BMC q ${Mt}BT ` + D + ` 1 0 0 1 0 ${(0, g.numberToString)(lt)} Tm ${Et} ET Q EMC`;
        }
        _splitLine(D, G, et, J, it = {}) {
          D = it.line || D;
          const lt = it.glyphs || G.charsToGlyphs(D);
          if (lt.length <= 1) return [D];
          const ot = it.positions || G.getCharPositions(D), ut = et / 1e3, ct = [];
          let gt = -1, dt = -1, bt = -1, vt = 0, xt = 0;
          for (let St = 0, Mt = lt.length; St < Mt; St++) {
            const [Et, Ft] = ot[St], Wt = lt[St], Kt = Wt.width * ut;
            Wt.unicode === " " ? xt + Kt > J ? (ct.push(D.substring(vt, Et)), vt = Et, xt = Kt, gt = -1, bt = -1) : (xt += Kt, gt = Et, dt = Ft, bt = St) : xt + Kt > J ? gt !== -1 ? (ct.push(D.substring(vt, dt)), vt = dt, St = bt + 1, gt = -1, xt = 0) : (ct.push(D.substring(vt, Et)), vt = Et, xt = Kt) : xt += Kt;
          }
          return vt < D.length && ct.push(D.substring(vt, D.length)), ct;
        }
        getFieldObject() {
          return { id: this.data.id, value: this.data.fieldValue, defaultValue: this.data.defaultFieldValue || "", multiline: this.data.multiLine, password: this.hasFieldFlag(o.AnnotationFieldFlag.PASSWORD), charLimit: this.data.maxLen, comb: this.data.comb, editable: !this.data.readOnly, hidden: this.data.hidden, name: this.data.fieldName, rect: this.data.rect, actions: this.data.actions, page: this.data.pageIndex, strokeColor: this.data.borderColor, fillColor: this.data.backgroundColor, rotation: this.rotation, type: "text" };
        }
      }
      class T extends B {
        constructor(D) {
          super(D), this.checkedAppearance = null, this.uncheckedAppearance = null, this.data.checkBox = !this.hasFieldFlag(o.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(o.AnnotationFieldFlag.PUSHBUTTON), this.data.radioButton = this.hasFieldFlag(o.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(o.AnnotationFieldFlag.PUSHBUTTON), this.data.pushButton = this.hasFieldFlag(o.AnnotationFieldFlag.PUSHBUTTON), this.data.isTooltipOnly = !1, this.data.checkBox ? this._processCheckBox(D) : this.data.radioButton ? this._processRadioButton(D) : this.data.pushButton ? (this.data.hasOwnCanvas = !0, this._processPushButton(D)) : (0, o.warn)("Invalid field flags for button widget annotation");
        }
        async getOperatorList(D, G, et, J, it) {
          if (this.data.pushButton) return super.getOperatorList(D, G, et, !1, it);
          let lt = null, ot = null;
          if (it) {
            const ct = it.get(this.data.id);
            lt = ct ? ct.value : null, ot = ct ? ct.rotation : null;
          }
          if (lt === null && this.appearance) return super.getOperatorList(D, G, et, J, it);
          lt == null && (lt = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue);
          const ut = lt ? this.checkedAppearance : this.uncheckedAppearance;
          if (ut) {
            const ct = this.appearance, gt = ut.dict.getArray("Matrix") || o.IDENTITY_MATRIX;
            ot && ut.dict.set("Matrix", this.getRotationMatrix(it)), this.appearance = ut;
            const dt = super.getOperatorList(D, G, et, J, it);
            return this.appearance = ct, ut.dict.set("Matrix", gt), dt;
          }
          return { opList: new _.OperatorList(), separateForm: !1, separateCanvas: !1 };
        }
        async save(D, G, et) {
          return this.data.checkBox ? this._saveCheckbox(D, G, et) : this.data.radioButton ? this._saveRadioButton(D, G, et) : null;
        }
        async _saveCheckbox(D, G, et) {
          if (!et) return null;
          const J = et.get(this.data.id);
          let it = J == null ? void 0 : J.rotation, lt = J == null ? void 0 : J.value;
          if (it === void 0 && (lt === void 0 || this.data.fieldValue === this.data.exportValue === lt))
            return null;
          const ot = D.xref.fetchIfRef(this.ref);
          if (!(ot instanceof n.Dict)) return null;
          it === void 0 && (it = this.rotation), lt === void 0 && (lt = this.data.fieldValue === this.data.exportValue);
          const ut = { path: this.data.fieldName, value: lt ? this.data.exportValue : "" }, ct = n.Name.get(lt ? this.data.exportValue : "Off");
          ot.set("V", ct), ot.set("AS", ct), ot.set("M", `D:${(0, o.getModificationDate)()}`);
          const gt = this._getMKDict(it);
          gt && ot.set("MK", gt);
          const dt = [];
          return await (0, M.writeObject)(this.ref, ot, dt, D.xref), [{ ref: this.ref, data: dt.join(""), xfa: ut }];
        }
        async _saveRadioButton(D, G, et) {
          if (!et) return null;
          const J = et.get(this.data.id);
          let it = J == null ? void 0 : J.rotation, lt = J == null ? void 0 : J.value;
          if (it === void 0 && (lt === void 0 || this.data.fieldValue === this.data.buttonValue === lt))
            return null;
          const ot = D.xref.fetchIfRef(this.ref);
          if (!(ot instanceof n.Dict)) return null;
          lt === void 0 && (lt = this.data.fieldValue === this.data.buttonValue), it === void 0 && (it = this.rotation);
          const ut = { path: this.data.fieldName, value: lt ? this.data.buttonValue : "" }, ct = n.Name.get(lt ? this.data.buttonValue : "Off"), gt = [];
          let dt = null;
          if (lt) if (this.parent instanceof n.Ref) {
            const xt = D.xref.fetch(this.parent);
            xt.set("V", ct), await (0, M.writeObject)(this.parent, xt, gt, D.xref), dt = gt.join(""), gt.length = 0;
          } else this.parent instanceof n.Dict && this.parent.set("V", ct);
          ot.set("AS", ct), ot.set("M", `D:${(0, o.getModificationDate)()}`);
          const bt = this._getMKDict(it);
          bt && ot.set("MK", bt), await (0, M.writeObject)(this.ref, ot, gt, D.xref);
          const vt = [{ ref: this.ref, data: gt.join(""), xfa: ut }];
          return dt && vt.push({ ref: this.parent, data: dt, xfa: null }), vt;
        }
        _getDefaultCheckedAppearance(D, G) {
          const et = this.data.rect[2] - this.data.rect[0], J = this.data.rect[3] - this.data.rect[1], it = [0, 0, et, J], lt = 0.8 * Math.min(et, J);
          let ot, ut;
          G === "check" ? (ot = { width: 0.755 * lt, height: 0.705 * lt }, ut = "3") : G === "disc" ? (ot = { width: 0.791 * lt, height: 0.705 * lt }, ut = "l") : (0, o.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${G}`);
          const ct = `q BT /PdfJsZaDb ${lt} Tf 0 g ${(0, g.numberToString)((et - ot.width) / 2)} ${(0, g.numberToString)((J - ot.height) / 2)} Td (${ut}) Tj ET Q`, gt = new n.Dict(D.xref);
          gt.set("FormType", 1), gt.set("Subtype", n.Name.get("Form")), gt.set("Type", n.Name.get("XObject")), gt.set("BBox", it), gt.set("Matrix", [1, 0, 0, 1, 0, 0]), gt.set("Length", ct.length);
          const dt = new n.Dict(D.xref), bt = new n.Dict(D.xref);
          bt.set("PdfJsZaDb", this.fallbackFontDict), dt.set("Font", bt), gt.set("Resources", dt), this.checkedAppearance = new a.StringStream(ct), this.checkedAppearance.dict = gt, this._streams.push(this.checkedAppearance);
        }
        _processCheckBox(D) {
          const G = D.dict.get("AP");
          if (!(G instanceof n.Dict)) return;
          const et = G.get("N");
          if (!(et instanceof n.Dict)) return;
          const J = this._decodeFormValue(D.dict.get("AS"));
          typeof J == "string" && (this.data.fieldValue = J);
          const it = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes", lt = et.getKeys();
          if (lt.length === 0) lt.push("Off", it);
          else if (lt.length === 1) lt[0] === "Off" ? lt.push(it) : lt.unshift("Off");
          else if (lt.includes(it))
            lt.length = 0, lt.push("Off", it);
          else {
            const ct = lt.find((gt) => gt !== "Off");
            lt.length = 0, lt.push("Off", ct);
          }
          lt.includes(this.data.fieldValue) || (this.data.fieldValue = "Off"), this.data.exportValue = lt[1];
          const ot = et.get(this.data.exportValue);
          this.checkedAppearance = ot instanceof d.BaseStream ? ot : null;
          const ut = et.get("Off");
          this.uncheckedAppearance = ut instanceof d.BaseStream ? ut : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(D, "check"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
        }
        _processRadioButton(D) {
          this.data.fieldValue = this.data.buttonValue = null;
          const G = D.dict.get("Parent");
          if (G instanceof n.Dict) {
            this.parent = D.dict.getRaw("Parent");
            const ot = G.get("V");
            ot instanceof n.Name && (this.data.fieldValue = this._decodeFormValue(ot));
          }
          const et = D.dict.get("AP");
          if (!(et instanceof n.Dict)) return;
          const J = et.get("N");
          if (!(J instanceof n.Dict)) return;
          for (const ot of J.getKeys()) if (ot !== "Off") {
            this.data.buttonValue = this._decodeFormValue(ot);
            break;
          }
          const it = J.get(this.data.buttonValue);
          this.checkedAppearance = it instanceof d.BaseStream ? it : null;
          const lt = J.get("Off");
          this.uncheckedAppearance = lt instanceof d.BaseStream ? lt : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(D, "disc"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
        }
        _processPushButton(D) {
          const { dict: G, annotationGlobals: et } = D;
          G.has("A") || G.has("AA") || this.data.alternativeText ? (this.data.isTooltipOnly = !G.has("A") && !G.has("AA"), b.Catalog.parseDestDictionary({ destDict: G, resultObj: this.data, docBaseUrl: et.baseUrl, docAttachments: et.attachments })) : (0, o.warn)("Push buttons without action dictionaries are not supported");
        }
        getFieldObject() {
          let D, G = "button";
          return this.data.checkBox ? (G = "checkbox", D = this.data.exportValue) : this.data.radioButton && (G = "radiobutton", D = this.data.buttonValue), { id: this.data.id, value: this.data.fieldValue || "Off", defaultValue: this.data.defaultFieldValue, exportValues: D, editable: !this.data.readOnly, name: this.data.fieldName, rect: this.data.rect, hidden: this.data.hidden, actions: this.data.actions, page: this.data.pageIndex, strokeColor: this.data.borderColor, fillColor: this.data.backgroundColor, rotation: this.rotation, type: G };
        }
        get fallbackFontDict() {
          const D = new n.Dict();
          return D.set("BaseFont", n.Name.get("ZapfDingbats")), D.set("Type", n.Name.get("FallbackType")), D.set("Subtype", n.Name.get("FallbackType")), D.set("Encoding", n.Name.get("ZapfDingbatsEncoding")), (0, o.shadow)(this, "fallbackFontDict", D);
        }
      }
      class F extends B {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          this.indices = G.getArray("I"), this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0, this.data.options = [];
          const J = (0, g.getInheritableProperty)({ dict: G, key: "Opt" });
          if (Array.isArray(J)) for (let it = 0, lt = J.length; it < lt; it++) {
            const ot = et.fetchIfRef(J[it]), ut = Array.isArray(ot);
            this.data.options[it] = { exportValue: this._decodeFormValue(ut ? et.fetchIfRef(ot[0]) : ot), displayValue: this._decodeFormValue(ut ? et.fetchIfRef(ot[1]) : ot) };
          }
          if (this.hasIndices) {
            this.data.fieldValue = [];
            const it = this.data.options.length;
            for (const lt of this.indices) Number.isInteger(lt) && lt >= 0 && lt < it && this.data.fieldValue.push(this.data.options[lt].exportValue);
          } else typeof this.data.fieldValue == "string" ? this.data.fieldValue = [this.data.fieldValue] : this.data.fieldValue || (this.data.fieldValue = []);
          this.data.combo = this.hasFieldFlag(o.AnnotationFieldFlag.COMBO), this.data.multiSelect = this.hasFieldFlag(o.AnnotationFieldFlag.MULTISELECT), this._hasText = !0;
        }
        getFieldObject() {
          const D = this.data.combo ? "combobox" : "listbox", G = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
          return { id: this.data.id, value: G, defaultValue: this.data.defaultFieldValue, editable: !this.data.readOnly, name: this.data.fieldName, rect: this.data.rect, numItems: this.data.fieldValue.length, multipleSelection: this.data.multiSelect, hidden: this.data.hidden, actions: this.data.actions, items: this.data.options, page: this.data.pageIndex, strokeColor: this.data.borderColor, fillColor: this.data.backgroundColor, rotation: this.rotation, type: D };
        }
        amendSavedDict(D, G) {
          var lt;
          if (!this.hasIndices) return;
          let et = (lt = D == null ? void 0 : D.get(this.data.id)) == null ? void 0 : lt.value;
          Array.isArray(et) || (et = [et]);
          const J = [], { options: it } = this.data;
          for (let ot = 0, ut = 0, ct = it.length; ot < ct; ot++) it[ot].exportValue === et[ut] && (J.push(ot), ut += 1);
          G.set("I", J);
        }
        async _getAppearance(D, G, et, J) {
          if (this.data.combo) return super._getAppearance(D, G, et, J);
          let it, lt;
          const ot = J == null ? void 0 : J.get(this.data.id);
          if (ot && (lt = ot.rotation, it = ot.value), lt === void 0 && it === void 0 && !this._needAppearances) return null;
          it === void 0 ? it = this.data.fieldValue : Array.isArray(it) || (it = [it]);
          let ut = this.data.rect[3] - this.data.rect[1], ct = this.data.rect[2] - this.data.rect[0];
          lt !== 90 && lt !== 270 || ([ct, ut] = [ut, ct]);
          const gt = this.data.options.length, dt = [];
          for (let It = 0; It < gt; It++) {
            const { exportValue: re } = this.data.options[It];
            it.includes(re) && dt.push(It);
          }
          this._defaultAppearance || (this.data.defaultAppearanceData = (0, p.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
          const bt = await B._getFontData(D, G, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
          let vt, { fontSize: xt } = this.data.defaultAppearanceData;
          if (xt) vt = this._defaultAppearance;
          else {
            const It = (ut - 1) / gt;
            let re, le = -1;
            for (const { displayValue: Ce } of this.data.options) {
              const ce = this._getTextWidth(Ce, bt);
              ce > le && (le = ce, re = Ce);
            }
            [vt, xt] = this._computeFontSize(It, ct - 4, re, bt, -1);
          }
          const St = xt * o.LINE_FACTOR, Mt = (St - xt) / 2, Et = Math.floor(ut / St);
          let Ft = 0;
          if (dt.length > 0) {
            const It = Math.min(...dt), re = Math.max(...dt);
            Ft = Math.max(0, re - Et + 1), Ft > It && (Ft = It);
          }
          const Wt = Math.min(Ft + Et + 1, gt), Kt = ["/Tx BMC q", `1 1 ${ct} ${ut} re W n`];
          if (dt.length) {
            Kt.push("0.600006 0.756866 0.854904 rg");
            for (const It of dt) Ft <= It && It < Wt && Kt.push(`1 ${ut - (It - Ft + 1) * St} ${ct} ${St} re f`);
          }
          Kt.push("BT", vt, `1 0 0 1 0 ${ut} Tm`);
          const qt = { shift: 0 };
          for (let It = Ft; It < Wt; It++) {
            const { displayValue: re } = this.data.options[It], le = It === Ft ? Mt : 0;
            Kt.push(this._renderText(re, bt, xt, ct, 0, qt, 2, -St + le));
          }
          return Kt.push("ET Q EMC"), Kt.join(`
`);
        }
      }
      class S extends B {
        constructor(D) {
          super(D), this.data.fieldValue = null, this.data.hasOwnCanvas = this.data.noRotate;
        }
        getFieldObject() {
          return { id: this.data.id, value: null, page: this.data.pageIndex, type: "signature" };
        }
      }
      class A extends $ {
        constructor(D) {
          super(D), this.data.noRotate = !0, this.data.hasOwnCanvas = this.data.noRotate;
          const { dict: G } = D;
          this.data.annotationType = o.AnnotationType.TEXT, this.data.hasAppearance ? this.data.name = "NoIcon" : (this.data.rect[1] = this.data.rect[3] - 22, this.data.rect[2] = this.data.rect[0] + 22, this.data.name = G.has("Name") ? G.get("Name").name : "Note"), G.has("State") ? (this.data.state = G.get("State") || null, this.data.stateModel = G.get("StateModel") || null) : (this.data.state = null, this.data.stateModel = null);
        }
      }
      class U extends z {
        constructor(D) {
          var it;
          super(D);
          const { dict: G, annotationGlobals: et } = D;
          this.data.annotationType = o.AnnotationType.LINK;
          const J = R(G, this.rectangle);
          J && (this.data.quadPoints = J), (it = this.data).borderColor || (it.borderColor = this.data.color), b.Catalog.parseDestDictionary({ destDict: G, resultObj: this.data, docBaseUrl: et.baseUrl, docAttachments: et.attachments });
        }
      }
      class K extends z {
        constructor(D) {
          super(D);
          const { dict: G } = D;
          this.data.annotationType = o.AnnotationType.POPUP, this.data.rect[0] !== this.data.rect[2] && this.data.rect[1] !== this.data.rect[3] || (this.data.rect = null);
          let et = G.get("Parent");
          if (!et) {
            (0, o.warn)("Popup annotation has a missing or invalid parent annotation.");
            return;
          }
          const J = et.getArray("Rect");
          this.data.parentRect = Array.isArray(J) && J.length === 4 ? o.Util.normalizeRect(J) : null;
          const it = et.get("RT");
          if ((0, n.isName)(it, o.AnnotationReplyType.GROUP) && (et = et.get("IRT")), et.has("M") ? (this.setModificationDate(et.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, et.has("C") ? (this.setColor(et.getArray("C")), this.data.color = this.color) : this.data.color = null, !this.viewable) {
            const lt = et.get("F");
            this._isViewable(lt) && this.setFlags(lt);
          }
          this.setTitle(et.get("T")), this.data.titleObj = this._title, this.setContents(et.get("Contents")), this.data.contentsObj = this._contents, et.has("RC") && (this.data.richText = O.XFAFactory.getRichTextAsHtml(et.get("RC"))), this.data.open = !!G.get("Open");
        }
      }
      l.PopupAnnotation = K;
      class X extends $ {
        constructor(D) {
          var J;
          super(D), this.data.hasOwnCanvas = !0;
          const { evaluatorOptions: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.FREETEXT, this.setDefaultAppearance(D), this.appearance) {
            const { fontColor: it, fontSize: lt } = (0, p.parseAppearanceStream)(this.appearance, G, et);
            this.data.defaultAppearanceData.fontColor = it, this.data.defaultAppearanceData.fontSize = lt || 10;
          } else if (this._isOffscreenCanvasSupported) {
            const it = D.dict.get("CA"), lt = new p.FakeUnicodeFont(et, "sans-serif");
            (J = this.data.defaultAppearanceData).fontSize || (J.fontSize = 10);
            const { fontColor: ot, fontSize: ut } = this.data.defaultAppearanceData;
            this.appearance = lt.createAppearance(this._contents.str, this.rectangle, this.rotation, ut, ot, it), this._streams.push(this.appearance, p.FakeUnicodeFont.toUnicodeStream);
          } else (0, o.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
        }
        get hasTextContent() {
          return !!this.appearance;
        }
        static createNewDict(D, G, { apRef: et, ap: J }) {
          const { color: it, fontSize: lt, rect: ot, rotation: ut, user: ct, value: gt } = D, dt = new n.Dict(G);
          dt.set("Type", n.Name.get("Annot")), dt.set("Subtype", n.Name.get("FreeText")), dt.set("CreationDate", `D:${(0, o.getModificationDate)()}`), dt.set("Rect", ot);
          const bt = `/Helv ${lt} Tf ${(0, p.getPdfColor)(it, !0)}`;
          if (dt.set("DA", bt), dt.set("Contents", (0, g.isAscii)(gt) ? gt : (0, g.stringToUTF16String)(gt, !0)), dt.set("F", 4), dt.set("Border", [0, 0, 0]), dt.set("Rotate", ut), ct && dt.set("T", (0, g.isAscii)(ct) ? ct : (0, g.stringToUTF16String)(ct, !0)), et || J) {
            const vt = new n.Dict(G);
            dt.set("AP", vt), et ? vt.set("N", et) : vt.set("N", J);
          }
          return dt;
        }
        static async createNewAppearanceStream(D, G, et) {
          const { baseFontRef: J, evaluator: it, task: lt } = et, { color: ot, fontSize: ut, rect: ct, rotation: gt, value: dt } = D, bt = new n.Dict(G), vt = new n.Dict(G);
          if (J) vt.set("Helv", J);
          else {
            const Tt = new n.Dict(G);
            Tt.set("BaseFont", n.Name.get("Helvetica")), Tt.set("Type", n.Name.get("Font")), Tt.set("Subtype", n.Name.get("Type1")), Tt.set("Encoding", n.Name.get("WinAnsiEncoding")), vt.set("Helv", Tt);
          }
          bt.set("Font", vt);
          const xt = await B._getFontData(it, lt, { fontName: "Helv", fontSize: ut }, bt), [St, Mt, Et, Ft] = ct;
          let Wt = Et - St, Kt = Ft - Mt;
          gt % 180 != 0 && ([Wt, Kt] = [Kt, Wt]);
          const qt = dt.split(`
`), It = ut / 1e3;
          let re = -1 / 0;
          const le = [];
          for (let Tt of qt) {
            const ee = xt.encodeString(Tt);
            if (ee.length > 1) return null;
            Tt = ee.join(""), le.push(Tt);
            let te = 0;
            const Jt = xt.charsToGlyphs(Tt);
            for (const pe of Jt) te += pe.width * It;
            re = Math.max(re, te);
          }
          let Ce = 1;
          re > Wt && (Ce = Wt / re);
          let ce = 1;
          const xe = o.LINE_FACTOR * ut, ve = (o.LINE_FACTOR - o.LINE_DESCENT_FACTOR) * ut, Oe = xe * qt.length;
          Oe > Kt && (ce = Kt / Oe);
          const He = ut * Math.min(Ce, ce);
          let Zt, Xt, Gt;
          switch (gt) {
            case 0:
              Gt = [1, 0, 0, 1], Xt = [ct[0], ct[1], Wt, Kt], Zt = [ct[0], ct[3] - ve];
              break;
            case 90:
              Gt = [0, 1, -1, 0], Xt = [ct[1], -ct[2], Wt, Kt], Zt = [ct[1], -ct[0] - ve];
              break;
            case 180:
              Gt = [-1, 0, 0, -1], Xt = [-ct[2], -ct[3], Wt, Kt], Zt = [-ct[2], -ct[1] - ve];
              break;
            case 270:
              Gt = [0, -1, 1, 0], Xt = [-ct[3], ct[0], Wt, Kt], Zt = [-ct[3], ct[2] - ve];
          }
          const Lt = ["q", `${Gt.join(" ")} 0 0 cm`, `${Xt.join(" ")} re W n`, "BT", `${(0, p.getPdfColor)(ot, !0)}`, `0 Tc /Helv ${(0, g.numberToString)(He)} Tf`];
          Lt.push(`${Zt.join(" ")} Td (${(0, g.escapeString)(le[0])}) Tj`);
          const Dt = (0, g.numberToString)(xe);
          for (let Tt = 1, ee = le.length; Tt < ee; Tt++) {
            const te = le[Tt];
            Lt.push(`0 -${Dt} Td (${(0, g.escapeString)(te)}) Tj`);
          }
          Lt.push("ET", "Q");
          const jt = Lt.join(`
`), Ot = new n.Dict(G);
          Ot.set("FormType", 1), Ot.set("Subtype", n.Name.get("Form")), Ot.set("Type", n.Name.get("XObject")), Ot.set("BBox", ct), Ot.set("Resources", bt), Ot.set("Matrix", [1, 0, 0, 1, -ct[0], -ct[1]]);
          const Rt = new a.StringStream(jt);
          return Rt.dict = Ot, Rt;
        }
      }
      class L extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          this.data.annotationType = o.AnnotationType.LINE, this.data.hasOwnCanvas = this.data.noRotate;
          const J = G.getArray("L");
          if (this.data.lineCoordinates = o.Util.normalizeRect(J), this.setLineEndings(G.getArray("LE")), this.data.lineEndings = this.lineEndings, !this.appearance) {
            const it = this.color ? I(this.color) : [0, 0, 0], lt = G.get("CA"), ot = E(G.getArray("IC"), null), ut = ot ? I(ot) : null, ct = ut ? lt : null, gt = this.borderStyle.width || 1, dt = 2 * gt, bt = [this.data.lineCoordinates[0] - dt, this.data.lineCoordinates[1] - dt, this.data.lineCoordinates[2] + dt, this.data.lineCoordinates[3] + dt];
            o.Util.intersect(this.rectangle, bt) || (this.rectangle = bt), this._setDefaultAppearance({ xref: et, extra: `${gt} w`, strokeColor: it, fillColor: ut, strokeAlpha: lt, fillAlpha: ct, pointsCallback: (vt, xt) => (vt.push(`${J[0]} ${J[1]} m`, `${J[2]} ${J[3]} l`, "S"), [xt[0].x - gt, xt[1].x + gt, xt[3].y - gt, xt[1].y + gt]) });
          }
        }
      }
      class H extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.SQUARE, this.data.hasOwnCanvas = this.data.noRotate, !this.appearance) {
            const J = this.color ? I(this.color) : [0, 0, 0], it = G.get("CA"), lt = E(G.getArray("IC"), null), ot = lt ? I(lt) : null, ut = ot ? it : null;
            if (this.borderStyle.width === 0 && !ot) return;
            this._setDefaultAppearance({ xref: et, extra: `${this.borderStyle.width} w`, strokeColor: J, fillColor: ot, strokeAlpha: it, fillAlpha: ut, pointsCallback: (ct, gt) => {
              const dt = gt[2].x + this.borderStyle.width / 2, bt = gt[2].y + this.borderStyle.width / 2, vt = gt[3].x - gt[2].x - this.borderStyle.width, xt = gt[1].y - gt[3].y - this.borderStyle.width;
              return ct.push(`${dt} ${bt} ${vt} ${xt} re`), ot ? ct.push("B") : ct.push("S"), [gt[0].x, gt[1].x, gt[3].y, gt[1].y];
            } });
          }
        }
      }
      class Q extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.CIRCLE, !this.appearance) {
            const J = this.color ? I(this.color) : [0, 0, 0], it = G.get("CA"), lt = E(G.getArray("IC"), null), ot = lt ? I(lt) : null, ut = ot ? it : null;
            if (this.borderStyle.width === 0 && !ot) return;
            const ct = 4 / 3 * Math.tan(Math.PI / 8);
            this._setDefaultAppearance({ xref: et, extra: `${this.borderStyle.width} w`, strokeColor: J, fillColor: ot, strokeAlpha: it, fillAlpha: ut, pointsCallback: (gt, dt) => {
              const bt = dt[0].x + this.borderStyle.width / 2, vt = dt[0].y - this.borderStyle.width / 2, xt = dt[3].x - this.borderStyle.width / 2, St = dt[3].y + this.borderStyle.width / 2, Mt = bt + (xt - bt) / 2, Et = vt + (St - vt) / 2, Ft = (xt - bt) / 2 * ct, Wt = (St - vt) / 2 * ct;
              return gt.push(`${Mt} ${St} m`, `${Mt + Ft} ${St} ${xt} ${Et + Wt} ${xt} ${Et} c`, `${xt} ${Et - Wt} ${Mt + Ft} ${vt} ${Mt} ${vt} c`, `${Mt - Ft} ${vt} ${bt} ${Et - Wt} ${bt} ${Et} c`, `${bt} ${Et + Wt} ${Mt - Ft} ${St} ${Mt} ${St} c`, "h"), ot ? gt.push("B") : gt.push("S"), [dt[0].x, dt[1].x, dt[3].y, dt[1].y];
            } });
          }
        }
      }
      class N extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          this.data.annotationType = o.AnnotationType.POLYLINE, this.data.hasOwnCanvas = this.data.noRotate, this.data.vertices = [], this instanceof V || (this.setLineEndings(G.getArray("LE")), this.data.lineEndings = this.lineEndings);
          const J = G.getArray("Vertices");
          if (Array.isArray(J)) {
            for (let it = 0, lt = J.length; it < lt; it += 2) this.data.vertices.push({ x: J[it], y: J[it + 1] });
            if (!this.appearance) {
              const it = this.color ? I(this.color) : [0, 0, 0], lt = G.get("CA"), ot = this.borderStyle.width || 1, ut = 2 * ot, ct = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
              for (const gt of this.data.vertices)
                ct[0] = Math.min(ct[0], gt.x - ut), ct[1] = Math.min(ct[1], gt.y - ut), ct[2] = Math.max(ct[2], gt.x + ut), ct[3] = Math.max(ct[3], gt.y + ut);
              o.Util.intersect(this.rectangle, ct) || (this.rectangle = ct), this._setDefaultAppearance({ xref: et, extra: `${ot} w`, strokeColor: it, strokeAlpha: lt, pointsCallback: (gt, dt) => {
                const bt = this.data.vertices;
                for (let vt = 0, xt = bt.length; vt < xt; vt++) gt.push(`${bt[vt].x} ${bt[vt].y} ${vt === 0 ? "m" : "l"}`);
                return gt.push("S"), [dt[0].x, dt[1].x, dt[3].y, dt[1].y];
              } });
            }
          }
        }
      }
      class V extends N {
        constructor(D) {
          super(D), this.data.annotationType = o.AnnotationType.POLYGON;
        }
      }
      class Y extends $ {
        constructor(D) {
          super(D), this.data.annotationType = o.AnnotationType.CARET;
        }
      }
      class Z extends $ {
        constructor(D) {
          super(D), this.data.hasOwnCanvas = this.data.noRotate;
          const { dict: G, xref: et } = D;
          this.data.annotationType = o.AnnotationType.INK, this.data.inkLists = [];
          const J = G.getArray("InkList");
          if (Array.isArray(J)) {
            for (let it = 0, lt = J.length; it < lt; ++it) {
              this.data.inkLists.push([]);
              for (let ot = 0, ut = J[it].length; ot < ut; ot += 2) this.data.inkLists[it].push({ x: et.fetchIfRef(J[it][ot]), y: et.fetchIfRef(J[it][ot + 1]) });
            }
            if (!this.appearance) {
              const it = this.color ? I(this.color) : [0, 0, 0], lt = G.get("CA"), ot = this.borderStyle.width || 1, ut = 2 * ot, ct = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
              for (const gt of this.data.inkLists) for (const dt of gt)
                ct[0] = Math.min(ct[0], dt.x - ut), ct[1] = Math.min(ct[1], dt.y - ut), ct[2] = Math.max(ct[2], dt.x + ut), ct[3] = Math.max(ct[3], dt.y + ut);
              o.Util.intersect(this.rectangle, ct) || (this.rectangle = ct), this._setDefaultAppearance({ xref: et, extra: `${ot} w`, strokeColor: it, strokeAlpha: lt, pointsCallback: (gt, dt) => {
                for (const bt of this.data.inkLists) {
                  for (let vt = 0, xt = bt.length; vt < xt; vt++) gt.push(`${bt[vt].x} ${bt[vt].y} ${vt === 0 ? "m" : "l"}`);
                  gt.push("S");
                }
                return [dt[0].x, dt[1].x, dt[3].y, dt[1].y];
              } });
            }
          }
        }
        static createNewDict(D, G, { apRef: et, ap: J }) {
          const { color: it, opacity: lt, paths: ot, rect: ut, rotation: ct, thickness: gt } = D, dt = new n.Dict(G);
          dt.set("Type", n.Name.get("Annot")), dt.set("Subtype", n.Name.get("Ink")), dt.set("CreationDate", `D:${(0, o.getModificationDate)()}`), dt.set("Rect", ut), dt.set("InkList", ot.map((xt) => xt.points)), dt.set("F", 4), dt.set("Rotate", ct);
          const bt = new n.Dict(G);
          dt.set("BS", bt), bt.set("W", gt), dt.set("C", Array.from(it, (xt) => xt / 255)), dt.set("CA", lt);
          const vt = new n.Dict(G);
          return dt.set("AP", vt), et ? vt.set("N", et) : vt.set("N", J), dt;
        }
        static async createNewAppearanceStream(D, G, et) {
          const { color: J, rect: it, paths: lt, thickness: ot, opacity: ut } = D, ct = [`${ot} w 1 J 1 j`, `${(0, p.getPdfColor)(J, !1)}`];
          ut !== 1 && ct.push("/R0 gs");
          const gt = [];
          for (const { bezier: xt } of lt) {
            gt.length = 0, gt.push(`${(0, g.numberToString)(xt[0])} ${(0, g.numberToString)(xt[1])} m`);
            for (let St = 2, Mt = xt.length; St < Mt; St += 6) {
              const Et = xt.slice(St, St + 6).map(g.numberToString).join(" ");
              gt.push(`${Et} c`);
            }
            gt.push("S"), ct.push(gt.join(`
`));
          }
          const dt = ct.join(`
`), bt = new n.Dict(G);
          if (bt.set("FormType", 1), bt.set("Subtype", n.Name.get("Form")), bt.set("Type", n.Name.get("XObject")), bt.set("BBox", it), bt.set("Length", dt.length), ut !== 1) {
            const xt = new n.Dict(G), St = new n.Dict(G), Mt = new n.Dict(G);
            Mt.set("CA", ut), Mt.set("Type", n.Name.get("ExtGState")), St.set("R0", Mt), xt.set("ExtGState", St), bt.set("Resources", xt);
          }
          const vt = new a.StringStream(dt);
          return vt.dict = bt, vt;
        }
      }
      class rt extends $ {
        constructor(D) {
          var J;
          super(D);
          const { dict: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.HIGHLIGHT, this.data.quadPoints = R(G, null)) {
            const it = (J = this.appearance) == null ? void 0 : J.dict.get("Resources");
            if (!this.appearance || !(it != null && it.has("ExtGState"))) {
              this.appearance && (0, o.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
              const lt = this.color ? I(this.color) : [1, 1, 0], ot = G.get("CA");
              this._setDefaultAppearance({ xref: et, fillColor: lt, blendMode: "Multiply", fillAlpha: ot, pointsCallback: (ut, ct) => (ut.push(`${ct[0].x} ${ct[0].y} m`, `${ct[1].x} ${ct[1].y} l`, `${ct[3].x} ${ct[3].y} l`, `${ct[2].x} ${ct[2].y} l`, "f"), [ct[0].x, ct[1].x, ct[3].y, ct[1].y]) });
            }
          } else this.data.popupRef = null;
        }
      }
      class st extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.UNDERLINE, this.data.quadPoints = R(G, null)) {
            if (!this.appearance) {
              const J = this.color ? I(this.color) : [0, 0, 0], it = G.get("CA");
              this._setDefaultAppearance({ xref: et, extra: "[] 0 d 0.571 w", strokeColor: J, strokeAlpha: it, pointsCallback: (lt, ot) => (lt.push(`${ot[2].x} ${ot[2].y + 1.3} m`, `${ot[3].x} ${ot[3].y + 1.3} l`, "S"), [ot[0].x, ot[1].x, ot[3].y, ot[1].y]) });
            }
          } else this.data.popupRef = null;
        }
      }
      class mt extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.SQUIGGLY, this.data.quadPoints = R(G, null)) {
            if (!this.appearance) {
              const J = this.color ? I(this.color) : [0, 0, 0], it = G.get("CA");
              this._setDefaultAppearance({ xref: et, extra: "[] 0 d 1 w", strokeColor: J, strokeAlpha: it, pointsCallback: (lt, ot) => {
                const ut = (ot[0].y - ot[2].y) / 6;
                let ct = ut, gt = ot[2].x;
                const dt = ot[2].y, bt = ot[3].x;
                lt.push(`${gt} ${dt + ct} m`);
                do
                  gt += 2, ct = ct === 0 ? ut : 0, lt.push(`${gt} ${dt + ct} l`);
                while (gt < bt);
                return lt.push("S"), [ot[2].x, bt, dt - 2 * ut, dt + 2 * ut];
              } });
            }
          } else this.data.popupRef = null;
        }
      }
      class yt extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D;
          if (this.data.annotationType = o.AnnotationType.STRIKEOUT, this.data.quadPoints = R(G, null)) {
            if (!this.appearance) {
              const J = this.color ? I(this.color) : [0, 0, 0], it = G.get("CA");
              this._setDefaultAppearance({ xref: et, extra: "[] 0 d 1 w", strokeColor: J, strokeAlpha: it, pointsCallback: (lt, ot) => (lt.push((ot[0].x + ot[2].x) / 2 + " " + (ot[0].y + ot[2].y) / 2 + " m", (ot[1].x + ot[3].x) / 2 + " " + (ot[1].y + ot[3].y) / 2 + " l", "S"), [ot[0].x, ot[1].x, ot[3].y, ot[1].y]) });
            }
          } else this.data.popupRef = null;
        }
      }
      class at extends $ {
        constructor(D) {
          super(D), this.data.annotationType = o.AnnotationType.STAMP, this.data.hasOwnCanvas = this.data.noRotate;
        }
        static async createImage(D, G) {
          const { width: et, height: J } = D, it = new OffscreenCanvas(et, J), lt = it.getContext("2d", { alpha: !0 });
          lt.drawImage(D, 0, 0);
          const ot = lt.getImageData(0, 0, et, J).data, ut = new Uint32Array(ot.buffer), ct = ut.some(o.FeatureTest.isLittleEndian ? (St) => St >>> 24 != 255 : (St) => (255 & St) != 255);
          ct && (lt.fillStyle = "white", lt.fillRect(0, 0, et, J), lt.drawImage(D, 0, 0));
          const gt = it.convertToBlob({ type: "image/jpeg", quality: 1 }).then((St) => St.arrayBuffer()), dt = n.Name.get("XObject"), bt = n.Name.get("Image"), vt = new n.Dict(G);
          vt.set("Type", dt), vt.set("Subtype", bt), vt.set("BitsPerComponent", 8), vt.set("ColorSpace", n.Name.get("DeviceRGB")), vt.set("Filter", n.Name.get("DCTDecode")), vt.set("BBox", [0, 0, et, J]), vt.set("Width", et), vt.set("Height", J);
          let xt = null;
          if (ct) {
            const St = new Uint8Array(ut.length);
            if (o.FeatureTest.isLittleEndian) for (let Et = 0, Ft = ut.length; Et < Ft; Et++) St[Et] = ut[Et] >>> 24;
            else for (let Et = 0, Ft = ut.length; Et < Ft; Et++) St[Et] = 255 & ut[Et];
            const Mt = new n.Dict(G);
            Mt.set("Type", dt), Mt.set("Subtype", bt), Mt.set("BitsPerComponent", 8), Mt.set("ColorSpace", n.Name.get("DeviceGray")), Mt.set("Width", et), Mt.set("Height", J), xt = new a.Stream(St, 0, 0, Mt);
          }
          return { imageStream: new a.Stream(await gt, 0, 0, vt), smaskStream: xt, width: et, height: J };
        }
        static createNewDict(D, G, { apRef: et, ap: J }) {
          const { rect: it, rotation: lt, user: ot } = D, ut = new n.Dict(G);
          if (ut.set("Type", n.Name.get("Annot")), ut.set("Subtype", n.Name.get("Stamp")), ut.set("CreationDate", `D:${(0, o.getModificationDate)()}`), ut.set("Rect", it), ut.set("F", 4), ut.set("Border", [0, 0, 0]), ut.set("Rotate", lt), ot && ut.set("T", (0, g.isAscii)(ot) ? ot : (0, g.stringToUTF16String)(ot, !0)), et || J) {
            const ct = new n.Dict(G);
            ut.set("AP", ct), et ? ct.set("N", et) : ct.set("N", J);
          }
          return ut;
        }
        static async createNewAppearanceStream(D, G, et) {
          const { rotation: J } = D, { imageRef: it, width: lt, height: ot } = et.image, ut = new n.Dict(G), ct = new n.Dict(G);
          ut.set("XObject", ct), ct.set("Im0", it);
          const gt = `q ${lt} 0 0 ${ot} 0 0 cm /Im0 Do Q`, dt = new n.Dict(G);
          if (dt.set("FormType", 1), dt.set("Subtype", n.Name.get("Form")), dt.set("Type", n.Name.get("XObject")), dt.set("BBox", [0, 0, lt, ot]), dt.set("Resources", ut), J) {
            const vt = (0, g.getRotationMatrix)(J, lt, ot);
            dt.set("Matrix", vt);
          }
          const bt = new a.StringStream(gt);
          return bt.dict = dt, bt;
        }
      }
      class nt extends $ {
        constructor(D) {
          super(D);
          const { dict: G, xref: et } = D, J = new v.FileSpec(G.get("FS"), et);
          this.data.annotationType = o.AnnotationType.FILEATTACHMENT, this.data.hasOwnCanvas = this.data.noRotate, this.data.file = J.serializable;
          const it = G.get("Name");
          this.data.name = it instanceof n.Name ? (0, o.stringToPDFString)(it.name) : "PushPin";
          const lt = G.get("ca");
          this.data.fillAlpha = typeof lt == "number" && lt >= 0 && lt <= 1 ? lt : null;
        }
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.FakeUnicodeFont = void 0, l.createDefaultAppearance = function({ fontSize: M, fontName: O, fontColor: E }) {
        return `/${(0, g.escapePDFName)(O)} ${M} Tf ${h(E, !0)}`;
      }, l.getPdfColor = h, l.parseAppearanceStream = function(M, O, E) {
        return new v(M, O, E).parse();
      }, l.parseDefaultAppearance = function(M) {
        return new w(M).parse();
      };
      var o = f(4), g = f(3), p = f(2), n = f(12), a = f(13), d = f(59), m = f(57), b = f(8);
      class w extends a.EvaluatorPreprocessor {
        constructor(M) {
          super(new b.StringStream(M));
        }
        parse() {
          const M = { fn: 0, args: [] }, O = { fontSize: 0, fontName: "", fontColor: new Uint8ClampedArray(3) };
          try {
            for (; M.args.length = 0, !!this.read(M); ) {
              if (this.savedStatesDepth !== 0) continue;
              const { fn: E, args: I } = M;
              switch (0 | E) {
                case p.OPS.setFont:
                  const [R, W] = I;
                  R instanceof o.Name && (O.fontName = R.name), typeof W == "number" && W > 0 && (O.fontSize = W);
                  break;
                case p.OPS.setFillRGBColor:
                  n.ColorSpace.singletons.rgb.getRgbItem(I, 0, O.fontColor, 0);
                  break;
                case p.OPS.setFillGray:
                  n.ColorSpace.singletons.gray.getRgbItem(I, 0, O.fontColor, 0);
                  break;
                case p.OPS.setFillCMYKColor:
                  n.ColorSpace.singletons.cmyk.getRgbItem(I, 0, O.fontColor, 0);
              }
            }
          } catch (E) {
            (0, p.warn)(`parseDefaultAppearance - ignoring errors: "${E}".`);
          }
          return O;
        }
      }
      class v extends a.EvaluatorPreprocessor {
        constructor(M, O, E) {
          var I;
          super(M), this.stream = M, this.evaluatorOptions = O, this.xref = E, this.resources = (I = M.dict) == null ? void 0 : I.get("Resources");
        }
        parse() {
          const M = { fn: 0, args: [] };
          let O = { scaleFactor: 1, fontSize: 0, fontName: "", fontColor: new Uint8ClampedArray(3), fillColorSpace: n.ColorSpace.singletons.gray }, E = !1;
          const I = [];
          try {
            for (; M.args.length = 0, !(E || !this.read(M)); ) {
              const { fn: R, args: W } = M;
              switch (0 | R) {
                case p.OPS.save:
                  I.push({ scaleFactor: O.scaleFactor, fontSize: O.fontSize, fontName: O.fontName, fontColor: O.fontColor.slice(), fillColorSpace: O.fillColorSpace });
                  break;
                case p.OPS.restore:
                  O = I.pop() || O;
                  break;
                case p.OPS.setTextMatrix:
                  O.scaleFactor *= Math.hypot(W[0], W[1]);
                  break;
                case p.OPS.setFont:
                  const [z, j] = W;
                  z instanceof o.Name && (O.fontName = z.name), typeof j == "number" && j > 0 && (O.fontSize = j * O.scaleFactor);
                  break;
                case p.OPS.setFillColorSpace:
                  O.fillColorSpace = n.ColorSpace.parse({ cs: W[0], xref: this.xref, resources: this.resources, pdfFunctionFactory: this._pdfFunctionFactory, localColorSpaceCache: this._localColorSpaceCache });
                  break;
                case p.OPS.setFillColor:
                  O.fillColorSpace.getRgbItem(W, 0, O.fontColor, 0);
                  break;
                case p.OPS.setFillRGBColor:
                  n.ColorSpace.singletons.rgb.getRgbItem(W, 0, O.fontColor, 0);
                  break;
                case p.OPS.setFillGray:
                  n.ColorSpace.singletons.gray.getRgbItem(W, 0, O.fontColor, 0);
                  break;
                case p.OPS.setFillCMYKColor:
                  n.ColorSpace.singletons.cmyk.getRgbItem(W, 0, O.fontColor, 0);
                  break;
                case p.OPS.showText:
                case p.OPS.showSpacedText:
                case p.OPS.nextLineShowText:
                case p.OPS.nextLineSetSpacingShowText:
                  E = !0;
              }
            }
          } catch (R) {
            (0, p.warn)(`parseAppearanceStream - ignoring errors: "${R}".`);
          }
          return this.stream.reset(), delete O.scaleFactor, delete O.fillColorSpace, O;
        }
        get _localColorSpaceCache() {
          return (0, p.shadow)(this, "_localColorSpaceCache", new d.LocalColorSpaceCache());
        }
        get _pdfFunctionFactory() {
          const M = new m.PDFFunctionFactory({ xref: this.xref, isEvalSupported: this.evaluatorOptions.isEvalSupported });
          return (0, p.shadow)(this, "_pdfFunctionFactory", M);
        }
      }
      function h(_, M) {
        if (_[0] === _[1] && _[1] === _[2]) {
          const O = _[0] / 255;
          return `${(0, g.numberToString)(O)} ${M ? "g" : "G"}`;
        }
        return Array.from(_, (O) => (0, g.numberToString)(O / 255)).join(" ") + " " + (M ? "rg" : "RG");
      }
      class x {
        constructor(M, O) {
          this.xref = M, this.widths = null, this.firstChar = 1 / 0, this.lastChar = -1 / 0, this.fontFamily = O;
          const E = new OffscreenCanvas(1, 1);
          this.ctxMeasure = E.getContext("2d"), x._fontNameId || (x._fontNameId = 1), this.fontName = o.Name.get(`InvalidPDFjsFont_${O}_${x._fontNameId++}`);
        }
        get toUnicodeRef() {
          if (!x._toUnicodeRef) {
            const M = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`, O = x.toUnicodeStream = new b.StringStream(M), E = new o.Dict(this.xref);
            O.dict = E, E.set("Length", M.length), x._toUnicodeRef = this.xref.getNewPersistentRef(O);
          }
          return x._toUnicodeRef;
        }
        get fontDescriptorRef() {
          if (!x._fontDescriptorRef) {
            const M = new o.Dict(this.xref);
            M.set("Type", o.Name.get("FontDescriptor")), M.set("FontName", this.fontName), M.set("FontFamily", "MyriadPro Regular"), M.set("FontBBox", [0, 0, 0, 0]), M.set("FontStretch", o.Name.get("Normal")), M.set("FontWeight", 400), M.set("ItalicAngle", 0), x._fontDescriptorRef = this.xref.getNewPersistentRef(M);
          }
          return x._fontDescriptorRef;
        }
        get descendantFontRef() {
          const M = new o.Dict(this.xref);
          M.set("BaseFont", this.fontName), M.set("Type", o.Name.get("Font")), M.set("Subtype", o.Name.get("CIDFontType0")), M.set("CIDToGIDMap", o.Name.get("Identity")), M.set("FirstChar", this.firstChar), M.set("LastChar", this.lastChar), M.set("FontDescriptor", this.fontDescriptorRef), M.set("DW", 1e3);
          const O = [], E = [...this.widths.entries()].sort();
          let I = null, R = null;
          for (const [z, j] of E) I ? z === I + R.length ? R.push(j) : (O.push(I, R), I = z, R = [j]) : (I = z, R = [j]);
          I && O.push(I, R), M.set("W", O);
          const W = new o.Dict(this.xref);
          return W.set("Ordering", "Identity"), W.set("Registry", "Adobe"), W.set("Supplement", 0), M.set("CIDSystemInfo", W), this.xref.getNewPersistentRef(M);
        }
        get baseFontRef() {
          const M = new o.Dict(this.xref);
          return M.set("BaseFont", this.fontName), M.set("Type", o.Name.get("Font")), M.set("Subtype", o.Name.get("Type0")), M.set("Encoding", o.Name.get("Identity-H")), M.set("DescendantFonts", [this.descendantFontRef]), M.set("ToUnicode", this.toUnicodeRef), this.xref.getNewPersistentRef(M);
        }
        get resources() {
          const M = new o.Dict(this.xref), O = new o.Dict(this.xref);
          return O.set(this.fontName.name, this.baseFontRef), M.set("Font", O), M;
        }
        _createContext() {
          return this.widths = /* @__PURE__ */ new Map(), this.ctxMeasure.font = `1000px ${this.fontFamily}`, this.ctxMeasure;
        }
        createFontResources(M) {
          const O = this._createContext();
          for (const E of M.split(/\r\n?|\n/)) for (const I of E.split("")) {
            const R = I.charCodeAt(0);
            if (this.widths.has(R)) continue;
            const W = O.measureText(I), z = Math.ceil(W.width);
            this.widths.set(R, z), this.firstChar = Math.min(R, this.firstChar), this.lastChar = Math.max(R, this.lastChar);
          }
          return this.resources;
        }
        createAppearance(M, O, E, I, R, W) {
          const z = this._createContext(), j = [];
          let $ = -1 / 0;
          for (const mt of M.split(/\r\n?|\n/)) {
            j.push(mt);
            const yt = z.measureText(mt).width;
            $ = Math.max($, yt);
            for (const at of mt.split("")) {
              const nt = at.charCodeAt(0);
              let q = this.widths.get(nt);
              if (q === void 0) {
                const D = z.measureText(at);
                q = Math.ceil(D.width), this.widths.set(nt, q), this.firstChar = Math.min(nt, this.firstChar), this.lastChar = Math.max(nt, this.lastChar);
              }
            }
          }
          $ *= I / 1e3;
          const [B, C, T, F] = O;
          let S = T - B, A = F - C;
          E % 180 != 0 && ([S, A] = [A, S]);
          let U = 1;
          $ > S && (U = S / $);
          let K = 1;
          const X = p.LINE_FACTOR * I, L = p.LINE_DESCENT_FACTOR * I, H = X * j.length;
          H > A && (K = A / H);
          const Q = I * Math.min(U, K), N = ["q", `0 0 ${(0, g.numberToString)(S)} ${(0, g.numberToString)(A)} re W n`, "BT", `1 0 0 1 0 ${(0, g.numberToString)(A + L)} Tm 0 Tc ${h(R, !0)}`, `/${this.fontName.name} ${(0, g.numberToString)(Q)} Tf`], { resources: V } = this;
          if ((W = typeof W == "number" && W >= 0 && W <= 1 ? W : 1) !== 1) {
            N.push("/R0 gs");
            const mt = new o.Dict(this.xref), yt = new o.Dict(this.xref);
            yt.set("ca", W), yt.set("CA", W), yt.set("Type", o.Name.get("ExtGState")), mt.set("R0", yt), V.set("ExtGState", mt);
          }
          const Y = (0, g.numberToString)(X);
          for (const mt of j) N.push(`0 -${Y} Td <${(0, g.stringToUTF16HexString)(mt)}> Tj`);
          N.push("ET", "Q");
          const Z = N.join(`
`), rt = new o.Dict(this.xref);
          if (rt.set("Subtype", o.Name.get("Form")), rt.set("Type", o.Name.get("XObject")), rt.set("BBox", [0, 0, S, A]), rt.set("Length", Z.length), rt.set("Resources", V), E) {
            const mt = (0, g.getRotationMatrix)(E, S, A);
            rt.set("Matrix", mt);
          }
          const st = new b.StringStream(Z);
          return st.dict = rt, st;
        }
      }
      l.FakeUnicodeFont = x;
    }, (u, l, f) => {
      var O, K9, I, Y9, W, z, j, $, B, C, T, F, S, vu, oM, lM, Jd, wu, xu, cM, uM, hM, Z9, rt, Qd, t2, J9;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ColorSpace = void 0;
      var o = f(2), g = f(4), p = f(5), n = f(3);
      class a {
        constructor(nt, q) {
          this.constructor === a && (0, o.unreachable)("Cannot initialize ColorSpace."), this.name = nt, this.numComps = q;
        }
        getRgb(nt, q) {
          const D = new Uint8ClampedArray(3);
          return this.getRgbItem(nt, q, D, 0), D;
        }
        getRgbItem(nt, q, D, G) {
          (0, o.unreachable)("Should not call ColorSpace.getRgbItem");
        }
        getRgbBuffer(nt, q, D, G, et, J, it) {
          (0, o.unreachable)("Should not call ColorSpace.getRgbBuffer");
        }
        getOutputLength(nt, q) {
          (0, o.unreachable)("Should not call ColorSpace.getOutputLength");
        }
        isPassthrough(nt) {
          return !1;
        }
        isDefaultDecode(nt, q) {
          return a.isDefaultDecode(nt, this.numComps);
        }
        fillRgb(nt, q, D, G, et, J, it, lt, ot) {
          const ut = q * D;
          let ct = null;
          const gt = 1 << it, dt = D !== et || q !== G;
          if (this.isPassthrough(it)) ct = lt;
          else if (this.numComps === 1 && ut > gt && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
            const bt = it <= 8 ? new Uint8Array(gt) : new Uint16Array(gt);
            for (let xt = 0; xt < gt; xt++) bt[xt] = xt;
            const vt = new Uint8ClampedArray(3 * gt);
            if (this.getRgbBuffer(bt, 0, gt, vt, 0, it, 0), dt) {
              ct = new Uint8Array(3 * ut);
              let xt = 0;
              for (let St = 0; St < ut; ++St) {
                const Mt = 3 * lt[St];
                ct[xt++] = vt[Mt], ct[xt++] = vt[Mt + 1], ct[xt++] = vt[Mt + 2];
              }
            } else {
              let xt = 0;
              for (let St = 0; St < ut; ++St) {
                const Mt = 3 * lt[St];
                nt[xt++] = vt[Mt], nt[xt++] = vt[Mt + 1], nt[xt++] = vt[Mt + 2], xt += ot;
              }
            }
          } else dt ? (ct = new Uint8ClampedArray(3 * ut), this.getRgbBuffer(lt, 0, ut, ct, 0, it, 0)) : this.getRgbBuffer(lt, 0, G * J, nt, 0, it, ot);
          if (ct) if (dt) (function(vt, xt, St, Mt, Et, Ft, Wt) {
            Wt = Wt !== 1 ? 0 : Wt;
            const Kt = St / Et, qt = Mt / Ft;
            let It, re = 0;
            const le = new Uint16Array(Et), Ce = 3 * St;
            for (let ce = 0; ce < Et; ce++) le[ce] = 3 * Math.floor(ce * Kt);
            for (let ce = 0; ce < Ft; ce++) {
              const xe = Math.floor(ce * qt) * Ce;
              for (let ve = 0; ve < Et; ve++)
                It = xe + le[ve], xt[re++] = vt[It++], xt[re++] = vt[It++], xt[re++] = vt[It++], re += Wt;
            }
          })(ct, nt, q, D, G, et, ot);
          else {
            let bt = 0, vt = 0;
            for (let xt = 0, St = G * J; xt < St; xt++)
              nt[bt++] = ct[vt++], nt[bt++] = ct[vt++], nt[bt++] = ct[vt++], bt += ot;
          }
        }
        get usesZeroToOneRange() {
          return (0, o.shadow)(this, "usesZeroToOneRange", !0);
        }
        static _cache(nt, q, D, G) {
          if (!D) throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
          if (!G) throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
          let et, J;
          nt instanceof g.Ref && (J = nt, nt = q.fetch(nt)), nt instanceof g.Name && (et = nt.name), (et || J) && D.set(et, J, G);
        }
        static getCached(nt, q, D) {
          if (!D) throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
          if (nt instanceof g.Ref) {
            const G = D.getByRef(nt);
            if (G) return G;
            try {
              nt = q.fetch(nt);
            } catch (et) {
              if (et instanceof n.MissingDataException) throw et;
            }
          }
          if (nt instanceof g.Name) {
            const G = D.getByName(nt.name);
            if (G) return G;
          }
          return null;
        }
        static async parseAsync({ cs: nt, xref: q, resources: D = null, pdfFunctionFactory: G, localColorSpaceCache: et }) {
          const J = this._parse(nt, q, D, G);
          return this._cache(nt, q, et, J), J;
        }
        static parse({ cs: nt, xref: q, resources: D = null, pdfFunctionFactory: G, localColorSpaceCache: et }) {
          const J = this.getCached(nt, q, et);
          if (J) return J;
          const it = this._parse(nt, q, D, G);
          return this._cache(nt, q, et, it), it;
        }
        static _parse(nt, q, D = null, G) {
          if ((nt = q.fetchIfRef(nt)) instanceof g.Name) switch (nt.name) {
            case "G":
            case "DeviceGray":
              return this.singletons.gray;
            case "RGB":
            case "DeviceRGB":
              return this.singletons.rgb;
            case "CMYK":
            case "DeviceCMYK":
              return this.singletons.cmyk;
            case "Pattern":
              return new m(null);
            default:
              if (D instanceof g.Dict) {
                const et = D.get("ColorSpace");
                if (et instanceof g.Dict) {
                  const J = et.get(nt.name);
                  if (J) {
                    if (J instanceof g.Name) return this._parse(J, q, D, G);
                    nt = J;
                    break;
                  }
                }
              }
              throw new o.FormatError(`Unrecognized ColorSpace: ${nt.name}`);
          }
          if (Array.isArray(nt)) {
            const et = q.fetchIfRef(nt[0]).name;
            let J, it, lt, ot, ut, ct;
            switch (et) {
              case "G":
              case "DeviceGray":
                return this.singletons.gray;
              case "RGB":
              case "DeviceRGB":
                return this.singletons.rgb;
              case "CMYK":
              case "DeviceCMYK":
                return this.singletons.cmyk;
              case "CalGray":
                return J = q.fetchIfRef(nt[1]), ot = J.getArray("WhitePoint"), ut = J.getArray("BlackPoint"), ct = J.get("Gamma"), new x(ot, ut, ct);
              case "CalRGB":
                J = q.fetchIfRef(nt[1]), ot = J.getArray("WhitePoint"), ut = J.getArray("BlackPoint"), ct = J.getArray("Gamma");
                const gt = J.getArray("Matrix");
                return new _(ot, ut, ct, gt);
              case "ICCBased":
                const dt = q.fetchIfRef(nt[1]).dict;
                it = dt.get("N");
                const bt = dt.get("Alternate");
                if (bt) {
                  const Ft = this._parse(bt, q, D, G);
                  if (Ft.numComps === it) return Ft;
                  (0, o.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                }
                if (it === 1) return this.singletons.gray;
                if (it === 3) return this.singletons.rgb;
                if (it === 4) return this.singletons.cmyk;
                break;
              case "Pattern":
                return lt = nt[1] || null, lt && (lt = this._parse(lt, q, D, G)), new m(lt);
              case "I":
              case "Indexed":
                lt = this._parse(nt[1], q, D, G);
                const vt = q.fetchIfRef(nt[2]) + 1, xt = q.fetchIfRef(nt[3]);
                return new b(lt, vt, xt);
              case "Separation":
              case "DeviceN":
                const St = q.fetchIfRef(nt[1]);
                it = Array.isArray(St) ? St.length : 1, lt = this._parse(nt[2], q, D, G);
                const Mt = G.create(nt[3]);
                return new d(it, lt, Mt);
              case "Lab":
                J = q.fetchIfRef(nt[1]), ot = J.getArray("WhitePoint"), ut = J.getArray("BlackPoint");
                const Et = J.getArray("Range");
                return new M(ot, ut, Et);
              default:
                throw new o.FormatError(`Unimplemented ColorSpace object: ${et}`);
            }
          }
          throw new o.FormatError(`Unrecognized ColorSpace object: ${nt}`);
        }
        static isDefaultDecode(nt, q) {
          if (!Array.isArray(nt)) return !0;
          if (2 * q !== nt.length)
            return (0, o.warn)("The decode map is not the correct length"), !0;
          for (let D = 0, G = nt.length; D < G; D += 2) if (nt[D] !== 0 || nt[D + 1] !== 1) return !1;
          return !0;
        }
        static get singletons() {
          return (0, o.shadow)(this, "singletons", { get gray() {
            return (0, o.shadow)(this, "gray", new w());
          }, get rgb() {
            return (0, o.shadow)(this, "rgb", new v());
          }, get cmyk() {
            return (0, o.shadow)(this, "cmyk", new h());
          } });
        }
      }
      l.ColorSpace = a;
      class d extends a {
        constructor(nt, q, D) {
          super("Alternate", nt), this.base = q, this.tintFn = D, this.tmpBuf = new Float32Array(q.numComps);
        }
        getRgbItem(nt, q, D, G) {
          const et = this.tmpBuf;
          this.tintFn(nt, q, et, 0), this.base.getRgbItem(et, 0, D, G);
        }
        getRgbBuffer(nt, q, D, G, et, J, it) {
          const lt = this.tintFn, ot = this.base, ut = 1 / ((1 << J) - 1), ct = ot.numComps, gt = ot.usesZeroToOneRange, dt = (ot.isPassthrough(8) || !gt) && it === 0;
          let bt = dt ? et : 0;
          const vt = dt ? G : new Uint8ClampedArray(ct * D), xt = this.numComps, St = new Float32Array(xt), Mt = new Float32Array(ct);
          let Et, Ft;
          for (Et = 0; Et < D; Et++) {
            for (Ft = 0; Ft < xt; Ft++) St[Ft] = nt[q++] * ut;
            if (lt(St, 0, Mt, 0), gt) for (Ft = 0; Ft < ct; Ft++) vt[bt++] = 255 * Mt[Ft];
            else
              ot.getRgbItem(Mt, 0, vt, bt), bt += ct;
          }
          dt || ot.getRgbBuffer(vt, 0, D, G, et, 8, it);
        }
        getOutputLength(nt, q) {
          return this.base.getOutputLength(nt * this.base.numComps / this.numComps, q);
        }
      }
      class m extends a {
        constructor(nt) {
          super("Pattern", null), this.base = nt;
        }
        isDefaultDecode(nt, q) {
          (0, o.unreachable)("Should not call PatternCS.isDefaultDecode");
        }
      }
      class b extends a {
        constructor(nt, q, D) {
          super("Indexed", 1), this.base = nt, this.highVal = q;
          const G = nt.numComps * q;
          if (this.lookup = new Uint8Array(G), D instanceof p.BaseStream) {
            const et = D.getBytes(G);
            this.lookup.set(et);
          } else {
            if (typeof D != "string") throw new o.FormatError(`IndexedCS - unrecognized lookup table: ${D}`);
            for (let et = 0; et < G; ++et) this.lookup[et] = 255 & D.charCodeAt(et);
          }
        }
        getRgbItem(nt, q, D, G) {
          const et = this.base.numComps, J = nt[q] * et;
          this.base.getRgbBuffer(this.lookup, J, 1, D, G, 8, 0);
        }
        getRgbBuffer(nt, q, D, G, et, J, it) {
          const lt = this.base, ot = lt.numComps, ut = lt.getOutputLength(ot, it), ct = this.lookup;
          for (let gt = 0; gt < D; ++gt) {
            const dt = nt[q++] * ot;
            lt.getRgbBuffer(ct, dt, 1, G, et, 8, it), et += ut;
          }
        }
        getOutputLength(nt, q) {
          return this.base.getOutputLength(nt * this.base.numComps, q);
        }
        isDefaultDecode(nt, q) {
          return Array.isArray(nt) ? nt.length !== 2 ? ((0, o.warn)("Decode map length is not correct"), !0) : !Number.isInteger(q) || q < 1 ? ((0, o.warn)("Bits per component is not correct"), !0) : nt[0] === 0 && nt[1] === (1 << q) - 1 : !0;
        }
      }
      class w extends a {
        constructor() {
          super("DeviceGray", 1);
        }
        getRgbItem(nt, q, D, G) {
          const et = 255 * nt[q];
          D[G] = D[G + 1] = D[G + 2] = et;
        }
        getRgbBuffer(nt, q, D, G, et, J, it) {
          const lt = 255 / ((1 << J) - 1);
          let ot = q, ut = et;
          for (let ct = 0; ct < D; ++ct) {
            const gt = lt * nt[ot++];
            G[ut++] = gt, G[ut++] = gt, G[ut++] = gt, ut += it;
          }
        }
        getOutputLength(nt, q) {
          return nt * (3 + q);
        }
      }
      class v extends a {
        constructor() {
          super("DeviceRGB", 3);
        }
        getRgbItem(nt, q, D, G) {
          D[G] = 255 * nt[q], D[G + 1] = 255 * nt[q + 1], D[G + 2] = 255 * nt[q + 2];
        }
        getRgbBuffer(nt, q, D, G, et, J, it) {
          if (J === 8 && it === 0) {
            G.set(nt.subarray(q, q + 3 * D), et);
            return;
          }
          const lt = 255 / ((1 << J) - 1);
          let ot = q, ut = et;
          for (let ct = 0; ct < D; ++ct)
            G[ut++] = lt * nt[ot++], G[ut++] = lt * nt[ot++], G[ut++] = lt * nt[ot++], ut += it;
        }
        getOutputLength(nt, q) {
          return nt * (3 + q) / 3 | 0;
        }
        isPassthrough(nt) {
          return nt === 8;
        }
      }
      class h extends a {
        constructor() {
          super("DeviceCMYK", 4);
          lr(this, O);
        }
        getRgbItem(q, D, G, et) {
          Le(this, O, K9).call(this, q, D, 1, G, et);
        }
        getRgbBuffer(q, D, G, et, J, it, lt) {
          const ot = 1 / ((1 << it) - 1);
          for (let ut = 0; ut < G; ut++)
            Le(this, O, K9).call(this, q, D, ot, et, J), D += 4, J += 3 + lt;
        }
        getOutputLength(q, D) {
          return q / 4 * (3 + D) | 0;
        }
      }
      O = new WeakSet(), K9 = function(q, D, G, et, J) {
        const it = q[D] * G, lt = q[D + 1] * G, ot = q[D + 2] * G, ut = q[D + 3] * G;
        et[J] = 255 + it * (-4.387332384609988 * it + 54.48615194189176 * lt + 18.82290502165302 * ot + 212.25662451639585 * ut - 285.2331026137004) + lt * (1.7149763477362134 * lt - 5.6096736904047315 * ot + -17.873870861415444 * ut - 5.497006427196366) + ot * (-2.5217340131683033 * ot - 21.248923337353073 * ut + 17.5119270841813) + ut * (-21.86122147463605 * ut - 189.48180835922747), et[J + 1] = 255 + it * (8.841041422036149 * it + 60.118027045597366 * lt + 6.871425592049007 * ot + 31.159100130055922 * ut - 79.2970844816548) + lt * (-15.310361306967817 * lt + 17.575251261109482 * ot + 131.35250912493976 * ut - 190.9453302588951) + ot * (4.444339102852739 * ot + 9.8632861493405 * ut - 24.86741582555878) + ut * (-20.737325471181034 * ut - 187.80453709719578), et[J + 2] = 255 + it * (0.8842522430003296 * it + 8.078677503112928 * lt + 30.89978309703729 * ot - 0.23883238689178934 * ut - 14.183576799673286) + lt * (10.49593273432072 * lt + 63.02378494754052 * ot + 50.606957656360734 * ut - 112.23884253719248) + ot * (0.03296041114873217 * ot + 115.60384449646641 * ut - 193.58209356861505) + ut * (-22.33816807309886 * ut - 180.12613974708367);
      };
      class x extends a {
        constructor(q, D, G) {
          super("CalGray", 1);
          lr(this, I);
          if (!q) throw new o.FormatError("WhitePoint missing - required for color space CalGray");
          if ([this.XW, this.YW, this.ZW] = q, [this.XB, this.YB, this.ZB] = D || [0, 0, 0], this.G = G || 1, this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new o.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
          (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, o.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`), this.XB = this.YB = this.ZB = 0), this.XB === 0 && this.YB === 0 && this.ZB === 0 || (0, o.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`), this.G < 1 && ((0, o.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`), this.G = 1);
        }
        getRgbItem(q, D, G, et) {
          Le(this, I, Y9).call(this, q, D, G, et, 1);
        }
        getRgbBuffer(q, D, G, et, J, it, lt) {
          const ot = 1 / ((1 << it) - 1);
          for (let ut = 0; ut < G; ++ut)
            Le(this, I, Y9).call(this, q, D, et, J, ot), D += 1, J += 3 + lt;
        }
        getOutputLength(q, D) {
          return q * (3 + D);
        }
      }
      I = new WeakSet(), Y9 = function(q, D, G, et, J) {
        const it = (q[D] * J) ** this.G, lt = this.YW * it, ot = Math.max(295.8 * lt ** 0.3333333333333333 - 40.8, 0);
        G[et] = ot, G[et + 1] = ot, G[et + 2] = ot;
      };
      const Z = class Z extends a {
        constructor(q, D, G, et) {
          super("CalRGB", 3);
          lr(this, S);
          if (!q) throw new o.FormatError("WhitePoint missing - required for color space CalRGB");
          const [J, it, lt] = this.whitePoint = q, [ot, ut, ct] = this.blackPoint = D || new Float32Array(3);
          if ([this.GR, this.GG, this.GB] = G || new Float32Array([1, 1, 1]), [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = et || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]), J < 0 || lt < 0 || it !== 1) throw new o.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
          (ot < 0 || ut < 0 || ct < 0) && ((0, o.info)(`Invalid BlackPoint for ${this.name} [${ot}, ${ut}, ${ct}], falling back to default.`), this.blackPoint = new Float32Array(3)), (this.GR < 0 || this.GG < 0 || this.GB < 0) && ((0, o.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`), this.GR = this.GG = this.GB = 1);
        }
        getRgbItem(q, D, G, et) {
          Le(this, S, Z9).call(this, q, D, G, et, 1);
        }
        getRgbBuffer(q, D, G, et, J, it, lt) {
          const ot = 1 / ((1 << it) - 1);
          for (let ut = 0; ut < G; ++ut)
            Le(this, S, Z9).call(this, q, D, et, J, ot), D += 3, J += 3 + lt;
        }
        getOutputLength(q, D) {
          return q * (3 + D) / 3 | 0;
        }
      };
      W = new WeakMap(), z = new WeakMap(), j = new WeakMap(), $ = new WeakMap(), B = new WeakMap(), C = new WeakMap(), T = new WeakMap(), F = new WeakMap(), S = new WeakSet(), vu = function(q, D, G) {
        G[0] = q[0] * D[0] + q[1] * D[1] + q[2] * D[2], G[1] = q[3] * D[0] + q[4] * D[1] + q[5] * D[2], G[2] = q[6] * D[0] + q[7] * D[1] + q[8] * D[2];
      }, oM = function(q, D, G) {
        G[0] = 1 * D[0] / q[0], G[1] = 1 * D[1] / q[1], G[2] = 1 * D[2] / q[2];
      }, lM = function(q, D, G) {
        G[0] = 0.95047 * D[0] / q[0], G[1] = 1 * D[1] / q[1], G[2] = 1.08883 * D[2] / q[2];
      }, Jd = function(q) {
        return q <= 31308e-7 ? Le(this, S, wu).call(this, 0, 1, 12.92 * q) : q >= 0.99554525 ? 1 : Le(this, S, wu).call(this, 0, 1, 1.055 * q ** 0.4166666666666667 - 0.055);
      }, wu = function(q, D, G) {
        return Math.max(q, Math.min(D, G));
      }, xu = function(q) {
        return q < 0 ? -Le(this, S, xu).call(this, -q) : q > 8 ? ((q + 16) / 116) ** 3 : q * or(Z, F);
      }, cM = function(q, D, G) {
        if (q[0] === 0 && q[1] === 0 && q[2] === 0) {
          G[0] = D[0], G[1] = D[1], G[2] = D[2];
          return;
        }
        const et = Le(this, S, xu).call(this, 0), J = (1 - et) / (1 - Le(this, S, xu).call(this, q[0])), it = 1 - J, lt = (1 - et) / (1 - Le(this, S, xu).call(this, q[1])), ot = 1 - lt, ut = (1 - et) / (1 - Le(this, S, xu).call(this, q[2])), ct = 1 - ut;
        G[0] = D[0] * J + it, G[1] = D[1] * lt + ot, G[2] = D[2] * ut + ct;
      }, uM = function(q, D, G) {
        if (q[0] === 1 && q[2] === 1) {
          G[0] = D[0], G[1] = D[1], G[2] = D[2];
          return;
        }
        const et = G;
        Le(this, S, vu).call(this, or(Z, W), D, et);
        const J = or(Z, B);
        Le(this, S, oM).call(this, q, et, J), Le(this, S, vu).call(this, or(Z, z), J, G);
      }, hM = function(q, D, G) {
        const et = G;
        Le(this, S, vu).call(this, or(Z, W), D, et);
        const J = or(Z, B);
        Le(this, S, lM).call(this, q, et, J), Le(this, S, vu).call(this, or(Z, z), J, G);
      }, Z9 = function(q, D, G, et, J) {
        const it = Le(this, S, wu).call(this, 0, 1, q[D] * J), lt = Le(this, S, wu).call(this, 0, 1, q[D + 1] * J), ot = Le(this, S, wu).call(this, 0, 1, q[D + 2] * J), ut = it === 1 ? 1 : it ** this.GR, ct = lt === 1 ? 1 : lt ** this.GG, gt = ot === 1 ? 1 : ot ** this.GB, dt = this.MXA * ut + this.MXB * ct + this.MXC * gt, bt = this.MYA * ut + this.MYB * ct + this.MYC * gt, vt = this.MZA * ut + this.MZB * ct + this.MZC * gt, xt = or(Z, C);
        xt[0] = dt, xt[1] = bt, xt[2] = vt;
        const St = or(Z, T);
        Le(this, S, uM).call(this, this.whitePoint, xt, St);
        const Mt = or(Z, C);
        Le(this, S, cM).call(this, this.blackPoint, St, Mt);
        const Et = or(Z, T);
        Le(this, S, hM).call(this, or(Z, $), Mt, Et);
        const Ft = or(Z, C);
        Le(this, S, vu).call(this, or(Z, j), Et, Ft), G[et] = 255 * Le(this, S, Jd).call(this, Ft[0]), G[et + 1] = 255 * Le(this, S, Jd).call(this, Ft[1]), G[et + 2] = 255 * Le(this, S, Jd).call(this, Ft[2]);
      }, lr(Z, W, new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296])), lr(Z, z, new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -85287e-7, 0.0400428, 0.9684867])), lr(Z, j, new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556, 0.0556434, -0.2040259, 1.0572252])), lr(Z, $, new Float32Array([1, 1, 1])), lr(Z, B, new Float32Array(3)), lr(Z, C, new Float32Array(3)), lr(Z, T, new Float32Array(3)), lr(Z, F, 0.0011070564598794539);
      let _ = Z;
      class M extends a {
        constructor(q, D, G) {
          super("Lab", 3);
          lr(this, rt);
          if (!q) throw new o.FormatError("WhitePoint missing - required for color space Lab");
          if ([this.XW, this.YW, this.ZW] = q, [this.amin, this.amax, this.bmin, this.bmax] = G || [-100, 100, -100, 100], [this.XB, this.YB, this.ZB] = D || [0, 0, 0], this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new o.FormatError("Invalid WhitePoint components, no fallback available");
          (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, o.info)("Invalid BlackPoint, falling back to default"), this.XB = this.YB = this.ZB = 0), (this.amin > this.amax || this.bmin > this.bmax) && ((0, o.info)("Invalid Range, falling back to defaults"), this.amin = -100, this.amax = 100, this.bmin = -100, this.bmax = 100);
        }
        getRgbItem(q, D, G, et) {
          Le(this, rt, J9).call(this, q, D, !1, G, et);
        }
        getRgbBuffer(q, D, G, et, J, it, lt) {
          const ot = (1 << it) - 1;
          for (let ut = 0; ut < G; ut++)
            Le(this, rt, J9).call(this, q, D, ot, et, J), D += 3, J += 3 + lt;
        }
        getOutputLength(q, D) {
          return q * (3 + D) / 3 | 0;
        }
        isDefaultDecode(q, D) {
          return !0;
        }
        get usesZeroToOneRange() {
          return (0, o.shadow)(this, "usesZeroToOneRange", !1);
        }
      }
      rt = new WeakSet(), Qd = function(q) {
        return q >= 0.20689655172413793 ? q ** 3 : 0.12841854934601665 * (q - 0.13793103448275862);
      }, t2 = function(q, D, G, et) {
        return G + q * (et - G) / D;
      }, J9 = function(q, D, G, et, J) {
        let it = q[D], lt = q[D + 1], ot = q[D + 2];
        G !== !1 && (it = Le(this, rt, t2).call(this, it, G, 0, 100), lt = Le(this, rt, t2).call(this, lt, G, this.amin, this.amax), ot = Le(this, rt, t2).call(this, ot, G, this.bmin, this.bmax)), lt > this.amax ? lt = this.amax : lt < this.amin && (lt = this.amin), ot > this.bmax ? ot = this.bmax : ot < this.bmin && (ot = this.bmin);
        const ut = (it + 16) / 116, ct = ut + lt / 500, gt = ut - ot / 200, dt = this.XW * Le(this, rt, Qd).call(this, ct), bt = this.YW * Le(this, rt, Qd).call(this, ut), vt = this.ZW * Le(this, rt, Qd).call(this, gt);
        let xt, St, Mt;
        this.ZW < 1 ? (xt = 3.1339 * dt + -1.617 * bt + -0.4906 * vt, St = -0.9785 * dt + 1.916 * bt + 0.0333 * vt, Mt = 0.072 * dt + -0.229 * bt + 1.4057 * vt) : (xt = 3.2406 * dt + -1.5372 * bt + -0.4986 * vt, St = -0.9689 * dt + 1.8758 * bt + 0.0415 * vt, Mt = 0.0557 * dt + -0.204 * bt + 1.057 * vt), et[J] = 255 * Math.sqrt(xt), et[J + 1] = 255 * Math.sqrt(St), et[J + 2] = 255 * Math.sqrt(Mt);
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PartialEvaluator = l.EvaluatorPreprocessor = void 0;
      var o = f(2), g = f(14), p = f(4), n = f(34), a = f(37), d = f(41), m = f(50), b = f(51), w = f(42), v = f(57), h = f(16), x = f(59), _ = f(8), M = f(5), O = f(60), E = f(12), I = f(18), R = f(38), W = f(61), z = f(39), j = f(45), $ = f(40), B = f(62), C = f(63), T = f(64), F = f(65);
      const S = Object.freeze({ maxImageSize: -1, disableFontFace: !1, ignoreErrors: !1, isEvalSupported: !0, isOffscreenCanvasSupported: !1, canvasMaxAreaInBytes: -1, fontExtraProperties: !1, useSystemFonts: !0, cMapUrl: null, standardFontDataUrl: null }), A = 1, U = 2, K = Promise.resolve();
      function X(yt, at = !1) {
        if (Array.isArray(yt)) {
          for (const nt of yt) {
            const q = X(nt, !0);
            if (q) return q;
          }
          return (0, o.warn)(`Unsupported blend mode Array: ${yt}`), "source-over";
        }
        if (!(yt instanceof p.Name)) return at ? null : "source-over";
        switch (yt.name) {
          case "Normal":
          case "Compatible":
            return "source-over";
          case "Multiply":
            return "multiply";
          case "Screen":
            return "screen";
          case "Overlay":
            return "overlay";
          case "Darken":
            return "darken";
          case "Lighten":
            return "lighten";
          case "ColorDodge":
            return "color-dodge";
          case "ColorBurn":
            return "color-burn";
          case "HardLight":
            return "hard-light";
          case "SoftLight":
            return "soft-light";
          case "Difference":
            return "difference";
          case "Exclusion":
            return "exclusion";
          case "Hue":
            return "hue";
          case "Saturation":
            return "saturation";
          case "Color":
            return "color";
          case "Luminosity":
            return "luminosity";
        }
        return at ? null : ((0, o.warn)(`Unsupported blend mode: ${yt.name}`), "source-over");
      }
      function L(yt) {
        var at;
        yt.fn === o.OPS.paintImageMaskXObject && ((at = yt.args[0]) == null ? void 0 : at.count) > 0 && yt.args[0].count++;
      }
      const st = class st {
        constructor() {
          this.reset();
        }
        check() {
          return ++this.checked < st.CHECK_TIME_EVERY ? !1 : (this.checked = 0, this.endTime <= Date.now());
        }
        reset() {
          this.endTime = Date.now() + st.TIME_SLOT_DURATION_MS, this.checked = 0;
        }
      };
      Mr(st, "TIME_SLOT_DURATION_MS", 20), Mr(st, "CHECK_TIME_EVERY", 100);
      let H = st;
      class Q {
        constructor({ xref: at, handler: nt, pageIndex: q, idFactory: D, fontCache: G, builtInCMapCache: et, standardFontDataCache: J, globalImageCache: it, systemFontCache: lt, options: ot = null }) {
          this.xref = at, this.handler = nt, this.pageIndex = q, this.idFactory = D, this.fontCache = G, this.builtInCMapCache = et, this.standardFontDataCache = J, this.globalImageCache = it, this.systemFontCache = lt, this.options = ot || S, this.parsingType3Font = !1, this._regionalImageCache = new x.RegionalImageCache(), this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this), B.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
        }
        get _pdfFunctionFactory() {
          const at = new v.PDFFunctionFactory({ xref: this.xref, isEvalSupported: this.options.isEvalSupported });
          return (0, o.shadow)(this, "_pdfFunctionFactory", at);
        }
        clone(at = null) {
          const nt = Object.create(this);
          return nt.options = Object.assign(/* @__PURE__ */ Object.create(null), this.options, at), nt;
        }
        hasBlendModes(at, nt) {
          if (!(at instanceof p.Dict) || at.objId && nt.has(at.objId)) return !1;
          const q = new p.RefSet(nt);
          at.objId && q.put(at.objId);
          const D = [at], G = this.xref;
          for (; D.length; ) {
            const et = D.shift(), J = et.get("ExtGState");
            if (J instanceof p.Dict) for (let lt of J.getRawValues()) {
              if (lt instanceof p.Ref) {
                if (q.has(lt)) continue;
                try {
                  lt = G.fetch(lt);
                } catch (ut) {
                  q.put(lt), (0, o.info)(`hasBlendModes - ignoring ExtGState: "${ut}".`);
                  continue;
                }
              }
              if (!(lt instanceof p.Dict)) continue;
              lt.objId && q.put(lt.objId);
              const ot = lt.get("BM");
              if (ot instanceof p.Name) {
                if (ot.name !== "Normal") return !0;
              } else if (ot !== void 0 && Array.isArray(ot)) {
                for (const ut of ot) if (ut instanceof p.Name && ut.name !== "Normal") return !0;
              }
            }
            const it = et.get("XObject");
            if (it instanceof p.Dict) for (let lt of it.getRawValues()) {
              if (lt instanceof p.Ref) {
                if (q.has(lt)) continue;
                try {
                  lt = G.fetch(lt);
                } catch (ut) {
                  q.put(lt), (0, o.info)(`hasBlendModes - ignoring XObject: "${ut}".`);
                  continue;
                }
              }
              if (!(lt instanceof M.BaseStream)) continue;
              lt.dict.objId && q.put(lt.dict.objId);
              const ot = lt.dict.get("Resources");
              ot instanceof p.Dict && (!ot.objId || !q.has(ot.objId)) && (D.push(ot), ot.objId && q.put(ot.objId));
            }
          }
          for (const et of q) nt.put(et);
          return !1;
        }
        async fetchBuiltInCMap(at) {
          const nt = this.builtInCMapCache.get(at);
          if (nt) return nt;
          let q;
          if (this.options.cMapUrl !== null) {
            const D = `${this.options.cMapUrl}${at}.bcmap`, G = await fetch(D);
            if (!G.ok) throw new Error(`fetchBuiltInCMap: failed to fetch file "${D}" with "${G.statusText}".`);
            q = { cMapData: new Uint8Array(await G.arrayBuffer()), compressionType: o.CMapCompressionType.BINARY };
          } else q = await this.handler.sendWithPromise("FetchBuiltInCMap", { name: at });
          return q.compressionType !== o.CMapCompressionType.NONE && this.builtInCMapCache.set(at, q), q;
        }
        async fetchStandardFontData(at) {
          const nt = this.standardFontDataCache.get(at);
          if (nt) return new _.Stream(nt);
          if (this.options.useSystemFonts && at !== "Symbol" && at !== "ZapfDingbats") return null;
          const q = (0, d.getFontNameToFileMap)()[at];
          let D;
          if (this.options.standardFontDataUrl !== null) {
            const G = `${this.options.standardFontDataUrl}${q}`, et = await fetch(G);
            et.ok ? D = await et.arrayBuffer() : (0, o.warn)(`fetchStandardFontData: failed to fetch file "${G}" with "${et.statusText}".`);
          } else try {
            D = await this.handler.sendWithPromise("FetchStandardFontData", { filename: q });
          } catch (G) {
            (0, o.warn)(`fetchStandardFontData: failed to fetch file "${q}" with "${G}".`);
          }
          return D ? (this.standardFontDataCache.set(at, D), new _.Stream(D)) : null;
        }
        async buildFormXObject(at, nt, q, D, G, et, J) {
          const it = nt.dict, lt = it.getArray("Matrix");
          let ot, ut, ct = it.getArray("BBox");
          ct = Array.isArray(ct) && ct.length === 4 ? o.Util.normalizeRect(ct) : null, it.has("OC") && (ot = await this.parseMarkedContentProps(it.get("OC"), at)), ot !== void 0 && D.addOp(o.OPS.beginMarkedContentProps, ["OC", ot]);
          const gt = it.get("Group");
          if (gt) {
            ut = { matrix: lt, bbox: ct, smask: q, isolated: !1, knockout: !1 };
            const bt = gt.get("S");
            let vt = null;
            if ((0, p.isName)(bt, "Transparency") && (ut.isolated = gt.get("I") || !1, ut.knockout = gt.get("K") || !1, gt.has("CS"))) {
              const xt = gt.getRaw("CS");
              vt = E.ColorSpace.getCached(xt, this.xref, J) || await this.parseColorSpace({ cs: xt, resources: at, localColorSpaceCache: J });
            }
            q != null && q.backdrop && (vt || (vt = E.ColorSpace.singletons.rgb), q.backdrop = vt.getRgb(q.backdrop, 0)), D.addOp(o.OPS.beginGroup, [ut]);
          }
          const dt = gt ? [lt, null] : [lt, ct];
          return D.addOp(o.OPS.paintFormXObjectBegin, dt), this.getOperatorList({ stream: nt, task: G, resources: it.get("Resources") || at, operatorList: D, initialState: et }).then(function() {
            D.addOp(o.OPS.paintFormXObjectEnd, []), gt && D.addOp(o.OPS.endGroup, [ut]), ot !== void 0 && D.addOp(o.OPS.endMarkedContent, []);
          });
        }
        _sendImgData(at, nt, q = !1) {
          const D = nt ? [nt.bitmap || nt.data.buffer] : null;
          return this.parsingType3Font || q ? this.handler.send("commonobj", [at, "Image", nt], D) : this.handler.send("obj", [at, this.pageIndex, "Image", nt], D);
        }
        async buildPaintImageXObject({ resources: at, image: nt, isInline: q = !1, operatorList: D, cacheKey: G, localImageCache: et, localColorSpaceCache: J }) {
          const it = nt.dict, lt = it.objId, ot = it.get("W", "Width"), ut = it.get("H", "Height");
          if (!ot || typeof ot != "number" || !ut || typeof ut != "number") {
            (0, o.warn)("Image dimensions are missing, or not numbers.");
            return;
          }
          const ct = this.options.maxImageSize;
          if (ct !== -1 && ot * ut > ct) {
            const St = "Image exceeded maximum allowed size and was removed.";
            if (this.options.ignoreErrors) {
              (0, o.warn)(St);
              return;
            }
            throw new Error(St);
          }
          let gt;
          it.has("OC") && (gt = await this.parseMarkedContentProps(it.get("OC"), at));
          let dt, bt;
          if (it.get("IM", "ImageMask")) {
            const St = it.get("I", "Interpolate"), Mt = ot + 7 >> 3, Et = nt.getBytes(Mt * ut), Ft = it.getArray("D", "Decode");
            if (this.parsingType3Font) {
              if (dt = F.PDFImage.createRawMask({ imgArray: Et, width: ot, height: ut, imageIsFromDecodeStream: nt instanceof I.DecodeStream, inverseDecode: (Ft == null ? void 0 : Ft[0]) > 0, interpolate: St }), dt.cached = !!G, bt = [dt], D.addImageOps(o.OPS.paintImageMaskXObject, bt, gt), G) {
                const Kt = { fn: o.OPS.paintImageMaskXObject, args: bt, optionalContent: gt };
                et.set(G, lt, Kt), lt && this._regionalImageCache.set(null, lt, Kt);
              }
              return;
            }
            if (dt = await F.PDFImage.createMask({ imgArray: Et, width: ot, height: ut, imageIsFromDecodeStream: nt instanceof I.DecodeStream, inverseDecode: (Ft == null ? void 0 : Ft[0]) > 0, interpolate: St, isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported }), dt.isSingleOpaquePixel) {
              if (D.addImageOps(o.OPS.paintSolidColorImageMask, [], gt), G) {
                const Kt = { fn: o.OPS.paintSolidColorImageMask, args: [], optionalContent: gt };
                et.set(G, lt, Kt), lt && this._regionalImageCache.set(null, lt, Kt);
              }
              return;
            }
            const Wt = `mask_${this.idFactory.createObjId()}`;
            if (D.addDependency(Wt), this._sendImgData(Wt, dt), bt = [{ data: Wt, width: dt.width, height: dt.height, interpolate: dt.interpolate, count: 1 }], D.addImageOps(o.OPS.paintImageMaskXObject, bt, gt), G) {
              const Kt = { fn: o.OPS.paintImageMaskXObject, args: bt, optionalContent: gt };
              et.set(G, lt, Kt), lt && this._regionalImageCache.set(null, lt, Kt);
            }
            return;
          }
          if (q && !it.has("SMask") && !it.has("Mask") && ot + ut < 200) {
            dt = await new F.PDFImage({ xref: this.xref, res: at, image: nt, isInline: q, pdfFunctionFactory: this._pdfFunctionFactory, localColorSpaceCache: J }).createImageData(!0, !1), D.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported, D.addImageOps(o.OPS.paintInlineImageXObject, [dt], gt);
            return;
          }
          let vt = `img_${this.idFactory.createObjId()}`, xt = !1;
          if (this.parsingType3Font ? vt = `${this.idFactory.getDocId()}_type3_${vt}` : lt && (xt = this.globalImageCache.shouldCache(lt, this.pageIndex), xt && (vt = `${this.idFactory.getDocId()}_${vt}`)), D.addDependency(vt), bt = [vt, ot, ut], F.PDFImage.buildImage({ xref: this.xref, res: at, image: nt, isInline: q, pdfFunctionFactory: this._pdfFunctionFactory, localColorSpaceCache: J }).then(async (St) => {
            if (dt = await St.createImageData(!1, this.options.isOffscreenCanvasSupported), G && lt && xt) {
              const Mt = dt.bitmap ? dt.width * dt.height * 4 : dt.data.length;
              this.globalImageCache.addByteSize(lt, Mt);
            }
            return this._sendImgData(vt, dt, xt);
          }).catch((St) => ((0, o.warn)(`Unable to decode image "${vt}": "${St}".`), this._sendImgData(vt, null, xt))), D.addImageOps(o.OPS.paintImageXObject, bt, gt), G) {
            const St = { fn: o.OPS.paintImageXObject, args: bt, optionalContent: gt };
            et.set(G, lt, St), lt && (this._regionalImageCache.set(null, lt, St), xt && ((0, o.assert)(!q, "Cannot cache an inline image globally."), this.globalImageCache.setData(lt, { objId: vt, fn: o.OPS.paintImageXObject, args: bt, optionalContent: gt, byteSize: 0 })));
          }
        }
        handleSMask(at, nt, q, D, G, et) {
          const J = at.get("G"), it = { subtype: at.get("S").name, backdrop: at.get("BC") }, lt = at.get("TR");
          if ((0, v.isPDFFunction)(lt)) {
            const ot = this._pdfFunctionFactory.create(lt), ut = new Uint8Array(256), ct = new Float32Array(1);
            for (let gt = 0; gt < 256; gt++)
              ct[0] = gt / 255, ot(ct, 0, ct, 0), ut[gt] = 255 * ct[0] | 0;
            it.transferMap = ut;
          }
          return this.buildFormXObject(nt, J, it, q, D, G.state.clone(), et);
        }
        handleTransferFunction(at) {
          let nt;
          if (Array.isArray(at)) nt = at;
          else {
            if (!(0, v.isPDFFunction)(at)) return null;
            nt = [at];
          }
          const q = [];
          let D = 0, G = 0;
          for (const et of nt) {
            const J = this.xref.fetchIfRef(et);
            if (D++, (0, p.isName)(J, "Identity")) {
              q.push(null);
              continue;
            }
            if (!(0, v.isPDFFunction)(J)) return null;
            const it = this._pdfFunctionFactory.create(J), lt = new Uint8Array(256), ot = new Float32Array(1);
            for (let ut = 0; ut < 256; ut++)
              ot[0] = ut / 255, it(ot, 0, ot, 0), lt[ut] = 255 * ot[0] | 0;
            q.push(lt), G++;
          }
          return D !== 1 && D !== 4 || G === 0 ? null : q;
        }
        handleTilingType(at, nt, q, D, G, et, J, it) {
          const lt = new T.OperatorList(), ot = p.Dict.merge({ xref: this.xref, dictArray: [G.get("Resources"), q] });
          return this.getOperatorList({ stream: D, task: J, resources: ot, operatorList: lt }).then(function() {
            const ut = lt.getIR(), ct = (0, m.getTilingPatternIR)(ut, G, nt);
            et.addDependencies(lt.dependencies), et.addOp(at, ct), G.objId && it.set(null, G.objId, { operatorListIR: ut, dict: G });
          }).catch((ut) => {
            if (!(ut instanceof o.AbortException)) {
              if (!this.options.ignoreErrors) throw ut;
              (0, o.warn)(`handleTilingType - ignoring pattern: "${ut}".`);
            }
          });
        }
        handleSetFont(at, nt, q, D, G, et, J = null, it = null) {
          const lt = (nt == null ? void 0 : nt[0]) instanceof p.Name ? nt[0].name : null;
          return this.loadFont(lt, q, at, J, it).then((ot) => ot.font.isType3Font ? ot.loadType3Data(this, at, G).then(function() {
            return D.addDependencies(ot.type3Dependencies), ot;
          }).catch((ut) => new N({ loadedName: "g_font_error", font: new n.ErrorFont(`Type3 font load error: ${ut}`), dict: ot.font, evaluatorOptions: this.options })) : ot).then((ot) => (et.font = ot.font, ot.send(this.handler), ot.loadedName));
        }
        handleText(at, nt) {
          const q = nt.font, D = q.charsToGlyphs(at);
          return q.data && (nt.textRenderingMode & o.TextRenderingMode.ADD_TO_PATH_FLAG || nt.fillColorSpace.name === "Pattern" || q.disableFontFace || this.options.disableFontFace) && Q.buildFontPaths(q, D, this.handler, this.options), D;
        }
        ensureStateFont(at) {
          if (at.font) return;
          const nt = new o.FormatError("Missing setFont (Tf) operator before text rendering operator.");
          if (!this.options.ignoreErrors) throw nt;
          (0, o.warn)(`ensureStateFont: "${nt}".`);
        }
        async setGState({ resources: at, gState: nt, operatorList: q, cacheKey: D, task: G, stateManager: et, localGStateCache: J, localColorSpaceCache: it }) {
          const lt = nt.objId;
          let ot = !0;
          const ut = [];
          let ct = Promise.resolve();
          for (const gt of nt.getKeys()) {
            const dt = nt.get(gt);
            switch (gt) {
              case "Type":
                break;
              case "LW":
              case "LC":
              case "LJ":
              case "ML":
              case "D":
              case "RI":
              case "FL":
              case "CA":
              case "ca":
                ut.push([gt, dt]);
                break;
              case "Font":
                ot = !1, ct = ct.then(() => this.handleSetFont(at, null, dt[0], q, G, et.state).then(function(vt) {
                  q.addDependency(vt), ut.push([gt, [vt, dt[1]]]);
                }));
                break;
              case "BM":
                ut.push([gt, X(dt)]);
                break;
              case "SMask":
                if ((0, p.isName)(dt, "None")) {
                  ut.push([gt, !1]);
                  break;
                }
                dt instanceof p.Dict ? (ot = !1, ct = ct.then(() => this.handleSMask(dt, at, q, G, et, it)), ut.push([gt, !0])) : (0, o.warn)("Unsupported SMask type");
                break;
              case "TR":
                const bt = this.handleTransferFunction(dt);
                ut.push([gt, bt]);
                break;
              case "OP":
              case "op":
              case "OPM":
              case "BG":
              case "BG2":
              case "UCR":
              case "UCR2":
              case "TR2":
              case "HT":
              case "SM":
              case "SA":
              case "AIS":
              case "TK":
                (0, o.info)("graphic state operator " + gt);
                break;
              default:
                (0, o.info)("Unknown graphic state operator " + gt);
            }
          }
          return ct.then(function() {
            ut.length > 0 && q.addOp(o.OPS.setGState, [ut]), ot && J.set(D, lt, ut);
          });
        }
        loadFont(at, nt, q, D = null, G = null) {
          const et = async () => new N({ loadedName: "g_font_error", font: new n.ErrorFont(`Font "${at}" is not available.`), dict: nt, evaluatorOptions: this.options });
          let J;
          if (nt) nt instanceof p.Ref && (J = nt);
          else {
            const dt = q.get("Font");
            dt && (J = dt.getRaw(at));
          }
          if (J) {
            if (this.parsingType3Font && this.type3FontRefs.has(J)) return et();
            if (this.fontCache.has(J)) return this.fontCache.get(J);
            nt = this.xref.fetchIfRef(J);
          }
          if (!(nt instanceof p.Dict)) {
            if (!this.options.ignoreErrors && !this.parsingType3Font)
              return (0, o.warn)(`Font "${at}" is not available.`), et();
            (0, o.warn)(`Font "${at}" is not available -- attempting to fallback to a default font.`), nt = D || Q.fallbackFontDict;
          }
          if (nt.cacheKey && this.fontCache.has(nt.cacheKey)) return this.fontCache.get(nt.cacheKey);
          const it = new o.PromiseCapability();
          let lt;
          try {
            lt = this.preEvaluateFont(nt), lt.cssFontInfo = G;
          } catch (dt) {
            return (0, o.warn)(`loadFont - preEvaluateFont failed: "${dt}".`), et();
          }
          const { descriptor: ot, hash: ut } = lt, ct = J instanceof p.Ref;
          let gt;
          if (ut && ot instanceof p.Dict) {
            const dt = ot.fontAliases || (ot.fontAliases = /* @__PURE__ */ Object.create(null));
            if (dt[ut]) {
              const bt = dt[ut].aliasRef;
              if (ct && bt && this.fontCache.has(bt))
                return this.fontCache.putAlias(J, bt), this.fontCache.get(J);
            } else dt[ut] = { fontID: this.idFactory.createFontId() };
            ct && (dt[ut].aliasRef = J), gt = dt[ut].fontID;
          } else gt = this.idFactory.createFontId();
          return (0, o.assert)(gt == null ? void 0 : gt.startsWith("f"), 'The "fontID" must be (correctly) defined.'), ct ? this.fontCache.put(J, it.promise) : (nt.cacheKey = `cacheKey_${gt}`, this.fontCache.put(nt.cacheKey, it.promise)), nt.loadedName = `${this.idFactory.getDocId()}_${gt}`, this.translateFont(lt).then((dt) => {
            it.resolve(new N({ loadedName: nt.loadedName, font: dt, dict: nt, evaluatorOptions: this.options }));
          }).catch((dt) => {
            (0, o.warn)(`loadFont - translateFont failed: "${dt}".`), it.resolve(new N({ loadedName: nt.loadedName, font: new n.ErrorFont(dt instanceof Error ? dt.message : dt), dict: nt, evaluatorOptions: this.options }));
          }), it.promise;
        }
        buildPath(at, nt, q, D = !1) {
          const G = at.length - 1;
          if (q || (q = []), G < 0 || at.fnArray[G] !== o.OPS.constructPath) {
            D && ((0, o.warn)(`Encountered path operator "${nt}" inside of a text object.`), at.addOp(o.OPS.save, null));
            let et;
            switch (nt) {
              case o.OPS.rectangle:
                const J = q[0] + q[2], it = q[1] + q[3];
                et = [Math.min(q[0], J), Math.max(q[0], J), Math.min(q[1], it), Math.max(q[1], it)];
                break;
              case o.OPS.moveTo:
              case o.OPS.lineTo:
                et = [q[0], q[0], q[1], q[1]];
                break;
              default:
                et = [1 / 0, -1 / 0, 1 / 0, -1 / 0];
            }
            at.addOp(o.OPS.constructPath, [[nt], q, et]), D && at.addOp(o.OPS.restore, null);
          } else {
            const et = at.argsArray[G];
            et[0].push(nt), et[1].push(...q);
            const J = et[2];
            switch (nt) {
              case o.OPS.rectangle:
                const it = q[0] + q[2], lt = q[1] + q[3];
                J[0] = Math.min(J[0], q[0], it), J[1] = Math.max(J[1], q[0], it), J[2] = Math.min(J[2], q[1], lt), J[3] = Math.max(J[3], q[1], lt);
                break;
              case o.OPS.moveTo:
              case o.OPS.lineTo:
                J[0] = Math.min(J[0], q[0]), J[1] = Math.max(J[1], q[0]), J[2] = Math.min(J[2], q[1]), J[3] = Math.max(J[3], q[1]);
            }
          }
        }
        parseColorSpace({ cs: at, resources: nt, localColorSpaceCache: q }) {
          return E.ColorSpace.parseAsync({ cs: at, xref: this.xref, resources: nt, pdfFunctionFactory: this._pdfFunctionFactory, localColorSpaceCache: q }).catch((D) => {
            if (D instanceof o.AbortException) return null;
            if (this.options.ignoreErrors)
              return (0, o.warn)(`parseColorSpace - ignoring ColorSpace: "${D}".`), null;
            throw D;
          });
        }
        parseShading({ shading: at, resources: nt, localColorSpaceCache: q, localShadingPatternCache: D }) {
          let G = D.get(at);
          if (!G) {
            const et = m.Pattern.parseShading(at, this.xref, nt, this._pdfFunctionFactory, q).getIR();
            G = `pattern_${this.idFactory.createObjId()}`, this.parsingType3Font && (G = `${this.idFactory.getDocId()}_type3_${G}`), D.set(at, G), this.parsingType3Font ? this.handler.send("commonobj", [G, "Pattern", et]) : this.handler.send("obj", [G, this.pageIndex, "Pattern", et]);
          }
          return G;
        }
        handleColorN(at, nt, q, D, G, et, J, it, lt, ot) {
          const ut = q.pop();
          if (ut instanceof p.Name) {
            const ct = G.getRaw(ut.name), gt = ct instanceof p.Ref && lt.getByRef(ct);
            if (gt) try {
              const bt = D.base ? D.base.getRgb(q, 0) : null, vt = (0, m.getTilingPatternIR)(gt.operatorListIR, gt.dict, bt);
              at.addOp(nt, vt);
              return;
            } catch {
            }
            const dt = this.xref.fetchIfRef(ct);
            if (dt) {
              const bt = dt instanceof M.BaseStream ? dt.dict : dt, vt = bt.get("PatternType");
              if (vt === A) {
                const xt = D.base ? D.base.getRgb(q, 0) : null;
                return this.handleTilingType(nt, xt, et, dt, bt, at, J, lt);
              }
              if (vt === U) {
                const xt = bt.get("Shading"), St = bt.getArray("Matrix"), Mt = this.parseShading({ shading: xt, resources: et, localColorSpaceCache: it, localShadingPatternCache: ot });
                at.addOp(nt, ["Shading", Mt, St]);
                return;
              }
              throw new o.FormatError(`Unknown PatternType: ${vt}`);
            }
          }
          throw new o.FormatError(`Unknown PatternName: ${ut}`);
        }
        _parseVisibilityExpression(at, nt, q) {
          if (++nt > 10) {
            (0, o.warn)("Visibility expression is too deeply nested");
            return;
          }
          const D = at.length, G = this.xref.fetchIfRef(at[0]);
          if (!(D < 2) && G instanceof p.Name) {
            switch (G.name) {
              case "And":
              case "Or":
              case "Not":
                q.push(G.name);
                break;
              default:
                (0, o.warn)(`Invalid operator ${G.name} in visibility expression`);
                return;
            }
            for (let et = 1; et < D; et++) {
              const J = at[et], it = this.xref.fetchIfRef(J);
              if (Array.isArray(it)) {
                const lt = [];
                q.push(lt), this._parseVisibilityExpression(it, nt, lt);
              } else J instanceof p.Ref && q.push(J.toString());
            }
          } else (0, o.warn)("Invalid visibility expression");
        }
        async parseMarkedContentProps(at, nt) {
          var G;
          let q;
          if (at instanceof p.Name)
            q = nt.get("Properties").get(at.name);
          else {
            if (!(at instanceof p.Dict)) throw new o.FormatError("Optional content properties malformed.");
            q = at;
          }
          const D = (G = q.get("Type")) == null ? void 0 : G.name;
          if (D === "OCG") return { type: D, id: q.objId };
          if (D === "OCMD") {
            const et = q.get("VE");
            if (Array.isArray(et)) {
              const it = [];
              if (this._parseVisibilityExpression(et, 0, it), it.length > 0) return { type: "OCMD", expression: it };
            }
            const J = q.get("OCGs");
            if (Array.isArray(J) || J instanceof p.Dict) {
              const it = [];
              if (Array.isArray(J)) for (const lt of J) it.push(lt.toString());
              else it.push(J.objId);
              return { type: D, ids: it, policy: q.get("P") instanceof p.Name ? q.get("P").name : null, expression: null };
            }
            if (J instanceof p.Ref) return { type: D, id: J.toString() };
          }
          return null;
        }
        getOperatorList({ stream: at, task: nt, resources: q, operatorList: D, initialState: G = null, fallbackFontDict: et = null }) {
          if (q || (q = p.Dict.empty), G || (G = new Z()), !D) throw new Error('getOperatorList: missing "operatorList" parameter');
          const J = this, it = this.xref;
          let lt = !1;
          const ot = new x.LocalImageCache(), ut = new x.LocalColorSpaceCache(), ct = new x.LocalGStateCache(), gt = new x.LocalTilingPatternCache(), dt = /* @__PURE__ */ new Map(), bt = q.get("XObject") || p.Dict.empty, vt = q.get("Pattern") || p.Dict.empty, xt = new V(G), St = new rt(at, it, xt), Mt = new H();
          function Et(Ft) {
            for (let Wt = 0, Kt = St.savedStatesDepth; Wt < Kt; Wt++) D.addOp(o.OPS.restore, []);
          }
          return new Promise(function Ft(Wt, Kt) {
            const qt = function(Dt) {
              Promise.all([Dt, D.ready]).then(function() {
                try {
                  Ft(Wt, Kt);
                } catch (jt) {
                  Kt(jt);
                }
              }, Kt);
            };
            nt.ensureNotTerminated(), Mt.reset();
            const It = {};
            let re, le, Ce, ce, xe, ve;
            for (; !(re = Mt.check()) && (It.args = null, !!St.read(It)); ) {
              let Dt = It.args, jt = It.fn;
              switch (0 | jt) {
                case o.OPS.paintXObject:
                  if (ve = Dt[0] instanceof p.Name, xe = Dt[0].name, ve) {
                    const Ot = ot.getByName(xe);
                    if (Ot) {
                      D.addImageOps(Ot.fn, Ot.args, Ot.optionalContent), L(Ot), Dt = null;
                      continue;
                    }
                  }
                  qt(new Promise(function(Ot, Rt) {
                    if (!ve) throw new o.FormatError("XObject must be referred to by name.");
                    let Tt = bt.getRaw(xe);
                    if (Tt instanceof p.Ref) {
                      const te = ot.getByRef(Tt) || J._regionalImageCache.getByRef(Tt);
                      if (te) {
                        D.addImageOps(te.fn, te.args, te.optionalContent), L(te), Ot();
                        return;
                      }
                      const Jt = J.globalImageCache.getData(Tt, J.pageIndex);
                      if (Jt) {
                        D.addDependency(Jt.objId), D.addImageOps(Jt.fn, Jt.args, Jt.optionalContent), Ot();
                        return;
                      }
                      Tt = it.fetch(Tt);
                    }
                    if (!(Tt instanceof M.BaseStream)) throw new o.FormatError("XObject should be a stream");
                    const ee = Tt.dict.get("Subtype");
                    if (!(ee instanceof p.Name)) throw new o.FormatError("XObject should have a Name subtype");
                    if (ee.name !== "Form") if (ee.name !== "Image") {
                      if (ee.name !== "PS") throw new o.FormatError(`Unhandled XObject subtype ${ee.name}`);
                      (0, o.info)("Ignored XObject subtype PS"), Ot();
                    } else J.buildPaintImageXObject({ resources: q, image: Tt, operatorList: D, cacheKey: xe, localImageCache: ot, localColorSpaceCache: ut }).then(Ot, Rt);
                    else
                      xt.save(), J.buildFormXObject(q, Tt, null, D, nt, xt.state.clone(), ut).then(function() {
                        xt.restore(), Ot();
                      }, Rt);
                  }).catch(function(Ot) {
                    if (!(Ot instanceof o.AbortException)) {
                      if (!J.options.ignoreErrors) throw Ot;
                      (0, o.warn)(`getOperatorList - ignoring XObject: "${Ot}".`);
                    }
                  }));
                  return;
                case o.OPS.setFont:
                  var Oe = Dt[1];
                  qt(J.handleSetFont(q, Dt, null, D, nt, xt.state, et).then(function(Ot) {
                    D.addDependency(Ot), D.addOp(o.OPS.setFont, [Ot, Oe]);
                  }));
                  return;
                case o.OPS.beginText:
                  lt = !0;
                  break;
                case o.OPS.endText:
                  lt = !1;
                  break;
                case o.OPS.endInlineImage:
                  var He = Dt[0].cacheKey;
                  if (He) {
                    const Ot = ot.getByName(He);
                    if (Ot) {
                      D.addImageOps(Ot.fn, Ot.args, Ot.optionalContent), L(Ot), Dt = null;
                      continue;
                    }
                  }
                  qt(J.buildPaintImageXObject({ resources: q, image: Dt[0], isInline: !0, operatorList: D, cacheKey: He, localImageCache: ot, localColorSpaceCache: ut }));
                  return;
                case o.OPS.showText:
                  if (!xt.state.font) {
                    J.ensureStateFont(xt.state);
                    continue;
                  }
                  Dt[0] = J.handleText(Dt[0], xt.state);
                  break;
                case o.OPS.showSpacedText:
                  if (!xt.state.font) {
                    J.ensureStateFont(xt.state);
                    continue;
                  }
                  var Zt = [], Xt = xt.state;
                  for (const Ot of Dt[0]) typeof Ot == "string" ? Zt.push(...J.handleText(Ot, Xt)) : typeof Ot == "number" && Zt.push(Ot);
                  Dt[0] = Zt, jt = o.OPS.showText;
                  break;
                case o.OPS.nextLineShowText:
                  if (!xt.state.font) {
                    J.ensureStateFont(xt.state);
                    continue;
                  }
                  D.addOp(o.OPS.nextLine), Dt[0] = J.handleText(Dt[0], xt.state), jt = o.OPS.showText;
                  break;
                case o.OPS.nextLineSetSpacingShowText:
                  if (!xt.state.font) {
                    J.ensureStateFont(xt.state);
                    continue;
                  }
                  D.addOp(o.OPS.nextLine), D.addOp(o.OPS.setWordSpacing, [Dt.shift()]), D.addOp(o.OPS.setCharSpacing, [Dt.shift()]), Dt[0] = J.handleText(Dt[0], xt.state), jt = o.OPS.showText;
                  break;
                case o.OPS.setTextRenderingMode:
                  xt.state.textRenderingMode = Dt[0];
                  break;
                case o.OPS.setFillColorSpace: {
                  const Ot = E.ColorSpace.getCached(Dt[0], it, ut);
                  if (Ot) {
                    xt.state.fillColorSpace = Ot;
                    continue;
                  }
                  qt(J.parseColorSpace({ cs: Dt[0], resources: q, localColorSpaceCache: ut }).then(function(Rt) {
                    Rt && (xt.state.fillColorSpace = Rt);
                  }));
                  return;
                }
                case o.OPS.setStrokeColorSpace: {
                  const Ot = E.ColorSpace.getCached(Dt[0], it, ut);
                  if (Ot) {
                    xt.state.strokeColorSpace = Ot;
                    continue;
                  }
                  qt(J.parseColorSpace({ cs: Dt[0], resources: q, localColorSpaceCache: ut }).then(function(Rt) {
                    Rt && (xt.state.strokeColorSpace = Rt);
                  }));
                  return;
                }
                case o.OPS.setFillColor:
                  ce = xt.state.fillColorSpace, Dt = ce.getRgb(Dt, 0), jt = o.OPS.setFillRGBColor;
                  break;
                case o.OPS.setStrokeColor:
                  ce = xt.state.strokeColorSpace, Dt = ce.getRgb(Dt, 0), jt = o.OPS.setStrokeRGBColor;
                  break;
                case o.OPS.setFillGray:
                  xt.state.fillColorSpace = E.ColorSpace.singletons.gray, Dt = E.ColorSpace.singletons.gray.getRgb(Dt, 0), jt = o.OPS.setFillRGBColor;
                  break;
                case o.OPS.setStrokeGray:
                  xt.state.strokeColorSpace = E.ColorSpace.singletons.gray, Dt = E.ColorSpace.singletons.gray.getRgb(Dt, 0), jt = o.OPS.setStrokeRGBColor;
                  break;
                case o.OPS.setFillCMYKColor:
                  xt.state.fillColorSpace = E.ColorSpace.singletons.cmyk, Dt = E.ColorSpace.singletons.cmyk.getRgb(Dt, 0), jt = o.OPS.setFillRGBColor;
                  break;
                case o.OPS.setStrokeCMYKColor:
                  xt.state.strokeColorSpace = E.ColorSpace.singletons.cmyk, Dt = E.ColorSpace.singletons.cmyk.getRgb(Dt, 0), jt = o.OPS.setStrokeRGBColor;
                  break;
                case o.OPS.setFillRGBColor:
                  xt.state.fillColorSpace = E.ColorSpace.singletons.rgb, Dt = E.ColorSpace.singletons.rgb.getRgb(Dt, 0);
                  break;
                case o.OPS.setStrokeRGBColor:
                  xt.state.strokeColorSpace = E.ColorSpace.singletons.rgb, Dt = E.ColorSpace.singletons.rgb.getRgb(Dt, 0);
                  break;
                case o.OPS.setFillColorN:
                  if (ce = xt.state.fillColorSpace, ce.name === "Pattern") {
                    qt(J.handleColorN(D, o.OPS.setFillColorN, Dt, ce, vt, q, nt, ut, gt, dt));
                    return;
                  }
                  Dt = ce.getRgb(Dt, 0), jt = o.OPS.setFillRGBColor;
                  break;
                case o.OPS.setStrokeColorN:
                  if (ce = xt.state.strokeColorSpace, ce.name === "Pattern") {
                    qt(J.handleColorN(D, o.OPS.setStrokeColorN, Dt, ce, vt, q, nt, ut, gt, dt));
                    return;
                  }
                  Dt = ce.getRgb(Dt, 0), jt = o.OPS.setStrokeRGBColor;
                  break;
                case o.OPS.shadingFill:
                  var Gt = q.get("Shading");
                  if (!Gt) throw new o.FormatError("No shading resource found");
                  var Lt = Gt.get(Dt[0].name);
                  if (!Lt) throw new o.FormatError("No shading object found");
                  Dt = [J.parseShading({ shading: Lt, resources: q, localColorSpaceCache: ut, localShadingPatternCache: dt })], jt = o.OPS.shadingFill;
                  break;
                case o.OPS.setGState:
                  if (ve = Dt[0] instanceof p.Name, xe = Dt[0].name, ve) {
                    const Ot = ct.getByName(xe);
                    if (Ot) {
                      Ot.length > 0 && D.addOp(o.OPS.setGState, [Ot]), Dt = null;
                      continue;
                    }
                  }
                  qt(new Promise(function(Ot, Rt) {
                    if (!ve) throw new o.FormatError("GState must be referred to by name.");
                    const Tt = q.get("ExtGState");
                    if (!(Tt instanceof p.Dict)) throw new o.FormatError("ExtGState should be a dictionary.");
                    const ee = Tt.get(xe);
                    if (!(ee instanceof p.Dict)) throw new o.FormatError("GState should be a dictionary.");
                    J.setGState({ resources: q, gState: ee, operatorList: D, cacheKey: xe, task: nt, stateManager: xt, localGStateCache: ct, localColorSpaceCache: ut }).then(Ot, Rt);
                  }).catch(function(Ot) {
                    if (!(Ot instanceof o.AbortException)) {
                      if (!J.options.ignoreErrors) throw Ot;
                      (0, o.warn)(`getOperatorList - ignoring ExtGState: "${Ot}".`);
                    }
                  }));
                  return;
                case o.OPS.moveTo:
                case o.OPS.lineTo:
                case o.OPS.curveTo:
                case o.OPS.curveTo2:
                case o.OPS.curveTo3:
                case o.OPS.closePath:
                case o.OPS.rectangle:
                  J.buildPath(D, jt, Dt, lt);
                  continue;
                case o.OPS.markPoint:
                case o.OPS.markPointProps:
                case o.OPS.beginCompat:
                case o.OPS.endCompat:
                  continue;
                case o.OPS.beginMarkedContentProps:
                  if (!(Dt[0] instanceof p.Name)) {
                    (0, o.warn)(`Expected name for beginMarkedContentProps arg0=${Dt[0]}`);
                    continue;
                  }
                  if (Dt[0].name === "OC") {
                    qt(J.parseMarkedContentProps(Dt[1], q).then((Ot) => {
                      D.addOp(o.OPS.beginMarkedContentProps, ["OC", Ot]);
                    }).catch((Ot) => {
                      if (!(Ot instanceof o.AbortException)) {
                        if (!J.options.ignoreErrors) throw Ot;
                        (0, o.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${Ot}".`);
                      }
                    }));
                    return;
                  }
                  Dt = [Dt[0].name, Dt[1] instanceof p.Dict ? Dt[1].get("MCID") : null];
                  break;
                case o.OPS.beginMarkedContent:
                case o.OPS.endMarkedContent:
                default:
                  if (Dt !== null) {
                    for (le = 0, Ce = Dt.length; le < Ce && !(Dt[le] instanceof p.Dict); le++) ;
                    if (le < Ce) {
                      (0, o.warn)("getOperatorList - ignoring operator: " + jt);
                      continue;
                    }
                  }
              }
              D.addOp(jt, Dt);
            }
            re ? qt(K) : (Et(), Wt());
          }).catch((Ft) => {
            if (!(Ft instanceof o.AbortException)) {
              if (!this.options.ignoreErrors) throw Ft;
              (0, o.warn)(`getOperatorList - ignoring errors during "${nt.name}" task: "${Ft}".`), Et();
            }
          });
        }
        getTextContent({ stream: at, task: nt, resources: q, stateManager: D = null, includeMarkedContent: G = !1, sink: et, seenStyles: J = /* @__PURE__ */ new Set(), viewBox: it, markedContentData: lt = null, disableNormalization: ot = !1 }) {
          q || (q = p.Dict.empty), D || (D = new V(new Y())), G && (lt || (lt = { level: 0 }));
          const ut = { items: [], styles: /* @__PURE__ */ Object.create(null) }, ct = { initialized: !1, str: [], totalWidth: 0, totalHeight: 0, width: 0, height: 0, vertical: !1, prevTransform: null, textAdvanceScale: 0, spaceInFlowMin: 0, spaceInFlowMax: 0, trackingSpaceMin: 1 / 0, negativeSpaceMax: -1 / 0, notASpace: -1 / 0, transform: null, fontName: null, hasEOL: !1 }, gt = [" ", " "];
          let dt = 0;
          function bt(jt) {
            const Ot = (dt + 1) % 2, Rt = gt[dt] !== " " && gt[Ot] === " ";
            return gt[dt] = jt, dt = Ot, Rt;
          }
          function vt() {
            return gt[dt] !== " " && gt[(dt + 1) % 2] === " ";
          }
          function xt() {
            gt[0] = gt[1] = " ", dt = 0;
          }
          const St = this, Mt = this.xref, Et = [];
          let Ft = null;
          const Wt = new x.LocalImageCache(), Kt = new x.LocalGStateCache(), qt = new rt(at, Mt, D);
          let It;
          function re({ width: jt = 0, height: Ot = 0, transform: Rt = ct.prevTransform, fontName: Tt = ct.fontName }) {
            ut.items.push({ str: " ", dir: "ltr", width: jt, height: Ot, transform: Rt, fontName: Tt, hasEOL: !1 });
          }
          function le() {
            const jt = It.font, Ot = [It.fontSize * It.textHScale, 0, 0, It.fontSize, 0, It.textRise];
            if (jt.isType3Font && (It.fontSize <= 1 || jt.isCharBBox) && !(0, o.isArrayEqual)(It.fontMatrix, o.FONT_IDENTITY_MATRIX)) {
              const Rt = jt.bbox[3] - jt.bbox[1];
              Rt > 0 && (Ot[3] *= Rt * It.fontMatrix[3]);
            }
            return o.Util.transform(It.ctm, o.Util.transform(It.textMatrix, Ot));
          }
          function Ce() {
            if (ct.initialized) return ct;
            const { font: jt, loadedName: Ot } = It;
            J.has(Ot) || (J.add(Ot), ut.styles[Ot] = { fontFamily: jt.fallbackName, ascent: jt.ascent, descent: jt.descent, vertical: jt.vertical }), ct.fontName = Ot;
            const Rt = ct.transform = le();
            jt.vertical ? (ct.width = ct.totalWidth = Math.hypot(Rt[0], Rt[1]), ct.height = ct.totalHeight = 0, ct.vertical = !0) : (ct.width = ct.totalWidth = 0, ct.height = ct.totalHeight = Math.hypot(Rt[2], Rt[3]), ct.vertical = !1);
            const Tt = Math.hypot(It.textLineMatrix[0], It.textLineMatrix[1]), ee = Math.hypot(It.ctm[0], It.ctm[1]);
            ct.textAdvanceScale = ee * Tt;
            const { fontSize: te } = It;
            return ct.trackingSpaceMin = 0.102 * te, ct.notASpace = 0.03 * te, ct.negativeSpaceMax = -0.2 * te, ct.spaceInFlowMin = 0.102 * te, ct.spaceInFlowMax = 0.6 * te, ct.hasEOL = !1, ct.initialized = !0, ct;
          }
          function ce() {
            if (!ct.initialized) return;
            const jt = Math.hypot(It.textLineMatrix[0], It.textLineMatrix[1]), Ot = Math.hypot(It.ctm[0], It.ctm[1]) * jt;
            Ot !== ct.textAdvanceScale && (ct.vertical ? (ct.totalHeight += ct.height * ct.textAdvanceScale, ct.height = 0) : (ct.totalWidth += ct.width * ct.textAdvanceScale, ct.width = 0), ct.textAdvanceScale = Ot);
          }
          function xe(jt, Ot) {
            return St.loadFont(jt, Ot, q).then(function(Rt) {
              return Rt.font.isType3Font ? Rt.loadType3Data(St, q, nt).catch(function() {
              }).then(function() {
                return Rt;
              }) : Rt;
            }).then(function(Rt) {
              It.loadedName = Rt.loadedName, It.font = Rt.font, It.fontMatrix = Rt.font.fontMatrix || o.FONT_IDENTITY_MATRIX;
            });
          }
          function ve(jt, Ot, Rt) {
            const Tt = Math.hypot(Rt[0], Rt[1]);
            return [(Rt[0] * jt + Rt[1] * Ot) / Tt, (Rt[2] * jt + Rt[3] * Ot) / Tt];
          }
          function Oe(jt) {
            var me;
            const Ot = le();
            let Rt = Ot[4], Tt = Ot[5];
            if ((me = It.font) != null && me.vertical) {
              if (Rt < it[0] || Rt > it[2] || Tt + jt < it[1] || Tt > it[3]) return !1;
            } else if (Rt + jt < it[0] || Rt > it[2] || Tt < it[1] || Tt > it[3]) return !1;
            if (!It.font || !ct.prevTransform) return !0;
            let ee = ct.prevTransform[4], te = ct.prevTransform[5];
            if (ee === Rt && te === Tt) return !0;
            let Jt = -1;
            switch (Ot[0] && Ot[1] === 0 && Ot[2] === 0 ? Jt = Ot[0] > 0 ? 0 : 180 : Ot[1] && Ot[0] === 0 && Ot[3] === 0 && (Jt = Ot[1] > 0 ? 90 : 270), Jt) {
              case 0:
                break;
              case 90:
                [Rt, Tt] = [Tt, Rt], [ee, te] = [te, ee];
                break;
              case 180:
                [Rt, Tt, ee, te] = [-Rt, -Tt, -ee, -te];
                break;
              case 270:
                [Rt, Tt] = [-Tt, -Rt], [ee, te] = [-te, -ee];
                break;
              default:
                [Rt, Tt] = ve(Rt, Tt, Ot), [ee, te] = ve(ee, te, ct.prevTransform);
            }
            if (It.font.vertical) {
              const we = (te - Tt) / ct.textAdvanceScale, Fe = Rt - ee, Re = Math.sign(ct.height);
              return we < Re * ct.negativeSpaceMax ? Math.abs(Fe) > 0.5 * ct.width ? (Zt(), !0) : (xt(), Gt(), !0) : Math.abs(Fe) > ct.width ? (Zt(), !0) : (we <= Re * ct.notASpace && xt(), we <= Re * ct.trackingSpaceMin ? vt() ? (xt(), Gt(), re({ height: Math.abs(we) })) : ct.height += we : Xt(we, ct.prevTransform, Re) || (ct.str.length === 0 ? (xt(), re({ height: Math.abs(we) })) : ct.height += we), Math.abs(Fe) > 0.25 * ct.width && Gt(), !0);
            }
            const pe = (Rt - ee) / ct.textAdvanceScale, ye = Tt - te, fe = Math.sign(ct.width);
            return pe < fe * ct.negativeSpaceMax ? Math.abs(ye) > 0.5 * ct.height ? (Zt(), !0) : (xt(), Gt(), !0) : Math.abs(ye) > ct.height ? (Zt(), !0) : (pe <= fe * ct.notASpace && xt(), pe <= fe * ct.trackingSpaceMin ? vt() ? (xt(), Gt(), re({ width: Math.abs(pe) })) : ct.width += pe : Xt(pe, ct.prevTransform, fe) || (ct.str.length === 0 ? (xt(), re({ width: Math.abs(pe) })) : ct.width += pe), Math.abs(ye) > 0.25 * ct.height && Gt(), !0);
          }
          function He({ chars: jt, extraSpacing: Ot }) {
            const Rt = It.font;
            if (!jt) {
              const te = It.charSpacing + Ot;
              te && (Rt.vertical ? It.translateTextMatrix(0, -te) : It.translateTextMatrix(te * It.textHScale, 0));
              return;
            }
            const Tt = Rt.charsToGlyphs(jt), ee = It.fontMatrix[0] * It.fontSize;
            for (let te = 0, Jt = Tt.length; te < Jt; te++) {
              const pe = Tt[te], { category: ye } = pe;
              if (ye.isInvisibleFormatMark) continue;
              let fe = It.charSpacing + (te + 1 === Jt ? Ot : 0), me = pe.width;
              Rt.vertical && (me = pe.vmetric ? pe.vmetric[0] : -me);
              let we = me * ee;
              if (ye.isWhitespace) {
                Rt.vertical ? (fe += -we + It.wordSpacing, It.translateTextMatrix(0, -fe)) : (fe += we + It.wordSpacing, It.translateTextMatrix(fe * It.textHScale, 0)), bt(" ");
                continue;
              }
              if (!ye.isZeroWidthDiacritic && !Oe(we)) {
                Rt.vertical ? It.translateTextMatrix(0, we) : It.translateTextMatrix(we * It.textHScale, 0);
                continue;
              }
              const Fe = Ce();
              ye.isZeroWidthDiacritic && (we = 0), Rt.vertical ? (It.translateTextMatrix(0, we), we = Math.abs(we), Fe.height += we) : (we *= It.textHScale, It.translateTextMatrix(we, 0), Fe.width += we), we && (Fe.prevTransform = le());
              const Re = pe.unicode;
              bt(Re) && Fe.str.push(" "), Fe.str.push(Re), fe && (Rt.vertical ? It.translateTextMatrix(0, -fe) : It.translateTextMatrix(fe * It.textHScale, 0));
            }
          }
          function Zt() {
            xt(), ct.initialized ? (ct.hasEOL = !0, Gt()) : ut.items.push({ str: "", dir: "ltr", width: 0, height: 0, transform: le(), fontName: It.loadedName, hasEOL: !0 });
          }
          function Xt(jt, Ot, Rt) {
            if (Rt * ct.spaceInFlowMin <= jt && jt <= Rt * ct.spaceInFlowMax)
              return ct.initialized && (xt(), ct.str.push(" ")), !1;
            const Tt = ct.fontName;
            let ee = 0;
            return ct.vertical && (ee = jt, jt = 0), Gt(), xt(), re({ width: Math.abs(jt), height: Math.abs(ee), transform: Ot || le(), fontName: Tt }), !0;
          }
          function Gt() {
            ct.initialized && ct.str && (ct.vertical ? ct.totalHeight += ct.height * ct.textAdvanceScale : ct.totalWidth += ct.width * ct.textAdvanceScale, ut.items.push(function(Ot) {
              let Rt = Ot.str.join("");
              ot || (Rt = (0, o.normalizeUnicode)(Rt));
              const Tt = (0, O.bidi)(Rt, -1, Ot.vertical);
              return { str: Tt.str, dir: Tt.dir, width: Math.abs(Ot.totalWidth), height: Math.abs(Ot.totalHeight), transform: Ot.transform, fontName: Ot.fontName, hasEOL: Ot.hasEOL };
            }(ct)), ct.initialized = !1, ct.str.length = 0);
          }
          function Lt(jt = !1) {
            const Ot = ut.items.length;
            Ot !== 0 && !(jt && Ot < 10) && (et.enqueue(ut, Ot), ut.items = [], ut.styles = /* @__PURE__ */ Object.create(null));
          }
          const Dt = new H();
          return new Promise(function jt(Ot, Rt) {
            const Tt = function(we) {
              Lt(!0), Promise.all([we, et.ready]).then(function() {
                try {
                  jt(Ot, Rt);
                } catch (Fe) {
                  Rt(Fe);
                }
              }, Rt);
            };
            nt.ensureNotTerminated(), Dt.reset();
            const ee = {};
            let te, Jt = [];
            for (; !(te = Dt.check()) && (Jt.length = 0, ee.args = Jt, !!qt.read(ee)); ) {
              const we = It;
              It = D.state;
              const Fe = ee.fn;
              switch (Jt = ee.args, 0 | Fe) {
                case o.OPS.setFont:
                  var pe = Jt[0].name, ye = Jt[1];
                  if (It.font && pe === It.fontName && ye === It.fontSize) break;
                  Gt(), It.fontName = pe, It.fontSize = ye, Tt(xe(pe, null));
                  return;
                case o.OPS.setTextRise:
                  It.textRise = Jt[0];
                  break;
                case o.OPS.setHScale:
                  It.textHScale = Jt[0] / 100;
                  break;
                case o.OPS.setLeading:
                  It.leading = Jt[0];
                  break;
                case o.OPS.moveText:
                  It.translateTextLineMatrix(Jt[0], Jt[1]), It.textMatrix = It.textLineMatrix.slice();
                  break;
                case o.OPS.setLeadingMoveText:
                  It.leading = -Jt[1], It.translateTextLineMatrix(Jt[0], Jt[1]), It.textMatrix = It.textLineMatrix.slice();
                  break;
                case o.OPS.nextLine:
                  It.carriageReturn();
                  break;
                case o.OPS.setTextMatrix:
                  It.setTextMatrix(Jt[0], Jt[1], Jt[2], Jt[3], Jt[4], Jt[5]), It.setTextLineMatrix(Jt[0], Jt[1], Jt[2], Jt[3], Jt[4], Jt[5]), ce();
                  break;
                case o.OPS.setCharSpacing:
                  It.charSpacing = Jt[0];
                  break;
                case o.OPS.setWordSpacing:
                  It.wordSpacing = Jt[0];
                  break;
                case o.OPS.beginText:
                  It.textMatrix = o.IDENTITY_MATRIX.slice(), It.textLineMatrix = o.IDENTITY_MATRIX.slice();
                  break;
                case o.OPS.showSpacedText:
                  if (!D.state.font) {
                    St.ensureStateFont(D.state);
                    continue;
                  }
                  const Re = (It.font.vertical ? 1 : -1) * It.fontSize / 1e3, ge = Jt[0];
                  for (let se = 0, ue = ge.length; se < ue; se++) {
                    const Ae = ge[se];
                    if (typeof Ae == "string") Et.push(Ae);
                    else if (typeof Ae == "number" && Ae !== 0) {
                      const he = Et.join("");
                      Et.length = 0, He({ chars: he, extraSpacing: Ae * Re });
                    }
                  }
                  if (Et.length > 0) {
                    const se = Et.join("");
                    Et.length = 0, He({ chars: se, extraSpacing: 0 });
                  }
                  break;
                case o.OPS.showText:
                  if (!D.state.font) {
                    St.ensureStateFont(D.state);
                    continue;
                  }
                  He({ chars: Jt[0], extraSpacing: 0 });
                  break;
                case o.OPS.nextLineShowText:
                  if (!D.state.font) {
                    St.ensureStateFont(D.state);
                    continue;
                  }
                  It.carriageReturn(), He({ chars: Jt[0], extraSpacing: 0 });
                  break;
                case o.OPS.nextLineSetSpacingShowText:
                  if (!D.state.font) {
                    St.ensureStateFont(D.state);
                    continue;
                  }
                  It.wordSpacing = Jt[0], It.charSpacing = Jt[1], It.carriageReturn(), He({ chars: Jt[2], extraSpacing: 0 });
                  break;
                case o.OPS.paintXObject:
                  Gt(), Ft || (Ft = q.get("XObject") || p.Dict.empty);
                  var fe = Jt[0] instanceof p.Name, me = Jt[0].name;
                  if (fe && Wt.getByName(me)) break;
                  Tt(new Promise(function(se, ue) {
                    if (!fe) throw new o.FormatError("XObject must be referred to by name.");
                    let Ae = Ft.getRaw(me);
                    if (Ae instanceof p.Ref) {
                      if (Wt.getByRef(Ae)) {
                        se();
                        return;
                      }
                      if (St.globalImageCache.getData(Ae, St.pageIndex)) {
                        se();
                        return;
                      }
                      Ae = Mt.fetch(Ae);
                    }
                    if (!(Ae instanceof M.BaseStream)) throw new o.FormatError("XObject should be a stream");
                    const he = Ae.dict.get("Subtype");
                    if (!(he instanceof p.Name)) throw new o.FormatError("XObject should have a Name subtype");
                    if (he.name !== "Form") {
                      Wt.set(me, Ae.dict.objId, !0), se();
                      return;
                    }
                    const de = D.state.clone(), _e = new V(de), Qe = Ae.dict.getArray("Matrix");
                    Array.isArray(Qe) && Qe.length === 6 && _e.transform(Qe), Lt();
                    const $n = { enqueueInvoked: !1, enqueue(zr, Jn) {
                      this.enqueueInvoked = !0, et.enqueue(zr, Jn);
                    }, get desiredSize() {
                      return et.desiredSize;
                    }, get ready() {
                      return et.ready;
                    } };
                    St.getTextContent({ stream: Ae, task: nt, resources: Ae.dict.get("Resources") || q, stateManager: _e, includeMarkedContent: G, sink: $n, seenStyles: J, viewBox: it, markedContentData: lt, disableNormalization: ot }).then(function() {
                      $n.enqueueInvoked || Wt.set(me, Ae.dict.objId, !0), se();
                    }, ue);
                  }).catch(function(se) {
                    if (!(se instanceof o.AbortException)) {
                      if (!St.options.ignoreErrors) throw se;
                      (0, o.warn)(`getTextContent - ignoring XObject: "${se}".`);
                    }
                  }));
                  return;
                case o.OPS.setGState:
                  if (fe = Jt[0] instanceof p.Name, me = Jt[0].name, fe && Kt.getByName(me)) break;
                  Tt(new Promise(function(se, ue) {
                    if (!fe) throw new o.FormatError("GState must be referred to by name.");
                    const Ae = q.get("ExtGState");
                    if (!(Ae instanceof p.Dict)) throw new o.FormatError("ExtGState should be a dictionary.");
                    const he = Ae.get(me);
                    if (!(he instanceof p.Dict)) throw new o.FormatError("GState should be a dictionary.");
                    const de = he.get("Font");
                    de ? (Gt(), It.fontName = null, It.fontSize = de[1], xe(null, de[0]).then(se, ue)) : (Kt.set(me, he.objId, !0), se());
                  }).catch(function(se) {
                    if (!(se instanceof o.AbortException)) {
                      if (!St.options.ignoreErrors) throw se;
                      (0, o.warn)(`getTextContent - ignoring ExtGState: "${se}".`);
                    }
                  }));
                  return;
                case o.OPS.beginMarkedContent:
                  Gt(), G && (lt.level++, ut.items.push({ type: "beginMarkedContent", tag: Jt[0] instanceof p.Name ? Jt[0].name : null }));
                  break;
                case o.OPS.beginMarkedContentProps:
                  if (Gt(), G) {
                    lt.level++;
                    let se = null;
                    Jt[1] instanceof p.Dict && (se = Jt[1].get("MCID")), ut.items.push({ type: "beginMarkedContentProps", id: Number.isInteger(se) ? `${St.idFactory.getPageObjId()}_mc${se}` : null, tag: Jt[0] instanceof p.Name ? Jt[0].name : null });
                  }
                  break;
                case o.OPS.endMarkedContent:
                  if (Gt(), G) {
                    if (lt.level === 0) break;
                    lt.level--, ut.items.push({ type: "endMarkedContent" });
                  }
                  break;
                case o.OPS.restore:
                  !we || we.font === It.font && we.fontSize === It.fontSize && we.fontName === It.fontName || Gt();
              }
              if (ut.items.length >= et.desiredSize) {
                te = !0;
                break;
              }
            }
            te ? Tt(K) : (Gt(), Lt(), Ot());
          }).catch((jt) => {
            if (!(jt instanceof o.AbortException)) {
              if (!this.options.ignoreErrors) throw jt;
              (0, o.warn)(`getTextContent - ignoring errors during "${nt.name}" task: "${jt}".`), Gt(), Lt();
            }
          });
        }
        extractDataStructures(at, nt, q) {
          const D = this.xref;
          let G;
          const et = this.readToUnicode(q.toUnicode || at.get("ToUnicode") || nt.get("ToUnicode"));
          if (q.composite) {
            const ct = at.get("CIDSystemInfo");
            ct instanceof p.Dict && (q.cidSystemInfo = { registry: (0, o.stringToPDFString)(ct.get("Registry")), ordering: (0, o.stringToPDFString)(ct.get("Ordering")), supplement: ct.get("Supplement") });
            try {
              const gt = at.get("CIDToGIDMap");
              gt instanceof M.BaseStream && (G = gt.getBytes());
            } catch (gt) {
              if (!this.options.ignoreErrors) throw gt;
              (0, o.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${gt}".`);
            }
          }
          const J = [];
          let it, lt = null;
          if (at.has("Encoding")) {
            if (it = at.get("Encoding"), it instanceof p.Dict) {
              if (lt = it.get("BaseEncoding"), lt = lt instanceof p.Name ? lt.name : null, it.has("Differences")) {
                const ct = it.get("Differences");
                let gt = 0;
                for (const dt of ct) {
                  const bt = D.fetchIfRef(dt);
                  if (typeof bt == "number") gt = bt;
                  else {
                    if (!(bt instanceof p.Name)) throw new o.FormatError(`Invalid entry in 'Differences' array: ${bt}`);
                    J[gt++] = bt.name;
                  }
                }
              }
            } else if (it instanceof p.Name) lt = it.name;
            else {
              const ct = "Encoding is not a Name nor a Dict";
              if (!this.options.ignoreErrors) throw new o.FormatError(ct);
              (0, o.warn)(ct);
            }
            lt !== "MacRomanEncoding" && lt !== "MacExpertEncoding" && lt !== "WinAnsiEncoding" && (lt = null);
          }
          const ot = !q.file || q.isInternalFont, ut = (0, d.getSymbolsFonts)()[q.name];
          if (lt && ot && ut && (lt = null), lt) q.defaultEncoding = (0, a.getEncoding)(lt);
          else {
            const ct = !!(q.flags & R.FontFlags.Symbolic), gt = !!(q.flags & R.FontFlags.Nonsymbolic);
            it = a.StandardEncoding, q.type !== "TrueType" || gt || (it = a.WinAnsiEncoding), (ct || ut) && (it = a.MacRomanEncoding, ot && (/Symbol/i.test(q.name) ? it = a.SymbolSetEncoding : /Dingbats/i.test(q.name) ? it = a.ZapfDingbatsEncoding : /Wingdings/i.test(q.name) && (it = a.WinAnsiEncoding))), q.defaultEncoding = it;
          }
          return q.differences = J, q.baseEncodingName = lt, q.hasEncoding = !!lt || J.length > 0, q.dict = at, et.then((ct) => (q.toUnicode = ct, this.buildToUnicode(q))).then((ct) => (q.toUnicode = ct, G && (q.cidToGidMap = this.readCidToGidMap(G, ct)), q));
        }
        _simpleFontToUnicode(at, nt = !1) {
          (0, o.assert)(!at.composite, "Must be a simple font.");
          const q = [], D = at.defaultEncoding.slice(), G = at.baseEncodingName, et = at.differences;
          for (const it in et) {
            const lt = et[it];
            lt !== ".notdef" && (D[it] = lt);
          }
          const J = (0, z.getGlyphsUnicode)();
          for (const it in D) {
            let lt = D[it];
            if (lt === "") continue;
            let ot = J[lt];
            if (ot !== void 0) {
              q[it] = String.fromCharCode(ot);
              continue;
            }
            let ut = 0;
            switch (lt[0]) {
              case "G":
                lt.length === 3 && (ut = parseInt(lt.substring(1), 16));
                break;
              case "g":
                lt.length === 5 && (ut = parseInt(lt.substring(1), 16));
                break;
              case "C":
              case "c":
                if (lt.length >= 3 && lt.length <= 4) {
                  const ct = lt.substring(1);
                  if (nt) {
                    ut = parseInt(ct, 16);
                    break;
                  }
                  if (ut = +ct, Number.isNaN(ut) && Number.isInteger(parseInt(ct, 16))) return this._simpleFontToUnicode(at, !0);
                }
                break;
              case "u":
                ot = (0, $.getUnicodeForGlyph)(lt, J), ot !== -1 && (ut = ot);
                break;
              default:
                switch (lt) {
                  case "f_h":
                  case "f_t":
                  case "T_h":
                    q[it] = lt.replaceAll("_", "");
                    continue;
                }
            }
            if (ut > 0 && ut <= 1114111 && Number.isInteger(ut)) {
              if (G && ut === +it) {
                const ct = (0, a.getEncoding)(G);
                if (ct && (lt = ct[it])) {
                  q[it] = String.fromCharCode(J[lt]);
                  continue;
                }
              }
              q[it] = String.fromCodePoint(ut);
            }
          }
          return q;
        }
        async buildToUnicode(at) {
          var nt;
          if (at.hasIncludedToUnicodeMap = ((nt = at.toUnicode) == null ? void 0 : nt.length) > 0, at.hasIncludedToUnicodeMap)
            return !at.composite && at.hasEncoding && (at.fallbackToUnicode = this._simpleFontToUnicode(at)), at.toUnicode;
          if (!at.composite) return new w.ToUnicodeMap(this._simpleFontToUnicode(at));
          if (at.composite && (at.cMap.builtInCMap && !(at.cMap instanceof g.IdentityCMap) || at.cidSystemInfo.registry === "Adobe" && (at.cidSystemInfo.ordering === "GB1" || at.cidSystemInfo.ordering === "CNS1" || at.cidSystemInfo.ordering === "Japan1" || at.cidSystemInfo.ordering === "Korea1"))) {
            const { registry: q, ordering: D } = at.cidSystemInfo, G = p.Name.get(`${q}-${D}-UCS2`), et = await g.CMapFactory.create({ encoding: G, fetchBuiltInCMap: this._fetchBuiltInCMapBound, useCMap: null }), J = [], it = [];
            return at.cMap.forEach(function(lt, ot) {
              if (ot > 65535) throw new o.FormatError("Max size of CID is 65,535");
              const ut = et.lookup(ot);
              if (ut) {
                it.length = 0;
                for (let ct = 0, gt = ut.length; ct < gt; ct += 2) it.push((ut.charCodeAt(ct) << 8) + ut.charCodeAt(ct + 1));
                J[lt] = String.fromCharCode(...it);
              }
            }), new w.ToUnicodeMap(J);
          }
          return new w.IdentityToUnicodeMap(at.firstChar, at.lastChar);
        }
        readToUnicode(at) {
          return at ? at instanceof p.Name ? g.CMapFactory.create({ encoding: at, fetchBuiltInCMap: this._fetchBuiltInCMapBound, useCMap: null }).then(function(nt) {
            return nt instanceof g.IdentityCMap ? new w.IdentityToUnicodeMap(0, 65535) : new w.ToUnicodeMap(nt.getMap());
          }) : at instanceof M.BaseStream ? g.CMapFactory.create({ encoding: at, fetchBuiltInCMap: this._fetchBuiltInCMapBound, useCMap: null }).then(function(nt) {
            if (nt instanceof g.IdentityCMap) return new w.IdentityToUnicodeMap(0, 65535);
            const q = new Array(nt.length);
            return nt.forEach(function(D, G) {
              if (typeof G == "number") {
                q[D] = String.fromCodePoint(G);
                return;
              }
              const et = [];
              for (let J = 0; J < G.length; J += 2) {
                const it = G.charCodeAt(J) << 8 | G.charCodeAt(J + 1);
                if ((63488 & it) != 55296) {
                  et.push(it);
                  continue;
                }
                J += 2;
                const lt = G.charCodeAt(J) << 8 | G.charCodeAt(J + 1);
                et.push(((1023 & it) << 10) + (1023 & lt) + 65536);
              }
              q[D] = String.fromCodePoint(...et);
            }), new w.ToUnicodeMap(q);
          }, (nt) => {
            if (nt instanceof o.AbortException) return null;
            if (this.options.ignoreErrors)
              return (0, o.warn)(`readToUnicode - ignoring ToUnicode data: "${nt}".`), null;
            throw nt;
          }) : Promise.resolve(null) : Promise.resolve(null);
        }
        readCidToGidMap(at, nt) {
          const q = [];
          for (let D = 0, G = at.length; D < G; D++) {
            const et = at[D++] << 8 | at[D], J = D >> 1;
            (et !== 0 || nt.has(J)) && (q[J] = et);
          }
          return q;
        }
        extractWidths(at, nt, q) {
          const D = this.xref;
          let G = [], et = 0;
          const J = [];
          let it, lt, ot, ut, ct, gt, dt, bt;
          if (q.composite) {
            if (et = at.has("DW") ? at.get("DW") : 1e3, bt = at.get("W"), bt) for (lt = 0, ot = bt.length; lt < ot; lt++)
              if (gt = D.fetchIfRef(bt[lt++]), dt = D.fetchIfRef(bt[lt]), Array.isArray(dt)) for (ut = 0, ct = dt.length; ut < ct; ut++) G[gt++] = D.fetchIfRef(dt[ut]);
              else {
                const St = D.fetchIfRef(bt[++lt]);
                for (ut = gt; ut <= dt; ut++) G[ut] = St;
              }
            if (q.vertical) {
              let St = at.getArray("DW2") || [880, -1e3];
              if (it = [St[1], 0.5 * et, St[0]], St = at.get("W2"), St) for (lt = 0, ot = St.length; lt < ot; lt++)
                if (gt = D.fetchIfRef(St[lt++]), dt = D.fetchIfRef(St[lt]), Array.isArray(dt)) for (ut = 0, ct = dt.length; ut < ct; ut++) J[gt++] = [D.fetchIfRef(dt[ut++]), D.fetchIfRef(dt[ut++]), D.fetchIfRef(dt[ut])];
                else {
                  const Mt = [D.fetchIfRef(St[++lt]), D.fetchIfRef(St[++lt]), D.fetchIfRef(St[++lt])];
                  for (ut = gt; ut <= dt; ut++) J[ut] = Mt;
                }
            }
          } else {
            const St = q.firstChar;
            if (bt = at.get("Widths"), bt) {
              for (ut = St, lt = 0, ot = bt.length; lt < ot; lt++) G[ut++] = D.fetchIfRef(bt[lt]);
              et = parseFloat(nt.get("MissingWidth")) || 0;
            } else {
              const Mt = at.get("BaseFont");
              if (Mt instanceof p.Name) {
                const Et = this.getBaseFontMetrics(Mt.name);
                G = this.buildCharCodeToWidth(Et.widths, q), et = Et.defaultWidth;
              }
            }
          }
          let vt = !0, xt = et;
          for (const St in G) {
            const Mt = G[St];
            if (Mt) if (xt) {
              if (xt !== Mt) {
                vt = !1;
                break;
              }
            } else xt = Mt;
          }
          vt ? q.flags |= R.FontFlags.FixedPitch : q.flags &= ~R.FontFlags.FixedPitch, q.defaultWidth = et, q.widths = G, q.defaultVMetrics = it, q.vmetrics = J;
        }
        isSerifFont(at) {
          const nt = at.split("-")[0];
          return nt in (0, d.getSerifFonts)() || /serif/gi.test(nt);
        }
        getBaseFontMetrics(at) {
          let nt = 0, q = /* @__PURE__ */ Object.create(null), D = !1, G = (0, d.getStdFontMap)()[at] || at;
          const et = (0, j.getMetrics)();
          G in et || (G = this.isSerifFont(at) ? "Times-Roman" : "Helvetica");
          const J = et[G];
          return typeof J == "number" ? (nt = J, D = !0) : q = J(), { defaultWidth: nt, monospace: D, widths: q };
        }
        buildCharCodeToWidth(at, nt) {
          const q = /* @__PURE__ */ Object.create(null), D = nt.differences, G = nt.defaultEncoding;
          for (let et = 0; et < 256; et++) et in D && at[D[et]] ? q[et] = at[D[et]] : et in G && at[G[et]] && (q[et] = at[G[et]]);
          return q;
        }
        preEvaluateFont(at) {
          const nt = at;
          let q = at.get("Subtype");
          if (!(q instanceof p.Name)) throw new o.FormatError("invalid font Subtype");
          let D, G, et = !1;
          if (q.name === "Type0") {
            const ot = at.get("DescendantFonts");
            if (!ot) throw new o.FormatError("Descendant fonts are not specified");
            if (!((at = Array.isArray(ot) ? this.xref.fetchIfRef(ot[0]) : ot) instanceof p.Dict)) throw new o.FormatError("Descendant font is not a dictionary.");
            if (q = at.get("Subtype"), !(q instanceof p.Name)) throw new o.FormatError("invalid font Subtype");
            et = !0;
          }
          const J = at.get("FirstChar") || 0, it = at.get("LastChar") || (et ? 65535 : 255), lt = at.get("FontDescriptor");
          if (lt) {
            D = new C.MurmurHash3_64();
            const ot = nt.getRaw("Encoding");
            if (ot instanceof p.Name) D.update(ot.name);
            else if (ot instanceof p.Ref) D.update(ot.toString());
            else if (ot instanceof p.Dict) {
              for (const ct of ot.getRawValues()) if (ct instanceof p.Name) D.update(ct.name);
              else if (ct instanceof p.Ref) D.update(ct.toString());
              else if (Array.isArray(ct)) {
                const gt = ct.length, dt = new Array(gt);
                for (let bt = 0; bt < gt; bt++) {
                  const vt = ct[bt];
                  vt instanceof p.Name ? dt[bt] = vt.name : (typeof vt == "number" || vt instanceof p.Ref) && (dt[bt] = vt.toString());
                }
                D.update(dt.join());
              }
            }
            if (D.update(`${J}-${it}`), G = at.get("ToUnicode") || nt.get("ToUnicode"), G instanceof M.BaseStream) {
              const ct = G.str || G, gt = ct.buffer ? new Uint8Array(ct.buffer.buffer, 0, ct.bufferLength) : new Uint8Array(ct.bytes.buffer, ct.start, ct.end - ct.start);
              D.update(gt);
            } else G instanceof p.Name && D.update(G.name);
            const ut = at.get("Widths") || nt.get("Widths");
            if (Array.isArray(ut)) {
              const ct = [];
              for (const gt of ut) (typeof gt == "number" || gt instanceof p.Ref) && ct.push(gt.toString());
              D.update(ct.join());
            }
            if (et) {
              D.update("compositeFont");
              const ct = at.get("W") || nt.get("W");
              if (Array.isArray(ct)) {
                const dt = [];
                for (const bt of ct) if (typeof bt == "number" || bt instanceof p.Ref) dt.push(bt.toString());
                else if (Array.isArray(bt)) {
                  const vt = [];
                  for (const xt of bt) (typeof xt == "number" || xt instanceof p.Ref) && vt.push(xt.toString());
                  dt.push(`[${vt.join()}]`);
                }
                D.update(dt.join());
              }
              const gt = at.getRaw("CIDToGIDMap") || nt.getRaw("CIDToGIDMap");
              gt instanceof p.Name ? D.update(gt.name) : gt instanceof p.Ref ? D.update(gt.toString()) : gt instanceof M.BaseStream && D.update(gt.peekBytes());
            }
          }
          return { descriptor: lt, dict: at, baseDict: nt, composite: et, type: q.name, firstChar: J, lastChar: it, toUnicode: G, hash: D ? D.hexdigest() : "" };
        }
        async translateFont({ descriptor: at, dict: nt, baseDict: q, composite: D, type: G, firstChar: et, lastChar: J, toUnicode: it, cssFontInfo: lt }) {
          const ot = G === "Type3";
          let ut;
          if (!at) {
            if (!ot) {
              let qt = nt.get("BaseFont");
              if (!(qt instanceof p.Name)) throw new o.FormatError("Base font is not specified");
              qt = qt.name.replaceAll(/[,_]/g, "-");
              const It = this.getBaseFontMetrics(qt), re = qt.split("-")[0], le = (this.isSerifFont(re) ? R.FontFlags.Serif : 0) | (It.monospace ? R.FontFlags.FixedPitch : 0) | ((0, d.getSymbolsFonts)()[re] ? R.FontFlags.Symbolic : R.FontFlags.Nonsymbolic);
              ut = { type: G, name: qt, loadedName: q.loadedName, systemFontInfo: null, widths: It.widths, defaultWidth: It.defaultWidth, isSimulatedFlags: !0, flags: le, firstChar: et, lastChar: J, toUnicode: it, xHeight: 0, capHeight: 0, italicAngle: 0, isType3Font: ot };
              const Ce = nt.get("Widths"), ce = (0, d.getStandardFontName)(qt);
              let xe = null;
              return ce && (xe = await this.fetchStandardFontData(ce), ut.isInternalFont = !!xe), !ut.isInternalFont && this.options.useSystemFonts && (ut.systemFontInfo = (0, W.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, qt, ce)), this.extractDataStructures(nt, nt, ut).then((ve) => {
                if (Ce) {
                  const Oe = [];
                  let He = et;
                  for (const Zt of Ce) Oe[He++] = this.xref.fetchIfRef(Zt);
                  ve.widths = Oe;
                } else ve.widths = this.buildCharCodeToWidth(It.widths, ve);
                return new n.Font(qt, xe, ve);
              });
            }
            (at = new p.Dict(null)).set("FontName", p.Name.get(G)), at.set("FontBBox", nt.getArray("FontBBox") || [0, 0, 0, 0]);
          }
          let ct = at.get("FontName"), gt = nt.get("BaseFont");
          typeof ct == "string" && (ct = p.Name.get(ct)), typeof gt == "string" && (gt = p.Name.get(gt));
          const dt = ct == null ? void 0 : ct.name, bt = gt == null ? void 0 : gt.name;
          if (!ot && dt !== bt && ((0, o.info)(`The FontDescriptor's FontName is "${dt}" but should be the same as the Font's BaseFont "${bt}".`), dt && bt && (bt.startsWith(dt) || !(0, d.isKnownFontName)(dt) && (0, d.isKnownFontName)(bt)) && (ct = null)), ct || (ct = gt), !(ct instanceof p.Name)) throw new o.FormatError("invalid font name");
          let vt, xt, St, Mt, Et;
          try {
            vt = at.get("FontFile", "FontFile2", "FontFile3");
          } catch (qt) {
            if (!this.options.ignoreErrors) throw qt;
            (0, o.warn)(`translateFont - fetching "${ct.name}" font file: "${qt}".`), vt = new _.NullStream();
          }
          let Ft = !1, Wt = null, Kt = null;
          if (vt) {
            if (vt.dict) {
              const qt = vt.dict.get("Subtype");
              qt instanceof p.Name && (xt = qt.name), St = vt.dict.get("Length1"), Mt = vt.dict.get("Length2"), Et = vt.dict.get("Length3");
            }
          } else if (lt) {
            const qt = (0, b.getXfaFontName)(ct.name);
            qt && (lt.fontFamily = `${lt.fontFamily}-PdfJS-XFA`, lt.metrics = qt.metrics || null, Wt = qt.factors || null, vt = await this.fetchStandardFontData(qt.name), Ft = !!vt, q = nt = (0, b.getXfaFontDict)(ct.name), D = !0);
          } else if (!ot) {
            const qt = (0, d.getStandardFontName)(ct.name);
            qt && (vt = await this.fetchStandardFontData(qt), Ft = !!vt), !Ft && this.options.useSystemFonts && (Kt = (0, W.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, ct.name, qt));
          }
          if (ut = { type: G, name: ct.name, subtype: xt, file: vt, length1: St, length2: Mt, length3: Et, isInternalFont: Ft, loadedName: q.loadedName, composite: D, fixedPitch: !1, fontMatrix: nt.getArray("FontMatrix") || o.FONT_IDENTITY_MATRIX, firstChar: et, lastChar: J, toUnicode: it, bbox: at.getArray("FontBBox") || nt.getArray("FontBBox"), ascent: at.get("Ascent"), descent: at.get("Descent"), xHeight: at.get("XHeight") || 0, capHeight: at.get("CapHeight") || 0, flags: at.get("Flags"), italicAngle: at.get("ItalicAngle") || 0, isType3Font: ot, cssFontInfo: lt, scaleFactors: Wt, systemFontInfo: Kt }, D) {
            const qt = q.get("Encoding");
            qt instanceof p.Name && (ut.cidEncoding = qt.name);
            const It = await g.CMapFactory.create({ encoding: qt, fetchBuiltInCMap: this._fetchBuiltInCMapBound, useCMap: null });
            ut.cMap = It, ut.vertical = ut.cMap.vertical;
          }
          return this.extractDataStructures(nt, q, ut).then((qt) => (this.extractWidths(nt, at, qt), new n.Font(ct.name, vt, qt)));
        }
        static buildFontPaths(at, nt, q, D) {
          function G(et) {
            const J = `${at.loadedName}_path_${et}`;
            try {
              if (at.renderer.hasBuiltPath(et)) return;
              q.send("commonobj", [J, "FontPath", at.renderer.getPathJs(et)]);
            } catch (it) {
              if (D.ignoreErrors) {
                (0, o.warn)(`buildFontPaths - ignoring ${J} glyph: "${it}".`);
                return;
              }
              throw it;
            }
          }
          for (const et of nt) {
            G(et.fontChar);
            const J = et.accent;
            J != null && J.fontChar && G(J.fontChar);
          }
        }
        static get fallbackFontDict() {
          const at = new p.Dict();
          return at.set("BaseFont", p.Name.get("Helvetica")), at.set("Type", p.Name.get("FallbackType")), at.set("Subtype", p.Name.get("FallbackType")), at.set("Encoding", p.Name.get("WinAnsiEncoding")), (0, o.shadow)(this, "fallbackFontDict", at);
        }
      }
      l.PartialEvaluator = Q;
      class N {
        constructor({ loadedName: at, font: nt, dict: q, evaluatorOptions: D }) {
          this.loadedName = at, this.font = nt, this.dict = q, this._evaluatorOptions = D || S, this.type3Loaded = null, this.type3Dependencies = nt.isType3Font ? /* @__PURE__ */ new Set() : null, this.sent = !1;
        }
        send(at) {
          this.sent || (this.sent = !0, at.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]));
        }
        fallback(at) {
          this.font.data && (this.font.disableFontFace = !0, Q.buildFontPaths(this.font, this.font.glyphCacheValues, at, this._evaluatorOptions));
        }
        loadType3Data(at, nt, q) {
          if (this.type3Loaded) return this.type3Loaded;
          if (!this.font.isType3Font) throw new Error("Must be a Type3 font.");
          const D = at.clone({ ignoreErrors: !1 });
          D.parsingType3Font = !0;
          const G = new p.RefSet(at.type3FontRefs);
          this.dict.objId && !G.has(this.dict.objId) && G.put(this.dict.objId), D.type3FontRefs = G;
          const et = this.font, J = this.type3Dependencies;
          let it = Promise.resolve();
          const lt = this.dict.get("CharProcs"), ot = this.dict.get("Resources") || nt, ut = /* @__PURE__ */ Object.create(null), ct = o.Util.normalizeRect(et.bbox || [0, 0, 0, 0]), gt = ct[2] - ct[0], dt = ct[3] - ct[1], bt = Math.hypot(gt, dt);
          for (const vt of lt.getKeys()) it = it.then(() => {
            const xt = lt.get(vt), St = new T.OperatorList();
            return D.getOperatorList({ stream: xt, task: q, resources: ot, operatorList: St }).then(() => {
              St.fnArray[0] === o.OPS.setCharWidthAndBounds && this._removeType3ColorOperators(St, bt), ut[vt] = St.getIR();
              for (const Mt of St.dependencies) J.add(Mt);
            }).catch(function(Mt) {
              (0, o.warn)(`Type3 font resource "${vt}" is not available.`);
              const Et = new T.OperatorList();
              ut[vt] = Et.getIR();
            });
          });
          return this.type3Loaded = it.then(() => {
            et.charProcOperatorList = ut, this._bbox && (et.isCharBBox = !0, et.bbox = this._bbox);
          }), this.type3Loaded;
        }
        _removeType3ColorOperators(at, nt = NaN) {
          const q = o.Util.normalizeRect(at.argsArray[0].slice(2)), D = q[2] - q[0], G = q[3] - q[1], et = Math.hypot(D, G);
          D === 0 || G === 0 ? (at.fnArray.splice(0, 1), at.argsArray.splice(0, 1)) : (nt === 0 || Math.round(et / nt) >= 10) && (this._bbox || (this._bbox = [1 / 0, 1 / 0, -1 / 0, -1 / 0]), this._bbox[0] = Math.min(this._bbox[0], q[0]), this._bbox[1] = Math.min(this._bbox[1], q[1]), this._bbox[2] = Math.max(this._bbox[2], q[2]), this._bbox[3] = Math.max(this._bbox[3], q[3]));
          let J = 0, it = at.length;
          for (; J < it; ) {
            switch (at.fnArray[J]) {
              case o.OPS.setCharWidthAndBounds:
                break;
              case o.OPS.setStrokeColorSpace:
              case o.OPS.setFillColorSpace:
              case o.OPS.setStrokeColor:
              case o.OPS.setStrokeColorN:
              case o.OPS.setFillColor:
              case o.OPS.setFillColorN:
              case o.OPS.setStrokeGray:
              case o.OPS.setFillGray:
              case o.OPS.setStrokeRGBColor:
              case o.OPS.setFillRGBColor:
              case o.OPS.setStrokeCMYKColor:
              case o.OPS.setFillCMYKColor:
              case o.OPS.shadingFill:
              case o.OPS.setRenderingIntent:
                at.fnArray.splice(J, 1), at.argsArray.splice(J, 1), it--;
                continue;
              case o.OPS.setGState:
                const [lt] = at.argsArray[J];
                let ot = 0, ut = lt.length;
                for (; ot < ut; ) {
                  const [ct] = lt[ot];
                  switch (ct) {
                    case "TR":
                    case "TR2":
                    case "HT":
                    case "BG":
                    case "BG2":
                    case "UCR":
                    case "UCR2":
                      lt.splice(ot, 1), ut--;
                      continue;
                  }
                  ot++;
                }
            }
            J++;
          }
        }
      }
      class V {
        constructor(at = new Z()) {
          this.state = at, this.stateStack = [];
        }
        save() {
          const at = this.state;
          this.stateStack.push(this.state), this.state = at.clone();
        }
        restore() {
          const at = this.stateStack.pop();
          at && (this.state = at);
        }
        transform(at) {
          this.state.ctm = o.Util.transform(this.state.ctm, at);
        }
      }
      class Y {
        constructor() {
          this.ctm = new Float32Array(o.IDENTITY_MATRIX), this.fontName = null, this.fontSize = 0, this.loadedName = null, this.font = null, this.fontMatrix = o.FONT_IDENTITY_MATRIX, this.textMatrix = o.IDENTITY_MATRIX.slice(), this.textLineMatrix = o.IDENTITY_MATRIX.slice(), this.charSpacing = 0, this.wordSpacing = 0, this.leading = 0, this.textHScale = 1, this.textRise = 0;
        }
        setTextMatrix(at, nt, q, D, G, et) {
          const J = this.textMatrix;
          J[0] = at, J[1] = nt, J[2] = q, J[3] = D, J[4] = G, J[5] = et;
        }
        setTextLineMatrix(at, nt, q, D, G, et) {
          const J = this.textLineMatrix;
          J[0] = at, J[1] = nt, J[2] = q, J[3] = D, J[4] = G, J[5] = et;
        }
        translateTextMatrix(at, nt) {
          const q = this.textMatrix;
          q[4] = q[0] * at + q[2] * nt + q[4], q[5] = q[1] * at + q[3] * nt + q[5];
        }
        translateTextLineMatrix(at, nt) {
          const q = this.textLineMatrix;
          q[4] = q[0] * at + q[2] * nt + q[4], q[5] = q[1] * at + q[3] * nt + q[5];
        }
        carriageReturn() {
          this.translateTextLineMatrix(0, -this.leading), this.textMatrix = this.textLineMatrix.slice();
        }
        clone() {
          const at = Object.create(this);
          return at.textMatrix = this.textMatrix.slice(), at.textLineMatrix = this.textLineMatrix.slice(), at.fontMatrix = this.fontMatrix.slice(), at;
        }
      }
      class Z {
        constructor() {
          this.ctm = new Float32Array(o.IDENTITY_MATRIX), this.font = null, this.textRenderingMode = o.TextRenderingMode.FILL, this.fillColorSpace = E.ColorSpace.singletons.gray, this.strokeColorSpace = E.ColorSpace.singletons.gray;
        }
        clone() {
          return Object.create(this);
        }
      }
      const mt = class mt {
        static get opMap() {
          return (0, o.shadow)(this, "opMap", { w: { id: o.OPS.setLineWidth, numArgs: 1, variableArgs: !1 }, J: { id: o.OPS.setLineCap, numArgs: 1, variableArgs: !1 }, j: { id: o.OPS.setLineJoin, numArgs: 1, variableArgs: !1 }, M: { id: o.OPS.setMiterLimit, numArgs: 1, variableArgs: !1 }, d: { id: o.OPS.setDash, numArgs: 2, variableArgs: !1 }, ri: { id: o.OPS.setRenderingIntent, numArgs: 1, variableArgs: !1 }, i: { id: o.OPS.setFlatness, numArgs: 1, variableArgs: !1 }, gs: { id: o.OPS.setGState, numArgs: 1, variableArgs: !1 }, q: { id: o.OPS.save, numArgs: 0, variableArgs: !1 }, Q: { id: o.OPS.restore, numArgs: 0, variableArgs: !1 }, cm: { id: o.OPS.transform, numArgs: 6, variableArgs: !1 }, m: { id: o.OPS.moveTo, numArgs: 2, variableArgs: !1 }, l: { id: o.OPS.lineTo, numArgs: 2, variableArgs: !1 }, c: { id: o.OPS.curveTo, numArgs: 6, variableArgs: !1 }, v: { id: o.OPS.curveTo2, numArgs: 4, variableArgs: !1 }, y: { id: o.OPS.curveTo3, numArgs: 4, variableArgs: !1 }, h: { id: o.OPS.closePath, numArgs: 0, variableArgs: !1 }, re: { id: o.OPS.rectangle, numArgs: 4, variableArgs: !1 }, S: { id: o.OPS.stroke, numArgs: 0, variableArgs: !1 }, s: { id: o.OPS.closeStroke, numArgs: 0, variableArgs: !1 }, f: { id: o.OPS.fill, numArgs: 0, variableArgs: !1 }, F: { id: o.OPS.fill, numArgs: 0, variableArgs: !1 }, "f*": { id: o.OPS.eoFill, numArgs: 0, variableArgs: !1 }, B: { id: o.OPS.fillStroke, numArgs: 0, variableArgs: !1 }, "B*": { id: o.OPS.eoFillStroke, numArgs: 0, variableArgs: !1 }, b: { id: o.OPS.closeFillStroke, numArgs: 0, variableArgs: !1 }, "b*": { id: o.OPS.closeEOFillStroke, numArgs: 0, variableArgs: !1 }, n: { id: o.OPS.endPath, numArgs: 0, variableArgs: !1 }, W: { id: o.OPS.clip, numArgs: 0, variableArgs: !1 }, "W*": { id: o.OPS.eoClip, numArgs: 0, variableArgs: !1 }, BT: { id: o.OPS.beginText, numArgs: 0, variableArgs: !1 }, ET: { id: o.OPS.endText, numArgs: 0, variableArgs: !1 }, Tc: { id: o.OPS.setCharSpacing, numArgs: 1, variableArgs: !1 }, Tw: { id: o.OPS.setWordSpacing, numArgs: 1, variableArgs: !1 }, Tz: { id: o.OPS.setHScale, numArgs: 1, variableArgs: !1 }, TL: { id: o.OPS.setLeading, numArgs: 1, variableArgs: !1 }, Tf: { id: o.OPS.setFont, numArgs: 2, variableArgs: !1 }, Tr: { id: o.OPS.setTextRenderingMode, numArgs: 1, variableArgs: !1 }, Ts: { id: o.OPS.setTextRise, numArgs: 1, variableArgs: !1 }, Td: { id: o.OPS.moveText, numArgs: 2, variableArgs: !1 }, TD: { id: o.OPS.setLeadingMoveText, numArgs: 2, variableArgs: !1 }, Tm: { id: o.OPS.setTextMatrix, numArgs: 6, variableArgs: !1 }, "T*": { id: o.OPS.nextLine, numArgs: 0, variableArgs: !1 }, Tj: { id: o.OPS.showText, numArgs: 1, variableArgs: !1 }, TJ: { id: o.OPS.showSpacedText, numArgs: 1, variableArgs: !1 }, "'": { id: o.OPS.nextLineShowText, numArgs: 1, variableArgs: !1 }, '"': { id: o.OPS.nextLineSetSpacingShowText, numArgs: 3, variableArgs: !1 }, d0: { id: o.OPS.setCharWidth, numArgs: 2, variableArgs: !1 }, d1: { id: o.OPS.setCharWidthAndBounds, numArgs: 6, variableArgs: !1 }, CS: { id: o.OPS.setStrokeColorSpace, numArgs: 1, variableArgs: !1 }, cs: { id: o.OPS.setFillColorSpace, numArgs: 1, variableArgs: !1 }, SC: { id: o.OPS.setStrokeColor, numArgs: 4, variableArgs: !0 }, SCN: { id: o.OPS.setStrokeColorN, numArgs: 33, variableArgs: !0 }, sc: { id: o.OPS.setFillColor, numArgs: 4, variableArgs: !0 }, scn: { id: o.OPS.setFillColorN, numArgs: 33, variableArgs: !0 }, G: { id: o.OPS.setStrokeGray, numArgs: 1, variableArgs: !1 }, g: { id: o.OPS.setFillGray, numArgs: 1, variableArgs: !1 }, RG: { id: o.OPS.setStrokeRGBColor, numArgs: 3, variableArgs: !1 }, rg: { id: o.OPS.setFillRGBColor, numArgs: 3, variableArgs: !1 }, K: { id: o.OPS.setStrokeCMYKColor, numArgs: 4, variableArgs: !1 }, k: { id: o.OPS.setFillCMYKColor, numArgs: 4, variableArgs: !1 }, sh: { id: o.OPS.shadingFill, numArgs: 1, variableArgs: !1 }, BI: { id: o.OPS.beginInlineImage, numArgs: 0, variableArgs: !1 }, ID: { id: o.OPS.beginImageData, numArgs: 0, variableArgs: !1 }, EI: { id: o.OPS.endInlineImage, numArgs: 1, variableArgs: !1 }, Do: { id: o.OPS.paintXObject, numArgs: 1, variableArgs: !1 }, MP: { id: o.OPS.markPoint, numArgs: 1, variableArgs: !1 }, DP: { id: o.OPS.markPointProps, numArgs: 2, variableArgs: !1 }, BMC: { id: o.OPS.beginMarkedContent, numArgs: 1, variableArgs: !1 }, BDC: { id: o.OPS.beginMarkedContentProps, numArgs: 2, variableArgs: !1 }, EMC: { id: o.OPS.endMarkedContent, numArgs: 0, variableArgs: !1 }, BX: { id: o.OPS.beginCompat, numArgs: 0, variableArgs: !1 }, EX: { id: o.OPS.endCompat, numArgs: 0, variableArgs: !1 }, BM: null, BD: null, true: null, fa: null, fal: null, fals: null, false: null, nu: null, nul: null, null: null });
        }
        constructor(at, nt, q = new V()) {
          this.parser = new h.Parser({ lexer: new h.Lexer(at, mt.opMap), xref: nt }), this.stateManager = q, this.nonProcessedArgs = [], this._isPathOp = !1, this._numInvalidPathOPS = 0;
        }
        get savedStatesDepth() {
          return this.stateManager.stateStack.length;
        }
        read(at) {
          let nt = at.args;
          for (; ; ) {
            const q = this.parser.getObj();
            if (q instanceof p.Cmd) {
              const D = q.cmd, G = mt.opMap[D];
              if (!G) {
                (0, o.warn)(`Unknown command "${D}".`);
                continue;
              }
              const et = G.id, J = G.numArgs;
              let it = nt !== null ? nt.length : 0;
              if (this._isPathOp || (this._numInvalidPathOPS = 0), this._isPathOp = et >= o.OPS.moveTo && et <= o.OPS.endPath, G.variableArgs) it > J && (0, o.info)(`Command ${D}: expected [0, ${J}] args, but received ${it} args.`);
              else {
                if (it !== J) {
                  const lt = this.nonProcessedArgs;
                  for (; it > J; )
                    lt.push(nt.shift()), it--;
                  for (; it < J && lt.length !== 0; )
                    nt === null && (nt = []), nt.unshift(lt.pop()), it++;
                }
                if (it < J) {
                  const lt = `command ${D}: expected ${J} args, but received ${it} args.`;
                  if (this._isPathOp && ++this._numInvalidPathOPS > mt.MAX_INVALID_PATH_OPS) throw new o.FormatError(`Invalid ${lt}`);
                  (0, o.warn)(`Skipping ${lt}`), nt !== null && (nt.length = 0);
                  continue;
                }
              }
              return this.preprocessCommand(et, nt), at.fn = et, at.args = nt, !0;
            }
            if (q === p.EOF) return !1;
            if (q !== null && (nt === null && (nt = []), nt.push(q), nt.length > 33))
              throw new o.FormatError("Too many arguments");
          }
        }
        preprocessCommand(at, nt) {
          switch (0 | at) {
            case o.OPS.save:
              this.stateManager.save();
              break;
            case o.OPS.restore:
              this.stateManager.restore();
              break;
            case o.OPS.transform:
              this.stateManager.transform(nt);
          }
        }
      };
      Mr(mt, "MAX_INVALID_PATH_OPS", 10);
      let rt = mt;
      l.EvaluatorPreprocessor = rt;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.IdentityCMap = l.CMapFactory = l.CMap = void 0;
      var o = f(2), g = f(4), p = f(5), n = f(15), a = f(16), d = f(3), m = f(8);
      const b = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"], w = 2 ** 24 - 1;
      class v {
        constructor(F = !1) {
          this.codespaceRanges = [[], [], [], []], this.numCodespaceRanges = 0, this._map = [], this.name = "", this.vertical = !1, this.useCMap = null, this.builtInCMap = F;
        }
        addCodespaceRange(F, S, A) {
          this.codespaceRanges[F - 1].push(S, A), this.numCodespaceRanges++;
        }
        mapCidRange(F, S, A) {
          if (S - F > w) throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
          for (; F <= S; ) this._map[F++] = A++;
        }
        mapBfRange(F, S, A) {
          if (S - F > w) throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
          const U = A.length - 1;
          for (; F <= S; ) {
            this._map[F++] = A;
            const K = A.charCodeAt(U) + 1;
            K > 255 ? A = A.substring(0, U - 1) + String.fromCharCode(A.charCodeAt(U - 1) + 1) + "\0" : A = A.substring(0, U) + String.fromCharCode(K);
          }
        }
        mapBfRangeToArray(F, S, A) {
          if (S - F > w) throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
          const U = A.length;
          let K = 0;
          for (; F <= S && K < U; )
            this._map[F] = A[K++], ++F;
        }
        mapOne(F, S) {
          this._map[F] = S;
        }
        lookup(F) {
          return this._map[F];
        }
        contains(F) {
          return this._map[F] !== void 0;
        }
        forEach(F) {
          const S = this._map, A = S.length;
          if (A <= 65536) for (let U = 0; U < A; U++) S[U] !== void 0 && F(U, S[U]);
          else for (const U in S) F(U, S[U]);
        }
        charCodeOf(F) {
          const S = this._map;
          if (S.length <= 65536) return S.indexOf(F);
          for (const A in S) if (S[A] === F) return 0 | A;
          return -1;
        }
        getMap() {
          return this._map;
        }
        readCharCode(F, S, A) {
          let U = 0;
          const K = this.codespaceRanges;
          for (let X = 0, L = K.length; X < L; X++) {
            U = (U << 8 | F.charCodeAt(S + X)) >>> 0;
            const H = K[X];
            for (let Q = 0, N = H.length; Q < N; ) {
              const V = H[Q++], Y = H[Q++];
              if (U >= V && U <= Y) {
                A.charcode = U, A.length = X + 1;
                return;
              }
            }
          }
          A.charcode = 0, A.length = 1;
        }
        getCharCodeLength(F) {
          const S = this.codespaceRanges;
          for (let A = 0, U = S.length; A < U; A++) {
            const K = S[A];
            for (let X = 0, L = K.length; X < L; ) {
              const H = K[X++], Q = K[X++];
              if (F >= H && F <= Q) return A + 1;
            }
          }
          return 1;
        }
        get length() {
          return this._map.length;
        }
        get isIdentityCMap() {
          if (this.name !== "Identity-H" && this.name !== "Identity-V" || this._map.length !== 65536) return !1;
          for (let F = 0; F < 65536; F++) if (this._map[F] !== F) return !1;
          return !0;
        }
      }
      l.CMap = v;
      class h extends v {
        constructor(F, S) {
          super(), this.vertical = F, this.addCodespaceRange(S, 0, 65535);
        }
        mapCidRange(F, S, A) {
          (0, o.unreachable)("should not call mapCidRange");
        }
        mapBfRange(F, S, A) {
          (0, o.unreachable)("should not call mapBfRange");
        }
        mapBfRangeToArray(F, S, A) {
          (0, o.unreachable)("should not call mapBfRangeToArray");
        }
        mapOne(F, S) {
          (0, o.unreachable)("should not call mapCidOne");
        }
        lookup(F) {
          return Number.isInteger(F) && F <= 65535 ? F : void 0;
        }
        contains(F) {
          return Number.isInteger(F) && F <= 65535;
        }
        forEach(F) {
          for (let S = 0; S <= 65535; S++) F(S, S);
        }
        charCodeOf(F) {
          return Number.isInteger(F) && F <= 65535 ? F : -1;
        }
        getMap() {
          const F = new Array(65536);
          for (let S = 0; S <= 65535; S++) F[S] = S;
          return F;
        }
        get length() {
          return 65536;
        }
        get isIdentityCMap() {
          (0, o.unreachable)("should not access .isIdentityCMap");
        }
      }
      l.IdentityCMap = h;
      function x(T) {
        let F = 0;
        for (let S = 0; S < T.length; S++) F = F << 8 | T.charCodeAt(S);
        return F >>> 0;
      }
      function _(T) {
        if (typeof T != "string") throw new o.FormatError("Malformed CMap: expected string.");
      }
      function M(T) {
        if (!Number.isInteger(T)) throw new o.FormatError("Malformed CMap: expected int.");
      }
      function O(T, F) {
        for (; ; ) {
          let S = F.getObj();
          if (S === g.EOF) break;
          if ((0, g.isCmd)(S, "endbfchar")) return;
          _(S);
          const A = x(S);
          S = F.getObj(), _(S);
          const U = S;
          T.mapOne(A, U);
        }
      }
      function E(T, F) {
        for (; ; ) {
          let S = F.getObj();
          if (S === g.EOF) break;
          if ((0, g.isCmd)(S, "endbfrange")) return;
          _(S);
          const A = x(S);
          S = F.getObj(), _(S);
          const U = x(S);
          if (S = F.getObj(), Number.isInteger(S) || typeof S == "string") {
            const K = Number.isInteger(S) ? String.fromCharCode(S) : S;
            T.mapBfRange(A, U, K);
          } else {
            if (!(0, g.isCmd)(S, "[")) break;
            {
              S = F.getObj();
              const K = [];
              for (; !(0, g.isCmd)(S, "]") && S !== g.EOF; )
                K.push(S), S = F.getObj();
              T.mapBfRangeToArray(A, U, K);
            }
          }
        }
        throw new o.FormatError("Invalid bf range.");
      }
      function I(T, F) {
        for (; ; ) {
          let S = F.getObj();
          if (S === g.EOF) break;
          if ((0, g.isCmd)(S, "endcidchar")) return;
          _(S);
          const A = x(S);
          S = F.getObj(), M(S);
          const U = S;
          T.mapOne(A, U);
        }
      }
      function R(T, F) {
        for (; ; ) {
          let S = F.getObj();
          if (S === g.EOF) break;
          if ((0, g.isCmd)(S, "endcidrange")) return;
          _(S);
          const A = x(S);
          S = F.getObj(), _(S);
          const U = x(S);
          S = F.getObj(), M(S);
          const K = S;
          T.mapCidRange(A, U, K);
        }
      }
      function W(T, F) {
        for (; ; ) {
          let S = F.getObj();
          if (S === g.EOF) break;
          if ((0, g.isCmd)(S, "endcodespacerange")) return;
          if (typeof S != "string") break;
          const A = x(S);
          if (S = F.getObj(), typeof S != "string") break;
          const U = x(S);
          T.addCodespaceRange(S.length, A, U);
        }
        throw new o.FormatError("Invalid codespace range.");
      }
      function z(T, F) {
        const S = F.getObj();
        Number.isInteger(S) && (T.vertical = !!S);
      }
      function j(T, F) {
        const S = F.getObj();
        S instanceof g.Name && (T.name = S.name);
      }
      async function $(T, F, S, A) {
        let U, K;
        t: for (; ; ) try {
          const X = F.getObj();
          if (X === g.EOF) break;
          if (X instanceof g.Name)
            X.name === "WMode" ? z(T, F) : X.name === "CMapName" && j(T, F), U = X;
          else if (X instanceof g.Cmd) switch (X.cmd) {
            case "endcmap":
              break t;
            case "usecmap":
              U instanceof g.Name && (K = U.name);
              break;
            case "begincodespacerange":
              W(T, F);
              break;
            case "beginbfchar":
              O(T, F);
              break;
            case "begincidchar":
              I(T, F);
              break;
            case "beginbfrange":
              E(T, F);
              break;
            case "begincidrange":
              R(T, F);
          }
        } catch (X) {
          if (X instanceof d.MissingDataException) throw X;
          (0, o.warn)("Invalid cMap data: " + X);
          continue;
        }
        return !A && K && (A = K), A ? B(T, S, A) : T;
      }
      async function B(T, F, S) {
        if (T.useCMap = await C(S, F), T.numCodespaceRanges === 0) {
          const A = T.useCMap.codespaceRanges;
          for (let U = 0; U < A.length; U++) T.codespaceRanges[U] = A[U].slice();
          T.numCodespaceRanges = T.useCMap.numCodespaceRanges;
        }
        return T.useCMap.forEach(function(A, U) {
          T.contains(A) || T.mapOne(A, T.useCMap.lookup(A));
        }), T;
      }
      async function C(T, F) {
        if (T === "Identity-H") return new h(!1, 2);
        if (T === "Identity-V") return new h(!0, 2);
        if (!b.includes(T)) throw new Error("Unknown CMap name: " + T);
        if (!F) throw new Error("Built-in CMap parameters are not provided.");
        const { cMapData: S, compressionType: A } = await F(T), U = new v(!0);
        if (A === o.CMapCompressionType.BINARY) return new n.BinaryCMapReader().process(S, U, (K) => B(U, F, K));
        if (A === o.CMapCompressionType.NONE) {
          const K = new a.Lexer(new m.Stream(S));
          return $(U, K, F, null);
        }
        throw new Error(`Invalid CMap "compressionType" value: ${A}`);
      }
      l.CMapFactory = class {
        static async create({ encoding: F, fetchBuiltInCMap: S, useCMap: A }) {
          if (F instanceof g.Name) return C(F.name, S);
          if (F instanceof p.BaseStream) {
            const U = await $(new v(), new a.Lexer(F), S, A);
            return U.isIdentityCMap ? C(U.name, S) : U;
          }
          throw new Error("Encoding required.");
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.BinaryCMapReader = void 0;
      var o = f(2);
      function g(b, w) {
        let v = 0;
        for (let h = 0; h <= w; h++) v = v << 8 | b[h];
        return v >>> 0;
      }
      function p(b, w) {
        return w === 1 ? String.fromCharCode(b[0], b[1]) : w === 3 ? String.fromCharCode(b[0], b[1], b[2], b[3]) : String.fromCharCode(...b.subarray(0, w + 1));
      }
      function n(b, w, v) {
        let h = 0;
        for (let x = v; x >= 0; x--)
          h += b[x] + w[x], b[x] = 255 & h, h >>= 8;
      }
      function a(b, w) {
        let v = 1;
        for (let h = w; h >= 0 && v > 0; h--)
          v += b[h], b[h] = 255 & v, v >>= 8;
      }
      const d = 16;
      class m {
        constructor(w) {
          this.buffer = w, this.pos = 0, this.end = w.length, this.tmpBuf = new Uint8Array(19);
        }
        readByte() {
          return this.pos >= this.end ? -1 : this.buffer[this.pos++];
        }
        readNumber() {
          let w, v = 0;
          do {
            const h = this.readByte();
            if (h < 0) throw new o.FormatError("unexpected EOF in bcmap");
            w = !(128 & h), v = v << 7 | 127 & h;
          } while (!w);
          return v;
        }
        readSigned() {
          const w = this.readNumber();
          return 1 & w ? ~(w >>> 1) : w >>> 1;
        }
        readHex(w, v) {
          w.set(this.buffer.subarray(this.pos, this.pos + v + 1)), this.pos += v + 1;
        }
        readHexNumber(w, v) {
          let h;
          const x = this.tmpBuf;
          let _ = 0;
          do {
            const I = this.readByte();
            if (I < 0) throw new o.FormatError("unexpected EOF in bcmap");
            h = !(128 & I), x[_++] = 127 & I;
          } while (!h);
          let M = v, O = 0, E = 0;
          for (; M >= 0; ) {
            for (; E < 8 && x.length > 0; )
              O |= x[--_] << E, E += 7;
            w[M] = 255 & O, M--, O >>= 8, E -= 8;
          }
        }
        readHexSigned(w, v) {
          this.readHexNumber(w, v);
          const h = 1 & w[v] ? 255 : 0;
          let x = 0;
          for (let _ = 0; _ <= v; _++)
            x = (1 & x) << 8 | w[_], w[_] = x >> 1 ^ h;
        }
        readString() {
          const w = this.readNumber(), v = new Array(w);
          for (let h = 0; h < w; h++) v[h] = this.readNumber();
          return String.fromCharCode(...v);
        }
      }
      l.BinaryCMapReader = class {
        async process(w, v, h) {
          const x = new m(w), _ = x.readByte();
          v.vertical = !!(1 & _);
          let M = null;
          const O = new Uint8Array(d), E = new Uint8Array(d), I = new Uint8Array(d), R = new Uint8Array(d), W = new Uint8Array(d);
          let z, j;
          for (; (j = x.readByte()) >= 0; ) {
            const $ = j >> 5;
            if ($ === 7) {
              switch (31 & j) {
                case 0:
                  x.readString();
                  break;
                case 1:
                  M = x.readString();
              }
              continue;
            }
            const B = !!(16 & j), C = 15 & j;
            if (C + 1 > d) throw new Error("BinaryCMapReader.process: Invalid dataSize.");
            const T = 1, F = x.readNumber();
            switch ($) {
              case 0:
                x.readHex(O, C), x.readHexNumber(E, C), n(E, O, C), v.addCodespaceRange(C + 1, g(O, C), g(E, C));
                for (let S = 1; S < F; S++)
                  a(E, C), x.readHexNumber(O, C), n(O, E, C), x.readHexNumber(E, C), n(E, O, C), v.addCodespaceRange(C + 1, g(O, C), g(E, C));
                break;
              case 1:
                x.readHex(O, C), x.readHexNumber(E, C), n(E, O, C), x.readNumber();
                for (let S = 1; S < F; S++)
                  a(E, C), x.readHexNumber(O, C), n(O, E, C), x.readHexNumber(E, C), n(E, O, C), x.readNumber();
                break;
              case 2:
                x.readHex(I, C), z = x.readNumber(), v.mapOne(g(I, C), z);
                for (let S = 1; S < F; S++)
                  a(I, C), B || (x.readHexNumber(W, C), n(I, W, C)), z = x.readSigned() + (z + 1), v.mapOne(g(I, C), z);
                break;
              case 3:
                x.readHex(O, C), x.readHexNumber(E, C), n(E, O, C), z = x.readNumber(), v.mapCidRange(g(O, C), g(E, C), z);
                for (let S = 1; S < F; S++)
                  a(E, C), B ? O.set(E) : (x.readHexNumber(O, C), n(O, E, C)), x.readHexNumber(E, C), n(E, O, C), z = x.readNumber(), v.mapCidRange(g(O, C), g(E, C), z);
                break;
              case 4:
                x.readHex(I, T), x.readHex(R, C), v.mapOne(g(I, T), p(R, C));
                for (let S = 1; S < F; S++)
                  a(I, T), B || (x.readHexNumber(W, T), n(I, W, T)), a(R, C), x.readHexSigned(W, C), n(R, W, C), v.mapOne(g(I, T), p(R, C));
                break;
              case 5:
                x.readHex(O, T), x.readHexNumber(E, T), n(E, O, T), x.readHex(R, C), v.mapBfRange(g(O, T), g(E, T), p(R, C));
                for (let S = 1; S < F; S++)
                  a(E, T), B ? O.set(E) : (x.readHexNumber(O, T), n(O, E, T)), x.readHexNumber(E, T), n(E, O, T), x.readHex(R, C), v.mapBfRange(g(O, T), g(E, T), p(R, C));
                break;
              default:
                throw new Error(`BinaryCMapReader.process - unknown type: ${$}`);
            }
          }
          return M ? h(M) : v;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Parser = l.Linearization = l.Lexer = void 0;
      var o = f(2), g = f(4), p = f(3), n = f(8), a = f(17), d = f(19), m = f(20), b = f(22), w = f(23), v = f(26), h = f(29), x = f(31), _ = f(32), M = f(33);
      class O {
        constructor({ lexer: z, xref: j, allowStreams: $ = !1, recoveryMode: B = !1 }) {
          this.lexer = z, this.xref = j, this.allowStreams = $, this.recoveryMode = B, this.imageCache = /* @__PURE__ */ Object.create(null), this._imageId = 0, this.refill();
        }
        refill() {
          this.buf1 = this.lexer.getObj(), this.buf2 = this.lexer.getObj();
        }
        shift() {
          this.buf2 instanceof g.Cmd && this.buf2.cmd === "ID" ? (this.buf1 = this.buf2, this.buf2 = null) : (this.buf1 = this.buf2, this.buf2 = this.lexer.getObj());
        }
        tryShift() {
          try {
            return this.shift(), !0;
          } catch (z) {
            if (z instanceof p.MissingDataException) throw z;
            return !1;
          }
        }
        getObj(z = null) {
          const j = this.buf1;
          if (this.shift(), j instanceof g.Cmd) switch (j.cmd) {
            case "BI":
              return this.makeInlineImage(z);
            case "[":
              const $ = [];
              for (; !(0, g.isCmd)(this.buf1, "]") && this.buf1 !== g.EOF; ) $.push(this.getObj(z));
              if (this.buf1 === g.EOF) {
                if (this.recoveryMode) return $;
                throw new p.ParserEOFException("End of file inside array.");
              }
              return this.shift(), $;
            case "<<":
              const B = new g.Dict(this.xref);
              for (; !(0, g.isCmd)(this.buf1, ">>") && this.buf1 !== g.EOF; ) {
                if (!(this.buf1 instanceof g.Name)) {
                  (0, o.info)("Malformed dictionary: key must be a name object"), this.shift();
                  continue;
                }
                const C = this.buf1.name;
                if (this.shift(), this.buf1 === g.EOF) break;
                B.set(C, this.getObj(z));
              }
              if (this.buf1 === g.EOF) {
                if (this.recoveryMode) return B;
                throw new p.ParserEOFException("End of file inside dictionary.");
              }
              return (0, g.isCmd)(this.buf2, "stream") ? this.allowStreams ? this.makeStream(B, z) : B : (this.shift(), B);
            default:
              return j;
          }
          if (Number.isInteger(j)) {
            if (Number.isInteger(this.buf1) && (0, g.isCmd)(this.buf2, "R")) {
              const $ = g.Ref.get(j, this.buf1);
              return this.shift(), this.shift(), $;
            }
            return j;
          }
          return typeof j == "string" && z ? z.decryptString(j) : j;
        }
        findDefaultInlineStreamEnd(z) {
          const { knownCommands: j } = this.lexer, $ = z.pos;
          let B, C, T = 0;
          for (; (B = z.getByte()) !== -1; ) if (T === 0) T = B === 69 ? 1 : 0;
          else if (T === 1) T = B === 73 ? 2 : 0;
          else if (B === 32 || B === 10 || B === 13) {
            C = z.pos;
            const S = z.peekBytes(15), A = S.length;
            if (A === 0) break;
            for (let X = 0; X < A; X++)
              if (B = S[X], (B !== 0 || S[X + 1] === 0) && B !== 10 && B !== 13 && (B < 32 || B > 127)) {
                T = 0;
                break;
              }
            if (T !== 2) continue;
            if (!j) {
              (0, o.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
              continue;
            }
            const U = new R(new n.Stream(S.slice()), j);
            U._hexStringWarn = () => {
            };
            let K = 0;
            for (; ; ) {
              const X = U.getObj();
              if (X === g.EOF) {
                T = 0;
                break;
              }
              if (X instanceof g.Cmd) {
                const L = j[X.cmd];
                if (!L) {
                  T = 0;
                  break;
                }
                if (L.variableArgs ? K <= L.numArgs : K === L.numArgs) break;
                K = 0;
              } else K++;
            }
            if (T === 2) break;
          } else T = 0;
          B === -1 && ((0, o.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker"), C && ((0, o.warn)('... trying to recover by using the last "EI" occurrence.'), z.skip(-(z.pos - C))));
          let F = 4;
          return z.skip(-F), B = z.peekByte(), z.skip(F), (0, p.isWhiteSpace)(B) || F--, z.pos - F - $;
        }
        findDCTDecodeInlineStreamEnd(z) {
          const j = z.pos;
          let $, B, C = !1;
          for (; ($ = z.getByte()) !== -1; ) if ($ === 255) {
            switch (z.getByte()) {
              case 0:
                break;
              case 255:
                z.skip(-1);
                break;
              case 217:
                C = !0;
                break;
              case 192:
              case 193:
              case 194:
              case 195:
              case 197:
              case 198:
              case 199:
              case 201:
              case 202:
              case 203:
              case 205:
              case 206:
              case 207:
              case 196:
              case 204:
              case 218:
              case 219:
              case 220:
              case 221:
              case 222:
              case 223:
              case 224:
              case 225:
              case 226:
              case 227:
              case 228:
              case 229:
              case 230:
              case 231:
              case 232:
              case 233:
              case 234:
              case 235:
              case 236:
              case 237:
              case 238:
              case 239:
              case 254:
                B = z.getUint16(), B > 2 ? z.skip(B - 2) : z.skip(-2);
            }
            if (C) break;
          }
          const T = z.pos - j;
          return $ === -1 ? ((0, o.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."), z.skip(-T), this.findDefaultInlineStreamEnd(z)) : (this.inlineStreamSkipEI(z), T);
        }
        findASCII85DecodeInlineStreamEnd(z) {
          const j = z.pos;
          let $;
          for (; ($ = z.getByte()) !== -1; ) if ($ === 126) {
            const C = z.pos;
            for ($ = z.peekByte(); (0, p.isWhiteSpace)($); )
              z.skip(), $ = z.peekByte();
            if ($ === 62) {
              z.skip();
              break;
            }
            if (z.pos > C) {
              const T = z.peekBytes(2);
              if (T[0] === 69 && T[1] === 73) break;
            }
          }
          const B = z.pos - j;
          return $ === -1 ? ((0, o.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."), z.skip(-B), this.findDefaultInlineStreamEnd(z)) : (this.inlineStreamSkipEI(z), B);
        }
        findASCIIHexDecodeInlineStreamEnd(z) {
          const j = z.pos;
          let $;
          for (; ($ = z.getByte()) !== -1 && $ !== 62; ) ;
          const B = z.pos - j;
          return $ === -1 ? ((0, o.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."), z.skip(-B), this.findDefaultInlineStreamEnd(z)) : (this.inlineStreamSkipEI(z), B);
        }
        inlineStreamSkipEI(z) {
          let j, $ = 0;
          for (; (j = z.getByte()) !== -1; ) if ($ === 0) $ = j === 69 ? 1 : 0;
          else if ($ === 1) $ = j === 73 ? 2 : 0;
          else if ($ === 2) break;
        }
        makeInlineImage(z) {
          const j = this.lexer, $ = j.stream, B = /* @__PURE__ */ Object.create(null);
          let C;
          for (; !(0, g.isCmd)(this.buf1, "ID") && this.buf1 !== g.EOF; ) {
            if (!(this.buf1 instanceof g.Name)) throw new o.FormatError("Dictionary key must be a name object");
            const L = this.buf1.name;
            if (this.shift(), this.buf1 === g.EOF) break;
            B[L] = this.getObj(z);
          }
          j.beginInlineImagePos !== -1 && (C = $.pos - j.beginInlineImagePos);
          const T = this.xref.fetchIfRef(B.F || B.Filter);
          let F;
          if (T instanceof g.Name) F = T.name;
          else if (Array.isArray(T)) {
            const L = this.xref.fetchIfRef(T[0]);
            L instanceof g.Name && (F = L.name);
          }
          const S = $.pos;
          let A, U;
          switch (F) {
            case "DCT":
            case "DCTDecode":
              A = this.findDCTDecodeInlineStreamEnd($);
              break;
            case "A85":
            case "ASCII85Decode":
              A = this.findASCII85DecodeInlineStreamEnd($);
              break;
            case "AHx":
            case "ASCIIHexDecode":
              A = this.findASCIIHexDecodeInlineStreamEnd($);
              break;
            default:
              A = this.findDefaultInlineStreamEnd($);
          }
          if (A < 1e3 && C > 0) {
            const L = $.pos;
            $.pos = j.beginInlineImagePos, U = function(N) {
              const V = [], Y = N.length;
              let Z = 0;
              for (; Z < Y - 1; ) V.push(N[Z++] << 8 | N[Z++]);
              return Z < Y && V.push(N[Z]), Y + "_" + String.fromCharCode.apply(null, V);
            }($.getBytes(C + A)), $.pos = L;
            const H = this.imageCache[U];
            if (H !== void 0)
              return this.buf2 = g.Cmd.get("EI"), this.shift(), H.reset(), H;
          }
          const K = new g.Dict(this.xref);
          for (const L in B) K.set(L, B[L]);
          let X = $.makeSubStream(S, A, K);
          return z && (X = z.createStream(X, A)), X = this.filter(X, K, A), X.dict = K, U !== void 0 && (X.cacheKey = "inline_img_" + ++this._imageId, this.imageCache[U] = X), this.buf2 = g.Cmd.get("EI"), this.shift(), X;
        }
        _findStreamLength(z, j) {
          const { stream: $ } = this.lexer;
          $.pos = z;
          const B = j.length;
          for (; $.pos < $.end; ) {
            const C = $.peekBytes(2048), T = C.length - B;
            if (T <= 0) break;
            let F = 0;
            for (; F < T; ) {
              let S = 0;
              for (; S < B && C[F + S] === j[S]; ) S++;
              if (S >= B)
                return $.pos += F, $.pos - z;
              F++;
            }
            $.pos += T;
          }
          return -1;
        }
        makeStream(z, j) {
          const $ = this.lexer;
          let B = $.stream;
          $.skipToNextLine();
          const C = B.pos - 1;
          let T = z.get("Length");
          if (Number.isInteger(T) || ((0, o.info)(`Bad length "${T && T.toString()}" in stream.`), T = 0), B.pos = C + T, $.nextChar(), this.tryShift() && (0, g.isCmd)(this.buf2, "endstream")) this.shift();
          else {
            const F = new Uint8Array([101, 110, 100, 115, 116, 114, 101, 97, 109]);
            let S = this._findStreamLength(C, F);
            if (S < 0) {
              for (let U = 1; U <= 1; U++) {
                const K = F.length - U, X = F.slice(0, K), L = this._findStreamLength(C, X);
                if (L >= 0) {
                  const H = B.peekBytes(K + 1)[K];
                  if (!(0, p.isWhiteSpace)(H)) break;
                  (0, o.info)(`Found "${(0, o.bytesToString)(X)}" when searching for endstream command.`), S = L;
                  break;
                }
              }
              if (S < 0) throw new o.FormatError("Missing endstream command.");
            }
            T = S, $.nextChar(), this.shift(), this.shift();
          }
          return this.shift(), B = B.makeSubStream(C, T, z), j && (B = j.createStream(B, T)), B = this.filter(B, z, T), B.dict = z, B;
        }
        filter(z, j, $) {
          let B = j.get("F", "Filter"), C = j.get("DP", "DecodeParms");
          if (B instanceof g.Name)
            return Array.isArray(C) && (0, o.warn)("/DecodeParms should not be an Array, when /Filter is a Name."), this.makeFilter(z, B.name, $, C);
          let T = $;
          if (Array.isArray(B)) {
            const F = B, S = C;
            for (let A = 0, U = F.length; A < U; ++A) {
              if (B = this.xref.fetchIfRef(F[A]), !(B instanceof g.Name)) throw new o.FormatError(`Bad filter name "${B}"`);
              C = null, Array.isArray(S) && A in S && (C = this.xref.fetchIfRef(S[A])), z = this.makeFilter(z, B.name, T, C), T = null;
            }
          }
          return z;
        }
        makeFilter(z, j, $, B) {
          if ($ === 0)
            return (0, o.warn)(`Empty "${j}" stream.`), new n.NullStream();
          try {
            switch (j) {
              case "Fl":
              case "FlateDecode":
                return B ? new _.PredictorStream(new b.FlateStream(z, $), $, B) : new b.FlateStream(z, $);
              case "LZW":
              case "LZWDecode":
                let C = 1;
                return B ? (B.has("EarlyChange") && (C = B.get("EarlyChange")), new _.PredictorStream(new x.LZWStream(z, $, C), $, B)) : new x.LZWStream(z, $, C);
              case "DCT":
              case "DCTDecode":
                return new v.JpegStream(z, $, B);
              case "JPX":
              case "JPXDecode":
                return new h.JpxStream(z, $, B);
              case "A85":
              case "ASCII85Decode":
                return new a.Ascii85Stream(z, $);
              case "AHx":
              case "ASCIIHexDecode":
                return new d.AsciiHexStream(z, $);
              case "CCF":
              case "CCITTFaxDecode":
                return new m.CCITTFaxStream(z, $, B);
              case "RL":
              case "RunLengthDecode":
                return new M.RunLengthStream(z, $);
              case "JBIG2Decode":
                return new w.Jbig2Stream(z, $, B);
            }
            return (0, o.warn)(`Filter "${j}" is not supported.`), z;
          } catch (C) {
            if (C instanceof p.MissingDataException) throw C;
            return (0, o.warn)(`Invalid stream: "${C}"`), new n.NullStream();
          }
        }
      }
      l.Parser = O;
      const E = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      function I(W) {
        return W >= 48 && W <= 57 ? 15 & W : W >= 65 && W <= 70 || W >= 97 && W <= 102 ? 9 + (15 & W) : -1;
      }
      class R {
        constructor(z, j = null) {
          this.stream = z, this.nextChar(), this.strBuf = [], this.knownCommands = j, this._hexStringNumWarn = 0, this.beginInlineImagePos = -1;
        }
        nextChar() {
          return this.currentChar = this.stream.getByte();
        }
        peekChar() {
          return this.stream.peekByte();
        }
        getNumber() {
          let z = this.currentChar, j = !1, $ = 0, B = 1;
          if (z === 45 ? (B = -1, z = this.nextChar(), z === 45 && (z = this.nextChar())) : z === 43 && (z = this.nextChar()), z === 10 || z === 13) do
            z = this.nextChar();
          while (z === 10 || z === 13);
          if (z === 46 && ($ = 10, z = this.nextChar()), z < 48 || z > 57) {
            const S = `Invalid number: ${String.fromCharCode(z)} (charCode ${z})`;
            if ((0, p.isWhiteSpace)(z) || z === -1)
              return (0, o.info)(`Lexer.getNumber - "${S}".`), 0;
            throw new o.FormatError(S);
          }
          let C = z - 48, T = 0, F = 1;
          for (; (z = this.nextChar()) >= 0; ) if (z >= 48 && z <= 57) {
            const S = z - 48;
            j ? T = 10 * T + S : ($ !== 0 && ($ *= 10), C = 10 * C + S);
          } else if (z === 46) {
            if ($ !== 0) break;
            $ = 1;
          } else if (z === 45) (0, o.warn)("Badly formatted number: minus sign in the middle");
          else {
            if (z !== 69 && z !== 101) break;
            if (z = this.peekChar(), z === 43 || z === 45)
              F = z === 45 ? -1 : 1, this.nextChar();
            else if (z < 48 || z > 57) break;
            j = !0;
          }
          return $ !== 0 && (C /= $), j && (C *= 10 ** (F * T)), B * C;
        }
        getString() {
          let z = 1, j = !1;
          const $ = this.strBuf;
          $.length = 0;
          let B = this.nextChar();
          for (; ; ) {
            let C = !1;
            switch (0 | B) {
              case -1:
                (0, o.warn)("Unterminated string"), j = !0;
                break;
              case 40:
                ++z, $.push("(");
                break;
              case 41:
                --z == 0 ? (this.nextChar(), j = !0) : $.push(")");
                break;
              case 92:
                switch (B = this.nextChar(), B) {
                  case -1:
                    (0, o.warn)("Unterminated string"), j = !0;
                    break;
                  case 110:
                    $.push(`
`);
                    break;
                  case 114:
                    $.push("\r");
                    break;
                  case 116:
                    $.push("	");
                    break;
                  case 98:
                    $.push("\b");
                    break;
                  case 102:
                    $.push("\f");
                    break;
                  case 92:
                  case 40:
                  case 41:
                    $.push(String.fromCharCode(B));
                    break;
                  case 48:
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                    let T = 15 & B;
                    B = this.nextChar(), C = !0, B >= 48 && B <= 55 && (T = (T << 3) + (15 & B), B = this.nextChar(), B >= 48 && B <= 55 && (C = !1, T = (T << 3) + (15 & B))), $.push(String.fromCharCode(T));
                    break;
                  case 13:
                    this.peekChar() === 10 && this.nextChar();
                    break;
                  case 10:
                    break;
                  default:
                    $.push(String.fromCharCode(B));
                }
                break;
              default:
                $.push(String.fromCharCode(B));
            }
            if (j) break;
            C || (B = this.nextChar());
          }
          return $.join("");
        }
        getName() {
          let z, j;
          const $ = this.strBuf;
          for ($.length = 0; (z = this.nextChar()) >= 0 && !E[z]; ) if (z === 35) {
            if (z = this.nextChar(), E[z]) {
              (0, o.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number."), $.push("#");
              break;
            }
            const B = I(z);
            if (B !== -1) {
              j = z, z = this.nextChar();
              const C = I(z);
              if (C === -1) {
                if ((0, o.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(z)}) in hexadecimal number.`), $.push("#", String.fromCharCode(j)), E[z]) break;
                $.push(String.fromCharCode(z));
                continue;
              }
              $.push(String.fromCharCode(B << 4 | C));
            } else $.push("#", String.fromCharCode(z));
          } else $.push(String.fromCharCode(z));
          return $.length > 127 && (0, o.warn)(`Name token is longer than allowed by the spec: ${$.length}`), g.Name.get($.join(""));
        }
        _hexStringWarn(z) {
          this._hexStringNumWarn++ != 5 ? this._hexStringNumWarn > 5 || (0, o.warn)(`getHexString - ignoring invalid character: ${z}`) : (0, o.warn)("getHexString - ignoring additional invalid characters.");
        }
        getHexString() {
          const z = this.strBuf;
          z.length = 0;
          let j, $, B = this.currentChar, C = !0;
          for (this._hexStringNumWarn = 0; ; ) {
            if (B < 0) {
              (0, o.warn)("Unterminated hex string");
              break;
            }
            if (B === 62) {
              this.nextChar();
              break;
            }
            if (E[B] !== 1) {
              if (C) {
                if (j = I(B), j === -1) {
                  this._hexStringWarn(B), B = this.nextChar();
                  continue;
                }
              } else {
                if ($ = I(B), $ === -1) {
                  this._hexStringWarn(B), B = this.nextChar();
                  continue;
                }
                z.push(String.fromCharCode(j << 4 | $));
              }
              C = !C, B = this.nextChar();
            } else B = this.nextChar();
          }
          return z.join("");
        }
        getObj() {
          let z = !1, j = this.currentChar;
          for (; ; ) {
            if (j < 0) return g.EOF;
            if (z) j !== 10 && j !== 13 || (z = !1);
            else if (j === 37) z = !0;
            else if (E[j] !== 1) break;
            j = this.nextChar();
          }
          switch (0 | j) {
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 43:
            case 45:
            case 46:
              return this.getNumber();
            case 40:
              return this.getString();
            case 47:
              return this.getName();
            case 91:
              return this.nextChar(), g.Cmd.get("[");
            case 93:
              return this.nextChar(), g.Cmd.get("]");
            case 60:
              return j = this.nextChar(), j === 60 ? (this.nextChar(), g.Cmd.get("<<")) : this.getHexString();
            case 62:
              return j = this.nextChar(), j === 62 ? (this.nextChar(), g.Cmd.get(">>")) : g.Cmd.get(">");
            case 123:
              return this.nextChar(), g.Cmd.get("{");
            case 125:
              return this.nextChar(), g.Cmd.get("}");
            case 41:
              throw this.nextChar(), new o.FormatError(`Illegal character: ${j}`);
          }
          let $ = String.fromCharCode(j);
          if (j < 32 || j > 127) {
            const T = this.peekChar();
            if (T >= 32 && T <= 127)
              return this.nextChar(), g.Cmd.get($);
          }
          const B = this.knownCommands;
          let C = (B == null ? void 0 : B[$]) !== void 0;
          for (; (j = this.nextChar()) >= 0 && !E[j]; ) {
            const T = $ + String.fromCharCode(j);
            if (C && B[T] === void 0) break;
            if ($.length === 128) throw new o.FormatError(`Command token too long: ${$.length}`);
            $ = T, C = (B == null ? void 0 : B[$]) !== void 0;
          }
          return $ === "true" ? !0 : $ === "false" ? !1 : $ === "null" ? null : ($ === "BI" && (this.beginInlineImagePos = this.stream.pos), g.Cmd.get($));
        }
        skipToNextLine() {
          let z = this.currentChar;
          for (; z >= 0; ) {
            if (z === 13) {
              z = this.nextChar(), z === 10 && this.nextChar();
              break;
            }
            if (z === 10) {
              this.nextChar();
              break;
            }
            z = this.nextChar();
          }
        }
      }
      l.Lexer = R, l.Linearization = class {
        static create(z) {
          function j(U, K, X = !1) {
            const L = U.get(K);
            if (Number.isInteger(L) && (X ? L >= 0 : L > 0)) return L;
            throw new Error(`The "${K}" parameter in the linearization dictionary is invalid.`);
          }
          const $ = new O({ lexer: new R(z), xref: null }), B = $.getObj(), C = $.getObj(), T = $.getObj(), F = $.getObj();
          let S, A;
          if (!(Number.isInteger(B) && Number.isInteger(C) && (0, g.isCmd)(T, "obj") && F instanceof g.Dict && typeof (S = F.get("Linearized")) == "number" && S > 0)) return null;
          if ((A = j(F, "L")) !== z.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
          return { length: A, hints: function(K) {
            const X = K.get("H");
            let L;
            if (Array.isArray(X) && ((L = X.length) === 2 || L === 4)) {
              for (let H = 0; H < L; H++) {
                const Q = X[H];
                if (!(Number.isInteger(Q) && Q > 0)) throw new Error(`Hint (${H}) in the linearization dictionary is invalid.`);
              }
              return X;
            }
            throw new Error("Hint array in the linearization dictionary is invalid.");
          }(F), objectNumberFirst: j(F, "O"), endFirst: j(F, "E"), numPages: j(F, "N"), mainXRefEntriesOffset: j(F, "T"), pageFirst: F.has("P") ? j(F, "P", !0) : 0 };
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Ascii85Stream = void 0;
      var o = f(18), g = f(3);
      class p extends o.DecodeStream {
        constructor(a, d) {
          d && (d *= 0.8), super(d), this.str = a, this.dict = a.dict, this.input = new Uint8Array(5);
        }
        readBlock() {
          const a = this.str;
          let d = a.getByte();
          for (; (0, g.isWhiteSpace)(d); ) d = a.getByte();
          if (d === -1 || d === 126) {
            this.eof = !0;
            return;
          }
          const m = this.bufferLength;
          let b, w;
          if (d === 122) {
            for (b = this.ensureBuffer(m + 4), w = 0; w < 4; ++w) b[m + w] = 0;
            this.bufferLength += 4;
          } else {
            const v = this.input;
            for (v[0] = d, w = 1; w < 5; ++w) {
              for (d = a.getByte(); (0, g.isWhiteSpace)(d); ) d = a.getByte();
              if (v[w] = d, d === -1 || d === 126) break;
            }
            if (b = this.ensureBuffer(m + w - 1), this.bufferLength += w - 1, w < 5) {
              for (; w < 5; ++w) v[w] = 117;
              this.eof = !0;
            }
            let h = 0;
            for (w = 0; w < 5; ++w) h = 85 * h + (v[w] - 33);
            for (w = 3; w >= 0; --w)
              b[m + w] = 255 & h, h >>= 8;
          }
        }
      }
      l.Ascii85Stream = p;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.StreamsSequenceStream = l.DecodeStream = void 0;
      var o = f(5), g = f(8);
      const p = new Uint8Array(0);
      class n extends o.BaseStream {
        constructor(d) {
          if (super(), this._rawMinBufferLength = d || 0, this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = p, this.minBufferLength = 512, d) for (; this.minBufferLength < d; ) this.minBufferLength *= 2;
        }
        get isEmpty() {
          for (; !this.eof && this.bufferLength === 0; ) this.readBlock();
          return this.bufferLength === 0;
        }
        ensureBuffer(d) {
          const m = this.buffer;
          if (d <= m.byteLength) return m;
          let b = this.minBufferLength;
          for (; b < d; ) b *= 2;
          const w = new Uint8Array(b);
          return w.set(m), this.buffer = w;
        }
        getByte() {
          const d = this.pos;
          for (; this.bufferLength <= d; ) {
            if (this.eof) return -1;
            this.readBlock();
          }
          return this.buffer[this.pos++];
        }
        getBytes(d) {
          const m = this.pos;
          let b;
          if (d) {
            for (this.ensureBuffer(m + d), b = m + d; !this.eof && this.bufferLength < b; ) this.readBlock();
            const w = this.bufferLength;
            b > w && (b = w);
          } else {
            for (; !this.eof; ) this.readBlock();
            b = this.bufferLength;
          }
          return this.pos = b, this.buffer.subarray(m, b);
        }
        reset() {
          this.pos = 0;
        }
        makeSubStream(d, m, b = null) {
          if (m === void 0) for (; !this.eof; ) this.readBlock();
          else {
            const w = d + m;
            for (; this.bufferLength <= w && !this.eof; ) this.readBlock();
          }
          return new g.Stream(this.buffer, d, m, b);
        }
        getBaseStreams() {
          return this.str ? this.str.getBaseStreams() : null;
        }
      }
      l.DecodeStream = n, l.StreamsSequenceStream = class extends n {
        constructor(d, m = null) {
          let b = 0;
          for (const w of d) b += w instanceof n ? w._rawMinBufferLength : w.length;
          super(b), this.streams = d, this._onError = m;
        }
        readBlock() {
          var h;
          const d = this.streams;
          if (d.length === 0) {
            this.eof = !0;
            return;
          }
          const m = d.shift();
          let b;
          try {
            b = m.getBytes();
          } catch (x) {
            if (this._onError) {
              this._onError(x, (h = m.dict) == null ? void 0 : h.objId);
              return;
            }
            throw x;
          }
          const w = this.bufferLength, v = w + b.length;
          this.ensureBuffer(v).set(b, w), this.bufferLength = v;
        }
        getBaseStreams() {
          const d = [];
          for (const m of this.streams) {
            const b = m.getBaseStreams();
            b && d.push(...b);
          }
          return d.length > 0 ? d : null;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.AsciiHexStream = void 0;
      var o = f(18);
      class g extends o.DecodeStream {
        constructor(n, a) {
          a && (a *= 0.5), super(a), this.str = n, this.dict = n.dict, this.firstDigit = -1;
        }
        readBlock() {
          const n = this.str.getBytes(8e3);
          if (!n.length) {
            this.eof = !0;
            return;
          }
          const a = n.length + 1 >> 1, d = this.ensureBuffer(this.bufferLength + a);
          let m = this.bufferLength, b = this.firstDigit;
          for (const w of n) {
            let v;
            if (w >= 48 && w <= 57) v = 15 & w;
            else {
              if (!(w >= 65 && w <= 70 || w >= 97 && w <= 102)) {
                if (w === 62) {
                  this.eof = !0;
                  break;
                }
                continue;
              }
              v = 9 + (15 & w);
            }
            b < 0 ? b = v : (d[m++] = b << 4 | v, b = -1);
          }
          b >= 0 && this.eof && (d[m++] = b << 4, b = -1), this.firstDigit = b, this.bufferLength = m;
        }
      }
      l.AsciiHexStream = g;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CCITTFaxStream = void 0;
      var o = f(21), g = f(18), p = f(4);
      class n extends g.DecodeStream {
        constructor(d, m, b) {
          super(m), this.str = d, this.dict = d.dict, b instanceof p.Dict || (b = p.Dict.empty);
          const w = { next: () => d.getByte() };
          this.ccittFaxDecoder = new o.CCITTFaxDecoder(w, { K: b.get("K"), EndOfLine: b.get("EndOfLine"), EncodedByteAlign: b.get("EncodedByteAlign"), Columns: b.get("Columns"), Rows: b.get("Rows"), EndOfBlock: b.get("EndOfBlock"), BlackIs1: b.get("BlackIs1") });
        }
        readBlock() {
          for (; !this.eof; ) {
            const d = this.ccittFaxDecoder.readNextChar();
            if (d === -1) {
              this.eof = !0;
              return;
            }
            this.ensureBuffer(this.bufferLength + 1), this.buffer[this.bufferLength++] = d;
          }
        }
      }
      l.CCITTFaxStream = n;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CCITTFaxDecoder = void 0;
      var o = f(2);
      const g = -1, p = [[-1, -1], [-1, -1], [7, 8], [7, 7], [6, 6], [6, 6], [6, 5], [6, 5], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2]], n = [[-1, -1], [12, -2], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]], a = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]], d = [[-1, -1], [-1, -1], [12, -2], [12, -2], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]], m = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]], b = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
      l.CCITTFaxDecoder = class {
        constructor(v, h = {}) {
          if (!v || typeof v.next != "function") throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
          this.source = v, this.eof = !1, this.encoding = h.K || 0, this.eoline = h.EndOfLine || !1, this.byteAlign = h.EncodedByteAlign || !1, this.columns = h.Columns || 1728, this.rows = h.Rows || 0, this.eoblock = h.EndOfBlock ?? !0, this.black = h.BlackIs1 || !1, this.codingLine = new Uint32Array(this.columns + 1), this.refLine = new Uint32Array(this.columns + 2), this.codingLine[0] = this.columns, this.codingPos = 0, this.row = 0, this.nextLine2D = this.encoding < 0, this.inputBits = 0, this.inputBuf = 0, this.outputBits = 0, this.rowsDone = !1;
          let x;
          for (; (x = this._lookBits(12)) === 0; ) this._eatBits(1);
          x === 1 && this._eatBits(12), this.encoding > 0 && (this.nextLine2D = !this._lookBits(1), this._eatBits(1));
        }
        readNextChar() {
          if (this.eof) return -1;
          const v = this.refLine, h = this.codingLine, x = this.columns;
          let _, M, O, E, I;
          if (this.outputBits === 0) {
            if (this.rowsDone && (this.eof = !0), this.eof) return -1;
            this.err = !1;
            let R, W, z;
            if (this.nextLine2D) {
              for (E = 0; h[E] < x; ++E) v[E] = h[E];
              for (v[E++] = x, v[E] = x, h[0] = 0, this.codingPos = 0, _ = 0, M = 0; h[this.codingPos] < x; )
                switch (R = this._getTwoDimCode(), R) {
                  case 0:
                    this._addPixels(v[_ + 1], M), v[_ + 1] < x && (_ += 2);
                    break;
                  case 1:
                    if (R = W = 0, M) {
                      do
                        R += z = this._getBlackCode();
                      while (z >= 64);
                      do
                        W += z = this._getWhiteCode();
                      while (z >= 64);
                    } else {
                      do
                        R += z = this._getWhiteCode();
                      while (z >= 64);
                      do
                        W += z = this._getBlackCode();
                      while (z >= 64);
                    }
                    for (this._addPixels(h[this.codingPos] + R, M), h[this.codingPos] < x && this._addPixels(h[this.codingPos] + W, 1 ^ M); v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 7:
                    if (this._addPixels(v[_] + 3, M), M ^= 1, h[this.codingPos] < x)
                      for (++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 5:
                    if (this._addPixels(v[_] + 2, M), M ^= 1, h[this.codingPos] < x)
                      for (++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 3:
                    if (this._addPixels(v[_] + 1, M), M ^= 1, h[this.codingPos] < x)
                      for (++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 2:
                    if (this._addPixels(v[_], M), M ^= 1, h[this.codingPos] < x)
                      for (++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 8:
                    if (this._addPixelsNeg(v[_] - 3, M), M ^= 1, h[this.codingPos] < x)
                      for (_ > 0 ? --_ : ++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 6:
                    if (this._addPixelsNeg(v[_] - 2, M), M ^= 1, h[this.codingPos] < x)
                      for (_ > 0 ? --_ : ++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case 4:
                    if (this._addPixelsNeg(v[_] - 1, M), M ^= 1, h[this.codingPos] < x)
                      for (_ > 0 ? --_ : ++_; v[_] <= h[this.codingPos] && v[_] < x; ) _ += 2;
                    break;
                  case g:
                    this._addPixels(x, 0), this.eof = !0;
                    break;
                  default:
                    (0, o.info)("bad 2d code"), this._addPixels(x, 0), this.err = !0;
                }
            } else
              for (h[0] = 0, this.codingPos = 0, M = 0; h[this.codingPos] < x; ) {
                if (R = 0, M) do
                  R += z = this._getBlackCode();
                while (z >= 64);
                else do
                  R += z = this._getWhiteCode();
                while (z >= 64);
                this._addPixels(h[this.codingPos] + R, M), M ^= 1;
              }
            let j = !1;
            if (this.byteAlign && (this.inputBits &= -8), this.eoblock || this.row !== this.rows - 1) {
              if (R = this._lookBits(12), this.eoline) for (; R !== g && R !== 1; )
                this._eatBits(1), R = this._lookBits(12);
              else for (; R === 0; )
                this._eatBits(1), R = this._lookBits(12);
              R === 1 ? (this._eatBits(12), j = !0) : R === g && (this.eof = !0);
            } else this.rowsDone = !0;
            if (!this.eof && this.encoding > 0 && !this.rowsDone && (this.nextLine2D = !this._lookBits(1), this._eatBits(1)), this.eoblock && j && this.byteAlign) {
              if (R = this._lookBits(12), R === 1) {
                if (this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1)), this.encoding >= 0) for (E = 0; E < 4; ++E)
                  R = this._lookBits(12), R !== 1 && (0, o.info)("bad rtc code: " + R), this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1));
                this.eof = !0;
              }
            } else if (this.err && this.eoline) {
              for (; ; ) {
                if (R = this._lookBits(13), R === g)
                  return this.eof = !0, -1;
                if (R >> 1 == 1) break;
                this._eatBits(1);
              }
              this._eatBits(12), this.encoding > 0 && (this._eatBits(1), this.nextLine2D = !(1 & R));
            }
            this.outputBits = h[0] > 0 ? h[this.codingPos = 0] : h[this.codingPos = 1], this.row++;
          }
          if (this.outputBits >= 8)
            I = 1 & this.codingPos ? 0 : 255, this.outputBits -= 8, this.outputBits === 0 && h[this.codingPos] < x && (this.codingPos++, this.outputBits = h[this.codingPos] - h[this.codingPos - 1]);
          else {
            O = 8, I = 0;
            do {
              if (typeof this.outputBits != "number") throw new o.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
              this.outputBits > O ? (I <<= O, 1 & this.codingPos || (I |= 255 >> 8 - O), this.outputBits -= O, O = 0) : (I <<= this.outputBits, 1 & this.codingPos || (I |= 255 >> 8 - this.outputBits), O -= this.outputBits, this.outputBits = 0, h[this.codingPos] < x ? (this.codingPos++, this.outputBits = h[this.codingPos] - h[this.codingPos - 1]) : O > 0 && (I <<= O, O = 0));
            } while (O);
          }
          return this.black && (I ^= 255), I;
        }
        _addPixels(v, h) {
          const x = this.codingLine;
          let _ = this.codingPos;
          v > x[_] && (v > this.columns && ((0, o.info)("row is wrong length"), this.err = !0, v = this.columns), 1 & _ ^ h && ++_, x[_] = v), this.codingPos = _;
        }
        _addPixelsNeg(v, h) {
          const x = this.codingLine;
          let _ = this.codingPos;
          if (v > x[_])
            v > this.columns && ((0, o.info)("row is wrong length"), this.err = !0, v = this.columns), 1 & _ ^ h && ++_, x[_] = v;
          else if (v < x[_]) {
            for (v < 0 && ((0, o.info)("invalid code"), this.err = !0, v = 0); _ > 0 && v < x[_ - 1]; ) --_;
            x[_] = v;
          }
          this.codingPos = _;
        }
        _findTableCode(v, h, x, _) {
          const M = _ || 0;
          for (let O = v; O <= h; ++O) {
            let E = this._lookBits(O);
            if (E === g) return [!0, 1, !1];
            if (O < h && (E <<= h - O), !M || E >= M) {
              const I = x[E - M];
              if (I[0] === O)
                return this._eatBits(O), [!0, I[1], !0];
            }
          }
          return [!1, 0, !1];
        }
        _getTwoDimCode() {
          let v, h = 0;
          if (this.eoblock) {
            if (h = this._lookBits(7), v = p[h], (v == null ? void 0 : v[0]) > 0)
              return this._eatBits(v[0]), v[1];
          } else {
            const x = this._findTableCode(1, 7, p);
            if (x[0] && x[2]) return x[1];
          }
          return (0, o.info)("Bad two dim code"), g;
        }
        _getWhiteCode() {
          let v, h = 0;
          if (this.eoblock) {
            if (h = this._lookBits(12), h === g) return 1;
            if (v = h >> 5 ? a[h >> 3] : n[h], v[0] > 0)
              return this._eatBits(v[0]), v[1];
          } else {
            let x = this._findTableCode(1, 9, a);
            if (x[0] || (x = this._findTableCode(11, 12, n), x[0])) return x[1];
          }
          return (0, o.info)("bad white code"), this._eatBits(1), 1;
        }
        _getBlackCode() {
          let v, h;
          if (this.eoblock) {
            if (v = this._lookBits(13), v === g) return 1;
            if (h = v >> 7 ? !(v >> 9) && v >> 7 ? m[(v >> 1) - 64] : b[v >> 7] : d[v], h[0] > 0)
              return this._eatBits(h[0]), h[1];
          } else {
            let x = this._findTableCode(2, 6, b);
            if (x[0] || (x = this._findTableCode(7, 12, m, 64), x[0]) || (x = this._findTableCode(10, 13, d), x[0])) return x[1];
          }
          return (0, o.info)("bad black code"), this._eatBits(1), 1;
        }
        _lookBits(v) {
          let h;
          for (; this.inputBits < v; ) {
            if ((h = this.source.next()) === -1) return this.inputBits === 0 ? g : this.inputBuf << v - this.inputBits & 65535 >> 16 - v;
            this.inputBuf = this.inputBuf << 8 | h, this.inputBits += 8;
          }
          return this.inputBuf >> this.inputBits - v & 65535 >> 16 - v;
        }
        _eatBits(v) {
          (this.inputBits -= v) < 0 && (this.inputBits = 0);
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.FlateStream = void 0;
      var o = f(18), g = f(2);
      const p = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), n = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]), a = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]), d = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9], m = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
      class b extends o.DecodeStream {
        constructor(v, h) {
          super(h), this.str = v, this.dict = v.dict;
          const x = v.getByte(), _ = v.getByte();
          if (x === -1 || _ === -1) throw new g.FormatError(`Invalid header in flate stream: ${x}, ${_}`);
          if ((15 & x) != 8) throw new g.FormatError(`Unknown compression method in flate stream: ${x}, ${_}`);
          if (((x << 8) + _) % 31 != 0) throw new g.FormatError(`Bad FCHECK in flate stream: ${x}, ${_}`);
          if (32 & _) throw new g.FormatError(`FDICT bit set in flate stream: ${x}, ${_}`);
          this.codeSize = 0, this.codeBuf = 0;
        }
        getBits(v) {
          const h = this.str;
          let x, _ = this.codeSize, M = this.codeBuf;
          for (; _ < v; ) {
            if ((x = h.getByte()) === -1) throw new g.FormatError("Bad encoding in flate stream");
            M |= x << _, _ += 8;
          }
          return x = M & (1 << v) - 1, this.codeBuf = M >> v, this.codeSize = _ -= v, x;
        }
        getCode(v) {
          const h = this.str, x = v[0], _ = v[1];
          let M, O = this.codeSize, E = this.codeBuf;
          for (; O < _ && (M = h.getByte()) !== -1; )
            E |= M << O, O += 8;
          const I = x[E & (1 << _) - 1], R = I >> 16, W = 65535 & I;
          if (R < 1 || O < R) throw new g.FormatError("Bad encoding in flate stream");
          return this.codeBuf = E >> R, this.codeSize = O - R, W;
        }
        generateHuffmanTable(v) {
          const h = v.length;
          let x, _ = 0;
          for (x = 0; x < h; ++x) v[x] > _ && (_ = v[x]);
          const M = 1 << _, O = new Int32Array(M);
          for (let E = 1, I = 0, R = 2; E <= _; ++E, I <<= 1, R <<= 1) for (let W = 0; W < h; ++W) if (v[W] === E) {
            let z = 0, j = I;
            for (x = 0; x < E; ++x)
              z = z << 1 | 1 & j, j >>= 1;
            for (x = z; x < M; x += R) O[x] = E << 16 | W;
            ++I;
          }
          return [O, _];
        }
        readBlock() {
          let v, h;
          const x = this.str;
          let _, M, O = this.getBits(3);
          if (1 & O && (this.eof = !0), O >>= 1, O === 0) {
            let R;
            if ((R = x.getByte()) === -1) throw new g.FormatError("Bad block header in flate stream");
            let W = R;
            if ((R = x.getByte()) === -1) throw new g.FormatError("Bad block header in flate stream");
            if (W |= R << 8, (R = x.getByte()) === -1) throw new g.FormatError("Bad block header in flate stream");
            let z = R;
            if ((R = x.getByte()) === -1) throw new g.FormatError("Bad block header in flate stream");
            if (z |= R << 8, z !== (65535 & ~W) && (W !== 0 || z !== 0)) throw new g.FormatError("Bad uncompressed block length in flate stream");
            this.codeBuf = 0, this.codeSize = 0;
            const j = this.bufferLength, $ = j + W;
            if (v = this.ensureBuffer($), this.bufferLength = $, W === 0) x.peekByte() === -1 && (this.eof = !0);
            else {
              const B = x.getBytes(W);
              v.set(B, j), B.length < W && (this.eof = !0);
            }
            return;
          }
          if (O === 1)
            _ = d, M = m;
          else {
            if (O !== 2) throw new g.FormatError("Unknown block type in flate stream");
            {
              const R = this.getBits(5) + 257, W = this.getBits(5) + 1, z = this.getBits(4) + 4, j = new Uint8Array(p.length);
              let $;
              for ($ = 0; $ < z; ++$) j[p[$]] = this.getBits(3);
              const B = this.generateHuffmanTable(j);
              h = 0, $ = 0;
              const C = R + W, T = new Uint8Array(C);
              let F, S, A;
              for (; $ < C; ) {
                const U = this.getCode(B);
                if (U === 16)
                  F = 2, S = 3, A = h;
                else if (U === 17)
                  F = 3, S = 3, A = h = 0;
                else {
                  if (U !== 18) {
                    T[$++] = h = U;
                    continue;
                  }
                  F = 7, S = 11, A = h = 0;
                }
                let K = this.getBits(F) + S;
                for (; K-- > 0; ) T[$++] = A;
              }
              _ = this.generateHuffmanTable(T.subarray(0, R)), M = this.generateHuffmanTable(T.subarray(R, C));
            }
          }
          v = this.buffer;
          let E = v ? v.length : 0, I = this.bufferLength;
          for (; ; ) {
            let R = this.getCode(_);
            if (R < 256) {
              I + 1 >= E && (v = this.ensureBuffer(I + 1), E = v.length), v[I++] = R;
              continue;
            }
            if (R === 256) {
              this.bufferLength = I;
              return;
            }
            R -= 257, R = n[R];
            let W = R >> 16;
            W > 0 && (W = this.getBits(W)), h = (65535 & R) + W, R = this.getCode(M), R = a[R], W = R >> 16, W > 0 && (W = this.getBits(W));
            const z = (65535 & R) + W;
            I + h >= E && (v = this.ensureBuffer(I + h), E = v.length);
            for (let j = 0; j < h; ++j, ++I) v[I] = v[I - z];
          }
        }
      }
      l.FlateStream = b;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Jbig2Stream = void 0;
      var o = f(5), g = f(18), p = f(4), n = f(24), a = f(2);
      class d extends g.DecodeStream {
        constructor(b, w, v) {
          super(w), this.stream = b, this.dict = b.dict, this.maybeLength = w, this.params = v;
        }
        get bytes() {
          return (0, a.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
        }
        ensureBuffer(b) {
        }
        readBlock() {
          if (this.eof) return;
          const b = new n.Jbig2Image(), w = [];
          if (this.params instanceof p.Dict) {
            const x = this.params.get("JBIG2Globals");
            if (x instanceof o.BaseStream) {
              const _ = x.getBytes();
              w.push({ data: _, start: 0, end: _.length });
            }
          }
          w.push({ data: this.bytes, start: 0, end: this.bytes.length });
          const v = b.parseChunks(w), h = v.length;
          for (let x = 0; x < h; x++) v[x] ^= 255;
          this.buffer = v, this.bufferLength = h, this.eof = !0;
        }
      }
      l.Jbig2Stream = d;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Jbig2Image = void 0;
      var o = f(2), g = f(3), p = f(25), n = f(21);
      class a extends o.BaseException {
        constructor(V) {
          super(`JBIG2 error: ${V}`, "Jbig2Error");
        }
      }
      class d {
        getContexts(V) {
          return V in this ? this[V] : this[V] = new Int8Array(65536);
        }
      }
      class m {
        constructor(V, Y, Z) {
          this.data = V, this.start = Y, this.end = Z;
        }
        get decoder() {
          const V = new p.ArithmeticDecoder(this.data, this.start, this.end);
          return (0, o.shadow)(this, "decoder", V);
        }
        get contextCache() {
          const V = new d();
          return (0, o.shadow)(this, "contextCache", V);
        }
      }
      const b = 2 ** 31 - 1, w = -2147483648;
      function v(N, V, Y) {
        const Z = N.getContexts(V);
        let rt = 1;
        function st(nt) {
          let q = 0;
          for (let D = 0; D < nt; D++) {
            const G = Y.readBit(Z, rt);
            rt = rt < 256 ? rt << 1 | G : 511 & (rt << 1 | G) | 256, q = q << 1 | G;
          }
          return q >>> 0;
        }
        const mt = st(1), yt = st(1) ? st(1) ? st(1) ? st(1) ? st(1) ? st(32) + 4436 : st(12) + 340 : st(8) + 84 : st(6) + 20 : st(4) + 4 : st(2);
        let at;
        return mt === 0 ? at = yt : yt > 0 && (at = -yt), at >= w && at <= b ? at : null;
      }
      function h(N, V, Y) {
        const Z = N.getContexts("IAID");
        let rt = 1;
        for (let st = 0; st < Y; st++)
          rt = rt << 1 | V.readBit(Z, rt);
        return Y < 31 ? rt & (1 << Y) - 1 : 2147483647 & rt;
      }
      const x = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"], _ = [[{ x: -1, y: -2 }, { x: 0, y: -2 }, { x: 1, y: -2 }, { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 2, y: -1 }, { x: -4, y: 0 }, { x: -3, y: 0 }, { x: -2, y: 0 }, { x: -1, y: 0 }], [{ x: -1, y: -2 }, { x: 0, y: -2 }, { x: 1, y: -2 }, { x: 2, y: -2 }, { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 2, y: -1 }, { x: -3, y: 0 }, { x: -2, y: 0 }, { x: -1, y: 0 }], [{ x: -1, y: -2 }, { x: 0, y: -2 }, { x: 1, y: -2 }, { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: -2, y: 0 }, { x: -1, y: 0 }], [{ x: -3, y: -1 }, { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: -4, y: 0 }, { x: -3, y: 0 }, { x: -2, y: 0 }, { x: -1, y: 0 }]], M = [{ coding: [{ x: 0, y: -1 }, { x: 1, y: -1 }, { x: -1, y: 0 }], reference: [{ x: 0, y: -1 }, { x: 1, y: -1 }, { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }] }, { coding: [{ x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: -1, y: 0 }], reference: [{ x: 0, y: -1 }, { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 1 }] }], O = [39717, 1941, 229, 405];
      function E(N, V, Y, Z, rt, st, mt, yt) {
        if (N)
          return Q(new X(yt.data, yt.start, yt.end), V, Y, !1);
        if (Z === 0 && !rt && mt.length === 4 && mt[0].x === 3 && mt[0].y === -1 && mt[1].x === -3 && mt[1].y === -1 && mt[2].x === 2 && mt[2].y === -2 && mt[3].x === -2 && mt[3].y === -2) return function(Oe, He, Zt) {
          const Xt = Zt.decoder, Gt = Zt.contextCache.getContexts("GB"), Lt = [];
          let Dt, jt, Ot, Rt, Tt, ee, te;
          for (jt = 0; jt < He; jt++)
            for (Tt = Lt[jt] = new Uint8Array(Oe), ee = jt < 1 ? Tt : Lt[jt - 1], te = jt < 2 ? Tt : Lt[jt - 2], Dt = te[0] << 13 | te[1] << 12 | te[2] << 11 | ee[0] << 7 | ee[1] << 6 | ee[2] << 5 | ee[3] << 4, Ot = 0; Ot < Oe; Ot++)
              Tt[Ot] = Rt = Xt.readBit(Gt, Dt), Dt = (31735 & Dt) << 1 | (Ot + 3 < Oe ? te[Ot + 3] << 11 : 0) | (Ot + 4 < Oe ? ee[Ot + 4] << 4 : 0) | Rt;
          return Lt;
        }(V, Y, yt);
        const at = _[Z].concat(mt);
        at.sort(function(ve, Oe) {
          return ve.y - Oe.y || ve.x - Oe.x;
        });
        const nt = at.length, q = new Int8Array(nt), D = new Int8Array(nt), G = [];
        let et, J, it = 0, lt = 0, ot = 0, ut = 0;
        for (J = 0; J < nt; J++)
          q[J] = at[J].x, D[J] = at[J].y, lt = Math.min(lt, at[J].x), ot = Math.max(ot, at[J].x), ut = Math.min(ut, at[J].y), J < nt - 1 && at[J].y === at[J + 1].y && at[J].x === at[J + 1].x - 1 ? it |= 1 << nt - 1 - J : G.push(J);
        const ct = G.length, gt = new Int8Array(ct), dt = new Int8Array(ct), bt = new Uint16Array(ct);
        for (et = 0; et < ct; et++)
          J = G[et], gt[et] = at[J].x, dt[et] = at[J].y, bt[et] = 1 << nt - 1 - J;
        const vt = -lt, xt = -ut, St = V - ot, Mt = O[Z];
        let Et = new Uint8Array(V);
        const Ft = [], Wt = yt.decoder, Kt = yt.contextCache.getContexts("GB");
        let qt, It, re, le, Ce, ce = 0, xe = 0;
        for (let ve = 0; ve < Y; ve++) {
          if (rt && (ce ^= Wt.readBit(Kt, Mt), ce)) {
            Ft.push(Et);
            continue;
          }
          for (Et = new Uint8Array(Et), Ft.push(Et), qt = 0; qt < V; qt++) {
            if (qt >= vt && qt < St && ve >= xt)
              for (xe = xe << 1 & it, J = 0; J < ct; J++)
                It = ve + dt[J], re = qt + gt[J], le = Ft[It][re], le && (le = bt[J], xe |= le);
            else
              for (xe = 0, Ce = nt - 1, J = 0; J < nt; J++, Ce--)
                re = qt + q[J], re >= 0 && re < V && (It = ve + D[J], It >= 0 && (le = Ft[It][re], le && (xe |= le << Ce)));
            const Oe = Wt.readBit(Kt, xe);
            Et[qt] = Oe;
          }
        }
        return Ft;
      }
      function I(N, V, Y, Z, rt, st, mt, yt, at) {
        let nt = M[Y].coding;
        Y === 0 && (nt = nt.concat([yt[0]]));
        const q = nt.length, D = new Int32Array(q), G = new Int32Array(q);
        let et;
        for (et = 0; et < q; et++)
          D[et] = nt[et].x, G[et] = nt[et].y;
        let J = M[Y].reference;
        Y === 0 && (J = J.concat([yt[1]]));
        const it = J.length, lt = new Int32Array(it), ot = new Int32Array(it);
        for (et = 0; et < it; et++)
          lt[et] = J[et].x, ot[et] = J[et].y;
        const ut = Z[0].length, ct = Z.length, gt = [], dt = at.decoder, bt = at.contextCache.getContexts("GR");
        for (let vt = 0; vt < V; vt++) {
          const xt = new Uint8Array(N);
          gt.push(xt);
          for (let St = 0; St < N; St++) {
            let Mt, Et, Ft = 0;
            for (et = 0; et < q; et++)
              Mt = vt + G[et], Et = St + D[et], Mt < 0 || Et < 0 || Et >= N ? Ft <<= 1 : Ft = Ft << 1 | gt[Mt][Et];
            for (et = 0; et < it; et++)
              Mt = vt + ot[et] - st, Et = St + lt[et] - rt, Mt < 0 || Mt >= ct || Et < 0 || Et >= ut ? Ft <<= 1 : Ft = Ft << 1 | Z[Mt][Et];
            const Wt = dt.readBit(bt, Ft);
            xt[St] = Wt;
          }
        }
        return gt;
      }
      function R(N, V, Y, Z, rt, st, mt, yt, at, nt, q, D, G, et, J, it, lt, ot, ut) {
        if (N && V) throw new a("refinement with Huffman is not supported");
        const ct = [];
        let gt, dt;
        for (gt = 0; gt < Z; gt++) {
          if (dt = new Uint8Array(Y), rt) for (let Mt = 0; Mt < Y; Mt++) dt[Mt] = rt;
          ct.push(dt);
        }
        const bt = lt.decoder, vt = lt.contextCache;
        let xt = N ? -et.tableDeltaT.decode(ut) : -v(vt, "IADT", bt), St = 0;
        for (gt = 0; gt < st; ) {
          xt += N ? et.tableDeltaT.decode(ut) : v(vt, "IADT", bt), St += N ? et.tableFirstS.decode(ut) : v(vt, "IAFS", bt);
          let Mt = St;
          for (; ; ) {
            let Et = 0;
            mt > 1 && (Et = N ? ut.readBits(ot) : v(vt, "IAIT", bt));
            const Ft = mt * xt + Et, Wt = N ? et.symbolIDTable.decode(ut) : h(vt, bt, at), Kt = V && (N ? ut.readBit() : v(vt, "IARI", bt));
            let qt = yt[Wt], It = qt[0].length, re = qt.length;
            if (Kt) {
              const He = v(vt, "IARDW", bt), Zt = v(vt, "IARDH", bt);
              It += He, re += Zt, qt = I(It, re, J, qt, (He >> 1) + v(vt, "IARDX", bt), (Zt >> 1) + v(vt, "IARDY", bt), !1, it, lt);
            }
            const le = Ft - (1 & D ? 0 : re - 1), Ce = Mt - (2 & D ? It - 1 : 0);
            let ce, xe, ve;
            if (nt) {
              for (ce = 0; ce < re; ce++) {
                if (dt = ct[Ce + ce], !dt) continue;
                ve = qt[ce];
                const He = Math.min(Y - le, It);
                switch (G) {
                  case 0:
                    for (xe = 0; xe < He; xe++) dt[le + xe] |= ve[xe];
                    break;
                  case 2:
                    for (xe = 0; xe < He; xe++) dt[le + xe] ^= ve[xe];
                    break;
                  default:
                    throw new a(`operator ${G} is not supported`);
                }
              }
              Mt += re - 1;
            } else {
              for (xe = 0; xe < re; xe++)
                if (dt = ct[le + xe], dt)
                  switch (ve = qt[xe], G) {
                    case 0:
                      for (ce = 0; ce < It; ce++) dt[Ce + ce] |= ve[ce];
                      break;
                    case 2:
                      for (ce = 0; ce < It; ce++) dt[Ce + ce] ^= ve[ce];
                      break;
                    default:
                      throw new a(`operator ${G} is not supported`);
                  }
              Mt += It - 1;
            }
            gt++;
            const Oe = N ? et.tableDeltaS.decode(ut) : v(vt, "IADS", bt);
            if (Oe === null) break;
            Mt += Oe + q;
          }
        }
        return ct;
      }
      function W(N, V) {
        const Y = {};
        Y.number = (0, g.readUint32)(N, V);
        const Z = N[V + 4], rt = 63 & Z;
        if (!x[rt]) throw new a("invalid segment type: " + rt);
        Y.type = rt, Y.typeName = x[rt], Y.deferredNonRetain = !!(128 & Z);
        const st = !!(64 & Z), mt = N[V + 5];
        let yt = mt >> 5 & 7;
        const at = [31 & mt];
        let nt = V + 6;
        if (mt === 7) {
          yt = 536870911 & (0, g.readUint32)(N, nt - 1), nt += 3;
          let J = yt + 7 >> 3;
          for (at[0] = N[nt++]; --J > 0; ) at.push(N[nt++]);
        } else if (mt === 5 || mt === 6) throw new a("invalid referred-to flags");
        Y.retainBits = at;
        let q = 4;
        Y.number <= 256 ? q = 1 : Y.number <= 65536 && (q = 2);
        const D = [];
        let G, et;
        for (G = 0; G < yt; G++) {
          let J;
          J = q === 1 ? N[nt] : q === 2 ? (0, g.readUint16)(N, nt) : (0, g.readUint32)(N, nt), D.push(J), nt += q;
        }
        if (Y.referredTo = D, st ? (Y.pageAssociation = (0, g.readUint32)(N, nt), nt += 4) : Y.pageAssociation = N[nt++], Y.length = (0, g.readUint32)(N, nt), nt += 4, Y.length === 4294967295) {
          if (rt !== 38) throw new a("invalid unknown segment length");
          {
            const J = j(N, nt), it = !!(1 & N[nt + $]), lt = 6, ot = new Uint8Array(lt);
            for (it || (ot[0] = 255, ot[1] = 172), ot[2] = J.height >>> 24 & 255, ot[3] = J.height >> 16 & 255, ot[4] = J.height >> 8 & 255, ot[5] = 255 & J.height, G = nt, et = N.length; G < et; G++) {
              let ut = 0;
              for (; ut < lt && ot[ut] === N[G + ut]; ) ut++;
              if (ut === lt) {
                Y.length = G + lt;
                break;
              }
            }
            if (Y.length === 4294967295) throw new a("segment end was not found");
          }
        }
        return Y.headerEnd = nt, Y;
      }
      function z(N, V, Y, Z) {
        const rt = [];
        let st = Y;
        for (; st < Z; ) {
          const mt = W(V, st);
          st = mt.headerEnd;
          const yt = { header: mt, data: V };
          if (N.randomAccess || (yt.start = st, st += mt.length, yt.end = st), rt.push(yt), mt.type === 51) break;
        }
        if (N.randomAccess) for (let mt = 0, yt = rt.length; mt < yt; mt++)
          rt[mt].start = st, st += rt[mt].header.length, rt[mt].end = st;
        return rt;
      }
      function j(N, V) {
        return { width: (0, g.readUint32)(N, V), height: (0, g.readUint32)(N, V + 4), x: (0, g.readUint32)(N, V + 8), y: (0, g.readUint32)(N, V + 12), combinationOperator: 7 & N[V + 16] };
      }
      const $ = 17;
      function B(N, V) {
        const Y = N.header, Z = N.data, rt = N.end;
        let st, mt, yt, at, nt = N.start;
        switch (Y.type) {
          case 0:
            const D = {}, G = (0, g.readUint16)(Z, nt);
            if (D.huffman = !!(1 & G), D.refinement = !!(2 & G), D.huffmanDHSelector = G >> 2 & 3, D.huffmanDWSelector = G >> 4 & 3, D.bitmapSizeSelector = G >> 6 & 1, D.aggregationInstancesSelector = G >> 7 & 1, D.bitmapCodingContextUsed = !!(256 & G), D.bitmapCodingContextRetained = !!(512 & G), D.template = G >> 10 & 3, D.refinementTemplate = G >> 12 & 1, nt += 2, !D.huffman) {
              for (at = D.template === 0 ? 4 : 1, mt = [], yt = 0; yt < at; yt++)
                mt.push({ x: (0, g.readInt8)(Z, nt), y: (0, g.readInt8)(Z, nt + 1) }), nt += 2;
              D.at = mt;
            }
            if (D.refinement && !D.refinementTemplate) {
              for (mt = [], yt = 0; yt < 2; yt++)
                mt.push({ x: (0, g.readInt8)(Z, nt), y: (0, g.readInt8)(Z, nt + 1) }), nt += 2;
              D.refinementAt = mt;
            }
            D.numberOfExportedSymbols = (0, g.readUint32)(Z, nt), nt += 4, D.numberOfNewSymbols = (0, g.readUint32)(Z, nt), nt += 4, st = [D, Y.number, Y.referredTo, Z, nt, rt];
            break;
          case 6:
          case 7:
            const et = {};
            et.info = j(Z, nt), nt += $;
            const J = (0, g.readUint16)(Z, nt);
            if (nt += 2, et.huffman = !!(1 & J), et.refinement = !!(2 & J), et.logStripSize = J >> 2 & 3, et.stripSize = 1 << et.logStripSize, et.referenceCorner = J >> 4 & 3, et.transposed = !!(64 & J), et.combinationOperator = J >> 7 & 3, et.defaultPixelValue = J >> 9 & 1, et.dsOffset = J << 17 >> 27, et.refinementTemplate = J >> 15 & 1, et.huffman) {
              const vt = (0, g.readUint16)(Z, nt);
              nt += 2, et.huffmanFS = 3 & vt, et.huffmanDS = vt >> 2 & 3, et.huffmanDT = vt >> 4 & 3, et.huffmanRefinementDW = vt >> 6 & 3, et.huffmanRefinementDH = vt >> 8 & 3, et.huffmanRefinementDX = vt >> 10 & 3, et.huffmanRefinementDY = vt >> 12 & 3, et.huffmanRefinementSizeSelector = !!(16384 & vt);
            }
            if (et.refinement && !et.refinementTemplate) {
              for (mt = [], yt = 0; yt < 2; yt++)
                mt.push({ x: (0, g.readInt8)(Z, nt), y: (0, g.readInt8)(Z, nt + 1) }), nt += 2;
              et.refinementAt = mt;
            }
            et.numberOfSymbolInstances = (0, g.readUint32)(Z, nt), nt += 4, st = [et, Y.referredTo, Z, nt, rt];
            break;
          case 16:
            const it = {}, lt = Z[nt++];
            it.mmr = !!(1 & lt), it.template = lt >> 1 & 3, it.patternWidth = Z[nt++], it.patternHeight = Z[nt++], it.maxPatternIndex = (0, g.readUint32)(Z, nt), nt += 4, st = [it, Y.number, Z, nt, rt];
            break;
          case 22:
          case 23:
            const ot = {};
            ot.info = j(Z, nt), nt += $;
            const ut = Z[nt++];
            ot.mmr = !!(1 & ut), ot.template = ut >> 1 & 3, ot.enableSkip = !!(8 & ut), ot.combinationOperator = ut >> 4 & 7, ot.defaultPixelValue = ut >> 7 & 1, ot.gridWidth = (0, g.readUint32)(Z, nt), nt += 4, ot.gridHeight = (0, g.readUint32)(Z, nt), nt += 4, ot.gridOffsetX = 4294967295 & (0, g.readUint32)(Z, nt), nt += 4, ot.gridOffsetY = 4294967295 & (0, g.readUint32)(Z, nt), nt += 4, ot.gridVectorX = (0, g.readUint16)(Z, nt), nt += 2, ot.gridVectorY = (0, g.readUint16)(Z, nt), nt += 2, st = [ot, Y.referredTo, Z, nt, rt];
            break;
          case 38:
          case 39:
            const ct = {};
            ct.info = j(Z, nt), nt += $;
            const gt = Z[nt++];
            if (ct.mmr = !!(1 & gt), ct.template = gt >> 1 & 3, ct.prediction = !!(8 & gt), !ct.mmr) {
              for (at = ct.template === 0 ? 4 : 1, mt = [], yt = 0; yt < at; yt++)
                mt.push({ x: (0, g.readInt8)(Z, nt), y: (0, g.readInt8)(Z, nt + 1) }), nt += 2;
              ct.at = mt;
            }
            st = [ct, Z, nt, rt];
            break;
          case 48:
            const dt = { width: (0, g.readUint32)(Z, nt), height: (0, g.readUint32)(Z, nt + 4), resolutionX: (0, g.readUint32)(Z, nt + 8), resolutionY: (0, g.readUint32)(Z, nt + 12) };
            dt.height === 4294967295 && delete dt.height;
            const bt = Z[nt + 16];
            (0, g.readUint16)(Z, nt + 17), dt.lossless = !!(1 & bt), dt.refinement = !!(2 & bt), dt.defaultPixelValue = bt >> 2 & 1, dt.combinationOperator = bt >> 3 & 3, dt.requiresBuffer = !!(32 & bt), dt.combinationOperatorOverride = !!(64 & bt), st = [dt];
            break;
          case 49:
          case 50:
          case 51:
          case 62:
            break;
          case 53:
            st = [Y.number, Z, nt, rt];
            break;
          default:
            throw new a(`segment type ${Y.typeName}(${Y.type}) is not implemented`);
        }
        const q = "on" + Y.typeName;
        q in V && V[q].apply(V, st);
      }
      function C(N, V) {
        for (let Y = 0, Z = N.length; Y < Z; Y++) B(N[Y], V);
      }
      class T {
        onPageInformation(V) {
          this.currentPageInfo = V;
          const Y = V.width + 7 >> 3, Z = new Uint8ClampedArray(Y * V.height);
          V.defaultPixelValue && Z.fill(255), this.buffer = Z;
        }
        drawBitmap(V, Y) {
          const Z = this.currentPageInfo, rt = V.width, st = V.height, mt = Z.width + 7 >> 3, yt = Z.combinationOperatorOverride ? V.combinationOperator : Z.combinationOperator, at = this.buffer, nt = 128 >> (7 & V.x);
          let q, D, G, et, J = V.y * mt + (V.x >> 3);
          switch (yt) {
            case 0:
              for (q = 0; q < st; q++) {
                for (G = nt, et = J, D = 0; D < rt; D++)
                  Y[q][D] && (at[et] |= G), G >>= 1, G || (G = 128, et++);
                J += mt;
              }
              break;
            case 2:
              for (q = 0; q < st; q++) {
                for (G = nt, et = J, D = 0; D < rt; D++)
                  Y[q][D] && (at[et] ^= G), G >>= 1, G || (G = 128, et++);
                J += mt;
              }
              break;
            default:
              throw new a(`operator ${yt} is not supported`);
          }
        }
        onImmediateGenericRegion(V, Y, Z, rt) {
          const st = V.info, mt = new m(Y, Z, rt), yt = E(V.mmr, st.width, st.height, V.template, V.prediction, null, V.at, mt);
          this.drawBitmap(st, yt);
        }
        onImmediateLosslessGenericRegion() {
          this.onImmediateGenericRegion(...arguments);
        }
        onSymbolDictionary(V, Y, Z, rt, st, mt) {
          let yt, at;
          V.huffman && (yt = function(et, J, it) {
            let lt, ot, ut, ct, gt = 0;
            switch (et.huffmanDHSelector) {
              case 0:
              case 1:
                lt = K(et.huffmanDHSelector + 4);
                break;
              case 3:
                lt = L(gt, J, it), gt++;
                break;
              default:
                throw new a("invalid Huffman DH selector");
            }
            switch (et.huffmanDWSelector) {
              case 0:
              case 1:
                ot = K(et.huffmanDWSelector + 2);
                break;
              case 3:
                ot = L(gt, J, it), gt++;
                break;
              default:
                throw new a("invalid Huffman DW selector");
            }
            return et.bitmapSizeSelector ? (ut = L(gt, J, it), gt++) : ut = K(1), ct = et.aggregationInstancesSelector ? L(gt, J, it) : K(1), { tableDeltaHeight: lt, tableDeltaWidth: ot, tableBitmapSize: ut, tableAggregateInstances: ct };
          }(V, Z, this.customTables), at = new X(rt, st, mt));
          let nt = this.symbols;
          nt || (this.symbols = nt = {});
          const q = [];
          for (const G of Z) {
            const et = nt[G];
            et && q.push(...et);
          }
          const D = new m(rt, st, mt);
          nt[Y] = function(et, J, it, lt, ot, ut, ct, gt, dt, bt, vt, xt) {
            if (et && J) throw new a("symbol refinement with Huffman is not supported");
            const St = [];
            let Mt = 0, Et = (0, g.log2)(it.length + lt);
            const Ft = vt.decoder, Wt = vt.contextCache;
            let Kt, qt;
            for (et && (Kt = K(1), qt = [], Et = Math.max(Et, 1)); St.length < lt; ) {
              Mt += et ? ut.tableDeltaHeight.decode(xt) : v(Wt, "IADH", Ft);
              let ve = 0, Oe = 0;
              const He = et ? qt.length : 0;
              for (; ; ) {
                const Zt = et ? ut.tableDeltaWidth.decode(xt) : v(Wt, "IADW", Ft);
                if (Zt === null) break;
                ve += Zt, Oe += ve;
                let Xt;
                if (J) {
                  const Gt = v(Wt, "IAAI", Ft);
                  if (Gt > 1) Xt = R(et, J, ve, Mt, 0, Gt, 1, it.concat(St), Et, 0, 0, 1, 0, ut, dt, bt, vt, 0, xt);
                  else {
                    const Lt = h(Wt, Ft, Et), Dt = v(Wt, "IARDX", Ft), jt = v(Wt, "IARDY", Ft);
                    Xt = I(ve, Mt, dt, Lt < it.length ? it[Lt] : St[Lt - it.length], Dt, jt, !1, bt, vt);
                  }
                  St.push(Xt);
                } else et ? qt.push(ve) : (Xt = E(!1, ve, Mt, ct, !1, null, gt, vt), St.push(Xt));
              }
              if (et && !J) {
                const Zt = ut.tableBitmapSize.decode(xt);
                xt.byteAlign();
                let Xt;
                if (Zt === 0) Xt = H(xt, Oe, Mt);
                else {
                  const Lt = xt.end, Dt = xt.position + Zt;
                  xt.end = Dt, Xt = Q(xt, Oe, Mt, !1), xt.end = Lt, xt.position = Dt;
                }
                const Gt = qt.length;
                if (He === Gt - 1) St.push(Xt);
                else {
                  let Lt, Dt, jt, Ot, Rt, Tt = 0;
                  for (Lt = He; Lt < Gt; Lt++) {
                    for (Ot = qt[Lt], jt = Tt + Ot, Rt = [], Dt = 0; Dt < Mt; Dt++) Rt.push(Xt[Dt].subarray(Tt, jt));
                    St.push(Rt), Tt = jt;
                  }
                }
              }
            }
            const It = [], re = [];
            let le, Ce, ce = !1;
            const xe = it.length + lt;
            for (; re.length < xe; ) {
              let ve = et ? Kt.decode(xt) : v(Wt, "IAEX", Ft);
              for (; ve--; ) re.push(ce);
              ce = !ce;
            }
            for (le = 0, Ce = it.length; le < Ce; le++) re[le] && It.push(it[le]);
            for (let ve = 0; ve < lt; le++, ve++) re[le] && It.push(St[ve]);
            return It;
          }(V.huffman, V.refinement, q, V.numberOfNewSymbols, V.numberOfExportedSymbols, yt, V.template, V.at, V.refinementTemplate, V.refinementAt, D, at);
        }
        onImmediateTextRegion(V, Y, Z, rt, st) {
          const mt = V.info;
          let yt, at;
          const nt = this.symbols, q = [];
          for (const J of Y) {
            const it = nt[J];
            it && q.push(...it);
          }
          const D = (0, g.log2)(q.length);
          V.huffman && (at = new X(Z, rt, st), yt = function(it, lt, ot, ut, ct) {
            const gt = [];
            for (let Et = 0; Et <= 34; Et++) {
              const Ft = ct.readBits(4);
              gt.push(new F([Et, Ft, 0, 0]));
            }
            const dt = new A(gt, !1);
            gt.length = 0;
            for (let Et = 0; Et < ut; ) {
              const Ft = dt.decode(ct);
              if (Ft >= 32) {
                let Wt, Kt, qt;
                switch (Ft) {
                  case 32:
                    if (Et === 0) throw new a("no previous value in symbol ID table");
                    Kt = ct.readBits(2) + 3, Wt = gt[Et - 1].prefixLength;
                    break;
                  case 33:
                    Kt = ct.readBits(3) + 3, Wt = 0;
                    break;
                  case 34:
                    Kt = ct.readBits(7) + 11, Wt = 0;
                    break;
                  default:
                    throw new a("invalid code length in symbol ID table");
                }
                for (qt = 0; qt < Kt; qt++)
                  gt.push(new F([Et, Wt, 0, 0])), Et++;
              } else
                gt.push(new F([Et, Ft, 0, 0])), Et++;
            }
            ct.byteAlign();
            const bt = new A(gt, !1);
            let vt, xt, St, Mt = 0;
            switch (it.huffmanFS) {
              case 0:
              case 1:
                vt = K(it.huffmanFS + 6);
                break;
              case 3:
                vt = L(Mt, lt, ot), Mt++;
                break;
              default:
                throw new a("invalid Huffman FS selector");
            }
            switch (it.huffmanDS) {
              case 0:
              case 1:
              case 2:
                xt = K(it.huffmanDS + 8);
                break;
              case 3:
                xt = L(Mt, lt, ot), Mt++;
                break;
              default:
                throw new a("invalid Huffman DS selector");
            }
            switch (it.huffmanDT) {
              case 0:
              case 1:
              case 2:
                St = K(it.huffmanDT + 11);
                break;
              case 3:
                St = L(Mt, lt, ot), Mt++;
                break;
              default:
                throw new a("invalid Huffman DT selector");
            }
            if (it.refinement) throw new a("refinement with Huffman is not supported");
            return { symbolIDTable: bt, tableFirstS: vt, tableDeltaS: xt, tableDeltaT: St };
          }(V, Y, this.customTables, q.length, at));
          const G = new m(Z, rt, st), et = R(V.huffman, V.refinement, mt.width, mt.height, V.defaultPixelValue, V.numberOfSymbolInstances, V.stripSize, q, D, V.transposed, V.dsOffset, V.referenceCorner, V.combinationOperator, yt, V.refinementTemplate, V.refinementAt, G, V.logStripSize, at);
          this.drawBitmap(mt, et);
        }
        onImmediateLosslessTextRegion() {
          this.onImmediateTextRegion(...arguments);
        }
        onPatternDictionary(V, Y, Z, rt, st) {
          let mt = this.patterns;
          mt || (this.patterns = mt = {});
          const yt = new m(Z, rt, st);
          mt[Y] = function(nt, q, D, G, et, J) {
            const it = [];
            nt || (it.push({ x: -q, y: 0 }), et === 0 && it.push({ x: -3, y: -1 }, { x: 2, y: -2 }, { x: -2, y: -2 }));
            const lt = E(nt, (G + 1) * q, D, et, !1, null, it, J), ot = [];
            for (let ut = 0; ut <= G; ut++) {
              const ct = [], gt = q * ut, dt = gt + q;
              for (let bt = 0; bt < D; bt++) ct.push(lt[bt].subarray(gt, dt));
              ot.push(ct);
            }
            return ot;
          }(V.mmr, V.patternWidth, V.patternHeight, V.maxPatternIndex, V.template, yt);
        }
        onImmediateHalftoneRegion(V, Y, Z, rt, st) {
          const mt = this.patterns[Y[0]], yt = V.info, at = new m(Z, rt, st), nt = function(D, G, et, J, it, lt, ot, ut, ct, gt, dt, bt, vt, xt, St) {
            if (ot) throw new a("skip is not supported");
            if (ut !== 0) throw new a(`operator "${ut}" is not supported in halftone region`);
            const Mt = [];
            let Et, Ft, Wt;
            for (Et = 0; Et < it; Et++) {
              if (Wt = new Uint8Array(J), lt) for (Ft = 0; Ft < J; Ft++) Wt[Ft] = lt;
              Mt.push(Wt);
            }
            const Kt = G.length, qt = G[0], It = qt[0].length, re = qt.length, le = (0, g.log2)(Kt), Ce = [];
            D || (Ce.push({ x: et <= 1 ? 3 : 2, y: -1 }), et === 0 && Ce.push({ x: -3, y: -1 }, { x: 2, y: -2 }, { x: -2, y: -2 }));
            const ce = [];
            let xe, ve, Oe, He, Zt, Xt, Gt, Lt, Dt, jt, Ot;
            for (D && (xe = new X(St.data, St.start, St.end)), Et = le - 1; Et >= 0; Et--)
              ve = D ? Q(xe, ct, gt, !0) : E(!1, ct, gt, et, !1, null, Ce, St), ce[Et] = ve;
            for (Oe = 0; Oe < gt; Oe++) for (He = 0; He < ct; He++) {
              for (Zt = 0, Xt = 0, Ft = le - 1; Ft >= 0; Ft--)
                Zt ^= ce[Ft][Oe][He], Xt |= Zt << Ft;
              if (Gt = G[Xt], Lt = dt + Oe * xt + He * vt >> 8, Dt = bt + Oe * vt - He * xt >> 8, Lt >= 0 && Lt + It <= J && Dt >= 0 && Dt + re <= it) for (Et = 0; Et < re; Et++)
                for (Ot = Mt[Dt + Et], jt = Gt[Et], Ft = 0; Ft < It; Ft++) Ot[Lt + Ft] |= jt[Ft];
              else {
                let Rt, Tt;
                for (Et = 0; Et < re; Et++)
                  if (Tt = Dt + Et, !(Tt < 0 || Tt >= it))
                    for (Ot = Mt[Tt], jt = Gt[Et], Ft = 0; Ft < It; Ft++)
                      Rt = Lt + Ft, Rt >= 0 && Rt < J && (Ot[Rt] |= jt[Ft]);
              }
            }
            return Mt;
          }(V.mmr, mt, V.template, yt.width, yt.height, V.defaultPixelValue, V.enableSkip, V.combinationOperator, V.gridWidth, V.gridHeight, V.gridOffsetX, V.gridOffsetY, V.gridVectorX, V.gridVectorY, at);
          this.drawBitmap(yt, nt);
        }
        onImmediateLosslessHalftoneRegion() {
          this.onImmediateHalftoneRegion(...arguments);
        }
        onTables(V, Y, Z, rt) {
          let st = this.customTables;
          st || (this.customTables = st = {}), st[V] = function(yt, at, nt) {
            const q = yt[at], D = 4294967295 & (0, g.readUint32)(yt, at + 1), G = 4294967295 & (0, g.readUint32)(yt, at + 5), et = new X(yt, at + 9, nt), J = 1 + (q >> 1 & 7), it = 1 + (q >> 4 & 7), lt = [];
            let ot, ut, ct = D;
            do
              ot = et.readBits(J), ut = et.readBits(it), lt.push(new F([ct, ot, ut, 0])), ct += 1 << ut;
            while (ct < G);
            return ot = et.readBits(J), lt.push(new F([D - 1, ot, 32, 0, "lower"])), ot = et.readBits(J), lt.push(new F([G, ot, 32, 0])), 1 & q && (ot = et.readBits(J), lt.push(new F([ot, 0]))), new A(lt, !1);
          }(Y, Z, rt);
        }
      }
      class F {
        constructor(V) {
          V.length === 2 ? (this.isOOB = !0, this.rangeLow = 0, this.prefixLength = V[0], this.rangeLength = 0, this.prefixCode = V[1], this.isLowerRange = !1) : (this.isOOB = !1, this.rangeLow = V[0], this.prefixLength = V[1], this.rangeLength = V[2], this.prefixCode = V[3], this.isLowerRange = V[4] === "lower");
        }
      }
      class S {
        constructor(V) {
          this.children = [], V ? (this.isLeaf = !0, this.rangeLength = V.rangeLength, this.rangeLow = V.rangeLow, this.isLowerRange = V.isLowerRange, this.isOOB = V.isOOB) : this.isLeaf = !1;
        }
        buildTree(V, Y) {
          const Z = V.prefixCode >> Y & 1;
          if (Y <= 0) this.children[Z] = new S(V);
          else {
            let rt = this.children[Z];
            rt || (this.children[Z] = rt = new S(null)), rt.buildTree(V, Y - 1);
          }
        }
        decodeNode(V) {
          if (this.isLeaf) {
            if (this.isOOB) return null;
            const Z = V.readBits(this.rangeLength);
            return this.rangeLow + (this.isLowerRange ? -Z : Z);
          }
          const Y = this.children[V.readBit()];
          if (!Y) throw new a("invalid Huffman data");
          return Y.decodeNode(V);
        }
      }
      class A {
        constructor(V, Y) {
          Y || this.assignPrefixCodes(V), this.rootNode = new S(null);
          for (let Z = 0, rt = V.length; Z < rt; Z++) {
            const st = V[Z];
            st.prefixLength > 0 && this.rootNode.buildTree(st, st.prefixLength - 1);
          }
        }
        decode(V) {
          return this.rootNode.decodeNode(V);
        }
        assignPrefixCodes(V) {
          const Y = V.length;
          let Z = 0;
          for (let q = 0; q < Y; q++) Z = Math.max(Z, V[q].prefixLength);
          const rt = new Uint32Array(Z + 1);
          for (let q = 0; q < Y; q++) rt[V[q].prefixLength]++;
          let st, mt, yt, at = 1, nt = 0;
          for (rt[0] = 0; at <= Z; ) {
            for (nt = nt + rt[at - 1] << 1, st = nt, mt = 0; mt < Y; )
              yt = V[mt], yt.prefixLength === at && (yt.prefixCode = st, st++), mt++;
            at++;
          }
        }
      }
      const U = {};
      function K(N) {
        let V, Y = U[N];
        if (Y) return Y;
        switch (N) {
          case 1:
            V = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
            break;
          case 2:
            V = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
            break;
          case 3:
            V = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
            break;
          case 4:
            V = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
            break;
          case 5:
            V = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
            break;
          case 6:
            V = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
            break;
          case 7:
            V = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
            break;
          case 8:
            V = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
            break;
          case 9:
            V = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
            break;
          case 10:
            V = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
            break;
          case 11:
            V = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
            break;
          case 12:
            V = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
            break;
          case 13:
            V = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
            break;
          case 14:
            V = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
            break;
          case 15:
            V = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
            break;
          default:
            throw new a(`standard table B.${N} does not exist`);
        }
        for (let Z = 0, rt = V.length; Z < rt; Z++) V[Z] = new F(V[Z]);
        return Y = new A(V, !0), U[N] = Y, Y;
      }
      class X {
        constructor(V, Y, Z) {
          this.data = V, this.start = Y, this.end = Z, this.position = Y, this.shift = -1, this.currentByte = 0;
        }
        readBit() {
          if (this.shift < 0) {
            if (this.position >= this.end) throw new a("end of data while reading bit");
            this.currentByte = this.data[this.position++], this.shift = 7;
          }
          const V = this.currentByte >> this.shift & 1;
          return this.shift--, V;
        }
        readBits(V) {
          let Y, Z = 0;
          for (Y = V - 1; Y >= 0; Y--) Z |= this.readBit() << Y;
          return Z;
        }
        byteAlign() {
          this.shift = -1;
        }
        next() {
          return this.position >= this.end ? -1 : this.data[this.position++];
        }
      }
      function L(N, V, Y) {
        let Z = 0;
        for (let rt = 0, st = V.length; rt < st; rt++) {
          const mt = Y[V[rt]];
          if (mt) {
            if (N === Z) return mt;
            Z++;
          }
        }
        throw new a("can't find custom Huffman table");
      }
      function H(N, V, Y) {
        const Z = [];
        for (let rt = 0; rt < Y; rt++) {
          const st = new Uint8Array(V);
          Z.push(st);
          for (let mt = 0; mt < V; mt++) st[mt] = N.readBit();
          N.byteAlign();
        }
        return Z;
      }
      function Q(N, V, Y, Z) {
        const rt = { K: -1, Columns: V, Rows: Y, BlackIs1: !0, EndOfBlock: Z }, st = new n.CCITTFaxDecoder(N, rt), mt = [];
        let yt, at = !1;
        for (let nt = 0; nt < Y; nt++) {
          const q = new Uint8Array(V);
          mt.push(q);
          let D = -1;
          for (let G = 0; G < V; G++)
            D < 0 && (yt = st.readNextChar(), yt === -1 && (yt = 0, at = !0), D = 7), q[G] = yt >> D & 1, D--;
        }
        if (Z && !at)
          for (let q = 0; q < 5 && st.readNextChar() !== -1; q++) ;
        return mt;
      }
      l.Jbig2Image = class {
        parseChunks(V) {
          return function(Z) {
            const rt = new T();
            for (let st = 0, mt = Z.length; st < mt; st++) {
              const yt = Z[st];
              C(z({}, yt.data, yt.start, yt.end), rt);
            }
            return rt.buffer;
          }(V);
        }
        parse(V) {
          throw new Error("Not implemented: Jbig2Image.parse");
        }
      };
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ArithmeticDecoder = void 0;
      const f = [{ qe: 22017, nmps: 1, nlps: 1, switchFlag: 1 }, { qe: 13313, nmps: 2, nlps: 6, switchFlag: 0 }, { qe: 6145, nmps: 3, nlps: 9, switchFlag: 0 }, { qe: 2753, nmps: 4, nlps: 12, switchFlag: 0 }, { qe: 1313, nmps: 5, nlps: 29, switchFlag: 0 }, { qe: 545, nmps: 38, nlps: 33, switchFlag: 0 }, { qe: 22017, nmps: 7, nlps: 6, switchFlag: 1 }, { qe: 21505, nmps: 8, nlps: 14, switchFlag: 0 }, { qe: 18433, nmps: 9, nlps: 14, switchFlag: 0 }, { qe: 14337, nmps: 10, nlps: 14, switchFlag: 0 }, { qe: 12289, nmps: 11, nlps: 17, switchFlag: 0 }, { qe: 9217, nmps: 12, nlps: 18, switchFlag: 0 }, { qe: 7169, nmps: 13, nlps: 20, switchFlag: 0 }, { qe: 5633, nmps: 29, nlps: 21, switchFlag: 0 }, { qe: 22017, nmps: 15, nlps: 14, switchFlag: 1 }, { qe: 21505, nmps: 16, nlps: 14, switchFlag: 0 }, { qe: 20737, nmps: 17, nlps: 15, switchFlag: 0 }, { qe: 18433, nmps: 18, nlps: 16, switchFlag: 0 }, { qe: 14337, nmps: 19, nlps: 17, switchFlag: 0 }, { qe: 13313, nmps: 20, nlps: 18, switchFlag: 0 }, { qe: 12289, nmps: 21, nlps: 19, switchFlag: 0 }, { qe: 10241, nmps: 22, nlps: 19, switchFlag: 0 }, { qe: 9217, nmps: 23, nlps: 20, switchFlag: 0 }, { qe: 8705, nmps: 24, nlps: 21, switchFlag: 0 }, { qe: 7169, nmps: 25, nlps: 22, switchFlag: 0 }, { qe: 6145, nmps: 26, nlps: 23, switchFlag: 0 }, { qe: 5633, nmps: 27, nlps: 24, switchFlag: 0 }, { qe: 5121, nmps: 28, nlps: 25, switchFlag: 0 }, { qe: 4609, nmps: 29, nlps: 26, switchFlag: 0 }, { qe: 4353, nmps: 30, nlps: 27, switchFlag: 0 }, { qe: 2753, nmps: 31, nlps: 28, switchFlag: 0 }, { qe: 2497, nmps: 32, nlps: 29, switchFlag: 0 }, { qe: 2209, nmps: 33, nlps: 30, switchFlag: 0 }, { qe: 1313, nmps: 34, nlps: 31, switchFlag: 0 }, { qe: 1089, nmps: 35, nlps: 32, switchFlag: 0 }, { qe: 673, nmps: 36, nlps: 33, switchFlag: 0 }, { qe: 545, nmps: 37, nlps: 34, switchFlag: 0 }, { qe: 321, nmps: 38, nlps: 35, switchFlag: 0 }, { qe: 273, nmps: 39, nlps: 36, switchFlag: 0 }, { qe: 133, nmps: 40, nlps: 37, switchFlag: 0 }, { qe: 73, nmps: 41, nlps: 38, switchFlag: 0 }, { qe: 37, nmps: 42, nlps: 39, switchFlag: 0 }, { qe: 21, nmps: 43, nlps: 40, switchFlag: 0 }, { qe: 9, nmps: 44, nlps: 41, switchFlag: 0 }, { qe: 5, nmps: 45, nlps: 42, switchFlag: 0 }, { qe: 1, nmps: 45, nlps: 43, switchFlag: 0 }, { qe: 22017, nmps: 46, nlps: 46, switchFlag: 0 }];
      l.ArithmeticDecoder = class {
        constructor(g, p, n) {
          this.data = g, this.bp = p, this.dataEnd = n, this.chigh = g[p], this.clow = 0, this.byteIn(), this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127, this.clow = this.clow << 7 & 65535, this.ct -= 7, this.a = 32768;
        }
        byteIn() {
          const g = this.data;
          let p = this.bp;
          g[p] === 255 ? g[p + 1] > 143 ? (this.clow += 65280, this.ct = 8) : (p++, this.clow += g[p] << 9, this.ct = 7, this.bp = p) : (p++, this.clow += p < this.dataEnd ? g[p] << 8 : 65280, this.ct = 8, this.bp = p), this.clow > 65535 && (this.chigh += this.clow >> 16, this.clow &= 65535);
        }
        readBit(g, p) {
          let n = g[p] >> 1, a = 1 & g[p];
          const d = f[n], m = d.qe;
          let b, w = this.a - m;
          if (this.chigh < m) w < m ? (w = m, b = a, n = d.nmps) : (w = m, b = 1 ^ a, d.switchFlag === 1 && (a = b), n = d.nlps);
          else {
            if (this.chigh -= m, 32768 & w)
              return this.a = w, a;
            w < m ? (b = 1 ^ a, d.switchFlag === 1 && (a = b), n = d.nlps) : (b = a, n = d.nmps);
          }
          do
            this.ct === 0 && this.byteIn(), w <<= 1, this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1, this.clow = this.clow << 1 & 65535, this.ct--;
          while (!(32768 & w));
          return this.a = w, g[p] = n << 1 | a, b;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.JpegStream = void 0;
      var o = f(18), g = f(4), p = f(27), n = f(2);
      class a extends o.DecodeStream {
        constructor(m, b, w) {
          let v;
          for (; (v = m.getByte()) !== -1; ) if (v === 255) {
            m.skip(-1);
            break;
          }
          super(b), this.stream = m, this.dict = m.dict, this.maybeLength = b, this.params = w;
        }
        get bytes() {
          return (0, n.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
        }
        ensureBuffer(m) {
        }
        readBlock() {
          if (this.eof) return;
          const m = { decodeTransform: void 0, colorTransform: void 0 }, b = this.dict.getArray("D", "Decode");
          if ((this.forceRGBA || this.forceRGB) && Array.isArray(b)) {
            const h = this.dict.get("BPC", "BitsPerComponent") || 8, x = b.length, _ = new Int32Array(x);
            let M = !1;
            const O = (1 << h) - 1;
            for (let E = 0; E < x; E += 2)
              _[E] = 256 * (b[E + 1] - b[E]) | 0, _[E + 1] = b[E] * O | 0, _[E] === 256 && _[E + 1] === 0 || (M = !0);
            M && (m.decodeTransform = _);
          }
          if (this.params instanceof g.Dict) {
            const h = this.params.get("ColorTransform");
            Number.isInteger(h) && (m.colorTransform = h);
          }
          const w = new p.JpegImage(m);
          w.parse(this.bytes);
          const v = w.getData({ width: this.drawWidth, height: this.drawHeight, forceRGBA: this.forceRGBA, forceRGB: this.forceRGB, isSourcePDF: !0 });
          this.buffer = v, this.bufferLength = v.length, this.eof = !0;
        }
      }
      l.JpegStream = a;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.JpegImage = void 0;
      var o = f(2), g = f(28), p = f(3);
      class n extends o.BaseException {
        constructor(B) {
          super(`JPEG error: ${B}`, "JpegError");
        }
      }
      class a extends o.BaseException {
        constructor(B, C) {
          super(B, "DNLMarkerError"), this.scanLines = C;
        }
      }
      class d extends o.BaseException {
        constructor(B) {
          super(B, "EOIMarkerError");
        }
      }
      const m = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), b = 4017, w = 799, v = 3406, h = 2276, x = 1567, _ = 3784, M = 5793, O = 2896;
      function E($, B) {
        let C, T, F = 0, S = 16;
        for (; S > 0 && !$[S - 1]; ) S--;
        const A = [{ children: [], index: 0 }];
        let U, K = A[0];
        for (C = 0; C < S; C++) {
          for (T = 0; T < $[C]; T++) {
            for (K = A.pop(), K.children[K.index] = B[F]; K.index > 0; ) K = A.pop();
            for (K.index++, A.push(K); A.length <= C; )
              A.push(U = { children: [], index: 0 }), K.children[K.index] = U.children, K = U;
            F++;
          }
          C + 1 < S && (A.push(U = { children: [], index: 0 }), K.children[K.index] = U.children, K = U);
        }
        return A[0].children;
      }
      function I($, B, C) {
        return 64 * (($.blocksPerLine + 1) * B + C);
      }
      function R($, B, C, T, F, S, A, U, K, X = !1) {
        const L = C.mcusPerLine, H = C.progressive, Q = B;
        let N = 0, V = 0;
        function Y() {
          if (V > 0)
            return V--, N >> V & 1;
          if (N = $[B++], N === 255) {
            const xt = $[B++];
            if (xt) {
              if (xt === 220 && X) {
                B += 2;
                const St = (0, p.readUint16)($, B);
                if (B += 2, St > 0 && St !== C.scanLines) throw new a("Found DNL marker (0xFFDC) while parsing scan data", St);
              } else if (xt === 217) {
                if (X) {
                  const St = nt * (C.precision === 8 ? 8 : 0);
                  if (St > 0 && Math.round(C.scanLines / St) >= 5) throw new a("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", St);
                }
                throw new d("Found EOI marker (0xFFD9) while parsing scan data");
              }
              throw new n(`unexpected marker ${(N << 8 | xt).toString(16)}`);
            }
          }
          return V = 7, N >>> 7;
        }
        function Z(xt) {
          let St = xt;
          for (; ; ) {
            switch (St = St[Y()], typeof St) {
              case "number":
                return St;
              case "object":
                continue;
            }
            throw new n("invalid huffman sequence");
          }
        }
        function rt(xt) {
          let St = 0;
          for (; xt > 0; )
            St = St << 1 | Y(), xt--;
          return St;
        }
        function st(xt) {
          if (xt === 1) return Y() === 1 ? 1 : -1;
          const St = rt(xt);
          return St >= 1 << xt - 1 ? St : St + (-1 << xt) + 1;
        }
        let mt = 0, yt, at = 0, nt = 0;
        function q(xt, St, Mt, Et, Ft) {
          const Wt = Mt % L;
          nt = (Mt / L | 0) * xt.v + Et;
          const Kt = Wt * xt.h + Ft;
          St(xt, I(xt, nt, Kt));
        }
        function D(xt, St, Mt) {
          nt = Mt / xt.blocksPerLine | 0;
          const Et = Mt % xt.blocksPerLine;
          St(xt, I(xt, nt, Et));
        }
        const G = T.length;
        let et, J, it, lt, ot, ut;
        ut = H ? S === 0 ? U === 0 ? function(St, Mt) {
          const Et = Z(St.huffmanTableDC), Ft = Et === 0 ? 0 : st(Et) << K;
          St.blockData[Mt] = St.pred += Ft;
        } : function(St, Mt) {
          St.blockData[Mt] |= Y() << K;
        } : U === 0 ? function(St, Mt) {
          if (mt > 0) {
            mt--;
            return;
          }
          let Et = S;
          const Ft = A;
          for (; Et <= Ft; ) {
            const Wt = Z(St.huffmanTableAC), Kt = 15 & Wt, qt = Wt >> 4;
            if (Kt === 0) {
              if (qt < 15) {
                mt = rt(qt) + (1 << qt) - 1;
                break;
              }
              Et += 16;
              continue;
            }
            Et += qt;
            const It = m[Et];
            St.blockData[Mt + It] = st(Kt) * (1 << K), Et++;
          }
        } : function(St, Mt) {
          let Et = S;
          const Ft = A;
          let Wt, Kt, qt = 0;
          for (; Et <= Ft; ) {
            const It = Mt + m[Et], re = St.blockData[It] < 0 ? -1 : 1;
            switch (at) {
              case 0:
                if (Kt = Z(St.huffmanTableAC), Wt = 15 & Kt, qt = Kt >> 4, Wt === 0) qt < 15 ? (mt = rt(qt) + (1 << qt), at = 4) : (qt = 16, at = 1);
                else {
                  if (Wt !== 1) throw new n("invalid ACn encoding");
                  yt = st(Wt), at = qt ? 2 : 3;
                }
                continue;
              case 1:
              case 2:
                St.blockData[It] ? St.blockData[It] += re * (Y() << K) : (qt--, qt === 0 && (at = at === 2 ? 3 : 0));
                break;
              case 3:
                St.blockData[It] ? St.blockData[It] += re * (Y() << K) : (St.blockData[It] = yt << K, at = 0);
                break;
              case 4:
                St.blockData[It] && (St.blockData[It] += re * (Y() << K));
            }
            Et++;
          }
          at === 4 && (mt--, mt === 0 && (at = 0));
        } : function(St, Mt) {
          const Et = Z(St.huffmanTableDC), Ft = Et === 0 ? 0 : st(Et);
          St.blockData[Mt] = St.pred += Ft;
          let Wt = 1;
          for (; Wt < 64; ) {
            const Kt = Z(St.huffmanTableAC), qt = 15 & Kt, It = Kt >> 4;
            if (qt === 0) {
              if (It < 15) break;
              Wt += 16;
              continue;
            }
            Wt += It;
            const re = m[Wt];
            St.blockData[Mt + re] = st(qt), Wt++;
          }
        };
        let ct, gt = 0;
        const dt = G === 1 ? T[0].blocksPerLine * T[0].blocksPerColumn : L * C.mcusPerColumn;
        let bt, vt;
        for (; gt <= dt; ) {
          const xt = F ? Math.min(dt - gt, F) : dt;
          if (xt > 0) {
            for (J = 0; J < G; J++) T[J].pred = 0;
            if (mt = 0, G === 1)
              for (et = T[0], ot = 0; ot < xt; ot++)
                D(et, ut, gt), gt++;
            else for (ot = 0; ot < xt; ot++) {
              for (J = 0; J < G; J++)
                for (et = T[J], bt = et.h, vt = et.v, it = 0; it < vt; it++) for (lt = 0; lt < bt; lt++) q(et, ut, gt, it, lt);
              gt++;
            }
          }
          if (V = 0, ct = j($, B), !ct) break;
          if (ct.invalid) {
            const St = xt > 0 ? "unexpected" : "excessive";
            (0, o.warn)(`decodeScan - ${St} MCU data, current marker is: ${ct.invalid}`), B = ct.offset;
          }
          if (!(ct.marker >= 65488 && ct.marker <= 65495)) break;
          B += 2;
        }
        return B - Q;
      }
      function W($, B, C) {
        const T = $.quantizationTable, F = $.blockData;
        let S, A, U, K, X, L, H, Q, N, V, Y, Z, rt, st, mt, yt, at;
        if (!T) throw new n("missing required Quantization Table.");
        for (let nt = 0; nt < 64; nt += 8)
          N = F[B + nt], V = F[B + nt + 1], Y = F[B + nt + 2], Z = F[B + nt + 3], rt = F[B + nt + 4], st = F[B + nt + 5], mt = F[B + nt + 6], yt = F[B + nt + 7], N *= T[nt], V | Y | Z | rt | st | mt | yt ? (V *= T[nt + 1], Y *= T[nt + 2], Z *= T[nt + 3], rt *= T[nt + 4], st *= T[nt + 5], mt *= T[nt + 6], yt *= T[nt + 7], S = M * N + 128 >> 8, A = M * rt + 128 >> 8, U = Y, K = mt, X = O * (V - yt) + 128 >> 8, Q = O * (V + yt) + 128 >> 8, L = Z << 4, H = st << 4, S = S + A + 1 >> 1, A = S - A, at = U * _ + K * x + 128 >> 8, U = U * x - K * _ + 128 >> 8, K = at, X = X + H + 1 >> 1, H = X - H, Q = Q + L + 1 >> 1, L = Q - L, S = S + K + 1 >> 1, K = S - K, A = A + U + 1 >> 1, U = A - U, at = X * h + Q * v + 2048 >> 12, X = X * v - Q * h + 2048 >> 12, Q = at, at = L * w + H * b + 2048 >> 12, L = L * b - H * w + 2048 >> 12, H = at, C[nt] = S + Q, C[nt + 7] = S - Q, C[nt + 1] = A + H, C[nt + 6] = A - H, C[nt + 2] = U + L, C[nt + 5] = U - L, C[nt + 3] = K + X, C[nt + 4] = K - X) : (at = M * N + 512 >> 10, C[nt] = at, C[nt + 1] = at, C[nt + 2] = at, C[nt + 3] = at, C[nt + 4] = at, C[nt + 5] = at, C[nt + 6] = at, C[nt + 7] = at);
        for (let nt = 0; nt < 8; ++nt)
          N = C[nt], V = C[nt + 8], Y = C[nt + 16], Z = C[nt + 24], rt = C[nt + 32], st = C[nt + 40], mt = C[nt + 48], yt = C[nt + 56], V | Y | Z | rt | st | mt | yt ? (S = M * N + 2048 >> 12, A = M * rt + 2048 >> 12, U = Y, K = mt, X = O * (V - yt) + 2048 >> 12, Q = O * (V + yt) + 2048 >> 12, L = Z, H = st, S = 4112 + (S + A + 1 >> 1), A = S - A, at = U * _ + K * x + 2048 >> 12, U = U * x - K * _ + 2048 >> 12, K = at, X = X + H + 1 >> 1, H = X - H, Q = Q + L + 1 >> 1, L = Q - L, S = S + K + 1 >> 1, K = S - K, A = A + U + 1 >> 1, U = A - U, at = X * h + Q * v + 2048 >> 12, X = X * v - Q * h + 2048 >> 12, Q = at, at = L * w + H * b + 2048 >> 12, L = L * b - H * w + 2048 >> 12, H = at, N = S + Q, yt = S - Q, V = A + H, mt = A - H, Y = U + L, st = U - L, Z = K + X, rt = K - X, N < 16 ? N = 0 : N >= 4080 ? N = 255 : N >>= 4, V < 16 ? V = 0 : V >= 4080 ? V = 255 : V >>= 4, Y < 16 ? Y = 0 : Y >= 4080 ? Y = 255 : Y >>= 4, Z < 16 ? Z = 0 : Z >= 4080 ? Z = 255 : Z >>= 4, rt < 16 ? rt = 0 : rt >= 4080 ? rt = 255 : rt >>= 4, st < 16 ? st = 0 : st >= 4080 ? st = 255 : st >>= 4, mt < 16 ? mt = 0 : mt >= 4080 ? mt = 255 : mt >>= 4, yt < 16 ? yt = 0 : yt >= 4080 ? yt = 255 : yt >>= 4, F[B + nt] = N, F[B + nt + 8] = V, F[B + nt + 16] = Y, F[B + nt + 24] = Z, F[B + nt + 32] = rt, F[B + nt + 40] = st, F[B + nt + 48] = mt, F[B + nt + 56] = yt) : (at = M * N + 8192 >> 14, at = at < -2040 ? 0 : at >= 2024 ? 255 : at + 2056 >> 4, F[B + nt] = at, F[B + nt + 8] = at, F[B + nt + 16] = at, F[B + nt + 24] = at, F[B + nt + 32] = at, F[B + nt + 40] = at, F[B + nt + 48] = at, F[B + nt + 56] = at);
      }
      function z($, B) {
        const C = B.blocksPerLine, T = B.blocksPerColumn, F = new Int16Array(64);
        for (let S = 0; S < T; S++) for (let A = 0; A < C; A++)
          W(B, I(B, S, A), F);
        return B.blockData;
      }
      function j($, B, C = B) {
        const T = $.length - 1;
        let F = C < B ? C : B;
        if (B >= T) return null;
        const S = (0, p.readUint16)($, B);
        if (S >= 65472 && S <= 65534) return { invalid: null, marker: S, offset: B };
        let A = (0, p.readUint16)($, F);
        for (; !(A >= 65472 && A <= 65534); ) {
          if (++F >= T) return null;
          A = (0, p.readUint16)($, F);
        }
        return { invalid: S.toString(16), marker: A, offset: F };
      }
      l.JpegImage = class {
        constructor({ decodeTransform: B = null, colorTransform: C = -1 } = {}) {
          this._decodeTransform = B, this._colorTransform = C;
        }
        parse(B, { dnlScanLines: C = null } = {}) {
          function T() {
            const Y = (0, p.readUint16)(B, U);
            U += 2;
            let Z = U + Y - 2;
            const rt = j(B, Z, U);
            rt != null && rt.invalid && ((0, o.warn)("readDataBlock - incorrect length, current marker is: " + rt.invalid), Z = rt.offset);
            const st = B.subarray(U, Z);
            return U += st.length, st;
          }
          function F(Y) {
            const Z = Math.ceil(Y.samplesPerLine / 8 / Y.maxH), rt = Math.ceil(Y.scanLines / 8 / Y.maxV);
            for (const st of Y.components) {
              const mt = Math.ceil(Math.ceil(Y.samplesPerLine / 8) * st.h / Y.maxH), yt = Math.ceil(Math.ceil(Y.scanLines / 8) * st.v / Y.maxV), at = Z * st.h, nt = 64 * (rt * st.v) * (at + 1);
              st.blockData = new Int16Array(nt), st.blocksPerLine = mt, st.blocksPerColumn = yt;
            }
            Y.mcusPerLine = Z, Y.mcusPerColumn = rt;
          }
          let S, A, U = 0, K = null, X = null, L = 0;
          const H = [], Q = [], N = [];
          let V = (0, p.readUint16)(B, U);
          if (U += 2, V !== 65496) throw new n("SOI not found");
          V = (0, p.readUint16)(B, U), U += 2;
          t: for (; V !== 65497; ) {
            let Y, Z, rt;
            switch (V) {
              case 65504:
              case 65505:
              case 65506:
              case 65507:
              case 65508:
              case 65509:
              case 65510:
              case 65511:
              case 65512:
              case 65513:
              case 65514:
              case 65515:
              case 65516:
              case 65517:
              case 65518:
              case 65519:
              case 65534:
                const st = T();
                V === 65504 && st[0] === 74 && st[1] === 70 && st[2] === 73 && st[3] === 70 && st[4] === 0 && (K = { version: { major: st[5], minor: st[6] }, densityUnits: st[7], xDensity: st[8] << 8 | st[9], yDensity: st[10] << 8 | st[11], thumbWidth: st[12], thumbHeight: st[13], thumbData: st.subarray(14, 14 + 3 * st[12] * st[13]) }), V === 65518 && st[0] === 65 && st[1] === 100 && st[2] === 111 && st[3] === 98 && st[4] === 101 && (X = { version: st[5] << 8 | st[6], flags0: st[7] << 8 | st[8], flags1: st[9] << 8 | st[10], transformCode: st[11] });
                break;
              case 65499:
                const mt = (0, p.readUint16)(B, U);
                U += 2;
                const yt = mt + U - 2;
                let at;
                for (; U < yt; ) {
                  const dt = B[U++], bt = new Uint16Array(64);
                  if (dt >> 4) {
                    if (dt >> 4 != 1) throw new n("DQT - invalid table spec");
                    for (Z = 0; Z < 64; Z++)
                      at = m[Z], bt[at] = (0, p.readUint16)(B, U), U += 2;
                  } else
                    for (Z = 0; Z < 64; Z++)
                      at = m[Z], bt[at] = B[U++];
                  H[15 & dt] = bt;
                }
                break;
              case 65472:
              case 65473:
              case 65474:
                if (S) throw new n("Only single frame JPEGs supported");
                U += 2, S = {}, S.extended = V === 65473, S.progressive = V === 65474, S.precision = B[U++];
                const nt = (0, p.readUint16)(B, U);
                U += 2, S.scanLines = C || nt, S.samplesPerLine = (0, p.readUint16)(B, U), U += 2, S.components = [], S.componentIds = {};
                const q = B[U++];
                let D = 0, G = 0;
                for (Y = 0; Y < q; Y++) {
                  const dt = B[U], bt = B[U + 1] >> 4, vt = 15 & B[U + 1];
                  D < bt && (D = bt), G < vt && (G = vt);
                  const xt = B[U + 2];
                  rt = S.components.push({ h: bt, v: vt, quantizationId: xt, quantizationTable: null }), S.componentIds[dt] = rt - 1, U += 3;
                }
                S.maxH = D, S.maxV = G, F(S);
                break;
              case 65476:
                const et = (0, p.readUint16)(B, U);
                for (U += 2, Y = 2; Y < et; ) {
                  const dt = B[U++], bt = new Uint8Array(16);
                  let vt = 0;
                  for (Z = 0; Z < 16; Z++, U++) vt += bt[Z] = B[U];
                  const xt = new Uint8Array(vt);
                  for (Z = 0; Z < vt; Z++, U++) xt[Z] = B[U];
                  Y += 17 + vt, (dt >> 4 ? Q : N)[15 & dt] = E(bt, xt);
                }
                break;
              case 65501:
                U += 2, A = (0, p.readUint16)(B, U), U += 2;
                break;
              case 65498:
                const J = ++L == 1 && !C;
                U += 2;
                const it = B[U++], lt = [];
                for (Y = 0; Y < it; Y++) {
                  const dt = B[U++], bt = S.componentIds[dt], vt = S.components[bt];
                  vt.index = dt;
                  const xt = B[U++];
                  vt.huffmanTableDC = N[xt >> 4], vt.huffmanTableAC = Q[15 & xt], lt.push(vt);
                }
                const ot = B[U++], ut = B[U++], ct = B[U++];
                try {
                  const dt = R(B, U, S, lt, A, ot, ut, ct >> 4, 15 & ct, J);
                  U += dt;
                } catch (dt) {
                  if (dt instanceof a)
                    return (0, o.warn)(`${dt.message} -- attempting to re-parse the JPEG image.`), this.parse(B, { dnlScanLines: dt.scanLines });
                  if (dt instanceof d) {
                    (0, o.warn)(`${dt.message} -- ignoring the rest of the image data.`);
                    break t;
                  }
                  throw dt;
                }
                break;
              case 65500:
                U += 4;
                break;
              case 65535:
                B[U] !== 255 && U--;
                break;
              default:
                const gt = j(B, U - 2, U - 3);
                if (gt != null && gt.invalid) {
                  (0, o.warn)("JpegImage.parse - unexpected data, current marker is: " + gt.invalid), U = gt.offset;
                  break;
                }
                if (!gt || U >= B.length - 1) {
                  (0, o.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                  break t;
                }
                throw new n("JpegImage.parse - unknown marker: " + V.toString(16));
            }
            V = (0, p.readUint16)(B, U), U += 2;
          }
          this.width = S.samplesPerLine, this.height = S.scanLines, this.jfif = K, this.adobe = X, this.components = [];
          for (const Y of S.components) {
            const Z = H[Y.quantizationId];
            Z && (Y.quantizationTable = Z), this.components.push({ index: Y.index, output: z(0, Y), scaleX: Y.h / S.maxH, scaleY: Y.v / S.maxV, blocksPerLine: Y.blocksPerLine, blocksPerColumn: Y.blocksPerColumn });
          }
          this.numComponents = this.components.length;
        }
        _getLinearizedBlockData(B, C, T = !1) {
          const F = this.width / B, S = this.height / C;
          let A, U, K, X, L, H, Q, N, V, Y, Z, rt = 0;
          const st = this.components.length, mt = B * C * st, yt = new Uint8ClampedArray(mt), at = new Uint32Array(B), nt = 4294967288;
          let q;
          for (Q = 0; Q < st; Q++) {
            if (A = this.components[Q], U = A.scaleX * F, K = A.scaleY * S, rt = Q, Z = A.output, X = A.blocksPerLine + 1 << 3, U !== q) {
              for (L = 0; L < B; L++)
                N = 0 | L * U, at[L] = (N & nt) << 3 | 7 & N;
              q = U;
            }
            for (H = 0; H < C; H++)
              for (N = 0 | H * K, Y = X * (N & nt) | (7 & N) << 3, L = 0; L < B; L++)
                yt[rt] = Z[Y + at[L]], rt += st;
          }
          let D = this._decodeTransform;
          if (T || st !== 4 || D || (D = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), D) for (Q = 0; Q < mt; ) for (N = 0, V = 0; N < st; N++, Q++, V += 2) yt[Q] = (yt[Q] * D[V] >> 8) + D[V + 1];
          return yt;
        }
        get _isColorConversionNeeded() {
          return this.adobe ? !!this.adobe.transformCode : this.numComponents === 3 ? this._colorTransform !== 0 && (this.components[0].index !== 82 || this.components[1].index !== 71 || this.components[2].index !== 66) : this._colorTransform === 1;
        }
        _convertYccToRgb(B) {
          let C, T, F;
          for (let S = 0, A = B.length; S < A; S += 3)
            C = B[S], T = B[S + 1], F = B[S + 2], B[S] = C - 179.456 + 1.402 * F, B[S + 1] = C + 135.459 - 0.344 * T - 0.714 * F, B[S + 2] = C - 226.816 + 1.772 * T;
          return B;
        }
        _convertYccToRgba(B, C) {
          for (let T = 0, F = 0, S = B.length; T < S; T += 3, F += 4) {
            const A = B[T], U = B[T + 1], K = B[T + 2];
            C[F] = A - 179.456 + 1.402 * K, C[F + 1] = A + 135.459 - 0.344 * U - 0.714 * K, C[F + 2] = A - 226.816 + 1.772 * U, C[F + 3] = 255;
          }
          return C;
        }
        _convertYcckToRgb(B) {
          let C, T, F, S, A = 0;
          for (let U = 0, K = B.length; U < K; U += 4)
            C = B[U], T = B[U + 1], F = B[U + 2], S = B[U + 3], B[A++] = T * (-660635669420364e-19 * T + 437130475926232e-18 * F - 54080610064599e-18 * C + 48449797120281e-17 * S - 0.154362151871126) - 122.67195406894 + F * (-957964378445773e-18 * F + 817076911346625e-18 * C - 0.00477271405408747 * S + 1.53380253221734) + C * (961250184130688e-18 * C - 0.00266257332283933 * S + 0.48357088451265) + S * (-336197177618394e-18 * S + 0.484791561490776), B[A++] = 107.268039397724 + T * (219927104525741e-19 * T - 640992018297945e-18 * F + 659397001245577e-18 * C + 426105652938837e-18 * S - 0.176491792462875) + F * (-778269941513683e-18 * F + 0.00130872261408275 * C + 770482631801132e-18 * S - 0.151051492775562) + C * (0.00126935368114843 * C - 0.00265090189010898 * S + 0.25802910206845) + S * (-318913117588328e-18 * S - 0.213742400323665), B[A++] = T * (-570115196973677e-18 * T - 263409051004589e-19 * F + 0.0020741088115012 * C - 0.00288260236853442 * S + 0.814272968359295) - 20.810012546947 + F * (-153496057440975e-19 * F - 132689043961446e-18 * C + 560833691242812e-18 * S - 0.195152027534049) + C * (0.00174418132927582 * C - 0.00255243321439347 * S + 0.116935020465145) + S * (-343531996510555e-18 * S + 0.24165260232407);
          return B.subarray(0, A);
        }
        _convertYcckToRgba(B) {
          for (let C = 0, T = B.length; C < T; C += 4) {
            const F = B[C], S = B[C + 1], A = B[C + 2], U = B[C + 3];
            B[C] = S * (-660635669420364e-19 * S + 437130475926232e-18 * A - 54080610064599e-18 * F + 48449797120281e-17 * U - 0.154362151871126) - 122.67195406894 + A * (-957964378445773e-18 * A + 817076911346625e-18 * F - 0.00477271405408747 * U + 1.53380253221734) + F * (961250184130688e-18 * F - 0.00266257332283933 * U + 0.48357088451265) + U * (-336197177618394e-18 * U + 0.484791561490776), B[C + 1] = 107.268039397724 + S * (219927104525741e-19 * S - 640992018297945e-18 * A + 659397001245577e-18 * F + 426105652938837e-18 * U - 0.176491792462875) + A * (-778269941513683e-18 * A + 0.00130872261408275 * F + 770482631801132e-18 * U - 0.151051492775562) + F * (0.00126935368114843 * F - 0.00265090189010898 * U + 0.25802910206845) + U * (-318913117588328e-18 * U - 0.213742400323665), B[C + 2] = S * (-570115196973677e-18 * S - 263409051004589e-19 * A + 0.0020741088115012 * F - 0.00288260236853442 * U + 0.814272968359295) - 20.810012546947 + A * (-153496057440975e-19 * A - 132689043961446e-18 * F + 560833691242812e-18 * U - 0.195152027534049) + F * (0.00174418132927582 * F - 0.00255243321439347 * U + 0.116935020465145) + U * (-343531996510555e-18 * U + 0.24165260232407), B[C + 3] = 255;
          }
          return B;
        }
        _convertYcckToCmyk(B) {
          let C, T, F;
          for (let S = 0, A = B.length; S < A; S += 4)
            C = B[S], T = B[S + 1], F = B[S + 2], B[S] = 434.456 - C - 1.402 * F, B[S + 1] = 119.541 - C + 0.344 * T + 0.714 * F, B[S + 2] = 481.816 - C - 1.772 * T;
          return B;
        }
        _convertCmykToRgb(B) {
          let C, T, F, S, A = 0;
          for (let U = 0, K = B.length; U < K; U += 4)
            C = B[U], T = B[U + 1], F = B[U + 2], S = B[U + 3], B[A++] = 255 + C * (-6747147073602441e-20 * C + 8379262121013727e-19 * T + 2894718188643294e-19 * F + 0.003264231057537806 * S - 1.1185611867203937) + T * (26374107616089405e-21 * T - 8626949158638572e-20 * F - 2748769067499491e-19 * S - 0.02155688794978967) + F * (-3878099212869363e-20 * F - 3267808279485286e-19 * S + 0.0686742238595345) - S * (3361971776183937e-19 * S + 0.7430659151342254), B[A++] = 255 + C * (13596372813588848e-20 * C + 924537132573585e-18 * T + 10567359618683593e-20 * F + 4791864687436512e-19 * S - 0.3109689587515875) + T * (-23545346108370344e-20 * T + 2702845253534714e-19 * F + 0.0020200308977307156 * S - 0.7488052167015494) + F * (6834815998235662e-20 * F + 15168452363460973e-20 * S - 0.09751927774728933) - S * (3189131175883281e-19 * S + 0.7364883807733168), B[A++] = 255 + C * (13598650411385307e-21 * C + 12423956175490851e-20 * T + 4751985097583589e-19 * F - 36729317476630422e-22 * S - 0.05562186980264034) + T * (16141380598724676e-20 * T + 9692239130725186e-19 * F + 7782692450036253e-19 * S - 0.44015232367526463) + F * (5068882914068769e-22 * F + 0.0017778369011375071 * S - 0.7591454649749609) - S * (3435319965105553e-19 * S + 0.7063770186160144);
          return B.subarray(0, A);
        }
        _convertCmykToRgba(B) {
          for (let C = 0, T = B.length; C < T; C += 4) {
            const F = B[C], S = B[C + 1], A = B[C + 2], U = B[C + 3];
            B[C] = 255 + F * (-6747147073602441e-20 * F + 8379262121013727e-19 * S + 2894718188643294e-19 * A + 0.003264231057537806 * U - 1.1185611867203937) + S * (26374107616089405e-21 * S - 8626949158638572e-20 * A - 2748769067499491e-19 * U - 0.02155688794978967) + A * (-3878099212869363e-20 * A - 3267808279485286e-19 * U + 0.0686742238595345) - U * (3361971776183937e-19 * U + 0.7430659151342254), B[C + 1] = 255 + F * (13596372813588848e-20 * F + 924537132573585e-18 * S + 10567359618683593e-20 * A + 4791864687436512e-19 * U - 0.3109689587515875) + S * (-23545346108370344e-20 * S + 2702845253534714e-19 * A + 0.0020200308977307156 * U - 0.7488052167015494) + A * (6834815998235662e-20 * A + 15168452363460973e-20 * U - 0.09751927774728933) - U * (3189131175883281e-19 * U + 0.7364883807733168), B[C + 2] = 255 + F * (13598650411385307e-21 * F + 12423956175490851e-20 * S + 4751985097583589e-19 * A - 36729317476630422e-22 * U - 0.05562186980264034) + S * (16141380598724676e-20 * S + 9692239130725186e-19 * A + 7782692450036253e-19 * U - 0.44015232367526463) + A * (5068882914068769e-22 * A + 0.0017778369011375071 * U - 0.7591454649749609) - U * (3435319965105553e-19 * U + 0.7063770186160144), B[C + 3] = 255;
          }
          return B;
        }
        getData({ width: B, height: C, forceRGBA: T = !1, forceRGB: F = !1, isSourcePDF: S = !1 }) {
          if (this.numComponents > 4) throw new n("Unsupported color mode");
          const A = this._getLinearizedBlockData(B, C, S);
          if (this.numComponents === 1 && (T || F)) {
            const U = A.length * (T ? 4 : 3), K = new Uint8ClampedArray(U);
            let X = 0;
            if (T) (0, g.grayToRGBA)(A, new Uint32Array(K.buffer));
            else for (const L of A)
              K[X++] = L, K[X++] = L, K[X++] = L;
            return K;
          }
          if (this.numComponents === 3 && this._isColorConversionNeeded) {
            if (T) {
              const U = new Uint8ClampedArray(A.length / 3 * 4);
              return this._convertYccToRgba(A, U);
            }
            return this._convertYccToRgb(A);
          }
          if (this.numComponents === 4) {
            if (this._isColorConversionNeeded) return T ? this._convertYcckToRgba(A) : F ? this._convertYcckToRgb(A) : this._convertYcckToCmyk(A);
            if (T) return this._convertCmykToRgba(A);
            if (F) return this._convertCmykToRgb(A);
          }
          return A;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.convertBlackAndWhiteToRGBA = g, l.convertToRGBA = function(n) {
        switch (n.kind) {
          case o.ImageKind.GRAYSCALE_1BPP:
            return g(n);
          case o.ImageKind.RGB_24BPP:
            return function({ src: d, srcPos: m = 0, dest: b, destPos: w = 0, width: v, height: h }) {
              let x = 0;
              const _ = d.length >> 2, M = new Uint32Array(d.buffer, m, _);
              if (o.FeatureTest.isLittleEndian) {
                for (; x < _ - 2; x += 3, w += 4) {
                  const O = M[x], E = M[x + 1], I = M[x + 2];
                  b[w] = 4278190080 | O, b[w + 1] = O >>> 24 | E << 8 | 4278190080, b[w + 2] = E >>> 16 | I << 16 | 4278190080, b[w + 3] = I >>> 8 | 4278190080;
                }
                for (let O = 4 * x, E = d.length; O < E; O += 3) b[w++] = d[O] | d[O + 1] << 8 | d[O + 2] << 16 | 4278190080;
              } else {
                for (; x < _ - 2; x += 3, w += 4) {
                  const O = M[x], E = M[x + 1], I = M[x + 2];
                  b[w] = 255 | O, b[w + 1] = O << 24 | E >>> 8 | 255, b[w + 2] = E << 16 | I >>> 16 | 255, b[w + 3] = I << 8 | 255;
                }
                for (let O = 4 * x, E = d.length; O < E; O += 3) b[w++] = d[O] << 24 | d[O + 1] << 16 | d[O + 2] << 8 | 255;
              }
              return { srcPos: m, destPos: w };
            }(n);
        }
        return null;
      }, l.grayToRGBA = function(n, a) {
        if (o.FeatureTest.isLittleEndian) for (let d = 0, m = n.length; d < m; d++) a[d] = 65793 * n[d] | 4278190080;
        else for (let d = 0, m = n.length; d < m; d++) a[d] = 16843008 * n[d] | 255;
      };
      var o = f(2);
      function g({ src: p, srcPos: n = 0, dest: a, width: d, height: m, nonBlackColor: b = 4294967295, inverseDecode: w = !1 }) {
        const v = o.FeatureTest.isLittleEndian ? 4278190080 : 255, [h, x] = w ? [b, v] : [v, b], _ = d >> 3, M = 7 & d, O = p.length;
        a = new Uint32Array(a.buffer);
        let E = 0;
        for (let I = 0; I < m; I++) {
          for (const W = n + _; n < W; n++) {
            const z = n < O ? p[n] : 255;
            a[E++] = 128 & z ? x : h, a[E++] = 64 & z ? x : h, a[E++] = 32 & z ? x : h, a[E++] = 16 & z ? x : h, a[E++] = 8 & z ? x : h, a[E++] = 4 & z ? x : h, a[E++] = 2 & z ? x : h, a[E++] = 1 & z ? x : h;
          }
          if (M === 0) continue;
          const R = n < O ? p[n++] : 255;
          for (let W = 0; W < M; W++) a[E++] = R & 1 << 7 - W ? x : h;
        }
        return { srcPos: n, destPos: E };
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.JpxStream = void 0;
      var o = f(18), g = f(30), p = f(2);
      class n extends o.DecodeStream {
        constructor(d, m, b) {
          super(m), this.stream = d, this.dict = d.dict, this.maybeLength = m, this.params = b;
        }
        get bytes() {
          return (0, p.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
        }
        ensureBuffer(d) {
        }
        readBlock() {
          if (this.eof) return;
          const d = new g.JpxImage();
          d.parse(this.bytes);
          const m = d.width, b = d.height, w = d.componentsCount, v = d.tiles.length;
          if (v === 1) this.buffer = d.tiles[0].items;
          else {
            const h = new Uint8ClampedArray(m * b * w);
            for (let x = 0; x < v; x++) {
              const _ = d.tiles[x], M = _.width, O = _.height, E = _.left, I = _.top, R = _.items;
              let W = 0, z = (m * I + E) * w;
              const j = m * w, $ = M * w;
              for (let B = 0; B < O; B++) {
                const C = R.subarray(W, W + $);
                h.set(C, z), W += $, z += j;
              }
            }
            this.buffer = h;
          }
          this.bufferLength = this.buffer.length, this.eof = !0;
        }
      }
      l.JpxStream = n;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.JpxImage = void 0;
      var o = f(2), g = f(3), p = f(25);
      class n extends o.BaseException {
        constructor(L) {
          super(`JPX error: ${L}`, "JpxError");
        }
      }
      const a = { LL: 0, LH: 1, HL: 1, HH: 2 };
      l.JpxImage = class {
        constructor() {
          this.failOnCorruptedImage = !1;
        }
        parse(L) {
          if ((0, g.readUint16)(L, 0) === 65359) {
            this.parseCodestream(L, 0, L.length);
            return;
          }
          const H = L.length;
          let Q = 0;
          for (; Q < H; ) {
            let N = 8, V = (0, g.readUint32)(L, Q);
            const Y = (0, g.readUint32)(L, Q + 4);
            if (Q += N, V === 1 && (V = 4294967296 * (0, g.readUint32)(L, Q) + (0, g.readUint32)(L, Q + 4), Q += 8, N += 8), V === 0 && (V = H - Q + N), V < N) throw new n("Invalid box field size");
            const Z = V - N;
            let rt = !0;
            switch (Y) {
              case 1785737832:
                rt = !1;
                break;
              case 1668246642:
                const st = L[Q];
                if (st === 1) {
                  const yt = (0, g.readUint32)(L, Q + 3);
                  switch (yt) {
                    case 16:
                    case 17:
                    case 18:
                      break;
                    default:
                      (0, o.warn)("Unknown colorspace " + yt);
                  }
                } else st === 2 && (0, o.info)("ICC profile not supported");
                break;
              case 1785737827:
                this.parseCodestream(L, Q, Q + Z);
                break;
              case 1783636e3:
                (0, g.readUint32)(L, Q) !== 218793738 && (0, o.warn)("Invalid JP2 signature");
                break;
              case 1783634458:
              case 1718909296:
              case 1920099697:
              case 1919251232:
              case 1768449138:
                break;
              default:
                const mt = String.fromCharCode(Y >> 24 & 255, Y >> 16 & 255, Y >> 8 & 255, 255 & Y);
                (0, o.warn)(`Unsupported header type ${Y} (${mt}).`);
            }
            rt && (Q += Z);
          }
        }
        parseImageProperties(L) {
          let H = L.getByte();
          for (; H >= 0; ) {
            const Q = H;
            if (H = L.getByte(), (Q << 8 | H) === 65361) {
              L.skip(4);
              const N = L.getInt32() >>> 0, V = L.getInt32() >>> 0, Y = L.getInt32() >>> 0, Z = L.getInt32() >>> 0;
              L.skip(16);
              const rt = L.getUint16();
              this.width = N - Y, this.height = V - Z, this.componentsCount = rt, this.bitsPerComponent = 8;
              return;
            }
          }
          throw new n("No size marker found in JPX stream");
        }
        parseCodestream(L, H, Q) {
          const N = {};
          let V = !1;
          try {
            let Y = H;
            for (; Y + 1 < Q; ) {
              const Z = (0, g.readUint16)(L, Y);
              Y += 2;
              let rt, st, mt, yt, at, nt, q = 0;
              switch (Z) {
                case 65359:
                  N.mainHeader = !0;
                  break;
                case 65497:
                  break;
                case 65361:
                  q = (0, g.readUint16)(L, Y);
                  const D = {};
                  D.Xsiz = (0, g.readUint32)(L, Y + 4), D.Ysiz = (0, g.readUint32)(L, Y + 8), D.XOsiz = (0, g.readUint32)(L, Y + 12), D.YOsiz = (0, g.readUint32)(L, Y + 16), D.XTsiz = (0, g.readUint32)(L, Y + 20), D.YTsiz = (0, g.readUint32)(L, Y + 24), D.XTOsiz = (0, g.readUint32)(L, Y + 28), D.YTOsiz = (0, g.readUint32)(L, Y + 32);
                  const G = (0, g.readUint16)(L, Y + 36);
                  D.Csiz = G;
                  const et = [];
                  rt = Y + 38;
                  for (let dt = 0; dt < G; dt++) {
                    const bt = { precision: 1 + (127 & L[rt]), isSigned: !!(128 & L[rt]), XRsiz: L[rt + 1], YRsiz: L[rt + 2] };
                    rt += 3, d(bt, D), et.push(bt);
                  }
                  N.SIZ = D, N.components = et, m(N, et), N.QCC = [], N.COC = [];
                  break;
                case 65372:
                  q = (0, g.readUint16)(L, Y);
                  const J = {};
                  switch (rt = Y + 2, st = L[rt++], 31 & st) {
                    case 0:
                      yt = 8, at = !0;
                      break;
                    case 1:
                      yt = 16, at = !1;
                      break;
                    case 2:
                      yt = 16, at = !0;
                      break;
                    default:
                      throw new Error("Invalid SQcd value " + st);
                  }
                  for (J.noQuantization = yt === 8, J.scalarExpounded = at, J.guardBits = st >> 5, mt = []; rt < q + Y; ) {
                    const dt = {};
                    yt === 8 ? (dt.epsilon = L[rt++] >> 3, dt.mu = 0) : (dt.epsilon = L[rt] >> 3, dt.mu = (7 & L[rt]) << 8 | L[rt + 1], rt += 2), mt.push(dt);
                  }
                  J.SPqcds = mt, N.mainHeader ? N.QCD = J : (N.currentTile.QCD = J, N.currentTile.QCC = []);
                  break;
                case 65373:
                  q = (0, g.readUint16)(L, Y);
                  const it = {};
                  rt = Y + 2;
                  let lt;
                  switch (N.SIZ.Csiz < 257 ? lt = L[rt++] : (lt = (0, g.readUint16)(L, rt), rt += 2), st = L[rt++], 31 & st) {
                    case 0:
                      yt = 8, at = !0;
                      break;
                    case 1:
                      yt = 16, at = !1;
                      break;
                    case 2:
                      yt = 16, at = !0;
                      break;
                    default:
                      throw new Error("Invalid SQcd value " + st);
                  }
                  for (it.noQuantization = yt === 8, it.scalarExpounded = at, it.guardBits = st >> 5, mt = []; rt < q + Y; ) {
                    const dt = {};
                    yt === 8 ? (dt.epsilon = L[rt++] >> 3, dt.mu = 0) : (dt.epsilon = L[rt] >> 3, dt.mu = (7 & L[rt]) << 8 | L[rt + 1], rt += 2), mt.push(dt);
                  }
                  it.SPqcds = mt, N.mainHeader ? N.QCC[lt] = it : N.currentTile.QCC[lt] = it;
                  break;
                case 65362:
                  q = (0, g.readUint16)(L, Y);
                  const ot = {};
                  rt = Y + 2;
                  const ut = L[rt++];
                  ot.entropyCoderWithCustomPrecincts = !!(1 & ut), ot.sopMarkerUsed = !!(2 & ut), ot.ephMarkerUsed = !!(4 & ut), ot.progressionOrder = L[rt++], ot.layersCount = (0, g.readUint16)(L, rt), rt += 2, ot.multipleComponentTransform = L[rt++], ot.decompositionLevelsCount = L[rt++], ot.xcb = 2 + (15 & L[rt++]), ot.ycb = 2 + (15 & L[rt++]);
                  const ct = L[rt++];
                  if (ot.selectiveArithmeticCodingBypass = !!(1 & ct), ot.resetContextProbabilities = !!(2 & ct), ot.terminationOnEachCodingPass = !!(4 & ct), ot.verticallyStripe = !!(8 & ct), ot.predictableTermination = !!(16 & ct), ot.segmentationSymbolUsed = !!(32 & ct), ot.reversibleTransformation = L[rt++], ot.entropyCoderWithCustomPrecincts) {
                    const dt = [];
                    for (; rt < q + Y; ) {
                      const bt = L[rt++];
                      dt.push({ PPx: 15 & bt, PPy: bt >> 4 });
                    }
                    ot.precinctsSizes = dt;
                  }
                  const gt = [];
                  ot.selectiveArithmeticCodingBypass && gt.push("selectiveArithmeticCodingBypass"), ot.terminationOnEachCodingPass && gt.push("terminationOnEachCodingPass"), ot.verticallyStripe && gt.push("verticallyStripe"), ot.predictableTermination && gt.push("predictableTermination"), gt.length > 0 && (V = !0, (0, o.warn)(`JPX: Unsupported COD options (${gt.join(", ")}).`)), N.mainHeader ? N.COD = ot : (N.currentTile.COD = ot, N.currentTile.COC = []);
                  break;
                case 65424:
                  q = (0, g.readUint16)(L, Y), nt = {}, nt.index = (0, g.readUint16)(L, Y + 2), nt.length = (0, g.readUint32)(L, Y + 4), nt.dataEnd = nt.length + Y - 2, nt.partIndex = L[Y + 8], nt.partsCount = L[Y + 9], N.mainHeader = !1, nt.partIndex === 0 && (nt.COD = N.COD, nt.COC = N.COC.slice(0), nt.QCD = N.QCD, nt.QCC = N.QCC.slice(0)), N.currentTile = nt;
                  break;
                case 65427:
                  nt = N.currentTile, nt.partIndex === 0 && (B(N, nt.index), W(N)), q = nt.dataEnd - Y, z(N, L, Y, q);
                  break;
                case 65363:
                  (0, o.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                case 65365:
                case 65367:
                case 65368:
                case 65380:
                  q = (0, g.readUint16)(L, Y);
                  break;
                default:
                  throw new Error("Unknown codestream code: " + Z.toString(16));
              }
              Y += q;
            }
          } catch (Y) {
            if (V || this.failOnCorruptedImage) throw new n(Y.message);
            (0, o.warn)(`JPX: Trying to recover from: "${Y.message}".`);
          }
          this.tiles = function(Z) {
            const rt = Z.SIZ, st = Z.components, mt = rt.Csiz, yt = [];
            for (let at = 0, nt = Z.tiles.length; at < nt; at++) {
              const q = Z.tiles[at], D = [];
              for (let vt = 0; vt < mt; vt++) D[vt] = $(Z, q, vt);
              const G = D[0], et = new Uint8ClampedArray(G.items.length * mt), J = { left: G.left, top: G.top, width: G.width, height: G.height, items: et };
              let it, lt, ot, ut, ct, gt, dt, bt = 0;
              if (q.codingStyleDefaultParameters.multipleComponentTransform) {
                const vt = mt === 4, xt = D[0].items, St = D[1].items, Mt = D[2].items, Et = vt ? D[3].items : null;
                it = st[0].precision - 8, lt = 0.5 + (128 << it);
                const Ft = q.components[0], Wt = mt - 3;
                if (ut = xt.length, Ft.codingStyleParameters.reversibleTransformation) for (ot = 0; ot < ut; ot++, bt += Wt) {
                  ct = xt[ot] + lt, gt = St[ot], dt = Mt[ot];
                  const Kt = ct - (dt + gt >> 2);
                  et[bt++] = Kt + dt >> it, et[bt++] = Kt >> it, et[bt++] = Kt + gt >> it;
                }
                else for (ot = 0; ot < ut; ot++, bt += Wt)
                  ct = xt[ot] + lt, gt = St[ot], dt = Mt[ot], et[bt++] = ct + 1.402 * dt >> it, et[bt++] = ct - 0.34413 * gt - 0.71414 * dt >> it, et[bt++] = ct + 1.772 * gt >> it;
                if (vt) for (ot = 0, bt = 3; ot < ut; ot++, bt += 4) et[bt] = Et[ot] + lt >> it;
              } else for (let vt = 0; vt < mt; vt++) {
                const xt = D[vt].items;
                for (it = st[vt].precision - 8, lt = 0.5 + (128 << it), bt = vt, ot = 0, ut = xt.length; ot < ut; ot++)
                  et[bt] = xt[ot] + lt >> it, bt += mt;
              }
              yt.push(J);
            }
            return yt;
          }(N), this.width = N.SIZ.Xsiz - N.SIZ.XOsiz, this.height = N.SIZ.Ysiz - N.SIZ.YOsiz, this.componentsCount = N.SIZ.Csiz;
        }
      };
      function d(X, L) {
        X.x0 = Math.ceil(L.XOsiz / X.XRsiz), X.x1 = Math.ceil(L.Xsiz / X.XRsiz), X.y0 = Math.ceil(L.YOsiz / X.YRsiz), X.y1 = Math.ceil(L.Ysiz / X.YRsiz), X.width = X.x1 - X.x0, X.height = X.y1 - X.y0;
      }
      function m(X, L) {
        const H = X.SIZ, Q = [];
        let N;
        const V = Math.ceil((H.Xsiz - H.XTOsiz) / H.XTsiz), Y = Math.ceil((H.Ysiz - H.YTOsiz) / H.YTsiz);
        for (let Z = 0; Z < Y; Z++) for (let rt = 0; rt < V; rt++)
          N = {}, N.tx0 = Math.max(H.XTOsiz + rt * H.XTsiz, H.XOsiz), N.ty0 = Math.max(H.YTOsiz + Z * H.YTsiz, H.YOsiz), N.tx1 = Math.min(H.XTOsiz + (rt + 1) * H.XTsiz, H.Xsiz), N.ty1 = Math.min(H.YTOsiz + (Z + 1) * H.YTsiz, H.Ysiz), N.width = N.tx1 - N.tx0, N.height = N.ty1 - N.ty0, N.components = [], Q.push(N);
        X.tiles = Q;
        for (let Z = 0, rt = H.Csiz; Z < rt; Z++) {
          const st = L[Z];
          for (let mt = 0, yt = Q.length; mt < yt; mt++) {
            const at = {};
            N = Q[mt], at.tcx0 = Math.ceil(N.tx0 / st.XRsiz), at.tcy0 = Math.ceil(N.ty0 / st.YRsiz), at.tcx1 = Math.ceil(N.tx1 / st.XRsiz), at.tcy1 = Math.ceil(N.ty1 / st.YRsiz), at.width = at.tcx1 - at.tcx0, at.height = at.tcy1 - at.tcy0, N.components[Z] = at;
          }
        }
      }
      function b(X, L, H) {
        const Q = L.codingStyleParameters, N = {};
        return Q.entropyCoderWithCustomPrecincts ? (N.PPx = Q.precinctsSizes[H].PPx, N.PPy = Q.precinctsSizes[H].PPy) : (N.PPx = 15, N.PPy = 15), N.xcb_ = H > 0 ? Math.min(Q.xcb, N.PPx - 1) : Math.min(Q.xcb, N.PPx), N.ycb_ = H > 0 ? Math.min(Q.ycb, N.PPy - 1) : Math.min(Q.ycb, N.PPy), N;
      }
      function w(X, L, H) {
        const Q = 1 << H.PPx, N = 1 << H.PPy, V = L.resLevel === 0, Y = 1 << H.PPx + (V ? 0 : -1), Z = 1 << H.PPy + (V ? 0 : -1), rt = L.trx1 > L.trx0 ? Math.ceil(L.trx1 / Q) - Math.floor(L.trx0 / Q) : 0, st = L.try1 > L.try0 ? Math.ceil(L.try1 / N) - Math.floor(L.try0 / N) : 0, mt = rt * st;
        L.precinctParameters = { precinctWidth: Q, precinctHeight: N, numprecinctswide: rt, numprecinctshigh: st, numprecincts: mt, precinctWidthInSubband: Y, precinctHeightInSubband: Z };
      }
      function v(X, L, H) {
        const Q = H.xcb_, N = H.ycb_, V = 1 << Q, Y = 1 << N, Z = L.tbx0 >> Q, rt = L.tby0 >> N, st = L.tbx1 + V - 1 >> Q, mt = L.tby1 + Y - 1 >> N, yt = L.resolution.precinctParameters, at = [], nt = [];
        let q, D, G, et;
        for (D = rt; D < mt; D++) for (q = Z; q < st; q++) {
          if (G = { cbx: q, cby: D, tbx0: V * q, tby0: Y * D, tbx1: V * (q + 1), tby1: Y * (D + 1) }, G.tbx0_ = Math.max(L.tbx0, G.tbx0), G.tby0_ = Math.max(L.tby0, G.tby0), G.tbx1_ = Math.min(L.tbx1, G.tbx1), G.tby1_ = Math.min(L.tby1, G.tby1), et = Math.floor((G.tbx0_ - L.tbx0) / yt.precinctWidthInSubband) + Math.floor((G.tby0_ - L.tby0) / yt.precinctHeightInSubband) * yt.numprecinctswide, G.precinctNumber = et, G.subbandType = L.type, G.Lblock = 3, G.tbx1_ <= G.tbx0_ || G.tby1_ <= G.tby0_) continue;
          at.push(G);
          let J = nt[et];
          J !== void 0 ? (q < J.cbxMin ? J.cbxMin = q : q > J.cbxMax && (J.cbxMax = q), D < J.cbyMin ? J.cbxMin = D : D > J.cbyMax && (J.cbyMax = D)) : nt[et] = J = { cbxMin: q, cbyMin: D, cbxMax: q, cbyMax: D }, G.precinct = J;
        }
        L.codeblockParameters = { codeblockWidth: Q, codeblockHeight: N, numcodeblockwide: st - Z + 1, numcodeblockhigh: mt - rt + 1 }, L.codeblocks = at, L.precincts = nt;
      }
      function h(X, L, H) {
        const Q = [], N = X.subbands;
        for (let V = 0, Y = N.length; V < Y; V++) {
          const Z = N[V].codeblocks;
          for (let rt = 0, st = Z.length; rt < st; rt++) {
            const mt = Z[rt];
            mt.precinctNumber === L && Q.push(mt);
          }
        }
        return { layerNumber: H, codeblocks: Q };
      }
      function x(X) {
        const L = X.SIZ, H = X.currentTile.index, Q = X.tiles[H], N = Q.codingStyleDefaultParameters.layersCount, V = L.Csiz;
        let Y = 0;
        for (let yt = 0; yt < V; yt++) Y = Math.max(Y, Q.components[yt].codingStyleParameters.decompositionLevelsCount);
        let Z = 0, rt = 0, st = 0, mt = 0;
        this.nextPacket = function() {
          for (; Z < N; Z++) {
            for (; rt <= Y; rt++) {
              for (; st < V; st++) {
                const at = Q.components[st];
                if (rt > at.codingStyleParameters.decompositionLevelsCount) continue;
                const nt = at.resolutions[rt], q = nt.precinctParameters.numprecincts;
                for (; mt < q; ) {
                  const D = h(nt, mt, Z);
                  return mt++, D;
                }
                mt = 0;
              }
              st = 0;
            }
            rt = 0;
          }
          throw new n("Out of packets");
        };
      }
      function _(X) {
        const L = X.SIZ, H = X.currentTile.index, Q = X.tiles[H], N = Q.codingStyleDefaultParameters.layersCount, V = L.Csiz;
        let Y = 0;
        for (let yt = 0; yt < V; yt++) Y = Math.max(Y, Q.components[yt].codingStyleParameters.decompositionLevelsCount);
        let Z = 0, rt = 0, st = 0, mt = 0;
        this.nextPacket = function() {
          for (; Z <= Y; Z++) {
            for (; rt < N; rt++) {
              for (; st < V; st++) {
                const at = Q.components[st];
                if (Z > at.codingStyleParameters.decompositionLevelsCount) continue;
                const nt = at.resolutions[Z], q = nt.precinctParameters.numprecincts;
                for (; mt < q; ) {
                  const D = h(nt, mt, rt);
                  return mt++, D;
                }
                mt = 0;
              }
              st = 0;
            }
            rt = 0;
          }
          throw new n("Out of packets");
        };
      }
      function M(X) {
        const L = X.SIZ, H = X.currentTile.index, Q = X.tiles[H], N = Q.codingStyleDefaultParameters.layersCount, V = L.Csiz;
        let Y, Z, rt, st, mt = 0;
        for (rt = 0; rt < V; rt++) {
          const at = Q.components[rt];
          mt = Math.max(mt, at.codingStyleParameters.decompositionLevelsCount);
        }
        const yt = new Int32Array(mt + 1);
        for (Z = 0; Z <= mt; ++Z) {
          let at = 0;
          for (rt = 0; rt < V; ++rt) {
            const nt = Q.components[rt].resolutions;
            Z < nt.length && (at = Math.max(at, nt[Z].precinctParameters.numprecincts));
          }
          yt[Z] = at;
        }
        Y = 0, Z = 0, rt = 0, st = 0, this.nextPacket = function() {
          for (; Z <= mt; Z++) {
            for (; st < yt[Z]; st++) {
              for (; rt < V; rt++) {
                const nt = Q.components[rt];
                if (Z > nt.codingStyleParameters.decompositionLevelsCount) continue;
                const q = nt.resolutions[Z], D = q.precinctParameters.numprecincts;
                if (!(st >= D)) {
                  for (; Y < N; ) {
                    const G = h(q, st, Y);
                    return Y++, G;
                  }
                  Y = 0;
                }
              }
              rt = 0;
            }
            st = 0;
          }
          throw new n("Out of packets");
        };
      }
      function O(X) {
        const L = X.SIZ, H = X.currentTile.index, Q = X.tiles[H], N = Q.codingStyleDefaultParameters.layersCount, V = L.Csiz, Y = R(Q), Z = Y;
        let rt = 0, st = 0, mt = 0, yt = 0, at = 0;
        this.nextPacket = function() {
          for (; at < Z.maxNumHigh; at++) {
            for (; yt < Z.maxNumWide; yt++) {
              for (; mt < V; mt++) {
                const q = Q.components[mt], D = q.codingStyleParameters.decompositionLevelsCount;
                for (; st <= D; st++) {
                  const G = q.resolutions[st], et = Y.components[mt].resolutions[st], J = I(yt, at, et, Z, G);
                  if (J !== null) {
                    for (; rt < N; ) {
                      const it = h(G, J, rt);
                      return rt++, it;
                    }
                    rt = 0;
                  }
                }
                st = 0;
              }
              mt = 0;
            }
            yt = 0;
          }
          throw new n("Out of packets");
        };
      }
      function E(X) {
        const L = X.SIZ, H = X.currentTile.index, Q = X.tiles[H], N = Q.codingStyleDefaultParameters.layersCount, V = L.Csiz, Y = R(Q);
        let Z = 0, rt = 0, st = 0, mt = 0, yt = 0;
        this.nextPacket = function() {
          for (; st < V; ++st) {
            const nt = Q.components[st], q = Y.components[st], D = nt.codingStyleParameters.decompositionLevelsCount;
            for (; yt < q.maxNumHigh; yt++) {
              for (; mt < q.maxNumWide; mt++) {
                for (; rt <= D; rt++) {
                  const G = nt.resolutions[rt], et = q.resolutions[rt], J = I(mt, yt, et, q, G);
                  if (J !== null) {
                    for (; Z < N; ) {
                      const it = h(G, J, Z);
                      return Z++, it;
                    }
                    Z = 0;
                  }
                }
                rt = 0;
              }
              mt = 0;
            }
            yt = 0;
          }
          throw new n("Out of packets");
        };
      }
      function I(X, L, H, Q, N) {
        const V = X * Q.minWidth, Y = L * Q.minHeight;
        if (V % H.width != 0 || Y % H.height != 0) return null;
        const Z = Y / H.width * N.precinctParameters.numprecinctswide;
        return V / H.height + Z;
      }
      function R(X) {
        const L = X.components.length;
        let H = Number.MAX_VALUE, Q = Number.MAX_VALUE, N = 0, V = 0;
        const Y = new Array(L);
        for (let Z = 0; Z < L; Z++) {
          const rt = X.components[Z], st = rt.codingStyleParameters.decompositionLevelsCount, mt = new Array(st + 1);
          let yt = Number.MAX_VALUE, at = Number.MAX_VALUE, nt = 0, q = 0, D = 1;
          for (let G = st; G >= 0; --G) {
            const et = rt.resolutions[G], J = D * et.precinctParameters.precinctWidth, it = D * et.precinctParameters.precinctHeight;
            yt = Math.min(yt, J), at = Math.min(at, it), nt = Math.max(nt, et.precinctParameters.numprecinctswide), q = Math.max(q, et.precinctParameters.numprecinctshigh), mt[G] = { width: J, height: it }, D <<= 1;
          }
          H = Math.min(H, yt), Q = Math.min(Q, at), N = Math.max(N, nt), V = Math.max(V, q), Y[Z] = { resolutions: mt, minWidth: yt, minHeight: at, maxNumWide: nt, maxNumHigh: q };
        }
        return { components: Y, minWidth: H, minHeight: Q, maxNumWide: N, maxNumHigh: V };
      }
      function W(X) {
        const L = X.SIZ, H = X.currentTile.index, Q = X.tiles[H], N = L.Csiz;
        for (let Y = 0; Y < N; Y++) {
          const Z = Q.components[Y], rt = Z.codingStyleParameters.decompositionLevelsCount, st = [], mt = [];
          for (let yt = 0; yt <= rt; yt++) {
            const at = b(0, Z, yt), nt = {}, q = 1 << rt - yt;
            nt.trx0 = Math.ceil(Z.tcx0 / q), nt.try0 = Math.ceil(Z.tcy0 / q), nt.trx1 = Math.ceil(Z.tcx1 / q), nt.try1 = Math.ceil(Z.tcy1 / q), nt.resLevel = yt, w(0, nt, at), st.push(nt);
            let D;
            if (yt === 0)
              D = {}, D.type = "LL", D.tbx0 = Math.ceil(Z.tcx0 / q), D.tby0 = Math.ceil(Z.tcy0 / q), D.tbx1 = Math.ceil(Z.tcx1 / q), D.tby1 = Math.ceil(Z.tcy1 / q), D.resolution = nt, v(0, D, at), mt.push(D), nt.subbands = [D];
            else {
              const G = 1 << rt - yt + 1, et = [];
              D = {}, D.type = "HL", D.tbx0 = Math.ceil(Z.tcx0 / G - 0.5), D.tby0 = Math.ceil(Z.tcy0 / G), D.tbx1 = Math.ceil(Z.tcx1 / G - 0.5), D.tby1 = Math.ceil(Z.tcy1 / G), D.resolution = nt, v(0, D, at), mt.push(D), et.push(D), D = {}, D.type = "LH", D.tbx0 = Math.ceil(Z.tcx0 / G), D.tby0 = Math.ceil(Z.tcy0 / G - 0.5), D.tbx1 = Math.ceil(Z.tcx1 / G), D.tby1 = Math.ceil(Z.tcy1 / G - 0.5), D.resolution = nt, v(0, D, at), mt.push(D), et.push(D), D = {}, D.type = "HH", D.tbx0 = Math.ceil(Z.tcx0 / G - 0.5), D.tby0 = Math.ceil(Z.tcy0 / G - 0.5), D.tbx1 = Math.ceil(Z.tcx1 / G - 0.5), D.tby1 = Math.ceil(Z.tcy1 / G - 0.5), D.resolution = nt, v(0, D, at), mt.push(D), et.push(D), nt.subbands = et;
            }
          }
          Z.resolutions = st, Z.subbands = mt;
        }
        const V = Q.codingStyleDefaultParameters.progressionOrder;
        switch (V) {
          case 0:
            Q.packetsIterator = new x(X);
            break;
          case 1:
            Q.packetsIterator = new _(X);
            break;
          case 2:
            Q.packetsIterator = new M(X);
            break;
          case 3:
            Q.packetsIterator = new O(X);
            break;
          case 4:
            Q.packetsIterator = new E(X);
            break;
          default:
            throw new n(`Unsupported progression order ${V}`);
        }
      }
      function z(X, L, H, Q) {
        let N, V = 0, Y = 0, Z = !1;
        function rt(J) {
          for (; Y < J; ) {
            const it = L[H + V];
            V++, Z ? (N = N << 7 | it, Y += 7, Z = !1) : (N = N << 8 | it, Y += 8), it === 255 && (Z = !0);
          }
          return Y -= J, N >>> Y & (1 << J) - 1;
        }
        function st(J) {
          return L[H + V - 1] === 255 && L[H + V] === J ? (mt(1), !0) : L[H + V] === 255 && L[H + V + 1] === J ? (mt(2), !0) : !1;
        }
        function mt(J) {
          V += J;
        }
        function yt() {
          Y = 0, Z && (V++, Z = !1);
        }
        function at() {
          if (rt(1) === 0) return 1;
          if (rt(1) === 0) return 2;
          let J = rt(2);
          return J < 3 ? J + 3 : (J = rt(5), J < 31 ? J + 6 : (J = rt(7), J + 37));
        }
        const nt = X.currentTile.index, q = X.tiles[nt], D = X.COD.sopMarkerUsed, G = X.COD.ephMarkerUsed, et = q.packetsIterator;
        for (; V < Q; ) {
          yt(), D && st(145) && mt(4);
          const J = et.nextPacket();
          if (!rt(1)) continue;
          const it = J.layerNumber, lt = [];
          let ot;
          for (let ut = 0, ct = J.codeblocks.length; ut < ct; ut++) {
            ot = J.codeblocks[ut];
            let gt = ot.precinct;
            const dt = ot.cbx - gt.cbxMin, bt = ot.cby - gt.cbyMin;
            let vt, xt, St = !1, Mt = !1;
            if (ot.included !== void 0) St = !!rt(1);
            else {
              gt = ot.precinct;
              let Kt;
              if (gt.inclusionTree !== void 0) Kt = gt.inclusionTree;
              else {
                const qt = gt.cbxMax - gt.cbxMin + 1, It = gt.cbyMax - gt.cbyMin + 1;
                Kt = new T(qt, It, it), xt = new C(qt, It), gt.inclusionTree = Kt, gt.zeroBitPlanesTree = xt;
                for (let re = 0; re < it; re++) if (rt(1) !== 0) throw new n("Invalid tag tree");
              }
              if (Kt.reset(dt, bt, it)) for (; ; ) {
                if (!rt(1)) {
                  Kt.incrementValue(it);
                  break;
                }
                if (vt = !Kt.nextLevel(), vt) {
                  ot.included = !0, St = Mt = !0;
                  break;
                }
              }
            }
            if (!St) continue;
            if (Mt) {
              for (xt = gt.zeroBitPlanesTree, xt.reset(dt, bt); ; ) if (rt(1)) {
                if (vt = !xt.nextLevel(), vt) break;
              } else xt.incrementValue();
              ot.zeroBitPlanes = xt.value;
            }
            const Et = at();
            for (; rt(1); ) ot.Lblock++;
            const Ft = (0, g.log2)(Et), Wt = rt((Et < 1 << Ft ? Ft - 1 : Ft) + ot.Lblock);
            lt.push({ codeblock: ot, codingpasses: Et, dataLength: Wt });
          }
          for (yt(), G && st(146); lt.length > 0; ) {
            const ut = lt.shift();
            ot = ut.codeblock, ot.data === void 0 && (ot.data = []), ot.data.push({ data: L, start: H + V, end: H + V + ut.dataLength, codingpasses: ut.codingpasses }), V += ut.dataLength;
          }
        }
        return V;
      }
      function j(X, L, H, Q, N, V, Y, Z, rt) {
        const st = Q.tbx0, mt = Q.tby0, yt = Q.tbx1 - Q.tbx0, at = Q.codeblocks, nt = Q.type.charAt(0) === "H" ? 1 : 0, q = Q.type.charAt(1) === "H" ? L : 0;
        for (let D = 0, G = at.length; D < G; ++D) {
          const et = at[D], J = et.tbx1_ - et.tbx0_, it = et.tby1_ - et.tby0_;
          if (J === 0 || it === 0 || et.data === void 0) continue;
          const lt = new F(J, it, et.subbandType, et.zeroBitPlanes, V);
          let ot = 2;
          const ut = et.data;
          let ct, gt, dt, bt = 0, vt = 0;
          for (ct = 0, gt = ut.length; ct < gt; ct++)
            dt = ut[ct], bt += dt.end - dt.start, vt += dt.codingpasses;
          const xt = new Uint8Array(bt);
          let St = 0;
          for (ct = 0, gt = ut.length; ct < gt; ct++) {
            dt = ut[ct];
            const ce = dt.data.subarray(dt.start, dt.end);
            xt.set(ce, St), St += ce.length;
          }
          const Mt = new p.ArithmeticDecoder(xt, 0, bt);
          for (lt.setDecoder(Mt), ct = 0; ct < vt; ct++) {
            switch (ot) {
              case 0:
                lt.runSignificancePropagationPass();
                break;
              case 1:
                lt.runMagnitudeRefinementPass();
                break;
              case 2:
                lt.runCleanupPass(), Z && lt.checkSegmentationSymbol();
            }
            rt && lt.reset(), ot = (ot + 1) % 3;
          }
          let Et = et.tbx0_ - st + (et.tby0_ - mt) * yt;
          const Ft = lt.coefficentsSign, Wt = lt.coefficentsMagnitude, Kt = lt.bitsDecoded, qt = Y ? 0 : 0.5;
          let It, re, le;
          St = 0;
          const Ce = Q.type !== "LL";
          for (ct = 0; ct < it; ct++) {
            const ce = 2 * (Et / yt | 0) * (L - yt) + nt + q;
            for (It = 0; It < J; It++)
              re = Wt[St], re !== 0 && (re = (re + qt) * N, Ft[St] !== 0 && (re = -re), le = Kt[St], X[Ce ? ce + (Et << 1) : Et] = Y && le >= V ? re : re * (1 << V - le)), Et++, St++;
            Et += yt - J;
          }
        }
      }
      function $(X, L, H) {
        const Q = L.components[H], N = Q.codingStyleParameters, V = Q.quantizationParameters, Y = N.decompositionLevelsCount, Z = V.SPqcds, rt = V.scalarExpounded, st = V.guardBits, mt = N.segmentationSymbolUsed, yt = N.resetContextProbabilities, at = X.components[H].precision, nt = N.reversibleTransformation, q = nt ? new U() : new A(), D = [];
        let G = 0;
        for (let J = 0; J <= Y; J++) {
          const it = Q.resolutions[J], lt = it.trx1 - it.trx0, ot = it.try1 - it.try0, ut = new Float32Array(lt * ot);
          for (let ct = 0, gt = it.subbands.length; ct < gt; ct++) {
            let dt, bt;
            rt ? (dt = Z[G].mu, bt = Z[G].epsilon, G++) : (dt = Z[0].mu, bt = Z[0].epsilon + (J > 0 ? 1 - J : 0));
            const vt = it.subbands[ct], xt = a[vt.type];
            j(ut, lt, 0, vt, nt ? 1 : 2 ** (at + xt - bt) * (1 + dt / 2048), st + bt - 1, nt, mt, yt);
          }
          D.push({ width: lt, height: ot, items: ut });
        }
        const et = q.calculate(D, Q.tcx0, Q.tcy0);
        return { left: Q.tcx0, top: Q.tcy0, width: et.width, height: et.height, items: et.items };
      }
      function B(X, L) {
        const H = X.SIZ.Csiz, Q = X.tiles[L];
        for (let N = 0; N < H; N++) {
          const V = Q.components[N], Y = X.currentTile.QCC[N] !== void 0 ? X.currentTile.QCC[N] : X.currentTile.QCD;
          V.quantizationParameters = Y;
          const Z = X.currentTile.COC[N] !== void 0 ? X.currentTile.COC[N] : X.currentTile.COD;
          V.codingStyleParameters = Z;
        }
        Q.codingStyleDefaultParameters = X.currentTile.COD;
      }
      class C {
        constructor(L, H) {
          const Q = (0, g.log2)(Math.max(L, H)) + 1;
          this.levels = [];
          for (let N = 0; N < Q; N++) {
            const V = { width: L, height: H, items: [] };
            this.levels.push(V), L = Math.ceil(L / 2), H = Math.ceil(H / 2);
          }
        }
        reset(L, H) {
          let Q, N = 0, V = 0;
          for (; N < this.levels.length; ) {
            Q = this.levels[N];
            const Y = L + H * Q.width;
            if (Q.items[Y] !== void 0) {
              V = Q.items[Y];
              break;
            }
            Q.index = Y, L >>= 1, H >>= 1, N++;
          }
          N--, Q = this.levels[N], Q.items[Q.index] = V, this.currentLevel = N, delete this.value;
        }
        incrementValue() {
          const L = this.levels[this.currentLevel];
          L.items[L.index]++;
        }
        nextLevel() {
          let L = this.currentLevel, H = this.levels[L];
          const Q = H.items[H.index];
          return L--, L < 0 ? (this.value = Q, !1) : (this.currentLevel = L, H = this.levels[L], H.items[H.index] = Q, !0);
        }
      }
      class T {
        constructor(L, H, Q) {
          const N = (0, g.log2)(Math.max(L, H)) + 1;
          this.levels = [];
          for (let V = 0; V < N; V++) {
            const Y = new Uint8Array(L * H);
            for (let rt = 0, st = Y.length; rt < st; rt++) Y[rt] = Q;
            const Z = { width: L, height: H, items: Y };
            this.levels.push(Z), L = Math.ceil(L / 2), H = Math.ceil(H / 2);
          }
        }
        reset(L, H, Q) {
          let N = 0;
          for (; N < this.levels.length; ) {
            const V = this.levels[N], Y = L + H * V.width;
            V.index = Y;
            const Z = V.items[Y];
            if (Z === 255) break;
            if (Z > Q)
              return this.currentLevel = N, this.propagateValues(), !1;
            L >>= 1, H >>= 1, N++;
          }
          return this.currentLevel = N - 1, !0;
        }
        incrementValue(L) {
          const H = this.levels[this.currentLevel];
          H.items[H.index] = L + 1, this.propagateValues();
        }
        propagateValues() {
          let L = this.currentLevel, H = this.levels[L];
          const Q = H.items[H.index];
          for (; --L >= 0; )
            H = this.levels[L], H.items[H.index] = Q;
        }
        nextLevel() {
          let L = this.currentLevel, H = this.levels[L];
          const Q = H.items[H.index];
          return H.items[H.index] = 255, L--, L < 0 ? !1 : (this.currentLevel = L, H = this.levels[L], H.items[H.index] = Q, !0);
        }
      }
      const K = class K {
        constructor(L, H, Q, N, V) {
          this.width = L, this.height = H;
          let Y;
          Y = Q === "HH" ? K.HHContextLabel : Q === "HL" ? K.HLContextLabel : K.LLAndLHContextsLabel, this.contextLabelTable = Y;
          const Z = L * H;
          this.neighborsSignificance = new Uint8Array(Z), this.coefficentsSign = new Uint8Array(Z);
          let rt;
          rt = V > 14 ? new Uint32Array(Z) : V > 6 ? new Uint16Array(Z) : new Uint8Array(Z), this.coefficentsMagnitude = rt, this.processingFlags = new Uint8Array(Z);
          const st = new Uint8Array(Z);
          if (N !== 0) for (let mt = 0; mt < Z; mt++) st[mt] = N;
          this.bitsDecoded = st, this.reset();
        }
        setDecoder(L) {
          this.decoder = L;
        }
        reset() {
          this.contexts = new Int8Array(19), this.contexts[0] = 8, this.contexts[K.UNIFORM_CONTEXT] = 92, this.contexts[K.RUNLENGTH_CONTEXT] = 6;
        }
        setNeighborsSignificance(L, H, Q) {
          const N = this.neighborsSignificance, V = this.width, Y = this.height, Z = H > 0, rt = H + 1 < V;
          let st;
          L > 0 && (st = Q - V, Z && (N[st - 1] += 16), rt && (N[st + 1] += 16), N[st] += 4), L + 1 < Y && (st = Q + V, Z && (N[st - 1] += 16), rt && (N[st + 1] += 16), N[st] += 4), Z && (N[Q - 1] += 1), rt && (N[Q + 1] += 1), N[Q] |= 128;
        }
        runSignificancePropagationPass() {
          const L = this.decoder, H = this.width, Q = this.height, N = this.coefficentsMagnitude, V = this.coefficentsSign, Y = this.neighborsSignificance, Z = this.processingFlags, rt = this.contexts, st = this.contextLabelTable, mt = this.bitsDecoded;
          for (let yt = 0; yt < Q; yt += 4) for (let at = 0; at < H; at++) {
            let nt = yt * H + at;
            for (let q = 0; q < 4; q++, nt += H) {
              const D = yt + q;
              if (D >= Q) break;
              if (Z[nt] &= -2, N[nt] || !Y[nt]) continue;
              const G = st[Y[nt]];
              if (L.readBit(rt, G)) {
                const et = this.decodeSignBit(D, at, nt);
                V[nt] = et, N[nt] = 1, this.setNeighborsSignificance(D, at, nt), Z[nt] |= 2;
              }
              mt[nt]++, Z[nt] |= 1;
            }
          }
        }
        decodeSignBit(L, H, Q) {
          const N = this.width, V = this.height, Y = this.coefficentsMagnitude, Z = this.coefficentsSign;
          let rt, st, mt, yt, at, nt;
          yt = H > 0 && Y[Q - 1] !== 0, H + 1 < N && Y[Q + 1] !== 0 ? (mt = Z[Q + 1], yt ? (st = Z[Q - 1], rt = 1 - mt - st) : rt = 1 - mt - mt) : yt ? (st = Z[Q - 1], rt = 1 - st - st) : rt = 0;
          const q = 3 * rt;
          return yt = L > 0 && Y[Q - N] !== 0, L + 1 < V && Y[Q + N] !== 0 ? (mt = Z[Q + N], yt ? (st = Z[Q - N], rt = 1 - mt - st + q) : rt = 1 - mt - mt + q) : yt ? (st = Z[Q - N], rt = 1 - st - st + q) : rt = q, rt >= 0 ? (at = 9 + rt, nt = this.decoder.readBit(this.contexts, at)) : (at = 9 - rt, nt = 1 ^ this.decoder.readBit(this.contexts, at)), nt;
        }
        runMagnitudeRefinementPass() {
          const L = this.decoder, H = this.width, Q = this.height, N = this.coefficentsMagnitude, V = this.neighborsSignificance, Y = this.contexts, Z = this.bitsDecoded, rt = this.processingFlags, st = H * Q, mt = 4 * H;
          for (let yt, at = 0; at < st; at = yt) {
            yt = Math.min(st, at + mt);
            for (let nt = 0; nt < H; nt++) for (let q = at + nt; q < yt; q += H) {
              if (!N[q] || 1 & rt[q]) continue;
              let D = 16;
              2 & rt[q] && (rt[q] ^= 2, D = 127 & V[q] ? 14 : 15);
              const G = L.readBit(Y, D);
              N[q] = N[q] << 1 | G, Z[q]++, rt[q] |= 1;
            }
          }
        }
        runCleanupPass() {
          const L = this.decoder, H = this.width, Q = this.height, N = this.neighborsSignificance, V = this.coefficentsMagnitude, Y = this.coefficentsSign, Z = this.contexts, rt = this.contextLabelTable, st = this.bitsDecoded, mt = this.processingFlags, yt = H, at = 2 * H, nt = 3 * H;
          let q;
          for (let D = 0; D < Q; D = q) {
            q = Math.min(D + 4, Q);
            const G = D * H, et = D + 3 < Q;
            for (let J = 0; J < H; J++) {
              const it = G + J;
              let lt, ot = 0, ut = it, ct = D;
              if (et && mt[it] === 0 && mt[it + yt] === 0 && mt[it + at] === 0 && mt[it + nt] === 0 && N[it] === 0 && N[it + yt] === 0 && N[it + at] === 0 && N[it + nt] === 0) {
                if (!L.readBit(Z, K.RUNLENGTH_CONTEXT)) {
                  st[it]++, st[it + yt]++, st[it + at]++, st[it + nt]++;
                  continue;
                }
                ot = L.readBit(Z, K.UNIFORM_CONTEXT) << 1 | L.readBit(Z, K.UNIFORM_CONTEXT), ot !== 0 && (ct = D + ot, ut += ot * H), lt = this.decodeSignBit(ct, J, ut), Y[ut] = lt, V[ut] = 1, this.setNeighborsSignificance(ct, J, ut), mt[ut] |= 2, ut = it;
                for (let gt = D; gt <= ct; gt++, ut += H) st[ut]++;
                ot++;
              }
              for (ct = D + ot; ct < q; ct++, ut += H) {
                if (V[ut] || 1 & mt[ut]) continue;
                const gt = rt[N[ut]];
                L.readBit(Z, gt) === 1 && (lt = this.decodeSignBit(ct, J, ut), Y[ut] = lt, V[ut] = 1, this.setNeighborsSignificance(ct, J, ut), mt[ut] |= 2), st[ut]++;
              }
            }
          }
        }
        checkSegmentationSymbol() {
          const L = this.decoder, H = this.contexts;
          if ((L.readBit(H, K.UNIFORM_CONTEXT) << 3 | L.readBit(H, K.UNIFORM_CONTEXT) << 2 | L.readBit(H, K.UNIFORM_CONTEXT) << 1 | L.readBit(H, K.UNIFORM_CONTEXT)) !== 10) throw new n("Invalid segmentation symbol");
        }
      };
      Mr(K, "UNIFORM_CONTEXT", 17), Mr(K, "RUNLENGTH_CONTEXT", 18), Mr(K, "LLAndLHContextsLabel", new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8])), Mr(K, "HLContextLabel", new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8])), Mr(K, "HHContextLabel", new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]));
      let F = K;
      class S {
        constructor() {
          this.constructor === S && (0, o.unreachable)("Cannot initialize Transform.");
        }
        calculate(L, H, Q) {
          let N = L[0];
          for (let V = 1, Y = L.length; V < Y; V++) N = this.iterate(N, L[V], H, Q);
          return N;
        }
        extend(L, H, Q) {
          let N = H - 1, V = H + 1, Y = H + Q - 2, Z = H + Q;
          L[N--] = L[V++], L[Z++] = L[Y--], L[N--] = L[V++], L[Z++] = L[Y--], L[N--] = L[V++], L[Z++] = L[Y--], L[N] = L[V], L[Z] = L[Y];
        }
        filter(L, H, Q) {
          (0, o.unreachable)("Abstract method `filter` called");
        }
        iterate(L, H, Q, N) {
          const V = L.width, Y = L.height;
          let Z = L.items;
          const rt = H.width, st = H.height, mt = H.items;
          let yt, at, nt, q, D, G;
          for (nt = 0, yt = 0; yt < Y; yt++)
            for (q = 2 * yt * rt, at = 0; at < V; at++, nt++, q += 2) mt[q] = Z[nt];
          Z = L.items = null;
          const et = new Float32Array(rt + 8);
          if (rt === 1) {
            if (1 & Q) for (G = 0, nt = 0; G < st; G++, nt += rt) mt[nt] *= 0.5;
          } else for (G = 0, nt = 0; G < st; G++, nt += rt)
            et.set(mt.subarray(nt, nt + rt), 4), this.extend(et, 4, rt), this.filter(et, 4, rt), mt.set(et.subarray(4, 4 + rt), nt);
          let J = 16;
          const it = [];
          for (yt = 0; yt < J; yt++) it.push(new Float32Array(st + 8));
          let lt, ot = 0;
          if (L = 4 + st, st === 1) {
            if (1 & N) for (D = 0; D < rt; D++) mt[D] *= 0.5;
          } else for (D = 0; D < rt; D++) {
            if (ot === 0) {
              for (J = Math.min(rt - D, J), nt = D, q = 4; q < L; nt += rt, q++) for (lt = 0; lt < J; lt++) it[lt][q] = mt[nt + lt];
              ot = J;
            }
            ot--;
            const ut = it[ot];
            if (this.extend(ut, 4, st), this.filter(ut, 4, st), ot === 0)
              for (nt = D - J + 1, q = 4; q < L; nt += rt, q++) for (lt = 0; lt < J; lt++) mt[nt + lt] = it[lt][q];
          }
          return { width: rt, height: st, items: mt };
        }
      }
      class A extends S {
        filter(L, H, Q) {
          const N = Q >> 1;
          let V, Y, Z, rt;
          const st = -1.586134342059924, mt = -0.052980118572961, yt = 0.882911075530934, at = 0.443506852043971, nt = 1.230174104914001;
          for (V = (H |= 0) - 3, Y = N + 4; Y--; V += 2) L[V] *= 0.8128930661159609;
          for (V = H - 2, Z = at * L[V - 1], Y = N + 3; Y-- && (rt = at * L[V + 1], L[V] = nt * L[V] - Z - rt, !!Y--); V += 2)
            V += 2, Z = at * L[V + 1], L[V] = nt * L[V] - Z - rt;
          for (V = H - 1, Z = yt * L[V - 1], Y = N + 2; Y-- && (rt = yt * L[V + 1], L[V] -= Z + rt, !!Y--); V += 2)
            V += 2, Z = yt * L[V + 1], L[V] -= Z + rt;
          for (V = H, Z = mt * L[V - 1], Y = N + 1; Y-- && (rt = mt * L[V + 1], L[V] -= Z + rt, !!Y--); V += 2)
            V += 2, Z = mt * L[V + 1], L[V] -= Z + rt;
          if (N !== 0)
            for (V = H + 1, Z = st * L[V - 1], Y = N; Y-- && (rt = st * L[V + 1], L[V] -= Z + rt, !!Y--); V += 2)
              V += 2, Z = st * L[V + 1], L[V] -= Z + rt;
        }
      }
      class U extends S {
        filter(L, H, Q) {
          const N = Q >> 1;
          let V, Y;
          for (V = H |= 0, Y = N + 1; Y--; V += 2) L[V] -= L[V - 1] + L[V + 1] + 2 >> 2;
          for (V = H + 1, Y = N; Y--; V += 2) L[V] += L[V - 1] + L[V + 1] >> 1;
        }
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.LZWStream = void 0;
      var o = f(18);
      class g extends o.DecodeStream {
        constructor(n, a, d) {
          super(a), this.str = n, this.dict = n.dict, this.cachedData = 0, this.bitsCached = 0;
          const m = 4096, b = { earlyChange: d, codeLength: 9, nextCode: 258, dictionaryValues: new Uint8Array(m), dictionaryLengths: new Uint16Array(m), dictionaryPrevCodes: new Uint16Array(m), currentSequence: new Uint8Array(m), currentSequenceLength: 0 };
          for (let w = 0; w < 256; ++w)
            b.dictionaryValues[w] = w, b.dictionaryLengths[w] = 1;
          this.lzwState = b;
        }
        readBits(n) {
          let a = this.bitsCached, d = this.cachedData;
          for (; a < n; ) {
            const m = this.str.getByte();
            if (m === -1)
              return this.eof = !0, null;
            d = d << 8 | m, a += 8;
          }
          return this.bitsCached = a -= n, this.cachedData = d, this.lastCode = null, d >>> a & (1 << n) - 1;
        }
        readBlock() {
          let n, a, d, m = 1024;
          const b = this.lzwState;
          if (!b) return;
          const w = b.earlyChange;
          let v = b.nextCode;
          const h = b.dictionaryValues, x = b.dictionaryLengths, _ = b.dictionaryPrevCodes;
          let M = b.codeLength, O = b.prevCode;
          const E = b.currentSequence;
          let I = b.currentSequenceLength, R = 0, W = this.bufferLength, z = this.ensureBuffer(this.bufferLength + m);
          for (n = 0; n < 512; n++) {
            const j = this.readBits(M), $ = I > 0;
            if (j < 256)
              E[0] = j, I = 1;
            else {
              if (!(j >= 258)) {
                if (j === 256) {
                  M = 9, v = 258, I = 0;
                  continue;
                }
                this.eof = !0, delete this.lzwState;
                break;
              }
              if (j < v)
                for (I = x[j], a = I - 1, d = j; a >= 0; a--)
                  E[a] = h[d], d = _[d];
              else E[I++] = E[0];
            }
            if ($ && (_[v] = O, x[v] = x[O] + 1, h[v] = E[0], v++, M = v + w & v + w - 1 ? M : 0 | Math.min(Math.log(v + w) / 0.6931471805599453 + 1, 12)), O = j, R += I, m < R) {
              do
                m += 512;
              while (m < R);
              z = this.ensureBuffer(this.bufferLength + m);
            }
            for (a = 0; a < I; a++) z[W++] = E[a];
          }
          b.nextCode = v, b.codeLength = M, b.prevCode = O, b.currentSequenceLength = I, this.bufferLength = W;
        }
      }
      l.LZWStream = g;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PredictorStream = void 0;
      var o = f(18), g = f(4), p = f(2);
      class n extends o.DecodeStream {
        constructor(d, m, b) {
          if (super(m), !(b instanceof g.Dict)) return d;
          const w = this.predictor = b.get("Predictor") || 1;
          if (w <= 1) return d;
          if (w !== 2 && (w < 10 || w > 15)) throw new p.FormatError(`Unsupported predictor: ${w}`);
          this.readBlock = w === 2 ? this.readBlockTiff : this.readBlockPng, this.str = d, this.dict = d.dict;
          const v = this.colors = b.get("Colors") || 1, h = this.bits = b.get("BPC", "BitsPerComponent") || 8, x = this.columns = b.get("Columns") || 1;
          return this.pixBytes = v * h + 7 >> 3, this.rowBytes = x * v * h + 7 >> 3, this;
        }
        readBlockTiff() {
          const d = this.rowBytes, m = this.bufferLength, b = this.ensureBuffer(m + d), w = this.bits, v = this.colors, h = this.str.getBytes(d);
          if (this.eof = !h.length, this.eof) return;
          let x, _ = 0, M = 0, O = 0, E = 0, I = m;
          if (w === 1 && v === 1) for (x = 0; x < d; ++x) {
            let R = h[x] ^ _;
            R ^= R >> 1, R ^= R >> 2, R ^= R >> 4, _ = (1 & R) << 7, b[I++] = R;
          }
          else if (w === 8) {
            for (x = 0; x < v; ++x) b[I++] = h[x];
            for (; x < d; ++x)
              b[I] = b[I - v] + h[x], I++;
          } else if (w === 16) {
            const R = 2 * v;
            for (x = 0; x < R; ++x) b[I++] = h[x];
            for (; x < d; x += 2) {
              const W = ((255 & h[x]) << 8) + (255 & h[x + 1]) + ((255 & b[I - R]) << 8) + (255 & b[I - R + 1]);
              b[I++] = W >> 8 & 255, b[I++] = 255 & W;
            }
          } else {
            const R = new Uint8Array(v + 1), W = (1 << w) - 1;
            let z = 0, j = m;
            const $ = this.columns;
            for (x = 0; x < $; ++x) for (let B = 0; B < v; ++B)
              O < w && (_ = _ << 8 | 255 & h[z++], O += 8), R[B] = R[B] + (_ >> O - w) & W, O -= w, M = M << w | R[B], E += w, E >= 8 && (b[j++] = M >> E - 8 & 255, E -= 8);
            E > 0 && (b[j++] = (M << 8 - E) + (_ & (1 << 8 - E) - 1));
          }
          this.bufferLength += d;
        }
        readBlockPng() {
          const d = this.rowBytes, m = this.pixBytes, b = this.str.getByte(), w = this.str.getBytes(d);
          if (this.eof = !w.length, this.eof) return;
          const v = this.bufferLength, h = this.ensureBuffer(v + d);
          let x = h.subarray(v - d, v);
          x.length === 0 && (x = new Uint8Array(d));
          let _, M, O, E = v;
          switch (b) {
            case 0:
              for (_ = 0; _ < d; ++_) h[E++] = w[_];
              break;
            case 1:
              for (_ = 0; _ < m; ++_) h[E++] = w[_];
              for (; _ < d; ++_)
                h[E] = h[E - m] + w[_] & 255, E++;
              break;
            case 2:
              for (_ = 0; _ < d; ++_) h[E++] = x[_] + w[_] & 255;
              break;
            case 3:
              for (_ = 0; _ < m; ++_) h[E++] = (x[_] >> 1) + w[_];
              for (; _ < d; ++_)
                h[E] = (x[_] + h[E - m] >> 1) + w[_] & 255, E++;
              break;
            case 4:
              for (_ = 0; _ < m; ++_)
                M = x[_], O = w[_], h[E++] = M + O;
              for (; _ < d; ++_) {
                M = x[_];
                const I = x[_ - m], R = h[E - m], W = R + M - I;
                let z = W - R;
                z < 0 && (z = -z);
                let j = W - M;
                j < 0 && (j = -j);
                let $ = W - I;
                $ < 0 && ($ = -$), O = w[_], h[E++] = z <= j && z <= $ ? R + O : j <= $ ? M + O : I + O;
              }
              break;
            default:
              throw new p.FormatError(`Unsupported predictor: ${b}`);
          }
          this.bufferLength += d;
        }
      }
      l.PredictorStream = n;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.RunLengthStream = void 0;
      var o = f(18);
      class g extends o.DecodeStream {
        constructor(n, a) {
          super(a), this.str = n, this.dict = n.dict;
        }
        readBlock() {
          const n = this.str.getBytes(2);
          if (!n || n.length < 2 || n[0] === 128) {
            this.eof = !0;
            return;
          }
          let a, d = this.bufferLength, m = n[0];
          if (m < 128) {
            if (a = this.ensureBuffer(d + m + 1), a[d++] = n[1], m > 0) {
              const b = this.str.getBytes(m);
              a.set(b, d), d += m;
            }
          } else {
            m = 257 - m;
            const b = n[1];
            a = this.ensureBuffer(d + m + 1);
            for (let w = 0; w < m; w++) a[d++] = b;
          }
          this.bufferLength = d;
        }
      }
      l.RunLengthStream = g;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Font = l.ErrorFont = void 0;
      var o = f(2), g = f(35), p = f(38), n = f(40), a = f(39), d = f(37), m = f(41), b = f(42), w = f(43), v = f(44), h = f(45), x = f(46), _ = f(14), M = f(47), O = f(3), E = f(8), I = f(48);
      const R = [[57344, 63743], [1048576, 1114109]], W = 1e3, z = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"], j = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
      function $(at) {
        if (!at.fontMatrix || at.fontMatrix[0] === o.FONT_IDENTITY_MATRIX[0]) return;
        const nt = 1e-3 / at.fontMatrix[0], q = at.widths;
        for (const D in q) q[D] *= nt;
        at.defaultWidth *= nt;
      }
      function B(at) {
        if (!at.fallbackToUnicode || at.toUnicode instanceof b.IdentityToUnicodeMap) return;
        const nt = [];
        for (const q in at.fallbackToUnicode) at.toUnicode.has(q) || (nt[q] = at.fallbackToUnicode[q]);
        nt.length > 0 && at.toUnicode.amend(nt);
      }
      class C {
        constructor(nt, q, D, G, et, J, it, lt, ot) {
          this.originalCharCode = nt, this.fontChar = q, this.unicode = D, this.accent = G, this.width = et, this.vmetric = J, this.operatorListId = it, this.isSpace = lt, this.isInFont = ot;
        }
        get category() {
          return (0, o.shadow)(this, "category", (0, n.getCharUnicodeCategory)(this.unicode), !0);
        }
      }
      function T(at, nt) {
        return (at << 8) + nt;
      }
      function F(at, nt, q) {
        at[nt + 1] = q, at[nt] = q >>> 8;
      }
      function S(at, nt) {
        const q = (at << 8) + nt;
        return 32768 & q ? q - 65536 : q;
      }
      function A(at) {
        return String.fromCharCode(at >> 8 & 255, 255 & at);
      }
      function U(at) {
        return at > 32767 ? at = 32767 : at < -32768 && (at = -32768), String.fromCharCode(at >> 8 & 255, 255 & at);
      }
      function K(at) {
        const nt = at.peekBytes(4);
        return (0, o.bytesToString)(nt) === "ttcf";
      }
      function X(at, { type: nt, subtype: q, composite: D }) {
        let G, et;
        return function(it) {
          const lt = it.peekBytes(4);
          return (0, O.readUint32)(lt, 0) === 65536 || (0, o.bytesToString)(lt) === "true";
        }(at) || K(at) ? G = D ? "CIDFontType2" : "TrueType" : function(it) {
          const lt = it.peekBytes(4);
          return (0, o.bytesToString)(lt) === "OTTO";
        }(at) ? G = D ? "CIDFontType2" : "OpenType" : function(it) {
          const lt = it.peekBytes(2);
          return lt[0] === 37 && lt[1] === 33 || lt[0] === 128 && lt[1] === 1;
        }(at) ? G = D ? "CIDFontType0" : nt === "MMType1" ? "MMType1" : "Type1" : function(it) {
          const lt = it.peekBytes(4);
          return lt[0] >= 1 && lt[3] >= 1 && lt[3] <= 4;
        }(at) ? D ? (G = "CIDFontType0", et = "CIDFontType0C") : (G = nt === "MMType1" ? "MMType1" : "Type1", et = "Type1C") : ((0, o.warn)("getFontFileType: Unable to detect correct font file Type/Subtype."), G = nt, et = q), [G, et];
      }
      function L(at, nt) {
        for (const q in nt) at[+q] = nt[q];
      }
      function H(at, nt, q) {
        const D = [];
        let G;
        for (let et = 0, J = at.length; et < J; et++)
          G = (0, n.getUnicodeForGlyph)(at[et], nt), G !== -1 && (D[et] = G);
        for (const et in q)
          G = (0, n.getUnicodeForGlyph)(q[et], nt), G !== -1 && (D[+et] = G);
        return D;
      }
      function Q(at) {
        return at.platform === 1 && at.encoding === 0 && at.language === 0;
      }
      function N(at) {
        return at.platform === 3 && at.encoding === 1 && at.language === 1033;
      }
      function V(at, nt, q = !1) {
        switch (nt.length) {
          case 1:
            return nt.charCodeAt(0);
          case 2:
            return nt.charCodeAt(0) << 8 | nt.charCodeAt(1);
        }
        const D = `Unsupported CID string (charCode ${at}): "${nt}".`;
        if (q) throw new o.FormatError(D);
        return (0, o.warn)(D), nt;
      }
      function Y(at, nt, q, D) {
        const G = /* @__PURE__ */ Object.create(null), et = /* @__PURE__ */ new Map(), J = [], it = /* @__PURE__ */ new Set();
        let lt = 0, ot = R[lt][0], ut = R[lt][1];
        for (let gt in at) {
          gt |= 0;
          let dt = at[gt];
          if (!nt(dt)) continue;
          if (ot > ut) {
            if (lt++, lt >= R.length) {
              (0, o.warn)("Ran out of space in font private use area.");
              break;
            }
            ot = R[lt][0], ut = R[lt][1];
          }
          const bt = ot++;
          dt === 0 && (dt = q);
          let vt = D.get(gt);
          typeof vt == "string" && (vt = vt.codePointAt(0)), vt && (ct = vt, !(R[0][0] <= ct && ct <= R[0][1] || R[1][0] <= ct && ct <= R[1][1])) && !it.has(dt) && (et.set(vt, dt), it.add(dt)), G[bt] = dt, J[gt] = bt;
        }
        var ct;
        return { toFontChar: J, charCodeToGlyphId: G, toUnicodeExtraMap: et, nextAvailableFontCharCode: ot };
      }
      function Z(at, nt, q) {
        const D = function(ce, xe, ve) {
          const Oe = [];
          for (const Xt in ce) ce[Xt] >= ve || Oe.push({ fontCharCode: 0 | Xt, glyphId: ce[Xt] });
          if (xe) for (const [Xt, Gt] of xe) Gt >= ve || Oe.push({ fontCharCode: Xt, glyphId: Gt });
          Oe.length === 0 && Oe.push({ fontCharCode: 0, glyphId: 0 }), Oe.sort(function(Gt, Lt) {
            return Gt.fontCharCode - Lt.fontCharCode;
          });
          const He = [], Zt = Oe.length;
          for (let Xt = 0; Xt < Zt; ) {
            const Gt = Oe[Xt].fontCharCode, Lt = [Oe[Xt].glyphId];
            ++Xt;
            let Dt = Gt;
            for (; Xt < Zt && Dt + 1 === Oe[Xt].fontCharCode && (Lt.push(Oe[Xt].glyphId), ++Dt, ++Xt, Dt !== 65535); )
              ;
            He.push([Gt, Dt, Lt]);
          }
          return He;
        }(at, nt, q), G = D.at(-1)[1] > 65535 ? 2 : 1;
        let et, J, it, lt, ot = "\0\0" + A(G) + "\0\0" + (0, o.string32)(4 + 8 * G);
        for (et = D.length - 1; et >= 0 && !(D[et][0] <= 65535); --et) ;
        const ut = et + 1;
        D[et][0] < 65535 && D[et][1] === 65535 && (D[et][1] = 65534);
        const ct = D[et][1] < 65535 ? 1 : 0, gt = ut + ct, dt = M.OpenTypeFileBuilder.getSearchParams(gt, 2);
        let bt, vt, xt, St, Mt = "", Et = "", Ft = "", Wt = "", Kt = "", qt = 0;
        for (et = 0, J = ut; et < J; et++) {
          bt = D[et], vt = bt[0], xt = bt[1], Mt += A(vt), Et += A(xt), St = bt[2];
          let Ce = !0;
          for (it = 1, lt = St.length; it < lt; ++it) if (St[it] !== St[it - 1] + 1) {
            Ce = !1;
            break;
          }
          if (Ce)
            Ft += A(St[0] - vt & 65535), Wt += A(0);
          else {
            const ce = 2 * (gt - et) + 2 * qt;
            for (qt += xt - vt + 1, Ft += A(0), Wt += A(ce), it = 0, lt = St.length; it < lt; ++it) Kt += A(St[it]);
          }
        }
        ct > 0 && (Et += "ÿÿ", Mt += "ÿÿ", Ft += "\0", Wt += "\0\0");
        const It = "\0\0" + A(2 * gt) + A(dt.range) + A(dt.entry) + A(dt.rangeShift) + Et + "\0\0" + Mt + Ft + Wt + Kt;
        let re = "", le = "";
        if (G > 1) {
          for (ot += `\0\0
` + (0, o.string32)(4 + 8 * G + 4 + It.length), re = "", et = 0, J = D.length; et < J; et++) {
            bt = D[et], vt = bt[0], St = bt[2];
            let Ce = St[0];
            for (it = 1, lt = St.length; it < lt; ++it) St[it] !== St[it - 1] + 1 && (xt = bt[0] + it - 1, re += (0, o.string32)(vt) + (0, o.string32)(xt) + (0, o.string32)(Ce), vt = xt + 1, Ce = St[it]);
            re += (0, o.string32)(vt) + (0, o.string32)(bt[1]) + (0, o.string32)(Ce);
          }
          le = "\0\f\0\0" + (0, o.string32)(re.length + 16) + "\0\0\0\0" + (0, o.string32)(re.length / 12);
        }
        return ot + "\0" + A(It.length + 4) + It + le + re;
      }
      function rt(at, nt, q) {
        q || (q = { unitsPerEm: 0, yMax: 0, yMin: 0, ascent: 0, descent: 0 });
        let D = 0, G = 0, et = 0, J = 0, it = null, lt = 0, ot = -1;
        if (nt) {
          for (let St in nt)
            if (St |= 0, (it > St || !it) && (it = St), lt < St && (lt = St), ot = (0, n.getUnicodeRangeFor)(St, ot), ot < 32) D |= 1 << ot;
            else if (ot < 64) G |= 1 << ot - 32;
            else if (ot < 96) et |= 1 << ot - 64;
            else {
              if (!(ot < 123)) throw new o.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
              J |= 1 << ot - 96;
            }
          lt > 65535 && (lt = 65535);
        } else
          it = 0, lt = 255;
        const ut = at.bbox || [0, 0, 0, 0], ct = q.unitsPerEm || 1 / (at.fontMatrix || o.FONT_IDENTITY_MATRIX)[0], gt = at.ascentScaled ? 1 : ct / W, dt = q.ascent || Math.round(gt * (at.ascent || ut[3]));
        let bt = q.descent || Math.round(gt * (at.descent || ut[1]));
        bt > 0 && at.descent > 0 && ut[1] < 0 && (bt = -bt);
        const vt = q.yMax || dt, xt = -q.yMin || -bt;
        return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode(at.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, o.string32)(D) + (0, o.string32)(G) + (0, o.string32)(et) + (0, o.string32)(J) + "*21*" + A(at.italicAngle ? 1 : 0) + A(it || at.firstChar) + A(lt || at.lastChar) + A(dt) + A(bt) + "\0d" + A(vt) + A(xt) + "\0\0\0\0\0\0\0\0" + A(at.xHeight) + A(at.capHeight) + A(0) + A(it || at.firstChar) + "\0";
      }
      function st(at) {
        const nt = Math.floor(65536 * at.italicAngle);
        return "\0\0\0" + (0, o.string32)(nt) + "\0\0\0\0" + (0, o.string32)(at.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
      }
      function mt(at) {
        return at.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
      }
      function yt(at, nt) {
        nt || (nt = [[], []]);
        const q = [nt[0][0] || "Original licence", nt[0][1] || at, nt[0][2] || "Unknown", nt[0][3] || "uniqueID", nt[0][4] || at, nt[0][5] || "Version 0.11", nt[0][6] || mt(at), nt[0][7] || "Unknown", nt[0][8] || "Unknown", nt[0][9] || "Unknown"], D = [];
        let G, et, J, it, lt;
        for (G = 0, et = q.length; G < et; G++) {
          lt = nt[1][G] || q[G];
          const xt = [];
          for (J = 0, it = lt.length; J < it; J++) xt.push(A(lt.charCodeAt(J)));
          D.push(xt.join(""));
        }
        const ot = [q, D], ut = ["\0", "\0"], ct = ["\0\0", "\0"], gt = ["\0\0", "	"], dt = q.length * ut.length;
        let bt = "\0\0" + A(dt) + A(12 * dt + 6), vt = 0;
        for (G = 0, et = ut.length; G < et; G++) {
          const xt = ot[G];
          for (J = 0, it = xt.length; J < it; J++)
            lt = xt[J], bt += ut[G] + ct[G] + gt[G] + A(J) + A(lt.length) + A(vt), vt += lt.length;
        }
        return bt += q.join("") + D.join(""), bt;
      }
      l.Font = class {
        constructor(nt, q, D) {
          var ot;
          this.name = nt, this.psName = null, this.mimetype = null, this.disableFontFace = !1, this.loadedName = D.loadedName, this.isType3Font = D.isType3Font, this.missingFile = !1, this.cssFontInfo = D.cssFontInfo, this._charsCache = /* @__PURE__ */ Object.create(null), this._glyphCache = /* @__PURE__ */ Object.create(null);
          let G = !!(D.flags & p.FontFlags.Serif);
          if (!G && !D.isSimulatedFlags) {
            const ut = nt.replaceAll(/[,_]/g, "-").split("-")[0], ct = (0, m.getSerifFonts)();
            for (const gt of ut.split("+")) if (ct[gt]) {
              G = !0;
              break;
            }
          }
          this.isSerifFont = G, this.isSymbolicFont = !!(D.flags & p.FontFlags.Symbolic), this.isMonospace = !!(D.flags & p.FontFlags.FixedPitch);
          let { type: et, subtype: J } = D;
          this.type = et, this.subtype = J, this.systemFontInfo = D.systemFontInfo;
          const it = nt.match(/^InvalidPDFjsFont_(.*)_\d+$/);
          if (this.isInvalidPDFjsFont = !!it, this.isInvalidPDFjsFont ? this.fallbackName = it[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif", (ot = this.systemFontInfo) != null && ot.guessFallback && (this.systemFontInfo.guessFallback = !1, this.systemFontInfo.css += `,${this.fallbackName}`), this.differences = D.differences, this.widths = D.widths, this.defaultWidth = D.defaultWidth, this.composite = D.composite, this.cMap = D.cMap, this.capHeight = D.capHeight / W, this.ascent = D.ascent / W, this.descent = D.descent / W, this.lineHeight = this.ascent - this.descent, this.fontMatrix = D.fontMatrix, this.bbox = D.bbox, this.defaultEncoding = D.defaultEncoding, this.toUnicode = D.toUnicode, this.toFontChar = [], D.type === "Type3") {
            for (let ut = 0; ut < 256; ut++) this.toFontChar[ut] = this.differences[ut] || D.defaultEncoding[ut];
            return;
          }
          if (this.cidEncoding = D.cidEncoding || "", this.vertical = !!D.vertical, this.vertical && (this.vmetrics = D.vmetrics, this.defaultVMetrics = D.defaultVMetrics), !q || q.isEmpty) {
            q && (0, o.warn)('Font file is empty in "' + nt + '" (' + this.loadedName + ")"), this.fallbackToSystemFont(D);
            return;
          }
          [et, J] = X(q, D), et === this.type && J === this.subtype || (0, o.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${et}/${J}.`);
          let lt;
          try {
            switch (et) {
              case "MMType1":
                (0, o.info)("MMType1 font (" + nt + "), falling back to Type1.");
              case "Type1":
              case "CIDFontType0":
                this.mimetype = "font/opentype";
                const ut = J === "Type1C" || J === "CIDFontType0C" ? new w.CFFFont(q, D) : new I.Type1Font(nt, q, D);
                $(D), lt = this.convert(nt, ut, D);
                break;
              case "OpenType":
              case "TrueType":
              case "CIDFontType2":
                this.mimetype = "font/opentype", lt = this.checkAndRepair(nt, q, D), this.isOpenType && ($(D), et = "OpenType");
                break;
              default:
                throw new o.FormatError(`Font ${et} is not supported`);
            }
          } catch (ut) {
            (0, o.warn)(ut), this.fallbackToSystemFont(D);
            return;
          }
          B(D), this.data = lt, this.type = et, this.subtype = J, this.fontMatrix = D.fontMatrix, this.widths = D.widths, this.defaultWidth = D.defaultWidth, this.toUnicode = D.toUnicode, this.seacMap = D.seacMap;
        }
        get renderer() {
          const nt = v.FontRendererFactory.create(this, p.SEAC_ANALYSIS_ENABLED);
          return (0, o.shadow)(this, "renderer", nt);
        }
        exportData(nt = !1) {
          const q = nt ? [...z, ...j] : z, D = /* @__PURE__ */ Object.create(null);
          let G, et;
          for (G of q)
            et = this[G], et !== void 0 && (D[G] = et);
          return D;
        }
        fallbackToSystemFont(nt) {
          this.missingFile = !0;
          const { name: q, type: D } = this;
          let G = (0, p.normalizeFontName)(q);
          const et = (0, m.getStdFontMap)(), J = (0, m.getNonStdFontMap)(), it = !!et[G], lt = !(!J[G] || !et[J[G]]);
          G = et[G] || J[G] || G;
          const ot = (0, h.getFontBasicMetrics)()[G];
          ot && (isNaN(this.ascent) && (this.ascent = ot.ascent / W), isNaN(this.descent) && (this.descent = ot.descent / W), isNaN(this.capHeight) && (this.capHeight = ot.capHeight / W)), this.bold = /bold/gi.test(G), this.italic = /oblique|italic/gi.test(G), this.black = /Black/g.test(q);
          const ut = /Narrow/g.test(q);
          if (this.remeasure = (!it || ut) && Object.keys(this.widths).length > 0, (it || lt) && D === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
            const ct = nt.cidToGidMap, gt = [];
            if (L(gt, (0, m.getGlyphMapForStandardFonts)()), /Arial-?Black/i.test(q) ? L(gt, (0, m.getSupplementalGlyphMapForArialBlack)()) : /Calibri/i.test(q) && L(gt, (0, m.getSupplementalGlyphMapForCalibri)()), ct) {
              for (const dt in gt) {
                const bt = gt[dt];
                ct[bt] !== void 0 && (gt[+dt] = ct[bt]);
              }
              ct.length !== this.toUnicode.length && nt.hasIncludedToUnicodeMap && this.toUnicode instanceof b.IdentityToUnicodeMap && this.toUnicode.forEach(function(dt, bt) {
                const vt = gt[dt];
                ct[vt] === void 0 && (gt[+dt] = bt);
              });
            }
            this.toUnicode instanceof b.IdentityToUnicodeMap || this.toUnicode.forEach(function(dt, bt) {
              gt[+dt] = bt;
            }), this.toFontChar = gt, this.toUnicode = new b.ToUnicodeMap(gt);
          } else if (/Symbol/i.test(G)) this.toFontChar = H(d.SymbolSetEncoding, (0, a.getGlyphsUnicode)(), this.differences);
          else if (/Dingbats/i.test(G)) this.toFontChar = H(d.ZapfDingbatsEncoding, (0, a.getDingbatsGlyphsUnicode)(), this.differences);
          else if (it) {
            const ct = H(this.defaultEncoding, (0, a.getGlyphsUnicode)(), this.differences);
            D !== "CIDFontType2" || this.cidEncoding.startsWith("Identity-") || this.toUnicode instanceof b.IdentityToUnicodeMap || this.toUnicode.forEach(function(gt, dt) {
              ct[+gt] = dt;
            }), this.toFontChar = ct;
          } else {
            const ct = (0, a.getGlyphsUnicode)(), gt = [];
            this.toUnicode.forEach((dt, bt) => {
              if (!this.composite) {
                const vt = this.differences[dt] || this.defaultEncoding[dt], xt = (0, n.getUnicodeForGlyph)(vt, ct);
                xt !== -1 && (bt = xt);
              }
              gt[+dt] = bt;
            }), this.composite && this.toUnicode instanceof b.IdentityToUnicodeMap && /Tahoma|Verdana/i.test(q) && L(gt, (0, m.getGlyphMapForStandardFonts)()), this.toFontChar = gt;
          }
          B(nt), this.loadedName = G.split("-")[0];
        }
        checkAndRepair(nt, q, D) {
          var ve, Oe, He;
          const G = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
          function et(Zt, Xt) {
            const Gt = /* @__PURE__ */ Object.create(null);
            Gt["OS/2"] = null, Gt.cmap = null, Gt.head = null, Gt.hhea = null, Gt.hmtx = null, Gt.maxp = null, Gt.name = null, Gt.post = null;
            for (let Lt = 0; Lt < Xt; Lt++) {
              const Dt = J(Zt);
              G.includes(Dt.tag) && Dt.length !== 0 && (Gt[Dt.tag] = Dt);
            }
            return Gt;
          }
          function J(Zt) {
            const Xt = Zt.getString(4), Gt = Zt.getInt32() >>> 0, Lt = Zt.getInt32() >>> 0, Dt = Zt.getInt32() >>> 0, jt = Zt.pos;
            Zt.pos = Zt.start || 0, Zt.skip(Lt);
            const Ot = Zt.getBytes(Dt);
            return Zt.pos = jt, Xt === "head" && (Ot[8] = Ot[9] = Ot[10] = Ot[11] = 0, Ot[17] |= 32), { tag: Xt, checksum: Gt, length: Dt, offset: Lt, data: Ot };
          }
          function it(Zt) {
            return { version: Zt.getString(4), numTables: Zt.getUint16(), searchRange: Zt.getUint16(), entrySelector: Zt.getUint16(), rangeShift: Zt.getUint16() };
          }
          function lt(Zt, Xt, Gt, Lt, Dt, jt) {
            const Ot = { length: 0, sizeOfInstructions: 0 };
            if (Xt < 0 || Xt >= Zt.length || Gt > Zt.length || Gt - Xt <= 12) return Ot;
            const Rt = Zt.subarray(Xt, Gt), Tt = S(Rt[2], Rt[3]), ee = S(Rt[4], Rt[5]), te = S(Rt[6], Rt[7]), Jt = S(Rt[8], Rt[9]);
            Tt > te && (F(Rt, 2, te), F(Rt, 6, Tt)), ee > Jt && (F(Rt, 4, Jt), F(Rt, 8, ee));
            const pe = S(Rt[0], Rt[1]);
            if (pe < 0)
              return pe < -1 || (Lt.set(Rt, Dt), Ot.length = Rt.length), Ot;
            let ye, fe = 10, me = 0;
            for (ye = 0; ye < pe; ye++)
              me = (Rt[fe] << 8 | Rt[fe + 1]) + 1, fe += 2;
            const we = fe, Fe = Rt[fe] << 8 | Rt[fe + 1];
            Ot.sizeOfInstructions = Fe, fe += 2 + Fe;
            const Re = fe;
            let ge = 0;
            for (ye = 0; ye < me; ye++) {
              const ue = Rt[fe++];
              192 & ue && (Rt[fe - 1] = 63 & ue);
              let Ae = 2;
              2 & ue ? Ae = 1 : 16 & ue && (Ae = 0);
              let he = 2;
              4 & ue ? he = 1 : 32 & ue && (he = 0);
              const de = Ae + he;
              if (ge += de, 8 & ue) {
                const _e = Rt[fe++];
                _e === 0 && (Rt[fe - 1] ^= 8), ye += _e, ge += _e * de;
              }
            }
            if (ge === 0) return Ot;
            let se = fe + ge;
            return se > Rt.length ? Ot : !jt && Fe > 0 ? (Lt.set(Rt.subarray(0, we), Dt), Lt.set([0, 0], Dt + we), Lt.set(Rt.subarray(Re, se), Dt + we + 2), se -= Fe, Rt.length - se > 3 && (se = se + 3 & -4), Ot.length = se, Ot) : Rt.length - se > 3 ? (se = se + 3 & -4, Lt.set(Rt.subarray(0, se), Dt), Ot.length = se, Ot) : (Lt.set(Rt, Dt), Ot.length = Rt.length, Ot);
          }
          function ot(Zt) {
            const Xt = (q.start || 0) + Zt.offset;
            q.pos = Xt;
            const Gt = [[], []], Lt = [], Dt = Zt.length, jt = Xt + Dt;
            if (q.getUint16() !== 0 || Dt < 6) return [Gt, Lt];
            const Ot = q.getUint16(), Rt = q.getUint16();
            let Tt, ee;
            for (Tt = 0; Tt < Ot && q.pos + 12 <= jt; Tt++) {
              const te = { platform: q.getUint16(), encoding: q.getUint16(), language: q.getUint16(), name: q.getUint16(), length: q.getUint16(), offset: q.getUint16() };
              (Q(te) || N(te)) && Lt.push(te);
            }
            for (Tt = 0, ee = Lt.length; Tt < ee; Tt++) {
              const te = Lt[Tt];
              if (te.length <= 0) continue;
              const Jt = Xt + Rt + te.offset;
              if (Jt + te.length > jt) continue;
              q.pos = Jt;
              const pe = te.name;
              if (te.encoding) {
                let ye = "";
                for (let fe = 0, me = te.length; fe < me; fe += 2) ye += String.fromCharCode(q.getUint16());
                Gt[1][pe] = ye;
              } else Gt[0][pe] = q.getString(te.length);
            }
            return [Gt, Lt];
          }
          const ut = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
          function ct(Zt, Xt) {
            let Gt, Lt, Dt, jt, Ot, Rt = Zt.data, Tt = 0, ee = 0, te = 0;
            const Jt = [], pe = [], ye = [];
            let fe = Xt.tooComplexToFollowFunctions, me = !1, we = 0, Fe = 0;
            for (let ge = Rt.length; Tt < ge; ) {
              const se = Rt[Tt++];
              if (se === 64)
                if (Lt = Rt[Tt++], me || Fe) Tt += Lt;
                else for (Gt = 0; Gt < Lt; Gt++) Jt.push(Rt[Tt++]);
              else if (se === 65)
                if (Lt = Rt[Tt++], me || Fe) Tt += 2 * Lt;
                else for (Gt = 0; Gt < Lt; Gt++)
                  Dt = Rt[Tt++], Jt.push(Dt << 8 | Rt[Tt++]);
              else if ((248 & se) == 176)
                if (Lt = se - 176 + 1, me || Fe) Tt += Lt;
                else for (Gt = 0; Gt < Lt; Gt++) Jt.push(Rt[Tt++]);
              else if ((248 & se) == 184)
                if (Lt = se - 184 + 1, me || Fe) Tt += 2 * Lt;
                else for (Gt = 0; Gt < Lt; Gt++)
                  Dt = Rt[Tt++], Jt.push(Dt << 8 | Rt[Tt++]);
              else if (se !== 43 || fe) if (se !== 44 || fe) {
                if (se === 45) if (me)
                  me = !1, ee = Tt;
                else {
                  if (Ot = pe.pop(), !Ot) {
                    (0, o.warn)("TT: ENDF bad stack"), Xt.hintsValid = !1;
                    return;
                  }
                  jt = ye.pop(), Rt = Ot.data, Tt = Ot.i, Xt.functionsStackDeltas[jt] = Jt.length - Ot.stackTop;
                }
                else if (se === 137)
                  (me || Fe) && ((0, o.warn)("TT: nested IDEFs not allowed"), fe = !0), me = !0, te = Tt;
                else if (se === 88) ++we;
                else if (se === 27) Fe = we;
                else if (se === 89)
                  Fe === we && (Fe = 0), --we;
                else if (se === 28 && !me && !Fe) {
                  const ue = Jt.at(-1);
                  ue > 0 && (Tt += ue - 1);
                }
              } else
                (me || Fe) && ((0, o.warn)("TT: nested FDEFs not allowed"), fe = !0), me = !0, te = Tt, jt = Jt.pop(), Xt.functionsDefined[jt] = { data: Rt, i: Tt };
              else if (!me && !Fe) {
                if (jt = Jt.at(-1), isNaN(jt)) (0, o.info)("TT: CALL empty stack (or invalid entry).");
                else if (Xt.functionsUsed[jt] = !0, jt in Xt.functionsStackDeltas) {
                  const ue = Jt.length + Xt.functionsStackDeltas[jt];
                  if (ue < 0) {
                    (0, o.warn)("TT: CALL invalid functions stack delta."), Xt.hintsValid = !1;
                    return;
                  }
                  Jt.length = ue;
                } else if (jt in Xt.functionsDefined && !ye.includes(jt)) {
                  if (pe.push({ data: Rt, i: Tt, stackTop: Jt.length - 1 }), ye.push(jt), Ot = Xt.functionsDefined[jt], !Ot) {
                    (0, o.warn)("TT: CALL non-existent function"), Xt.hintsValid = !1;
                    return;
                  }
                  Rt = Ot.data, Tt = Ot.i;
                }
              }
              if (!me && !Fe) {
                let ue = 0;
                for (se <= 142 ? ue = ut[se] : se >= 192 && se <= 223 ? ue = -1 : se >= 224 && (ue = -2), se >= 113 && se <= 117 && (Lt = Jt.pop(), isNaN(Lt) || (ue = 2 * -Lt)); ue < 0 && Jt.length > 0; )
                  Jt.pop(), ue++;
                for (; ue > 0; )
                  Jt.push(NaN), ue--;
              }
            }
            Xt.tooComplexToFollowFunctions = fe;
            const Re = [Rt];
            Tt > Rt.length && Re.push(new Uint8Array(Tt - Rt.length)), te > ee && ((0, o.warn)("TT: complementing a missing function tail"), Re.push(new Uint8Array([34, 45]))), function(se, ue) {
              if (ue.length > 1) {
                let Ae, he, de = 0;
                for (Ae = 0, he = ue.length; Ae < he; Ae++) de += ue[Ae].length;
                de = de + 3 & -4;
                const _e = new Uint8Array(de);
                let Qe = 0;
                for (Ae = 0, he = ue.length; Ae < he; Ae++)
                  _e.set(ue[Ae], Qe), Qe += ue[Ae].length;
                se.data = _e, se.length = de;
              }
            }(Zt, Re);
          }
          let gt, dt, bt, vt;
          if (K(q = new E.Stream(new Uint8Array(q.getBytes())))) {
            const Zt = function(Gt, Lt) {
              var Tt;
              const { numFonts: Dt, offsetTable: jt } = function(te) {
                const Jt = te.getString(4);
                (0, o.assert)(Jt === "ttcf", "Must be a TrueType Collection font.");
                const pe = te.getUint16(), ye = te.getUint16(), fe = te.getInt32() >>> 0, me = [];
                for (let Fe = 0; Fe < fe; Fe++) me.push(te.getInt32() >>> 0);
                const we = { ttcTag: Jt, majorVersion: pe, minorVersion: ye, numFonts: fe, offsetTable: me };
                switch (pe) {
                  case 1:
                    return we;
                  case 2:
                    return we.dsigTag = te.getInt32() >>> 0, we.dsigLength = te.getInt32() >>> 0, we.dsigOffset = te.getInt32() >>> 0, we;
                }
                throw new o.FormatError(`Invalid TrueType Collection majorVersion: ${pe}.`);
              }(Gt), Ot = Lt.split("+");
              let Rt;
              for (let ee = 0; ee < Dt; ee++) {
                Gt.pos = (Gt.start || 0) + jt[ee];
                const te = it(Gt), Jt = et(Gt, te.numTables);
                if (!Jt.name) throw new o.FormatError('TrueType Collection font must contain a "name" table.');
                const [pe] = ot(Jt.name);
                for (let ye = 0, fe = pe.length; ye < fe; ye++) for (let me = 0, we = pe[ye].length; me < we; me++) {
                  const Fe = (Tt = pe[ye][me]) == null ? void 0 : Tt.replaceAll(/\s/g, "");
                  if (Fe) {
                    if (Fe === Lt) return { header: te, tables: Jt };
                    if (!(Ot.length < 2)) for (const Re of Ot) Fe === Re && (Rt = { name: Re, header: te, tables: Jt });
                  }
                }
              }
              if (Rt)
                return (0, o.warn)(`TrueType Collection does not contain "${Lt}" font, falling back to "${Rt.name}" font instead.`), { header: Rt.header, tables: Rt.tables };
              throw new o.FormatError(`TrueType Collection does not contain "${Lt}" font.`);
            }(q, this.name);
            gt = Zt.header, dt = Zt.tables;
          } else
            gt = it(q), dt = et(q, gt.numTables);
          const xt = !dt["CFF "];
          if (xt) {
            if (!dt.loca) throw new o.FormatError('Required "loca" table is not found');
            dt.glyf || ((0, o.warn)('Required "glyf" table is not found -- trying to recover.'), dt.glyf = { tag: "glyf", data: new Uint8Array(0) }), this.isOpenType = !1;
          } else {
            const Zt = D.composite && (((ve = D.cidToGidMap) == null ? void 0 : ve.length) > 0 || !(D.cMap instanceof _.IdentityCMap));
            if (gt.version === "OTTO" && !Zt || !dt.head || !dt.hhea || !dt.maxp || !dt.post)
              return vt = new E.Stream(dt["CFF "].data), bt = new w.CFFFont(vt, D), $(D), this.convert(nt, bt, D);
            delete dt.glyf, delete dt.loca, delete dt.fpgm, delete dt.prep, delete dt["cvt "], this.isOpenType = !0;
          }
          if (!dt.maxp) throw new o.FormatError('Required "maxp" table is not found');
          q.pos = (q.start || 0) + dt.maxp.offset;
          const St = q.getInt32(), Mt = q.getUint16();
          if (((Oe = D.scaleFactors) == null ? void 0 : Oe.length) === Mt && xt) {
            const { scaleFactors: Zt } = D, Xt = T(dt.head.data[50], dt.head.data[51]), Gt = new x.GlyfTable({ glyfTable: dt.glyf.data, isGlyphLocationsLong: Xt, locaTable: dt.loca.data, numGlyphs: Mt });
            Gt.scale(Zt);
            const { glyf: Lt, loca: Dt, isLocationLong: jt } = Gt.write();
            dt.glyf.data = Lt, dt.loca.data = Dt, jt !== !!Xt && (dt.head.data[50] = 0, dt.head.data[51] = jt ? 1 : 0);
            const Ot = dt.hmtx.data;
            for (let Rt = 0; Rt < Mt; Rt++) {
              const Tt = 4 * Rt, ee = Math.round(Zt[Rt] * T(Ot[Tt], Ot[Tt + 1]));
              Ot[Tt] = ee >> 8 & 255, Ot[Tt + 1] = 255 & ee, F(Ot, Tt + 2, Math.round(Zt[Rt] * S(Ot[Tt + 2], Ot[Tt + 3])));
            }
          }
          let Et = Mt + 1, Ft = !0;
          Et > 65535 && (Ft = !1, Et = Mt, (0, o.warn)("Not enough space in glyfs to duplicate first glyph."));
          let Wt = 0, Kt = 0;
          St >= 65536 && dt.maxp.length >= 22 && (q.pos += 8, q.getUint16() > 2 && (dt.maxp.data[14] = 0, dt.maxp.data[15] = 2), q.pos += 4, Wt = q.getUint16(), q.pos += 4, Kt = q.getUint16()), dt.maxp.data[4] = Et >> 8, dt.maxp.data[5] = 255 & Et;
          const qt = function(Xt, Gt, Lt, Dt) {
            const jt = { functionsDefined: [], functionsUsed: [], functionsStackDeltas: [], tooComplexToFollowFunctions: !1, hintsValid: !0 };
            if (Xt && ct(Xt, jt), Gt && ct(Gt, jt), Xt && function(Rt, Tt) {
              if (!Rt.tooComplexToFollowFunctions) if (Rt.functionsDefined.length > Tt)
                (0, o.warn)("TT: more functions defined than expected"), Rt.hintsValid = !1;
              else for (let ee = 0, te = Rt.functionsUsed.length; ee < te; ee++) {
                if (ee > Tt) {
                  (0, o.warn)("TT: invalid function id: " + ee), Rt.hintsValid = !1;
                  return;
                }
                if (Rt.functionsUsed[ee] && !Rt.functionsDefined[ee]) {
                  (0, o.warn)("TT: undefined function: " + ee), Rt.hintsValid = !1;
                  return;
                }
              }
            }(jt, Dt), Lt && 1 & Lt.length) {
              const Ot = new Uint8Array(Lt.length + 1);
              Ot.set(Lt.data), Lt.data = Ot;
            }
            return jt.hintsValid;
          }(dt.fpgm, dt.prep, dt["cvt "], Wt);
          if (qt || (delete dt.fpgm, delete dt.prep, delete dt["cvt "]), function(Xt, Gt, Lt, Dt, jt, Ot) {
            if (!Gt) {
              Lt && (Lt.data = null);
              return;
            }
            Xt.pos = (Xt.start || 0) + Gt.offset, Xt.pos += 4, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2, Xt.pos += 2;
            const Rt = Xt.getUint16();
            Xt.pos += 8, Xt.pos += 2;
            let Tt = Xt.getUint16();
            Rt !== 0 && (2 & T(Dt.data[44], Dt.data[45]) || (Gt.data[22] = 0, Gt.data[23] = 0)), Tt > jt && ((0, o.info)(`The numOfMetrics (${Tt}) should not be greater than the numGlyphs (${jt}).`), Tt = jt, Gt.data[34] = (65280 & Tt) >> 8, Gt.data[35] = 255 & Tt);
            const ee = jt - Tt - (Lt.length - 4 * Tt >> 1);
            if (ee > 0) {
              const te = new Uint8Array(Lt.length + 2 * ee);
              te.set(Lt.data), Ot && (te[Lt.length] = Lt.data[2], te[Lt.length + 1] = Lt.data[3]), Lt.data = te;
            }
          }(q, dt.hhea, dt.hmtx, dt.head, Et, Ft), !dt.head) throw new o.FormatError('Required "head" table is not found');
          (function(Xt, Gt, Lt) {
            const Dt = Xt.data, jt = function(Tt, ee, te, Jt) {
              return (Tt << 24) + (ee << 16) + (te << 8) + Jt;
            }(Dt[0], Dt[1], Dt[2], Dt[3]);
            jt >> 16 != 1 && ((0, o.info)("Attempting to fix invalid version in head table: " + jt), Dt[0] = 0, Dt[1] = 1, Dt[2] = 0, Dt[3] = 0);
            const Ot = T(Dt[50], Dt[51]);
            if (Ot < 0 || Ot > 1) {
              (0, o.info)("Attempting to fix invalid indexToLocFormat in head table: " + Ot);
              const Rt = Gt + 1;
              if (Lt === Rt << 1)
                Dt[50] = 0, Dt[51] = 0;
              else {
                if (Lt !== Rt << 2) throw new o.FormatError("Could not fix indexToLocFormat: " + Ot);
                Dt[50] = 0, Dt[51] = 1;
              }
            }
          })(dt.head, Mt, xt ? dt.loca.length : 0);
          let It = /* @__PURE__ */ Object.create(null);
          if (xt) {
            const Zt = T(dt.head.data[50], dt.head.data[51]), Xt = function(Lt, Dt, jt, Ot, Rt, Tt, ee) {
              let te, Jt, pe;
              Ot ? (te = 4, Jt = function(_e, Qe) {
                return _e[Qe] << 24 | _e[Qe + 1] << 16 | _e[Qe + 2] << 8 | _e[Qe + 3];
              }, pe = function(_e, Qe, $n) {
                _e[Qe] = $n >>> 24 & 255, _e[Qe + 1] = $n >> 16 & 255, _e[Qe + 2] = $n >> 8 & 255, _e[Qe + 3] = 255 & $n;
              }) : (te = 2, Jt = function(_e, Qe) {
                return _e[Qe] << 9 | _e[Qe + 1] << 1;
              }, pe = function(_e, Qe, $n) {
                _e[Qe] = $n >> 9 & 255, _e[Qe + 1] = $n >> 1 & 255;
              });
              const ye = Tt ? jt + 1 : jt, fe = te * (1 + ye), me = new Uint8Array(fe);
              me.set(Lt.data.subarray(0, fe)), Lt.data = me;
              const we = Dt.data, Fe = we.length, Re = new Uint8Array(Fe);
              let ge, se;
              const ue = [];
              for (ge = 0, se = 0; ge < jt + 1; ge++, se += te) {
                let de = Jt(me, se);
                de > Fe && (de = Fe), ue.push({ index: ge, offset: de, endOffset: 0 });
              }
              for (ue.sort((de, _e) => de.offset - _e.offset), ge = 0; ge < jt; ge++) ue[ge].endOffset = ue[ge + 1].offset;
              for (ue.sort((de, _e) => de.index - _e.index), ge = 0; ge < jt; ge++) {
                const { offset: de, endOffset: _e } = ue[ge];
                if (de !== 0 || _e !== 0) break;
                const Qe = ue[ge + 1].offset;
                if (Qe !== 0) {
                  ue[ge].endOffset = Qe;
                  break;
                }
              }
              const Ae = /* @__PURE__ */ Object.create(null);
              let he = 0;
              for (pe(me, 0, he), ge = 0, se = te; ge < jt; ge++, se += te) {
                const de = lt(we, ue[ge].offset, ue[ge].endOffset, Re, he, Rt), _e = de.length;
                _e === 0 && (Ae[ge] = !0), de.sizeOfInstructions > ee && (ee = de.sizeOfInstructions), he += _e, pe(me, se, he);
              }
              if (he === 0) {
                const de = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                for (ge = 0, se = te; ge < ye; ge++, se += te) pe(me, se, de.length);
                Dt.data = de;
              } else if (Tt) {
                const de = Jt(me, te);
                Re.length > de + he ? Dt.data = Re.subarray(0, de + he) : (Dt.data = new Uint8Array(de + he), Dt.data.set(Re.subarray(0, he))), Dt.data.set(Re.subarray(0, de), he), pe(Lt.data, me.length - te, he + de);
              } else Dt.data = Re.subarray(0, he);
              return { missingGlyphs: Ae, maxSizeOfInstructions: ee };
            }(dt.loca, dt.glyf, Mt, Zt, qt, Ft, Kt);
            It = Xt.missingGlyphs, St >= 65536 && dt.maxp.length >= 22 && (dt.maxp.data[26] = Xt.maxSizeOfInstructions >> 8, dt.maxp.data[27] = 255 & Xt.maxSizeOfInstructions);
          }
          if (!dt.hhea) throw new o.FormatError('Required "hhea" table is not found');
          dt.hhea.data[10] === 0 && dt.hhea.data[11] === 0 && (dt.hhea.data[10] = 255, dt.hhea.data[11] = 255);
          const re = { unitsPerEm: T(dt.head.data[18], dt.head.data[19]), yMax: S(dt.head.data[42], dt.head.data[43]), yMin: S(dt.head.data[38], dt.head.data[39]), ascent: S(dt.hhea.data[4], dt.hhea.data[5]), descent: S(dt.hhea.data[6], dt.hhea.data[7]), lineGap: S(dt.hhea.data[8], dt.hhea.data[9]) };
          this.ascent = re.ascent / re.unitsPerEm, this.descent = re.descent / re.unitsPerEm, this.lineGap = re.lineGap / re.unitsPerEm, (He = this.cssFontInfo) != null && He.lineHeight ? (this.lineHeight = this.cssFontInfo.metrics.lineHeight, this.lineGap = this.cssFontInfo.metrics.lineGap) : this.lineHeight = this.ascent - this.descent + this.lineGap, dt.post && function(Xt, Gt, Lt) {
            const Dt = (q.start || 0) + Xt.offset;
            q.pos = Dt;
            const jt = Dt + Xt.length, Ot = q.getInt32();
            q.skip(28);
            let Rt, Tt, ee = !0;
            switch (Ot) {
              case 65536:
                Rt = p.MacStandardGlyphOrdering;
                break;
              case 131072:
                const te = q.getUint16();
                if (te !== Lt) {
                  ee = !1;
                  break;
                }
                const Jt = [];
                for (Tt = 0; Tt < te; ++Tt) {
                  const fe = q.getUint16();
                  if (fe >= 32768) {
                    ee = !1;
                    break;
                  }
                  Jt.push(fe);
                }
                if (!ee) break;
                const pe = [], ye = [];
                for (; q.pos < jt; ) {
                  const fe = q.getByte();
                  for (ye.length = fe, Tt = 0; Tt < fe; ++Tt) ye[Tt] = String.fromCharCode(q.getByte());
                  pe.push(ye.join(""));
                }
                for (Rt = [], Tt = 0; Tt < te; ++Tt) {
                  const fe = Jt[Tt];
                  fe < 258 ? Rt.push(p.MacStandardGlyphOrdering[fe]) : Rt.push(pe[fe - 258]);
                }
                break;
              case 196608:
                break;
              default:
                (0, o.warn)("Unknown/unsupported post table version " + Ot), ee = !1, Gt.defaultEncoding && (Rt = Gt.defaultEncoding);
            }
            return Gt.glyphNames = Rt, ee;
          }(dt.post, D, Mt), dt.post = { tag: "post", data: st(D) };
          const le = [];
          function Ce(Zt) {
            return !It[Zt];
          }
          if (D.composite) {
            const Zt = D.cidToGidMap || [], Xt = Zt.length === 0;
            D.cMap.forEach(function(Gt, Lt) {
              if (typeof Lt == "string" && (Lt = V(Gt, Lt, !0)), Lt > 65535) throw new o.FormatError("Max size of CID is 65,535");
              let Dt = -1;
              Xt ? Dt = Lt : Zt[Lt] !== void 0 && (Dt = Zt[Lt]), Dt >= 0 && Dt < Mt && Ce(Dt) && (le[Gt] = Dt);
            });
          } else {
            const Zt = function(Rt, Tt, ee, te) {
              if (!Rt)
                return (0, o.warn)("No cmap table available."), { platformId: -1, encodingId: -1, mappings: [], hasShortCmap: !1 };
              let Jt, pe = (Tt.start || 0) + Rt.offset;
              Tt.pos = pe, Tt.skip(2);
              const ye = Tt.getUint16();
              let fe, me = !1;
              for (let ue = 0; ue < ye; ue++) {
                const Ae = Tt.getUint16(), he = Tt.getUint16(), de = Tt.getInt32() >>> 0;
                let _e = !1;
                if ((fe == null ? void 0 : fe.platformId) !== Ae || (fe == null ? void 0 : fe.encodingId) !== he) {
                  if (Ae !== 0 || he !== 0 && he !== 1 && he !== 3) if (Ae === 1 && he === 0) _e = !0;
                  else if (Ae !== 3 || he !== 1 || !te && fe) {
                    if (ee && Ae === 3 && he === 0) {
                      _e = !0;
                      let Qe = !0;
                      if (ue < ye - 1) {
                        const $n = Tt.peekBytes(2);
                        T($n[0], $n[1]) < Ae && (Qe = !1);
                      }
                      Qe && (me = !0);
                    }
                  } else
                    _e = !0, ee || (me = !0);
                  else _e = !0;
                  if (_e && (fe = { platformId: Ae, encodingId: he, offset: de }), me) break;
                }
              }
              if (fe && (Tt.pos = pe + fe.offset), !fe || Tt.peekByte() === -1)
                return (0, o.warn)("Could not find a preferred cmap table."), { platformId: -1, encodingId: -1, mappings: [], hasShortCmap: !1 };
              const we = Tt.getUint16();
              let Fe = !1;
              const Re = [];
              let ge, se;
              if (we === 0) {
                for (Tt.skip(4), ge = 0; ge < 256; ge++) {
                  const ue = Tt.getByte();
                  ue && Re.push({ charCode: ge, glyphId: ue });
                }
                Fe = !0;
              } else if (we === 2) {
                Tt.skip(4);
                const ue = [];
                let Ae = 0;
                for (let de = 0; de < 256; de++) {
                  const _e = Tt.getUint16() >> 3;
                  ue.push(_e), Ae = Math.max(_e, Ae);
                }
                const he = [];
                for (let de = 0; de <= Ae; de++) he.push({ firstCode: Tt.getUint16(), entryCount: Tt.getUint16(), idDelta: S(Tt.getByte(), Tt.getByte()), idRangePos: Tt.pos + Tt.getUint16() });
                for (let de = 0; de < 256; de++) if (ue[de] === 0)
                  Tt.pos = he[0].idRangePos + 2 * de, se = Tt.getUint16(), Re.push({ charCode: de, glyphId: se });
                else {
                  const _e = he[ue[de]];
                  for (ge = 0; ge < _e.entryCount; ge++) {
                    const Qe = (de << 8) + ge + _e.firstCode;
                    Tt.pos = _e.idRangePos + 2 * ge, se = Tt.getUint16(), se !== 0 && (se = (se + _e.idDelta) % 65536), Re.push({ charCode: Qe, glyphId: se });
                  }
                }
              } else if (we === 4) {
                Tt.skip(4);
                const ue = Tt.getUint16() >> 1;
                Tt.skip(6);
                const Ae = [];
                let he;
                for (he = 0; he < ue; he++) Ae.push({ end: Tt.getUint16() });
                for (Tt.skip(2), he = 0; he < ue; he++) Ae[he].start = Tt.getUint16();
                for (he = 0; he < ue; he++) Ae[he].delta = Tt.getUint16();
                let de, _e = 0;
                for (he = 0; he < ue; he++) {
                  Jt = Ae[he];
                  const $n = Tt.getUint16();
                  $n ? (de = ($n >> 1) - (ue - he), Jt.offsetIndex = de, _e = Math.max(_e, de + Jt.end - Jt.start + 1)) : Jt.offsetIndex = -1;
                }
                const Qe = [];
                for (ge = 0; ge < _e; ge++) Qe.push(Tt.getUint16());
                for (he = 0; he < ue; he++) {
                  Jt = Ae[he], pe = Jt.start;
                  const $n = Jt.end, zr = Jt.delta;
                  for (de = Jt.offsetIndex, ge = pe; ge <= $n; ge++) ge !== 65535 && (se = de < 0 ? ge : Qe[de + ge - pe], se = se + zr & 65535, Re.push({ charCode: ge, glyphId: se }));
                }
              } else if (we === 6) {
                Tt.skip(4);
                const ue = Tt.getUint16(), Ae = Tt.getUint16();
                for (ge = 0; ge < Ae; ge++) {
                  se = Tt.getUint16();
                  const he = ue + ge;
                  Re.push({ charCode: he, glyphId: se });
                }
              } else {
                if (we !== 12)
                  return (0, o.warn)("cmap table has unsupported format: " + we), { platformId: -1, encodingId: -1, mappings: [], hasShortCmap: !1 };
                {
                  Tt.skip(10);
                  const ue = Tt.getInt32() >>> 0;
                  for (ge = 0; ge < ue; ge++) {
                    const Ae = Tt.getInt32() >>> 0, he = Tt.getInt32() >>> 0;
                    let de = Tt.getInt32() >>> 0;
                    for (let _e = Ae; _e <= he; _e++) Re.push({ charCode: _e, glyphId: de++ });
                  }
                }
              }
              Re.sort(function(ue, Ae) {
                return ue.charCode - Ae.charCode;
              });
              for (let ue = 1; ue < Re.length; ue++) Re[ue - 1].charCode === Re[ue].charCode && (Re.splice(ue, 1), ue--);
              return { platformId: fe.platformId, encodingId: fe.encodingId, mappings: Re, hasShortCmap: Fe };
            }(dt.cmap, q, this.isSymbolicFont, D.hasEncoding), Xt = Zt.platformId, Gt = Zt.encodingId, Lt = Zt.mappings;
            let Dt = [], jt = !1;
            if (!D.hasEncoding || D.baseEncodingName !== "MacRomanEncoding" && D.baseEncodingName !== "WinAnsiEncoding" || (Dt = (0, d.getEncoding)(D.baseEncodingName)), D.hasEncoding && !this.isSymbolicFont && (Xt === 3 && Gt === 1 || Xt === 1 && Gt === 0)) {
              const Ot = (0, a.getGlyphsUnicode)();
              for (let Rt = 0; Rt < 256; Rt++) {
                let Tt;
                if (Tt = this.differences[Rt] !== void 0 ? this.differences[Rt] : Dt.length && Dt[Rt] !== "" ? Dt[Rt] : d.StandardEncoding[Rt], !Tt) continue;
                const ee = (0, p.recoverGlyphName)(Tt, Ot);
                let te;
                if (Xt === 3 && Gt === 1 ? te = Ot[ee] : Xt === 1 && Gt === 0 && (te = d.MacRomanEncoding.indexOf(ee)), te === void 0) {
                  if (!D.glyphNames && D.hasIncludedToUnicodeMap && !(this.toUnicode instanceof b.IdentityToUnicodeMap)) {
                    const Jt = this.toUnicode.get(Rt);
                    Jt && (te = Jt.codePointAt(0));
                  }
                  if (te === void 0) continue;
                }
                for (const Jt of Lt) if (Jt.charCode === te) {
                  le[Rt] = Jt.glyphId;
                  break;
                }
              }
            } else if (Xt === 0) {
              for (const Ot of Lt) le[Ot.charCode] = Ot.glyphId;
              jt = !0;
            } else for (const Ot of Lt) {
              let Rt = Ot.charCode;
              Xt === 3 && Rt >= 61440 && Rt <= 61695 && (Rt &= 255), le[Rt] = Ot.glyphId;
            }
            if (D.glyphNames && (Dt.length || this.differences.length)) for (let Ot = 0; Ot < 256; ++Ot) {
              if (!jt && le[Ot] !== void 0) continue;
              const Rt = this.differences[Ot] || Dt[Ot];
              if (!Rt) continue;
              const Tt = D.glyphNames.indexOf(Rt);
              Tt > 0 && Ce(Tt) && (le[Ot] = Tt);
            }
          }
          le.length === 0 && (le[0] = 0);
          let ce = Et - 1;
          if (Ft || (ce = 0), !D.cssFontInfo) {
            const Zt = Y(le, Ce, ce, this.toUnicode);
            this.toFontChar = Zt.toFontChar, dt.cmap = { tag: "cmap", data: Z(Zt.charCodeToGlyphId, Zt.toUnicodeExtraMap, Et) }, dt["OS/2"] && function(Gt, Lt) {
              Lt.pos = (Lt.start || 0) + Gt.offset;
              const Dt = Lt.getUint16();
              Lt.skip(60);
              const jt = Lt.getUint16();
              return Dt < 4 && 768 & jt || Lt.getUint16() > Lt.getUint16() || (Lt.skip(6), Lt.getUint16() === 0) ? !1 : (Gt.data[8] = Gt.data[9] = 0, !0);
            }(dt["OS/2"], q) || (dt["OS/2"] = { tag: "OS/2", data: rt(D, Zt.charCodeToGlyphId, re) });
          }
          if (!xt) try {
            vt = new E.Stream(dt["CFF "].data), bt = new g.CFFParser(vt, D, p.SEAC_ANALYSIS_ENABLED).parse(), bt.duplicateFirstGlyph();
            const Zt = new g.CFFCompiler(bt);
            dt["CFF "].data = Zt.compile();
          } catch {
            (0, o.warn)("Failed to compile font " + D.loadedName);
          }
          if (dt.name) {
            const [Zt, Xt] = ot(dt.name);
            dt.name.data = yt(nt, Zt), this.psName = Zt[0][6] || null, D.composite || function(Lt, Dt, jt) {
              if (Lt.isInternalFont || Lt.hasIncludedToUnicodeMap || Lt.hasEncoding || Lt.toUnicode instanceof b.IdentityToUnicodeMap || !Dt || jt.length === 0 || Lt.defaultEncoding === d.WinAnsiEncoding) return;
              for (const ee of jt) if (!N(ee)) return;
              const Ot = d.WinAnsiEncoding, Rt = [], Tt = (0, a.getGlyphsUnicode)();
              for (const ee in Ot) {
                const te = Ot[ee];
                if (te === "") continue;
                const Jt = Tt[te];
                Jt !== void 0 && (Rt[ee] = String.fromCharCode(Jt));
              }
              Rt.length > 0 && Lt.toUnicode.amend(Rt);
            }(D, this.isSymbolicFont, Xt);
          } else dt.name = { tag: "name", data: yt(this.name) };
          const xe = new M.OpenTypeFileBuilder(gt.version);
          for (const Zt in dt) xe.addTable(Zt, dt[Zt].data);
          return xe.toArray();
        }
        convert(nt, q, D) {
          D.fixedPitch = !1, D.builtInEncoding && function(xt, St) {
            if (xt.isInternalFont || xt.hasIncludedToUnicodeMap || St === xt.defaultEncoding || xt.toUnicode instanceof b.IdentityToUnicodeMap) return;
            const Mt = [], Et = (0, a.getGlyphsUnicode)();
            for (const Ft in St) {
              if (xt.hasEncoding && (xt.baseEncodingName || xt.differences[Ft] !== void 0)) continue;
              const Wt = St[Ft], Kt = (0, n.getUnicodeForGlyph)(Wt, Et);
              Kt !== -1 && (Mt[Ft] = String.fromCharCode(Kt));
            }
            Mt.length > 0 && xt.toUnicode.amend(Mt);
          }(D, D.builtInEncoding);
          let G = 1;
          q instanceof w.CFFFont && (G = q.numGlyphs - 1);
          const et = q.getGlyphMapping(D);
          let J = null, it = et, lt = null;
          D.cssFontInfo || (J = Y(et, q.hasGlyphId.bind(q), G, this.toUnicode), this.toFontChar = J.toFontChar, it = J.charCodeToGlyphId, lt = J.toUnicodeExtraMap);
          const ot = q.numGlyphs;
          function ut(vt, xt) {
            let St = null;
            for (const Mt in vt) xt === vt[Mt] && (St || (St = [])).push(0 | Mt);
            return St;
          }
          function ct(vt, xt) {
            for (const St in vt) if (xt === vt[St]) return 0 | St;
            return J.charCodeToGlyphId[J.nextAvailableFontCharCode] = xt, J.nextAvailableFontCharCode++;
          }
          const gt = q.seacs;
          if (J && p.SEAC_ANALYSIS_ENABLED && (gt != null && gt.length)) {
            const vt = D.fontMatrix || o.FONT_IDENTITY_MATRIX, xt = q.getCharset(), St = /* @__PURE__ */ Object.create(null);
            for (let Mt in gt) {
              Mt |= 0;
              const Et = gt[Mt], Ft = d.StandardEncoding[Et[2]], Wt = d.StandardEncoding[Et[3]], Kt = xt.indexOf(Ft), qt = xt.indexOf(Wt);
              if (Kt < 0 || qt < 0) continue;
              const It = { x: Et[0] * vt[0] + Et[1] * vt[2] + vt[4], y: Et[0] * vt[1] + Et[1] * vt[3] + vt[5] }, re = ut(et, Mt);
              if (re) for (const le of re) {
                const Ce = J.charCodeToGlyphId, ce = ct(Ce, Kt), xe = ct(Ce, qt);
                St[le] = { baseFontCharCode: ce, accentFontCharCode: xe, accentOffset: It };
              }
            }
            D.seacMap = St;
          }
          const dt = 1 / (D.fontMatrix || o.FONT_IDENTITY_MATRIX)[0], bt = new M.OpenTypeFileBuilder("OTTO");
          return bt.addTable("CFF ", q.data), bt.addTable("OS/2", rt(D, it)), bt.addTable("cmap", Z(it, lt, ot)), bt.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + U(dt) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + U(D.descent) + "ÿ" + U(D.ascent) + A(D.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0"), bt.addTable("hhea", "\0\0\0" + U(D.ascent) + U(D.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + U(D.capHeight) + U(Math.tan(D.italicAngle) * D.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + A(ot)), bt.addTable("hmtx", function() {
            const xt = q.charstrings, St = q.cff ? q.cff.widths : null;
            let Mt = "\0\0\0\0";
            for (let Et = 1, Ft = ot; Et < Ft; Et++) {
              let Wt = 0;
              if (xt) {
                const Kt = xt[Et - 1];
                Wt = "width" in Kt ? Kt.width : 0;
              } else St && (Wt = Math.ceil(St[Et] || 0));
              Mt += A(Wt) + A(0);
            }
            return Mt;
          }()), bt.addTable("maxp", "\0\0P\0" + A(ot)), bt.addTable("name", yt(nt)), bt.addTable("post", st(D)), bt.toArray();
        }
        get spaceWidth() {
          const nt = ["space", "minus", "one", "i", "I"];
          let q;
          for (const D of nt) {
            if (D in this.widths) {
              q = this.widths[D];
              break;
            }
            const G = (0, a.getGlyphsUnicode)()[D];
            let et = 0;
            if (this.composite && this.cMap.contains(G) && (et = this.cMap.lookup(G), typeof et == "string" && (et = V(G, et))), !et && this.toUnicode && (et = this.toUnicode.charCodeOf(G)), et <= 0 && (et = G), q = this.widths[et], q) break;
          }
          return (0, o.shadow)(this, "spaceWidth", q || this.defaultWidth);
        }
        _charToGlyph(nt, q = !1) {
          var dt, bt, vt;
          let D, G, et, J = this._glyphCache[nt];
          if ((J == null ? void 0 : J.isSpace) === q) return J;
          let it = nt;
          (dt = this.cMap) != null && dt.contains(nt) && (it = this.cMap.lookup(nt), typeof it == "string" && (it = V(nt, it))), G = this.widths[it], typeof G != "number" && (G = this.defaultWidth);
          const lt = (bt = this.vmetrics) == null ? void 0 : bt[it];
          let ot = this.toUnicode.get(nt) || nt;
          typeof ot == "number" && (ot = String.fromCharCode(ot));
          let ut = this.toFontChar[nt] !== void 0;
          if (D = this.toFontChar[nt] || nt, this.missingFile) {
            const xt = this.differences[nt] || this.defaultEncoding[nt];
            xt !== ".notdef" && xt !== "" || this.type !== "Type1" || (D = 32), D = (0, n.mapSpecialUnicodeValues)(D);
          }
          this.isType3Font && (et = D);
          let ct = null;
          if ((vt = this.seacMap) != null && vt[nt]) {
            ut = !0;
            const xt = this.seacMap[nt];
            D = xt.baseFontCharCode, ct = { fontChar: String.fromCodePoint(xt.accentFontCharCode), offset: xt.accentOffset };
          }
          let gt = "";
          return typeof D == "number" && (D <= 1114111 ? gt = String.fromCodePoint(D) : (0, o.warn)(`charToGlyph - invalid fontCharCode: ${D}`)), J = new C(nt, gt, ot, ct, G, lt, et, q, ut), this._glyphCache[nt] = J;
        }
        charsToGlyphs(nt) {
          let q = this._charsCache[nt];
          if (q) return q;
          if (q = [], this.cMap) {
            const D = /* @__PURE__ */ Object.create(null), G = nt.length;
            let et = 0;
            for (; et < G; ) {
              this.cMap.readCharCode(nt, et, D);
              const { charcode: J, length: it } = D;
              et += it;
              const lt = this._charToGlyph(J, it === 1 && nt.charCodeAt(et - 1) === 32);
              q.push(lt);
            }
          } else for (let D = 0, G = nt.length; D < G; ++D) {
            const et = nt.charCodeAt(D), J = this._charToGlyph(et, et === 32);
            q.push(J);
          }
          return this._charsCache[nt] = q;
        }
        getCharPositions(nt) {
          const q = [];
          if (this.cMap) {
            const D = /* @__PURE__ */ Object.create(null);
            let G = 0;
            for (; G < nt.length; ) {
              this.cMap.readCharCode(nt, G, D);
              const et = D.length;
              q.push([G, G + et]), G += et;
            }
          } else for (let D = 0, G = nt.length; D < G; ++D) q.push([D, D + 1]);
          return q;
        }
        get glyphCacheValues() {
          return Object.values(this._glyphCache);
        }
        encodeString(nt) {
          const q = [], D = [], G = () => q.length % 2 == 1, et = this.toUnicode instanceof b.IdentityToUnicodeMap ? (J) => this.toUnicode.charCodeOf(J) : (J) => this.toUnicode.charCodeOf(String.fromCodePoint(J));
          for (let J = 0, it = nt.length; J < it; J++) {
            const lt = nt.codePointAt(J);
            if (lt > 55295 && (lt < 57344 || lt > 65533) && J++, this.toUnicode) {
              const ot = et(lt);
              if (ot !== -1) {
                G() && (q.push(D.join("")), D.length = 0);
                for (let ut = (this.cMap ? this.cMap.getCharCodeLength(ot) : 1) - 1; ut >= 0; ut--) D.push(String.fromCharCode(ot >> 8 * ut & 255));
                continue;
              }
            }
            G() || (q.push(D.join("")), D.length = 0), D.push(String.fromCodePoint(lt));
          }
          return q.push(D.join("")), q;
        }
      }, l.ErrorFont = class {
        constructor(nt) {
          this.error = nt, this.loadedName = "g_font_error", this.missingFile = !0;
        }
        charsToGlyphs() {
          return [];
        }
        encodeString(nt) {
          return [nt];
        }
        exportData(nt = !1) {
          return { error: this.error };
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CFFTopDict = l.CFFStrings = l.CFFStandardStrings = l.CFFPrivateDict = l.CFFParser = l.CFFIndex = l.CFFHeader = l.CFFFDSelect = l.CFFCompiler = l.CFFCharset = l.CFF = void 0;
      var o = f(2), g = f(36), p = f(37);
      const n = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
      l.CFFStandardStrings = n;
      const a = 391, d = [null, { id: "hstem", min: 2, stackClearing: !0, stem: !0 }, null, { id: "vstem", min: 2, stackClearing: !0, stem: !0 }, { id: "vmoveto", min: 1, stackClearing: !0 }, { id: "rlineto", min: 2, resetStack: !0 }, { id: "hlineto", min: 1, resetStack: !0 }, { id: "vlineto", min: 1, resetStack: !0 }, { id: "rrcurveto", min: 6, resetStack: !0 }, null, { id: "callsubr", min: 1, undefStack: !0 }, { id: "return", min: 0, undefStack: !0 }, null, null, { id: "endchar", min: 0, stackClearing: !0 }, null, null, null, { id: "hstemhm", min: 2, stackClearing: !0, stem: !0 }, { id: "hintmask", min: 0, stackClearing: !0 }, { id: "cntrmask", min: 0, stackClearing: !0 }, { id: "rmoveto", min: 2, stackClearing: !0 }, { id: "hmoveto", min: 1, stackClearing: !0 }, { id: "vstemhm", min: 2, stackClearing: !0, stem: !0 }, { id: "rcurveline", min: 8, resetStack: !0 }, { id: "rlinecurve", min: 8, resetStack: !0 }, { id: "vvcurveto", min: 4, resetStack: !0 }, { id: "hhcurveto", min: 4, resetStack: !0 }, null, { id: "callgsubr", min: 1, undefStack: !0 }, { id: "vhcurveto", min: 4, resetStack: !0 }, { id: "hvcurveto", min: 4, resetStack: !0 }], m = [null, null, null, { id: "and", min: 2, stackDelta: -1 }, { id: "or", min: 2, stackDelta: -1 }, { id: "not", min: 1, stackDelta: 0 }, null, null, null, { id: "abs", min: 1, stackDelta: 0 }, { id: "add", min: 2, stackDelta: -1, stackFn(B, C) {
        B[C - 2] = B[C - 2] + B[C - 1];
      } }, { id: "sub", min: 2, stackDelta: -1, stackFn(B, C) {
        B[C - 2] = B[C - 2] - B[C - 1];
      } }, { id: "div", min: 2, stackDelta: -1, stackFn(B, C) {
        B[C - 2] = B[C - 2] / B[C - 1];
      } }, null, { id: "neg", min: 1, stackDelta: 0, stackFn(B, C) {
        B[C - 1] = -B[C - 1];
      } }, { id: "eq", min: 2, stackDelta: -1 }, null, null, { id: "drop", min: 1, stackDelta: -1 }, null, { id: "put", min: 2, stackDelta: -2 }, { id: "get", min: 1, stackDelta: 0 }, { id: "ifelse", min: 4, stackDelta: -3 }, { id: "random", min: 0, stackDelta: 1 }, { id: "mul", min: 2, stackDelta: -1, stackFn(B, C) {
        B[C - 2] = B[C - 2] * B[C - 1];
      } }, null, { id: "sqrt", min: 1, stackDelta: 0 }, { id: "dup", min: 1, stackDelta: 1 }, { id: "exch", min: 2, stackDelta: 0 }, { id: "index", min: 2, stackDelta: 0 }, { id: "roll", min: 3, stackDelta: -2 }, null, null, null, { id: "hflex", min: 7, resetStack: !0 }, { id: "flex", min: 13, resetStack: !0 }, { id: "hflex1", min: 9, resetStack: !0 }, { id: "flex1", min: 11, resetStack: !0 }];
      l.CFFParser = class {
        constructor(C, T, F) {
          this.bytes = C.getBytes(), this.properties = T, this.seacAnalysisEnabled = !!F;
        }
        parse() {
          const C = this.properties, T = new b();
          this.cff = T;
          const F = this.parseHeader(), S = this.parseIndex(F.endPos), A = this.parseIndex(S.endPos), U = this.parseIndex(A.endPos), K = this.parseIndex(U.endPos), X = this.parseDict(A.obj.get(0)), L = this.createDict(M, X, T.strings);
          T.header = F.obj, T.names = this.parseNameIndex(S.obj), T.strings = this.parseStringIndex(U.obj), T.topDict = L, T.globalSubrIndex = K.obj, this.parsePrivateDict(T.topDict), T.isCIDFont = L.hasName("ROS");
          const H = L.getByName("CharStrings"), Q = this.parseIndex(H).obj, N = L.getByName("FontMatrix");
          N && (C.fontMatrix = N);
          const V = L.getByName("FontBBox");
          V && (C.ascent = Math.max(V[3], V[1]), C.descent = Math.min(V[1], V[3]), C.ascentScaled = !0);
          let Y, Z;
          if (T.isCIDFont) {
            const st = this.parseIndex(L.getByName("FDArray")).obj;
            for (let mt = 0, yt = st.count; mt < yt; ++mt) {
              const at = st.get(mt), nt = this.createDict(M, this.parseDict(at), T.strings);
              this.parsePrivateDict(nt), T.fdArray.push(nt);
            }
            Z = null, Y = this.parseCharsets(L.getByName("charset"), Q.count, T.strings, !0), T.fdSelect = this.parseFDSelect(L.getByName("FDSelect"), Q.count);
          } else
            Y = this.parseCharsets(L.getByName("charset"), Q.count, T.strings, !1), Z = this.parseEncoding(L.getByName("Encoding"), C, T.strings, Y.charset);
          T.charset = Y, T.encoding = Z;
          const rt = this.parseCharStrings({ charStrings: Q, localSubrIndex: L.privateDict.subrsIndex, globalSubrIndex: K.obj, fdSelect: T.fdSelect, fdArray: T.fdArray, privateDict: L.privateDict });
          return T.charStrings = rt.charStrings, T.seacs = rt.seacs, T.widths = rt.widths, T;
        }
        parseHeader() {
          let C = this.bytes;
          const T = C.length;
          let F = 0;
          for (; F < T && C[F] !== 1; ) ++F;
          if (F >= T) throw new o.FormatError("Invalid CFF header");
          F !== 0 && ((0, o.info)("cff data is shifted"), C = C.subarray(F), this.bytes = C);
          const S = C[0], A = C[1], U = C[2], K = C[3];
          return { obj: new w(S, A, U, K), endPos: U };
        }
        parseDict(C) {
          let T = 0;
          function F() {
            let K = C[T++];
            return K === 30 ? function() {
              let L = "";
              const Q = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], N = C.length;
              for (; T < N; ) {
                const V = C[T++], Y = V >> 4, Z = 15 & V;
                if (Y === 15 || (L += Q[Y], Z === 15)) break;
                L += Q[Z];
              }
              return parseFloat(L);
            }() : K === 28 ? (K = C[T++], K = (K << 24 | C[T++] << 16) >> 16, K) : K === 29 ? (K = C[T++], K = K << 8 | C[T++], K = K << 8 | C[T++], K = K << 8 | C[T++], K) : K >= 32 && K <= 246 ? K - 139 : K >= 247 && K <= 250 ? 256 * (K - 247) + C[T++] + 108 : K >= 251 && K <= 254 ? -256 * (K - 251) - C[T++] - 108 : ((0, o.warn)('CFFParser_parseDict: "' + K + '" is a reserved command.'), NaN);
          }
          let S = [];
          const A = [];
          T = 0;
          const U = C.length;
          for (; T < U; ) {
            let K = C[T];
            K <= 21 ? (K === 12 && (K = K << 8 | C[++T]), A.push([K, S]), S = [], ++T) : S.push(F());
          }
          return A;
        }
        parseIndex(C) {
          const T = new h(), F = this.bytes, S = F[C++] << 8 | F[C++], A = [];
          let U, K, X = C;
          if (S !== 0) {
            const L = F[C++], H = C + (S + 1) * L - 1;
            for (U = 0, K = S + 1; U < K; ++U) {
              let Q = 0;
              for (let N = 0; N < L; ++N)
                Q <<= 8, Q += F[C++];
              A.push(H + Q);
            }
            X = A[S];
          }
          for (U = 0, K = A.length - 1; U < K; ++U) {
            const L = A[U], H = A[U + 1];
            T.add(F.subarray(L, H));
          }
          return { obj: T, endPos: X };
        }
        parseNameIndex(C) {
          const T = [];
          for (let F = 0, S = C.count; F < S; ++F) {
            const A = C.get(F);
            T.push((0, o.bytesToString)(A));
          }
          return T;
        }
        parseStringIndex(C) {
          const T = new v();
          for (let F = 0, S = C.count; F < S; ++F) {
            const A = C.get(F);
            T.add((0, o.bytesToString)(A));
          }
          return T;
        }
        createDict(C, T, F) {
          const S = new C(F);
          for (const [A, U] of T) S.setByKey(A, U);
          return S;
        }
        parseCharString(C, T, F, S) {
          if (!T || C.callDepth > 10) return !1;
          let A = C.stackSize;
          const U = C.stack;
          let K = T.length;
          for (let X = 0; X < K; ) {
            const L = T[X++];
            let H = null;
            if (L === 12) {
              const Q = T[X++];
              Q === 0 ? (T[X - 2] = 139, T[X - 1] = 22, A = 0) : H = m[Q];
            } else if (L === 28)
              U[A] = (T[X] << 24 | T[X + 1] << 16) >> 16, X += 2, A++;
            else if (L === 14) {
              if (A >= 4 && (A -= 4, this.seacAnalysisEnabled))
                return C.seac = U.slice(A, A + 4), !1;
              H = d[L];
            } else if (L >= 32 && L <= 246)
              U[A] = L - 139, A++;
            else if (L >= 247 && L <= 254)
              U[A] = L < 251 ? (L - 247 << 8) + T[X] + 108 : -(L - 251 << 8) - T[X] - 108, X++, A++;
            else if (L === 255)
              U[A] = (T[X] << 24 | T[X + 1] << 16 | T[X + 2] << 8 | T[X + 3]) / 65536, X += 4, A++;
            else if (L === 19 || L === 20) {
              if (C.hints += A >> 1, C.hints === 0) {
                T.copyWithin(X - 1, X, -1), X -= 1, K -= 1;
                continue;
              }
              X += C.hints + 7 >> 3, A %= 2, H = d[L];
            } else {
              if (L === 10 || L === 29) {
                const Q = L === 10 ? F : S;
                if (!Q)
                  return H = d[L], (0, o.warn)("Missing subrsIndex for " + H.id), !1;
                let N = 32768;
                Q.count < 1240 ? N = 107 : Q.count < 33900 && (N = 1131);
                const V = U[--A] + N;
                if (V < 0 || V >= Q.count || isNaN(V))
                  return H = d[L], (0, o.warn)("Out of bounds subrIndex for " + H.id), !1;
                if (C.stackSize = A, C.callDepth++, !this.parseCharString(C, Q.get(V), F, S)) return !1;
                C.callDepth--, A = C.stackSize;
                continue;
              }
              if (L === 11)
                return C.stackSize = A, !0;
              if (L === 0 && X === T.length)
                T[X - 1] = 14, H = d[14];
              else {
                if (L === 9) {
                  T.copyWithin(X - 1, X, -1), X -= 1, K -= 1;
                  continue;
                }
                H = d[L];
              }
            }
            if (H) {
              if (H.stem && (C.hints += A >> 1, L === 3 || L === 23 ? C.hasVStems = !0 : C.hasVStems && (L === 1 || L === 18) && ((0, o.warn)("CFF stem hints are in wrong order"), T[X - 1] = L === 1 ? 3 : 23)), "min" in H && !C.undefStack && A < H.min)
                return (0, o.warn)("Not enough parameters for " + H.id + "; actual: " + A + ", expected: " + H.min), A === 0 ? (T[X - 1] = 14, !0) : !1;
              C.firstStackClearing && H.stackClearing && (C.firstStackClearing = !1, A -= H.min, A >= 2 && H.stem ? A %= 2 : A > 1 && (0, o.warn)("Found too many parameters for stack-clearing command"), A > 0 && (C.width = U[A - 1])), "stackDelta" in H ? ("stackFn" in H && H.stackFn(U, A), A += H.stackDelta) : H.stackClearing ? A = 0 : H.resetStack ? (A = 0, C.undefStack = !1) : H.undefStack && (A = 0, C.undefStack = !0, C.firstStackClearing = !1);
            }
          }
          return K < T.length && T.fill(14, K), C.stackSize = A, !0;
        }
        parseCharStrings({ charStrings: C, localSubrIndex: T, globalSubrIndex: F, fdSelect: S, fdArray: A, privateDict: U }) {
          const K = [], X = [], L = C.count;
          for (let H = 0; H < L; H++) {
            const Q = C.get(H), N = { callDepth: 0, stackSize: 0, stack: [], undefStack: !0, hints: 0, firstStackClearing: !0, seac: null, width: null, hasVStems: !1 };
            let V = !0, Y = null, Z = U;
            if (S && A.length) {
              const rt = S.getFDIndex(H);
              rt === -1 && ((0, o.warn)("Glyph index is not in fd select."), V = !1), rt >= A.length && ((0, o.warn)("Invalid fd index for glyph index."), V = !1), V && (Z = A[rt].privateDict, Y = Z.subrsIndex);
            } else T && (Y = T);
            if (V && (V = this.parseCharString(N, Q, Y, F)), N.width !== null) {
              const rt = Z.getByName("nominalWidthX");
              X[H] = rt + N.width;
            } else {
              const rt = Z.getByName("defaultWidthX");
              X[H] = rt;
            }
            N.seac !== null && (K[H] = N.seac), V || C.set(H, new Uint8Array([14]));
          }
          return { charStrings: C, seacs: K, widths: X };
        }
        emptyPrivateDictionary(C) {
          const T = this.createDict(E, [], C.strings);
          C.setByKey(18, [0, 0]), C.privateDict = T;
        }
        parsePrivateDict(C) {
          if (!C.hasName("Private")) {
            this.emptyPrivateDictionary(C);
            return;
          }
          const T = C.getByName("Private");
          if (!Array.isArray(T) || T.length !== 2) {
            C.removeByName("Private");
            return;
          }
          const F = T[0], S = T[1];
          if (F === 0 || S >= this.bytes.length) {
            this.emptyPrivateDictionary(C);
            return;
          }
          const A = S + F, U = this.bytes.subarray(S, A), K = this.parseDict(U), X = this.createDict(E, K, C.strings);
          if (C.privateDict = X, X.getByName("ExpansionFactor") === 0 && X.setByName("ExpansionFactor", 0.06), !X.getByName("Subrs")) return;
          const L = X.getByName("Subrs"), H = S + L;
          if (L === 0 || H >= this.bytes.length) {
            this.emptyPrivateDictionary(C);
            return;
          }
          const Q = this.parseIndex(H);
          X.subrsIndex = Q.obj;
        }
        parseCharsets(C, T, F, S) {
          if (C === 0) return new R(!0, I.ISO_ADOBE, g.ISOAdobeCharset);
          if (C === 1) return new R(!0, I.EXPERT, g.ExpertCharset);
          if (C === 2) return new R(!0, I.EXPERT_SUBSET, g.ExpertSubsetCharset);
          const A = this.bytes, U = C, K = A[C++], X = [S ? 0 : ".notdef"];
          let L, H, Q;
          switch (T -= 1, K) {
            case 0:
              for (Q = 0; Q < T; Q++)
                L = A[C++] << 8 | A[C++], X.push(S ? L : F.get(L));
              break;
            case 1:
              for (; X.length <= T; )
                for (L = A[C++] << 8 | A[C++], H = A[C++], Q = 0; Q <= H; Q++) X.push(S ? L++ : F.get(L++));
              break;
            case 2:
              for (; X.length <= T; )
                for (L = A[C++] << 8 | A[C++], H = A[C++] << 8 | A[C++], Q = 0; Q <= H; Q++) X.push(S ? L++ : F.get(L++));
              break;
            default:
              throw new o.FormatError("Unknown charset format");
          }
          const N = C, V = A.subarray(U, N);
          return new R(!1, K, X, V);
        }
        parseEncoding(C, T, F, S) {
          const A = /* @__PURE__ */ Object.create(null), U = this.bytes;
          let K, X, L, H = !1, Q = null;
          if (C === 0 || C === 1) {
            H = !0, K = C;
            const N = C ? p.ExpertEncoding : p.StandardEncoding;
            for (X = 0, L = S.length; X < L; X++) {
              const V = N.indexOf(S[X]);
              V !== -1 && (A[V] = X);
            }
          } else {
            const N = C;
            switch (K = U[C++], 127 & K) {
              case 0:
                const Y = U[C++];
                for (X = 1; X <= Y; X++) A[U[C++]] = X;
                break;
              case 1:
                const Z = U[C++];
                let rt = 1;
                for (X = 0; X < Z; X++) {
                  const st = U[C++], mt = U[C++];
                  for (let yt = st; yt <= st + mt; yt++) A[yt] = rt++;
                }
                break;
              default:
                throw new o.FormatError(`Unknown encoding format: ${K} in CFF`);
            }
            const V = C;
            128 & K && (U[N] &= 127, function() {
              const Z = U[C++];
              for (X = 0; X < Z; X++) {
                const rt = U[C++], st = (U[C++] << 8) + (255 & U[C++]);
                A[rt] = S.indexOf(F.get(st));
              }
            }()), Q = U.subarray(N, V);
          }
          return K &= 127, new W(H, K, A, Q);
        }
        parseFDSelect(C, T) {
          const F = this.bytes, S = F[C++], A = [];
          let U;
          switch (S) {
            case 0:
              for (U = 0; U < T; ++U) {
                const X = F[C++];
                A.push(X);
              }
              break;
            case 3:
              const K = F[C++] << 8 | F[C++];
              for (U = 0; U < K; ++U) {
                let X = F[C++] << 8 | F[C++];
                U === 0 && X !== 0 && ((0, o.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."), X = 0);
                const L = F[C++], H = F[C] << 8 | F[C + 1];
                for (let Q = X; Q < H; ++Q) A.push(L);
              }
              C += 2;
              break;
            default:
              throw new o.FormatError(`parseFDSelect: Unknown format "${S}".`);
          }
          if (A.length !== T) throw new o.FormatError("parseFDSelect: Invalid font data.");
          return new z(S, A);
        }
      };
      class b {
        constructor() {
          this.header = null, this.names = [], this.topDict = null, this.strings = new v(), this.globalSubrIndex = null, this.encoding = null, this.charset = null, this.charStrings = null, this.fdArray = [], this.fdSelect = null, this.isCIDFont = !1;
        }
        duplicateFirstGlyph() {
          if (this.charStrings.count >= 65535) {
            (0, o.warn)("Not enough space in charstrings to duplicate first glyph.");
            return;
          }
          const C = this.charStrings.get(0);
          this.charStrings.add(C), this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
        }
        hasGlyphId(C) {
          return C < 0 || C >= this.charStrings.count ? !1 : this.charStrings.get(C).length > 0;
        }
      }
      l.CFF = b;
      class w {
        constructor(C, T, F, S) {
          this.major = C, this.minor = T, this.hdrSize = F, this.offSize = S;
        }
      }
      l.CFFHeader = w;
      class v {
        constructor() {
          this.strings = [];
        }
        get(C) {
          return C >= 0 && C <= 390 ? n[C] : C - a <= this.strings.length ? this.strings[C - a] : n[0];
        }
        getSID(C) {
          let T = n.indexOf(C);
          return T !== -1 ? T : (T = this.strings.indexOf(C), T !== -1 ? T + a : -1);
        }
        add(C) {
          this.strings.push(C);
        }
        get count() {
          return this.strings.length;
        }
      }
      l.CFFStrings = v;
      class h {
        constructor() {
          this.objects = [], this.length = 0;
        }
        add(C) {
          this.length += C.length, this.objects.push(C);
        }
        set(C, T) {
          this.length += T.length - this.objects[C].length, this.objects[C] = T;
        }
        get(C) {
          return this.objects[C];
        }
        get count() {
          return this.objects.length;
        }
      }
      l.CFFIndex = h;
      class x {
        constructor(C, T) {
          this.keyToNameMap = C.keyToNameMap, this.nameToKeyMap = C.nameToKeyMap, this.defaults = C.defaults, this.types = C.types, this.opcodes = C.opcodes, this.order = C.order, this.strings = T, this.values = /* @__PURE__ */ Object.create(null);
        }
        setByKey(C, T) {
          if (!(C in this.keyToNameMap)) return !1;
          if (T.length === 0) return !0;
          for (const S of T) if (isNaN(S))
            return (0, o.warn)(`Invalid CFFDict value: "${T}" for key "${C}".`), !0;
          const F = this.types[C];
          return F !== "num" && F !== "sid" && F !== "offset" || (T = T[0]), this.values[C] = T, !0;
        }
        setByName(C, T) {
          if (!(C in this.nameToKeyMap)) throw new o.FormatError(`Invalid dictionary name "${C}"`);
          this.values[this.nameToKeyMap[C]] = T;
        }
        hasName(C) {
          return this.nameToKeyMap[C] in this.values;
        }
        getByName(C) {
          if (!(C in this.nameToKeyMap)) throw new o.FormatError(`Invalid dictionary name ${C}"`);
          const T = this.nameToKeyMap[C];
          return T in this.values ? this.values[T] : this.defaults[T];
        }
        removeByName(C) {
          delete this.values[this.nameToKeyMap[C]];
        }
        static createTables(C) {
          const T = { keyToNameMap: {}, nameToKeyMap: {}, defaults: {}, types: {}, opcodes: {}, order: [] };
          for (const F of C) {
            const S = Array.isArray(F[0]) ? (F[0][0] << 8) + F[0][1] : F[0];
            T.keyToNameMap[S] = F[1], T.nameToKeyMap[F[1]] = S, T.types[S] = F[2], T.defaults[S] = F[3], T.opcodes[S] = Array.isArray(F[0]) ? F[0] : [F[0]], T.order.push(S);
          }
          return T;
        }
      }
      const _ = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [1e-3, 0, 0, 1e-3, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
      class M extends x {
        static get tables() {
          return (0, o.shadow)(this, "tables", this.createTables(_));
        }
        constructor(C) {
          super(M.tables, C), this.privateDict = null;
        }
      }
      l.CFFTopDict = M;
      const O = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
      class E extends x {
        static get tables() {
          return (0, o.shadow)(this, "tables", this.createTables(O));
        }
        constructor(C) {
          super(E.tables, C), this.subrsIndex = null;
        }
      }
      l.CFFPrivateDict = E;
      const I = { ISO_ADOBE: 0, EXPERT: 1, EXPERT_SUBSET: 2 };
      class R {
        constructor(C, T, F, S) {
          this.predefined = C, this.format = T, this.charset = F, this.raw = S;
        }
      }
      l.CFFCharset = R;
      class W {
        constructor(C, T, F, S) {
          this.predefined = C, this.format = T, this.encoding = F, this.raw = S;
        }
      }
      class z {
        constructor(C, T) {
          this.format = C, this.fdSelect = T;
        }
        getFDIndex(C) {
          return C < 0 || C >= this.fdSelect.length ? -1 : this.fdSelect[C];
        }
      }
      l.CFFFDSelect = z;
      class j {
        constructor() {
          this.offsets = /* @__PURE__ */ Object.create(null);
        }
        isTracking(C) {
          return C in this.offsets;
        }
        track(C, T) {
          if (C in this.offsets) throw new o.FormatError(`Already tracking location of ${C}`);
          this.offsets[C] = T;
        }
        offset(C) {
          for (const T in this.offsets) this.offsets[T] += C;
        }
        setEntryLocation(C, T, F) {
          if (!(C in this.offsets)) throw new o.FormatError(`Not tracking location of ${C}`);
          const S = F.data, A = this.offsets[C];
          for (let U = 0, K = T.length; U < K; ++U) {
            const X = 5 * U + A, L = X + 1, H = X + 2, Q = X + 3, N = X + 4;
            if (S[X] !== 29 || S[L] !== 0 || S[H] !== 0 || S[Q] !== 0 || S[N] !== 0) throw new o.FormatError("writing to an offset that is not empty");
            const V = T[U];
            S[X] = 29, S[L] = V >> 24 & 255, S[H] = V >> 16 & 255, S[Q] = V >> 8 & 255, S[N] = 255 & V;
          }
        }
      }
      class $ {
        constructor(C) {
          this.cff = C;
        }
        compile() {
          const C = this.cff, T = { data: [], length: 0, add(N) {
            try {
              this.data.push(...N);
            } catch {
              this.data = this.data.concat(N);
            }
            this.length = this.data.length;
          } }, F = this.compileHeader(C.header);
          T.add(F);
          const S = this.compileNameIndex(C.names);
          if (T.add(S), C.isCIDFont && C.topDict.hasName("FontMatrix")) {
            const N = C.topDict.getByName("FontMatrix");
            C.topDict.removeByName("FontMatrix");
            for (const V of C.fdArray) {
              let Y = N.slice(0);
              V.hasName("FontMatrix") && (Y = o.Util.transform(Y, V.getByName("FontMatrix"))), V.setByName("FontMatrix", Y);
            }
          }
          const A = C.topDict.getByName("XUID");
          (A == null ? void 0 : A.length) > 16 && C.topDict.removeByName("XUID"), C.topDict.setByName("charset", 0);
          let U = this.compileTopDicts([C.topDict], T.length, C.isCIDFont);
          T.add(U.output);
          const K = U.trackers[0], X = this.compileStringIndex(C.strings.strings);
          T.add(X);
          const L = this.compileIndex(C.globalSubrIndex);
          if (T.add(L), C.encoding && C.topDict.hasName("Encoding")) if (C.encoding.predefined) K.setEntryLocation("Encoding", [C.encoding.format], T);
          else {
            const N = this.compileEncoding(C.encoding);
            K.setEntryLocation("Encoding", [T.length], T), T.add(N);
          }
          const H = this.compileCharset(C.charset, C.charStrings.count, C.strings, C.isCIDFont);
          K.setEntryLocation("charset", [T.length], T), T.add(H);
          const Q = this.compileCharStrings(C.charStrings);
          if (K.setEntryLocation("CharStrings", [T.length], T), T.add(Q), C.isCIDFont) {
            K.setEntryLocation("FDSelect", [T.length], T);
            const N = this.compileFDSelect(C.fdSelect);
            T.add(N), U = this.compileTopDicts(C.fdArray, T.length, !0), K.setEntryLocation("FDArray", [T.length], T), T.add(U.output);
            const V = U.trackers;
            this.compilePrivateDicts(C.fdArray, V, T);
          }
          return this.compilePrivateDicts([C.topDict], [K], T), T.add([0]), T.data;
        }
        encodeNumber(C) {
          return Number.isInteger(C) ? this.encodeInteger(C) : this.encodeFloat(C);
        }
        static get EncodeFloatRegExp() {
          return (0, o.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
        }
        encodeFloat(C) {
          let T = C.toString();
          const F = $.EncodeFloatRegExp.exec(T);
          if (F) {
            const X = parseFloat("1e" + ((F[2] ? +F[2] : 0) + F[1].length));
            T = (Math.round(C * X) / X).toString();
          }
          let S, A, U = "";
          for (S = 0, A = T.length; S < A; ++S) {
            const X = T[S];
            U += X === "e" ? T[++S] === "-" ? "c" : "b" : X === "." ? "a" : X === "-" ? "e" : X;
          }
          U += 1 & U.length ? "f" : "ff";
          const K = [30];
          for (S = 0, A = U.length; S < A; S += 2) K.push(parseInt(U.substring(S, S + 2), 16));
          return K;
        }
        encodeInteger(C) {
          let T;
          return T = C >= -107 && C <= 107 ? [C + 139] : C >= 108 && C <= 1131 ? [247 + ((C -= 108) >> 8), 255 & C] : C >= -1131 && C <= -108 ? [251 + ((C = -C - 108) >> 8), 255 & C] : C >= -32768 && C <= 32767 ? [28, C >> 8 & 255, 255 & C] : [29, C >> 24 & 255, C >> 16 & 255, C >> 8 & 255, 255 & C], T;
        }
        compileHeader(C) {
          return [C.major, C.minor, 4, C.offSize];
        }
        compileNameIndex(C) {
          const T = new h();
          for (const F of C) {
            const S = Math.min(F.length, 127);
            let A = new Array(S);
            for (let U = 0; U < S; U++) {
              let K = F[U];
              (K < "!" || K > "~" || K === "[" || K === "]" || K === "(" || K === ")" || K === "{" || K === "}" || K === "<" || K === ">" || K === "/" || K === "%") && (K = "_"), A[U] = K;
            }
            A = A.join(""), A === "" && (A = "Bad_Font_Name"), T.add((0, o.stringToBytes)(A));
          }
          return this.compileIndex(T);
        }
        compileTopDicts(C, T, F) {
          const S = [];
          let A = new h();
          for (const U of C) {
            F && (U.removeByName("CIDFontVersion"), U.removeByName("CIDFontRevision"), U.removeByName("CIDFontType"), U.removeByName("CIDCount"), U.removeByName("UIDBase"));
            const K = new j(), X = this.compileDict(U, K);
            S.push(K), A.add(X), K.offset(T);
          }
          return A = this.compileIndex(A, S), { trackers: S, output: A };
        }
        compilePrivateDicts(C, T, F) {
          for (let S = 0, A = C.length; S < A; ++S) {
            const U = C[S], K = U.privateDict;
            if (!K || !U.hasName("Private")) throw new o.FormatError("There must be a private dictionary.");
            const X = new j(), L = this.compileDict(K, X);
            let H = F.length;
            if (X.offset(H), L.length || (H = 0), T[S].setEntryLocation("Private", [L.length, H], F), F.add(L), K.subrsIndex && K.hasName("Subrs")) {
              const Q = this.compileIndex(K.subrsIndex);
              X.setEntryLocation("Subrs", [L.length], F), F.add(Q);
            }
          }
        }
        compileDict(C, T) {
          const F = [];
          for (const S of C.order) {
            if (!(S in C.values)) continue;
            let A = C.values[S], U = C.types[S];
            if (Array.isArray(U) || (U = [U]), Array.isArray(A) || (A = [A]), A.length !== 0) {
              for (let K = 0, X = U.length; K < X; ++K) {
                const L = U[K], H = A[K];
                switch (L) {
                  case "num":
                  case "sid":
                    F.push(...this.encodeNumber(H));
                    break;
                  case "offset":
                    const Q = C.keyToNameMap[S];
                    T.isTracking(Q) || T.track(Q, F.length), F.push(29, 0, 0, 0, 0);
                    break;
                  case "array":
                  case "delta":
                    F.push(...this.encodeNumber(H));
                    for (let N = 1, V = A.length; N < V; ++N) F.push(...this.encodeNumber(A[N]));
                    break;
                  default:
                    throw new o.FormatError(`Unknown data type of ${L}`);
                }
              }
              F.push(...C.opcodes[S]);
            }
          }
          return F;
        }
        compileStringIndex(C) {
          const T = new h();
          for (const F of C) T.add((0, o.stringToBytes)(F));
          return this.compileIndex(T);
        }
        compileCharStrings(C) {
          const T = new h();
          for (let F = 0; F < C.count; F++) {
            const S = C.get(F);
            S.length !== 0 ? T.add(S) : T.add(new Uint8Array([139, 14]));
          }
          return this.compileIndex(T);
        }
        compileCharset(C, T, F, S) {
          let A;
          const U = T - 1;
          if (S) A = new Uint8Array([2, 0, 0, U >> 8 & 255, 255 & U]);
          else {
            A = new Uint8Array(1 + 2 * U), A[0] = 0;
            let K = 0;
            const X = C.charset.length;
            let L = !1;
            for (let H = 1; H < A.length; H += 2) {
              let Q = 0;
              if (K < X) {
                const N = C.charset[K++];
                Q = F.getSID(N), Q === -1 && (Q = 0, L || (L = !0, (0, o.warn)(`Couldn't find ${N} in CFF strings`)));
              }
              A[H] = Q >> 8 & 255, A[H + 1] = 255 & Q;
            }
          }
          return this.compileTypedArray(A);
        }
        compileEncoding(C) {
          return this.compileTypedArray(C.raw);
        }
        compileFDSelect(C) {
          const T = C.format;
          let F, S;
          switch (T) {
            case 0:
              for (F = new Uint8Array(1 + C.fdSelect.length), F[0] = T, S = 0; S < C.fdSelect.length; S++) F[S + 1] = C.fdSelect[S];
              break;
            case 3:
              const A = 0;
              let U = C.fdSelect[0];
              const K = [T, 0, 0, A >> 8 & 255, 255 & A, U];
              for (S = 1; S < C.fdSelect.length; S++) {
                const L = C.fdSelect[S];
                L !== U && (K.push(S >> 8 & 255, 255 & S, L), U = L);
              }
              const X = (K.length - 3) / 3;
              K[1] = X >> 8 & 255, K[2] = 255 & X, K.push(S >> 8 & 255, 255 & S), F = new Uint8Array(K);
          }
          return this.compileTypedArray(F);
        }
        compileTypedArray(C) {
          return Array.from(C);
        }
        compileIndex(C, T = []) {
          const F = C.objects, S = F.length;
          if (S === 0) return [0, 0];
          const A = [S >> 8 & 255, 255 & S];
          let U, K, X = 1;
          for (U = 0; U < S; ++U) X += F[U].length;
          K = X < 256 ? 1 : X < 65536 ? 2 : X < 16777216 ? 3 : 4, A.push(K);
          let L = 1;
          for (U = 0; U < S + 1; U++)
            K === 1 ? A.push(255 & L) : K === 2 ? A.push(L >> 8 & 255, 255 & L) : K === 3 ? A.push(L >> 16 & 255, L >> 8 & 255, 255 & L) : A.push(L >>> 24 & 255, L >> 16 & 255, L >> 8 & 255, 255 & L), F[U] && (L += F[U].length);
          for (U = 0; U < S; U++)
            T[U] && T[U].offset(A.length), A.push(...F[U]);
          return A;
        }
      }
      l.CFFCompiler = $;
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ISOAdobeCharset = l.ExpertSubsetCharset = l.ExpertCharset = void 0, l.ISOAdobeCharset = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"], l.ExpertCharset = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"], l.ExpertSubsetCharset = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ZapfDingbatsEncoding = l.WinAnsiEncoding = l.SymbolSetEncoding = l.StandardEncoding = l.MacRomanEncoding = l.ExpertEncoding = void 0, l.getEncoding = function(b) {
        switch (b) {
          case "WinAnsiEncoding":
            return n;
          case "StandardEncoding":
            return p;
          case "MacRomanEncoding":
            return g;
          case "SymbolSetEncoding":
            return a;
          case "ZapfDingbatsEncoding":
            return d;
          case "ExpertEncoding":
            return f;
          case "MacExpertEncoding":
            return o;
          default:
            return null;
        }
      };
      const f = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
      l.ExpertEncoding = f;
      const o = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""], g = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
      l.MacRomanEncoding = g;
      const p = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""];
      l.StandardEncoding = p;
      const n = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
      l.WinAnsiEncoding = n;
      const a = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""];
      l.SymbolSetEncoding = a;
      const d = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
      l.ZapfDingbatsEncoding = d;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.SEAC_ANALYSIS_ENABLED = l.MacStandardGlyphOrdering = l.FontFlags = void 0, l.normalizeFontName = function(b) {
        return b.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
      }, l.recoverGlyphName = d, l.type1FontGlyphMapping = function(b, w, v) {
        const h = /* @__PURE__ */ Object.create(null);
        let x, _, M;
        const O = !!(b.flags & a.Symbolic);
        if (b.isInternalFont)
          for (M = w, _ = 0; _ < M.length; _++)
            x = v.indexOf(M[_]), h[_] = x >= 0 ? x : 0;
        else if (b.baseEncodingName)
          for (M = (0, o.getEncoding)(b.baseEncodingName), _ = 0; _ < M.length; _++)
            x = v.indexOf(M[_]), h[_] = x >= 0 ? x : 0;
        else if (O) for (_ in w) h[_] = w[_];
        else
          for (M = o.StandardEncoding, _ = 0; _ < M.length; _++)
            x = v.indexOf(M[_]), h[_] = x >= 0 ? x : 0;
        const E = b.differences;
        let I;
        if (E) for (_ in E) {
          const R = E[_];
          if (x = v.indexOf(R), x === -1) {
            I || (I = (0, g.getGlyphsUnicode)());
            const W = d(R, I);
            W !== R && (x = v.indexOf(W));
          }
          h[_] = x >= 0 ? x : 0;
        }
        return h;
      };
      var o = f(37), g = f(39), p = f(40), n = f(2);
      l.SEAC_ANALYSIS_ENABLED = !0;
      const a = { FixedPitch: 1, Serif: 2, Symbolic: 4, Script: 8, Nonsymbolic: 32, Italic: 64, AllCap: 65536, SmallCap: 131072, ForceBold: 262144 };
      l.FontFlags = a, l.MacStandardGlyphOrdering = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
      function d(m, b) {
        if (b[m] !== void 0) return m;
        const w = (0, p.getUnicodeForGlyph)(m, b);
        if (w !== -1) {
          for (const v in b) if (b[v] === w) return v;
        }
        return (0, n.info)("Unable to recover a standard glyph name for: " + m), m;
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.getGlyphsUnicode = l.getDingbatsGlyphsUnicode = void 0;
      var o = f(3);
      const g = (0, o.getLookupTableFactory)(function(n) {
        n.A = 65, n.AE = 198, n.AEacute = 508, n.AEmacron = 482, n.AEsmall = 63462, n.Aacute = 193, n.Aacutesmall = 63457, n.Abreve = 258, n.Abreveacute = 7854, n.Abrevecyrillic = 1232, n.Abrevedotbelow = 7862, n.Abrevegrave = 7856, n.Abrevehookabove = 7858, n.Abrevetilde = 7860, n.Acaron = 461, n.Acircle = 9398, n.Acircumflex = 194, n.Acircumflexacute = 7844, n.Acircumflexdotbelow = 7852, n.Acircumflexgrave = 7846, n.Acircumflexhookabove = 7848, n.Acircumflexsmall = 63458, n.Acircumflextilde = 7850, n.Acute = 63177, n.Acutesmall = 63412, n.Acyrillic = 1040, n.Adblgrave = 512, n.Adieresis = 196, n.Adieresiscyrillic = 1234, n.Adieresismacron = 478, n.Adieresissmall = 63460, n.Adotbelow = 7840, n.Adotmacron = 480, n.Agrave = 192, n.Agravesmall = 63456, n.Ahookabove = 7842, n.Aiecyrillic = 1236, n.Ainvertedbreve = 514, n.Alpha = 913, n.Alphatonos = 902, n.Amacron = 256, n.Amonospace = 65313, n.Aogonek = 260, n.Aring = 197, n.Aringacute = 506, n.Aringbelow = 7680, n.Aringsmall = 63461, n.Asmall = 63329, n.Atilde = 195, n.Atildesmall = 63459, n.Aybarmenian = 1329, n.B = 66, n.Bcircle = 9399, n.Bdotaccent = 7682, n.Bdotbelow = 7684, n.Becyrillic = 1041, n.Benarmenian = 1330, n.Beta = 914, n.Bhook = 385, n.Blinebelow = 7686, n.Bmonospace = 65314, n.Brevesmall = 63220, n.Bsmall = 63330, n.Btopbar = 386, n.C = 67, n.Caarmenian = 1342, n.Cacute = 262, n.Caron = 63178, n.Caronsmall = 63221, n.Ccaron = 268, n.Ccedilla = 199, n.Ccedillaacute = 7688, n.Ccedillasmall = 63463, n.Ccircle = 9400, n.Ccircumflex = 264, n.Cdot = 266, n.Cdotaccent = 266, n.Cedillasmall = 63416, n.Chaarmenian = 1353, n.Cheabkhasiancyrillic = 1212, n.Checyrillic = 1063, n.Chedescenderabkhasiancyrillic = 1214, n.Chedescendercyrillic = 1206, n.Chedieresiscyrillic = 1268, n.Cheharmenian = 1347, n.Chekhakassiancyrillic = 1227, n.Cheverticalstrokecyrillic = 1208, n.Chi = 935, n.Chook = 391, n.Circumflexsmall = 63222, n.Cmonospace = 65315, n.Coarmenian = 1361, n.Csmall = 63331, n.D = 68, n.DZ = 497, n.DZcaron = 452, n.Daarmenian = 1332, n.Dafrican = 393, n.Dcaron = 270, n.Dcedilla = 7696, n.Dcircle = 9401, n.Dcircumflexbelow = 7698, n.Dcroat = 272, n.Ddotaccent = 7690, n.Ddotbelow = 7692, n.Decyrillic = 1044, n.Deicoptic = 1006, n.Delta = 8710, n.Deltagreek = 916, n.Dhook = 394, n.Dieresis = 63179, n.DieresisAcute = 63180, n.DieresisGrave = 63181, n.Dieresissmall = 63400, n.Digammagreek = 988, n.Djecyrillic = 1026, n.Dlinebelow = 7694, n.Dmonospace = 65316, n.Dotaccentsmall = 63223, n.Dslash = 272, n.Dsmall = 63332, n.Dtopbar = 395, n.Dz = 498, n.Dzcaron = 453, n.Dzeabkhasiancyrillic = 1248, n.Dzecyrillic = 1029, n.Dzhecyrillic = 1039, n.E = 69, n.Eacute = 201, n.Eacutesmall = 63465, n.Ebreve = 276, n.Ecaron = 282, n.Ecedillabreve = 7708, n.Echarmenian = 1333, n.Ecircle = 9402, n.Ecircumflex = 202, n.Ecircumflexacute = 7870, n.Ecircumflexbelow = 7704, n.Ecircumflexdotbelow = 7878, n.Ecircumflexgrave = 7872, n.Ecircumflexhookabove = 7874, n.Ecircumflexsmall = 63466, n.Ecircumflextilde = 7876, n.Ecyrillic = 1028, n.Edblgrave = 516, n.Edieresis = 203, n.Edieresissmall = 63467, n.Edot = 278, n.Edotaccent = 278, n.Edotbelow = 7864, n.Efcyrillic = 1060, n.Egrave = 200, n.Egravesmall = 63464, n.Eharmenian = 1335, n.Ehookabove = 7866, n.Eightroman = 8551, n.Einvertedbreve = 518, n.Eiotifiedcyrillic = 1124, n.Elcyrillic = 1051, n.Elevenroman = 8554, n.Emacron = 274, n.Emacronacute = 7702, n.Emacrongrave = 7700, n.Emcyrillic = 1052, n.Emonospace = 65317, n.Encyrillic = 1053, n.Endescendercyrillic = 1186, n.Eng = 330, n.Enghecyrillic = 1188, n.Enhookcyrillic = 1223, n.Eogonek = 280, n.Eopen = 400, n.Epsilon = 917, n.Epsilontonos = 904, n.Ercyrillic = 1056, n.Ereversed = 398, n.Ereversedcyrillic = 1069, n.Escyrillic = 1057, n.Esdescendercyrillic = 1194, n.Esh = 425, n.Esmall = 63333, n.Eta = 919, n.Etarmenian = 1336, n.Etatonos = 905, n.Eth = 208, n.Ethsmall = 63472, n.Etilde = 7868, n.Etildebelow = 7706, n.Euro = 8364, n.Ezh = 439, n.Ezhcaron = 494, n.Ezhreversed = 440, n.F = 70, n.Fcircle = 9403, n.Fdotaccent = 7710, n.Feharmenian = 1366, n.Feicoptic = 996, n.Fhook = 401, n.Fitacyrillic = 1138, n.Fiveroman = 8548, n.Fmonospace = 65318, n.Fourroman = 8547, n.Fsmall = 63334, n.G = 71, n.GBsquare = 13191, n.Gacute = 500, n.Gamma = 915, n.Gammaafrican = 404, n.Gangiacoptic = 1002, n.Gbreve = 286, n.Gcaron = 486, n.Gcedilla = 290, n.Gcircle = 9404, n.Gcircumflex = 284, n.Gcommaaccent = 290, n.Gdot = 288, n.Gdotaccent = 288, n.Gecyrillic = 1043, n.Ghadarmenian = 1346, n.Ghemiddlehookcyrillic = 1172, n.Ghestrokecyrillic = 1170, n.Gheupturncyrillic = 1168, n.Ghook = 403, n.Gimarmenian = 1331, n.Gjecyrillic = 1027, n.Gmacron = 7712, n.Gmonospace = 65319, n.Grave = 63182, n.Gravesmall = 63328, n.Gsmall = 63335, n.Gsmallhook = 667, n.Gstroke = 484, n.H = 72, n.H18533 = 9679, n.H18543 = 9642, n.H18551 = 9643, n.H22073 = 9633, n.HPsquare = 13259, n.Haabkhasiancyrillic = 1192, n.Hadescendercyrillic = 1202, n.Hardsigncyrillic = 1066, n.Hbar = 294, n.Hbrevebelow = 7722, n.Hcedilla = 7720, n.Hcircle = 9405, n.Hcircumflex = 292, n.Hdieresis = 7718, n.Hdotaccent = 7714, n.Hdotbelow = 7716, n.Hmonospace = 65320, n.Hoarmenian = 1344, n.Horicoptic = 1e3, n.Hsmall = 63336, n.Hungarumlaut = 63183, n.Hungarumlautsmall = 63224, n.Hzsquare = 13200, n.I = 73, n.IAcyrillic = 1071, n.IJ = 306, n.IUcyrillic = 1070, n.Iacute = 205, n.Iacutesmall = 63469, n.Ibreve = 300, n.Icaron = 463, n.Icircle = 9406, n.Icircumflex = 206, n.Icircumflexsmall = 63470, n.Icyrillic = 1030, n.Idblgrave = 520, n.Idieresis = 207, n.Idieresisacute = 7726, n.Idieresiscyrillic = 1252, n.Idieresissmall = 63471, n.Idot = 304, n.Idotaccent = 304, n.Idotbelow = 7882, n.Iebrevecyrillic = 1238, n.Iecyrillic = 1045, n.Ifraktur = 8465, n.Igrave = 204, n.Igravesmall = 63468, n.Ihookabove = 7880, n.Iicyrillic = 1048, n.Iinvertedbreve = 522, n.Iishortcyrillic = 1049, n.Imacron = 298, n.Imacroncyrillic = 1250, n.Imonospace = 65321, n.Iniarmenian = 1339, n.Iocyrillic = 1025, n.Iogonek = 302, n.Iota = 921, n.Iotaafrican = 406, n.Iotadieresis = 938, n.Iotatonos = 906, n.Ismall = 63337, n.Istroke = 407, n.Itilde = 296, n.Itildebelow = 7724, n.Izhitsacyrillic = 1140, n.Izhitsadblgravecyrillic = 1142, n.J = 74, n.Jaarmenian = 1345, n.Jcircle = 9407, n.Jcircumflex = 308, n.Jecyrillic = 1032, n.Jheharmenian = 1355, n.Jmonospace = 65322, n.Jsmall = 63338, n.K = 75, n.KBsquare = 13189, n.KKsquare = 13261, n.Kabashkircyrillic = 1184, n.Kacute = 7728, n.Kacyrillic = 1050, n.Kadescendercyrillic = 1178, n.Kahookcyrillic = 1219, n.Kappa = 922, n.Kastrokecyrillic = 1182, n.Kaverticalstrokecyrillic = 1180, n.Kcaron = 488, n.Kcedilla = 310, n.Kcircle = 9408, n.Kcommaaccent = 310, n.Kdotbelow = 7730, n.Keharmenian = 1364, n.Kenarmenian = 1343, n.Khacyrillic = 1061, n.Kheicoptic = 998, n.Khook = 408, n.Kjecyrillic = 1036, n.Klinebelow = 7732, n.Kmonospace = 65323, n.Koppacyrillic = 1152, n.Koppagreek = 990, n.Ksicyrillic = 1134, n.Ksmall = 63339, n.L = 76, n.LJ = 455, n.LL = 63167, n.Lacute = 313, n.Lambda = 923, n.Lcaron = 317, n.Lcedilla = 315, n.Lcircle = 9409, n.Lcircumflexbelow = 7740, n.Lcommaaccent = 315, n.Ldot = 319, n.Ldotaccent = 319, n.Ldotbelow = 7734, n.Ldotbelowmacron = 7736, n.Liwnarmenian = 1340, n.Lj = 456, n.Ljecyrillic = 1033, n.Llinebelow = 7738, n.Lmonospace = 65324, n.Lslash = 321, n.Lslashsmall = 63225, n.Lsmall = 63340, n.M = 77, n.MBsquare = 13190, n.Macron = 63184, n.Macronsmall = 63407, n.Macute = 7742, n.Mcircle = 9410, n.Mdotaccent = 7744, n.Mdotbelow = 7746, n.Menarmenian = 1348, n.Mmonospace = 65325, n.Msmall = 63341, n.Mturned = 412, n.Mu = 924, n.N = 78, n.NJ = 458, n.Nacute = 323, n.Ncaron = 327, n.Ncedilla = 325, n.Ncircle = 9411, n.Ncircumflexbelow = 7754, n.Ncommaaccent = 325, n.Ndotaccent = 7748, n.Ndotbelow = 7750, n.Nhookleft = 413, n.Nineroman = 8552, n.Nj = 459, n.Njecyrillic = 1034, n.Nlinebelow = 7752, n.Nmonospace = 65326, n.Nowarmenian = 1350, n.Nsmall = 63342, n.Ntilde = 209, n.Ntildesmall = 63473, n.Nu = 925, n.O = 79, n.OE = 338, n.OEsmall = 63226, n.Oacute = 211, n.Oacutesmall = 63475, n.Obarredcyrillic = 1256, n.Obarreddieresiscyrillic = 1258, n.Obreve = 334, n.Ocaron = 465, n.Ocenteredtilde = 415, n.Ocircle = 9412, n.Ocircumflex = 212, n.Ocircumflexacute = 7888, n.Ocircumflexdotbelow = 7896, n.Ocircumflexgrave = 7890, n.Ocircumflexhookabove = 7892, n.Ocircumflexsmall = 63476, n.Ocircumflextilde = 7894, n.Ocyrillic = 1054, n.Odblacute = 336, n.Odblgrave = 524, n.Odieresis = 214, n.Odieresiscyrillic = 1254, n.Odieresissmall = 63478, n.Odotbelow = 7884, n.Ogoneksmall = 63227, n.Ograve = 210, n.Ogravesmall = 63474, n.Oharmenian = 1365, n.Ohm = 8486, n.Ohookabove = 7886, n.Ohorn = 416, n.Ohornacute = 7898, n.Ohorndotbelow = 7906, n.Ohorngrave = 7900, n.Ohornhookabove = 7902, n.Ohorntilde = 7904, n.Ohungarumlaut = 336, n.Oi = 418, n.Oinvertedbreve = 526, n.Omacron = 332, n.Omacronacute = 7762, n.Omacrongrave = 7760, n.Omega = 8486, n.Omegacyrillic = 1120, n.Omegagreek = 937, n.Omegaroundcyrillic = 1146, n.Omegatitlocyrillic = 1148, n.Omegatonos = 911, n.Omicron = 927, n.Omicrontonos = 908, n.Omonospace = 65327, n.Oneroman = 8544, n.Oogonek = 490, n.Oogonekmacron = 492, n.Oopen = 390, n.Oslash = 216, n.Oslashacute = 510, n.Oslashsmall = 63480, n.Osmall = 63343, n.Ostrokeacute = 510, n.Otcyrillic = 1150, n.Otilde = 213, n.Otildeacute = 7756, n.Otildedieresis = 7758, n.Otildesmall = 63477, n.P = 80, n.Pacute = 7764, n.Pcircle = 9413, n.Pdotaccent = 7766, n.Pecyrillic = 1055, n.Peharmenian = 1354, n.Pemiddlehookcyrillic = 1190, n.Phi = 934, n.Phook = 420, n.Pi = 928, n.Piwrarmenian = 1363, n.Pmonospace = 65328, n.Psi = 936, n.Psicyrillic = 1136, n.Psmall = 63344, n.Q = 81, n.Qcircle = 9414, n.Qmonospace = 65329, n.Qsmall = 63345, n.R = 82, n.Raarmenian = 1356, n.Racute = 340, n.Rcaron = 344, n.Rcedilla = 342, n.Rcircle = 9415, n.Rcommaaccent = 342, n.Rdblgrave = 528, n.Rdotaccent = 7768, n.Rdotbelow = 7770, n.Rdotbelowmacron = 7772, n.Reharmenian = 1360, n.Rfraktur = 8476, n.Rho = 929, n.Ringsmall = 63228, n.Rinvertedbreve = 530, n.Rlinebelow = 7774, n.Rmonospace = 65330, n.Rsmall = 63346, n.Rsmallinverted = 641, n.Rsmallinvertedsuperior = 694, n.S = 83, n.SF010000 = 9484, n.SF020000 = 9492, n.SF030000 = 9488, n.SF040000 = 9496, n.SF050000 = 9532, n.SF060000 = 9516, n.SF070000 = 9524, n.SF080000 = 9500, n.SF090000 = 9508, n.SF100000 = 9472, n.SF110000 = 9474, n.SF190000 = 9569, n.SF200000 = 9570, n.SF210000 = 9558, n.SF220000 = 9557, n.SF230000 = 9571, n.SF240000 = 9553, n.SF250000 = 9559, n.SF260000 = 9565, n.SF270000 = 9564, n.SF280000 = 9563, n.SF360000 = 9566, n.SF370000 = 9567, n.SF380000 = 9562, n.SF390000 = 9556, n.SF400000 = 9577, n.SF410000 = 9574, n.SF420000 = 9568, n.SF430000 = 9552, n.SF440000 = 9580, n.SF450000 = 9575, n.SF460000 = 9576, n.SF470000 = 9572, n.SF480000 = 9573, n.SF490000 = 9561, n.SF500000 = 9560, n.SF510000 = 9554, n.SF520000 = 9555, n.SF530000 = 9579, n.SF540000 = 9578, n.Sacute = 346, n.Sacutedotaccent = 7780, n.Sampigreek = 992, n.Scaron = 352, n.Scarondotaccent = 7782, n.Scaronsmall = 63229, n.Scedilla = 350, n.Schwa = 399, n.Schwacyrillic = 1240, n.Schwadieresiscyrillic = 1242, n.Scircle = 9416, n.Scircumflex = 348, n.Scommaaccent = 536, n.Sdotaccent = 7776, n.Sdotbelow = 7778, n.Sdotbelowdotaccent = 7784, n.Seharmenian = 1357, n.Sevenroman = 8550, n.Shaarmenian = 1351, n.Shacyrillic = 1064, n.Shchacyrillic = 1065, n.Sheicoptic = 994, n.Shhacyrillic = 1210, n.Shimacoptic = 1004, n.Sigma = 931, n.Sixroman = 8549, n.Smonospace = 65331, n.Softsigncyrillic = 1068, n.Ssmall = 63347, n.Stigmagreek = 986, n.T = 84, n.Tau = 932, n.Tbar = 358, n.Tcaron = 356, n.Tcedilla = 354, n.Tcircle = 9417, n.Tcircumflexbelow = 7792, n.Tcommaaccent = 354, n.Tdotaccent = 7786, n.Tdotbelow = 7788, n.Tecyrillic = 1058, n.Tedescendercyrillic = 1196, n.Tenroman = 8553, n.Tetsecyrillic = 1204, n.Theta = 920, n.Thook = 428, n.Thorn = 222, n.Thornsmall = 63486, n.Threeroman = 8546, n.Tildesmall = 63230, n.Tiwnarmenian = 1359, n.Tlinebelow = 7790, n.Tmonospace = 65332, n.Toarmenian = 1337, n.Tonefive = 444, n.Tonesix = 388, n.Tonetwo = 423, n.Tretroflexhook = 430, n.Tsecyrillic = 1062, n.Tshecyrillic = 1035, n.Tsmall = 63348, n.Twelveroman = 8555, n.Tworoman = 8545, n.U = 85, n.Uacute = 218, n.Uacutesmall = 63482, n.Ubreve = 364, n.Ucaron = 467, n.Ucircle = 9418, n.Ucircumflex = 219, n.Ucircumflexbelow = 7798, n.Ucircumflexsmall = 63483, n.Ucyrillic = 1059, n.Udblacute = 368, n.Udblgrave = 532, n.Udieresis = 220, n.Udieresisacute = 471, n.Udieresisbelow = 7794, n.Udieresiscaron = 473, n.Udieresiscyrillic = 1264, n.Udieresisgrave = 475, n.Udieresismacron = 469, n.Udieresissmall = 63484, n.Udotbelow = 7908, n.Ugrave = 217, n.Ugravesmall = 63481, n.Uhookabove = 7910, n.Uhorn = 431, n.Uhornacute = 7912, n.Uhorndotbelow = 7920, n.Uhorngrave = 7914, n.Uhornhookabove = 7916, n.Uhorntilde = 7918, n.Uhungarumlaut = 368, n.Uhungarumlautcyrillic = 1266, n.Uinvertedbreve = 534, n.Ukcyrillic = 1144, n.Umacron = 362, n.Umacroncyrillic = 1262, n.Umacrondieresis = 7802, n.Umonospace = 65333, n.Uogonek = 370, n.Upsilon = 933, n.Upsilon1 = 978, n.Upsilonacutehooksymbolgreek = 979, n.Upsilonafrican = 433, n.Upsilondieresis = 939, n.Upsilondieresishooksymbolgreek = 980, n.Upsilonhooksymbol = 978, n.Upsilontonos = 910, n.Uring = 366, n.Ushortcyrillic = 1038, n.Usmall = 63349, n.Ustraightcyrillic = 1198, n.Ustraightstrokecyrillic = 1200, n.Utilde = 360, n.Utildeacute = 7800, n.Utildebelow = 7796, n.V = 86, n.Vcircle = 9419, n.Vdotbelow = 7806, n.Vecyrillic = 1042, n.Vewarmenian = 1358, n.Vhook = 434, n.Vmonospace = 65334, n.Voarmenian = 1352, n.Vsmall = 63350, n.Vtilde = 7804, n.W = 87, n.Wacute = 7810, n.Wcircle = 9420, n.Wcircumflex = 372, n.Wdieresis = 7812, n.Wdotaccent = 7814, n.Wdotbelow = 7816, n.Wgrave = 7808, n.Wmonospace = 65335, n.Wsmall = 63351, n.X = 88, n.Xcircle = 9421, n.Xdieresis = 7820, n.Xdotaccent = 7818, n.Xeharmenian = 1341, n.Xi = 926, n.Xmonospace = 65336, n.Xsmall = 63352, n.Y = 89, n.Yacute = 221, n.Yacutesmall = 63485, n.Yatcyrillic = 1122, n.Ycircle = 9422, n.Ycircumflex = 374, n.Ydieresis = 376, n.Ydieresissmall = 63487, n.Ydotaccent = 7822, n.Ydotbelow = 7924, n.Yericyrillic = 1067, n.Yerudieresiscyrillic = 1272, n.Ygrave = 7922, n.Yhook = 435, n.Yhookabove = 7926, n.Yiarmenian = 1349, n.Yicyrillic = 1031, n.Yiwnarmenian = 1362, n.Ymonospace = 65337, n.Ysmall = 63353, n.Ytilde = 7928, n.Yusbigcyrillic = 1130, n.Yusbigiotifiedcyrillic = 1132, n.Yuslittlecyrillic = 1126, n.Yuslittleiotifiedcyrillic = 1128, n.Z = 90, n.Zaarmenian = 1334, n.Zacute = 377, n.Zcaron = 381, n.Zcaronsmall = 63231, n.Zcircle = 9423, n.Zcircumflex = 7824, n.Zdot = 379, n.Zdotaccent = 379, n.Zdotbelow = 7826, n.Zecyrillic = 1047, n.Zedescendercyrillic = 1176, n.Zedieresiscyrillic = 1246, n.Zeta = 918, n.Zhearmenian = 1338, n.Zhebrevecyrillic = 1217, n.Zhecyrillic = 1046, n.Zhedescendercyrillic = 1174, n.Zhedieresiscyrillic = 1244, n.Zlinebelow = 7828, n.Zmonospace = 65338, n.Zsmall = 63354, n.Zstroke = 437, n.a = 97, n.aabengali = 2438, n.aacute = 225, n.aadeva = 2310, n.aagujarati = 2694, n.aagurmukhi = 2566, n.aamatragurmukhi = 2622, n.aarusquare = 13059, n.aavowelsignbengali = 2494, n.aavowelsigndeva = 2366, n.aavowelsigngujarati = 2750, n.abbreviationmarkarmenian = 1375, n.abbreviationsigndeva = 2416, n.abengali = 2437, n.abopomofo = 12570, n.abreve = 259, n.abreveacute = 7855, n.abrevecyrillic = 1233, n.abrevedotbelow = 7863, n.abrevegrave = 7857, n.abrevehookabove = 7859, n.abrevetilde = 7861, n.acaron = 462, n.acircle = 9424, n.acircumflex = 226, n.acircumflexacute = 7845, n.acircumflexdotbelow = 7853, n.acircumflexgrave = 7847, n.acircumflexhookabove = 7849, n.acircumflextilde = 7851, n.acute = 180, n.acutebelowcmb = 791, n.acutecmb = 769, n.acutecomb = 769, n.acutedeva = 2388, n.acutelowmod = 719, n.acutetonecmb = 833, n.acyrillic = 1072, n.adblgrave = 513, n.addakgurmukhi = 2673, n.adeva = 2309, n.adieresis = 228, n.adieresiscyrillic = 1235, n.adieresismacron = 479, n.adotbelow = 7841, n.adotmacron = 481, n.ae = 230, n.aeacute = 509, n.aekorean = 12624, n.aemacron = 483, n.afii00208 = 8213, n.afii08941 = 8356, n.afii10017 = 1040, n.afii10018 = 1041, n.afii10019 = 1042, n.afii10020 = 1043, n.afii10021 = 1044, n.afii10022 = 1045, n.afii10023 = 1025, n.afii10024 = 1046, n.afii10025 = 1047, n.afii10026 = 1048, n.afii10027 = 1049, n.afii10028 = 1050, n.afii10029 = 1051, n.afii10030 = 1052, n.afii10031 = 1053, n.afii10032 = 1054, n.afii10033 = 1055, n.afii10034 = 1056, n.afii10035 = 1057, n.afii10036 = 1058, n.afii10037 = 1059, n.afii10038 = 1060, n.afii10039 = 1061, n.afii10040 = 1062, n.afii10041 = 1063, n.afii10042 = 1064, n.afii10043 = 1065, n.afii10044 = 1066, n.afii10045 = 1067, n.afii10046 = 1068, n.afii10047 = 1069, n.afii10048 = 1070, n.afii10049 = 1071, n.afii10050 = 1168, n.afii10051 = 1026, n.afii10052 = 1027, n.afii10053 = 1028, n.afii10054 = 1029, n.afii10055 = 1030, n.afii10056 = 1031, n.afii10057 = 1032, n.afii10058 = 1033, n.afii10059 = 1034, n.afii10060 = 1035, n.afii10061 = 1036, n.afii10062 = 1038, n.afii10063 = 63172, n.afii10064 = 63173, n.afii10065 = 1072, n.afii10066 = 1073, n.afii10067 = 1074, n.afii10068 = 1075, n.afii10069 = 1076, n.afii10070 = 1077, n.afii10071 = 1105, n.afii10072 = 1078, n.afii10073 = 1079, n.afii10074 = 1080, n.afii10075 = 1081, n.afii10076 = 1082, n.afii10077 = 1083, n.afii10078 = 1084, n.afii10079 = 1085, n.afii10080 = 1086, n.afii10081 = 1087, n.afii10082 = 1088, n.afii10083 = 1089, n.afii10084 = 1090, n.afii10085 = 1091, n.afii10086 = 1092, n.afii10087 = 1093, n.afii10088 = 1094, n.afii10089 = 1095, n.afii10090 = 1096, n.afii10091 = 1097, n.afii10092 = 1098, n.afii10093 = 1099, n.afii10094 = 1100, n.afii10095 = 1101, n.afii10096 = 1102, n.afii10097 = 1103, n.afii10098 = 1169, n.afii10099 = 1106, n.afii10100 = 1107, n.afii10101 = 1108, n.afii10102 = 1109, n.afii10103 = 1110, n.afii10104 = 1111, n.afii10105 = 1112, n.afii10106 = 1113, n.afii10107 = 1114, n.afii10108 = 1115, n.afii10109 = 1116, n.afii10110 = 1118, n.afii10145 = 1039, n.afii10146 = 1122, n.afii10147 = 1138, n.afii10148 = 1140, n.afii10192 = 63174, n.afii10193 = 1119, n.afii10194 = 1123, n.afii10195 = 1139, n.afii10196 = 1141, n.afii10831 = 63175, n.afii10832 = 63176, n.afii10846 = 1241, n.afii299 = 8206, n.afii300 = 8207, n.afii301 = 8205, n.afii57381 = 1642, n.afii57388 = 1548, n.afii57392 = 1632, n.afii57393 = 1633, n.afii57394 = 1634, n.afii57395 = 1635, n.afii57396 = 1636, n.afii57397 = 1637, n.afii57398 = 1638, n.afii57399 = 1639, n.afii57400 = 1640, n.afii57401 = 1641, n.afii57403 = 1563, n.afii57407 = 1567, n.afii57409 = 1569, n.afii57410 = 1570, n.afii57411 = 1571, n.afii57412 = 1572, n.afii57413 = 1573, n.afii57414 = 1574, n.afii57415 = 1575, n.afii57416 = 1576, n.afii57417 = 1577, n.afii57418 = 1578, n.afii57419 = 1579, n.afii57420 = 1580, n.afii57421 = 1581, n.afii57422 = 1582, n.afii57423 = 1583, n.afii57424 = 1584, n.afii57425 = 1585, n.afii57426 = 1586, n.afii57427 = 1587, n.afii57428 = 1588, n.afii57429 = 1589, n.afii57430 = 1590, n.afii57431 = 1591, n.afii57432 = 1592, n.afii57433 = 1593, n.afii57434 = 1594, n.afii57440 = 1600, n.afii57441 = 1601, n.afii57442 = 1602, n.afii57443 = 1603, n.afii57444 = 1604, n.afii57445 = 1605, n.afii57446 = 1606, n.afii57448 = 1608, n.afii57449 = 1609, n.afii57450 = 1610, n.afii57451 = 1611, n.afii57452 = 1612, n.afii57453 = 1613, n.afii57454 = 1614, n.afii57455 = 1615, n.afii57456 = 1616, n.afii57457 = 1617, n.afii57458 = 1618, n.afii57470 = 1607, n.afii57505 = 1700, n.afii57506 = 1662, n.afii57507 = 1670, n.afii57508 = 1688, n.afii57509 = 1711, n.afii57511 = 1657, n.afii57512 = 1672, n.afii57513 = 1681, n.afii57514 = 1722, n.afii57519 = 1746, n.afii57534 = 1749, n.afii57636 = 8362, n.afii57645 = 1470, n.afii57658 = 1475, n.afii57664 = 1488, n.afii57665 = 1489, n.afii57666 = 1490, n.afii57667 = 1491, n.afii57668 = 1492, n.afii57669 = 1493, n.afii57670 = 1494, n.afii57671 = 1495, n.afii57672 = 1496, n.afii57673 = 1497, n.afii57674 = 1498, n.afii57675 = 1499, n.afii57676 = 1500, n.afii57677 = 1501, n.afii57678 = 1502, n.afii57679 = 1503, n.afii57680 = 1504, n.afii57681 = 1505, n.afii57682 = 1506, n.afii57683 = 1507, n.afii57684 = 1508, n.afii57685 = 1509, n.afii57686 = 1510, n.afii57687 = 1511, n.afii57688 = 1512, n.afii57689 = 1513, n.afii57690 = 1514, n.afii57694 = 64298, n.afii57695 = 64299, n.afii57700 = 64331, n.afii57705 = 64287, n.afii57716 = 1520, n.afii57717 = 1521, n.afii57718 = 1522, n.afii57723 = 64309, n.afii57793 = 1460, n.afii57794 = 1461, n.afii57795 = 1462, n.afii57796 = 1467, n.afii57797 = 1464, n.afii57798 = 1463, n.afii57799 = 1456, n.afii57800 = 1458, n.afii57801 = 1457, n.afii57802 = 1459, n.afii57803 = 1474, n.afii57804 = 1473, n.afii57806 = 1465, n.afii57807 = 1468, n.afii57839 = 1469, n.afii57841 = 1471, n.afii57842 = 1472, n.afii57929 = 700, n.afii61248 = 8453, n.afii61289 = 8467, n.afii61352 = 8470, n.afii61573 = 8236, n.afii61574 = 8237, n.afii61575 = 8238, n.afii61664 = 8204, n.afii63167 = 1645, n.afii64937 = 701, n.agrave = 224, n.agujarati = 2693, n.agurmukhi = 2565, n.ahiragana = 12354, n.ahookabove = 7843, n.aibengali = 2448, n.aibopomofo = 12574, n.aideva = 2320, n.aiecyrillic = 1237, n.aigujarati = 2704, n.aigurmukhi = 2576, n.aimatragurmukhi = 2632, n.ainarabic = 1593, n.ainfinalarabic = 65226, n.aininitialarabic = 65227, n.ainmedialarabic = 65228, n.ainvertedbreve = 515, n.aivowelsignbengali = 2504, n.aivowelsigndeva = 2376, n.aivowelsigngujarati = 2760, n.akatakana = 12450, n.akatakanahalfwidth = 65393, n.akorean = 12623, n.alef = 1488, n.alefarabic = 1575, n.alefdageshhebrew = 64304, n.aleffinalarabic = 65166, n.alefhamzaabovearabic = 1571, n.alefhamzaabovefinalarabic = 65156, n.alefhamzabelowarabic = 1573, n.alefhamzabelowfinalarabic = 65160, n.alefhebrew = 1488, n.aleflamedhebrew = 64335, n.alefmaddaabovearabic = 1570, n.alefmaddaabovefinalarabic = 65154, n.alefmaksuraarabic = 1609, n.alefmaksurafinalarabic = 65264, n.alefmaksurainitialarabic = 65267, n.alefmaksuramedialarabic = 65268, n.alefpatahhebrew = 64302, n.alefqamatshebrew = 64303, n.aleph = 8501, n.allequal = 8780, n.alpha = 945, n.alphatonos = 940, n.amacron = 257, n.amonospace = 65345, n.ampersand = 38, n.ampersandmonospace = 65286, n.ampersandsmall = 63270, n.amsquare = 13250, n.anbopomofo = 12578, n.angbopomofo = 12580, n.angbracketleft = 12296, n.angbracketright = 12297, n.angkhankhuthai = 3674, n.angle = 8736, n.anglebracketleft = 12296, n.anglebracketleftvertical = 65087, n.anglebracketright = 12297, n.anglebracketrightvertical = 65088, n.angleleft = 9001, n.angleright = 9002, n.angstrom = 8491, n.anoteleia = 903, n.anudattadeva = 2386, n.anusvarabengali = 2434, n.anusvaradeva = 2306, n.anusvaragujarati = 2690, n.aogonek = 261, n.apaatosquare = 13056, n.aparen = 9372, n.apostrophearmenian = 1370, n.apostrophemod = 700, n.apple = 63743, n.approaches = 8784, n.approxequal = 8776, n.approxequalorimage = 8786, n.approximatelyequal = 8773, n.araeaekorean = 12686, n.araeakorean = 12685, n.arc = 8978, n.arighthalfring = 7834, n.aring = 229, n.aringacute = 507, n.aringbelow = 7681, n.arrowboth = 8596, n.arrowdashdown = 8675, n.arrowdashleft = 8672, n.arrowdashright = 8674, n.arrowdashup = 8673, n.arrowdblboth = 8660, n.arrowdbldown = 8659, n.arrowdblleft = 8656, n.arrowdblright = 8658, n.arrowdblup = 8657, n.arrowdown = 8595, n.arrowdownleft = 8601, n.arrowdownright = 8600, n.arrowdownwhite = 8681, n.arrowheaddownmod = 709, n.arrowheadleftmod = 706, n.arrowheadrightmod = 707, n.arrowheadupmod = 708, n.arrowhorizex = 63719, n.arrowleft = 8592, n.arrowleftdbl = 8656, n.arrowleftdblstroke = 8653, n.arrowleftoverright = 8646, n.arrowleftwhite = 8678, n.arrowright = 8594, n.arrowrightdblstroke = 8655, n.arrowrightheavy = 10142, n.arrowrightoverleft = 8644, n.arrowrightwhite = 8680, n.arrowtableft = 8676, n.arrowtabright = 8677, n.arrowup = 8593, n.arrowupdn = 8597, n.arrowupdnbse = 8616, n.arrowupdownbase = 8616, n.arrowupleft = 8598, n.arrowupleftofdown = 8645, n.arrowupright = 8599, n.arrowupwhite = 8679, n.arrowvertex = 63718, n.asciicircum = 94, n.asciicircummonospace = 65342, n.asciitilde = 126, n.asciitildemonospace = 65374, n.ascript = 593, n.ascriptturned = 594, n.asmallhiragana = 12353, n.asmallkatakana = 12449, n.asmallkatakanahalfwidth = 65383, n.asterisk = 42, n.asteriskaltonearabic = 1645, n.asteriskarabic = 1645, n.asteriskmath = 8727, n.asteriskmonospace = 65290, n.asterisksmall = 65121, n.asterism = 8258, n.asuperior = 63209, n.asymptoticallyequal = 8771, n.at = 64, n.atilde = 227, n.atmonospace = 65312, n.atsmall = 65131, n.aturned = 592, n.aubengali = 2452, n.aubopomofo = 12576, n.audeva = 2324, n.augujarati = 2708, n.augurmukhi = 2580, n.aulengthmarkbengali = 2519, n.aumatragurmukhi = 2636, n.auvowelsignbengali = 2508, n.auvowelsigndeva = 2380, n.auvowelsigngujarati = 2764, n.avagrahadeva = 2365, n.aybarmenian = 1377, n.ayin = 1506, n.ayinaltonehebrew = 64288, n.ayinhebrew = 1506, n.b = 98, n.babengali = 2476, n.backslash = 92, n.backslashmonospace = 65340, n.badeva = 2348, n.bagujarati = 2732, n.bagurmukhi = 2604, n.bahiragana = 12400, n.bahtthai = 3647, n.bakatakana = 12496, n.bar = 124, n.barmonospace = 65372, n.bbopomofo = 12549, n.bcircle = 9425, n.bdotaccent = 7683, n.bdotbelow = 7685, n.beamedsixteenthnotes = 9836, n.because = 8757, n.becyrillic = 1073, n.beharabic = 1576, n.behfinalarabic = 65168, n.behinitialarabic = 65169, n.behiragana = 12409, n.behmedialarabic = 65170, n.behmeeminitialarabic = 64671, n.behmeemisolatedarabic = 64520, n.behnoonfinalarabic = 64621, n.bekatakana = 12505, n.benarmenian = 1378, n.bet = 1489, n.beta = 946, n.betasymbolgreek = 976, n.betdagesh = 64305, n.betdageshhebrew = 64305, n.bethebrew = 1489, n.betrafehebrew = 64332, n.bhabengali = 2477, n.bhadeva = 2349, n.bhagujarati = 2733, n.bhagurmukhi = 2605, n.bhook = 595, n.bihiragana = 12403, n.bikatakana = 12499, n.bilabialclick = 664, n.bindigurmukhi = 2562, n.birusquare = 13105, n.blackcircle = 9679, n.blackdiamond = 9670, n.blackdownpointingtriangle = 9660, n.blackleftpointingpointer = 9668, n.blackleftpointingtriangle = 9664, n.blacklenticularbracketleft = 12304, n.blacklenticularbracketleftvertical = 65083, n.blacklenticularbracketright = 12305, n.blacklenticularbracketrightvertical = 65084, n.blacklowerlefttriangle = 9699, n.blacklowerrighttriangle = 9698, n.blackrectangle = 9644, n.blackrightpointingpointer = 9658, n.blackrightpointingtriangle = 9654, n.blacksmallsquare = 9642, n.blacksmilingface = 9787, n.blacksquare = 9632, n.blackstar = 9733, n.blackupperlefttriangle = 9700, n.blackupperrighttriangle = 9701, n.blackuppointingsmalltriangle = 9652, n.blackuppointingtriangle = 9650, n.blank = 9251, n.blinebelow = 7687, n.block = 9608, n.bmonospace = 65346, n.bobaimaithai = 3610, n.bohiragana = 12412, n.bokatakana = 12508, n.bparen = 9373, n.bqsquare = 13251, n.braceex = 63732, n.braceleft = 123, n.braceleftbt = 63731, n.braceleftmid = 63730, n.braceleftmonospace = 65371, n.braceleftsmall = 65115, n.bracelefttp = 63729, n.braceleftvertical = 65079, n.braceright = 125, n.bracerightbt = 63742, n.bracerightmid = 63741, n.bracerightmonospace = 65373, n.bracerightsmall = 65116, n.bracerighttp = 63740, n.bracerightvertical = 65080, n.bracketleft = 91, n.bracketleftbt = 63728, n.bracketleftex = 63727, n.bracketleftmonospace = 65339, n.bracketlefttp = 63726, n.bracketright = 93, n.bracketrightbt = 63739, n.bracketrightex = 63738, n.bracketrightmonospace = 65341, n.bracketrighttp = 63737, n.breve = 728, n.brevebelowcmb = 814, n.brevecmb = 774, n.breveinvertedbelowcmb = 815, n.breveinvertedcmb = 785, n.breveinverteddoublecmb = 865, n.bridgebelowcmb = 810, n.bridgeinvertedbelowcmb = 826, n.brokenbar = 166, n.bstroke = 384, n.bsuperior = 63210, n.btopbar = 387, n.buhiragana = 12406, n.bukatakana = 12502, n.bullet = 8226, n.bulletinverse = 9688, n.bulletoperator = 8729, n.bullseye = 9678, n.c = 99, n.caarmenian = 1390, n.cabengali = 2458, n.cacute = 263, n.cadeva = 2330, n.cagujarati = 2714, n.cagurmukhi = 2586, n.calsquare = 13192, n.candrabindubengali = 2433, n.candrabinducmb = 784, n.candrabindudeva = 2305, n.candrabindugujarati = 2689, n.capslock = 8682, n.careof = 8453, n.caron = 711, n.caronbelowcmb = 812, n.caroncmb = 780, n.carriagereturn = 8629, n.cbopomofo = 12568, n.ccaron = 269, n.ccedilla = 231, n.ccedillaacute = 7689, n.ccircle = 9426, n.ccircumflex = 265, n.ccurl = 597, n.cdot = 267, n.cdotaccent = 267, n.cdsquare = 13253, n.cedilla = 184, n.cedillacmb = 807, n.cent = 162, n.centigrade = 8451, n.centinferior = 63199, n.centmonospace = 65504, n.centoldstyle = 63394, n.centsuperior = 63200, n.chaarmenian = 1401, n.chabengali = 2459, n.chadeva = 2331, n.chagujarati = 2715, n.chagurmukhi = 2587, n.chbopomofo = 12564, n.cheabkhasiancyrillic = 1213, n.checkmark = 10003, n.checyrillic = 1095, n.chedescenderabkhasiancyrillic = 1215, n.chedescendercyrillic = 1207, n.chedieresiscyrillic = 1269, n.cheharmenian = 1395, n.chekhakassiancyrillic = 1228, n.cheverticalstrokecyrillic = 1209, n.chi = 967, n.chieuchacirclekorean = 12919, n.chieuchaparenkorean = 12823, n.chieuchcirclekorean = 12905, n.chieuchkorean = 12618, n.chieuchparenkorean = 12809, n.chochangthai = 3594, n.chochanthai = 3592, n.chochingthai = 3593, n.chochoethai = 3596, n.chook = 392, n.cieucacirclekorean = 12918, n.cieucaparenkorean = 12822, n.cieuccirclekorean = 12904, n.cieuckorean = 12616, n.cieucparenkorean = 12808, n.cieucuparenkorean = 12828, n.circle = 9675, n.circlecopyrt = 169, n.circlemultiply = 8855, n.circleot = 8857, n.circleplus = 8853, n.circlepostalmark = 12342, n.circlewithlefthalfblack = 9680, n.circlewithrighthalfblack = 9681, n.circumflex = 710, n.circumflexbelowcmb = 813, n.circumflexcmb = 770, n.clear = 8999, n.clickalveolar = 450, n.clickdental = 448, n.clicklateral = 449, n.clickretroflex = 451, n.club = 9827, n.clubsuitblack = 9827, n.clubsuitwhite = 9831, n.cmcubedsquare = 13220, n.cmonospace = 65347, n.cmsquaredsquare = 13216, n.coarmenian = 1409, n.colon = 58, n.colonmonetary = 8353, n.colonmonospace = 65306, n.colonsign = 8353, n.colonsmall = 65109, n.colontriangularhalfmod = 721, n.colontriangularmod = 720, n.comma = 44, n.commaabovecmb = 787, n.commaaboverightcmb = 789, n.commaaccent = 63171, n.commaarabic = 1548, n.commaarmenian = 1373, n.commainferior = 63201, n.commamonospace = 65292, n.commareversedabovecmb = 788, n.commareversedmod = 701, n.commasmall = 65104, n.commasuperior = 63202, n.commaturnedabovecmb = 786, n.commaturnedmod = 699, n.compass = 9788, n.congruent = 8773, n.contourintegral = 8750, n.control = 8963, n.controlACK = 6, n.controlBEL = 7, n.controlBS = 8, n.controlCAN = 24, n.controlCR = 13, n.controlDC1 = 17, n.controlDC2 = 18, n.controlDC3 = 19, n.controlDC4 = 20, n.controlDEL = 127, n.controlDLE = 16, n.controlEM = 25, n.controlENQ = 5, n.controlEOT = 4, n.controlESC = 27, n.controlETB = 23, n.controlETX = 3, n.controlFF = 12, n.controlFS = 28, n.controlGS = 29, n.controlHT = 9, n.controlLF = 10, n.controlNAK = 21, n.controlNULL = 0, n.controlRS = 30, n.controlSI = 15, n.controlSO = 14, n.controlSOT = 2, n.controlSTX = 1, n.controlSUB = 26, n.controlSYN = 22, n.controlUS = 31, n.controlVT = 11, n.copyright = 169, n.copyrightsans = 63721, n.copyrightserif = 63193, n.cornerbracketleft = 12300, n.cornerbracketlefthalfwidth = 65378, n.cornerbracketleftvertical = 65089, n.cornerbracketright = 12301, n.cornerbracketrighthalfwidth = 65379, n.cornerbracketrightvertical = 65090, n.corporationsquare = 13183, n.cosquare = 13255, n.coverkgsquare = 13254, n.cparen = 9374, n.cruzeiro = 8354, n.cstretched = 663, n.curlyand = 8911, n.curlyor = 8910, n.currency = 164, n.cyrBreve = 63185, n.cyrFlex = 63186, n.cyrbreve = 63188, n.cyrflex = 63189, n.d = 100, n.daarmenian = 1380, n.dabengali = 2470, n.dadarabic = 1590, n.dadeva = 2342, n.dadfinalarabic = 65214, n.dadinitialarabic = 65215, n.dadmedialarabic = 65216, n.dagesh = 1468, n.dageshhebrew = 1468, n.dagger = 8224, n.daggerdbl = 8225, n.dagujarati = 2726, n.dagurmukhi = 2598, n.dahiragana = 12384, n.dakatakana = 12480, n.dalarabic = 1583, n.dalet = 1491, n.daletdagesh = 64307, n.daletdageshhebrew = 64307, n.dalethebrew = 1491, n.dalfinalarabic = 65194, n.dammaarabic = 1615, n.dammalowarabic = 1615, n.dammatanaltonearabic = 1612, n.dammatanarabic = 1612, n.danda = 2404, n.dargahebrew = 1447, n.dargalefthebrew = 1447, n.dasiapneumatacyrilliccmb = 1157, n.dblGrave = 63187, n.dblanglebracketleft = 12298, n.dblanglebracketleftvertical = 65085, n.dblanglebracketright = 12299, n.dblanglebracketrightvertical = 65086, n.dblarchinvertedbelowcmb = 811, n.dblarrowleft = 8660, n.dblarrowright = 8658, n.dbldanda = 2405, n.dblgrave = 63190, n.dblgravecmb = 783, n.dblintegral = 8748, n.dbllowline = 8215, n.dbllowlinecmb = 819, n.dbloverlinecmb = 831, n.dblprimemod = 698, n.dblverticalbar = 8214, n.dblverticallineabovecmb = 782, n.dbopomofo = 12553, n.dbsquare = 13256, n.dcaron = 271, n.dcedilla = 7697, n.dcircle = 9427, n.dcircumflexbelow = 7699, n.dcroat = 273, n.ddabengali = 2465, n.ddadeva = 2337, n.ddagujarati = 2721, n.ddagurmukhi = 2593, n.ddalarabic = 1672, n.ddalfinalarabic = 64393, n.dddhadeva = 2396, n.ddhabengali = 2466, n.ddhadeva = 2338, n.ddhagujarati = 2722, n.ddhagurmukhi = 2594, n.ddotaccent = 7691, n.ddotbelow = 7693, n.decimalseparatorarabic = 1643, n.decimalseparatorpersian = 1643, n.decyrillic = 1076, n.degree = 176, n.dehihebrew = 1453, n.dehiragana = 12391, n.deicoptic = 1007, n.dekatakana = 12487, n.deleteleft = 9003, n.deleteright = 8998, n.delta = 948, n.deltaturned = 397, n.denominatorminusonenumeratorbengali = 2552, n.dezh = 676, n.dhabengali = 2471, n.dhadeva = 2343, n.dhagujarati = 2727, n.dhagurmukhi = 2599, n.dhook = 599, n.dialytikatonos = 901, n.dialytikatonoscmb = 836, n.diamond = 9830, n.diamondsuitwhite = 9826, n.dieresis = 168, n.dieresisacute = 63191, n.dieresisbelowcmb = 804, n.dieresiscmb = 776, n.dieresisgrave = 63192, n.dieresistonos = 901, n.dihiragana = 12386, n.dikatakana = 12482, n.dittomark = 12291, n.divide = 247, n.divides = 8739, n.divisionslash = 8725, n.djecyrillic = 1106, n.dkshade = 9619, n.dlinebelow = 7695, n.dlsquare = 13207, n.dmacron = 273, n.dmonospace = 65348, n.dnblock = 9604, n.dochadathai = 3598, n.dodekthai = 3604, n.dohiragana = 12393, n.dokatakana = 12489, n.dollar = 36, n.dollarinferior = 63203, n.dollarmonospace = 65284, n.dollaroldstyle = 63268, n.dollarsmall = 65129, n.dollarsuperior = 63204, n.dong = 8363, n.dorusquare = 13094, n.dotaccent = 729, n.dotaccentcmb = 775, n.dotbelowcmb = 803, n.dotbelowcomb = 803, n.dotkatakana = 12539, n.dotlessi = 305, n.dotlessj = 63166, n.dotlessjstrokehook = 644, n.dotmath = 8901, n.dottedcircle = 9676, n.doubleyodpatah = 64287, n.doubleyodpatahhebrew = 64287, n.downtackbelowcmb = 798, n.downtackmod = 725, n.dparen = 9375, n.dsuperior = 63211, n.dtail = 598, n.dtopbar = 396, n.duhiragana = 12389, n.dukatakana = 12485, n.dz = 499, n.dzaltone = 675, n.dzcaron = 454, n.dzcurl = 677, n.dzeabkhasiancyrillic = 1249, n.dzecyrillic = 1109, n.dzhecyrillic = 1119, n.e = 101, n.eacute = 233, n.earth = 9793, n.ebengali = 2447, n.ebopomofo = 12572, n.ebreve = 277, n.ecandradeva = 2317, n.ecandragujarati = 2701, n.ecandravowelsigndeva = 2373, n.ecandravowelsigngujarati = 2757, n.ecaron = 283, n.ecedillabreve = 7709, n.echarmenian = 1381, n.echyiwnarmenian = 1415, n.ecircle = 9428, n.ecircumflex = 234, n.ecircumflexacute = 7871, n.ecircumflexbelow = 7705, n.ecircumflexdotbelow = 7879, n.ecircumflexgrave = 7873, n.ecircumflexhookabove = 7875, n.ecircumflextilde = 7877, n.ecyrillic = 1108, n.edblgrave = 517, n.edeva = 2319, n.edieresis = 235, n.edot = 279, n.edotaccent = 279, n.edotbelow = 7865, n.eegurmukhi = 2575, n.eematragurmukhi = 2631, n.efcyrillic = 1092, n.egrave = 232, n.egujarati = 2703, n.eharmenian = 1383, n.ehbopomofo = 12573, n.ehiragana = 12360, n.ehookabove = 7867, n.eibopomofo = 12575, n.eight = 56, n.eightarabic = 1640, n.eightbengali = 2542, n.eightcircle = 9319, n.eightcircleinversesansserif = 10129, n.eightdeva = 2414, n.eighteencircle = 9329, n.eighteenparen = 9349, n.eighteenperiod = 9369, n.eightgujarati = 2798, n.eightgurmukhi = 2670, n.eighthackarabic = 1640, n.eighthangzhou = 12328, n.eighthnotebeamed = 9835, n.eightideographicparen = 12839, n.eightinferior = 8328, n.eightmonospace = 65304, n.eightoldstyle = 63288, n.eightparen = 9339, n.eightperiod = 9359, n.eightpersian = 1784, n.eightroman = 8567, n.eightsuperior = 8312, n.eightthai = 3672, n.einvertedbreve = 519, n.eiotifiedcyrillic = 1125, n.ekatakana = 12456, n.ekatakanahalfwidth = 65396, n.ekonkargurmukhi = 2676, n.ekorean = 12628, n.elcyrillic = 1083, n.element = 8712, n.elevencircle = 9322, n.elevenparen = 9342, n.elevenperiod = 9362, n.elevenroman = 8570, n.ellipsis = 8230, n.ellipsisvertical = 8942, n.emacron = 275, n.emacronacute = 7703, n.emacrongrave = 7701, n.emcyrillic = 1084, n.emdash = 8212, n.emdashvertical = 65073, n.emonospace = 65349, n.emphasismarkarmenian = 1371, n.emptyset = 8709, n.enbopomofo = 12579, n.encyrillic = 1085, n.endash = 8211, n.endashvertical = 65074, n.endescendercyrillic = 1187, n.eng = 331, n.engbopomofo = 12581, n.enghecyrillic = 1189, n.enhookcyrillic = 1224, n.enspace = 8194, n.eogonek = 281, n.eokorean = 12627, n.eopen = 603, n.eopenclosed = 666, n.eopenreversed = 604, n.eopenreversedclosed = 606, n.eopenreversedhook = 605, n.eparen = 9376, n.epsilon = 949, n.epsilontonos = 941, n.equal = 61, n.equalmonospace = 65309, n.equalsmall = 65126, n.equalsuperior = 8316, n.equivalence = 8801, n.erbopomofo = 12582, n.ercyrillic = 1088, n.ereversed = 600, n.ereversedcyrillic = 1101, n.escyrillic = 1089, n.esdescendercyrillic = 1195, n.esh = 643, n.eshcurl = 646, n.eshortdeva = 2318, n.eshortvowelsigndeva = 2374, n.eshreversedloop = 426, n.eshsquatreversed = 645, n.esmallhiragana = 12359, n.esmallkatakana = 12455, n.esmallkatakanahalfwidth = 65386, n.estimated = 8494, n.esuperior = 63212, n.eta = 951, n.etarmenian = 1384, n.etatonos = 942, n.eth = 240, n.etilde = 7869, n.etildebelow = 7707, n.etnahtafoukhhebrew = 1425, n.etnahtafoukhlefthebrew = 1425, n.etnahtahebrew = 1425, n.etnahtalefthebrew = 1425, n.eturned = 477, n.eukorean = 12641, n.euro = 8364, n.evowelsignbengali = 2503, n.evowelsigndeva = 2375, n.evowelsigngujarati = 2759, n.exclam = 33, n.exclamarmenian = 1372, n.exclamdbl = 8252, n.exclamdown = 161, n.exclamdownsmall = 63393, n.exclammonospace = 65281, n.exclamsmall = 63265, n.existential = 8707, n.ezh = 658, n.ezhcaron = 495, n.ezhcurl = 659, n.ezhreversed = 441, n.ezhtail = 442, n.f = 102, n.fadeva = 2398, n.fagurmukhi = 2654, n.fahrenheit = 8457, n.fathaarabic = 1614, n.fathalowarabic = 1614, n.fathatanarabic = 1611, n.fbopomofo = 12552, n.fcircle = 9429, n.fdotaccent = 7711, n.feharabic = 1601, n.feharmenian = 1414, n.fehfinalarabic = 65234, n.fehinitialarabic = 65235, n.fehmedialarabic = 65236, n.feicoptic = 997, n.female = 9792, n.ff = 64256, n.f_f = 64256, n.ffi = 64259, n.f_f_i = 64259, n.ffl = 64260, n.f_f_l = 64260, n.fi = 64257, n.f_i = 64257, n.fifteencircle = 9326, n.fifteenparen = 9346, n.fifteenperiod = 9366, n.figuredash = 8210, n.filledbox = 9632, n.filledrect = 9644, n.finalkaf = 1498, n.finalkafdagesh = 64314, n.finalkafdageshhebrew = 64314, n.finalkafhebrew = 1498, n.finalmem = 1501, n.finalmemhebrew = 1501, n.finalnun = 1503, n.finalnunhebrew = 1503, n.finalpe = 1507, n.finalpehebrew = 1507, n.finaltsadi = 1509, n.finaltsadihebrew = 1509, n.firsttonechinese = 713, n.fisheye = 9673, n.fitacyrillic = 1139, n.five = 53, n.fivearabic = 1637, n.fivebengali = 2539, n.fivecircle = 9316, n.fivecircleinversesansserif = 10126, n.fivedeva = 2411, n.fiveeighths = 8541, n.fivegujarati = 2795, n.fivegurmukhi = 2667, n.fivehackarabic = 1637, n.fivehangzhou = 12325, n.fiveideographicparen = 12836, n.fiveinferior = 8325, n.fivemonospace = 65301, n.fiveoldstyle = 63285, n.fiveparen = 9336, n.fiveperiod = 9356, n.fivepersian = 1781, n.fiveroman = 8564, n.fivesuperior = 8309, n.fivethai = 3669, n.fl = 64258, n.f_l = 64258, n.florin = 402, n.fmonospace = 65350, n.fmsquare = 13209, n.fofanthai = 3615, n.fofathai = 3613, n.fongmanthai = 3663, n.forall = 8704, n.four = 52, n.fourarabic = 1636, n.fourbengali = 2538, n.fourcircle = 9315, n.fourcircleinversesansserif = 10125, n.fourdeva = 2410, n.fourgujarati = 2794, n.fourgurmukhi = 2666, n.fourhackarabic = 1636, n.fourhangzhou = 12324, n.fourideographicparen = 12835, n.fourinferior = 8324, n.fourmonospace = 65300, n.fournumeratorbengali = 2551, n.fouroldstyle = 63284, n.fourparen = 9335, n.fourperiod = 9355, n.fourpersian = 1780, n.fourroman = 8563, n.foursuperior = 8308, n.fourteencircle = 9325, n.fourteenparen = 9345, n.fourteenperiod = 9365, n.fourthai = 3668, n.fourthtonechinese = 715, n.fparen = 9377, n.fraction = 8260, n.franc = 8355, n.g = 103, n.gabengali = 2455, n.gacute = 501, n.gadeva = 2327, n.gafarabic = 1711, n.gaffinalarabic = 64403, n.gafinitialarabic = 64404, n.gafmedialarabic = 64405, n.gagujarati = 2711, n.gagurmukhi = 2583, n.gahiragana = 12364, n.gakatakana = 12460, n.gamma = 947, n.gammalatinsmall = 611, n.gammasuperior = 736, n.gangiacoptic = 1003, n.gbopomofo = 12557, n.gbreve = 287, n.gcaron = 487, n.gcedilla = 291, n.gcircle = 9430, n.gcircumflex = 285, n.gcommaaccent = 291, n.gdot = 289, n.gdotaccent = 289, n.gecyrillic = 1075, n.gehiragana = 12370, n.gekatakana = 12466, n.geometricallyequal = 8785, n.gereshaccenthebrew = 1436, n.gereshhebrew = 1523, n.gereshmuqdamhebrew = 1437, n.germandbls = 223, n.gershayimaccenthebrew = 1438, n.gershayimhebrew = 1524, n.getamark = 12307, n.ghabengali = 2456, n.ghadarmenian = 1394, n.ghadeva = 2328, n.ghagujarati = 2712, n.ghagurmukhi = 2584, n.ghainarabic = 1594, n.ghainfinalarabic = 65230, n.ghaininitialarabic = 65231, n.ghainmedialarabic = 65232, n.ghemiddlehookcyrillic = 1173, n.ghestrokecyrillic = 1171, n.gheupturncyrillic = 1169, n.ghhadeva = 2394, n.ghhagurmukhi = 2650, n.ghook = 608, n.ghzsquare = 13203, n.gihiragana = 12366, n.gikatakana = 12462, n.gimarmenian = 1379, n.gimel = 1490, n.gimeldagesh = 64306, n.gimeldageshhebrew = 64306, n.gimelhebrew = 1490, n.gjecyrillic = 1107, n.glottalinvertedstroke = 446, n.glottalstop = 660, n.glottalstopinverted = 662, n.glottalstopmod = 704, n.glottalstopreversed = 661, n.glottalstopreversedmod = 705, n.glottalstopreversedsuperior = 740, n.glottalstopstroke = 673, n.glottalstopstrokereversed = 674, n.gmacron = 7713, n.gmonospace = 65351, n.gohiragana = 12372, n.gokatakana = 12468, n.gparen = 9378, n.gpasquare = 13228, n.gradient = 8711, n.grave = 96, n.gravebelowcmb = 790, n.gravecmb = 768, n.gravecomb = 768, n.gravedeva = 2387, n.gravelowmod = 718, n.gravemonospace = 65344, n.gravetonecmb = 832, n.greater = 62, n.greaterequal = 8805, n.greaterequalorless = 8923, n.greatermonospace = 65310, n.greaterorequivalent = 8819, n.greaterorless = 8823, n.greateroverequal = 8807, n.greatersmall = 65125, n.gscript = 609, n.gstroke = 485, n.guhiragana = 12368, n.guillemotleft = 171, n.guillemotright = 187, n.guilsinglleft = 8249, n.guilsinglright = 8250, n.gukatakana = 12464, n.guramusquare = 13080, n.gysquare = 13257, n.h = 104, n.haabkhasiancyrillic = 1193, n.haaltonearabic = 1729, n.habengali = 2489, n.hadescendercyrillic = 1203, n.hadeva = 2361, n.hagujarati = 2745, n.hagurmukhi = 2617, n.haharabic = 1581, n.hahfinalarabic = 65186, n.hahinitialarabic = 65187, n.hahiragana = 12399, n.hahmedialarabic = 65188, n.haitusquare = 13098, n.hakatakana = 12495, n.hakatakanahalfwidth = 65418, n.halantgurmukhi = 2637, n.hamzaarabic = 1569, n.hamzalowarabic = 1569, n.hangulfiller = 12644, n.hardsigncyrillic = 1098, n.harpoonleftbarbup = 8636, n.harpoonrightbarbup = 8640, n.hasquare = 13258, n.hatafpatah = 1458, n.hatafpatah16 = 1458, n.hatafpatah23 = 1458, n.hatafpatah2f = 1458, n.hatafpatahhebrew = 1458, n.hatafpatahnarrowhebrew = 1458, n.hatafpatahquarterhebrew = 1458, n.hatafpatahwidehebrew = 1458, n.hatafqamats = 1459, n.hatafqamats1b = 1459, n.hatafqamats28 = 1459, n.hatafqamats34 = 1459, n.hatafqamatshebrew = 1459, n.hatafqamatsnarrowhebrew = 1459, n.hatafqamatsquarterhebrew = 1459, n.hatafqamatswidehebrew = 1459, n.hatafsegol = 1457, n.hatafsegol17 = 1457, n.hatafsegol24 = 1457, n.hatafsegol30 = 1457, n.hatafsegolhebrew = 1457, n.hatafsegolnarrowhebrew = 1457, n.hatafsegolquarterhebrew = 1457, n.hatafsegolwidehebrew = 1457, n.hbar = 295, n.hbopomofo = 12559, n.hbrevebelow = 7723, n.hcedilla = 7721, n.hcircle = 9431, n.hcircumflex = 293, n.hdieresis = 7719, n.hdotaccent = 7715, n.hdotbelow = 7717, n.he = 1492, n.heart = 9829, n.heartsuitblack = 9829, n.heartsuitwhite = 9825, n.hedagesh = 64308, n.hedageshhebrew = 64308, n.hehaltonearabic = 1729, n.heharabic = 1607, n.hehebrew = 1492, n.hehfinalaltonearabic = 64423, n.hehfinalalttwoarabic = 65258, n.hehfinalarabic = 65258, n.hehhamzaabovefinalarabic = 64421, n.hehhamzaaboveisolatedarabic = 64420, n.hehinitialaltonearabic = 64424, n.hehinitialarabic = 65259, n.hehiragana = 12408, n.hehmedialaltonearabic = 64425, n.hehmedialarabic = 65260, n.heiseierasquare = 13179, n.hekatakana = 12504, n.hekatakanahalfwidth = 65421, n.hekutaarusquare = 13110, n.henghook = 615, n.herutusquare = 13113, n.het = 1495, n.hethebrew = 1495, n.hhook = 614, n.hhooksuperior = 689, n.hieuhacirclekorean = 12923, n.hieuhaparenkorean = 12827, n.hieuhcirclekorean = 12909, n.hieuhkorean = 12622, n.hieuhparenkorean = 12813, n.hihiragana = 12402, n.hikatakana = 12498, n.hikatakanahalfwidth = 65419, n.hiriq = 1460, n.hiriq14 = 1460, n.hiriq21 = 1460, n.hiriq2d = 1460, n.hiriqhebrew = 1460, n.hiriqnarrowhebrew = 1460, n.hiriqquarterhebrew = 1460, n.hiriqwidehebrew = 1460, n.hlinebelow = 7830, n.hmonospace = 65352, n.hoarmenian = 1392, n.hohipthai = 3627, n.hohiragana = 12411, n.hokatakana = 12507, n.hokatakanahalfwidth = 65422, n.holam = 1465, n.holam19 = 1465, n.holam26 = 1465, n.holam32 = 1465, n.holamhebrew = 1465, n.holamnarrowhebrew = 1465, n.holamquarterhebrew = 1465, n.holamwidehebrew = 1465, n.honokhukthai = 3630, n.hookabovecomb = 777, n.hookcmb = 777, n.hookpalatalizedbelowcmb = 801, n.hookretroflexbelowcmb = 802, n.hoonsquare = 13122, n.horicoptic = 1001, n.horizontalbar = 8213, n.horncmb = 795, n.hotsprings = 9832, n.house = 8962, n.hparen = 9379, n.hsuperior = 688, n.hturned = 613, n.huhiragana = 12405, n.huiitosquare = 13107, n.hukatakana = 12501, n.hukatakanahalfwidth = 65420, n.hungarumlaut = 733, n.hungarumlautcmb = 779, n.hv = 405, n.hyphen = 45, n.hypheninferior = 63205, n.hyphenmonospace = 65293, n.hyphensmall = 65123, n.hyphensuperior = 63206, n.hyphentwo = 8208, n.i = 105, n.iacute = 237, n.iacyrillic = 1103, n.ibengali = 2439, n.ibopomofo = 12583, n.ibreve = 301, n.icaron = 464, n.icircle = 9432, n.icircumflex = 238, n.icyrillic = 1110, n.idblgrave = 521, n.ideographearthcircle = 12943, n.ideographfirecircle = 12939, n.ideographicallianceparen = 12863, n.ideographiccallparen = 12858, n.ideographiccentrecircle = 12965, n.ideographicclose = 12294, n.ideographiccomma = 12289, n.ideographiccommaleft = 65380, n.ideographiccongratulationparen = 12855, n.ideographiccorrectcircle = 12963, n.ideographicearthparen = 12847, n.ideographicenterpriseparen = 12861, n.ideographicexcellentcircle = 12957, n.ideographicfestivalparen = 12864, n.ideographicfinancialcircle = 12950, n.ideographicfinancialparen = 12854, n.ideographicfireparen = 12843, n.ideographichaveparen = 12850, n.ideographichighcircle = 12964, n.ideographiciterationmark = 12293, n.ideographiclaborcircle = 12952, n.ideographiclaborparen = 12856, n.ideographicleftcircle = 12967, n.ideographiclowcircle = 12966, n.ideographicmedicinecircle = 12969, n.ideographicmetalparen = 12846, n.ideographicmoonparen = 12842, n.ideographicnameparen = 12852, n.ideographicperiod = 12290, n.ideographicprintcircle = 12958, n.ideographicreachparen = 12867, n.ideographicrepresentparen = 12857, n.ideographicresourceparen = 12862, n.ideographicrightcircle = 12968, n.ideographicsecretcircle = 12953, n.ideographicselfparen = 12866, n.ideographicsocietyparen = 12851, n.ideographicspace = 12288, n.ideographicspecialparen = 12853, n.ideographicstockparen = 12849, n.ideographicstudyparen = 12859, n.ideographicsunparen = 12848, n.ideographicsuperviseparen = 12860, n.ideographicwaterparen = 12844, n.ideographicwoodparen = 12845, n.ideographiczero = 12295, n.ideographmetalcircle = 12942, n.ideographmooncircle = 12938, n.ideographnamecircle = 12948, n.ideographsuncircle = 12944, n.ideographwatercircle = 12940, n.ideographwoodcircle = 12941, n.ideva = 2311, n.idieresis = 239, n.idieresisacute = 7727, n.idieresiscyrillic = 1253, n.idotbelow = 7883, n.iebrevecyrillic = 1239, n.iecyrillic = 1077, n.ieungacirclekorean = 12917, n.ieungaparenkorean = 12821, n.ieungcirclekorean = 12903, n.ieungkorean = 12615, n.ieungparenkorean = 12807, n.igrave = 236, n.igujarati = 2695, n.igurmukhi = 2567, n.ihiragana = 12356, n.ihookabove = 7881, n.iibengali = 2440, n.iicyrillic = 1080, n.iideva = 2312, n.iigujarati = 2696, n.iigurmukhi = 2568, n.iimatragurmukhi = 2624, n.iinvertedbreve = 523, n.iishortcyrillic = 1081, n.iivowelsignbengali = 2496, n.iivowelsigndeva = 2368, n.iivowelsigngujarati = 2752, n.ij = 307, n.ikatakana = 12452, n.ikatakanahalfwidth = 65394, n.ikorean = 12643, n.ilde = 732, n.iluyhebrew = 1452, n.imacron = 299, n.imacroncyrillic = 1251, n.imageorapproximatelyequal = 8787, n.imatragurmukhi = 2623, n.imonospace = 65353, n.increment = 8710, n.infinity = 8734, n.iniarmenian = 1387, n.integral = 8747, n.integralbottom = 8993, n.integralbt = 8993, n.integralex = 63733, n.integraltop = 8992, n.integraltp = 8992, n.intersection = 8745, n.intisquare = 13061, n.invbullet = 9688, n.invcircle = 9689, n.invsmileface = 9787, n.iocyrillic = 1105, n.iogonek = 303, n.iota = 953, n.iotadieresis = 970, n.iotadieresistonos = 912, n.iotalatin = 617, n.iotatonos = 943, n.iparen = 9380, n.irigurmukhi = 2674, n.ismallhiragana = 12355, n.ismallkatakana = 12451, n.ismallkatakanahalfwidth = 65384, n.issharbengali = 2554, n.istroke = 616, n.isuperior = 63213, n.iterationhiragana = 12445, n.iterationkatakana = 12541, n.itilde = 297, n.itildebelow = 7725, n.iubopomofo = 12585, n.iucyrillic = 1102, n.ivowelsignbengali = 2495, n.ivowelsigndeva = 2367, n.ivowelsigngujarati = 2751, n.izhitsacyrillic = 1141, n.izhitsadblgravecyrillic = 1143, n.j = 106, n.jaarmenian = 1393, n.jabengali = 2460, n.jadeva = 2332, n.jagujarati = 2716, n.jagurmukhi = 2588, n.jbopomofo = 12560, n.jcaron = 496, n.jcircle = 9433, n.jcircumflex = 309, n.jcrossedtail = 669, n.jdotlessstroke = 607, n.jecyrillic = 1112, n.jeemarabic = 1580, n.jeemfinalarabic = 65182, n.jeeminitialarabic = 65183, n.jeemmedialarabic = 65184, n.jeharabic = 1688, n.jehfinalarabic = 64395, n.jhabengali = 2461, n.jhadeva = 2333, n.jhagujarati = 2717, n.jhagurmukhi = 2589, n.jheharmenian = 1403, n.jis = 12292, n.jmonospace = 65354, n.jparen = 9381, n.jsuperior = 690, n.k = 107, n.kabashkircyrillic = 1185, n.kabengali = 2453, n.kacute = 7729, n.kacyrillic = 1082, n.kadescendercyrillic = 1179, n.kadeva = 2325, n.kaf = 1499, n.kafarabic = 1603, n.kafdagesh = 64315, n.kafdageshhebrew = 64315, n.kaffinalarabic = 65242, n.kafhebrew = 1499, n.kafinitialarabic = 65243, n.kafmedialarabic = 65244, n.kafrafehebrew = 64333, n.kagujarati = 2709, n.kagurmukhi = 2581, n.kahiragana = 12363, n.kahookcyrillic = 1220, n.kakatakana = 12459, n.kakatakanahalfwidth = 65398, n.kappa = 954, n.kappasymbolgreek = 1008, n.kapyeounmieumkorean = 12657, n.kapyeounphieuphkorean = 12676, n.kapyeounpieupkorean = 12664, n.kapyeounssangpieupkorean = 12665, n.karoriisquare = 13069, n.kashidaautoarabic = 1600, n.kashidaautonosidebearingarabic = 1600, n.kasmallkatakana = 12533, n.kasquare = 13188, n.kasraarabic = 1616, n.kasratanarabic = 1613, n.kastrokecyrillic = 1183, n.katahiraprolongmarkhalfwidth = 65392, n.kaverticalstrokecyrillic = 1181, n.kbopomofo = 12558, n.kcalsquare = 13193, n.kcaron = 489, n.kcedilla = 311, n.kcircle = 9434, n.kcommaaccent = 311, n.kdotbelow = 7731, n.keharmenian = 1412, n.kehiragana = 12369, n.kekatakana = 12465, n.kekatakanahalfwidth = 65401, n.kenarmenian = 1391, n.kesmallkatakana = 12534, n.kgreenlandic = 312, n.khabengali = 2454, n.khacyrillic = 1093, n.khadeva = 2326, n.khagujarati = 2710, n.khagurmukhi = 2582, n.khaharabic = 1582, n.khahfinalarabic = 65190, n.khahinitialarabic = 65191, n.khahmedialarabic = 65192, n.kheicoptic = 999, n.khhadeva = 2393, n.khhagurmukhi = 2649, n.khieukhacirclekorean = 12920, n.khieukhaparenkorean = 12824, n.khieukhcirclekorean = 12906, n.khieukhkorean = 12619, n.khieukhparenkorean = 12810, n.khokhaithai = 3586, n.khokhonthai = 3589, n.khokhuatthai = 3587, n.khokhwaithai = 3588, n.khomutthai = 3675, n.khook = 409, n.khorakhangthai = 3590, n.khzsquare = 13201, n.kihiragana = 12365, n.kikatakana = 12461, n.kikatakanahalfwidth = 65399, n.kiroguramusquare = 13077, n.kiromeetorusquare = 13078, n.kirosquare = 13076, n.kiyeokacirclekorean = 12910, n.kiyeokaparenkorean = 12814, n.kiyeokcirclekorean = 12896, n.kiyeokkorean = 12593, n.kiyeokparenkorean = 12800, n.kiyeoksioskorean = 12595, n.kjecyrillic = 1116, n.klinebelow = 7733, n.klsquare = 13208, n.kmcubedsquare = 13222, n.kmonospace = 65355, n.kmsquaredsquare = 13218, n.kohiragana = 12371, n.kohmsquare = 13248, n.kokaithai = 3585, n.kokatakana = 12467, n.kokatakanahalfwidth = 65402, n.kooposquare = 13086, n.koppacyrillic = 1153, n.koreanstandardsymbol = 12927, n.koroniscmb = 835, n.kparen = 9382, n.kpasquare = 13226, n.ksicyrillic = 1135, n.ktsquare = 13263, n.kturned = 670, n.kuhiragana = 12367, n.kukatakana = 12463, n.kukatakanahalfwidth = 65400, n.kvsquare = 13240, n.kwsquare = 13246, n.l = 108, n.labengali = 2482, n.lacute = 314, n.ladeva = 2354, n.lagujarati = 2738, n.lagurmukhi = 2610, n.lakkhangyaothai = 3653, n.lamaleffinalarabic = 65276, n.lamalefhamzaabovefinalarabic = 65272, n.lamalefhamzaaboveisolatedarabic = 65271, n.lamalefhamzabelowfinalarabic = 65274, n.lamalefhamzabelowisolatedarabic = 65273, n.lamalefisolatedarabic = 65275, n.lamalefmaddaabovefinalarabic = 65270, n.lamalefmaddaaboveisolatedarabic = 65269, n.lamarabic = 1604, n.lambda = 955, n.lambdastroke = 411, n.lamed = 1500, n.lameddagesh = 64316, n.lameddageshhebrew = 64316, n.lamedhebrew = 1500, n.lamfinalarabic = 65246, n.lamhahinitialarabic = 64714, n.laminitialarabic = 65247, n.lamjeeminitialarabic = 64713, n.lamkhahinitialarabic = 64715, n.lamlamhehisolatedarabic = 65010, n.lammedialarabic = 65248, n.lammeemhahinitialarabic = 64904, n.lammeeminitialarabic = 64716, n.largecircle = 9711, n.lbar = 410, n.lbelt = 620, n.lbopomofo = 12556, n.lcaron = 318, n.lcedilla = 316, n.lcircle = 9435, n.lcircumflexbelow = 7741, n.lcommaaccent = 316, n.ldot = 320, n.ldotaccent = 320, n.ldotbelow = 7735, n.ldotbelowmacron = 7737, n.leftangleabovecmb = 794, n.lefttackbelowcmb = 792, n.less = 60, n.lessequal = 8804, n.lessequalorgreater = 8922, n.lessmonospace = 65308, n.lessorequivalent = 8818, n.lessorgreater = 8822, n.lessoverequal = 8806, n.lesssmall = 65124, n.lezh = 622, n.lfblock = 9612, n.lhookretroflex = 621, n.lira = 8356, n.liwnarmenian = 1388, n.lj = 457, n.ljecyrillic = 1113, n.ll = 63168, n.lladeva = 2355, n.llagujarati = 2739, n.llinebelow = 7739, n.llladeva = 2356, n.llvocalicbengali = 2529, n.llvocalicdeva = 2401, n.llvocalicvowelsignbengali = 2531, n.llvocalicvowelsigndeva = 2403, n.lmiddletilde = 619, n.lmonospace = 65356, n.lmsquare = 13264, n.lochulathai = 3628, n.logicaland = 8743, n.logicalnot = 172, n.logicalnotreversed = 8976, n.logicalor = 8744, n.lolingthai = 3621, n.longs = 383, n.lowlinecenterline = 65102, n.lowlinecmb = 818, n.lowlinedashed = 65101, n.lozenge = 9674, n.lparen = 9383, n.lslash = 322, n.lsquare = 8467, n.lsuperior = 63214, n.ltshade = 9617, n.luthai = 3622, n.lvocalicbengali = 2444, n.lvocalicdeva = 2316, n.lvocalicvowelsignbengali = 2530, n.lvocalicvowelsigndeva = 2402, n.lxsquare = 13267, n.m = 109, n.mabengali = 2478, n.macron = 175, n.macronbelowcmb = 817, n.macroncmb = 772, n.macronlowmod = 717, n.macronmonospace = 65507, n.macute = 7743, n.madeva = 2350, n.magujarati = 2734, n.magurmukhi = 2606, n.mahapakhhebrew = 1444, n.mahapakhlefthebrew = 1444, n.mahiragana = 12414, n.maichattawalowleftthai = 63637, n.maichattawalowrightthai = 63636, n.maichattawathai = 3659, n.maichattawaupperleftthai = 63635, n.maieklowleftthai = 63628, n.maieklowrightthai = 63627, n.maiekthai = 3656, n.maiekupperleftthai = 63626, n.maihanakatleftthai = 63620, n.maihanakatthai = 3633, n.maitaikhuleftthai = 63625, n.maitaikhuthai = 3655, n.maitholowleftthai = 63631, n.maitholowrightthai = 63630, n.maithothai = 3657, n.maithoupperleftthai = 63629, n.maitrilowleftthai = 63634, n.maitrilowrightthai = 63633, n.maitrithai = 3658, n.maitriupperleftthai = 63632, n.maiyamokthai = 3654, n.makatakana = 12510, n.makatakanahalfwidth = 65423, n.male = 9794, n.mansyonsquare = 13127, n.maqafhebrew = 1470, n.mars = 9794, n.masoracirclehebrew = 1455, n.masquare = 13187, n.mbopomofo = 12551, n.mbsquare = 13268, n.mcircle = 9436, n.mcubedsquare = 13221, n.mdotaccent = 7745, n.mdotbelow = 7747, n.meemarabic = 1605, n.meemfinalarabic = 65250, n.meeminitialarabic = 65251, n.meemmedialarabic = 65252, n.meemmeeminitialarabic = 64721, n.meemmeemisolatedarabic = 64584, n.meetorusquare = 13133, n.mehiragana = 12417, n.meizierasquare = 13182, n.mekatakana = 12513, n.mekatakanahalfwidth = 65426, n.mem = 1502, n.memdagesh = 64318, n.memdageshhebrew = 64318, n.memhebrew = 1502, n.menarmenian = 1396, n.merkhahebrew = 1445, n.merkhakefulahebrew = 1446, n.merkhakefulalefthebrew = 1446, n.merkhalefthebrew = 1445, n.mhook = 625, n.mhzsquare = 13202, n.middledotkatakanahalfwidth = 65381, n.middot = 183, n.mieumacirclekorean = 12914, n.mieumaparenkorean = 12818, n.mieumcirclekorean = 12900, n.mieumkorean = 12609, n.mieumpansioskorean = 12656, n.mieumparenkorean = 12804, n.mieumpieupkorean = 12654, n.mieumsioskorean = 12655, n.mihiragana = 12415, n.mikatakana = 12511, n.mikatakanahalfwidth = 65424, n.minus = 8722, n.minusbelowcmb = 800, n.minuscircle = 8854, n.minusmod = 727, n.minusplus = 8723, n.minute = 8242, n.miribaarusquare = 13130, n.mirisquare = 13129, n.mlonglegturned = 624, n.mlsquare = 13206, n.mmcubedsquare = 13219, n.mmonospace = 65357, n.mmsquaredsquare = 13215, n.mohiragana = 12418, n.mohmsquare = 13249, n.mokatakana = 12514, n.mokatakanahalfwidth = 65427, n.molsquare = 13270, n.momathai = 3617, n.moverssquare = 13223, n.moverssquaredsquare = 13224, n.mparen = 9384, n.mpasquare = 13227, n.mssquare = 13235, n.msuperior = 63215, n.mturned = 623, n.mu = 181, n.mu1 = 181, n.muasquare = 13186, n.muchgreater = 8811, n.muchless = 8810, n.mufsquare = 13196, n.mugreek = 956, n.mugsquare = 13197, n.muhiragana = 12416, n.mukatakana = 12512, n.mukatakanahalfwidth = 65425, n.mulsquare = 13205, n.multiply = 215, n.mumsquare = 13211, n.munahhebrew = 1443, n.munahlefthebrew = 1443, n.musicalnote = 9834, n.musicalnotedbl = 9835, n.musicflatsign = 9837, n.musicsharpsign = 9839, n.mussquare = 13234, n.muvsquare = 13238, n.muwsquare = 13244, n.mvmegasquare = 13241, n.mvsquare = 13239, n.mwmegasquare = 13247, n.mwsquare = 13245, n.n = 110, n.nabengali = 2472, n.nabla = 8711, n.nacute = 324, n.nadeva = 2344, n.nagujarati = 2728, n.nagurmukhi = 2600, n.nahiragana = 12394, n.nakatakana = 12490, n.nakatakanahalfwidth = 65413, n.napostrophe = 329, n.nasquare = 13185, n.nbopomofo = 12555, n.nbspace = 160, n.ncaron = 328, n.ncedilla = 326, n.ncircle = 9437, n.ncircumflexbelow = 7755, n.ncommaaccent = 326, n.ndotaccent = 7749, n.ndotbelow = 7751, n.nehiragana = 12397, n.nekatakana = 12493, n.nekatakanahalfwidth = 65416, n.newsheqelsign = 8362, n.nfsquare = 13195, n.ngabengali = 2457, n.ngadeva = 2329, n.ngagujarati = 2713, n.ngagurmukhi = 2585, n.ngonguthai = 3591, n.nhiragana = 12435, n.nhookleft = 626, n.nhookretroflex = 627, n.nieunacirclekorean = 12911, n.nieunaparenkorean = 12815, n.nieuncieuckorean = 12597, n.nieuncirclekorean = 12897, n.nieunhieuhkorean = 12598, n.nieunkorean = 12596, n.nieunpansioskorean = 12648, n.nieunparenkorean = 12801, n.nieunsioskorean = 12647, n.nieuntikeutkorean = 12646, n.nihiragana = 12395, n.nikatakana = 12491, n.nikatakanahalfwidth = 65414, n.nikhahitleftthai = 63641, n.nikhahitthai = 3661, n.nine = 57, n.ninearabic = 1641, n.ninebengali = 2543, n.ninecircle = 9320, n.ninecircleinversesansserif = 10130, n.ninedeva = 2415, n.ninegujarati = 2799, n.ninegurmukhi = 2671, n.ninehackarabic = 1641, n.ninehangzhou = 12329, n.nineideographicparen = 12840, n.nineinferior = 8329, n.ninemonospace = 65305, n.nineoldstyle = 63289, n.nineparen = 9340, n.nineperiod = 9360, n.ninepersian = 1785, n.nineroman = 8568, n.ninesuperior = 8313, n.nineteencircle = 9330, n.nineteenparen = 9350, n.nineteenperiod = 9370, n.ninethai = 3673, n.nj = 460, n.njecyrillic = 1114, n.nkatakana = 12531, n.nkatakanahalfwidth = 65437, n.nlegrightlong = 414, n.nlinebelow = 7753, n.nmonospace = 65358, n.nmsquare = 13210, n.nnabengali = 2467, n.nnadeva = 2339, n.nnagujarati = 2723, n.nnagurmukhi = 2595, n.nnnadeva = 2345, n.nohiragana = 12398, n.nokatakana = 12494, n.nokatakanahalfwidth = 65417, n.nonbreakingspace = 160, n.nonenthai = 3603, n.nonuthai = 3609, n.noonarabic = 1606, n.noonfinalarabic = 65254, n.noonghunnaarabic = 1722, n.noonghunnafinalarabic = 64415, n.nooninitialarabic = 65255, n.noonjeeminitialarabic = 64722, n.noonjeemisolatedarabic = 64587, n.noonmedialarabic = 65256, n.noonmeeminitialarabic = 64725, n.noonmeemisolatedarabic = 64590, n.noonnoonfinalarabic = 64653, n.notcontains = 8716, n.notelement = 8713, n.notelementof = 8713, n.notequal = 8800, n.notgreater = 8815, n.notgreaternorequal = 8817, n.notgreaternorless = 8825, n.notidentical = 8802, n.notless = 8814, n.notlessnorequal = 8816, n.notparallel = 8742, n.notprecedes = 8832, n.notsubset = 8836, n.notsucceeds = 8833, n.notsuperset = 8837, n.nowarmenian = 1398, n.nparen = 9385, n.nssquare = 13233, n.nsuperior = 8319, n.ntilde = 241, n.nu = 957, n.nuhiragana = 12396, n.nukatakana = 12492, n.nukatakanahalfwidth = 65415, n.nuktabengali = 2492, n.nuktadeva = 2364, n.nuktagujarati = 2748, n.nuktagurmukhi = 2620, n.numbersign = 35, n.numbersignmonospace = 65283, n.numbersignsmall = 65119, n.numeralsigngreek = 884, n.numeralsignlowergreek = 885, n.numero = 8470, n.nun = 1504, n.nundagesh = 64320, n.nundageshhebrew = 64320, n.nunhebrew = 1504, n.nvsquare = 13237, n.nwsquare = 13243, n.nyabengali = 2462, n.nyadeva = 2334, n.nyagujarati = 2718, n.nyagurmukhi = 2590, n.o = 111, n.oacute = 243, n.oangthai = 3629, n.obarred = 629, n.obarredcyrillic = 1257, n.obarreddieresiscyrillic = 1259, n.obengali = 2451, n.obopomofo = 12571, n.obreve = 335, n.ocandradeva = 2321, n.ocandragujarati = 2705, n.ocandravowelsigndeva = 2377, n.ocandravowelsigngujarati = 2761, n.ocaron = 466, n.ocircle = 9438, n.ocircumflex = 244, n.ocircumflexacute = 7889, n.ocircumflexdotbelow = 7897, n.ocircumflexgrave = 7891, n.ocircumflexhookabove = 7893, n.ocircumflextilde = 7895, n.ocyrillic = 1086, n.odblacute = 337, n.odblgrave = 525, n.odeva = 2323, n.odieresis = 246, n.odieresiscyrillic = 1255, n.odotbelow = 7885, n.oe = 339, n.oekorean = 12634, n.ogonek = 731, n.ogonekcmb = 808, n.ograve = 242, n.ogujarati = 2707, n.oharmenian = 1413, n.ohiragana = 12362, n.ohookabove = 7887, n.ohorn = 417, n.ohornacute = 7899, n.ohorndotbelow = 7907, n.ohorngrave = 7901, n.ohornhookabove = 7903, n.ohorntilde = 7905, n.ohungarumlaut = 337, n.oi = 419, n.oinvertedbreve = 527, n.okatakana = 12458, n.okatakanahalfwidth = 65397, n.okorean = 12631, n.olehebrew = 1451, n.omacron = 333, n.omacronacute = 7763, n.omacrongrave = 7761, n.omdeva = 2384, n.omega = 969, n.omega1 = 982, n.omegacyrillic = 1121, n.omegalatinclosed = 631, n.omegaroundcyrillic = 1147, n.omegatitlocyrillic = 1149, n.omegatonos = 974, n.omgujarati = 2768, n.omicron = 959, n.omicrontonos = 972, n.omonospace = 65359, n.one = 49, n.onearabic = 1633, n.onebengali = 2535, n.onecircle = 9312, n.onecircleinversesansserif = 10122, n.onedeva = 2407, n.onedotenleader = 8228, n.oneeighth = 8539, n.onefitted = 63196, n.onegujarati = 2791, n.onegurmukhi = 2663, n.onehackarabic = 1633, n.onehalf = 189, n.onehangzhou = 12321, n.oneideographicparen = 12832, n.oneinferior = 8321, n.onemonospace = 65297, n.onenumeratorbengali = 2548, n.oneoldstyle = 63281, n.oneparen = 9332, n.oneperiod = 9352, n.onepersian = 1777, n.onequarter = 188, n.oneroman = 8560, n.onesuperior = 185, n.onethai = 3665, n.onethird = 8531, n.oogonek = 491, n.oogonekmacron = 493, n.oogurmukhi = 2579, n.oomatragurmukhi = 2635, n.oopen = 596, n.oparen = 9386, n.openbullet = 9702, n.option = 8997, n.ordfeminine = 170, n.ordmasculine = 186, n.orthogonal = 8735, n.oshortdeva = 2322, n.oshortvowelsigndeva = 2378, n.oslash = 248, n.oslashacute = 511, n.osmallhiragana = 12361, n.osmallkatakana = 12457, n.osmallkatakanahalfwidth = 65387, n.ostrokeacute = 511, n.osuperior = 63216, n.otcyrillic = 1151, n.otilde = 245, n.otildeacute = 7757, n.otildedieresis = 7759, n.oubopomofo = 12577, n.overline = 8254, n.overlinecenterline = 65098, n.overlinecmb = 773, n.overlinedashed = 65097, n.overlinedblwavy = 65100, n.overlinewavy = 65099, n.overscore = 175, n.ovowelsignbengali = 2507, n.ovowelsigndeva = 2379, n.ovowelsigngujarati = 2763, n.p = 112, n.paampssquare = 13184, n.paasentosquare = 13099, n.pabengali = 2474, n.pacute = 7765, n.padeva = 2346, n.pagedown = 8671, n.pageup = 8670, n.pagujarati = 2730, n.pagurmukhi = 2602, n.pahiragana = 12401, n.paiyannoithai = 3631, n.pakatakana = 12497, n.palatalizationcyrilliccmb = 1156, n.palochkacyrillic = 1216, n.pansioskorean = 12671, n.paragraph = 182, n.parallel = 8741, n.parenleft = 40, n.parenleftaltonearabic = 64830, n.parenleftbt = 63725, n.parenleftex = 63724, n.parenleftinferior = 8333, n.parenleftmonospace = 65288, n.parenleftsmall = 65113, n.parenleftsuperior = 8317, n.parenlefttp = 63723, n.parenleftvertical = 65077, n.parenright = 41, n.parenrightaltonearabic = 64831, n.parenrightbt = 63736, n.parenrightex = 63735, n.parenrightinferior = 8334, n.parenrightmonospace = 65289, n.parenrightsmall = 65114, n.parenrightsuperior = 8318, n.parenrighttp = 63734, n.parenrightvertical = 65078, n.partialdiff = 8706, n.paseqhebrew = 1472, n.pashtahebrew = 1433, n.pasquare = 13225, n.patah = 1463, n.patah11 = 1463, n.patah1d = 1463, n.patah2a = 1463, n.patahhebrew = 1463, n.patahnarrowhebrew = 1463, n.patahquarterhebrew = 1463, n.patahwidehebrew = 1463, n.pazerhebrew = 1441, n.pbopomofo = 12550, n.pcircle = 9439, n.pdotaccent = 7767, n.pe = 1508, n.pecyrillic = 1087, n.pedagesh = 64324, n.pedageshhebrew = 64324, n.peezisquare = 13115, n.pefinaldageshhebrew = 64323, n.peharabic = 1662, n.peharmenian = 1402, n.pehebrew = 1508, n.pehfinalarabic = 64343, n.pehinitialarabic = 64344, n.pehiragana = 12410, n.pehmedialarabic = 64345, n.pekatakana = 12506, n.pemiddlehookcyrillic = 1191, n.perafehebrew = 64334, n.percent = 37, n.percentarabic = 1642, n.percentmonospace = 65285, n.percentsmall = 65130, n.period = 46, n.periodarmenian = 1417, n.periodcentered = 183, n.periodhalfwidth = 65377, n.periodinferior = 63207, n.periodmonospace = 65294, n.periodsmall = 65106, n.periodsuperior = 63208, n.perispomenigreekcmb = 834, n.perpendicular = 8869, n.perthousand = 8240, n.peseta = 8359, n.pfsquare = 13194, n.phabengali = 2475, n.phadeva = 2347, n.phagujarati = 2731, n.phagurmukhi = 2603, n.phi = 966, n.phi1 = 981, n.phieuphacirclekorean = 12922, n.phieuphaparenkorean = 12826, n.phieuphcirclekorean = 12908, n.phieuphkorean = 12621, n.phieuphparenkorean = 12812, n.philatin = 632, n.phinthuthai = 3642, n.phisymbolgreek = 981, n.phook = 421, n.phophanthai = 3614, n.phophungthai = 3612, n.phosamphaothai = 3616, n.pi = 960, n.pieupacirclekorean = 12915, n.pieupaparenkorean = 12819, n.pieupcieuckorean = 12662, n.pieupcirclekorean = 12901, n.pieupkiyeokkorean = 12658, n.pieupkorean = 12610, n.pieupparenkorean = 12805, n.pieupsioskiyeokkorean = 12660, n.pieupsioskorean = 12612, n.pieupsiostikeutkorean = 12661, n.pieupthieuthkorean = 12663, n.pieuptikeutkorean = 12659, n.pihiragana = 12404, n.pikatakana = 12500, n.pisymbolgreek = 982, n.piwrarmenian = 1411, n.planckover2pi = 8463, n.planckover2pi1 = 8463, n.plus = 43, n.plusbelowcmb = 799, n.pluscircle = 8853, n.plusminus = 177, n.plusmod = 726, n.plusmonospace = 65291, n.plussmall = 65122, n.plussuperior = 8314, n.pmonospace = 65360, n.pmsquare = 13272, n.pohiragana = 12413, n.pointingindexdownwhite = 9759, n.pointingindexleftwhite = 9756, n.pointingindexrightwhite = 9758, n.pointingindexupwhite = 9757, n.pokatakana = 12509, n.poplathai = 3611, n.postalmark = 12306, n.postalmarkface = 12320, n.pparen = 9387, n.precedes = 8826, n.prescription = 8478, n.primemod = 697, n.primereversed = 8245, n.product = 8719, n.projective = 8965, n.prolongedkana = 12540, n.propellor = 8984, n.propersubset = 8834, n.propersuperset = 8835, n.proportion = 8759, n.proportional = 8733, n.psi = 968, n.psicyrillic = 1137, n.psilipneumatacyrilliccmb = 1158, n.pssquare = 13232, n.puhiragana = 12407, n.pukatakana = 12503, n.pvsquare = 13236, n.pwsquare = 13242, n.q = 113, n.qadeva = 2392, n.qadmahebrew = 1448, n.qafarabic = 1602, n.qaffinalarabic = 65238, n.qafinitialarabic = 65239, n.qafmedialarabic = 65240, n.qamats = 1464, n.qamats10 = 1464, n.qamats1a = 1464, n.qamats1c = 1464, n.qamats27 = 1464, n.qamats29 = 1464, n.qamats33 = 1464, n.qamatsde = 1464, n.qamatshebrew = 1464, n.qamatsnarrowhebrew = 1464, n.qamatsqatanhebrew = 1464, n.qamatsqatannarrowhebrew = 1464, n.qamatsqatanquarterhebrew = 1464, n.qamatsqatanwidehebrew = 1464, n.qamatsquarterhebrew = 1464, n.qamatswidehebrew = 1464, n.qarneyparahebrew = 1439, n.qbopomofo = 12561, n.qcircle = 9440, n.qhook = 672, n.qmonospace = 65361, n.qof = 1511, n.qofdagesh = 64327, n.qofdageshhebrew = 64327, n.qofhebrew = 1511, n.qparen = 9388, n.quarternote = 9833, n.qubuts = 1467, n.qubuts18 = 1467, n.qubuts25 = 1467, n.qubuts31 = 1467, n.qubutshebrew = 1467, n.qubutsnarrowhebrew = 1467, n.qubutsquarterhebrew = 1467, n.qubutswidehebrew = 1467, n.question = 63, n.questionarabic = 1567, n.questionarmenian = 1374, n.questiondown = 191, n.questiondownsmall = 63423, n.questiongreek = 894, n.questionmonospace = 65311, n.questionsmall = 63295, n.quotedbl = 34, n.quotedblbase = 8222, n.quotedblleft = 8220, n.quotedblmonospace = 65282, n.quotedblprime = 12318, n.quotedblprimereversed = 12317, n.quotedblright = 8221, n.quoteleft = 8216, n.quoteleftreversed = 8219, n.quotereversed = 8219, n.quoteright = 8217, n.quoterightn = 329, n.quotesinglbase = 8218, n.quotesingle = 39, n.quotesinglemonospace = 65287, n.r = 114, n.raarmenian = 1404, n.rabengali = 2480, n.racute = 341, n.radeva = 2352, n.radical = 8730, n.radicalex = 63717, n.radoverssquare = 13230, n.radoverssquaredsquare = 13231, n.radsquare = 13229, n.rafe = 1471, n.rafehebrew = 1471, n.ragujarati = 2736, n.ragurmukhi = 2608, n.rahiragana = 12425, n.rakatakana = 12521, n.rakatakanahalfwidth = 65431, n.ralowerdiagonalbengali = 2545, n.ramiddlediagonalbengali = 2544, n.ramshorn = 612, n.ratio = 8758, n.rbopomofo = 12566, n.rcaron = 345, n.rcedilla = 343, n.rcircle = 9441, n.rcommaaccent = 343, n.rdblgrave = 529, n.rdotaccent = 7769, n.rdotbelow = 7771, n.rdotbelowmacron = 7773, n.referencemark = 8251, n.reflexsubset = 8838, n.reflexsuperset = 8839, n.registered = 174, n.registersans = 63720, n.registerserif = 63194, n.reharabic = 1585, n.reharmenian = 1408, n.rehfinalarabic = 65198, n.rehiragana = 12428, n.rekatakana = 12524, n.rekatakanahalfwidth = 65434, n.resh = 1512, n.reshdageshhebrew = 64328, n.reshhebrew = 1512, n.reversedtilde = 8765, n.reviahebrew = 1431, n.reviamugrashhebrew = 1431, n.revlogicalnot = 8976, n.rfishhook = 638, n.rfishhookreversed = 639, n.rhabengali = 2525, n.rhadeva = 2397, n.rho = 961, n.rhook = 637, n.rhookturned = 635, n.rhookturnedsuperior = 693, n.rhosymbolgreek = 1009, n.rhotichookmod = 734, n.rieulacirclekorean = 12913, n.rieulaparenkorean = 12817, n.rieulcirclekorean = 12899, n.rieulhieuhkorean = 12608, n.rieulkiyeokkorean = 12602, n.rieulkiyeoksioskorean = 12649, n.rieulkorean = 12601, n.rieulmieumkorean = 12603, n.rieulpansioskorean = 12652, n.rieulparenkorean = 12803, n.rieulphieuphkorean = 12607, n.rieulpieupkorean = 12604, n.rieulpieupsioskorean = 12651, n.rieulsioskorean = 12605, n.rieulthieuthkorean = 12606, n.rieultikeutkorean = 12650, n.rieulyeorinhieuhkorean = 12653, n.rightangle = 8735, n.righttackbelowcmb = 793, n.righttriangle = 8895, n.rihiragana = 12426, n.rikatakana = 12522, n.rikatakanahalfwidth = 65432, n.ring = 730, n.ringbelowcmb = 805, n.ringcmb = 778, n.ringhalfleft = 703, n.ringhalfleftarmenian = 1369, n.ringhalfleftbelowcmb = 796, n.ringhalfleftcentered = 723, n.ringhalfright = 702, n.ringhalfrightbelowcmb = 825, n.ringhalfrightcentered = 722, n.rinvertedbreve = 531, n.rittorusquare = 13137, n.rlinebelow = 7775, n.rlongleg = 636, n.rlonglegturned = 634, n.rmonospace = 65362, n.rohiragana = 12429, n.rokatakana = 12525, n.rokatakanahalfwidth = 65435, n.roruathai = 3619, n.rparen = 9389, n.rrabengali = 2524, n.rradeva = 2353, n.rragurmukhi = 2652, n.rreharabic = 1681, n.rrehfinalarabic = 64397, n.rrvocalicbengali = 2528, n.rrvocalicdeva = 2400, n.rrvocalicgujarati = 2784, n.rrvocalicvowelsignbengali = 2500, n.rrvocalicvowelsigndeva = 2372, n.rrvocalicvowelsigngujarati = 2756, n.rsuperior = 63217, n.rtblock = 9616, n.rturned = 633, n.rturnedsuperior = 692, n.ruhiragana = 12427, n.rukatakana = 12523, n.rukatakanahalfwidth = 65433, n.rupeemarkbengali = 2546, n.rupeesignbengali = 2547, n.rupiah = 63197, n.ruthai = 3620, n.rvocalicbengali = 2443, n.rvocalicdeva = 2315, n.rvocalicgujarati = 2699, n.rvocalicvowelsignbengali = 2499, n.rvocalicvowelsigndeva = 2371, n.rvocalicvowelsigngujarati = 2755, n.s = 115, n.sabengali = 2488, n.sacute = 347, n.sacutedotaccent = 7781, n.sadarabic = 1589, n.sadeva = 2360, n.sadfinalarabic = 65210, n.sadinitialarabic = 65211, n.sadmedialarabic = 65212, n.sagujarati = 2744, n.sagurmukhi = 2616, n.sahiragana = 12373, n.sakatakana = 12469, n.sakatakanahalfwidth = 65403, n.sallallahoualayhewasallamarabic = 65018, n.samekh = 1505, n.samekhdagesh = 64321, n.samekhdageshhebrew = 64321, n.samekhhebrew = 1505, n.saraaathai = 3634, n.saraaethai = 3649, n.saraaimaimalaithai = 3652, n.saraaimaimuanthai = 3651, n.saraamthai = 3635, n.saraathai = 3632, n.saraethai = 3648, n.saraiileftthai = 63622, n.saraiithai = 3637, n.saraileftthai = 63621, n.saraithai = 3636, n.saraothai = 3650, n.saraueeleftthai = 63624, n.saraueethai = 3639, n.saraueleftthai = 63623, n.sarauethai = 3638, n.sarauthai = 3640, n.sarauuthai = 3641, n.sbopomofo = 12569, n.scaron = 353, n.scarondotaccent = 7783, n.scedilla = 351, n.schwa = 601, n.schwacyrillic = 1241, n.schwadieresiscyrillic = 1243, n.schwahook = 602, n.scircle = 9442, n.scircumflex = 349, n.scommaaccent = 537, n.sdotaccent = 7777, n.sdotbelow = 7779, n.sdotbelowdotaccent = 7785, n.seagullbelowcmb = 828, n.second = 8243, n.secondtonechinese = 714, n.section = 167, n.seenarabic = 1587, n.seenfinalarabic = 65202, n.seeninitialarabic = 65203, n.seenmedialarabic = 65204, n.segol = 1462, n.segol13 = 1462, n.segol1f = 1462, n.segol2c = 1462, n.segolhebrew = 1462, n.segolnarrowhebrew = 1462, n.segolquarterhebrew = 1462, n.segoltahebrew = 1426, n.segolwidehebrew = 1462, n.seharmenian = 1405, n.sehiragana = 12379, n.sekatakana = 12475, n.sekatakanahalfwidth = 65406, n.semicolon = 59, n.semicolonarabic = 1563, n.semicolonmonospace = 65307, n.semicolonsmall = 65108, n.semivoicedmarkkana = 12444, n.semivoicedmarkkanahalfwidth = 65439, n.sentisquare = 13090, n.sentosquare = 13091, n.seven = 55, n.sevenarabic = 1639, n.sevenbengali = 2541, n.sevencircle = 9318, n.sevencircleinversesansserif = 10128, n.sevendeva = 2413, n.seveneighths = 8542, n.sevengujarati = 2797, n.sevengurmukhi = 2669, n.sevenhackarabic = 1639, n.sevenhangzhou = 12327, n.sevenideographicparen = 12838, n.seveninferior = 8327, n.sevenmonospace = 65303, n.sevenoldstyle = 63287, n.sevenparen = 9338, n.sevenperiod = 9358, n.sevenpersian = 1783, n.sevenroman = 8566, n.sevensuperior = 8311, n.seventeencircle = 9328, n.seventeenparen = 9348, n.seventeenperiod = 9368, n.seventhai = 3671, n.sfthyphen = 173, n.shaarmenian = 1399, n.shabengali = 2486, n.shacyrillic = 1096, n.shaddaarabic = 1617, n.shaddadammaarabic = 64609, n.shaddadammatanarabic = 64606, n.shaddafathaarabic = 64608, n.shaddakasraarabic = 64610, n.shaddakasratanarabic = 64607, n.shade = 9618, n.shadedark = 9619, n.shadelight = 9617, n.shademedium = 9618, n.shadeva = 2358, n.shagujarati = 2742, n.shagurmukhi = 2614, n.shalshelethebrew = 1427, n.shbopomofo = 12565, n.shchacyrillic = 1097, n.sheenarabic = 1588, n.sheenfinalarabic = 65206, n.sheeninitialarabic = 65207, n.sheenmedialarabic = 65208, n.sheicoptic = 995, n.sheqel = 8362, n.sheqelhebrew = 8362, n.sheva = 1456, n.sheva115 = 1456, n.sheva15 = 1456, n.sheva22 = 1456, n.sheva2e = 1456, n.shevahebrew = 1456, n.shevanarrowhebrew = 1456, n.shevaquarterhebrew = 1456, n.shevawidehebrew = 1456, n.shhacyrillic = 1211, n.shimacoptic = 1005, n.shin = 1513, n.shindagesh = 64329, n.shindageshhebrew = 64329, n.shindageshshindot = 64300, n.shindageshshindothebrew = 64300, n.shindageshsindot = 64301, n.shindageshsindothebrew = 64301, n.shindothebrew = 1473, n.shinhebrew = 1513, n.shinshindot = 64298, n.shinshindothebrew = 64298, n.shinsindot = 64299, n.shinsindothebrew = 64299, n.shook = 642, n.sigma = 963, n.sigma1 = 962, n.sigmafinal = 962, n.sigmalunatesymbolgreek = 1010, n.sihiragana = 12375, n.sikatakana = 12471, n.sikatakanahalfwidth = 65404, n.siluqhebrew = 1469, n.siluqlefthebrew = 1469, n.similar = 8764, n.sindothebrew = 1474, n.siosacirclekorean = 12916, n.siosaparenkorean = 12820, n.sioscieuckorean = 12670, n.sioscirclekorean = 12902, n.sioskiyeokkorean = 12666, n.sioskorean = 12613, n.siosnieunkorean = 12667, n.siosparenkorean = 12806, n.siospieupkorean = 12669, n.siostikeutkorean = 12668, n.six = 54, n.sixarabic = 1638, n.sixbengali = 2540, n.sixcircle = 9317, n.sixcircleinversesansserif = 10127, n.sixdeva = 2412, n.sixgujarati = 2796, n.sixgurmukhi = 2668, n.sixhackarabic = 1638, n.sixhangzhou = 12326, n.sixideographicparen = 12837, n.sixinferior = 8326, n.sixmonospace = 65302, n.sixoldstyle = 63286, n.sixparen = 9337, n.sixperiod = 9357, n.sixpersian = 1782, n.sixroman = 8565, n.sixsuperior = 8310, n.sixteencircle = 9327, n.sixteencurrencydenominatorbengali = 2553, n.sixteenparen = 9347, n.sixteenperiod = 9367, n.sixthai = 3670, n.slash = 47, n.slashmonospace = 65295, n.slong = 383, n.slongdotaccent = 7835, n.smileface = 9786, n.smonospace = 65363, n.sofpasuqhebrew = 1475, n.softhyphen = 173, n.softsigncyrillic = 1100, n.sohiragana = 12381, n.sokatakana = 12477, n.sokatakanahalfwidth = 65407, n.soliduslongoverlaycmb = 824, n.solidusshortoverlaycmb = 823, n.sorusithai = 3625, n.sosalathai = 3624, n.sosothai = 3595, n.sosuathai = 3626, n.space = 32, n.spacehackarabic = 32, n.spade = 9824, n.spadesuitblack = 9824, n.spadesuitwhite = 9828, n.sparen = 9390, n.squarebelowcmb = 827, n.squarecc = 13252, n.squarecm = 13213, n.squarediagonalcrosshatchfill = 9641, n.squarehorizontalfill = 9636, n.squarekg = 13199, n.squarekm = 13214, n.squarekmcapital = 13262, n.squareln = 13265, n.squarelog = 13266, n.squaremg = 13198, n.squaremil = 13269, n.squaremm = 13212, n.squaremsquared = 13217, n.squareorthogonalcrosshatchfill = 9638, n.squareupperlefttolowerrightfill = 9639, n.squareupperrighttolowerleftfill = 9640, n.squareverticalfill = 9637, n.squarewhitewithsmallblack = 9635, n.srsquare = 13275, n.ssabengali = 2487, n.ssadeva = 2359, n.ssagujarati = 2743, n.ssangcieuckorean = 12617, n.ssanghieuhkorean = 12677, n.ssangieungkorean = 12672, n.ssangkiyeokkorean = 12594, n.ssangnieunkorean = 12645, n.ssangpieupkorean = 12611, n.ssangsioskorean = 12614, n.ssangtikeutkorean = 12600, n.ssuperior = 63218, n.sterling = 163, n.sterlingmonospace = 65505, n.strokelongoverlaycmb = 822, n.strokeshortoverlaycmb = 821, n.subset = 8834, n.subsetnotequal = 8842, n.subsetorequal = 8838, n.succeeds = 8827, n.suchthat = 8715, n.suhiragana = 12377, n.sukatakana = 12473, n.sukatakanahalfwidth = 65405, n.sukunarabic = 1618, n.summation = 8721, n.sun = 9788, n.superset = 8835, n.supersetnotequal = 8843, n.supersetorequal = 8839, n.svsquare = 13276, n.syouwaerasquare = 13180, n.t = 116, n.tabengali = 2468, n.tackdown = 8868, n.tackleft = 8867, n.tadeva = 2340, n.tagujarati = 2724, n.tagurmukhi = 2596, n.taharabic = 1591, n.tahfinalarabic = 65218, n.tahinitialarabic = 65219, n.tahiragana = 12383, n.tahmedialarabic = 65220, n.taisyouerasquare = 13181, n.takatakana = 12479, n.takatakanahalfwidth = 65408, n.tatweelarabic = 1600, n.tau = 964, n.tav = 1514, n.tavdages = 64330, n.tavdagesh = 64330, n.tavdageshhebrew = 64330, n.tavhebrew = 1514, n.tbar = 359, n.tbopomofo = 12554, n.tcaron = 357, n.tccurl = 680, n.tcedilla = 355, n.tcheharabic = 1670, n.tchehfinalarabic = 64379, n.tchehinitialarabic = 64380, n.tchehmedialarabic = 64381, n.tcircle = 9443, n.tcircumflexbelow = 7793, n.tcommaaccent = 355, n.tdieresis = 7831, n.tdotaccent = 7787, n.tdotbelow = 7789, n.tecyrillic = 1090, n.tedescendercyrillic = 1197, n.teharabic = 1578, n.tehfinalarabic = 65174, n.tehhahinitialarabic = 64674, n.tehhahisolatedarabic = 64524, n.tehinitialarabic = 65175, n.tehiragana = 12390, n.tehjeeminitialarabic = 64673, n.tehjeemisolatedarabic = 64523, n.tehmarbutaarabic = 1577, n.tehmarbutafinalarabic = 65172, n.tehmedialarabic = 65176, n.tehmeeminitialarabic = 64676, n.tehmeemisolatedarabic = 64526, n.tehnoonfinalarabic = 64627, n.tekatakana = 12486, n.tekatakanahalfwidth = 65411, n.telephone = 8481, n.telephoneblack = 9742, n.telishagedolahebrew = 1440, n.telishaqetanahebrew = 1449, n.tencircle = 9321, n.tenideographicparen = 12841, n.tenparen = 9341, n.tenperiod = 9361, n.tenroman = 8569, n.tesh = 679, n.tet = 1496, n.tetdagesh = 64312, n.tetdageshhebrew = 64312, n.tethebrew = 1496, n.tetsecyrillic = 1205, n.tevirhebrew = 1435, n.tevirlefthebrew = 1435, n.thabengali = 2469, n.thadeva = 2341, n.thagujarati = 2725, n.thagurmukhi = 2597, n.thalarabic = 1584, n.thalfinalarabic = 65196, n.thanthakhatlowleftthai = 63640, n.thanthakhatlowrightthai = 63639, n.thanthakhatthai = 3660, n.thanthakhatupperleftthai = 63638, n.theharabic = 1579, n.thehfinalarabic = 65178, n.thehinitialarabic = 65179, n.thehmedialarabic = 65180, n.thereexists = 8707, n.therefore = 8756, n.theta = 952, n.theta1 = 977, n.thetasymbolgreek = 977, n.thieuthacirclekorean = 12921, n.thieuthaparenkorean = 12825, n.thieuthcirclekorean = 12907, n.thieuthkorean = 12620, n.thieuthparenkorean = 12811, n.thirteencircle = 9324, n.thirteenparen = 9344, n.thirteenperiod = 9364, n.thonangmonthothai = 3601, n.thook = 429, n.thophuthaothai = 3602, n.thorn = 254, n.thothahanthai = 3607, n.thothanthai = 3600, n.thothongthai = 3608, n.thothungthai = 3606, n.thousandcyrillic = 1154, n.thousandsseparatorarabic = 1644, n.thousandsseparatorpersian = 1644, n.three = 51, n.threearabic = 1635, n.threebengali = 2537, n.threecircle = 9314, n.threecircleinversesansserif = 10124, n.threedeva = 2409, n.threeeighths = 8540, n.threegujarati = 2793, n.threegurmukhi = 2665, n.threehackarabic = 1635, n.threehangzhou = 12323, n.threeideographicparen = 12834, n.threeinferior = 8323, n.threemonospace = 65299, n.threenumeratorbengali = 2550, n.threeoldstyle = 63283, n.threeparen = 9334, n.threeperiod = 9354, n.threepersian = 1779, n.threequarters = 190, n.threequartersemdash = 63198, n.threeroman = 8562, n.threesuperior = 179, n.threethai = 3667, n.thzsquare = 13204, n.tihiragana = 12385, n.tikatakana = 12481, n.tikatakanahalfwidth = 65409, n.tikeutacirclekorean = 12912, n.tikeutaparenkorean = 12816, n.tikeutcirclekorean = 12898, n.tikeutkorean = 12599, n.tikeutparenkorean = 12802, n.tilde = 732, n.tildebelowcmb = 816, n.tildecmb = 771, n.tildecomb = 771, n.tildedoublecmb = 864, n.tildeoperator = 8764, n.tildeoverlaycmb = 820, n.tildeverticalcmb = 830, n.timescircle = 8855, n.tipehahebrew = 1430, n.tipehalefthebrew = 1430, n.tippigurmukhi = 2672, n.titlocyrilliccmb = 1155, n.tiwnarmenian = 1407, n.tlinebelow = 7791, n.tmonospace = 65364, n.toarmenian = 1385, n.tohiragana = 12392, n.tokatakana = 12488, n.tokatakanahalfwidth = 65412, n.tonebarextrahighmod = 741, n.tonebarextralowmod = 745, n.tonebarhighmod = 742, n.tonebarlowmod = 744, n.tonebarmidmod = 743, n.tonefive = 445, n.tonesix = 389, n.tonetwo = 424, n.tonos = 900, n.tonsquare = 13095, n.topatakthai = 3599, n.tortoiseshellbracketleft = 12308, n.tortoiseshellbracketleftsmall = 65117, n.tortoiseshellbracketleftvertical = 65081, n.tortoiseshellbracketright = 12309, n.tortoiseshellbracketrightsmall = 65118, n.tortoiseshellbracketrightvertical = 65082, n.totaothai = 3605, n.tpalatalhook = 427, n.tparen = 9391, n.trademark = 8482, n.trademarksans = 63722, n.trademarkserif = 63195, n.tretroflexhook = 648, n.triagdn = 9660, n.triaglf = 9668, n.triagrt = 9658, n.triagup = 9650, n.ts = 678, n.tsadi = 1510, n.tsadidagesh = 64326, n.tsadidageshhebrew = 64326, n.tsadihebrew = 1510, n.tsecyrillic = 1094, n.tsere = 1461, n.tsere12 = 1461, n.tsere1e = 1461, n.tsere2b = 1461, n.tserehebrew = 1461, n.tserenarrowhebrew = 1461, n.tserequarterhebrew = 1461, n.tserewidehebrew = 1461, n.tshecyrillic = 1115, n.tsuperior = 63219, n.ttabengali = 2463, n.ttadeva = 2335, n.ttagujarati = 2719, n.ttagurmukhi = 2591, n.tteharabic = 1657, n.ttehfinalarabic = 64359, n.ttehinitialarabic = 64360, n.ttehmedialarabic = 64361, n.tthabengali = 2464, n.tthadeva = 2336, n.tthagujarati = 2720, n.tthagurmukhi = 2592, n.tturned = 647, n.tuhiragana = 12388, n.tukatakana = 12484, n.tukatakanahalfwidth = 65410, n.tusmallhiragana = 12387, n.tusmallkatakana = 12483, n.tusmallkatakanahalfwidth = 65391, n.twelvecircle = 9323, n.twelveparen = 9343, n.twelveperiod = 9363, n.twelveroman = 8571, n.twentycircle = 9331, n.twentyhangzhou = 21316, n.twentyparen = 9351, n.twentyperiod = 9371, n.two = 50, n.twoarabic = 1634, n.twobengali = 2536, n.twocircle = 9313, n.twocircleinversesansserif = 10123, n.twodeva = 2408, n.twodotenleader = 8229, n.twodotleader = 8229, n.twodotleadervertical = 65072, n.twogujarati = 2792, n.twogurmukhi = 2664, n.twohackarabic = 1634, n.twohangzhou = 12322, n.twoideographicparen = 12833, n.twoinferior = 8322, n.twomonospace = 65298, n.twonumeratorbengali = 2549, n.twooldstyle = 63282, n.twoparen = 9333, n.twoperiod = 9353, n.twopersian = 1778, n.tworoman = 8561, n.twostroke = 443, n.twosuperior = 178, n.twothai = 3666, n.twothirds = 8532, n.u = 117, n.uacute = 250, n.ubar = 649, n.ubengali = 2441, n.ubopomofo = 12584, n.ubreve = 365, n.ucaron = 468, n.ucircle = 9444, n.ucircumflex = 251, n.ucircumflexbelow = 7799, n.ucyrillic = 1091, n.udattadeva = 2385, n.udblacute = 369, n.udblgrave = 533, n.udeva = 2313, n.udieresis = 252, n.udieresisacute = 472, n.udieresisbelow = 7795, n.udieresiscaron = 474, n.udieresiscyrillic = 1265, n.udieresisgrave = 476, n.udieresismacron = 470, n.udotbelow = 7909, n.ugrave = 249, n.ugujarati = 2697, n.ugurmukhi = 2569, n.uhiragana = 12358, n.uhookabove = 7911, n.uhorn = 432, n.uhornacute = 7913, n.uhorndotbelow = 7921, n.uhorngrave = 7915, n.uhornhookabove = 7917, n.uhorntilde = 7919, n.uhungarumlaut = 369, n.uhungarumlautcyrillic = 1267, n.uinvertedbreve = 535, n.ukatakana = 12454, n.ukatakanahalfwidth = 65395, n.ukcyrillic = 1145, n.ukorean = 12636, n.umacron = 363, n.umacroncyrillic = 1263, n.umacrondieresis = 7803, n.umatragurmukhi = 2625, n.umonospace = 65365, n.underscore = 95, n.underscoredbl = 8215, n.underscoremonospace = 65343, n.underscorevertical = 65075, n.underscorewavy = 65103, n.union = 8746, n.universal = 8704, n.uogonek = 371, n.uparen = 9392, n.upblock = 9600, n.upperdothebrew = 1476, n.upsilon = 965, n.upsilondieresis = 971, n.upsilondieresistonos = 944, n.upsilonlatin = 650, n.upsilontonos = 973, n.uptackbelowcmb = 797, n.uptackmod = 724, n.uragurmukhi = 2675, n.uring = 367, n.ushortcyrillic = 1118, n.usmallhiragana = 12357, n.usmallkatakana = 12453, n.usmallkatakanahalfwidth = 65385, n.ustraightcyrillic = 1199, n.ustraightstrokecyrillic = 1201, n.utilde = 361, n.utildeacute = 7801, n.utildebelow = 7797, n.uubengali = 2442, n.uudeva = 2314, n.uugujarati = 2698, n.uugurmukhi = 2570, n.uumatragurmukhi = 2626, n.uuvowelsignbengali = 2498, n.uuvowelsigndeva = 2370, n.uuvowelsigngujarati = 2754, n.uvowelsignbengali = 2497, n.uvowelsigndeva = 2369, n.uvowelsigngujarati = 2753, n.v = 118, n.vadeva = 2357, n.vagujarati = 2741, n.vagurmukhi = 2613, n.vakatakana = 12535, n.vav = 1493, n.vavdagesh = 64309, n.vavdagesh65 = 64309, n.vavdageshhebrew = 64309, n.vavhebrew = 1493, n.vavholam = 64331, n.vavholamhebrew = 64331, n.vavvavhebrew = 1520, n.vavyodhebrew = 1521, n.vcircle = 9445, n.vdotbelow = 7807, n.vecyrillic = 1074, n.veharabic = 1700, n.vehfinalarabic = 64363, n.vehinitialarabic = 64364, n.vehmedialarabic = 64365, n.vekatakana = 12537, n.venus = 9792, n.verticalbar = 124, n.verticallineabovecmb = 781, n.verticallinebelowcmb = 809, n.verticallinelowmod = 716, n.verticallinemod = 712, n.vewarmenian = 1406, n.vhook = 651, n.vikatakana = 12536, n.viramabengali = 2509, n.viramadeva = 2381, n.viramagujarati = 2765, n.visargabengali = 2435, n.visargadeva = 2307, n.visargagujarati = 2691, n.vmonospace = 65366, n.voarmenian = 1400, n.voicediterationhiragana = 12446, n.voicediterationkatakana = 12542, n.voicedmarkkana = 12443, n.voicedmarkkanahalfwidth = 65438, n.vokatakana = 12538, n.vparen = 9393, n.vtilde = 7805, n.vturned = 652, n.vuhiragana = 12436, n.vukatakana = 12532, n.w = 119, n.wacute = 7811, n.waekorean = 12633, n.wahiragana = 12431, n.wakatakana = 12527, n.wakatakanahalfwidth = 65436, n.wakorean = 12632, n.wasmallhiragana = 12430, n.wasmallkatakana = 12526, n.wattosquare = 13143, n.wavedash = 12316, n.wavyunderscorevertical = 65076, n.wawarabic = 1608, n.wawfinalarabic = 65262, n.wawhamzaabovearabic = 1572, n.wawhamzaabovefinalarabic = 65158, n.wbsquare = 13277, n.wcircle = 9446, n.wcircumflex = 373, n.wdieresis = 7813, n.wdotaccent = 7815, n.wdotbelow = 7817, n.wehiragana = 12433, n.weierstrass = 8472, n.wekatakana = 12529, n.wekorean = 12638, n.weokorean = 12637, n.wgrave = 7809, n.whitebullet = 9702, n.whitecircle = 9675, n.whitecircleinverse = 9689, n.whitecornerbracketleft = 12302, n.whitecornerbracketleftvertical = 65091, n.whitecornerbracketright = 12303, n.whitecornerbracketrightvertical = 65092, n.whitediamond = 9671, n.whitediamondcontainingblacksmalldiamond = 9672, n.whitedownpointingsmalltriangle = 9663, n.whitedownpointingtriangle = 9661, n.whiteleftpointingsmalltriangle = 9667, n.whiteleftpointingtriangle = 9665, n.whitelenticularbracketleft = 12310, n.whitelenticularbracketright = 12311, n.whiterightpointingsmalltriangle = 9657, n.whiterightpointingtriangle = 9655, n.whitesmallsquare = 9643, n.whitesmilingface = 9786, n.whitesquare = 9633, n.whitestar = 9734, n.whitetelephone = 9743, n.whitetortoiseshellbracketleft = 12312, n.whitetortoiseshellbracketright = 12313, n.whiteuppointingsmalltriangle = 9653, n.whiteuppointingtriangle = 9651, n.wihiragana = 12432, n.wikatakana = 12528, n.wikorean = 12639, n.wmonospace = 65367, n.wohiragana = 12434, n.wokatakana = 12530, n.wokatakanahalfwidth = 65382, n.won = 8361, n.wonmonospace = 65510, n.wowaenthai = 3623, n.wparen = 9394, n.wring = 7832, n.wsuperior = 695, n.wturned = 653, n.wynn = 447, n.x = 120, n.xabovecmb = 829, n.xbopomofo = 12562, n.xcircle = 9447, n.xdieresis = 7821, n.xdotaccent = 7819, n.xeharmenian = 1389, n.xi = 958, n.xmonospace = 65368, n.xparen = 9395, n.xsuperior = 739, n.y = 121, n.yaadosquare = 13134, n.yabengali = 2479, n.yacute = 253, n.yadeva = 2351, n.yaekorean = 12626, n.yagujarati = 2735, n.yagurmukhi = 2607, n.yahiragana = 12420, n.yakatakana = 12516, n.yakatakanahalfwidth = 65428, n.yakorean = 12625, n.yamakkanthai = 3662, n.yasmallhiragana = 12419, n.yasmallkatakana = 12515, n.yasmallkatakanahalfwidth = 65388, n.yatcyrillic = 1123, n.ycircle = 9448, n.ycircumflex = 375, n.ydieresis = 255, n.ydotaccent = 7823, n.ydotbelow = 7925, n.yeharabic = 1610, n.yehbarreearabic = 1746, n.yehbarreefinalarabic = 64431, n.yehfinalarabic = 65266, n.yehhamzaabovearabic = 1574, n.yehhamzaabovefinalarabic = 65162, n.yehhamzaaboveinitialarabic = 65163, n.yehhamzaabovemedialarabic = 65164, n.yehinitialarabic = 65267, n.yehmedialarabic = 65268, n.yehmeeminitialarabic = 64733, n.yehmeemisolatedarabic = 64600, n.yehnoonfinalarabic = 64660, n.yehthreedotsbelowarabic = 1745, n.yekorean = 12630, n.yen = 165, n.yenmonospace = 65509, n.yeokorean = 12629, n.yeorinhieuhkorean = 12678, n.yerahbenyomohebrew = 1450, n.yerahbenyomolefthebrew = 1450, n.yericyrillic = 1099, n.yerudieresiscyrillic = 1273, n.yesieungkorean = 12673, n.yesieungpansioskorean = 12675, n.yesieungsioskorean = 12674, n.yetivhebrew = 1434, n.ygrave = 7923, n.yhook = 436, n.yhookabove = 7927, n.yiarmenian = 1397, n.yicyrillic = 1111, n.yikorean = 12642, n.yinyang = 9775, n.yiwnarmenian = 1410, n.ymonospace = 65369, n.yod = 1497, n.yoddagesh = 64313, n.yoddageshhebrew = 64313, n.yodhebrew = 1497, n.yodyodhebrew = 1522, n.yodyodpatahhebrew = 64287, n.yohiragana = 12424, n.yoikorean = 12681, n.yokatakana = 12520, n.yokatakanahalfwidth = 65430, n.yokorean = 12635, n.yosmallhiragana = 12423, n.yosmallkatakana = 12519, n.yosmallkatakanahalfwidth = 65390, n.yotgreek = 1011, n.yoyaekorean = 12680, n.yoyakorean = 12679, n.yoyakthai = 3618, n.yoyingthai = 3597, n.yparen = 9396, n.ypogegrammeni = 890, n.ypogegrammenigreekcmb = 837, n.yr = 422, n.yring = 7833, n.ysuperior = 696, n.ytilde = 7929, n.yturned = 654, n.yuhiragana = 12422, n.yuikorean = 12684, n.yukatakana = 12518, n.yukatakanahalfwidth = 65429, n.yukorean = 12640, n.yusbigcyrillic = 1131, n.yusbigiotifiedcyrillic = 1133, n.yuslittlecyrillic = 1127, n.yuslittleiotifiedcyrillic = 1129, n.yusmallhiragana = 12421, n.yusmallkatakana = 12517, n.yusmallkatakanahalfwidth = 65389, n.yuyekorean = 12683, n.yuyeokorean = 12682, n.yyabengali = 2527, n.yyadeva = 2399, n.z = 122, n.zaarmenian = 1382, n.zacute = 378, n.zadeva = 2395, n.zagurmukhi = 2651, n.zaharabic = 1592, n.zahfinalarabic = 65222, n.zahinitialarabic = 65223, n.zahiragana = 12374, n.zahmedialarabic = 65224, n.zainarabic = 1586, n.zainfinalarabic = 65200, n.zakatakana = 12470, n.zaqefgadolhebrew = 1429, n.zaqefqatanhebrew = 1428, n.zarqahebrew = 1432, n.zayin = 1494, n.zayindagesh = 64310, n.zayindageshhebrew = 64310, n.zayinhebrew = 1494, n.zbopomofo = 12567, n.zcaron = 382, n.zcircle = 9449, n.zcircumflex = 7825, n.zcurl = 657, n.zdot = 380, n.zdotaccent = 380, n.zdotbelow = 7827, n.zecyrillic = 1079, n.zedescendercyrillic = 1177, n.zedieresiscyrillic = 1247, n.zehiragana = 12380, n.zekatakana = 12476, n.zero = 48, n.zeroarabic = 1632, n.zerobengali = 2534, n.zerodeva = 2406, n.zerogujarati = 2790, n.zerogurmukhi = 2662, n.zerohackarabic = 1632, n.zeroinferior = 8320, n.zeromonospace = 65296, n.zerooldstyle = 63280, n.zeropersian = 1776, n.zerosuperior = 8304, n.zerothai = 3664, n.zerowidthjoiner = 65279, n.zerowidthnonjoiner = 8204, n.zerowidthspace = 8203, n.zeta = 950, n.zhbopomofo = 12563, n.zhearmenian = 1386, n.zhebrevecyrillic = 1218, n.zhecyrillic = 1078, n.zhedescendercyrillic = 1175, n.zhedieresiscyrillic = 1245, n.zihiragana = 12376, n.zikatakana = 12472, n.zinorhebrew = 1454, n.zlinebelow = 7829, n.zmonospace = 65370, n.zohiragana = 12382, n.zokatakana = 12478, n.zparen = 9397, n.zretroflexhook = 656, n.zstroke = 438, n.zuhiragana = 12378, n.zukatakana = 12474, n[".notdef"] = 0, n.angbracketleftbig = 9001, n.angbracketleftBig = 9001, n.angbracketleftbigg = 9001, n.angbracketleftBigg = 9001, n.angbracketrightBig = 9002, n.angbracketrightbig = 9002, n.angbracketrightBigg = 9002, n.angbracketrightbigg = 9002, n.arrowhookleft = 8618, n.arrowhookright = 8617, n.arrowlefttophalf = 8636, n.arrowleftbothalf = 8637, n.arrownortheast = 8599, n.arrownorthwest = 8598, n.arrowrighttophalf = 8640, n.arrowrightbothalf = 8641, n.arrowsoutheast = 8600, n.arrowsouthwest = 8601, n.backslashbig = 8726, n.backslashBig = 8726, n.backslashBigg = 8726, n.backslashbigg = 8726, n.bardbl = 8214, n.bracehtipdownleft = 65079, n.bracehtipdownright = 65079, n.bracehtipupleft = 65080, n.bracehtipupright = 65080, n.braceleftBig = 123, n.braceleftbig = 123, n.braceleftbigg = 123, n.braceleftBigg = 123, n.bracerightBig = 125, n.bracerightbig = 125, n.bracerightbigg = 125, n.bracerightBigg = 125, n.bracketleftbig = 91, n.bracketleftBig = 91, n.bracketleftbigg = 91, n.bracketleftBigg = 91, n.bracketrightBig = 93, n.bracketrightbig = 93, n.bracketrightbigg = 93, n.bracketrightBigg = 93, n.ceilingleftbig = 8968, n.ceilingleftBig = 8968, n.ceilingleftBigg = 8968, n.ceilingleftbigg = 8968, n.ceilingrightbig = 8969, n.ceilingrightBig = 8969, n.ceilingrightbigg = 8969, n.ceilingrightBigg = 8969, n.circledotdisplay = 8857, n.circledottext = 8857, n.circlemultiplydisplay = 8855, n.circlemultiplytext = 8855, n.circleplusdisplay = 8853, n.circleplustext = 8853, n.contintegraldisplay = 8750, n.contintegraltext = 8750, n.coproductdisplay = 8720, n.coproducttext = 8720, n.floorleftBig = 8970, n.floorleftbig = 8970, n.floorleftbigg = 8970, n.floorleftBigg = 8970, n.floorrightbig = 8971, n.floorrightBig = 8971, n.floorrightBigg = 8971, n.floorrightbigg = 8971, n.hatwide = 770, n.hatwider = 770, n.hatwidest = 770, n.intercal = 7488, n.integraldisplay = 8747, n.integraltext = 8747, n.intersectiondisplay = 8898, n.intersectiontext = 8898, n.logicalanddisplay = 8743, n.logicalandtext = 8743, n.logicalordisplay = 8744, n.logicalortext = 8744, n.parenleftBig = 40, n.parenleftbig = 40, n.parenleftBigg = 40, n.parenleftbigg = 40, n.parenrightBig = 41, n.parenrightbig = 41, n.parenrightBigg = 41, n.parenrightbigg = 41, n.prime = 8242, n.productdisplay = 8719, n.producttext = 8719, n.radicalbig = 8730, n.radicalBig = 8730, n.radicalBigg = 8730, n.radicalbigg = 8730, n.radicalbt = 8730, n.radicaltp = 8730, n.radicalvertex = 8730, n.slashbig = 47, n.slashBig = 47, n.slashBigg = 47, n.slashbigg = 47, n.summationdisplay = 8721, n.summationtext = 8721, n.tildewide = 732, n.tildewider = 732, n.tildewidest = 732, n.uniondisplay = 8899, n.unionmultidisplay = 8846, n.unionmultitext = 8846, n.unionsqdisplay = 8852, n.unionsqtext = 8852, n.uniontext = 8899, n.vextenddouble = 8741, n.vextendsingle = 8739;
      });
      l.getGlyphsUnicode = g;
      const p = (0, o.getLookupTableFactory)(function(n) {
        n.space = 32, n.a1 = 9985, n.a2 = 9986, n.a202 = 9987, n.a3 = 9988, n.a4 = 9742, n.a5 = 9990, n.a119 = 9991, n.a118 = 9992, n.a117 = 9993, n.a11 = 9755, n.a12 = 9758, n.a13 = 9996, n.a14 = 9997, n.a15 = 9998, n.a16 = 9999, n.a105 = 1e4, n.a17 = 10001, n.a18 = 10002, n.a19 = 10003, n.a20 = 10004, n.a21 = 10005, n.a22 = 10006, n.a23 = 10007, n.a24 = 10008, n.a25 = 10009, n.a26 = 10010, n.a27 = 10011, n.a28 = 10012, n.a6 = 10013, n.a7 = 10014, n.a8 = 10015, n.a9 = 10016, n.a10 = 10017, n.a29 = 10018, n.a30 = 10019, n.a31 = 10020, n.a32 = 10021, n.a33 = 10022, n.a34 = 10023, n.a35 = 9733, n.a36 = 10025, n.a37 = 10026, n.a38 = 10027, n.a39 = 10028, n.a40 = 10029, n.a41 = 10030, n.a42 = 10031, n.a43 = 10032, n.a44 = 10033, n.a45 = 10034, n.a46 = 10035, n.a47 = 10036, n.a48 = 10037, n.a49 = 10038, n.a50 = 10039, n.a51 = 10040, n.a52 = 10041, n.a53 = 10042, n.a54 = 10043, n.a55 = 10044, n.a56 = 10045, n.a57 = 10046, n.a58 = 10047, n.a59 = 10048, n.a60 = 10049, n.a61 = 10050, n.a62 = 10051, n.a63 = 10052, n.a64 = 10053, n.a65 = 10054, n.a66 = 10055, n.a67 = 10056, n.a68 = 10057, n.a69 = 10058, n.a70 = 10059, n.a71 = 9679, n.a72 = 10061, n.a73 = 9632, n.a74 = 10063, n.a203 = 10064, n.a75 = 10065, n.a204 = 10066, n.a76 = 9650, n.a77 = 9660, n.a78 = 9670, n.a79 = 10070, n.a81 = 9687, n.a82 = 10072, n.a83 = 10073, n.a84 = 10074, n.a97 = 10075, n.a98 = 10076, n.a99 = 10077, n.a100 = 10078, n.a101 = 10081, n.a102 = 10082, n.a103 = 10083, n.a104 = 10084, n.a106 = 10085, n.a107 = 10086, n.a108 = 10087, n.a112 = 9827, n.a111 = 9830, n.a110 = 9829, n.a109 = 9824, n.a120 = 9312, n.a121 = 9313, n.a122 = 9314, n.a123 = 9315, n.a124 = 9316, n.a125 = 9317, n.a126 = 9318, n.a127 = 9319, n.a128 = 9320, n.a129 = 9321, n.a130 = 10102, n.a131 = 10103, n.a132 = 10104, n.a133 = 10105, n.a134 = 10106, n.a135 = 10107, n.a136 = 10108, n.a137 = 10109, n.a138 = 10110, n.a139 = 10111, n.a140 = 10112, n.a141 = 10113, n.a142 = 10114, n.a143 = 10115, n.a144 = 10116, n.a145 = 10117, n.a146 = 10118, n.a147 = 10119, n.a148 = 10120, n.a149 = 10121, n.a150 = 10122, n.a151 = 10123, n.a152 = 10124, n.a153 = 10125, n.a154 = 10126, n.a155 = 10127, n.a156 = 10128, n.a157 = 10129, n.a158 = 10130, n.a159 = 10131, n.a160 = 10132, n.a161 = 8594, n.a163 = 8596, n.a164 = 8597, n.a196 = 10136, n.a165 = 10137, n.a192 = 10138, n.a166 = 10139, n.a167 = 10140, n.a168 = 10141, n.a169 = 10142, n.a170 = 10143, n.a171 = 10144, n.a172 = 10145, n.a173 = 10146, n.a162 = 10147, n.a174 = 10148, n.a175 = 10149, n.a176 = 10150, n.a177 = 10151, n.a178 = 10152, n.a179 = 10153, n.a193 = 10154, n.a180 = 10155, n.a199 = 10156, n.a181 = 10157, n.a200 = 10158, n.a182 = 10159, n.a201 = 10161, n.a183 = 10162, n.a184 = 10163, n.a197 = 10164, n.a185 = 10165, n.a194 = 10166, n.a198 = 10167, n.a186 = 10168, n.a195 = 10169, n.a187 = 10170, n.a188 = 10171, n.a189 = 10172, n.a190 = 10173, n.a191 = 10174, n.a89 = 10088, n.a90 = 10089, n.a93 = 10090, n.a94 = 10091, n.a91 = 10092, n.a92 = 10093, n.a205 = 10094, n.a85 = 10095, n.a206 = 10096, n.a86 = 10097, n.a87 = 10098, n.a88 = 10099, n.a95 = 10100, n.a96 = 10101, n[".notdef"] = 0;
      });
      l.getDingbatsGlyphsUnicode = p;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.clearUnicodeCaches = function() {
        n.clear();
      }, l.getCharUnicodeCategory = function(d) {
        const m = n.get(d);
        if (m) return m;
        const b = d.match(p), w = { isWhitespace: !!(b != null && b[1]), isZeroWidthDiacritic: !!(b != null && b[2]), isInvisibleFormatMark: !!(b != null && b[3]) };
        return n.set(d, w), w;
      }, l.getUnicodeForGlyph = function(d, m) {
        let b = m[d];
        if (b !== void 0) return b;
        if (!d) return -1;
        if (d[0] === "u") {
          const w = d.length;
          let v;
          if (w === 7 && d[1] === "n" && d[2] === "i") v = d.substring(3);
          else {
            if (!(w >= 5 && w <= 7)) return -1;
            v = d.substring(1);
          }
          if (v === v.toUpperCase() && (b = parseInt(v, 16), b >= 0))
            return b;
        }
        return -1;
      }, l.getUnicodeRangeFor = function(d, m = -1) {
        if (m !== -1) {
          const b = g[m];
          for (let w = 0, v = b.length; w < v; w += 2) if (d >= b[w] && d <= b[w + 1]) return m;
        }
        for (let b = 0, w = g.length; b < w; b++) {
          const v = g[b];
          for (let h = 0, x = v.length; h < x; h += 2) if (d >= v[h] && d <= v[h + 1]) return b;
        }
        return -1;
      }, l.mapSpecialUnicodeValues = function(d) {
        return d >= 65520 && d <= 65535 ? 0 : d >= 62976 && d <= 63743 ? o()[d] || d : d === 173 ? 45 : d;
      };
      const o = (0, f(3).getLookupTableFactory)(function(a) {
        a[63721] = 169, a[63193] = 169, a[63720] = 174, a[63194] = 174, a[63722] = 8482, a[63195] = 8482, a[63729] = 9127, a[63730] = 9128, a[63731] = 9129, a[63740] = 9131, a[63741] = 9132, a[63742] = 9133, a[63726] = 9121, a[63727] = 9122, a[63728] = 9123, a[63737] = 9124, a[63738] = 9125, a[63739] = 9126, a[63723] = 9115, a[63724] = 9116, a[63725] = 9117, a[63734] = 9118, a[63735] = 9119, a[63736] = 9120;
      }), g = [[0, 127], [128, 255], [256, 383], [384, 591], [592, 687, 7424, 7551, 7552, 7615], [688, 767, 42752, 42783], [768, 879, 7616, 7679], [880, 1023], [11392, 11519], [1024, 1279, 1280, 1327, 11744, 11775, 42560, 42655], [1328, 1423], [1424, 1535], [42240, 42559], [1536, 1791, 1872, 1919], [1984, 2047], [2304, 2431], [2432, 2559], [2560, 2687], [2688, 2815], [2816, 2943], [2944, 3071], [3072, 3199], [3200, 3327], [3328, 3455], [3584, 3711], [3712, 3839], [4256, 4351, 11520, 11567], [6912, 7039], [4352, 4607], [7680, 7935, 11360, 11391, 42784, 43007], [7936, 8191], [8192, 8303, 11776, 11903], [8304, 8351], [8352, 8399], [8400, 8447], [8448, 8527], [8528, 8591], [8592, 8703, 10224, 10239, 10496, 10623, 11008, 11263], [8704, 8959, 10752, 11007, 10176, 10223, 10624, 10751], [8960, 9215], [9216, 9279], [9280, 9311], [9312, 9471], [9472, 9599], [9600, 9631], [9632, 9727], [9728, 9983], [9984, 10175], [12288, 12351], [12352, 12447], [12448, 12543, 12784, 12799], [12544, 12591, 12704, 12735], [12592, 12687], [43072, 43135], [12800, 13055], [13056, 13311], [44032, 55215], [55296, 57343], [67840, 67871], [19968, 40959, 11904, 12031, 12032, 12255, 12272, 12287, 13312, 19903, 131072, 173791, 12688, 12703], [57344, 63743], [12736, 12783, 63744, 64255, 194560, 195103], [64256, 64335], [64336, 65023], [65056, 65071], [65040, 65055], [65104, 65135], [65136, 65279], [65280, 65519], [65520, 65535], [3840, 4095], [1792, 1871], [1920, 1983], [3456, 3583], [4096, 4255], [4608, 4991, 4992, 5023, 11648, 11743], [5024, 5119], [5120, 5759], [5760, 5791], [5792, 5887], [6016, 6143], [6144, 6319], [10240, 10495], [40960, 42127], [5888, 5919, 5920, 5951, 5952, 5983, 5984, 6015], [66304, 66351], [66352, 66383], [66560, 66639], [118784, 119039, 119040, 119295, 119296, 119375], [119808, 120831], [1044480, 1048573], [65024, 65039, 917760, 917999], [917504, 917631], [6400, 6479], [6480, 6527], [6528, 6623], [6656, 6687], [11264, 11359], [11568, 11647], [19904, 19967], [43008, 43055], [65536, 65663, 65664, 65791, 65792, 65855], [65856, 65935], [66432, 66463], [66464, 66527], [66640, 66687], [66688, 66735], [67584, 67647], [68096, 68191], [119552, 119647], [73728, 74751, 74752, 74879], [119648, 119679], [7040, 7103], [7168, 7247], [7248, 7295], [43136, 43231], [43264, 43311], [43312, 43359], [43520, 43615], [65936, 65999], [66e3, 66047], [66208, 66271, 66176, 66207, 67872, 67903], [127024, 127135, 126976, 127023]], p = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"), n = /* @__PURE__ */ new Map();
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.getSerifFonts = l.getNonStdFontMap = l.getGlyphMapForStandardFonts = l.getFontNameToFileMap = void 0, l.getStandardFontName = function(x) {
        const _ = (0, g.normalizeFontName)(x);
        return p()[_];
      }, l.getSymbolsFonts = l.getSupplementalGlyphMapForCalibri = l.getSupplementalGlyphMapForArialBlack = l.getStdFontMap = void 0, l.isKnownFontName = function(x) {
        const _ = (0, g.normalizeFontName)(x);
        return !!(p()[_] || a()[_] || d()[_] || m()[_]);
      };
      var o = f(3), g = f(38);
      const p = (0, o.getLookupTableFactory)(function(h) {
        h["Times-Roman"] = "Times-Roman", h.Helvetica = "Helvetica", h.Courier = "Courier", h.Symbol = "Symbol", h["Times-Bold"] = "Times-Bold", h["Helvetica-Bold"] = "Helvetica-Bold", h["Courier-Bold"] = "Courier-Bold", h.ZapfDingbats = "ZapfDingbats", h["Times-Italic"] = "Times-Italic", h["Helvetica-Oblique"] = "Helvetica-Oblique", h["Courier-Oblique"] = "Courier-Oblique", h["Times-BoldItalic"] = "Times-BoldItalic", h["Helvetica-BoldOblique"] = "Helvetica-BoldOblique", h["Courier-BoldOblique"] = "Courier-BoldOblique", h.ArialNarrow = "Helvetica", h["ArialNarrow-Bold"] = "Helvetica-Bold", h["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique", h["ArialNarrow-Italic"] = "Helvetica-Oblique", h.ArialBlack = "Helvetica", h["ArialBlack-Bold"] = "Helvetica-Bold", h["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique", h["ArialBlack-Italic"] = "Helvetica-Oblique", h["Arial-Black"] = "Helvetica", h["Arial-Black-Bold"] = "Helvetica-Bold", h["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique", h["Arial-Black-Italic"] = "Helvetica-Oblique", h.Arial = "Helvetica", h["Arial-Bold"] = "Helvetica-Bold", h["Arial-BoldItalic"] = "Helvetica-BoldOblique", h["Arial-Italic"] = "Helvetica-Oblique", h.ArialMT = "Helvetica", h["Arial-BoldItalicMT"] = "Helvetica-BoldOblique", h["Arial-BoldMT"] = "Helvetica-Bold", h["Arial-ItalicMT"] = "Helvetica-Oblique", h["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique", h["Arial-BoldMT-Bold"] = "Helvetica-Bold", h["Arial-ItalicMT-Italic"] = "Helvetica-Oblique", h.ArialUnicodeMS = "Helvetica", h["ArialUnicodeMS-Bold"] = "Helvetica-Bold", h["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique", h["ArialUnicodeMS-Italic"] = "Helvetica-Oblique", h["Courier-BoldItalic"] = "Courier-BoldOblique", h["Courier-Italic"] = "Courier-Oblique", h.CourierNew = "Courier", h["CourierNew-Bold"] = "Courier-Bold", h["CourierNew-BoldItalic"] = "Courier-BoldOblique", h["CourierNew-Italic"] = "Courier-Oblique", h["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique", h["CourierNewPS-BoldMT"] = "Courier-Bold", h["CourierNewPS-ItalicMT"] = "Courier-Oblique", h.CourierNewPSMT = "Courier", h["Helvetica-BoldItalic"] = "Helvetica-BoldOblique", h["Helvetica-Italic"] = "Helvetica-Oblique", h["Symbol-Bold"] = "Symbol", h["Symbol-BoldItalic"] = "Symbol", h["Symbol-Italic"] = "Symbol", h.TimesNewRoman = "Times-Roman", h["TimesNewRoman-Bold"] = "Times-Bold", h["TimesNewRoman-BoldItalic"] = "Times-BoldItalic", h["TimesNewRoman-Italic"] = "Times-Italic", h.TimesNewRomanPS = "Times-Roman", h["TimesNewRomanPS-Bold"] = "Times-Bold", h["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic", h["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic", h["TimesNewRomanPS-BoldMT"] = "Times-Bold", h["TimesNewRomanPS-Italic"] = "Times-Italic", h["TimesNewRomanPS-ItalicMT"] = "Times-Italic", h.TimesNewRomanPSMT = "Times-Roman", h["TimesNewRomanPSMT-Bold"] = "Times-Bold", h["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic", h["TimesNewRomanPSMT-Italic"] = "Times-Italic";
      });
      l.getStdFontMap = p;
      const n = (0, o.getLookupTableFactory)(function(h) {
        h.Courier = "FoxitFixed.pfb", h["Courier-Bold"] = "FoxitFixedBold.pfb", h["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb", h["Courier-Oblique"] = "FoxitFixedItalic.pfb", h.Helvetica = "LiberationSans-Regular.ttf", h["Helvetica-Bold"] = "LiberationSans-Bold.ttf", h["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf", h["Helvetica-Oblique"] = "LiberationSans-Italic.ttf", h["Times-Roman"] = "FoxitSerif.pfb", h["Times-Bold"] = "FoxitSerifBold.pfb", h["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb", h["Times-Italic"] = "FoxitSerifItalic.pfb", h.Symbol = "FoxitSymbol.pfb", h.ZapfDingbats = "FoxitDingbats.pfb", h["LiberationSans-Regular"] = "LiberationSans-Regular.ttf", h["LiberationSans-Bold"] = "LiberationSans-Bold.ttf", h["LiberationSans-Italic"] = "LiberationSans-Italic.ttf", h["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
      });
      l.getFontNameToFileMap = n;
      const a = (0, o.getLookupTableFactory)(function(h) {
        h.Calibri = "Helvetica", h["Calibri-Bold"] = "Helvetica-Bold", h["Calibri-BoldItalic"] = "Helvetica-BoldOblique", h["Calibri-Italic"] = "Helvetica-Oblique", h.CenturyGothic = "Helvetica", h["CenturyGothic-Bold"] = "Helvetica-Bold", h["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique", h["CenturyGothic-Italic"] = "Helvetica-Oblique", h.ComicSansMS = "Comic Sans MS", h["ComicSansMS-Bold"] = "Comic Sans MS-Bold", h["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic", h["ComicSansMS-Italic"] = "Comic Sans MS-Italic", h.Impact = "Helvetica", h["ItcSymbol-Bold"] = "Helvetica-Bold", h["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique", h["ItcSymbol-Book"] = "Helvetica", h["ItcSymbol-BookItalic"] = "Helvetica-Oblique", h["ItcSymbol-Medium"] = "Helvetica", h["ItcSymbol-MediumItalic"] = "Helvetica-Oblique", h.LucidaConsole = "Courier", h["LucidaConsole-Bold"] = "Courier-Bold", h["LucidaConsole-BoldItalic"] = "Courier-BoldOblique", h["LucidaConsole-Italic"] = "Courier-Oblique", h["LucidaSans-Demi"] = "Helvetica-Bold", h["MS-Gothic"] = "MS Gothic", h["MS-Gothic-Bold"] = "MS Gothic-Bold", h["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic", h["MS-Gothic-Italic"] = "MS Gothic-Italic", h["MS-Mincho"] = "MS Mincho", h["MS-Mincho-Bold"] = "MS Mincho-Bold", h["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic", h["MS-Mincho-Italic"] = "MS Mincho-Italic", h["MS-PGothic"] = "MS PGothic", h["MS-PGothic-Bold"] = "MS PGothic-Bold", h["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic", h["MS-PGothic-Italic"] = "MS PGothic-Italic", h["MS-PMincho"] = "MS PMincho", h["MS-PMincho-Bold"] = "MS PMincho-Bold", h["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic", h["MS-PMincho-Italic"] = "MS PMincho-Italic", h.NuptialScript = "Times-Italic", h.SegoeUISymbol = "Helvetica";
      });
      l.getNonStdFontMap = a;
      const d = (0, o.getLookupTableFactory)(function(h) {
        h["Adobe Jenson"] = !0, h["Adobe Text"] = !0, h.Albertus = !0, h.Aldus = !0, h.Alexandria = !0, h.Algerian = !0, h["American Typewriter"] = !0, h.Antiqua = !0, h.Apex = !0, h.Arno = !0, h.Aster = !0, h.Aurora = !0, h.Baskerville = !0, h.Bell = !0, h.Bembo = !0, h["Bembo Schoolbook"] = !0, h.Benguiat = !0, h["Berkeley Old Style"] = !0, h["Bernhard Modern"] = !0, h["Berthold City"] = !0, h.Bodoni = !0, h["Bauer Bodoni"] = !0, h["Book Antiqua"] = !0, h.Bookman = !0, h["Bordeaux Roman"] = !0, h["Californian FB"] = !0, h.Calisto = !0, h.Calvert = !0, h.Capitals = !0, h.Cambria = !0, h.Cartier = !0, h.Caslon = !0, h.Catull = !0, h.Centaur = !0, h["Century Old Style"] = !0, h["Century Schoolbook"] = !0, h.Chaparral = !0, h["Charis SIL"] = !0, h.Cheltenham = !0, h["Cholla Slab"] = !0, h.Clarendon = !0, h.Clearface = !0, h.Cochin = !0, h.Colonna = !0, h["Computer Modern"] = !0, h["Concrete Roman"] = !0, h.Constantia = !0, h["Cooper Black"] = !0, h.Corona = !0, h.Ecotype = !0, h.Egyptienne = !0, h.Elephant = !0, h.Excelsior = !0, h.Fairfield = !0, h["FF Scala"] = !0, h.Folkard = !0, h.Footlight = !0, h.FreeSerif = !0, h["Friz Quadrata"] = !0, h.Garamond = !0, h.Gentium = !0, h.Georgia = !0, h.Gloucester = !0, h["Goudy Old Style"] = !0, h["Goudy Schoolbook"] = !0, h["Goudy Pro Font"] = !0, h.Granjon = !0, h["Guardian Egyptian"] = !0, h.Heather = !0, h.Hercules = !0, h["High Tower Text"] = !0, h.Hiroshige = !0, h["Hoefler Text"] = !0, h["Humana Serif"] = !0, h.Imprint = !0, h["Ionic No. 5"] = !0, h.Janson = !0, h.Joanna = !0, h.Korinna = !0, h.Lexicon = !0, h.LiberationSerif = !0, h["Liberation Serif"] = !0, h["Linux Libertine"] = !0, h.Literaturnaya = !0, h.Lucida = !0, h["Lucida Bright"] = !0, h.Melior = !0, h.Memphis = !0, h.Miller = !0, h.Minion = !0, h.Modern = !0, h["Mona Lisa"] = !0, h["Mrs Eaves"] = !0, h["MS Serif"] = !0, h["Museo Slab"] = !0, h["New York"] = !0, h["Nimbus Roman"] = !0, h["NPS Rawlinson Roadway"] = !0, h.NuptialScript = !0, h.Palatino = !0, h.Perpetua = !0, h.Plantin = !0, h["Plantin Schoolbook"] = !0, h.Playbill = !0, h["Poor Richard"] = !0, h["Rawlinson Roadway"] = !0, h.Renault = !0, h.Requiem = !0, h.Rockwell = !0, h.Roman = !0, h["Rotis Serif"] = !0, h.Sabon = !0, h.Scala = !0, h.Seagull = !0, h.Sistina = !0, h.Souvenir = !0, h.STIX = !0, h["Stone Informal"] = !0, h["Stone Serif"] = !0, h.Sylfaen = !0, h.Times = !0, h.Trajan = !0, h.Trinité = !0, h["Trump Mediaeval"] = !0, h.Utopia = !0, h["Vale Type"] = !0, h["Bitstream Vera"] = !0, h["Vera Serif"] = !0, h.Versailles = !0, h.Wanted = !0, h.Weiss = !0, h["Wide Latin"] = !0, h.Windsor = !0, h.XITS = !0;
      });
      l.getSerifFonts = d;
      const m = (0, o.getLookupTableFactory)(function(h) {
        h.Dingbats = !0, h.Symbol = !0, h.ZapfDingbats = !0, h.Wingdings = !0, h["Wingdings-Bold"] = !0, h["Wingdings-Regular"] = !0;
      });
      l.getSymbolsFonts = m;
      const b = (0, o.getLookupTableFactory)(function(h) {
        h[2] = 10, h[3] = 32, h[4] = 33, h[5] = 34, h[6] = 35, h[7] = 36, h[8] = 37, h[9] = 38, h[10] = 39, h[11] = 40, h[12] = 41, h[13] = 42, h[14] = 43, h[15] = 44, h[16] = 45, h[17] = 46, h[18] = 47, h[19] = 48, h[20] = 49, h[21] = 50, h[22] = 51, h[23] = 52, h[24] = 53, h[25] = 54, h[26] = 55, h[27] = 56, h[28] = 57, h[29] = 58, h[30] = 894, h[31] = 60, h[32] = 61, h[33] = 62, h[34] = 63, h[35] = 64, h[36] = 65, h[37] = 66, h[38] = 67, h[39] = 68, h[40] = 69, h[41] = 70, h[42] = 71, h[43] = 72, h[44] = 73, h[45] = 74, h[46] = 75, h[47] = 76, h[48] = 77, h[49] = 78, h[50] = 79, h[51] = 80, h[52] = 81, h[53] = 82, h[54] = 83, h[55] = 84, h[56] = 85, h[57] = 86, h[58] = 87, h[59] = 88, h[60] = 89, h[61] = 90, h[62] = 91, h[63] = 92, h[64] = 93, h[65] = 94, h[66] = 95, h[67] = 96, h[68] = 97, h[69] = 98, h[70] = 99, h[71] = 100, h[72] = 101, h[73] = 102, h[74] = 103, h[75] = 104, h[76] = 105, h[77] = 106, h[78] = 107, h[79] = 108, h[80] = 109, h[81] = 110, h[82] = 111, h[83] = 112, h[84] = 113, h[85] = 114, h[86] = 115, h[87] = 116, h[88] = 117, h[89] = 118, h[90] = 119, h[91] = 120, h[92] = 121, h[93] = 122, h[94] = 123, h[95] = 124, h[96] = 125, h[97] = 126, h[98] = 196, h[99] = 197, h[100] = 199, h[101] = 201, h[102] = 209, h[103] = 214, h[104] = 220, h[105] = 225, h[106] = 224, h[107] = 226, h[108] = 228, h[109] = 227, h[110] = 229, h[111] = 231, h[112] = 233, h[113] = 232, h[114] = 234, h[115] = 235, h[116] = 237, h[117] = 236, h[118] = 238, h[119] = 239, h[120] = 241, h[121] = 243, h[122] = 242, h[123] = 244, h[124] = 246, h[125] = 245, h[126] = 250, h[127] = 249, h[128] = 251, h[129] = 252, h[130] = 8224, h[131] = 176, h[132] = 162, h[133] = 163, h[134] = 167, h[135] = 8226, h[136] = 182, h[137] = 223, h[138] = 174, h[139] = 169, h[140] = 8482, h[141] = 180, h[142] = 168, h[143] = 8800, h[144] = 198, h[145] = 216, h[146] = 8734, h[147] = 177, h[148] = 8804, h[149] = 8805, h[150] = 165, h[151] = 181, h[152] = 8706, h[153] = 8721, h[154] = 8719, h[156] = 8747, h[157] = 170, h[158] = 186, h[159] = 8486, h[160] = 230, h[161] = 248, h[162] = 191, h[163] = 161, h[164] = 172, h[165] = 8730, h[166] = 402, h[167] = 8776, h[168] = 8710, h[169] = 171, h[170] = 187, h[171] = 8230, h[179] = 8220, h[180] = 8221, h[181] = 8216, h[182] = 8217, h[200] = 193, h[203] = 205, h[207] = 211, h[210] = 218, h[223] = 711, h[224] = 321, h[225] = 322, h[226] = 352, h[227] = 353, h[228] = 381, h[229] = 382, h[233] = 221, h[234] = 253, h[252] = 263, h[253] = 268, h[254] = 269, h[258] = 258, h[260] = 260, h[261] = 261, h[265] = 280, h[266] = 281, h[267] = 282, h[268] = 283, h[269] = 313, h[275] = 323, h[276] = 324, h[278] = 328, h[283] = 344, h[284] = 345, h[285] = 346, h[286] = 347, h[292] = 367, h[295] = 377, h[296] = 378, h[298] = 380, h[305] = 963, h[306] = 964, h[307] = 966, h[308] = 8215, h[309] = 8252, h[310] = 8319, h[311] = 8359, h[312] = 8592, h[313] = 8593, h[337] = 9552, h[493] = 1039, h[494] = 1040, h[672] = 1488, h[673] = 1489, h[674] = 1490, h[675] = 1491, h[676] = 1492, h[677] = 1493, h[678] = 1494, h[679] = 1495, h[680] = 1496, h[681] = 1497, h[682] = 1498, h[683] = 1499, h[684] = 1500, h[685] = 1501, h[686] = 1502, h[687] = 1503, h[688] = 1504, h[689] = 1505, h[690] = 1506, h[691] = 1507, h[692] = 1508, h[693] = 1509, h[694] = 1510, h[695] = 1511, h[696] = 1512, h[697] = 1513, h[698] = 1514, h[705] = 1524, h[706] = 8362, h[710] = 64288, h[711] = 64298, h[759] = 1617, h[761] = 1776, h[763] = 1778, h[775] = 1652, h[777] = 1764, h[778] = 1780, h[779] = 1781, h[780] = 1782, h[782] = 771, h[783] = 64726, h[786] = 8363, h[788] = 8532, h[790] = 768, h[791] = 769, h[792] = 768, h[795] = 803, h[797] = 64336, h[798] = 64337, h[799] = 64342, h[800] = 64343, h[801] = 64344, h[802] = 64345, h[803] = 64362, h[804] = 64363, h[805] = 64364, h[2424] = 7821, h[2425] = 7822, h[2426] = 7823, h[2427] = 7824, h[2428] = 7825, h[2429] = 7826, h[2430] = 7827, h[2433] = 7682, h[2678] = 8045, h[2679] = 8046, h[2830] = 1552, h[2838] = 686, h[2840] = 751, h[2842] = 753, h[2843] = 754, h[2844] = 755, h[2846] = 757, h[2856] = 767, h[2857] = 848, h[2858] = 849, h[2862] = 853, h[2863] = 854, h[2864] = 855, h[2865] = 861, h[2866] = 862, h[2906] = 7460, h[2908] = 7462, h[2909] = 7463, h[2910] = 7464, h[2912] = 7466, h[2913] = 7467, h[2914] = 7468, h[2916] = 7470, h[2917] = 7471, h[2918] = 7472, h[2920] = 7474, h[2921] = 7475, h[2922] = 7476, h[2924] = 7478, h[2925] = 7479, h[2926] = 7480, h[2928] = 7482, h[2929] = 7483, h[2930] = 7484, h[2932] = 7486, h[2933] = 7487, h[2934] = 7488, h[2936] = 7490, h[2937] = 7491, h[2938] = 7492, h[2940] = 7494, h[2941] = 7495, h[2942] = 7496, h[2944] = 7498, h[2946] = 7500, h[2948] = 7502, h[2950] = 7504, h[2951] = 7505, h[2952] = 7506, h[2954] = 7508, h[2955] = 7509, h[2956] = 7510, h[2958] = 7512, h[2959] = 7513, h[2960] = 7514, h[2962] = 7516, h[2963] = 7517, h[2964] = 7518, h[2966] = 7520, h[2967] = 7521, h[2968] = 7522, h[2970] = 7524, h[2971] = 7525, h[2972] = 7526, h[2974] = 7528, h[2975] = 7529, h[2976] = 7530, h[2978] = 1537, h[2979] = 1538, h[2980] = 1539, h[2982] = 1549, h[2983] = 1551, h[2984] = 1552, h[2986] = 1554, h[2987] = 1555, h[2988] = 1556, h[2990] = 1623, h[2991] = 1624, h[2995] = 1775, h[2999] = 1791, h[3002] = 64290, h[3003] = 64291, h[3004] = 64292, h[3006] = 64294, h[3007] = 64295, h[3008] = 64296, h[3011] = 1900, h[3014] = 8223, h[3015] = 8244, h[3017] = 7532, h[3018] = 7533, h[3019] = 7534, h[3075] = 7590, h[3076] = 7591, h[3079] = 7594, h[3080] = 7595, h[3083] = 7598, h[3084] = 7599, h[3087] = 7602, h[3088] = 7603, h[3091] = 7606, h[3092] = 7607, h[3095] = 7610, h[3096] = 7611, h[3099] = 7614, h[3100] = 7615, h[3103] = 7618, h[3104] = 7619, h[3107] = 8337, h[3108] = 8338, h[3116] = 1884, h[3119] = 1885, h[3120] = 1885, h[3123] = 1886, h[3124] = 1886, h[3127] = 1887, h[3128] = 1887, h[3131] = 1888, h[3132] = 1888, h[3135] = 1889, h[3136] = 1889, h[3139] = 1890, h[3140] = 1890, h[3143] = 1891, h[3144] = 1891, h[3147] = 1892, h[3148] = 1892, h[3153] = 580, h[3154] = 581, h[3157] = 584, h[3158] = 585, h[3161] = 588, h[3162] = 589, h[3165] = 891, h[3166] = 892, h[3169] = 1274, h[3170] = 1275, h[3173] = 1278, h[3174] = 1279, h[3181] = 7622, h[3182] = 7623, h[3282] = 11799, h[3316] = 578, h[3379] = 42785, h[3393] = 1159, h[3416] = 8377;
      });
      l.getGlyphMapForStandardFonts = b;
      const w = (0, o.getLookupTableFactory)(function(h) {
        h[227] = 322, h[264] = 261, h[291] = 346;
      });
      l.getSupplementalGlyphMapForArialBlack = w;
      const v = (0, o.getLookupTableFactory)(function(h) {
        h[1] = 32, h[4] = 65, h[5] = 192, h[6] = 193, h[9] = 196, h[17] = 66, h[18] = 67, h[21] = 268, h[24] = 68, h[28] = 69, h[29] = 200, h[30] = 201, h[32] = 282, h[38] = 70, h[39] = 71, h[44] = 72, h[47] = 73, h[48] = 204, h[49] = 205, h[58] = 74, h[60] = 75, h[62] = 76, h[68] = 77, h[69] = 78, h[75] = 79, h[76] = 210, h[80] = 214, h[87] = 80, h[89] = 81, h[90] = 82, h[92] = 344, h[94] = 83, h[97] = 352, h[100] = 84, h[104] = 85, h[109] = 220, h[115] = 86, h[116] = 87, h[121] = 88, h[122] = 89, h[124] = 221, h[127] = 90, h[129] = 381, h[258] = 97, h[259] = 224, h[260] = 225, h[263] = 228, h[268] = 261, h[271] = 98, h[272] = 99, h[273] = 263, h[275] = 269, h[282] = 100, h[286] = 101, h[287] = 232, h[288] = 233, h[290] = 283, h[295] = 281, h[296] = 102, h[336] = 103, h[346] = 104, h[349] = 105, h[350] = 236, h[351] = 237, h[361] = 106, h[364] = 107, h[367] = 108, h[371] = 322, h[373] = 109, h[374] = 110, h[381] = 111, h[382] = 242, h[383] = 243, h[386] = 246, h[393] = 112, h[395] = 113, h[396] = 114, h[398] = 345, h[400] = 115, h[401] = 347, h[403] = 353, h[410] = 116, h[437] = 117, h[442] = 252, h[448] = 118, h[449] = 119, h[454] = 120, h[455] = 121, h[457] = 253, h[460] = 122, h[462] = 382, h[463] = 380, h[853] = 44, h[855] = 58, h[856] = 46, h[876] = 47, h[878] = 45, h[882] = 45, h[894] = 40, h[895] = 41, h[896] = 91, h[897] = 93, h[923] = 64, h[1004] = 48, h[1005] = 49, h[1006] = 50, h[1007] = 51, h[1008] = 52, h[1009] = 53, h[1010] = 54, h[1011] = 55, h[1012] = 56, h[1013] = 57, h[1081] = 37, h[1085] = 43, h[1086] = 45;
      });
      l.getSupplementalGlyphMapForCalibri = v;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ToUnicodeMap = l.IdentityToUnicodeMap = void 0;
      var o = f(2);
      l.ToUnicodeMap = class {
        constructor(p = []) {
          this._map = p;
        }
        get length() {
          return this._map.length;
        }
        forEach(p) {
          for (const n in this._map) p(n, this._map[n].charCodeAt(0));
        }
        has(p) {
          return this._map[p] !== void 0;
        }
        get(p) {
          return this._map[p];
        }
        charCodeOf(p) {
          const n = this._map;
          if (n.length <= 65536) return n.indexOf(p);
          for (const a in n) if (n[a] === p) return 0 | a;
          return -1;
        }
        amend(p) {
          for (const n in p) this._map[n] = p[n];
        }
      }, l.IdentityToUnicodeMap = class {
        constructor(p, n) {
          this.firstChar = p, this.lastChar = n;
        }
        get length() {
          return this.lastChar + 1 - this.firstChar;
        }
        forEach(p) {
          for (let n = this.firstChar, a = this.lastChar; n <= a; n++) p(n, n);
        }
        has(p) {
          return this.firstChar <= p && p <= this.lastChar;
        }
        get(p) {
          if (this.firstChar <= p && p <= this.lastChar) return String.fromCharCode(p);
        }
        charCodeOf(p) {
          return Number.isInteger(p) && p >= this.firstChar && p <= this.lastChar ? p : -1;
        }
        amend(p) {
          (0, o.unreachable)("Should not call amend()");
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CFFFont = void 0;
      var o = f(35), g = f(38), p = f(2);
      l.CFFFont = class {
        constructor(a, d) {
          this.properties = d;
          const m = new o.CFFParser(a, d, g.SEAC_ANALYSIS_ENABLED);
          this.cff = m.parse(), this.cff.duplicateFirstGlyph();
          const b = new o.CFFCompiler(this.cff);
          this.seacs = this.cff.seacs;
          try {
            this.data = b.compile();
          } catch {
            (0, p.warn)("Failed to compile font " + d.loadedName), this.data = a;
          }
          this._createBuiltInEncoding();
        }
        get numGlyphs() {
          return this.cff.charStrings.count;
        }
        getCharset() {
          return this.cff.charset.charset;
        }
        getGlyphMapping() {
          const a = this.cff, d = this.properties, { cidToGidMap: m, cMap: b } = d, w = a.charset.charset;
          let v, h;
          if (d.composite) {
            let _, M;
            if ((m == null ? void 0 : m.length) > 0) {
              _ = /* @__PURE__ */ Object.create(null);
              for (let O = 0, E = m.length; O < E; O++) {
                const I = m[O];
                I !== void 0 && (_[I] = O);
              }
            }
            if (v = /* @__PURE__ */ Object.create(null), a.isCIDFont) for (h = 0; h < w.length; h++) {
              const O = w[h];
              M = b.charCodeOf(O), (_ == null ? void 0 : _[M]) !== void 0 && (M = _[M]), v[M] = h;
            }
            else for (h = 0; h < a.charStrings.count; h++)
              M = b.charCodeOf(h), v[M] = h;
            return v;
          }
          let x = a.encoding ? a.encoding.encoding : null;
          return d.isInternalFont && (x = d.defaultEncoding), v = (0, g.type1FontGlyphMapping)(d, x, w), v;
        }
        hasGlyphId(a) {
          return this.cff.hasGlyphId(a);
        }
        _createBuiltInEncoding() {
          const { charset: a, encoding: d } = this.cff;
          if (!a || !d) return;
          const m = a.charset, b = d.encoding, w = [];
          for (const v in b) {
            const h = b[v];
            if (h >= 0) {
              const x = m[h];
              x && (w[v] = x);
            }
          }
          w.length > 0 && (this.properties.builtInEncoding = w);
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.FontRendererFactory = void 0;
      var o = f(2), g = f(35), p = f(39), n = f(37), a = f(8);
      function d(j, $) {
        return (j[$] << 24 | j[$ + 1] << 16 | j[$ + 2] << 8 | j[$ + 3]) >>> 0;
      }
      function m(j, $) {
        return j[$] << 8 | j[$ + 1];
      }
      function b(j, $) {
        return (j[$] << 24 | j[$ + 1] << 16) >> 16;
      }
      function w(j, $) {
        return j[$] << 24 >> 24;
      }
      function v(j, $) {
        return b(j, $) / 16384;
      }
      function h(j) {
        const $ = j.length;
        let B = 32768;
        return $ < 1240 ? B = 107 : $ < 33900 && (B = 1131), B;
      }
      function x(j, $, B) {
        const C = m(j, $ + 2) === 1 ? d(j, $ + 8) : d(j, $ + 16), T = m(j, $ + C);
        let F, S, A;
        if (T === 4) {
          m(j, $ + C + 2);
          const U = m(j, $ + C + 6) >> 1;
          for (S = $ + C + 14, F = [], A = 0; A < U; A++, S += 2) F[A] = { end: m(j, S) };
          for (S += 2, A = 0; A < U; A++, S += 2) F[A].start = m(j, S);
          for (A = 0; A < U; A++, S += 2) F[A].idDelta = m(j, S);
          for (A = 0; A < U; A++, S += 2) {
            let K = m(j, S);
            if (K !== 0) {
              F[A].ids = [];
              for (let X = 0, L = F[A].end - F[A].start + 1; X < L; X++)
                F[A].ids[X] = m(j, S + K), K += 2;
            }
          }
          return F;
        }
        if (T === 12) {
          const U = d(j, $ + C + 12);
          for (S = $ + C + 16, F = [], A = 0; A < U; A++)
            $ = d(j, S), F.push({ start: $, end: d(j, S + 4), idDelta: d(j, S + 8) - $ }), S += 12;
          return F;
        }
        throw new o.FormatError(`unsupported cmap: ${T}`);
      }
      function _(j, $, B, C) {
        var F, S, A;
        const T = new g.CFFParser(new a.Stream(j, $, B - $), {}, C).parse();
        return { glyphs: T.charStrings.objects, subrs: (S = (F = T.topDict.privateDict) == null ? void 0 : F.subrsIndex) == null ? void 0 : S.objects, gsubrs: (A = T.globalSubrIndex) == null ? void 0 : A.objects, isCFFCIDFont: T.isCIDFont, fdSelect: T.fdSelect, fdArray: T.fdArray };
      }
      function M(j, $) {
        const B = $.codePointAt(0);
        let C = 0, T = 0, F = j.length - 1;
        for (; T < F; ) {
          const S = T + F + 1 >> 1;
          B < j[S].start ? F = S - 1 : T = S;
        }
        return j[T].start <= B && B <= j[T].end && (C = j[T].idDelta + (j[T].ids ? j[T].ids[B - j[T].start] : B) & 65535), { charCode: B, glyphId: C };
      }
      function O(j, $, B) {
        function C(L, H) {
          $.push({ cmd: "moveTo", args: [L, H] });
        }
        function T(L, H) {
          $.push({ cmd: "lineTo", args: [L, H] });
        }
        function F(L, H, Q, N) {
          $.push({ cmd: "quadraticCurveTo", args: [L, H, Q, N] });
        }
        let S = 0;
        const A = b(j, S);
        let U, K = 0, X = 0;
        if (S += 10, A < 0) do {
          U = m(j, S);
          const L = m(j, S + 2);
          S += 4;
          let H, Q;
          1 & U ? (2 & U ? (H = b(j, S), Q = b(j, S + 2)) : (H = m(j, S), Q = m(j, S + 2)), S += 4) : 2 & U ? (H = w(j, S++), Q = w(j, S++)) : (H = j[S++], Q = j[S++]), 2 & U ? (K = H, X = Q) : (K = 0, X = 0);
          let N = 1, V = 1, Y = 0, Z = 0;
          8 & U ? (N = V = v(j, S), S += 2) : 64 & U ? (N = v(j, S), V = v(j, S + 2), S += 4) : 128 & U && (N = v(j, S), Y = v(j, S + 2), Z = v(j, S + 4), V = v(j, S + 6), S += 8);
          const rt = B.glyphs[L];
          rt && ($.push({ cmd: "save" }, { cmd: "transform", args: [N, Y, Z, V, K, X] }), O(rt, $, B), $.push({ cmd: "restore" }));
        } while (32 & U);
        else {
          const L = [];
          let H, Q;
          for (H = 0; H < A; H++)
            L.push(m(j, S)), S += 2;
          S += 2 + m(j, S);
          const N = L.at(-1) + 1, V = [];
          for (; V.length < N; ) {
            U = j[S++];
            let Z = 1;
            for (8 & U && (Z += j[S++]); Z-- > 0; ) V.push({ flags: U });
          }
          for (H = 0; H < N; H++) {
            switch (18 & V[H].flags) {
              case 0:
                K += b(j, S), S += 2;
                break;
              case 2:
                K -= j[S++];
                break;
              case 18:
                K += j[S++];
            }
            V[H].x = K;
          }
          for (H = 0; H < N; H++) {
            switch (36 & V[H].flags) {
              case 0:
                X += b(j, S), S += 2;
                break;
              case 4:
                X -= j[S++];
                break;
              case 36:
                X += j[S++];
            }
            V[H].y = X;
          }
          let Y = 0;
          for (S = 0; S < A; S++) {
            const Z = L[S], rt = V.slice(Y, Z + 1);
            if (1 & rt[0].flags) rt.push(rt[0]);
            else if (1 & rt.at(-1).flags) rt.unshift(rt.at(-1));
            else {
              const st = { flags: 1, x: (rt[0].x + rt.at(-1).x) / 2, y: (rt[0].y + rt.at(-1).y) / 2 };
              rt.unshift(st), rt.push(st);
            }
            for (C(rt[0].x, rt[0].y), H = 1, Q = rt.length; H < Q; H++) 1 & rt[H].flags ? T(rt[H].x, rt[H].y) : 1 & rt[H + 1].flags ? (F(rt[H].x, rt[H].y, rt[H + 1].x, rt[H + 1].y), H++) : F(rt[H].x, rt[H].y, (rt[H].x + rt[H + 1].x) / 2, (rt[H].y + rt[H + 1].y) / 2);
            Y = Z + 1;
          }
        }
      }
      function E(j, $, B, C) {
        function T(L, H) {
          $.push({ cmd: "moveTo", args: [L, H] });
        }
        function F(L, H) {
          $.push({ cmd: "lineTo", args: [L, H] });
        }
        function S(L, H, Q, N, V, Y) {
          $.push({ cmd: "bezierCurveTo", args: [L, H, Q, N, V, Y] });
        }
        const A = [];
        let U = 0, K = 0, X = 0;
        (function L(H) {
          var N;
          let Q = 0;
          for (; Q < H.length; ) {
            let V, Y, Z, rt, st, mt, yt, at, nt, q = !1, D = H[Q++];
            switch (D) {
              case 1:
              case 3:
              case 18:
              case 23:
                X += A.length >> 1, q = !0;
                break;
              case 4:
                K += A.pop(), T(U, K), q = !0;
                break;
              case 5:
                for (; A.length > 0; )
                  U += A.shift(), K += A.shift(), F(U, K);
                break;
              case 6:
                for (; A.length > 0 && (U += A.shift(), F(U, K), A.length !== 0); )
                  K += A.shift(), F(U, K);
                break;
              case 7:
                for (; A.length > 0 && (K += A.shift(), F(U, K), A.length !== 0); )
                  U += A.shift(), F(U, K);
                break;
              case 8:
                for (; A.length > 0; )
                  V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + A.shift(), S(V, Z, Y, rt, U, K);
                break;
              case 10:
                if (at = A.pop(), nt = null, B.isCFFCIDFont) {
                  const G = B.fdSelect.getFDIndex(C);
                  if (G >= 0 && G < B.fdArray.length) {
                    const et = B.fdArray[G];
                    let J;
                    (N = et.privateDict) != null && N.subrsIndex && (J = et.privateDict.subrsIndex.objects), J && (at += h(J), nt = J[at]);
                  } else (0, o.warn)("Invalid fd index for glyph index.");
                } else nt = B.subrs[at + B.subrsBias];
                nt && L(nt);
                break;
              case 11:
                return;
              case 12:
                switch (D = H[Q++], D) {
                  case 34:
                    V = U + A.shift(), Y = V + A.shift(), st = K + A.shift(), U = Y + A.shift(), S(V, K, Y, st, U, st), V = U + A.shift(), Y = V + A.shift(), U = Y + A.shift(), S(V, st, Y, K, U, K);
                    break;
                  case 35:
                    V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + A.shift(), S(V, Z, Y, rt, U, K), V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + A.shift(), S(V, Z, Y, rt, U, K), A.pop();
                    break;
                  case 36:
                    V = U + A.shift(), st = K + A.shift(), Y = V + A.shift(), mt = st + A.shift(), U = Y + A.shift(), S(V, st, Y, mt, U, mt), V = U + A.shift(), Y = V + A.shift(), yt = mt + A.shift(), U = Y + A.shift(), S(V, mt, Y, yt, U, K);
                    break;
                  case 37:
                    const G = U, et = K;
                    V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + A.shift(), S(V, Z, Y, rt, U, K), V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y, K = rt, Math.abs(U - G) > Math.abs(K - et) ? U += A.shift() : K += A.shift(), S(V, Z, Y, rt, U, K);
                    break;
                  default:
                    throw new o.FormatError(`unknown operator: 12 ${D}`);
                }
                break;
              case 14:
                if (A.length >= 4) {
                  const G = A.pop(), et = A.pop();
                  K = A.pop(), U = A.pop(), $.push({ cmd: "save" }, { cmd: "translate", args: [U, K] });
                  let J = M(B.cmap, String.fromCharCode(B.glyphNameMap[n.StandardEncoding[G]]));
                  E(B.glyphs[J.glyphId], $, B, J.glyphId), $.push({ cmd: "restore" }), J = M(B.cmap, String.fromCharCode(B.glyphNameMap[n.StandardEncoding[et]])), E(B.glyphs[J.glyphId], $, B, J.glyphId);
                }
                return;
              case 19:
              case 20:
                X += A.length >> 1, Q += X + 7 >> 3, q = !0;
                break;
              case 21:
                K += A.pop(), U += A.pop(), T(U, K), q = !0;
                break;
              case 22:
                U += A.pop(), T(U, K), q = !0;
                break;
              case 24:
                for (; A.length > 2; )
                  V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + A.shift(), S(V, Z, Y, rt, U, K);
                U += A.shift(), K += A.shift(), F(U, K);
                break;
              case 25:
                for (; A.length > 6; )
                  U += A.shift(), K += A.shift(), F(U, K);
                V = U + A.shift(), Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + A.shift(), S(V, Z, Y, rt, U, K);
                break;
              case 26:
                for (A.length % 2 && (U += A.shift()); A.length > 0; )
                  V = U, Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y, K = rt + A.shift(), S(V, Z, Y, rt, U, K);
                break;
              case 27:
                for (A.length % 2 && (K += A.shift()); A.length > 0; )
                  V = U + A.shift(), Z = K, Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt, S(V, Z, Y, rt, U, K);
                break;
              case 28:
                A.push((H[Q] << 24 | H[Q + 1] << 16) >> 16), Q += 2;
                break;
              case 29:
                at = A.pop() + B.gsubrsBias, nt = B.gsubrs[at], nt && L(nt);
                break;
              case 30:
                for (; A.length > 0 && (V = U, Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + (A.length === 1 ? A.shift() : 0), S(V, Z, Y, rt, U, K), A.length !== 0); )
                  V = U + A.shift(), Z = K, Y = V + A.shift(), rt = Z + A.shift(), K = rt + A.shift(), U = Y + (A.length === 1 ? A.shift() : 0), S(V, Z, Y, rt, U, K);
                break;
              case 31:
                for (; A.length > 0 && (V = U + A.shift(), Z = K, Y = V + A.shift(), rt = Z + A.shift(), K = rt + A.shift(), U = Y + (A.length === 1 ? A.shift() : 0), S(V, Z, Y, rt, U, K), A.length !== 0); )
                  V = U, Z = K + A.shift(), Y = V + A.shift(), rt = Z + A.shift(), U = Y + A.shift(), K = rt + (A.length === 1 ? A.shift() : 0), S(V, Z, Y, rt, U, K);
                break;
              default:
                if (D < 32) throw new o.FormatError(`unknown operator: ${D}`);
                D < 247 ? A.push(D - 139) : D < 251 ? A.push(256 * (D - 247) + H[Q++] + 108) : D < 255 ? A.push(256 * -(D - 251) - H[Q++] - 108) : (A.push((H[Q] << 24 | H[Q + 1] << 16 | H[Q + 2] << 8 | H[Q + 3]) / 65536), Q += 4);
            }
            q && (A.length = 0);
          }
        })(j);
      }
      const I = [];
      class R {
        constructor($) {
          this.constructor === R && (0, o.unreachable)("Cannot initialize CompiledFont."), this.fontMatrix = $, this.compiledGlyphs = /* @__PURE__ */ Object.create(null), this.compiledCharCodeToGlyphId = /* @__PURE__ */ Object.create(null);
        }
        getPathJs($) {
          const { charCode: B, glyphId: C } = M(this.cmap, $);
          let T = this.compiledGlyphs[C];
          if (!T) try {
            T = this.compileGlyph(this.glyphs[C], C), this.compiledGlyphs[C] = T;
          } catch (F) {
            throw this.compiledGlyphs[C] = I, this.compiledCharCodeToGlyphId[B] === void 0 && (this.compiledCharCodeToGlyphId[B] = C), F;
          }
          return this.compiledCharCodeToGlyphId[B] === void 0 && (this.compiledCharCodeToGlyphId[B] = C), T;
        }
        compileGlyph($, B) {
          if (!$ || $.length === 0 || $[0] === 14) return I;
          let C = this.fontMatrix;
          if (this.isCFFCIDFont) {
            const F = this.fdSelect.getFDIndex(B);
            F >= 0 && F < this.fdArray.length ? C = this.fdArray[F].getByName("FontMatrix") || o.FONT_IDENTITY_MATRIX : (0, o.warn)("Invalid fd index for glyph index.");
          }
          const T = [{ cmd: "save" }, { cmd: "transform", args: C.slice() }, { cmd: "scale", args: ["size", "-size"] }];
          return this.compileGlyphImpl($, T, B), T.push({ cmd: "restore" }), T;
        }
        compileGlyphImpl() {
          (0, o.unreachable)("Children classes should implement this.");
        }
        hasBuiltPath($) {
          const { charCode: B, glyphId: C } = M(this.cmap, $);
          return this.compiledGlyphs[C] !== void 0 && this.compiledCharCodeToGlyphId[B] !== void 0;
        }
      }
      class W extends R {
        constructor($, B, C) {
          super(C || [488e-6, 0, 0, 488e-6, 0, 0]), this.glyphs = $, this.cmap = B;
        }
        compileGlyphImpl($, B) {
          O($, B, this);
        }
      }
      class z extends R {
        constructor($, B, C, T) {
          super(C || [1e-3, 0, 0, 1e-3, 0, 0]), this.glyphs = $.glyphs, this.gsubrs = $.gsubrs || [], this.subrs = $.subrs || [], this.cmap = B, this.glyphNameMap = T || (0, p.getGlyphsUnicode)(), this.gsubrsBias = h(this.gsubrs), this.subrsBias = h(this.subrs), this.isCFFCIDFont = $.isCFFCIDFont, this.fdSelect = $.fdSelect, this.fdArray = $.fdArray;
        }
        compileGlyphImpl($, B, C) {
          E($, B, this, C);
        }
      }
      l.FontRendererFactory = class {
        static create($, B) {
          const C = new Uint8Array($.data);
          let T, F, S, A, U, K;
          const X = m(C, 4);
          for (let L = 0, H = 12; L < X; L++, H += 16) {
            const Q = (0, o.bytesToString)(C.subarray(H, H + 4)), N = d(C, H + 8), V = d(C, H + 12);
            switch (Q) {
              case "cmap":
                T = x(C, N);
                break;
              case "glyf":
                F = C.subarray(N, N + V);
                break;
              case "loca":
                S = C.subarray(N, N + V);
                break;
              case "head":
                K = m(C, N + 18), U = m(C, N + 50);
                break;
              case "CFF ":
                A = _(C, N, N + V, B);
            }
          }
          if (F) {
            const L = K ? [1 / K, 0, 0, 1 / K, 0, 0] : $.fontMatrix;
            return new W(function(Q, N, V) {
              let Y, Z;
              V ? (Y = 4, Z = d) : (Y = 2, Z = (mt, yt) => 2 * m(mt, yt));
              const rt = [];
              let st = Z(N, 0);
              for (let mt = Y; mt < N.length; mt += Y) {
                const yt = Z(N, mt);
                rt.push(Q.subarray(st, yt)), st = yt;
              }
              return rt;
            }(F, S, U), T, L);
          }
          return new z(A, T, $.fontMatrix, $.glyphNameMap);
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.getMetrics = l.getFontBasicMetrics = void 0;
      var o = f(3);
      const g = (0, o.getLookupTableFactory)(function(n) {
        n.Courier = 600, n["Courier-Bold"] = 600, n["Courier-BoldOblique"] = 600, n["Courier-Oblique"] = 600, n.Helvetica = (0, o.getLookupTableFactory)(function(a) {
          a.space = 278, a.exclam = 278, a.quotedbl = 355, a.numbersign = 556, a.dollar = 556, a.percent = 889, a.ampersand = 667, a.quoteright = 222, a.parenleft = 333, a.parenright = 333, a.asterisk = 389, a.plus = 584, a.comma = 278, a.hyphen = 333, a.period = 278, a.slash = 278, a.zero = 556, a.one = 556, a.two = 556, a.three = 556, a.four = 556, a.five = 556, a.six = 556, a.seven = 556, a.eight = 556, a.nine = 556, a.colon = 278, a.semicolon = 278, a.less = 584, a.equal = 584, a.greater = 584, a.question = 556, a.at = 1015, a.A = 667, a.B = 667, a.C = 722, a.D = 722, a.E = 667, a.F = 611, a.G = 778, a.H = 722, a.I = 278, a.J = 500, a.K = 667, a.L = 556, a.M = 833, a.N = 722, a.O = 778, a.P = 667, a.Q = 778, a.R = 722, a.S = 667, a.T = 611, a.U = 722, a.V = 667, a.W = 944, a.X = 667, a.Y = 667, a.Z = 611, a.bracketleft = 278, a.backslash = 278, a.bracketright = 278, a.asciicircum = 469, a.underscore = 556, a.quoteleft = 222, a.a = 556, a.b = 556, a.c = 500, a.d = 556, a.e = 556, a.f = 278, a.g = 556, a.h = 556, a.i = 222, a.j = 222, a.k = 500, a.l = 222, a.m = 833, a.n = 556, a.o = 556, a.p = 556, a.q = 556, a.r = 333, a.s = 500, a.t = 278, a.u = 556, a.v = 500, a.w = 722, a.x = 500, a.y = 500, a.z = 500, a.braceleft = 334, a.bar = 260, a.braceright = 334, a.asciitilde = 584, a.exclamdown = 333, a.cent = 556, a.sterling = 556, a.fraction = 167, a.yen = 556, a.florin = 556, a.section = 556, a.currency = 556, a.quotesingle = 191, a.quotedblleft = 333, a.guillemotleft = 556, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 500, a.fl = 500, a.endash = 556, a.dagger = 556, a.daggerdbl = 556, a.periodcentered = 278, a.paragraph = 537, a.bullet = 350, a.quotesinglbase = 222, a.quotedblbase = 333, a.quotedblright = 333, a.guillemotright = 556, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 611, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 1e3, a.ordfeminine = 370, a.Lslash = 556, a.Oslash = 778, a.OE = 1e3, a.ordmasculine = 365, a.ae = 889, a.dotlessi = 278, a.lslash = 222, a.oslash = 611, a.oe = 944, a.germandbls = 611, a.Idieresis = 278, a.eacute = 556, a.abreve = 556, a.uhungarumlaut = 556, a.ecaron = 556, a.Ydieresis = 667, a.divide = 584, a.Yacute = 667, a.Acircumflex = 667, a.aacute = 556, a.Ucircumflex = 722, a.yacute = 500, a.scommaaccent = 500, a.ecircumflex = 556, a.Uring = 722, a.Udieresis = 722, a.aogonek = 556, a.Uacute = 722, a.uogonek = 556, a.Edieresis = 667, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 737, a.Emacron = 667, a.ccaron = 500, a.aring = 556, a.Ncommaaccent = 722, a.lacute = 222, a.agrave = 556, a.Tcommaaccent = 611, a.Cacute = 722, a.atilde = 556, a.Edotaccent = 667, a.scaron = 500, a.scedilla = 500, a.iacute = 278, a.lozenge = 471, a.Rcaron = 722, a.Gcommaaccent = 778, a.ucircumflex = 556, a.acircumflex = 556, a.Amacron = 667, a.rcaron = 333, a.ccedilla = 500, a.Zdotaccent = 611, a.Thorn = 667, a.Omacron = 778, a.Racute = 722, a.Sacute = 667, a.dcaron = 643, a.Umacron = 722, a.uring = 556, a.threesuperior = 333, a.Ograve = 778, a.Agrave = 667, a.Abreve = 667, a.multiply = 584, a.uacute = 556, a.Tcaron = 611, a.partialdiff = 476, a.ydieresis = 500, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 667, a.adieresis = 556, a.edieresis = 556, a.cacute = 500, a.nacute = 556, a.umacron = 556, a.Ncaron = 722, a.Iacute = 278, a.plusminus = 584, a.brokenbar = 260, a.registered = 737, a.Gbreve = 778, a.Idotaccent = 278, a.summation = 600, a.Egrave = 667, a.racute = 333, a.omacron = 556, a.Zacute = 611, a.Zcaron = 611, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 722, a.lcommaaccent = 222, a.tcaron = 317, a.eogonek = 556, a.Uogonek = 722, a.Aacute = 667, a.Adieresis = 667, a.egrave = 556, a.zacute = 500, a.iogonek = 222, a.Oacute = 778, a.oacute = 556, a.amacron = 556, a.sacute = 500, a.idieresis = 278, a.Ocircumflex = 778, a.Ugrave = 722, a.Delta = 612, a.thorn = 556, a.twosuperior = 333, a.Odieresis = 778, a.mu = 556, a.igrave = 278, a.ohungarumlaut = 556, a.Eogonek = 667, a.dcroat = 556, a.threequarters = 834, a.Scedilla = 667, a.lcaron = 299, a.Kcommaaccent = 667, a.Lacute = 556, a.trademark = 1e3, a.edotaccent = 556, a.Igrave = 278, a.Imacron = 278, a.Lcaron = 556, a.onehalf = 834, a.lessequal = 549, a.ocircumflex = 556, a.ntilde = 556, a.Uhungarumlaut = 722, a.Eacute = 667, a.emacron = 556, a.gbreve = 556, a.onequarter = 834, a.Scaron = 667, a.Scommaaccent = 667, a.Ohungarumlaut = 778, a.degree = 400, a.ograve = 556, a.Ccaron = 722, a.ugrave = 556, a.radical = 453, a.Dcaron = 722, a.rcommaaccent = 333, a.Ntilde = 722, a.otilde = 556, a.Rcommaaccent = 722, a.Lcommaaccent = 556, a.Atilde = 667, a.Aogonek = 667, a.Aring = 667, a.Otilde = 778, a.zdotaccent = 500, a.Ecaron = 667, a.Iogonek = 278, a.kcommaaccent = 500, a.minus = 584, a.Icircumflex = 278, a.ncaron = 556, a.tcommaaccent = 278, a.logicalnot = 584, a.odieresis = 556, a.udieresis = 556, a.notequal = 549, a.gcommaaccent = 556, a.eth = 556, a.zcaron = 500, a.ncommaaccent = 556, a.onesuperior = 333, a.imacron = 278, a.Euro = 556;
        }), n["Helvetica-Bold"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 278, a.exclam = 333, a.quotedbl = 474, a.numbersign = 556, a.dollar = 556, a.percent = 889, a.ampersand = 722, a.quoteright = 278, a.parenleft = 333, a.parenright = 333, a.asterisk = 389, a.plus = 584, a.comma = 278, a.hyphen = 333, a.period = 278, a.slash = 278, a.zero = 556, a.one = 556, a.two = 556, a.three = 556, a.four = 556, a.five = 556, a.six = 556, a.seven = 556, a.eight = 556, a.nine = 556, a.colon = 333, a.semicolon = 333, a.less = 584, a.equal = 584, a.greater = 584, a.question = 611, a.at = 975, a.A = 722, a.B = 722, a.C = 722, a.D = 722, a.E = 667, a.F = 611, a.G = 778, a.H = 722, a.I = 278, a.J = 556, a.K = 722, a.L = 611, a.M = 833, a.N = 722, a.O = 778, a.P = 667, a.Q = 778, a.R = 722, a.S = 667, a.T = 611, a.U = 722, a.V = 667, a.W = 944, a.X = 667, a.Y = 667, a.Z = 611, a.bracketleft = 333, a.backslash = 278, a.bracketright = 333, a.asciicircum = 584, a.underscore = 556, a.quoteleft = 278, a.a = 556, a.b = 611, a.c = 556, a.d = 611, a.e = 556, a.f = 333, a.g = 611, a.h = 611, a.i = 278, a.j = 278, a.k = 556, a.l = 278, a.m = 889, a.n = 611, a.o = 611, a.p = 611, a.q = 611, a.r = 389, a.s = 556, a.t = 333, a.u = 611, a.v = 556, a.w = 778, a.x = 556, a.y = 556, a.z = 500, a.braceleft = 389, a.bar = 280, a.braceright = 389, a.asciitilde = 584, a.exclamdown = 333, a.cent = 556, a.sterling = 556, a.fraction = 167, a.yen = 556, a.florin = 556, a.section = 556, a.currency = 556, a.quotesingle = 238, a.quotedblleft = 500, a.guillemotleft = 556, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 611, a.fl = 611, a.endash = 556, a.dagger = 556, a.daggerdbl = 556, a.periodcentered = 278, a.paragraph = 556, a.bullet = 350, a.quotesinglbase = 278, a.quotedblbase = 500, a.quotedblright = 500, a.guillemotright = 556, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 611, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 1e3, a.ordfeminine = 370, a.Lslash = 611, a.Oslash = 778, a.OE = 1e3, a.ordmasculine = 365, a.ae = 889, a.dotlessi = 278, a.lslash = 278, a.oslash = 611, a.oe = 944, a.germandbls = 611, a.Idieresis = 278, a.eacute = 556, a.abreve = 556, a.uhungarumlaut = 611, a.ecaron = 556, a.Ydieresis = 667, a.divide = 584, a.Yacute = 667, a.Acircumflex = 722, a.aacute = 556, a.Ucircumflex = 722, a.yacute = 556, a.scommaaccent = 556, a.ecircumflex = 556, a.Uring = 722, a.Udieresis = 722, a.aogonek = 556, a.Uacute = 722, a.uogonek = 611, a.Edieresis = 667, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 737, a.Emacron = 667, a.ccaron = 556, a.aring = 556, a.Ncommaaccent = 722, a.lacute = 278, a.agrave = 556, a.Tcommaaccent = 611, a.Cacute = 722, a.atilde = 556, a.Edotaccent = 667, a.scaron = 556, a.scedilla = 556, a.iacute = 278, a.lozenge = 494, a.Rcaron = 722, a.Gcommaaccent = 778, a.ucircumflex = 611, a.acircumflex = 556, a.Amacron = 722, a.rcaron = 389, a.ccedilla = 556, a.Zdotaccent = 611, a.Thorn = 667, a.Omacron = 778, a.Racute = 722, a.Sacute = 667, a.dcaron = 743, a.Umacron = 722, a.uring = 611, a.threesuperior = 333, a.Ograve = 778, a.Agrave = 722, a.Abreve = 722, a.multiply = 584, a.uacute = 611, a.Tcaron = 611, a.partialdiff = 494, a.ydieresis = 556, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 667, a.adieresis = 556, a.edieresis = 556, a.cacute = 556, a.nacute = 611, a.umacron = 611, a.Ncaron = 722, a.Iacute = 278, a.plusminus = 584, a.brokenbar = 280, a.registered = 737, a.Gbreve = 778, a.Idotaccent = 278, a.summation = 600, a.Egrave = 667, a.racute = 389, a.omacron = 611, a.Zacute = 611, a.Zcaron = 611, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 722, a.lcommaaccent = 278, a.tcaron = 389, a.eogonek = 556, a.Uogonek = 722, a.Aacute = 722, a.Adieresis = 722, a.egrave = 556, a.zacute = 500, a.iogonek = 278, a.Oacute = 778, a.oacute = 611, a.amacron = 556, a.sacute = 556, a.idieresis = 278, a.Ocircumflex = 778, a.Ugrave = 722, a.Delta = 612, a.thorn = 611, a.twosuperior = 333, a.Odieresis = 778, a.mu = 611, a.igrave = 278, a.ohungarumlaut = 611, a.Eogonek = 667, a.dcroat = 611, a.threequarters = 834, a.Scedilla = 667, a.lcaron = 400, a.Kcommaaccent = 722, a.Lacute = 611, a.trademark = 1e3, a.edotaccent = 556, a.Igrave = 278, a.Imacron = 278, a.Lcaron = 611, a.onehalf = 834, a.lessequal = 549, a.ocircumflex = 611, a.ntilde = 611, a.Uhungarumlaut = 722, a.Eacute = 667, a.emacron = 556, a.gbreve = 611, a.onequarter = 834, a.Scaron = 667, a.Scommaaccent = 667, a.Ohungarumlaut = 778, a.degree = 400, a.ograve = 611, a.Ccaron = 722, a.ugrave = 611, a.radical = 549, a.Dcaron = 722, a.rcommaaccent = 389, a.Ntilde = 722, a.otilde = 611, a.Rcommaaccent = 722, a.Lcommaaccent = 611, a.Atilde = 722, a.Aogonek = 722, a.Aring = 722, a.Otilde = 778, a.zdotaccent = 500, a.Ecaron = 667, a.Iogonek = 278, a.kcommaaccent = 556, a.minus = 584, a.Icircumflex = 278, a.ncaron = 611, a.tcommaaccent = 333, a.logicalnot = 584, a.odieresis = 611, a.udieresis = 611, a.notequal = 549, a.gcommaaccent = 611, a.eth = 611, a.zcaron = 500, a.ncommaaccent = 611, a.onesuperior = 333, a.imacron = 278, a.Euro = 556;
        }), n["Helvetica-BoldOblique"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 278, a.exclam = 333, a.quotedbl = 474, a.numbersign = 556, a.dollar = 556, a.percent = 889, a.ampersand = 722, a.quoteright = 278, a.parenleft = 333, a.parenright = 333, a.asterisk = 389, a.plus = 584, a.comma = 278, a.hyphen = 333, a.period = 278, a.slash = 278, a.zero = 556, a.one = 556, a.two = 556, a.three = 556, a.four = 556, a.five = 556, a.six = 556, a.seven = 556, a.eight = 556, a.nine = 556, a.colon = 333, a.semicolon = 333, a.less = 584, a.equal = 584, a.greater = 584, a.question = 611, a.at = 975, a.A = 722, a.B = 722, a.C = 722, a.D = 722, a.E = 667, a.F = 611, a.G = 778, a.H = 722, a.I = 278, a.J = 556, a.K = 722, a.L = 611, a.M = 833, a.N = 722, a.O = 778, a.P = 667, a.Q = 778, a.R = 722, a.S = 667, a.T = 611, a.U = 722, a.V = 667, a.W = 944, a.X = 667, a.Y = 667, a.Z = 611, a.bracketleft = 333, a.backslash = 278, a.bracketright = 333, a.asciicircum = 584, a.underscore = 556, a.quoteleft = 278, a.a = 556, a.b = 611, a.c = 556, a.d = 611, a.e = 556, a.f = 333, a.g = 611, a.h = 611, a.i = 278, a.j = 278, a.k = 556, a.l = 278, a.m = 889, a.n = 611, a.o = 611, a.p = 611, a.q = 611, a.r = 389, a.s = 556, a.t = 333, a.u = 611, a.v = 556, a.w = 778, a.x = 556, a.y = 556, a.z = 500, a.braceleft = 389, a.bar = 280, a.braceright = 389, a.asciitilde = 584, a.exclamdown = 333, a.cent = 556, a.sterling = 556, a.fraction = 167, a.yen = 556, a.florin = 556, a.section = 556, a.currency = 556, a.quotesingle = 238, a.quotedblleft = 500, a.guillemotleft = 556, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 611, a.fl = 611, a.endash = 556, a.dagger = 556, a.daggerdbl = 556, a.periodcentered = 278, a.paragraph = 556, a.bullet = 350, a.quotesinglbase = 278, a.quotedblbase = 500, a.quotedblright = 500, a.guillemotright = 556, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 611, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 1e3, a.ordfeminine = 370, a.Lslash = 611, a.Oslash = 778, a.OE = 1e3, a.ordmasculine = 365, a.ae = 889, a.dotlessi = 278, a.lslash = 278, a.oslash = 611, a.oe = 944, a.germandbls = 611, a.Idieresis = 278, a.eacute = 556, a.abreve = 556, a.uhungarumlaut = 611, a.ecaron = 556, a.Ydieresis = 667, a.divide = 584, a.Yacute = 667, a.Acircumflex = 722, a.aacute = 556, a.Ucircumflex = 722, a.yacute = 556, a.scommaaccent = 556, a.ecircumflex = 556, a.Uring = 722, a.Udieresis = 722, a.aogonek = 556, a.Uacute = 722, a.uogonek = 611, a.Edieresis = 667, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 737, a.Emacron = 667, a.ccaron = 556, a.aring = 556, a.Ncommaaccent = 722, a.lacute = 278, a.agrave = 556, a.Tcommaaccent = 611, a.Cacute = 722, a.atilde = 556, a.Edotaccent = 667, a.scaron = 556, a.scedilla = 556, a.iacute = 278, a.lozenge = 494, a.Rcaron = 722, a.Gcommaaccent = 778, a.ucircumflex = 611, a.acircumflex = 556, a.Amacron = 722, a.rcaron = 389, a.ccedilla = 556, a.Zdotaccent = 611, a.Thorn = 667, a.Omacron = 778, a.Racute = 722, a.Sacute = 667, a.dcaron = 743, a.Umacron = 722, a.uring = 611, a.threesuperior = 333, a.Ograve = 778, a.Agrave = 722, a.Abreve = 722, a.multiply = 584, a.uacute = 611, a.Tcaron = 611, a.partialdiff = 494, a.ydieresis = 556, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 667, a.adieresis = 556, a.edieresis = 556, a.cacute = 556, a.nacute = 611, a.umacron = 611, a.Ncaron = 722, a.Iacute = 278, a.plusminus = 584, a.brokenbar = 280, a.registered = 737, a.Gbreve = 778, a.Idotaccent = 278, a.summation = 600, a.Egrave = 667, a.racute = 389, a.omacron = 611, a.Zacute = 611, a.Zcaron = 611, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 722, a.lcommaaccent = 278, a.tcaron = 389, a.eogonek = 556, a.Uogonek = 722, a.Aacute = 722, a.Adieresis = 722, a.egrave = 556, a.zacute = 500, a.iogonek = 278, a.Oacute = 778, a.oacute = 611, a.amacron = 556, a.sacute = 556, a.idieresis = 278, a.Ocircumflex = 778, a.Ugrave = 722, a.Delta = 612, a.thorn = 611, a.twosuperior = 333, a.Odieresis = 778, a.mu = 611, a.igrave = 278, a.ohungarumlaut = 611, a.Eogonek = 667, a.dcroat = 611, a.threequarters = 834, a.Scedilla = 667, a.lcaron = 400, a.Kcommaaccent = 722, a.Lacute = 611, a.trademark = 1e3, a.edotaccent = 556, a.Igrave = 278, a.Imacron = 278, a.Lcaron = 611, a.onehalf = 834, a.lessequal = 549, a.ocircumflex = 611, a.ntilde = 611, a.Uhungarumlaut = 722, a.Eacute = 667, a.emacron = 556, a.gbreve = 611, a.onequarter = 834, a.Scaron = 667, a.Scommaaccent = 667, a.Ohungarumlaut = 778, a.degree = 400, a.ograve = 611, a.Ccaron = 722, a.ugrave = 611, a.radical = 549, a.Dcaron = 722, a.rcommaaccent = 389, a.Ntilde = 722, a.otilde = 611, a.Rcommaaccent = 722, a.Lcommaaccent = 611, a.Atilde = 722, a.Aogonek = 722, a.Aring = 722, a.Otilde = 778, a.zdotaccent = 500, a.Ecaron = 667, a.Iogonek = 278, a.kcommaaccent = 556, a.minus = 584, a.Icircumflex = 278, a.ncaron = 611, a.tcommaaccent = 333, a.logicalnot = 584, a.odieresis = 611, a.udieresis = 611, a.notequal = 549, a.gcommaaccent = 611, a.eth = 611, a.zcaron = 500, a.ncommaaccent = 611, a.onesuperior = 333, a.imacron = 278, a.Euro = 556;
        }), n["Helvetica-Oblique"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 278, a.exclam = 278, a.quotedbl = 355, a.numbersign = 556, a.dollar = 556, a.percent = 889, a.ampersand = 667, a.quoteright = 222, a.parenleft = 333, a.parenright = 333, a.asterisk = 389, a.plus = 584, a.comma = 278, a.hyphen = 333, a.period = 278, a.slash = 278, a.zero = 556, a.one = 556, a.two = 556, a.three = 556, a.four = 556, a.five = 556, a.six = 556, a.seven = 556, a.eight = 556, a.nine = 556, a.colon = 278, a.semicolon = 278, a.less = 584, a.equal = 584, a.greater = 584, a.question = 556, a.at = 1015, a.A = 667, a.B = 667, a.C = 722, a.D = 722, a.E = 667, a.F = 611, a.G = 778, a.H = 722, a.I = 278, a.J = 500, a.K = 667, a.L = 556, a.M = 833, a.N = 722, a.O = 778, a.P = 667, a.Q = 778, a.R = 722, a.S = 667, a.T = 611, a.U = 722, a.V = 667, a.W = 944, a.X = 667, a.Y = 667, a.Z = 611, a.bracketleft = 278, a.backslash = 278, a.bracketright = 278, a.asciicircum = 469, a.underscore = 556, a.quoteleft = 222, a.a = 556, a.b = 556, a.c = 500, a.d = 556, a.e = 556, a.f = 278, a.g = 556, a.h = 556, a.i = 222, a.j = 222, a.k = 500, a.l = 222, a.m = 833, a.n = 556, a.o = 556, a.p = 556, a.q = 556, a.r = 333, a.s = 500, a.t = 278, a.u = 556, a.v = 500, a.w = 722, a.x = 500, a.y = 500, a.z = 500, a.braceleft = 334, a.bar = 260, a.braceright = 334, a.asciitilde = 584, a.exclamdown = 333, a.cent = 556, a.sterling = 556, a.fraction = 167, a.yen = 556, a.florin = 556, a.section = 556, a.currency = 556, a.quotesingle = 191, a.quotedblleft = 333, a.guillemotleft = 556, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 500, a.fl = 500, a.endash = 556, a.dagger = 556, a.daggerdbl = 556, a.periodcentered = 278, a.paragraph = 537, a.bullet = 350, a.quotesinglbase = 222, a.quotedblbase = 333, a.quotedblright = 333, a.guillemotright = 556, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 611, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 1e3, a.ordfeminine = 370, a.Lslash = 556, a.Oslash = 778, a.OE = 1e3, a.ordmasculine = 365, a.ae = 889, a.dotlessi = 278, a.lslash = 222, a.oslash = 611, a.oe = 944, a.germandbls = 611, a.Idieresis = 278, a.eacute = 556, a.abreve = 556, a.uhungarumlaut = 556, a.ecaron = 556, a.Ydieresis = 667, a.divide = 584, a.Yacute = 667, a.Acircumflex = 667, a.aacute = 556, a.Ucircumflex = 722, a.yacute = 500, a.scommaaccent = 500, a.ecircumflex = 556, a.Uring = 722, a.Udieresis = 722, a.aogonek = 556, a.Uacute = 722, a.uogonek = 556, a.Edieresis = 667, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 737, a.Emacron = 667, a.ccaron = 500, a.aring = 556, a.Ncommaaccent = 722, a.lacute = 222, a.agrave = 556, a.Tcommaaccent = 611, a.Cacute = 722, a.atilde = 556, a.Edotaccent = 667, a.scaron = 500, a.scedilla = 500, a.iacute = 278, a.lozenge = 471, a.Rcaron = 722, a.Gcommaaccent = 778, a.ucircumflex = 556, a.acircumflex = 556, a.Amacron = 667, a.rcaron = 333, a.ccedilla = 500, a.Zdotaccent = 611, a.Thorn = 667, a.Omacron = 778, a.Racute = 722, a.Sacute = 667, a.dcaron = 643, a.Umacron = 722, a.uring = 556, a.threesuperior = 333, a.Ograve = 778, a.Agrave = 667, a.Abreve = 667, a.multiply = 584, a.uacute = 556, a.Tcaron = 611, a.partialdiff = 476, a.ydieresis = 500, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 667, a.adieresis = 556, a.edieresis = 556, a.cacute = 500, a.nacute = 556, a.umacron = 556, a.Ncaron = 722, a.Iacute = 278, a.plusminus = 584, a.brokenbar = 260, a.registered = 737, a.Gbreve = 778, a.Idotaccent = 278, a.summation = 600, a.Egrave = 667, a.racute = 333, a.omacron = 556, a.Zacute = 611, a.Zcaron = 611, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 722, a.lcommaaccent = 222, a.tcaron = 317, a.eogonek = 556, a.Uogonek = 722, a.Aacute = 667, a.Adieresis = 667, a.egrave = 556, a.zacute = 500, a.iogonek = 222, a.Oacute = 778, a.oacute = 556, a.amacron = 556, a.sacute = 500, a.idieresis = 278, a.Ocircumflex = 778, a.Ugrave = 722, a.Delta = 612, a.thorn = 556, a.twosuperior = 333, a.Odieresis = 778, a.mu = 556, a.igrave = 278, a.ohungarumlaut = 556, a.Eogonek = 667, a.dcroat = 556, a.threequarters = 834, a.Scedilla = 667, a.lcaron = 299, a.Kcommaaccent = 667, a.Lacute = 556, a.trademark = 1e3, a.edotaccent = 556, a.Igrave = 278, a.Imacron = 278, a.Lcaron = 556, a.onehalf = 834, a.lessequal = 549, a.ocircumflex = 556, a.ntilde = 556, a.Uhungarumlaut = 722, a.Eacute = 667, a.emacron = 556, a.gbreve = 556, a.onequarter = 834, a.Scaron = 667, a.Scommaaccent = 667, a.Ohungarumlaut = 778, a.degree = 400, a.ograve = 556, a.Ccaron = 722, a.ugrave = 556, a.radical = 453, a.Dcaron = 722, a.rcommaaccent = 333, a.Ntilde = 722, a.otilde = 556, a.Rcommaaccent = 722, a.Lcommaaccent = 556, a.Atilde = 667, a.Aogonek = 667, a.Aring = 667, a.Otilde = 778, a.zdotaccent = 500, a.Ecaron = 667, a.Iogonek = 278, a.kcommaaccent = 500, a.minus = 584, a.Icircumflex = 278, a.ncaron = 556, a.tcommaaccent = 278, a.logicalnot = 584, a.odieresis = 556, a.udieresis = 556, a.notequal = 549, a.gcommaaccent = 556, a.eth = 556, a.zcaron = 500, a.ncommaaccent = 556, a.onesuperior = 333, a.imacron = 278, a.Euro = 556;
        }), n.Symbol = (0, o.getLookupTableFactory)(function(a) {
          a.space = 250, a.exclam = 333, a.universal = 713, a.numbersign = 500, a.existential = 549, a.percent = 833, a.ampersand = 778, a.suchthat = 439, a.parenleft = 333, a.parenright = 333, a.asteriskmath = 500, a.plus = 549, a.comma = 250, a.minus = 549, a.period = 250, a.slash = 278, a.zero = 500, a.one = 500, a.two = 500, a.three = 500, a.four = 500, a.five = 500, a.six = 500, a.seven = 500, a.eight = 500, a.nine = 500, a.colon = 278, a.semicolon = 278, a.less = 549, a.equal = 549, a.greater = 549, a.question = 444, a.congruent = 549, a.Alpha = 722, a.Beta = 667, a.Chi = 722, a.Delta = 612, a.Epsilon = 611, a.Phi = 763, a.Gamma = 603, a.Eta = 722, a.Iota = 333, a.theta1 = 631, a.Kappa = 722, a.Lambda = 686, a.Mu = 889, a.Nu = 722, a.Omicron = 722, a.Pi = 768, a.Theta = 741, a.Rho = 556, a.Sigma = 592, a.Tau = 611, a.Upsilon = 690, a.sigma1 = 439, a.Omega = 768, a.Xi = 645, a.Psi = 795, a.Zeta = 611, a.bracketleft = 333, a.therefore = 863, a.bracketright = 333, a.perpendicular = 658, a.underscore = 500, a.radicalex = 500, a.alpha = 631, a.beta = 549, a.chi = 549, a.delta = 494, a.epsilon = 439, a.phi = 521, a.gamma = 411, a.eta = 603, a.iota = 329, a.phi1 = 603, a.kappa = 549, a.lambda = 549, a.mu = 576, a.nu = 521, a.omicron = 549, a.pi = 549, a.theta = 521, a.rho = 549, a.sigma = 603, a.tau = 439, a.upsilon = 576, a.omega1 = 713, a.omega = 686, a.xi = 493, a.psi = 686, a.zeta = 494, a.braceleft = 480, a.bar = 200, a.braceright = 480, a.similar = 549, a.Euro = 750, a.Upsilon1 = 620, a.minute = 247, a.lessequal = 549, a.fraction = 167, a.infinity = 713, a.florin = 500, a.club = 753, a.diamond = 753, a.heart = 753, a.spade = 753, a.arrowboth = 1042, a.arrowleft = 987, a.arrowup = 603, a.arrowright = 987, a.arrowdown = 603, a.degree = 400, a.plusminus = 549, a.second = 411, a.greaterequal = 549, a.multiply = 549, a.proportional = 713, a.partialdiff = 494, a.bullet = 460, a.divide = 549, a.notequal = 549, a.equivalence = 549, a.approxequal = 549, a.ellipsis = 1e3, a.arrowvertex = 603, a.arrowhorizex = 1e3, a.carriagereturn = 658, a.aleph = 823, a.Ifraktur = 686, a.Rfraktur = 795, a.weierstrass = 987, a.circlemultiply = 768, a.circleplus = 768, a.emptyset = 823, a.intersection = 768, a.union = 768, a.propersuperset = 713, a.reflexsuperset = 713, a.notsubset = 713, a.propersubset = 713, a.reflexsubset = 713, a.element = 713, a.notelement = 713, a.angle = 768, a.gradient = 713, a.registerserif = 790, a.copyrightserif = 790, a.trademarkserif = 890, a.product = 823, a.radical = 549, a.dotmath = 250, a.logicalnot = 713, a.logicaland = 603, a.logicalor = 603, a.arrowdblboth = 1042, a.arrowdblleft = 987, a.arrowdblup = 603, a.arrowdblright = 987, a.arrowdbldown = 603, a.lozenge = 494, a.angleleft = 329, a.registersans = 790, a.copyrightsans = 790, a.trademarksans = 786, a.summation = 713, a.parenlefttp = 384, a.parenleftex = 384, a.parenleftbt = 384, a.bracketlefttp = 384, a.bracketleftex = 384, a.bracketleftbt = 384, a.bracelefttp = 494, a.braceleftmid = 494, a.braceleftbt = 494, a.braceex = 494, a.angleright = 329, a.integral = 274, a.integraltp = 686, a.integralex = 686, a.integralbt = 686, a.parenrighttp = 384, a.parenrightex = 384, a.parenrightbt = 384, a.bracketrighttp = 384, a.bracketrightex = 384, a.bracketrightbt = 384, a.bracerighttp = 494, a.bracerightmid = 494, a.bracerightbt = 494, a.apple = 790;
        }), n["Times-Roman"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 250, a.exclam = 333, a.quotedbl = 408, a.numbersign = 500, a.dollar = 500, a.percent = 833, a.ampersand = 778, a.quoteright = 333, a.parenleft = 333, a.parenright = 333, a.asterisk = 500, a.plus = 564, a.comma = 250, a.hyphen = 333, a.period = 250, a.slash = 278, a.zero = 500, a.one = 500, a.two = 500, a.three = 500, a.four = 500, a.five = 500, a.six = 500, a.seven = 500, a.eight = 500, a.nine = 500, a.colon = 278, a.semicolon = 278, a.less = 564, a.equal = 564, a.greater = 564, a.question = 444, a.at = 921, a.A = 722, a.B = 667, a.C = 667, a.D = 722, a.E = 611, a.F = 556, a.G = 722, a.H = 722, a.I = 333, a.J = 389, a.K = 722, a.L = 611, a.M = 889, a.N = 722, a.O = 722, a.P = 556, a.Q = 722, a.R = 667, a.S = 556, a.T = 611, a.U = 722, a.V = 722, a.W = 944, a.X = 722, a.Y = 722, a.Z = 611, a.bracketleft = 333, a.backslash = 278, a.bracketright = 333, a.asciicircum = 469, a.underscore = 500, a.quoteleft = 333, a.a = 444, a.b = 500, a.c = 444, a.d = 500, a.e = 444, a.f = 333, a.g = 500, a.h = 500, a.i = 278, a.j = 278, a.k = 500, a.l = 278, a.m = 778, a.n = 500, a.o = 500, a.p = 500, a.q = 500, a.r = 333, a.s = 389, a.t = 278, a.u = 500, a.v = 500, a.w = 722, a.x = 500, a.y = 500, a.z = 444, a.braceleft = 480, a.bar = 200, a.braceright = 480, a.asciitilde = 541, a.exclamdown = 333, a.cent = 500, a.sterling = 500, a.fraction = 167, a.yen = 500, a.florin = 500, a.section = 500, a.currency = 500, a.quotesingle = 180, a.quotedblleft = 444, a.guillemotleft = 500, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 556, a.fl = 556, a.endash = 500, a.dagger = 500, a.daggerdbl = 500, a.periodcentered = 250, a.paragraph = 453, a.bullet = 350, a.quotesinglbase = 333, a.quotedblbase = 444, a.quotedblright = 444, a.guillemotright = 500, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 444, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 889, a.ordfeminine = 276, a.Lslash = 611, a.Oslash = 722, a.OE = 889, a.ordmasculine = 310, a.ae = 667, a.dotlessi = 278, a.lslash = 278, a.oslash = 500, a.oe = 722, a.germandbls = 500, a.Idieresis = 333, a.eacute = 444, a.abreve = 444, a.uhungarumlaut = 500, a.ecaron = 444, a.Ydieresis = 722, a.divide = 564, a.Yacute = 722, a.Acircumflex = 722, a.aacute = 444, a.Ucircumflex = 722, a.yacute = 500, a.scommaaccent = 389, a.ecircumflex = 444, a.Uring = 722, a.Udieresis = 722, a.aogonek = 444, a.Uacute = 722, a.uogonek = 500, a.Edieresis = 611, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 760, a.Emacron = 611, a.ccaron = 444, a.aring = 444, a.Ncommaaccent = 722, a.lacute = 278, a.agrave = 444, a.Tcommaaccent = 611, a.Cacute = 667, a.atilde = 444, a.Edotaccent = 611, a.scaron = 389, a.scedilla = 389, a.iacute = 278, a.lozenge = 471, a.Rcaron = 667, a.Gcommaaccent = 722, a.ucircumflex = 500, a.acircumflex = 444, a.Amacron = 722, a.rcaron = 333, a.ccedilla = 444, a.Zdotaccent = 611, a.Thorn = 556, a.Omacron = 722, a.Racute = 667, a.Sacute = 556, a.dcaron = 588, a.Umacron = 722, a.uring = 500, a.threesuperior = 300, a.Ograve = 722, a.Agrave = 722, a.Abreve = 722, a.multiply = 564, a.uacute = 500, a.Tcaron = 611, a.partialdiff = 476, a.ydieresis = 500, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 611, a.adieresis = 444, a.edieresis = 444, a.cacute = 444, a.nacute = 500, a.umacron = 500, a.Ncaron = 722, a.Iacute = 333, a.plusminus = 564, a.brokenbar = 200, a.registered = 760, a.Gbreve = 722, a.Idotaccent = 333, a.summation = 600, a.Egrave = 611, a.racute = 333, a.omacron = 500, a.Zacute = 611, a.Zcaron = 611, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 667, a.lcommaaccent = 278, a.tcaron = 326, a.eogonek = 444, a.Uogonek = 722, a.Aacute = 722, a.Adieresis = 722, a.egrave = 444, a.zacute = 444, a.iogonek = 278, a.Oacute = 722, a.oacute = 500, a.amacron = 444, a.sacute = 389, a.idieresis = 278, a.Ocircumflex = 722, a.Ugrave = 722, a.Delta = 612, a.thorn = 500, a.twosuperior = 300, a.Odieresis = 722, a.mu = 500, a.igrave = 278, a.ohungarumlaut = 500, a.Eogonek = 611, a.dcroat = 500, a.threequarters = 750, a.Scedilla = 556, a.lcaron = 344, a.Kcommaaccent = 722, a.Lacute = 611, a.trademark = 980, a.edotaccent = 444, a.Igrave = 333, a.Imacron = 333, a.Lcaron = 611, a.onehalf = 750, a.lessequal = 549, a.ocircumflex = 500, a.ntilde = 500, a.Uhungarumlaut = 722, a.Eacute = 611, a.emacron = 444, a.gbreve = 500, a.onequarter = 750, a.Scaron = 556, a.Scommaaccent = 556, a.Ohungarumlaut = 722, a.degree = 400, a.ograve = 500, a.Ccaron = 667, a.ugrave = 500, a.radical = 453, a.Dcaron = 722, a.rcommaaccent = 333, a.Ntilde = 722, a.otilde = 500, a.Rcommaaccent = 667, a.Lcommaaccent = 611, a.Atilde = 722, a.Aogonek = 722, a.Aring = 722, a.Otilde = 722, a.zdotaccent = 444, a.Ecaron = 611, a.Iogonek = 333, a.kcommaaccent = 500, a.minus = 564, a.Icircumflex = 333, a.ncaron = 500, a.tcommaaccent = 278, a.logicalnot = 564, a.odieresis = 500, a.udieresis = 500, a.notequal = 549, a.gcommaaccent = 500, a.eth = 500, a.zcaron = 444, a.ncommaaccent = 500, a.onesuperior = 300, a.imacron = 278, a.Euro = 500;
        }), n["Times-Bold"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 250, a.exclam = 333, a.quotedbl = 555, a.numbersign = 500, a.dollar = 500, a.percent = 1e3, a.ampersand = 833, a.quoteright = 333, a.parenleft = 333, a.parenright = 333, a.asterisk = 500, a.plus = 570, a.comma = 250, a.hyphen = 333, a.period = 250, a.slash = 278, a.zero = 500, a.one = 500, a.two = 500, a.three = 500, a.four = 500, a.five = 500, a.six = 500, a.seven = 500, a.eight = 500, a.nine = 500, a.colon = 333, a.semicolon = 333, a.less = 570, a.equal = 570, a.greater = 570, a.question = 500, a.at = 930, a.A = 722, a.B = 667, a.C = 722, a.D = 722, a.E = 667, a.F = 611, a.G = 778, a.H = 778, a.I = 389, a.J = 500, a.K = 778, a.L = 667, a.M = 944, a.N = 722, a.O = 778, a.P = 611, a.Q = 778, a.R = 722, a.S = 556, a.T = 667, a.U = 722, a.V = 722, a.W = 1e3, a.X = 722, a.Y = 722, a.Z = 667, a.bracketleft = 333, a.backslash = 278, a.bracketright = 333, a.asciicircum = 581, a.underscore = 500, a.quoteleft = 333, a.a = 500, a.b = 556, a.c = 444, a.d = 556, a.e = 444, a.f = 333, a.g = 500, a.h = 556, a.i = 278, a.j = 333, a.k = 556, a.l = 278, a.m = 833, a.n = 556, a.o = 500, a.p = 556, a.q = 556, a.r = 444, a.s = 389, a.t = 333, a.u = 556, a.v = 500, a.w = 722, a.x = 500, a.y = 500, a.z = 444, a.braceleft = 394, a.bar = 220, a.braceright = 394, a.asciitilde = 520, a.exclamdown = 333, a.cent = 500, a.sterling = 500, a.fraction = 167, a.yen = 500, a.florin = 500, a.section = 500, a.currency = 500, a.quotesingle = 278, a.quotedblleft = 500, a.guillemotleft = 500, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 556, a.fl = 556, a.endash = 500, a.dagger = 500, a.daggerdbl = 500, a.periodcentered = 250, a.paragraph = 540, a.bullet = 350, a.quotesinglbase = 333, a.quotedblbase = 500, a.quotedblright = 500, a.guillemotright = 500, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 500, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 1e3, a.ordfeminine = 300, a.Lslash = 667, a.Oslash = 778, a.OE = 1e3, a.ordmasculine = 330, a.ae = 722, a.dotlessi = 278, a.lslash = 278, a.oslash = 500, a.oe = 722, a.germandbls = 556, a.Idieresis = 389, a.eacute = 444, a.abreve = 500, a.uhungarumlaut = 556, a.ecaron = 444, a.Ydieresis = 722, a.divide = 570, a.Yacute = 722, a.Acircumflex = 722, a.aacute = 500, a.Ucircumflex = 722, a.yacute = 500, a.scommaaccent = 389, a.ecircumflex = 444, a.Uring = 722, a.Udieresis = 722, a.aogonek = 500, a.Uacute = 722, a.uogonek = 556, a.Edieresis = 667, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 747, a.Emacron = 667, a.ccaron = 444, a.aring = 500, a.Ncommaaccent = 722, a.lacute = 278, a.agrave = 500, a.Tcommaaccent = 667, a.Cacute = 722, a.atilde = 500, a.Edotaccent = 667, a.scaron = 389, a.scedilla = 389, a.iacute = 278, a.lozenge = 494, a.Rcaron = 722, a.Gcommaaccent = 778, a.ucircumflex = 556, a.acircumflex = 500, a.Amacron = 722, a.rcaron = 444, a.ccedilla = 444, a.Zdotaccent = 667, a.Thorn = 611, a.Omacron = 778, a.Racute = 722, a.Sacute = 556, a.dcaron = 672, a.Umacron = 722, a.uring = 556, a.threesuperior = 300, a.Ograve = 778, a.Agrave = 722, a.Abreve = 722, a.multiply = 570, a.uacute = 556, a.Tcaron = 667, a.partialdiff = 494, a.ydieresis = 500, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 667, a.adieresis = 500, a.edieresis = 444, a.cacute = 444, a.nacute = 556, a.umacron = 556, a.Ncaron = 722, a.Iacute = 389, a.plusminus = 570, a.brokenbar = 220, a.registered = 747, a.Gbreve = 778, a.Idotaccent = 389, a.summation = 600, a.Egrave = 667, a.racute = 444, a.omacron = 500, a.Zacute = 667, a.Zcaron = 667, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 722, a.lcommaaccent = 278, a.tcaron = 416, a.eogonek = 444, a.Uogonek = 722, a.Aacute = 722, a.Adieresis = 722, a.egrave = 444, a.zacute = 444, a.iogonek = 278, a.Oacute = 778, a.oacute = 500, a.amacron = 500, a.sacute = 389, a.idieresis = 278, a.Ocircumflex = 778, a.Ugrave = 722, a.Delta = 612, a.thorn = 556, a.twosuperior = 300, a.Odieresis = 778, a.mu = 556, a.igrave = 278, a.ohungarumlaut = 500, a.Eogonek = 667, a.dcroat = 556, a.threequarters = 750, a.Scedilla = 556, a.lcaron = 394, a.Kcommaaccent = 778, a.Lacute = 667, a.trademark = 1e3, a.edotaccent = 444, a.Igrave = 389, a.Imacron = 389, a.Lcaron = 667, a.onehalf = 750, a.lessequal = 549, a.ocircumflex = 500, a.ntilde = 556, a.Uhungarumlaut = 722, a.Eacute = 667, a.emacron = 444, a.gbreve = 500, a.onequarter = 750, a.Scaron = 556, a.Scommaaccent = 556, a.Ohungarumlaut = 778, a.degree = 400, a.ograve = 500, a.Ccaron = 722, a.ugrave = 556, a.radical = 549, a.Dcaron = 722, a.rcommaaccent = 444, a.Ntilde = 722, a.otilde = 500, a.Rcommaaccent = 722, a.Lcommaaccent = 667, a.Atilde = 722, a.Aogonek = 722, a.Aring = 722, a.Otilde = 778, a.zdotaccent = 444, a.Ecaron = 667, a.Iogonek = 389, a.kcommaaccent = 556, a.minus = 570, a.Icircumflex = 389, a.ncaron = 556, a.tcommaaccent = 333, a.logicalnot = 570, a.odieresis = 500, a.udieresis = 556, a.notequal = 549, a.gcommaaccent = 500, a.eth = 500, a.zcaron = 444, a.ncommaaccent = 556, a.onesuperior = 300, a.imacron = 278, a.Euro = 500;
        }), n["Times-BoldItalic"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 250, a.exclam = 389, a.quotedbl = 555, a.numbersign = 500, a.dollar = 500, a.percent = 833, a.ampersand = 778, a.quoteright = 333, a.parenleft = 333, a.parenright = 333, a.asterisk = 500, a.plus = 570, a.comma = 250, a.hyphen = 333, a.period = 250, a.slash = 278, a.zero = 500, a.one = 500, a.two = 500, a.three = 500, a.four = 500, a.five = 500, a.six = 500, a.seven = 500, a.eight = 500, a.nine = 500, a.colon = 333, a.semicolon = 333, a.less = 570, a.equal = 570, a.greater = 570, a.question = 500, a.at = 832, a.A = 667, a.B = 667, a.C = 667, a.D = 722, a.E = 667, a.F = 667, a.G = 722, a.H = 778, a.I = 389, a.J = 500, a.K = 667, a.L = 611, a.M = 889, a.N = 722, a.O = 722, a.P = 611, a.Q = 722, a.R = 667, a.S = 556, a.T = 611, a.U = 722, a.V = 667, a.W = 889, a.X = 667, a.Y = 611, a.Z = 611, a.bracketleft = 333, a.backslash = 278, a.bracketright = 333, a.asciicircum = 570, a.underscore = 500, a.quoteleft = 333, a.a = 500, a.b = 500, a.c = 444, a.d = 500, a.e = 444, a.f = 333, a.g = 500, a.h = 556, a.i = 278, a.j = 278, a.k = 500, a.l = 278, a.m = 778, a.n = 556, a.o = 500, a.p = 500, a.q = 500, a.r = 389, a.s = 389, a.t = 278, a.u = 556, a.v = 444, a.w = 667, a.x = 500, a.y = 444, a.z = 389, a.braceleft = 348, a.bar = 220, a.braceright = 348, a.asciitilde = 570, a.exclamdown = 389, a.cent = 500, a.sterling = 500, a.fraction = 167, a.yen = 500, a.florin = 500, a.section = 500, a.currency = 500, a.quotesingle = 278, a.quotedblleft = 500, a.guillemotleft = 500, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 556, a.fl = 556, a.endash = 500, a.dagger = 500, a.daggerdbl = 500, a.periodcentered = 250, a.paragraph = 500, a.bullet = 350, a.quotesinglbase = 333, a.quotedblbase = 500, a.quotedblright = 500, a.guillemotright = 500, a.ellipsis = 1e3, a.perthousand = 1e3, a.questiondown = 500, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 1e3, a.AE = 944, a.ordfeminine = 266, a.Lslash = 611, a.Oslash = 722, a.OE = 944, a.ordmasculine = 300, a.ae = 722, a.dotlessi = 278, a.lslash = 278, a.oslash = 500, a.oe = 722, a.germandbls = 500, a.Idieresis = 389, a.eacute = 444, a.abreve = 500, a.uhungarumlaut = 556, a.ecaron = 444, a.Ydieresis = 611, a.divide = 570, a.Yacute = 611, a.Acircumflex = 667, a.aacute = 500, a.Ucircumflex = 722, a.yacute = 444, a.scommaaccent = 389, a.ecircumflex = 444, a.Uring = 722, a.Udieresis = 722, a.aogonek = 500, a.Uacute = 722, a.uogonek = 556, a.Edieresis = 667, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 747, a.Emacron = 667, a.ccaron = 444, a.aring = 500, a.Ncommaaccent = 722, a.lacute = 278, a.agrave = 500, a.Tcommaaccent = 611, a.Cacute = 667, a.atilde = 500, a.Edotaccent = 667, a.scaron = 389, a.scedilla = 389, a.iacute = 278, a.lozenge = 494, a.Rcaron = 667, a.Gcommaaccent = 722, a.ucircumflex = 556, a.acircumflex = 500, a.Amacron = 667, a.rcaron = 389, a.ccedilla = 444, a.Zdotaccent = 611, a.Thorn = 611, a.Omacron = 722, a.Racute = 667, a.Sacute = 556, a.dcaron = 608, a.Umacron = 722, a.uring = 556, a.threesuperior = 300, a.Ograve = 722, a.Agrave = 667, a.Abreve = 667, a.multiply = 570, a.uacute = 556, a.Tcaron = 611, a.partialdiff = 494, a.ydieresis = 444, a.Nacute = 722, a.icircumflex = 278, a.Ecircumflex = 667, a.adieresis = 500, a.edieresis = 444, a.cacute = 444, a.nacute = 556, a.umacron = 556, a.Ncaron = 722, a.Iacute = 389, a.plusminus = 570, a.brokenbar = 220, a.registered = 747, a.Gbreve = 722, a.Idotaccent = 389, a.summation = 600, a.Egrave = 667, a.racute = 389, a.omacron = 500, a.Zacute = 611, a.Zcaron = 611, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 667, a.lcommaaccent = 278, a.tcaron = 366, a.eogonek = 444, a.Uogonek = 722, a.Aacute = 667, a.Adieresis = 667, a.egrave = 444, a.zacute = 389, a.iogonek = 278, a.Oacute = 722, a.oacute = 500, a.amacron = 500, a.sacute = 389, a.idieresis = 278, a.Ocircumflex = 722, a.Ugrave = 722, a.Delta = 612, a.thorn = 500, a.twosuperior = 300, a.Odieresis = 722, a.mu = 576, a.igrave = 278, a.ohungarumlaut = 500, a.Eogonek = 667, a.dcroat = 500, a.threequarters = 750, a.Scedilla = 556, a.lcaron = 382, a.Kcommaaccent = 667, a.Lacute = 611, a.trademark = 1e3, a.edotaccent = 444, a.Igrave = 389, a.Imacron = 389, a.Lcaron = 611, a.onehalf = 750, a.lessequal = 549, a.ocircumflex = 500, a.ntilde = 556, a.Uhungarumlaut = 722, a.Eacute = 667, a.emacron = 444, a.gbreve = 500, a.onequarter = 750, a.Scaron = 556, a.Scommaaccent = 556, a.Ohungarumlaut = 722, a.degree = 400, a.ograve = 500, a.Ccaron = 667, a.ugrave = 556, a.radical = 549, a.Dcaron = 722, a.rcommaaccent = 389, a.Ntilde = 722, a.otilde = 500, a.Rcommaaccent = 667, a.Lcommaaccent = 611, a.Atilde = 667, a.Aogonek = 667, a.Aring = 667, a.Otilde = 722, a.zdotaccent = 389, a.Ecaron = 667, a.Iogonek = 389, a.kcommaaccent = 500, a.minus = 606, a.Icircumflex = 389, a.ncaron = 556, a.tcommaaccent = 278, a.logicalnot = 606, a.odieresis = 500, a.udieresis = 556, a.notequal = 549, a.gcommaaccent = 500, a.eth = 500, a.zcaron = 389, a.ncommaaccent = 556, a.onesuperior = 300, a.imacron = 278, a.Euro = 500;
        }), n["Times-Italic"] = (0, o.getLookupTableFactory)(function(a) {
          a.space = 250, a.exclam = 333, a.quotedbl = 420, a.numbersign = 500, a.dollar = 500, a.percent = 833, a.ampersand = 778, a.quoteright = 333, a.parenleft = 333, a.parenright = 333, a.asterisk = 500, a.plus = 675, a.comma = 250, a.hyphen = 333, a.period = 250, a.slash = 278, a.zero = 500, a.one = 500, a.two = 500, a.three = 500, a.four = 500, a.five = 500, a.six = 500, a.seven = 500, a.eight = 500, a.nine = 500, a.colon = 333, a.semicolon = 333, a.less = 675, a.equal = 675, a.greater = 675, a.question = 500, a.at = 920, a.A = 611, a.B = 611, a.C = 667, a.D = 722, a.E = 611, a.F = 611, a.G = 722, a.H = 722, a.I = 333, a.J = 444, a.K = 667, a.L = 556, a.M = 833, a.N = 667, a.O = 722, a.P = 611, a.Q = 722, a.R = 611, a.S = 500, a.T = 556, a.U = 722, a.V = 611, a.W = 833, a.X = 611, a.Y = 556, a.Z = 556, a.bracketleft = 389, a.backslash = 278, a.bracketright = 389, a.asciicircum = 422, a.underscore = 500, a.quoteleft = 333, a.a = 500, a.b = 500, a.c = 444, a.d = 500, a.e = 444, a.f = 278, a.g = 500, a.h = 500, a.i = 278, a.j = 278, a.k = 444, a.l = 278, a.m = 722, a.n = 500, a.o = 500, a.p = 500, a.q = 500, a.r = 389, a.s = 389, a.t = 278, a.u = 500, a.v = 444, a.w = 667, a.x = 444, a.y = 444, a.z = 389, a.braceleft = 400, a.bar = 275, a.braceright = 400, a.asciitilde = 541, a.exclamdown = 389, a.cent = 500, a.sterling = 500, a.fraction = 167, a.yen = 500, a.florin = 500, a.section = 500, a.currency = 500, a.quotesingle = 214, a.quotedblleft = 556, a.guillemotleft = 500, a.guilsinglleft = 333, a.guilsinglright = 333, a.fi = 500, a.fl = 500, a.endash = 500, a.dagger = 500, a.daggerdbl = 500, a.periodcentered = 250, a.paragraph = 523, a.bullet = 350, a.quotesinglbase = 333, a.quotedblbase = 556, a.quotedblright = 556, a.guillemotright = 500, a.ellipsis = 889, a.perthousand = 1e3, a.questiondown = 500, a.grave = 333, a.acute = 333, a.circumflex = 333, a.tilde = 333, a.macron = 333, a.breve = 333, a.dotaccent = 333, a.dieresis = 333, a.ring = 333, a.cedilla = 333, a.hungarumlaut = 333, a.ogonek = 333, a.caron = 333, a.emdash = 889, a.AE = 889, a.ordfeminine = 276, a.Lslash = 556, a.Oslash = 722, a.OE = 944, a.ordmasculine = 310, a.ae = 667, a.dotlessi = 278, a.lslash = 278, a.oslash = 500, a.oe = 667, a.germandbls = 500, a.Idieresis = 333, a.eacute = 444, a.abreve = 500, a.uhungarumlaut = 500, a.ecaron = 444, a.Ydieresis = 556, a.divide = 675, a.Yacute = 556, a.Acircumflex = 611, a.aacute = 500, a.Ucircumflex = 722, a.yacute = 444, a.scommaaccent = 389, a.ecircumflex = 444, a.Uring = 722, a.Udieresis = 722, a.aogonek = 500, a.Uacute = 722, a.uogonek = 500, a.Edieresis = 611, a.Dcroat = 722, a.commaaccent = 250, a.copyright = 760, a.Emacron = 611, a.ccaron = 444, a.aring = 500, a.Ncommaaccent = 667, a.lacute = 278, a.agrave = 500, a.Tcommaaccent = 556, a.Cacute = 667, a.atilde = 500, a.Edotaccent = 611, a.scaron = 389, a.scedilla = 389, a.iacute = 278, a.lozenge = 471, a.Rcaron = 611, a.Gcommaaccent = 722, a.ucircumflex = 500, a.acircumflex = 500, a.Amacron = 611, a.rcaron = 389, a.ccedilla = 444, a.Zdotaccent = 556, a.Thorn = 611, a.Omacron = 722, a.Racute = 611, a.Sacute = 500, a.dcaron = 544, a.Umacron = 722, a.uring = 500, a.threesuperior = 300, a.Ograve = 722, a.Agrave = 611, a.Abreve = 611, a.multiply = 675, a.uacute = 500, a.Tcaron = 556, a.partialdiff = 476, a.ydieresis = 444, a.Nacute = 667, a.icircumflex = 278, a.Ecircumflex = 611, a.adieresis = 500, a.edieresis = 444, a.cacute = 444, a.nacute = 500, a.umacron = 500, a.Ncaron = 667, a.Iacute = 333, a.plusminus = 675, a.brokenbar = 275, a.registered = 760, a.Gbreve = 722, a.Idotaccent = 333, a.summation = 600, a.Egrave = 611, a.racute = 389, a.omacron = 500, a.Zacute = 556, a.Zcaron = 556, a.greaterequal = 549, a.Eth = 722, a.Ccedilla = 667, a.lcommaaccent = 278, a.tcaron = 300, a.eogonek = 444, a.Uogonek = 722, a.Aacute = 611, a.Adieresis = 611, a.egrave = 444, a.zacute = 389, a.iogonek = 278, a.Oacute = 722, a.oacute = 500, a.amacron = 500, a.sacute = 389, a.idieresis = 278, a.Ocircumflex = 722, a.Ugrave = 722, a.Delta = 612, a.thorn = 500, a.twosuperior = 300, a.Odieresis = 722, a.mu = 500, a.igrave = 278, a.ohungarumlaut = 500, a.Eogonek = 611, a.dcroat = 500, a.threequarters = 750, a.Scedilla = 500, a.lcaron = 300, a.Kcommaaccent = 667, a.Lacute = 556, a.trademark = 980, a.edotaccent = 444, a.Igrave = 333, a.Imacron = 333, a.Lcaron = 611, a.onehalf = 750, a.lessequal = 549, a.ocircumflex = 500, a.ntilde = 500, a.Uhungarumlaut = 722, a.Eacute = 611, a.emacron = 444, a.gbreve = 500, a.onequarter = 750, a.Scaron = 500, a.Scommaaccent = 500, a.Ohungarumlaut = 722, a.degree = 400, a.ograve = 500, a.Ccaron = 667, a.ugrave = 500, a.radical = 453, a.Dcaron = 722, a.rcommaaccent = 389, a.Ntilde = 667, a.otilde = 500, a.Rcommaaccent = 611, a.Lcommaaccent = 556, a.Atilde = 611, a.Aogonek = 611, a.Aring = 611, a.Otilde = 722, a.zdotaccent = 389, a.Ecaron = 611, a.Iogonek = 333, a.kcommaaccent = 444, a.minus = 675, a.Icircumflex = 333, a.ncaron = 500, a.tcommaaccent = 278, a.logicalnot = 675, a.odieresis = 500, a.udieresis = 500, a.notequal = 549, a.gcommaaccent = 500, a.eth = 500, a.zcaron = 389, a.ncommaaccent = 500, a.onesuperior = 300, a.imacron = 278, a.Euro = 500;
        }), n.ZapfDingbats = (0, o.getLookupTableFactory)(function(a) {
          a.space = 278, a.a1 = 974, a.a2 = 961, a.a202 = 974, a.a3 = 980, a.a4 = 719, a.a5 = 789, a.a119 = 790, a.a118 = 791, a.a117 = 690, a.a11 = 960, a.a12 = 939, a.a13 = 549, a.a14 = 855, a.a15 = 911, a.a16 = 933, a.a105 = 911, a.a17 = 945, a.a18 = 974, a.a19 = 755, a.a20 = 846, a.a21 = 762, a.a22 = 761, a.a23 = 571, a.a24 = 677, a.a25 = 763, a.a26 = 760, a.a27 = 759, a.a28 = 754, a.a6 = 494, a.a7 = 552, a.a8 = 537, a.a9 = 577, a.a10 = 692, a.a29 = 786, a.a30 = 788, a.a31 = 788, a.a32 = 790, a.a33 = 793, a.a34 = 794, a.a35 = 816, a.a36 = 823, a.a37 = 789, a.a38 = 841, a.a39 = 823, a.a40 = 833, a.a41 = 816, a.a42 = 831, a.a43 = 923, a.a44 = 744, a.a45 = 723, a.a46 = 749, a.a47 = 790, a.a48 = 792, a.a49 = 695, a.a50 = 776, a.a51 = 768, a.a52 = 792, a.a53 = 759, a.a54 = 707, a.a55 = 708, a.a56 = 682, a.a57 = 701, a.a58 = 826, a.a59 = 815, a.a60 = 789, a.a61 = 789, a.a62 = 707, a.a63 = 687, a.a64 = 696, a.a65 = 689, a.a66 = 786, a.a67 = 787, a.a68 = 713, a.a69 = 791, a.a70 = 785, a.a71 = 791, a.a72 = 873, a.a73 = 761, a.a74 = 762, a.a203 = 762, a.a75 = 759, a.a204 = 759, a.a76 = 892, a.a77 = 892, a.a78 = 788, a.a79 = 784, a.a81 = 438, a.a82 = 138, a.a83 = 277, a.a84 = 415, a.a97 = 392, a.a98 = 392, a.a99 = 668, a.a100 = 668, a.a89 = 390, a.a90 = 390, a.a93 = 317, a.a94 = 317, a.a91 = 276, a.a92 = 276, a.a205 = 509, a.a85 = 509, a.a206 = 410, a.a86 = 410, a.a87 = 234, a.a88 = 234, a.a95 = 334, a.a96 = 334, a.a101 = 732, a.a102 = 544, a.a103 = 544, a.a104 = 910, a.a106 = 667, a.a107 = 760, a.a108 = 760, a.a112 = 776, a.a111 = 595, a.a110 = 694, a.a109 = 626, a.a120 = 788, a.a121 = 788, a.a122 = 788, a.a123 = 788, a.a124 = 788, a.a125 = 788, a.a126 = 788, a.a127 = 788, a.a128 = 788, a.a129 = 788, a.a130 = 788, a.a131 = 788, a.a132 = 788, a.a133 = 788, a.a134 = 788, a.a135 = 788, a.a136 = 788, a.a137 = 788, a.a138 = 788, a.a139 = 788, a.a140 = 788, a.a141 = 788, a.a142 = 788, a.a143 = 788, a.a144 = 788, a.a145 = 788, a.a146 = 788, a.a147 = 788, a.a148 = 788, a.a149 = 788, a.a150 = 788, a.a151 = 788, a.a152 = 788, a.a153 = 788, a.a154 = 788, a.a155 = 788, a.a156 = 788, a.a157 = 788, a.a158 = 788, a.a159 = 788, a.a160 = 894, a.a161 = 838, a.a163 = 1016, a.a164 = 458, a.a196 = 748, a.a165 = 924, a.a192 = 748, a.a166 = 918, a.a167 = 927, a.a168 = 928, a.a169 = 928, a.a170 = 834, a.a171 = 873, a.a172 = 828, a.a173 = 924, a.a162 = 924, a.a174 = 917, a.a175 = 930, a.a176 = 931, a.a177 = 463, a.a178 = 883, a.a179 = 836, a.a193 = 836, a.a180 = 867, a.a199 = 867, a.a181 = 696, a.a200 = 696, a.a182 = 874, a.a201 = 874, a.a183 = 760, a.a184 = 946, a.a197 = 771, a.a185 = 865, a.a194 = 771, a.a198 = 888, a.a186 = 967, a.a195 = 888, a.a187 = 831, a.a188 = 873, a.a189 = 927, a.a190 = 970, a.a191 = 918;
        });
      });
      l.getMetrics = g;
      const p = (0, o.getLookupTableFactory)(function(n) {
        n.Courier = { ascent: 629, descent: -157, capHeight: 562, xHeight: -426 }, n["Courier-Bold"] = { ascent: 629, descent: -157, capHeight: 562, xHeight: 439 }, n["Courier-Oblique"] = { ascent: 629, descent: -157, capHeight: 562, xHeight: 426 }, n["Courier-BoldOblique"] = { ascent: 629, descent: -157, capHeight: 562, xHeight: 426 }, n.Helvetica = { ascent: 718, descent: -207, capHeight: 718, xHeight: 523 }, n["Helvetica-Bold"] = { ascent: 718, descent: -207, capHeight: 718, xHeight: 532 }, n["Helvetica-Oblique"] = { ascent: 718, descent: -207, capHeight: 718, xHeight: 523 }, n["Helvetica-BoldOblique"] = { ascent: 718, descent: -207, capHeight: 718, xHeight: 532 }, n["Times-Roman"] = { ascent: 683, descent: -217, capHeight: 662, xHeight: 450 }, n["Times-Bold"] = { ascent: 683, descent: -217, capHeight: 676, xHeight: 461 }, n["Times-Italic"] = { ascent: 683, descent: -217, capHeight: 653, xHeight: 441 }, n["Times-BoldItalic"] = { ascent: 683, descent: -217, capHeight: 669, xHeight: 462 }, n.Symbol = { ascent: Math.NaN, descent: Math.NaN, capHeight: Math.NaN, xHeight: Math.NaN }, n.ZapfDingbats = { ascent: Math.NaN, descent: Math.NaN, capHeight: Math.NaN, xHeight: Math.NaN };
      });
      l.getFontBasicMetrics = p;
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.GlyfTable = void 0, l.GlyfTable = class {
        constructor({ glyfTable: d, isGlyphLocationsLong: m, locaTable: b, numGlyphs: w }) {
          this.glyphs = [];
          const v = new DataView(b.buffer, b.byteOffset, b.byteLength), h = new DataView(d.buffer, d.byteOffset, d.byteLength), x = m ? 4 : 2;
          let _ = m ? v.getUint32(0) : 2 * v.getUint16(0), M = 0;
          for (let O = 0; O < w; O++) {
            M += x;
            const E = m ? v.getUint32(M) : 2 * v.getUint16(M);
            if (E === _) {
              this.glyphs.push(new f({}));
              continue;
            }
            const I = f.parse(_, h);
            this.glyphs.push(I), _ = E;
          }
        }
        getSize() {
          return this.glyphs.reduce((d, m) => d + (m.getSize() + 3 & -4), 0);
        }
        write() {
          const d = this.getSize(), m = new DataView(new ArrayBuffer(d)), b = d > 131070, w = b ? 4 : 2, v = new DataView(new ArrayBuffer((this.glyphs.length + 1) * w));
          b ? v.setUint32(0, 0) : v.setUint16(0, 0);
          let h = 0, x = 0;
          for (const _ of this.glyphs)
            h += _.write(h, m), h = h + 3 & -4, x += w, b ? v.setUint32(x, h) : v.setUint16(x, h >> 1);
          return { isLocationLong: b, loca: new Uint8Array(v.buffer), glyf: new Uint8Array(m.buffer) };
        }
        scale(d) {
          for (let m = 0, b = this.glyphs.length; m < b; m++) this.glyphs[m].scale(d[m]);
        }
      };
      class f {
        constructor({ header: d = null, simple: m = null, composites: b = null }) {
          this.header = d, this.simple = m, this.composites = b;
        }
        static parse(d, m) {
          const [b, w] = o.parse(d, m);
          if (d += b, w.numberOfContours < 0) {
            const h = [];
            for (; ; ) {
              const [x, _] = n.parse(d, m);
              if (d += x, h.push(_), !(32 & _.flags)) break;
            }
            return new f({ header: w, composites: h });
          }
          const v = p.parse(d, m, w.numberOfContours);
          return new f({ header: w, simple: v });
        }
        getSize() {
          if (!this.header) return 0;
          const d = this.simple ? this.simple.getSize() : this.composites.reduce((m, b) => m + b.getSize(), 0);
          return this.header.getSize() + d;
        }
        write(d, m) {
          if (!this.header) return 0;
          const b = d;
          if (d += this.header.write(d, m), this.simple) d += this.simple.write(d, m);
          else for (const w of this.composites) d += w.write(d, m);
          return d - b;
        }
        scale(d) {
          if (!this.header) return;
          const m = (this.header.xMin + this.header.xMax) / 2;
          if (this.header.scale(m, d), this.simple) this.simple.scale(m, d);
          else for (const b of this.composites) b.scale(m, d);
        }
      }
      class o {
        constructor({ numberOfContours: d, xMin: m, yMin: b, xMax: w, yMax: v }) {
          this.numberOfContours = d, this.xMin = m, this.yMin = b, this.xMax = w, this.yMax = v;
        }
        static parse(d, m) {
          return [10, new o({ numberOfContours: m.getInt16(d), xMin: m.getInt16(d + 2), yMin: m.getInt16(d + 4), xMax: m.getInt16(d + 6), yMax: m.getInt16(d + 8) })];
        }
        getSize() {
          return 10;
        }
        write(d, m) {
          return m.setInt16(d, this.numberOfContours), m.setInt16(d + 2, this.xMin), m.setInt16(d + 4, this.yMin), m.setInt16(d + 6, this.xMax), m.setInt16(d + 8, this.yMax), 10;
        }
        scale(d, m) {
          this.xMin = Math.round(d + (this.xMin - d) * m), this.xMax = Math.round(d + (this.xMax - d) * m);
        }
      }
      class g {
        constructor({ flags: d, xCoordinates: m, yCoordinates: b }) {
          this.xCoordinates = m, this.yCoordinates = b, this.flags = d;
        }
      }
      class p {
        constructor({ contours: d, instructions: m }) {
          this.contours = d, this.instructions = m;
        }
        static parse(d, m, b) {
          const w = [];
          for (let j = 0; j < b; j++) {
            const $ = m.getUint16(d);
            d += 2, w.push($);
          }
          const v = w[b - 1] + 1, h = m.getUint16(d);
          d += 2;
          const x = new Uint8Array(m).slice(d, d + h);
          d += h;
          const _ = [];
          for (let j = 0; j < v; d++, j++) {
            let $ = m.getUint8(d);
            if (_.push($), 8 & $) {
              const B = m.getUint8(++d);
              $ ^= 8;
              for (let C = 0; C < B; C++) _.push($);
              j += B;
            }
          }
          const M = [];
          let O = [], E = [], I = [];
          const R = [];
          let W = 0, z = 0;
          for (let j = 0; j < v; j++) {
            const $ = _[j];
            if (2 & $) {
              const B = m.getUint8(d++);
              z += 16 & $ ? B : -B, O.push(z);
            } else 16 & $ || (z += m.getInt16(d), d += 2), O.push(z);
            w[W] === j && (W++, M.push(O), O = []);
          }
          z = 0, W = 0;
          for (let j = 0; j < v; j++) {
            const $ = _[j];
            if (4 & $) {
              const B = m.getUint8(d++);
              z += 32 & $ ? B : -B, E.push(z);
            } else 32 & $ || (z += m.getInt16(d), d += 2), E.push(z);
            I.push(1 & $ | 64 & $), w[W] === j && (O = M[W], W++, R.push(new g({ flags: I, xCoordinates: O, yCoordinates: E })), E = [], I = []);
          }
          return new p({ contours: R, instructions: x });
        }
        getSize() {
          let d = 2 * this.contours.length + 2 + this.instructions.length, m = 0, b = 0;
          for (const w of this.contours) {
            d += w.flags.length;
            for (let v = 0, h = w.xCoordinates.length; v < h; v++) {
              const x = w.xCoordinates[v], _ = w.yCoordinates[v];
              let M = Math.abs(x - m);
              M > 255 ? d += 2 : M > 0 && (d += 1), m = x, M = Math.abs(_ - b), M > 255 ? d += 2 : M > 0 && (d += 1), b = _;
            }
          }
          return d;
        }
        write(d, m) {
          const b = d, w = [], v = [], h = [];
          let x = 0, _ = 0;
          for (const M of this.contours) {
            for (let O = 0, E = M.xCoordinates.length; O < E; O++) {
              let I = M.flags[O];
              const R = M.xCoordinates[O];
              let W = R - x;
              if (W === 0)
                I |= 16, w.push(0);
              else {
                const j = Math.abs(W);
                j <= 255 ? (I |= W >= 0 ? 18 : 2, w.push(j)) : w.push(W);
              }
              x = R;
              const z = M.yCoordinates[O];
              if (W = z - _, W === 0)
                I |= 32, v.push(0);
              else {
                const j = Math.abs(W);
                j <= 255 ? (I |= W >= 0 ? 36 : 4, v.push(j)) : v.push(W);
              }
              _ = z, h.push(I);
            }
            m.setUint16(d, w.length - 1), d += 2;
          }
          m.setUint16(d, this.instructions.length), d += 2, this.instructions.length && (new Uint8Array(m.buffer, 0, m.buffer.byteLength).set(this.instructions, d), d += this.instructions.length);
          for (const M of h) m.setUint8(d++, M);
          for (let M = 0, O = w.length; M < O; M++) {
            const E = w[M], I = h[M];
            2 & I ? m.setUint8(d++, E) : 16 & I || (m.setInt16(d, E), d += 2);
          }
          for (let M = 0, O = v.length; M < O; M++) {
            const E = v[M], I = h[M];
            4 & I ? m.setUint8(d++, E) : 32 & I || (m.setInt16(d, E), d += 2);
          }
          return d - b;
        }
        scale(d, m) {
          for (const b of this.contours) if (b.xCoordinates.length !== 0) for (let w = 0, v = b.xCoordinates.length; w < v; w++) b.xCoordinates[w] = Math.round(d + (b.xCoordinates[w] - d) * m);
        }
      }
      class n {
        constructor({ flags: d, glyphIndex: m, argument1: b, argument2: w, transf: v, instructions: h }) {
          this.flags = d, this.glyphIndex = m, this.argument1 = b, this.argument2 = w, this.transf = v, this.instructions = h;
        }
        static parse(d, m) {
          const b = d, w = [];
          let v = m.getUint16(d);
          const h = m.getUint16(d + 2);
          d += 4;
          let x, _;
          1 & v ? (2 & v ? (x = m.getInt16(d), _ = m.getInt16(d + 2)) : (x = m.getUint16(d), _ = m.getUint16(d + 2)), d += 4, v ^= 1) : (2 & v ? (x = m.getInt8(d), _ = m.getInt8(d + 1)) : (x = m.getUint8(d), _ = m.getUint8(d + 1)), d += 2), 8 & v ? (w.push(m.getUint16(d)), d += 2) : 64 & v ? (w.push(m.getUint16(d), m.getUint16(d + 2)), d += 4) : 128 & v && (w.push(m.getUint16(d), m.getUint16(d + 2), m.getUint16(d + 4), m.getUint16(d + 6)), d += 8);
          let M = null;
          if (256 & v) {
            const O = m.getUint16(d);
            d += 2, M = new Uint8Array(m).slice(d, d + O), d += O;
          }
          return [d - b, new n({ flags: v, glyphIndex: h, argument1: x, argument2: _, transf: w, instructions: M })];
        }
        getSize() {
          let d = 4 + 2 * this.transf.length;
          return 256 & this.flags && (d += 2 + this.instructions.length), d += 2, 2 & this.flags ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (d += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (d += 2), d;
        }
        write(d, m) {
          const b = d;
          return 2 & this.flags ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= 1) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= 1), m.setUint16(d, this.flags), m.setUint16(d + 2, this.glyphIndex), d += 4, 1 & this.flags ? (2 & this.flags ? (m.setInt16(d, this.argument1), m.setInt16(d + 2, this.argument2)) : (m.setUint16(d, this.argument1), m.setUint16(d + 2, this.argument2)), d += 4) : (m.setUint8(d, this.argument1), m.setUint8(d + 1, this.argument2), d += 2), 256 & this.flags && (m.setUint16(d, this.instructions.length), d += 2, this.instructions.length && (new Uint8Array(m.buffer, 0, m.buffer.byteLength).set(this.instructions, d), d += this.instructions.length)), d - b;
        }
        scale(d, m) {
        }
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.OpenTypeFileBuilder = void 0;
      var o = f(3), g = f(2);
      function p(m, b, w) {
        m[b] = w >> 8 & 255, m[b + 1] = 255 & w;
      }
      function n(m, b, w) {
        m[b] = w >> 24 & 255, m[b + 1] = w >> 16 & 255, m[b + 2] = w >> 8 & 255, m[b + 3] = 255 & w;
      }
      function a(m, b, w) {
        if (w instanceof Uint8Array) m.set(w, b);
        else if (typeof w == "string") for (let v = 0, h = w.length; v < h; v++) m[b++] = 255 & w.charCodeAt(v);
        else for (const v of w) m[b++] = 255 & v;
      }
      class d {
        constructor(b) {
          this.sfnt = b, this.tables = /* @__PURE__ */ Object.create(null);
        }
        static getSearchParams(b, w) {
          let v = 1, h = 0;
          for (; (v ^ b) > v; )
            v <<= 1, h++;
          const x = v * w;
          return { range: x, entry: h, rangeShift: w * b - x };
        }
        toArray() {
          let b = this.sfnt;
          const w = this.tables, v = Object.keys(w);
          v.sort();
          const h = v.length;
          let x, _, M, O, E, I = 12 + 16 * h;
          const R = [I];
          for (x = 0; x < h; x++)
            O = w[v[x]], I += (O.length + 3 & -4) >>> 0, R.push(I);
          const W = new Uint8Array(I);
          for (x = 0; x < h; x++)
            O = w[v[x]], a(W, R[x], O);
          b === "true" && (b = (0, g.string32)(65536)), W[0] = 255 & b.charCodeAt(0), W[1] = 255 & b.charCodeAt(1), W[2] = 255 & b.charCodeAt(2), W[3] = 255 & b.charCodeAt(3), p(W, 4, h);
          const z = d.getSearchParams(h, 16);
          for (p(W, 6, z.range), p(W, 8, z.entry), p(W, 10, z.rangeShift), I = 12, x = 0; x < h; x++) {
            E = v[x], W[I] = 255 & E.charCodeAt(0), W[I + 1] = 255 & E.charCodeAt(1), W[I + 2] = 255 & E.charCodeAt(2), W[I + 3] = 255 & E.charCodeAt(3);
            let j = 0;
            for (_ = R[x], M = R[x + 1]; _ < M; _ += 4)
              j = j + (0, o.readUint32)(W, _) >>> 0;
            n(W, I + 4, j), n(W, I + 8, R[x]), n(W, I + 12, w[E].length), I += 16;
          }
          return W;
        }
        addTable(b, w) {
          if (b in this.tables) throw new Error("Table " + b + " already exists");
          this.tables[b] = w;
        }
      }
      l.OpenTypeFileBuilder = d;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Type1Font = void 0;
      var o = f(35), g = f(2), p = f(38), n = f(3), a = f(8), d = f(49);
      function m(b, w, v) {
        const h = b.length, x = w.length, _ = h - x;
        let M = v, O = !1;
        for (; M < _; ) {
          let E = 0;
          for (; E < x && b[M + E] === w[E]; ) E++;
          if (E >= x) {
            for (M += E; M < h && (0, n.isWhiteSpace)(b[M]); ) M++;
            O = !0;
            break;
          }
          M++;
        }
        return { found: O, length: M };
      }
      l.Type1Font = class {
        constructor(w, v, h) {
          let x = h.length1;
          h.length2;
          let _ = v.peekBytes(6);
          const M = _[0] === 128 && _[1] === 1;
          M && (v.skip(6), x = _[5] << 24 | _[4] << 16 | _[3] << 8 | _[2]);
          const O = function($, B) {
            const C = [101, 101, 120, 101, 99], T = $.pos;
            let F, S, A, U;
            try {
              F = $.getBytes(B), S = F.length;
            } catch {
            }
            if (S === B && (A = m(F, C, B - 2 * C.length), A.found && A.length === B))
              return { stream: new a.Stream(F), length: B };
            for ((0, g.warn)('Invalid "Length1" property in Type1 font -- trying to recover.'), $.pos = T; A = m($.peekBytes(2048), C, 0), A.length !== 0; )
              if ($.pos += A.length, A.found) {
                U = $.pos - T;
                break;
              }
            return $.pos = T, U ? { stream: new a.Stream($.getBytes(U)), length: U } : ((0, g.warn)('Unable to recover "Length1" property in Type1 font -- using as is.'), { stream: new a.Stream($.getBytes(B)), length: B });
          }(v, x);
          new d.Type1Parser(O.stream, !1, p.SEAC_ANALYSIS_ENABLED).extractFontHeader(h), M && (_ = v.getBytes(6), _[5] << 24 | _[4] << 16 | _[3] << 8 | _[2]);
          const E = function($, B) {
            const C = $.getBytes();
            if (C.length === 0) throw new g.FormatError("getEexecBlock - no font program found.");
            return { stream: new a.Stream(C), length: C.length };
          }(v), I = new d.Type1Parser(E.stream, !0, p.SEAC_ANALYSIS_ENABLED).extractFontProgram(h);
          for (const j in I.properties) h[j] = I.properties[j];
          const R = I.charstrings, W = this.getType2Charstrings(R), z = this.getType2Subrs(I.subrs);
          this.charstrings = R, this.data = this.wrap(w, W, this.charstrings, z, h), this.seacs = this.getSeacs(I.charstrings);
        }
        get numGlyphs() {
          return this.charstrings.length + 1;
        }
        getCharset() {
          const w = [".notdef"];
          for (const { glyphName: v } of this.charstrings) w.push(v);
          return w;
        }
        getGlyphMapping(w) {
          const v = this.charstrings;
          if (w.composite) {
            const O = /* @__PURE__ */ Object.create(null);
            for (let E = 0, I = v.length; E < I; E++)
              O[w.cMap.charCodeOf(E)] = E + 1;
            return O;
          }
          const h = [".notdef"];
          let x, _;
          for (_ = 0; _ < v.length; _++) h.push(v[_].glyphName);
          const M = w.builtInEncoding;
          if (M) {
            x = /* @__PURE__ */ Object.create(null);
            for (const O in M)
              _ = h.indexOf(M[O]), _ >= 0 && (x[O] = _);
          }
          return (0, p.type1FontGlyphMapping)(w, x, h);
        }
        hasGlyphId(w) {
          return w < 0 || w >= this.numGlyphs ? !1 : w === 0 ? !0 : this.charstrings[w - 1].charstring.length > 0;
        }
        getSeacs(w) {
          const v = [];
          for (let h = 0, x = w.length; h < x; h++) {
            const _ = w[h];
            _.seac && (v[h + 1] = _.seac);
          }
          return v;
        }
        getType2Charstrings(w) {
          const v = [];
          for (const h of w) v.push(h.charstring);
          return v;
        }
        getType2Subrs(w) {
          let v = 0;
          const h = w.length;
          v = h < 1133 ? 107 : h < 33769 ? 1131 : 32768;
          const x = [];
          let _;
          for (_ = 0; _ < v; _++) x.push([11]);
          for (_ = 0; _ < h; _++) x.push(w[_]);
          return x;
        }
        wrap(w, v, h, x, _) {
          const M = new o.CFF();
          M.header = new o.CFFHeader(1, 0, 4, 4), M.names = [w];
          const O = new o.CFFTopDict();
          O.setByName("version", 391), O.setByName("Notice", 392), O.setByName("FullName", 393), O.setByName("FamilyName", 394), O.setByName("Weight", 395), O.setByName("Encoding", null), O.setByName("FontMatrix", _.fontMatrix), O.setByName("FontBBox", _.bbox), O.setByName("charset", null), O.setByName("CharStrings", null), O.setByName("Private", null), M.topDict = O;
          const E = new o.CFFStrings();
          E.add("Version 0.11"), E.add("See original notice"), E.add(w), E.add(w), E.add("Medium"), M.strings = E, M.globalSubrIndex = new o.CFFIndex();
          const I = v.length, R = [".notdef"];
          let W, z;
          for (W = 0; W < I; W++) {
            const T = h[W].glyphName;
            o.CFFStandardStrings.indexOf(T) === -1 && E.add(T), R.push(T);
          }
          M.charset = new o.CFFCharset(!1, 0, R);
          const j = new o.CFFIndex();
          for (j.add([139, 14]), W = 0; W < I; W++) j.add(v[W]);
          M.charStrings = j;
          const $ = new o.CFFPrivateDict();
          $.setByName("Subrs", null);
          const B = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
          for (W = 0, z = B.length; W < z; W++) {
            const T = B[W];
            if (!(T in _.privateData)) continue;
            const F = _.privateData[T];
            if (Array.isArray(F)) for (let S = F.length - 1; S > 0; S--) F[S] -= F[S - 1];
            $.setByName(T, F);
          }
          M.topDict.privateDict = $;
          const C = new o.CFFIndex();
          for (W = 0, z = x.length; W < z; W++) C.add(x[W]);
          return $.subrsIndex = C, new o.CFFCompiler(M).compile();
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Type1Parser = void 0;
      var o = f(37), g = f(3), p = f(8), n = f(2);
      const a = [4], d = [5], m = [6], b = [7], w = [8], v = [12, 35], h = [14], x = [21], _ = [22], M = [30], O = [31];
      class E {
        constructor() {
          this.width = 0, this.lsb = 0, this.flexing = !1, this.output = [], this.stack = [];
        }
        convert(j, $, B) {
          const C = j.length;
          let T, F, S, A = !1;
          for (let U = 0; U < C; U++) {
            let K = j[U];
            if (K < 32) {
              switch (K === 12 && (K = (K << 8) + j[++U]), K) {
                case 1:
                case 3:
                case 9:
                case 3072:
                case 3073:
                case 3074:
                case 3105:
                  this.stack = [];
                  break;
                case 4:
                  if (this.flexing) {
                    if (this.stack.length < 1) {
                      A = !0;
                      break;
                    }
                    const N = this.stack.pop();
                    this.stack.push(0, N);
                    break;
                  }
                  A = this.executeCommand(1, a);
                  break;
                case 5:
                  A = this.executeCommand(2, d);
                  break;
                case 6:
                  A = this.executeCommand(1, m);
                  break;
                case 7:
                  A = this.executeCommand(1, b);
                  break;
                case 8:
                  A = this.executeCommand(6, w);
                  break;
                case 10:
                  if (this.stack.length < 1) {
                    A = !0;
                    break;
                  }
                  if (S = this.stack.pop(), !$[S]) {
                    A = !0;
                    break;
                  }
                  A = this.convert($[S], $, B);
                  break;
                case 11:
                  return A;
                case 13:
                  if (this.stack.length < 2) {
                    A = !0;
                    break;
                  }
                  T = this.stack.pop(), F = this.stack.pop(), this.lsb = F, this.width = T, this.stack.push(T, F), A = this.executeCommand(2, _);
                  break;
                case 14:
                  this.output.push(h[0]);
                  break;
                case 21:
                  if (this.flexing) break;
                  A = this.executeCommand(2, x);
                  break;
                case 22:
                  if (this.flexing) {
                    this.stack.push(0);
                    break;
                  }
                  A = this.executeCommand(1, _);
                  break;
                case 30:
                  A = this.executeCommand(4, M);
                  break;
                case 31:
                  A = this.executeCommand(4, O);
                  break;
                case 3078:
                  if (B) {
                    const N = this.stack.at(-5);
                    this.seac = this.stack.splice(-4, 4), this.seac[0] += this.lsb - N, A = this.executeCommand(0, h);
                  } else A = this.executeCommand(4, h);
                  break;
                case 3079:
                  if (this.stack.length < 4) {
                    A = !0;
                    break;
                  }
                  this.stack.pop(), T = this.stack.pop();
                  const X = this.stack.pop();
                  F = this.stack.pop(), this.lsb = F, this.width = T, this.stack.push(T, F, X), A = this.executeCommand(3, x);
                  break;
                case 3084:
                  if (this.stack.length < 2) {
                    A = !0;
                    break;
                  }
                  const L = this.stack.pop(), H = this.stack.pop();
                  this.stack.push(H / L);
                  break;
                case 3088:
                  if (this.stack.length < 2) {
                    A = !0;
                    break;
                  }
                  S = this.stack.pop();
                  const Q = this.stack.pop();
                  if (S === 0 && Q === 3) {
                    const N = this.stack.splice(-17, 17);
                    this.stack.push(N[2] + N[0], N[3] + N[1], N[4], N[5], N[6], N[7], N[8], N[9], N[10], N[11], N[12], N[13], N[14]), A = this.executeCommand(13, v, !0), this.flexing = !1, this.stack.push(N[15], N[16]);
                  } else S === 1 && Q === 0 && (this.flexing = !0);
                  break;
                case 3089:
                  break;
                default:
                  (0, n.warn)('Unknown type 1 charstring command of "' + K + '"');
              }
              if (A) break;
            } else
              K <= 246 ? K -= 139 : K = K <= 250 ? 256 * (K - 247) + j[++U] + 108 : K <= 254 ? -256 * (K - 251) - j[++U] - 108 : (255 & j[++U]) << 24 | (255 & j[++U]) << 16 | (255 & j[++U]) << 8 | (255 & j[++U]) << 0, this.stack.push(K);
          }
          return A;
        }
        executeCommand(j, $, B) {
          const C = this.stack.length;
          if (j > C) return !0;
          const T = C - j;
          for (let F = T; F < C; F++) {
            let S = this.stack[F];
            Number.isInteger(S) ? this.output.push(28, S >> 8 & 255, 255 & S) : (S = 65536 * S | 0, this.output.push(255, S >> 24 & 255, S >> 16 & 255, S >> 8 & 255, 255 & S));
          }
          return this.output.push(...$), B ? this.stack.splice(T, j) : this.stack.length = 0, !1;
        }
      }
      function I(z) {
        return z >= 48 && z <= 57 || z >= 65 && z <= 70 || z >= 97 && z <= 102;
      }
      function R(z, j, $) {
        if ($ >= z.length) return new Uint8Array(0);
        let B, C, T = 0 | j;
        for (B = 0; B < $; B++) T = 52845 * (z[B] + T) + 22719 & 65535;
        const F = z.length - $, S = new Uint8Array(F);
        for (B = $, C = 0; C < F; B++, C++) {
          const A = z[B];
          S[C] = A ^ T >> 8, T = 52845 * (A + T) + 22719 & 65535;
        }
        return S;
      }
      function W(z) {
        return z === 47 || z === 91 || z === 93 || z === 123 || z === 125 || z === 40 || z === 41;
      }
      l.Type1Parser = class {
        constructor(j, $, B) {
          if ($) {
            const C = j.getBytes(), T = !((I(C[0]) || (0, g.isWhiteSpace)(C[0])) && I(C[1]) && I(C[2]) && I(C[3]) && I(C[4]) && I(C[5]) && I(C[6]) && I(C[7]));
            j = new p.Stream(T ? R(C, 55665, 4) : function(S, A, U) {
              let K = 0 | A;
              const X = S.length, L = new Uint8Array(X >>> 1);
              let H, Q;
              for (H = 0, Q = 0; H < X; H++) {
                const N = S[H];
                if (!I(N)) continue;
                H++;
                let V;
                for (; H < X && !I(V = S[H]); ) H++;
                if (H < X) {
                  const Y = parseInt(String.fromCharCode(N, V), 16);
                  L[Q++] = Y ^ K >> 8, K = 52845 * (Y + K) + 22719 & 65535;
                }
              }
              return L.slice(U, Q);
            }(C, 55665, 4));
          }
          this.seacAnalysisEnabled = !!B, this.stream = j, this.nextChar();
        }
        readNumberArray() {
          this.getToken();
          const j = [];
          for (; ; ) {
            const $ = this.getToken();
            if ($ === null || $ === "]" || $ === "}") break;
            j.push(parseFloat($ || 0));
          }
          return j;
        }
        readNumber() {
          const j = this.getToken();
          return parseFloat(j || 0);
        }
        readInt() {
          const j = this.getToken();
          return 0 | parseInt(j || 0, 10);
        }
        readBoolean() {
          return this.getToken() === "true" ? 1 : 0;
        }
        nextChar() {
          return this.currentChar = this.stream.getByte();
        }
        prevChar() {
          return this.stream.skip(-2), this.currentChar = this.stream.getByte();
        }
        getToken() {
          let j = !1, $ = this.currentChar;
          for (; ; ) {
            if ($ === -1) return null;
            if (j) $ !== 10 && $ !== 13 || (j = !1);
            else if ($ === 37) j = !0;
            else if (!(0, g.isWhiteSpace)($)) break;
            $ = this.nextChar();
          }
          if (W($))
            return this.nextChar(), String.fromCharCode($);
          let B = "";
          do
            B += String.fromCharCode($), $ = this.nextChar();
          while ($ >= 0 && !(0, g.isWhiteSpace)($) && !W($));
          return B;
        }
        readCharStrings(j, $) {
          return $ === -1 ? j : R(j, 4330, $);
        }
        extractFontProgram(j) {
          const $ = this.stream, B = [], C = [], T = /* @__PURE__ */ Object.create(null);
          T.lenIV = 4;
          const F = { subrs: [], charstrings: [], properties: { privateData: T } };
          let S, A, U, K;
          for (; (S = this.getToken()) !== null; ) if (S === "/")
            switch (S = this.getToken(), S) {
              case "CharStrings":
                for (this.getToken(), this.getToken(), this.getToken(), this.getToken(); S = this.getToken(), !(S === null || S === "end"); ) {
                  if (S !== "/") continue;
                  const L = this.getToken();
                  A = this.readInt(), this.getToken(), U = A > 0 ? $.getBytes(A) : new Uint8Array(0), K = F.properties.privateData.lenIV;
                  const H = this.readCharStrings(U, K);
                  this.nextChar(), S = this.getToken(), S === "noaccess" ? this.getToken() : S === "/" && this.prevChar(), C.push({ glyph: L, encoded: H });
                }
                break;
              case "Subrs":
                for (this.readInt(), this.getToken(); this.getToken() === "dup"; ) {
                  const L = this.readInt();
                  A = this.readInt(), this.getToken(), U = A > 0 ? $.getBytes(A) : new Uint8Array(0), K = F.properties.privateData.lenIV;
                  const H = this.readCharStrings(U, K);
                  this.nextChar(), S = this.getToken(), S === "noaccess" && this.getToken(), B[L] = H;
                }
                break;
              case "BlueValues":
              case "OtherBlues":
              case "FamilyBlues":
              case "FamilyOtherBlues":
                const X = this.readNumberArray();
                X.length > 0 && X.length;
                break;
              case "StemSnapH":
              case "StemSnapV":
                F.properties.privateData[S] = this.readNumberArray();
                break;
              case "StdHW":
              case "StdVW":
                F.properties.privateData[S] = this.readNumberArray()[0];
                break;
              case "BlueShift":
              case "lenIV":
              case "BlueFuzz":
              case "BlueScale":
              case "LanguageGroup":
                F.properties.privateData[S] = this.readNumber();
                break;
              case "ExpansionFactor":
                F.properties.privateData[S] = this.readNumber() || 0.06;
                break;
              case "ForceBold":
                F.properties.privateData[S] = this.readBoolean();
            }
          for (const { encoded: X, glyph: L } of C) {
            const H = new E(), Q = H.convert(X, B, this.seacAnalysisEnabled);
            let N = H.output;
            Q && (N = [14]);
            const V = { glyphName: L, charstring: N, width: H.width, lsb: H.lsb, seac: H.seac };
            if (L === ".notdef" ? F.charstrings.unshift(V) : F.charstrings.push(V), j.builtInEncoding) {
              const Y = j.builtInEncoding.indexOf(L);
              Y > -1 && j.widths[Y] === void 0 && Y >= j.firstChar && Y <= j.lastChar && (j.widths[Y] = H.width);
            }
          }
          return F;
        }
        extractFontHeader(j) {
          let $;
          for (; ($ = this.getToken()) !== null; ) if ($ === "/")
            switch ($ = this.getToken(), $) {
              case "FontMatrix":
                const B = this.readNumberArray();
                j.fontMatrix = B;
                break;
              case "Encoding":
                const C = this.getToken();
                let T;
                if (/^\d+$/.test(C)) {
                  T = [];
                  const S = 0 | parseInt(C, 10);
                  this.getToken();
                  for (let A = 0; A < S; A++) {
                    for ($ = this.getToken(); $ !== "dup" && $ !== "def"; )
                      if ($ = this.getToken(), $ === null) return;
                    if ($ === "def") break;
                    const U = this.readInt();
                    this.getToken();
                    const K = this.getToken();
                    T[U] = K, this.getToken();
                  }
                } else T = (0, o.getEncoding)(C);
                j.builtInEncoding = T;
                break;
              case "FontBBox":
                const F = this.readNumberArray();
                j.ascent = Math.max(F[3], F[1]), j.descent = Math.min(F[1], F[3]), j.ascentScaled = !0;
            }
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Pattern = void 0, l.clearPatternCaches = function() {
        M = /* @__PURE__ */ Object.create(null);
      }, l.getTilingPatternIR = function(j, $, B) {
        const C = $.getArray("Matrix"), T = o.Util.normalizeRect($.getArray("BBox")), F = $.get("XStep"), S = $.get("YStep"), A = $.get("PaintType"), U = $.get("TilingType");
        if (T[2] - T[0] == 0 || T[3] - T[1] == 0) throw new o.FormatError(`Invalid getTilingPatternIR /BBox array: [${T}].`);
        return ["TilingPattern", B, j, C, T, F, S, A, U];
      };
      var o = f(2), g = f(5), p = f(12), n = f(3);
      const a = 2, d = 3, m = 4, b = 5, w = 6, v = 7;
      l.Pattern = class {
        constructor() {
          (0, o.unreachable)("Cannot initialize Pattern.");
        }
        static parseShading(j, $, B, C, T) {
          const F = j instanceof g.BaseStream ? j.dict : j, S = F.get("ShadingType");
          try {
            switch (S) {
              case a:
              case d:
                return new x(F, $, B, C, T);
              case m:
              case b:
              case w:
              case v:
                return new E(j, $, B, C, T);
              default:
                throw new o.FormatError("Unsupported ShadingType: " + S);
            }
          } catch (A) {
            if (A instanceof n.MissingDataException) throw A;
            return (0, o.warn)(A), new I();
          }
        }
      };
      const R = class R {
        constructor() {
          this.constructor === R && (0, o.unreachable)("Cannot initialize BaseShading.");
        }
        getIR() {
          (0, o.unreachable)("Abstract method `getIR` called.");
        }
      };
      Mr(R, "SMALL_NUMBER", 1e-6);
      let h = R;
      class x extends h {
        constructor(j, $, B, C, T) {
          super(), this.coordsArr = j.getArray("Coords"), this.shadingType = j.get("ShadingType");
          const F = p.ColorSpace.parse({ cs: j.getRaw("CS") || j.getRaw("ColorSpace"), xref: $, resources: B, pdfFunctionFactory: C, localColorSpaceCache: T }), S = j.getArray("BBox");
          this.bbox = Array.isArray(S) && S.length === 4 ? o.Util.normalizeRect(S) : null;
          let A = 0, U = 1;
          if (j.has("Domain")) {
            const ot = j.getArray("Domain");
            A = ot[0], U = ot[1];
          }
          let K = !1, X = !1;
          if (j.has("Extend")) {
            const ot = j.getArray("Extend");
            K = ot[0], X = ot[1];
          }
          if (!(this.shadingType !== d || K && X)) {
            const [ot, ut, ct, gt, dt, bt] = this.coordsArr, vt = Math.hypot(ot - gt, ut - dt);
            ct <= bt + vt && bt <= ct + vt && (0, o.warn)("Unsupported radial gradient.");
          }
          this.extendStart = K, this.extendEnd = X;
          const L = j.getRaw("Function"), H = C.createFromArray(L), Q = (U - A) / 840, N = this.colorStops = [];
          if (A >= U || Q <= 0) {
            (0, o.info)("Bad shading domain.");
            return;
          }
          const V = new Float32Array(F.numComps), Y = new Float32Array(1);
          let Z, rt = 0;
          Y[0] = A, H(Y, 0, V, 0);
          let st = F.getRgb(V, 0);
          const mt = o.Util.makeHexColor(st[0], st[1], st[2]);
          N.push([0, mt]);
          let yt = 1;
          Y[0] = A + Q, H(Y, 0, V, 0);
          let at = F.getRgb(V, 0), nt = at[0] - st[0] + 1, q = at[1] - st[1] + 1, D = at[2] - st[2] + 1, G = at[0] - st[0] - 1, et = at[1] - st[1] - 1, J = at[2] - st[2] - 1;
          for (let ot = 2; ot < 840; ot++) {
            Y[0] = A + ot * Q, H(Y, 0, V, 0), Z = F.getRgb(V, 0);
            const ut = ot - rt;
            if (nt = Math.min(nt, (Z[0] - st[0] + 1) / ut), q = Math.min(q, (Z[1] - st[1] + 1) / ut), D = Math.min(D, (Z[2] - st[2] + 1) / ut), G = Math.max(G, (Z[0] - st[0] - 1) / ut), et = Math.max(et, (Z[1] - st[1] - 1) / ut), J = Math.max(J, (Z[2] - st[2] - 1) / ut), !(G <= nt && et <= q && J <= D)) {
              const ct = o.Util.makeHexColor(at[0], at[1], at[2]);
              N.push([yt / 840, ct]), nt = Z[0] - at[0] + 1, q = Z[1] - at[1] + 1, D = Z[2] - at[2] + 1, G = Z[0] - at[0] - 1, et = Z[1] - at[1] - 1, J = Z[2] - at[2] - 1, rt = yt, st = at;
            }
            yt = ot, at = Z;
          }
          const it = o.Util.makeHexColor(at[0], at[1], at[2]);
          N.push([1, it]);
          let lt = "transparent";
          j.has("Background") && (Z = F.getRgb(j.get("Background"), 0), lt = o.Util.makeHexColor(Z[0], Z[1], Z[2])), K || (N.unshift([0, lt]), N[1][0] += h.SMALL_NUMBER), X || (N.at(-1)[0] -= h.SMALL_NUMBER, N.push([1, lt])), this.colorStops = N;
        }
        getIR() {
          const j = this.coordsArr, $ = this.shadingType;
          let B, C, T, F, S;
          return $ === a ? (C = [j[0], j[1]], T = [j[2], j[3]], F = null, S = null, B = "axial") : $ === d ? (C = [j[0], j[1]], T = [j[3], j[4]], F = j[2], S = j[5], B = "radial") : (0, o.unreachable)(`getPattern type unknown: ${$}`), ["RadialAxial", B, this.bbox, this.colorStops, C, T, F, S];
        }
      }
      class _ {
        constructor(j, $) {
          this.stream = j, this.context = $, this.buffer = 0, this.bufferLength = 0;
          const B = $.numComps;
          this.tmpCompsBuf = new Float32Array(B);
          const C = $.colorSpace.numComps;
          this.tmpCsCompsBuf = $.colorFn ? new Float32Array(C) : this.tmpCompsBuf;
        }
        get hasData() {
          if (this.stream.end) return this.stream.pos < this.stream.end;
          if (this.bufferLength > 0) return !0;
          const j = this.stream.getByte();
          return j < 0 ? !1 : (this.buffer = j, this.bufferLength = 8, !0);
        }
        readBits(j) {
          let $ = this.buffer, B = this.bufferLength;
          if (j === 32) {
            if (B === 0) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
            $ = $ << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
            const C = this.stream.getByte();
            return this.buffer = C & (1 << B) - 1, ($ << 8 - B | (255 & C) >> B) >>> 0;
          }
          if (j === 8 && B === 0) return this.stream.getByte();
          for (; B < j; )
            $ = $ << 8 | this.stream.getByte(), B += 8;
          return B -= j, this.bufferLength = B, this.buffer = $ & (1 << B) - 1, $ >> B;
        }
        align() {
          this.buffer = 0, this.bufferLength = 0;
        }
        readFlag() {
          return this.readBits(this.context.bitsPerFlag);
        }
        readCoordinate() {
          const j = this.context.bitsPerCoordinate, $ = this.readBits(j), B = this.readBits(j), C = this.context.decode, T = j < 32 ? 1 / ((1 << j) - 1) : 23283064365386963e-26;
          return [$ * T * (C[1] - C[0]) + C[0], B * T * (C[3] - C[2]) + C[2]];
        }
        readComponents() {
          const j = this.context.numComps, $ = this.context.bitsPerComponent, B = $ < 32 ? 1 / ((1 << $) - 1) : 23283064365386963e-26, C = this.context.decode, T = this.tmpCompsBuf;
          for (let S = 0, A = 4; S < j; S++, A += 2) {
            const U = this.readBits($);
            T[S] = U * B * (C[A + 1] - C[A]) + C[A];
          }
          const F = this.tmpCsCompsBuf;
          return this.context.colorFn && this.context.colorFn(T, 0, F, 0), this.context.colorSpace.getRgb(F, 0);
        }
      }
      let M = /* @__PURE__ */ Object.create(null);
      function O(z) {
        return M[z] || (M[z] = function($) {
          const B = [];
          for (let C = 0; C <= $; C++) {
            const T = C / $, F = 1 - T;
            B.push(new Float32Array([F ** 3, 3 * T * F ** 2, 3 * T ** 2 * F, T ** 3]));
          }
          return B;
        }(z));
      }
      const W = class W extends h {
        constructor(j, $, B, C, T) {
          if (super(), !(j instanceof g.BaseStream)) throw new o.FormatError("Mesh data is not a stream");
          const F = j.dict;
          this.shadingType = F.get("ShadingType");
          const S = F.getArray("BBox");
          this.bbox = Array.isArray(S) && S.length === 4 ? o.Util.normalizeRect(S) : null;
          const A = p.ColorSpace.parse({ cs: F.getRaw("CS") || F.getRaw("ColorSpace"), xref: $, resources: B, pdfFunctionFactory: C, localColorSpaceCache: T });
          this.background = F.has("Background") ? A.getRgb(F.get("Background"), 0) : null;
          const U = F.getRaw("Function"), K = U ? C.createFromArray(U) : null;
          this.coords = [], this.colors = [], this.figures = [];
          const X = { bitsPerCoordinate: F.get("BitsPerCoordinate"), bitsPerComponent: F.get("BitsPerComponent"), bitsPerFlag: F.get("BitsPerFlag"), decode: F.getArray("Decode"), colorFn: K, colorSpace: A, numComps: K ? 1 : A.numComps }, L = new _(j, X);
          let H = !1;
          switch (this.shadingType) {
            case m:
              this._decodeType4Shading(L);
              break;
            case b:
              const Q = 0 | F.get("VerticesPerRow");
              if (Q < 2) throw new o.FormatError("Invalid VerticesPerRow");
              this._decodeType5Shading(L, Q);
              break;
            case w:
              this._decodeType6Shading(L), H = !0;
              break;
            case v:
              this._decodeType7Shading(L), H = !0;
              break;
            default:
              (0, o.unreachable)("Unsupported mesh type.");
          }
          if (H) {
            this._updateBounds();
            for (let Q = 0, N = this.figures.length; Q < N; Q++) this._buildFigureFromPatch(Q);
          }
          this._updateBounds(), this._packData();
        }
        _decodeType4Shading(j) {
          const $ = this.coords, B = this.colors, C = [];
          let T = 0;
          for (; j.hasData; ) {
            const F = j.readFlag(), S = j.readCoordinate(), A = j.readComponents();
            if (T === 0) {
              if (!(0 <= F && F <= 2)) throw new o.FormatError("Unknown type4 flag");
              switch (F) {
                case 0:
                  T = 3;
                  break;
                case 1:
                  C.push(C.at(-2), C.at(-1)), T = 1;
                  break;
                case 2:
                  C.push(C.at(-3), C.at(-1)), T = 1;
              }
            }
            C.push($.length), $.push(S), B.push(A), T--, j.align();
          }
          this.figures.push({ type: "triangles", coords: new Int32Array(C), colors: new Int32Array(C) });
        }
        _decodeType5Shading(j, $) {
          const B = this.coords, C = this.colors, T = [];
          for (; j.hasData; ) {
            const F = j.readCoordinate(), S = j.readComponents();
            T.push(B.length), B.push(F), C.push(S);
          }
          this.figures.push({ type: "lattice", coords: new Int32Array(T), colors: new Int32Array(T), verticesPerRow: $ });
        }
        _decodeType6Shading(j) {
          const $ = this.coords, B = this.colors, C = new Int32Array(16), T = new Int32Array(4);
          for (; j.hasData; ) {
            const F = j.readFlag();
            if (!(0 <= F && F <= 3)) throw new o.FormatError("Unknown type6 flag");
            const S = $.length;
            for (let H = 0, Q = F !== 0 ? 8 : 12; H < Q; H++) $.push(j.readCoordinate());
            const A = B.length;
            for (let H = 0, Q = F !== 0 ? 2 : 4; H < Q; H++) B.push(j.readComponents());
            let U, K, X, L;
            switch (F) {
              case 0:
                C[12] = S + 3, C[13] = S + 4, C[14] = S + 5, C[15] = S + 6, C[8] = S + 2, C[11] = S + 7, C[4] = S + 1, C[7] = S + 8, C[0] = S, C[1] = S + 11, C[2] = S + 10, C[3] = S + 9, T[2] = A + 1, T[3] = A + 2, T[0] = A, T[1] = A + 3;
                break;
              case 1:
                U = C[12], K = C[13], X = C[14], L = C[15], C[12] = L, C[13] = S + 0, C[14] = S + 1, C[15] = S + 2, C[8] = X, C[11] = S + 3, C[4] = K, C[7] = S + 4, C[0] = U, C[1] = S + 7, C[2] = S + 6, C[3] = S + 5, U = T[2], K = T[3], T[2] = K, T[3] = A, T[0] = U, T[1] = A + 1;
                break;
              case 2:
                U = C[15], K = C[11], C[12] = C[3], C[13] = S + 0, C[14] = S + 1, C[15] = S + 2, C[8] = C[7], C[11] = S + 3, C[4] = K, C[7] = S + 4, C[0] = U, C[1] = S + 7, C[2] = S + 6, C[3] = S + 5, U = T[3], T[2] = T[1], T[3] = A, T[0] = U, T[1] = A + 1;
                break;
              case 3:
                C[12] = C[0], C[13] = S + 0, C[14] = S + 1, C[15] = S + 2, C[8] = C[1], C[11] = S + 3, C[4] = C[2], C[7] = S + 4, C[0] = C[3], C[1] = S + 7, C[2] = S + 6, C[3] = S + 5, T[2] = T[0], T[3] = A, T[0] = T[1], T[1] = A + 1;
            }
            C[5] = $.length, $.push([(-4 * $[C[0]][0] - $[C[15]][0] + 6 * ($[C[4]][0] + $[C[1]][0]) - 2 * ($[C[12]][0] + $[C[3]][0]) + 3 * ($[C[13]][0] + $[C[7]][0])) / 9, (-4 * $[C[0]][1] - $[C[15]][1] + 6 * ($[C[4]][1] + $[C[1]][1]) - 2 * ($[C[12]][1] + $[C[3]][1]) + 3 * ($[C[13]][1] + $[C[7]][1])) / 9]), C[6] = $.length, $.push([(-4 * $[C[3]][0] - $[C[12]][0] + 6 * ($[C[2]][0] + $[C[7]][0]) - 2 * ($[C[0]][0] + $[C[15]][0]) + 3 * ($[C[4]][0] + $[C[14]][0])) / 9, (-4 * $[C[3]][1] - $[C[12]][1] + 6 * ($[C[2]][1] + $[C[7]][1]) - 2 * ($[C[0]][1] + $[C[15]][1]) + 3 * ($[C[4]][1] + $[C[14]][1])) / 9]), C[9] = $.length, $.push([(-4 * $[C[12]][0] - $[C[3]][0] + 6 * ($[C[8]][0] + $[C[13]][0]) - 2 * ($[C[0]][0] + $[C[15]][0]) + 3 * ($[C[11]][0] + $[C[1]][0])) / 9, (-4 * $[C[12]][1] - $[C[3]][1] + 6 * ($[C[8]][1] + $[C[13]][1]) - 2 * ($[C[0]][1] + $[C[15]][1]) + 3 * ($[C[11]][1] + $[C[1]][1])) / 9]), C[10] = $.length, $.push([(-4 * $[C[15]][0] - $[C[0]][0] + 6 * ($[C[11]][0] + $[C[14]][0]) - 2 * ($[C[12]][0] + $[C[3]][0]) + 3 * ($[C[2]][0] + $[C[8]][0])) / 9, (-4 * $[C[15]][1] - $[C[0]][1] + 6 * ($[C[11]][1] + $[C[14]][1]) - 2 * ($[C[12]][1] + $[C[3]][1]) + 3 * ($[C[2]][1] + $[C[8]][1])) / 9]), this.figures.push({ type: "patch", coords: new Int32Array(C), colors: new Int32Array(T) });
          }
        }
        _decodeType7Shading(j) {
          const $ = this.coords, B = this.colors, C = new Int32Array(16), T = new Int32Array(4);
          for (; j.hasData; ) {
            const F = j.readFlag();
            if (!(0 <= F && F <= 3)) throw new o.FormatError("Unknown type7 flag");
            const S = $.length;
            for (let H = 0, Q = F !== 0 ? 12 : 16; H < Q; H++) $.push(j.readCoordinate());
            const A = B.length;
            for (let H = 0, Q = F !== 0 ? 2 : 4; H < Q; H++) B.push(j.readComponents());
            let U, K, X, L;
            switch (F) {
              case 0:
                C[12] = S + 3, C[13] = S + 4, C[14] = S + 5, C[15] = S + 6, C[8] = S + 2, C[9] = S + 13, C[10] = S + 14, C[11] = S + 7, C[4] = S + 1, C[5] = S + 12, C[6] = S + 15, C[7] = S + 8, C[0] = S, C[1] = S + 11, C[2] = S + 10, C[3] = S + 9, T[2] = A + 1, T[3] = A + 2, T[0] = A, T[1] = A + 3;
                break;
              case 1:
                U = C[12], K = C[13], X = C[14], L = C[15], C[12] = L, C[13] = S + 0, C[14] = S + 1, C[15] = S + 2, C[8] = X, C[9] = S + 9, C[10] = S + 10, C[11] = S + 3, C[4] = K, C[5] = S + 8, C[6] = S + 11, C[7] = S + 4, C[0] = U, C[1] = S + 7, C[2] = S + 6, C[3] = S + 5, U = T[2], K = T[3], T[2] = K, T[3] = A, T[0] = U, T[1] = A + 1;
                break;
              case 2:
                U = C[15], K = C[11], C[12] = C[3], C[13] = S + 0, C[14] = S + 1, C[15] = S + 2, C[8] = C[7], C[9] = S + 9, C[10] = S + 10, C[11] = S + 3, C[4] = K, C[5] = S + 8, C[6] = S + 11, C[7] = S + 4, C[0] = U, C[1] = S + 7, C[2] = S + 6, C[3] = S + 5, U = T[3], T[2] = T[1], T[3] = A, T[0] = U, T[1] = A + 1;
                break;
              case 3:
                C[12] = C[0], C[13] = S + 0, C[14] = S + 1, C[15] = S + 2, C[8] = C[1], C[9] = S + 9, C[10] = S + 10, C[11] = S + 3, C[4] = C[2], C[5] = S + 8, C[6] = S + 11, C[7] = S + 4, C[0] = C[3], C[1] = S + 7, C[2] = S + 6, C[3] = S + 5, T[2] = T[0], T[3] = A, T[0] = T[1], T[1] = A + 1;
            }
            this.figures.push({ type: "patch", coords: new Int32Array(C), colors: new Int32Array(T) });
          }
        }
        _buildFigureFromPatch(j) {
          const $ = this.figures[j];
          (0, o.assert)($.type === "patch", "Unexpected patch mesh figure");
          const B = this.coords, C = this.colors, T = $.coords, F = $.colors, S = Math.min(B[T[0]][0], B[T[3]][0], B[T[12]][0], B[T[15]][0]), A = Math.min(B[T[0]][1], B[T[3]][1], B[T[12]][1], B[T[15]][1]), U = Math.max(B[T[0]][0], B[T[3]][0], B[T[12]][0], B[T[15]][0]), K = Math.max(B[T[0]][1], B[T[3]][1], B[T[12]][1], B[T[15]][1]);
          let X = Math.ceil((U - S) * W.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
          X = Math.max(W.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(W.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, X));
          let L = Math.ceil((K - A) * W.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
          L = Math.max(W.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(W.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, L));
          const H = X + 1, Q = new Int32Array((L + 1) * H), N = new Int32Array((L + 1) * H);
          let V = 0;
          const Y = new Uint8Array(3), Z = new Uint8Array(3), rt = C[F[0]], st = C[F[1]], mt = C[F[2]], yt = C[F[3]], at = O(L), nt = O(X);
          for (let q = 0; q <= L; q++) {
            Y[0] = (rt[0] * (L - q) + mt[0] * q) / L | 0, Y[1] = (rt[1] * (L - q) + mt[1] * q) / L | 0, Y[2] = (rt[2] * (L - q) + mt[2] * q) / L | 0, Z[0] = (st[0] * (L - q) + yt[0] * q) / L | 0, Z[1] = (st[1] * (L - q) + yt[1] * q) / L | 0, Z[2] = (st[2] * (L - q) + yt[2] * q) / L | 0;
            for (let D = 0; D <= X; D++, V++) {
              if (!(q !== 0 && q !== L || D !== 0 && D !== X)) continue;
              let G = 0, et = 0, J = 0;
              for (let lt = 0; lt <= 3; lt++) for (let ot = 0; ot <= 3; ot++, J++) {
                const ut = at[q][lt] * nt[D][ot];
                G += B[T[J]][0] * ut, et += B[T[J]][1] * ut;
              }
              Q[V] = B.length, B.push([G, et]), N[V] = C.length;
              const it = new Uint8Array(3);
              it[0] = (Y[0] * (X - D) + Z[0] * D) / X | 0, it[1] = (Y[1] * (X - D) + Z[1] * D) / X | 0, it[2] = (Y[2] * (X - D) + Z[2] * D) / X | 0, C.push(it);
            }
          }
          Q[0] = T[0], N[0] = F[0], Q[X] = T[3], N[X] = F[1], Q[H * L] = T[12], N[H * L] = F[2], Q[H * L + X] = T[15], N[H * L + X] = F[3], this.figures[j] = { type: "lattice", coords: Q, colors: N, verticesPerRow: H };
        }
        _updateBounds() {
          let j = this.coords[0][0], $ = this.coords[0][1], B = j, C = $;
          for (let T = 1, F = this.coords.length; T < F; T++) {
            const S = this.coords[T][0], A = this.coords[T][1];
            j = j > S ? S : j, $ = $ > A ? A : $, B = B < S ? S : B, C = C < A ? A : C;
          }
          this.bounds = [j, $, B, C];
        }
        _packData() {
          let j, $, B, C;
          const T = this.coords, F = new Float32Array(2 * T.length);
          for (j = 0, B = 0, $ = T.length; j < $; j++) {
            const K = T[j];
            F[B++] = K[0], F[B++] = K[1];
          }
          this.coords = F;
          const S = this.colors, A = new Uint8Array(3 * S.length);
          for (j = 0, B = 0, $ = S.length; j < $; j++) {
            const K = S[j];
            A[B++] = K[0], A[B++] = K[1], A[B++] = K[2];
          }
          this.colors = A;
          const U = this.figures;
          for (j = 0, $ = U.length; j < $; j++) {
            const K = U[j], X = K.coords, L = K.colors;
            for (B = 0, C = X.length; B < C; B++)
              X[B] *= 2, L[B] *= 3;
          }
        }
        getIR() {
          return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.bbox, this.background];
        }
      };
      Mr(W, "MIN_SPLIT_PATCH_CHUNKS_AMOUNT", 3), Mr(W, "MAX_SPLIT_PATCH_CHUNKS_AMOUNT", 20), Mr(W, "TRIANGLE_DENSITY", 20);
      let E = W;
      class I extends h {
        getIR() {
          return ["Dummy"];
        }
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.getXfaFontDict = function(x) {
        const _ = function(R) {
          const W = v(R);
          if (!W) return null;
          const { baseWidths: z, baseMapping: j, factors: $ } = W, B = $ ? z.map((S, A) => S * $[A]) : z;
          let C, T = -2;
          const F = [];
          for (const [S, A] of j.map((U, K) => [U, K]).sort(([U], [K]) => U - K)) S !== -1 && (S === T + 1 ? (C.push(B[A]), T += 1) : (T = S, C = [B[A]], F.push(S, C)));
          return F;
        }(x), M = new g.Dict(null);
        M.set("BaseFont", g.Name.get(x)), M.set("Type", g.Name.get("Font")), M.set("Subtype", g.Name.get("CIDFontType2")), M.set("Encoding", g.Name.get("Identity-H")), M.set("CIDToGIDMap", g.Name.get("Identity")), M.set("W", _), M.set("FirstChar", _[0]), M.set("LastChar", _.at(-2) + _.at(-1).length - 1);
        const O = new g.Dict(null);
        M.set("FontDescriptor", O);
        const E = new g.Dict(null);
        return E.set("Ordering", "Identity"), E.set("Registry", "Adobe"), E.set("Supplement", 0), M.set("CIDSystemInfo", E), M;
      }, l.getXfaFontName = v;
      var o = f(52), g = f(4), p = f(53), n = f(54), a = f(55), d = f(56), m = f(3), b = f(38);
      const w = (0, m.getLookupTableFactory)(function(h) {
        h["MyriadPro-Regular"] = h["PdfJS-Fallback-Regular"] = { name: "LiberationSans-Regular", factors: a.MyriadProRegularFactors, baseWidths: n.LiberationSansRegularWidths, baseMapping: n.LiberationSansRegularMapping, metrics: a.MyriadProRegularMetrics }, h["MyriadPro-Bold"] = h["PdfJS-Fallback-Bold"] = { name: "LiberationSans-Bold", factors: a.MyriadProBoldFactors, baseWidths: n.LiberationSansBoldWidths, baseMapping: n.LiberationSansBoldMapping, metrics: a.MyriadProBoldMetrics }, h["MyriadPro-It"] = h["MyriadPro-Italic"] = h["PdfJS-Fallback-Italic"] = { name: "LiberationSans-Italic", factors: a.MyriadProItalicFactors, baseWidths: n.LiberationSansItalicWidths, baseMapping: n.LiberationSansItalicMapping, metrics: a.MyriadProItalicMetrics }, h["MyriadPro-BoldIt"] = h["MyriadPro-BoldItalic"] = h["PdfJS-Fallback-BoldItalic"] = { name: "LiberationSans-BoldItalic", factors: a.MyriadProBoldItalicFactors, baseWidths: n.LiberationSansBoldItalicWidths, baseMapping: n.LiberationSansBoldItalicMapping, metrics: a.MyriadProBoldItalicMetrics }, h.ArialMT = h.Arial = h["Arial-Regular"] = { name: "LiberationSans-Regular", baseWidths: n.LiberationSansRegularWidths, baseMapping: n.LiberationSansRegularMapping }, h["Arial-BoldMT"] = h["Arial-Bold"] = { name: "LiberationSans-Bold", baseWidths: n.LiberationSansBoldWidths, baseMapping: n.LiberationSansBoldMapping }, h["Arial-ItalicMT"] = h["Arial-Italic"] = { name: "LiberationSans-Italic", baseWidths: n.LiberationSansItalicWidths, baseMapping: n.LiberationSansItalicMapping }, h["Arial-BoldItalicMT"] = h["Arial-BoldItalic"] = { name: "LiberationSans-BoldItalic", baseWidths: n.LiberationSansBoldItalicWidths, baseMapping: n.LiberationSansBoldItalicMapping }, h["Calibri-Regular"] = { name: "LiberationSans-Regular", factors: o.CalibriRegularFactors, baseWidths: n.LiberationSansRegularWidths, baseMapping: n.LiberationSansRegularMapping, metrics: o.CalibriRegularMetrics }, h["Calibri-Bold"] = { name: "LiberationSans-Bold", factors: o.CalibriBoldFactors, baseWidths: n.LiberationSansBoldWidths, baseMapping: n.LiberationSansBoldMapping, metrics: o.CalibriBoldMetrics }, h["Calibri-Italic"] = { name: "LiberationSans-Italic", factors: o.CalibriItalicFactors, baseWidths: n.LiberationSansItalicWidths, baseMapping: n.LiberationSansItalicMapping, metrics: o.CalibriItalicMetrics }, h["Calibri-BoldItalic"] = { name: "LiberationSans-BoldItalic", factors: o.CalibriBoldItalicFactors, baseWidths: n.LiberationSansBoldItalicWidths, baseMapping: n.LiberationSansBoldItalicMapping, metrics: o.CalibriBoldItalicMetrics }, h["Segoeui-Regular"] = { name: "LiberationSans-Regular", factors: d.SegoeuiRegularFactors, baseWidths: n.LiberationSansRegularWidths, baseMapping: n.LiberationSansRegularMapping, metrics: d.SegoeuiRegularMetrics }, h["Segoeui-Bold"] = { name: "LiberationSans-Bold", factors: d.SegoeuiBoldFactors, baseWidths: n.LiberationSansBoldWidths, baseMapping: n.LiberationSansBoldMapping, metrics: d.SegoeuiBoldMetrics }, h["Segoeui-Italic"] = { name: "LiberationSans-Italic", factors: d.SegoeuiItalicFactors, baseWidths: n.LiberationSansItalicWidths, baseMapping: n.LiberationSansItalicMapping, metrics: d.SegoeuiItalicMetrics }, h["Segoeui-BoldItalic"] = { name: "LiberationSans-BoldItalic", factors: d.SegoeuiBoldItalicFactors, baseWidths: n.LiberationSansBoldItalicWidths, baseMapping: n.LiberationSansBoldItalicMapping, metrics: d.SegoeuiBoldItalicMetrics }, h["Helvetica-Regular"] = h.Helvetica = { name: "LiberationSans-Regular", factors: p.HelveticaRegularFactors, baseWidths: n.LiberationSansRegularWidths, baseMapping: n.LiberationSansRegularMapping, metrics: p.HelveticaRegularMetrics }, h["Helvetica-Bold"] = { name: "LiberationSans-Bold", factors: p.HelveticaBoldFactors, baseWidths: n.LiberationSansBoldWidths, baseMapping: n.LiberationSansBoldMapping, metrics: p.HelveticaBoldMetrics }, h["Helvetica-Italic"] = { name: "LiberationSans-Italic", factors: p.HelveticaItalicFactors, baseWidths: n.LiberationSansItalicWidths, baseMapping: n.LiberationSansItalicMapping, metrics: p.HelveticaItalicMetrics }, h["Helvetica-BoldItalic"] = { name: "LiberationSans-BoldItalic", factors: p.HelveticaBoldItalicFactors, baseWidths: n.LiberationSansBoldItalicWidths, baseMapping: n.LiberationSansBoldItalicMapping, metrics: p.HelveticaBoldItalicMetrics };
      });
      function v(h) {
        const x = (0, b.normalizeFontName)(h);
        return w()[x];
      }
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CalibriRegularMetrics = l.CalibriRegularFactors = l.CalibriItalicMetrics = l.CalibriItalicFactors = l.CalibriBoldMetrics = l.CalibriBoldItalicMetrics = l.CalibriBoldItalicFactors = l.CalibriBoldFactors = void 0, l.CalibriBoldFactors = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.54657, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.73293, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.9121, 0.86943, 0.79795, 0.88198, 0.77958, 0.70864, 0.81055, 0.90399, 0.88653, 0.96017, 0.82577, 0.77892, 0.78257, 0.97507, 1.54657, 0.97507, 0.85284, 0.89552, 0.90176, 0.88762, 0.8785, 0.75241, 0.8785, 0.90518, 0.95015, 0.77618, 0.8785, 0.88401, 0.91916, 0.86304, 0.88401, 0.91488, 0.8785, 0.8801, 0.8785, 0.8785, 0.91343, 0.7173, 1.04106, 0.8785, 0.85075, 0.95794, 0.82616, 0.85162, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.12401, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.73293, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.9121, 0.86943, 0.86943, 0.86943, 0.86943, 0.86943, 0.85284, 0.87508, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.8715, 0.75241, 0.90518, 0.90518, 0.90518, 0.90518, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.8785, 0.8801, 0.8801, 0.8801, 0.8801, 0.8801, 0.90747, 0.89049, 0.8785, 0.8785, 0.8785, 0.8785, 0.85162, 0.8785, 0.85162, 0.83908, 0.88762, 0.83908, 0.88762, 0.83908, 0.88762, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.87289, 0.83016, 0.88506, 0.93125, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.81921, 0.77618, 0.81921, 0.77618, 0.81921, 0.77618, 1, 1, 0.87356, 0.8785, 0.91075, 0.89608, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76229, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.79468, 0.91926, 0.88175, 0.70823, 0.94903, 0.9121, 0.8785, 1, 1, 0.9121, 0.8785, 0.87802, 0.88656, 0.8785, 0.86943, 0.8801, 0.86943, 0.8801, 0.86943, 0.8801, 0.87402, 0.89291, 0.77958, 0.91343, 1, 1, 0.77958, 0.91343, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.96017, 0.95794, 0.77892, 0.85162, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.88762, 0.77539, 0.8715, 0.87508, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70674, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.06303, 0.83908, 0.80352, 0.57184, 0.6965, 0.56289, 0.82001, 0.56029, 0.81235, 1.02988, 0.83908, 0.7762, 0.68156, 0.80367, 0.73133, 0.78257, 0.87356, 0.86943, 0.95958, 0.75727, 0.89019, 1.04924, 0.9121, 0.7648, 0.86943, 0.87356, 0.79795, 0.78275, 0.81055, 0.77892, 0.9762, 0.82577, 0.99819, 0.84896, 0.95958, 0.77892, 0.96108, 1.01407, 0.89049, 1.02988, 0.94211, 0.96108, 0.8936, 0.84021, 0.87842, 0.96399, 0.79109, 0.89049, 1.00813, 1.02988, 0.86077, 0.87445, 0.92099, 0.84723, 0.86513, 0.8801, 0.75638, 0.85714, 0.78216, 0.79586, 0.87965, 0.94211, 0.97747, 0.78287, 0.97926, 0.84971, 1.02988, 0.94211, 0.8801, 0.94211, 0.84971, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90548, 1, 1, 1, 1, 1, 1, 0.96017, 0.95794, 0.96017, 0.95794, 0.96017, 0.95794, 0.77892, 0.85162, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.92794, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71143, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.93835, 0.83406, 0.91133, 0.84107, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90527, 1.81055, 0.90527, 1.81055, 1.31006, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.CalibriBoldMetrics = { lineHeight: 1.2207, lineGap: 0.2207 }, l.CalibriBoldItalicFactors = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.56239, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.71805, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.90872, 0.85938, 0.79795, 0.87068, 0.77958, 0.69766, 0.81055, 0.90399, 0.88653, 0.96068, 0.82577, 0.77892, 0.78257, 0.97507, 1.529, 0.97507, 0.85284, 0.89552, 0.90176, 0.94908, 0.86411, 0.74012, 0.86411, 0.88323, 0.95015, 0.86411, 0.86331, 0.88401, 0.91916, 0.86304, 0.88401, 0.9039, 0.86331, 0.86331, 0.86411, 0.86411, 0.90464, 0.70852, 1.04106, 0.86331, 0.84372, 0.95794, 0.82616, 0.84548, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.19129, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.71805, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.90872, 0.85938, 0.85938, 0.85938, 0.85938, 0.85938, 0.85284, 0.87068, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.85887, 0.74012, 0.88323, 0.88323, 0.88323, 0.88323, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.90747, 0.89049, 0.86331, 0.86331, 0.86331, 0.86331, 0.84548, 0.86411, 0.84548, 0.83908, 0.94908, 0.83908, 0.94908, 0.83908, 0.94908, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.87289, 0.79538, 0.88506, 0.92726, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.81921, 0.86411, 0.81921, 0.86411, 0.81921, 0.86411, 1, 1, 0.87356, 0.86331, 0.91075, 0.8777, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76467, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.77312, 0.91926, 0.88175, 0.70823, 0.94903, 0.90872, 0.86331, 1, 1, 0.90872, 0.86331, 0.86906, 0.88116, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.87402, 0.86549, 0.77958, 0.90464, 1, 1, 0.77958, 0.90464, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.96068, 0.95794, 0.77892, 0.84548, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.94908, 0.77539, 0.85887, 0.87068, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70088, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.48387, 0.83908, 0.80352, 0.57118, 0.6965, 0.56347, 0.79179, 0.55853, 0.80346, 1.02988, 0.83908, 0.7762, 0.67174, 0.86036, 0.73133, 0.78257, 0.87356, 0.86441, 0.95958, 0.75727, 0.89019, 1.04924, 0.90872, 0.74889, 0.85938, 0.87891, 0.79795, 0.7957, 0.81055, 0.77892, 0.97447, 0.82577, 0.97466, 0.87179, 0.95958, 0.77892, 0.94252, 0.95612, 0.8753, 1.02988, 0.92733, 0.94252, 0.87411, 0.84021, 0.8728, 0.95612, 0.74081, 0.8753, 1.02189, 1.02988, 0.84814, 0.87445, 0.91822, 0.84723, 0.85668, 0.86331, 0.81344, 0.87581, 0.76422, 0.82046, 0.96057, 0.92733, 0.99375, 0.78022, 0.95452, 0.86015, 1.02988, 0.92733, 0.86331, 0.92733, 0.86015, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85174, 1, 1, 1, 1, 1, 1, 0.96068, 0.95794, 0.96068, 0.95794, 0.96068, 0.95794, 0.77892, 0.84548, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.89807, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71094, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.92972, 0.83406, 0.91133, 0.83326, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90616, 1.81055, 0.90527, 1.81055, 1.3107, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.CalibriBoldItalicMetrics = { lineHeight: 1.2207, lineGap: 0.2207 }, l.CalibriItalicFactors = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39543, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.72346, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89249, 0.84118, 0.77452, 0.85374, 0.75186, 0.67789, 0.79776, 0.88844, 0.85066, 0.94309, 0.77818, 0.7306, 0.76659, 1.10369, 1.38313, 1.10369, 1.06139, 0.89552, 0.8739, 0.9245, 0.9245, 0.83203, 0.9245, 0.85865, 1.09842, 0.9245, 0.9245, 1.03297, 1.07692, 0.90918, 1.03297, 0.94959, 0.9245, 0.92274, 0.9245, 0.9245, 1.02933, 0.77832, 1.20562, 0.9245, 0.8916, 0.98986, 0.86621, 0.89453, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.16359, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.72346, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89249, 0.84118, 0.84118, 0.84118, 0.84118, 0.84118, 0.85284, 0.84557, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.84843, 0.83203, 0.85865, 0.85865, 0.85865, 0.85865, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.9245, 0.92274, 0.92274, 0.92274, 0.92274, 0.92274, 0.90747, 0.86651, 0.9245, 0.9245, 0.9245, 0.9245, 0.89453, 0.9245, 0.89453, 0.8675, 0.9245, 0.8675, 0.9245, 0.8675, 0.9245, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.85193, 0.8875, 0.86477, 0.99034, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.81105, 0.9245, 0.81105, 0.9245, 0.81105, 0.9245, 1, 1, 0.86275, 0.9245, 0.90872, 0.93591, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77896, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.9375, 0.98156, 0.93407, 0.77261, 1.11429, 0.89249, 0.9245, 1, 1, 0.89249, 0.9245, 0.92534, 0.86698, 0.9245, 0.84118, 0.92274, 0.84118, 0.92274, 0.84118, 0.92274, 0.8667, 0.86291, 0.75186, 1.02933, 1, 1, 0.75186, 1.02933, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 1, 1, 0.79776, 0.97655, 0.79776, 1.23023, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.94309, 0.98986, 0.7306, 0.89453, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.9245, 0.76318, 0.84843, 0.84557, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67009, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.8675, 0.90861, 0.6192, 0.7363, 0.64824, 0.82411, 0.56321, 0.85696, 1.23516, 0.8675, 0.81552, 0.7286, 0.84134, 0.73206, 0.76659, 0.86275, 0.84369, 0.90685, 0.77892, 0.85871, 1.02638, 0.89249, 0.75828, 0.84118, 0.85984, 0.77452, 0.76466, 0.79776, 0.7306, 0.90782, 0.77818, 0.903, 0.87291, 0.90685, 0.7306, 0.99058, 1.03667, 0.94635, 1.23516, 0.9849, 0.99058, 0.92393, 0.8916, 0.942, 1.03667, 0.75026, 0.94635, 1.0297, 1.23516, 0.90918, 0.94048, 0.98217, 0.89746, 0.84153, 0.92274, 0.82507, 0.88832, 0.84438, 0.88178, 1.03525, 0.9849, 1.00225, 0.78086, 0.97248, 0.89404, 1.23516, 0.9849, 0.92274, 0.9849, 0.89404, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90933, 1, 1, 1, 1, 1, 1, 0.94309, 0.98986, 0.94309, 0.98986, 0.94309, 0.98986, 0.7306, 0.89453, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.97858, 0.82616, 0.91133, 0.83437, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90572, 1.81055, 0.90749, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85284, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.CalibriItalicMetrics = { lineHeight: 1.2207, lineGap: 0.2207 }, l.CalibriRegularFactors = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39016, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.73834, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89385, 0.85122, 0.77452, 0.86503, 0.75186, 0.68887, 0.79776, 0.88844, 0.85066, 0.94258, 0.77818, 0.7306, 0.76659, 1.10369, 1.39016, 1.10369, 1.06139, 0.89552, 0.8739, 0.86128, 0.94469, 0.8457, 0.94469, 0.89464, 1.09842, 0.84636, 0.94469, 1.03297, 1.07692, 0.90918, 1.03297, 0.95897, 0.94469, 0.9482, 0.94469, 0.94469, 1.04692, 0.78223, 1.20562, 0.94469, 0.90332, 0.98986, 0.86621, 0.90527, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.08707, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.73834, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89385, 0.85122, 0.85122, 0.85122, 0.85122, 0.85122, 0.85284, 0.85311, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.8693, 0.8457, 0.89464, 0.89464, 0.89464, 0.89464, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.94469, 0.9482, 0.9482, 0.9482, 0.9482, 0.9482, 0.90747, 0.86651, 0.94469, 0.94469, 0.94469, 0.94469, 0.90527, 0.94469, 0.90527, 0.8675, 0.86128, 0.8675, 0.86128, 0.8675, 0.86128, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.85193, 0.92454, 0.86477, 0.9921, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.81105, 0.84636, 0.81105, 0.84636, 0.81105, 0.84636, 1, 1, 0.86275, 0.94469, 0.90872, 0.95786, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77741, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.90452, 0.98156, 1.11842, 0.77261, 1.11429, 0.89385, 0.94469, 1, 1, 0.89385, 0.94469, 0.95877, 0.86901, 0.94469, 0.85122, 0.9482, 0.85122, 0.9482, 0.85122, 0.9482, 0.8667, 0.90016, 0.75186, 1.04692, 1, 1, 0.75186, 1.04692, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 1, 1, 0.79776, 0.92188, 0.79776, 1.23023, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.94258, 0.98986, 0.7306, 0.90527, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.86128, 0.76318, 0.8693, 0.85311, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67742, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.86686, 0.90861, 0.62267, 0.74359, 0.65649, 0.85498, 0.56963, 0.88254, 1.23516, 0.8675, 0.81552, 0.75443, 0.84503, 0.73206, 0.76659, 0.86275, 0.85122, 0.90685, 0.77892, 0.85746, 1.02638, 0.89385, 0.75657, 0.85122, 0.86275, 0.77452, 0.74171, 0.79776, 0.7306, 0.95165, 0.77818, 0.89772, 0.88831, 0.90685, 0.7306, 0.98142, 1.02191, 0.96576, 1.23516, 0.99018, 0.98142, 0.9236, 0.89258, 0.94035, 1.02191, 0.78848, 0.96576, 0.9561, 1.23516, 0.90918, 0.92578, 0.95424, 0.89746, 0.83969, 0.9482, 0.80113, 0.89442, 0.85208, 0.86155, 0.98022, 0.99018, 1.00452, 0.81209, 0.99247, 0.89181, 1.23516, 0.99018, 0.9482, 0.99018, 0.89181, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96766, 1, 1, 1, 1, 1, 1, 0.94258, 0.98986, 0.94258, 0.98986, 0.94258, 0.98986, 0.7306, 0.90527, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.99331, 0.82616, 0.91133, 0.84286, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90527, 1.81055, 0.90527, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, 0.99413, 0.96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.CalibriRegularMetrics = { lineHeight: 1.2207, lineGap: 0.2207 };
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.HelveticaRegularMetrics = l.HelveticaRegularFactors = l.HelveticaItalicMetrics = l.HelveticaItalicFactors = l.HelveticaBoldMetrics = l.HelveticaBoldItalicMetrics = l.HelveticaBoldItalicFactors = l.HelveticaBoldFactors = void 0, l.HelveticaBoldFactors = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.03374, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00034, 0.99977, 1, 0.99997, 1.00026, 1.00078, 1.00036, 0.99973, 1.00013, 1.0006, 0.99977, 0.99977, 0.99988, 0.85148, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 1.00069, 1.00022, 0.99977, 1.00001, 0.99984, 1.00026, 1.00001, 1.00024, 1.00001, 0.9999, 1, 1.0006, 1.00001, 1.00041, 0.99962, 1.00026, 1.0006, 0.99995, 1.00041, 0.99942, 0.99973, 0.99927, 1.00082, 0.99902, 1.00026, 1.00087, 1.0006, 1.00069, 0.99973, 0.99867, 0.99973, 0.9993, 1.00026, 1.00049, 1.00056, 1, 0.99988, 0.99935, 0.99995, 0.99954, 1.00055, 0.99945, 1.00032, 1.0006, 0.99995, 1.00026, 0.99995, 1.00032, 1.00001, 1.00008, 0.99971, 1.00019, 0.9994, 1.00001, 1.0006, 1.00044, 0.99973, 1.00023, 1.00047, 1, 0.99942, 0.99561, 0.99989, 1.00035, 0.99977, 1.00035, 0.99977, 1.00019, 0.99944, 1.00001, 1.00021, 0.99926, 1.00035, 1.00035, 0.99942, 1.00048, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.99989, 1.00057, 1.00001, 0.99936, 1.00052, 1.00012, 0.99996, 1.00043, 1, 1.00035, 0.9994, 0.99976, 1.00035, 0.99973, 1.00052, 1.00041, 1.00119, 1.00037, 0.99973, 1.00002, 0.99986, 1.00041, 1.00041, 0.99902, 0.9996, 1.00034, 0.99999, 1.00026, 0.99999, 1.00026, 0.99973, 1.00052, 0.99973, 1, 0.99973, 1.00041, 1.00075, 0.9994, 1.0003, 0.99999, 1, 1.00041, 0.99955, 1, 0.99915, 0.99973, 0.99973, 1.00026, 1.00119, 0.99955, 0.99973, 1.0006, 0.99911, 1.0006, 1.00026, 0.99972, 1.00026, 0.99902, 1.00041, 0.99973, 0.99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 1.00047, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.HelveticaBoldMetrics = { lineHeight: 1.2, lineGap: 0.2 }, l.HelveticaBoldItalicFactors = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.0044, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99971, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99977, 1, 1, 1.00026, 0.99969, 0.99972, 0.99981, 0.9998, 1.0006, 0.99977, 0.99977, 1.00022, 0.91155, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 0.99966, 1.00022, 1.00032, 1.00001, 0.99944, 1.00026, 1.00001, 0.99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, 0.99981, 1.00101, 1.00026, 1.0006, 0.99948, 0.99981, 1.00064, 0.99973, 0.99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, 0.99973, 1.01322, 0.99973, 1.00065, 1.00026, 1.00012, 0.99923, 1, 1.00064, 1.00076, 0.99948, 1.00055, 1.00063, 1.00007, 0.99943, 1.0006, 0.99948, 1.00026, 0.99948, 0.99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, 0.99973, 0.99978, 1.00001, 1.00057, 0.99989, 0.99967, 0.99964, 0.99967, 0.99977, 0.99999, 0.99977, 1.00038, 0.99977, 1.00001, 0.99973, 1.00066, 0.99967, 0.99967, 1.00041, 0.99998, 0.99999, 0.99977, 1.00022, 0.99967, 1.00001, 0.99977, 1.00026, 0.99964, 1.00031, 1.00001, 0.99999, 0.99999, 1, 1.00023, 1, 1, 0.99999, 1.00035, 1.00001, 0.99999, 0.99973, 0.99977, 0.99999, 1.00058, 0.99973, 0.99973, 0.99955, 0.9995, 1.00026, 1.00026, 1.00032, 0.99989, 1.00034, 0.99999, 1.00026, 1.00026, 1.00026, 0.99973, 0.45998, 0.99973, 1.00026, 0.99973, 1.00001, 0.99999, 0.99982, 0.99994, 0.99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, 0.99973, 0.99973, 1.00026, 0.99949, 1.00002, 0.99973, 1.0006, 1.0006, 1.0006, 0.99975, 1.00026, 1.00026, 1.00032, 0.98685, 0.99973, 1.00026, 1, 1, 0.99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1, 0.99973, 0.99971, 0.99978, 1, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.HelveticaBoldItalicMetrics = { lineHeight: 1.35, lineGap: 0.2 }, l.HelveticaItalicFactors = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.0288, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 0.99946, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.06311, 0.99973, 1.00024, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00041, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.89547, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00001, 1, 1.00054, 0.99977, 1.00084, 1.00007, 0.99973, 1.00013, 0.99924, 1.00001, 1.00001, 0.99945, 0.91221, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00001, 0.99999, 0.99977, 0.99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, 0.99945, 0.99897, 0.99968, 0.99924, 1.00036, 0.99945, 0.99949, 1, 1.0006, 0.99897, 0.99918, 0.99968, 0.99911, 0.99924, 1, 0.99962, 1.01487, 1, 1.0005, 0.99973, 1.00012, 1.00043, 1, 0.99995, 0.99994, 1.00036, 0.99947, 1.00019, 1.00063, 1.00025, 0.99924, 1.00036, 0.99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, 0.99957, 0.99972, 0.9994, 0.99954, 0.99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, 0.99986, 1.00001, 1.00001, 1.00038, 0.99954, 0.99954, 0.9994, 1.00066, 0.99999, 0.99977, 1.00022, 1.00054, 1.00001, 0.99977, 1.00026, 0.99975, 1.0001, 1.00001, 0.99993, 0.9995, 0.99955, 1.00016, 0.99978, 0.99974, 1.00019, 1.00022, 0.99955, 1.00053, 0.99973, 1.00089, 1.00005, 0.99967, 1.00048, 0.99973, 1.00002, 1.00034, 0.99973, 0.99973, 0.99964, 1.00006, 1.00066, 0.99947, 0.99973, 0.98894, 0.99973, 1, 0.44898, 1, 0.99946, 1, 1.00039, 1.00082, 0.99991, 0.99991, 0.99985, 1.00022, 1.00023, 1.00061, 1.00006, 0.99966, 0.99973, 0.99973, 0.99973, 1.00019, 1.0008, 1, 0.99924, 0.99924, 0.99924, 0.99983, 1.00044, 0.99973, 0.99964, 0.98332, 1, 0.99973, 1, 1, 0.99962, 0.99895, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 1.00423, 0.99925, 0.99999, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.HelveticaItalicMetrics = { lineHeight: 1.35, lineGap: 0.2 }, l.HelveticaRegularFactors = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.04596, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.02572, 0.99973, 1.00005, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99999, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.84533, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99928, 1, 0.99977, 1.00013, 1.00055, 0.99947, 0.99945, 0.99941, 0.99924, 1.00001, 1.00001, 1.0004, 0.91621, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00005, 0.99999, 0.99977, 1.00015, 1.00022, 0.99977, 1.00001, 0.99973, 1.00026, 1.00001, 1.00019, 1.00001, 0.99946, 1, 1.0006, 1.00001, 0.99978, 1.00045, 0.99973, 0.99924, 1.00023, 0.99978, 0.99966, 1, 1.00065, 1.00045, 1.00019, 0.99973, 0.99973, 0.99924, 1, 1, 0.96499, 1, 1.00055, 0.99973, 1.00008, 1.00027, 1, 0.9997, 0.99995, 1.00023, 0.99933, 1.00019, 1.00015, 1.00031, 0.99924, 1.00023, 0.99973, 1.00023, 1.00031, 1.00001, 0.99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, 0.99988, 0.99975, 1, 1.00082, 0.99561, 0.9996, 1.00035, 1.00001, 0.99962, 1.00001, 1.00092, 0.99964, 1.00001, 0.99963, 0.99999, 1.00035, 1.00035, 1.00082, 0.99962, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.9996, 0.99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, 0.99971, 0.99962, 1.00035, 0.99975, 0.99977, 0.99973, 1.00043, 0.99953, 1.0007, 0.99915, 0.99973, 1.00008, 0.99892, 1.00073, 1.00073, 1.00114, 0.99915, 1.00073, 0.99955, 0.99973, 1.00092, 0.99973, 1, 0.99998, 1, 1.0003, 1, 1.00043, 1.00001, 0.99969, 1.0003, 1, 1.00035, 1.00001, 0.9995, 1, 1.00092, 0.99973, 0.99973, 0.99973, 1.0007, 0.9995, 1, 0.99924, 1.0006, 0.99924, 0.99972, 1.00062, 0.99973, 1.00114, 1.00073, 1, 0.99955, 1, 1, 1.00047, 0.99968, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 0.99925, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.HelveticaRegularMetrics = { lineHeight: 1.2, lineGap: 0.2 };
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.LiberationSansRegularWidths = l.LiberationSansRegularMapping = l.LiberationSansItalicWidths = l.LiberationSansItalicMapping = l.LiberationSansBoldWidths = l.LiberationSansBoldMapping = l.LiberationSansBoldItalicWidths = l.LiberationSansBoldItalicMapping = void 0, l.LiberationSansBoldWidths = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333], l.LiberationSansBoldMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], l.LiberationSansBoldItalicWidths = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333], l.LiberationSansBoldItalicMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], l.LiberationSansItalicWidths = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285], l.LiberationSansItalicMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], l.LiberationSansRegularWidths = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285], l.LiberationSansRegularMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.MyriadProRegularMetrics = l.MyriadProRegularFactors = l.MyriadProItalicMetrics = l.MyriadProItalicFactors = l.MyriadProBoldMetrics = l.MyriadProBoldItalicMetrics = l.MyriadProBoldItalicFactors = l.MyriadProBoldFactors = void 0, l.MyriadProBoldFactors = [1.36898, 1, 1, 0.72706, 0.80479, 0.83734, 0.98894, 0.99793, 0.9897, 0.93884, 0.86209, 0.94292, 0.94292, 1.16661, 1.02058, 0.93582, 0.96694, 0.93582, 1.19137, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.72851, 0.78966, 0.90838, 0.83637, 0.82391, 0.96376, 0.80061, 0.86275, 0.8768, 0.95407, 1.0258, 0.73901, 0.85022, 0.83655, 1.0156, 0.95546, 0.92179, 0.87107, 0.92179, 0.82114, 0.8096, 0.89713, 0.94438, 0.95353, 0.94083, 0.91905, 0.90406, 0.9446, 0.94292, 1.18777, 0.94292, 1.02058, 0.89903, 0.90088, 0.94938, 0.97898, 0.81093, 0.97571, 0.94938, 1.024, 0.9577, 0.95933, 0.98621, 1.0474, 0.97455, 0.98981, 0.9672, 0.95933, 0.9446, 0.97898, 0.97407, 0.97646, 0.78036, 1.10208, 0.95442, 0.95298, 0.97579, 0.9332, 0.94039, 0.938, 0.80687, 1.01149, 0.80687, 1.02058, 0.80479, 0.99793, 0.99793, 0.99793, 0.99793, 1.01149, 1.00872, 0.90088, 0.91882, 1.0213, 0.8361, 1.02058, 0.62295, 0.54324, 0.89022, 1.08595, 1, 1, 0.90088, 1, 0.97455, 0.93582, 0.90088, 1, 1.05686, 0.8361, 0.99642, 0.99642, 0.99642, 0.72851, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.868, 0.82391, 0.80061, 0.80061, 0.80061, 0.80061, 1.0258, 1.0258, 1.0258, 1.0258, 0.97484, 0.95546, 0.92179, 0.92179, 0.92179, 0.92179, 0.92179, 1.02058, 0.92179, 0.94438, 0.94438, 0.94438, 0.94438, 0.90406, 0.86958, 0.98225, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.9031, 0.81093, 0.94938, 0.94938, 0.94938, 0.94938, 0.98621, 0.98621, 0.98621, 0.98621, 0.93969, 0.95933, 0.9446, 0.9446, 0.9446, 0.9446, 0.9446, 1.08595, 0.9446, 0.95442, 0.95442, 0.95442, 0.95442, 0.94039, 0.97898, 0.94039, 0.90838, 0.94938, 0.90838, 0.94938, 0.90838, 0.94938, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.96376, 0.84313, 0.97484, 0.97571, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.8768, 0.9577, 0.8768, 0.9577, 0.8768, 0.9577, 1, 1, 0.95407, 0.95933, 0.97069, 0.95933, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 0.887, 1.01591, 0.73901, 1.0474, 1, 1, 0.97455, 0.83655, 0.98981, 1, 1, 0.83655, 0.73977, 0.83655, 0.73903, 0.84638, 1.033, 0.95546, 0.95933, 1, 1, 0.95546, 0.95933, 0.8271, 0.95417, 0.95933, 0.92179, 0.9446, 0.92179, 0.9446, 0.92179, 0.9446, 0.936, 0.91964, 0.82114, 0.97646, 1, 1, 0.82114, 0.97646, 0.8096, 0.78036, 0.8096, 0.78036, 1, 1, 0.8096, 0.78036, 1, 1, 0.89713, 0.77452, 0.89713, 1.10208, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94083, 0.97579, 0.90406, 0.94039, 0.90406, 0.9446, 0.938, 0.9446, 0.938, 0.9446, 0.938, 1, 0.99793, 0.90838, 0.94938, 0.868, 0.9031, 0.92179, 0.9446, 1, 1, 0.89713, 1.10208, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90989, 0.9358, 0.91945, 0.83181, 0.75261, 0.87992, 0.82976, 0.96034, 0.83689, 0.97268, 1.0078, 0.90838, 0.83637, 0.8019, 0.90157, 0.80061, 0.9446, 0.95407, 0.92436, 1.0258, 0.85022, 0.97153, 1.0156, 0.95546, 0.89192, 0.92179, 0.92361, 0.87107, 0.96318, 0.89713, 0.93704, 0.95638, 0.91905, 0.91709, 0.92796, 1.0258, 0.93704, 0.94836, 1.0373, 0.95933, 1.0078, 0.95871, 0.94836, 0.96174, 0.92601, 0.9498, 0.98607, 0.95776, 0.95933, 1.05453, 1.0078, 0.98275, 0.9314, 0.95617, 0.91701, 1.05993, 0.9446, 0.78367, 0.9553, 1, 0.86832, 1.0128, 0.95871, 0.99394, 0.87548, 0.96361, 0.86774, 1.0078, 0.95871, 0.9446, 0.95871, 0.86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.94083, 0.97579, 0.94083, 0.97579, 0.94083, 0.97579, 0.90406, 0.94039, 0.96694, 1, 0.89903, 1, 1, 1, 0.93582, 0.93582, 0.93582, 1, 0.908, 0.908, 0.918, 0.94219, 0.94219, 0.96544, 1, 1.285, 1, 1, 0.81079, 0.81079, 1, 1, 0.74854, 1, 1, 1, 1, 0.99793, 1, 1, 1, 0.65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, 0.80535, 0.76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.MyriadProBoldMetrics = { lineHeight: 1.2, lineGap: 0.2 }, l.MyriadProBoldItalicFactors = [1.36898, 1, 1, 0.66227, 0.80779, 0.81625, 0.97276, 0.97276, 0.97733, 0.92222, 0.83266, 0.94292, 0.94292, 1.16148, 1.02058, 0.93582, 0.96694, 0.93582, 1.17337, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.71541, 0.76813, 0.85576, 0.80591, 0.80729, 0.94299, 0.77512, 0.83655, 0.86523, 0.92222, 0.98621, 0.71743, 0.81698, 0.79726, 0.98558, 0.92222, 0.90637, 0.83809, 0.90637, 0.80729, 0.76463, 0.86275, 0.90699, 0.91605, 0.9154, 0.85308, 0.85458, 0.90531, 0.94292, 1.21296, 0.94292, 1.02058, 0.89903, 1.18616, 0.99613, 0.91677, 0.78216, 0.91677, 0.90083, 0.98796, 0.9135, 0.92168, 0.95381, 0.98981, 0.95298, 0.95381, 0.93459, 0.92168, 0.91513, 0.92004, 0.91677, 0.95077, 0.748, 1.04502, 0.91677, 0.92061, 0.94236, 0.89544, 0.89364, 0.9, 0.80687, 0.8578, 0.80687, 1.02058, 0.80779, 0.97276, 0.97276, 0.97276, 0.97276, 0.8578, 0.99973, 1.18616, 0.91339, 1.08074, 0.82891, 1.02058, 0.55509, 0.71526, 0.89022, 1.08595, 1, 1, 1.18616, 1, 0.96736, 0.93582, 1.18616, 1, 1.04864, 0.82711, 0.99043, 0.99043, 0.99043, 0.71541, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.845, 0.80729, 0.77512, 0.77512, 0.77512, 0.77512, 0.98621, 0.98621, 0.98621, 0.98621, 0.95961, 0.92222, 0.90637, 0.90637, 0.90637, 0.90637, 0.90637, 1.02058, 0.90251, 0.90699, 0.90699, 0.90699, 0.90699, 0.85458, 0.83659, 0.94951, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.85811, 0.78216, 0.90083, 0.90083, 0.90083, 0.90083, 0.95381, 0.95381, 0.95381, 0.95381, 0.9135, 0.92168, 0.91513, 0.91513, 0.91513, 0.91513, 0.91513, 1.08595, 0.91677, 0.91677, 0.91677, 0.91677, 0.91677, 0.89364, 0.92332, 0.89364, 0.85576, 0.99613, 0.85576, 0.99613, 0.85576, 0.99613, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.94299, 0.76783, 0.95961, 0.91677, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.86523, 0.9135, 0.86523, 0.9135, 0.86523, 0.9135, 1, 1, 0.92222, 0.92168, 0.92222, 0.92168, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.86036, 0.97096, 0.71743, 0.98981, 1, 1, 0.95298, 0.79726, 0.95381, 1, 1, 0.79726, 0.6894, 0.79726, 0.74321, 0.81691, 1.0006, 0.92222, 0.92168, 1, 1, 0.92222, 0.92168, 0.79464, 0.92098, 0.92168, 0.90637, 0.91513, 0.90637, 0.91513, 0.90637, 0.91513, 0.909, 0.87514, 0.80729, 0.95077, 1, 1, 0.80729, 0.95077, 0.76463, 0.748, 0.76463, 0.748, 1, 1, 0.76463, 0.748, 1, 1, 0.86275, 0.72651, 0.86275, 1.04502, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.9154, 0.94236, 0.85458, 0.89364, 0.85458, 0.90531, 0.9, 0.90531, 0.9, 0.90531, 0.9, 1, 0.97276, 0.85576, 0.99613, 0.845, 0.85811, 0.90251, 0.91677, 1, 1, 0.86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, 0.85576, 0.80178, 0.66862, 0.7927, 0.69323, 0.88127, 0.72459, 0.89711, 0.95381, 0.85576, 0.80591, 0.7805, 0.94729, 0.77512, 0.90531, 0.92222, 0.90637, 0.98621, 0.81698, 0.92655, 0.98558, 0.92222, 0.85359, 0.90637, 0.90976, 0.83809, 0.94523, 0.86275, 0.83509, 0.93157, 0.85308, 0.83392, 0.92346, 0.98621, 0.83509, 0.92886, 0.91324, 0.92168, 0.95381, 0.90646, 0.92886, 0.90557, 0.86847, 0.90276, 0.91324, 0.86842, 0.92168, 0.99531, 0.95381, 0.9224, 0.85408, 0.92699, 0.86847, 1.0051, 0.91513, 0.80487, 0.93481, 1, 0.88159, 1.05214, 0.90646, 0.97355, 0.81539, 0.89398, 0.85923, 0.95381, 0.90646, 0.91513, 0.90646, 0.85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9154, 0.94236, 0.9154, 0.94236, 0.9154, 0.94236, 0.85458, 0.89364, 0.96694, 1, 0.89903, 1, 1, 1, 0.91782, 0.91782, 0.91782, 1, 0.896, 0.896, 0.896, 0.9332, 0.9332, 0.95973, 1, 1.26, 1, 1, 0.80479, 0.80178, 1, 1, 0.85633, 1, 1, 1, 1, 0.97276, 1, 1, 1, 0.698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, 0.79199, 0.78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.MyriadProBoldItalicMetrics = { lineHeight: 1.2, lineGap: 0.2 }, l.MyriadProItalicFactors = [1.36898, 1, 1, 0.65507, 0.84943, 0.85639, 0.88465, 0.88465, 0.86936, 0.88307, 0.86948, 0.85283, 0.85283, 1.06383, 1.02058, 0.75945, 0.9219, 0.75945, 1.17337, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.75945, 0.75945, 1.02058, 1.02058, 1.02058, 0.69046, 0.70926, 0.85158, 0.77812, 0.76852, 0.89591, 0.70466, 0.76125, 0.80094, 0.86822, 0.83864, 0.728, 0.77212, 0.79475, 0.93637, 0.87514, 0.8588, 0.76013, 0.8588, 0.72421, 0.69866, 0.77598, 0.85991, 0.80811, 0.87832, 0.78112, 0.77512, 0.8562, 1.0222, 1.18417, 1.0222, 1.27014, 0.89903, 1.15012, 0.93859, 0.94399, 0.846, 0.94399, 0.81453, 1.0186, 0.94219, 0.96017, 1.03075, 1.02175, 0.912, 1.03075, 0.96998, 0.96017, 0.93859, 0.94399, 0.94399, 0.95493, 0.746, 1.12658, 0.94578, 0.91, 0.979, 0.882, 0.882, 0.83, 0.85034, 0.83537, 0.85034, 1.02058, 0.70869, 0.88465, 0.88465, 0.88465, 0.88465, 0.83537, 0.90083, 1.15012, 0.9161, 0.94565, 0.73541, 1.02058, 0.53609, 0.69353, 0.79519, 1.08595, 1, 1, 1.15012, 1, 0.91974, 0.75945, 1.15012, 1, 0.9446, 0.73361, 0.9005, 0.9005, 0.9005, 0.62864, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.773, 0.76852, 0.70466, 0.70466, 0.70466, 0.70466, 0.83864, 0.83864, 0.83864, 0.83864, 0.90561, 0.87514, 0.8588, 0.8588, 0.8588, 0.8588, 0.8588, 1.02058, 0.85751, 0.85991, 0.85991, 0.85991, 0.85991, 0.77512, 0.76013, 0.88075, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.8075, 0.846, 0.81453, 0.81453, 0.81453, 0.81453, 0.82424, 0.82424, 0.82424, 0.82424, 0.9278, 0.96017, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 1.08595, 0.8562, 0.94578, 0.94578, 0.94578, 0.94578, 0.882, 0.94578, 0.882, 0.85158, 0.93859, 0.85158, 0.93859, 0.85158, 0.93859, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.89591, 0.8544, 0.90561, 0.94399, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.80094, 0.94219, 0.80094, 0.94219, 0.80094, 0.94219, 1, 1, 0.86822, 0.96017, 0.86822, 0.96017, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 1.03075, 0.83864, 0.82424, 0.81402, 1.02738, 0.728, 1.02175, 1, 1, 0.912, 0.79475, 1.03075, 1, 1, 0.79475, 0.83911, 0.79475, 0.66266, 0.80553, 1.06676, 0.87514, 0.96017, 1, 1, 0.87514, 0.96017, 0.86865, 0.87396, 0.96017, 0.8588, 0.93859, 0.8588, 0.93859, 0.8588, 0.93859, 0.867, 0.84759, 0.72421, 0.95493, 1, 1, 0.72421, 0.95493, 0.69866, 0.746, 0.69866, 0.746, 1, 1, 0.69866, 0.746, 1, 1, 0.77598, 0.88417, 0.77598, 1.12658, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.87832, 0.979, 0.77512, 0.882, 0.77512, 0.8562, 0.83, 0.8562, 0.83, 0.8562, 0.83, 1, 0.88465, 0.85158, 0.93859, 0.773, 0.8075, 0.85751, 0.8562, 1, 1, 0.77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, 0.85158, 0.77025, 0.62264, 0.7646, 0.65351, 0.86026, 0.69461, 0.89947, 1.03075, 0.85158, 0.77812, 0.76449, 0.88836, 0.70466, 0.8562, 0.86822, 0.8588, 0.83864, 0.77212, 0.85308, 0.93637, 0.87514, 0.82352, 0.8588, 0.85701, 0.76013, 0.89058, 0.77598, 0.8156, 0.82565, 0.78112, 0.77899, 0.89386, 0.83864, 0.8156, 0.9486, 0.92388, 0.96186, 1.03075, 0.91123, 0.9486, 0.93298, 0.878, 0.93942, 0.92388, 0.84596, 0.96186, 0.95119, 1.03075, 0.922, 0.88787, 0.95829, 0.88, 0.93559, 0.93859, 0.78815, 0.93758, 1, 0.89217, 1.03737, 0.91123, 0.93969, 0.77487, 0.85769, 0.86799, 1.03075, 0.91123, 0.93859, 0.91123, 0.86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87832, 0.979, 0.87832, 0.979, 0.87832, 0.979, 0.77512, 0.882, 0.9219, 1, 0.89903, 1, 1, 1, 0.87321, 0.87321, 0.87321, 1, 1.027, 1.027, 1.027, 0.86847, 0.86847, 0.79121, 1, 1.124, 1, 1, 0.73572, 0.73572, 1, 1, 0.85034, 1, 1, 1, 1, 0.88465, 1, 1, 1, 0.669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, 0.74948, 0.75187, 1.02058, 0.98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.MyriadProItalicMetrics = { lineHeight: 1.2, lineGap: 0.2 }, l.MyriadProRegularFactors = [1.36898, 1, 1, 0.76305, 0.82784, 0.94935, 0.89364, 0.92241, 0.89073, 0.90706, 0.98472, 0.85283, 0.85283, 1.0664, 1.02058, 0.74505, 0.9219, 0.74505, 1.23456, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.74505, 0.74505, 1.02058, 1.02058, 1.02058, 0.73002, 0.72601, 0.91755, 0.8126, 0.80314, 0.92222, 0.73764, 0.79726, 0.83051, 0.90284, 0.86023, 0.74, 0.8126, 0.84869, 0.96518, 0.91115, 0.8858, 0.79761, 0.8858, 0.74498, 0.73914, 0.81363, 0.89591, 0.83659, 0.89633, 0.85608, 0.8111, 0.90531, 1.0222, 1.22736, 1.0222, 1.27014, 0.89903, 0.90088, 0.86667, 1.0231, 0.896, 1.01411, 0.90083, 1.05099, 1.00512, 0.99793, 1.05326, 1.09377, 0.938, 1.06226, 1.00119, 0.99793, 0.98714, 1.0231, 1.01231, 0.98196, 0.792, 1.19137, 0.99074, 0.962, 1.01915, 0.926, 0.942, 0.856, 0.85034, 0.92006, 0.85034, 1.02058, 0.69067, 0.92241, 0.92241, 0.92241, 0.92241, 0.92006, 0.9332, 0.90088, 0.91882, 0.93484, 0.75339, 1.02058, 0.56866, 0.54324, 0.79519, 1.08595, 1, 1, 0.90088, 1, 0.95325, 0.74505, 0.90088, 1, 0.97198, 0.75339, 0.91009, 0.91009, 0.91009, 0.66466, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.788, 0.80314, 0.73764, 0.73764, 0.73764, 0.73764, 0.86023, 0.86023, 0.86023, 0.86023, 0.92915, 0.91115, 0.8858, 0.8858, 0.8858, 0.8858, 0.8858, 1.02058, 0.8858, 0.89591, 0.89591, 0.89591, 0.89591, 0.8111, 0.79611, 0.89713, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86936, 0.896, 0.90083, 0.90083, 0.90083, 0.90083, 0.84224, 0.84224, 0.84224, 0.84224, 0.97276, 0.99793, 0.98714, 0.98714, 0.98714, 0.98714, 0.98714, 1.08595, 0.89876, 0.99074, 0.99074, 0.99074, 0.99074, 0.942, 1.0231, 0.942, 0.91755, 0.86667, 0.91755, 0.86667, 0.91755, 0.86667, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.92222, 0.93372, 0.92915, 1.01411, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.83051, 1.00512, 0.83051, 1.00512, 0.83051, 1.00512, 1, 1, 0.90284, 0.99793, 0.90976, 0.99793, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 1.05326, 0.86023, 0.84224, 0.82873, 1.07469, 0.74, 1.09377, 1, 1, 0.938, 0.84869, 1.06226, 1, 1, 0.84869, 0.83704, 0.84869, 0.81441, 0.85588, 1.08927, 0.91115, 0.99793, 1, 1, 0.91115, 0.99793, 0.91887, 0.90991, 0.99793, 0.8858, 0.98714, 0.8858, 0.98714, 0.8858, 0.98714, 0.894, 0.91434, 0.74498, 0.98196, 1, 1, 0.74498, 0.98196, 0.73914, 0.792, 0.73914, 0.792, 1, 1, 0.73914, 0.792, 1, 1, 0.81363, 0.904, 0.81363, 1.19137, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89633, 1.01915, 0.8111, 0.942, 0.8111, 0.90531, 0.856, 0.90531, 0.856, 0.90531, 0.856, 1, 0.92241, 0.91755, 0.86667, 0.788, 0.86936, 0.8858, 0.89876, 1, 1, 0.81363, 1.19137, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90388, 1.03901, 0.92138, 0.78105, 0.7154, 0.86169, 0.80513, 0.94007, 0.82528, 0.98612, 1.06226, 0.91755, 0.8126, 0.81884, 0.92819, 0.73764, 0.90531, 0.90284, 0.8858, 0.86023, 0.8126, 0.91172, 0.96518, 0.91115, 0.83089, 0.8858, 0.87791, 0.79761, 0.89297, 0.81363, 0.88157, 0.89992, 0.85608, 0.81992, 0.94307, 0.86023, 0.88157, 0.95308, 0.98699, 0.99793, 1.06226, 0.95817, 0.95308, 0.97358, 0.928, 0.98088, 0.98699, 0.92761, 0.99793, 0.96017, 1.06226, 0.986, 0.944, 0.95978, 0.938, 0.96705, 0.98714, 0.80442, 0.98972, 1, 0.89762, 1.04552, 0.95817, 0.99007, 0.87064, 0.91879, 0.88888, 1.06226, 0.95817, 0.98714, 0.95817, 0.88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89633, 1.01915, 0.89633, 1.01915, 0.89633, 1.01915, 0.8111, 0.942, 0.9219, 1, 0.89903, 1, 1, 1, 0.93173, 0.93173, 0.93173, 1, 1.06304, 1.06304, 1.06904, 0.89903, 0.89903, 0.80549, 1, 1.156, 1, 1, 0.76575, 0.76575, 1, 1, 0.72458, 1, 1, 1, 1, 0.92241, 1, 1, 1, 0.619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, 0.74705, 0.71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.MyriadProRegularMetrics = { lineHeight: 1.2, lineGap: 0.2 };
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.SegoeuiRegularMetrics = l.SegoeuiRegularFactors = l.SegoeuiItalicMetrics = l.SegoeuiItalicFactors = l.SegoeuiBoldMetrics = l.SegoeuiBoldItalicMetrics = l.SegoeuiBoldItalicFactors = l.SegoeuiBoldFactors = void 0, l.SegoeuiBoldFactors = [1.76738, 1, 1, 0.99297, 0.9824, 1.04016, 1.06497, 1.03424, 0.97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, 0.9754, 1.21408, 0.9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 0.81378, 0.81378, 1.2107, 1.2107, 1.2107, 0.71703, 0.97847, 0.97363, 0.88776, 0.8641, 1.02096, 0.79795, 0.85132, 0.914, 1.06085, 1.1406, 0.8007, 0.89858, 0.83693, 1.14889, 1.09398, 0.97489, 0.92094, 0.97489, 0.90399, 0.84041, 0.95923, 1.00135, 1, 1.06467, 0.98243, 0.90996, 0.99361, 1.1085, 1.56942, 1.1085, 1.2107, 0.74627, 0.94282, 0.96752, 1.01519, 0.86304, 1.01359, 0.97278, 1.15103, 1.01359, 0.98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, 0.99041, 1.0008, 1.01519, 1.01359, 1.02258, 0.79104, 1.16862, 0.99041, 0.97454, 1.02511, 0.99298, 0.96752, 0.95801, 0.94856, 1.16579, 0.94856, 1.2107, 0.9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, 0.8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, 0.75155, 0.94994, 1.28826, 1.21408, 1.21408, 0.91056, 1, 0.91572, 0.9754, 0.64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, 0.71703, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.93506, 0.8641, 0.79795, 0.79795, 0.79795, 0.79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, 0.97426, 0.97426, 0.97426, 0.97426, 0.97426, 1.2107, 0.97489, 1.00135, 1.00135, 1.00135, 1.00135, 0.90996, 0.92094, 1.02798, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.93136, 0.86304, 0.97278, 0.97278, 0.97278, 0.97278, 1.02285, 1.02285, 1.02285, 1.02285, 0.97122, 0.99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, 0.99041, 0.99041, 0.99041, 0.99041, 0.96752, 1.01519, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 1.02096, 1.03057, 1.02096, 1.03517, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.914, 1.01359, 0.914, 1.01359, 0.914, 1.01359, 1, 1, 1.06085, 0.98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 0.97138, 1.08692, 0.8007, 1.02285, 1, 1, 1.00527, 0.83693, 1.02285, 1, 1, 0.83693, 0.9455, 0.83693, 0.90418, 0.83693, 1.13005, 1.09398, 0.99041, 1, 1, 1.09398, 0.99041, 0.96692, 1.09251, 0.99041, 0.97489, 1.0008, 0.97489, 1.0008, 0.97489, 1.0008, 0.93994, 0.97931, 0.90399, 1.02258, 1, 1, 0.90399, 1.02258, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 1, 1, 0.95923, 1.07034, 0.95923, 1.16862, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.06467, 1.02511, 0.90996, 0.96752, 0.90996, 0.99361, 0.95801, 0.99361, 0.95801, 0.99361, 0.95801, 1.07733, 1.03424, 0.97363, 0.96752, 0.93506, 0.93136, 0.97489, 1.0008, 1, 1, 0.95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, 0.75953, 0.81378, 0.79912, 1.15103, 1.21994, 0.95161, 0.87815, 1.01149, 0.81525, 0.7676, 0.98167, 1.01134, 1.02546, 0.84097, 1.03089, 1.18102, 0.97363, 0.88776, 0.85134, 0.97826, 0.79795, 0.99361, 1.06085, 0.97489, 1.1406, 0.89858, 1.0388, 1.14889, 1.09398, 0.86039, 0.97489, 1.0595, 0.92094, 0.94793, 0.95923, 0.90996, 0.99346, 0.98243, 1.02112, 0.95493, 1.1406, 0.90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, 0.97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, 0.98683, 1.0016, 0.99561, 1.07237, 1.0008, 0.90434, 0.99921, 0.93803, 0.8965, 1.23085, 1.06628, 1.04983, 0.96268, 1.0499, 0.98439, 1.18102, 1.06628, 1.0008, 1.06628, 0.98439, 0.79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, 0.90996, 0.96752, 1, 1.21408, 0.89903, 1, 1, 0.75155, 1.04394, 1.04394, 1.04394, 1.04394, 0.98633, 0.98633, 0.98633, 0.73047, 0.73047, 1.20642, 0.91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.12454, 0.93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, 0.771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.16897, 1, 0.96085, 0.90137, 1.2107, 1.18416, 1.13973, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.SegoeuiBoldMetrics = { lineHeight: 1.33008, lineGap: 0 }, l.SegoeuiBoldItalicFactors = [1.76738, 1, 1, 0.98946, 1.03959, 1.04016, 1.02809, 1.036, 0.97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, 0.9754, 1.21261, 0.9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 0.81378, 0.81378, 1.21237, 1.21237, 1.21237, 0.73541, 0.97847, 0.97363, 0.89723, 0.87897, 1.0426, 0.79429, 0.85292, 0.91149, 1.05815, 1.1406, 0.79631, 0.90128, 0.83853, 1.04396, 1.10615, 0.97552, 0.94436, 0.97552, 0.88641, 0.80527, 0.96083, 1.00135, 1, 1.06777, 0.9817, 0.91142, 0.99361, 1.11144, 1.57293, 1.11144, 1.21237, 0.74627, 1.31818, 1.06585, 0.97042, 0.83055, 0.97042, 0.93503, 1.1261, 0.97042, 0.97922, 1.14236, 0.94552, 1.01054, 1.14236, 1.02471, 0.97922, 0.94165, 0.97042, 0.97042, 1.0276, 0.78929, 1.1261, 0.97922, 0.95874, 1.02197, 0.98507, 0.96752, 0.97168, 0.95107, 1.16579, 0.95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, 0.87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, 0.79487, 0.94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, 0.91484, 0.9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, 0.73541, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.94385, 0.87897, 0.79429, 0.79429, 0.79429, 0.79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, 0.97552, 0.97552, 0.97552, 0.97552, 0.97552, 1.21237, 0.97552, 1.00135, 1.00135, 1.00135, 1.00135, 0.91142, 0.94436, 0.98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 0.96705, 0.83055, 0.93503, 0.93503, 0.93503, 0.93503, 1.14236, 1.14236, 1.14236, 1.14236, 0.93125, 0.97922, 0.94165, 0.94165, 0.94165, 0.94165, 0.94165, 1.29004, 0.94165, 0.97922, 0.97922, 0.97922, 0.97922, 0.96752, 0.97042, 0.96752, 0.97363, 1.06585, 0.97363, 1.06585, 0.97363, 1.06585, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 1.0426, 1.0033, 1.0426, 0.97042, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.91149, 0.97042, 0.91149, 0.97042, 0.91149, 0.97042, 1, 1, 1.05815, 0.97922, 1.05815, 0.97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 0.97441, 1.04302, 0.79631, 1.01582, 1, 1, 1.01054, 0.83853, 1.14236, 1, 1, 0.83853, 1.09125, 0.83853, 0.90418, 0.83853, 1.19508, 1.10615, 0.97922, 1, 1, 1.10615, 0.97922, 1.01034, 1.10466, 0.97922, 0.97552, 0.94165, 0.97552, 0.94165, 0.97552, 0.94165, 0.91602, 0.91981, 0.88641, 1.0276, 1, 1, 0.88641, 1.0276, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 1, 1, 0.96083, 1.05403, 0.95923, 1.16862, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.06777, 1.02197, 0.91142, 0.96752, 0.91142, 0.99361, 0.97168, 0.99361, 0.97168, 0.99361, 0.97168, 1.23199, 1.036, 0.97363, 1.06585, 0.94385, 0.96705, 0.97552, 0.94165, 1, 1, 0.96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 0.95161, 1.27126, 1.00811, 0.83284, 0.77702, 0.99137, 0.95253, 1.0347, 0.86142, 1.07205, 1.14236, 0.97363, 0.89723, 0.86869, 1.09818, 0.79429, 0.99361, 1.05815, 0.97552, 1.1406, 0.90128, 1.06662, 1.04396, 1.10615, 0.84918, 0.97552, 1.04694, 0.94436, 0.98015, 0.96083, 0.91142, 1.00356, 0.9817, 1.01945, 0.98999, 1.1406, 0.91142, 1.04961, 0.9898, 1.00639, 1.14236, 1.07514, 1.04961, 0.99607, 1.02897, 1.008, 0.9898, 0.95134, 1.00639, 1.11121, 1.14236, 1.00518, 0.97981, 1.02186, 1, 1.08578, 0.94165, 0.99314, 0.98387, 0.93028, 0.93377, 1.35125, 1.07514, 1.10687, 0.93491, 1.04232, 1.00351, 1.14236, 1.07514, 0.94165, 1.07514, 1.00351, 0.79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, 0.91142, 0.96752, 1, 1.21261, 0.89903, 1, 1, 0.75155, 1.04745, 1.04745, 1.04745, 1.04394, 0.98633, 0.98633, 0.98633, 0.72959, 0.72959, 1.20502, 0.91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.09125, 0.93327, 1.03336, 1.16541, 1.036, 1, 1, 1, 0.771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, 0.86364, 0.94434, 0.86279, 0.94434, 0.86224, 1, 1, 1.16798, 1, 0.96085, 0.90068, 1.21237, 1.18416, 1.13904, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.SegoeuiBoldItalicMetrics = { lineHeight: 1.33008, lineGap: 0 }, l.SegoeuiItalicFactors = [1.76738, 1, 1, 0.98946, 1.14763, 1.05365, 1.06234, 0.96927, 0.92586, 1.15373, 1.18414, 0.91349, 0.91349, 1.07403, 1.17308, 0.78383, 1.20088, 0.78383, 1.42531, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78383, 0.78383, 1.17308, 1.17308, 1.17308, 0.77349, 0.94565, 0.94729, 0.85944, 0.88506, 0.9858, 0.74817, 0.80016, 0.88449, 0.98039, 0.95782, 0.69238, 0.89898, 0.83231, 0.98183, 1.03989, 0.96924, 0.86237, 0.96924, 0.80595, 0.74524, 0.86091, 0.95402, 0.94143, 0.98448, 0.8858, 0.83089, 0.93285, 1.0949, 1.39016, 1.0949, 1.45994, 0.74627, 1.04839, 0.97454, 0.97454, 0.87207, 0.97454, 0.87533, 1.06151, 0.97454, 1.00176, 1.16484, 1.08132, 0.98047, 1.16484, 1.02989, 1.01054, 0.96225, 0.97454, 0.97454, 1.06598, 0.79004, 1.16344, 1.00351, 0.94629, 0.9973, 0.91016, 0.96777, 0.9043, 0.91082, 0.92481, 0.91082, 1.17308, 0.95748, 0.96927, 0.96927, 1, 0.96927, 0.92481, 0.80597, 1.04839, 1.23393, 1.1781, 0.9245, 1.17308, 1.20808, 0.63218, 0.94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, 0.85273, 0.78032, 1.04839, 1.09971, 1.22326, 0.9245, 1.09836, 1.13525, 1.15222, 0.70424, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.85498, 0.88506, 0.74817, 0.74817, 0.74817, 0.74817, 0.95782, 0.95782, 0.95782, 0.95782, 0.9858, 1.03989, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.17308, 0.96924, 0.95402, 0.95402, 0.95402, 0.95402, 0.83089, 0.86237, 0.88409, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.92916, 0.87207, 0.87533, 0.87533, 0.87533, 0.87533, 0.93146, 0.93146, 0.93146, 0.93146, 0.93854, 1.01054, 0.96225, 0.96225, 0.96225, 0.96225, 0.96225, 1.24822, 0.8761, 1.00351, 1.00351, 1.00351, 1.00351, 0.96777, 0.97454, 0.96777, 0.94729, 0.97454, 0.94729, 0.97454, 0.94729, 0.97454, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.9858, 0.95391, 0.9858, 0.97454, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.88449, 0.97454, 0.88449, 0.97454, 0.88449, 0.97454, 1, 1, 0.98039, 1.00176, 0.98039, 1.00176, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 1.16484, 0.95782, 0.93146, 0.84421, 1.12761, 0.69238, 1.08132, 1, 1, 0.98047, 0.83231, 1.16484, 1, 1, 0.84723, 1.04861, 0.84723, 0.78755, 0.83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, 0.9857, 1.03849, 1.01054, 0.96924, 0.96225, 0.96924, 0.96225, 0.96924, 0.96225, 0.92383, 0.90171, 0.80595, 1.06598, 1, 1, 0.80595, 1.06598, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 1, 1, 0.86091, 1.02759, 0.85771, 1.16344, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.98448, 0.9973, 0.83089, 0.96777, 0.83089, 0.93285, 0.9043, 0.93285, 0.9043, 0.93285, 0.9043, 1.31868, 0.96927, 0.94729, 0.97454, 0.85498, 0.92916, 0.96924, 0.8761, 1, 1, 0.86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 0.81965, 0.81965, 0.94729, 0.78032, 0.71022, 0.90883, 0.84171, 0.99877, 0.77596, 1.05734, 1.2, 0.94729, 0.85944, 0.82791, 0.9607, 0.74817, 0.93285, 0.98039, 0.96924, 0.95782, 0.89898, 0.98316, 0.98183, 1.03989, 0.78614, 0.96924, 0.97642, 0.86237, 0.86075, 0.86091, 0.83089, 0.90082, 0.8858, 0.97296, 1.01284, 0.95782, 0.83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, 0.98205, 1.03809, 1.05097, 1.04, 0.95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, 0.96225, 0.8965, 0.97783, 0.93574, 0.94818, 1.30679, 1.0675, 1.11826, 0.99821, 1.0557, 1.0326, 1.2, 1.0675, 0.96225, 1.0675, 1.0326, 0.74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.98705, 1, 1, 1, 1, 1, 1, 0.98448, 0.9973, 0.98448, 0.9973, 0.98448, 0.9973, 0.83089, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 0.94945, 0.94945, 0.94945, 0.94945, 1.12317, 1.12317, 1.12317, 0.67603, 0.67603, 1.15621, 0.73584, 1.21191, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87709, 0.96927, 1.01473, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, 0.86321, 0.94434, 0.8649, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86438, 1.17308, 1.18416, 1.14589, 0.69825, 0.97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.SegoeuiItalicMetrics = { lineHeight: 1.33008, lineGap: 0 }, l.SegoeuiRegularFactors = [1.76738, 1, 1, 0.98594, 1.02285, 1.10454, 1.06234, 0.96927, 0.92037, 1.19985, 1.2046, 0.90616, 0.90616, 1.07152, 1.1714, 0.78032, 1.20088, 0.78032, 1.40246, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78032, 0.78032, 1.1714, 1.1714, 1.1714, 0.80597, 0.94084, 0.96706, 0.85944, 0.85734, 0.97093, 0.75842, 0.79936, 0.88198, 0.9831, 0.95782, 0.71387, 0.86969, 0.84636, 1.07796, 1.03584, 0.96924, 0.83968, 0.96924, 0.82826, 0.79649, 0.85771, 0.95132, 0.93119, 0.98965, 0.88433, 0.8287, 0.93365, 1.08612, 1.3638, 1.08612, 1.45786, 0.74627, 0.80499, 0.91484, 1.05707, 0.92383, 1.05882, 0.9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, 0.99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, 0.84863, 1.21968, 1.01756, 0.95801, 1.00068, 0.91797, 0.96777, 0.9043, 0.90351, 0.92105, 0.90351, 1.1714, 0.85337, 0.96927, 0.96927, 0.99912, 0.96927, 0.92105, 0.80597, 1.2434, 1.20808, 1.05937, 0.90957, 1.1714, 1.20808, 0.75155, 0.94261, 1.24644, 1.09971, 1.09971, 0.84751, 1, 0.85273, 0.78032, 0.61584, 1.05425, 1.17914, 0.90957, 1.08665, 1.11593, 1.14169, 0.73381, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.86035, 0.85734, 0.75842, 0.75842, 0.75842, 0.75842, 0.95782, 0.95782, 0.95782, 0.95782, 0.97093, 1.03584, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.1714, 0.96924, 0.95132, 0.95132, 0.95132, 0.95132, 0.8287, 0.83968, 0.89049, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.93575, 0.92383, 0.9403, 0.9403, 0.9403, 0.9403, 0.8717, 0.8717, 0.8717, 0.8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, 0.95923, 1.01756, 1.01756, 1.01756, 1.01756, 0.96777, 1.05707, 0.96777, 0.96706, 0.91484, 0.96706, 0.91484, 0.96706, 0.91484, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.97093, 1.0969, 0.97093, 1.05882, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.88198, 1.05882, 0.88198, 1.05882, 0.88198, 1.05882, 1, 1, 0.9831, 1.01756, 0.9831, 1.01756, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 1.09011, 0.95782, 0.8717, 0.84784, 1.11551, 0.71387, 1.09011, 1, 1, 0.99414, 0.84636, 1.09011, 1, 1, 0.84636, 1.0536, 0.84636, 0.94298, 0.84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, 0.96924, 1.05356, 0.96924, 1.05356, 0.96924, 1.05356, 0.93066, 0.98293, 0.82826, 1.04399, 1, 1, 0.82826, 1.04399, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 1, 1, 0.85771, 1.17318, 0.85771, 1.21968, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.98965, 1.00068, 0.8287, 0.96777, 0.8287, 0.93365, 0.9043, 0.93365, 0.9043, 0.93365, 0.9043, 1.08571, 0.96927, 0.96706, 0.91484, 0.86035, 0.93575, 0.96924, 0.95923, 1, 1, 0.85771, 1.21968, 1.11437, 1.11437, 0.93109, 0.91202, 0.60411, 0.84164, 0.55572, 1.01173, 0.97361, 0.81818, 0.81818, 0.96635, 0.78032, 0.72727, 0.92366, 0.98601, 1.03405, 0.77968, 1.09799, 1.2, 0.96706, 0.85944, 0.85638, 0.96491, 0.75842, 0.93365, 0.9831, 0.96924, 0.95782, 0.86969, 0.94152, 1.07796, 1.03584, 0.78437, 0.96924, 0.98715, 0.83968, 0.83491, 0.85771, 0.8287, 0.94492, 0.88433, 0.9287, 1.0098, 0.95782, 0.8287, 1.0625, 0.98248, 1.03424, 1.2, 1.01071, 1.0625, 0.95246, 1.03809, 1.04912, 0.98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, 0.99609, 1.00169, 1.05176, 0.99346, 1.05356, 0.9087, 1.03004, 0.95542, 0.93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, 0.75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, 0.98965, 1.00068, 0.98965, 1.00068, 0.98965, 1.00068, 0.8287, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, 0.67428, 0.67428, 1.16039, 0.73291, 1.20996, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87796, 0.96927, 1.01518, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86507, 1.1714, 1.18416, 1.14589, 0.69825, 0.97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], l.SegoeuiRegularMetrics = { lineHeight: 1.33008, lineGap: 0 };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PostScriptEvaluator = l.PostScriptCompiler = l.PDFFunctionFactory = void 0, l.isPDFFunction = function(T) {
        let F;
        if (T instanceof o.Dict) F = T;
        else {
          if (!(T instanceof n.BaseStream)) return !1;
          F = T.dict;
        }
        return F.has("FunctionType");
      };
      var o = f(4), g = f(2), p = f(58), n = f(5), a = f(59);
      l.PDFFunctionFactory = class {
        constructor({ xref: T, isEvalSupported: F = !0 }) {
          this.xref = T, this.isEvalSupported = F !== !1;
        }
        create(T) {
          const F = this.getCached(T);
          if (F) return F;
          const S = m.parse({ xref: this.xref, isEvalSupported: this.isEvalSupported, fn: T instanceof o.Ref ? this.xref.fetch(T) : T });
          return this._cache(T, S), S;
        }
        createFromArray(T) {
          const F = this.getCached(T);
          if (F) return F;
          const S = m.parseArray({ xref: this.xref, isEvalSupported: this.isEvalSupported, fnObj: T instanceof o.Ref ? this.xref.fetch(T) : T });
          return this._cache(T, S), S;
        }
        getCached(T) {
          var S;
          let F;
          if (T instanceof o.Ref ? F = T : T instanceof o.Dict ? F = T.objId : T instanceof n.BaseStream && (F = (S = T.dict) == null ? void 0 : S.objId), F) {
            const A = this._localFunctionCache.getByRef(F);
            if (A) return A;
          }
          return null;
        }
        _cache(T, F) {
          var A;
          if (!F) throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
          let S;
          T instanceof o.Ref ? S = T : T instanceof o.Dict ? S = T.objId : T instanceof n.BaseStream && (S = (A = T.dict) == null ? void 0 : A.objId), S && this._localFunctionCache.set(null, S, F);
        }
        get _localFunctionCache() {
          return (0, g.shadow)(this, "_localFunctionCache", new a.LocalFunctionCache());
        }
      };
      function d(C) {
        if (!Array.isArray(C)) return null;
        const T = C.length;
        for (let F = 0; F < T; F++) if (typeof C[F] != "number") {
          const S = new Array(T);
          for (let A = 0; A < T; A++) S[A] = +C[A];
          return S;
        }
        return C;
      }
      class m {
        static getSampleArray(T, F, S, A) {
          let U, K, X = 1;
          for (U = 0, K = T.length; U < K; U++) X *= T[U];
          X *= F;
          const L = new Array(X);
          let H = 0, Q = 0;
          const N = 1 / (2 ** S - 1), V = A.getBytes((X * S + 7) / 8);
          let Y = 0;
          for (U = 0; U < X; U++) {
            for (; H < S; )
              Q <<= 8, Q |= V[Y++], H += 8;
            H -= S, L[U] = (Q >> H) * N, Q &= (1 << H) - 1;
          }
          return L;
        }
        static parse({ xref: T, isEvalSupported: F, fn: S }) {
          const A = S.dict || S;
          switch (A.get("FunctionType")) {
            case 0:
              return this.constructSampled({ xref: T, isEvalSupported: F, fn: S, dict: A });
            case 1:
              break;
            case 2:
              return this.constructInterpolated({ xref: T, isEvalSupported: F, dict: A });
            case 3:
              return this.constructStiched({ xref: T, isEvalSupported: F, dict: A });
            case 4:
              return this.constructPostScript({ xref: T, isEvalSupported: F, fn: S, dict: A });
          }
          throw new g.FormatError("Unknown type of function");
        }
        static parseArray({ xref: T, isEvalSupported: F, fnObj: S }) {
          if (!Array.isArray(S)) return this.parse({ xref: T, isEvalSupported: F, fn: S });
          const A = [];
          for (const U of S) A.push(this.parse({ xref: T, isEvalSupported: F, fn: T.fetchIfRef(U) }));
          return function(U, K, X, L) {
            for (let H = 0, Q = A.length; H < Q; H++) A[H](U, K, X, L + H);
          };
        }
        static constructSampled({ xref: T, isEvalSupported: F, fn: S, dict: A }) {
          function U(mt) {
            const yt = mt.length, at = [];
            let nt = 0;
            for (let q = 0; q < yt; q += 2) at[nt++] = [mt[q], mt[q + 1]];
            return at;
          }
          function K(mt, yt, at, nt, q) {
            return nt + (q - nt) / (at - yt) * (mt - yt);
          }
          let X = d(A.getArray("Domain")), L = d(A.getArray("Range"));
          if (!X || !L) throw new g.FormatError("No domain or range");
          const H = X.length / 2, Q = L.length / 2;
          X = U(X), L = U(L);
          const N = d(A.getArray("Size")), V = A.get("BitsPerSample"), Y = A.get("Order") || 1;
          Y !== 1 && (0, g.info)("No support for cubic spline interpolation: " + Y);
          let Z = d(A.getArray("Encode"));
          if (Z) Z = U(Z);
          else {
            Z = [];
            for (let mt = 0; mt < H; ++mt) Z.push([0, N[mt] - 1]);
          }
          let rt = d(A.getArray("Decode"));
          rt = rt ? U(rt) : L;
          const st = this.getSampleArray(N, Q, V, S);
          return function(yt, at, nt, q) {
            const D = 1 << H, G = new Float64Array(D), et = new Uint32Array(D);
            let J, it;
            for (it = 0; it < D; it++) G[it] = 1;
            let lt = Q, ot = 1;
            for (J = 0; J < H; ++J) {
              const ut = X[J][0], ct = X[J][1];
              let gt = K(Math.min(Math.max(yt[at + J], ut), ct), ut, ct, Z[J][0], Z[J][1]);
              const dt = N[J];
              gt = Math.min(Math.max(gt, 0), dt - 1);
              const bt = gt < dt - 1 ? Math.floor(gt) : gt - 1, vt = bt + 1 - gt, xt = gt - bt, St = bt * lt, Mt = St + lt;
              for (it = 0; it < D; it++) it & ot ? (G[it] *= xt, et[it] += Mt) : (G[it] *= vt, et[it] += St);
              lt *= dt, ot <<= 1;
            }
            for (it = 0; it < Q; ++it) {
              let ut = 0;
              for (J = 0; J < D; J++) ut += st[et[J] + it] * G[J];
              ut = K(ut, 0, 1, rt[it][0], rt[it][1]), nt[q + it] = Math.min(Math.max(ut, L[it][0]), L[it][1]);
            }
          };
        }
        static constructInterpolated({ xref: T, isEvalSupported: F, dict: S }) {
          const A = d(S.getArray("C0")) || [0], U = d(S.getArray("C1")) || [1], K = S.get("N"), X = [];
          for (let H = 0, Q = A.length; H < Q; ++H) X.push(U[H] - A[H]);
          const L = X.length;
          return function(Q, N, V, Y) {
            const Z = K === 1 ? Q[N] : Q[N] ** K;
            for (let rt = 0; rt < L; ++rt) V[Y + rt] = A[rt] + Z * X[rt];
          };
        }
        static constructStiched({ xref: T, isEvalSupported: F, dict: S }) {
          const A = d(S.getArray("Domain"));
          if (!A) throw new g.FormatError("No domain");
          if (A.length / 2 !== 1) throw new g.FormatError("Bad domain for stiched function");
          const U = [];
          for (const H of S.get("Functions")) U.push(this.parse({ xref: T, isEvalSupported: F, fn: T.fetchIfRef(H) }));
          const K = d(S.getArray("Bounds")), X = d(S.getArray("Encode")), L = new Float32Array(1);
          return function(Q, N, V, Y) {
            const Z = function(D, G, et) {
              return D > et ? D = et : D < G && (D = G), D;
            }(Q[N], A[0], A[1]), rt = K.length;
            let st;
            for (st = 0; st < rt && !(Z < K[st]); ++st) ;
            let mt = A[0];
            st > 0 && (mt = K[st - 1]);
            let yt = A[1];
            st < K.length && (yt = K[st]);
            const at = X[2 * st], nt = X[2 * st + 1];
            L[0] = mt === yt ? at : at + (Z - mt) * (nt - at) / (yt - mt), U[st](L, 0, V, Y);
          };
        }
        static constructPostScript({ xref: T, isEvalSupported: F, fn: S, dict: A }) {
          const U = d(A.getArray("Domain")), K = d(A.getArray("Range"));
          if (!U) throw new g.FormatError("No domain.");
          if (!K) throw new g.FormatError("No range.");
          const X = new p.PostScriptLexer(S), L = new p.PostScriptParser(X).parse();
          if (F && g.FeatureTest.isEvalSupported) {
            const rt = new $().compile(L, U, K);
            if (rt) return new Function("src", "srcOffset", "dest", "destOffset", rt);
          }
          (0, g.info)("Unable to compile PS function");
          const H = K.length >> 1, Q = U.length >> 1, N = new w(L), V = /* @__PURE__ */ Object.create(null);
          let Y = 8192;
          const Z = new Float32Array(Q);
          return function(st, mt, yt, at) {
            let nt, q, D = "";
            const G = Z;
            for (nt = 0; nt < Q; nt++)
              q = st[mt + nt], G[nt] = q, D += q + "_";
            const et = V[D];
            if (et !== void 0) {
              yt.set(et, at);
              return;
            }
            const J = new Float32Array(H), it = N.execute(G), lt = it.length - H;
            for (nt = 0; nt < H; nt++) {
              q = it[lt + nt];
              let ot = K[2 * nt];
              q < ot ? q = ot : (ot = K[2 * nt + 1], q > ot && (q = ot)), J[nt] = q;
            }
            Y > 0 && (Y--, V[D] = J), yt.set(J, at);
          };
        }
      }
      const B = class B {
        constructor(T) {
          this.stack = T ? Array.from(T) : [];
        }
        push(T) {
          if (this.stack.length >= B.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
          this.stack.push(T);
        }
        pop() {
          if (this.stack.length <= 0) throw new Error("PostScript function stack underflow.");
          return this.stack.pop();
        }
        copy(T) {
          if (this.stack.length + T >= B.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
          const F = this.stack;
          for (let S = F.length - T, A = T - 1; A >= 0; A--, S++) F.push(F[S]);
        }
        index(T) {
          this.push(this.stack[this.stack.length - T - 1]);
        }
        roll(T, F) {
          const S = this.stack, A = S.length - T, U = S.length - 1, K = A + (F - Math.floor(F / T) * T);
          for (let X = A, L = U; X < L; X++, L--) {
            const H = S[X];
            S[X] = S[L], S[L] = H;
          }
          for (let X = A, L = K - 1; X < L; X++, L--) {
            const H = S[X];
            S[X] = S[L], S[L] = H;
          }
          for (let X = K, L = U; X < L; X++, L--) {
            const H = S[X];
            S[X] = S[L], S[L] = H;
          }
        }
      };
      Mr(B, "MAX_STACK_SIZE", 100);
      let b = B;
      class w {
        constructor(T) {
          this.operators = T;
        }
        execute(T) {
          const F = new b(T);
          let S = 0;
          const A = this.operators, U = A.length;
          let K, X, L;
          for (; S < U; )
            if (K = A[S++], typeof K != "number") switch (K) {
              case "jz":
                L = F.pop(), X = F.pop(), X || (S = L);
                break;
              case "j":
                X = F.pop(), S = X;
                break;
              case "abs":
                X = F.pop(), F.push(Math.abs(X));
                break;
              case "add":
                L = F.pop(), X = F.pop(), F.push(X + L);
                break;
              case "and":
                L = F.pop(), X = F.pop(), typeof X == "boolean" && typeof L == "boolean" ? F.push(X && L) : F.push(X & L);
                break;
              case "atan":
                L = F.pop(), X = F.pop(), X = Math.atan2(X, L) / Math.PI * 180, X < 0 && (X += 360), F.push(X);
                break;
              case "bitshift":
                L = F.pop(), X = F.pop(), X > 0 ? F.push(X << L) : F.push(X >> L);
                break;
              case "ceiling":
                X = F.pop(), F.push(Math.ceil(X));
                break;
              case "copy":
                X = F.pop(), F.copy(X);
                break;
              case "cos":
                X = F.pop(), F.push(Math.cos(X % 360 / 180 * Math.PI));
                break;
              case "cvi":
                X = 0 | F.pop(), F.push(X);
                break;
              case "cvr":
                break;
              case "div":
                L = F.pop(), X = F.pop(), F.push(X / L);
                break;
              case "dup":
                F.copy(1);
                break;
              case "eq":
                L = F.pop(), X = F.pop(), F.push(X === L);
                break;
              case "exch":
                F.roll(2, 1);
                break;
              case "exp":
                L = F.pop(), X = F.pop(), F.push(X ** L);
                break;
              case "false":
                F.push(!1);
                break;
              case "floor":
                X = F.pop(), F.push(Math.floor(X));
                break;
              case "ge":
                L = F.pop(), X = F.pop(), F.push(X >= L);
                break;
              case "gt":
                L = F.pop(), X = F.pop(), F.push(X > L);
                break;
              case "idiv":
                L = F.pop(), X = F.pop(), F.push(X / L | 0);
                break;
              case "index":
                X = F.pop(), F.index(X);
                break;
              case "le":
                L = F.pop(), X = F.pop(), F.push(X <= L);
                break;
              case "ln":
                X = F.pop(), F.push(Math.log(X));
                break;
              case "log":
                X = F.pop(), F.push(Math.log10(X));
                break;
              case "lt":
                L = F.pop(), X = F.pop(), F.push(X < L);
                break;
              case "mod":
                L = F.pop(), X = F.pop(), F.push(X % L);
                break;
              case "mul":
                L = F.pop(), X = F.pop(), F.push(X * L);
                break;
              case "ne":
                L = F.pop(), X = F.pop(), F.push(X !== L);
                break;
              case "neg":
                X = F.pop(), F.push(-X);
                break;
              case "not":
                X = F.pop(), typeof X == "boolean" ? F.push(!X) : F.push(~X);
                break;
              case "or":
                L = F.pop(), X = F.pop(), typeof X == "boolean" && typeof L == "boolean" ? F.push(X || L) : F.push(X | L);
                break;
              case "pop":
                F.pop();
                break;
              case "roll":
                L = F.pop(), X = F.pop(), F.roll(X, L);
                break;
              case "round":
                X = F.pop(), F.push(Math.round(X));
                break;
              case "sin":
                X = F.pop(), F.push(Math.sin(X % 360 / 180 * Math.PI));
                break;
              case "sqrt":
                X = F.pop(), F.push(Math.sqrt(X));
                break;
              case "sub":
                L = F.pop(), X = F.pop(), F.push(X - L);
                break;
              case "true":
                F.push(!0);
                break;
              case "truncate":
                X = F.pop(), X = X < 0 ? Math.ceil(X) : Math.floor(X), F.push(X);
                break;
              case "xor":
                L = F.pop(), X = F.pop(), typeof X == "boolean" && typeof L == "boolean" ? F.push(X !== L) : F.push(X ^ L);
                break;
              default:
                throw new g.FormatError(`Unknown operator ${K}`);
            }
            else F.push(K);
          return F.stack;
        }
      }
      l.PostScriptEvaluator = w;
      class v {
        constructor(T) {
          this.type = T;
        }
        visit(T) {
          (0, g.unreachable)("abstract method");
        }
      }
      class h extends v {
        constructor(T, F, S) {
          super("args"), this.index = T, this.min = F, this.max = S;
        }
        visit(T) {
          T.visitArgument(this);
        }
      }
      class x extends v {
        constructor(T) {
          super("literal"), this.number = T, this.min = T, this.max = T;
        }
        visit(T) {
          T.visitLiteral(this);
        }
      }
      class _ extends v {
        constructor(T, F, S, A, U) {
          super("binary"), this.op = T, this.arg1 = F, this.arg2 = S, this.min = A, this.max = U;
        }
        visit(T) {
          T.visitBinaryOperation(this);
        }
      }
      class M extends v {
        constructor(T, F) {
          super("max"), this.arg = T, this.min = T.min, this.max = F;
        }
        visit(T) {
          T.visitMin(this);
        }
      }
      class O extends v {
        constructor(T, F, S) {
          super("var"), this.index = T, this.min = F, this.max = S;
        }
        visit(T) {
          T.visitVariable(this);
        }
      }
      class E extends v {
        constructor(T, F) {
          super("definition"), this.variable = T, this.arg = F;
        }
        visit(T) {
          T.visitVariableDefinition(this);
        }
      }
      class I {
        constructor() {
          this.parts = [];
        }
        visitArgument(T) {
          this.parts.push("Math.max(", T.min, ", Math.min(", T.max, ", src[srcOffset + ", T.index, "]))");
        }
        visitVariable(T) {
          this.parts.push("v", T.index);
        }
        visitLiteral(T) {
          this.parts.push(T.number);
        }
        visitBinaryOperation(T) {
          this.parts.push("("), T.arg1.visit(this), this.parts.push(" ", T.op, " "), T.arg2.visit(this), this.parts.push(")");
        }
        visitVariableDefinition(T) {
          this.parts.push("var "), T.variable.visit(this), this.parts.push(" = "), T.arg.visit(this), this.parts.push(";");
        }
        visitMin(T) {
          this.parts.push("Math.min("), T.arg.visit(this), this.parts.push(", ", T.max, ")");
        }
        toString() {
          return this.parts.join("");
        }
      }
      function R(C, T) {
        return T.type === "literal" && T.number === 0 ? C : C.type === "literal" && C.number === 0 ? T : T.type === "literal" && C.type === "literal" ? new x(C.number + T.number) : new _("+", C, T, C.min + T.min, C.max + T.max);
      }
      function W(C, T) {
        if (T.type === "literal") {
          if (T.number === 0) return new x(0);
          if (T.number === 1) return C;
          if (C.type === "literal") return new x(C.number * T.number);
        }
        if (C.type === "literal") {
          if (C.number === 0) return new x(0);
          if (C.number === 1) return T;
        }
        const F = Math.min(C.min * T.min, C.min * T.max, C.max * T.min, C.max * T.max), S = Math.max(C.min * T.min, C.min * T.max, C.max * T.min, C.max * T.max);
        return new _("*", C, T, F, S);
      }
      function z(C, T) {
        if (T.type === "literal") {
          if (T.number === 0) return C;
          if (C.type === "literal") return new x(C.number - T.number);
        }
        return T.type === "binary" && T.op === "-" && C.type === "literal" && C.number === 1 && T.arg1.type === "literal" && T.arg1.number === 1 ? T.arg2 : new _("-", C, T, C.min - T.max, C.max - T.min);
      }
      function j(C, T) {
        return C.min >= T ? new x(T) : C.max <= T ? C : new M(C, T);
      }
      class $ {
        compile(T, F, S) {
          const A = [], U = [], K = F.length >> 1, X = S.length >> 1;
          let L, H, Q, N, V, Y, Z, rt, st = 0;
          for (let yt = 0; yt < K; yt++) A.push(new h(yt, F[2 * yt], F[2 * yt + 1]));
          for (let yt = 0, at = T.length; yt < at; yt++)
            if (rt = T[yt], typeof rt != "number") switch (rt) {
              case "add":
                if (A.length < 2) return null;
                N = A.pop(), Q = A.pop(), A.push(R(Q, N));
                break;
              case "cvr":
                if (A.length < 1) return null;
                break;
              case "mul":
                if (A.length < 2) return null;
                N = A.pop(), Q = A.pop(), A.push(W(Q, N));
                break;
              case "sub":
                if (A.length < 2) return null;
                N = A.pop(), Q = A.pop(), A.push(z(Q, N));
                break;
              case "exch":
                if (A.length < 2) return null;
                V = A.pop(), Y = A.pop(), A.push(V, Y);
                break;
              case "pop":
                if (A.length < 1) return null;
                A.pop();
                break;
              case "index":
                if (A.length < 1 || (Q = A.pop(), Q.type !== "literal") || (L = Q.number, L < 0 || !Number.isInteger(L) || A.length < L)) return null;
                if (V = A[A.length - L - 1], V.type === "literal" || V.type === "var") {
                  A.push(V);
                  break;
                }
                Z = new O(st++, V.min, V.max), A[A.length - L - 1] = Z, A.push(Z), U.push(new E(Z, V));
                break;
              case "dup":
                if (A.length < 1) return null;
                if (typeof T[yt + 1] == "number" && T[yt + 2] === "gt" && T[yt + 3] === yt + 7 && T[yt + 4] === "jz" && T[yt + 5] === "pop" && T[yt + 6] === T[yt + 1]) {
                  Q = A.pop(), A.push(j(Q, T[yt + 1])), yt += 6;
                  break;
                }
                if (V = A.at(-1), V.type === "literal" || V.type === "var") {
                  A.push(V);
                  break;
                }
                Z = new O(st++, V.min, V.max), A[A.length - 1] = Z, A.push(Z), U.push(new E(Z, V));
                break;
              case "roll":
                if (A.length < 2 || (N = A.pop(), Q = A.pop(), N.type !== "literal" || Q.type !== "literal") || (H = N.number, L = Q.number, L <= 0 || !Number.isInteger(L) || !Number.isInteger(H) || A.length < L)) return null;
                if (H = (H % L + L) % L, H === 0) break;
                A.push(...A.splice(A.length - L, L - H));
                break;
              default:
                return null;
            }
            else A.push(new x(rt));
          if (A.length !== X) return null;
          const mt = [];
          for (const yt of U) {
            const at = new I();
            yt.visit(at), mt.push(at.toString());
          }
          for (let yt = 0, at = A.length; yt < at; yt++) {
            const nt = A[yt], q = new I();
            nt.visit(q);
            const D = S[2 * yt], G = S[2 * yt + 1], et = [q.toString()];
            D > nt.min && (et.unshift("Math.max(", D, ", "), et.push(")")), G < nt.max && (et.unshift("Math.min(", G, ", "), et.push(")")), et.unshift("dest[destOffset + ", yt, "] = "), et.push(";"), mt.push(et.join(""));
          }
          return mt.join(`
`);
        }
      }
      l.PostScriptCompiler = $;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PostScriptParser = l.PostScriptLexer = void 0;
      var o = f(2), g = f(4), p = f(3);
      l.PostScriptParser = class {
        constructor(m) {
          this.lexer = m, this.operators = [], this.token = null, this.prev = null;
        }
        nextToken() {
          this.prev = this.token, this.token = this.lexer.getToken();
        }
        accept(m) {
          return this.token.type === m ? (this.nextToken(), !0) : !1;
        }
        expect(m) {
          if (this.accept(m)) return !0;
          throw new o.FormatError(`Unexpected symbol: found ${this.token.type} expected ${m}.`);
        }
        parse() {
          return this.nextToken(), this.expect(n.LBRACE), this.parseBlock(), this.expect(n.RBRACE), this.operators;
        }
        parseBlock() {
          for (; ; ) if (this.accept(n.NUMBER)) this.operators.push(this.prev.value);
          else if (this.accept(n.OPERATOR)) this.operators.push(this.prev.value);
          else {
            if (!this.accept(n.LBRACE)) return;
            this.parseCondition();
          }
        }
        parseCondition() {
          const m = this.operators.length;
          if (this.operators.push(null, null), this.parseBlock(), this.expect(n.RBRACE), this.accept(n.IF))
            this.operators[m] = this.operators.length, this.operators[m + 1] = "jz";
          else {
            if (!this.accept(n.LBRACE)) throw new o.FormatError("PS Function: error parsing conditional.");
            {
              const b = this.operators.length;
              this.operators.push(null, null);
              const w = this.operators.length;
              this.parseBlock(), this.expect(n.RBRACE), this.expect(n.IFELSE), this.operators[b] = this.operators.length, this.operators[b + 1] = "j", this.operators[m] = w, this.operators[m + 1] = "jz";
            }
          }
        }
      };
      const n = { LBRACE: 0, RBRACE: 1, NUMBER: 2, OPERATOR: 3, IF: 4, IFELSE: 5 };
      class a {
        static get opCache() {
          return (0, o.shadow)(this, "opCache", /* @__PURE__ */ Object.create(null));
        }
        constructor(m, b) {
          this.type = m, this.value = b;
        }
        static getOperator(m) {
          var b;
          return (b = a.opCache)[m] || (b[m] = new a(n.OPERATOR, m));
        }
        static get LBRACE() {
          return (0, o.shadow)(this, "LBRACE", new a(n.LBRACE, "{"));
        }
        static get RBRACE() {
          return (0, o.shadow)(this, "RBRACE", new a(n.RBRACE, "}"));
        }
        static get IF() {
          return (0, o.shadow)(this, "IF", new a(n.IF, "IF"));
        }
        static get IFELSE() {
          return (0, o.shadow)(this, "IFELSE", new a(n.IFELSE, "IFELSE"));
        }
      }
      l.PostScriptLexer = class {
        constructor(m) {
          this.stream = m, this.nextChar(), this.strBuf = [];
        }
        nextChar() {
          return this.currentChar = this.stream.getByte();
        }
        getToken() {
          let m = !1, b = this.currentChar;
          for (; ; ) {
            if (b < 0) return g.EOF;
            if (m) b !== 10 && b !== 13 || (m = !1);
            else if (b === 37) m = !0;
            else if (!(0, p.isWhiteSpace)(b)) break;
            b = this.nextChar();
          }
          switch (0 | b) {
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 43:
            case 45:
            case 46:
              return new a(n.NUMBER, this.getNumber());
            case 123:
              return this.nextChar(), a.LBRACE;
            case 125:
              return this.nextChar(), a.RBRACE;
          }
          const w = this.strBuf;
          for (w.length = 0, w[0] = String.fromCharCode(b); (b = this.nextChar()) >= 0 && (b >= 65 && b <= 90 || b >= 97 && b <= 122); ) w.push(String.fromCharCode(b));
          const v = w.join("");
          switch (v.toLowerCase()) {
            case "if":
              return a.IF;
            case "ifelse":
              return a.IFELSE;
            default:
              return a.getOperator(v);
          }
        }
        getNumber() {
          let m = this.currentChar;
          const b = this.strBuf;
          for (b.length = 0, b[0] = String.fromCharCode(m); (m = this.nextChar()) >= 0 && (m >= 48 && m <= 57 || m === 45 || m === 46); ) b.push(String.fromCharCode(m));
          const w = parseFloat(b.join(""));
          if (isNaN(w)) throw new o.FormatError(`Invalid floating point number: ${w}`);
          return w;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.RegionalImageCache = l.LocalTilingPatternCache = l.LocalImageCache = l.LocalGStateCache = l.LocalFunctionCache = l.LocalColorSpaceCache = l.GlobalImageCache = void 0;
      var o = f(2), g = f(4);
      class p {
        constructor(m) {
          this.constructor === p && (0, o.unreachable)("Cannot initialize BaseLocalCache."), this._onlyRefs = (m == null ? void 0 : m.onlyRefs) === !0, this._onlyRefs || (this._nameRefMap = /* @__PURE__ */ new Map(), this._imageMap = /* @__PURE__ */ new Map()), this._imageCache = new g.RefSetCache();
        }
        getByName(m) {
          this._onlyRefs && (0, o.unreachable)("Should not call `getByName` method.");
          const b = this._nameRefMap.get(m);
          return b ? this.getByRef(b) : this._imageMap.get(m) || null;
        }
        getByRef(m) {
          return this._imageCache.get(m) || null;
        }
        set(m, b, w) {
          (0, o.unreachable)("Abstract method `set` called.");
        }
      }
      l.LocalImageCache = class extends p {
        set(m, b = null, w) {
          if (typeof m != "string") throw new Error('LocalImageCache.set - expected "name" argument.');
          if (b) {
            if (this._imageCache.has(b)) return;
            this._nameRefMap.set(m, b), this._imageCache.put(b, w);
          } else this._imageMap.has(m) || this._imageMap.set(m, w);
        }
      }, l.LocalColorSpaceCache = class extends p {
        set(m = null, b = null, w) {
          if (typeof m != "string" && !b) throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
          if (b) {
            if (this._imageCache.has(b)) return;
            m !== null && this._nameRefMap.set(m, b), this._imageCache.put(b, w);
          } else this._imageMap.has(m) || this._imageMap.set(m, w);
        }
      }, l.LocalFunctionCache = class extends p {
        constructor(m) {
          super({ onlyRefs: !0 });
        }
        set(m = null, b, w) {
          if (!b) throw new Error('LocalFunctionCache.set - expected "ref" argument.');
          this._imageCache.has(b) || this._imageCache.put(b, w);
        }
      }, l.LocalGStateCache = class extends p {
        set(m, b = null, w) {
          if (typeof m != "string") throw new Error('LocalGStateCache.set - expected "name" argument.');
          if (b) {
            if (this._imageCache.has(b)) return;
            this._nameRefMap.set(m, b), this._imageCache.put(b, w);
          } else this._imageMap.has(m) || this._imageMap.set(m, w);
        }
      }, l.LocalTilingPatternCache = class extends p {
        constructor(m) {
          super({ onlyRefs: !0 });
        }
        set(m = null, b, w) {
          if (!b) throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
          this._imageCache.has(b) || this._imageCache.put(b, w);
        }
      }, l.RegionalImageCache = class extends p {
        constructor(m) {
          super({ onlyRefs: !0 });
        }
        set(m = null, b, w) {
          if (!b) throw new Error('RegionalImageCache.set - expected "ref" argument.');
          this._imageCache.has(b) || this._imageCache.put(b, w);
        }
      };
      const a = class a {
        constructor() {
          this._refCache = new g.RefSetCache(), this._imageCache = new g.RefSetCache();
        }
        get _byteSize() {
          let m = 0;
          for (const b of this._imageCache) m += b.byteSize;
          return m;
        }
        get _cacheLimitReached() {
          return !(this._imageCache.size < a.MIN_IMAGES_TO_CACHE) && !(this._byteSize < a.MAX_BYTE_SIZE);
        }
        shouldCache(m, b) {
          let w = this._refCache.get(m);
          return w || (w = /* @__PURE__ */ new Set(), this._refCache.put(m, w)), w.add(b), !(w.size < a.NUM_PAGES_THRESHOLD) && !(!this._imageCache.has(m) && this._cacheLimitReached);
        }
        addByteSize(m, b) {
          const w = this._imageCache.get(m);
          w && (w.byteSize || (w.byteSize = b));
        }
        getData(m, b) {
          const w = this._refCache.get(m);
          if (!w || w.size < a.NUM_PAGES_THRESHOLD) return null;
          const v = this._imageCache.get(m);
          return v ? (w.add(b), v) : null;
        }
        setData(m, b) {
          if (!this._refCache.has(m)) throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
          this._imageCache.has(m) || (this._cacheLimitReached ? (0, o.warn)("GlobalImageCache.setData - cache limit reached.") : this._imageCache.put(m, b));
        }
        clear(m = !1) {
          m || this._refCache.clear(), this._imageCache.clear();
        }
      };
      Mr(a, "NUM_PAGES_THRESHOLD", 2), Mr(a, "MIN_IMAGES_TO_CACHE", 10), Mr(a, "MAX_BYTE_SIZE", 5 * o.MAX_IMAGE_SIZE_TO_CACHE);
      let n = a;
      l.GlobalImageCache = n;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.bidi = function(_, M = -1, O = !1) {
        let E = !0;
        const I = _.length;
        if (I === 0 || O) return w(_, E, O);
        v.length = I, h.length = I;
        let R, W, z = 0;
        for (R = 0; R < I; ++R) {
          v[R] = _.charAt(R);
          const K = _.charCodeAt(R);
          let X = "L";
          K <= 255 ? X = g[K] : 1424 <= K && K <= 1524 ? X = "R" : 1536 <= K && K <= 1791 ? (X = p[255 & K], X || (0, o.warn)("Bidi: invalid Unicode character " + K.toString(16))) : (1792 <= K && K <= 2220 || 64336 <= K && K <= 65023 || 65136 <= K && K <= 65279) && (X = "AL"), X !== "R" && X !== "AL" && X !== "AN" || z++, h[R] = X;
        }
        if (z === 0)
          return E = !0, w(_, E);
        M === -1 && (z / I < 0.3 && I > 4 ? (E = !0, M = 0) : (E = !1, M = 1));
        const j = [];
        for (R = 0; R < I; ++R) j[R] = M;
        const $ = n(M) ? "R" : "L", B = $, C = B;
        let T, F = B;
        for (R = 0; R < I; ++R) h[R] === "NSM" ? h[R] = F : F = h[R];
        for (F = B, R = 0; R < I; ++R)
          T = h[R], T === "EN" ? h[R] = F === "AL" ? "AN" : "EN" : T !== "R" && T !== "L" && T !== "AL" || (F = T);
        for (R = 0; R < I; ++R)
          T = h[R], T === "AL" && (h[R] = "R");
        for (R = 1; R < I - 1; ++R)
          h[R] === "ES" && h[R - 1] === "EN" && h[R + 1] === "EN" && (h[R] = "EN"), h[R] !== "CS" || h[R - 1] !== "EN" && h[R - 1] !== "AN" || h[R + 1] !== h[R - 1] || (h[R] = h[R - 1]);
        for (R = 0; R < I; ++R) if (h[R] === "EN") {
          for (let K = R - 1; K >= 0 && h[K] === "ET"; --K) h[K] = "EN";
          for (let K = R + 1; K < I && h[K] === "ET"; ++K) h[K] = "EN";
        }
        for (R = 0; R < I; ++R)
          T = h[R], T !== "WS" && T !== "ES" && T !== "ET" && T !== "CS" || (h[R] = "ON");
        for (F = B, R = 0; R < I; ++R)
          T = h[R], T === "EN" ? h[R] = F === "L" ? "L" : "EN" : T !== "R" && T !== "L" || (F = T);
        for (R = 0; R < I; ++R) if (h[R] === "ON") {
          const K = d(h, R + 1, "ON");
          let X = B;
          R > 0 && (X = h[R - 1]);
          let L = C;
          K + 1 < I && (L = h[K + 1]), X !== "L" && (X = "R"), L !== "L" && (L = "R"), X === L && m(h, R, K, X), R = K - 1;
        }
        for (R = 0; R < I; ++R) h[R] === "ON" && (h[R] = $);
        for (R = 0; R < I; ++R)
          T = h[R], a(j[R]) ? T === "R" ? j[R] += 1 : T !== "AN" && T !== "EN" || (j[R] += 2) : T !== "L" && T !== "AN" && T !== "EN" || (j[R] += 1);
        let S, A = -1, U = 99;
        for (R = 0, W = j.length; R < W; ++R)
          S = j[R], A < S && (A = S), U > S && n(S) && (U = S);
        for (S = A; S >= U; --S) {
          let K = -1;
          for (R = 0, W = j.length; R < W; ++R) j[R] < S ? K >= 0 && (b(v, K, R), K = -1) : K < 0 && (K = R);
          K >= 0 && b(v, K, j.length);
        }
        for (R = 0, W = v.length; R < W; ++R) {
          const K = v[R];
          K !== "<" && K !== ">" || (v[R] = "");
        }
        return w(v.join(""), E);
      };
      var o = f(2);
      const g = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"], p = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
      function n(x) {
        return (1 & x) != 0;
      }
      function a(x) {
        return (1 & x) == 0;
      }
      function d(x, _, M) {
        let O, E;
        for (O = _, E = x.length; O < E; ++O) if (x[O] !== M) return O;
        return O;
      }
      function m(x, _, M, O) {
        for (let E = _; E < M; ++E) x[E] = O;
      }
      function b(x, _, M) {
        for (let O = _, E = M - 1; O < E; ++O, --E) {
          const I = x[O];
          x[O] = x[E], x[E] = I;
        }
      }
      function w(x, _, M = !1) {
        let O = "ltr";
        return M ? O = "ttb" : _ || (O = "rtl"), { str: x, dir: O };
      }
      const v = [], h = [];
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.getFontSubstitution = function(h, x, _, M, O) {
        const E = M = (0, o.normalizeFontName)(M);
        let I = h.get(E);
        if (I) return I;
        let R = m.get(M);
        if (!R) {
          for (const [T, F] of b) if (M.startsWith(T)) {
            M = `${F}${M.substring(T.length)}`, R = m.get(M);
            break;
          }
        }
        let W = !1;
        R || (R = m.get(O), W = !0);
        const z = `${x.getDocId()}_s${x.createFontId()}`;
        if (!R) {
          if (!(0, g.validateFontName)(M))
            return h.set(E, null), null;
          const T = /bold/gi.test(M), F = /oblique|italic/gi.test(M);
          return I = { css: z, guessFallback: !0, loadedName: z, baseFontName: M, src: `local(${M})`, style: T && F && d || T && n || F && a || p }, h.set(E, I), I;
        }
        const j = [];
        W && (0, g.validateFontName)(M) && j.push(`local(${M})`);
        const { style: $, ultimate: B } = w(R, j, _), C = B === null;
        return I = { css: `${z}${C ? "" : `,${B}`}`, guessFallback: C, loadedName: z, baseFontName: M, src: j.join(","), style: $ }, h.set(E, I), I;
      };
      var o = f(38), g = f(3);
      const p = { style: "normal", weight: "normal" }, n = { style: "normal", weight: "bold" }, a = { style: "italic", weight: "normal" }, d = { style: "italic", weight: "bold" }, m = /* @__PURE__ */ new Map([["Times-Roman", { local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"], style: p, ultimate: "serif" }], ["Times-Bold", { alias: "Times-Roman", style: n, ultimate: "serif" }], ["Times-Italic", { alias: "Times-Roman", style: a, ultimate: "serif" }], ["Times-BoldItalic", { alias: "Times-Roman", style: d, ultimate: "serif" }], ["Helvetica", { local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"], path: "LiberationSans-Regular.ttf", style: p, ultimate: "sans-serif" }], ["Helvetica-Bold", { alias: "Helvetica", path: "LiberationSans-Bold.ttf", style: n, ultimate: "sans-serif" }], ["Helvetica-Oblique", { alias: "Helvetica", path: "LiberationSans-Italic.ttf", style: a, ultimate: "sans-serif" }], ["Helvetica-BoldOblique", { alias: "Helvetica", path: "LiberationSans-BoldItalic.ttf", style: d, ultimate: "sans-serif" }], ["Courier", { local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono"], style: p, ultimate: "monospace" }], ["Courier-Bold", { alias: "Courier", style: n, ultimate: "monospace" }], ["Courier-Oblique", { alias: "Courier", style: a, ultimate: "monospace" }], ["Courier-BoldOblique", { alias: "Courier", style: d, ultimate: "monospace" }], ["ArialBlack", { local: ["Arial Black"], style: { style: "normal", weight: "900" }, fallback: "Helvetica-Bold" }], ["ArialBlack-Bold", { alias: "ArialBlack" }], ["ArialBlack-Italic", { alias: "ArialBlack", style: { style: "italic", weight: "900" }, fallback: "Helvetica-BoldOblique" }], ["ArialBlack-BoldItalic", { alias: "ArialBlack-Italic" }], ["ArialNarrow", { local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"], style: p, fallback: "Helvetica" }], ["ArialNarrow-Bold", { alias: "ArialNarrow", style: n, fallback: "Helvetica-Bold" }], ["ArialNarrow-Italic", { alias: "ArialNarrow", style: a, fallback: "Helvetica-Oblique" }], ["ArialNarrow-BoldItalic", { alias: "ArialNarrow", style: d, fallback: "Helvetica-BoldOblique" }], ["Calibri", { local: ["Calibri", "Carlito"], style: p, fallback: "Helvetica" }], ["Calibri-Bold", { alias: "Calibri", style: n, fallback: "Helvetica-Bold" }], ["Calibri-Italic", { alias: "Calibri", style: a, fallback: "Helvetica-Oblique" }], ["Calibri-BoldItalic", { alias: "Calibri", style: d, fallback: "Helvetica-BoldOblique" }], ["Wingdings", { local: ["Wingdings", "URW Dingbats"], style: p }], ["Wingdings-Regular", { alias: "Wingdings" }], ["Wingdings-Bold", { alias: "Wingdings" }]]), b = /* @__PURE__ */ new Map([["Arial-Black", "ArialBlack"]]);
      function w({ alias: v, local: h, path: x, fallback: _, style: M, ultimate: O }, E, I, R = !0, W = !0, z = "") {
        const j = { style: null, ultimate: null };
        if (h) {
          const $ = z ? ` ${z}` : "";
          for (const B of h) E.push(`local(${B}${$})`);
        }
        if (v) {
          const $ = m.get(v), B = z || function(T) {
            switch (T) {
              case n:
                return "Bold";
              case a:
                return "Italic";
              case d:
                return "Bold Italic";
              default:
                if ((T == null ? void 0 : T.weight) === "bold") return "Bold";
                if ((T == null ? void 0 : T.style) === "italic") return "Italic";
            }
            return "";
          }(M);
          Object.assign(j, w($, E, I, R && !_, W && !x, B));
        }
        if (M && (j.style = M), O && (j.ultimate = O), R && _) {
          const $ = m.get(_), { ultimate: B } = w($, E, I, R, W && !x, z);
          j.ultimate || (j.ultimate = B);
        }
        return W && x && I && E.push(`url(${I}${x})`), j;
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ImageResizer = void 0;
      var o = f(2);
      class g {
        constructor(n, a) {
          this._imgData = n, this._isMask = a;
        }
        static needsToBeResized(n, a) {
          if (n <= this._goodSquareLength && a <= this._goodSquareLength) return !1;
          const { MAX_DIM: d } = this;
          if (n > d || a > d) return !0;
          const m = n * a;
          return this._hasMaxArea ? m > this.MAX_AREA : m < this._goodSquareLength ** 2 ? !1 : this._areGoodDims(n, a) ? (this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(n * a))), !1) : (this._goodSquareLength = this._guessMax(this._goodSquareLength, d, 128, 0), m > (this.MAX_AREA = this._goodSquareLength ** 2));
        }
        static get MAX_DIM() {
          return (0, o.shadow)(this, "MAX_DIM", this._guessMax(2048, 65537, 0, 1));
        }
        static get MAX_AREA() {
          return this._hasMaxArea = !0, (0, o.shadow)(this, "MAX_AREA", this._guessMax(g._goodSquareLength, this.MAX_DIM, 128, 0) ** 2);
        }
        static set MAX_AREA(n) {
          n >= 0 && (this._hasMaxArea = !0, (0, o.shadow)(this, "MAX_AREA", n));
        }
        static setMaxArea(n) {
          this._hasMaxArea || (this.MAX_AREA = n >> 2);
        }
        static _areGoodDims(n, a) {
          try {
            const d = new OffscreenCanvas(n, a), m = d.getContext("2d");
            m.fillRect(0, 0, 1, 1);
            const b = m.getImageData(0, 0, 1, 1).data[3];
            return d.width = d.height = 1, b !== 0;
          } catch {
            return !1;
          }
        }
        static _guessMax(n, a, d, m) {
          for (; n + d + 1 < a; ) {
            const b = Math.floor((n + a) / 2), w = m || b;
            this._areGoodDims(b, w) ? n = b : a = b;
          }
          return n;
        }
        static async createImage(n, a = !1) {
          return new g(n, a)._createImage();
        }
        async _createImage() {
          const n = this._encodeBMP(), a = new Blob([n.buffer], { type: "image/bmp" }), d = createImageBitmap(a), { MAX_AREA: m, MAX_DIM: b } = g, { _imgData: w } = this, { width: v, height: h } = w, x = Math.max(v / b, h / b, Math.sqrt(v * h / m)), _ = Math.max(x, 2), M = Math.round(10 * (x + 1.25)) / 10 / _, O = Math.floor(Math.log2(M)), E = new Array(O + 2).fill(2);
          E[0] = _, E.splice(-1, 1, M / (1 << O));
          let I = v, R = h, W = await d;
          for (const z of E) {
            const j = I, $ = R;
            I = Math.floor(I / z) - 1, R = Math.floor(R / z) - 1;
            const B = new OffscreenCanvas(I, R);
            B.getContext("2d").drawImage(W, 0, 0, j, $, 0, 0, I, R), W = B.transferToImageBitmap();
          }
          return w.data = null, w.bitmap = W, w.width = I, w.height = R, w;
        }
        _encodeBMP() {
          const { width: n, height: a, kind: d } = this._imgData;
          let m, b = this._imgData.data, w = new Uint8Array(0), v = w, h = 0;
          switch (d) {
            case o.ImageKind.GRAYSCALE_1BPP: {
              m = 1, w = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
              const R = n + 7 >> 3, W = R + 3 & -4;
              if (R !== W) {
                const z = new Uint8Array(W * a);
                let j = 0;
                for (let $ = 0, B = a * R; $ < B; $ += R, j += W) z.set(b.subarray($, $ + R), j);
                b = z;
              }
              break;
            }
            case o.ImageKind.RGB_24BPP:
              if (m = 24, 3 & n) {
                const R = 3 * n, W = R + 3 & -4, z = W - R, j = new Uint8Array(W * a);
                let $ = 0;
                for (let B = 0, C = a * R; B < C; B += R) {
                  const T = b.subarray(B, B + R);
                  for (let F = 0; F < R; F += 3)
                    j[$++] = T[F + 2], j[$++] = T[F + 1], j[$++] = T[F];
                  $ += z;
                }
                b = j;
              } else for (let R = 0, W = b.length; R < W; R += 3) {
                const z = b[R];
                b[R] = b[R + 2], b[R + 2] = z;
              }
              break;
            case o.ImageKind.RGBA_32BPP:
              m = 32, h = 3, v = new Uint8Array(68);
              const I = new DataView(v.buffer);
              o.FeatureTest.isLittleEndian ? (I.setUint32(0, 255, !0), I.setUint32(4, 65280, !0), I.setUint32(8, 16711680, !0), I.setUint32(12, 4278190080, !0)) : (I.setUint32(0, 4278190080, !0), I.setUint32(4, 16711680, !0), I.setUint32(8, 65280, !0), I.setUint32(12, 255, !0));
              break;
            default:
              throw new Error("invalid format");
          }
          let x = 0;
          const _ = 40 + v.length, M = 14 + _ + w.length + b.length, O = new Uint8Array(M), E = new DataView(O.buffer);
          return E.setUint16(x, 19778, !0), x += 2, E.setUint32(x, M, !0), x += 4, E.setUint32(x, 0, !0), x += 4, E.setUint32(x, 14 + _ + w.length, !0), x += 4, E.setUint32(x, _, !0), x += 4, E.setInt32(x, n, !0), x += 4, E.setInt32(x, -a, !0), x += 4, E.setUint16(x, 1, !0), x += 2, E.setUint16(x, m, !0), x += 2, E.setUint32(x, h, !0), x += 4, E.setUint32(x, 0, !0), x += 4, E.setInt32(x, 0, !0), x += 4, E.setInt32(x, 0, !0), x += 4, E.setUint32(x, w.length / 4, !0), x += 4, E.setUint32(x, 0, !0), x += 4, O.set(v, x), x += v.length, O.set(w, x), x += w.length, O.set(b, x), O;
        }
      }
      l.ImageResizer = g, g._goodSquareLength = 2048;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.MurmurHash3_64 = void 0;
      var o = f(2);
      const g = 3285377520, p = 4294901760, n = 65535;
      l.MurmurHash3_64 = class {
        constructor(d) {
          this.h1 = d ? 4294967295 & d : g, this.h2 = d ? 4294967295 & d : g;
        }
        update(d) {
          let m, b;
          if (typeof d == "string") {
            m = new Uint8Array(2 * d.length), b = 0;
            for (let z = 0, j = d.length; z < j; z++) {
              const $ = d.charCodeAt(z);
              $ <= 255 ? m[b++] = $ : (m[b++] = $ >>> 8, m[b++] = 255 & $);
            }
          } else {
            if (!(0, o.isArrayBuffer)(d)) throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
            m = d.slice(), b = m.byteLength;
          }
          const w = b >> 2, v = b - 4 * w, h = new Uint32Array(m.buffer, 0, w);
          let x = 0, _ = 0, M = this.h1, O = this.h2;
          const E = 3432918353, I = 461845907, R = 11601, W = 13715;
          for (let z = 0; z < w; z++) 1 & z ? (x = h[z], x = x * E & p | x * R & n, x = x << 15 | x >>> 17, x = x * I & p | x * W & n, M ^= x, M = M << 13 | M >>> 19, M = 5 * M + 3864292196) : (_ = h[z], _ = _ * E & p | _ * R & n, _ = _ << 15 | _ >>> 17, _ = _ * I & p | _ * W & n, O ^= _, O = O << 13 | O >>> 19, O = 5 * O + 3864292196);
          switch (x = 0, v) {
            case 3:
              x ^= m[4 * w + 2] << 16;
            case 2:
              x ^= m[4 * w + 1] << 8;
            case 1:
              x ^= m[4 * w], x = x * E & p | x * R & n, x = x << 15 | x >>> 17, x = x * I & p | x * W & n, 1 & w ? M ^= x : O ^= x;
          }
          this.h1 = M, this.h2 = O;
        }
        hexdigest() {
          let d = this.h1, m = this.h2;
          return d ^= m >>> 1, d = 3981806797 * d & p | 36045 * d & n, m = 4283543511 * m & p | (2950163797 * (m << 16 | d >>> 16) & p) >>> 16, d ^= m >>> 1, d = 444984403 * d & p | 60499 * d & n, m = 3301882366 * m & p | (3120437893 * (m << 16 | d >>> 16) & p) >>> 16, d ^= m >>> 1, (d >>> 0).toString(16).padStart(8, "0") + (m >>> 0).toString(16).padStart(8, "0");
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.OperatorList = void 0;
      var o = f(2);
      function g(b, w, v, h, x) {
        let _ = b;
        for (let M = 0, O = w.length - 1; M < O; M++) {
          const E = w[M];
          _ = _[E] || (_[E] = []);
        }
        _[w.at(-1)] = { checkFn: v, iterateFn: h, processFn: x };
      }
      const p = [];
      g(p, [o.OPS.save, o.OPS.transform, o.OPS.paintInlineImageXObject, o.OPS.restore], null, function(w, v) {
        const h = w.fnArray, x = (v - (w.iCurr - 3)) % 4;
        switch (x) {
          case 0:
            return h[v] === o.OPS.save;
          case 1:
            return h[v] === o.OPS.transform;
          case 2:
            return h[v] === o.OPS.paintInlineImageXObject;
          case 3:
            return h[v] === o.OPS.restore;
        }
        throw new Error(`iterateInlineImageGroup - invalid pos: ${x}`);
      }, function(w, v) {
        const h = w.fnArray, x = w.argsArray, _ = w.iCurr, M = _ - 3, O = _ - 2, E = _ - 1, I = Math.min(Math.floor((v - M) / 4), 200);
        if (I < 10) return v - (v - M) % 4;
        let R = 0;
        const W = [];
        let z = 0, j = 1, $ = 1;
        for (let A = 0; A < I; A++) {
          const U = x[O + (A << 2)], K = x[E + (A << 2)][0];
          j + K.width > 1e3 && (R = Math.max(R, j), $ += z + 2, j = 0, z = 0), W.push({ transform: U, x: j, y: $, w: K.width, h: K.height }), j += K.width + 2, z = Math.max(z, K.height);
        }
        const B = Math.max(R, j) + 1, C = $ + z + 1, T = new Uint8Array(B * C * 4), F = B << 2;
        for (let A = 0; A < I; A++) {
          const U = x[E + (A << 2)][0].data, K = W[A].w << 2;
          let X = 0, L = W[A].x + W[A].y * B << 2;
          T.set(U.subarray(0, K), L - F);
          for (let H = 0, Q = W[A].h; H < Q; H++)
            T.set(U.subarray(X, X + K), L), X += K, L += F;
          for (T.set(U.subarray(X - K, X), L); L >= 0; )
            U[L - 4] = U[L], U[L - 3] = U[L + 1], U[L - 2] = U[L + 2], U[L - 1] = U[L + 3], U[L + K] = U[L + K - 4], U[L + K + 1] = U[L + K - 3], U[L + K + 2] = U[L + K - 2], U[L + K + 3] = U[L + K - 1], L -= F;
        }
        const S = { width: B, height: C };
        if (w.isOffscreenCanvasSupported) {
          const A = new OffscreenCanvas(B, C);
          A.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(T.buffer), B, C), 0, 0), S.bitmap = A.transferToImageBitmap(), S.data = null;
        } else
          S.kind = o.ImageKind.RGBA_32BPP, S.data = T;
        return h.splice(M, 4 * I, o.OPS.paintInlineImageXObjectGroup), x.splice(M, 4 * I, [S, W]), M + 1;
      }), g(p, [o.OPS.save, o.OPS.transform, o.OPS.paintImageMaskXObject, o.OPS.restore], null, function(w, v) {
        const h = w.fnArray, x = (v - (w.iCurr - 3)) % 4;
        switch (x) {
          case 0:
            return h[v] === o.OPS.save;
          case 1:
            return h[v] === o.OPS.transform;
          case 2:
            return h[v] === o.OPS.paintImageMaskXObject;
          case 3:
            return h[v] === o.OPS.restore;
        }
        throw new Error(`iterateImageMaskGroup - invalid pos: ${x}`);
      }, function(w, v) {
        const h = w.fnArray, x = w.argsArray, _ = w.iCurr, M = _ - 3, O = _ - 2, E = _ - 1;
        let I = Math.floor((v - M) / 4);
        if (I < 10) return v - (v - M) % 4;
        let R, W, z = !1;
        const j = x[E][0], $ = x[O][0], B = x[O][1], C = x[O][2], T = x[O][3];
        if (B === C) {
          z = !0, R = O + 4;
          let F = E + 4;
          for (let S = 1; S < I; S++, R += 4, F += 4)
            if (W = x[R], x[F][0] !== j || W[0] !== $ || W[1] !== B || W[2] !== C || W[3] !== T) {
              S < 10 ? z = !1 : I = S;
              break;
            }
        }
        if (z) {
          I = Math.min(I, 1e3);
          const F = new Float32Array(2 * I);
          R = O;
          for (let S = 0; S < I; S++, R += 4)
            W = x[R], F[S << 1] = W[4], F[1 + (S << 1)] = W[5];
          h.splice(M, 4 * I, o.OPS.paintImageMaskXObjectRepeat), x.splice(M, 4 * I, [j, $, B, C, T, F]);
        } else {
          I = Math.min(I, 100);
          const F = [];
          for (let S = 0; S < I; S++) {
            W = x[O + (S << 2)];
            const A = x[E + (S << 2)][0];
            F.push({ data: A.data, width: A.width, height: A.height, interpolate: A.interpolate, count: A.count, transform: W });
          }
          h.splice(M, 4 * I, o.OPS.paintImageMaskXObjectGroup), x.splice(M, 4 * I, [F]);
        }
        return M + 1;
      }), g(p, [o.OPS.save, o.OPS.transform, o.OPS.paintImageXObject, o.OPS.restore], function(b) {
        const w = b.argsArray, v = b.iCurr - 2;
        return w[v][1] === 0 && w[v][2] === 0;
      }, function(w, v) {
        const h = w.fnArray, x = w.argsArray, _ = (v - (w.iCurr - 3)) % 4;
        switch (_) {
          case 0:
            return h[v] === o.OPS.save;
          case 1:
            if (h[v] !== o.OPS.transform) return !1;
            const M = w.iCurr - 2, O = x[M][0], E = x[M][3];
            return x[v][0] === O && x[v][1] === 0 && x[v][2] === 0 && x[v][3] === E;
          case 2:
            if (h[v] !== o.OPS.paintImageXObject) return !1;
            const I = x[w.iCurr - 1][0];
            return x[v][0] === I;
          case 3:
            return h[v] === o.OPS.restore;
        }
        throw new Error(`iterateImageGroup - invalid pos: ${_}`);
      }, function(b, w) {
        const v = b.fnArray, h = b.argsArray, x = b.iCurr, _ = x - 3, M = x - 2, O = h[x - 1][0], E = h[M][0], I = h[M][3], R = Math.min(Math.floor((w - _) / 4), 1e3);
        if (R < 3) return w - (w - _) % 4;
        const W = new Float32Array(2 * R);
        let z = M;
        for (let $ = 0; $ < R; $++, z += 4) {
          const B = h[z];
          W[$ << 1] = B[4], W[1 + ($ << 1)] = B[5];
        }
        const j = [O, E, I, W];
        return v.splice(_, 4 * R, o.OPS.paintImageXObjectRepeat), h.splice(_, 4 * R, j), _ + 1;
      }), g(p, [o.OPS.beginText, o.OPS.setFont, o.OPS.setTextMatrix, o.OPS.showText, o.OPS.endText], null, function(w, v) {
        const h = w.fnArray, x = w.argsArray, _ = (v - (w.iCurr - 4)) % 5;
        switch (_) {
          case 0:
            return h[v] === o.OPS.beginText;
          case 1:
            return h[v] === o.OPS.setFont;
          case 2:
            return h[v] === o.OPS.setTextMatrix;
          case 3:
            if (h[v] !== o.OPS.showText) return !1;
            const M = w.iCurr - 3, O = x[M][0], E = x[M][1];
            return x[v][0] === O && x[v][1] === E;
          case 4:
            return h[v] === o.OPS.endText;
        }
        throw new Error(`iterateShowTextGroup - invalid pos: ${_}`);
      }, function(b, w) {
        const v = b.fnArray, h = b.argsArray, x = b.iCurr, _ = x - 4, M = x - 3, O = x - 2, E = x - 1, I = x, R = h[M][0], W = h[M][1];
        let z = Math.min(Math.floor((w - _) / 5), 1e3);
        if (z < 3) return w - (w - _) % 5;
        let j = _;
        _ >= 4 && v[_ - 4] === v[M] && v[_ - 3] === v[O] && v[_ - 2] === v[E] && v[_ - 1] === v[I] && h[_ - 4][0] === R && h[_ - 4][1] === W && (z++, j -= 5);
        let $ = j + 4;
        for (let B = 1; B < z; B++)
          v.splice($, 3), h.splice($, 3), $ += 2;
        return $ + 1;
      });
      class n {
        constructor(w) {
          this.queue = w;
        }
        _optimize() {
        }
        push(w, v) {
          this.queue.fnArray.push(w), this.queue.argsArray.push(v), this._optimize();
        }
        flush() {
        }
        reset() {
        }
      }
      class a extends n {
        constructor(w) {
          super(w), this.state = null, this.context = { iCurr: 0, fnArray: w.fnArray, argsArray: w.argsArray, isOffscreenCanvasSupported: !1 }, this.match = null, this.lastProcessed = 0;
        }
        set isOffscreenCanvasSupported(w) {
          this.context.isOffscreenCanvasSupported = w;
        }
        _optimize() {
          const w = this.queue.fnArray;
          let v = this.lastProcessed, h = w.length, x = this.state, _ = this.match;
          if (!x && !_ && v + 1 === h && !p[w[v]]) {
            this.lastProcessed = h;
            return;
          }
          const M = this.context;
          for (; v < h; ) {
            if (_) {
              if ((0, _.iterateFn)(M, v)) {
                v++;
                continue;
              }
              if (v = (0, _.processFn)(M, v + 1), h = w.length, _ = null, x = null, v >= h) break;
            }
            x = (x || p)[w[v]], x && !Array.isArray(x) ? (M.iCurr = v, v++, (!x.checkFn || (0, x.checkFn)(M)) && (_ = x), x = null) : v++;
          }
          this.state = x, this.match = _, this.lastProcessed = v;
        }
        flush() {
          for (; this.match; ) {
            const w = this.queue.fnArray.length;
            this.lastProcessed = (0, this.match.processFn)(this.context, w), this.match = null, this.state = null, this._optimize();
          }
        }
        reset() {
          this.state = null, this.match = null, this.lastProcessed = 0;
        }
      }
      const m = class m {
        constructor(w = 0, v) {
          this._streamSink = v, this.fnArray = [], this.argsArray = [], this.optimizer = !v || w & o.RenderingIntentFlag.OPLIST ? new n(this) : new a(this), this.dependencies = /* @__PURE__ */ new Set(), this._totalLength = 0, this.weight = 0, this._resolved = v ? null : Promise.resolve();
        }
        set isOffscreenCanvasSupported(w) {
          this.optimizer.isOffscreenCanvasSupported = w;
        }
        get length() {
          return this.argsArray.length;
        }
        get ready() {
          return this._resolved || this._streamSink.ready;
        }
        get totalLength() {
          return this._totalLength + this.length;
        }
        addOp(w, v) {
          this.optimizer.push(w, v), this.weight++, this._streamSink && (this.weight >= m.CHUNK_SIZE || this.weight >= m.CHUNK_SIZE_ABOUT && (w === o.OPS.restore || w === o.OPS.endText)) && this.flush();
        }
        addImageOps(w, v, h) {
          h !== void 0 && this.addOp(o.OPS.beginMarkedContentProps, ["OC", h]), this.addOp(w, v), h !== void 0 && this.addOp(o.OPS.endMarkedContent, []);
        }
        addDependency(w) {
          this.dependencies.has(w) || (this.dependencies.add(w), this.addOp(o.OPS.dependency, [w]));
        }
        addDependencies(w) {
          for (const v of w) this.addDependency(v);
        }
        addOpList(w) {
          if (w instanceof m) {
            for (const v of w.dependencies) this.dependencies.add(v);
            for (let v = 0, h = w.length; v < h; v++) this.addOp(w.fnArray[v], w.argsArray[v]);
          } else (0, o.warn)('addOpList - ignoring invalid "opList" parameter.');
        }
        getIR() {
          return { fnArray: this.fnArray, argsArray: this.argsArray, length: this.length };
        }
        get _transfers() {
          var _;
          const w = [], { fnArray: v, argsArray: h, length: x } = this;
          for (let M = 0; M < x; M++) switch (v[M]) {
            case o.OPS.paintInlineImageXObject:
            case o.OPS.paintInlineImageXObjectGroup:
            case o.OPS.paintImageMaskXObject:
              const O = h[M][0];
              !O.cached && ((_ = O.data) == null ? void 0 : _.buffer) instanceof ArrayBuffer && w.push(O.data.buffer);
          }
          return w;
        }
        flush(w = !1, v = null) {
          this.optimizer.flush();
          const h = this.length;
          this._totalLength += h, this._streamSink.enqueue({ fnArray: this.fnArray, argsArray: this.argsArray, lastChunk: w, separateAnnots: v, length: h }, 1, this._transfers), this.dependencies.clear(), this.fnArray.length = 0, this.argsArray.length = 0, this.weight = 0, this.optimizer.reset();
        }
      };
      Mr(m, "CHUNK_SIZE", 1e3), Mr(m, "CHUNK_SIZE_ABOUT", m.CHUNK_SIZE - 5);
      let d = m;
      l.OperatorList = d;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PDFImage = void 0;
      var o = f(2), g = f(28), p = f(5), n = f(12), a = f(18), d = f(62), m = f(26), b = f(30), w = f(4);
      function v(_, M, O, E) {
        return (_ = M + _ * O) < 0 ? _ = 0 : _ > E && (_ = E), _;
      }
      function h(_, M, O, E, I, R) {
        const W = I * R;
        let z;
        z = M <= 8 ? new Uint8Array(W) : M <= 16 ? new Uint16Array(W) : new Uint32Array(W);
        const j = O / I, $ = E / R;
        let B, C, T, F, S = 0;
        const A = new Uint16Array(I), U = O;
        for (B = 0; B < I; B++) A[B] = Math.floor(B * j);
        for (B = 0; B < R; B++)
          for (T = Math.floor(B * $) * U, C = 0; C < I; C++)
            F = T + A[C], z[S++] = _[F];
        return z;
      }
      class x {
        constructor({ xref: M, res: O, image: E, isInline: I = !1, smask: R = null, mask: W = null, isMask: z = !1, pdfFunctionFactory: j, localColorSpaceCache: $ }) {
          var U;
          this.image = E;
          const B = E.dict, C = B.get("F", "Filter");
          let T;
          if (C instanceof w.Name) T = C.name;
          else if (Array.isArray(C)) {
            const K = M.fetchIfRef(C[0]);
            K instanceof w.Name && (T = K.name);
          }
          switch (T) {
            case "JPXDecode":
              const K = new b.JpxImage();
              K.parseImageProperties(E.stream), E.stream.reset(), E.width = K.width, E.height = K.height, E.bitsPerComponent = K.bitsPerComponent, E.numComps = K.componentsCount;
              break;
            case "JBIG2Decode":
              E.bitsPerComponent = 1, E.numComps = 1;
          }
          let F = B.get("W", "Width"), S = B.get("H", "Height");
          if (Number.isInteger(E.width) && E.width > 0 && Number.isInteger(E.height) && E.height > 0 && (E.width !== F || E.height !== S) && ((0, o.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary."), F = E.width, S = E.height), F < 1 || S < 1) throw new o.FormatError(`Invalid image width: ${F} or height: ${S}`);
          this.width = F, this.height = S, this.interpolate = B.get("I", "Interpolate"), this.imageMask = B.get("IM", "ImageMask") || !1, this.matte = B.get("Matte") || !1;
          let A = E.bitsPerComponent;
          if (!A && (A = B.get("BPC", "BitsPerComponent"), !A)) {
            if (!this.imageMask) throw new o.FormatError(`Bits per component missing in image: ${this.imageMask}`);
            A = 1;
          }
          if (this.bpc = A, !this.imageMask) {
            let K = B.getRaw("CS") || B.getRaw("ColorSpace");
            if (!K)
              switch ((0, o.info)("JPX images (which do not require color spaces)"), E.numComps) {
                case 1:
                  K = w.Name.get("DeviceGray");
                  break;
                case 3:
                  K = w.Name.get("DeviceRGB");
                  break;
                case 4:
                  K = w.Name.get("DeviceCMYK");
                  break;
                default:
                  throw new Error(`JPX images with ${E.numComps} color components not supported.`);
              }
            this.colorSpace = n.ColorSpace.parse({ cs: K, xref: M, resources: I ? O : null, pdfFunctionFactory: j, localColorSpaceCache: $ }), this.numComps = this.colorSpace.numComps;
          }
          if (this.decode = B.getArray("D", "Decode"), this.needsDecode = !1, this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, A) || z && !n.ColorSpace.isDefaultDecode(this.decode, 1))) {
            this.needsDecode = !0;
            const K = (1 << A) - 1;
            this.decodeCoefficients = [], this.decodeAddends = [];
            const X = ((U = this.colorSpace) == null ? void 0 : U.name) === "Indexed";
            for (let L = 0, H = 0; L < this.decode.length; L += 2, ++H) {
              const Q = this.decode[L], N = this.decode[L + 1];
              this.decodeCoefficients[H] = X ? (N - Q) / K : N - Q, this.decodeAddends[H] = X ? Q : K * Q;
            }
          }
          R ? this.smask = new x({ xref: M, res: O, image: R, isInline: I, pdfFunctionFactory: j, localColorSpaceCache: $ }) : W && (W instanceof p.BaseStream ? W.dict.get("IM", "ImageMask") ? this.mask = new x({ xref: M, res: O, image: W, isInline: I, isMask: !0, pdfFunctionFactory: j, localColorSpaceCache: $ }) : (0, o.warn)("Ignoring /Mask in image without /ImageMask.") : this.mask = W);
        }
        static async buildImage({ xref: M, res: O, image: E, isInline: I = !1, pdfFunctionFactory: R, localColorSpaceCache: W }) {
          const z = E;
          let j = null, $ = null;
          const B = E.dict.get("SMask"), C = E.dict.get("Mask");
          return B ? B instanceof p.BaseStream ? j = B : (0, o.warn)("Unsupported /SMask format.") : C && (C instanceof p.BaseStream || Array.isArray(C) ? $ = C : (0, o.warn)("Unsupported /Mask format.")), new x({ xref: M, res: O, image: z, isInline: I, smask: j, mask: $, pdfFunctionFactory: R, localColorSpaceCache: W });
        }
        static createRawMask({ imgArray: M, width: O, height: E, imageIsFromDecodeStream: I, inverseDecode: R, interpolate: W }) {
          const z = (O + 7 >> 3) * E, j = M.byteLength;
          let $, B;
          if (!I || R && z !== j ? R ? ($ = new Uint8Array(z), $.set(M), $.fill(255, j)) : $ = new Uint8Array(M) : $ = M, R) for (B = 0; B < j; B++) $[B] ^= 255;
          return { data: $, width: O, height: E, interpolate: W };
        }
        static async createMask({ imgArray: M, width: O, height: E, imageIsFromDecodeStream: I, inverseDecode: R, interpolate: W, isOffscreenCanvasSupported: z = !1 }) {
          const j = O === 1 && E === 1 && R === (M.length === 0 || !!(128 & M[0]));
          if (j) return { isSingleOpaquePixel: j };
          if (z) {
            if (d.ImageResizer.needsToBeResized(O, E)) {
              const T = new Uint8ClampedArray(O * E * 4);
              return (0, g.convertBlackAndWhiteToRGBA)({ src: M, dest: T, width: O, height: E, nonBlackColor: 0, inverseDecode: R }), d.ImageResizer.createImage({ kind: o.ImageKind.RGBA_32BPP, data: T, width: O, height: E, interpolate: W });
            }
            const $ = new OffscreenCanvas(O, E), B = $.getContext("2d"), C = B.createImageData(O, E);
            return (0, g.convertBlackAndWhiteToRGBA)({ src: M, dest: C.data, width: O, height: E, nonBlackColor: 0, inverseDecode: R }), B.putImageData(C, 0, 0), { data: null, width: O, height: E, interpolate: W, bitmap: $.transferToImageBitmap() };
          }
          return this.createRawMask({ imgArray: M, width: O, height: E, inverseDecode: R, imageIsFromDecodeStream: I, interpolate: W });
        }
        get drawWidth() {
          var M, O;
          return Math.max(this.width, ((M = this.smask) == null ? void 0 : M.width) || 0, ((O = this.mask) == null ? void 0 : O.width) || 0);
        }
        get drawHeight() {
          var M, O;
          return Math.max(this.height, ((M = this.smask) == null ? void 0 : M.height) || 0, ((O = this.mask) == null ? void 0 : O.height) || 0);
        }
        decodeBuffer(M) {
          const O = this.bpc, E = this.numComps, I = this.decodeAddends, R = this.decodeCoefficients, W = (1 << O) - 1;
          let z, j;
          if (O === 1) {
            for (z = 0, j = M.length; z < j; z++) M[z] = +!M[z];
            return;
          }
          let $ = 0;
          for (z = 0, j = this.width * this.height; z < j; z++) for (let B = 0; B < E; B++)
            M[$] = v(M[$], I[B], R[B], W), $++;
        }
        getComponents(M) {
          const O = this.bpc;
          if (O === 8) return M;
          const E = this.width, I = this.height, R = this.numComps, W = E * I * R;
          let z, j = 0;
          z = O <= 8 ? new Uint8Array(W) : O <= 16 ? new Uint16Array(W) : new Uint32Array(W);
          const $ = E * R, B = (1 << O) - 1;
          let C, T, F = 0;
          if (O === 1) {
            let S, A, U;
            for (let K = 0; K < I; K++) {
              for (A = F + (-8 & $), U = F + $; F < A; )
                T = M[j++], z[F] = T >> 7 & 1, z[F + 1] = T >> 6 & 1, z[F + 2] = T >> 5 & 1, z[F + 3] = T >> 4 & 1, z[F + 4] = T >> 3 & 1, z[F + 5] = T >> 2 & 1, z[F + 6] = T >> 1 & 1, z[F + 7] = 1 & T, F += 8;
              if (F < U)
                for (T = M[j++], S = 128; F < U; )
                  z[F++] = +!!(T & S), S >>= 1;
            }
          } else {
            let S = 0;
            for (T = 0, F = 0, C = W; F < C; ++F) {
              for (F % $ == 0 && (T = 0, S = 0); S < O; )
                T = T << 8 | M[j++], S += 8;
              const A = S - O;
              let U = T >> A;
              U < 0 ? U = 0 : U > B && (U = B), z[F] = U, T &= (1 << A) - 1, S = A;
            }
          }
          return z;
        }
        fillOpacity(M, O, E, I, R) {
          const W = this.smask, z = this.mask;
          let j, $, B, C, T, F;
          if (W)
            $ = W.width, B = W.height, j = new Uint8ClampedArray($ * B), W.fillGrayBuffer(j), $ === O && B === E || (j = h(j, W.bpc, $, B, O, E));
          else if (z) if (z instanceof x) {
            for ($ = z.width, B = z.height, j = new Uint8ClampedArray($ * B), z.numComps = 1, z.fillGrayBuffer(j), C = 0, T = $ * B; C < T; ++C) j[C] = 255 - j[C];
            $ === O && B === E || (j = h(j, z.bpc, $, B, O, E));
          } else {
            if (!Array.isArray(z)) throw new o.FormatError("Unknown mask format.");
            {
              j = new Uint8ClampedArray(O * E);
              const S = this.numComps;
              for (C = 0, T = O * E; C < T; ++C) {
                let A = 0;
                const U = C * S;
                for (F = 0; F < S; ++F) {
                  const K = R[U + F], X = 2 * F;
                  if (K < z[X] || K > z[X + 1]) {
                    A = 255;
                    break;
                  }
                }
                j[C] = A;
              }
            }
          }
          if (j) for (C = 0, F = 3, T = O * I; C < T; ++C, F += 4) M[F] = j[C];
          else for (C = 0, F = 3, T = O * I; C < T; ++C, F += 4) M[F] = 255;
        }
        undoPreblend(M, O, E) {
          var B;
          const I = (B = this.smask) == null ? void 0 : B.matte;
          if (!I) return;
          const R = this.colorSpace.getRgb(I, 0), W = R[0], z = R[1], j = R[2], $ = O * E * 4;
          for (let C = 0; C < $; C += 4) {
            const T = M[C + 3];
            if (T === 0) {
              M[C] = 255, M[C + 1] = 255, M[C + 2] = 255;
              continue;
            }
            const F = 255 / T;
            M[C] = (M[C] - W) * F + W, M[C + 1] = (M[C + 1] - z) * F + z, M[C + 2] = (M[C + 2] - j) * F + j;
          }
        }
        async createImageData(M = !1, O = !1) {
          const E = this.drawWidth, I = this.drawHeight, R = { width: E, height: I, interpolate: this.interpolate, kind: 0, data: null }, W = this.numComps, z = this.width, j = this.height, $ = this.bpc, B = z * W * $ + 7 >> 3, C = O && d.ImageResizer.needsToBeResized(E, I);
          if (!M) {
            let Q;
            if (this.colorSpace.name === "DeviceGray" && $ === 1 ? Q = o.ImageKind.GRAYSCALE_1BPP : this.colorSpace.name !== "DeviceRGB" || $ !== 8 || this.needsDecode || (Q = o.ImageKind.RGB_24BPP), Q && !this.smask && !this.mask && E === z && I === j) {
              const N = this.getImageBytes(j * B, {});
              if (O) return C ? d.ImageResizer.createImage({ data: N, kind: Q, width: E, height: I, interpolate: this.interpolate }, this.needsDecode) : this.createBitmap(Q, z, j, N);
              if (R.kind = Q, R.data = N, this.needsDecode) {
                (0, o.assert)(Q === o.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                const V = R.data;
                for (let Y = 0, Z = V.length; Y < Z; Y++) V[Y] ^= 255;
              }
              return R;
            }
            if (this.image instanceof m.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
              let N = j * B;
              if (O && !C) {
                let V = !1;
                switch (this.colorSpace.name) {
                  case "DeviceGray":
                    N *= 4, V = !0;
                    break;
                  case "DeviceRGB":
                    N = N / 3 * 4, V = !0;
                    break;
                  case "DeviceCMYK":
                    V = !0;
                }
                if (V) {
                  const Y = this.getImageBytes(N, { drawWidth: E, drawHeight: I, forceRGBA: !0 });
                  return this.createBitmap(o.ImageKind.RGBA_32BPP, E, I, Y);
                }
              } else switch (this.colorSpace.name) {
                case "DeviceGray":
                  N *= 3;
                case "DeviceRGB":
                case "DeviceCMYK":
                  return R.kind = o.ImageKind.RGB_24BPP, R.data = this.getImageBytes(N, { drawWidth: E, drawHeight: I, forceRGB: !0 }), C ? d.ImageResizer.createImage(R) : R;
              }
            }
          }
          const T = this.getImageBytes(j * B, { internal: !0 }), F = 0 | T.length / B * I / j, S = this.getComponents(T);
          let A, U, K, X, L, H;
          return O && !C && (K = new OffscreenCanvas(E, I), X = K.getContext("2d"), L = X.createImageData(E, I), H = L.data), R.kind = o.ImageKind.RGBA_32BPP, M || this.smask || this.mask ? (O && !C || (H = new Uint8ClampedArray(E * I * 4)), A = 1, U = !0, this.fillOpacity(H, E, I, F, S)) : (!O || C ? (R.kind = o.ImageKind.RGB_24BPP, H = new Uint8ClampedArray(E * I * 3), A = 0) : (new Uint32Array(H.buffer).fill(o.FeatureTest.isLittleEndian ? 4278190080 : 255), A = 1), U = !1), this.needsDecode && this.decodeBuffer(S), this.colorSpace.fillRgb(H, z, j, E, I, F, $, S, A), U && this.undoPreblend(H, E, F), O && !C ? (X.putImageData(L, 0, 0), { data: null, width: E, height: I, bitmap: K.transferToImageBitmap(), interpolate: this.interpolate }) : (R.data = H, C ? d.ImageResizer.createImage(R) : R);
        }
        fillGrayBuffer(M) {
          const O = this.numComps;
          if (O !== 1) throw new o.FormatError(`Reading gray scale from a color image: ${O}`);
          const E = this.width, I = this.height, R = this.bpc, W = E * O * R + 7 >> 3, z = this.getImageBytes(I * W, { internal: !0 }), j = this.getComponents(z);
          let $, B;
          if (R === 1) {
            if (B = E * I, this.needsDecode) for ($ = 0; $ < B; ++$) M[$] = j[$] - 1 & 255;
            else for ($ = 0; $ < B; ++$) M[$] = 255 & -j[$];
            return;
          }
          this.needsDecode && this.decodeBuffer(j), B = E * I;
          const C = 255 / ((1 << R) - 1);
          for ($ = 0; $ < B; ++$) M[$] = C * j[$];
        }
        createBitmap(M, O, E, I) {
          const R = new OffscreenCanvas(O, E), W = R.getContext("2d");
          let z;
          return M === o.ImageKind.RGBA_32BPP ? z = new ImageData(I, O, E) : (z = W.createImageData(O, E), (0, g.convertToRGBA)({ kind: M, src: I, dest: new Uint32Array(z.data.buffer), width: O, height: E, inverseDecode: this.needsDecode })), W.putImageData(z, 0, 0), { data: null, width: O, height: E, bitmap: R.transferToImageBitmap(), interpolate: this.interpolate };
        }
        getImageBytes(M, { drawWidth: O, drawHeight: E, forceRGBA: I = !1, forceRGB: R = !1, internal: W = !1 }) {
          this.image.reset(), this.image.drawWidth = O || this.width, this.image.drawHeight = E || this.height, this.image.forceRGBA = !!I, this.image.forceRGB = !!R;
          const z = this.image.getBytes(M);
          return W || this.image instanceof a.DecodeStream ? z : ((0, o.assert)(z instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.'), new Uint8Array(z));
        }
      }
      l.PDFImage = x;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Catalog = void 0;
      var o = f(3), g = f(2), p = f(4), n = f(67), a = f(5), d = f(68), m = f(12), b = f(69), w = f(59), v = f(70), h = f(72);
      function x(M) {
        return M instanceof p.Dict && (M = M.get("D")), Array.isArray(M) ? M : null;
      }
      class _ {
        constructor(O, E) {
          if (this.pdfManager = O, this.xref = E, this._catDict = E.getCatalogObj(), !(this._catDict instanceof p.Dict)) throw new g.FormatError("Catalog object is not a dictionary.");
          this.toplevelPagesDict, this._actualNumPages = null, this.fontCache = new p.RefSetCache(), this.builtInCMapCache = /* @__PURE__ */ new Map(), this.standardFontDataCache = /* @__PURE__ */ new Map(), this.globalImageCache = new w.GlobalImageCache(), this.pageKidsCountCache = new p.RefSetCache(), this.pageIndexCache = new p.RefSetCache(), this.nonBlendModesSet = new p.RefSet(), this.systemFontCache = /* @__PURE__ */ new Map();
        }
        cloneDict() {
          return this._catDict.clone();
        }
        get version() {
          const O = this._catDict.get("Version");
          if (O instanceof p.Name) {
            if (o.PDF_VERSION_REGEXP.test(O.name)) return (0, g.shadow)(this, "version", O.name);
            (0, g.warn)(`Invalid PDF catalog version: ${O.name}`);
          }
          return (0, g.shadow)(this, "version", null);
        }
        get lang() {
          const O = this._catDict.get("Lang");
          return (0, g.shadow)(this, "lang", typeof O == "string" ? (0, g.stringToPDFString)(O) : null);
        }
        get needsRendering() {
          const O = this._catDict.get("NeedsRendering");
          return (0, g.shadow)(this, "needsRendering", typeof O == "boolean" && O);
        }
        get collection() {
          let O = null;
          try {
            const E = this._catDict.get("Collection");
            E instanceof p.Dict && E.size > 0 && (O = E);
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.info)("Cannot fetch Collection entry; assuming no collection is present.");
          }
          return (0, g.shadow)(this, "collection", O);
        }
        get acroForm() {
          let O = null;
          try {
            const E = this._catDict.get("AcroForm");
            E instanceof p.Dict && E.size > 0 && (O = E);
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
          }
          return (0, g.shadow)(this, "acroForm", O);
        }
        get acroFormRef() {
          const O = this._catDict.getRaw("AcroForm");
          return (0, g.shadow)(this, "acroFormRef", O instanceof p.Ref ? O : null);
        }
        get metadata() {
          var I;
          const O = this._catDict.getRaw("Metadata");
          if (!(O instanceof p.Ref)) return (0, g.shadow)(this, "metadata", null);
          let E = null;
          try {
            const R = this.xref.fetch(O, !((I = this.xref.encrypt) != null && I.encryptMetadata));
            if (R instanceof a.BaseStream && R.dict instanceof p.Dict) {
              const W = R.dict.get("Type"), z = R.dict.get("Subtype");
              if ((0, p.isName)(W, "Metadata") && (0, p.isName)(z, "XML")) {
                const j = (0, g.stringToUTF8String)(R.getString());
                j && (E = new v.MetadataParser(j).serializable);
              }
            }
          } catch (R) {
            if (R instanceof o.MissingDataException) throw R;
            (0, g.info)(`Skipping invalid Metadata: "${R}".`);
          }
          return (0, g.shadow)(this, "metadata", E);
        }
        get markInfo() {
          let O = null;
          try {
            O = this._readMarkInfo();
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.warn)("Unable to read mark info.");
          }
          return (0, g.shadow)(this, "markInfo", O);
        }
        _readMarkInfo() {
          const O = this._catDict.get("MarkInfo");
          if (!(O instanceof p.Dict)) return null;
          const E = { Marked: !1, UserProperties: !1, Suspects: !1 };
          for (const I in E) {
            const R = O.get(I);
            typeof R == "boolean" && (E[I] = R);
          }
          return E;
        }
        get structTreeRoot() {
          let O = null;
          try {
            O = this._readStructTreeRoot();
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.warn)("Unable read to structTreeRoot info.");
          }
          return (0, g.shadow)(this, "structTreeRoot", O);
        }
        _readStructTreeRoot() {
          const O = this._catDict.getRaw("StructTreeRoot"), E = this.xref.fetchIfRef(O);
          if (!(E instanceof p.Dict)) return null;
          const I = new h.StructTreeRoot(E, O);
          return I.init(), I;
        }
        get toplevelPagesDict() {
          const O = this._catDict.get("Pages");
          if (!(O instanceof p.Dict)) throw new g.FormatError("Invalid top-level pages dictionary.");
          return (0, g.shadow)(this, "toplevelPagesDict", O);
        }
        get documentOutline() {
          let O = null;
          try {
            O = this._readDocumentOutline();
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.warn)("Unable to read document outline.");
          }
          return (0, g.shadow)(this, "documentOutline", O);
        }
        _readDocumentOutline() {
          let O = this._catDict.get("Outlines");
          if (!(O instanceof p.Dict) || (O = O.getRaw("First"), !(O instanceof p.Ref))) return null;
          const E = { items: [] }, I = [{ obj: O, parent: E }], R = new p.RefSet();
          R.put(O);
          const W = this.xref, z = new Uint8ClampedArray(3);
          for (; I.length > 0; ) {
            const j = I.shift(), $ = W.fetchIfRef(j.obj);
            if ($ === null) continue;
            if (!$.has("Title")) throw new g.FormatError("Invalid outline item encountered.");
            const B = { url: null, dest: null, action: null };
            _.parseDestDictionary({ destDict: $, resultObj: B, docBaseUrl: this.baseUrl, docAttachments: this.attachments });
            const C = $.get("Title"), T = $.get("F") || 0, F = $.getArray("C"), S = $.get("Count");
            let A = z;
            !Array.isArray(F) || F.length !== 3 || F[0] === 0 && F[1] === 0 && F[2] === 0 || (A = m.ColorSpace.singletons.rgb.getRgb(F, 0));
            const U = { action: B.action, attachment: B.attachment, dest: B.dest, url: B.url, unsafeUrl: B.unsafeUrl, newWindow: B.newWindow, setOCGState: B.setOCGState, title: (0, g.stringToPDFString)(C), color: A, count: Number.isInteger(S) ? S : void 0, bold: !!(2 & T), italic: !!(1 & T), items: [] };
            j.parent.items.push(U), O = $.getRaw("First"), O instanceof p.Ref && !R.has(O) && (I.push({ obj: O, parent: U }), R.put(O)), O = $.getRaw("Next"), O instanceof p.Ref && !R.has(O) && (I.push({ obj: O, parent: j.parent }), R.put(O));
          }
          return E.items.length > 0 ? E.items : null;
        }
        get permissions() {
          let O = null;
          try {
            O = this._readPermissions();
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.warn)("Unable to read permissions.");
          }
          return (0, g.shadow)(this, "permissions", O);
        }
        _readPermissions() {
          const O = this.xref.trailer.get("Encrypt");
          if (!(O instanceof p.Dict)) return null;
          let E = O.get("P");
          if (typeof E != "number") return null;
          E += 4294967296;
          const I = [];
          for (const R in g.PermissionFlag) {
            const W = g.PermissionFlag[R];
            E & W && I.push(W);
          }
          return I;
        }
        get optionalContentConfig() {
          let O = null;
          try {
            const E = this._catDict.get("OCProperties");
            if (!E) return (0, g.shadow)(this, "optionalContentConfig", null);
            const I = E.get("D");
            if (!I) return (0, g.shadow)(this, "optionalContentConfig", null);
            const R = E.get("OCGs");
            if (!Array.isArray(R)) return (0, g.shadow)(this, "optionalContentConfig", null);
            const W = [], z = [];
            for (const j of R) {
              if (!(j instanceof p.Ref)) continue;
              z.push(j);
              const $ = this.xref.fetchIfRef(j);
              W.push({ id: j.toString(), name: typeof $.get("Name") == "string" ? (0, g.stringToPDFString)($.get("Name")) : null, intent: typeof $.get("Intent") == "string" ? (0, g.stringToPDFString)($.get("Intent")) : null });
            }
            O = this._readOptionalContentConfig(I, z), O.groups = W;
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.warn)(`Unable to read optional content config: ${E}`);
          }
          return (0, g.shadow)(this, "optionalContentConfig", O);
        }
        _readOptionalContentConfig(O, E) {
          function I(B) {
            const C = [];
            if (Array.isArray(B)) for (const T of B) T instanceof p.Ref && E.includes(T) && C.push(T.toString());
            return C;
          }
          function R(B, C = 0) {
            if (!Array.isArray(B)) return null;
            const T = [];
            for (const S of B) {
              if (S instanceof p.Ref && E.includes(S)) {
                j.put(S), T.push(S.toString());
                continue;
              }
              const A = W(S, C);
              A && T.push(A);
            }
            if (C > 0) return T;
            const F = [];
            for (const S of E) j.has(S) || F.push(S.toString());
            return F.length && T.push({ name: null, order: F }), T;
          }
          function W(B, C) {
            if (++C > $)
              return (0, g.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS."), null;
            const T = z.fetchIfRef(B);
            if (!Array.isArray(T)) return null;
            const F = z.fetchIfRef(T[0]);
            if (typeof F != "string") return null;
            const S = R(T.slice(1), C);
            return S && S.length ? { name: (0, g.stringToPDFString)(F), order: S } : null;
          }
          const z = this.xref, j = new p.RefSet(), $ = 10;
          return { name: typeof O.get("Name") == "string" ? (0, g.stringToPDFString)(O.get("Name")) : null, creator: typeof O.get("Creator") == "string" ? (0, g.stringToPDFString)(O.get("Creator")) : null, baseState: O.get("BaseState") instanceof p.Name ? O.get("BaseState").name : null, on: I(O.get("ON")), off: I(O.get("OFF")), order: R(O.get("Order")), groups: null };
        }
        setActualNumPages(O = null) {
          this._actualNumPages = O;
        }
        get hasActualNumPages() {
          return this._actualNumPages !== null;
        }
        get _pagesCount() {
          const O = this.toplevelPagesDict.get("Count");
          if (!Number.isInteger(O)) throw new g.FormatError("Page count in top-level pages dictionary is not an integer.");
          return (0, g.shadow)(this, "_pagesCount", O);
        }
        get numPages() {
          return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
        }
        get destinations() {
          const O = this._readDests(), E = /* @__PURE__ */ Object.create(null);
          if (O instanceof n.NameTree) for (const [I, R] of O.getAll()) {
            const W = x(R);
            W && (E[(0, g.stringToPDFString)(I)] = W);
          }
          else O instanceof p.Dict && O.forEach(function(I, R) {
            const W = x(R);
            W && (E[I] = W);
          });
          return (0, g.shadow)(this, "destinations", E);
        }
        getDestination(O) {
          const E = this._readDests();
          if (E instanceof n.NameTree) {
            const I = x(E.get(O));
            if (I) return I;
            const R = this.destinations[O];
            if (R)
              return (0, g.warn)(`Found "${O}" at an incorrect position in the NameTree.`), R;
          } else if (E instanceof p.Dict) {
            const I = x(E.get(O));
            if (I) return I;
          }
          return null;
        }
        _readDests() {
          const O = this._catDict.get("Names");
          return O != null && O.has("Dests") ? new n.NameTree(O.getRaw("Dests"), this.xref) : this._catDict.has("Dests") ? this._catDict.get("Dests") : void 0;
        }
        get pageLabels() {
          let O = null;
          try {
            O = this._readPageLabels();
          } catch (E) {
            if (E instanceof o.MissingDataException) throw E;
            (0, g.warn)("Unable to read page labels.");
          }
          return (0, g.shadow)(this, "pageLabels", O);
        }
        _readPageLabels() {
          const O = this._catDict.getRaw("PageLabels");
          if (!O) return null;
          const E = new Array(this.numPages);
          let I = null, R = "";
          const W = new n.NumberTree(O, this.xref).getAll();
          let z = "", j = 1;
          for (let $ = 0, B = this.numPages; $ < B; $++) {
            const C = W.get($);
            if (C !== void 0) {
              if (!(C instanceof p.Dict)) throw new g.FormatError("PageLabel is not a dictionary.");
              if (C.has("Type") && !(0, p.isName)(C.get("Type"), "PageLabel")) throw new g.FormatError("Invalid type in PageLabel dictionary.");
              if (C.has("S")) {
                const T = C.get("S");
                if (!(T instanceof p.Name)) throw new g.FormatError("Invalid style in PageLabel dictionary.");
                I = T.name;
              } else I = null;
              if (C.has("P")) {
                const T = C.get("P");
                if (typeof T != "string") throw new g.FormatError("Invalid prefix in PageLabel dictionary.");
                R = (0, g.stringToPDFString)(T);
              } else R = "";
              if (C.has("St")) {
                const T = C.get("St");
                if (!(Number.isInteger(T) && T >= 1)) throw new g.FormatError("Invalid start in PageLabel dictionary.");
                j = T;
              } else j = 1;
            }
            switch (I) {
              case "D":
                z = j;
                break;
              case "R":
              case "r":
                z = (0, o.toRomanNumerals)(j, I === "r");
                break;
              case "A":
              case "a":
                const T = 26, F = I === "a" ? 97 : 65, S = j - 1;
                z = String.fromCharCode(F + S % T).repeat(Math.floor(S / T) + 1);
                break;
              default:
                if (I) throw new g.FormatError(`Invalid style "${I}" in PageLabel dictionary.`);
                z = "";
            }
            E[$] = R + z, j++;
          }
          return E;
        }
        get pageLayout() {
          const O = this._catDict.get("PageLayout");
          let E = "";
          if (O instanceof p.Name) switch (O.name) {
            case "SinglePage":
            case "OneColumn":
            case "TwoColumnLeft":
            case "TwoColumnRight":
            case "TwoPageLeft":
            case "TwoPageRight":
              E = O.name;
          }
          return (0, g.shadow)(this, "pageLayout", E);
        }
        get pageMode() {
          const O = this._catDict.get("PageMode");
          let E = "UseNone";
          if (O instanceof p.Name) switch (O.name) {
            case "UseNone":
            case "UseOutlines":
            case "UseThumbs":
            case "FullScreen":
            case "UseOC":
            case "UseAttachments":
              E = O.name;
          }
          return (0, g.shadow)(this, "pageMode", E);
        }
        get viewerPreferences() {
          const O = this._catDict.get("ViewerPreferences");
          if (!(O instanceof p.Dict)) return (0, g.shadow)(this, "viewerPreferences", null);
          let E = null;
          for (const I of O.getKeys()) {
            const R = O.get(I);
            let W;
            switch (I) {
              case "HideToolbar":
              case "HideMenubar":
              case "HideWindowUI":
              case "FitWindow":
              case "CenterWindow":
              case "DisplayDocTitle":
              case "PickTrayByPDFSize":
                typeof R == "boolean" && (W = R);
                break;
              case "NonFullScreenPageMode":
                if (R instanceof p.Name) switch (R.name) {
                  case "UseNone":
                  case "UseOutlines":
                  case "UseThumbs":
                  case "UseOC":
                    W = R.name;
                    break;
                  default:
                    W = "UseNone";
                }
                break;
              case "Direction":
                if (R instanceof p.Name) switch (R.name) {
                  case "L2R":
                  case "R2L":
                    W = R.name;
                    break;
                  default:
                    W = "L2R";
                }
                break;
              case "ViewArea":
              case "ViewClip":
              case "PrintArea":
              case "PrintClip":
                if (R instanceof p.Name) switch (R.name) {
                  case "MediaBox":
                  case "CropBox":
                  case "BleedBox":
                  case "TrimBox":
                  case "ArtBox":
                    W = R.name;
                    break;
                  default:
                    W = "CropBox";
                }
                break;
              case "PrintScaling":
                if (R instanceof p.Name) switch (R.name) {
                  case "None":
                  case "AppDefault":
                    W = R.name;
                    break;
                  default:
                    W = "AppDefault";
                }
                break;
              case "Duplex":
                if (R instanceof p.Name) switch (R.name) {
                  case "Simplex":
                  case "DuplexFlipShortEdge":
                  case "DuplexFlipLongEdge":
                    W = R.name;
                    break;
                  default:
                    W = "None";
                }
                break;
              case "PrintPageRange":
                Array.isArray(R) && R.length % 2 == 0 && R.every((z, j, $) => Number.isInteger(z) && z > 0 && (j === 0 || z >= $[j - 1]) && z <= this.numPages) && (W = R);
                break;
              case "NumCopies":
                Number.isInteger(R) && R > 0 && (W = R);
                break;
              default:
                (0, g.warn)(`Ignoring non-standard key in ViewerPreferences: ${I}.`);
                continue;
            }
            W !== void 0 ? (E || (E = /* @__PURE__ */ Object.create(null)), E[I] = W) : (0, g.warn)(`Bad value, for key "${I}", in ViewerPreferences: ${R}.`);
          }
          return (0, g.shadow)(this, "viewerPreferences", E);
        }
        get openAction() {
          const O = this._catDict.get("OpenAction"), E = /* @__PURE__ */ Object.create(null);
          if (O instanceof p.Dict) {
            const I = new p.Dict(this.xref);
            I.set("A", O);
            const R = { url: null, dest: null, action: null };
            _.parseDestDictionary({ destDict: I, resultObj: R }), Array.isArray(R.dest) ? E.dest = R.dest : R.action && (E.action = R.action);
          } else Array.isArray(O) && (E.dest = O);
          return (0, g.shadow)(this, "openAction", (0, g.objectSize)(E) > 0 ? E : null);
        }
        get attachments() {
          const O = this._catDict.get("Names");
          let E = null;
          if (O instanceof p.Dict && O.has("EmbeddedFiles")) {
            const I = new n.NameTree(O.getRaw("EmbeddedFiles"), this.xref);
            for (const [R, W] of I.getAll()) {
              const z = new b.FileSpec(W, this.xref);
              E || (E = /* @__PURE__ */ Object.create(null)), E[(0, g.stringToPDFString)(R)] = z.serializable;
            }
          }
          return (0, g.shadow)(this, "attachments", E);
        }
        get xfaImages() {
          const O = this._catDict.get("Names");
          let E = null;
          if (O instanceof p.Dict && O.has("XFAImages")) {
            const I = new n.NameTree(O.getRaw("XFAImages"), this.xref);
            for (const [R, W] of I.getAll())
              E || (E = new p.Dict(this.xref)), E.set((0, g.stringToPDFString)(R), W);
          }
          return (0, g.shadow)(this, "xfaImages", E);
        }
        _collectJavaScript() {
          const O = this._catDict.get("Names");
          let E = null;
          function I(W, z) {
            if (!(z instanceof p.Dict) || !(0, p.isName)(z.get("S"), "JavaScript")) return;
            let j = z.get("JS");
            if (j instanceof a.BaseStream) j = j.getString();
            else if (typeof j != "string") return;
            j = (0, g.stringToPDFString)(j).replaceAll("\0", ""), j && (E || (E = /* @__PURE__ */ new Map())).set(W, j);
          }
          if (O instanceof p.Dict && O.has("JavaScript")) {
            const W = new n.NameTree(O.getRaw("JavaScript"), this.xref);
            for (const [z, j] of W.getAll()) I((0, g.stringToPDFString)(z), j);
          }
          const R = this._catDict.get("OpenAction");
          return R && I("OpenAction", R), E;
        }
        get jsActions() {
          const O = this._collectJavaScript();
          let E = (0, o.collectActions)(this.xref, this._catDict, g.DocumentActionEventType);
          if (O) {
            E || (E = /* @__PURE__ */ Object.create(null));
            for (const [I, R] of O) I in E ? E[I].push(R) : E[I] = [R];
          }
          return (0, g.shadow)(this, "jsActions", E);
        }
        async fontFallback(O, E) {
          const I = await Promise.all(this.fontCache);
          for (const R of I) if (R.loadedName === O) {
            R.fallback(E);
            return;
          }
        }
        async cleanup(O = !1) {
          (0, d.clearGlobalCaches)(), this.globalImageCache.clear(O), this.pageKidsCountCache.clear(), this.pageIndexCache.clear(), this.nonBlendModesSet.clear();
          const E = await Promise.all(this.fontCache);
          for (const { dict: I } of E) delete I.cacheKey;
          this.fontCache.clear(), this.builtInCMapCache.clear(), this.standardFontDataCache.clear(), this.systemFontCache.clear();
        }
        async getPageDict(O) {
          const E = [this.toplevelPagesDict], I = new p.RefSet(), R = this._catDict.getRaw("Pages");
          R instanceof p.Ref && I.put(R);
          const W = this.xref, z = this.pageKidsCountCache, j = this.pageIndexCache;
          let $ = 0;
          for (; E.length; ) {
            const B = E.pop();
            if (B instanceof p.Ref) {
              const S = z.get(B);
              if (S >= 0 && $ + S <= O) {
                $ += S;
                continue;
              }
              if (I.has(B)) throw new g.FormatError("Pages tree contains circular reference.");
              I.put(B);
              const A = await W.fetchAsync(B);
              if (A instanceof p.Dict) {
                let U = A.getRaw("Type");
                if (U instanceof p.Ref && (U = await W.fetchAsync(U)), (0, p.isName)(U, "Page") || !A.has("Kids")) {
                  if (z.has(B) || z.put(B, 1), j.has(B) || j.put(B, $), $ === O) return [A, B];
                  $++;
                  continue;
                }
              }
              E.push(A);
              continue;
            }
            if (!(B instanceof p.Dict)) throw new g.FormatError("Page dictionary kid reference points to wrong type of object.");
            const { objId: C } = B;
            let T = B.getRaw("Count");
            if (T instanceof p.Ref && (T = await W.fetchAsync(T)), Number.isInteger(T) && T >= 0 && (C && !z.has(C) && z.put(C, T), $ + T <= O)) {
              $ += T;
              continue;
            }
            let F = B.getRaw("Kids");
            if (F instanceof p.Ref && (F = await W.fetchAsync(F)), !Array.isArray(F)) {
              let S = B.getRaw("Type");
              if (S instanceof p.Ref && (S = await W.fetchAsync(S)), (0, p.isName)(S, "Page") || !B.has("Kids")) {
                if ($ === O) return [B, null];
                $++;
                continue;
              }
              throw new g.FormatError("Page dictionary kids object is not an array.");
            }
            for (let S = F.length - 1; S >= 0; S--) E.push(F[S]);
          }
          throw new Error(`Page index ${O} not found.`);
        }
        async getAllPageDicts(O = !1) {
          const { ignoreErrors: E } = this.pdfManager.evaluatorOptions, I = [{ currentNode: this.toplevelPagesDict, posInKids: 0 }], R = new p.RefSet(), W = this._catDict.getRaw("Pages");
          W instanceof p.Ref && R.put(W);
          const z = /* @__PURE__ */ new Map(), j = this.xref, $ = this.pageIndexCache;
          let B = 0;
          function C(F, S) {
            S && !$.has(S) && $.put(S, B), z.set(B++, [F, S]);
          }
          function T(F) {
            if (F instanceof o.XRefEntryException && !O) throw F;
            O && E && B === 0 && ((0, g.warn)(`getAllPageDicts - Skipping invalid first page: "${F}".`), F = p.Dict.empty), z.set(B++, [F, null]);
          }
          for (; I.length > 0; ) {
            const F = I.at(-1), { currentNode: S, posInKids: A } = F;
            let U = S.getRaw("Kids");
            if (U instanceof p.Ref) try {
              U = await j.fetchAsync(U);
            } catch (H) {
              T(H);
              break;
            }
            if (!Array.isArray(U)) {
              T(new g.FormatError("Page dictionary kids object is not an array."));
              break;
            }
            if (A >= U.length) {
              I.pop();
              continue;
            }
            const K = U[A];
            let X;
            if (K instanceof p.Ref) {
              if (R.has(K)) {
                T(new g.FormatError("Pages tree contains circular reference."));
                break;
              }
              R.put(K);
              try {
                X = await j.fetchAsync(K);
              } catch (H) {
                T(H);
                break;
              }
            } else X = K;
            if (!(X instanceof p.Dict)) {
              T(new g.FormatError("Page dictionary kid reference points to wrong type of object."));
              break;
            }
            let L = X.getRaw("Type");
            if (L instanceof p.Ref) try {
              L = await j.fetchAsync(L);
            } catch (H) {
              T(H);
              break;
            }
            (0, p.isName)(L, "Page") || !X.has("Kids") ? C(X, K instanceof p.Ref ? K : null) : I.push({ currentNode: X, posInKids: 0 }), F.posInKids++;
          }
          return z;
        }
        getPageIndex(O) {
          const E = this.pageIndexCache.get(O);
          if (E !== void 0) return Promise.resolve(E);
          const I = this.xref;
          let R = 0;
          const W = (z) => function($) {
            let B, C = 0;
            return I.fetchAsync($).then(function(T) {
              if ((0, p.isRefsEqual)($, O) && !(0, p.isDict)(T, "Page") && !(T instanceof p.Dict && !T.has("Type") && T.has("Contents"))) throw new g.FormatError("The reference does not point to a /Page dictionary.");
              if (!T) return null;
              if (!(T instanceof p.Dict)) throw new g.FormatError("Node must be a dictionary.");
              return B = T.getRaw("Parent"), T.getAsync("Parent");
            }).then(function(T) {
              if (!T) return null;
              if (!(T instanceof p.Dict)) throw new g.FormatError("Parent must be a dictionary.");
              return T.getAsync("Kids");
            }).then(function(T) {
              if (!T) return null;
              const F = [];
              let S = !1;
              for (const A of T) {
                if (!(A instanceof p.Ref)) throw new g.FormatError("Kid must be a reference.");
                if ((0, p.isRefsEqual)(A, $)) {
                  S = !0;
                  break;
                }
                F.push(I.fetchAsync(A).then(function(U) {
                  if (!(U instanceof p.Dict)) throw new g.FormatError("Kid node must be a dictionary.");
                  U.has("Count") ? C += U.get("Count") : C++;
                }));
              }
              if (!S) throw new g.FormatError("Kid reference not found in parent's kids.");
              return Promise.all(F).then(function() {
                return [C, B];
              });
            });
          }(z).then((j) => {
            if (!j)
              return this.pageIndexCache.put(O, R), R;
            const [$, B] = j;
            return R += $, W(B);
          });
          return W(O);
        }
        get baseUrl() {
          const O = this._catDict.get("URI");
          if (O instanceof p.Dict) {
            const E = O.get("Base");
            if (typeof E == "string") {
              const I = (0, g.createValidAbsoluteUrl)(E, null, { tryConvertEncoding: !0 });
              if (I) return (0, g.shadow)(this, "baseUrl", I.href);
            }
          }
          return (0, g.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
        }
        static parseDestDictionary({ destDict: O, resultObj: E, docBaseUrl: I = null, docAttachments: R = null }) {
          if (!(O instanceof p.Dict)) {
            (0, g.warn)("parseDestDictionary: `destDict` must be a dictionary.");
            return;
          }
          let W, z, j = O.get("A");
          if (j instanceof p.Dict || (O.has("Dest") ? j = O.get("Dest") : (j = O.get("AA"), j instanceof p.Dict && (j.has("D") ? j = j.get("D") : j.has("U") && (j = j.get("U"))))), j instanceof p.Dict) {
            const $ = j.get("S");
            if (!($ instanceof p.Name)) {
              (0, g.warn)("parseDestDictionary: Invalid type in Action dictionary.");
              return;
            }
            const B = $.name;
            switch (B) {
              case "ResetForm":
                const C = j.get("Flags"), T = (1 & (typeof C == "number" ? C : 0)) == 0, F = [], S = [];
                for (const st of j.get("Fields") || []) st instanceof p.Ref ? S.push(st.toString()) : typeof st == "string" && F.push((0, g.stringToPDFString)(st));
                E.resetForm = { fields: F, refs: S, include: T };
                break;
              case "URI":
                W = j.get("URI"), W instanceof p.Name && (W = "/" + W.name);
                break;
              case "GoTo":
                z = j.get("D");
                break;
              case "Launch":
              case "GoToR":
                const A = j.get("F");
                A instanceof p.Dict ? W = A.get("F") || null : typeof A == "string" && (W = A);
                let U = j.get("D");
                if (U && (U instanceof p.Name && (U = U.name), typeof W == "string")) {
                  const st = W.split("#")[0];
                  typeof U == "string" ? W = st + "#" + U : Array.isArray(U) && (W = st + "#" + JSON.stringify(U));
                }
                const K = j.get("NewWindow");
                typeof K == "boolean" && (E.newWindow = K);
                break;
              case "GoToE":
                const X = j.get("T");
                let L;
                if (R && X instanceof p.Dict) {
                  const st = X.get("R"), mt = X.get("N");
                  (0, p.isName)(st, "C") && typeof mt == "string" && (L = R[(0, g.stringToPDFString)(mt)]);
                }
                L ? E.attachment = L : (0, g.warn)('parseDestDictionary - unimplemented "GoToE" action.');
                break;
              case "Named":
                const H = j.get("N");
                H instanceof p.Name && (E.action = H.name);
                break;
              case "SetOCGState":
                const Q = j.get("State"), N = j.get("PreserveRB");
                if (!Array.isArray(Q) || Q.length === 0) break;
                const V = [];
                for (const st of Q) if (st instanceof p.Name) switch (st.name) {
                  case "ON":
                  case "OFF":
                  case "Toggle":
                    V.push(st.name);
                }
                else st instanceof p.Ref && V.push(st.toString());
                if (V.length !== Q.length) break;
                E.setOCGState = { state: V, preserveRB: typeof N != "boolean" || N };
                break;
              case "JavaScript":
                const Y = j.get("JS");
                let Z;
                Y instanceof a.BaseStream ? Z = Y.getString() : typeof Y == "string" && (Z = Y);
                const rt = Z && (0, o.recoverJsURL)((0, g.stringToPDFString)(Z));
                if (rt) {
                  W = rt.url, E.newWindow = rt.newWindow;
                  break;
                }
              default:
                if (B === "JavaScript" || B === "SubmitForm") break;
                (0, g.warn)(`parseDestDictionary - unsupported action: "${B}".`);
            }
          } else O.has("Dest") && (z = O.get("Dest"));
          if (typeof W == "string") {
            const $ = (0, g.createValidAbsoluteUrl)(W, I, { addDefaultProtocol: !0, tryConvertEncoding: !0 });
            $ && (E.url = $.href), E.unsafeUrl = W;
          }
          z && (z instanceof p.Name && (z = z.name), typeof z == "string" ? E.dest = (0, g.stringToPDFString)(z) : Array.isArray(z) && (E.dest = z));
        }
      }
      l.Catalog = _;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.NumberTree = l.NameTree = void 0;
      var o = f(4), g = f(2);
      class p {
        constructor(a, d, m) {
          this.constructor === p && (0, g.unreachable)("Cannot initialize NameOrNumberTree."), this.root = a, this.xref = d, this._type = m;
        }
        getAll() {
          const a = /* @__PURE__ */ new Map();
          if (!this.root) return a;
          const d = this.xref, m = new o.RefSet();
          m.put(this.root);
          const b = [this.root];
          for (; b.length > 0; ) {
            const w = d.fetchIfRef(b.shift());
            if (!(w instanceof o.Dict)) continue;
            if (w.has("Kids")) {
              const h = w.get("Kids");
              if (!Array.isArray(h)) continue;
              for (const x of h) {
                if (m.has(x)) throw new g.FormatError(`Duplicate entry in "${this._type}" tree.`);
                b.push(x), m.put(x);
              }
              continue;
            }
            const v = w.get(this._type);
            if (Array.isArray(v)) for (let h = 0, x = v.length; h < x; h += 2) a.set(d.fetchIfRef(v[h]), d.fetchIfRef(v[h + 1]));
          }
          return a;
        }
        get(a) {
          if (!this.root) return null;
          const d = this.xref;
          let m = d.fetchIfRef(this.root), b = 0;
          for (; m.has("Kids"); ) {
            if (++b > 10)
              return (0, g.warn)(`Search depth limit reached for "${this._type}" tree.`), null;
            const v = m.get("Kids");
            if (!Array.isArray(v)) return null;
            let h = 0, x = v.length - 1;
            for (; h <= x; ) {
              const _ = h + x >> 1, M = d.fetchIfRef(v[_]), O = M.get("Limits");
              if (a < d.fetchIfRef(O[0])) x = _ - 1;
              else {
                if (!(a > d.fetchIfRef(O[1]))) {
                  m = M;
                  break;
                }
                h = _ + 1;
              }
            }
            if (h > x) return null;
          }
          const w = m.get(this._type);
          if (Array.isArray(w)) {
            let v = 0, h = w.length - 2;
            for (; v <= h; ) {
              const x = v + h >> 1, _ = x + (1 & x), M = d.fetchIfRef(w[_]);
              if (a < M) h = _ - 2;
              else {
                if (!(a > M)) return d.fetchIfRef(w[_ + 1]);
                v = _ + 2;
              }
            }
          }
          return null;
        }
      }
      l.NameTree = class extends p {
        constructor(a, d) {
          super(a, d, "Names");
        }
      }, l.NumberTree = class extends p {
        constructor(a, d) {
          super(a, d, "Nums");
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.clearGlobalCaches = function() {
        (0, o.clearPatternCaches)(), (0, g.clearPrimitiveCaches)(), (0, p.clearUnicodeCaches)();
      };
      var o = f(50), g = f(4), p = f(40);
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.FileSpec = void 0;
      var o = f(2), g = f(5), p = f(4);
      function n(a) {
        return a.has("UF") ? a.get("UF") : a.has("F") ? a.get("F") : a.has("Unix") ? a.get("Unix") : a.has("Mac") ? a.get("Mac") : a.has("DOS") ? a.get("DOS") : null;
      }
      l.FileSpec = class {
        constructor(d, m) {
          d instanceof p.Dict && (this.xref = m, this.root = d, d.has("FS") && (this.fs = d.get("FS")), this.description = d.has("Desc") ? (0, o.stringToPDFString)(d.get("Desc")) : "", d.has("RF") && (0, o.warn)("Related file specifications are not supported"), this.contentAvailable = !0, d.has("EF") || (this.contentAvailable = !1, (0, o.warn)("Non-embedded file specifications are not supported")));
        }
        get filename() {
          if (!this._filename && this.root) {
            const d = n(this.root) || "unnamed";
            this._filename = (0, o.stringToPDFString)(d).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
          }
          return this._filename;
        }
        get content() {
          if (!this.contentAvailable) return null;
          !this.contentRef && this.root && (this.contentRef = n(this.root.get("EF")));
          let d = null;
          if (this.contentRef) {
            const m = this.xref.fetchIfRef(this.contentRef);
            m instanceof g.BaseStream ? d = m.getBytes() : (0, o.warn)("Embedded file specification points to non-existing/invalid content");
          } else (0, o.warn)("Embedded file specification does not have a content");
          return d;
        }
        get serializable() {
          return { filename: this.filename, content: this.content };
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.MetadataParser = void 0;
      var o = f(71);
      l.MetadataParser = class {
        constructor(p) {
          p = this._repair(p);
          const n = new o.SimpleXMLParser({ lowerCaseName: !0 }).parseFromString(p);
          this._metadataMap = /* @__PURE__ */ new Map(), this._data = p, n && this._parse(n);
        }
        _repair(p) {
          return p.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(n, a) {
            const d = a.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(b, w, v, h) {
              return String.fromCharCode(64 * w + 8 * v + 1 * h);
            }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(b, w) {
              switch (w) {
                case "amp":
                  return "&";
                case "apos":
                  return "'";
                case "gt":
                  return ">";
                case "lt":
                  return "<";
                case "quot":
                  return '"';
              }
              throw new Error(`_repair: ${w} isn't defined.`);
            }), m = [">"];
            for (let b = 0, w = d.length; b < w; b += 2) {
              const v = 256 * d.charCodeAt(b) + d.charCodeAt(b + 1);
              v >= 32 && v < 127 && v !== 60 && v !== 62 && v !== 38 ? m.push(String.fromCharCode(v)) : m.push("&#x" + (65536 + v).toString(16).substring(1) + ";");
            }
            return m.join("");
          });
        }
        _getSequence(p) {
          const n = p.nodeName;
          return n !== "rdf:bag" && n !== "rdf:seq" && n !== "rdf:alt" ? null : p.childNodes.filter((a) => a.nodeName === "rdf:li");
        }
        _parseArray(p) {
          if (!p.hasChildNodes()) return;
          const [n] = p.childNodes, a = this._getSequence(n) || [];
          this._metadataMap.set(p.nodeName, a.map((d) => d.textContent.trim()));
        }
        _parse(p) {
          let n = p.documentElement;
          if (n.nodeName !== "rdf:rdf")
            for (n = n.firstChild; n && n.nodeName !== "rdf:rdf"; ) n = n.nextSibling;
          if (n && n.nodeName === "rdf:rdf" && n.hasChildNodes()) {
            for (const a of n.childNodes) if (a.nodeName === "rdf:description") for (const d of a.childNodes) {
              const m = d.nodeName;
              switch (m) {
                case "#text":
                  continue;
                case "dc:creator":
                case "dc:subject":
                  this._parseArray(d);
                  continue;
              }
              this._metadataMap.set(m, d.textContent.trim());
            }
          }
        }
        get serializable() {
          return { parsedData: this._metadataMap, rawData: this._data };
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XMLParserErrorCode = l.XMLParserBase = l.SimpleXMLParser = l.SimpleDOMNode = void 0;
      var o = f(3);
      const g = { NoError: 0, EndOfDocument: -1, UnterminatedCdat: -2, UnterminatedXmlDeclaration: -3, UnterminatedDoctypeDeclaration: -4, UnterminatedComment: -5, MalformedElement: -6, OutOfMemory: -7, UnterminatedAttributeValue: -8, UnterminatedElement: -9, ElementNeverBegun: -10 };
      l.XMLParserErrorCode = g;
      function p(d, m) {
        const b = d[m];
        return b === " " || b === `
` || b === "\r" || b === "	";
      }
      class n {
        _resolveEntities(m) {
          return m.replaceAll(/&([^;]+);/g, (b, w) => {
            if (w.substring(0, 2) === "#x") return String.fromCodePoint(parseInt(w.substring(2), 16));
            if (w.substring(0, 1) === "#") return String.fromCodePoint(parseInt(w.substring(1), 10));
            switch (w) {
              case "lt":
                return "<";
              case "gt":
                return ">";
              case "amp":
                return "&";
              case "quot":
                return '"';
              case "apos":
                return "'";
            }
            return this.onResolveEntity(w);
          });
        }
        _parseContent(m, b) {
          const w = [];
          let v = b;
          function h() {
            for (; v < m.length && p(m, v); ) ++v;
          }
          for (; v < m.length && !p(m, v) && m[v] !== ">" && m[v] !== "/"; ) ++v;
          const x = m.substring(b, v);
          for (h(); v < m.length && m[v] !== ">" && m[v] !== "/" && m[v] !== "?"; ) {
            h();
            let _ = "", M = "";
            for (; v < m.length && !p(m, v) && m[v] !== "="; )
              _ += m[v], ++v;
            if (h(), m[v] !== "=") return null;
            ++v, h();
            const O = m[v];
            if (O !== '"' && O !== "'") return null;
            const E = m.indexOf(O, ++v);
            if (E < 0) return null;
            M = m.substring(v, E), w.push({ name: _, value: this._resolveEntities(M) }), v = E + 1, h();
          }
          return { name: x, attributes: w, parsed: v - b };
        }
        _parseProcessingInstruction(m, b) {
          let w = b;
          for (; w < m.length && !p(m, w) && m[w] !== ">" && m[w] !== "?" && m[w] !== "/"; ) ++w;
          const v = m.substring(b, w);
          (function() {
            for (; w < m.length && p(m, w); ) ++w;
          })();
          const h = w;
          for (; w < m.length && (m[w] !== "?" || m[w + 1] !== ">"); ) ++w;
          return { name: v, value: m.substring(h, w), parsed: w - b };
        }
        parseXml(m) {
          let b = 0;
          for (; b < m.length; ) {
            let w = b;
            if (m[b] === "<") {
              ++w;
              let v;
              switch (m[w]) {
                case "/":
                  if (++w, v = m.indexOf(">", w), v < 0) {
                    this.onError(g.UnterminatedElement);
                    return;
                  }
                  this.onEndElement(m.substring(w, v)), w = v + 1;
                  break;
                case "?":
                  ++w;
                  const h = this._parseProcessingInstruction(m, w);
                  if (m.substring(w + h.parsed, w + h.parsed + 2) !== "?>") {
                    this.onError(g.UnterminatedXmlDeclaration);
                    return;
                  }
                  this.onPi(h.name, h.value), w += h.parsed + 2;
                  break;
                case "!":
                  if (m.substring(w + 1, w + 3) === "--") {
                    if (v = m.indexOf("-->", w + 3), v < 0) {
                      this.onError(g.UnterminatedComment);
                      return;
                    }
                    this.onComment(m.substring(w + 3, v)), w = v + 3;
                  } else if (m.substring(w + 1, w + 8) === "[CDATA[") {
                    if (v = m.indexOf("]]>", w + 8), v < 0) {
                      this.onError(g.UnterminatedCdat);
                      return;
                    }
                    this.onCdata(m.substring(w + 8, v)), w = v + 3;
                  } else {
                    if (m.substring(w + 1, w + 8) !== "DOCTYPE") {
                      this.onError(g.MalformedElement);
                      return;
                    }
                    {
                      const M = m.indexOf("[", w + 8);
                      let O = !1;
                      if (v = m.indexOf(">", w + 8), v < 0) {
                        this.onError(g.UnterminatedDoctypeDeclaration);
                        return;
                      }
                      if (M > 0 && v > M) {
                        if (v = m.indexOf("]>", w + 8), v < 0) {
                          this.onError(g.UnterminatedDoctypeDeclaration);
                          return;
                        }
                        O = !0;
                      }
                      const E = m.substring(w + 8, v + (O ? 1 : 0));
                      this.onDoctype(E), w = v + (O ? 2 : 1);
                    }
                  }
                  break;
                default:
                  const x = this._parseContent(m, w);
                  if (x === null) {
                    this.onError(g.MalformedElement);
                    return;
                  }
                  let _ = !1;
                  if (m.substring(w + x.parsed, w + x.parsed + 2) === "/>") _ = !0;
                  else if (m.substring(w + x.parsed, w + x.parsed + 1) !== ">") {
                    this.onError(g.UnterminatedElement);
                    return;
                  }
                  this.onBeginElement(x.name, x.attributes, _), w += x.parsed + (_ ? 2 : 1);
              }
            } else {
              for (; w < m.length && m[w] !== "<"; ) w++;
              const v = m.substring(b, w);
              this.onText(this._resolveEntities(v));
            }
            b = w;
          }
        }
        onResolveEntity(m) {
          return `&${m};`;
        }
        onPi(m, b) {
        }
        onComment(m) {
        }
        onCdata(m) {
        }
        onDoctype(m) {
        }
        onText(m) {
        }
        onBeginElement(m, b, w) {
        }
        onEndElement(m) {
        }
        onError(m) {
        }
      }
      l.XMLParserBase = n;
      class a {
        constructor(m, b) {
          this.nodeName = m, this.nodeValue = b, Object.defineProperty(this, "parentNode", { value: null, writable: !0 });
        }
        get firstChild() {
          var m;
          return (m = this.childNodes) == null ? void 0 : m[0];
        }
        get nextSibling() {
          const m = this.parentNode.childNodes;
          if (!m) return;
          const b = m.indexOf(this);
          return b !== -1 ? m[b + 1] : void 0;
        }
        get textContent() {
          return this.childNodes ? this.childNodes.map(function(m) {
            return m.textContent;
          }).join("") : this.nodeValue || "";
        }
        get children() {
          return this.childNodes || [];
        }
        hasChildNodes() {
          var m;
          return ((m = this.childNodes) == null ? void 0 : m.length) > 0;
        }
        searchNode(m, b) {
          var x;
          if (b >= m.length) return this;
          const w = m[b];
          if (w.name.startsWith("#") && b < m.length - 1) return this.searchNode(m, b + 1);
          const v = [];
          let h = this;
          for (; ; ) {
            if (w.name === h.nodeName) {
              if (w.pos !== 0) {
                if (v.length === 0) return null;
                {
                  const [_] = v.pop();
                  let M = 0;
                  for (const O of _.childNodes) if (w.name === O.nodeName) {
                    if (M === w.pos) return O.searchNode(m, b + 1);
                    M++;
                  }
                  return h.searchNode(m, b + 1);
                }
              }
              {
                const _ = h.searchNode(m, b + 1);
                if (_ !== null) return _;
              }
            }
            if (((x = h.childNodes) == null ? void 0 : x.length) > 0)
              v.push([h, 0]), h = h.childNodes[0];
            else {
              if (v.length === 0) return null;
              for (; v.length !== 0; ) {
                const [_, M] = v.pop(), O = M + 1;
                if (O < _.childNodes.length) {
                  v.push([_, O]), h = _.childNodes[O];
                  break;
                }
              }
              if (v.length === 0) return null;
            }
          }
        }
        dump(m) {
          if (this.nodeName !== "#text") {
            if (m.push(`<${this.nodeName}`), this.attributes) for (const b of this.attributes) m.push(` ${b.name}="${(0, o.encodeToXmlString)(b.value)}"`);
            if (this.hasChildNodes()) {
              m.push(">");
              for (const b of this.childNodes) b.dump(m);
              m.push(`</${this.nodeName}>`);
            } else this.nodeValue ? m.push(`>${(0, o.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`) : m.push("/>");
          } else m.push((0, o.encodeToXmlString)(this.nodeValue));
        }
      }
      l.SimpleDOMNode = a, l.SimpleXMLParser = class extends n {
        constructor({ hasAttributes: m = !1, lowerCaseName: b = !1 }) {
          super(), this._currentFragment = null, this._stack = null, this._errorCode = g.NoError, this._hasAttributes = m, this._lowerCaseName = b;
        }
        parseFromString(m) {
          if (this._currentFragment = [], this._stack = [], this._errorCode = g.NoError, this.parseXml(m), this._errorCode !== g.NoError) return;
          const [b] = this._currentFragment;
          return b ? { documentElement: b } : void 0;
        }
        onText(m) {
          if (function(v) {
            for (let h = 0, x = v.length; h < x; h++) if (!p(v, h)) return !1;
            return !0;
          }(m)) return;
          const b = new a("#text", m);
          this._currentFragment.push(b);
        }
        onCdata(m) {
          const b = new a("#text", m);
          this._currentFragment.push(b);
        }
        onBeginElement(m, b, w) {
          this._lowerCaseName && (m = m.toLowerCase());
          const v = new a(m);
          v.childNodes = [], this._hasAttributes && (v.attributes = b), this._currentFragment.push(v), w || (this._stack.push(this._currentFragment), this._currentFragment = v.childNodes);
        }
        onEndElement(m) {
          this._currentFragment = this._stack.pop() || [];
          const b = this._currentFragment.at(-1);
          if (!b) return null;
          for (const w of b.childNodes) w.parentNode = b;
          return b;
        }
        onError(m) {
          this._errorCode = m;
        }
      };
    }, (u, l, f) => {
      var _, fM, O, Q9, dM, gM;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.StructTreeRoot = l.StructTreePage = void 0;
      var o = f(2), g = f(4), p = f(67), n = f(73);
      const a = 1, d = 2, m = 3, b = 4, w = 5, W = class W {
        constructor(j, $) {
          lr(this, _);
          this.dict = j, this.ref = $ instanceof g.Ref ? $ : null, this.roleMap = /* @__PURE__ */ new Map(), this.structParentIds = null;
        }
        init() {
          this.readRoleMap();
        }
        addAnnotationIdToPage(j, $) {
          Le(this, _, fM).call(this, j, $, b);
        }
        readRoleMap() {
          const j = this.dict.get("RoleMap");
          j instanceof g.Dict && j.forEach(($, B) => {
            B instanceof g.Name && this.roleMap.set($, B.name);
          });
        }
        static async canCreateStructureTree({ catalogRef: j, pdfManager: $, newAnnotationsByPage: B }) {
          var F;
          if (!(j instanceof g.Ref))
            return (0, o.warn)("Cannot save the struct tree: no catalog reference."), !1;
          let C = 0, T = !0;
          for (const [S, A] of B) {
            const { ref: U } = await $.getPage(S);
            if (!(U instanceof g.Ref)) {
              (0, o.warn)(`Cannot save the struct tree: page ${S} has no ref.`), T = !0;
              break;
            }
            for (const K of A) (F = K.accessibilityData) != null && F.type && (K.parentTreeId = C++, T = !1);
          }
          if (T) {
            for (const S of B.values()) for (const A of S) delete A.parentTreeId;
            return !1;
          }
          return !0;
        }
        static async createStructureTree({ newAnnotationsByPage: j, xref: $, catalogRef: B, pdfManager: C, newRefs: T }) {
          const F = C.catalog.cloneDict(), S = $.getNewTemporaryRef();
          F.set("StructTreeRoot", S);
          const A = [];
          await (0, n.writeObject)(B, F, A, $), T.push({ ref: B, data: A.join("") });
          const U = new g.Dict($);
          U.set("Type", g.Name.get("StructTreeRoot"));
          const K = $.getNewTemporaryRef();
          U.set("ParentTree", K);
          const X = [];
          U.set("K", X);
          const L = new g.Dict($), H = [];
          L.set("Nums", H);
          const Q = await Le(this, O, Q9).call(this, { newAnnotationsByPage: j, structTreeRootRef: S, kids: X, nums: H, xref: $, pdfManager: C, newRefs: T, buffer: A });
          U.set("ParentTreeNextKey", Q), A.length = 0, await (0, n.writeObject)(K, L, A, $), T.push({ ref: K, data: A.join("") }), A.length = 0, await (0, n.writeObject)(S, U, A, $), T.push({ ref: S, data: A.join("") });
        }
        async canUpdateStructTree({ pdfManager: j, newAnnotationsByPage: $ }) {
          var A, U;
          if (!this.ref)
            return (0, o.warn)("Cannot update the struct tree: no root reference."), !1;
          let B = this.dict.get("ParentTreeNextKey");
          if (!Number.isInteger(B) || B < 0)
            return (0, o.warn)("Cannot update the struct tree: invalid next key."), !1;
          const C = this.dict.get("ParentTree");
          if (!(C instanceof g.Dict))
            return (0, o.warn)("Cannot update the struct tree: ParentTree isn't a dict."), !1;
          const T = C.get("Nums");
          if (!Array.isArray(T))
            return (0, o.warn)("Cannot update the struct tree: nums isn't an array."), !1;
          const { numPages: F } = j.catalog;
          for (const K of $.keys()) {
            const { pageDict: X, ref: L } = await j.getPage(K);
            if (!(L instanceof g.Ref))
              return (0, o.warn)(`Cannot save the struct tree: page ${K} has no ref.`), !1;
            const H = X.get("StructParents");
            if (!Number.isInteger(H) || H < 0 || H >= F)
              return (0, o.warn)(`Cannot save the struct tree: page ${K} has no id.`), !1;
          }
          let S = !0;
          for (const [K, X] of $) {
            const { pageDict: L } = await j.getPage(K);
            Le(A = W, O, dM).call(A, { elements: X, xref: this.dict.xref, pageDict: L, parentTree: C });
            for (const H of X) (U = H.accessibilityData) != null && U.type && (H.parentTreeId = B++, S = !1);
          }
          if (S) {
            for (const K of $.values()) for (const X of K)
              delete X.parentTreeId, delete X.structTreeParent;
            return !1;
          }
          return !0;
        }
        async updateStructureTree({ newAnnotationsByPage: j, pdfManager: $, newRefs: B }) {
          var N;
          const C = this.dict.xref, T = this.dict.clone(), F = this.ref;
          let S, A = T.getRaw("ParentTree");
          A instanceof g.Ref ? S = C.fetch(A) : (S = A, A = C.getNewTemporaryRef(), T.set("ParentTree", A)), S = S.clone();
          let U = S.getRaw("Nums"), K = null;
          U instanceof g.Ref && (K = U, U = C.fetch(K)), U = U.slice(), K || S.set("Nums", U);
          let X = T.getRaw("K"), L = null;
          X instanceof g.Ref ? (L = X, X = C.fetch(L)) : (L = C.getNewTemporaryRef(), T.set("K", L)), X = Array.isArray(X) ? X.slice() : [X];
          const H = [], Q = await Le(N = W, O, Q9).call(N, { newAnnotationsByPage: j, structTreeRootRef: F, kids: X, nums: U, xref: C, pdfManager: $, newRefs: B, buffer: H });
          T.set("ParentTreeNextKey", Q), H.length = 0, await (0, n.writeObject)(L, X, H, C), B.push({ ref: L, data: H.join("") }), K && (H.length = 0, await (0, n.writeObject)(K, U, H, C), B.push({ ref: K, data: H.join("") })), H.length = 0, await (0, n.writeObject)(A, S, H, C), B.push({ ref: A, data: H.join("") }), H.length = 0, await (0, n.writeObject)(F, T, H, C), B.push({ ref: F, data: H.join("") });
        }
      };
      _ = new WeakSet(), fM = function(j, $, B) {
        if (!(j instanceof g.Ref) || $ < 0) return;
        this.structParentIds || (this.structParentIds = new g.RefSetCache());
        let C = this.structParentIds.get(j);
        C || (C = [], this.structParentIds.put(j, C)), C.push([$, B]);
      }, O = new WeakSet(), Q9 = async function({ newAnnotationsByPage: j, structTreeRootRef: $, kids: B, nums: C, xref: T, pdfManager: F, newRefs: S, buffer: A }) {
        const U = g.Name.get("OBJR");
        let K = -1 / 0;
        for (const [X, L] of j) {
          const { ref: H } = await F.getPage(X);
          for (const { accessibilityData: { type: Q, title: N, lang: V, alt: Y, expanded: Z, actualText: rt }, ref: st, parentTreeId: mt, structTreeParent: yt } of L) {
            K = Math.max(K, mt);
            const at = T.getNewTemporaryRef(), nt = new g.Dict(T);
            nt.set("S", g.Name.get(Q)), N && nt.set("T", N), V && nt.set("Lang", V), Y && nt.set("Alt", Y), Z && nt.set("E", Z), rt && nt.set("ActualText", rt), yt ? await Le(this, O, gM).call(this, { structTreeParent: yt, tagDict: nt, newTagRef: at, fallbackRef: $, xref: T, newRefs: S, buffer: A }) : nt.set("P", $);
            const q = new g.Dict(T);
            nt.set("K", q), q.set("Type", U), q.set("Pg", H), q.set("Obj", st), A.length = 0, await (0, n.writeObject)(at, nt, A, T), S.push({ ref: at, data: A.join("") }), C.push(mt, at), B.push(at);
          }
        }
        return K + 1;
      }, dM = function({ elements: j, xref: $, pageDict: B, parentTree: C }) {
        const T = /* @__PURE__ */ new Map();
        for (const U of j) if (U.structTreeParentId) {
          const K = parseInt(U.structTreeParentId.split("_mc")[1], 10);
          T.set(K, U);
        }
        const F = B.get("StructParents"), S = new p.NumberTree(C, $).get(F);
        if (!Array.isArray(S)) return;
        const A = (U, K, X) => {
          const L = T.get(U);
          if (L) {
            const H = K.getRaw("P"), Q = $.fetchIfRef(H);
            return H instanceof g.Ref && Q instanceof g.Dict && (L.structTreeParent = { ref: X, dict: K }), !0;
          }
          return !1;
        };
        for (const U of S) {
          if (!(U instanceof g.Ref)) continue;
          const K = $.fetch(U), X = K.get("K");
          if (Number.isInteger(X)) A(X, K, U);
          else if (Array.isArray(X)) {
            for (let L of X)
              if (L = $.fetchIfRef(L), Number.isInteger(L) && A(L, K, U)) break;
          }
        }
      }, gM = async function({ structTreeParent: { ref: j, dict: $ }, tagDict: B, newTagRef: C, fallbackRef: T, xref: F, newRefs: S, buffer: A }) {
        const U = $.getRaw("P");
        let K = F.fetchIfRef(U);
        B.set("P", U);
        let X, L = !1, H = K.getRaw("K");
        if (H instanceof g.Ref ? X = F.fetch(H) : (X = H, H = F.getNewTemporaryRef(), K = K.clone(), K.set("K", H), L = !0), Array.isArray(X)) {
          const Q = X.indexOf(j);
          if (!(Q >= 0)) {
            (0, o.warn)("Cannot update the struct tree: parent kid not found."), B.set("P", T);
            return;
          }
          X = X.slice(), X.splice(Q + 1, 0, C);
        } else X instanceof g.Dict && (X = [H, C], H = F.getNewTemporaryRef(), K.set("K", H), L = !0);
        A.length = 0, await (0, n.writeObject)(H, X, A, F), S.push({ ref: H, data: A.join("") }), L && (A.length = 0, await (0, n.writeObject)(U, K, A, F), S.push({ ref: U, data: A.join("") }));
      }, lr(W, O);
      let v = W;
      l.StructTreeRoot = v;
      class h {
        constructor(j, $) {
          this.tree = j, this.dict = $, this.kids = [], this.parseKids();
        }
        get role() {
          const j = this.dict.get("S"), $ = j instanceof g.Name ? j.name : "", { root: B } = this.tree;
          return B.roleMap.has($) ? B.roleMap.get($) : $;
        }
        parseKids() {
          let j = null;
          const $ = this.dict.getRaw("Pg");
          $ instanceof g.Ref && (j = $.toString());
          const B = this.dict.get("K");
          if (Array.isArray(B)) for (const C of B) {
            const T = this.parseKid(j, C);
            T && this.kids.push(T);
          }
          else {
            const C = this.parseKid(j, B);
            C && this.kids.push(C);
          }
        }
        parseKid(j, $) {
          if (Number.isInteger($)) return this.tree.pageDict.objId !== j ? null : new x({ type: a, mcid: $, pageObjId: j });
          let B = null;
          if ($ instanceof g.Ref ? B = this.dict.xref.fetch($) : $ instanceof g.Dict && (B = $), !B) return null;
          const C = B.getRaw("Pg");
          C instanceof g.Ref && (j = C.toString());
          const T = B.get("Type") instanceof g.Name ? B.get("Type").name : null;
          if (T === "MCR") {
            if (this.tree.pageDict.objId !== j) return null;
            const F = B.getRaw("Stm");
            return new x({ type: d, refObjId: F instanceof g.Ref ? F.toString() : null, pageObjId: j, mcid: B.get("MCID") });
          }
          if (T === "OBJR") {
            if (this.tree.pageDict.objId !== j) return null;
            const F = B.getRaw("Obj");
            return new x({ type: m, refObjId: F instanceof g.Ref ? F.toString() : null, pageObjId: j });
          }
          return new x({ type: w, dict: B });
        }
      }
      class x {
        constructor({ type: j, dict: $ = null, mcid: B = null, pageObjId: C = null, refObjId: T = null }) {
          this.type = j, this.dict = $, this.mcid = B, this.pageObjId = C, this.refObjId = T, this.parentNode = null;
        }
      }
      l.StructTreePage = class {
        constructor(j, $) {
          this.root = j, this.rootDict = j ? j.dict : null, this.pageDict = $, this.nodes = [];
        }
        parse(j) {
          var S, A;
          if (!this.root || !this.rootDict) return;
          const $ = this.rootDict.get("ParentTree");
          if (!$) return;
          const B = this.pageDict.get("StructParents"), C = j instanceof g.Ref && ((S = this.root.structParentIds) == null ? void 0 : S.get(j));
          if (!Number.isInteger(B) && !C) return;
          const T = /* @__PURE__ */ new Map(), F = new p.NumberTree($, this.rootDict.xref);
          if (Number.isInteger(B)) {
            const U = F.get(B);
            if (Array.isArray(U)) for (const K of U) K instanceof g.Ref && this.addNode(this.rootDict.xref.fetch(K), T);
          }
          if (C) for (const [U, K] of C) {
            const X = F.get(U);
            if (X) {
              const L = this.addNode(this.rootDict.xref.fetchIfRef(X), T);
              ((A = L == null ? void 0 : L.kids) == null ? void 0 : A.length) === 1 && L.kids[0].type === m && (L.kids[0].type = K);
            }
          }
        }
        addNode(j, $, B = 0) {
          if (B > 40)
            return (0, o.warn)("StructTree MAX_DEPTH reached."), null;
          if ($.has(j)) return $.get(j);
          const C = new h(this, j);
          $.set(j, C);
          const T = j.get("P");
          if (!T || (0, g.isName)(T.get("Type"), "StructTreeRoot"))
            return this.addTopLevelNode(j, C) || $.delete(j), C;
          const F = this.addNode(T, $, B + 1);
          if (!F) return C;
          let S = !1;
          for (const A of F.kids) A.type === w && A.dict === j && (A.parentNode = C, S = !0);
          return S || $.delete(j), C;
        }
        addTopLevelNode(j, $) {
          const B = this.rootDict.get("K");
          if (!B) return !1;
          if (B instanceof g.Dict)
            return B.objId !== j.objId ? !1 : (this.nodes[0] = $, !0);
          if (!Array.isArray(B)) return !0;
          let C = !1;
          for (let T = 0; T < B.length; T++) {
            const F = B[T];
            (F == null ? void 0 : F.toString()) === j.objId && (this.nodes[T] = $, C = !0);
          }
          return C;
        }
        get serializable() {
          function j(B, C, T = 0) {
            if (T > 40) {
              (0, o.warn)("StructTree too deep to be fully serialized.");
              return;
            }
            const F = /* @__PURE__ */ Object.create(null);
            F.role = B.role, F.children = [], C.children.push(F);
            const S = B.dict.get("Alt");
            typeof S == "string" && (F.alt = (0, o.stringToPDFString)(S));
            const A = B.dict.get("Lang");
            typeof A == "string" && (F.lang = (0, o.stringToPDFString)(A));
            for (const U of B.kids) {
              const K = U.type === w ? U.parentNode : null;
              K ? j(K, F, T + 1) : U.type === a || U.type === d ? F.children.push({ type: "content", id: `p${U.pageObjId}_mc${U.mcid}` }) : U.type === m ? F.children.push({ type: "object", id: U.refObjId }) : U.type === b && F.children.push({ type: "annotation", id: `${o.AnnotationPrefix}${U.refObjId}` });
            }
          }
          const $ = /* @__PURE__ */ Object.create(null);
          $.children = [], $.role = "Root";
          for (const B of this.nodes) B && j(B, $);
          return $;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.incrementalUpdate = async function({ originalData: O, xrefInfo: E, newRefs: I, xref: R = null, hasXfa: W = !1, xfaDatasetsRef: z = null, hasXfaDatasetsEntry: j = !1, needAppearances: $, acroFormRef: B = null, acroForm: C = null, xfaData: T = null }) {
        await async function({ xref: mt, acroForm: yt, acroFormRef: at, hasXfa: nt, hasXfaDatasetsEntry: q, xfaDatasetsRef: D, needAppearances: G, newRefs: et }) {
          if (!nt || q || D || (0, o.warn)("XFA - Cannot save it"), !G && (!nt || !D || q)) return;
          const J = yt.clone();
          if (nt && !q) {
            const lt = yt.get("XFA").slice();
            lt.splice(2, 0, "datasets"), lt.splice(3, 0, D), J.set("XFA", lt);
          }
          G && J.set("NeedAppearances", !0);
          const it = [];
          await m(at, J, it, mt), et.push({ ref: at, data: it.join("") });
        }({ xref: R, acroForm: C, acroFormRef: B, hasXfa: W, hasXfaDatasetsEntry: j, xfaDatasetsRef: z, needAppearances: $, newRefs: I }), W && function({ xfaData: mt, xfaDatasetsRef: yt, newRefs: at, xref: nt }) {
          mt === null && (mt = function(et, J) {
            const it = new n.SimpleXMLParser({ hasAttributes: !0 }).parseFromString(et);
            for (const { xfa: ot } of J) {
              if (!ot) continue;
              const { path: ut, value: ct } = ot;
              if (!ut) continue;
              const gt = (0, p.parseXFAPath)(ut);
              let dt = it.documentElement.searchNode(gt, 0);
              !dt && gt.length > 1 && (dt = it.documentElement.searchNode([gt.at(-1)], 0)), dt ? dt.childNodes = Array.isArray(ct) ? ct.map((bt) => new n.SimpleDOMNode("value", bt)) : [new n.SimpleDOMNode("#text", ct)] : (0, o.warn)(`Node not found for path: ${ut}`);
            }
            const lt = [];
            return it.documentElement.dump(lt), lt.join("");
          }(nt.fetchIfRef(yt).getString(), at));
          const q = nt.encrypt;
          q && (mt = q.createCipherTransform(yt.num, yt.gen).encryptString(mt));
          const D = `${yt.num} ${yt.gen} obj
<< /Type /EmbeddedFile /Length ${mt.length}>>
stream
` + mt + `
endstream
endobj
`;
          at.push({ ref: yt, data: D });
        }({ xfaData: T, xfaDatasetsRef: z, newRefs: I, xref: R });
        const F = new g.Dict(null), S = E.newRef;
        let A, U;
        const K = O.at(-1);
        K === 10 || K === 13 ? (A = [], U = O.length) : (A = [`
`], U = O.length + 1), F.set("Size", S.num + 1), F.set("Prev", E.startXRef), F.set("Type", g.Name.get("XRef")), E.rootRef !== null && F.set("Root", E.rootRef), E.infoRef !== null && F.set("Info", E.infoRef), E.encryptRef !== null && F.set("Encrypt", E.encryptRef), I.push({ ref: S, data: "" }), I = I.sort((st, mt) => st.ref.num - mt.ref.num);
        const X = [[0, 1, 65535]], L = [0, 1];
        let H = 0;
        for (const { ref: st, data: mt } of I)
          H = Math.max(H, U), X.push([1, U, Math.min(st.gen, 65535)]), U += mt.length, L.push(st.num, 1), A.push(mt);
        if (F.set("Index", L), Array.isArray(E.fileIds) && E.fileIds.length > 0) {
          const st = function(yt, at) {
            const nt = Math.floor(Date.now() / 1e3), q = at.filename || "", D = [nt.toString(), q, yt.toString()];
            let G = D.reduce((it, lt) => it + lt.length, 0);
            for (const it of Object.values(at.info))
              D.push(it), G += it.length;
            const et = new Uint8Array(G);
            let J = 0;
            for (const it of D)
              _(it, J, et), J += it.length;
            return (0, o.bytesToString)((0, d.calculateMD5)(et));
          }(U, E);
          F.set("ID", [E.fileIds[0], st]);
        }
        const Q = [1, Math.ceil(Math.log2(H) / 8), 2], N = (Q[0] + Q[1] + Q[2]) * X.length;
        F.set("W", Q), F.set("Length", N), A.push(`${S.num} ${S.gen} obj
`), await b(F, A, null), A.push(` stream
`);
        const V = A.reduce((st, mt) => st + mt.length, 0), Y = `
endstream
endobj
startxref
${U}
%%EOF
`, Z = new Uint8Array(O.length + V + N + Y.length);
        Z.set(O);
        let rt = O.length;
        for (const st of A)
          _(st, rt, Z), rt += st.length;
        for (const [st, mt, yt] of X)
          rt = x(st, Q[0], rt, Z), rt = x(mt, Q[1], rt, Z), rt = x(yt, Q[2], rt, Z);
        return _(Y, rt, Z), Z;
      }, l.writeDict = b, l.writeObject = m;
      var o = f(2), g = f(4), p = f(3), n = f(71), a = f(5), d = f(74);
      async function m(M, O, E, { encrypt: I = null }) {
        const R = I == null ? void 0 : I.createCipherTransform(M.num, M.gen);
        E.push(`${M.num} ${M.gen} obj
`), O instanceof g.Dict ? await b(O, E, R) : O instanceof a.BaseStream ? await w(O, E, R) : Array.isArray(O) && await v(O, E, R), E.push(`
endobj
`);
      }
      async function b(M, O, E) {
        O.push("<<");
        for (const I of M.getKeys())
          O.push(` /${(0, p.escapePDFName)(I)} `), await h(M.getRaw(I), O, E);
        O.push(">>");
      }
      async function w(M, O, E) {
        let I = M.getString();
        const { dict: R } = M, [W, z] = await Promise.all([R.getAsync("Filter"), R.getAsync("DecodeParms")]), j = Array.isArray(W) ? await R.xref.fetchIfRefAsync(W[0]) : W, $ = (0, g.isName)(j, "FlateDecode");
        if (typeof CompressionStream < "u" && (I.length >= 256 || $)) try {
          const B = (0, o.stringToBytes)(I), C = new CompressionStream("deflate"), T = C.writable.getWriter();
          T.write(B), T.close();
          const F = await new Response(C.readable).arrayBuffer();
          I = (0, o.bytesToString)(new Uint8Array(F));
          let S, A;
          W ? $ || (S = Array.isArray(W) ? [g.Name.get("FlateDecode"), ...W] : [g.Name.get("FlateDecode"), W], z && (A = Array.isArray(z) ? [null, ...z] : [null, z])) : S = g.Name.get("FlateDecode"), S && R.set("Filter", S), A && R.set("DecodeParms", A);
        } catch (B) {
          (0, o.info)(`writeStream - cannot compress data: "${B}".`);
        }
        E && (I = E.encryptString(I)), R.set("Length", I.length), await b(R, O, E), O.push(` stream
`, I, `
endstream`);
      }
      async function v(M, O, E) {
        O.push("[");
        let I = !0;
        for (const R of M)
          I ? I = !1 : O.push(" "), await h(R, O, E);
        O.push("]");
      }
      async function h(M, O, E) {
        M instanceof g.Name ? O.push(`/${(0, p.escapePDFName)(M.name)}`) : M instanceof g.Ref ? O.push(`${M.num} ${M.gen} R`) : Array.isArray(M) ? await v(M, O, E) : typeof M == "string" ? (E && (M = E.encryptString(M)), O.push(`(${(0, p.escapeString)(M)})`)) : typeof M == "number" ? O.push((0, p.numberToString)(M)) : typeof M == "boolean" ? O.push(M.toString()) : M instanceof g.Dict ? await b(M, O, E) : M instanceof a.BaseStream ? await w(M, O, E) : M === null ? O.push("null") : (0, o.warn)(`Unhandled value in writer: ${typeof M}, please file a bug.`);
      }
      function x(M, O, E, I) {
        for (let R = O + E - 1; R > E - 1; R--)
          I[R] = 255 & M, M >>= 8;
        return E + O;
      }
      function _(M, O, E) {
        for (let I = 0, R = M.length; I < R; I++) E[O + I] = 255 & M.charCodeAt(I);
      }
    }, (u, l, f) => {
      var R, W, pM, t6, mM, e2, e6;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.calculateSHA256 = l.calculateMD5 = l.PDF20 = l.PDF17 = l.CipherTransformFactory = l.ARCFourCipher = l.AES256Cipher = l.AES128Cipher = void 0, l.calculateSHA384 = w, l.calculateSHA512 = void 0;
      var o = f(2), g = f(4), p = f(75);
      class n {
        constructor(S) {
          this.a = 0, this.b = 0;
          const A = new Uint8Array(256), U = S.length;
          for (let K = 0; K < 256; ++K) A[K] = K;
          for (let K = 0, X = 0; K < 256; ++K) {
            const L = A[K];
            X = X + L + S[K % U] & 255, A[K] = A[X], A[X] = L;
          }
          this.s = A;
        }
        encryptBlock(S) {
          let A = this.a, U = this.b;
          const K = this.s, X = S.length, L = new Uint8Array(X);
          for (let H = 0; H < X; ++H) {
            A = A + 1 & 255;
            const Q = K[A];
            U = U + Q & 255;
            const N = K[U];
            K[A] = N, K[U] = Q, L[H] = S[H] ^ K[Q + N & 255];
          }
          return this.a = A, this.b = U, L;
        }
        decryptBlock(S) {
          return this.encryptBlock(S);
        }
        encrypt(S) {
          return this.encryptBlock(S);
        }
      }
      l.ARCFourCipher = n;
      const a = function() {
        const S = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]), A = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
        return function(K, X, L) {
          let H = 1732584193, Q = -271733879, N = -1732584194, V = 271733878;
          const Y = L + 72 & -64, Z = new Uint8Array(Y);
          let rt, st;
          for (rt = 0; rt < L; ++rt) Z[rt] = K[X++];
          Z[rt++] = 128;
          const mt = Y - 8;
          for (; rt < mt; ) Z[rt++] = 0;
          Z[rt++] = L << 3 & 255, Z[rt++] = L >> 5 & 255, Z[rt++] = L >> 13 & 255, Z[rt++] = L >> 21 & 255, Z[rt++] = L >>> 29 & 255, Z[rt++] = 0, Z[rt++] = 0, Z[rt++] = 0;
          const yt = new Int32Array(16);
          for (rt = 0; rt < Y; ) {
            for (st = 0; st < 16; ++st, rt += 4) yt[st] = Z[rt] | Z[rt + 1] << 8 | Z[rt + 2] << 16 | Z[rt + 3] << 24;
            let at, nt, q = H, D = Q, G = N, et = V;
            for (st = 0; st < 64; ++st) {
              st < 16 ? (at = D & G | ~D & et, nt = st) : st < 32 ? (at = et & D | ~et & G, nt = 5 * st + 1 & 15) : st < 48 ? (at = D ^ G ^ et, nt = 3 * st + 5 & 15) : (at = G ^ (D | ~et), nt = 7 * st & 15);
              const J = et, it = q + at + A[st] + yt[nt] | 0, lt = S[st];
              et = G, G = D, D = D + (it << lt | it >>> 32 - lt) | 0, q = J;
            }
            H = H + q | 0, Q = Q + D | 0, N = N + G | 0, V = V + et | 0;
          }
          return new Uint8Array([255 & H, H >> 8 & 255, H >> 16 & 255, H >>> 24 & 255, 255 & Q, Q >> 8 & 255, Q >> 16 & 255, Q >>> 24 & 255, 255 & N, N >> 8 & 255, N >> 16 & 255, N >>> 24 & 255, 255 & V, V >> 8 & 255, V >> 16 & 255, V >>> 24 & 255]);
        };
      }();
      l.calculateMD5 = a;
      class d {
        constructor(S, A) {
          this.high = 0 | S, this.low = 0 | A;
        }
        and(S) {
          this.high &= S.high, this.low &= S.low;
        }
        xor(S) {
          this.high ^= S.high, this.low ^= S.low;
        }
        or(S) {
          this.high |= S.high, this.low |= S.low;
        }
        shiftRight(S) {
          S >= 32 ? (this.low = this.high >>> S - 32 | 0, this.high = 0) : (this.low = this.low >>> S | this.high << 32 - S, this.high = this.high >>> S | 0);
        }
        shiftLeft(S) {
          S >= 32 ? (this.high = this.low << S - 32, this.low = 0) : (this.high = this.high << S | this.low >>> 32 - S, this.low <<= S);
        }
        rotateRight(S) {
          let A, U;
          32 & S ? (U = this.low, A = this.high) : (A = this.low, U = this.high), S &= 31, this.low = A >>> S | U << 32 - S, this.high = U >>> S | A << 32 - S;
        }
        not() {
          this.high = ~this.high, this.low = ~this.low;
        }
        add(S) {
          const A = (this.low >>> 0) + (S.low >>> 0);
          let U = (this.high >>> 0) + (S.high >>> 0);
          A > 4294967295 && (U += 1), this.low = 0 | A, this.high = 0 | U;
        }
        copyTo(S, A) {
          S[A] = this.high >>> 24 & 255, S[A + 1] = this.high >> 16 & 255, S[A + 2] = this.high >> 8 & 255, S[A + 3] = 255 & this.high, S[A + 4] = this.low >>> 24 & 255, S[A + 5] = this.low >> 16 & 255, S[A + 6] = this.low >> 8 & 255, S[A + 7] = 255 & this.low;
        }
        assign(S) {
          this.high = S.high, this.low = S.low;
        }
      }
      const m = /* @__PURE__ */ function() {
        function S(Q, N) {
          return Q >>> N | Q << 32 - N;
        }
        function A(Q, N, V) {
          return Q & N ^ ~Q & V;
        }
        function U(Q, N, V) {
          return Q & N ^ Q & V ^ N & V;
        }
        function K(Q) {
          return S(Q, 2) ^ S(Q, 13) ^ S(Q, 22);
        }
        function X(Q) {
          return S(Q, 6) ^ S(Q, 11) ^ S(Q, 25);
        }
        function L(Q) {
          return S(Q, 7) ^ S(Q, 18) ^ Q >>> 3;
        }
        const H = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
        return function(N, V, Y) {
          let Z = 1779033703, rt = 3144134277, st = 1013904242, mt = 2773480762, yt = 1359893119, at = 2600822924, nt = 528734635, q = 1541459225;
          const D = 64 * Math.ceil((Y + 9) / 64), G = new Uint8Array(D);
          let et, J;
          for (et = 0; et < Y; ++et) G[et] = N[V++];
          G[et++] = 128;
          const it = D - 8;
          for (; et < it; ) G[et++] = 0;
          G[et++] = 0, G[et++] = 0, G[et++] = 0, G[et++] = Y >>> 29 & 255, G[et++] = Y >> 21 & 255, G[et++] = Y >> 13 & 255, G[et++] = Y >> 5 & 255, G[et++] = Y << 3 & 255;
          const lt = new Uint32Array(64);
          for (et = 0; et < D; ) {
            for (J = 0; J < 16; ++J)
              lt[J] = G[et] << 24 | G[et + 1] << 16 | G[et + 2] << 8 | G[et + 3], et += 4;
            for (J = 16; J < 64; ++J) lt[J] = (S(ot = lt[J - 2], 17) ^ S(ot, 19) ^ ot >>> 10) + lt[J - 7] + L(lt[J - 15]) + lt[J - 16] | 0;
            let ut, ct, gt = Z, dt = rt, bt = st, vt = mt, xt = yt, St = at, Mt = nt, Et = q;
            for (J = 0; J < 64; ++J)
              ut = Et + X(xt) + A(xt, St, Mt) + H[J] + lt[J], ct = K(gt) + U(gt, dt, bt), Et = Mt, Mt = St, St = xt, xt = vt + ut | 0, vt = bt, bt = dt, dt = gt, gt = ut + ct | 0;
            Z = Z + gt | 0, rt = rt + dt | 0, st = st + bt | 0, mt = mt + vt | 0, yt = yt + xt | 0, at = at + St | 0, nt = nt + Mt | 0, q = q + Et | 0;
          }
          var ot;
          return new Uint8Array([Z >> 24 & 255, Z >> 16 & 255, Z >> 8 & 255, 255 & Z, rt >> 24 & 255, rt >> 16 & 255, rt >> 8 & 255, 255 & rt, st >> 24 & 255, st >> 16 & 255, st >> 8 & 255, 255 & st, mt >> 24 & 255, mt >> 16 & 255, mt >> 8 & 255, 255 & mt, yt >> 24 & 255, yt >> 16 & 255, yt >> 8 & 255, 255 & yt, at >> 24 & 255, at >> 16 & 255, at >> 8 & 255, 255 & at, nt >> 24 & 255, nt >> 16 & 255, nt >> 8 & 255, 255 & nt, q >> 24 & 255, q >> 16 & 255, q >> 8 & 255, 255 & q]);
        };
      }();
      l.calculateSHA256 = m;
      const b = function() {
        function S(Q, N, V, Y, Z) {
          Q.assign(N), Q.and(V), Z.assign(N), Z.not(), Z.and(Y), Q.xor(Z);
        }
        function A(Q, N, V, Y, Z) {
          Q.assign(N), Q.and(V), Z.assign(N), Z.and(Y), Q.xor(Z), Z.assign(V), Z.and(Y), Q.xor(Z);
        }
        function U(Q, N, V) {
          Q.assign(N), Q.rotateRight(28), V.assign(N), V.rotateRight(34), Q.xor(V), V.assign(N), V.rotateRight(39), Q.xor(V);
        }
        function K(Q, N, V) {
          Q.assign(N), Q.rotateRight(14), V.assign(N), V.rotateRight(18), Q.xor(V), V.assign(N), V.rotateRight(41), Q.xor(V);
        }
        function X(Q, N, V) {
          Q.assign(N), Q.rotateRight(1), V.assign(N), V.rotateRight(8), Q.xor(V), V.assign(N), V.shiftRight(7), Q.xor(V);
        }
        function L(Q, N, V) {
          Q.assign(N), Q.rotateRight(19), V.assign(N), V.rotateRight(61), Q.xor(V), V.assign(N), V.shiftRight(6), Q.xor(V);
        }
        const H = [new d(1116352408, 3609767458), new d(1899447441, 602891725), new d(3049323471, 3964484399), new d(3921009573, 2173295548), new d(961987163, 4081628472), new d(1508970993, 3053834265), new d(2453635748, 2937671579), new d(2870763221, 3664609560), new d(3624381080, 2734883394), new d(310598401, 1164996542), new d(607225278, 1323610764), new d(1426881987, 3590304994), new d(1925078388, 4068182383), new d(2162078206, 991336113), new d(2614888103, 633803317), new d(3248222580, 3479774868), new d(3835390401, 2666613458), new d(4022224774, 944711139), new d(264347078, 2341262773), new d(604807628, 2007800933), new d(770255983, 1495990901), new d(1249150122, 1856431235), new d(1555081692, 3175218132), new d(1996064986, 2198950837), new d(2554220882, 3999719339), new d(2821834349, 766784016), new d(2952996808, 2566594879), new d(3210313671, 3203337956), new d(3336571891, 1034457026), new d(3584528711, 2466948901), new d(113926993, 3758326383), new d(338241895, 168717936), new d(666307205, 1188179964), new d(773529912, 1546045734), new d(1294757372, 1522805485), new d(1396182291, 2643833823), new d(1695183700, 2343527390), new d(1986661051, 1014477480), new d(2177026350, 1206759142), new d(2456956037, 344077627), new d(2730485921, 1290863460), new d(2820302411, 3158454273), new d(3259730800, 3505952657), new d(3345764771, 106217008), new d(3516065817, 3606008344), new d(3600352804, 1432725776), new d(4094571909, 1467031594), new d(275423344, 851169720), new d(430227734, 3100823752), new d(506948616, 1363258195), new d(659060556, 3750685593), new d(883997877, 3785050280), new d(958139571, 3318307427), new d(1322822218, 3812723403), new d(1537002063, 2003034995), new d(1747873779, 3602036899), new d(1955562222, 1575990012), new d(2024104815, 1125592928), new d(2227730452, 2716904306), new d(2361852424, 442776044), new d(2428436474, 593698344), new d(2756734187, 3733110249), new d(3204031479, 2999351573), new d(3329325298, 3815920427), new d(3391569614, 3928383900), new d(3515267271, 566280711), new d(3940187606, 3454069534), new d(4118630271, 4000239992), new d(116418474, 1914138554), new d(174292421, 2731055270), new d(289380356, 3203993006), new d(460393269, 320620315), new d(685471733, 587496836), new d(852142971, 1086792851), new d(1017036298, 365543100), new d(1126000580, 2618297676), new d(1288033470, 3409855158), new d(1501505948, 4234509866), new d(1607167915, 987167468), new d(1816402316, 1246189591)];
        return function(N, V, Y, Z = !1) {
          let rt, st, mt, yt, at, nt, q, D;
          Z ? (rt = new d(3418070365, 3238371032), st = new d(1654270250, 914150663), mt = new d(2438529370, 812702999), yt = new d(355462360, 4144912697), at = new d(1731405415, 4290775857), nt = new d(2394180231, 1750603025), q = new d(3675008525, 1694076839), D = new d(1203062813, 3204075428)) : (rt = new d(1779033703, 4089235720), st = new d(3144134277, 2227873595), mt = new d(1013904242, 4271175723), yt = new d(2773480762, 1595750129), at = new d(1359893119, 2917565137), nt = new d(2600822924, 725511199), q = new d(528734635, 4215389547), D = new d(1541459225, 327033209));
          const G = 128 * Math.ceil((Y + 17) / 128), et = new Uint8Array(G);
          let J, it;
          for (J = 0; J < Y; ++J) et[J] = N[V++];
          et[J++] = 128;
          const lt = G - 16;
          for (; J < lt; ) et[J++] = 0;
          et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = 0, et[J++] = Y >>> 29 & 255, et[J++] = Y >> 21 & 255, et[J++] = Y >> 13 & 255, et[J++] = Y >> 5 & 255, et[J++] = Y << 3 & 255;
          const ot = new Array(80);
          for (J = 0; J < 80; J++) ot[J] = new d(0, 0);
          let ut = new d(0, 0), ct = new d(0, 0), gt = new d(0, 0), dt = new d(0, 0), bt = new d(0, 0), vt = new d(0, 0), xt = new d(0, 0), St = new d(0, 0);
          const Mt = new d(0, 0), Et = new d(0, 0), Ft = new d(0, 0), Wt = new d(0, 0);
          let Kt, qt;
          for (J = 0; J < G; ) {
            for (it = 0; it < 16; ++it)
              ot[it].high = et[J] << 24 | et[J + 1] << 16 | et[J + 2] << 8 | et[J + 3], ot[it].low = et[J + 4] << 24 | et[J + 5] << 16 | et[J + 6] << 8 | et[J + 7], J += 8;
            for (it = 16; it < 80; ++it)
              Kt = ot[it], L(Kt, ot[it - 2], Wt), Kt.add(ot[it - 7]), X(Ft, ot[it - 15], Wt), Kt.add(Ft), Kt.add(ot[it - 16]);
            for (ut.assign(rt), ct.assign(st), gt.assign(mt), dt.assign(yt), bt.assign(at), vt.assign(nt), xt.assign(q), St.assign(D), it = 0; it < 80; ++it)
              Mt.assign(St), K(Ft, bt, Wt), Mt.add(Ft), S(Ft, bt, vt, xt, Wt), Mt.add(Ft), Mt.add(H[it]), Mt.add(ot[it]), U(Et, ut, Wt), A(Ft, ut, ct, gt, Wt), Et.add(Ft), Kt = St, St = xt, xt = vt, vt = bt, dt.add(Mt), bt = dt, dt = gt, gt = ct, ct = ut, Kt.assign(Mt), Kt.add(Et), ut = Kt;
            rt.add(ut), st.add(ct), mt.add(gt), yt.add(dt), at.add(bt), nt.add(vt), q.add(xt), D.add(St);
          }
          return Z ? (qt = new Uint8Array(48), rt.copyTo(qt, 0), st.copyTo(qt, 8), mt.copyTo(qt, 16), yt.copyTo(qt, 24), at.copyTo(qt, 32), nt.copyTo(qt, 40)) : (qt = new Uint8Array(64), rt.copyTo(qt, 0), st.copyTo(qt, 8), mt.copyTo(qt, 16), yt.copyTo(qt, 24), at.copyTo(qt, 32), nt.copyTo(qt, 40), q.copyTo(qt, 48), D.copyTo(qt, 56)), qt;
        };
      }();
      l.calculateSHA512 = b;
      function w(F, S, A) {
        return b(F, S, A, !0);
      }
      class v {
        decryptBlock(S) {
          return S;
        }
        encrypt(S) {
          return S;
        }
      }
      class h {
        constructor() {
          this.constructor === h && (0, o.unreachable)("Cannot initialize AESBaseCipher."), this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]), this._mixCol = new Uint8Array(256);
          for (let S = 0; S < 256; S++) this._mixCol[S] = S < 128 ? S << 1 : S << 1 ^ 27;
          this.buffer = new Uint8Array(16), this.bufferPosition = 0;
        }
        _expandKey(S) {
          (0, o.unreachable)("Cannot call `_expandKey` on the base class");
        }
        _decrypt(S, A) {
          let U, K, X;
          const L = new Uint8Array(16);
          L.set(S);
          for (let H = 0, Q = this._keySize; H < 16; ++H, ++Q) L[H] ^= A[Q];
          for (let H = this._cyclesOfRepetition - 1; H >= 1; --H) {
            U = L[13], L[13] = L[9], L[9] = L[5], L[5] = L[1], L[1] = U, U = L[14], K = L[10], L[14] = L[6], L[10] = L[2], L[6] = U, L[2] = K, U = L[15], K = L[11], X = L[7], L[15] = L[3], L[11] = U, L[7] = K, L[3] = X;
            for (let Q = 0; Q < 16; ++Q) L[Q] = this._inv_s[L[Q]];
            for (let Q = 0, N = 16 * H; Q < 16; ++Q, ++N) L[Q] ^= A[N];
            for (let Q = 0; Q < 16; Q += 4) {
              const N = this._mix[L[Q]], V = this._mix[L[Q + 1]], Y = this._mix[L[Q + 2]], Z = this._mix[L[Q + 3]];
              U = N ^ V >>> 8 ^ V << 24 ^ Y >>> 16 ^ Y << 16 ^ Z >>> 24 ^ Z << 8, L[Q] = U >>> 24 & 255, L[Q + 1] = U >> 16 & 255, L[Q + 2] = U >> 8 & 255, L[Q + 3] = 255 & U;
            }
          }
          U = L[13], L[13] = L[9], L[9] = L[5], L[5] = L[1], L[1] = U, U = L[14], K = L[10], L[14] = L[6], L[10] = L[2], L[6] = U, L[2] = K, U = L[15], K = L[11], X = L[7], L[15] = L[3], L[11] = U, L[7] = K, L[3] = X;
          for (let H = 0; H < 16; ++H)
            L[H] = this._inv_s[L[H]], L[H] ^= A[H];
          return L;
        }
        _encrypt(S, A) {
          const U = this._s;
          let K, X, L;
          const H = new Uint8Array(16);
          H.set(S);
          for (let Q = 0; Q < 16; ++Q) H[Q] ^= A[Q];
          for (let Q = 1; Q < this._cyclesOfRepetition; Q++) {
            for (let N = 0; N < 16; ++N) H[N] = U[H[N]];
            L = H[1], H[1] = H[5], H[5] = H[9], H[9] = H[13], H[13] = L, L = H[2], X = H[6], H[2] = H[10], H[6] = H[14], H[10] = L, H[14] = X, L = H[3], X = H[7], K = H[11], H[3] = H[15], H[7] = L, H[11] = X, H[15] = K;
            for (let N = 0; N < 16; N += 4) {
              const V = H[N + 0], Y = H[N + 1], Z = H[N + 2], rt = H[N + 3];
              K = V ^ Y ^ Z ^ rt, H[N + 0] ^= K ^ this._mixCol[V ^ Y], H[N + 1] ^= K ^ this._mixCol[Y ^ Z], H[N + 2] ^= K ^ this._mixCol[Z ^ rt], H[N + 3] ^= K ^ this._mixCol[rt ^ V];
            }
            for (let N = 0, V = 16 * Q; N < 16; ++N, ++V) H[N] ^= A[V];
          }
          for (let Q = 0; Q < 16; ++Q) H[Q] = U[H[Q]];
          L = H[1], H[1] = H[5], H[5] = H[9], H[9] = H[13], H[13] = L, L = H[2], X = H[6], H[2] = H[10], H[6] = H[14], H[10] = L, H[14] = X, L = H[3], X = H[7], K = H[11], H[3] = H[15], H[7] = L, H[11] = X, H[15] = K;
          for (let Q = 0, N = this._keySize; Q < 16; ++Q, ++N) H[Q] ^= A[N];
          return H;
        }
        _decryptBlock2(S, A) {
          const U = S.length;
          let K = this.buffer, X = this.bufferPosition;
          const L = [];
          let H = this.iv;
          for (let V = 0; V < U; ++V) {
            if (K[X] = S[V], ++X, X < 16) continue;
            const Y = this._decrypt(K, this._key);
            for (let Z = 0; Z < 16; ++Z) Y[Z] ^= H[Z];
            H = K, L.push(Y), K = new Uint8Array(16), X = 0;
          }
          if (this.buffer = K, this.bufferLength = X, this.iv = H, L.length === 0) return new Uint8Array(0);
          let Q = 16 * L.length;
          if (A) {
            const V = L.at(-1);
            let Y = V[15];
            if (Y <= 16) {
              for (let Z = 15, rt = 16 - Y; Z >= rt; --Z) if (V[Z] !== Y) {
                Y = 0;
                break;
              }
              Q -= Y, L[L.length - 1] = V.subarray(0, 16 - Y);
            }
          }
          const N = new Uint8Array(Q);
          for (let V = 0, Y = 0, Z = L.length; V < Z; ++V, Y += 16) N.set(L[V], Y);
          return N;
        }
        decryptBlock(S, A, U = null) {
          const K = S.length, X = this.buffer;
          let L = this.bufferPosition;
          if (U) this.iv = U;
          else {
            for (let H = 0; L < 16 && H < K; ++H, ++L) X[L] = S[H];
            if (L < 16)
              return this.bufferLength = L, new Uint8Array(0);
            this.iv = X, S = S.subarray(16);
          }
          return this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = this._decryptBlock2, this.decryptBlock(S, A);
        }
        encrypt(S, A) {
          const U = S.length;
          let K = this.buffer, X = this.bufferPosition;
          const L = [];
          A || (A = new Uint8Array(16));
          for (let N = 0; N < U; ++N) {
            if (K[X] = S[N], ++X, X < 16) continue;
            for (let Y = 0; Y < 16; ++Y) K[Y] ^= A[Y];
            const V = this._encrypt(K, this._key);
            A = V, L.push(V), K = new Uint8Array(16), X = 0;
          }
          if (this.buffer = K, this.bufferLength = X, this.iv = A, L.length === 0) return new Uint8Array(0);
          const H = 16 * L.length, Q = new Uint8Array(H);
          for (let N = 0, V = 0, Y = L.length; N < Y; ++N, V += 16) Q.set(L[N], V);
          return Q;
        }
      }
      class x extends h {
        constructor(S) {
          super(), this._cyclesOfRepetition = 10, this._keySize = 160, this._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]), this._key = this._expandKey(S);
        }
        _expandKey(S) {
          const A = this._s, U = this._rcon, K = new Uint8Array(176);
          K.set(S);
          for (let X = 16, L = 1; X < 176; ++L) {
            let H = K[X - 3], Q = K[X - 2], N = K[X - 1], V = K[X - 4];
            H = A[H], Q = A[Q], N = A[N], V = A[V], H ^= U[L];
            for (let Y = 0; Y < 4; ++Y)
              K[X] = H ^= K[X - 16], X++, K[X] = Q ^= K[X - 16], X++, K[X] = N ^= K[X - 16], X++, K[X] = V ^= K[X - 16], X++;
          }
          return K;
        }
      }
      l.AES128Cipher = x;
      class _ extends h {
        constructor(S) {
          super(), this._cyclesOfRepetition = 14, this._keySize = 224, this._key = this._expandKey(S);
        }
        _expandKey(S) {
          const A = this._s, U = new Uint8Array(240);
          U.set(S);
          let K, X, L, H, Q = 1;
          for (let N = 32, V = 1; N < 240; ++V) {
            N % 32 == 16 ? (K = A[K], X = A[X], L = A[L], H = A[H]) : N % 32 == 0 && (K = U[N - 3], X = U[N - 2], L = U[N - 1], H = U[N - 4], K = A[K], X = A[X], L = A[L], H = A[H], K ^= Q, (Q <<= 1) >= 256 && (Q = 255 & (27 ^ Q)));
            for (let Y = 0; Y < 4; ++Y)
              U[N] = K ^= U[N - 32], N++, U[N] = X ^= U[N - 32], N++, U[N] = L ^= U[N - 32], N++, U[N] = H ^= U[N - 32], N++;
          }
          return U;
        }
      }
      l.AES256Cipher = _;
      class M {
        checkOwnerPassword(S, A, U, K) {
          const X = new Uint8Array(S.length + 56);
          X.set(S, 0), X.set(A, S.length), X.set(U, S.length + A.length);
          const L = m(X, 0, X.length);
          return (0, o.isArrayEqual)(L, K);
        }
        checkUserPassword(S, A, U) {
          const K = new Uint8Array(S.length + 8);
          K.set(S, 0), K.set(A, S.length);
          const X = m(K, 0, K.length);
          return (0, o.isArrayEqual)(X, U);
        }
        getOwnerKey(S, A, U, K) {
          const X = new Uint8Array(S.length + 56);
          X.set(S, 0), X.set(A, S.length), X.set(U, S.length + A.length);
          const L = m(X, 0, X.length);
          return new _(L).decryptBlock(K, !1, new Uint8Array(16));
        }
        getUserKey(S, A, U) {
          const K = new Uint8Array(S.length + 8);
          K.set(S, 0), K.set(A, S.length);
          const X = m(K, 0, K.length);
          return new _(X).decryptBlock(U, !1, new Uint8Array(16));
        }
      }
      l.PDF17 = M;
      class O {
        _hash(S, A, U) {
          let K = m(A, 0, A.length).subarray(0, 32), X = [0], L = 0;
          for (; L < 64 || X.at(-1) > L - 32; ) {
            const H = S.length + K.length + U.length, Q = new Uint8Array(H);
            let N = 0;
            Q.set(S, N), N += S.length, Q.set(K, N), N += K.length, Q.set(U, N);
            const V = new Uint8Array(64 * H);
            for (let Z = 0, rt = 0; Z < 64; Z++, rt += H) V.set(Q, rt);
            X = new x(K.subarray(0, 16)).encrypt(V, K.subarray(16, 32));
            const Y = X.slice(0, 16).reduce((Z, rt) => Z + rt, 0) % 3;
            Y === 0 ? K = m(X, 0, X.length) : Y === 1 ? K = w(X, 0, X.length) : Y === 2 && (K = b(X, 0, X.length)), L++;
          }
          return K.subarray(0, 32);
        }
        checkOwnerPassword(S, A, U, K) {
          const X = new Uint8Array(S.length + 56);
          X.set(S, 0), X.set(A, S.length), X.set(U, S.length + A.length);
          const L = this._hash(S, X, U);
          return (0, o.isArrayEqual)(L, K);
        }
        checkUserPassword(S, A, U) {
          const K = new Uint8Array(S.length + 8);
          K.set(S, 0), K.set(A, S.length);
          const X = this._hash(S, K, []);
          return (0, o.isArrayEqual)(X, U);
        }
        getOwnerKey(S, A, U, K) {
          const X = new Uint8Array(S.length + 56);
          X.set(S, 0), X.set(A, S.length), X.set(U, S.length + A.length);
          const L = this._hash(S, X, U);
          return new _(L).decryptBlock(K, !1, new Uint8Array(16));
        }
        getUserKey(S, A, U) {
          const K = new Uint8Array(S.length + 8);
          K.set(S, 0), K.set(A, S.length);
          const X = this._hash(S, K, []);
          return new _(X).decryptBlock(U, !1, new Uint8Array(16));
        }
      }
      l.PDF20 = O;
      class E {
        constructor(S, A) {
          this.StringCipherConstructor = S, this.StreamCipherConstructor = A;
        }
        createStream(S, A) {
          const U = new this.StreamCipherConstructor();
          return new p.DecryptStream(S, A, function(X, L) {
            return U.decryptBlock(X, L);
          });
        }
        decryptString(S) {
          const A = new this.StringCipherConstructor();
          let U = (0, o.stringToBytes)(S);
          return U = A.decryptBlock(U, !0), (0, o.bytesToString)(U);
        }
        encryptString(S) {
          const A = new this.StringCipherConstructor();
          if (A instanceof h) {
            const K = 16 - S.length % 16;
            S += String.fromCharCode(K).repeat(K);
            const X = new Uint8Array(16);
            if (typeof crypto < "u") crypto.getRandomValues(X);
            else for (let Q = 0; Q < 16; Q++) X[Q] = Math.floor(256 * Math.random());
            let L = (0, o.stringToBytes)(S);
            L = A.encrypt(L, X);
            const H = new Uint8Array(16 + L.length);
            return H.set(X), H.set(L, 16), (0, o.bytesToString)(H);
          }
          let U = (0, o.stringToBytes)(S);
          return U = A.encrypt(U), (0, o.bytesToString)(U);
        }
      }
      const T = class T {
        constructor(S, A, U) {
          lr(this, W);
          const K = S.get("Filter");
          if (!(0, g.isName)(K, "Standard")) throw new o.FormatError("unknown encryption method");
          this.filterName = K.name, this.dict = S;
          const X = S.get("V");
          if (!Number.isInteger(X) || X !== 1 && X !== 2 && X !== 4 && X !== 5) throw new o.FormatError("unsupported encryption algorithm");
          this.algorithm = X;
          let L = S.get("Length");
          if (!L) if (X <= 3) L = 40;
          else {
            const at = S.get("CF"), nt = S.get("StmF");
            if (at instanceof g.Dict && nt instanceof g.Name) {
              at.suppressEncryption = !0;
              const q = at.get(nt.name);
              L = (q == null ? void 0 : q.get("Length")) || 128, L < 40 && (L <<= 3);
            }
          }
          if (!Number.isInteger(L) || L < 40 || L % 8 != 0) throw new o.FormatError("invalid key length");
          const H = (0, o.stringToBytes)(S.get("O")), Q = (0, o.stringToBytes)(S.get("U")), N = H.subarray(0, 32), V = Q.subarray(0, 32), Y = S.get("P"), Z = S.get("R"), rt = (X === 4 || X === 5) && S.get("EncryptMetadata") !== !1;
          this.encryptMetadata = rt;
          const st = (0, o.stringToBytes)(A);
          let mt, yt;
          if (U) {
            if (Z === 6) try {
              U = (0, o.utf8StringToString)(U);
            } catch {
              (0, o.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
            }
            mt = (0, o.stringToBytes)(U);
          }
          if (X !== 5) yt = Le(this, W, t6).call(this, st, mt, N, V, Y, Z, L, rt);
          else {
            const at = H.subarray(32, 40), nt = H.subarray(40, 48), q = Q.subarray(0, 48), D = Q.subarray(32, 40), G = Q.subarray(40, 48), et = (0, o.stringToBytes)(S.get("OE")), J = (0, o.stringToBytes)(S.get("UE")), it = (0, o.stringToBytes)(S.get("Perms"));
            yt = Le(this, W, pM).call(this, Z, mt, N, at, nt, q, V, D, G, et, J, it);
          }
          if (!yt && !U) throw new o.PasswordException("No password given", o.PasswordResponses.NEED_PASSWORD);
          if (!yt && U) {
            const at = Le(this, W, mM).call(this, mt, N, Z, L);
            yt = Le(this, W, t6).call(this, st, at, N, V, Y, Z, L, rt);
          }
          if (!yt) throw new o.PasswordException("Incorrect Password", o.PasswordResponses.INCORRECT_PASSWORD);
          if (this.encryptionKey = yt, X >= 4) {
            const at = S.get("CF");
            at instanceof g.Dict && (at.suppressEncryption = !0), this.cf = at, this.stmf = S.get("StmF") || g.Name.get("Identity"), this.strf = S.get("StrF") || g.Name.get("Identity"), this.eff = S.get("EFF") || this.stmf;
          }
        }
        createCipherTransform(S, A) {
          if (this.algorithm === 4 || this.algorithm === 5) return new E(Le(this, W, e6).call(this, this.cf, this.strf, S, A, this.encryptionKey), Le(this, W, e6).call(this, this.cf, this.stmf, S, A, this.encryptionKey));
          const U = Le(this, W, e2).call(this, S, A, this.encryptionKey, !1), K = function() {
            return new n(U);
          };
          return new E(K, K);
        }
      };
      R = new WeakMap(), W = new WeakSet(), pM = function(S, A, U, K, X, L, H, Q, N, V, Y, Z) {
        if (A) {
          const st = Math.min(127, A.length);
          A = A.subarray(0, st);
        } else A = [];
        const rt = S === 6 ? new O() : new M();
        return rt.checkUserPassword(A, Q, H) ? rt.getUserKey(A, N, Y) : A.length && rt.checkOwnerPassword(A, K, L, U) ? rt.getOwnerKey(A, X, L, V) : null;
      }, t6 = function(S, A, U, K, X, L, H, Q) {
        const N = 40 + U.length + S.length, V = new Uint8Array(N);
        let Y, Z, rt = 0;
        if (A)
          for (Z = Math.min(32, A.length); rt < Z; ++rt) V[rt] = A[rt];
        for (Y = 0; rt < 32; ) V[rt++] = or(T, R)[Y++];
        for (Y = 0, Z = U.length; Y < Z; ++Y) V[rt++] = U[Y];
        for (V[rt++] = 255 & X, V[rt++] = X >> 8 & 255, V[rt++] = X >> 16 & 255, V[rt++] = X >>> 24 & 255, Y = 0, Z = S.length; Y < Z; ++Y) V[rt++] = S[Y];
        L >= 4 && !Q && (V[rt++] = 255, V[rt++] = 255, V[rt++] = 255, V[rt++] = 255);
        let st = a(V, 0, rt);
        const mt = H >> 3;
        if (L >= 3) for (Y = 0; Y < 50; ++Y) st = a(st, 0, mt);
        const yt = st.subarray(0, mt);
        let at, nt;
        if (L >= 3) {
          for (rt = 0; rt < 32; ++rt) V[rt] = or(T, R)[rt];
          for (Y = 0, Z = S.length; Y < Z; ++Y) V[rt++] = S[Y];
          at = new n(yt), nt = at.encryptBlock(a(V, 0, rt)), Z = yt.length;
          const q = new Uint8Array(Z);
          for (Y = 1; Y <= 19; ++Y) {
            for (let D = 0; D < Z; ++D) q[D] = yt[D] ^ Y;
            at = new n(q), nt = at.encryptBlock(nt);
          }
          for (Y = 0, Z = nt.length; Y < Z; ++Y) if (K[Y] !== nt[Y]) return null;
        } else
          for (at = new n(yt), nt = at.encryptBlock(or(T, R)), Y = 0, Z = nt.length; Y < Z; ++Y) if (K[Y] !== nt[Y]) return null;
        return yt;
      }, mM = function(S, A, U, K) {
        const X = new Uint8Array(32);
        let L = 0;
        const H = Math.min(32, S.length);
        for (; L < H; ++L) X[L] = S[L];
        let Q = 0;
        for (; L < 32; ) X[L++] = or(T, R)[Q++];
        let N = a(X, 0, L);
        const V = K >> 3;
        if (U >= 3) for (Q = 0; Q < 50; ++Q) N = a(N, 0, N.length);
        let Y, Z;
        if (U >= 3) {
          Z = A;
          const rt = new Uint8Array(V);
          for (Q = 19; Q >= 0; Q--) {
            for (let st = 0; st < V; ++st) rt[st] = N[st] ^ Q;
            Y = new n(rt), Z = Y.encryptBlock(Z);
          }
        } else
          Y = new n(N.subarray(0, V)), Z = Y.encryptBlock(A);
        return Z;
      }, e2 = function(S, A, U, K = !1) {
        const X = new Uint8Array(U.length + 9), L = U.length;
        let H;
        for (H = 0; H < L; ++H) X[H] = U[H];
        return X[H++] = 255 & S, X[H++] = S >> 8 & 255, X[H++] = S >> 16 & 255, X[H++] = 255 & A, X[H++] = A >> 8 & 255, K && (X[H++] = 115, X[H++] = 65, X[H++] = 108, X[H++] = 84), a(X, 0, H).subarray(0, Math.min(U.length + 5, 16));
      }, e6 = function(S, A, U, K, X) {
        if (!(A instanceof g.Name)) throw new o.FormatError("Invalid crypt filter name.");
        const L = this, H = S.get(A.name), Q = H == null ? void 0 : H.get("CFM");
        if (!Q || Q.name === "None") return function() {
          return new v();
        };
        if (Q.name === "V2") return function() {
          var N;
          return new n(Le(N = L, W, e2).call(N, U, K, X, !1));
        };
        if (Q.name === "AESV2") return function() {
          var N;
          return new x(Le(N = L, W, e2).call(N, U, K, X, !0));
        };
        if (Q.name === "AESV3") return function() {
          return new _(X);
        };
        throw new o.FormatError("Unknown crypto method");
      }, lr(T, R, new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]));
      let I = T;
      l.CipherTransformFactory = I;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.DecryptStream = void 0;
      var o = f(18);
      class g extends o.DecodeStream {
        constructor(n, a, d) {
          super(a), this.str = n, this.dict = n.dict, this.decrypt = d, this.nextChunk = null, this.initialized = !1;
        }
        readBlock() {
          var b;
          let n;
          if (this.initialized ? n = this.nextChunk : (n = this.str.getBytes(512), this.initialized = !0), !n || n.length === 0) {
            this.eof = !0;
            return;
          }
          this.nextChunk = this.str.getBytes(512);
          const a = ((b = this.nextChunk) == null ? void 0 : b.length) > 0;
          n = (0, this.decrypt)(n, !a);
          const d = this.bufferLength, m = d + n.length;
          this.ensureBuffer(m).set(n, d), this.bufferLength = m;
        }
      }
      l.DecryptStream = g;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ObjectLoader = void 0;
      var o = f(4), g = f(5), p = f(3), n = f(2);
      function a(d, m) {
        if (d instanceof o.Dict) d = d.getRawValues();
        else if (d instanceof g.BaseStream) d = d.dict.getRawValues();
        else if (!Array.isArray(d)) return;
        for (const w of d) ((b = w) instanceof o.Ref || b instanceof o.Dict || b instanceof g.BaseStream || Array.isArray(b)) && m.push(w);
        var b;
      }
      l.ObjectLoader = class {
        constructor(m, b, w) {
          this.dict = m, this.keys = b, this.xref = w, this.refSet = null;
        }
        async load() {
          if (this.xref.stream.isDataLoaded) return;
          const { keys: m, dict: b } = this;
          this.refSet = new o.RefSet();
          const w = [];
          for (const v of m) {
            const h = b.getRaw(v);
            h !== void 0 && w.push(h);
          }
          return this._walk(w);
        }
        async _walk(m) {
          const b = [], w = [];
          for (; m.length; ) {
            let v = m.pop();
            if (v instanceof o.Ref) {
              if (this.refSet.has(v)) continue;
              try {
                this.refSet.put(v), v = this.xref.fetch(v);
              } catch (h) {
                if (!(h instanceof p.MissingDataException)) {
                  (0, n.warn)(`ObjectLoader._walk - requesting all data: "${h}".`), this.refSet = null;
                  const { manager: x } = this.xref.stream;
                  return x.requestAllChunks();
                }
                b.push(v), w.push({ begin: h.begin, end: h.end });
              }
            }
            if (v instanceof g.BaseStream) {
              const h = v.getBaseStreams();
              if (h) {
                let x = !1;
                for (const _ of h) _.isDataLoaded || (x = !0, w.push({ begin: _.start, end: _.end }));
                x && b.push(v);
              }
            }
            a(v, m);
          }
          if (w.length) {
            await this.xref.stream.manager.requestRanges(w);
            for (const v of b) v instanceof o.Ref && this.refSet.remove(v);
            return this._walk(b);
          }
          this.refSet = null;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XFAFactory = void 0;
      var o = f(78), g = f(79), p = f(89), n = f(85), a = f(84), d = f(2), m = f(90), b = f(100);
      class w {
        constructor(h) {
          try {
            this.root = new m.XFAParser().parse(w._createDocument(h));
            const x = new g.Binder(this.root);
            this.form = x.bind(), this.dataHandler = new p.DataHandler(this.root, x.getData()), this.form[o.$globalData].template = this.form;
          } catch (x) {
            (0, d.warn)(`XFA - an error occurred during parsing and binding: ${x}`);
          }
        }
        isValid() {
          return this.root && this.form;
        }
        _createPagesHelper() {
          const h = this.form[o.$toPages]();
          return new Promise((x, _) => {
            const M = () => {
              try {
                const O = h.next();
                O.done ? x(O.value) : setTimeout(M, 0);
              } catch (O) {
                _(O);
              }
            };
            setTimeout(M, 0);
          });
        }
        async _createPages() {
          try {
            this.pages = await this._createPagesHelper(), this.dims = this.pages.children.map((h) => {
              const { width: x, height: _ } = h.attributes.style;
              return [0, 0, parseInt(x), parseInt(_)];
            });
          } catch (h) {
            (0, d.warn)(`XFA - an error occurred during layout: ${h}`);
          }
        }
        getBoundingBox(h) {
          return this.dims[h];
        }
        async getNumPages() {
          return this.pages || await this._createPages(), this.dims.length;
        }
        setImages(h) {
          this.form[o.$globalData].images = h;
        }
        setFonts(h) {
          this.form[o.$globalData].fontFinder = new n.FontFinder(h);
          const x = [];
          for (let _ of this.form[o.$globalData].usedTypefaces)
            _ = (0, a.stripQuotes)(_), this.form[o.$globalData].fontFinder.find(_) || x.push(_);
          return x.length > 0 ? x : null;
        }
        appendFonts(h, x) {
          this.form[o.$globalData].fontFinder.add(h, x);
        }
        async getPages() {
          this.pages || await this._createPages();
          const h = this.pages;
          return this.pages = null, h;
        }
        serializeData(h) {
          return this.dataHandler.serialize(h);
        }
        static _createDocument(h) {
          return h["/xdp:xdp"] ? Object.values(h).join("") : h["xdp:xdp"];
        }
        static getRichTextAsHtml(h) {
          if (!h || typeof h != "string") return null;
          try {
            let x = new m.XFAParser(b.XhtmlNamespace, !0).parse(h);
            if (!["body", "xhtml"].includes(x[o.$nodeName])) {
              const E = b.XhtmlNamespace.body({});
              E[o.$appendChild](x), x = E;
            }
            const _ = x[o.$toHTML]();
            if (!_.success) return null;
            const { html: M } = _, { attributes: O } = M;
            return O && (O.class && (O.class = O.class.filter((E) => !E.startsWith("xfa"))), O.dir = "auto"), { html: M, str: x[o.$text]() };
          } catch (x) {
            (0, d.warn)(`XFA - an error occurred during parsing of rich text: ${x}`);
          }
          return null;
        }
      }
      l.XFAFactory = w;
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.$uid = l.$toStyle = l.$toString = l.$toPages = l.$toHTML = l.$text = l.$tabIndex = l.$setValue = l.$setSetAttributes = l.$setId = l.$searchNode = l.$root = l.$resolvePrototypes = l.$removeChild = l.$pushPara = l.$pushGlyphs = l.$popPara = l.$onText = l.$onChildCheck = l.$onChild = l.$nsAttributes = l.$nodeName = l.$namespaceId = l.$lastAttribute = l.$isUsable = l.$isTransparent = l.$isThereMoreWidth = l.$isSplittable = l.$isNsAgnostic = l.$isDescendent = l.$isDataValue = l.$isCDATAXml = l.$isBindable = l.$insertAt = l.$indexOf = l.$ids = l.$hasSettableValue = l.$globalData = l.$getTemplateRoot = l.$getSubformParent = l.$getRealChildrenByNameIt = l.$getParent = l.$getNextPage = l.$getExtra = l.$getDataValue = l.$getContainedChildren = l.$getChildrenByNameIt = l.$getChildrenByName = l.$getChildrenByClass = l.$getChildren = l.$getAvailableSpace = l.$getAttributes = l.$getAttributeIt = l.$flushHTML = l.$finalize = l.$extra = l.$dump = l.$data = l.$content = l.$consumed = l.$clone = l.$cleanup = l.$cleanPage = l.$clean = l.$childrenToHTML = l.$appendChild = l.$addHTML = l.$acceptWhitespace = void 0;
      const f = Symbol();
      l.$acceptWhitespace = f;
      const o = Symbol();
      l.$addHTML = o;
      const g = Symbol();
      l.$appendChild = g;
      const p = Symbol();
      l.$childrenToHTML = p;
      const n = Symbol();
      l.$clean = n;
      const a = Symbol();
      l.$cleanPage = a;
      const d = Symbol();
      l.$cleanup = d;
      const m = Symbol();
      l.$clone = m;
      const b = Symbol();
      l.$consumed = b;
      const w = Symbol("content");
      l.$content = w;
      const v = Symbol("data");
      l.$data = v;
      const h = Symbol();
      l.$dump = h;
      const x = Symbol("extra");
      l.$extra = x;
      const _ = Symbol();
      l.$finalize = _;
      const M = Symbol();
      l.$flushHTML = M;
      const O = Symbol();
      l.$getAttributeIt = O;
      const E = Symbol();
      l.$getAttributes = E;
      const I = Symbol();
      l.$getAvailableSpace = I;
      const R = Symbol();
      l.$getChildrenByClass = R;
      const W = Symbol();
      l.$getChildrenByName = W;
      const z = Symbol();
      l.$getChildrenByNameIt = z;
      const j = Symbol();
      l.$getDataValue = j;
      const $ = Symbol();
      l.$getExtra = $;
      const B = Symbol();
      l.$getRealChildrenByNameIt = B;
      const C = Symbol();
      l.$getChildren = C;
      const T = Symbol();
      l.$getContainedChildren = T;
      const F = Symbol();
      l.$getNextPage = F;
      const S = Symbol();
      l.$getSubformParent = S;
      const A = Symbol();
      l.$getParent = A;
      const U = Symbol();
      l.$getTemplateRoot = U;
      const K = Symbol();
      l.$globalData = K;
      const X = Symbol();
      l.$hasSettableValue = X;
      const L = Symbol();
      l.$ids = L;
      const H = Symbol();
      l.$indexOf = H;
      const Q = Symbol();
      l.$insertAt = Q;
      const N = Symbol();
      l.$isCDATAXml = N;
      const V = Symbol();
      l.$isBindable = V;
      const Y = Symbol();
      l.$isDataValue = Y;
      const Z = Symbol();
      l.$isDescendent = Z;
      const rt = Symbol();
      l.$isNsAgnostic = rt;
      const st = Symbol();
      l.$isSplittable = st;
      const mt = Symbol();
      l.$isThereMoreWidth = mt;
      const yt = Symbol();
      l.$isTransparent = yt;
      const at = Symbol();
      l.$isUsable = at;
      const nt = Symbol();
      l.$lastAttribute = nt;
      const q = Symbol("namespaceId");
      l.$namespaceId = q;
      const D = Symbol("nodeName");
      l.$nodeName = D;
      const G = Symbol();
      l.$nsAttributes = G;
      const et = Symbol();
      l.$onChild = et;
      const J = Symbol();
      l.$onChildCheck = J;
      const it = Symbol();
      l.$onText = it;
      const lt = Symbol();
      l.$pushGlyphs = lt;
      const ot = Symbol();
      l.$popPara = ot;
      const ut = Symbol();
      l.$pushPara = ut;
      const ct = Symbol();
      l.$removeChild = ct;
      const gt = Symbol("root");
      l.$root = gt;
      const dt = Symbol();
      l.$resolvePrototypes = dt;
      const bt = Symbol();
      l.$searchNode = bt;
      const vt = Symbol();
      l.$setId = vt;
      const xt = Symbol();
      l.$setSetAttributes = xt;
      const St = Symbol();
      l.$setValue = St;
      const Mt = Symbol();
      l.$tabIndex = Mt;
      const Et = Symbol();
      l.$text = Et;
      const Ft = Symbol();
      l.$toPages = Ft;
      const Wt = Symbol();
      l.$toHTML = Wt;
      const Kt = Symbol();
      l.$toString = Kt;
      const qt = Symbol();
      l.$toStyle = qt;
      const It = Symbol("uid");
      l.$uid = It;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Binder = void 0;
      var o = f(78), g = f(80), p = f(88), n = f(87), a = f(81), d = f(2);
      const m = a.NamespaceIds.datasets.id;
      function b(w) {
        const v = new g.Text({});
        return v[o.$content] = w, v;
      }
      l.Binder = class {
        constructor(v) {
          var h;
          this.root = v, this.datasets = v.datasets, this.data = ((h = v.datasets) == null ? void 0 : h.data) || new n.XmlObject(a.NamespaceIds.datasets.id, "data"), this.emptyMerge = this.data[o.$getChildren]().length === 0, this.root.form = this.form = v.template[o.$clone]();
        }
        _isConsumeData() {
          return !this.emptyMerge && this._mergeMode;
        }
        _isMatchTemplate() {
          return !this._isConsumeData();
        }
        bind() {
          return this._bindElement(this.form, this.data), this.form;
        }
        getData() {
          return this.data;
        }
        _bindValue(v, h, x) {
          var _, M;
          if (v[o.$data] = h, v[o.$hasSettableValue]()) if (h[o.$isDataValue]()) {
            const O = h[o.$getDataValue]();
            v[o.$setValue](b(O));
          } else if (v instanceof g.Field && ((M = (_ = v.ui) == null ? void 0 : _.choiceList) == null ? void 0 : M.open) === "multiSelect") {
            const O = h[o.$getChildren]().map((E) => E[o.$content].trim()).join(`
`);
            v[o.$setValue](b(O));
          } else this._isConsumeData() && (0, d.warn)("XFA - Nodes haven't the same type.");
          else !h[o.$isDataValue]() || this._isMatchTemplate() ? this._bindElement(v, h) : (0, d.warn)("XFA - Nodes haven't the same type.");
        }
        _findDataByNameToConsume(v, h, x, _) {
          if (!v) return null;
          let M, O;
          for (let E = 0; E < 3; E++) {
            for (M = x[o.$getRealChildrenByNameIt](v, !1, !0); O = M.next().value, !!O; )
              if (h === O[o.$isDataValue]()) return O;
            if (x[o.$namespaceId] === a.NamespaceIds.datasets.id && x[o.$nodeName] === "data") break;
            x = x[o.$getParent]();
          }
          return _ ? (M = this.data[o.$getRealChildrenByNameIt](v, !0, !1), O = M.next().value, O || (M = this.data[o.$getAttributeIt](v, !0), O = M.next().value, O != null && O[o.$isDataValue]() ? O : null)) : null;
        }
        _setProperties(v, h) {
          if (v.hasOwnProperty("setProperty")) for (const { ref: x, target: _, connection: M } of v.setProperty.children) {
            if (M || !x) continue;
            const O = (0, p.searchNode)(this.root, h, x, !1, !1);
            if (!O) {
              (0, d.warn)(`XFA - Invalid reference: ${x}.`);
              continue;
            }
            const [E] = O;
            if (!E[o.$isDescendent](this.data)) {
              (0, d.warn)("XFA - Invalid node: must be a data node.");
              continue;
            }
            const I = (0, p.searchNode)(this.root, v, _, !1, !1);
            if (!I) {
              (0, d.warn)(`XFA - Invalid target: ${_}.`);
              continue;
            }
            const [R] = I;
            if (!R[o.$isDescendent](v)) {
              (0, d.warn)("XFA - Invalid target: must be a property or subproperty.");
              continue;
            }
            const W = R[o.$getParent]();
            if (R instanceof g.SetProperty || W instanceof g.SetProperty) {
              (0, d.warn)("XFA - Invalid target: cannot be a setProperty or one of its properties.");
              continue;
            }
            if (R instanceof g.BindItems || W instanceof g.BindItems) {
              (0, d.warn)("XFA - Invalid target: cannot be a bindItems or one of its properties.");
              continue;
            }
            const z = E[o.$text](), j = R[o.$nodeName];
            if (R instanceof n.XFAAttribute) {
              const $ = /* @__PURE__ */ Object.create(null);
              $[j] = z;
              const B = Reflect.construct(Object.getPrototypeOf(W).constructor, [$]);
              W[j] = B[j];
            } else R.hasOwnProperty(o.$content) ? (R[o.$data] = E, R[o.$content] = z, R[o.$finalize]()) : (0, d.warn)("XFA - Invalid node to use in setProperty");
          }
        }
        _bindItems(v, h) {
          if (!v.hasOwnProperty("items") || !v.hasOwnProperty("bindItems") || v.bindItems.isEmpty()) return;
          for (const M of v.items.children) v[o.$removeChild](M);
          v.items.clear();
          const x = new g.Items({}), _ = new g.Items({});
          v[o.$appendChild](x), v.items.push(x), v[o.$appendChild](_), v.items.push(_);
          for (const { ref: M, labelRef: O, valueRef: E, connection: I } of v.bindItems.children) {
            if (I || !M) continue;
            const R = (0, p.searchNode)(this.root, h, M, !1, !1);
            if (R) for (const W of R) {
              if (!W[o.$isDescendent](this.datasets)) {
                (0, d.warn)(`XFA - Invalid ref (${M}): must be a datasets child.`);
                continue;
              }
              const z = (0, p.searchNode)(this.root, W, O, !0, !1);
              if (!z) {
                (0, d.warn)(`XFA - Invalid label: ${O}.`);
                continue;
              }
              const [j] = z;
              if (!j[o.$isDescendent](this.datasets)) {
                (0, d.warn)("XFA - Invalid label: must be a datasets child.");
                continue;
              }
              const $ = (0, p.searchNode)(this.root, W, E, !0, !1);
              if (!$) {
                (0, d.warn)(`XFA - Invalid value: ${E}.`);
                continue;
              }
              const [B] = $;
              if (!B[o.$isDescendent](this.datasets)) {
                (0, d.warn)("XFA - Invalid value: must be a datasets child.");
                continue;
              }
              const C = b(j[o.$text]()), T = b(B[o.$text]());
              x[o.$appendChild](C), x.text.push(C), _[o.$appendChild](T), _.text.push(T);
            }
            else (0, d.warn)(`XFA - Invalid reference: ${M}.`);
          }
        }
        _bindOccurrences(v, h, x) {
          let _;
          if (h.length > 1 && (_ = v[o.$clone](), _[o.$removeChild](_.occur), _.occur = null), this._bindValue(v, h[0], x), this._setProperties(v, h[0]), this._bindItems(v, h[0]), h.length === 1) return;
          const M = v[o.$getParent](), O = v[o.$nodeName], E = M[o.$indexOf](v);
          for (let I = 1, R = h.length; I < R; I++) {
            const W = h[I], z = _[o.$clone]();
            M[O].push(z), M[o.$insertAt](E + I, z), this._bindValue(z, W, x), this._setProperties(z, W), this._bindItems(z, W);
          }
        }
        _createOccurrences(v) {
          if (!this.emptyMerge) return;
          const { occur: h } = v;
          if (!h || h.initial <= 1) return;
          const x = v[o.$getParent](), _ = v[o.$nodeName];
          if (!(x[_] instanceof n.XFAObjectArray)) return;
          let M;
          M = v.name ? x[_].children.filter((I) => I.name === v.name).length : x[_].children.length;
          const O = x[o.$indexOf](v) + 1, E = h.initial - M;
          if (E) {
            const I = v[o.$clone]();
            I[o.$removeChild](I.occur), I.occur = null, x[_].push(I), x[o.$insertAt](O, I);
            for (let R = 1; R < E; R++) {
              const W = I[o.$clone]();
              x[_].push(W), x[o.$insertAt](O + R, W);
            }
          }
        }
        _getOccurInfo(v) {
          const { name: h, occur: x } = v;
          if (!x || !h) return [1, 1];
          const _ = x.max === -1 ? 1 / 0 : x.max;
          return [x.min, _];
        }
        _setAndBind(v, h) {
          this._setProperties(v, h), this._bindItems(v, h), this._bindElement(v, h);
        }
        _bindElement(v, h) {
          const x = [];
          this._createOccurrences(v);
          for (const _ of v[o.$getChildren]()) {
            if (_[o.$data]) continue;
            if (this._mergeMode === void 0 && _[o.$nodeName] === "subform") {
              this._mergeMode = _.mergeMode === "consumeData";
              const z = h[o.$getChildren]();
              if (z.length > 0) this._bindOccurrences(_, [z[0]], null);
              else if (this.emptyMerge) {
                const j = h[o.$namespaceId] === m ? -1 : h[o.$namespaceId], $ = _[o.$data] = new n.XmlObject(j, _.name || "root");
                h[o.$appendChild]($), this._bindElement(_, $);
              }
              continue;
            }
            if (!_[o.$isBindable]()) continue;
            let M = !1, O = null, E = null, I = null;
            if (_.bind) {
              switch (_.bind.match) {
                case "none":
                  this._setAndBind(_, h);
                  continue;
                case "global":
                  M = !0;
                  break;
                case "dataRef":
                  if (!_.bind.ref) {
                    (0, d.warn)(`XFA - ref is empty in node ${_[o.$nodeName]}.`), this._setAndBind(_, h);
                    continue;
                  }
                  E = _.bind.ref;
              }
              _.bind.picture && (O = _.bind.picture[o.$content]);
            }
            const [R, W] = this._getOccurInfo(_);
            if (E) {
              if (I = (0, p.searchNode)(this.root, h, E, !0, !1), I === null) {
                if (I = (0, p.createDataNode)(this.data, h, E), !I) continue;
                this._isConsumeData() && (I[o.$consumed] = !0), this._setAndBind(_, I);
                continue;
              }
              this._isConsumeData() && (I = I.filter((z) => !z[o.$consumed])), I.length > W ? I = I.slice(0, W) : I.length === 0 && (I = null), I && this._isConsumeData() && I.forEach((z) => {
                z[o.$consumed] = !0;
              });
            } else {
              if (!_.name) {
                this._setAndBind(_, h);
                continue;
              }
              if (this._isConsumeData()) {
                const z = [];
                for (; z.length < W; ) {
                  const j = this._findDataByNameToConsume(_.name, _[o.$hasSettableValue](), h, M);
                  if (!j) break;
                  j[o.$consumed] = !0, z.push(j);
                }
                I = z.length > 0 ? z : null;
              } else {
                if (I = h[o.$getRealChildrenByNameIt](_.name, !1, this.emptyMerge).next().value, !I) {
                  if (R === 0) {
                    x.push(_);
                    continue;
                  }
                  const z = h[o.$namespaceId] === m ? -1 : h[o.$namespaceId];
                  I = _[o.$data] = new n.XmlObject(z, _.name), this.emptyMerge && (I[o.$consumed] = !0), h[o.$appendChild](I), this._setAndBind(_, I);
                  continue;
                }
                this.emptyMerge && (I[o.$consumed] = !0), I = [I];
              }
            }
            I ? this._bindOccurrences(_, I, O) : R > 0 ? this._setAndBind(_, h) : x.push(_);
          }
          x.forEach((_) => _[o.$getParent]()[o.$removeChild](_));
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Value = l.Text = l.TemplateNamespace = l.Template = l.SetProperty = l.Items = l.Field = l.BindItems = void 0;
      var o = f(78), g = f(81), p = f(82), n = f(83), a = f(87), d = f(84), m = f(2), b = f(85), w = f(3), v = f(88);
      const h = g.NamespaceIds.template.id, x = "http://www.w3.org/2000/svg", _ = /^H(\d+)$/, M = /* @__PURE__ */ new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]), O = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
      function E(Ht) {
        if (!Ht || !Ht.border) return { w: 0, h: 0 };
        const P = Ht.border[o.$getExtra]();
        return P ? { w: P.widths[0] + P.widths[2] + P.insets[0] + P.insets[2], h: P.widths[1] + P.widths[3] + P.insets[1] + P.insets[3] } : { w: 0, h: 0 };
      }
      function I(Ht) {
        return Ht.margin && (Ht.margin.topInset || Ht.margin.rightInset || Ht.margin.bottomInset || Ht.margin.leftInset);
      }
      function R(Ht, P) {
        if (!Ht.value) {
          const At = new wo({});
          Ht[o.$appendChild](At), Ht.value = At;
        }
        Ht.value[o.$setValue](P);
      }
      function* W(Ht) {
        for (const P of Ht[o.$getChildren]()) P instanceof ya ? yield* P[o.$getContainedChildren]() : yield P;
      }
      function z(Ht) {
        var P;
        return ((P = Ht.validate) == null ? void 0 : P.nullTest) === "error";
      }
      function j(Ht) {
        for (; Ht; ) {
          if (!Ht.traversal) {
            Ht[o.$tabIndex] = Ht[o.$getParent]()[o.$tabIndex];
            return;
          }
          if (Ht[o.$tabIndex]) return;
          let P = null;
          for (const kt of Ht.traversal[o.$getChildren]()) if (kt.operation === "next") {
            P = kt;
            break;
          }
          if (!P || !P.ref) {
            Ht[o.$tabIndex] = Ht[o.$getParent]()[o.$tabIndex];
            return;
          }
          const At = Ht[o.$getTemplateRoot]();
          Ht[o.$tabIndex] = ++At[o.$tabIndex];
          const Vt = At[o.$searchNode](P.ref, Ht);
          if (!Vt) return;
          Ht = Vt[0];
        }
      }
      function $(Ht, P) {
        var Vt;
        const At = Ht.assist;
        if (At) {
          const kt = At[o.$toHTML]();
          kt && (P.title = kt);
          const ht = At.role.match(_);
          if (ht) {
            const Yt = "heading", be = ht[1];
            P.role = Yt, P["aria-level"] = be;
          }
        }
        if (Ht.layout === "table") P.role = "table";
        else if (Ht.layout === "row") P.role = "row";
        else {
          const kt = Ht[o.$getParent]();
          kt.layout === "row" && (P.role = ((Vt = kt.assist) == null ? void 0 : Vt.role) === "TH" ? "columnheader" : "cell");
        }
      }
      function B(Ht) {
        if (!Ht.assist) return null;
        const P = Ht.assist;
        return P.speak && P.speak[o.$content] !== "" ? P.speak[o.$content] : P.toolTip ? P.toolTip[o.$content] : null;
      }
      function C(Ht) {
        return d.HTMLResult.success({ name: "div", attributes: { class: ["xfaRich"], style: /* @__PURE__ */ Object.create(null) }, children: [{ name: "span", attributes: { style: /* @__PURE__ */ Object.create(null) }, value: Ht }] });
      }
      function T(Ht) {
        const P = Ht[o.$getTemplateRoot]();
        P[o.$extra].firstUnsplittable === null && (P[o.$extra].firstUnsplittable = Ht, P[o.$extra].noLayoutFailure = !0);
      }
      function F(Ht) {
        const P = Ht[o.$getTemplateRoot]();
        P[o.$extra].firstUnsplittable === Ht && (P[o.$extra].noLayoutFailure = !1);
      }
      function S(Ht) {
        if (Ht[o.$extra] || (Ht[o.$extra] = /* @__PURE__ */ Object.create(null), Ht.targetType === "auto")) return !1;
        const P = Ht[o.$getTemplateRoot]();
        let At = null;
        if (Ht.target) {
          if (At = P[o.$searchNode](Ht.target, Ht[o.$getParent]()), !At) return !1;
          At = At[0];
        }
        const { currentPageArea: Vt, currentContentArea: kt } = P[o.$extra];
        if (Ht.targetType === "pageArea")
          return At instanceof Jn || (At = null), Ht.startNew ? (Ht[o.$extra].target = At || Vt, !0) : At && At !== Vt ? (Ht[o.$extra].target = At, !0) : !1;
        At instanceof ot || (At = null);
        const ht = At && At[o.$getParent]();
        let Yt, be = ht;
        if (Ht.startNew) if (At) {
          const ke = ht.contentArea.children, je = ke.indexOf(kt), Ze = ke.indexOf(At);
          je !== -1 && je < Ze && (be = null), Yt = Ze - 1;
        } else Yt = Vt.contentArea.children.indexOf(kt);
        else {
          if (!At || At === kt) return !1;
          Yt = ht.contentArea.children.indexOf(At) - 1, be = ht === Vt ? null : ht;
        }
        return Ht[o.$extra].target = be, Ht[o.$extra].index = Yt, !0;
      }
      function A(Ht, P, At) {
        const Vt = Ht[o.$getTemplateRoot](), kt = Vt[o.$extra].noLayoutFailure, ht = P[o.$getSubformParent];
        P[o.$getSubformParent] = () => Ht, Vt[o.$extra].noLayoutFailure = !0;
        const Yt = P[o.$toHTML](At);
        Ht[o.$addHTML](Yt.html, Yt.bbox), Vt[o.$extra].noLayoutFailure = kt, P[o.$getSubformParent] = ht;
      }
      class U extends a.StringObject {
        constructor(P) {
          super(h, "appearanceFilter"), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class K extends a.XFAObject {
        constructor(P) {
          super(h, "arc", !0), this.circular = (0, d.getInteger)({ data: P.circular, defaultValue: 0, validate: (At) => At === 1 }), this.hand = (0, d.getStringOption)(P.hand, ["even", "left", "right"]), this.id = P.id || "", this.startAngle = (0, d.getFloat)({ data: P.startAngle, defaultValue: 0, validate: (At) => !0 }), this.sweepAngle = (0, d.getFloat)({ data: P.sweepAngle, defaultValue: 360, validate: (At) => !0 }), this.use = P.use || "", this.usehref = P.usehref || "", this.edge = null, this.fill = null;
        }
        [o.$toHTML]() {
          var be;
          const P = this.edge || new Ft({}), At = P[o.$toStyle](), Vt = /* @__PURE__ */ Object.create(null);
          ((be = this.fill) == null ? void 0 : be.presence) === "visible" ? Object.assign(Vt, this.fill[o.$toStyle]()) : Vt.fill = "transparent", Vt.strokeWidth = (0, n.measureToString)(P.presence === "visible" ? P.thickness : 0), Vt.stroke = At.color;
          let kt;
          const ht = { xmlns: x, style: { width: "100%", height: "100%", overflow: "visible" } };
          if (this.sweepAngle === 360) kt = { name: "ellipse", attributes: { xmlns: x, cx: "50%", cy: "50%", rx: "50%", ry: "50%", style: Vt } };
          else {
            const ke = this.startAngle * Math.PI / 180, je = this.sweepAngle * Math.PI / 180, Ze = this.sweepAngle > 180 ? 1 : 0, [xn, An, Ln, Gn] = [50 * (1 + Math.cos(ke)), 50 * (1 - Math.sin(ke)), 50 * (1 + Math.cos(ke + je)), 50 * (1 - Math.sin(ke + je))];
            kt = { name: "path", attributes: { xmlns: x, d: `M ${xn} ${An} A 50 50 0 ${Ze} 0 ${Ln} ${Gn}`, vectorEffect: "non-scaling-stroke", style: Vt } }, Object.assign(ht, { viewBox: "0 0 100 100", preserveAspectRatio: "none" });
          }
          const Yt = { name: "svg", children: [kt], attributes: ht };
          return I(this[o.$getParent]()[o.$getParent]()) ? d.HTMLResult.success({ name: "div", attributes: { style: { display: "inline", width: "100%", height: "100%" } }, children: [Yt] }) : (Yt.attributes.style.position = "absolute", d.HTMLResult.success(Yt));
        }
      }
      class X extends a.XFAObject {
        constructor(P) {
          super(h, "area", !0), this.colSpan = (0, d.getInteger)({ data: P.colSpan, defaultValue: 1, validate: (At) => At >= 1 || At === -1 }), this.id = P.id || "", this.name = P.name || "", this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.x = (0, d.getMeasurement)(P.x, "0pt"), this.y = (0, d.getMeasurement)(P.y, "0pt"), this.desc = null, this.extras = null, this.area = new a.XFAObjectArray(), this.draw = new a.XFAObjectArray(), this.exObject = new a.XFAObjectArray(), this.exclGroup = new a.XFAObjectArray(), this.field = new a.XFAObjectArray(), this.subform = new a.XFAObjectArray(), this.subformSet = new a.XFAObjectArray();
        }
        *[o.$getContainedChildren]() {
          yield* W(this);
        }
        [o.$isTransparent]() {
          return !0;
        }
        [o.$isBindable]() {
          return !0;
        }
        [o.$addHTML](P, At) {
          const [Vt, kt, ht, Yt] = At;
          this[o.$extra].width = Math.max(this[o.$extra].width, Vt + ht), this[o.$extra].height = Math.max(this[o.$extra].height, kt + Yt), this[o.$extra].children.push(P);
        }
        [o.$getAvailableSpace]() {
          return this[o.$extra].availableSpace;
        }
        [o.$toHTML](P) {
          const At = (0, n.toStyle)(this, "position"), Vt = { style: At, id: this[o.$uid], class: ["xfaArea"] };
          (0, n.isPrintOnly)(this) && Vt.class.push("xfaPrintOnly"), this.name && (Vt.xfaName = this.name);
          const kt = [];
          this[o.$extra] = { children: kt, width: 0, height: 0, availableSpace: P };
          const ht = this[o.$childrenToHTML]({ filter: /* @__PURE__ */ new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]), include: !0 });
          if (!ht.success)
            return ht.isBreak() ? ht : (delete this[o.$extra], d.HTMLResult.FAILURE);
          At.width = (0, n.measureToString)(this[o.$extra].width), At.height = (0, n.measureToString)(this[o.$extra].height);
          const Yt = { name: "div", attributes: Vt, children: kt }, be = [this.x, this.y, this[o.$extra].width, this[o.$extra].height];
          return delete this[o.$extra], d.HTMLResult.success(Yt, be);
        }
      }
      class L extends a.XFAObject {
        constructor(P) {
          super(h, "assist", !0), this.id = P.id || "", this.role = P.role || "", this.use = P.use || "", this.usehref = P.usehref || "", this.speak = null, this.toolTip = null;
        }
        [o.$toHTML]() {
          var P;
          return ((P = this.toolTip) == null ? void 0 : P[o.$content]) || null;
        }
      }
      class H extends a.XFAObject {
        constructor(P) {
          super(h, "barcode", !0), this.charEncoding = (0, d.getKeyword)({ data: P.charEncoding ? P.charEncoding.toLowerCase() : "", defaultValue: "", validate: (At) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(At) || At.match(/iso-8859-\d{2}/) }), this.checksum = (0, d.getStringOption)(P.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]), this.dataColumnCount = (0, d.getInteger)({ data: P.dataColumnCount, defaultValue: -1, validate: (At) => At >= 0 }), this.dataLength = (0, d.getInteger)({ data: P.dataLength, defaultValue: -1, validate: (At) => At >= 0 }), this.dataPrep = (0, d.getStringOption)(P.dataPrep, ["none", "flateCompress"]), this.dataRowCount = (0, d.getInteger)({ data: P.dataRowCount, defaultValue: -1, validate: (At) => At >= 0 }), this.endChar = P.endChar || "", this.errorCorrectionLevel = (0, d.getInteger)({ data: P.errorCorrectionLevel, defaultValue: -1, validate: (At) => At >= 0 && At <= 8 }), this.id = P.id || "", this.moduleHeight = (0, d.getMeasurement)(P.moduleHeight, "5mm"), this.moduleWidth = (0, d.getMeasurement)(P.moduleWidth, "0.25mm"), this.printCheckDigit = (0, d.getInteger)({ data: P.printCheckDigit, defaultValue: 0, validate: (At) => At === 1 }), this.rowColumnRatio = (0, d.getRatio)(P.rowColumnRatio), this.startChar = P.startChar || "", this.textLocation = (0, d.getStringOption)(P.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]), this.truncate = (0, d.getInteger)({ data: P.truncate, defaultValue: 0, validate: (At) => At === 1 }), this.type = (0, d.getStringOption)(P.type ? P.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]), this.upsMode = (0, d.getStringOption)(P.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]), this.use = P.use || "", this.usehref = P.usehref || "", this.wideNarrowRatio = (0, d.getRatio)(P.wideNarrowRatio), this.encrypt = null, this.extras = null;
        }
      }
      class Q extends a.XFAObject {
        constructor(P) {
          super(h, "bind", !0), this.match = (0, d.getStringOption)(P.match, ["once", "dataRef", "global", "none"]), this.ref = P.ref || "", this.picture = null;
        }
      }
      class N extends a.XFAObject {
        constructor(P) {
          super(h, "bindItems"), this.connection = P.connection || "", this.labelRef = P.labelRef || "", this.ref = P.ref || "", this.valueRef = P.valueRef || "";
        }
      }
      l.BindItems = N;
      class V extends a.XFAObject {
        constructor(P) {
          super(h, "bookend"), this.id = P.id || "", this.leader = P.leader || "", this.trailer = P.trailer || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Y extends a.Option01 {
        constructor(P) {
          super(h, "boolean"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$toHTML](P) {
          return C(this[o.$content] === 1 ? "1" : "0");
        }
      }
      class Z extends a.XFAObject {
        constructor(P) {
          super(h, "border", !0), this.break = (0, d.getStringOption)(P.break, ["close", "open"]), this.hand = (0, d.getStringOption)(P.hand, ["even", "left", "right"]), this.id = P.id || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.corner = new a.XFAObjectArray(4), this.edge = new a.XFAObjectArray(4), this.extras = null, this.fill = null, this.margin = null;
        }
        [o.$getExtra]() {
          if (!this[o.$extra]) {
            const P = this.edge.children.slice();
            if (P.length < 4) {
              const kt = P.at(-1) || new Ft({});
              for (let ht = P.length; ht < 4; ht++) P.push(kt);
            }
            const At = P.map((kt) => kt.thickness), Vt = [0, 0, 0, 0];
            this.margin && (Vt[0] = this.margin.topInset, Vt[1] = this.margin.rightInset, Vt[2] = this.margin.bottomInset, Vt[3] = this.margin.leftInset), this[o.$extra] = { widths: At, insets: Vt, edges: P };
          }
          return this[o.$extra];
        }
        [o.$toStyle]() {
          var kt;
          const { edges: P } = this[o.$getExtra](), At = P.map((ht) => {
            const Yt = ht[o.$toStyle]();
            return Yt.color || (Yt.color = "#000000"), Yt;
          }), Vt = /* @__PURE__ */ Object.create(null);
          if (this.margin && Object.assign(Vt, this.margin[o.$toStyle]()), ((kt = this.fill) == null ? void 0 : kt.presence) === "visible" && Object.assign(Vt, this.fill[o.$toStyle]()), this.corner.children.some((ht) => ht.radius !== 0)) {
            const ht = this.corner.children.map((Yt) => Yt[o.$toStyle]());
            if (ht.length === 2 || ht.length === 3) {
              const Yt = ht.at(-1);
              for (let be = ht.length; be < 4; be++) ht.push(Yt);
            }
            Vt.borderRadius = ht.map((Yt) => Yt.radius).join(" ");
          }
          switch (this.presence) {
            case "invisible":
            case "hidden":
              Vt.borderStyle = "";
              break;
            case "inactive":
              Vt.borderStyle = "none";
              break;
            default:
              Vt.borderStyle = At.map((ht) => ht.style).join(" ");
          }
          return Vt.borderWidth = At.map((ht) => ht.width).join(" "), Vt.borderColor = At.map((ht) => ht.color).join(" "), Vt;
        }
      }
      class rt extends a.XFAObject {
        constructor(P) {
          super(h, "break", !0), this.after = (0, d.getStringOption)(P.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.afterTarget = P.afterTarget || "", this.before = (0, d.getStringOption)(P.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.beforeTarget = P.beforeTarget || "", this.bookendLeader = P.bookendLeader || "", this.bookendTrailer = P.bookendTrailer || "", this.id = P.id || "", this.overflowLeader = P.overflowLeader || "", this.overflowTarget = P.overflowTarget || "", this.overflowTrailer = P.overflowTrailer || "", this.startNew = (0, d.getInteger)({ data: P.startNew, defaultValue: 0, validate: (At) => At === 1 }), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
      }
      class st extends a.XFAObject {
        constructor(P) {
          super(h, "breakAfter", !0), this.id = P.id || "", this.leader = P.leader || "", this.startNew = (0, d.getInteger)({ data: P.startNew, defaultValue: 0, validate: (At) => At === 1 }), this.target = P.target || "", this.targetType = (0, d.getStringOption)(P.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = P.trailer || "", this.use = P.use || "", this.usehref = P.usehref || "", this.script = null;
        }
      }
      class mt extends a.XFAObject {
        constructor(P) {
          super(h, "breakBefore", !0), this.id = P.id || "", this.leader = P.leader || "", this.startNew = (0, d.getInteger)({ data: P.startNew, defaultValue: 0, validate: (At) => At === 1 }), this.target = P.target || "", this.targetType = (0, d.getStringOption)(P.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = P.trailer || "", this.use = P.use || "", this.usehref = P.usehref || "", this.script = null;
        }
        [o.$toHTML](P) {
          return this[o.$extra] = {}, d.HTMLResult.FAILURE;
        }
      }
      class yt extends a.XFAObject {
        constructor(P) {
          super(h, "button", !0), this.highlight = (0, d.getStringOption)(P.highlight, ["inverted", "none", "outline", "push"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
        [o.$toHTML](P) {
          const At = this[o.$getParent]()[o.$getParent](), Vt = { name: "button", attributes: { id: this[o.$uid], class: ["xfaButton"], style: {} }, children: [] };
          for (const kt of At.event.children) {
            if (kt.activity !== "click" || !kt.script) continue;
            const ht = (0, w.recoverJsURL)(kt.script[o.$content]);
            if (!ht) continue;
            const Yt = (0, n.fixURL)(ht.url);
            Yt && Vt.children.push({ name: "a", attributes: { id: "link" + this[o.$uid], href: Yt, newWindow: ht.newWindow, class: ["xfaLink"], style: {} }, children: [] });
          }
          return d.HTMLResult.success(Vt);
        }
      }
      class at extends a.XFAObject {
        constructor(P) {
          super(h, "calculate", !0), this.id = P.id || "", this.override = (0, d.getStringOption)(P.override, ["disabled", "error", "ignore", "warning"]), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.message = null, this.script = null;
        }
      }
      class nt extends a.XFAObject {
        constructor(P) {
          super(h, "caption", !0), this.id = P.id || "", this.placement = (0, d.getStringOption)(P.placement, ["left", "bottom", "inline", "right", "top"]), this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.reserve = Math.ceil((0, d.getMeasurement)(P.reserve)), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.font = null, this.margin = null, this.para = null, this.value = null;
        }
        [o.$setValue](P) {
          R(this, P);
        }
        [o.$getExtra](P) {
          if (!this[o.$extra]) {
            let { width: At, height: Vt } = P;
            switch (this.placement) {
              case "left":
              case "right":
              case "inline":
                At = this.reserve <= 0 ? At : this.reserve;
                break;
              case "top":
              case "bottom":
                Vt = this.reserve <= 0 ? Vt : this.reserve;
            }
            this[o.$extra] = (0, n.layoutNode)(this, { width: At, height: Vt });
          }
          return this[o.$extra];
        }
        [o.$toHTML](P) {
          if (!this.value) return d.HTMLResult.EMPTY;
          this[o.$pushPara]();
          const At = this.value[o.$toHTML](P).html;
          if (!At)
            return this[o.$popPara](), d.HTMLResult.EMPTY;
          const Vt = this.reserve;
          if (this.reserve <= 0) {
            const { w: Yt, h: be } = this[o.$getExtra](P);
            switch (this.placement) {
              case "left":
              case "right":
              case "inline":
                this.reserve = Yt;
                break;
              case "top":
              case "bottom":
                this.reserve = be;
            }
          }
          const kt = [];
          typeof At == "string" ? kt.push({ name: "#text", value: At }) : kt.push(At);
          const ht = (0, n.toStyle)(this, "font", "margin", "visibility");
          switch (this.placement) {
            case "left":
            case "right":
              this.reserve > 0 && (ht.width = (0, n.measureToString)(this.reserve));
              break;
            case "top":
            case "bottom":
              this.reserve > 0 && (ht.height = (0, n.measureToString)(this.reserve));
          }
          return (0, n.setPara)(this, null, At), this[o.$popPara](), this.reserve = Vt, d.HTMLResult.success({ name: "div", attributes: { style: ht, class: ["xfaCaption"] }, children: kt });
        }
      }
      class q extends a.StringObject {
        constructor(P) {
          super(h, "certificate"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class D extends a.XFAObject {
        constructor(P) {
          super(h, "certificates", !0), this.credentialServerPolicy = (0, d.getStringOption)(P.credentialServerPolicy, ["optional", "required"]), this.id = P.id || "", this.url = P.url || "", this.urlPolicy = P.urlPolicy || "", this.use = P.use || "", this.usehref = P.usehref || "", this.encryption = null, this.issuers = null, this.keyUsage = null, this.oids = null, this.signing = null, this.subjectDNs = null;
        }
      }
      class G extends a.XFAObject {
        constructor(P) {
          super(h, "checkButton", !0), this.id = P.id || "", this.mark = (0, d.getStringOption)(P.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]), this.shape = (0, d.getStringOption)(P.shape, ["square", "round"]), this.size = (0, d.getMeasurement)(P.size, "10pt"), this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.extras = null, this.margin = null;
        }
        [o.$toHTML](P) {
          var $e, yr, fn;
          const At = (0, n.toStyle)("margin"), Vt = (0, n.measureToString)(this.size);
          At.width = At.height = Vt;
          let kt, ht, Yt;
          const be = this[o.$getParent]()[o.$getParent](), ke = be.items.children.length && be.items.children[0][o.$toHTML]().html || [], je = { on: (ke[0] !== void 0 ? ke[0] : "on").toString(), off: (ke[1] !== void 0 ? ke[1] : "off").toString() }, Ze = ((($e = be.value) == null ? void 0 : $e[o.$text]()) || "off") === je.on || void 0, xn = be[o.$getSubformParent](), An = be[o.$uid];
          let Ln;
          xn instanceof Oe ? (Yt = xn[o.$uid], kt = "radio", ht = "xfaRadio", Ln = ((yr = xn[o.$data]) == null ? void 0 : yr[o.$uid]) || xn[o.$uid]) : (kt = "checkbox", ht = "xfaCheckbox", Ln = ((fn = be[o.$data]) == null ? void 0 : fn[o.$uid]) || be[o.$uid]);
          const Gn = { name: "input", attributes: { class: [ht], style: At, fieldId: An, dataId: Ln, type: kt, checked: Ze, xfaOn: je.on, xfaOff: je.off, "aria-label": B(be), "aria-required": !1 } };
          return Yt && (Gn.attributes.name = Yt), z(be) && (Gn.attributes["aria-required"] = !0, Gn.attributes.required = !0), d.HTMLResult.success({ name: "label", attributes: { class: ["xfaLabel"] }, children: [Gn] });
        }
      }
      class et extends a.XFAObject {
        constructor(P) {
          super(h, "choiceList", !0), this.commitOn = (0, d.getStringOption)(P.commitOn, ["select", "exit"]), this.id = P.id || "", this.open = (0, d.getStringOption)(P.open, ["userControl", "always", "multiSelect", "onEntry"]), this.textEntry = (0, d.getInteger)({ data: P.textEntry, defaultValue: 0, validate: (At) => At === 1 }), this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.extras = null, this.margin = null;
        }
        [o.$toHTML](P) {
          var be, ke, je;
          const At = (0, n.toStyle)(this, "border", "margin"), Vt = this[o.$getParent]()[o.$getParent](), kt = { fontSize: `calc(${((be = Vt.font) == null ? void 0 : be.size) || 10}px * var(--scale-factor))` }, ht = [];
          if (Vt.items.children.length > 0) {
            const Ze = Vt.items;
            let xn = 0, An = 0;
            Ze.children.length === 2 && (xn = Ze.children[0].save, An = 1 - xn);
            const Ln = Ze.children[xn][o.$toHTML]().html, Gn = Ze.children[An][o.$toHTML]().html;
            let $e = !1;
            const yr = ((ke = Vt.value) == null ? void 0 : ke[o.$text]()) || "";
            for (let fn = 0, qi = Ln.length; fn < qi; fn++) {
              const Xr = { name: "option", attributes: { value: Gn[fn] || Ln[fn], style: kt }, value: Ln[fn] };
              Gn[fn] === yr && (Xr.attributes.selected = $e = !0), ht.push(Xr);
            }
            $e || ht.splice(0, 0, { name: "option", attributes: { hidden: !0, selected: !0 }, value: " " });
          }
          const Yt = { class: ["xfaSelect"], fieldId: Vt[o.$uid], dataId: ((je = Vt[o.$data]) == null ? void 0 : je[o.$uid]) || Vt[o.$uid], style: At, "aria-label": B(Vt), "aria-required": !1 };
          return z(Vt) && (Yt["aria-required"] = !0, Yt.required = !0), this.open === "multiSelect" && (Yt.multiple = !0), d.HTMLResult.success({ name: "label", attributes: { class: ["xfaLabel"] }, children: [{ name: "select", children: ht, attributes: Yt }] });
        }
      }
      class J extends a.XFAObject {
        constructor(P) {
          super(h, "color", !0), this.cSpace = (0, d.getStringOption)(P.cSpace, ["SRGB"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.value = P.value ? (0, d.getColor)(P.value) : "", this.extras = null;
        }
        [o.$hasSettableValue]() {
          return !1;
        }
        [o.$toStyle]() {
          return this.value ? m.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
        }
      }
      class it extends a.XFAObject {
        constructor(P) {
          super(h, "comb"), this.id = P.id || "", this.numberOfCells = (0, d.getInteger)({ data: P.numberOfCells, defaultValue: 0, validate: (At) => At >= 0 }), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class lt extends a.XFAObject {
        constructor(P) {
          super(h, "connect", !0), this.connection = P.connection || "", this.id = P.id || "", this.ref = P.ref || "", this.usage = (0, d.getStringOption)(P.usage, ["exportAndImport", "exportOnly", "importOnly"]), this.use = P.use || "", this.usehref = P.usehref || "", this.picture = null;
        }
      }
      class ot extends a.XFAObject {
        constructor(P) {
          super(h, "contentArea", !0), this.h = (0, d.getMeasurement)(P.h), this.id = P.id || "", this.name = P.name || "", this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.w = (0, d.getMeasurement)(P.w), this.x = (0, d.getMeasurement)(P.x, "0pt"), this.y = (0, d.getMeasurement)(P.y, "0pt"), this.desc = null, this.extras = null;
        }
        [o.$toHTML](P) {
          const At = { left: (0, n.measureToString)(this.x), top: (0, n.measureToString)(this.y), width: (0, n.measureToString)(this.w), height: (0, n.measureToString)(this.h) }, Vt = ["xfaContentarea"];
          return (0, n.isPrintOnly)(this) && Vt.push("xfaPrintOnly"), d.HTMLResult.success({ name: "div", children: [], attributes: { style: At, class: Vt, id: this[o.$uid] } });
        }
      }
      class ut extends a.XFAObject {
        constructor(P) {
          super(h, "corner", !0), this.id = P.id || "", this.inverted = (0, d.getInteger)({ data: P.inverted, defaultValue: 0, validate: (At) => At === 1 }), this.join = (0, d.getStringOption)(P.join, ["square", "round"]), this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.radius = (0, d.getMeasurement)(P.radius), this.stroke = (0, d.getStringOption)(P.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, d.getMeasurement)(P.thickness, "0.5pt"), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null;
        }
        [o.$toStyle]() {
          const P = (0, n.toStyle)(this, "visibility");
          return P.radius = (0, n.measureToString)(this.join === "square" ? 0 : this.radius), P;
        }
      }
      class ct extends a.ContentObject {
        constructor(P) {
          super(h, "date"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          const P = this[o.$content].trim();
          this[o.$content] = P ? new Date(P) : null;
        }
        [o.$toHTML](P) {
          return C(this[o.$content] ? this[o.$content].toString() : "");
        }
      }
      class gt extends a.ContentObject {
        constructor(P) {
          super(h, "dateTime"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          const P = this[o.$content].trim();
          this[o.$content] = P ? new Date(P) : null;
        }
        [o.$toHTML](P) {
          return C(this[o.$content] ? this[o.$content].toString() : "");
        }
      }
      class dt extends a.XFAObject {
        constructor(P) {
          super(h, "dateTimeEdit", !0), this.hScrollPolicy = (0, d.getStringOption)(P.hScrollPolicy, ["auto", "off", "on"]), this.id = P.id || "", this.picker = (0, d.getStringOption)(P.picker, ["host", "none"]), this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
        }
        [o.$toHTML](P) {
          var ht;
          const At = (0, n.toStyle)(this, "border", "font", "margin"), Vt = this[o.$getParent]()[o.$getParent](), kt = { name: "input", attributes: { type: "text", fieldId: Vt[o.$uid], dataId: ((ht = Vt[o.$data]) == null ? void 0 : ht[o.$uid]) || Vt[o.$uid], class: ["xfaTextfield"], style: At, "aria-label": B(Vt), "aria-required": !1 } };
          return z(Vt) && (kt.attributes["aria-required"] = !0, kt.attributes.required = !0), d.HTMLResult.success({ name: "label", attributes: { class: ["xfaLabel"] }, children: [kt] });
        }
      }
      class bt extends a.ContentObject {
        constructor(P) {
          super(h, "decimal"), this.fracDigits = (0, d.getInteger)({ data: P.fracDigits, defaultValue: 2, validate: (At) => !0 }), this.id = P.id || "", this.leadDigits = (0, d.getInteger)({ data: P.leadDigits, defaultValue: -1, validate: (At) => !0 }), this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          const P = parseFloat(this[o.$content].trim());
          this[o.$content] = isNaN(P) ? null : P;
        }
        [o.$toHTML](P) {
          return C(this[o.$content] !== null ? this[o.$content].toString() : "");
        }
      }
      class vt extends a.XFAObject {
        constructor(P) {
          super(h, "defaultUi", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
      }
      class xt extends a.XFAObject {
        constructor(P) {
          super(h, "desc", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.boolean = new a.XFAObjectArray(), this.date = new a.XFAObjectArray(), this.dateTime = new a.XFAObjectArray(), this.decimal = new a.XFAObjectArray(), this.exData = new a.XFAObjectArray(), this.float = new a.XFAObjectArray(), this.image = new a.XFAObjectArray(), this.integer = new a.XFAObjectArray(), this.text = new a.XFAObjectArray(), this.time = new a.XFAObjectArray();
        }
      }
      class St extends a.OptionObject {
        constructor(P) {
          super(h, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Mt extends a.XFAObject {
        constructor(P) {
          super(h, "digestMethods", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.digestMethod = new a.XFAObjectArray();
        }
      }
      class Et extends a.XFAObject {
        constructor(P) {
          super(h, "draw", !0), this.anchorType = (0, d.getStringOption)(P.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, d.getInteger)({ data: P.colSpan, defaultValue: 1, validate: (At) => At >= 1 || At === -1 }), this.h = P.h ? (0, d.getMeasurement)(P.h) : "", this.hAlign = (0, d.getStringOption)(P.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = P.id || "", this.locale = P.locale || "", this.maxH = (0, d.getMeasurement)(P.maxH, "0pt"), this.maxW = (0, d.getMeasurement)(P.maxW, "0pt"), this.minH = (0, d.getMeasurement)(P.minH, "0pt"), this.minW = (0, d.getMeasurement)(P.minW, "0pt"), this.name = P.name || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, d.getRelevant)(P.relevant), this.rotate = (0, d.getInteger)({ data: P.rotate, defaultValue: 0, validate: (At) => At % 90 == 0 }), this.use = P.use || "", this.usehref = P.usehref || "", this.w = P.w ? (0, d.getMeasurement)(P.w) : "", this.x = (0, d.getMeasurement)(P.x, "0pt"), this.y = (0, d.getMeasurement)(P.y, "0pt"), this.assist = null, this.border = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.value = null, this.setProperty = new a.XFAObjectArray();
        }
        [o.$setValue](P) {
          R(this, P);
        }
        [o.$toHTML](P) {
          if (j(this), this.presence === "hidden" || this.presence === "inactive") return d.HTMLResult.EMPTY;
          (0, n.fixDimensions)(this), this[o.$pushPara]();
          const At = this.w, Vt = this.h, { w: kt, h: ht, isBroken: Yt } = (0, n.layoutNode)(this, P);
          if (kt && this.w === "") {
            if (Yt && this[o.$getSubformParent]()[o.$isThereMoreWidth]())
              return this[o.$popPara](), d.HTMLResult.FAILURE;
            this.w = kt;
          }
          if (ht && this.h === "" && (this.h = ht), T(this), !(0, p.checkDimensions)(this, P))
            return this.w = At, this.h = Vt, this[o.$popPara](), d.HTMLResult.FAILURE;
          F(this);
          const be = (0, n.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
          (0, n.setMinMaxDimensions)(this, be), be.margin && (be.padding = be.margin, delete be.margin);
          const ke = ["xfaDraw"];
          this.font && ke.push("xfaFont"), (0, n.isPrintOnly)(this) && ke.push("xfaPrintOnly");
          const je = { style: be, id: this[o.$uid], class: ke };
          this.name && (je.xfaName = this.name);
          const Ze = { name: "div", attributes: je, children: [] };
          $(this, je);
          const xn = (0, n.computeBbox)(this, Ze, P), An = this.value ? this.value[o.$toHTML](P).html : null;
          return An === null ? (this.w = At, this.h = Vt, this[o.$popPara](), d.HTMLResult.success((0, n.createWrapper)(this, Ze), xn)) : (Ze.children.push(An), (0, n.setPara)(this, be, An), this.w = At, this.h = Vt, this[o.$popPara](), d.HTMLResult.success((0, n.createWrapper)(this, Ze), xn));
        }
      }
      class Ft extends a.XFAObject {
        constructor(P) {
          super(h, "edge", !0), this.cap = (0, d.getStringOption)(P.cap, ["square", "butt", "round"]), this.id = P.id || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.stroke = (0, d.getStringOption)(P.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, d.getMeasurement)(P.thickness, "0.5pt"), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null;
        }
        [o.$toStyle]() {
          const P = (0, n.toStyle)(this, "visibility");
          if (Object.assign(P, { linecap: this.cap, width: (0, n.measureToString)(this.thickness), color: this.color ? this.color[o.$toStyle]() : "#000000", style: "" }), this.presence !== "visible") P.style = "none";
          else switch (this.stroke) {
            case "solid":
              P.style = "solid";
              break;
            case "dashDot":
            case "dashDotDot":
            case "dashed":
              P.style = "dashed";
              break;
            case "dotted":
              P.style = "dotted";
              break;
            case "embossed":
              P.style = "ridge";
              break;
            case "etched":
              P.style = "groove";
              break;
            case "lowered":
              P.style = "inset";
              break;
            case "raised":
              P.style = "outset";
          }
          return P;
        }
      }
      class Wt extends a.OptionObject {
        constructor(P) {
          super(h, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Kt extends a.XFAObject {
        constructor(P) {
          super(h, "encodings", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.encoding = new a.XFAObjectArray();
        }
      }
      class qt extends a.XFAObject {
        constructor(P) {
          super(h, "encrypt", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.certificate = null;
        }
      }
      class It extends a.XFAObject {
        constructor(P) {
          super(h, "encryptData", !0), this.id = P.id || "", this.operation = (0, d.getStringOption)(P.operation, ["encrypt", "decrypt"]), this.target = P.target || "", this.use = P.use || "", this.usehref = P.usehref || "", this.filter = null, this.manifest = null;
        }
      }
      class re extends a.XFAObject {
        constructor(P) {
          super(h, "encryption", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.certificate = new a.XFAObjectArray();
        }
      }
      class le extends a.OptionObject {
        constructor(P) {
          super(h, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Ce extends a.XFAObject {
        constructor(P) {
          super(h, "encryptionMethods", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.encryptionMethod = new a.XFAObjectArray();
        }
      }
      class ce extends a.XFAObject {
        constructor(P) {
          super(h, "event", !0), this.activity = (0, d.getStringOption)(P.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]), this.id = P.id || "", this.listen = (0, d.getStringOption)(P.listen, ["refOnly", "refAndDescendents"]), this.name = P.name || "", this.ref = P.ref || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.encryptData = null, this.execute = null, this.script = null, this.signData = null, this.submit = null;
        }
      }
      class xe extends a.ContentObject {
        constructor(P) {
          super(h, "exData"), this.contentType = P.contentType || "", this.href = P.href || "", this.id = P.id || "", this.maxLength = (0, d.getInteger)({ data: P.maxLength, defaultValue: -1, validate: (At) => At >= -1 }), this.name = P.name || "", this.rid = P.rid || "", this.transferEncoding = (0, d.getStringOption)(P.transferEncoding, ["none", "base64", "package"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$isCDATAXml]() {
          return this.contentType === "text/html";
        }
        [o.$onChild](P) {
          return this.contentType === "text/html" && P[o.$namespaceId] === g.NamespaceIds.xhtml.id ? (this[o.$content] = P, !0) : this.contentType === "text/xml" ? (this[o.$content] = P, !0) : !1;
        }
        [o.$toHTML](P) {
          return this.contentType === "text/html" && this[o.$content] ? this[o.$content][o.$toHTML](P) : d.HTMLResult.EMPTY;
        }
      }
      class ve extends a.XFAObject {
        constructor(P) {
          super(h, "exObject", !0), this.archive = P.archive || "", this.classId = P.classId || "", this.codeBase = P.codeBase || "", this.codeType = P.codeType || "", this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.boolean = new a.XFAObjectArray(), this.date = new a.XFAObjectArray(), this.dateTime = new a.XFAObjectArray(), this.decimal = new a.XFAObjectArray(), this.exData = new a.XFAObjectArray(), this.exObject = new a.XFAObjectArray(), this.float = new a.XFAObjectArray(), this.image = new a.XFAObjectArray(), this.integer = new a.XFAObjectArray(), this.text = new a.XFAObjectArray(), this.time = new a.XFAObjectArray();
        }
      }
      class Oe extends a.XFAObject {
        constructor(P) {
          super(h, "exclGroup", !0), this.access = (0, d.getStringOption)(P.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = P.accessKey || "", this.anchorType = (0, d.getStringOption)(P.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, d.getInteger)({ data: P.colSpan, defaultValue: 1, validate: (At) => At >= 1 || At === -1 }), this.h = P.h ? (0, d.getMeasurement)(P.h) : "", this.hAlign = (0, d.getStringOption)(P.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = P.id || "", this.layout = (0, d.getStringOption)(P.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.maxH = (0, d.getMeasurement)(P.maxH, "0pt"), this.maxW = (0, d.getMeasurement)(P.maxW, "0pt"), this.minH = (0, d.getMeasurement)(P.minH, "0pt"), this.minW = (0, d.getMeasurement)(P.minW, "0pt"), this.name = P.name || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.w = P.w ? (0, d.getMeasurement)(P.w) : "", this.x = (0, d.getMeasurement)(P.x, "0pt"), this.y = (0, d.getMeasurement)(P.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.margin = null, this.para = null, this.traversal = null, this.validate = null, this.connect = new a.XFAObjectArray(), this.event = new a.XFAObjectArray(), this.field = new a.XFAObjectArray(), this.setProperty = new a.XFAObjectArray();
        }
        [o.$isBindable]() {
          return !0;
        }
        [o.$hasSettableValue]() {
          return !0;
        }
        [o.$setValue](P) {
          for (const At of this.field.children) {
            if (!At.value) {
              const Vt = new wo({});
              At[o.$appendChild](Vt), At.value = Vt;
            }
            At.value[o.$setValue](P);
          }
        }
        [o.$isThereMoreWidth]() {
          return this.layout.endsWith("-tb") && this[o.$extra].attempt === 0 && this[o.$extra].numberInLine > 0 || this[o.$getParent]()[o.$isThereMoreWidth]();
        }
        [o.$isSplittable]() {
          var At;
          const P = this[o.$getSubformParent]();
          return P[o.$isSplittable]() ? this[o.$extra]._isSplittable !== void 0 ? this[o.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[o.$extra]._isSplittable = !1, !1) : (At = P.layout) != null && At.endsWith("-tb") && P[o.$extra].numberInLine !== 0 ? !1 : (this[o.$extra]._isSplittable = !0, !0) : !1;
        }
        [o.$flushHTML]() {
          return (0, p.flushHTML)(this);
        }
        [o.$addHTML](P, At) {
          (0, p.addHTML)(this, P, At);
        }
        [o.$getAvailableSpace]() {
          return (0, p.getAvailableSpace)(this);
        }
        [o.$toHTML](P) {
          if (j(this), this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return d.HTMLResult.EMPTY;
          (0, n.fixDimensions)(this);
          const At = [], Vt = { id: this[o.$uid], class: [] };
          (0, n.setAccess)(this, Vt.class), this[o.$extra] || (this[o.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[o.$extra], { children: At, attributes: Vt, attempt: 0, line: null, numberInLine: 0, availableSpace: { width: Math.min(this.w || 1 / 0, P.width), height: Math.min(this.h || 1 / 0, P.height) }, width: 0, height: 0, prevHeight: 0, currentWidth: 0 });
          const kt = this[o.$isSplittable]();
          if (kt || T(this), !(0, p.checkDimensions)(this, P)) return d.HTMLResult.FAILURE;
          const ht = /* @__PURE__ */ new Set(["field"]);
          if (this.layout.includes("row")) {
            const fn = this[o.$getSubformParent]().columnWidths;
            Array.isArray(fn) && fn.length > 0 && (this[o.$extra].columnWidths = fn, this[o.$extra].currentColumn = 0);
          }
          const Yt = (0, n.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), be = ["xfaExclgroup"], ke = (0, n.layoutClass)(this);
          ke && be.push(ke), (0, n.isPrintOnly)(this) && be.push("xfaPrintOnly"), Vt.style = Yt, Vt.class = be, this.name && (Vt.xfaName = this.name), this[o.$pushPara]();
          const je = this.layout === "lr-tb" || this.layout === "rl-tb", Ze = je ? 2 : 1;
          for (; this[o.$extra].attempt < Ze; this[o.$extra].attempt++) {
            je && this[o.$extra].attempt === 1 && (this[o.$extra].numberInLine = 0);
            const fn = this[o.$childrenToHTML]({ filter: ht, include: !0 });
            if (fn.success) break;
            if (fn.isBreak())
              return this[o.$popPara](), fn;
            if (je && this[o.$extra].attempt === 0 && this[o.$extra].numberInLine === 0 && !this[o.$getTemplateRoot]()[o.$extra].noLayoutFailure) {
              this[o.$extra].attempt = Ze;
              break;
            }
          }
          if (this[o.$popPara](), kt || F(this), this[o.$extra].attempt === Ze)
            return kt || delete this[o.$extra], d.HTMLResult.FAILURE;
          let xn = 0, An = 0;
          this.margin && (xn = this.margin.leftInset + this.margin.rightInset, An = this.margin.topInset + this.margin.bottomInset);
          const Ln = Math.max(this[o.$extra].width + xn, this.w || 0), Gn = Math.max(this[o.$extra].height + An, this.h || 0), $e = [this.x, this.y, Ln, Gn];
          this.w === "" && (Yt.width = (0, n.measureToString)(Ln)), this.h === "" && (Yt.height = (0, n.measureToString)(Gn));
          const yr = { name: "div", attributes: Vt, children: At };
          return $(this, Vt), delete this[o.$extra], d.HTMLResult.success((0, n.createWrapper)(this, yr), $e);
        }
      }
      class He extends a.XFAObject {
        constructor(P) {
          super(h, "execute"), this.connection = P.connection || "", this.executeType = (0, d.getStringOption)(P.executeType, ["import", "remerge"]), this.id = P.id || "", this.runAt = (0, d.getStringOption)(P.runAt, ["client", "both", "server"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Zt extends a.XFAObject {
        constructor(P) {
          super(h, "extras", !0), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "", this.boolean = new a.XFAObjectArray(), this.date = new a.XFAObjectArray(), this.dateTime = new a.XFAObjectArray(), this.decimal = new a.XFAObjectArray(), this.exData = new a.XFAObjectArray(), this.extras = new a.XFAObjectArray(), this.float = new a.XFAObjectArray(), this.image = new a.XFAObjectArray(), this.integer = new a.XFAObjectArray(), this.text = new a.XFAObjectArray(), this.time = new a.XFAObjectArray();
        }
      }
      class Xt extends a.XFAObject {
        constructor(P) {
          super(h, "field", !0), this.access = (0, d.getStringOption)(P.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = P.accessKey || "", this.anchorType = (0, d.getStringOption)(P.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, d.getInteger)({ data: P.colSpan, defaultValue: 1, validate: (At) => At >= 1 || At === -1 }), this.h = P.h ? (0, d.getMeasurement)(P.h) : "", this.hAlign = (0, d.getStringOption)(P.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = P.id || "", this.locale = P.locale || "", this.maxH = (0, d.getMeasurement)(P.maxH, "0pt"), this.maxW = (0, d.getMeasurement)(P.maxW, "0pt"), this.minH = (0, d.getMeasurement)(P.minH, "0pt"), this.minW = (0, d.getMeasurement)(P.minW, "0pt"), this.name = P.name || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, d.getRelevant)(P.relevant), this.rotate = (0, d.getInteger)({ data: P.rotate, defaultValue: 0, validate: (At) => At % 90 == 0 }), this.use = P.use || "", this.usehref = P.usehref || "", this.w = P.w ? (0, d.getMeasurement)(P.w) : "", this.x = (0, d.getMeasurement)(P.x, "0pt"), this.y = (0, d.getMeasurement)(P.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.format = null, this.items = new a.XFAObjectArray(2), this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.validate = null, this.value = null, this.bindItems = new a.XFAObjectArray(), this.connect = new a.XFAObjectArray(), this.event = new a.XFAObjectArray(), this.setProperty = new a.XFAObjectArray();
        }
        [o.$isBindable]() {
          return !0;
        }
        [o.$setValue](P) {
          R(this, P);
        }
        [o.$toHTML](P) {
          var fn, qi, Xr;
          if (j(this), !this.ui) {
            this.ui = new Ml({}), this.ui[o.$globalData] = this[o.$globalData], this[o.$appendChild](this.ui);
            let ze;
            switch (this.items.children.length) {
              case 0:
                ze = new Tl({}), this.ui.textEdit = ze;
                break;
              case 1:
                ze = new G({}), this.ui.checkButton = ze;
                break;
              case 2:
                ze = new et({}), this.ui.choiceList = ze;
            }
            this.ui[o.$appendChild](ze);
          }
          if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return d.HTMLResult.EMPTY;
          this.caption && delete this.caption[o.$extra], this[o.$pushPara]();
          const At = this.caption ? this.caption[o.$toHTML](P).html : null, Vt = this.w, kt = this.h;
          let ht = 0, Yt = 0;
          this.margin && (ht = this.margin.leftInset + this.margin.rightInset, Yt = this.margin.topInset + this.margin.bottomInset);
          let be = null;
          if (this.w === "" || this.h === "") {
            let ze = null, Me = null, Ei = 0, gi = 0;
            if (this.ui.checkButton) Ei = gi = this.ui.checkButton.size;
            else {
              const { w: Ha, h: Wi } = (0, n.layoutNode)(this, P);
              Ha !== null ? (Ei = Ha, gi = Wi) : gi = (0, b.getMetrics)(this.font, !0).lineNoGap;
            }
            if (be = E(this.ui[o.$getExtra]()), Ei += be.w, gi += be.h, this.caption) {
              const { w: Ha, h: Wi, isBroken: br } = this.caption[o.$getExtra](P);
              if (br && this[o.$getSubformParent]()[o.$isThereMoreWidth]())
                return this[o.$popPara](), d.HTMLResult.FAILURE;
              switch (ze = Ha, Me = Wi, this.caption.placement) {
                case "left":
                case "right":
                case "inline":
                  ze += Ei;
                  break;
                case "top":
                case "bottom":
                  Me += gi;
              }
            } else
              ze = Ei, Me = gi;
            ze && this.w === "" && (ze += ht, this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < ze ? ze : this.minW)), Me && this.h === "" && (Me += Yt, this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < Me ? Me : this.minH));
          }
          if (this[o.$popPara](), (0, n.fixDimensions)(this), T(this), !(0, p.checkDimensions)(this, P))
            return this.w = Vt, this.h = kt, this[o.$popPara](), d.HTMLResult.FAILURE;
          F(this);
          const ke = (0, n.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
          (0, n.setMinMaxDimensions)(this, ke);
          const je = ["xfaField"];
          this.font && je.push("xfaFont"), (0, n.isPrintOnly)(this) && je.push("xfaPrintOnly");
          const Ze = { style: ke, id: this[o.$uid], class: je };
          ke.margin && (ke.padding = ke.margin, delete ke.margin), (0, n.setAccess)(this, je), this.name && (Ze.xfaName = this.name);
          const xn = [], An = { name: "div", attributes: Ze, children: xn };
          $(this, Ze);
          const Ln = this.border ? this.border[o.$toStyle]() : null, Gn = (0, n.computeBbox)(this, An, P), $e = this.ui[o.$toHTML]().html;
          if (!$e)
            return Object.assign(ke, Ln), d.HTMLResult.success((0, n.createWrapper)(this, An), Gn);
          this[o.$tabIndex] && ((fn = $e.children) != null && fn[0] ? $e.children[0].attributes.tabindex = this[o.$tabIndex] : $e.attributes.tabindex = this[o.$tabIndex]), $e.attributes.style || ($e.attributes.style = /* @__PURE__ */ Object.create(null));
          let yr = null;
          if (this.ui.button ? ($e.children.length === 1 && ([yr] = $e.children.splice(0, 1)), Object.assign($e.attributes.style, Ln)) : Object.assign(ke, Ln), xn.push($e), this.value) {
            if (this.ui.imageEdit) $e.children.push(this.value[o.$toHTML]().html);
            else if (!this.ui.button) {
              let ze = "";
              if (this.value.exData) ze = this.value.exData[o.$text]();
              else if (this.value.text) ze = this.value.text[o.$getExtra]();
              else {
                const Me = this.value[o.$toHTML]().html;
                Me !== null && (ze = Me.children[0].value);
              }
              this.ui.textEdit && ((qi = this.value.text) != null && qi.maxChars) && ($e.children[0].attributes.maxLength = this.value.text.maxChars), ze && (this.ui.numericEdit && (ze = parseFloat(ze), ze = isNaN(ze) ? "" : ze.toString()), $e.children[0].name === "textarea" ? $e.children[0].attributes.textContent = ze : $e.children[0].attributes.value = ze);
            }
          }
          if (!this.ui.imageEdit && ((Xr = $e.children) != null && Xr[0]) && this.h) {
            be = be || E(this.ui[o.$getExtra]());
            let ze = 0;
            if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
              ze = this.caption.reserve, ze <= 0 && (ze = this.caption[o.$getExtra](P).h);
              const Me = this.h - ze - Yt - be.h;
              $e.children[0].attributes.style.height = (0, n.measureToString)(Me);
            } else $e.children[0].attributes.style.height = "100%";
          }
          if (yr && $e.children.push(yr), !At)
            return $e.attributes.class && $e.attributes.class.push("xfaLeft"), this.w = Vt, this.h = kt, d.HTMLResult.success((0, n.createWrapper)(this, An), Gn);
          if (this.ui.button)
            return ke.padding && delete ke.padding, At.name === "div" && (At.name = "span"), $e.children.push(At), d.HTMLResult.success(An, Gn);
          switch (this.ui.checkButton && (At.attributes.class[0] = "xfaCaptionForCheckButton"), $e.attributes.class || ($e.attributes.class = []), $e.children.splice(0, 0, At), this.caption.placement) {
            case "left":
            case "inline":
              $e.attributes.class.push("xfaLeft");
              break;
            case "right":
              $e.attributes.class.push("xfaRight");
              break;
            case "top":
              $e.attributes.class.push("xfaTop");
              break;
            case "bottom":
              $e.attributes.class.push("xfaBottom");
          }
          return this.w = Vt, this.h = kt, d.HTMLResult.success((0, n.createWrapper)(this, An), Gn);
        }
      }
      l.Field = Xt;
      class Gt extends a.XFAObject {
        constructor(P) {
          super(h, "fill", !0), this.id = P.id || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null, this.linear = null, this.pattern = null, this.radial = null, this.solid = null, this.stipple = null;
        }
        [o.$toStyle]() {
          var Yt;
          const P = this[o.$getParent](), At = P[o.$getParent]()[o.$getParent](), Vt = /* @__PURE__ */ Object.create(null);
          let kt = "color", ht = kt;
          P instanceof Z && (kt = "background-color", ht = "background", At instanceof Ml && (Vt.backgroundColor = "white")), (P instanceof Al || P instanceof K) && (kt = ht = "fill", Vt.fill = "white");
          for (const be of Object.getOwnPropertyNames(this)) {
            if (be === "extras" || be === "color") continue;
            const ke = this[be];
            if (!(ke instanceof a.XFAObject)) continue;
            const je = ke[o.$toStyle](this.color);
            return je && (Vt[je.startsWith("#") ? kt : ht] = je), Vt;
          }
          if ((Yt = this.color) != null && Yt.value) {
            const be = this.color[o.$toStyle]();
            Vt[be.startsWith("#") ? kt : ht] = be;
          }
          return Vt;
        }
      }
      class Lt extends a.XFAObject {
        constructor(P) {
          super(h, "filter", !0), this.addRevocationInfo = (0, d.getStringOption)(P.addRevocationInfo, ["", "required", "optional", "none"]), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "", this.version = (0, d.getInteger)({ data: this.version, defaultValue: 5, validate: (At) => At >= 1 && At <= 5 }), this.appearanceFilter = null, this.certificates = null, this.digestMethods = null, this.encodings = null, this.encryptionMethods = null, this.handler = null, this.lockDocument = null, this.mdp = null, this.reasons = null, this.timeStamp = null;
        }
      }
      class Dt extends a.ContentObject {
        constructor(P) {
          super(h, "float"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          const P = parseFloat(this[o.$content].trim());
          this[o.$content] = isNaN(P) ? null : P;
        }
        [o.$toHTML](P) {
          return C(this[o.$content] !== null ? this[o.$content].toString() : "");
        }
      }
      class jt extends a.XFAObject {
        constructor(P) {
          super(h, "font", !0), this.baselineShift = (0, d.getMeasurement)(P.baselineShift), this.fontHorizontalScale = (0, d.getFloat)({ data: P.fontHorizontalScale, defaultValue: 100, validate: (At) => At >= 0 }), this.fontVerticalScale = (0, d.getFloat)({ data: P.fontVerticalScale, defaultValue: 100, validate: (At) => At >= 0 }), this.id = P.id || "", this.kerningMode = (0, d.getStringOption)(P.kerningMode, ["none", "pair"]), this.letterSpacing = (0, d.getMeasurement)(P.letterSpacing, "0"), this.lineThrough = (0, d.getInteger)({ data: P.lineThrough, defaultValue: 0, validate: (At) => At === 1 || At === 2 }), this.lineThroughPeriod = (0, d.getStringOption)(P.lineThroughPeriod, ["all", "word"]), this.overline = (0, d.getInteger)({ data: P.overline, defaultValue: 0, validate: (At) => At === 1 || At === 2 }), this.overlinePeriod = (0, d.getStringOption)(P.overlinePeriod, ["all", "word"]), this.posture = (0, d.getStringOption)(P.posture, ["normal", "italic"]), this.size = (0, d.getMeasurement)(P.size, "10pt"), this.typeface = P.typeface || "Courier", this.underline = (0, d.getInteger)({ data: P.underline, defaultValue: 0, validate: (At) => At === 1 || At === 2 }), this.underlinePeriod = (0, d.getStringOption)(P.underlinePeriod, ["all", "word"]), this.use = P.use || "", this.usehref = P.usehref || "", this.weight = (0, d.getStringOption)(P.weight, ["normal", "bold"]), this.extras = null, this.fill = null;
        }
        [o.$clean](P) {
          super[o.$clean](P), this[o.$globalData].usedTypefaces.add(this.typeface);
        }
        [o.$toStyle]() {
          const P = (0, n.toStyle)(this, "fill"), At = P.color;
          return At && (At === "#000000" ? delete P.color : At.startsWith("#") || (P.background = At, P.backgroundClip = "text", P.color = "transparent")), this.baselineShift && (P.verticalAlign = (0, n.measureToString)(this.baselineShift)), P.fontKerning = this.kerningMode === "none" ? "none" : "normal", P.letterSpacing = (0, n.measureToString)(this.letterSpacing), this.lineThrough !== 0 && (P.textDecoration = "line-through", this.lineThrough === 2 && (P.textDecorationStyle = "double")), this.overline !== 0 && (P.textDecoration = "overline", this.overline === 2 && (P.textDecorationStyle = "double")), P.fontStyle = this.posture, P.fontSize = (0, n.measureToString)(0.99 * this.size), (0, n.setFontFamily)(this, this, this[o.$globalData].fontFinder, P), this.underline !== 0 && (P.textDecoration = "underline", this.underline === 2 && (P.textDecorationStyle = "double")), P.fontWeight = this.weight, P;
        }
      }
      class Ot extends a.XFAObject {
        constructor(P) {
          super(h, "format", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.picture = null;
        }
      }
      class Rt extends a.StringObject {
        constructor(P) {
          super(h, "handler"), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Tt extends a.XFAObject {
        constructor(P) {
          super(h, "hyphenation"), this.excludeAllCaps = (0, d.getInteger)({ data: P.excludeAllCaps, defaultValue: 0, validate: (At) => At === 1 }), this.excludeInitialCap = (0, d.getInteger)({ data: P.excludeInitialCap, defaultValue: 0, validate: (At) => At === 1 }), this.hyphenate = (0, d.getInteger)({ data: P.hyphenate, defaultValue: 0, validate: (At) => At === 1 }), this.id = P.id || "", this.pushCharacterCount = (0, d.getInteger)({ data: P.pushCharacterCount, defaultValue: 3, validate: (At) => At >= 0 }), this.remainCharacterCount = (0, d.getInteger)({ data: P.remainCharacterCount, defaultValue: 3, validate: (At) => At >= 0 }), this.use = P.use || "", this.usehref = P.usehref || "", this.wordCharacterCount = (0, d.getInteger)({ data: P.wordCharacterCount, defaultValue: 7, validate: (At) => At >= 0 });
        }
      }
      class ee extends a.StringObject {
        constructor(P) {
          super(h, "image"), this.aspect = (0, d.getStringOption)(P.aspect, ["fit", "actual", "height", "none", "width"]), this.contentType = P.contentType || "", this.href = P.href || "", this.id = P.id || "", this.name = P.name || "", this.transferEncoding = (0, d.getStringOption)(P.transferEncoding, ["base64", "none", "package"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$toHTML]() {
          if (this.contentType && !M.has(this.contentType.toLowerCase())) return d.HTMLResult.EMPTY;
          let P = this[o.$globalData].images && this[o.$globalData].images.get(this.href);
          if (!P && (this.href || !this[o.$content]) || (P || this.transferEncoding !== "base64" || (P = (0, m.stringToBytes)(atob(this[o.$content]))), !P)) return d.HTMLResult.EMPTY;
          if (!this.contentType) {
            for (const [ht, Yt] of O) if (P.length > ht.length && ht.every((be, ke) => be === P[ke])) {
              this.contentType = Yt;
              break;
            }
            if (!this.contentType) return d.HTMLResult.EMPTY;
          }
          const At = new Blob([P], { type: this.contentType });
          let Vt;
          switch (this.aspect) {
            case "fit":
            case "actual":
              break;
            case "height":
              Vt = { height: "100%", objectFit: "fill" };
              break;
            case "none":
              Vt = { width: "100%", height: "100%", objectFit: "fill" };
              break;
            case "width":
              Vt = { width: "100%", objectFit: "fill" };
          }
          const kt = this[o.$getParent]();
          return d.HTMLResult.success({ name: "img", attributes: { class: ["xfaImage"], style: Vt, src: URL.createObjectURL(At), alt: kt ? B(kt[o.$getParent]()) : null } });
        }
      }
      class te extends a.XFAObject {
        constructor(P) {
          super(h, "imageEdit", !0), this.data = (0, d.getStringOption)(P.data, ["link", "embed"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.extras = null, this.margin = null;
        }
        [o.$toHTML](P) {
          return this.data === "embed" ? d.HTMLResult.success({ name: "div", children: [], attributes: {} }) : d.HTMLResult.EMPTY;
        }
      }
      class Jt extends a.ContentObject {
        constructor(P) {
          super(h, "integer"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          const P = parseInt(this[o.$content].trim(), 10);
          this[o.$content] = isNaN(P) ? null : P;
        }
        [o.$toHTML](P) {
          return C(this[o.$content] !== null ? this[o.$content].toString() : "");
        }
      }
      class pe extends a.XFAObject {
        constructor(P) {
          super(h, "issuers", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.certificate = new a.XFAObjectArray();
        }
      }
      class ye extends a.XFAObject {
        constructor(P) {
          super(h, "items", !0), this.id = P.id || "", this.name = P.name || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.ref = P.ref || "", this.save = (0, d.getInteger)({ data: P.save, defaultValue: 0, validate: (At) => At === 1 }), this.use = P.use || "", this.usehref = P.usehref || "", this.boolean = new a.XFAObjectArray(), this.date = new a.XFAObjectArray(), this.dateTime = new a.XFAObjectArray(), this.decimal = new a.XFAObjectArray(), this.exData = new a.XFAObjectArray(), this.float = new a.XFAObjectArray(), this.image = new a.XFAObjectArray(), this.integer = new a.XFAObjectArray(), this.text = new a.XFAObjectArray(), this.time = new a.XFAObjectArray();
        }
        [o.$toHTML]() {
          const P = [];
          for (const At of this[o.$getChildren]()) P.push(At[o.$text]());
          return d.HTMLResult.success(P);
        }
      }
      l.Items = ye;
      class fe extends a.XFAObject {
        constructor(P) {
          super(h, "keep", !0), this.id = P.id || "";
          const At = ["none", "contentArea", "pageArea"];
          this.intact = (0, d.getStringOption)(P.intact, At), this.next = (0, d.getStringOption)(P.next, At), this.previous = (0, d.getStringOption)(P.previous, At), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
      }
      class me extends a.XFAObject {
        constructor(P) {
          super(h, "keyUsage");
          const At = ["", "yes", "no"];
          this.crlSign = (0, d.getStringOption)(P.crlSign, At), this.dataEncipherment = (0, d.getStringOption)(P.dataEncipherment, At), this.decipherOnly = (0, d.getStringOption)(P.decipherOnly, At), this.digitalSignature = (0, d.getStringOption)(P.digitalSignature, At), this.encipherOnly = (0, d.getStringOption)(P.encipherOnly, At), this.id = P.id || "", this.keyAgreement = (0, d.getStringOption)(P.keyAgreement, At), this.keyCertSign = (0, d.getStringOption)(P.keyCertSign, At), this.keyEncipherment = (0, d.getStringOption)(P.keyEncipherment, At), this.nonRepudiation = (0, d.getStringOption)(P.nonRepudiation, At), this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class we extends a.XFAObject {
        constructor(P) {
          super(h, "line", !0), this.hand = (0, d.getStringOption)(P.hand, ["even", "left", "right"]), this.id = P.id || "", this.slope = (0, d.getStringOption)(P.slope, ["\\", "/"]), this.use = P.use || "", this.usehref = P.usehref || "", this.edge = null;
        }
        [o.$toHTML]() {
          const P = this[o.$getParent]()[o.$getParent](), At = this.edge || new Ft({}), Vt = At[o.$toStyle](), kt = /* @__PURE__ */ Object.create(null), ht = At.presence === "visible" ? At.thickness : 0;
          kt.strokeWidth = (0, n.measureToString)(ht), kt.stroke = Vt.color;
          let Yt, be, ke, je, Ze = "100%", xn = "100%";
          P.w <= ht ? ([Yt, be, ke, je] = ["50%", 0, "50%", "100%"], Ze = kt.strokeWidth) : P.h <= ht ? ([Yt, be, ke, je] = [0, "50%", "100%", "50%"], xn = kt.strokeWidth) : this.slope === "\\" ? [Yt, be, ke, je] = [0, 0, "100%", "100%"] : [Yt, be, ke, je] = [0, "100%", "100%", 0];
          const An = { name: "svg", children: [{ name: "line", attributes: { xmlns: x, x1: Yt, y1: be, x2: ke, y2: je, style: kt } }], attributes: { xmlns: x, width: Ze, height: xn, style: { overflow: "visible" } } };
          return I(P) ? d.HTMLResult.success({ name: "div", attributes: { style: { display: "inline", width: "100%", height: "100%" } }, children: [An] }) : (An.attributes.style.position = "absolute", d.HTMLResult.success(An));
        }
      }
      class Fe extends a.XFAObject {
        constructor(P) {
          super(h, "linear", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["toRight", "toBottom", "toLeft", "toTop"]), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null;
        }
        [o.$toStyle](P) {
          return P = P ? P[o.$toStyle]() : "#FFFFFF", `linear-gradient(${this.type.replace(/([RBLT])/, " $1").toLowerCase()}, ${P}, ${this.color ? this.color[o.$toStyle]() : "#000000"})`;
        }
      }
      class Re extends a.ContentObject {
        constructor(P) {
          super(h, "lockDocument"), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          this[o.$content] = (0, d.getStringOption)(this[o.$content], ["auto", "0", "1"]);
        }
      }
      class ge extends a.XFAObject {
        constructor(P) {
          super(h, "manifest", !0), this.action = (0, d.getStringOption)(P.action, ["include", "all", "exclude"]), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.ref = new a.XFAObjectArray();
        }
      }
      class se extends a.XFAObject {
        constructor(P) {
          super(h, "margin", !0), this.bottomInset = (0, d.getMeasurement)(P.bottomInset, "0"), this.id = P.id || "", this.leftInset = (0, d.getMeasurement)(P.leftInset, "0"), this.rightInset = (0, d.getMeasurement)(P.rightInset, "0"), this.topInset = (0, d.getMeasurement)(P.topInset, "0"), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
        [o.$toStyle]() {
          return { margin: (0, n.measureToString)(this.topInset) + " " + (0, n.measureToString)(this.rightInset) + " " + (0, n.measureToString)(this.bottomInset) + " " + (0, n.measureToString)(this.leftInset) };
        }
      }
      class ue extends a.XFAObject {
        constructor(P) {
          super(h, "mdp"), this.id = P.id || "", this.permissions = (0, d.getInteger)({ data: P.permissions, defaultValue: 2, validate: (At) => At === 1 || At === 3 }), this.signatureType = (0, d.getStringOption)(P.signatureType, ["filler", "author"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Ae extends a.XFAObject {
        constructor(P) {
          super(h, "medium"), this.id = P.id || "", this.imagingBBox = (0, d.getBBox)(P.imagingBBox), this.long = (0, d.getMeasurement)(P.long), this.orientation = (0, d.getStringOption)(P.orientation, ["portrait", "landscape"]), this.short = (0, d.getMeasurement)(P.short), this.stock = P.stock || "", this.trayIn = (0, d.getStringOption)(P.trayIn, ["auto", "delegate", "pageFront"]), this.trayOut = (0, d.getStringOption)(P.trayOut, ["auto", "delegate"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class he extends a.XFAObject {
        constructor(P) {
          super(h, "message", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.text = new a.XFAObjectArray();
        }
      }
      class de extends a.XFAObject {
        constructor(P) {
          super(h, "numericEdit", !0), this.hScrollPolicy = (0, d.getStringOption)(P.hScrollPolicy, ["auto", "off", "on"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
        }
        [o.$toHTML](P) {
          var ht;
          const At = (0, n.toStyle)(this, "border", "font", "margin"), Vt = this[o.$getParent]()[o.$getParent](), kt = { name: "input", attributes: { type: "text", fieldId: Vt[o.$uid], dataId: ((ht = Vt[o.$data]) == null ? void 0 : ht[o.$uid]) || Vt[o.$uid], class: ["xfaTextfield"], style: At, "aria-label": B(Vt), "aria-required": !1 } };
          return z(Vt) && (kt.attributes["aria-required"] = !0, kt.attributes.required = !0), d.HTMLResult.success({ name: "label", attributes: { class: ["xfaLabel"] }, children: [kt] });
        }
      }
      class _e extends a.XFAObject {
        constructor(P) {
          super(h, "occur", !0), this.id = P.id || "", this.initial = P.initial !== "" ? (0, d.getInteger)({ data: P.initial, defaultValue: "", validate: (At) => !0 }) : "", this.max = P.max !== "" ? (0, d.getInteger)({ data: P.max, defaultValue: 1, validate: (At) => !0 }) : "", this.min = P.min !== "" ? (0, d.getInteger)({ data: P.min, defaultValue: 1, validate: (At) => !0 }) : "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
        [o.$clean]() {
          const P = this[o.$getParent](), At = this.min;
          this.min === "" && (this.min = P instanceof Jn || P instanceof di ? 0 : 1), this.max === "" && (this.max = At === "" ? P instanceof Jn || P instanceof di ? -1 : 1 : this.min), this.max !== -1 && this.max < this.min && (this.max = this.min), this.initial === "" && (this.initial = P instanceof vo ? 1 : this.min);
        }
      }
      class Qe extends a.StringObject {
        constructor(P) {
          super(h, "oid"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class $n extends a.XFAObject {
        constructor(P) {
          super(h, "oids", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.oid = new a.XFAObjectArray();
        }
      }
      class zr extends a.XFAObject {
        constructor(P) {
          super(h, "overflow"), this.id = P.id || "", this.leader = P.leader || "", this.target = P.target || "", this.trailer = P.trailer || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$getExtra]() {
          if (!this[o.$extra]) {
            const P = this[o.$getParent](), At = this[o.$getTemplateRoot](), Vt = At[o.$searchNode](this.target, P), kt = At[o.$searchNode](this.leader, P), ht = At[o.$searchNode](this.trailer, P);
            this[o.$extra] = { target: (Vt == null ? void 0 : Vt[0]) || null, leader: (kt == null ? void 0 : kt[0]) || null, trailer: (ht == null ? void 0 : ht[0]) || null, addLeader: !1, addTrailer: !1 };
          }
          return this[o.$extra];
        }
      }
      class Jn extends a.XFAObject {
        constructor(P) {
          super(h, "pageArea", !0), this.blankOrNotBlank = (0, d.getStringOption)(P.blankOrNotBlank, ["any", "blank", "notBlank"]), this.id = P.id || "", this.initialNumber = (0, d.getInteger)({ data: P.initialNumber, defaultValue: 1, validate: (At) => !0 }), this.name = P.name || "", this.numbered = (0, d.getInteger)({ data: P.numbered, defaultValue: 1, validate: (At) => !0 }), this.oddOrEven = (0, d.getStringOption)(P.oddOrEven, ["any", "even", "odd"]), this.pagePosition = (0, d.getStringOption)(P.pagePosition, ["any", "first", "last", "only", "rest"]), this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.desc = null, this.extras = null, this.medium = null, this.occur = null, this.area = new a.XFAObjectArray(), this.contentArea = new a.XFAObjectArray(), this.draw = new a.XFAObjectArray(), this.exclGroup = new a.XFAObjectArray(), this.field = new a.XFAObjectArray(), this.subform = new a.XFAObjectArray();
        }
        [o.$isUsable]() {
          return this[o.$extra] ? !this.occur || this.occur.max === -1 || this[o.$extra].numberOfUse < this.occur.max : (this[o.$extra] = { numberOfUse: 0 }, !0);
        }
        [o.$cleanPage]() {
          delete this[o.$extra];
        }
        [o.$getNextPage]() {
          this[o.$extra] || (this[o.$extra] = { numberOfUse: 0 });
          const P = this[o.$getParent]();
          return P.relation === "orderedOccurrence" && this[o.$isUsable]() ? (this[o.$extra].numberOfUse += 1, this) : P[o.$getNextPage]();
        }
        [o.$getAvailableSpace]() {
          return this[o.$extra].space || { width: 0, height: 0 };
        }
        [o.$toHTML]() {
          this[o.$extra] || (this[o.$extra] = { numberOfUse: 1 });
          const P = [];
          this[o.$extra].children = P;
          const At = /* @__PURE__ */ Object.create(null);
          if (this.medium && this.medium.short && this.medium.long) {
            if (At.width = (0, n.measureToString)(this.medium.short), At.height = (0, n.measureToString)(this.medium.long), this[o.$extra].space = { width: this.medium.short, height: this.medium.long }, this.medium.orientation === "landscape") {
              const Vt = At.width;
              At.width = At.height, At.height = Vt, this[o.$extra].space = { width: this.medium.long, height: this.medium.short };
            }
          } else (0, m.warn)("XFA - No medium specified in pageArea: please file a bug.");
          return this[o.$childrenToHTML]({ filter: /* @__PURE__ */ new Set(["area", "draw", "field", "subform"]), include: !0 }), this[o.$childrenToHTML]({ filter: /* @__PURE__ */ new Set(["contentArea"]), include: !0 }), d.HTMLResult.success({ name: "div", children: P, attributes: { class: ["xfaPage"], id: this[o.$uid], style: At, xfaName: this.name } });
        }
      }
      class di extends a.XFAObject {
        constructor(P) {
          super(h, "pageSet", !0), this.duplexImposition = (0, d.getStringOption)(P.duplexImposition, ["longEdge", "shortEdge"]), this.id = P.id || "", this.name = P.name || "", this.relation = (0, d.getStringOption)(P.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]), this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.occur = null, this.pageArea = new a.XFAObjectArray(), this.pageSet = new a.XFAObjectArray();
        }
        [o.$cleanPage]() {
          for (const P of this.pageArea.children) P[o.$cleanPage]();
          for (const P of this.pageSet.children) P[o.$cleanPage]();
        }
        [o.$isUsable]() {
          return !this.occur || this.occur.max === -1 || this[o.$extra].numberOfUse < this.occur.max;
        }
        [o.$getNextPage]() {
          if (this[o.$extra] || (this[o.$extra] = { numberOfUse: 1, pageIndex: -1, pageSetIndex: -1 }), this.relation === "orderedOccurrence") {
            if (this[o.$extra].pageIndex + 1 < this.pageArea.children.length)
              return this[o.$extra].pageIndex += 1, this.pageArea.children[this[o.$extra].pageIndex][o.$getNextPage]();
            if (this[o.$extra].pageSetIndex + 1 < this.pageSet.children.length)
              return this[o.$extra].pageSetIndex += 1, this.pageSet.children[this[o.$extra].pageSetIndex][o.$getNextPage]();
            if (this[o.$isUsable]())
              return this[o.$extra].numberOfUse += 1, this[o.$extra].pageIndex = -1, this[o.$extra].pageSetIndex = -1, this[o.$getNextPage]();
            const ht = this[o.$getParent]();
            return ht instanceof di ? ht[o.$getNextPage]() : (this[o.$cleanPage](), this[o.$getNextPage]());
          }
          const P = this[o.$getTemplateRoot]()[o.$extra].pageNumber, At = P % 2 == 0 ? "even" : "odd", Vt = P === 0 ? "first" : "rest";
          let kt = this.pageArea.children.find((ht) => ht.oddOrEven === At && ht.pagePosition === Vt);
          return kt || (kt = this.pageArea.children.find((ht) => ht.oddOrEven === "any" && ht.pagePosition === Vt), kt) ? kt : (kt = this.pageArea.children.find((ht) => ht.oddOrEven === "any" && ht.pagePosition === "any"), kt || this.pageArea.children[0]);
        }
      }
      class rs extends a.XFAObject {
        constructor(P) {
          super(h, "para", !0), this.hAlign = (0, d.getStringOption)(P.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = P.id || "", this.lineHeight = P.lineHeight ? (0, d.getMeasurement)(P.lineHeight, "0pt") : "", this.marginLeft = P.marginLeft ? (0, d.getMeasurement)(P.marginLeft, "0pt") : "", this.marginRight = P.marginRight ? (0, d.getMeasurement)(P.marginRight, "0pt") : "", this.orphans = (0, d.getInteger)({ data: P.orphans, defaultValue: 0, validate: (At) => At >= 0 }), this.preserve = P.preserve || "", this.radixOffset = P.radixOffset ? (0, d.getMeasurement)(P.radixOffset, "0pt") : "", this.spaceAbove = P.spaceAbove ? (0, d.getMeasurement)(P.spaceAbove, "0pt") : "", this.spaceBelow = P.spaceBelow ? (0, d.getMeasurement)(P.spaceBelow, "0pt") : "", this.tabDefault = P.tabDefault ? (0, d.getMeasurement)(this.tabDefault) : "", this.tabStops = (P.tabStops || "").trim().split(/\s+/).map((At, Vt) => Vt % 2 == 1 ? (0, d.getMeasurement)(At) : At), this.textIndent = P.textIndent ? (0, d.getMeasurement)(P.textIndent, "0pt") : "", this.use = P.use || "", this.usehref = P.usehref || "", this.vAlign = (0, d.getStringOption)(P.vAlign, ["top", "bottom", "middle"]), this.widows = (0, d.getInteger)({ data: P.widows, defaultValue: 0, validate: (At) => At >= 0 }), this.hyphenation = null;
        }
        [o.$toStyle]() {
          const P = (0, n.toStyle)(this, "hAlign");
          return this.marginLeft !== "" && (P.paddingLeft = (0, n.measureToString)(this.marginLeft)), this.marginRight !== "" && (P.paddingight = (0, n.measureToString)(this.marginRight)), this.spaceAbove !== "" && (P.paddingTop = (0, n.measureToString)(this.spaceAbove)), this.spaceBelow !== "" && (P.paddingBottom = (0, n.measureToString)(this.spaceBelow)), this.textIndent !== "" && (P.textIndent = (0, n.measureToString)(this.textIndent), (0, n.fixTextIndent)(P)), this.lineHeight > 0 && (P.lineHeight = (0, n.measureToString)(this.lineHeight)), this.tabDefault !== "" && (P.tabSize = (0, n.measureToString)(this.tabDefault)), this.tabStops.length, this.hyphenatation && Object.assign(P, this.hyphenatation[o.$toStyle]()), P;
        }
      }
      class Ua extends a.XFAObject {
        constructor(P) {
          super(h, "passwordEdit", !0), this.hScrollPolicy = (0, d.getStringOption)(P.hScrollPolicy, ["auto", "off", "on"]), this.id = P.id || "", this.passwordChar = P.passwordChar || "*", this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.extras = null, this.margin = null;
        }
      }
      class F0 extends a.XFAObject {
        constructor(P) {
          super(h, "pattern", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null;
        }
        [o.$toStyle](P) {
          P = P ? P[o.$toStyle]() : "#FFFFFF";
          const At = this.color ? this.color[o.$toStyle]() : "#000000", Vt = "repeating-linear-gradient", kt = `${P},${P} 5px,${At} 5px,${At} 10px`;
          switch (this.type) {
            case "crossHatch":
              return `${Vt}(to top,${kt}) ${Vt}(to right,${kt})`;
            case "crossDiagonal":
              return `${Vt}(45deg,${kt}) ${Vt}(-45deg,${kt})`;
            case "diagonalLeft":
              return `${Vt}(45deg,${kt})`;
            case "diagonalRight":
              return `${Vt}(-45deg,${kt})`;
            case "horizontal":
              return `${Vt}(to top,${kt})`;
            case "vertical":
              return `${Vt}(to right,${kt})`;
          }
          return "";
        }
      }
      class Bc extends a.StringObject {
        constructor(P) {
          super(h, "picture"), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class jc extends a.XFAObject {
        constructor(P) {
          super(h, "proto", !0), this.appearanceFilter = new a.XFAObjectArray(), this.arc = new a.XFAObjectArray(), this.area = new a.XFAObjectArray(), this.assist = new a.XFAObjectArray(), this.barcode = new a.XFAObjectArray(), this.bindItems = new a.XFAObjectArray(), this.bookend = new a.XFAObjectArray(), this.boolean = new a.XFAObjectArray(), this.border = new a.XFAObjectArray(), this.break = new a.XFAObjectArray(), this.breakAfter = new a.XFAObjectArray(), this.breakBefore = new a.XFAObjectArray(), this.button = new a.XFAObjectArray(), this.calculate = new a.XFAObjectArray(), this.caption = new a.XFAObjectArray(), this.certificate = new a.XFAObjectArray(), this.certificates = new a.XFAObjectArray(), this.checkButton = new a.XFAObjectArray(), this.choiceList = new a.XFAObjectArray(), this.color = new a.XFAObjectArray(), this.comb = new a.XFAObjectArray(), this.connect = new a.XFAObjectArray(), this.contentArea = new a.XFAObjectArray(), this.corner = new a.XFAObjectArray(), this.date = new a.XFAObjectArray(), this.dateTime = new a.XFAObjectArray(), this.dateTimeEdit = new a.XFAObjectArray(), this.decimal = new a.XFAObjectArray(), this.defaultUi = new a.XFAObjectArray(), this.desc = new a.XFAObjectArray(), this.digestMethod = new a.XFAObjectArray(), this.digestMethods = new a.XFAObjectArray(), this.draw = new a.XFAObjectArray(), this.edge = new a.XFAObjectArray(), this.encoding = new a.XFAObjectArray(), this.encodings = new a.XFAObjectArray(), this.encrypt = new a.XFAObjectArray(), this.encryptData = new a.XFAObjectArray(), this.encryption = new a.XFAObjectArray(), this.encryptionMethod = new a.XFAObjectArray(), this.encryptionMethods = new a.XFAObjectArray(), this.event = new a.XFAObjectArray(), this.exData = new a.XFAObjectArray(), this.exObject = new a.XFAObjectArray(), this.exclGroup = new a.XFAObjectArray(), this.execute = new a.XFAObjectArray(), this.extras = new a.XFAObjectArray(), this.field = new a.XFAObjectArray(), this.fill = new a.XFAObjectArray(), this.filter = new a.XFAObjectArray(), this.float = new a.XFAObjectArray(), this.font = new a.XFAObjectArray(), this.format = new a.XFAObjectArray(), this.handler = new a.XFAObjectArray(), this.hyphenation = new a.XFAObjectArray(), this.image = new a.XFAObjectArray(), this.imageEdit = new a.XFAObjectArray(), this.integer = new a.XFAObjectArray(), this.issuers = new a.XFAObjectArray(), this.items = new a.XFAObjectArray(), this.keep = new a.XFAObjectArray(), this.keyUsage = new a.XFAObjectArray(), this.line = new a.XFAObjectArray(), this.linear = new a.XFAObjectArray(), this.lockDocument = new a.XFAObjectArray(), this.manifest = new a.XFAObjectArray(), this.margin = new a.XFAObjectArray(), this.mdp = new a.XFAObjectArray(), this.medium = new a.XFAObjectArray(), this.message = new a.XFAObjectArray(), this.numericEdit = new a.XFAObjectArray(), this.occur = new a.XFAObjectArray(), this.oid = new a.XFAObjectArray(), this.oids = new a.XFAObjectArray(), this.overflow = new a.XFAObjectArray(), this.pageArea = new a.XFAObjectArray(), this.pageSet = new a.XFAObjectArray(), this.para = new a.XFAObjectArray(), this.passwordEdit = new a.XFAObjectArray(), this.pattern = new a.XFAObjectArray(), this.picture = new a.XFAObjectArray(), this.radial = new a.XFAObjectArray(), this.reason = new a.XFAObjectArray(), this.reasons = new a.XFAObjectArray(), this.rectangle = new a.XFAObjectArray(), this.ref = new a.XFAObjectArray(), this.script = new a.XFAObjectArray(), this.setProperty = new a.XFAObjectArray(), this.signData = new a.XFAObjectArray(), this.signature = new a.XFAObjectArray(), this.signing = new a.XFAObjectArray(), this.solid = new a.XFAObjectArray(), this.speak = new a.XFAObjectArray(), this.stipple = new a.XFAObjectArray(), this.subform = new a.XFAObjectArray(), this.subformSet = new a.XFAObjectArray(), this.subjectDN = new a.XFAObjectArray(), this.subjectDNs = new a.XFAObjectArray(), this.submit = new a.XFAObjectArray(), this.text = new a.XFAObjectArray(), this.textEdit = new a.XFAObjectArray(), this.time = new a.XFAObjectArray(), this.timeStamp = new a.XFAObjectArray(), this.toolTip = new a.XFAObjectArray(), this.traversal = new a.XFAObjectArray(), this.traverse = new a.XFAObjectArray(), this.ui = new a.XFAObjectArray(), this.validate = new a.XFAObjectArray(), this.value = new a.XFAObjectArray(), this.variables = new a.XFAObjectArray();
        }
      }
      class Uc extends a.XFAObject {
        constructor(P) {
          super(h, "radial", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["toEdge", "toCenter"]), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null;
        }
        [o.$toStyle](P) {
          P = P ? P[o.$toStyle]() : "#FFFFFF";
          const At = this.color ? this.color[o.$toStyle]() : "#000000";
          return `radial-gradient(circle at center, ${this.type === "toEdge" ? `${P},${At}` : `${At},${P}`})`;
        }
      }
      class Cl extends a.StringObject {
        constructor(P) {
          super(h, "reason"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class R0 extends a.XFAObject {
        constructor(P) {
          super(h, "reasons", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.reason = new a.XFAObjectArray();
        }
      }
      class Al extends a.XFAObject {
        constructor(P) {
          super(h, "rectangle", !0), this.hand = (0, d.getStringOption)(P.hand, ["even", "left", "right"]), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.corner = new a.XFAObjectArray(4), this.edge = new a.XFAObjectArray(4), this.fill = null;
        }
        [o.$toHTML]() {
          var Yt;
          const P = this.edge.children.length ? this.edge.children[0] : new Ft({}), At = P[o.$toStyle](), Vt = /* @__PURE__ */ Object.create(null);
          ((Yt = this.fill) == null ? void 0 : Yt.presence) === "visible" ? Object.assign(Vt, this.fill[o.$toStyle]()) : Vt.fill = "transparent", Vt.strokeWidth = (0, n.measureToString)(P.presence === "visible" ? P.thickness : 0), Vt.stroke = At.color;
          const kt = (this.corner.children.length ? this.corner.children[0] : new ut({}))[o.$toStyle](), ht = { name: "svg", children: [{ name: "rect", attributes: { xmlns: x, width: "100%", height: "100%", x: 0, y: 0, rx: kt.radius, ry: kt.radius, style: Vt } }], attributes: { xmlns: x, style: { overflow: "visible" }, width: "100%", height: "100%" } };
          return I(this[o.$getParent]()[o.$getParent]()) ? d.HTMLResult.success({ name: "div", attributes: { style: { display: "inline", width: "100%", height: "100%" } }, children: [ht] }) : (ht.attributes.style.position = "absolute", d.HTMLResult.success(ht));
        }
      }
      class yo extends a.StringObject {
        constructor(P) {
          super(h, "ref"), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Hc extends a.StringObject {
        constructor(P) {
          super(h, "script"), this.binding = P.binding || "", this.contentType = P.contentType || "", this.id = P.id || "", this.name = P.name || "", this.runAt = (0, d.getStringOption)(P.runAt, ["client", "both", "server"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class Vc extends a.XFAObject {
        constructor(P) {
          super(h, "setProperty"), this.connection = P.connection || "", this.ref = P.ref || "", this.target = P.target || "";
        }
      }
      l.SetProperty = Vc;
      class zc extends a.XFAObject {
        constructor(P) {
          super(h, "signData", !0), this.id = P.id || "", this.operation = (0, d.getStringOption)(P.operation, ["sign", "clear", "verify"]), this.ref = P.ref || "", this.target = P.target || "", this.use = P.use || "", this.usehref = P.usehref || "", this.filter = null, this.manifest = null;
        }
      }
      class Xc extends a.XFAObject {
        constructor(P) {
          super(h, "signature", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["PDF1.3", "PDF1.6"]), this.use = P.use || "", this.usehref = P.usehref || "", this.border = null, this.extras = null, this.filter = null, this.manifest = null, this.margin = null;
        }
      }
      class _l extends a.XFAObject {
        constructor(P) {
          super(h, "signing", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.certificate = new a.XFAObjectArray();
        }
      }
      class D0 extends a.XFAObject {
        constructor(P) {
          super(h, "solid", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null;
        }
        [o.$toStyle](P) {
          return P ? P[o.$toStyle]() : "#FFFFFF";
        }
      }
      class qc extends a.StringObject {
        constructor(P) {
          super(h, "speak"), this.disable = (0, d.getInteger)({ data: P.disable, defaultValue: 0, validate: (At) => At === 1 }), this.id = P.id || "", this.priority = (0, d.getStringOption)(P.priority, ["custom", "caption", "name", "toolTip"]), this.rid = P.rid || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class kl extends a.XFAObject {
        constructor(P) {
          super(h, "stipple", !0), this.id = P.id || "", this.rate = (0, d.getInteger)({ data: P.rate, defaultValue: 50, validate: (At) => At >= 0 && At <= 100 }), this.use = P.use || "", this.usehref = P.usehref || "", this.color = null, this.extras = null;
        }
        [o.$toStyle](P) {
          const At = this.rate / 100;
          return m.Util.makeHexColor(Math.round(P.value.r * (1 - At) + this.value.r * At), Math.round(P.value.g * (1 - At) + this.value.g * At), Math.round(P.value.b * (1 - At) + this.value.b * At));
        }
      }
      class bo extends a.XFAObject {
        constructor(P) {
          super(h, "subform", !0), this.access = (0, d.getStringOption)(P.access, ["open", "nonInteractive", "protected", "readOnly"]), this.allowMacro = (0, d.getInteger)({ data: P.allowMacro, defaultValue: 0, validate: (At) => At === 1 }), this.anchorType = (0, d.getStringOption)(P.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, d.getInteger)({ data: P.colSpan, defaultValue: 1, validate: (At) => At >= 1 || At === -1 }), this.columnWidths = (P.columnWidths || "").trim().split(/\s+/).map((At) => At === "-1" ? -1 : (0, d.getMeasurement)(At)), this.h = P.h ? (0, d.getMeasurement)(P.h) : "", this.hAlign = (0, d.getStringOption)(P.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = P.id || "", this.layout = (0, d.getStringOption)(P.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.locale = P.locale || "", this.maxH = (0, d.getMeasurement)(P.maxH, "0pt"), this.maxW = (0, d.getMeasurement)(P.maxW, "0pt"), this.mergeMode = (0, d.getStringOption)(P.mergeMode, ["consumeData", "matchTemplate"]), this.minH = (0, d.getMeasurement)(P.minH, "0pt"), this.minW = (0, d.getMeasurement)(P.minW, "0pt"), this.name = P.name || "", this.presence = (0, d.getStringOption)(P.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, d.getRelevant)(P.relevant), this.restoreState = (0, d.getStringOption)(P.restoreState, ["manual", "auto"]), this.scope = (0, d.getStringOption)(P.scope, ["name", "none"]), this.use = P.use || "", this.usehref = P.usehref || "", this.w = P.w ? (0, d.getMeasurement)(P.w) : "", this.x = (0, d.getMeasurement)(P.x, "0pt"), this.y = (0, d.getMeasurement)(P.y, "0pt"), this.assist = null, this.bind = null, this.bookend = null, this.border = null, this.break = null, this.calculate = null, this.desc = null, this.extras = null, this.keep = null, this.margin = null, this.occur = null, this.overflow = null, this.pageSet = null, this.para = null, this.traversal = null, this.validate = null, this.variables = null, this.area = new a.XFAObjectArray(), this.breakAfter = new a.XFAObjectArray(), this.breakBefore = new a.XFAObjectArray(), this.connect = new a.XFAObjectArray(), this.draw = new a.XFAObjectArray(), this.event = new a.XFAObjectArray(), this.exObject = new a.XFAObjectArray(), this.exclGroup = new a.XFAObjectArray(), this.field = new a.XFAObjectArray(), this.proto = new a.XFAObjectArray(), this.setProperty = new a.XFAObjectArray(), this.subform = new a.XFAObjectArray(), this.subformSet = new a.XFAObjectArray();
        }
        [o.$getSubformParent]() {
          const P = this[o.$getParent]();
          return P instanceof ya ? P[o.$getSubformParent]() : P;
        }
        [o.$isBindable]() {
          return !0;
        }
        [o.$isThereMoreWidth]() {
          return this.layout.endsWith("-tb") && this[o.$extra].attempt === 0 && this[o.$extra].numberInLine > 0 || this[o.$getParent]()[o.$isThereMoreWidth]();
        }
        *[o.$getContainedChildren]() {
          yield* W(this);
        }
        [o.$flushHTML]() {
          return (0, p.flushHTML)(this);
        }
        [o.$addHTML](P, At) {
          (0, p.addHTML)(this, P, At);
        }
        [o.$getAvailableSpace]() {
          return (0, p.getAvailableSpace)(this);
        }
        [o.$isSplittable]() {
          var At;
          const P = this[o.$getSubformParent]();
          return P[o.$isSplittable]() ? this[o.$extra]._isSplittable !== void 0 ? this[o.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[o.$extra]._isSplittable = !1, !1) : this.keep && this.keep.intact !== "none" ? (this[o.$extra]._isSplittable = !1, !1) : (At = P.layout) != null && At.endsWith("-tb") && P[o.$extra].numberInLine !== 0 ? !1 : (this[o.$extra]._isSplittable = !0, !0) : !1;
        }
        [o.$toHTML](P) {
          var ze;
          if (j(this), this.break) {
            if (this.break.after !== "auto" || this.break.afterTarget !== "") {
              const Me = new st({ targetType: this.break.after, target: this.break.afterTarget, startNew: this.break.startNew.toString() });
              Me[o.$globalData] = this[o.$globalData], this[o.$appendChild](Me), this.breakAfter.push(Me);
            }
            if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
              const Me = new mt({ targetType: this.break.before, target: this.break.beforeTarget, startNew: this.break.startNew.toString() });
              Me[o.$globalData] = this[o.$globalData], this[o.$appendChild](Me), this.breakBefore.push(Me);
            }
            if (this.break.overflowTarget !== "") {
              const Me = new zr({ target: this.break.overflowTarget, leader: this.break.overflowLeader, trailer: this.break.overflowTrailer });
              Me[o.$globalData] = this[o.$globalData], this[o.$appendChild](Me), this.overflow.push(Me);
            }
            this[o.$removeChild](this.break), this.break = null;
          }
          if (this.presence === "hidden" || this.presence === "inactive") return d.HTMLResult.EMPTY;
          if ((this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && (0, m.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug."), this.breakBefore.children.length >= 1) {
            const Me = this.breakBefore.children[0];
            if (S(Me)) return d.HTMLResult.breakNode(Me);
          }
          if ((ze = this[o.$extra]) != null && ze.afterBreakAfter) return d.HTMLResult.EMPTY;
          (0, n.fixDimensions)(this);
          const At = [], Vt = { id: this[o.$uid], class: [] };
          (0, n.setAccess)(this, Vt.class), this[o.$extra] || (this[o.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[o.$extra], { children: At, line: null, attributes: Vt, attempt: 0, numberInLine: 0, availableSpace: { width: Math.min(this.w || 1 / 0, P.width), height: Math.min(this.h || 1 / 0, P.height) }, width: 0, height: 0, prevHeight: 0, currentWidth: 0 });
          const kt = this[o.$getTemplateRoot](), ht = kt[o.$extra].noLayoutFailure, Yt = this[o.$isSplittable]();
          if (Yt || T(this), !(0, p.checkDimensions)(this, P)) return d.HTMLResult.FAILURE;
          const be = /* @__PURE__ */ new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
          if (this.layout.includes("row")) {
            const Me = this[o.$getSubformParent]().columnWidths;
            Array.isArray(Me) && Me.length > 0 && (this[o.$extra].columnWidths = Me, this[o.$extra].currentColumn = 0);
          }
          const ke = (0, n.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), je = ["xfaSubform"], Ze = (0, n.layoutClass)(this);
          if (Ze && je.push(Ze), Vt.style = ke, Vt.class = je, this.name && (Vt.xfaName = this.name), this.overflow) {
            const Me = this.overflow[o.$getExtra]();
            Me.addLeader && (Me.addLeader = !1, A(this, Me.leader, P));
          }
          this[o.$pushPara]();
          const xn = this.layout === "lr-tb" || this.layout === "rl-tb", An = xn ? 2 : 1;
          for (; this[o.$extra].attempt < An; this[o.$extra].attempt++) {
            xn && this[o.$extra].attempt === 1 && (this[o.$extra].numberInLine = 0);
            const Me = this[o.$childrenToHTML]({ filter: be, include: !0 });
            if (Me.success) break;
            if (Me.isBreak())
              return this[o.$popPara](), Me;
            if (xn && this[o.$extra].attempt === 0 && this[o.$extra].numberInLine === 0 && !kt[o.$extra].noLayoutFailure) {
              this[o.$extra].attempt = An;
              break;
            }
          }
          if (this[o.$popPara](), Yt || F(this), kt[o.$extra].noLayoutFailure = ht, this[o.$extra].attempt === An)
            return this.overflow && (this[o.$getTemplateRoot]()[o.$extra].overflowNode = this.overflow), Yt || delete this[o.$extra], d.HTMLResult.FAILURE;
          if (this.overflow) {
            const Me = this.overflow[o.$getExtra]();
            Me.addTrailer && (Me.addTrailer = !1, A(this, Me.trailer, P));
          }
          let Ln = 0, Gn = 0;
          this.margin && (Ln = this.margin.leftInset + this.margin.rightInset, Gn = this.margin.topInset + this.margin.bottomInset);
          const $e = Math.max(this[o.$extra].width + Ln, this.w || 0), yr = Math.max(this[o.$extra].height + Gn, this.h || 0), fn = [this.x, this.y, $e, yr];
          if (this.w === "" && (ke.width = (0, n.measureToString)($e)), this.h === "" && (ke.height = (0, n.measureToString)(yr)), (ke.width === "0px" || ke.height === "0px") && At.length === 0) return d.HTMLResult.EMPTY;
          const qi = { name: "div", attributes: Vt, children: At };
          $(this, Vt);
          const Xr = d.HTMLResult.success((0, n.createWrapper)(this, qi), fn);
          if (this.breakAfter.children.length >= 1) {
            const Me = this.breakAfter.children[0];
            if (S(Me))
              return this[o.$extra].afterBreakAfter = Xr, d.HTMLResult.breakNode(Me);
          }
          return delete this[o.$extra], Xr;
        }
      }
      class ya extends a.XFAObject {
        constructor(P) {
          super(h, "subformSet", !0), this.id = P.id || "", this.name = P.name || "", this.relation = (0, d.getStringOption)(P.relation, ["ordered", "choice", "unordered"]), this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.bookend = null, this.break = null, this.desc = null, this.extras = null, this.occur = null, this.overflow = null, this.breakAfter = new a.XFAObjectArray(), this.breakBefore = new a.XFAObjectArray(), this.subform = new a.XFAObjectArray(), this.subformSet = new a.XFAObjectArray();
        }
        *[o.$getContainedChildren]() {
          yield* W(this);
        }
        [o.$getSubformParent]() {
          let P = this[o.$getParent]();
          for (; !(P instanceof bo); ) P = P[o.$getParent]();
          return P;
        }
        [o.$isBindable]() {
          return !0;
        }
      }
      class Wc extends a.ContentObject {
        constructor(P) {
          super(h, "subjectDN"), this.delimiter = P.delimiter || ",", this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          this[o.$content] = new Map(this[o.$content].split(this.delimiter).map((P) => ((P = P.split("=", 2))[0] = P[0].trim(), P)));
        }
      }
      class Gc extends a.XFAObject {
        constructor(P) {
          super(h, "subjectDNs", !0), this.id = P.id || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "", this.subjectDN = new a.XFAObjectArray();
        }
      }
      class $0 extends a.XFAObject {
        constructor(P) {
          super(h, "submit", !0), this.embedPDF = (0, d.getInteger)({ data: P.embedPDF, defaultValue: 0, validate: (At) => At === 1 }), this.format = (0, d.getStringOption)(P.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]), this.id = P.id || "", this.target = P.target || "", this.textEncoding = (0, d.getKeyword)({ data: P.textEncoding ? P.textEncoding.toLowerCase() : "", defaultValue: "", validate: (At) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(At) || At.match(/iso-8859-\d{2}/) }), this.use = P.use || "", this.usehref = P.usehref || "", this.xdpContent = P.xdpContent || "", this.encrypt = null, this.encryptData = new a.XFAObjectArray(), this.signData = new a.XFAObjectArray();
        }
      }
      class vo extends a.XFAObject {
        constructor(P) {
          super(h, "template", !0), this.baseProfile = (0, d.getStringOption)(P.baseProfile, ["full", "interactiveForms"]), this.extras = null, this.subform = new a.XFAObjectArray();
        }
        [o.$finalize]() {
          this.subform.children.length === 0 && (0, m.warn)("XFA - No subforms in template node."), this.subform.children.length >= 2 && (0, m.warn)("XFA - Several subforms in template node: please file a bug."), this[o.$tabIndex] = 5e3;
        }
        [o.$isSplittable]() {
          return !0;
        }
        [o.$searchNode](P, At) {
          return P.startsWith("#") ? [this[o.$ids].get(P.slice(1))] : (0, v.searchNode)(this, At, P, !0, !0);
        }
        *[o.$toPages]() {
          var Gn, $e, yr;
          if (!this.subform.children.length) return d.HTMLResult.success({ name: "div", children: [] });
          this[o.$extra] = { overflowNode: null, firstUnsplittable: null, currentContentArea: null, currentPageArea: null, noLayoutFailure: !1, pageNumber: 1, pagePosition: "first", oddOrEven: "odd", blankOrNotBlank: "nonBlank", paraStack: [] };
          const P = this.subform.children[0];
          P.pageSet[o.$cleanPage]();
          const At = P.pageSet.pageArea.children, Vt = { name: "div", children: [] };
          let kt = null, ht = null, Yt = null;
          if (P.breakBefore.children.length >= 1 ? (ht = P.breakBefore.children[0], Yt = ht.target) : P.subform.children.length >= 1 && P.subform.children[0].breakBefore.children.length >= 1 ? (ht = P.subform.children[0].breakBefore.children[0], Yt = ht.target) : (Gn = P.break) != null && Gn.beforeTarget ? (ht = P.break, Yt = ht.beforeTarget) : P.subform.children.length >= 1 && (($e = P.subform.children[0].break) != null && $e.beforeTarget) && (ht = P.subform.children[0].break, Yt = ht.beforeTarget), ht) {
            const fn = this[o.$searchNode](Yt, ht[o.$getParent]());
            fn instanceof Jn && (kt = fn, ht[o.$extra] = {});
          }
          kt || (kt = At[0]), kt[o.$extra] = { numberOfUse: 1 };
          const be = kt[o.$getParent]();
          be[o.$extra] = { numberOfUse: 1, pageIndex: be.pageArea.children.indexOf(kt), pageSetIndex: 0 };
          let ke, je = null, Ze = null, xn = !0, An = 0, Ln = 0;
          for (; ; ) {
            if (xn) An = 0;
            else if (Vt.children.pop(), ++An == 3)
              return (0, m.warn)("XFA - Something goes wrong: please file a bug."), Vt;
            ke = null, this[o.$extra].currentPageArea = kt;
            const fn = kt[o.$toHTML]().html;
            Vt.children.push(fn), je && (this[o.$extra].noLayoutFailure = !0, fn.children.push(je[o.$toHTML](kt[o.$extra].space).html), je = null), Ze && (this[o.$extra].noLayoutFailure = !0, fn.children.push(Ze[o.$toHTML](kt[o.$extra].space).html), Ze = null);
            const qi = kt.contentArea.children, Xr = fn.children.filter((Me) => Me.attributes.class.includes("xfaContentarea"));
            xn = !1, this[o.$extra].firstUnsplittable = null, this[o.$extra].noLayoutFailure = !1;
            const ze = (Me) => {
              var gi;
              const Ei = P[o.$flushHTML]();
              Ei && (xn || (xn = ((gi = Ei.children) == null ? void 0 : gi.length) > 0), Xr[Me].children.push(Ei));
            };
            for (let Me = Ln, Ei = qi.length; Me < Ei; Me++) {
              const gi = this[o.$extra].currentContentArea = qi[Me], Ha = { width: gi.w, height: gi.h };
              Ln = 0, je && (Xr[Me].children.push(je[o.$toHTML](Ha).html), je = null), Ze && (Xr[Me].children.push(Ze[o.$toHTML](Ha).html), Ze = null);
              const Wi = P[o.$toHTML](Ha);
              if (Wi.success)
                return Wi.html ? (xn || (xn = ((yr = Wi.html.children) == null ? void 0 : yr.length) > 0), Xr[Me].children.push(Wi.html)) : !xn && Vt.children.length > 1 && Vt.children.pop(), Vt;
              if (Wi.isBreak()) {
                const br = Wi.breakNode;
                if (ze(Me), br.targetType === "auto") continue;
                br.leader && (je = this[o.$searchNode](br.leader, br[o.$getParent]()), je = je ? je[0] : null), br.trailer && (Ze = this[o.$searchNode](br.trailer, br[o.$getParent]()), Ze = Ze ? Ze[0] : null), br.targetType === "pageArea" ? (ke = br[o.$extra].target, Me = 1 / 0) : br[o.$extra].target ? (ke = br[o.$extra].target, Ln = br[o.$extra].index + 1, Me = 1 / 0) : Me = br[o.$extra].index;
              } else if (this[o.$extra].overflowNode) {
                const br = this[o.$extra].overflowNode;
                this[o.$extra].overflowNode = null;
                const kr = br[o.$getExtra](), xo = kr.target;
                kr.addLeader = kr.leader !== null, kr.addTrailer = kr.trailer !== null, ze(Me);
                const Pi = Me;
                if (Me = 1 / 0, xo instanceof Jn) ke = xo;
                else if (xo instanceof ot) {
                  const Zc = qi.indexOf(xo);
                  Zc !== -1 ? Zc > Pi ? Me = Zc - 1 : Ln = Zc : (ke = xo[o.$getParent](), Ln = ke.contentArea.children.indexOf(xo));
                }
              } else ze(Me);
            }
            this[o.$extra].pageNumber += 1, ke && (ke[o.$isUsable]() ? ke[o.$extra].numberOfUse += 1 : ke = null), kt = ke || kt[o.$getNextPage](), yield null;
          }
        }
      }
      l.Template = vo;
      class Ol extends a.ContentObject {
        constructor(P) {
          super(h, "text"), this.id = P.id || "", this.maxChars = (0, d.getInteger)({ data: P.maxChars, defaultValue: 0, validate: (At) => At >= 0 }), this.name = P.name || "", this.rid = P.rid || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$acceptWhitespace]() {
          return !0;
        }
        [o.$onChild](P) {
          return P[o.$namespaceId] === g.NamespaceIds.xhtml.id ? (this[o.$content] = P, !0) : ((0, m.warn)(`XFA - Invalid content in Text: ${P[o.$nodeName]}.`), !1);
        }
        [o.$onText](P) {
          this[o.$content] instanceof a.XFAObject || super[o.$onText](P);
        }
        [o.$finalize]() {
          typeof this[o.$content] == "string" && (this[o.$content] = this[o.$content].replaceAll(`\r
`, `
`));
        }
        [o.$getExtra]() {
          return typeof this[o.$content] == "string" ? this[o.$content].split(/[\u2029\u2028\n]/).reduce((P, At) => (At && P.push(At), P), []).join(`
`) : this[o.$content][o.$text]();
        }
        [o.$toHTML](P) {
          if (typeof this[o.$content] == "string") {
            const At = C(this[o.$content]).html;
            return this[o.$content].includes("\u2029") ? (At.name = "div", At.children = [], this[o.$content].split("\u2029").map((Vt) => Vt.split(/[\u2028\n]/).reduce((kt, ht) => (kt.push({ name: "span", value: ht }, { name: "br" }), kt), [])).forEach((Vt) => {
              At.children.push({ name: "p", children: Vt });
            })) : /[\u2028\n]/.test(this[o.$content]) && (At.name = "div", At.children = [], this[o.$content].split(/[\u2028\n]/).forEach((Vt) => {
              At.children.push({ name: "span", value: Vt }, { name: "br" });
            })), d.HTMLResult.success(At);
          }
          return this[o.$content][o.$toHTML](P);
        }
      }
      l.Text = Ol;
      class Tl extends a.XFAObject {
        constructor(P) {
          super(h, "textEdit", !0), this.allowRichText = (0, d.getInteger)({ data: P.allowRichText, defaultValue: 0, validate: (At) => At === 1 }), this.hScrollPolicy = (0, d.getStringOption)(P.hScrollPolicy, ["auto", "off", "on"]), this.id = P.id || "", this.multiLine = (0, d.getInteger)({ data: P.multiLine, defaultValue: "", validate: (At) => At === 0 || At === 1 }), this.use = P.use || "", this.usehref = P.usehref || "", this.vScrollPolicy = (0, d.getStringOption)(P.vScrollPolicy, ["auto", "off", "on"]), this.border = null, this.comb = null, this.extras = null, this.margin = null;
        }
        [o.$toHTML](P) {
          var ht, Yt;
          const At = (0, n.toStyle)(this, "border", "font", "margin");
          let Vt;
          const kt = this[o.$getParent]()[o.$getParent]();
          return this.multiLine === "" && (this.multiLine = kt instanceof Et ? 1 : 0), Vt = this.multiLine === 1 ? { name: "textarea", attributes: { dataId: ((ht = kt[o.$data]) == null ? void 0 : ht[o.$uid]) || kt[o.$uid], fieldId: kt[o.$uid], class: ["xfaTextfield"], style: At, "aria-label": B(kt), "aria-required": !1 } } : { name: "input", attributes: { type: "text", dataId: ((Yt = kt[o.$data]) == null ? void 0 : Yt[o.$uid]) || kt[o.$uid], fieldId: kt[o.$uid], class: ["xfaTextfield"], style: At, "aria-label": B(kt), "aria-required": !1 } }, z(kt) && (Vt.attributes["aria-required"] = !0, Vt.attributes.required = !0), d.HTMLResult.success({ name: "label", attributes: { class: ["xfaLabel"] }, children: [Vt] });
        }
      }
      class Kc extends a.StringObject {
        constructor(P) {
          super(h, "time"), this.id = P.id || "", this.name = P.name || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
        [o.$finalize]() {
          const P = this[o.$content].trim();
          this[o.$content] = P ? new Date(P) : null;
        }
        [o.$toHTML](P) {
          return C(this[o.$content] ? this[o.$content].toString() : "");
        }
      }
      class L0 extends a.XFAObject {
        constructor(P) {
          super(h, "timeStamp"), this.id = P.id || "", this.server = P.server || "", this.type = (0, d.getStringOption)(P.type, ["optional", "required"]), this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class N0 extends a.StringObject {
        constructor(P) {
          super(h, "toolTip"), this.id = P.id || "", this.rid = P.rid || "", this.use = P.use || "", this.usehref = P.usehref || "";
        }
      }
      class B0 extends a.XFAObject {
        constructor(P) {
          super(h, "traversal", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.traverse = new a.XFAObjectArray();
        }
      }
      class Yc extends a.XFAObject {
        constructor(P) {
          super(h, "traverse", !0), this.id = P.id || "", this.operation = (0, d.getStringOption)(P.operation, ["next", "back", "down", "first", "left", "right", "up"]), this.ref = P.ref || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.script = null;
        }
        get name() {
          return this.operation;
        }
        [o.$isTransparent]() {
          return !1;
        }
      }
      class Ml extends a.XFAObject {
        constructor(P) {
          super(h, "ui", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.picture = null, this.barcode = null, this.button = null, this.checkButton = null, this.choiceList = null, this.dateTimeEdit = null, this.defaultUi = null, this.imageEdit = null, this.numericEdit = null, this.passwordEdit = null, this.signature = null, this.textEdit = null;
        }
        [o.$getExtra]() {
          if (this[o.$extra] === void 0) {
            for (const P of Object.getOwnPropertyNames(this)) {
              if (P === "extras" || P === "picture") continue;
              const At = this[P];
              if (At instanceof a.XFAObject)
                return this[o.$extra] = At, At;
            }
            this[o.$extra] = null;
          }
          return this[o.$extra];
        }
        [o.$toHTML](P) {
          const At = this[o.$getExtra]();
          return At ? At[o.$toHTML](P) : d.HTMLResult.EMPTY;
        }
      }
      class j0 extends a.XFAObject {
        constructor(P) {
          super(h, "validate", !0), this.formatTest = (0, d.getStringOption)(P.formatTest, ["warning", "disabled", "error"]), this.id = P.id || "", this.nullTest = (0, d.getStringOption)(P.nullTest, ["disabled", "error", "warning"]), this.scriptTest = (0, d.getStringOption)(P.scriptTest, ["error", "disabled", "warning"]), this.use = P.use || "", this.usehref = P.usehref || "", this.extras = null, this.message = null, this.picture = null, this.script = null;
        }
      }
      class wo extends a.XFAObject {
        constructor(P) {
          super(h, "value", !0), this.id = P.id || "", this.override = (0, d.getInteger)({ data: P.override, defaultValue: 0, validate: (At) => At === 1 }), this.relevant = (0, d.getRelevant)(P.relevant), this.use = P.use || "", this.usehref = P.usehref || "", this.arc = null, this.boolean = null, this.date = null, this.dateTime = null, this.decimal = null, this.exData = null, this.float = null, this.image = null, this.integer = null, this.line = null, this.rectangle = null, this.text = null, this.time = null;
        }
        [o.$setValue](P) {
          var kt;
          const At = this[o.$getParent]();
          if (At instanceof Xt && ((kt = At.ui) != null && kt.imageEdit)) {
            this.image || (this.image = new ee({}), this[o.$appendChild](this.image)), this.image[o.$content] = P[o.$content];
            return;
          }
          const Vt = P[o.$nodeName];
          if (this[Vt] === null) {
            for (const ht of Object.getOwnPropertyNames(this)) {
              const Yt = this[ht];
              Yt instanceof a.XFAObject && (this[ht] = null, this[o.$removeChild](Yt));
            }
            this[P[o.$nodeName]] = P, this[o.$appendChild](P);
          } else this[Vt][o.$content] = P[o.$content];
        }
        [o.$text]() {
          if (this.exData) return typeof this.exData[o.$content] == "string" ? this.exData[o.$content].trim() : this.exData[o.$content][o.$text]().trim();
          for (const P of Object.getOwnPropertyNames(this)) {
            if (P === "image") continue;
            const At = this[P];
            if (At instanceof a.XFAObject) return (At[o.$content] || "").toString().trim();
          }
          return null;
        }
        [o.$toHTML](P) {
          for (const At of Object.getOwnPropertyNames(this)) {
            const Vt = this[At];
            if (Vt instanceof a.XFAObject) return Vt[o.$toHTML](P);
          }
          return d.HTMLResult.EMPTY;
        }
      }
      l.Value = wo;
      class U0 extends a.XFAObject {
        constructor(P) {
          super(h, "variables", !0), this.id = P.id || "", this.use = P.use || "", this.usehref = P.usehref || "", this.boolean = new a.XFAObjectArray(), this.date = new a.XFAObjectArray(), this.dateTime = new a.XFAObjectArray(), this.decimal = new a.XFAObjectArray(), this.exData = new a.XFAObjectArray(), this.float = new a.XFAObjectArray(), this.image = new a.XFAObjectArray(), this.integer = new a.XFAObjectArray(), this.manifest = new a.XFAObjectArray(), this.script = new a.XFAObjectArray(), this.text = new a.XFAObjectArray(), this.time = new a.XFAObjectArray();
        }
        [o.$isTransparent]() {
          return !0;
        }
      }
      class is {
        static [g.$buildXFAObject](P, At) {
          if (is.hasOwnProperty(P)) {
            const Vt = is[P](At);
            return Vt[o.$setSetAttributes](At), Vt;
          }
        }
        static appearanceFilter(P) {
          return new U(P);
        }
        static arc(P) {
          return new K(P);
        }
        static area(P) {
          return new X(P);
        }
        static assist(P) {
          return new L(P);
        }
        static barcode(P) {
          return new H(P);
        }
        static bind(P) {
          return new Q(P);
        }
        static bindItems(P) {
          return new N(P);
        }
        static bookend(P) {
          return new V(P);
        }
        static boolean(P) {
          return new Y(P);
        }
        static border(P) {
          return new Z(P);
        }
        static break(P) {
          return new rt(P);
        }
        static breakAfter(P) {
          return new st(P);
        }
        static breakBefore(P) {
          return new mt(P);
        }
        static button(P) {
          return new yt(P);
        }
        static calculate(P) {
          return new at(P);
        }
        static caption(P) {
          return new nt(P);
        }
        static certificate(P) {
          return new q(P);
        }
        static certificates(P) {
          return new D(P);
        }
        static checkButton(P) {
          return new G(P);
        }
        static choiceList(P) {
          return new et(P);
        }
        static color(P) {
          return new J(P);
        }
        static comb(P) {
          return new it(P);
        }
        static connect(P) {
          return new lt(P);
        }
        static contentArea(P) {
          return new ot(P);
        }
        static corner(P) {
          return new ut(P);
        }
        static date(P) {
          return new ct(P);
        }
        static dateTime(P) {
          return new gt(P);
        }
        static dateTimeEdit(P) {
          return new dt(P);
        }
        static decimal(P) {
          return new bt(P);
        }
        static defaultUi(P) {
          return new vt(P);
        }
        static desc(P) {
          return new xt(P);
        }
        static digestMethod(P) {
          return new St(P);
        }
        static digestMethods(P) {
          return new Mt(P);
        }
        static draw(P) {
          return new Et(P);
        }
        static edge(P) {
          return new Ft(P);
        }
        static encoding(P) {
          return new Wt(P);
        }
        static encodings(P) {
          return new Kt(P);
        }
        static encrypt(P) {
          return new qt(P);
        }
        static encryptData(P) {
          return new It(P);
        }
        static encryption(P) {
          return new re(P);
        }
        static encryptionMethod(P) {
          return new le(P);
        }
        static encryptionMethods(P) {
          return new Ce(P);
        }
        static event(P) {
          return new ce(P);
        }
        static exData(P) {
          return new xe(P);
        }
        static exObject(P) {
          return new ve(P);
        }
        static exclGroup(P) {
          return new Oe(P);
        }
        static execute(P) {
          return new He(P);
        }
        static extras(P) {
          return new Zt(P);
        }
        static field(P) {
          return new Xt(P);
        }
        static fill(P) {
          return new Gt(P);
        }
        static filter(P) {
          return new Lt(P);
        }
        static float(P) {
          return new Dt(P);
        }
        static font(P) {
          return new jt(P);
        }
        static format(P) {
          return new Ot(P);
        }
        static handler(P) {
          return new Rt(P);
        }
        static hyphenation(P) {
          return new Tt(P);
        }
        static image(P) {
          return new ee(P);
        }
        static imageEdit(P) {
          return new te(P);
        }
        static integer(P) {
          return new Jt(P);
        }
        static issuers(P) {
          return new pe(P);
        }
        static items(P) {
          return new ye(P);
        }
        static keep(P) {
          return new fe(P);
        }
        static keyUsage(P) {
          return new me(P);
        }
        static line(P) {
          return new we(P);
        }
        static linear(P) {
          return new Fe(P);
        }
        static lockDocument(P) {
          return new Re(P);
        }
        static manifest(P) {
          return new ge(P);
        }
        static margin(P) {
          return new se(P);
        }
        static mdp(P) {
          return new ue(P);
        }
        static medium(P) {
          return new Ae(P);
        }
        static message(P) {
          return new he(P);
        }
        static numericEdit(P) {
          return new de(P);
        }
        static occur(P) {
          return new _e(P);
        }
        static oid(P) {
          return new Qe(P);
        }
        static oids(P) {
          return new $n(P);
        }
        static overflow(P) {
          return new zr(P);
        }
        static pageArea(P) {
          return new Jn(P);
        }
        static pageSet(P) {
          return new di(P);
        }
        static para(P) {
          return new rs(P);
        }
        static passwordEdit(P) {
          return new Ua(P);
        }
        static pattern(P) {
          return new F0(P);
        }
        static picture(P) {
          return new Bc(P);
        }
        static proto(P) {
          return new jc(P);
        }
        static radial(P) {
          return new Uc(P);
        }
        static reason(P) {
          return new Cl(P);
        }
        static reasons(P) {
          return new R0(P);
        }
        static rectangle(P) {
          return new Al(P);
        }
        static ref(P) {
          return new yo(P);
        }
        static script(P) {
          return new Hc(P);
        }
        static setProperty(P) {
          return new Vc(P);
        }
        static signData(P) {
          return new zc(P);
        }
        static signature(P) {
          return new Xc(P);
        }
        static signing(P) {
          return new _l(P);
        }
        static solid(P) {
          return new D0(P);
        }
        static speak(P) {
          return new qc(P);
        }
        static stipple(P) {
          return new kl(P);
        }
        static subform(P) {
          return new bo(P);
        }
        static subformSet(P) {
          return new ya(P);
        }
        static subjectDN(P) {
          return new Wc(P);
        }
        static subjectDNs(P) {
          return new Gc(P);
        }
        static submit(P) {
          return new $0(P);
        }
        static template(P) {
          return new vo(P);
        }
        static text(P) {
          return new Ol(P);
        }
        static textEdit(P) {
          return new Tl(P);
        }
        static time(P) {
          return new Kc(P);
        }
        static timeStamp(P) {
          return new L0(P);
        }
        static toolTip(P) {
          return new N0(P);
        }
        static traversal(P) {
          return new B0(P);
        }
        static traverse(P) {
          return new Yc(P);
        }
        static ui(P) {
          return new Ml(P);
        }
        static validate(P) {
          return new j0(P);
        }
        static value(P) {
          return new wo(P);
        }
        static variables(P) {
          return new U0(P);
        }
      }
      l.TemplateNamespace = is;
    }, (u, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.NamespaceIds = l.$buildXFAObject = void 0;
      const f = Symbol();
      l.$buildXFAObject = f, l.NamespaceIds = { config: { id: 0, check: (o) => o.startsWith("http://www.xfa.org/schema/xci/") }, connectionSet: { id: 1, check: (o) => o.startsWith("http://www.xfa.org/schema/xfa-connection-set/") }, datasets: { id: 2, check: (o) => o.startsWith("http://www.xfa.org/schema/xfa-data/") }, form: { id: 3, check: (o) => o.startsWith("http://www.xfa.org/schema/xfa-form/") }, localeSet: { id: 4, check: (o) => o.startsWith("http://www.xfa.org/schema/xfa-locale-set/") }, pdf: { id: 5, check: (o) => o === "http://ns.adobe.com/xdp/pdf/" }, signature: { id: 6, check: (o) => o === "http://www.w3.org/2000/09/xmldsig#" }, sourceSet: { id: 7, check: (o) => o.startsWith("http://www.xfa.org/schema/xfa-source-set/") }, stylesheet: { id: 8, check: (o) => o === "http://www.w3.org/1999/XSL/Transform" }, template: { id: 9, check: (o) => o.startsWith("http://www.xfa.org/schema/xfa-template/") }, xdc: { id: 10, check: (o) => o.startsWith("http://www.xfa.org/schema/xdc/") }, xdp: { id: 11, check: (o) => o === "http://ns.adobe.com/xdp/" }, xfdf: { id: 12, check: (o) => o === "http://ns.adobe.com/xfdf/" }, xhtml: { id: 13, check: (o) => o === "http://www.w3.org/1999/xhtml" }, xmpmeta: { id: 14, check: (o) => o === "http://ns.adobe.com/xmpmeta/" } };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.addHTML = function(a, d, m) {
        const b = a[o.$extra], w = b.availableSpace, [v, h, x, _] = m;
        switch (a.layout) {
          case "position":
            b.width = Math.max(b.width, v + x), b.height = Math.max(b.height, h + _), b.children.push(d);
            break;
          case "lr-tb":
          case "rl-tb":
            (!b.line || b.attempt === 1) && (b.line = p(a, []), b.children.push(b.line), b.numberInLine = 0), b.numberInLine += 1, b.line.children.push(d), b.attempt === 0 ? (b.currentWidth += x, b.height = Math.max(b.height, b.prevHeight + _)) : (b.currentWidth = x, b.prevHeight = b.height, b.height += _, b.attempt = 0), b.width = Math.max(b.width, b.currentWidth);
            break;
          case "rl-row":
          case "row": {
            b.children.push(d), b.width += x, b.height = Math.max(b.height, _);
            const M = (0, g.measureToString)(b.height);
            for (const O of b.children) O.attributes.style.height = M;
            break;
          }
          case "table":
          case "tb":
            b.width = Math.min(w.width, Math.max(b.width, x)), b.height += _, b.children.push(d);
        }
      }, l.checkDimensions = function(a, d) {
        var x;
        if (a[o.$getTemplateRoot]()[o.$extra].firstUnsplittable === null || a.w === 0 || a.h === 0) return !0;
        const m = a[o.$getSubformParent](), b = ((x = m[o.$extra]) == null ? void 0 : x.attempt) || 0, [, w, v, h] = function(M) {
          let O, E, I = M.w === "" ? NaN : M.w, R = M.h === "" ? NaN : M.h, [W, z] = [0, 0];
          switch (M.anchorType || "") {
            case "bottomCenter":
              [W, z] = [I / 2, R];
              break;
            case "bottomLeft":
              [W, z] = [0, R];
              break;
            case "bottomRight":
              [W, z] = [I, R];
              break;
            case "middleCenter":
              [W, z] = [I / 2, R / 2];
              break;
            case "middleLeft":
              [W, z] = [0, R / 2];
              break;
            case "middleRight":
              [W, z] = [I, R / 2];
              break;
            case "topCenter":
              [W, z] = [I / 2, 0];
              break;
            case "topRight":
              [W, z] = [I, 0];
          }
          switch (M.rotate || 0) {
            case 0:
              [O, E] = [-W, -z];
              break;
            case 90:
              [O, E] = [-z, W], [I, R] = [R, -I];
              break;
            case 180:
              [O, E] = [W, z], [I, R] = [-I, -R];
              break;
            case 270:
              [O, E] = [z, -W], [I, R] = [-R, I];
          }
          return [M.x + O + Math.min(0, I), M.y + E + Math.min(0, R), Math.abs(I), Math.abs(R)];
        }(a);
        switch (m.layout) {
          case "lr-tb":
          case "rl-tb":
            return b === 0 ? a[o.$getTemplateRoot]()[o.$extra].noLayoutFailure ? a.w !== "" ? Math.round(v - d.width) <= 2 : d.width > 2 : !(a.h !== "" && Math.round(h - d.height) > 2) && (a.w !== "" ? Math.round(v - d.width) <= 2 || m[o.$extra].numberInLine === 0 && d.height > 2 : d.width > 2) : !!a[o.$getTemplateRoot]()[o.$extra].noLayoutFailure || !(a.h !== "" && Math.round(h - d.height) > 2) && (a.w === "" || Math.round(v - d.width) <= 2 || !m[o.$isThereMoreWidth]()) && d.height > 2;
          case "table":
          case "tb":
            return !!a[o.$getTemplateRoot]()[o.$extra].noLayoutFailure || (a.h === "" || a[o.$isSplittable]() ? (a.w === "" || Math.round(v - d.width) <= 2 || !m[o.$isThereMoreWidth]()) && d.height > 2 : Math.round(h - d.height) <= 2);
          case "position":
            return a[o.$getTemplateRoot]()[o.$extra].noLayoutFailure || a.h === "" || Math.round(h + w - d.height) <= 2 ? !0 : h + w > a[o.$getTemplateRoot]()[o.$extra].currentContentArea.h;
          case "rl-row":
          case "row":
            return !!a[o.$getTemplateRoot]()[o.$extra].noLayoutFailure || a.h === "" || Math.round(h - d.height) <= 2;
          default:
            return !0;
        }
      }, l.flushHTML = function(a) {
        if (!a[o.$extra]) return null;
        const d = { name: "div", attributes: a[o.$extra].attributes, children: a[o.$extra].children };
        if (a[o.$extra].failingNode) {
          const m = a[o.$extra].failingNode[o.$flushHTML]();
          m && (a.layout.endsWith("-tb") ? d.children.push(p(a, [m])) : d.children.push(m));
        }
        return d.children.length === 0 ? null : d;
      }, l.getAvailableSpace = function(a) {
        const d = a[o.$extra].availableSpace, m = a.margin ? a.margin.topInset + a.margin.bottomInset : 0, b = a.margin ? a.margin.leftInset + a.margin.rightInset : 0;
        switch (a.layout) {
          case "lr-tb":
          case "rl-tb":
            return a[o.$extra].attempt === 0 ? { width: d.width - b - a[o.$extra].currentWidth, height: d.height - m - a[o.$extra].prevHeight } : { width: d.width - b, height: d.height - m - a[o.$extra].height };
          case "rl-row":
          case "row":
            return { width: a[o.$extra].columnWidths.slice(a[o.$extra].currentColumn).reduce((w, v) => w + v), height: d.height - b };
          case "table":
          case "tb":
            return { width: d.width - b, height: d.height - m - a[o.$extra].height };
          default:
            return d;
        }
      };
      var o = f(78), g = f(83);
      function p(n, a) {
        return { name: "div", attributes: { class: [n.layout === "lr-tb" ? "xfaLr" : "xfaRl"] }, children: a };
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.computeBbox = function(_, M, O) {
        let E;
        if (_.w !== "" && _.h !== "") E = [_.x, _.y, _.w, _.h];
        else {
          if (!O) return null;
          let I = _.w;
          if (I === "") {
            if (_.maxW === 0) {
              const W = _[o.$getSubformParent]();
              I = W.layout === "position" && W.w !== "" ? 0 : _.minW;
            } else I = Math.min(_.maxW, O.width);
            M.attributes.style.width = m(I);
          }
          let R = _.h;
          if (R === "") {
            if (_.maxH === 0) {
              const W = _[o.$getSubformParent]();
              R = W.layout === "position" && W.h !== "" ? 0 : _.minH;
            } else R = Math.min(_.maxH, O.height);
            M.attributes.style.height = m(R);
          }
          E = [_.x, _.y, I, R];
        }
        return E;
      }, l.createWrapper = function(_, M) {
        const { attributes: O } = M, { style: E } = O, I = { name: "div", attributes: { class: ["xfaWrapper"], style: /* @__PURE__ */ Object.create(null) }, children: [] };
        if (O.class.push("xfaWrapped"), _.border) {
          const { widths: R, insets: W } = _.border[o.$extra];
          let z, j, $ = W[0], B = W[3];
          const C = W[0] + W[2], T = W[1] + W[3];
          switch (_.border.hand) {
            case "even":
              $ -= R[0] / 2, B -= R[3] / 2, z = `calc(100% + ${(R[1] + R[3]) / 2 - T}px)`, j = `calc(100% + ${(R[0] + R[2]) / 2 - C}px)`;
              break;
            case "left":
              $ -= R[0], B -= R[3], z = `calc(100% + ${R[1] + R[3] - T}px)`, j = `calc(100% + ${R[0] + R[2] - C}px)`;
              break;
            case "right":
              z = T ? `calc(100% - ${T}px)` : "100%", j = C ? `calc(100% - ${C}px)` : "100%";
          }
          const F = ["xfaBorder"];
          v(_.border) && F.push("xfaPrintOnly");
          const S = { name: "div", attributes: { class: F, style: { top: `${$}px`, left: `${B}px`, width: z, height: j } }, children: [] };
          for (const A of ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"]) E[A] !== void 0 && (S.attributes.style[A] = E[A], delete E[A]);
          I.children.push(S, M);
        } else I.children.push(M);
        for (const R of ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"]) E[R] !== void 0 && (I.attributes.style[R] = E[R], delete E[R]);
        return I.attributes.style.position = E.position === "absolute" ? "absolute" : "relative", delete E.position, E.alignSelf && (I.attributes.style.alignSelf = E.alignSelf, delete E.alignSelf), I;
      }, l.fixDimensions = function(_) {
        var O;
        const M = _[o.$getSubformParent]();
        if ((O = M.layout) != null && O.includes("row")) {
          const E = M[o.$extra], I = _.colSpan;
          let R;
          R = I === -1 ? E.columnWidths.slice(E.currentColumn).reduce((W, z) => W + z, 0) : E.columnWidths.slice(E.currentColumn, E.currentColumn + I).reduce((W, z) => W + z, 0), isNaN(R) || (_.w = R);
        }
        M.layout && M.layout !== "position" && (_.x = _.y = 0), _.layout === "table" && _.w === "" && Array.isArray(_.columnWidths) && (_.w = _.columnWidths.reduce((E, I) => E + I, 0));
      }, l.fixTextIndent = function(_) {
        const M = (0, p.getMeasurement)(_.textIndent, "0px");
        if (M >= 0) return;
        const O = "padding" + ((_.textAlign === "right" ? "right" : "left") == "left" ? "Left" : "Right"), E = (0, p.getMeasurement)(_[O], "0px");
        _[O] = E - M + "px";
      }, l.fixURL = function(_) {
        const M = (0, g.createValidAbsoluteUrl)(_, null, { addDefaultProtocol: !0, tryConvertEncoding: !0 });
        return M ? M.href : null;
      }, l.isPrintOnly = v, l.layoutClass = function(_) {
        switch (_.layout) {
          case "position":
          default:
            return "xfaPosition";
          case "lr-tb":
            return "xfaLrTb";
          case "rl-row":
            return "xfaRlRow";
          case "rl-tb":
            return "xfaRlTb";
          case "row":
            return "xfaRow";
          case "table":
            return "xfaTable";
          case "tb":
            return "xfaTb";
        }
      }, l.layoutNode = function(_, M) {
        let O = null, E = null, I = !1;
        if ((!_.w || !_.h) && _.value) {
          let R = 0, W = 0;
          _.margin && (R = _.margin.leftInset + _.margin.rightInset, W = _.margin.topInset + _.margin.bottomInset);
          let z = null, j = null;
          _.para && (j = /* @__PURE__ */ Object.create(null), z = _.para.lineHeight === "" ? null : _.para.lineHeight, j.top = _.para.spaceAbove === "" ? 0 : _.para.spaceAbove, j.bottom = _.para.spaceBelow === "" ? 0 : _.para.spaceBelow, j.left = _.para.marginLeft === "" ? 0 : _.para.marginLeft, j.right = _.para.marginRight === "" ? 0 : _.para.marginRight);
          let $ = _.font;
          if (!$) {
            const T = _[o.$getTemplateRoot]();
            let F = _[o.$getParent]();
            for (; F && F !== T; ) {
              if (F.font) {
                $ = F.font;
                break;
              }
              F = F[o.$getParent]();
            }
          }
          const B = (_.w || M.width) - R, C = _[o.$globalData].fontFinder;
          if (_.value.exData && _.value.exData[o.$content] && _.value.exData.contentType === "text/html") {
            const T = w(_.value.exData[o.$content], $, j, z, C, B);
            E = T.width, O = T.height, I = T.isBroken;
          } else {
            const T = _.value[o.$text]();
            if (T) {
              const F = w(T, $, j, z, C, B);
              E = F.width, O = F.height, I = F.isBroken;
            }
          }
          E === null || _.w || (E += R), O === null || _.h || (O += W);
        }
        return { w: E, h: O, isBroken: I };
      }, l.measureToString = m, l.setAccess = function(_, M) {
        switch (_.access) {
          case "nonInteractive":
            M.push("xfaNonInteractive");
            break;
          case "readOnly":
            M.push("xfaReadOnly");
            break;
          case "protected":
            M.push("xfaDisabled");
        }
      }, l.setFontFamily = function(_, M, O, E) {
        if (!O) {
          delete E.fontFamily;
          return;
        }
        const I = (0, p.stripQuotes)(_.typeface);
        E.fontFamily = `"${I}"`;
        const R = O.find(I);
        if (R) {
          const { fontFamily: W } = R.regular.cssFontInfo;
          W !== I && (E.fontFamily = `"${W}"`);
          const z = h(M);
          if (z && z.lineHeight !== "" || E.lineHeight) return;
          const j = (0, n.selectFont)(_, R);
          j && (E.lineHeight = Math.max(1.2, j.lineHeight));
        }
      }, l.setMinMaxDimensions = function(_, M) {
        _[o.$getSubformParent]().layout === "position" && (_.minW > 0 && (M.minWidth = m(_.minW)), _.maxW > 0 && (M.maxWidth = m(_.maxW)), _.minH > 0 && (M.minHeight = m(_.minH)), _.maxH > 0 && (M.maxHeight = m(_.maxH)));
      }, l.setPara = function(_, M, O) {
        var E;
        if ((E = O.attributes.class) != null && E.includes("xfaRich")) {
          M && (_.h === "" && (M.height = "auto"), _.w === "" && (M.width = "auto"));
          const I = h(_);
          if (I) {
            const R = O.attributes.style;
            switch (R.display = "flex", R.flexDirection = "column", I.vAlign) {
              case "top":
                R.justifyContent = "start";
                break;
              case "bottom":
                R.justifyContent = "end";
                break;
              case "middle":
                R.justifyContent = "center";
            }
            const W = I[o.$toStyle]();
            for (const [z, j] of Object.entries(W)) z in R || (R[z] = j);
          }
        }
      }, l.toStyle = function(_, ...M) {
        const O = /* @__PURE__ */ Object.create(null);
        for (const E of M) {
          const I = _[E];
          if (I !== null) {
            if (b.hasOwnProperty(E)) b[E](_, O);
            else if (I instanceof d.XFAObject) {
              const R = I[o.$toStyle]();
              R ? Object.assign(O, R) : (0, g.warn)(`(DEBUG) - XFA - style for ${E} not implemented yet`);
            }
          }
        }
        return O;
      };
      var o = f(78), g = f(2), p = f(84), n = f(85), a = f(86), d = f(87);
      function m(x) {
        return typeof x == "string" ? "0px" : Number.isInteger(x) ? `${x}px` : `${x.toFixed(2)}px`;
      }
      const b = { anchorType(x, _) {
        const M = x[o.$getSubformParent]();
        if (M && (!M.layout || M.layout === "position"))
          switch ("transform" in _ || (_.transform = ""), x.anchorType) {
            case "bottomCenter":
              _.transform += "translate(-50%, -100%)";
              break;
            case "bottomLeft":
              _.transform += "translate(0,-100%)";
              break;
            case "bottomRight":
              _.transform += "translate(-100%,-100%)";
              break;
            case "middleCenter":
              _.transform += "translate(-50%,-50%)";
              break;
            case "middleLeft":
              _.transform += "translate(0,-50%)";
              break;
            case "middleRight":
              _.transform += "translate(-100%,-50%)";
              break;
            case "topCenter":
              _.transform += "translate(-50%,0)";
              break;
            case "topRight":
              _.transform += "translate(-100%,0)";
          }
      }, dimensions(x, _) {
        var I;
        const M = x[o.$getSubformParent]();
        let O = x.w;
        const E = x.h;
        if ((I = M.layout) != null && I.includes("row")) {
          const R = M[o.$extra], W = x.colSpan;
          let z;
          W === -1 ? (z = R.columnWidths.slice(R.currentColumn).reduce((j, $) => j + $, 0), R.currentColumn = 0) : (z = R.columnWidths.slice(R.currentColumn, R.currentColumn + W).reduce((j, $) => j + $, 0), R.currentColumn = (R.currentColumn + x.colSpan) % R.columnWidths.length), isNaN(z) || (O = x.w = z);
        }
        _.width = O !== "" ? m(O) : "auto", _.height = E !== "" ? m(E) : "auto";
      }, position(x, _) {
        const M = x[o.$getSubformParent]();
        (!(M != null && M.layout) || M.layout === "position") && (_.position = "absolute", _.left = m(x.x), _.top = m(x.y));
      }, rotate(x, _) {
        x.rotate && ("transform" in _ || (_.transform = ""), _.transform += `rotate(-${x.rotate}deg)`, _.transformOrigin = "top left");
      }, presence(x, _) {
        switch (x.presence) {
          case "invisible":
            _.visibility = "hidden";
            break;
          case "hidden":
          case "inactive":
            _.display = "none";
        }
      }, hAlign(x, _) {
        if (x[o.$nodeName] === "para") switch (x.hAlign) {
          case "justifyAll":
            _.textAlign = "justify-all";
            break;
          case "radix":
            _.textAlign = "left";
            break;
          default:
            _.textAlign = x.hAlign;
        }
        else switch (x.hAlign) {
          case "left":
            _.alignSelf = "start";
            break;
          case "center":
            _.alignSelf = "center";
            break;
          case "right":
            _.alignSelf = "end";
        }
      }, margin(x, _) {
        x.margin && (_.margin = x.margin[o.$toStyle]().margin);
      } };
      function w(x, _, M, O, E, I) {
        const R = new a.TextMeasure(_, M, O, E);
        return typeof x == "string" ? R.addString(x) : x[o.$pushGlyphs](R), R.compute(I);
      }
      function v(x) {
        return x.relevant.length > 0 && !x.relevant[0].excluded && x.relevant[0].viewname === "print";
      }
      function h(x) {
        const _ = x[o.$getTemplateRoot]()[o.$extra].paraStack;
        return _.length ? _.at(-1) : null;
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.HTMLResult = void 0, l.getBBox = function(b) {
        if (!b) return { x: -1, y: -1, width: -1, height: -1 };
        const v = b.trim().split(/\s*,\s*/).map((O) => a(O, "-1"));
        if (v.length < 4 || v[2] < 0 || v[3] < 0) return { x: -1, y: -1, width: -1, height: -1 };
        const [h, x, _, M] = v;
        return { x: h, y: x, width: _, height: M };
      }, l.getColor = function(b, w = [0, 0, 0]) {
        let [v, h, x] = w;
        if (!b) return { r: v, g: h, b: x };
        const _ = b.trim().split(/\s*,\s*/).map((M) => Math.min(Math.max(0, parseInt(M.trim(), 10)), 255)).map((M) => isNaN(M) ? 0 : M);
        return _.length < 3 ? { r: v, g: h, b: x } : ([v, h, x] = _, { r: v, g: h, b: x });
      }, l.getFloat = function({ data: b, defaultValue: w, validate: v }) {
        if (!b) return w;
        b = b.trim();
        const h = parseFloat(b);
        return !isNaN(h) && v(h) ? h : w;
      }, l.getInteger = function({ data: b, defaultValue: w, validate: v }) {
        if (!b) return w;
        b = b.trim();
        const h = parseInt(b, 10);
        return !isNaN(h) && v(h) ? h : w;
      }, l.getKeyword = n, l.getMeasurement = a, l.getRatio = function(b) {
        if (!b) return { num: 1, den: 1 };
        const w = b.trim().split(/\s*:\s*/).map((x) => parseFloat(x)).filter((x) => !isNaN(x));
        if (w.length === 1 && w.push(1), w.length === 0) return { num: 1, den: 1 };
        const [v, h] = w;
        return { num: v, den: h };
      }, l.getRelevant = function(b) {
        return b ? b.trim().split(/\s+/).map((w) => ({ excluded: w[0] === "-", viewname: w.substring(1) })) : [];
      }, l.getStringOption = function(b, w) {
        return n({ data: b, defaultValue: w[0], validate: (v) => w.includes(v) });
      }, l.stripQuotes = function(b) {
        return b.startsWith("'") || b.startsWith('"') ? b.slice(1, -1) : b;
      };
      var o = f(2);
      const g = { pt: (m) => m, cm: (m) => m / 2.54 * 72, mm: (m) => m / 25.4 * 72, in: (m) => 72 * m, px: (m) => m }, p = /([+-]?\d+\.?\d*)(.*)/;
      function n({ data: m, defaultValue: b, validate: w }) {
        return m && w(m = m.trim()) ? m : b;
      }
      function a(m, b = "0") {
        if (b || (b = "0"), !m) return a(b);
        const w = m.trim().match(p);
        if (!w) return a(b);
        const [, v, h] = w, x = parseFloat(v);
        if (isNaN(x)) return a(b);
        if (x === 0) return 0;
        const _ = g[h];
        return _ ? _(x) : x;
      }
      class d {
        static get FAILURE() {
          return (0, o.shadow)(this, "FAILURE", new d(!1, null, null, null));
        }
        static get EMPTY() {
          return (0, o.shadow)(this, "EMPTY", new d(!0, null, null, null));
        }
        constructor(b, w, v, h) {
          this.success = b, this.html = w, this.bbox = v, this.breakNode = h;
        }
        isBreak() {
          return !!this.breakNode;
        }
        static breakNode(b) {
          return new d(!1, null, null, b);
        }
        static success(b, w = null) {
          return new d(!0, b, w, null);
        }
      }
      l.HTMLResult = d;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.FontFinder = void 0, l.getMetrics = function(d, m = !1) {
        let b = null;
        if (d) {
          const x = (0, g.stripQuotes)(d.typeface), _ = d[o.$globalData].fontFinder.find(x);
          b = n(d, _);
        }
        if (!b) return { lineHeight: 12, lineGap: 2, lineNoGap: 10 };
        const w = d.size || 10, v = b.lineHeight ? Math.max(m ? 0 : 1.2, b.lineHeight) : 1.2, h = b.lineGap === void 0 ? 0.2 : b.lineGap;
        return { lineHeight: v * w, lineGap: h * w, lineNoGap: Math.max(1, v - h) * w };
      }, l.selectFont = n;
      var o = f(78), g = f(84), p = f(2);
      l.FontFinder = class {
        constructor(d) {
          this.fonts = /* @__PURE__ */ new Map(), this.cache = /* @__PURE__ */ new Map(), this.warned = /* @__PURE__ */ new Set(), this.defaultFont = null, this.add(d);
        }
        add(d, m = null) {
          for (const w of d) this.addPdfFont(w);
          for (const w of this.fonts.values()) w.regular || (w.regular = w.italic || w.bold || w.bolditalic);
          if (!m || m.size === 0) return;
          const b = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
          for (const w of m) this.fonts.set(w, b);
        }
        addPdfFont(d) {
          var x, _, M;
          const m = d.cssFontInfo, b = m.fontFamily;
          let w = this.fonts.get(b);
          w || (w = /* @__PURE__ */ Object.create(null), this.fonts.set(b, w), this.defaultFont || (this.defaultFont = w));
          let v = "";
          const h = parseFloat(m.fontWeight);
          parseFloat(m.italicAngle) !== 0 ? v = h >= 700 ? "bolditalic" : "italic" : h >= 700 && (v = "bold"), v || ((d.name.includes("Bold") || (x = d.psName) != null && x.includes("Bold")) && (v = "bold"), (d.name.includes("Italic") || d.name.endsWith("It") || (_ = d.psName) != null && _.includes("Italic") || (M = d.psName) != null && M.endsWith("It")) && (v += "italic")), v || (v = "regular"), w[v] = d;
        }
        getDefault() {
          return this.defaultFont;
        }
        find(d, m = !0) {
          var x, _;
          let b = this.fonts.get(d) || this.cache.get(d);
          if (b) return b;
          const w = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
          let v = d.replaceAll(w, "");
          if (b = this.fonts.get(v), b)
            return this.cache.set(d, b), b;
          v = v.toLowerCase();
          const h = [];
          for (const [M, O] of this.fonts.entries()) M.replaceAll(w, "").toLowerCase().startsWith(v) && h.push(O);
          if (h.length === 0) for (const [, M] of this.fonts.entries()) (x = M.regular.name) != null && x.replaceAll(w, "").toLowerCase().startsWith(v) && h.push(M);
          if (h.length === 0) {
            v = v.replaceAll(/psmt|mt/gi, "");
            for (const [M, O] of this.fonts.entries()) M.replaceAll(w, "").toLowerCase().startsWith(v) && h.push(O);
          }
          if (h.length === 0) for (const M of this.fonts.values()) (_ = M.regular.name) != null && _.replaceAll(w, "").toLowerCase().startsWith(v) && h.push(M);
          return h.length >= 1 ? (h.length !== 1 && m && (0, p.warn)(`XFA - Too many choices to guess the correct font: ${d}`), this.cache.set(d, h[0]), h[0]) : (m && !this.warned.has(d) && (this.warned.add(d), (0, p.warn)(`XFA - Cannot find the font: ${d}`)), null);
        }
      };
      function n(a, d) {
        return a.posture === "italic" ? a.weight === "bold" ? d.bolditalic : d.italic : a.weight === "bold" ? d.bold : d.regular;
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.TextMeasure = void 0;
      var o = f(85);
      class g {
        constructor(a, d, m, b) {
          if (this.lineHeight = m, this.paraMargin = d || { top: 0, bottom: 0, left: 0, right: 0 }, !a) {
            [this.pdfFont, this.xfaFont] = this.defaultFont(b);
            return;
          }
          this.xfaFont = { typeface: a.typeface, posture: a.posture, weight: a.weight, size: a.size, letterSpacing: a.letterSpacing };
          const w = b.find(a.typeface);
          w ? (this.pdfFont = (0, o.selectFont)(a, w), this.pdfFont || ([this.pdfFont, this.xfaFont] = this.defaultFont(b))) : [this.pdfFont, this.xfaFont] = this.defaultFont(b);
        }
        defaultFont(a) {
          const d = a.find("Helvetica", !1) || a.find("Myriad Pro", !1) || a.find("Arial", !1) || a.getDefault();
          if (d != null && d.regular) {
            const m = d.regular;
            return [m, { typeface: m.cssFontInfo.fontFamily, posture: "normal", weight: "normal", size: 10, letterSpacing: 0 }];
          }
          return [null, { typeface: "Courier", posture: "normal", weight: "normal", size: 10, letterSpacing: 0 }];
        }
      }
      class p {
        constructor(a, d, m, b) {
          this.fontFinder = b, this.stack = [new g(a, d, m, b)];
        }
        pushData(a, d, m) {
          const b = this.stack.at(-1);
          for (const v of ["typeface", "posture", "weight", "size", "letterSpacing"]) a[v] || (a[v] = b.xfaFont[v]);
          for (const v of ["top", "bottom", "left", "right"]) isNaN(d[v]) && (d[v] = b.paraMargin[v]);
          const w = new g(a, d, m || b.lineHeight, this.fontFinder);
          w.pdfFont || (w.pdfFont = b.pdfFont), this.stack.push(w);
        }
        popFont() {
          this.stack.pop();
        }
        topFont() {
          return this.stack.at(-1);
        }
      }
      l.TextMeasure = class {
        constructor(a, d, m, b) {
          this.glyphs = [], this.fontSelector = new p(a, d, m, b), this.extraHeight = 0;
        }
        pushData(a, d, m) {
          this.fontSelector.pushData(a, d, m);
        }
        popFont(a) {
          return this.fontSelector.popFont();
        }
        addPara() {
          const a = this.fontSelector.topFont();
          this.extraHeight += a.paraMargin.top + a.paraMargin.bottom;
        }
        addString(a) {
          if (!a) return;
          const d = this.fontSelector.topFont(), m = d.xfaFont.size;
          if (d.pdfFont) {
            const b = d.xfaFont.letterSpacing, w = d.pdfFont, v = w.lineHeight || 1.2, h = d.lineHeight || Math.max(1.2, v) * m, x = v - (w.lineGap === void 0 ? 0.2 : w.lineGap), _ = Math.max(1, x) * m, M = m / 1e3, O = w.defaultWidth || w.charsToGlyphs(" ")[0].width;
            for (const E of a.split(/[\u2029\n]/)) {
              const I = w.encodeString(E).join(""), R = w.charsToGlyphs(I);
              for (const W of R) {
                const z = W.width || O;
                this.glyphs.push([z * M + b, h, _, W.unicode, !1]);
              }
              this.glyphs.push([0, 0, 0, `
`, !0]);
            }
            this.glyphs.pop();
          } else {
            for (const b of a.split(/[\u2029\n]/)) {
              for (const w of b.split("")) this.glyphs.push([m, 1.2 * m, m, w, !1]);
              this.glyphs.push([0, 0, 0, `
`, !0]);
            }
            this.glyphs.pop();
          }
        }
        compute(a) {
          let d = -1, m = 0, b = 0, w = 0, v = 0, h = 0, x = !1, _ = !0;
          for (let M = 0, O = this.glyphs.length; M < O; M++) {
            const [E, I, R, W, z] = this.glyphs[M], j = W === " ", $ = _ ? R : I;
            z ? (b = Math.max(b, v), v = 0, w += h, h = $, d = -1, m = 0, _ = !1) : j ? v + E > a ? (b = Math.max(b, v), v = 0, w += h, h = $, d = -1, m = 0, x = !0, _ = !1) : (h = Math.max($, h), m = v, v += E, d = M) : v + E > a ? (w += h, h = $, d !== -1 ? (M = d, b = Math.max(b, m), v = 0, d = -1, m = 0) : (b = Math.max(b, v), v = E), x = !0, _ = !1) : (v += E, h = Math.max($, h));
          }
          return b = Math.max(b, v), w += h + this.extraHeight, { width: 1.02 * b, height: w, isBroken: x };
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XmlObject = l.XFAObjectArray = l.XFAObject = l.XFAAttribute = l.StringObject = l.OptionObject = l.Option10 = l.Option01 = l.IntegerObject = l.ContentObject = void 0;
      var o = f(78), g = f(84), p = f(2), n = f(3), a = f(81), d = f(88);
      const m = Symbol(), b = Symbol(), w = Symbol(), v = Symbol("_children"), h = Symbol(), x = Symbol(), _ = Symbol(), M = Symbol(), O = Symbol(), E = Symbol(), I = Symbol(), R = Symbol(), W = Symbol(), z = Symbol("parent"), j = Symbol(), $ = Symbol(), B = Symbol();
      let C = 0;
      const T = a.NamespaceIds.datasets.id;
      class F {
        constructor(N, V, Y = !1) {
          this[o.$namespaceId] = N, this[o.$nodeName] = V, this[I] = Y, this[z] = null, this[v] = [], this[o.$uid] = `${V}${C++}`, this[o.$globalData] = null;
        }
        get isXFAObject() {
          return !0;
        }
        get isXFAObjectArray() {
          return !1;
        }
        createNodes(N) {
          let V = this, Y = null;
          for (const { name: Z, index: rt } of N) {
            for (let st = 0, mt = isFinite(rt) ? rt : 0; st <= mt; st++) {
              const yt = V[o.$namespaceId] === T ? -1 : V[o.$namespaceId];
              Y = new U(yt, Z), V[o.$appendChild](Y);
            }
            V = Y;
          }
          return Y;
        }
        [o.$onChild](N) {
          if (!this[I] || !this[o.$onChildCheck](N)) return !1;
          const V = N[o.$nodeName], Y = this[V];
          if (!(Y instanceof S))
            return Y !== null && this[o.$removeChild](Y), this[V] = N, this[o.$appendChild](N), !0;
          if (Y.push(N))
            return this[o.$appendChild](N), !0;
          let Z = "";
          return this.id ? Z = ` (id: ${this.id})` : this.name && (Z = ` (name: ${this.name} ${this.h.value})`), (0, p.warn)(`XFA - node "${this[o.$nodeName]}"${Z} has already enough "${V}"!`), !1;
        }
        [o.$onChildCheck](N) {
          return this.hasOwnProperty(N[o.$nodeName]) && N[o.$namespaceId] === this[o.$namespaceId];
        }
        [o.$isNsAgnostic]() {
          return !1;
        }
        [o.$acceptWhitespace]() {
          return !1;
        }
        [o.$isCDATAXml]() {
          return !1;
        }
        [o.$isBindable]() {
          return !1;
        }
        [o.$popPara]() {
          this.para && this[o.$getTemplateRoot]()[o.$extra].paraStack.pop();
        }
        [o.$pushPara]() {
          this[o.$getTemplateRoot]()[o.$extra].paraStack.push(this.para);
        }
        [o.$setId](N) {
          this.id && this[o.$namespaceId] === a.NamespaceIds.template.id && N.set(this.id, this);
        }
        [o.$getTemplateRoot]() {
          return this[o.$globalData].template;
        }
        [o.$isSplittable]() {
          return !1;
        }
        [o.$isThereMoreWidth]() {
          return !1;
        }
        [o.$appendChild](N) {
          N[z] = this, this[v].push(N), !N[o.$globalData] && this[o.$globalData] && (N[o.$globalData] = this[o.$globalData]);
        }
        [o.$removeChild](N) {
          const V = this[v].indexOf(N);
          this[v].splice(V, 1);
        }
        [o.$hasSettableValue]() {
          return this.hasOwnProperty("value");
        }
        [o.$setValue](N) {
        }
        [o.$onText](N) {
        }
        [o.$finalize]() {
        }
        [o.$clean](N) {
          delete this[I], this[o.$cleanup] && (N.clean(this[o.$cleanup]), delete this[o.$cleanup]);
        }
        [o.$indexOf](N) {
          return this[v].indexOf(N);
        }
        [o.$insertAt](N, V) {
          V[z] = this, this[v].splice(N, 0, V), !V[o.$globalData] && this[o.$globalData] && (V[o.$globalData] = this[o.$globalData]);
        }
        [o.$isTransparent]() {
          return !this.name;
        }
        [o.$lastAttribute]() {
          return "";
        }
        [o.$text]() {
          return this[v].length === 0 ? this[o.$content] : this[v].map((N) => N[o.$text]()).join("");
        }
        get [w]() {
          const N = Object.getPrototypeOf(this);
          if (!N._attributes) {
            const V = N._attributes = /* @__PURE__ */ new Set();
            for (const Y of Object.getOwnPropertyNames(this)) {
              if (this[Y] === null || this[Y] instanceof F || this[Y] instanceof S) break;
              V.add(Y);
            }
          }
          return (0, p.shadow)(this, w, N._attributes);
        }
        [o.$isDescendent](N) {
          let V = this;
          for (; V; ) {
            if (V === N) return !0;
            V = V[o.$getParent]();
          }
          return !1;
        }
        [o.$getParent]() {
          return this[z];
        }
        [o.$getSubformParent]() {
          return this[o.$getParent]();
        }
        [o.$getChildren](N = null) {
          return N ? this[N] : this[v];
        }
        [o.$dump]() {
          const N = /* @__PURE__ */ Object.create(null);
          this[o.$content] && (N.$content = this[o.$content]);
          for (const V of Object.getOwnPropertyNames(this)) {
            const Y = this[V];
            Y !== null && (Y instanceof F ? N[V] = Y[o.$dump]() : Y instanceof S ? Y.isEmpty() || (N[V] = Y.dump()) : N[V] = Y);
          }
          return N;
        }
        [o.$toStyle]() {
          return null;
        }
        [o.$toHTML]() {
          return g.HTMLResult.EMPTY;
        }
        *[o.$getContainedChildren]() {
          for (const N of this[o.$getChildren]()) yield N;
        }
        *[M](N, V) {
          for (const Y of this[o.$getContainedChildren]()) if (!N || V === N.has(Y[o.$nodeName])) {
            const Z = this[o.$getAvailableSpace](), rt = Y[o.$toHTML](Z);
            rt.success || (this[o.$extra].failingNode = Y), yield rt;
          }
        }
        [o.$flushHTML]() {
          return null;
        }
        [o.$addHTML](N, V) {
          this[o.$extra].children.push(N);
        }
        [o.$getAvailableSpace]() {
        }
        [o.$childrenToHTML]({ filter: N = null, include: V = !0 }) {
          if (this[o.$extra].generator) {
            const Y = this[o.$getAvailableSpace](), Z = this[o.$extra].failingNode[o.$toHTML](Y);
            if (!Z.success) return Z;
            Z.html && this[o.$addHTML](Z.html, Z.bbox), delete this[o.$extra].failingNode;
          } else this[o.$extra].generator = this[M](N, V);
          for (; ; ) {
            const Y = this[o.$extra].generator.next();
            if (Y.done) break;
            const Z = Y.value;
            if (!Z.success) return Z;
            Z.html && this[o.$addHTML](Z.html, Z.bbox);
          }
          return this[o.$extra].generator = null, g.HTMLResult.EMPTY;
        }
        [o.$setSetAttributes](N) {
          this[$] = new Set(Object.keys(N));
        }
        [E](N) {
          const V = this[w], Y = this[$];
          return [...N].filter((Z) => V.has(Z) && !Y.has(Z));
        }
        [o.$resolvePrototypes](N, V = /* @__PURE__ */ new Set()) {
          for (const Y of this[v]) Y[j](N, V);
        }
        [j](N, V) {
          const Y = this[O](N, V);
          Y ? this[m](Y, N, V) : this[o.$resolvePrototypes](N, V);
        }
        [O](N, V) {
          const { use: Y, usehref: Z } = this;
          if (!Y && !Z) return null;
          let rt = null, st = null, mt = null, yt = Y;
          if (Z ? (yt = Z, Z.startsWith("#som(") && Z.endsWith(")") ? st = Z.slice(5, -1) : Z.startsWith(".#som(") && Z.endsWith(")") ? st = Z.slice(6, -1) : Z.startsWith("#") ? mt = Z.slice(1) : Z.startsWith(".#") && (mt = Z.slice(2))) : Y.startsWith("#") ? mt = Y.slice(1) : st = Y, this.use = this.usehref = "", mt ? rt = N.get(mt) : (rt = (0, d.searchNode)(N.get(o.$root), this, st, !0, !1), rt && (rt = rt[0])), !rt)
            return (0, p.warn)(`XFA - Invalid prototype reference: ${yt}.`), null;
          if (rt[o.$nodeName] !== this[o.$nodeName])
            return (0, p.warn)(`XFA - Incompatible prototype: ${rt[o.$nodeName]} !== ${this[o.$nodeName]}.`), null;
          if (V.has(rt))
            return (0, p.warn)("XFA - Cycle detected in prototypes use."), null;
          V.add(rt);
          const at = rt[O](N, V);
          return at && rt[m](at, N, V), rt[o.$resolvePrototypes](N, V), V.delete(rt), rt;
        }
        [m](N, V, Y) {
          if (Y.has(N)) {
            (0, p.warn)("XFA - Cycle detected in prototypes use.");
            return;
          }
          !this[o.$content] && N[o.$content] && (this[o.$content] = N[o.$content]), new Set(Y).add(N);
          for (const Z of this[E](N[$]))
            this[Z] = N[Z], this[$] && this[$].add(Z);
          for (const Z of Object.getOwnPropertyNames(this)) {
            if (this[w].has(Z)) continue;
            const rt = this[Z], st = N[Z];
            if (rt instanceof S) {
              for (const mt of rt[v]) mt[j](V, Y);
              for (let mt = rt[v].length, yt = st[v].length; mt < yt; mt++) {
                const at = N[v][mt][o.$clone]();
                if (!rt.push(at)) break;
                at[z] = this, this[v].push(at), at[j](V, Y);
              }
            } else if (rt === null) {
              if (st !== null) {
                const mt = st[o.$clone]();
                mt[z] = this, this[Z] = mt, this[v].push(mt), mt[j](V, Y);
              }
            } else
              rt[o.$resolvePrototypes](V, Y), st && rt[m](st, V, Y);
          }
        }
        static [h](N) {
          return Array.isArray(N) ? N.map((V) => F[h](V)) : typeof N == "object" && N !== null ? Object.assign({}, N) : N;
        }
        [o.$clone]() {
          const N = Object.create(Object.getPrototypeOf(this));
          for (const V of Object.getOwnPropertySymbols(this)) try {
            N[V] = this[V];
          } catch {
            (0, p.shadow)(N, V, this[V]);
          }
          N[o.$uid] = `${N[o.$nodeName]}${C++}`, N[v] = [];
          for (const V of Object.getOwnPropertyNames(this)) {
            if (this[w].has(V)) {
              N[V] = F[h](this[V]);
              continue;
            }
            const Y = this[V];
            N[V] = Y instanceof S ? new S(Y[R]) : null;
          }
          for (const V of this[v]) {
            const Y = V[o.$nodeName], Z = V[o.$clone]();
            N[v].push(Z), Z[z] = N, N[Y] === null ? N[Y] = Z : N[Y][v].push(Z);
          }
          return N;
        }
        [o.$getChildren](N = null) {
          return N ? this[v].filter((V) => V[o.$nodeName] === N) : this[v];
        }
        [o.$getChildrenByClass](N) {
          return this[N];
        }
        [o.$getChildrenByName](N, V, Y = !0) {
          return Array.from(this[o.$getChildrenByNameIt](N, V, Y));
        }
        *[o.$getChildrenByNameIt](N, V, Y = !0) {
          if (N !== "parent") {
            for (const Z of this[v])
              Z[o.$nodeName] === N && (yield Z), Z.name === N && (yield Z), (V || Z[o.$isTransparent]()) && (yield* Z[o.$getChildrenByNameIt](N, V, !1));
            Y && this[w].has(N) && (yield new A(this, N, this[N]));
          } else yield this[z];
        }
      }
      l.XFAObject = F;
      class S {
        constructor(N = 1 / 0) {
          this[R] = N, this[v] = [];
        }
        get isXFAObject() {
          return !1;
        }
        get isXFAObjectArray() {
          return !0;
        }
        push(N) {
          return this[v].length <= this[R] ? (this[v].push(N), !0) : ((0, p.warn)(`XFA - node "${N[o.$nodeName]}" accepts no more than ${this[R]} children`), !1);
        }
        isEmpty() {
          return this[v].length === 0;
        }
        dump() {
          return this[v].length === 1 ? this[v][0][o.$dump]() : this[v].map((N) => N[o.$dump]());
        }
        [o.$clone]() {
          const N = new S(this[R]);
          return N[v] = this[v].map((V) => V[o.$clone]()), N;
        }
        get children() {
          return this[v];
        }
        clear() {
          this[v].length = 0;
        }
      }
      l.XFAObjectArray = S;
      class A {
        constructor(N, V, Y) {
          this[z] = N, this[o.$nodeName] = V, this[o.$content] = Y, this[o.$consumed] = !1, this[o.$uid] = "attribute" + C++;
        }
        [o.$getParent]() {
          return this[z];
        }
        [o.$isDataValue]() {
          return !0;
        }
        [o.$getDataValue]() {
          return this[o.$content].trim();
        }
        [o.$setValue](N) {
          N = N.value || "", this[o.$content] = N.toString();
        }
        [o.$text]() {
          return this[o.$content];
        }
        [o.$isDescendent](N) {
          return this[z] === N || this[z][o.$isDescendent](N);
        }
      }
      l.XFAAttribute = A;
      class U extends F {
        constructor(N, V, Y = {}) {
          if (super(N, V), this[o.$content] = "", this[x] = null, V !== "#text") {
            const Z = /* @__PURE__ */ new Map();
            this[b] = Z;
            for (const [rt, st] of Object.entries(Y)) Z.set(rt, new A(this, rt, st));
            if (Y.hasOwnProperty(o.$nsAttributes)) {
              const rt = Y[o.$nsAttributes].xfa.dataNode;
              rt !== void 0 && (rt === "dataGroup" ? this[x] = !1 : rt === "dataValue" && (this[x] = !0));
            }
          }
          this[o.$consumed] = !1;
        }
        [o.$toString](N) {
          const V = this[o.$nodeName];
          if (V === "#text") {
            N.push((0, n.encodeToXmlString)(this[o.$content]));
            return;
          }
          const Y = (0, p.utf8StringToString)(V), Z = this[o.$namespaceId] === T ? "xfa:" : "";
          N.push(`<${Z}${Y}`);
          for (const [rt, st] of this[b].entries()) {
            const mt = (0, p.utf8StringToString)(rt);
            N.push(` ${mt}="${(0, n.encodeToXmlString)(st[o.$content])}"`);
          }
          if (this[x] !== null && (this[x] ? N.push(' xfa:dataNode="dataValue"') : N.push(' xfa:dataNode="dataGroup"')), this[o.$content] || this[v].length !== 0) {
            if (N.push(">"), this[o.$content]) typeof this[o.$content] == "string" ? N.push((0, n.encodeToXmlString)(this[o.$content])) : this[o.$content][o.$toString](N);
            else for (const rt of this[v]) rt[o.$toString](N);
            N.push(`</${Z}${Y}>`);
          } else N.push("/>");
        }
        [o.$onChild](N) {
          if (this[o.$content]) {
            const V = new U(this[o.$namespaceId], "#text");
            this[o.$appendChild](V), V[o.$content] = this[o.$content], this[o.$content] = "";
          }
          return this[o.$appendChild](N), !0;
        }
        [o.$onText](N) {
          this[o.$content] += N;
        }
        [o.$finalize]() {
          if (this[o.$content] && this[v].length > 0) {
            const N = new U(this[o.$namespaceId], "#text");
            this[o.$appendChild](N), N[o.$content] = this[o.$content], delete this[o.$content];
          }
        }
        [o.$toHTML]() {
          return this[o.$nodeName] === "#text" ? g.HTMLResult.success({ name: "#text", value: this[o.$content] }) : g.HTMLResult.EMPTY;
        }
        [o.$getChildren](N = null) {
          return N ? this[v].filter((V) => V[o.$nodeName] === N) : this[v];
        }
        [o.$getAttributes]() {
          return this[b];
        }
        [o.$getChildrenByClass](N) {
          const V = this[b].get(N);
          return V !== void 0 ? V : this[o.$getChildren](N);
        }
        *[o.$getChildrenByNameIt](N, V) {
          const Y = this[b].get(N);
          Y && (yield Y);
          for (const Z of this[v])
            Z[o.$nodeName] === N && (yield Z), V && (yield* Z[o.$getChildrenByNameIt](N, V));
        }
        *[o.$getAttributeIt](N, V) {
          const Y = this[b].get(N);
          !Y || V && Y[o.$consumed] || (yield Y);
          for (const Z of this[v]) yield* Z[o.$getAttributeIt](N, V);
        }
        *[o.$getRealChildrenByNameIt](N, V, Y) {
          for (const Z of this[v])
            Z[o.$nodeName] !== N || Y && Z[o.$consumed] || (yield Z), V && (yield* Z[o.$getRealChildrenByNameIt](N, V, Y));
        }
        [o.$isDataValue]() {
          return this[x] === null ? this[v].length === 0 || this[v][0][o.$namespaceId] === a.NamespaceIds.xhtml.id : this[x];
        }
        [o.$getDataValue]() {
          return this[x] === null ? this[v].length === 0 ? this[o.$content].trim() : this[v][0][o.$namespaceId] === a.NamespaceIds.xhtml.id ? this[v][0][o.$text]().trim() : null : this[o.$content].trim();
        }
        [o.$setValue](N) {
          N = N.value || "", this[o.$content] = N.toString();
        }
        [o.$dump](N = !1) {
          const V = /* @__PURE__ */ Object.create(null);
          N && (V.$ns = this[o.$namespaceId]), this[o.$content] && (V.$content = this[o.$content]), V.$name = this[o.$nodeName], V.children = [];
          for (const Y of this[v]) V.children.push(Y[o.$dump](N));
          V.attributes = /* @__PURE__ */ Object.create(null);
          for (const [Y, Z] of this[b]) V.attributes[Y] = Z[o.$content];
          return V;
        }
      }
      l.XmlObject = U;
      class K extends F {
        constructor(N, V) {
          super(N, V), this[o.$content] = "";
        }
        [o.$onText](N) {
          this[o.$content] += N;
        }
        [o.$finalize]() {
        }
      }
      l.ContentObject = K;
      class X extends K {
        constructor(N, V, Y) {
          super(N, V), this[W] = Y;
        }
        [o.$finalize]() {
          this[o.$content] = (0, g.getKeyword)({ data: this[o.$content], defaultValue: this[W][0], validate: (N) => this[W].includes(N) });
        }
        [o.$clean](N) {
          super[o.$clean](N), delete this[W];
        }
      }
      l.OptionObject = X;
      class L extends K {
        [o.$finalize]() {
          this[o.$content] = this[o.$content].trim();
        }
      }
      l.StringObject = L;
      class H extends K {
        constructor(N, V, Y, Z) {
          super(N, V), this[_] = Y, this[B] = Z;
        }
        [o.$finalize]() {
          this[o.$content] = (0, g.getInteger)({ data: this[o.$content], defaultValue: this[_], validate: this[B] });
        }
        [o.$clean](N) {
          super[o.$clean](N), delete this[_], delete this[B];
        }
      }
      l.IntegerObject = H, l.Option01 = class extends H {
        constructor(N, V) {
          super(N, V, 0, (Y) => Y === 1);
        }
      }, l.Option10 = class extends H {
        constructor(N, V) {
          super(N, V, 1, (Y) => Y === 0);
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.createDataNode = function(v, h, x) {
        const _ = b(x);
        if (!_ || _.some((E) => E.operator === a.dotDot)) return null;
        const M = d.get(_[0].name);
        let O = 0;
        M ? (v = M(v, h), O = 1) : v = h || v;
        for (let E = _.length; O < E; O++) {
          const { name: I, operator: R, index: W } = _[O];
          if (!isFinite(W))
            return _[O].index = 0, v.createNodes(_.slice(O));
          let z;
          switch (R) {
            case a.dot:
              z = v[o.$getChildrenByName](I, !1);
              break;
            case a.dotDot:
              z = v[o.$getChildrenByName](I, !0);
              break;
            case a.dotHash:
              z = v[o.$getChildrenByClass](I), z = z.isXFAObjectArray ? z.children : [z];
          }
          if (z.length === 0) return v.createNodes(_.slice(O));
          if (!(W < z.length))
            return _[O].index = W - z.length, v.createNodes(_.slice(O));
          {
            const j = z[W];
            if (!j.isXFAObject)
              return (0, g.warn)("XFA - Cannot create a node."), null;
            v = j;
          }
        }
        return null;
      }, l.searchNode = function(v, h, x, _ = !0, M = !0) {
        const O = b(x, _);
        if (!O) return null;
        const E = d.get(O[0].name);
        let I, R = 0;
        E ? (I = !0, v = [E(v, h)], R = 1) : (I = h === null, v = [h || v]);
        for (let W = O.length; R < W; R++) {
          const { name: z, cacheName: j, operator: $, index: B } = O[R], C = [];
          for (const T of v) {
            if (!T.isXFAObject) continue;
            let F, S;
            if (M && (S = m.get(T), S || (S = /* @__PURE__ */ new Map(), m.set(T, S)), F = S.get(j)), !F) {
              switch ($) {
                case a.dot:
                  F = T[o.$getChildrenByName](z, !1);
                  break;
                case a.dotDot:
                  F = T[o.$getChildrenByName](z, !0);
                  break;
                case a.dotHash:
                  F = T[o.$getChildrenByClass](z), F = F.isXFAObjectArray ? F.children : [F];
              }
              M && S.set(j, F);
            }
            F.length > 0 && C.push(F);
          }
          if (C.length !== 0 || I || R !== 0) v = isFinite(B) ? C.filter((T) => B < T.length).map((T) => T[B]) : C.flat();
          else {
            if (!(h = h[o.$getParent]())) return null;
            R = -1, v = [h];
          }
        }
        return v.length === 0 ? null : v;
      };
      var o = f(78), g = f(2);
      const p = /^[^.[]+/, n = /^[^\]]+/, a = { dot: 0, dotDot: 1, dotHash: 2, dotBracket: 3, dotParen: 4 }, d = /* @__PURE__ */ new Map([["$data", (w, v) => w.datasets ? w.datasets.data : w], ["$record", (w, v) => (w.datasets ? w.datasets.data : w)[o.$getChildren]()[0]], ["$template", (w, v) => w.template], ["$connectionSet", (w, v) => w.connectionSet], ["$form", (w, v) => w.form], ["$layout", (w, v) => w.layout], ["$host", (w, v) => w.host], ["$dataWindow", (w, v) => w.dataWindow], ["$event", (w, v) => w.event], ["!", (w, v) => w.datasets], ["$xfa", (w, v) => w], ["xfa", (w, v) => w], ["$", (w, v) => v]]), m = /* @__PURE__ */ new WeakMap();
      function b(w, v, h = !0) {
        let x = w.match(p);
        if (!x) return null;
        let [_] = x;
        const M = [{ name: _, cacheName: "." + _, index: 0, js: null, formCalc: null, operator: a.dot }];
        let O = _.length;
        for (; O < w.length; ) {
          const I = O;
          if (w.charAt(O++) === "[") {
            if (x = w.slice(O).match(n), !x)
              return (0, g.warn)("XFA - Invalid index in SOM expression"), null;
            M.at(-1).index = (E = (E = x[0]).trim()) === "*" ? 1 / 0 : parseInt(E, 10) || 0, O += x[0].length + 1;
            continue;
          }
          let R;
          switch (w.charAt(O)) {
            case ".":
              if (!v) return null;
              O++, R = a.dotDot;
              break;
            case "#":
              O++, R = a.dotHash;
              break;
            case "[":
              if (h)
                return (0, g.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now."), null;
              R = a.dotBracket;
              break;
            case "(":
              if (h)
                return (0, g.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now."), null;
              R = a.dotParen;
              break;
            default:
              R = a.dot;
          }
          if (x = w.slice(O).match(p), !x) break;
          [_] = x, O += _.length, M.push({ name: _, cacheName: w.slice(I, O), operator: R, index: 0, js: null, formCalc: null });
        }
        var E;
        return M;
      }
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.DataHandler = void 0;
      var o = f(78);
      l.DataHandler = class {
        constructor(p, n) {
          this.data = n, this.dataset = p.datasets || null;
        }
        serialize(p) {
          const n = [[-1, this.data[o.$getChildren]()]];
          for (; n.length > 0; ) {
            const d = n.at(-1), [m, b] = d;
            if (m + 1 === b.length) {
              n.pop();
              continue;
            }
            const w = b[++d[0]], v = p.get(w[o.$uid]);
            if (v) w[o.$setValue](v);
            else {
              const x = w[o.$getAttributes]();
              for (const _ of x.values()) {
                const M = p.get(_[o.$uid]);
                if (M) {
                  _[o.$setValue](M);
                  break;
                }
              }
            }
            const h = w[o.$getChildren]();
            h.length > 0 && n.push([-1, h]);
          }
          const a = ['<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'];
          if (this.dataset) for (const d of this.dataset[o.$getChildren]()) d[o.$nodeName] !== "data" && d[o.$toString](a);
          return this.data[o.$toString](a), a.push("</xfa:datasets>"), a.join("");
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XFAParser = void 0;
      var o = f(78), g = f(71), p = f(91), n = f(2);
      class a extends g.XMLParserBase {
        constructor(m = null, b = !1) {
          super(), this._builder = new p.Builder(m), this._stack = [], this._globalData = { usedTypefaces: /* @__PURE__ */ new Set() }, this._ids = /* @__PURE__ */ new Map(), this._current = this._builder.buildRoot(this._ids), this._errorCode = g.XMLParserErrorCode.NoError, this._whiteRegex = /^\s+$/, this._nbsps = /\xa0+/g, this._richText = b;
        }
        parse(m) {
          if (this.parseXml(m), this._errorCode === g.XMLParserErrorCode.NoError)
            return this._current[o.$finalize](), this._current.element;
        }
        onText(m) {
          m = m.replace(this._nbsps, (b) => b.slice(1) + " "), this._richText || this._current[o.$acceptWhitespace]() ? this._current[o.$onText](m, this._richText) : this._whiteRegex.test(m) || this._current[o.$onText](m.trim());
        }
        onCdata(m) {
          this._current[o.$onText](m);
        }
        _mkAttributes(m, b) {
          let w = null, v = null;
          const h = /* @__PURE__ */ Object.create({});
          for (const { name: x, value: _ } of m) if (x === "xmlns") w ? (0, n.warn)(`XFA - multiple namespace definition in <${b}>`) : w = _;
          else if (x.startsWith("xmlns:")) {
            const M = x.substring(6);
            v || (v = []), v.push({ prefix: M, value: _ });
          } else {
            const M = x.indexOf(":");
            if (M === -1) h[x] = _;
            else {
              let O = h[o.$nsAttributes];
              O || (O = h[o.$nsAttributes] = /* @__PURE__ */ Object.create(null));
              const [E, I] = [x.slice(0, M), x.slice(M + 1)];
              (O[E] || (O[E] = /* @__PURE__ */ Object.create(null)))[I] = _;
            }
          }
          return [w, v, h];
        }
        _getNameAndPrefix(m, b) {
          const w = m.indexOf(":");
          return w === -1 ? [m, null] : [m.substring(w + 1), b ? "" : m.substring(0, w)];
        }
        onBeginElement(m, b, w) {
          const [v, h, x] = this._mkAttributes(b, m), [_, M] = this._getNameAndPrefix(m, this._builder.isNsAgnostic()), O = this._builder.build({ nsPrefix: M, name: _, attributes: x, namespace: v, prefixes: h });
          O[o.$globalData] = this._globalData, w ? (O[o.$finalize](), this._current[o.$onChild](O) && O[o.$setId](this._ids), O[o.$clean](this._builder)) : (this._stack.push(this._current), this._current = O);
        }
        onEndElement(m) {
          const b = this._current;
          if (b[o.$isCDATAXml]() && typeof b[o.$content] == "string") {
            const w = new a();
            w._globalData = this._globalData;
            const v = w.parse(b[o.$content]);
            b[o.$content] = null, b[o.$onChild](v);
          }
          b[o.$finalize](), this._current = this._stack.pop(), this._current[o.$onChild](b) && b[o.$setId](this._ids), b[o.$clean](this._builder);
        }
        onError(m) {
          this._errorCode = m;
        }
      }
      l.XFAParser = a;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Builder = void 0;
      var o = f(81), g = f(78), p = f(92), n = f(80), a = f(101), d = f(2), m = f(87);
      class b extends m.XFAObject {
        constructor(h) {
          super(-1, "root", /* @__PURE__ */ Object.create(null)), this.element = null, this[g.$ids] = h;
        }
        [g.$onChild](h) {
          return this.element = h, !0;
        }
        [g.$finalize]() {
          super[g.$finalize](), this.element.template instanceof n.Template && (this[g.$ids].set(g.$root, this.element), this.element.template[g.$resolvePrototypes](this[g.$ids]), this.element.template[g.$ids] = this[g.$ids]);
        }
      }
      class w extends m.XFAObject {
        constructor() {
          super(-1, "", /* @__PURE__ */ Object.create(null));
        }
        [g.$onChild](h) {
          return !1;
        }
      }
      l.Builder = class {
        constructor(h = null) {
          this._namespaceStack = [], this._nsAgnosticLevel = 0, this._namespacePrefixes = /* @__PURE__ */ new Map(), this._namespaces = /* @__PURE__ */ new Map(), this._nextNsId = Math.max(...Object.values(o.NamespaceIds).map(({ id: x }) => x)), this._currentNamespace = h || new a.UnknownNamespace(++this._nextNsId);
        }
        buildRoot(h) {
          return new b(h);
        }
        build({ nsPrefix: h, name: x, attributes: _, namespace: M, prefixes: O }) {
          const E = M !== null;
          if (E && (this._namespaceStack.push(this._currentNamespace), this._currentNamespace = this._searchNamespace(M)), O && this._addNamespacePrefix(O), _.hasOwnProperty(g.$nsAttributes)) {
            const W = p.NamespaceSetUp.datasets, z = _[g.$nsAttributes];
            let j = null;
            for (const [$, B] of Object.entries(z))
              if (this._getNamespaceToUse($) === W) {
                j = { xfa: B };
                break;
              }
            j ? _[g.$nsAttributes] = j : delete _[g.$nsAttributes];
          }
          const I = this._getNamespaceToUse(h), R = (I == null ? void 0 : I[o.$buildXFAObject](x, _)) || new w();
          return R[g.$isNsAgnostic]() && this._nsAgnosticLevel++, (E || O || R[g.$isNsAgnostic]()) && (R[g.$cleanup] = { hasNamespace: E, prefixes: O, nsAgnostic: R[g.$isNsAgnostic]() }), R;
        }
        isNsAgnostic() {
          return this._nsAgnosticLevel > 0;
        }
        _searchNamespace(h) {
          let x = this._namespaces.get(h);
          if (x) return x;
          for (const [_, { check: M }] of Object.entries(o.NamespaceIds)) if (M(h)) {
            if (x = p.NamespaceSetUp[_], x)
              return this._namespaces.set(h, x), x;
            break;
          }
          return x = new a.UnknownNamespace(++this._nextNsId), this._namespaces.set(h, x), x;
        }
        _addNamespacePrefix(h) {
          for (const { prefix: x, value: _ } of h) {
            const M = this._searchNamespace(_);
            let O = this._namespacePrefixes.get(x);
            O || (O = [], this._namespacePrefixes.set(x, O)), O.push(M);
          }
        }
        _getNamespaceToUse(h) {
          if (!h) return this._currentNamespace;
          const x = this._namespacePrefixes.get(h);
          return (x == null ? void 0 : x.length) > 0 ? x.at(-1) : ((0, d.warn)(`Unknown namespace prefix: ${h}.`), null);
        }
        clean(h) {
          const { hasNamespace: x, prefixes: _, nsAgnostic: M } = h;
          x && (this._currentNamespace = this._namespaceStack.pop()), _ && _.forEach(({ prefix: O }) => {
            this._namespacePrefixes.get(O).pop();
          }), M && this._nsAgnosticLevel--;
        }
      };
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.NamespaceSetUp = void 0;
      var o = f(93), g = f(94), p = f(95), n = f(96), a = f(97), d = f(98), m = f(80), b = f(99), w = f(100);
      const v = { config: o.ConfigNamespace, connection: g.ConnectionSetNamespace, datasets: p.DatasetsNamespace, localeSet: n.LocaleSetNamespace, signature: a.SignatureNamespace, stylesheet: d.StylesheetNamespace, template: m.TemplateNamespace, xdp: b.XdpNamespace, xhtml: w.XhtmlNamespace };
      l.NamespaceSetUp = v;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ConfigNamespace = void 0;
      var o = f(81), g = f(78), p = f(87), n = f(84), a = f(2);
      const d = o.NamespaceIds.config.id;
      class m extends p.XFAObject {
        constructor(ht) {
          super(d, "acrobat", !0), this.acrobat7 = null, this.autoSave = null, this.common = null, this.validate = null, this.validateApprovalSignatures = null, this.submitUrl = new p.XFAObjectArray();
        }
      }
      class b extends p.XFAObject {
        constructor(ht) {
          super(d, "acrobat7", !0), this.dynamicRender = null;
        }
      }
      class w extends p.OptionObject {
        constructor(ht) {
          super(d, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]);
        }
      }
      class v extends p.OptionObject {
        constructor(ht) {
          super(d, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]);
        }
      }
      class h extends p.Option01 {
        constructor(ht) {
          super(d, "addSilentPrint");
        }
      }
      class x extends p.Option01 {
        constructor(ht) {
          super(d, "addViewerPreferences");
        }
      }
      class _ extends p.Option10 {
        constructor(ht) {
          super(d, "adjustData");
        }
      }
      class M extends p.IntegerObject {
        constructor(ht) {
          super(d, "adobeExtensionLevel", 0, (Yt) => Yt >= 1 && Yt <= 8);
        }
      }
      class O extends p.XFAObject {
        constructor(ht) {
          super(d, "agent", !0), this.name = ht.name ? ht.name.trim() : "", this.common = new p.XFAObjectArray();
        }
      }
      class E extends p.ContentObject {
        constructor(ht) {
          super(d, "alwaysEmbed");
        }
      }
      class I extends p.StringObject {
        constructor(ht) {
          super(d, "amd");
        }
      }
      class R extends p.XFAObject {
        constructor(ht) {
          super(d, "area"), this.level = (0, n.getInteger)({ data: ht.level, defaultValue: 0, validate: (Yt) => Yt >= 1 && Yt <= 3 }), this.name = (0, n.getStringOption)(ht.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
        }
      }
      class W extends p.OptionObject {
        constructor(ht) {
          super(d, "attributes", ["preserve", "delegate", "ignore"]);
        }
      }
      class z extends p.OptionObject {
        constructor(ht) {
          super(d, "autoSave", ["disabled", "enabled"]);
        }
      }
      class j extends p.StringObject {
        constructor(ht) {
          super(d, "base");
        }
      }
      class $ extends p.XFAObject {
        constructor(ht) {
          super(d, "batchOutput"), this.format = (0, n.getStringOption)(ht.format, ["none", "concat", "zip", "zipCompress"]);
        }
      }
      class B extends p.ContentObject {
        constructor(ht) {
          super(d, "behaviorOverride");
        }
        [g.$finalize]() {
          this[g.$content] = new Map(this[g.$content].trim().split(/\s+/).filter((ht) => ht.includes(":")).map((ht) => ht.split(":", 2)));
        }
      }
      class C extends p.XFAObject {
        constructor(ht) {
          super(d, "cache", !0), this.templateCache = null;
        }
      }
      class T extends p.Option01 {
        constructor(ht) {
          super(d, "change");
        }
      }
      class F extends p.XFAObject {
        constructor(ht) {
          super(d, "common", !0), this.data = null, this.locale = null, this.localeSet = null, this.messaging = null, this.suppressBanner = null, this.template = null, this.validationMessaging = null, this.versionControl = null, this.log = new p.XFAObjectArray();
        }
      }
      class S extends p.XFAObject {
        constructor(ht) {
          super(d, "compress"), this.scope = (0, n.getStringOption)(ht.scope, ["imageOnly", "document"]);
        }
      }
      class A extends p.Option01 {
        constructor(ht) {
          super(d, "compressLogicalStructure");
        }
      }
      class U extends p.Option10 {
        constructor(ht) {
          super(d, "compressObjectStream");
        }
      }
      class K extends p.XFAObject {
        constructor(ht) {
          super(d, "compression", !0), this.compressLogicalStructure = null, this.compressObjectStream = null, this.level = null, this.type = null;
        }
      }
      class X extends p.XFAObject {
        constructor(ht) {
          super(d, "config", !0), this.acrobat = null, this.present = null, this.trace = null, this.agent = new p.XFAObjectArray();
        }
      }
      class L extends p.OptionObject {
        constructor(ht) {
          super(d, "conformance", ["A", "B"]);
        }
      }
      class H extends p.Option01 {
        constructor(ht) {
          super(d, "contentCopy");
        }
      }
      class Q extends p.IntegerObject {
        constructor(ht) {
          super(d, "copies", 1, (Yt) => Yt >= 1);
        }
      }
      class N extends p.StringObject {
        constructor(ht) {
          super(d, "creator");
        }
      }
      class V extends p.IntegerObject {
        constructor(ht) {
          super(d, "currentPage", 0, (Yt) => Yt >= 0);
        }
      }
      class Y extends p.XFAObject {
        constructor(ht) {
          super(d, "data", !0), this.adjustData = null, this.attributes = null, this.incrementalLoad = null, this.outputXSL = null, this.range = null, this.record = null, this.startNode = null, this.uri = null, this.window = null, this.xsl = null, this.excludeNS = new p.XFAObjectArray(), this.transform = new p.XFAObjectArray();
        }
      }
      class Z extends p.XFAObject {
        constructor(ht) {
          super(d, "debug", !0), this.uri = null;
        }
      }
      class rt extends p.ContentObject {
        constructor(ht) {
          super(d, "defaultTypeface"), this.writingScript = (0, n.getStringOption)(ht.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
        }
      }
      class st extends p.OptionObject {
        constructor(ht) {
          super(d, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]);
        }
      }
      class mt extends p.Option01 {
        constructor(ht) {
          super(d, "documentAssembly");
        }
      }
      class yt extends p.XFAObject {
        constructor(ht) {
          super(d, "driver", !0), this.name = ht.name ? ht.name.trim() : "", this.fontInfo = null, this.xdc = null;
        }
      }
      class at extends p.OptionObject {
        constructor(ht) {
          super(d, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]);
        }
      }
      class nt extends p.OptionObject {
        constructor(ht) {
          super(d, "dynamicRender", ["forbidden", "required"]);
        }
      }
      class q extends p.Option01 {
        constructor(ht) {
          super(d, "embed");
        }
      }
      class D extends p.Option01 {
        constructor(ht) {
          super(d, "encrypt");
        }
      }
      class G extends p.XFAObject {
        constructor(ht) {
          super(d, "encryption", !0), this.encrypt = null, this.encryptionLevel = null, this.permissions = null;
        }
      }
      class et extends p.OptionObject {
        constructor(ht) {
          super(d, "encryptionLevel", ["40bit", "128bit"]);
        }
      }
      class J extends p.StringObject {
        constructor(ht) {
          super(d, "enforce");
        }
      }
      class it extends p.XFAObject {
        constructor(ht) {
          super(d, "equate"), this.force = (0, n.getInteger)({ data: ht.force, defaultValue: 1, validate: (Yt) => Yt === 0 }), this.from = ht.from || "", this.to = ht.to || "";
        }
      }
      class lt extends p.XFAObject {
        constructor(ht) {
          super(d, "equateRange"), this.from = ht.from || "", this.to = ht.to || "", this._unicodeRange = ht.unicodeRange || "";
        }
        get unicodeRange() {
          const ht = [], Yt = /U\+([0-9a-fA-F]+)/, be = this._unicodeRange;
          for (let ke of be.split(",").map((je) => je.trim()).filter((je) => !!je))
            ke = ke.split("-", 2).map((je) => {
              const Ze = je.match(Yt);
              return Ze ? parseInt(Ze[1], 16) : 0;
            }), ke.length === 1 && ke.push(ke[0]), ht.push(ke);
          return (0, a.shadow)(this, "unicodeRange", ht);
        }
      }
      class ot extends p.ContentObject {
        constructor(ht) {
          super(d, "exclude");
        }
        [g.$finalize]() {
          this[g.$content] = this[g.$content].trim().split(/\s+/).filter((ht) => ht && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(ht));
        }
      }
      class ut extends p.StringObject {
        constructor(ht) {
          super(d, "excludeNS");
        }
      }
      class ct extends p.OptionObject {
        constructor(ht) {
          super(d, "flipLabel", ["usePrinterSetting", "on", "off"]);
        }
      }
      class gt extends p.XFAObject {
        constructor(ht) {
          super(d, "fontInfo", !0), this.embed = null, this.map = null, this.subsetBelow = null, this.alwaysEmbed = new p.XFAObjectArray(), this.defaultTypeface = new p.XFAObjectArray(), this.neverEmbed = new p.XFAObjectArray();
        }
      }
      class dt extends p.Option01 {
        constructor(ht) {
          super(d, "formFieldFilling");
        }
      }
      class bt extends p.StringObject {
        constructor(ht) {
          super(d, "groupParent");
        }
      }
      class vt extends p.OptionObject {
        constructor(ht) {
          super(d, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]);
        }
      }
      class xt extends p.StringObject {
        constructor(ht) {
          super(d, "includeXDPContent");
        }
      }
      class St extends p.OptionObject {
        constructor(ht) {
          super(d, "incrementalLoad", ["none", "forwardOnly"]);
        }
      }
      class Mt extends p.Option01 {
        constructor(ht) {
          super(d, "incrementalMerge");
        }
      }
      class Et extends p.Option01 {
        constructor(ht) {
          super(d, "interactive");
        }
      }
      class Ft extends p.OptionObject {
        constructor(ht) {
          super(d, "jog", ["usePrinterSetting", "none", "pageSet"]);
        }
      }
      class Wt extends p.XFAObject {
        constructor(ht) {
          super(d, "labelPrinter", !0), this.name = (0, n.getStringOption)(ht.name, ["zpl", "dpl", "ipl", "tcpl"]), this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
        }
      }
      class Kt extends p.OptionObject {
        constructor(ht) {
          super(d, "layout", ["paginate", "panel"]);
        }
      }
      class qt extends p.IntegerObject {
        constructor(ht) {
          super(d, "level", 0, (Yt) => Yt > 0);
        }
      }
      class It extends p.Option01 {
        constructor(ht) {
          super(d, "linearized");
        }
      }
      class re extends p.StringObject {
        constructor(ht) {
          super(d, "locale");
        }
      }
      class le extends p.StringObject {
        constructor(ht) {
          super(d, "localeSet");
        }
      }
      class Ce extends p.XFAObject {
        constructor(ht) {
          super(d, "log", !0), this.mode = null, this.threshold = null, this.to = null, this.uri = null;
        }
      }
      class ce extends p.XFAObject {
        constructor(ht) {
          super(d, "map", !0), this.equate = new p.XFAObjectArray(), this.equateRange = new p.XFAObjectArray();
        }
      }
      class xe extends p.XFAObject {
        constructor(ht) {
          super(d, "mediumInfo", !0), this.map = null;
        }
      }
      class ve extends p.XFAObject {
        constructor(ht) {
          super(d, "message", !0), this.msgId = null, this.severity = null;
        }
      }
      class Oe extends p.XFAObject {
        constructor(ht) {
          super(d, "messaging", !0), this.message = new p.XFAObjectArray();
        }
      }
      class He extends p.OptionObject {
        constructor(ht) {
          super(d, "mode", ["append", "overwrite"]);
        }
      }
      class Zt extends p.Option01 {
        constructor(ht) {
          super(d, "modifyAnnots");
        }
      }
      class Xt extends p.IntegerObject {
        constructor(ht) {
          super(d, "msgId", 1, (Yt) => Yt >= 1);
        }
      }
      class Gt extends p.StringObject {
        constructor(ht) {
          super(d, "nameAttr");
        }
      }
      class Lt extends p.ContentObject {
        constructor(ht) {
          super(d, "neverEmbed");
        }
      }
      class Dt extends p.IntegerObject {
        constructor(ht) {
          super(d, "numberOfCopies", null, (Yt) => Yt >= 2 && Yt <= 5);
        }
      }
      class jt extends p.XFAObject {
        constructor(ht) {
          super(d, "openAction", !0), this.destination = null;
        }
      }
      class Ot extends p.XFAObject {
        constructor(ht) {
          super(d, "output", !0), this.to = null, this.type = null, this.uri = null;
        }
      }
      class Rt extends p.StringObject {
        constructor(ht) {
          super(d, "outputBin");
        }
      }
      class Tt extends p.XFAObject {
        constructor(ht) {
          super(d, "outputXSL", !0), this.uri = null;
        }
      }
      class ee extends p.OptionObject {
        constructor(ht) {
          super(d, "overprint", ["none", "both", "draw", "field"]);
        }
      }
      class te extends p.StringObject {
        constructor(ht) {
          super(d, "packets");
        }
        [g.$finalize]() {
          this[g.$content] !== "*" && (this[g.$content] = this[g.$content].trim().split(/\s+/).filter((ht) => ["config", "datasets", "template", "xfdf", "xslt"].includes(ht)));
        }
      }
      class Jt extends p.XFAObject {
        constructor(ht) {
          super(d, "pageOffset"), this.x = (0, n.getInteger)({ data: ht.x, defaultValue: "useXDCSetting", validate: (Yt) => !0 }), this.y = (0, n.getInteger)({ data: ht.y, defaultValue: "useXDCSetting", validate: (Yt) => !0 });
        }
      }
      class pe extends p.StringObject {
        constructor(ht) {
          super(d, "pageRange");
        }
        [g.$finalize]() {
          const ht = this[g.$content].trim().split(/\s+/).map((be) => parseInt(be, 10)), Yt = [];
          for (let be = 0, ke = ht.length; be < ke; be += 2) Yt.push(ht.slice(be, be + 2));
          this[g.$content] = Yt;
        }
      }
      class ye extends p.OptionObject {
        constructor(ht) {
          super(d, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]);
        }
      }
      class fe extends p.OptionObject {
        constructor(ht) {
          super(d, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]);
        }
      }
      class me extends p.IntegerObject {
        constructor(ht) {
          super(d, "part", 1, (Yt) => !1);
        }
      }
      class we extends p.XFAObject {
        constructor(ht) {
          super(d, "pcl", !0), this.name = ht.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.pageOffset = null, this.staple = null, this.xdc = null;
        }
      }
      class Fe extends p.XFAObject {
        constructor(ht) {
          super(d, "pdf", !0), this.name = ht.name || "", this.adobeExtensionLevel = null, this.batchOutput = null, this.compression = null, this.creator = null, this.encryption = null, this.fontInfo = null, this.interactive = null, this.linearized = null, this.openAction = null, this.pdfa = null, this.producer = null, this.renderPolicy = null, this.scriptModel = null, this.silentPrint = null, this.submitFormat = null, this.tagged = null, this.version = null, this.viewerPreferences = null, this.xdc = null;
        }
      }
      class Re extends p.XFAObject {
        constructor(ht) {
          super(d, "pdfa", !0), this.amd = null, this.conformance = null, this.includeXDPContent = null, this.part = null;
        }
      }
      class ge extends p.XFAObject {
        constructor(ht) {
          super(d, "permissions", !0), this.accessibleContent = null, this.change = null, this.contentCopy = null, this.documentAssembly = null, this.formFieldFilling = null, this.modifyAnnots = null, this.plaintextMetadata = null, this.print = null, this.printHighQuality = null;
        }
      }
      class se extends p.Option01 {
        constructor(ht) {
          super(d, "pickTrayByPDFSize");
        }
      }
      class ue extends p.StringObject {
        constructor(ht) {
          super(d, "picture");
        }
      }
      class Ae extends p.Option01 {
        constructor(ht) {
          super(d, "plaintextMetadata");
        }
      }
      class he extends p.OptionObject {
        constructor(ht) {
          super(d, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]);
        }
      }
      class de extends p.XFAObject {
        constructor(ht) {
          super(d, "present", !0), this.behaviorOverride = null, this.cache = null, this.common = null, this.copies = null, this.destination = null, this.incrementalMerge = null, this.layout = null, this.output = null, this.overprint = null, this.pagination = null, this.paginationOverride = null, this.script = null, this.validate = null, this.xdp = null, this.driver = new p.XFAObjectArray(), this.labelPrinter = new p.XFAObjectArray(), this.pcl = new p.XFAObjectArray(), this.pdf = new p.XFAObjectArray(), this.ps = new p.XFAObjectArray(), this.submitUrl = new p.XFAObjectArray(), this.webClient = new p.XFAObjectArray(), this.zpl = new p.XFAObjectArray();
        }
      }
      class _e extends p.Option01 {
        constructor(ht) {
          super(d, "print");
        }
      }
      class Qe extends p.Option01 {
        constructor(ht) {
          super(d, "printHighQuality");
        }
      }
      class $n extends p.OptionObject {
        constructor(ht) {
          super(d, "printScaling", ["appdefault", "noScaling"]);
        }
      }
      class zr extends p.StringObject {
        constructor(ht) {
          super(d, "printerName");
        }
      }
      class Jn extends p.StringObject {
        constructor(ht) {
          super(d, "producer");
        }
      }
      class di extends p.XFAObject {
        constructor(ht) {
          super(d, "ps", !0), this.name = ht.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.staple = null, this.xdc = null;
        }
      }
      class rs extends p.ContentObject {
        constructor(ht) {
          super(d, "range");
        }
        [g.$finalize]() {
          this[g.$content] = this[g.$content].trim().split(/\s*,\s*/, 2).map((ht) => ht.split("-").map((Yt) => parseInt(Yt.trim(), 10))).filter((ht) => ht.every((Yt) => !isNaN(Yt))).map((ht) => (ht.length === 1 && ht.push(ht[0]), ht));
        }
      }
      class Ua extends p.ContentObject {
        constructor(ht) {
          super(d, "record");
        }
        [g.$finalize]() {
          this[g.$content] = this[g.$content].trim();
          const ht = parseInt(this[g.$content], 10);
          !isNaN(ht) && ht >= 0 && (this[g.$content] = ht);
        }
      }
      class F0 extends p.ContentObject {
        constructor(ht) {
          super(d, "relevant");
        }
        [g.$finalize]() {
          this[g.$content] = this[g.$content].trim().split(/\s+/);
        }
      }
      class Bc extends p.ContentObject {
        constructor(ht) {
          super(d, "rename");
        }
        [g.$finalize]() {
          this[g.$content] = this[g.$content].trim(), (this[g.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[g.$content])) && (0, a.warn)("XFA - Rename: invalid XFA name");
        }
      }
      class jc extends p.OptionObject {
        constructor(ht) {
          super(d, "renderPolicy", ["server", "client"]);
        }
      }
      class Uc extends p.OptionObject {
        constructor(ht) {
          super(d, "runScripts", ["both", "client", "none", "server"]);
        }
      }
      class Cl extends p.XFAObject {
        constructor(ht) {
          super(d, "script", !0), this.currentPage = null, this.exclude = null, this.runScripts = null;
        }
      }
      class R0 extends p.OptionObject {
        constructor(ht) {
          super(d, "scriptModel", ["XFA", "none"]);
        }
      }
      class Al extends p.OptionObject {
        constructor(ht) {
          super(d, "severity", ["ignore", "error", "information", "trace", "warning"]);
        }
      }
      class yo extends p.XFAObject {
        constructor(ht) {
          super(d, "silentPrint", !0), this.addSilentPrint = null, this.printerName = null;
        }
      }
      class Hc extends p.XFAObject {
        constructor(ht) {
          super(d, "staple"), this.mode = (0, n.getStringOption)(ht.mode, ["usePrinterSetting", "on", "off"]);
        }
      }
      class Vc extends p.StringObject {
        constructor(ht) {
          super(d, "startNode");
        }
      }
      class zc extends p.IntegerObject {
        constructor(ht) {
          super(d, "startPage", 0, (Yt) => !0);
        }
      }
      class Xc extends p.OptionObject {
        constructor(ht) {
          super(d, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]);
        }
      }
      class _l extends p.StringObject {
        constructor(ht) {
          super(d, "submitUrl");
        }
      }
      class D0 extends p.IntegerObject {
        constructor(ht) {
          super(d, "subsetBelow", 100, (Yt) => Yt >= 0 && Yt <= 100);
        }
      }
      class qc extends p.Option01 {
        constructor(ht) {
          super(d, "suppressBanner");
        }
      }
      class kl extends p.Option01 {
        constructor(ht) {
          super(d, "tagged");
        }
      }
      class bo extends p.XFAObject {
        constructor(ht) {
          super(d, "template", !0), this.base = null, this.relevant = null, this.startPage = null, this.uri = null, this.xsl = null;
        }
      }
      class ya extends p.OptionObject {
        constructor(ht) {
          super(d, "threshold", ["trace", "error", "information", "warning"]);
        }
      }
      class Wc extends p.OptionObject {
        constructor(ht) {
          super(d, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]);
        }
      }
      class Gc extends p.XFAObject {
        constructor(ht) {
          super(d, "templateCache"), this.maxEntries = (0, n.getInteger)({ data: ht.maxEntries, defaultValue: 5, validate: (Yt) => Yt >= 0 });
        }
      }
      class $0 extends p.XFAObject {
        constructor(ht) {
          super(d, "trace", !0), this.area = new p.XFAObjectArray();
        }
      }
      class vo extends p.XFAObject {
        constructor(ht) {
          super(d, "transform", !0), this.groupParent = null, this.ifEmpty = null, this.nameAttr = null, this.picture = null, this.presence = null, this.rename = null, this.whitespace = null;
        }
      }
      class Ol extends p.OptionObject {
        constructor(ht) {
          super(d, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]);
        }
      }
      class Tl extends p.StringObject {
        constructor(ht) {
          super(d, "uri");
        }
      }
      class Kc extends p.OptionObject {
        constructor(ht) {
          super(d, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]);
        }
      }
      class L0 extends p.ContentObject {
        constructor(ht) {
          super(d, "validateApprovalSignatures");
        }
        [g.$finalize]() {
          this[g.$content] = this[g.$content].trim().split(/\s+/).filter((ht) => ["docReady", "postSign"].includes(ht));
        }
      }
      class N0 extends p.OptionObject {
        constructor(ht) {
          super(d, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]);
        }
      }
      class B0 extends p.OptionObject {
        constructor(ht) {
          super(d, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]);
        }
      }
      class Yc extends p.XFAObject {
        constructor(ht) {
          super(d, "VersionControl"), this.outputBelow = (0, n.getStringOption)(ht.outputBelow, ["warn", "error", "update"]), this.sourceAbove = (0, n.getStringOption)(ht.sourceAbove, ["warn", "error"]), this.sourceBelow = (0, n.getStringOption)(ht.sourceBelow, ["update", "maintain"]);
        }
      }
      class Ml extends p.XFAObject {
        constructor(ht) {
          super(d, "viewerPreferences", !0), this.ADBE_JSConsole = null, this.ADBE_JSDebugger = null, this.addViewerPreferences = null, this.duplexOption = null, this.enforce = null, this.numberOfCopies = null, this.pageRange = null, this.pickTrayByPDFSize = null, this.printScaling = null;
        }
      }
      class j0 extends p.XFAObject {
        constructor(ht) {
          super(d, "webClient", !0), this.name = ht.name ? ht.name.trim() : "", this.fontInfo = null, this.xdc = null;
        }
      }
      class wo extends p.OptionObject {
        constructor(ht) {
          super(d, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]);
        }
      }
      class U0 extends p.ContentObject {
        constructor(ht) {
          super(d, "window");
        }
        [g.$finalize]() {
          const ht = this[g.$content].trim().split(/\s*,\s*/, 2).map((Yt) => parseInt(Yt, 10));
          ht.some((Yt) => isNaN(Yt)) ? this[g.$content] = [0, 0] : (ht.length === 1 && ht.push(ht[0]), this[g.$content] = ht);
        }
      }
      class is extends p.XFAObject {
        constructor(ht) {
          super(d, "xdc", !0), this.uri = new p.XFAObjectArray(), this.xsl = new p.XFAObjectArray();
        }
      }
      class Ht extends p.XFAObject {
        constructor(ht) {
          super(d, "xdp", !0), this.packets = null;
        }
      }
      class P extends p.XFAObject {
        constructor(ht) {
          super(d, "xsl", !0), this.debug = null, this.uri = null;
        }
      }
      class At extends p.XFAObject {
        constructor(ht) {
          super(d, "zpl", !0), this.name = ht.name ? ht.name.trim() : "", this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
        }
      }
      class Vt {
        static [o.$buildXFAObject](ht, Yt) {
          if (Vt.hasOwnProperty(ht)) return Vt[ht](Yt);
        }
        static acrobat(ht) {
          return new m(ht);
        }
        static acrobat7(ht) {
          return new b(ht);
        }
        static ADBE_JSConsole(ht) {
          return new w(ht);
        }
        static ADBE_JSDebugger(ht) {
          return new v(ht);
        }
        static addSilentPrint(ht) {
          return new h(ht);
        }
        static addViewerPreferences(ht) {
          return new x(ht);
        }
        static adjustData(ht) {
          return new _(ht);
        }
        static adobeExtensionLevel(ht) {
          return new M(ht);
        }
        static agent(ht) {
          return new O(ht);
        }
        static alwaysEmbed(ht) {
          return new E(ht);
        }
        static amd(ht) {
          return new I(ht);
        }
        static area(ht) {
          return new R(ht);
        }
        static attributes(ht) {
          return new W(ht);
        }
        static autoSave(ht) {
          return new z(ht);
        }
        static base(ht) {
          return new j(ht);
        }
        static batchOutput(ht) {
          return new $(ht);
        }
        static behaviorOverride(ht) {
          return new B(ht);
        }
        static cache(ht) {
          return new C(ht);
        }
        static change(ht) {
          return new T(ht);
        }
        static common(ht) {
          return new F(ht);
        }
        static compress(ht) {
          return new S(ht);
        }
        static compressLogicalStructure(ht) {
          return new A(ht);
        }
        static compressObjectStream(ht) {
          return new U(ht);
        }
        static compression(ht) {
          return new K(ht);
        }
        static config(ht) {
          return new X(ht);
        }
        static conformance(ht) {
          return new L(ht);
        }
        static contentCopy(ht) {
          return new H(ht);
        }
        static copies(ht) {
          return new Q(ht);
        }
        static creator(ht) {
          return new N(ht);
        }
        static currentPage(ht) {
          return new V(ht);
        }
        static data(ht) {
          return new Y(ht);
        }
        static debug(ht) {
          return new Z(ht);
        }
        static defaultTypeface(ht) {
          return new rt(ht);
        }
        static destination(ht) {
          return new st(ht);
        }
        static documentAssembly(ht) {
          return new mt(ht);
        }
        static driver(ht) {
          return new yt(ht);
        }
        static duplexOption(ht) {
          return new at(ht);
        }
        static dynamicRender(ht) {
          return new nt(ht);
        }
        static embed(ht) {
          return new q(ht);
        }
        static encrypt(ht) {
          return new D(ht);
        }
        static encryption(ht) {
          return new G(ht);
        }
        static encryptionLevel(ht) {
          return new et(ht);
        }
        static enforce(ht) {
          return new J(ht);
        }
        static equate(ht) {
          return new it(ht);
        }
        static equateRange(ht) {
          return new lt(ht);
        }
        static exclude(ht) {
          return new ot(ht);
        }
        static excludeNS(ht) {
          return new ut(ht);
        }
        static flipLabel(ht) {
          return new ct(ht);
        }
        static fontInfo(ht) {
          return new gt(ht);
        }
        static formFieldFilling(ht) {
          return new dt(ht);
        }
        static groupParent(ht) {
          return new bt(ht);
        }
        static ifEmpty(ht) {
          return new vt(ht);
        }
        static includeXDPContent(ht) {
          return new xt(ht);
        }
        static incrementalLoad(ht) {
          return new St(ht);
        }
        static incrementalMerge(ht) {
          return new Mt(ht);
        }
        static interactive(ht) {
          return new Et(ht);
        }
        static jog(ht) {
          return new Ft(ht);
        }
        static labelPrinter(ht) {
          return new Wt(ht);
        }
        static layout(ht) {
          return new Kt(ht);
        }
        static level(ht) {
          return new qt(ht);
        }
        static linearized(ht) {
          return new It(ht);
        }
        static locale(ht) {
          return new re(ht);
        }
        static localeSet(ht) {
          return new le(ht);
        }
        static log(ht) {
          return new Ce(ht);
        }
        static map(ht) {
          return new ce(ht);
        }
        static mediumInfo(ht) {
          return new xe(ht);
        }
        static message(ht) {
          return new ve(ht);
        }
        static messaging(ht) {
          return new Oe(ht);
        }
        static mode(ht) {
          return new He(ht);
        }
        static modifyAnnots(ht) {
          return new Zt(ht);
        }
        static msgId(ht) {
          return new Xt(ht);
        }
        static nameAttr(ht) {
          return new Gt(ht);
        }
        static neverEmbed(ht) {
          return new Lt(ht);
        }
        static numberOfCopies(ht) {
          return new Dt(ht);
        }
        static openAction(ht) {
          return new jt(ht);
        }
        static output(ht) {
          return new Ot(ht);
        }
        static outputBin(ht) {
          return new Rt(ht);
        }
        static outputXSL(ht) {
          return new Tt(ht);
        }
        static overprint(ht) {
          return new ee(ht);
        }
        static packets(ht) {
          return new te(ht);
        }
        static pageOffset(ht) {
          return new Jt(ht);
        }
        static pageRange(ht) {
          return new pe(ht);
        }
        static pagination(ht) {
          return new ye(ht);
        }
        static paginationOverride(ht) {
          return new fe(ht);
        }
        static part(ht) {
          return new me(ht);
        }
        static pcl(ht) {
          return new we(ht);
        }
        static pdf(ht) {
          return new Fe(ht);
        }
        static pdfa(ht) {
          return new Re(ht);
        }
        static permissions(ht) {
          return new ge(ht);
        }
        static pickTrayByPDFSize(ht) {
          return new se(ht);
        }
        static picture(ht) {
          return new ue(ht);
        }
        static plaintextMetadata(ht) {
          return new Ae(ht);
        }
        static presence(ht) {
          return new he(ht);
        }
        static present(ht) {
          return new de(ht);
        }
        static print(ht) {
          return new _e(ht);
        }
        static printHighQuality(ht) {
          return new Qe(ht);
        }
        static printScaling(ht) {
          return new $n(ht);
        }
        static printerName(ht) {
          return new zr(ht);
        }
        static producer(ht) {
          return new Jn(ht);
        }
        static ps(ht) {
          return new di(ht);
        }
        static range(ht) {
          return new rs(ht);
        }
        static record(ht) {
          return new Ua(ht);
        }
        static relevant(ht) {
          return new F0(ht);
        }
        static rename(ht) {
          return new Bc(ht);
        }
        static renderPolicy(ht) {
          return new jc(ht);
        }
        static runScripts(ht) {
          return new Uc(ht);
        }
        static script(ht) {
          return new Cl(ht);
        }
        static scriptModel(ht) {
          return new R0(ht);
        }
        static severity(ht) {
          return new Al(ht);
        }
        static silentPrint(ht) {
          return new yo(ht);
        }
        static staple(ht) {
          return new Hc(ht);
        }
        static startNode(ht) {
          return new Vc(ht);
        }
        static startPage(ht) {
          return new zc(ht);
        }
        static submitFormat(ht) {
          return new Xc(ht);
        }
        static submitUrl(ht) {
          return new _l(ht);
        }
        static subsetBelow(ht) {
          return new D0(ht);
        }
        static suppressBanner(ht) {
          return new qc(ht);
        }
        static tagged(ht) {
          return new kl(ht);
        }
        static template(ht) {
          return new bo(ht);
        }
        static templateCache(ht) {
          return new Gc(ht);
        }
        static threshold(ht) {
          return new ya(ht);
        }
        static to(ht) {
          return new Wc(ht);
        }
        static trace(ht) {
          return new $0(ht);
        }
        static transform(ht) {
          return new vo(ht);
        }
        static type(ht) {
          return new Ol(ht);
        }
        static uri(ht) {
          return new Tl(ht);
        }
        static validate(ht) {
          return new Kc(ht);
        }
        static validateApprovalSignatures(ht) {
          return new L0(ht);
        }
        static validationMessaging(ht) {
          return new N0(ht);
        }
        static version(ht) {
          return new B0(ht);
        }
        static versionControl(ht) {
          return new Yc(ht);
        }
        static viewerPreferences(ht) {
          return new Ml(ht);
        }
        static webClient(ht) {
          return new j0(ht);
        }
        static whitespace(ht) {
          return new wo(ht);
        }
        static window(ht) {
          return new U0(ht);
        }
        static xdc(ht) {
          return new is(ht);
        }
        static xdp(ht) {
          return new Ht(ht);
        }
        static xsl(ht) {
          return new P(ht);
        }
        static zpl(ht) {
          return new At(ht);
        }
      }
      l.ConfigNamespace = Vt;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ConnectionSetNamespace = void 0;
      var o = f(81), g = f(87);
      const p = o.NamespaceIds.connectionSet.id;
      class n extends g.XFAObject {
        constructor(R) {
          super(p, "connectionSet", !0), this.wsdlConnection = new g.XFAObjectArray(), this.xmlConnection = new g.XFAObjectArray(), this.xsdConnection = new g.XFAObjectArray();
        }
      }
      class a extends g.XFAObject {
        constructor(R) {
          super(p, "effectiveInputPolicy"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class d extends g.XFAObject {
        constructor(R) {
          super(p, "effectiveOutputPolicy"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class m extends g.StringObject {
        constructor(R) {
          super(p, "operation"), this.id = R.id || "", this.input = R.input || "", this.name = R.name || "", this.output = R.output || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class b extends g.StringObject {
        constructor(R) {
          super(p, "rootElement"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class w extends g.StringObject {
        constructor(R) {
          super(p, "soapAction"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class v extends g.StringObject {
        constructor(R) {
          super(p, "soapAddress"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class h extends g.StringObject {
        constructor(R) {
          super(p, "uri"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class x extends g.StringObject {
        constructor(R) {
          super(p, "wsdlAddress"), this.id = R.id || "", this.name = R.name || "", this.use = R.use || "", this.usehref = R.usehref || "";
        }
      }
      class _ extends g.XFAObject {
        constructor(R) {
          super(p, "wsdlConnection", !0), this.dataDescription = R.dataDescription || "", this.name = R.name || "", this.effectiveInputPolicy = null, this.effectiveOutputPolicy = null, this.operation = null, this.soapAction = null, this.soapAddress = null, this.wsdlAddress = null;
        }
      }
      class M extends g.XFAObject {
        constructor(R) {
          super(p, "xmlConnection", !0), this.dataDescription = R.dataDescription || "", this.name = R.name || "", this.uri = null;
        }
      }
      class O extends g.XFAObject {
        constructor(R) {
          super(p, "xsdConnection", !0), this.dataDescription = R.dataDescription || "", this.name = R.name || "", this.rootElement = null, this.uri = null;
        }
      }
      class E {
        static [o.$buildXFAObject](R, W) {
          if (E.hasOwnProperty(R)) return E[R](W);
        }
        static connectionSet(R) {
          return new n(R);
        }
        static effectiveInputPolicy(R) {
          return new a(R);
        }
        static effectiveOutputPolicy(R) {
          return new d(R);
        }
        static operation(R) {
          return new m(R);
        }
        static rootElement(R) {
          return new b(R);
        }
        static soapAction(R) {
          return new w(R);
        }
        static soapAddress(R) {
          return new v(R);
        }
        static uri(R) {
          return new h(R);
        }
        static wsdlAddress(R) {
          return new x(R);
        }
        static wsdlConnection(R) {
          return new _(R);
        }
        static xmlConnection(R) {
          return new M(R);
        }
        static xsdConnection(R) {
          return new O(R);
        }
      }
      l.ConnectionSetNamespace = E;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.DatasetsNamespace = void 0;
      var o = f(78), g = f(81), p = f(87);
      const n = g.NamespaceIds.datasets.id;
      class a extends p.XmlObject {
        constructor(w) {
          super(n, "data", w);
        }
        [o.$isNsAgnostic]() {
          return !0;
        }
      }
      class d extends p.XFAObject {
        constructor(w) {
          super(n, "datasets", !0), this.data = null, this.Signature = null;
        }
        [o.$onChild](w) {
          const v = w[o.$nodeName];
          (v === "data" && w[o.$namespaceId] === n || v === "Signature" && w[o.$namespaceId] === g.NamespaceIds.signature.id) && (this[v] = w), this[o.$appendChild](w);
        }
      }
      class m {
        static [g.$buildXFAObject](w, v) {
          if (m.hasOwnProperty(w)) return m[w](v);
        }
        static datasets(w) {
          return new d(w);
        }
        static data(w) {
          return new a(w);
        }
      }
      l.DatasetsNamespace = m;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.LocaleSetNamespace = void 0;
      var o = f(81), g = f(87), p = f(84);
      const n = o.NamespaceIds.localeSet.id;
      class a extends g.XFAObject {
        constructor(X) {
          super(n, "calendarSymbols", !0), this.name = "gregorian", this.dayNames = new g.XFAObjectArray(2), this.eraNames = null, this.meridiemNames = null, this.monthNames = new g.XFAObjectArray(2);
        }
      }
      class d extends g.StringObject {
        constructor(X) {
          super(n, "currencySymbol"), this.name = (0, p.getStringOption)(X.name, ["symbol", "isoname", "decimal"]);
        }
      }
      class m extends g.XFAObject {
        constructor(X) {
          super(n, "currencySymbols", !0), this.currencySymbol = new g.XFAObjectArray(3);
        }
      }
      class b extends g.StringObject {
        constructor(X) {
          super(n, "datePattern"), this.name = (0, p.getStringOption)(X.name, ["full", "long", "med", "short"]);
        }
      }
      class w extends g.XFAObject {
        constructor(X) {
          super(n, "datePatterns", !0), this.datePattern = new g.XFAObjectArray(4);
        }
      }
      class v extends g.ContentObject {
        constructor(X) {
          super(n, "dateTimeSymbols");
        }
      }
      class h extends g.StringObject {
        constructor(X) {
          super(n, "day");
        }
      }
      class x extends g.XFAObject {
        constructor(X) {
          super(n, "dayNames", !0), this.abbr = (0, p.getInteger)({ data: X.abbr, defaultValue: 0, validate: (L) => L === 1 }), this.day = new g.XFAObjectArray(7);
        }
      }
      class _ extends g.StringObject {
        constructor(X) {
          super(n, "era");
        }
      }
      class M extends g.XFAObject {
        constructor(X) {
          super(n, "eraNames", !0), this.era = new g.XFAObjectArray(2);
        }
      }
      class O extends g.XFAObject {
        constructor(X) {
          super(n, "locale", !0), this.desc = X.desc || "", this.name = "isoname", this.calendarSymbols = null, this.currencySymbols = null, this.datePatterns = null, this.dateTimeSymbols = null, this.numberPatterns = null, this.numberSymbols = null, this.timePatterns = null, this.typeFaces = null;
        }
      }
      class E extends g.XFAObject {
        constructor(X) {
          super(n, "localeSet", !0), this.locale = new g.XFAObjectArray();
        }
      }
      class I extends g.StringObject {
        constructor(X) {
          super(n, "meridiem");
        }
      }
      class R extends g.XFAObject {
        constructor(X) {
          super(n, "meridiemNames", !0), this.meridiem = new g.XFAObjectArray(2);
        }
      }
      class W extends g.StringObject {
        constructor(X) {
          super(n, "month");
        }
      }
      class z extends g.XFAObject {
        constructor(X) {
          super(n, "monthNames", !0), this.abbr = (0, p.getInteger)({ data: X.abbr, defaultValue: 0, validate: (L) => L === 1 }), this.month = new g.XFAObjectArray(12);
        }
      }
      class j extends g.StringObject {
        constructor(X) {
          super(n, "numberPattern"), this.name = (0, p.getStringOption)(X.name, ["full", "long", "med", "short"]);
        }
      }
      class $ extends g.XFAObject {
        constructor(X) {
          super(n, "numberPatterns", !0), this.numberPattern = new g.XFAObjectArray(4);
        }
      }
      class B extends g.StringObject {
        constructor(X) {
          super(n, "numberSymbol"), this.name = (0, p.getStringOption)(X.name, ["decimal", "grouping", "percent", "minus", "zero"]);
        }
      }
      class C extends g.XFAObject {
        constructor(X) {
          super(n, "numberSymbols", !0), this.numberSymbol = new g.XFAObjectArray(5);
        }
      }
      class T extends g.StringObject {
        constructor(X) {
          super(n, "timePattern"), this.name = (0, p.getStringOption)(X.name, ["full", "long", "med", "short"]);
        }
      }
      class F extends g.XFAObject {
        constructor(X) {
          super(n, "timePatterns", !0), this.timePattern = new g.XFAObjectArray(4);
        }
      }
      class S extends g.XFAObject {
        constructor(X) {
          super(n, "typeFace", !0), this.name = "" | X.name;
        }
      }
      class A extends g.XFAObject {
        constructor(X) {
          super(n, "typeFaces", !0), this.typeFace = new g.XFAObjectArray();
        }
      }
      class U {
        static [o.$buildXFAObject](X, L) {
          if (U.hasOwnProperty(X)) return U[X](L);
        }
        static calendarSymbols(X) {
          return new a(X);
        }
        static currencySymbol(X) {
          return new d(X);
        }
        static currencySymbols(X) {
          return new m(X);
        }
        static datePattern(X) {
          return new b(X);
        }
        static datePatterns(X) {
          return new w(X);
        }
        static dateTimeSymbols(X) {
          return new v(X);
        }
        static day(X) {
          return new h(X);
        }
        static dayNames(X) {
          return new x(X);
        }
        static era(X) {
          return new _(X);
        }
        static eraNames(X) {
          return new M(X);
        }
        static locale(X) {
          return new O(X);
        }
        static localeSet(X) {
          return new E(X);
        }
        static meridiem(X) {
          return new I(X);
        }
        static meridiemNames(X) {
          return new R(X);
        }
        static month(X) {
          return new W(X);
        }
        static monthNames(X) {
          return new z(X);
        }
        static numberPattern(X) {
          return new j(X);
        }
        static numberPatterns(X) {
          return new $(X);
        }
        static numberSymbol(X) {
          return new B(X);
        }
        static numberSymbols(X) {
          return new C(X);
        }
        static timePattern(X) {
          return new T(X);
        }
        static timePatterns(X) {
          return new F(X);
        }
        static typeFace(X) {
          return new S(X);
        }
        static typeFaces(X) {
          return new A(X);
        }
      }
      l.LocaleSetNamespace = U;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.SignatureNamespace = void 0;
      var o = f(81), g = f(87);
      const p = o.NamespaceIds.signature.id;
      class n extends g.XFAObject {
        constructor(m) {
          super(p, "signature", !0);
        }
      }
      class a {
        static [o.$buildXFAObject](m, b) {
          if (a.hasOwnProperty(m)) return a[m](b);
        }
        static signature(m) {
          return new n(m);
        }
      }
      l.SignatureNamespace = a;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.StylesheetNamespace = void 0;
      var o = f(81), g = f(87);
      const p = o.NamespaceIds.stylesheet.id;
      class n extends g.XFAObject {
        constructor(m) {
          super(p, "stylesheet", !0);
        }
      }
      class a {
        static [o.$buildXFAObject](m, b) {
          if (a.hasOwnProperty(m)) return a[m](b);
        }
        static stylesheet(m) {
          return new n(m);
        }
      }
      l.StylesheetNamespace = a;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XdpNamespace = void 0;
      var o = f(81), g = f(78), p = f(87);
      const n = o.NamespaceIds.xdp.id;
      class a extends p.XFAObject {
        constructor(b) {
          super(n, "xdp", !0), this.uuid = b.uuid || "", this.timeStamp = b.timeStamp || "", this.config = null, this.connectionSet = null, this.datasets = null, this.localeSet = null, this.stylesheet = new p.XFAObjectArray(), this.template = null;
        }
        [g.$onChildCheck](b) {
          const w = o.NamespaceIds[b[g.$nodeName]];
          return w && b[g.$namespaceId] === w.id;
        }
      }
      class d {
        static [o.$buildXFAObject](b, w) {
          if (d.hasOwnProperty(b)) return d[b](w);
        }
        static xdp(b) {
          return new a(b);
        }
      }
      l.XdpNamespace = d;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XhtmlNamespace = void 0;
      var o = f(78), g = f(81), p = f(83), n = f(84), a = f(87);
      const d = g.NamespaceIds.xhtml.id, m = Symbol(), b = /* @__PURE__ */ new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]), w = /* @__PURE__ */ new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", (K) => K === "none" ? "none" : "normal"], ["xfa-font-horizontal-scale", (K) => `scaleX(${Math.max(0, Math.min(parseInt(K) / 100)).toFixed(2)})`], ["xfa-font-vertical-scale", (K) => `scaleY(${Math.max(0, Math.min(parseInt(K) / 100)).toFixed(2)})`], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", (K, X) => (K = X.fontSize = (0, n.getMeasurement)(K), (0, p.measureToString)(0.99 * K))], ["letter-spacing", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["line-height", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["margin", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["margin-bottom", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["margin-left", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["margin-right", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["margin-top", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["text-indent", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))], ["font-family", (K) => K], ["vertical-align", (K) => (0, p.measureToString)((0, n.getMeasurement)(K))]]), v = /\s+/g, h = /[\r\n]+/g, x = /\r\n?/g;
      function _(K, X, L) {
        const H = /* @__PURE__ */ Object.create(null);
        if (!K) return H;
        const Q = /* @__PURE__ */ Object.create(null);
        for (const [N, V] of K.split(";").map((Y) => Y.split(":", 2))) {
          const Y = w.get(N);
          if (Y === "") continue;
          let Z = V;
          Y && (Z = typeof Y == "string" ? Y : Y(V, Q)), N.endsWith("scale") ? H.transform = H.transform ? `${H[N]} ${Z}` : Z : H[N.replaceAll(/-([a-zA-Z])/g, (rt, st) => st.toUpperCase())] = Z;
        }
        if (H.fontFamily && (0, p.setFontFamily)({ typeface: H.fontFamily, weight: H.fontWeight || "normal", posture: H.fontStyle || "normal", size: Q.fontSize || 0 }, X, X[o.$globalData].fontFinder, H), L && H.verticalAlign && H.verticalAlign !== "0px" && H.fontSize) {
          const Y = (0, n.getMeasurement)(H.fontSize);
          H.fontSize = (0, p.measureToString)(Y * 0.583), H.verticalAlign = (0, p.measureToString)(Math.sign((0, n.getMeasurement)(H.verticalAlign)) * Y * 0.333);
        }
        return L && H.fontSize && (H.fontSize = `calc(${H.fontSize} * var(--scale-factor))`), (0, p.fixTextIndent)(H), H;
      }
      const M = /* @__PURE__ */ new Set(["body", "html"]);
      class O extends a.XmlObject {
        constructor(X, L) {
          super(d, L), this[m] = !1, this.style = X.style || "";
        }
        [o.$clean](X) {
          super[o.$clean](X), this.style = function(H) {
            return H.style ? H.style.trim().split(/\s*;\s*/).filter((Q) => !!Q).map((Q) => Q.split(/\s*:\s*/, 2)).filter(([Q, N]) => (Q === "font-family" && H[o.$globalData].usedTypefaces.add(N), b.has(Q))).map((Q) => Q.join(":")).join(";") : "";
          }(this);
        }
        [o.$acceptWhitespace]() {
          return !M.has(this[o.$nodeName]);
        }
        [o.$onText](X, L = !1) {
          L ? this[m] = !0 : (X = X.replaceAll(h, ""), this.style.includes("xfa-spacerun:yes") || (X = X.replaceAll(v, " "))), X && (this[o.$content] += X);
        }
        [o.$pushGlyphs](X, L = !0) {
          const H = /* @__PURE__ */ Object.create(null), Q = { top: NaN, bottom: NaN, left: NaN, right: NaN };
          let N = null;
          for (const [V, Y] of this.style.split(";").map((Z) => Z.split(":", 2))) switch (V) {
            case "font-family":
              H.typeface = (0, n.stripQuotes)(Y);
              break;
            case "font-size":
              H.size = (0, n.getMeasurement)(Y);
              break;
            case "font-weight":
              H.weight = Y;
              break;
            case "font-style":
              H.posture = Y;
              break;
            case "letter-spacing":
              H.letterSpacing = (0, n.getMeasurement)(Y);
              break;
            case "margin":
              const Z = Y.split(/ \t/).map((rt) => (0, n.getMeasurement)(rt));
              switch (Z.length) {
                case 1:
                  Q.top = Q.bottom = Q.left = Q.right = Z[0];
                  break;
                case 2:
                  Q.top = Q.bottom = Z[0], Q.left = Q.right = Z[1];
                  break;
                case 3:
                  Q.top = Z[0], Q.bottom = Z[2], Q.left = Q.right = Z[1];
                  break;
                case 4:
                  Q.top = Z[0], Q.left = Z[1], Q.bottom = Z[2], Q.right = Z[3];
              }
              break;
            case "margin-top":
              Q.top = (0, n.getMeasurement)(Y);
              break;
            case "margin-bottom":
              Q.bottom = (0, n.getMeasurement)(Y);
              break;
            case "margin-left":
              Q.left = (0, n.getMeasurement)(Y);
              break;
            case "margin-right":
              Q.right = (0, n.getMeasurement)(Y);
              break;
            case "line-height":
              N = (0, n.getMeasurement)(Y);
          }
          if (X.pushData(H, Q, N), this[o.$content]) X.addString(this[o.$content]);
          else for (const V of this[o.$getChildren]()) V[o.$nodeName] !== "#text" ? V[o.$pushGlyphs](X) : X.addString(V[o.$content]);
          L && X.popFont();
        }
        [o.$toHTML](X) {
          const L = [];
          if (this[o.$extra] = { children: L }, this[o.$childrenToHTML]({}), L.length === 0 && !this[o.$content]) return n.HTMLResult.EMPTY;
          let H;
          return H = this[m] ? this[o.$content] ? this[o.$content].replaceAll(x, `
`) : void 0 : this[o.$content] || void 0, n.HTMLResult.success({ name: this[o.$nodeName], attributes: { href: this.href, style: _(this.style, this, this[m]) }, children: L, value: H });
        }
      }
      class E extends O {
        constructor(X) {
          super(X, "a"), this.href = (0, p.fixURL)(X.href) || "";
        }
      }
      class I extends O {
        constructor(X) {
          super(X, "b");
        }
        [o.$pushGlyphs](X) {
          X.pushFont({ weight: "bold" }), super[o.$pushGlyphs](X), X.popFont();
        }
      }
      class R extends O {
        constructor(X) {
          super(X, "body");
        }
        [o.$toHTML](X) {
          const L = super[o.$toHTML](X), { html: H } = L;
          return H ? (H.name = "div", H.attributes.class = ["xfaRich"], L) : n.HTMLResult.EMPTY;
        }
      }
      class W extends O {
        constructor(X) {
          super(X, "br");
        }
        [o.$text]() {
          return `
`;
        }
        [o.$pushGlyphs](X) {
          X.addString(`
`);
        }
        [o.$toHTML](X) {
          return n.HTMLResult.success({ name: "br" });
        }
      }
      class z extends O {
        constructor(X) {
          super(X, "html");
        }
        [o.$toHTML](X) {
          var H;
          const L = [];
          if (this[o.$extra] = { children: L }, this[o.$childrenToHTML]({}), L.length === 0) return n.HTMLResult.success({ name: "div", attributes: { class: ["xfaRich"], style: {} }, value: this[o.$content] || "" });
          if (L.length === 1) {
            const Q = L[0];
            if ((H = Q.attributes) != null && H.class.includes("xfaRich")) return n.HTMLResult.success(Q);
          }
          return n.HTMLResult.success({ name: "div", attributes: { class: ["xfaRich"], style: {} }, children: L });
        }
      }
      class j extends O {
        constructor(X) {
          super(X, "i");
        }
        [o.$pushGlyphs](X) {
          X.pushFont({ posture: "italic" }), super[o.$pushGlyphs](X), X.popFont();
        }
      }
      class $ extends O {
        constructor(X) {
          super(X, "li");
        }
      }
      class B extends O {
        constructor(X) {
          super(X, "ol");
        }
      }
      class C extends O {
        constructor(X) {
          super(X, "p");
        }
        [o.$pushGlyphs](X) {
          super[o.$pushGlyphs](X, !1), X.addString(`
`), X.addPara(), X.popFont();
        }
        [o.$text]() {
          return this[o.$getParent]()[o.$getChildren]().at(-1) === this ? super[o.$text]() : super[o.$text]() + `
`;
        }
      }
      class T extends O {
        constructor(X) {
          super(X, "span");
        }
      }
      class F extends O {
        constructor(X) {
          super(X, "sub");
        }
      }
      class S extends O {
        constructor(X) {
          super(X, "sup");
        }
      }
      class A extends O {
        constructor(X) {
          super(X, "ul");
        }
      }
      class U {
        static [g.$buildXFAObject](X, L) {
          if (U.hasOwnProperty(X)) return U[X](L);
        }
        static a(X) {
          return new E(X);
        }
        static b(X) {
          return new I(X);
        }
        static body(X) {
          return new R(X);
        }
        static br(X) {
          return new W(X);
        }
        static html(X) {
          return new z(X);
        }
        static i(X) {
          return new j(X);
        }
        static li(X) {
          return new $(X);
        }
        static ol(X) {
          return new B(X);
        }
        static p(X) {
          return new C(X);
        }
        static span(X) {
          return new T(X);
        }
        static sub(X) {
          return new F(X);
        }
        static sup(X) {
          return new S(X);
        }
        static ul(X) {
          return new A(X);
        }
      }
      l.XhtmlNamespace = U;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.UnknownNamespace = void 0;
      var o = f(81), g = f(87);
      class p {
        constructor(a) {
          this.namespaceId = a;
        }
        [o.$buildXFAObject](a, d) {
          return new g.XmlObject(this.namespaceId, a, d);
        }
      }
      l.UnknownNamespace = p;
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.DatasetReader = void 0;
      var o = f(2), g = f(3), p = f(71);
      function n(d) {
        try {
          return (0, o.stringToUTF8String)(d);
        } catch (m) {
          return (0, o.warn)(`UTF-8 decoding failed: "${m}".`), d;
        }
      }
      class a extends p.SimpleXMLParser {
        constructor(m) {
          super(m), this.node = null;
        }
        onEndElement(m) {
          const b = super.onEndElement(m);
          if (b && m === "xfa:datasets")
            throw this.node = b, new Error("Aborting DatasetXMLParser.");
        }
      }
      l.DatasetReader = class {
        constructor(m) {
          if (m.datasets) this.node = new p.SimpleXMLParser({ hasAttributes: !0 }).parseFromString(m.datasets).documentElement;
          else {
            const b = new a({ hasAttributes: !0 });
            try {
              b.parseFromString(m["xdp:xdp"]);
            } catch {
            }
            this.node = b.node;
          }
        }
        getValue(m) {
          if (!this.node || !m) return "";
          const b = this.node.searchNode((0, g.parseXFAPath)(m), 0);
          if (!b) return "";
          const w = b.firstChild;
          return (w == null ? void 0 : w.nodeName) === "value" ? b.children.map((v) => n(v.textContent)) : n(b.textContent);
        }
      };
    }, (u, l, f) => {
      var m, b;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.XRef = void 0;
      var o = f(2), g = f(4), p = f(16), n = f(3), a = f(5), d = f(74);
      l.XRef = (b = class {
        constructor(v, h) {
          lr(this, m, null);
          this.stream = v, this.pdfManager = h, this.entries = [], this._xrefStms = /* @__PURE__ */ new Set(), this._cacheMap = /* @__PURE__ */ new Map(), this._pendingRefs = new g.RefSet(), this._newPersistentRefNum = null, this._newTemporaryRefNum = null;
        }
        getNewPersistentRef(v) {
          this._newPersistentRefNum === null && (this._newPersistentRefNum = this.entries.length || 1);
          const h = this._newPersistentRefNum++;
          return this._cacheMap.set(h, v), g.Ref.get(h, 0);
        }
        getNewTemporaryRef() {
          return this._newTemporaryRefNum === null && (this._newTemporaryRefNum = this.entries.length || 1), g.Ref.get(this._newTemporaryRefNum++, 0);
        }
        resetNewTemporaryRef() {
          this._newTemporaryRefNum = null;
        }
        setStartXRef(v) {
          this.startXRefQueue = [v];
        }
        parse(v = !1) {
          let h, x, _;
          v ? ((0, o.warn)("Indexing all PDF objects"), h = this.indexObjects()) : h = this.readXRef(), h.assignXref(this), this.trailer = h;
          try {
            x = h.get("Encrypt");
          } catch (M) {
            if (M instanceof n.MissingDataException) throw M;
            (0, o.warn)(`XRef.parse - Invalid "Encrypt" reference: "${M}".`);
          }
          if (x instanceof g.Dict) {
            const M = h.get("ID"), O = M != null && M.length ? M[0] : "";
            x.suppressEncryption = !0, this.encrypt = new d.CipherTransformFactory(x, O, this.pdfManager.password);
          }
          try {
            _ = h.get("Root");
          } catch (M) {
            if (M instanceof n.MissingDataException) throw M;
            (0, o.warn)(`XRef.parse - Invalid "Root" reference: "${M}".`);
          }
          if (_ instanceof g.Dict) try {
            if (_.get("Pages") instanceof g.Dict) {
              this.root = _;
              return;
            }
          } catch (M) {
            if (M instanceof n.MissingDataException) throw M;
            (0, o.warn)(`XRef.parse - Invalid "Pages" reference: "${M}".`);
          }
          throw v ? new o.InvalidPDFException("Invalid Root reference.") : new n.XRefParseException();
        }
        processXRefTable(v) {
          "tableState" in this || (this.tableState = { entryNum: 0, streamPos: v.lexer.stream.pos, parserBuf1: v.buf1, parserBuf2: v.buf2 });
          const h = this.readXRefTable(v);
          if (!(0, g.isCmd)(h, "trailer")) throw new o.FormatError("Invalid XRef table: could not find trailer dictionary");
          let x = v.getObj();
          if (x instanceof g.Dict || !x.dict || (x = x.dict), !(x instanceof g.Dict)) throw new o.FormatError("Invalid XRef table: could not parse trailer dictionary");
          return delete this.tableState, x;
        }
        readXRefTable(v) {
          const h = v.lexer.stream, x = this.tableState;
          h.pos = x.streamPos, v.buf1 = x.parserBuf1, v.buf2 = x.parserBuf2;
          let _;
          for (; ; ) {
            if (!("firstEntryNum" in x) || !("entryCount" in x)) {
              if ((0, g.isCmd)(_ = v.getObj(), "trailer")) break;
              x.firstEntryNum = _, x.entryCount = v.getObj();
            }
            let M = x.firstEntryNum;
            const O = x.entryCount;
            if (!Number.isInteger(M) || !Number.isInteger(O)) throw new o.FormatError("Invalid XRef table: wrong types in subsection header");
            for (let E = x.entryNum; E < O; E++) {
              x.streamPos = h.pos, x.entryNum = E, x.parserBuf1 = v.buf1, x.parserBuf2 = v.buf2;
              const I = {};
              I.offset = v.getObj(), I.gen = v.getObj();
              const R = v.getObj();
              if (R instanceof g.Cmd) switch (R.cmd) {
                case "f":
                  I.free = !0;
                  break;
                case "n":
                  I.uncompressed = !0;
              }
              if (!Number.isInteger(I.offset) || !Number.isInteger(I.gen) || !I.free && !I.uncompressed) throw new o.FormatError(`Invalid entry in XRef subsection: ${M}, ${O}`);
              E === 0 && I.free && M === 1 && (M = 0), this.entries[E + M] || (this.entries[E + M] = I);
            }
            x.entryNum = 0, x.streamPos = h.pos, x.parserBuf1 = v.buf1, x.parserBuf2 = v.buf2, delete x.firstEntryNum, delete x.entryCount;
          }
          if (this.entries[0] && !this.entries[0].free) throw new o.FormatError("Invalid XRef table: unexpected first object");
          return _;
        }
        processXRefStream(v) {
          if (!("streamState" in this)) {
            const h = v.dict, x = h.get("W");
            let _ = h.get("Index");
            _ || (_ = [0, h.get("Size")]), this.streamState = { entryRanges: _, byteWidths: x, entryNum: 0, streamPos: v.pos };
          }
          return this.readXRefStream(v), delete this.streamState, v.dict;
        }
        readXRefStream(v) {
          const h = this.streamState;
          v.pos = h.streamPos;
          const [x, _, M] = h.byteWidths, O = h.entryRanges;
          for (; O.length > 0; ) {
            const [E, I] = O;
            if (!Number.isInteger(E) || !Number.isInteger(I)) throw new o.FormatError(`Invalid XRef range fields: ${E}, ${I}`);
            if (!Number.isInteger(x) || !Number.isInteger(_) || !Number.isInteger(M)) throw new o.FormatError(`Invalid XRef entry fields length: ${E}, ${I}`);
            for (let R = h.entryNum; R < I; ++R) {
              h.entryNum = R, h.streamPos = v.pos;
              let W = 0, z = 0, j = 0;
              for (let B = 0; B < x; ++B) {
                const C = v.getByte();
                if (C === -1) throw new o.FormatError("Invalid XRef byteWidths 'type'.");
                W = W << 8 | C;
              }
              x === 0 && (W = 1);
              for (let B = 0; B < _; ++B) {
                const C = v.getByte();
                if (C === -1) throw new o.FormatError("Invalid XRef byteWidths 'offset'.");
                z = z << 8 | C;
              }
              for (let B = 0; B < M; ++B) {
                const C = v.getByte();
                if (C === -1) throw new o.FormatError("Invalid XRef byteWidths 'generation'.");
                j = j << 8 | C;
              }
              const $ = {};
              switch ($.offset = z, $.gen = j, W) {
                case 0:
                  $.free = !0;
                  break;
                case 1:
                  $.uncompressed = !0;
                  break;
                case 2:
                  break;
                default:
                  throw new o.FormatError(`Invalid XRef entry type: ${W}`);
              }
              this.entries[E + R] || (this.entries[E + R] = $);
            }
            h.entryNum = 0, h.streamPos = v.pos, O.splice(0, 2);
          }
        }
        indexObjects() {
          function v(U, K) {
            let X = "", L = U[K];
            for (; L !== 10 && L !== 13 && L !== 60 && !(++K >= U.length); )
              X += String.fromCharCode(L), L = U[K];
            return X;
          }
          function h(U, K, X) {
            const L = X.length, H = U.length;
            let Q = 0;
            for (; K < H; ) {
              let N = 0;
              for (; N < L && U[K + N] === X[N]; ) ++N;
              if (N >= L) break;
              K++, Q++;
            }
            return Q;
          }
          const x = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g, _ = /\b(startxref|\d+\s+\d+\s+obj)\b/g, M = /^(\d+)\s+(\d+)\s+obj\b/, O = new Uint8Array([116, 114, 97, 105, 108, 101, 114]), E = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), I = new Uint8Array([47, 88, 82, 101, 102]);
          this.entries.length = 0, this._cacheMap.clear();
          const R = this.stream;
          R.pos = 0;
          const W = R.getBytes(), z = (0, o.bytesToString)(W), j = W.length;
          let $ = R.start;
          const B = [], C = [];
          for (; $ < j; ) {
            let U = W[$];
            if (U === 9 || U === 10 || U === 13 || U === 32) {
              ++$;
              continue;
            }
            if (U === 37) {
              do {
                if (++$, $ >= j) break;
                U = W[$];
              } while (U !== 10 && U !== 13);
              continue;
            }
            const K = v(W, $);
            let X;
            if (K.startsWith("xref") && (K.length === 4 || /\s/.test(K[4])))
              $ += h(W, $, O), B.push($), $ += h(W, $, E);
            else if (X = M.exec(K)) {
              const L = 0 | X[1], H = 0 | X[2], Q = $ + K.length;
              let N, V = !1;
              if (this.entries[L]) {
                if (this.entries[L].gen === H) try {
                  new p.Parser({ lexer: new p.Lexer(R.makeSubStream(Q)) }).getObj(), V = !0;
                } catch (st) {
                  st instanceof n.ParserEOFException ? (0, o.warn)(`indexObjects -- checking object (${K}): "${st}".`) : V = !0;
                }
              } else V = !0;
              V && (this.entries[L] = { offset: $ - R.start, gen: H, uncompressed: !0 }), x.lastIndex = Q;
              const Y = x.exec(z);
              Y ? (N = x.lastIndex + 1 - $, Y[1] !== "endobj" && ((0, o.warn)(`indexObjects: Found "${Y[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`), N -= Y[1].length + 1)) : N = j - $;
              const Z = W.subarray($, $ + N), rt = h(Z, 0, I);
              rt < N && Z[rt + 5] < 64 && (C.push($ - R.start), this._xrefStms.add($ - R.start)), $ += N;
            } else if (K.startsWith("trailer") && (K.length === 7 || /\s/.test(K[7]))) {
              B.push($);
              const L = $ + K.length;
              let H;
              _.lastIndex = L;
              const Q = _.exec(z);
              Q ? (H = _.lastIndex + 1 - $, Q[1] !== "startxref" && ((0, o.warn)(`indexObjects: Found "${Q[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`), H -= Q[1].length + 1)) : H = j - $, $ += H;
            } else $ += K.length + 1;
          }
          for (const U of C)
            this.startXRefQueue.push(U), this.readXRef(!0);
          const T = [];
          let F, S, A = !1;
          for (const U of B) {
            R.pos = U;
            const K = new p.Parser({ lexer: new p.Lexer(R), xref: this, allowStreams: !0, recoveryMode: !0 }), X = K.getObj();
            if (!(0, g.isCmd)(X, "trailer")) continue;
            const L = K.getObj();
            L instanceof g.Dict && (T.push(L), L.has("Encrypt") && (A = !0));
          }
          for (const U of [...T, "genFallback", ...T]) {
            if (U === "genFallback") {
              if (!S) break;
              this._generationFallback = !0;
              continue;
            }
            let K = !1;
            try {
              const X = U.get("Root");
              if (!(X instanceof g.Dict)) continue;
              const L = X.get("Pages");
              if (!(L instanceof g.Dict)) continue;
              const H = L.get("Count");
              Number.isInteger(H) && (K = !0);
            } catch (X) {
              S = X;
              continue;
            }
            if (K && (!A || U.has("Encrypt")) && U.has("ID")) return U;
            F = U;
          }
          if (F) return F;
          if (this.topDict) return this.topDict;
          throw new o.InvalidPDFException("Invalid PDF structure.");
        }
        readXRef(v = !1) {
          const h = this.stream, x = /* @__PURE__ */ new Set();
          for (; this.startXRefQueue.length; ) {
            try {
              const _ = this.startXRefQueue[0];
              if (x.has(_)) {
                (0, o.warn)("readXRef - skipping XRef table since it was already parsed."), this.startXRefQueue.shift();
                continue;
              }
              x.add(_), h.pos = _ + h.start;
              const M = new p.Parser({ lexer: new p.Lexer(h), xref: this, allowStreams: !0 });
              let O, E = M.getObj();
              if ((0, g.isCmd)(E, "xref"))
                O = this.processXRefTable(M), this.topDict || (this.topDict = O), E = O.get("XRefStm"), Number.isInteger(E) && !this._xrefStms.has(E) && (this._xrefStms.add(E), this.startXRefQueue.push(E), or(this, m) ?? Wf(this, m, E));
              else {
                if (!Number.isInteger(E)) throw new o.FormatError("Invalid XRef stream header");
                if (!(Number.isInteger(M.getObj()) && (0, g.isCmd)(M.getObj(), "obj") && (E = M.getObj()) instanceof a.BaseStream)) throw new o.FormatError("Invalid XRef stream");
                if (O = this.processXRefStream(E), this.topDict || (this.topDict = O), !O) throw new o.FormatError("Failed to read XRef stream");
              }
              E = O.get("Prev"), Number.isInteger(E) ? this.startXRefQueue.push(E) : E instanceof g.Ref && this.startXRefQueue.push(E.num);
            } catch (_) {
              if (_ instanceof n.MissingDataException) throw _;
              (0, o.info)("(while reading XRef): " + _);
            }
            this.startXRefQueue.shift();
          }
          if (this.topDict) return this.topDict;
          if (!v) throw new n.XRefParseException();
        }
        get lastXRefStreamPos() {
          return or(this, m) ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
        }
        getEntry(v) {
          const h = this.entries[v];
          return h && !h.free && h.offset ? h : null;
        }
        fetchIfRef(v, h = !1) {
          return v instanceof g.Ref ? this.fetch(v, h) : v;
        }
        fetch(v, h = !1) {
          if (!(v instanceof g.Ref)) throw new Error("ref object is not a reference");
          const x = v.num, _ = this._cacheMap.get(x);
          if (_ !== void 0)
            return _ instanceof g.Dict && !_.objId && (_.objId = v.toString()), _;
          let M = this.getEntry(x);
          if (M === null)
            return this._cacheMap.set(x, M), M;
          if (this._pendingRefs.has(v))
            return this._pendingRefs.remove(v), (0, o.warn)(`Ignoring circular reference: ${v}.`), g.CIRCULAR_REF;
          this._pendingRefs.put(v);
          try {
            M = M.uncompressed ? this.fetchUncompressed(v, M, h) : this.fetchCompressed(v, M, h), this._pendingRefs.remove(v);
          } catch (O) {
            throw this._pendingRefs.remove(v), O;
          }
          return M instanceof g.Dict ? M.objId = v.toString() : M instanceof a.BaseStream && (M.dict.objId = v.toString()), M;
        }
        fetchUncompressed(v, h, x = !1) {
          const _ = v.gen;
          let M = v.num;
          if (h.gen !== _) {
            const z = `Inconsistent generation in XRef: ${v}`;
            if (this._generationFallback && h.gen < _)
              return (0, o.warn)(z), this.fetchUncompressed(g.Ref.get(M, h.gen), h, x);
            throw new n.XRefEntryException(z);
          }
          const O = this.stream.makeSubStream(h.offset + this.stream.start), E = new p.Parser({ lexer: new p.Lexer(O), xref: this, allowStreams: !0 }), I = E.getObj(), R = E.getObj(), W = E.getObj();
          if (I !== M || R !== _ || !(W instanceof g.Cmd)) throw new n.XRefEntryException(`Bad (uncompressed) XRef entry: ${v}`);
          if (W.cmd !== "obj") {
            if (W.cmd.startsWith("obj") && (M = parseInt(W.cmd.substring(3), 10), !Number.isNaN(M)))
              return M;
            throw new n.XRefEntryException(`Bad (uncompressed) XRef entry: ${v}`);
          }
          return (h = this.encrypt && !x ? E.getObj(this.encrypt.createCipherTransform(M, _)) : E.getObj()) instanceof a.BaseStream || this._cacheMap.set(M, h), h;
        }
        fetchCompressed(v, h, x = !1) {
          const _ = h.offset, M = this.fetch(g.Ref.get(_, 0));
          if (!(M instanceof a.BaseStream)) throw new o.FormatError("bad ObjStm stream");
          const O = M.dict.get("First"), E = M.dict.get("N");
          if (!Number.isInteger(O) || !Number.isInteger(E)) throw new o.FormatError("invalid first and n parameters for ObjStm stream");
          let I = new p.Parser({ lexer: new p.Lexer(M), xref: this, allowStreams: !0 });
          const R = new Array(E), W = new Array(E);
          for (let $ = 0; $ < E; ++$) {
            const B = I.getObj();
            if (!Number.isInteger(B)) throw new o.FormatError(`invalid object number in the ObjStm stream: ${B}`);
            const C = I.getObj();
            if (!Number.isInteger(C)) throw new o.FormatError(`invalid object offset in the ObjStm stream: ${C}`);
            R[$] = B, W[$] = C;
          }
          const z = (M.start || 0) + O, j = new Array(E);
          for (let $ = 0; $ < E; ++$) {
            const B = $ < E - 1 ? W[$ + 1] - W[$] : void 0;
            if (B < 0) throw new o.FormatError("Invalid offset in the ObjStm stream.");
            I = new p.Parser({ lexer: new p.Lexer(M.makeSubStream(z + W[$], B, M.dict)), xref: this, allowStreams: !0 });
            const C = I.getObj();
            if (j[$] = C, C instanceof a.BaseStream) continue;
            const T = R[$], F = this.entries[T];
            F && F.offset === _ && F.gen === $ && this._cacheMap.set(T, C);
          }
          if ((h = j[h.gen]) === void 0) throw new n.XRefEntryException(`Bad (compressed) XRef entry: ${v}`);
          return h;
        }
        async fetchIfRefAsync(v, h) {
          return v instanceof g.Ref ? this.fetchAsync(v, h) : v;
        }
        async fetchAsync(v, h) {
          try {
            return this.fetch(v, h);
          } catch (x) {
            if (!(x instanceof n.MissingDataException)) throw x;
            return await this.pdfManager.requestRange(x.begin, x.end), this.fetchAsync(v, h);
          }
        }
        getCatalogObj() {
          return this.root;
        }
      }, m = new WeakMap(), b);
    }, (u, l, f) => {
      var _, yM, bM, n2, I;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.MessageHandler = void 0;
      var o = f(2);
      const g = 1, p = 2, n = 1, a = 2, d = 3, m = 4, b = 5, w = 6, v = 7, h = 8;
      function x(R) {
        switch (R instanceof Error || typeof R == "object" && R !== null || (0, o.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), R.name) {
          case "AbortException":
            return new o.AbortException(R.message);
          case "MissingPDFException":
            return new o.MissingPDFException(R.message);
          case "PasswordException":
            return new o.PasswordException(R.message, R.code);
          case "UnexpectedResponseException":
            return new o.UnexpectedResponseException(R.message, R.status);
          case "UnknownErrorException":
            return new o.UnknownErrorException(R.message, R.details);
          default:
            return new o.UnknownErrorException(R.message, R.toString());
        }
      }
      l.MessageHandler = (I = class {
        constructor(W, z, j) {
          lr(this, _);
          this.sourceName = W, this.targetName = z, this.comObj = j, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = ($) => {
            const B = $.data;
            if (B.targetName !== this.sourceName) return;
            if (B.stream) {
              Le(this, _, bM).call(this, B);
              return;
            }
            if (B.callback) {
              const T = B.callbackId, F = this.callbackCapabilities[T];
              if (!F) throw new Error(`Cannot resolve callback ${T}`);
              if (delete this.callbackCapabilities[T], B.callback === g) F.resolve(B.data);
              else {
                if (B.callback !== p) throw new Error("Unexpected callback case");
                F.reject(x(B.reason));
              }
              return;
            }
            const C = this.actionHandler[B.action];
            if (!C) throw new Error(`Unknown action from worker: ${B.action}`);
            if (B.callbackId) {
              const T = this.sourceName, F = B.sourceName;
              new Promise(function(S) {
                S(C(B.data));
              }).then(function(S) {
                j.postMessage({ sourceName: T, targetName: F, callback: g, callbackId: B.callbackId, data: S });
              }, function(S) {
                j.postMessage({ sourceName: T, targetName: F, callback: p, callbackId: B.callbackId, reason: x(S) });
              });
            } else B.streamId ? Le(this, _, yM).call(this, B) : C(B.data);
          }, j.addEventListener("message", this._onComObjOnMessage);
        }
        on(W, z) {
          const j = this.actionHandler;
          if (j[W]) throw new Error(`There is already an actionName called "${W}"`);
          j[W] = z;
        }
        send(W, z, j) {
          this.comObj.postMessage({ sourceName: this.sourceName, targetName: this.targetName, action: W, data: z }, j);
        }
        sendWithPromise(W, z, j) {
          const $ = this.callbackId++, B = new o.PromiseCapability();
          this.callbackCapabilities[$] = B;
          try {
            this.comObj.postMessage({ sourceName: this.sourceName, targetName: this.targetName, action: W, callbackId: $, data: z }, j);
          } catch (C) {
            B.reject(C);
          }
          return B.promise;
        }
        sendWithStream(W, z, j, $) {
          const B = this.streamId++, C = this.sourceName, T = this.targetName, F = this.comObj;
          return new ReadableStream({ start: (S) => {
            const A = new o.PromiseCapability();
            return this.streamControllers[B] = { controller: S, startCall: A, pullCall: null, cancelCall: null, isClosed: !1 }, F.postMessage({ sourceName: C, targetName: T, action: W, streamId: B, data: z, desiredSize: S.desiredSize }, $), A.promise;
          }, pull: (S) => {
            const A = new o.PromiseCapability();
            return this.streamControllers[B].pullCall = A, F.postMessage({ sourceName: C, targetName: T, stream: w, streamId: B, desiredSize: S.desiredSize }), A.promise;
          }, cancel: (S) => {
            (0, o.assert)(S instanceof Error, "cancel must have a valid reason");
            const A = new o.PromiseCapability();
            return this.streamControllers[B].cancelCall = A, this.streamControllers[B].isClosed = !0, F.postMessage({ sourceName: C, targetName: T, stream: n, streamId: B, reason: x(S) }), A.promise;
          } }, j);
        }
        destroy() {
          this.comObj.removeEventListener("message", this._onComObjOnMessage);
        }
      }, _ = new WeakSet(), yM = function(W) {
        const z = W.streamId, j = this.sourceName, $ = W.sourceName, B = this.comObj, C = this, T = this.actionHandler[W.action], F = { enqueue(S, A = 1, U) {
          if (this.isCancelled) return;
          const K = this.desiredSize;
          this.desiredSize -= A, K > 0 && this.desiredSize <= 0 && (this.sinkCapability = new o.PromiseCapability(), this.ready = this.sinkCapability.promise), B.postMessage({ sourceName: j, targetName: $, stream: m, streamId: z, chunk: S }, U);
        }, close() {
          this.isCancelled || (this.isCancelled = !0, B.postMessage({ sourceName: j, targetName: $, stream: d, streamId: z }), delete C.streamSinks[z]);
        }, error(S) {
          (0, o.assert)(S instanceof Error, "error must have a valid reason"), this.isCancelled || (this.isCancelled = !0, B.postMessage({ sourceName: j, targetName: $, stream: b, streamId: z, reason: x(S) }));
        }, sinkCapability: new o.PromiseCapability(), onPull: null, onCancel: null, isCancelled: !1, desiredSize: W.desiredSize, ready: null };
        F.sinkCapability.resolve(), F.ready = F.sinkCapability.promise, this.streamSinks[z] = F, new Promise(function(S) {
          S(T(W.data, F));
        }).then(function() {
          B.postMessage({ sourceName: j, targetName: $, stream: h, streamId: z, success: !0 });
        }, function(S) {
          B.postMessage({ sourceName: j, targetName: $, stream: h, streamId: z, reason: x(S) });
        });
      }, bM = function(W) {
        const z = W.streamId, j = this.sourceName, $ = W.sourceName, B = this.comObj, C = this.streamControllers[z], T = this.streamSinks[z];
        switch (W.stream) {
          case h:
            W.success ? C.startCall.resolve() : C.startCall.reject(x(W.reason));
            break;
          case v:
            W.success ? C.pullCall.resolve() : C.pullCall.reject(x(W.reason));
            break;
          case w:
            if (!T) {
              B.postMessage({ sourceName: j, targetName: $, stream: v, streamId: z, success: !0 });
              break;
            }
            T.desiredSize <= 0 && W.desiredSize > 0 && T.sinkCapability.resolve(), T.desiredSize = W.desiredSize, new Promise(function(F) {
              var S;
              F((S = T.onPull) == null ? void 0 : S.call(T));
            }).then(function() {
              B.postMessage({ sourceName: j, targetName: $, stream: v, streamId: z, success: !0 });
            }, function(F) {
              B.postMessage({ sourceName: j, targetName: $, stream: v, streamId: z, reason: x(F) });
            });
            break;
          case m:
            if ((0, o.assert)(C, "enqueue should have stream controller"), C.isClosed) break;
            C.controller.enqueue(W.chunk);
            break;
          case d:
            if ((0, o.assert)(C, "close should have stream controller"), C.isClosed) break;
            C.isClosed = !0, C.controller.close(), Le(this, _, n2).call(this, C, z);
            break;
          case b:
            (0, o.assert)(C, "error should have stream controller"), C.controller.error(x(W.reason)), Le(this, _, n2).call(this, C, z);
            break;
          case a:
            W.success ? C.cancelCall.resolve() : C.cancelCall.reject(x(W.reason)), Le(this, _, n2).call(this, C, z);
            break;
          case n:
            if (!T) break;
            new Promise(function(F) {
              var S;
              F((S = T.onCancel) == null ? void 0 : S.call(T, x(W.reason)));
            }).then(function() {
              B.postMessage({ sourceName: j, targetName: $, stream: a, streamId: z, success: !0 });
            }, function(F) {
              B.postMessage({ sourceName: j, targetName: $, stream: a, streamId: z, reason: x(F) });
            }), T.sinkCapability.reject(x(W.reason)), T.isCancelled = !0, delete this.streamSinks[z];
            break;
          default:
            throw new Error("Unexpected stream case");
        }
      }, n2 = async function(W, z) {
        var j, $, B;
        await Promise.allSettled([(j = W.startCall) == null ? void 0 : j.promise, ($ = W.pullCall) == null ? void 0 : $.promise, (B = W.cancelCall) == null ? void 0 : B.promise]), delete this.streamControllers[z];
      }, I);
    }, (u, l, f) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PDFWorkerStream = void 0;
      var o = f(2);
      l.PDFWorkerStream = class {
        constructor(a) {
          this._msgHandler = a, this._contentLength = null, this._fullRequestReader = null, this._rangeRequestReaders = [];
        }
        getFullReader() {
          return (0, o.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once."), this._fullRequestReader = new g(this._msgHandler), this._fullRequestReader;
        }
        getRangeReader(a, d) {
          const m = new p(a, d, this._msgHandler);
          return this._rangeRequestReaders.push(m), m;
        }
        cancelAllRequests(a) {
          var d;
          (d = this._fullRequestReader) == null || d.cancel(a);
          for (const m of this._rangeRequestReaders.slice(0)) m.cancel(a);
        }
      };
      class g {
        constructor(a) {
          this._msgHandler = a, this.onProgress = null, this._contentLength = null, this._isRangeSupported = !1, this._isStreamingSupported = !1;
          const d = this._msgHandler.sendWithStream("GetReader");
          this._reader = d.getReader(), this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((m) => {
            this._isStreamingSupported = m.isStreamingSupported, this._isRangeSupported = m.isRangeSupported, this._contentLength = m.contentLength;
          });
        }
        get headersReady() {
          return this._headersReady;
        }
        get contentLength() {
          return this._contentLength;
        }
        get isStreamingSupported() {
          return this._isStreamingSupported;
        }
        get isRangeSupported() {
          return this._isRangeSupported;
        }
        async read() {
          const { value: a, done: d } = await this._reader.read();
          return d ? { value: void 0, done: !0 } : { value: a.buffer, done: !1 };
        }
        cancel(a) {
          this._reader.cancel(a);
        }
      }
      class p {
        constructor(a, d, m) {
          this._msgHandler = m, this.onProgress = null;
          const b = this._msgHandler.sendWithStream("GetRangeReader", { begin: a, end: d });
          this._reader = b.getReader();
        }
        get isStreamingSupported() {
          return !1;
        }
        async read() {
          const { value: a, done: d } = await this._reader.read();
          return d ? { value: void 0, done: !0 } : { value: a.buffer, done: !1 };
        }
        cancel(a) {
          this._reader.cancel(a);
        }
      }
    }], i = {};
    function s(u) {
      var l = i[u];
      if (l !== void 0) return l.exports;
      var f = i[u] = { exports: {} };
      return r[u](f, f.exports, s), f.exports;
    }
    var c = {};
    return (() => {
      var u = c;
      Object.defineProperty(u, "__esModule", { value: !0 }), Object.defineProperty(u, "WorkerMessageHandler", { enumerable: !0, get: function() {
        return l.WorkerMessageHandler;
      } });
      var l = s(1);
    })(), c;
  })());
})(sM);
var Ygt = sM.exports;
const Zgt = /* @__PURE__ */ Dn(Ygt);
function qs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function vM(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
/*!
 * GSAP 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var ua = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, i0 = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, P4, Zr, tr, As = 1e8, li = 1 / As, n6 = Math.PI * 2, Jgt = n6 / 4, Qgt = 0, wM = Math.sqrt, tpt = Math.cos, ept = Math.sin, Hr = function(e) {
  return typeof e == "string";
}, ur = function(e) {
  return typeof e == "function";
}, ho = function(e) {
  return typeof e == "number";
}, I4 = function(e) {
  return typeof e > "u";
}, Ts = function(e) {
  return typeof e == "object";
}, Ui = function(e) {
  return e !== !1;
}, F4 = function() {
  return typeof window < "u";
}, wd = function(e) {
  return ur(e) || Hr(e);
}, xM = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, ci = Array.isArray, r6 = /(?:-?\.?\d|\.)+/gi, SM = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Eu = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Nm = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, CM = /[+-]=-?[.\d]+/, AM = /[^,'"\[\]\s]+/gi, npt = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, rr, us, i6, R4, ga = {}, bg = {}, _M, kM = function(e) {
  return (bg = a0(e, ga)) && Xi;
}, D4 = function(e, r) {
  return console.warn("Invalid property", e, "set to", r, "Missing plugin? gsap.registerPlugin()");
}, gh = function(e, r) {
  return !r && console.warn(e);
}, OM = function(e, r) {
  return e && (ga[e] = r) && bg && (bg[e] = r) || ga;
}, ph = function() {
  return 0;
}, rpt = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, r2 = {
  suppressEvents: !0,
  kill: !1
}, ipt = {
  suppressEvents: !0
}, $4 = {}, Ko = [], a6 = {}, TM, na = {}, Bm = {}, FS = 30, i2 = [], L4 = "", N4 = function(e) {
  var r = e[0], i, s;
  if (Ts(r) || ur(r) || (e = [e]), !(i = (r._gsap || {}).harness)) {
    for (s = i2.length; s-- && !i2[s].targetTest(r); )
      ;
    i = i2[s];
  }
  for (s = e.length; s--; )
    e[s] && (e[s]._gsap || (e[s]._gsap = new JM(e[s], i))) || e.splice(s, 1);
  return e;
}, hc = function(e) {
  return e._gsap || N4(Pa(e))[0]._gsap;
}, MM = function(e, r, i) {
  return (i = e[r]) && ur(i) ? e[r]() : I4(i) && e.getAttribute && e.getAttribute(r) || i;
}, Hi = function(e, r) {
  return (e = e.split(",")).forEach(r) || e;
}, gr = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Sr = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, $u = function(e, r) {
  var i = r.charAt(0), s = parseFloat(r.substr(2));
  return e = parseFloat(e), i === "+" ? e + s : i === "-" ? e - s : i === "*" ? e * s : e / s;
}, apt = function(e, r) {
  for (var i = r.length, s = 0; e.indexOf(r[s]) < 0 && ++s < i; )
    ;
  return s < i;
}, vg = function() {
  var e = Ko.length, r = Ko.slice(0), i, s;
  for (a6 = {}, Ko.length = 0, i = 0; i < e; i++)
    s = r[i], s && s._lazy && (s.render(s._lazy[0], s._lazy[1], !0)._lazy = 0);
}, EM = function(e, r, i, s) {
  Ko.length && !Zr && vg(), e.render(r, i, Zr && r < 0 && (e._initted || e._startAt)), Ko.length && !Zr && vg();
}, PM = function(e) {
  var r = parseFloat(e);
  return (r || r === 0) && (e + "").match(AM).length < 2 ? r : Hr(e) ? e.trim() : e;
}, IM = function(e) {
  return e;
}, pa = function(e, r) {
  for (var i in r)
    i in e || (e[i] = r[i]);
  return e;
}, spt = function(e) {
  return function(r, i) {
    for (var s in i)
      s in r || s === "duration" && e || s === "ease" || (r[s] = i[s]);
  };
}, a0 = function(e, r) {
  for (var i in r)
    e[i] = r[i];
  return e;
}, RS = function t(e, r) {
  for (var i in r)
    i !== "__proto__" && i !== "constructor" && i !== "prototype" && (e[i] = Ts(r[i]) ? t(e[i] || (e[i] = {}), r[i]) : r[i]);
  return e;
}, wg = function(e, r) {
  var i = {}, s;
  for (s in e)
    s in r || (i[s] = e[s]);
  return i;
}, j1 = function(e) {
  var r = e.parent || rr, i = e.keyframes ? spt(ci(e.keyframes)) : pa;
  if (Ui(e.inherit))
    for (; r; )
      i(e, r.vars.defaults), r = r.parent || r._dp;
  return e;
}, opt = function(e, r) {
  for (var i = e.length, s = i === r.length; s && i-- && e[i] === r[i]; )
    ;
  return i < 0;
}, FM = function(e, r, i, s, c) {
  var u = e[s], l;
  if (c)
    for (l = r[c]; u && u[c] > l; )
      u = u._prev;
  return u ? (r._next = u._next, u._next = r) : (r._next = e[i], e[i] = r), r._next ? r._next._prev = r : e[s] = r, r._prev = u, r.parent = r._dp = e, r;
}, Tp = function(e, r, i, s) {
  i === void 0 && (i = "_first"), s === void 0 && (s = "_last");
  var c = r._prev, u = r._next;
  c ? c._next = u : e[i] === r && (e[i] = u), u ? u._prev = c : e[s] === r && (e[s] = c), r._next = r._prev = r.parent = null;
}, cl = function(e, r) {
  e.parent && (!r || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, fc = function(e, r) {
  if (e && (!r || r._end > e._dur || r._start < 0))
    for (var i = e; i; )
      i._dirty = 1, i = i.parent;
  return e;
}, lpt = function(e) {
  for (var r = e.parent; r && r.parent; )
    r._dirty = 1, r.totalDuration(), r = r.parent;
  return e;
}, s6 = function(e, r, i, s) {
  return e._startAt && (Zr ? e._startAt.revert(r2) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(r, !0, s));
}, cpt = function t(e) {
  return !e || e._ts && t(e.parent);
}, DS = function(e) {
  return e._repeat ? s0(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, s0 = function(e, r) {
  var i = Math.floor(e = Sr(e / r));
  return e && i === e ? i - 1 : i;
}, xg = function(e, r) {
  return (e - r._start) * r._ts + (r._ts >= 0 ? 0 : r._dirty ? r.totalDuration() : r._tDur);
}, Mp = function(e) {
  return e._end = Sr(e._start + (e._tDur / Math.abs(e._ts || e._rts || li) || 0));
}, Ep = function(e, r) {
  var i = e._dp;
  return i && i.smoothChildTiming && e._ts && (e._start = Sr(i._time - (e._ts > 0 ? r / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - r) / -e._ts)), Mp(e), i._dirty || fc(i, e)), e;
}, RM = function(e, r) {
  var i;
  if ((r._time || !r._dur && r._initted || r._start < e._time && (r._dur || !r.add)) && (i = xg(e.rawTime(), r), (!r._dur || Yh(0, r.totalDuration(), i) - r._tTime > li) && r.render(i, !0)), fc(e, r)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (i = e; i._dp; )
        i.rawTime() >= 0 && i.totalTime(i._tTime), i = i._dp;
    e._zTime = -1e-8;
  }
}, gs = function(e, r, i, s) {
  return r.parent && cl(r), r._start = Sr((ho(i) ? i : i || e !== rr ? Oa(e, i, r) : e._time) + r._delay), r._end = Sr(r._start + (r.totalDuration() / Math.abs(r.timeScale()) || 0)), FM(e, r, "_first", "_last", e._sort ? "_start" : 0), o6(r) || (e._recent = r), s || RM(e, r), e._ts < 0 && Ep(e, e._tTime), e;
}, DM = function(e, r) {
  return (ga.ScrollTrigger || D4("scrollTrigger", r)) && ga.ScrollTrigger.create(r, e);
}, $M = function(e, r, i, s, c) {
  if (j4(e, r, c), !e._initted)
    return 1;
  if (!i && e._pt && !Zr && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && TM !== sa.frame)
    return Ko.push(e), e._lazy = [c, s], 1;
}, upt = function t(e) {
  var r = e.parent;
  return r && r._ts && r._initted && !r._lock && (r.rawTime() < 0 || t(r));
}, o6 = function(e) {
  var r = e.data;
  return r === "isFromStart" || r === "isStart";
}, hpt = function(e, r, i, s) {
  var c = e.ratio, u = r < 0 || !r && (!e._start && upt(e) && !(!e._initted && o6(e)) || (e._ts < 0 || e._dp._ts < 0) && !o6(e)) ? 0 : 1, l = e._rDelay, f = 0, o, g, p;
  if (l && e._repeat && (f = Yh(0, e._tDur, r), g = s0(f, l), e._yoyo && g & 1 && (u = 1 - u), g !== s0(e._tTime, l) && (c = 1 - u, e.vars.repeatRefresh && e._initted && e.invalidate())), u !== c || Zr || s || e._zTime === li || !r && e._zTime) {
    if (!e._initted && $M(e, r, s, i, f))
      return;
    for (p = e._zTime, e._zTime = r || (i ? li : 0), i || (i = r && !p), e.ratio = u, e._from && (u = 1 - u), e._time = 0, e._tTime = f, o = e._pt; o; )
      o.r(u, o.d), o = o._next;
    r < 0 && s6(e, r, i, !0), e._onUpdate && !i && ca(e, "onUpdate"), f && e._repeat && !i && e.parent && ca(e, "onRepeat"), (r >= e._tDur || r < 0) && e.ratio === u && (u && cl(e, 1), !i && !Zr && (ca(e, u ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = r);
}, fpt = function(e, r, i) {
  var s;
  if (i > r)
    for (s = e._first; s && s._start <= i; ) {
      if (s.data === "isPause" && s._start > r)
        return s;
      s = s._next;
    }
  else
    for (s = e._last; s && s._start >= i; ) {
      if (s.data === "isPause" && s._start < r)
        return s;
      s = s._prev;
    }
}, o0 = function(e, r, i, s) {
  var c = e._repeat, u = Sr(r) || 0, l = e._tTime / e._tDur;
  return l && !s && (e._time *= u / e._dur), e._dur = u, e._tDur = c ? c < 0 ? 1e10 : Sr(u * (c + 1) + e._rDelay * c) : u, l > 0 && !s && Ep(e, e._tTime = e._tDur * l), e.parent && Mp(e), i || fc(e.parent, e), e;
}, $S = function(e) {
  return e instanceof ki ? fc(e) : o0(e, e._dur);
}, dpt = {
  _start: 0,
  endTime: ph,
  totalDuration: ph
}, Oa = function t(e, r, i) {
  var s = e.labels, c = e._recent || dpt, u = e.duration() >= As ? c.endTime(!1) : e._dur, l, f, o;
  return Hr(r) && (isNaN(r) || r in s) ? (f = r.charAt(0), o = r.substr(-1) === "%", l = r.indexOf("="), f === "<" || f === ">" ? (l >= 0 && (r = r.replace(/=/, "")), (f === "<" ? c._start : c.endTime(c._repeat >= 0)) + (parseFloat(r.substr(1)) || 0) * (o ? (l < 0 ? c : i).totalDuration() / 100 : 1)) : l < 0 ? (r in s || (s[r] = u), s[r]) : (f = parseFloat(r.charAt(l - 1) + r.substr(l + 1)), o && i && (f = f / 100 * (ci(i) ? i[0] : i).totalDuration()), l > 1 ? t(e, r.substr(0, l - 1), i) + f : u + f)) : r == null ? u : +r;
}, U1 = function(e, r, i) {
  var s = ho(r[1]), c = (s ? 2 : 1) + (e < 2 ? 0 : 1), u = r[c], l, f;
  if (s && (u.duration = r[1]), u.parent = i, e) {
    for (l = u, f = i; f && !("immediateRender" in l); )
      l = f.vars.defaults || {}, f = Ui(f.vars.inherit) && f.parent;
    u.immediateRender = Ui(l.immediateRender), e < 2 ? u.runBackwards = 1 : u.startAt = r[c - 1];
  }
  return new xr(r[0], u, r[c + 1]);
}, xl = function(e, r) {
  return e || e === 0 ? r(e) : r;
}, Yh = function(e, r, i) {
  return i < e ? e : i > r ? r : i;
}, ai = function(e, r) {
  return !Hr(e) || !(r = npt.exec(e)) ? "" : r[1];
}, gpt = function(e, r, i) {
  return xl(i, function(s) {
    return Yh(e, r, s);
  });
}, l6 = [].slice, LM = function(e, r) {
  return e && Ts(e) && "length" in e && (!r && !e.length || e.length - 1 in e && Ts(e[0])) && !e.nodeType && e !== us;
}, ppt = function(e, r, i) {
  return i === void 0 && (i = []), e.forEach(function(s) {
    var c;
    return Hr(s) && !r || LM(s, 1) ? (c = i).push.apply(c, Pa(s)) : i.push(s);
  }) || i;
}, Pa = function(e, r, i) {
  return tr && !r && tr.selector ? tr.selector(e) : Hr(e) && !i && (i6 || !l0()) ? l6.call((r || R4).querySelectorAll(e), 0) : ci(e) ? ppt(e, i) : LM(e) ? l6.call(e, 0) : e ? [e] : [];
}, c6 = function(e) {
  return e = Pa(e)[0] || gh("Invalid scope") || {}, function(r) {
    var i = e.current || e.nativeElement || e;
    return Pa(r, i.querySelectorAll ? i : i === e ? gh("Invalid scope") || R4.createElement("div") : e);
  };
}, NM = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, BM = function(e) {
  if (ur(e))
    return e;
  var r = Ts(e) ? e : {
    each: e
  }, i = dc(r.ease), s = r.from || 0, c = parseFloat(r.base) || 0, u = {}, l = s > 0 && s < 1, f = isNaN(s) || l, o = r.axis, g = s, p = s;
  return Hr(s) ? g = p = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[s] || 0 : !l && f && (g = s[0], p = s[1]), function(n, a, d) {
    var m = (d || r).length, b = u[m], w, v, h, x, _, M, O, E, I;
    if (!b) {
      if (I = r.grid === "auto" ? 0 : (r.grid || [1, As])[1], !I) {
        for (O = -1e8; O < (O = d[I++].getBoundingClientRect().left) && I < m; )
          ;
        I < m && I--;
      }
      for (b = u[m] = [], w = f ? Math.min(I, m) * g - 0.5 : s % I, v = I === As ? 0 : f ? m * p / I - 0.5 : s / I | 0, O = 0, E = As, M = 0; M < m; M++)
        h = M % I - w, x = v - (M / I | 0), b[M] = _ = o ? Math.abs(o === "y" ? x : h) : wM(h * h + x * x), _ > O && (O = _), _ < E && (E = _);
      s === "random" && NM(b), b.max = O - E, b.min = E, b.v = m = (parseFloat(r.amount) || parseFloat(r.each) * (I > m ? m - 1 : o ? o === "y" ? m / I : I : Math.max(I, m / I)) || 0) * (s === "edges" ? -1 : 1), b.b = m < 0 ? c - m : c, b.u = ai(r.amount || r.each) || 0, i = i && m < 0 ? KM(i) : i;
    }
    return m = (b[n] - b.min) / b.max || 0, Sr(b.b + (i ? i(m) : m) * b.v) + b.u;
  };
}, u6 = function(e) {
  var r = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(i) {
    var s = Sr(Math.round(parseFloat(i) / e) * e * r);
    return (s - s % 1) / r + (ho(i) ? 0 : ai(i));
  };
}, jM = function(e, r) {
  var i = ci(e), s, c;
  return !i && Ts(e) && (s = i = e.radius || As, e.values ? (e = Pa(e.values), (c = !ho(e[0])) && (s *= s)) : e = u6(e.increment)), xl(r, i ? ur(e) ? function(u) {
    return c = e(u), Math.abs(c - u) <= s ? c : u;
  } : function(u) {
    for (var l = parseFloat(c ? u.x : u), f = parseFloat(c ? u.y : 0), o = As, g = 0, p = e.length, n, a; p--; )
      c ? (n = e[p].x - l, a = e[p].y - f, n = n * n + a * a) : n = Math.abs(e[p] - l), n < o && (o = n, g = p);
    return g = !s || o <= s ? e[g] : u, c || g === u || ho(u) ? g : g + ai(u);
  } : u6(e));
}, UM = function(e, r, i, s) {
  return xl(ci(e) ? !r : i === !0 ? !!(i = 0) : !s, function() {
    return ci(e) ? e[~~(Math.random() * e.length)] : (i = i || 1e-5) && (s = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((e - i / 2 + Math.random() * (r - e + i * 0.99)) / i) * i * s) / s;
  });
}, mpt = function() {
  for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
    r[i] = arguments[i];
  return function(s) {
    return r.reduce(function(c, u) {
      return u(c);
    }, s);
  };
}, ypt = function(e, r) {
  return function(i) {
    return e(parseFloat(i)) + (r || ai(i));
  };
}, bpt = function(e, r, i) {
  return VM(e, r, 0, 1, i);
}, HM = function(e, r, i) {
  return xl(i, function(s) {
    return e[~~r(s)];
  });
}, vpt = function t(e, r, i) {
  var s = r - e;
  return ci(e) ? HM(e, t(0, e.length), r) : xl(i, function(c) {
    return (s + (c - e) % s) % s + e;
  });
}, wpt = function t(e, r, i) {
  var s = r - e, c = s * 2;
  return ci(e) ? HM(e, t(0, e.length - 1), r) : xl(i, function(u) {
    return u = (c + (u - e) % c) % c || 0, e + (u > s ? c - u : u);
  });
}, mh = function(e) {
  for (var r = 0, i = "", s, c, u, l; ~(s = e.indexOf("random(", r)); )
    u = e.indexOf(")", s), l = e.charAt(s + 7) === "[", c = e.substr(s + 7, u - s - 7).match(l ? AM : r6), i += e.substr(r, s - r) + UM(l ? c : +c[0], l ? 0 : +c[1], +c[2] || 1e-5), r = u + 1;
  return i + e.substr(r, e.length - r);
}, VM = function(e, r, i, s, c) {
  var u = r - e, l = s - i;
  return xl(c, function(f) {
    return i + ((f - e) / u * l || 0);
  });
}, xpt = function t(e, r, i, s) {
  var c = isNaN(e + r) ? 0 : function(a) {
    return (1 - a) * e + a * r;
  };
  if (!c) {
    var u = Hr(e), l = {}, f, o, g, p, n;
    if (i === !0 && (s = 1) && (i = null), u)
      e = {
        p: e
      }, r = {
        p: r
      };
    else if (ci(e) && !ci(r)) {
      for (g = [], p = e.length, n = p - 2, o = 1; o < p; o++)
        g.push(t(e[o - 1], e[o]));
      p--, c = function(d) {
        d *= p;
        var m = Math.min(n, ~~d);
        return g[m](d - m);
      }, i = r;
    } else s || (e = a0(ci(e) ? [] : {}, e));
    if (!g) {
      for (f in r)
        B4.call(l, e, f, "get", r[f]);
      c = function(d) {
        return V4(d, l) || (u ? e.p : e);
      };
    }
  }
  return xl(i, c);
}, LS = function(e, r, i) {
  var s = e.labels, c = As, u, l, f;
  for (u in s)
    l = s[u] - r, l < 0 == !!i && l && c > (l = Math.abs(l)) && (f = u, c = l);
  return f;
}, ca = function(e, r, i) {
  var s = e.vars, c = s[r], u = tr, l = e._ctx, f, o, g;
  if (c)
    return f = s[r + "Params"], o = s.callbackScope || e, i && Ko.length && vg(), l && (tr = l), g = f ? c.apply(o, f) : c.call(o), tr = u, g;
}, _1 = function(e) {
  return cl(e), e.scrollTrigger && e.scrollTrigger.kill(!!Zr), e.progress() < 1 && ca(e, "onInterrupt"), e;
}, Pu, zM = [], XM = function(e) {
  if (e)
    if (e = !e.name && e.default || e, F4() || e.headless) {
      var r = e.name, i = ur(e), s = r && !i && e.init ? function() {
        this._props = [];
      } : e, c = {
        init: ph,
        render: V4,
        add: B4,
        kill: Lpt,
        modifier: $pt,
        rawVars: 0
      }, u = {
        targetTest: 0,
        get: 0,
        getSetter: H4,
        aliases: {},
        register: 0
      };
      if (l0(), e !== s) {
        if (na[r])
          return;
        pa(s, pa(wg(e, c), u)), a0(s.prototype, a0(c, wg(e, u))), na[s.prop = r] = s, e.targetTest && (i2.push(s), $4[r] = 1), r = (r === "css" ? "CSS" : r.charAt(0).toUpperCase() + r.substr(1)) + "Plugin";
      }
      OM(r, s), e.register && e.register(Xi, s, Vi);
    } else
      zM.push(e);
}, jn = 255, k1 = {
  aqua: [0, jn, jn],
  lime: [0, jn, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, jn],
  navy: [0, 0, 128],
  white: [jn, jn, jn],
  olive: [128, 128, 0],
  yellow: [jn, jn, 0],
  orange: [jn, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [jn, 0, 0],
  pink: [jn, 192, 203],
  cyan: [0, jn, jn],
  transparent: [jn, jn, jn, 0]
}, jm = function(e, r, i) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? r + (i - r) * e * 6 : e < 0.5 ? i : e * 3 < 2 ? r + (i - r) * (2 / 3 - e) * 6 : r) * jn + 0.5 | 0;
}, qM = function(e, r, i) {
  var s = e ? ho(e) ? [e >> 16, e >> 8 & jn, e & jn] : 0 : k1.black, c, u, l, f, o, g, p, n, a, d;
  if (!s) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), k1[e])
      s = k1[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (c = e.charAt(1), u = e.charAt(2), l = e.charAt(3), e = "#" + c + c + u + u + l + l + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return s = parseInt(e.substr(1, 6), 16), [s >> 16, s >> 8 & jn, s & jn, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), s = [e >> 16, e >> 8 & jn, e & jn];
    } else if (e.substr(0, 3) === "hsl") {
      if (s = d = e.match(r6), !r)
        f = +s[0] % 360 / 360, o = +s[1] / 100, g = +s[2] / 100, u = g <= 0.5 ? g * (o + 1) : g + o - g * o, c = g * 2 - u, s.length > 3 && (s[3] *= 1), s[0] = jm(f + 1 / 3, c, u), s[1] = jm(f, c, u), s[2] = jm(f - 1 / 3, c, u);
      else if (~e.indexOf("="))
        return s = e.match(SM), i && s.length < 4 && (s[3] = 1), s;
    } else
      s = e.match(r6) || k1.transparent;
    s = s.map(Number);
  }
  return r && !d && (c = s[0] / jn, u = s[1] / jn, l = s[2] / jn, p = Math.max(c, u, l), n = Math.min(c, u, l), g = (p + n) / 2, p === n ? f = o = 0 : (a = p - n, o = g > 0.5 ? a / (2 - p - n) : a / (p + n), f = p === c ? (u - l) / a + (u < l ? 6 : 0) : p === u ? (l - c) / a + 2 : (c - u) / a + 4, f *= 60), s[0] = ~~(f + 0.5), s[1] = ~~(o * 100 + 0.5), s[2] = ~~(g * 100 + 0.5)), i && s.length < 4 && (s[3] = 1), s;
}, WM = function(e) {
  var r = [], i = [], s = -1;
  return e.split(Yo).forEach(function(c) {
    var u = c.match(Eu) || [];
    r.push.apply(r, u), i.push(s += u.length + 1);
  }), r.c = i, r;
}, NS = function(e, r, i) {
  var s = "", c = (e + s).match(Yo), u = r ? "hsla(" : "rgba(", l = 0, f, o, g, p;
  if (!c)
    return e;
  if (c = c.map(function(n) {
    return (n = qM(n, r, 1)) && u + (r ? n[0] + "," + n[1] + "%," + n[2] + "%," + n[3] : n.join(",")) + ")";
  }), i && (g = WM(e), f = i.c, f.join(s) !== g.c.join(s)))
    for (o = e.replace(Yo, "1").split(Eu), p = o.length - 1; l < p; l++)
      s += o[l] + (~f.indexOf(l) ? c.shift() || u + "0,0,0,0)" : (g.length ? g : c.length ? c : i).shift());
  if (!o)
    for (o = e.split(Yo), p = o.length - 1; l < p; l++)
      s += o[l] + c[l];
  return s + o[p];
}, Yo = function() {
  var t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in k1)
    t += "|" + e + "\\b";
  return new RegExp(t + ")", "gi");
}(), Spt = /hsl[a]?\(/, GM = function(e) {
  var r = e.join(" "), i;
  if (Yo.lastIndex = 0, Yo.test(r))
    return i = Spt.test(r), e[1] = NS(e[1], i), e[0] = NS(e[0], i, WM(e[1])), !0;
}, yh, sa = function() {
  var t = Date.now, e = 500, r = 33, i = t(), s = i, c = 1e3 / 240, u = c, l = [], f, o, g, p, n, a, d = function m(b) {
    var w = t() - s, v = b === !0, h, x, _, M;
    if ((w > e || w < 0) && (i += w - r), s += w, _ = s - i, h = _ - u, (h > 0 || v) && (M = ++p.frame, n = _ - p.time * 1e3, p.time = _ = _ / 1e3, u += h + (h >= c ? 4 : c - h), x = 1), v || (f = o(m)), x)
      for (a = 0; a < l.length; a++)
        l[a](_, n, M, b);
  };
  return p = {
    time: 0,
    frame: 0,
    tick: function() {
      d(!0);
    },
    deltaRatio: function(b) {
      return n / (1e3 / (b || 60));
    },
    wake: function() {
      _M && (!i6 && F4() && (us = i6 = window, R4 = us.document || {}, ga.gsap = Xi, (us.gsapVersions || (us.gsapVersions = [])).push(Xi.version), kM(bg || us.GreenSockGlobals || !us.gsap && us || {}), zM.forEach(XM)), g = typeof requestAnimationFrame < "u" && requestAnimationFrame, f && p.sleep(), o = g || function(b) {
        return setTimeout(b, u - p.time * 1e3 + 1 | 0);
      }, yh = 1, d(2));
    },
    sleep: function() {
      (g ? cancelAnimationFrame : clearTimeout)(f), yh = 0, o = ph;
    },
    lagSmoothing: function(b, w) {
      e = b || 1 / 0, r = Math.min(w || 33, e);
    },
    fps: function(b) {
      c = 1e3 / (b || 240), u = p.time * 1e3 + c;
    },
    add: function(b, w, v) {
      var h = w ? function(x, _, M, O) {
        b(x, _, M, O), p.remove(h);
      } : b;
      return p.remove(b), l[v ? "unshift" : "push"](h), l0(), h;
    },
    remove: function(b, w) {
      ~(w = l.indexOf(b)) && l.splice(w, 1) && a >= w && a--;
    },
    _listeners: l
  }, p;
}(), l0 = function() {
  return !yh && sa.wake();
}, wn = {}, Cpt = /^[\d.\-M][\d.\-,\s]/, Apt = /["']/g, _pt = function(e) {
  for (var r = {}, i = e.substr(1, e.length - 3).split(":"), s = i[0], c = 1, u = i.length, l, f, o; c < u; c++)
    f = i[c], l = c !== u - 1 ? f.lastIndexOf(",") : f.length, o = f.substr(0, l), r[s] = isNaN(o) ? o.replace(Apt, "").trim() : +o, s = f.substr(l + 1).trim();
  return r;
}, kpt = function(e) {
  var r = e.indexOf("(") + 1, i = e.indexOf(")"), s = e.indexOf("(", r);
  return e.substring(r, ~s && s < i ? e.indexOf(")", i + 1) : i);
}, Opt = function(e) {
  var r = (e + "").split("("), i = wn[r[0]];
  return i && r.length > 1 && i.config ? i.config.apply(null, ~e.indexOf("{") ? [_pt(r[1])] : kpt(e).split(",").map(PM)) : wn._CE && Cpt.test(e) ? wn._CE("", e) : i;
}, KM = function(e) {
  return function(r) {
    return 1 - e(1 - r);
  };
}, YM = function t(e, r) {
  for (var i = e._first, s; i; )
    i instanceof ki ? t(i, r) : i.vars.yoyoEase && (!i._yoyo || !i._repeat) && i._yoyo !== r && (i.timeline ? t(i.timeline, r) : (s = i._ease, i._ease = i._yEase, i._yEase = s, i._yoyo = r)), i = i._next;
}, dc = function(e, r) {
  return e && (ur(e) ? e : wn[e] || Opt(e)) || r;
}, Lc = function(e, r, i, s) {
  i === void 0 && (i = function(f) {
    return 1 - r(1 - f);
  }), s === void 0 && (s = function(f) {
    return f < 0.5 ? r(f * 2) / 2 : 1 - r((1 - f) * 2) / 2;
  });
  var c = {
    easeIn: r,
    easeOut: i,
    easeInOut: s
  }, u;
  return Hi(e, function(l) {
    wn[l] = ga[l] = c, wn[u = l.toLowerCase()] = i;
    for (var f in c)
      wn[u + (f === "easeIn" ? ".in" : f === "easeOut" ? ".out" : ".inOut")] = wn[l + "." + f] = c[f];
  }), c;
}, ZM = function(e) {
  return function(r) {
    return r < 0.5 ? (1 - e(1 - r * 2)) / 2 : 0.5 + e((r - 0.5) * 2) / 2;
  };
}, Um = function t(e, r, i) {
  var s = r >= 1 ? r : 1, c = (i || (e ? 0.3 : 0.45)) / (r < 1 ? r : 1), u = c / n6 * (Math.asin(1 / s) || 0), l = function(g) {
    return g === 1 ? 1 : s * Math.pow(2, -10 * g) * ept((g - u) * c) + 1;
  }, f = e === "out" ? l : e === "in" ? function(o) {
    return 1 - l(1 - o);
  } : ZM(l);
  return c = n6 / c, f.config = function(o, g) {
    return t(e, o, g);
  }, f;
}, Hm = function t(e, r) {
  r === void 0 && (r = 1.70158);
  var i = function(u) {
    return u ? --u * u * ((r + 1) * u + r) + 1 : 0;
  }, s = e === "out" ? i : e === "in" ? function(c) {
    return 1 - i(1 - c);
  } : ZM(i);
  return s.config = function(c) {
    return t(e, c);
  }, s;
};
Hi("Linear,Quad,Cubic,Quart,Quint,Strong", function(t, e) {
  var r = e < 5 ? e + 1 : e;
  Lc(t + ",Power" + (r - 1), e ? function(i) {
    return Math.pow(i, r);
  } : function(i) {
    return i;
  }, function(i) {
    return 1 - Math.pow(1 - i, r);
  }, function(i) {
    return i < 0.5 ? Math.pow(i * 2, r) / 2 : 1 - Math.pow((1 - i) * 2, r) / 2;
  });
});
wn.Linear.easeNone = wn.none = wn.Linear.easeIn;
Lc("Elastic", Um("in"), Um("out"), Um());
(function(t, e) {
  var r = 1 / e, i = 2 * r, s = 2.5 * r, c = function(l) {
    return l < r ? t * l * l : l < i ? t * Math.pow(l - 1.5 / e, 2) + 0.75 : l < s ? t * (l -= 2.25 / e) * l + 0.9375 : t * Math.pow(l - 2.625 / e, 2) + 0.984375;
  };
  Lc("Bounce", function(u) {
    return 1 - c(1 - u);
  }, c);
})(7.5625, 2.75);
Lc("Expo", function(t) {
  return Math.pow(2, 10 * (t - 1)) * t + t * t * t * t * t * t * (1 - t);
});
Lc("Circ", function(t) {
  return -(wM(1 - t * t) - 1);
});
Lc("Sine", function(t) {
  return t === 1 ? 1 : -tpt(t * Jgt) + 1;
});
Lc("Back", Hm("in"), Hm("out"), Hm());
wn.SteppedEase = wn.steps = ga.SteppedEase = {
  config: function(e, r) {
    e === void 0 && (e = 1);
    var i = 1 / e, s = e + (r ? 0 : 1), c = r ? 1 : 0, u = 1 - li;
    return function(l) {
      return ((s * Yh(0, u, l) | 0) + c) * i;
    };
  }
};
i0.ease = wn["quad.out"];
Hi("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t) {
  return L4 += t + "," + t + "Params,";
});
var JM = function(e, r) {
  this.id = Qgt++, e._gsap = this, this.target = e, this.harness = r, this.get = r ? r.get : MM, this.set = r ? r.getSetter : H4;
}, bh = /* @__PURE__ */ function() {
  function t(r) {
    this.vars = r, this._delay = +r.delay || 0, (this._repeat = r.repeat === 1 / 0 ? -2 : r.repeat || 0) && (this._rDelay = r.repeatDelay || 0, this._yoyo = !!r.yoyo || !!r.yoyoEase), this._ts = 1, o0(this, +r.duration, 1, 1), this.data = r.data, tr && (this._ctx = tr, tr.data.push(this)), yh || sa.wake();
  }
  var e = t.prototype;
  return e.delay = function(i) {
    return i || i === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + i - this._delay), this._delay = i, this) : this._delay;
  }, e.duration = function(i) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? i + (i + this._rDelay) * this._repeat : i) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(i) {
    return arguments.length ? (this._dirty = 0, o0(this, this._repeat < 0 ? i : (i - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(i, s) {
    if (l0(), !arguments.length)
      return this._tTime;
    var c = this._dp;
    if (c && c.smoothChildTiming && this._ts) {
      for (Ep(this, i), !c._dp || c.parent || RM(c, this); c && c.parent; )
        c.parent._time !== c._start + (c._ts >= 0 ? c._tTime / c._ts : (c.totalDuration() - c._tTime) / -c._ts) && c.totalTime(c._tTime, !0), c = c.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && i < this._tDur || this._ts < 0 && i > 0 || !this._tDur && !i) && gs(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== i || !this._dur && !s || this._initted && Math.abs(this._zTime) === li || !i && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = i), EM(this, i, s)), this;
  }, e.time = function(i, s) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), i + DS(this)) % (this._dur + this._rDelay) || (i ? this._dur : 0), s) : this._time;
  }, e.totalProgress = function(i, s) {
    return arguments.length ? this.totalTime(this.totalDuration() * i, s) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(i, s) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - i : i) + DS(this), s) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(i, s) {
    var c = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (i - 1) * c, s) : this._repeat ? s0(this._tTime, c) + 1 : 1;
  }, e.timeScale = function(i, s) {
    if (!arguments.length)
      return this._rts === -1e-8 ? 0 : this._rts;
    if (this._rts === i)
      return this;
    var c = this.parent && this._ts ? xg(this.parent._time, this) : this._tTime;
    return this._rts = +i || 0, this._ts = this._ps || i === -1e-8 ? 0 : this._rts, this.totalTime(Yh(-Math.abs(this._delay), this._tDur, c), s !== !1), Mp(this), lpt(this);
  }, e.paused = function(i) {
    return arguments.length ? (this._ps !== i && (this._ps = i, i ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (l0(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== li && (this._tTime -= li)))), this) : this._ps;
  }, e.startTime = function(i) {
    if (arguments.length) {
      this._start = i;
      var s = this.parent || this._dp;
      return s && (s._sort || !this.parent) && gs(s, this, i - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(i) {
    return this._start + (Ui(i) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(i) {
    var s = this.parent || this._dp;
    return s ? i && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? xg(s.rawTime(i), this) : this._tTime : this._tTime;
  }, e.revert = function(i) {
    i === void 0 && (i = ipt);
    var s = Zr;
    return Zr = i, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(i), this.totalTime(-0.01, i.suppressEvents)), this.data !== "nested" && i.kill !== !1 && this.kill(), Zr = s, this;
  }, e.globalTime = function(i) {
    for (var s = this, c = arguments.length ? i : s.rawTime(); s; )
      c = s._start + c / (Math.abs(s._ts) || 1), s = s._dp;
    return !this.parent && this._sat ? this._sat.globalTime(i) : c;
  }, e.repeat = function(i) {
    return arguments.length ? (this._repeat = i === 1 / 0 ? -2 : i, $S(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(i) {
    if (arguments.length) {
      var s = this._time;
      return this._rDelay = i, $S(this), s ? this.time(s) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(i) {
    return arguments.length ? (this._yoyo = i, this) : this._yoyo;
  }, e.seek = function(i, s) {
    return this.totalTime(Oa(this, i), Ui(s));
  }, e.restart = function(i, s) {
    return this.play().totalTime(i ? -this._delay : 0, Ui(s)), this._dur || (this._zTime = -1e-8), this;
  }, e.play = function(i, s) {
    return i != null && this.seek(i, s), this.reversed(!1).paused(!1);
  }, e.reverse = function(i, s) {
    return i != null && this.seek(i || this.totalDuration(), s), this.reversed(!0).paused(!1);
  }, e.pause = function(i, s) {
    return i != null && this.seek(i, s), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(i) {
    return arguments.length ? (!!i !== this.reversed() && this.timeScale(-this._rts || (i ? -1e-8 : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -1e-8, this;
  }, e.isActive = function() {
    var i = this.parent || this._dp, s = this._start, c;
    return !!(!i || this._ts && this._initted && i.isActive() && (c = i.rawTime(!0)) >= s && c < this.endTime(!0) - li);
  }, e.eventCallback = function(i, s, c) {
    var u = this.vars;
    return arguments.length > 1 ? (s ? (u[i] = s, c && (u[i + "Params"] = c), i === "onUpdate" && (this._onUpdate = s)) : delete u[i], this) : u[i];
  }, e.then = function(i) {
    var s = this;
    return new Promise(function(c) {
      var u = ur(i) ? i : IM, l = function() {
        var o = s.then;
        s.then = null, ur(u) && (u = u(s)) && (u.then || u === s) && (s.then = o), c(u), s.then = o;
      };
      s._initted && s.totalProgress() === 1 && s._ts >= 0 || !s._tTime && s._ts < 0 ? l() : s._prom = l;
    });
  }, e.kill = function() {
    _1(this);
  }, t;
}();
pa(bh.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -1e-8,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var ki = /* @__PURE__ */ function(t) {
  vM(e, t);
  function e(i, s) {
    var c;
    return i === void 0 && (i = {}), c = t.call(this, i) || this, c.labels = {}, c.smoothChildTiming = !!i.smoothChildTiming, c.autoRemoveChildren = !!i.autoRemoveChildren, c._sort = Ui(i.sortChildren), rr && gs(i.parent || rr, qs(c), s), i.reversed && c.reverse(), i.paused && c.paused(!0), i.scrollTrigger && DM(qs(c), i.scrollTrigger), c;
  }
  var r = e.prototype;
  return r.to = function(s, c, u) {
    return U1(0, arguments, this), this;
  }, r.from = function(s, c, u) {
    return U1(1, arguments, this), this;
  }, r.fromTo = function(s, c, u, l) {
    return U1(2, arguments, this), this;
  }, r.set = function(s, c, u) {
    return c.duration = 0, c.parent = this, j1(c).repeatDelay || (c.repeat = 0), c.immediateRender = !!c.immediateRender, new xr(s, c, Oa(this, u), 1), this;
  }, r.call = function(s, c, u) {
    return gs(this, xr.delayedCall(0, s, c), u);
  }, r.staggerTo = function(s, c, u, l, f, o, g) {
    return u.duration = c, u.stagger = u.stagger || l, u.onComplete = o, u.onCompleteParams = g, u.parent = this, new xr(s, u, Oa(this, f)), this;
  }, r.staggerFrom = function(s, c, u, l, f, o, g) {
    return u.runBackwards = 1, j1(u).immediateRender = Ui(u.immediateRender), this.staggerTo(s, c, u, l, f, o, g);
  }, r.staggerFromTo = function(s, c, u, l, f, o, g, p) {
    return l.startAt = u, j1(l).immediateRender = Ui(l.immediateRender), this.staggerTo(s, c, l, f, o, g, p);
  }, r.render = function(s, c, u) {
    var l = this._time, f = this._dirty ? this.totalDuration() : this._tDur, o = this._dur, g = s <= 0 ? 0 : Sr(s), p = this._zTime < 0 != s < 0 && (this._initted || !o), n, a, d, m, b, w, v, h, x, _, M, O;
    if (this !== rr && g > f && s >= 0 && (g = f), g !== this._tTime || u || p) {
      if (l !== this._time && o && (g += this._time - l, s += this._time - l), n = g, x = this._start, h = this._ts, w = !h, p && (o || (l = this._zTime), (s || !c) && (this._zTime = s)), this._repeat) {
        if (M = this._yoyo, b = o + this._rDelay, this._repeat < -1 && s < 0)
          return this.totalTime(b * 100 + s, c, u);
        if (n = Sr(g % b), g === f ? (m = this._repeat, n = o) : (_ = Sr(g / b), m = ~~_, m && m === _ && (n = o, m--), n > o && (n = o)), _ = s0(this._tTime, b), !l && this._tTime && _ !== m && this._tTime - _ * b - this._dur <= 0 && (_ = m), M && m & 1 && (n = o - n, O = 1), m !== _ && !this._lock) {
          var E = M && _ & 1, I = E === (M && m & 1);
          if (m < _ && (E = !E), l = E ? 0 : g % o ? o : g, this._lock = 1, this.render(l || (O ? 0 : Sr(m * b)), c, !o)._lock = 0, this._tTime = g, !c && this.parent && ca(this, "onRepeat"), this.vars.repeatRefresh && !O && (this.invalidate()._lock = 1), l && l !== this._time || w !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (o = this._dur, f = this._tDur, I && (this._lock = 2, l = E ? o : -1e-4, this.render(l, !0), this.vars.repeatRefresh && !O && this.invalidate()), this._lock = 0, !this._ts && !w)
            return this;
          YM(this, O);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (v = fpt(this, Sr(l), Sr(n)), v && (g -= n - (n = v._start))), this._tTime = g, this._time = n, this._act = !h, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = s, l = 0), !l && n && !c && !m && (ca(this, "onStart"), this._tTime !== g))
        return this;
      if (n >= l && s >= 0)
        for (a = this._first; a; ) {
          if (d = a._next, (a._act || n >= a._start) && a._ts && v !== a) {
            if (a.parent !== this)
              return this.render(s, c, u);
            if (a.render(a._ts > 0 ? (n - a._start) * a._ts : (a._dirty ? a.totalDuration() : a._tDur) + (n - a._start) * a._ts, c, u), n !== this._time || !this._ts && !w) {
              v = 0, d && (g += this._zTime = -1e-8);
              break;
            }
          }
          a = d;
        }
      else {
        a = this._last;
        for (var R = s < 0 ? s : n; a; ) {
          if (d = a._prev, (a._act || R <= a._end) && a._ts && v !== a) {
            if (a.parent !== this)
              return this.render(s, c, u);
            if (a.render(a._ts > 0 ? (R - a._start) * a._ts : (a._dirty ? a.totalDuration() : a._tDur) + (R - a._start) * a._ts, c, u || Zr && (a._initted || a._startAt)), n !== this._time || !this._ts && !w) {
              v = 0, d && (g += this._zTime = R ? -1e-8 : li);
              break;
            }
          }
          a = d;
        }
      }
      if (v && !c && (this.pause(), v.render(n >= l ? 0 : -1e-8)._zTime = n >= l ? 1 : -1, this._ts))
        return this._start = x, Mp(this), this.render(s, c, u);
      this._onUpdate && !c && ca(this, "onUpdate", !0), (g === f && this._tTime >= this.totalDuration() || !g && l) && (x === this._start || Math.abs(h) !== Math.abs(this._ts)) && (this._lock || ((s || !o) && (g === f && this._ts > 0 || !g && this._ts < 0) && cl(this, 1), !c && !(s < 0 && !l) && (g || l || !f) && (ca(this, g === f && s >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < f && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, r.add = function(s, c) {
    var u = this;
    if (ho(c) || (c = Oa(this, c, s)), !(s instanceof bh)) {
      if (ci(s))
        return s.forEach(function(l) {
          return u.add(l, c);
        }), this;
      if (Hr(s))
        return this.addLabel(s, c);
      if (ur(s))
        s = xr.delayedCall(0, s);
      else
        return this;
    }
    return this !== s ? gs(this, s, c) : this;
  }, r.getChildren = function(s, c, u, l) {
    s === void 0 && (s = !0), c === void 0 && (c = !0), u === void 0 && (u = !0), l === void 0 && (l = -1e8);
    for (var f = [], o = this._first; o; )
      o._start >= l && (o instanceof xr ? c && f.push(o) : (u && f.push(o), s && f.push.apply(f, o.getChildren(!0, c, u)))), o = o._next;
    return f;
  }, r.getById = function(s) {
    for (var c = this.getChildren(1, 1, 1), u = c.length; u--; )
      if (c[u].vars.id === s)
        return c[u];
  }, r.remove = function(s) {
    return Hr(s) ? this.removeLabel(s) : ur(s) ? this.killTweensOf(s) : (s.parent === this && Tp(this, s), s === this._recent && (this._recent = this._last), fc(this));
  }, r.totalTime = function(s, c) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Sr(sa.time - (this._ts > 0 ? s / this._ts : (this.totalDuration() - s) / -this._ts))), t.prototype.totalTime.call(this, s, c), this._forcing = 0, this) : this._tTime;
  }, r.addLabel = function(s, c) {
    return this.labels[s] = Oa(this, c), this;
  }, r.removeLabel = function(s) {
    return delete this.labels[s], this;
  }, r.addPause = function(s, c, u) {
    var l = xr.delayedCall(0, c || ph, u);
    return l.data = "isPause", this._hasPause = 1, gs(this, l, Oa(this, s));
  }, r.removePause = function(s) {
    var c = this._first;
    for (s = Oa(this, s); c; )
      c._start === s && c.data === "isPause" && cl(c), c = c._next;
  }, r.killTweensOf = function(s, c, u) {
    for (var l = this.getTweensOf(s, u), f = l.length; f--; )
      jo !== l[f] && l[f].kill(s, c);
    return this;
  }, r.getTweensOf = function(s, c) {
    for (var u = [], l = Pa(s), f = this._first, o = ho(c), g; f; )
      f instanceof xr ? apt(f._targets, l) && (o ? (!jo || f._initted && f._ts) && f.globalTime(0) <= c && f.globalTime(f.totalDuration()) > c : !c || f.isActive()) && u.push(f) : (g = f.getTweensOf(l, c)).length && u.push.apply(u, g), f = f._next;
    return u;
  }, r.tweenTo = function(s, c) {
    c = c || {};
    var u = this, l = Oa(u, s), f = c, o = f.startAt, g = f.onStart, p = f.onStartParams, n = f.immediateRender, a, d = xr.to(u, pa({
      ease: c.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: l,
      overwrite: "auto",
      duration: c.duration || Math.abs((l - (o && "time" in o ? o.time : u._time)) / u.timeScale()) || li,
      onStart: function() {
        if (u.pause(), !a) {
          var b = c.duration || Math.abs((l - (o && "time" in o ? o.time : u._time)) / u.timeScale());
          d._dur !== b && o0(d, b, 0, 1).render(d._time, !0, !0), a = 1;
        }
        g && g.apply(d, p || []);
      }
    }, c));
    return n ? d.render(0) : d;
  }, r.tweenFromTo = function(s, c, u) {
    return this.tweenTo(c, pa({
      startAt: {
        time: Oa(this, s)
      }
    }, u));
  }, r.recent = function() {
    return this._recent;
  }, r.nextLabel = function(s) {
    return s === void 0 && (s = this._time), LS(this, Oa(this, s));
  }, r.previousLabel = function(s) {
    return s === void 0 && (s = this._time), LS(this, Oa(this, s), 1);
  }, r.currentLabel = function(s) {
    return arguments.length ? this.seek(s, !0) : this.previousLabel(this._time + li);
  }, r.shiftChildren = function(s, c, u) {
    u === void 0 && (u = 0);
    for (var l = this._first, f = this.labels, o; l; )
      l._start >= u && (l._start += s, l._end += s), l = l._next;
    if (c)
      for (o in f)
        f[o] >= u && (f[o] += s);
    return fc(this);
  }, r.invalidate = function(s) {
    var c = this._first;
    for (this._lock = 0; c; )
      c.invalidate(s), c = c._next;
    return t.prototype.invalidate.call(this, s);
  }, r.clear = function(s) {
    s === void 0 && (s = !0);
    for (var c = this._first, u; c; )
      u = c._next, this.remove(c), c = u;
    return this._dp && (this._time = this._tTime = this._pTime = 0), s && (this.labels = {}), fc(this);
  }, r.totalDuration = function(s) {
    var c = 0, u = this, l = u._last, f = As, o, g, p;
    if (arguments.length)
      return u.timeScale((u._repeat < 0 ? u.duration() : u.totalDuration()) / (u.reversed() ? -s : s));
    if (u._dirty) {
      for (p = u.parent; l; )
        o = l._prev, l._dirty && l.totalDuration(), g = l._start, g > f && u._sort && l._ts && !u._lock ? (u._lock = 1, gs(u, l, g - l._delay, 1)._lock = 0) : f = g, g < 0 && l._ts && (c -= g, (!p && !u._dp || p && p.smoothChildTiming) && (u._start += g / u._ts, u._time -= g, u._tTime -= g), u.shiftChildren(-g, !1, -1 / 0), f = 0), l._end > c && l._ts && (c = l._end), l = o;
      o0(u, u === rr && u._time > c ? u._time : c, 1, 1), u._dirty = 0;
    }
    return u._tDur;
  }, e.updateRoot = function(s) {
    if (rr._ts && (EM(rr, xg(s, rr)), TM = sa.frame), sa.frame >= FS) {
      FS += ua.autoSleep || 120;
      var c = rr._first;
      if ((!c || !c._ts) && ua.autoSleep && sa._listeners.length < 2) {
        for (; c && !c._ts; )
          c = c._next;
        c || sa.sleep();
      }
    }
  }, e;
}(bh);
pa(ki.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var Tpt = function(e, r, i, s, c, u, l) {
  var f = new Vi(this._pt, e, r, 0, 1, iE, null, c), o = 0, g = 0, p, n, a, d, m, b, w, v;
  for (f.b = i, f.e = s, i += "", s += "", (w = ~s.indexOf("random(")) && (s = mh(s)), u && (v = [i, s], u(v, e, r), i = v[0], s = v[1]), n = i.match(Nm) || []; p = Nm.exec(s); )
    d = p[0], m = s.substring(o, p.index), a ? a = (a + 1) % 5 : m.substr(-5) === "rgba(" && (a = 1), d !== n[g++] && (b = parseFloat(n[g - 1]) || 0, f._pt = {
      _next: f._pt,
      p: m || g === 1 ? m : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: b,
      c: d.charAt(1) === "=" ? $u(b, d) - b : parseFloat(d) - b,
      m: a && a < 4 ? Math.round : 0
    }, o = Nm.lastIndex);
  return f.c = o < s.length ? s.substring(o, s.length) : "", f.fp = l, (CM.test(s) || w) && (f.e = 0), this._pt = f, f;
}, B4 = function(e, r, i, s, c, u, l, f, o, g) {
  ur(s) && (s = s(c || 0, e, u));
  var p = e[r], n = i !== "get" ? i : ur(p) ? o ? e[r.indexOf("set") || !ur(e["get" + r.substr(3)]) ? r : "get" + r.substr(3)](o) : e[r]() : p, a = ur(p) ? o ? Fpt : nE : U4, d;
  if (Hr(s) && (~s.indexOf("random(") && (s = mh(s)), s.charAt(1) === "=" && (d = $u(n, s) + (ai(n) || 0), (d || d === 0) && (s = d))), !g || n !== s || h6)
    return !isNaN(n * s) && s !== "" ? (d = new Vi(this._pt, e, r, +n || 0, s - (n || 0), typeof p == "boolean" ? Dpt : rE, 0, a), o && (d.fp = o), l && d.modifier(l, this, e), this._pt = d) : (!p && !(r in e) && D4(r, s), Tpt.call(this, e, r, n, s, a, f || ua.stringFilter, o));
}, Mpt = function(e, r, i, s, c) {
  if (ur(e) && (e = H1(e, c, r, i, s)), !Ts(e) || e.style && e.nodeType || ci(e) || xM(e))
    return Hr(e) ? H1(e, c, r, i, s) : e;
  var u = {}, l;
  for (l in e)
    u[l] = H1(e[l], c, r, i, s);
  return u;
}, QM = function(e, r, i, s, c, u) {
  var l, f, o, g;
  if (na[e] && (l = new na[e]()).init(c, l.rawVars ? r[e] : Mpt(r[e], s, c, u, i), i, s, u) !== !1 && (i._pt = f = new Vi(i._pt, c, e, 0, 1, l.render, l, 0, l.priority), i !== Pu))
    for (o = i._ptLookup[i._targets.indexOf(c)], g = l._props.length; g--; )
      o[l._props[g]] = f;
  return l;
}, jo, h6, j4 = function t(e, r, i) {
  var s = e.vars, c = s.ease, u = s.startAt, l = s.immediateRender, f = s.lazy, o = s.onUpdate, g = s.runBackwards, p = s.yoyoEase, n = s.keyframes, a = s.autoRevert, d = e._dur, m = e._startAt, b = e._targets, w = e.parent, v = w && w.data === "nested" ? w.vars.targets : b, h = e._overwrite === "auto" && !P4, x = e.timeline, _, M, O, E, I, R, W, z, j, $, B, C, T;
  if (x && (!n || !c) && (c = "none"), e._ease = dc(c, i0.ease), e._yEase = p ? KM(dc(p === !0 ? c : p, i0.ease)) : 0, p && e._yoyo && !e._repeat && (p = e._yEase, e._yEase = e._ease, e._ease = p), e._from = !x && !!s.runBackwards, !x || n && !s.stagger) {
    if (z = b[0] ? hc(b[0]).harness : 0, C = z && s[z.prop], _ = wg(s, $4), m && (m._zTime < 0 && m.progress(1), r < 0 && g && l && !a ? m.render(-1, !0) : m.revert(g && d ? r2 : rpt), m._lazy = 0), u) {
      if (cl(e._startAt = xr.set(b, pa({
        data: "isStart",
        overwrite: !1,
        parent: w,
        immediateRender: !0,
        lazy: !m && Ui(f),
        startAt: null,
        delay: 0,
        onUpdate: o && function() {
          return ca(e, "onUpdate");
        },
        stagger: 0
      }, u))), e._startAt._dp = 0, e._startAt._sat = e, r < 0 && (Zr || !l && !a) && e._startAt.revert(r2), l && d && r <= 0 && i <= 0) {
        r && (e._zTime = r);
        return;
      }
    } else if (g && d && !m) {
      if (r && (l = !1), O = pa({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: l && !m && Ui(f),
        immediateRender: l,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: w
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, _), C && (O[z.prop] = C), cl(e._startAt = xr.set(b, O)), e._startAt._dp = 0, e._startAt._sat = e, r < 0 && (Zr ? e._startAt.revert(r2) : e._startAt.render(-1, !0)), e._zTime = r, !l)
        t(e._startAt, li, li);
      else if (!r)
        return;
    }
    for (e._pt = e._ptCache = 0, f = d && Ui(f) || f && !d, M = 0; M < b.length; M++) {
      if (I = b[M], W = I._gsap || N4(b)[M]._gsap, e._ptLookup[M] = $ = {}, a6[W.id] && Ko.length && vg(), B = v === b ? M : v.indexOf(I), z && (j = new z()).init(I, C || _, e, B, v) !== !1 && (e._pt = E = new Vi(e._pt, I, j.name, 0, 1, j.render, j, 0, j.priority), j._props.forEach(function(F) {
        $[F] = E;
      }), j.priority && (R = 1)), !z || C)
        for (O in _)
          na[O] && (j = QM(O, _, e, B, I, v)) ? j.priority && (R = 1) : $[O] = E = B4.call(e, I, O, "get", _[O], B, v, 0, s.stringFilter);
      e._op && e._op[M] && e.kill(I, e._op[M]), h && e._pt && (jo = e, rr.killTweensOf(I, $, e.globalTime(r)), T = !e.parent, jo = 0), e._pt && f && (a6[W.id] = 1);
    }
    R && aE(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = o, e._initted = (!e._op || e._pt) && !T, n && r <= 0 && x.render(As, !0, !0);
}, Ept = function(e, r, i, s, c, u, l, f) {
  var o = (e._pt && e._ptCache || (e._ptCache = {}))[r], g, p, n, a;
  if (!o)
    for (o = e._ptCache[r] = [], n = e._ptLookup, a = e._targets.length; a--; ) {
      if (g = n[a][r], g && g.d && g.d._pt)
        for (g = g.d._pt; g && g.p !== r && g.fp !== r; )
          g = g._next;
      if (!g)
        return h6 = 1, e.vars[r] = "+=0", j4(e, l), h6 = 0, f ? gh(r + " not eligible for reset") : 1;
      o.push(g);
    }
  for (a = o.length; a--; )
    p = o[a], g = p._pt || p, g.s = (s || s === 0) && !c ? s : g.s + (s || 0) + u * g.c, g.c = i - g.s, p.e && (p.e = gr(i) + ai(p.e)), p.b && (p.b = g.s + ai(p.b));
}, Ppt = function(e, r) {
  var i = e[0] ? hc(e[0]).harness : 0, s = i && i.aliases, c, u, l, f;
  if (!s)
    return r;
  c = a0({}, r);
  for (u in s)
    if (u in c)
      for (f = s[u].split(","), l = f.length; l--; )
        c[f[l]] = c[u];
  return c;
}, Ipt = function(e, r, i, s) {
  var c = r.ease || s || "power1.inOut", u, l;
  if (ci(r))
    l = i[e] || (i[e] = []), r.forEach(function(f, o) {
      return l.push({
        t: o / (r.length - 1) * 100,
        v: f,
        e: c
      });
    });
  else
    for (u in r)
      l = i[u] || (i[u] = []), u === "ease" || l.push({
        t: parseFloat(e),
        v: r[u],
        e: c
      });
}, H1 = function(e, r, i, s, c) {
  return ur(e) ? e.call(r, i, s, c) : Hr(e) && ~e.indexOf("random(") ? mh(e) : e;
}, tE = L4 + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", eE = {};
Hi(tE + ",id,stagger,delay,duration,paused,scrollTrigger", function(t) {
  return eE[t] = 1;
});
var xr = /* @__PURE__ */ function(t) {
  vM(e, t);
  function e(i, s, c, u) {
    var l;
    typeof s == "number" && (c.duration = s, s = c, c = null), l = t.call(this, u ? s : j1(s)) || this;
    var f = l.vars, o = f.duration, g = f.delay, p = f.immediateRender, n = f.stagger, a = f.overwrite, d = f.keyframes, m = f.defaults, b = f.scrollTrigger, w = f.yoyoEase, v = s.parent || rr, h = (ci(i) || xM(i) ? ho(i[0]) : "length" in s) ? [i] : Pa(i), x, _, M, O, E, I, R, W;
    if (l._targets = h.length ? N4(h) : gh("GSAP target " + i + " not found. https://gsap.com", !ua.nullTargetWarn) || [], l._ptLookup = [], l._overwrite = a, d || n || wd(o) || wd(g)) {
      if (s = l.vars, x = l.timeline = new ki({
        data: "nested",
        defaults: m || {},
        targets: v && v.data === "nested" ? v.vars.targets : h
      }), x.kill(), x.parent = x._dp = qs(l), x._start = 0, n || wd(o) || wd(g)) {
        if (O = h.length, R = n && BM(n), Ts(n))
          for (E in n)
            ~tE.indexOf(E) && (W || (W = {}), W[E] = n[E]);
        for (_ = 0; _ < O; _++)
          M = wg(s, eE), M.stagger = 0, w && (M.yoyoEase = w), W && a0(M, W), I = h[_], M.duration = +H1(o, qs(l), _, I, h), M.delay = (+H1(g, qs(l), _, I, h) || 0) - l._delay, !n && O === 1 && M.delay && (l._delay = g = M.delay, l._start += g, M.delay = 0), x.to(I, M, R ? R(_, I, h) : 0), x._ease = wn.none;
        x.duration() ? o = g = 0 : l.timeline = 0;
      } else if (d) {
        j1(pa(x.vars.defaults, {
          ease: "none"
        })), x._ease = dc(d.ease || s.ease || "none");
        var z = 0, j, $, B;
        if (ci(d))
          d.forEach(function(C) {
            return x.to(h, C, ">");
          }), x.duration();
        else {
          M = {};
          for (E in d)
            E === "ease" || E === "easeEach" || Ipt(E, d[E], M, d.easeEach);
          for (E in M)
            for (j = M[E].sort(function(C, T) {
              return C.t - T.t;
            }), z = 0, _ = 0; _ < j.length; _++)
              $ = j[_], B = {
                ease: $.e,
                duration: ($.t - (_ ? j[_ - 1].t : 0)) / 100 * o
              }, B[E] = $.v, x.to(h, B, z), z += B.duration;
          x.duration() < o && x.to({}, {
            duration: o - x.duration()
          });
        }
      }
      o || l.duration(o = x.duration());
    } else
      l.timeline = 0;
    return a === !0 && !P4 && (jo = qs(l), rr.killTweensOf(h), jo = 0), gs(v, qs(l), c), s.reversed && l.reverse(), s.paused && l.paused(!0), (p || !o && !d && l._start === Sr(v._time) && Ui(p) && cpt(qs(l)) && v.data !== "nested") && (l._tTime = -1e-8, l.render(Math.max(0, -g) || 0)), b && DM(qs(l), b), l;
  }
  var r = e.prototype;
  return r.render = function(s, c, u) {
    var l = this._time, f = this._tDur, o = this._dur, g = s < 0, p = s > f - li && !g ? f : s < li ? 0 : s, n, a, d, m, b, w, v, h, x;
    if (!o)
      hpt(this, s, c, u);
    else if (p !== this._tTime || !s || u || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== g || this._lazy) {
      if (n = p, h = this.timeline, this._repeat) {
        if (m = o + this._rDelay, this._repeat < -1 && g)
          return this.totalTime(m * 100 + s, c, u);
        if (n = Sr(p % m), p === f ? (d = this._repeat, n = o) : (b = Sr(p / m), d = ~~b, d && d === b ? (n = o, d--) : n > o && (n = o)), w = this._yoyo && d & 1, w && (x = this._yEase, n = o - n), b = s0(this._tTime, m), n === l && !u && this._initted && d === b)
          return this._tTime = p, this;
        d !== b && (h && this._yEase && YM(h, w), this.vars.repeatRefresh && !w && !this._lock && n !== m && this._initted && (this._lock = u = 1, this.render(Sr(m * d), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if ($M(this, g ? s : n, u, c, p))
          return this._tTime = 0, this;
        if (l !== this._time && !(u && this.vars.repeatRefresh && d !== b))
          return this;
        if (o !== this._dur)
          return this.render(s, c, u);
      }
      if (this._tTime = p, this._time = n, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = v = (x || this._ease)(n / o), this._from && (this.ratio = v = 1 - v), n && !l && !c && !d && (ca(this, "onStart"), this._tTime !== p))
        return this;
      for (a = this._pt; a; )
        a.r(v, a.d), a = a._next;
      h && h.render(s < 0 ? s : h._dur * h._ease(n / this._dur), c, u) || this._startAt && (this._zTime = s), this._onUpdate && !c && (g && s6(this, s, c, u), ca(this, "onUpdate")), this._repeat && d !== b && this.vars.onRepeat && !c && this.parent && ca(this, "onRepeat"), (p === this._tDur || !p) && this._tTime === p && (g && !this._onUpdate && s6(this, s, !0, !0), (s || !o) && (p === this._tDur && this._ts > 0 || !p && this._ts < 0) && cl(this, 1), !c && !(g && !l) && (p || l || w) && (ca(this, p === f ? "onComplete" : "onReverseComplete", !0), this._prom && !(p < f && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, r.targets = function() {
    return this._targets;
  }, r.invalidate = function(s) {
    return (!s || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(s), t.prototype.invalidate.call(this, s);
  }, r.resetTo = function(s, c, u, l, f) {
    yh || sa.wake(), this._ts || this.play();
    var o = Math.min(this._dur, (this._dp._time - this._start) * this._ts), g;
    return this._initted || j4(this, o), g = this._ease(o / this._dur), Ept(this, s, c, u, l, g, o, f) ? this.resetTo(s, c, u, l, 1) : (Ep(this, 0), this.parent || FM(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, r.kill = function(s, c) {
    if (c === void 0 && (c = "all"), !s && (!c || c === "all"))
      return this._lazy = this._pt = 0, this.parent ? _1(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Zr), this;
    if (this.timeline) {
      var u = this.timeline.totalDuration();
      return this.timeline.killTweensOf(s, c, jo && jo.vars.overwrite !== !0)._first || _1(this), this.parent && u !== this.timeline.totalDuration() && o0(this, this._dur * this.timeline._tDur / u, 0, 1), this;
    }
    var l = this._targets, f = s ? Pa(s) : l, o = this._ptLookup, g = this._pt, p, n, a, d, m, b, w;
    if ((!c || c === "all") && opt(l, f))
      return c === "all" && (this._pt = 0), _1(this);
    for (p = this._op = this._op || [], c !== "all" && (Hr(c) && (m = {}, Hi(c, function(v) {
      return m[v] = 1;
    }), c = m), c = Ppt(l, c)), w = l.length; w--; )
      if (~f.indexOf(l[w])) {
        n = o[w], c === "all" ? (p[w] = c, d = n, a = {}) : (a = p[w] = p[w] || {}, d = c);
        for (m in d)
          b = n && n[m], b && ((!("kill" in b.d) || b.d.kill(m) === !0) && Tp(this, b, "_pt"), delete n[m]), a !== "all" && (a[m] = 1);
      }
    return this._initted && !this._pt && g && _1(this), this;
  }, e.to = function(s, c) {
    return new e(s, c, arguments[2]);
  }, e.from = function(s, c) {
    return U1(1, arguments);
  }, e.delayedCall = function(s, c, u, l) {
    return new e(c, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: s,
      onComplete: c,
      onReverseComplete: c,
      onCompleteParams: u,
      onReverseCompleteParams: u,
      callbackScope: l
    });
  }, e.fromTo = function(s, c, u) {
    return U1(2, arguments);
  }, e.set = function(s, c) {
    return c.duration = 0, c.repeatDelay || (c.repeat = 0), new e(s, c);
  }, e.killTweensOf = function(s, c, u) {
    return rr.killTweensOf(s, c, u);
  }, e;
}(bh);
pa(xr.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Hi("staggerTo,staggerFrom,staggerFromTo", function(t) {
  xr[t] = function() {
    var e = new ki(), r = l6.call(arguments, 0);
    return r.splice(t === "staggerFromTo" ? 5 : 4, 0, 0), e[t].apply(e, r);
  };
});
var U4 = function(e, r, i) {
  return e[r] = i;
}, nE = function(e, r, i) {
  return e[r](i);
}, Fpt = function(e, r, i, s) {
  return e[r](s.fp, i);
}, Rpt = function(e, r, i) {
  return e.setAttribute(r, i);
}, H4 = function(e, r) {
  return ur(e[r]) ? nE : I4(e[r]) && e.setAttribute ? Rpt : U4;
}, rE = function(e, r) {
  return r.set(r.t, r.p, Math.round((r.s + r.c * e) * 1e6) / 1e6, r);
}, Dpt = function(e, r) {
  return r.set(r.t, r.p, !!(r.s + r.c * e), r);
}, iE = function(e, r) {
  var i = r._pt, s = "";
  if (!e && r.b)
    s = r.b;
  else if (e === 1 && r.e)
    s = r.e;
  else {
    for (; i; )
      s = i.p + (i.m ? i.m(i.s + i.c * e) : Math.round((i.s + i.c * e) * 1e4) / 1e4) + s, i = i._next;
    s += r.c;
  }
  r.set(r.t, r.p, s, r);
}, V4 = function(e, r) {
  for (var i = r._pt; i; )
    i.r(e, i.d), i = i._next;
}, $pt = function(e, r, i, s) {
  for (var c = this._pt, u; c; )
    u = c._next, c.p === s && c.modifier(e, r, i), c = u;
}, Lpt = function(e) {
  for (var r = this._pt, i, s; r; )
    s = r._next, r.p === e && !r.op || r.op === e ? Tp(this, r, "_pt") : r.dep || (i = 1), r = s;
  return !i;
}, Npt = function(e, r, i, s) {
  s.mSet(e, r, s.m.call(s.tween, i, s.mt), s);
}, aE = function(e) {
  for (var r = e._pt, i, s, c, u; r; ) {
    for (i = r._next, s = c; s && s.pr > r.pr; )
      s = s._next;
    (r._prev = s ? s._prev : u) ? r._prev._next = r : c = r, (r._next = s) ? s._prev = r : u = r, r = i;
  }
  e._pt = c;
}, Vi = /* @__PURE__ */ function() {
  function t(r, i, s, c, u, l, f, o, g) {
    this.t = i, this.s = c, this.c = u, this.p = s, this.r = l || rE, this.d = f || this, this.set = o || U4, this.pr = g || 0, this._next = r, r && (r._prev = this);
  }
  var e = t.prototype;
  return e.modifier = function(i, s, c) {
    this.mSet = this.mSet || this.set, this.set = Npt, this.m = i, this.mt = c, this.tween = s;
  }, t;
}();
Hi(L4 + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t) {
  return $4[t] = 1;
});
ga.TweenMax = ga.TweenLite = xr;
ga.TimelineLite = ga.TimelineMax = ki;
rr = new ki({
  sortChildren: !1,
  defaults: i0,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
ua.stringFilter = GM;
var gc = [], a2 = {}, Bpt = [], BS = 0, jpt = 0, Vm = function(e) {
  return (a2[e] || Bpt).map(function(r) {
    return r();
  });
}, f6 = function() {
  var e = Date.now(), r = [];
  e - BS > 2 && (Vm("matchMediaInit"), gc.forEach(function(i) {
    var s = i.queries, c = i.conditions, u, l, f, o;
    for (l in s)
      u = us.matchMedia(s[l]).matches, u && (f = 1), u !== c[l] && (c[l] = u, o = 1);
    o && (i.revert(), f && r.push(i));
  }), Vm("matchMediaRevert"), r.forEach(function(i) {
    return i.onMatch(i, function(s) {
      return i.add(null, s);
    });
  }), BS = e, Vm("matchMedia"));
}, sE = /* @__PURE__ */ function() {
  function t(r, i) {
    this.selector = i && c6(i), this.data = [], this._r = [], this.isReverted = !1, this.id = jpt++, r && this.add(r);
  }
  var e = t.prototype;
  return e.add = function(i, s, c) {
    ur(i) && (c = s, s = i, i = ur);
    var u = this, l = function() {
      var o = tr, g = u.selector, p;
      return o && o !== u && o.data.push(u), c && (u.selector = c6(c)), tr = u, p = s.apply(u, arguments), ur(p) && u._r.push(p), tr = o, u.selector = g, u.isReverted = !1, p;
    };
    return u.last = l, i === ur ? l(u, function(f) {
      return u.add(null, f);
    }) : i ? u[i] = l : l;
  }, e.ignore = function(i) {
    var s = tr;
    tr = null, i(this), tr = s;
  }, e.getTweens = function() {
    var i = [];
    return this.data.forEach(function(s) {
      return s instanceof t ? i.push.apply(i, s.getTweens()) : s instanceof xr && !(s.parent && s.parent.data === "nested") && i.push(s);
    }), i;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(i, s) {
    var c = this;
    if (i ? function() {
      for (var l = c.getTweens(), f = c.data.length, o; f--; )
        o = c.data[f], o.data === "isFlip" && (o.revert(), o.getChildren(!0, !0, !1).forEach(function(g) {
          return l.splice(l.indexOf(g), 1);
        }));
      for (l.map(function(g) {
        return {
          g: g._dur || g._delay || g._sat && !g._sat.vars.immediateRender ? g.globalTime(0) : -1 / 0,
          t: g
        };
      }).sort(function(g, p) {
        return p.g - g.g || -1 / 0;
      }).forEach(function(g) {
        return g.t.revert(i);
      }), f = c.data.length; f--; )
        o = c.data[f], o instanceof ki ? o.data !== "nested" && (o.scrollTrigger && o.scrollTrigger.revert(), o.kill()) : !(o instanceof xr) && o.revert && o.revert(i);
      c._r.forEach(function(g) {
        return g(i, c);
      }), c.isReverted = !0;
    }() : this.data.forEach(function(l) {
      return l.kill && l.kill();
    }), this.clear(), s)
      for (var u = gc.length; u--; )
        gc[u].id === this.id && gc.splice(u, 1);
  }, e.revert = function(i) {
    this.kill(i || {});
  }, t;
}(), Upt = /* @__PURE__ */ function() {
  function t(r) {
    this.contexts = [], this.scope = r, tr && tr.data.push(this);
  }
  var e = t.prototype;
  return e.add = function(i, s, c) {
    Ts(i) || (i = {
      matches: i
    });
    var u = new sE(0, c || this.scope), l = u.conditions = {}, f, o, g;
    tr && !u.selector && (u.selector = tr.selector), this.contexts.push(u), s = u.add("onMatch", s), u.queries = i;
    for (o in i)
      o === "all" ? g = 1 : (f = us.matchMedia(i[o]), f && (gc.indexOf(u) < 0 && gc.push(u), (l[o] = f.matches) && (g = 1), f.addListener ? f.addListener(f6) : f.addEventListener("change", f6)));
    return g && s(u, function(p) {
      return u.add(null, p);
    }), this;
  }, e.revert = function(i) {
    this.kill(i || {});
  }, e.kill = function(i) {
    this.contexts.forEach(function(s) {
      return s.kill(i, !0);
    });
  }, t;
}(), Sg = {
  registerPlugin: function() {
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    r.forEach(function(s) {
      return XM(s);
    });
  },
  timeline: function(e) {
    return new ki(e);
  },
  getTweensOf: function(e, r) {
    return rr.getTweensOf(e, r);
  },
  getProperty: function(e, r, i, s) {
    Hr(e) && (e = Pa(e)[0]);
    var c = hc(e || {}).get, u = i ? IM : PM;
    return i === "native" && (i = ""), e && (r ? u((na[r] && na[r].get || c)(e, r, i, s)) : function(l, f, o) {
      return u((na[l] && na[l].get || c)(e, l, f, o));
    });
  },
  quickSetter: function(e, r, i) {
    if (e = Pa(e), e.length > 1) {
      var s = e.map(function(g) {
        return Xi.quickSetter(g, r, i);
      }), c = s.length;
      return function(g) {
        for (var p = c; p--; )
          s[p](g);
      };
    }
    e = e[0] || {};
    var u = na[r], l = hc(e), f = l.harness && (l.harness.aliases || {})[r] || r, o = u ? function(g) {
      var p = new u();
      Pu._pt = 0, p.init(e, i ? g + i : g, Pu, 0, [e]), p.render(1, p), Pu._pt && V4(1, Pu);
    } : l.set(e, f);
    return u ? o : function(g) {
      return o(e, f, i ? g + i : g, l, 1);
    };
  },
  quickTo: function(e, r, i) {
    var s, c = Xi.to(e, pa((s = {}, s[r] = "+=0.1", s.paused = !0, s.stagger = 0, s), i || {})), u = function(f, o, g) {
      return c.resetTo(r, f, o, g);
    };
    return u.tween = c, u;
  },
  isTweening: function(e) {
    return rr.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = dc(e.ease, i0.ease)), RS(i0, e || {});
  },
  config: function(e) {
    return RS(ua, e || {});
  },
  registerEffect: function(e) {
    var r = e.name, i = e.effect, s = e.plugins, c = e.defaults, u = e.extendTimeline;
    (s || "").split(",").forEach(function(l) {
      return l && !na[l] && !ga[l] && gh(r + " effect requires " + l + " plugin.");
    }), Bm[r] = function(l, f, o) {
      return i(Pa(l), pa(f || {}, c), o);
    }, u && (ki.prototype[r] = function(l, f, o) {
      return this.add(Bm[r](l, Ts(f) ? f : (o = f) && {}, this), o);
    });
  },
  registerEase: function(e, r) {
    wn[e] = dc(r);
  },
  parseEase: function(e, r) {
    return arguments.length ? dc(e, r) : wn;
  },
  getById: function(e) {
    return rr.getById(e);
  },
  exportRoot: function(e, r) {
    e === void 0 && (e = {});
    var i = new ki(e), s, c;
    for (i.smoothChildTiming = Ui(e.smoothChildTiming), rr.remove(i), i._dp = 0, i._time = i._tTime = rr._time, s = rr._first; s; )
      c = s._next, (r || !(!s._dur && s instanceof xr && s.vars.onComplete === s._targets[0])) && gs(i, s, s._start - s._delay), s = c;
    return gs(rr, i, 0), i;
  },
  context: function(e, r) {
    return e ? new sE(e, r) : tr;
  },
  matchMedia: function(e) {
    return new Upt(e);
  },
  matchMediaRefresh: function() {
    return gc.forEach(function(e) {
      var r = e.conditions, i, s;
      for (s in r)
        r[s] && (r[s] = !1, i = 1);
      i && e.revert();
    }) || f6();
  },
  addEventListener: function(e, r) {
    var i = a2[e] || (a2[e] = []);
    ~i.indexOf(r) || i.push(r);
  },
  removeEventListener: function(e, r) {
    var i = a2[e], s = i && i.indexOf(r);
    s >= 0 && i.splice(s, 1);
  },
  utils: {
    wrap: vpt,
    wrapYoyo: wpt,
    distribute: BM,
    random: UM,
    snap: jM,
    normalize: bpt,
    getUnit: ai,
    clamp: gpt,
    splitColor: qM,
    toArray: Pa,
    selector: c6,
    mapRange: VM,
    pipe: mpt,
    unitize: ypt,
    interpolate: xpt,
    shuffle: NM
  },
  install: kM,
  effects: Bm,
  ticker: sa,
  updateRoot: ki.updateRoot,
  plugins: na,
  globalTimeline: rr,
  core: {
    PropTween: Vi,
    globals: OM,
    Tween: xr,
    Timeline: ki,
    Animation: bh,
    getCache: hc,
    _removeLinkedListItem: Tp,
    reverting: function() {
      return Zr;
    },
    context: function(e) {
      return e && tr && (tr.data.push(e), e._ctx = tr), tr;
    },
    suppressOverwrites: function(e) {
      return P4 = e;
    }
  }
};
Hi("to,from,fromTo,delayedCall,set,killTweensOf", function(t) {
  return Sg[t] = xr[t];
});
sa.add(ki.updateRoot);
Pu = Sg.to({}, {
  duration: 0
});
var Hpt = function(e, r) {
  for (var i = e._pt; i && i.p !== r && i.op !== r && i.fp !== r; )
    i = i._next;
  return i;
}, Vpt = function(e, r) {
  var i = e._targets, s, c, u;
  for (s in r)
    for (c = i.length; c--; )
      u = e._ptLookup[c][s], u && (u = u.d) && (u._pt && (u = Hpt(u, s)), u && u.modifier && u.modifier(r[s], e, i[c], s));
}, zm = function(e, r) {
  return {
    name: e,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(s, c, u) {
      u._onInit = function(l) {
        var f, o;
        if (Hr(c) && (f = {}, Hi(c, function(g) {
          return f[g] = 1;
        }), c = f), r) {
          f = {};
          for (o in c)
            f[o] = r(c[o]);
          c = f;
        }
        Vpt(l, c);
      };
    }
  };
}, Xi = Sg.registerPlugin({
  name: "attr",
  init: function(e, r, i, s, c) {
    var u, l, f;
    this.tween = i;
    for (u in r)
      f = e.getAttribute(u) || "", l = this.add(e, "setAttribute", (f || 0) + "", r[u], s, c, 0, 0, u), l.op = u, l.b = f, this._props.push(u);
  },
  render: function(e, r) {
    for (var i = r._pt; i; )
      Zr ? i.set(i.t, i.p, i.b, i) : i.r(e, i.d), i = i._next;
  }
}, {
  name: "endArray",
  init: function(e, r) {
    for (var i = r.length; i--; )
      this.add(e, i, e[i] || 0, r[i], 0, 0, 0, 0, 0, 1);
  }
}, zm("roundProps", u6), zm("modifiers"), zm("snap", jM)) || Sg;
xr.version = ki.version = Xi.version = "3.12.7";
_M = 1;
F4() && l0();
wn.Power0;
wn.Power1;
wn.Power2;
wn.Power3;
wn.Power4;
wn.Linear;
wn.Quad;
wn.Cubic;
wn.Quart;
wn.Quint;
wn.Strong;
wn.Elastic;
wn.Back;
wn.SteppedEase;
wn.Bounce;
wn.Sine;
wn.Expo;
wn.Circ;
/*!
 * CSSPlugin 3.12.7
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var jS, Uo, Lu, z4, ic, US, X4, zpt = function() {
  return typeof window < "u";
}, fo = {}, Wl = 180 / Math.PI, Nu = Math.PI / 180, pu = Math.atan2, HS = 1e8, q4 = /([A-Z])/g, Xpt = /(left|right|width|margin|padding|x)/i, qpt = /[\s,\(]\S/, ms = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, d6 = function(e, r) {
  return r.set(r.t, r.p, Math.round((r.s + r.c * e) * 1e4) / 1e4 + r.u, r);
}, Wpt = function(e, r) {
  return r.set(r.t, r.p, e === 1 ? r.e : Math.round((r.s + r.c * e) * 1e4) / 1e4 + r.u, r);
}, Gpt = function(e, r) {
  return r.set(r.t, r.p, e ? Math.round((r.s + r.c * e) * 1e4) / 1e4 + r.u : r.b, r);
}, Kpt = function(e, r) {
  var i = r.s + r.c * e;
  r.set(r.t, r.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + r.u, r);
}, oE = function(e, r) {
  return r.set(r.t, r.p, e ? r.e : r.b, r);
}, lE = function(e, r) {
  return r.set(r.t, r.p, e !== 1 ? r.b : r.e, r);
}, Ypt = function(e, r, i) {
  return e.style[r] = i;
}, Zpt = function(e, r, i) {
  return e.style.setProperty(r, i);
}, Jpt = function(e, r, i) {
  return e._gsap[r] = i;
}, Qpt = function(e, r, i) {
  return e._gsap.scaleX = e._gsap.scaleY = i;
}, t5t = function(e, r, i, s, c) {
  var u = e._gsap;
  u.scaleX = u.scaleY = i, u.renderTransform(c, u);
}, e5t = function(e, r, i, s, c) {
  var u = e._gsap;
  u[r] = i, u.renderTransform(c, u);
}, ir = "transform", zi = ir + "Origin", n5t = function t(e, r) {
  var i = this, s = this.target, c = s.style, u = s._gsap;
  if (e in fo && c) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = ms[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(l) {
        return i.tfm[l] = Gs(s, l);
      }) : this.tfm[e] = u.x ? u[e] : Gs(s, e), e === zi && (this.tfm.zOrigin = u.zOrigin);
    else
      return ms.transform.split(",").forEach(function(l) {
        return t.call(i, l, r);
      });
    if (this.props.indexOf(ir) >= 0)
      return;
    u.svg && (this.svgo = s.getAttribute("data-svg-origin"), this.props.push(zi, r, "")), e = ir;
  }
  (c || r) && this.props.push(e, r, c[e]);
}, cE = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, r5t = function() {
  var e = this.props, r = this.target, i = r.style, s = r._gsap, c, u;
  for (c = 0; c < e.length; c += 3)
    e[c + 1] ? e[c + 1] === 2 ? r[e[c]](e[c + 2]) : r[e[c]] = e[c + 2] : e[c + 2] ? i[e[c]] = e[c + 2] : i.removeProperty(e[c].substr(0, 2) === "--" ? e[c] : e[c].replace(q4, "-$1").toLowerCase());
  if (this.tfm) {
    for (u in this.tfm)
      s[u] = this.tfm[u];
    s.svg && (s.renderTransform(), r.setAttribute("data-svg-origin", this.svgo || "")), c = X4(), (!c || !c.isStart) && !i[ir] && (cE(i), s.zOrigin && i[zi] && (i[zi] += " " + s.zOrigin + "px", s.zOrigin = 0, s.renderTransform()), s.uncache = 1);
  }
}, uE = function(e, r) {
  var i = {
    target: e,
    props: [],
    revert: r5t,
    save: n5t
  };
  return e._gsap || Xi.core.getCache(e), r && e.style && e.nodeType && r.split(",").forEach(function(s) {
    return i.save(s);
  }), i;
}, hE, g6 = function(e, r) {
  var i = Uo.createElementNS ? Uo.createElementNS((r || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Uo.createElement(e);
  return i && i.style ? i : Uo.createElement(e);
}, _s = function t(e, r, i) {
  var s = getComputedStyle(e);
  return s[r] || s.getPropertyValue(r.replace(q4, "-$1").toLowerCase()) || s.getPropertyValue(r) || !i && t(e, c0(r) || r, 1) || "";
}, VS = "O,Moz,ms,Ms,Webkit".split(","), c0 = function(e, r, i) {
  var s = r || ic, c = s.style, u = 5;
  if (e in c && !i)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); u-- && !(VS[u] + e in c); )
    ;
  return u < 0 ? null : (u === 3 ? "ms" : u >= 0 ? VS[u] : "") + e;
}, p6 = function() {
  zpt() && window.document && (jS = window, Uo = jS.document, Lu = Uo.documentElement, ic = g6("div") || {
    style: {}
  }, g6("div"), ir = c0(ir), zi = ir + "Origin", ic.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", hE = !!c0("perspective"), X4 = Xi.core.reverting, z4 = 1);
}, zS = function(e) {
  var r = e.ownerSVGElement, i = g6("svg", r && r.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), s = e.cloneNode(!0), c;
  s.style.display = "block", i.appendChild(s), Lu.appendChild(i);
  try {
    c = s.getBBox();
  } catch {
  }
  return i.removeChild(s), Lu.removeChild(i), c;
}, XS = function(e, r) {
  for (var i = r.length; i--; )
    if (e.hasAttribute(r[i]))
      return e.getAttribute(r[i]);
}, fE = function(e) {
  var r, i;
  try {
    r = e.getBBox();
  } catch {
    r = zS(e), i = 1;
  }
  return r && (r.width || r.height) || i || (r = zS(e)), r && !r.width && !r.x && !r.y ? {
    x: +XS(e, ["x", "cx", "x1"]) || 0,
    y: +XS(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : r;
}, dE = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && fE(e));
}, Sc = function(e, r) {
  if (r) {
    var i = e.style, s;
    r in fo && r !== zi && (r = ir), i.removeProperty ? (s = r.substr(0, 2), (s === "ms" || r.substr(0, 6) === "webkit") && (r = "-" + r), i.removeProperty(s === "--" ? r : r.replace(q4, "-$1").toLowerCase())) : i.removeAttribute(r);
  }
}, Ho = function(e, r, i, s, c, u) {
  var l = new Vi(e._pt, r, i, 0, 1, u ? lE : oE);
  return e._pt = l, l.b = s, l.e = c, e._props.push(i), l;
}, qS = {
  deg: 1,
  rad: 1,
  turn: 1
}, i5t = {
  grid: 1,
  flex: 1
}, ul = function t(e, r, i, s) {
  var c = parseFloat(i) || 0, u = (i + "").trim().substr((c + "").length) || "px", l = ic.style, f = Xpt.test(r), o = e.tagName.toLowerCase() === "svg", g = (o ? "client" : "offset") + (f ? "Width" : "Height"), p = 100, n = s === "px", a = s === "%", d, m, b, w;
  if (s === u || !c || qS[s] || qS[u])
    return c;
  if (u !== "px" && !n && (c = t(e, r, i, "px")), w = e.getCTM && dE(e), (a || u === "%") && (fo[r] || ~r.indexOf("adius")))
    return d = w ? e.getBBox()[f ? "width" : "height"] : e[g], gr(a ? c / d * p : c / 100 * d);
  if (l[f ? "width" : "height"] = p + (n ? u : s), m = s !== "rem" && ~r.indexOf("adius") || s === "em" && e.appendChild && !o ? e : e.parentNode, w && (m = (e.ownerSVGElement || {}).parentNode), (!m || m === Uo || !m.appendChild) && (m = Uo.body), b = m._gsap, b && a && b.width && f && b.time === sa.time && !b.uncache)
    return gr(c / b.width * p);
  if (a && (r === "height" || r === "width")) {
    var v = e.style[r];
    e.style[r] = p + s, d = e[g], v ? e.style[r] = v : Sc(e, r);
  } else
    (a || u === "%") && !i5t[_s(m, "display")] && (l.position = _s(e, "position")), m === e && (l.position = "static"), m.appendChild(ic), d = ic[g], m.removeChild(ic), l.position = "absolute";
  return f && a && (b = hc(m), b.time = sa.time, b.width = m[g]), gr(n ? d * c / p : d && c ? p / d * c : 0);
}, Gs = function(e, r, i, s) {
  var c;
  return z4 || p6(), r in ms && r !== "transform" && (r = ms[r], ~r.indexOf(",") && (r = r.split(",")[0])), fo[r] && r !== "transform" ? (c = wh(e, s), c = r !== "transformOrigin" ? c[r] : c.svg ? c.origin : Ag(_s(e, zi)) + " " + c.zOrigin + "px") : (c = e.style[r], (!c || c === "auto" || s || ~(c + "").indexOf("calc(")) && (c = Cg[r] && Cg[r](e, r, i) || _s(e, r) || MM(e, r) || (r === "opacity" ? 1 : 0))), i && !~(c + "").trim().indexOf(" ") ? ul(e, r, c, i) + i : c;
}, a5t = function(e, r, i, s) {
  if (!i || i === "none") {
    var c = c0(r, e, 1), u = c && _s(e, c, 1);
    u && u !== i ? (r = c, i = u) : r === "borderColor" && (i = _s(e, "borderTopColor"));
  }
  var l = new Vi(this._pt, e.style, r, 0, 1, iE), f = 0, o = 0, g, p, n, a, d, m, b, w, v, h, x, _;
  if (l.b = i, l.e = s, i += "", s += "", s === "auto" && (m = e.style[r], e.style[r] = s, s = _s(e, r) || s, m ? e.style[r] = m : Sc(e, r)), g = [i, s], GM(g), i = g[0], s = g[1], n = i.match(Eu) || [], _ = s.match(Eu) || [], _.length) {
    for (; p = Eu.exec(s); )
      b = p[0], v = s.substring(f, p.index), d ? d = (d + 1) % 5 : (v.substr(-5) === "rgba(" || v.substr(-5) === "hsla(") && (d = 1), b !== (m = n[o++] || "") && (a = parseFloat(m) || 0, x = m.substr((a + "").length), b.charAt(1) === "=" && (b = $u(a, b) + x), w = parseFloat(b), h = b.substr((w + "").length), f = Eu.lastIndex - h.length, h || (h = h || ua.units[r] || x, f === s.length && (s += h, l.e += h)), x !== h && (a = ul(e, r, m, h) || 0), l._pt = {
        _next: l._pt,
        p: v || o === 1 ? v : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: a,
        c: w - a,
        m: d && d < 4 || r === "zIndex" ? Math.round : 0
      });
    l.c = f < s.length ? s.substring(f, s.length) : "";
  } else
    l.r = r === "display" && s === "none" ? lE : oE;
  return CM.test(s) && (l.e = 0), this._pt = l, l;
}, WS = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, s5t = function(e) {
  var r = e.split(" "), i = r[0], s = r[1] || "50%";
  return (i === "top" || i === "bottom" || s === "left" || s === "right") && (e = i, i = s, s = e), r[0] = WS[i] || i, r[1] = WS[s] || s, r.join(" ");
}, o5t = function(e, r) {
  if (r.tween && r.tween._time === r.tween._dur) {
    var i = r.t, s = i.style, c = r.u, u = i._gsap, l, f, o;
    if (c === "all" || c === !0)
      s.cssText = "", f = 1;
    else
      for (c = c.split(","), o = c.length; --o > -1; )
        l = c[o], fo[l] && (f = 1, l = l === "transformOrigin" ? zi : ir), Sc(i, l);
    f && (Sc(i, ir), u && (u.svg && i.removeAttribute("transform"), s.scale = s.rotate = s.translate = "none", wh(i, 1), u.uncache = 1, cE(s)));
  }
}, Cg = {
  clearProps: function(e, r, i, s, c) {
    if (c.data !== "isFromStart") {
      var u = e._pt = new Vi(e._pt, r, i, 0, 0, o5t);
      return u.u = s, u.pr = -10, u.tween = c, e._props.push(i), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, vh = [1, 0, 0, 1, 0, 0], gE = {}, pE = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, GS = function(e) {
  var r = _s(e, ir);
  return pE(r) ? vh : r.substr(7).match(SM).map(gr);
}, W4 = function(e, r) {
  var i = e._gsap || hc(e), s = e.style, c = GS(e), u, l, f, o;
  return i.svg && e.getAttribute("transform") ? (f = e.transform.baseVal.consolidate().matrix, c = [f.a, f.b, f.c, f.d, f.e, f.f], c.join(",") === "1,0,0,1,0,0" ? vh : c) : (c === vh && !e.offsetParent && e !== Lu && !i.svg && (f = s.display, s.display = "block", u = e.parentNode, (!u || !e.offsetParent && !e.getBoundingClientRect().width) && (o = 1, l = e.nextElementSibling, Lu.appendChild(e)), c = GS(e), f ? s.display = f : Sc(e, "display"), o && (l ? u.insertBefore(e, l) : u ? u.appendChild(e) : Lu.removeChild(e))), r && c.length > 6 ? [c[0], c[1], c[4], c[5], c[12], c[13]] : c);
}, m6 = function(e, r, i, s, c, u) {
  var l = e._gsap, f = c || W4(e, !0), o = l.xOrigin || 0, g = l.yOrigin || 0, p = l.xOffset || 0, n = l.yOffset || 0, a = f[0], d = f[1], m = f[2], b = f[3], w = f[4], v = f[5], h = r.split(" "), x = parseFloat(h[0]) || 0, _ = parseFloat(h[1]) || 0, M, O, E, I;
  i ? f !== vh && (O = a * b - d * m) && (E = x * (b / O) + _ * (-m / O) + (m * v - b * w) / O, I = x * (-d / O) + _ * (a / O) - (a * v - d * w) / O, x = E, _ = I) : (M = fE(e), x = M.x + (~h[0].indexOf("%") ? x / 100 * M.width : x), _ = M.y + (~(h[1] || h[0]).indexOf("%") ? _ / 100 * M.height : _)), s || s !== !1 && l.smooth ? (w = x - o, v = _ - g, l.xOffset = p + (w * a + v * m) - w, l.yOffset = n + (w * d + v * b) - v) : l.xOffset = l.yOffset = 0, l.xOrigin = x, l.yOrigin = _, l.smooth = !!s, l.origin = r, l.originIsAbsolute = !!i, e.style[zi] = "0px 0px", u && (Ho(u, l, "xOrigin", o, x), Ho(u, l, "yOrigin", g, _), Ho(u, l, "xOffset", p, l.xOffset), Ho(u, l, "yOffset", n, l.yOffset)), e.setAttribute("data-svg-origin", x + " " + _);
}, wh = function(e, r) {
  var i = e._gsap || new JM(e);
  if ("x" in i && !r && !i.uncache)
    return i;
  var s = e.style, c = i.scaleX < 0, u = "px", l = "deg", f = getComputedStyle(e), o = _s(e, zi) || "0", g, p, n, a, d, m, b, w, v, h, x, _, M, O, E, I, R, W, z, j, $, B, C, T, F, S, A, U, K, X, L, H;
  return g = p = n = m = b = w = v = h = x = 0, a = d = 1, i.svg = !!(e.getCTM && dE(e)), f.translate && ((f.translate !== "none" || f.scale !== "none" || f.rotate !== "none") && (s[ir] = (f.translate !== "none" ? "translate3d(" + (f.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (f.rotate !== "none" ? "rotate(" + f.rotate + ") " : "") + (f.scale !== "none" ? "scale(" + f.scale.split(" ").join(",") + ") " : "") + (f[ir] !== "none" ? f[ir] : "")), s.scale = s.rotate = s.translate = "none"), O = W4(e, i.svg), i.svg && (i.uncache ? (F = e.getBBox(), o = i.xOrigin - F.x + "px " + (i.yOrigin - F.y) + "px", T = "") : T = !r && e.getAttribute("data-svg-origin"), m6(e, T || o, !!T || i.originIsAbsolute, i.smooth !== !1, O)), _ = i.xOrigin || 0, M = i.yOrigin || 0, O !== vh && (W = O[0], z = O[1], j = O[2], $ = O[3], g = B = O[4], p = C = O[5], O.length === 6 ? (a = Math.sqrt(W * W + z * z), d = Math.sqrt($ * $ + j * j), m = W || z ? pu(z, W) * Wl : 0, v = j || $ ? pu(j, $) * Wl + m : 0, v && (d *= Math.abs(Math.cos(v * Nu))), i.svg && (g -= _ - (_ * W + M * j), p -= M - (_ * z + M * $))) : (H = O[6], X = O[7], A = O[8], U = O[9], K = O[10], L = O[11], g = O[12], p = O[13], n = O[14], E = pu(H, K), b = E * Wl, E && (I = Math.cos(-E), R = Math.sin(-E), T = B * I + A * R, F = C * I + U * R, S = H * I + K * R, A = B * -R + A * I, U = C * -R + U * I, K = H * -R + K * I, L = X * -R + L * I, B = T, C = F, H = S), E = pu(-j, K), w = E * Wl, E && (I = Math.cos(-E), R = Math.sin(-E), T = W * I - A * R, F = z * I - U * R, S = j * I - K * R, L = $ * R + L * I, W = T, z = F, j = S), E = pu(z, W), m = E * Wl, E && (I = Math.cos(E), R = Math.sin(E), T = W * I + z * R, F = B * I + C * R, z = z * I - W * R, C = C * I - B * R, W = T, B = F), b && Math.abs(b) + Math.abs(m) > 359.9 && (b = m = 0, w = 180 - w), a = gr(Math.sqrt(W * W + z * z + j * j)), d = gr(Math.sqrt(C * C + H * H)), E = pu(B, C), v = Math.abs(E) > 2e-4 ? E * Wl : 0, x = L ? 1 / (L < 0 ? -L : L) : 0), i.svg && (T = e.getAttribute("transform"), i.forceCSS = e.setAttribute("transform", "") || !pE(_s(e, ir)), T && e.setAttribute("transform", T))), Math.abs(v) > 90 && Math.abs(v) < 270 && (c ? (a *= -1, v += m <= 0 ? 180 : -180, m += m <= 0 ? 180 : -180) : (d *= -1, v += v <= 0 ? 180 : -180)), r = r || i.uncache, i.x = g - ((i.xPercent = g && (!r && i.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-g) ? -50 : 0))) ? e.offsetWidth * i.xPercent / 100 : 0) + u, i.y = p - ((i.yPercent = p && (!r && i.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-p) ? -50 : 0))) ? e.offsetHeight * i.yPercent / 100 : 0) + u, i.z = n + u, i.scaleX = gr(a), i.scaleY = gr(d), i.rotation = gr(m) + l, i.rotationX = gr(b) + l, i.rotationY = gr(w) + l, i.skewX = v + l, i.skewY = h + l, i.transformPerspective = x + u, (i.zOrigin = parseFloat(o.split(" ")[2]) || !r && i.zOrigin || 0) && (s[zi] = Ag(o)), i.xOffset = i.yOffset = 0, i.force3D = ua.force3D, i.renderTransform = i.svg ? c5t : hE ? mE : l5t, i.uncache = 0, i;
}, Ag = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, Xm = function(e, r, i) {
  var s = ai(r);
  return gr(parseFloat(r) + parseFloat(ul(e, "x", i + "px", s))) + s;
}, l5t = function(e, r) {
  r.z = "0px", r.rotationY = r.rotationX = "0deg", r.force3D = 0, mE(e, r);
}, jl = "0deg", p1 = "0px", Ul = ") ", mE = function(e, r) {
  var i = r || this, s = i.xPercent, c = i.yPercent, u = i.x, l = i.y, f = i.z, o = i.rotation, g = i.rotationY, p = i.rotationX, n = i.skewX, a = i.skewY, d = i.scaleX, m = i.scaleY, b = i.transformPerspective, w = i.force3D, v = i.target, h = i.zOrigin, x = "", _ = w === "auto" && e && e !== 1 || w === !0;
  if (h && (p !== jl || g !== jl)) {
    var M = parseFloat(g) * Nu, O = Math.sin(M), E = Math.cos(M), I;
    M = parseFloat(p) * Nu, I = Math.cos(M), u = Xm(v, u, O * I * -h), l = Xm(v, l, -Math.sin(M) * -h), f = Xm(v, f, E * I * -h + h);
  }
  b !== p1 && (x += "perspective(" + b + Ul), (s || c) && (x += "translate(" + s + "%, " + c + "%) "), (_ || u !== p1 || l !== p1 || f !== p1) && (x += f !== p1 || _ ? "translate3d(" + u + ", " + l + ", " + f + ") " : "translate(" + u + ", " + l + Ul), o !== jl && (x += "rotate(" + o + Ul), g !== jl && (x += "rotateY(" + g + Ul), p !== jl && (x += "rotateX(" + p + Ul), (n !== jl || a !== jl) && (x += "skew(" + n + ", " + a + Ul), (d !== 1 || m !== 1) && (x += "scale(" + d + ", " + m + Ul), v.style[ir] = x || "translate(0, 0)";
}, c5t = function(e, r) {
  var i = r || this, s = i.xPercent, c = i.yPercent, u = i.x, l = i.y, f = i.rotation, o = i.skewX, g = i.skewY, p = i.scaleX, n = i.scaleY, a = i.target, d = i.xOrigin, m = i.yOrigin, b = i.xOffset, w = i.yOffset, v = i.forceCSS, h = parseFloat(u), x = parseFloat(l), _, M, O, E, I;
  f = parseFloat(f), o = parseFloat(o), g = parseFloat(g), g && (g = parseFloat(g), o += g, f += g), f || o ? (f *= Nu, o *= Nu, _ = Math.cos(f) * p, M = Math.sin(f) * p, O = Math.sin(f - o) * -n, E = Math.cos(f - o) * n, o && (g *= Nu, I = Math.tan(o - g), I = Math.sqrt(1 + I * I), O *= I, E *= I, g && (I = Math.tan(g), I = Math.sqrt(1 + I * I), _ *= I, M *= I)), _ = gr(_), M = gr(M), O = gr(O), E = gr(E)) : (_ = p, E = n, M = O = 0), (h && !~(u + "").indexOf("px") || x && !~(l + "").indexOf("px")) && (h = ul(a, "x", u, "px"), x = ul(a, "y", l, "px")), (d || m || b || w) && (h = gr(h + d - (d * _ + m * O) + b), x = gr(x + m - (d * M + m * E) + w)), (s || c) && (I = a.getBBox(), h = gr(h + s / 100 * I.width), x = gr(x + c / 100 * I.height)), I = "matrix(" + _ + "," + M + "," + O + "," + E + "," + h + "," + x + ")", a.setAttribute("transform", I), v && (a.style[ir] = I);
}, u5t = function(e, r, i, s, c) {
  var u = 360, l = Hr(c), f = parseFloat(c) * (l && ~c.indexOf("rad") ? Wl : 1), o = f - s, g = s + o + "deg", p, n;
  return l && (p = c.split("_")[1], p === "short" && (o %= u, o !== o % (u / 2) && (o += o < 0 ? u : -360)), p === "cw" && o < 0 ? o = (o + u * HS) % u - ~~(o / u) * u : p === "ccw" && o > 0 && (o = (o - u * HS) % u - ~~(o / u) * u)), e._pt = n = new Vi(e._pt, r, i, s, o, Wpt), n.e = g, n.u = "deg", e._props.push(i), n;
}, KS = function(e, r) {
  for (var i in r)
    e[i] = r[i];
  return e;
}, h5t = function(e, r, i) {
  var s = KS({}, i._gsap), c = "perspective,force3D,transformOrigin,svgOrigin", u = i.style, l, f, o, g, p, n, a, d;
  s.svg ? (o = i.getAttribute("transform"), i.setAttribute("transform", ""), u[ir] = r, l = wh(i, 1), Sc(i, ir), i.setAttribute("transform", o)) : (o = getComputedStyle(i)[ir], u[ir] = r, l = wh(i, 1), u[ir] = o);
  for (f in fo)
    o = s[f], g = l[f], o !== g && c.indexOf(f) < 0 && (a = ai(o), d = ai(g), p = a !== d ? ul(i, f, o, d) : parseFloat(o), n = parseFloat(g), e._pt = new Vi(e._pt, l, f, p, n - p, d6), e._pt.u = d || 0, e._props.push(f));
  KS(l, s);
};
Hi("padding,margin,Width,Radius", function(t, e) {
  var r = "Top", i = "Right", s = "Bottom", c = "Left", u = (e < 3 ? [r, i, s, c] : [r + c, r + i, s + i, s + c]).map(function(l) {
    return e < 2 ? t + l : "border" + l + t;
  });
  Cg[e > 1 ? "border" + t : t] = function(l, f, o, g, p) {
    var n, a;
    if (arguments.length < 4)
      return n = u.map(function(d) {
        return Gs(l, d, o);
      }), a = n.join(" "), a.split(n[0]).length === 5 ? n[0] : a;
    n = (g + "").split(" "), a = {}, u.forEach(function(d, m) {
      return a[d] = n[m] = n[m] || n[(m - 1) / 2 | 0];
    }), l.init(f, a, p);
  };
});
var yE = {
  name: "css",
  register: p6,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, r, i, s, c) {
    var u = this._props, l = e.style, f = i.vars.startAt, o, g, p, n, a, d, m, b, w, v, h, x, _, M, O, E;
    z4 || p6(), this.styles = this.styles || uE(e), E = this.styles.props, this.tween = i;
    for (m in r)
      if (m !== "autoRound" && (g = r[m], !(na[m] && QM(m, r, i, s, e, c)))) {
        if (a = typeof g, d = Cg[m], a === "function" && (g = g.call(i, s, e, c), a = typeof g), a === "string" && ~g.indexOf("random(") && (g = mh(g)), d)
          d(this, e, m, g, i) && (O = 1);
        else if (m.substr(0, 2) === "--")
          o = (getComputedStyle(e).getPropertyValue(m) + "").trim(), g += "", Yo.lastIndex = 0, Yo.test(o) || (b = ai(o), w = ai(g)), w ? b !== w && (o = ul(e, m, o, w) + w) : b && (g += b), this.add(l, "setProperty", o, g, s, c, 0, 0, m), u.push(m), E.push(m, 0, l[m]);
        else if (a !== "undefined") {
          if (f && m in f ? (o = typeof f[m] == "function" ? f[m].call(i, s, e, c) : f[m], Hr(o) && ~o.indexOf("random(") && (o = mh(o)), ai(o + "") || o === "auto" || (o += ua.units[m] || ai(Gs(e, m)) || ""), (o + "").charAt(1) === "=" && (o = Gs(e, m))) : o = Gs(e, m), n = parseFloat(o), v = a === "string" && g.charAt(1) === "=" && g.substr(0, 2), v && (g = g.substr(2)), p = parseFloat(g), m in ms && (m === "autoAlpha" && (n === 1 && Gs(e, "visibility") === "hidden" && p && (n = 0), E.push("visibility", 0, l.visibility), Ho(this, l, "visibility", n ? "inherit" : "hidden", p ? "inherit" : "hidden", !p)), m !== "scale" && m !== "transform" && (m = ms[m], ~m.indexOf(",") && (m = m.split(",")[0]))), h = m in fo, h) {
            if (this.styles.save(m), x || (_ = e._gsap, _.renderTransform && !r.parseTransform || wh(e, r.parseTransform), M = r.smoothOrigin !== !1 && _.smooth, x = this._pt = new Vi(this._pt, l, ir, 0, 1, _.renderTransform, _, 0, -1), x.dep = 1), m === "scale")
              this._pt = new Vi(this._pt, _, "scaleY", _.scaleY, (v ? $u(_.scaleY, v + p) : p) - _.scaleY || 0, d6), this._pt.u = 0, u.push("scaleY", m), m += "X";
            else if (m === "transformOrigin") {
              E.push(zi, 0, l[zi]), g = s5t(g), _.svg ? m6(e, g, 0, M, 0, this) : (w = parseFloat(g.split(" ")[2]) || 0, w !== _.zOrigin && Ho(this, _, "zOrigin", _.zOrigin, w), Ho(this, l, m, Ag(o), Ag(g)));
              continue;
            } else if (m === "svgOrigin") {
              m6(e, g, 1, M, 0, this);
              continue;
            } else if (m in gE) {
              u5t(this, _, m, n, v ? $u(n, v + g) : g);
              continue;
            } else if (m === "smoothOrigin") {
              Ho(this, _, "smooth", _.smooth, g);
              continue;
            } else if (m === "force3D") {
              _[m] = g;
              continue;
            } else if (m === "transform") {
              h5t(this, g, e);
              continue;
            }
          } else m in l || (m = c0(m) || m);
          if (h || (p || p === 0) && (n || n === 0) && !qpt.test(g) && m in l)
            b = (o + "").substr((n + "").length), p || (p = 0), w = ai(g) || (m in ua.units ? ua.units[m] : b), b !== w && (n = ul(e, m, o, w)), this._pt = new Vi(this._pt, h ? _ : l, m, n, (v ? $u(n, v + p) : p) - n, !h && (w === "px" || m === "zIndex") && r.autoRound !== !1 ? Kpt : d6), this._pt.u = w || 0, b !== w && w !== "%" && (this._pt.b = o, this._pt.r = Gpt);
          else if (m in l)
            a5t.call(this, e, m, o, v ? v + g : g);
          else if (m in e)
            this.add(e, m, o || e[m], v ? v + g : g, s, c);
          else if (m !== "parseTransform") {
            D4(m, g);
            continue;
          }
          h || (m in l ? E.push(m, 0, l[m]) : typeof e[m] == "function" ? E.push(m, 2, e[m]()) : E.push(m, 1, o || e[m])), u.push(m);
        }
      }
    O && aE(this);
  },
  render: function(e, r) {
    if (r.tween._time || !X4())
      for (var i = r._pt; i; )
        i.r(e, i.d), i = i._next;
    else
      r.styles.revert();
  },
  get: Gs,
  aliases: ms,
  getSetter: function(e, r, i) {
    var s = ms[r];
    return s && s.indexOf(",") < 0 && (r = s), r in fo && r !== zi && (e._gsap.x || Gs(e, "x")) ? i && US === i ? r === "scale" ? Qpt : Jpt : (US = i || {}) && (r === "scale" ? t5t : e5t) : e.style && !I4(e.style[r]) ? Ypt : ~r.indexOf("-") ? Zpt : H4(e, r);
  },
  core: {
    _removeProperty: Sc,
    _getMatrix: W4
  }
};
Xi.utils.checkPrefix = c0;
Xi.core.getStyleSaver = uE;
(function(t, e, r, i) {
  var s = Hi(t + "," + e + "," + r, function(c) {
    fo[c] = 1;
  });
  Hi(e, function(c) {
    ua.units[c] = "deg", gE[c] = 1;
  }), ms[s[13]] = t + "," + e, Hi(i, function(c) {
    var u = c.split(":");
    ms[u[1]] = s[u[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Hi("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t) {
  ua.units[t] = "px";
});
Xi.registerPlugin(yE);
var M0 = Xi.registerPlugin(yE) || Xi;
M0.core.Tween;
function f5t(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function d5t(t, e, r) {
  return e && f5t(t.prototype, e), t;
}
/*!
 * Observer 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Yr, s2, oa, Vo, zo, Bu, bE, Gl, V1, vE, no, Wa, wE, xE = function() {
  return Yr || typeof window < "u" && (Yr = window.gsap) && Yr.registerPlugin && Yr;
}, SE = 1, Iu = [], gn = [], ks = [], z1 = Date.now, y6 = function(e, r) {
  return r;
}, g5t = function() {
  var e = V1.core, r = e.bridge || {}, i = e._scrollers, s = e._proxies;
  i.push.apply(i, gn), s.push.apply(s, ks), gn = i, ks = s, y6 = function(u, l) {
    return r[u](l);
  };
}, Zo = function(e, r) {
  return ~ks.indexOf(e) && ks[ks.indexOf(e) + 1][r];
}, X1 = function(e) {
  return !!~vE.indexOf(e);
}, wi = function(e, r, i, s, c) {
  return e.addEventListener(r, i, {
    passive: s !== !1,
    capture: !!c
  });
}, bi = function(e, r, i, s) {
  return e.removeEventListener(r, i, !!s);
}, xd = "scrollLeft", Sd = "scrollTop", b6 = function() {
  return no && no.isPressed || gn.cache++;
}, _g = function(e, r) {
  var i = function s(c) {
    if (c || c === 0) {
      SE && (oa.history.scrollRestoration = "manual");
      var u = no && no.isPressed;
      c = s.v = Math.round(c) || (no && no.iOS ? 1 : 0), e(c), s.cacheID = gn.cache, u && y6("ss", c);
    } else (r || gn.cache !== s.cacheID || y6("ref")) && (s.cacheID = gn.cache, s.v = e());
    return s.v + s.offset;
  };
  return i.offset = 0, e && i;
}, Oi = {
  s: xd,
  p: "left",
  p2: "Left",
  os: "right",
  os2: "Right",
  d: "width",
  d2: "Width",
  a: "x",
  sc: _g(function(t) {
    return arguments.length ? oa.scrollTo(t, Ir.sc()) : oa.pageXOffset || Vo[xd] || zo[xd] || Bu[xd] || 0;
  })
}, Ir = {
  s: Sd,
  p: "top",
  p2: "Top",
  os: "bottom",
  os2: "Bottom",
  d: "height",
  d2: "Height",
  a: "y",
  op: Oi,
  sc: _g(function(t) {
    return arguments.length ? oa.scrollTo(Oi.sc(), t) : oa.pageYOffset || Vo[Sd] || zo[Sd] || Bu[Sd] || 0;
  })
}, Li = function(e, r) {
  return (r && r._ctx && r._ctx.selector || Yr.utils.toArray)(e)[0] || (typeof e == "string" && Yr.config().nullTargetWarn !== !1 ? console.warn("Element not found:", e) : null);
}, hl = function(e, r) {
  var i = r.s, s = r.sc;
  X1(e) && (e = Vo.scrollingElement || zo);
  var c = gn.indexOf(e), u = s === Ir.sc ? 1 : 2;
  !~c && (c = gn.push(e) - 1), gn[c + u] || wi(e, "scroll", b6);
  var l = gn[c + u], f = l || (gn[c + u] = _g(Zo(e, i), !0) || (X1(e) ? s : _g(function(o) {
    return arguments.length ? e[i] = o : e[i];
  })));
  return f.target = e, l || (f.smooth = Yr.getProperty(e, "scrollBehavior") === "smooth"), f;
}, v6 = function(e, r, i) {
  var s = e, c = e, u = z1(), l = u, f = r || 50, o = Math.max(500, f * 3), g = function(d, m) {
    var b = z1();
    m || b - u > f ? (c = s, s = d, l = u, u = b) : i ? s += d : s = c + (d - c) / (b - l) * (u - l);
  }, p = function() {
    c = s = i ? 0 : s, l = u = 0;
  }, n = function(d) {
    var m = l, b = c, w = z1();
    return (d || d === 0) && d !== s && g(d), u === l || w - l > o ? 0 : (s + (i ? b : -b)) / ((i ? w : u) - m) * 1e3;
  };
  return {
    update: g,
    reset: p,
    getVelocity: n
  };
}, m1 = function(e, r) {
  return r && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
}, YS = function(e) {
  var r = Math.max.apply(Math, e), i = Math.min.apply(Math, e);
  return Math.abs(r) >= Math.abs(i) ? r : i;
}, CE = function() {
  V1 = Yr.core.globals().ScrollTrigger, V1 && V1.core && g5t();
}, AE = function(e) {
  return Yr = e || xE(), !s2 && Yr && typeof document < "u" && document.body && (oa = window, Vo = document, zo = Vo.documentElement, Bu = Vo.body, vE = [oa, Vo, zo, Bu], Yr.utils.clamp, wE = Yr.core.context || function() {
  }, Gl = "onpointerenter" in Bu ? "pointer" : "mouse", bE = pr.isTouch = oa.matchMedia && oa.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in oa || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, Wa = pr.eventTypes = ("ontouchstart" in zo ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in zo ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function() {
    return SE = 0;
  }, 500), CE(), s2 = 1), s2;
};
Oi.op = Ir;
gn.cache = 0;
var pr = /* @__PURE__ */ function() {
  function t(r) {
    this.init(r);
  }
  var e = t.prototype;
  return e.init = function(i) {
    s2 || AE(Yr) || console.warn("Please gsap.registerPlugin(Observer)"), V1 || CE();
    var s = i.tolerance, c = i.dragMinimum, u = i.type, l = i.target, f = i.lineHeight, o = i.debounce, g = i.preventDefault, p = i.onStop, n = i.onStopDelay, a = i.ignore, d = i.wheelSpeed, m = i.event, b = i.onDragStart, w = i.onDragEnd, v = i.onDrag, h = i.onPress, x = i.onRelease, _ = i.onRight, M = i.onLeft, O = i.onUp, E = i.onDown, I = i.onChangeX, R = i.onChangeY, W = i.onChange, z = i.onToggleX, j = i.onToggleY, $ = i.onHover, B = i.onHoverEnd, C = i.onMove, T = i.ignoreCheck, F = i.isNormalizer, S = i.onGestureStart, A = i.onGestureEnd, U = i.onWheel, K = i.onEnable, X = i.onDisable, L = i.onClick, H = i.scrollSpeed, Q = i.capture, N = i.allowClicks, V = i.lockAxis, Y = i.onLockAxis;
    this.target = l = Li(l) || zo, this.vars = i, a && (a = Yr.utils.toArray(a)), s = s || 1e-9, c = c || 0, d = d || 1, H = H || 1, u = u || "wheel,touch,pointer", o = o !== !1, f || (f = parseFloat(oa.getComputedStyle(Bu).lineHeight) || 22);
    var Z, rt, st, mt, yt, at, nt, q = this, D = 0, G = 0, et = i.passive || !g && i.passive !== !1, J = hl(l, Oi), it = hl(l, Ir), lt = J(), ot = it(), ut = ~u.indexOf("touch") && !~u.indexOf("pointer") && Wa[0] === "pointerdown", ct = X1(l), gt = l.ownerDocument || Vo, dt = [0, 0, 0], bt = [0, 0, 0], vt = 0, xt = function() {
      return vt = z1();
    }, St = function(Xt, Gt) {
      return (q.event = Xt) && a && ~a.indexOf(Xt.target) || Gt && ut && Xt.pointerType !== "touch" || T && T(Xt, Gt);
    }, Mt = function() {
      q._vx.reset(), q._vy.reset(), rt.pause(), p && p(q);
    }, Et = function() {
      var Xt = q.deltaX = YS(dt), Gt = q.deltaY = YS(bt), Lt = Math.abs(Xt) >= s, Dt = Math.abs(Gt) >= s;
      W && (Lt || Dt) && W(q, Xt, Gt, dt, bt), Lt && (_ && q.deltaX > 0 && _(q), M && q.deltaX < 0 && M(q), I && I(q), z && q.deltaX < 0 != D < 0 && z(q), D = q.deltaX, dt[0] = dt[1] = dt[2] = 0), Dt && (E && q.deltaY > 0 && E(q), O && q.deltaY < 0 && O(q), R && R(q), j && q.deltaY < 0 != G < 0 && j(q), G = q.deltaY, bt[0] = bt[1] = bt[2] = 0), (mt || st) && (C && C(q), st && (b && st === 1 && b(q), v && v(q), st = 0), mt = !1), at && !(at = !1) && Y && Y(q), yt && (U(q), yt = !1), Z = 0;
    }, Ft = function(Xt, Gt, Lt) {
      dt[Lt] += Xt, bt[Lt] += Gt, q._vx.update(Xt), q._vy.update(Gt), o ? Z || (Z = requestAnimationFrame(Et)) : Et();
    }, Wt = function(Xt, Gt) {
      V && !nt && (q.axis = nt = Math.abs(Xt) > Math.abs(Gt) ? "x" : "y", at = !0), nt !== "y" && (dt[2] += Xt, q._vx.update(Xt, !0)), nt !== "x" && (bt[2] += Gt, q._vy.update(Gt, !0)), o ? Z || (Z = requestAnimationFrame(Et)) : Et();
    }, Kt = function(Xt) {
      if (!St(Xt, 1)) {
        Xt = m1(Xt, g);
        var Gt = Xt.clientX, Lt = Xt.clientY, Dt = Gt - q.x, jt = Lt - q.y, Ot = q.isDragging;
        q.x = Gt, q.y = Lt, (Ot || (Dt || jt) && (Math.abs(q.startX - Gt) >= c || Math.abs(q.startY - Lt) >= c)) && (st = Ot ? 2 : 1, Ot || (q.isDragging = !0), Wt(Dt, jt));
      }
    }, qt = q.onPress = function(Zt) {
      St(Zt, 1) || Zt && Zt.button || (q.axis = nt = null, rt.pause(), q.isPressed = !0, Zt = m1(Zt), D = G = 0, q.startX = q.x = Zt.clientX, q.startY = q.y = Zt.clientY, q._vx.reset(), q._vy.reset(), wi(F ? l : gt, Wa[1], Kt, et, !0), q.deltaX = q.deltaY = 0, h && h(q));
    }, It = q.onRelease = function(Zt) {
      if (!St(Zt, 1)) {
        bi(F ? l : gt, Wa[1], Kt, !0);
        var Xt = !isNaN(q.y - q.startY), Gt = q.isDragging, Lt = Gt && (Math.abs(q.x - q.startX) > 3 || Math.abs(q.y - q.startY) > 3), Dt = m1(Zt);
        !Lt && Xt && (q._vx.reset(), q._vy.reset(), g && N && Yr.delayedCall(0.08, function() {
          if (z1() - vt > 300 && !Zt.defaultPrevented) {
            if (Zt.target.click)
              Zt.target.click();
            else if (gt.createEvent) {
              var jt = gt.createEvent("MouseEvents");
              jt.initMouseEvent("click", !0, !0, oa, 1, Dt.screenX, Dt.screenY, Dt.clientX, Dt.clientY, !1, !1, !1, !1, 0, null), Zt.target.dispatchEvent(jt);
            }
          }
        })), q.isDragging = q.isGesturing = q.isPressed = !1, p && Gt && !F && rt.restart(!0), st && Et(), w && Gt && w(q), x && x(q, Lt);
      }
    }, re = function(Xt) {
      return Xt.touches && Xt.touches.length > 1 && (q.isGesturing = !0) && S(Xt, q.isDragging);
    }, le = function() {
      return (q.isGesturing = !1) || A(q);
    }, Ce = function(Xt) {
      if (!St(Xt)) {
        var Gt = J(), Lt = it();
        Ft((Gt - lt) * H, (Lt - ot) * H, 1), lt = Gt, ot = Lt, p && rt.restart(!0);
      }
    }, ce = function(Xt) {
      if (!St(Xt)) {
        Xt = m1(Xt, g), U && (yt = !0);
        var Gt = (Xt.deltaMode === 1 ? f : Xt.deltaMode === 2 ? oa.innerHeight : 1) * d;
        Ft(Xt.deltaX * Gt, Xt.deltaY * Gt, 0), p && !F && rt.restart(!0);
      }
    }, xe = function(Xt) {
      if (!St(Xt)) {
        var Gt = Xt.clientX, Lt = Xt.clientY, Dt = Gt - q.x, jt = Lt - q.y;
        q.x = Gt, q.y = Lt, mt = !0, p && rt.restart(!0), (Dt || jt) && Wt(Dt, jt);
      }
    }, ve = function(Xt) {
      q.event = Xt, $(q);
    }, Oe = function(Xt) {
      q.event = Xt, B(q);
    }, He = function(Xt) {
      return St(Xt) || m1(Xt, g) && L(q);
    };
    rt = q._dc = Yr.delayedCall(n || 0.25, Mt).pause(), q.deltaX = q.deltaY = 0, q._vx = v6(0, 50, !0), q._vy = v6(0, 50, !0), q.scrollX = J, q.scrollY = it, q.isDragging = q.isGesturing = q.isPressed = !1, wE(this), q.enable = function(Zt) {
      return q.isEnabled || (wi(ct ? gt : l, "scroll", b6), u.indexOf("scroll") >= 0 && wi(ct ? gt : l, "scroll", Ce, et, Q), u.indexOf("wheel") >= 0 && wi(l, "wheel", ce, et, Q), (u.indexOf("touch") >= 0 && bE || u.indexOf("pointer") >= 0) && (wi(l, Wa[0], qt, et, Q), wi(gt, Wa[2], It), wi(gt, Wa[3], It), N && wi(l, "click", xt, !0, !0), L && wi(l, "click", He), S && wi(gt, "gesturestart", re), A && wi(gt, "gestureend", le), $ && wi(l, Gl + "enter", ve), B && wi(l, Gl + "leave", Oe), C && wi(l, Gl + "move", xe)), q.isEnabled = !0, q.isDragging = q.isGesturing = q.isPressed = mt = st = !1, q._vx.reset(), q._vy.reset(), lt = J(), ot = it(), Zt && Zt.type && qt(Zt), K && K(q)), q;
    }, q.disable = function() {
      q.isEnabled && (Iu.filter(function(Zt) {
        return Zt !== q && X1(Zt.target);
      }).length || bi(ct ? gt : l, "scroll", b6), q.isPressed && (q._vx.reset(), q._vy.reset(), bi(F ? l : gt, Wa[1], Kt, !0)), bi(ct ? gt : l, "scroll", Ce, Q), bi(l, "wheel", ce, Q), bi(l, Wa[0], qt, Q), bi(gt, Wa[2], It), bi(gt, Wa[3], It), bi(l, "click", xt, !0), bi(l, "click", He), bi(gt, "gesturestart", re), bi(gt, "gestureend", le), bi(l, Gl + "enter", ve), bi(l, Gl + "leave", Oe), bi(l, Gl + "move", xe), q.isEnabled = q.isPressed = q.isDragging = !1, X && X(q));
    }, q.kill = q.revert = function() {
      q.disable();
      var Zt = Iu.indexOf(q);
      Zt >= 0 && Iu.splice(Zt, 1), no === q && (no = 0);
    }, Iu.push(q), F && X1(l) && (no = q), q.enable(m);
  }, d5t(t, [{
    key: "velocityX",
    get: function() {
      return this._vx.getVelocity();
    }
  }, {
    key: "velocityY",
    get: function() {
      return this._vy.getVelocity();
    }
  }]), t;
}();
pr.version = "3.12.7";
pr.create = function(t) {
  return new pr(t);
};
pr.register = AE;
pr.getAll = function() {
  return Iu.slice();
};
pr.getById = function(t) {
  return Iu.filter(function(e) {
    return e.vars.id === t;
  })[0];
};
xE() && Yr.registerPlugin(pr);
/*!
 * ScrollTrigger 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Pe, Su, dn, Xn, ia, Fn, G4, kg, xh, q1, O1, Cd, ei, Pp, w6, Ci, ZS, JS, Cu, _E, qm, kE, Si, x6, OE, TE, $o, S6, K4, ju, Y4, Og, C6, Wm, Ad = 1, ii = Date.now, Gm = ii(), Ia = 0, T1 = 0, QS = function(e, r, i) {
  var s = ea(e) && (e.substr(0, 6) === "clamp(" || e.indexOf("max") > -1);
  return i["_" + r + "Clamp"] = s, s ? e.substr(6, e.length - 7) : e;
}, tC = function(e, r) {
  return r && (!ea(e) || e.substr(0, 6) !== "clamp(") ? "clamp(" + e + ")" : e;
}, p5t = function t() {
  return T1 && requestAnimationFrame(t);
}, eC = function() {
  return Pp = 1;
}, nC = function() {
  return Pp = 0;
}, hs = function(e) {
  return e;
}, M1 = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, ME = function() {
  return typeof window < "u";
}, EE = function() {
  return Pe || ME() && (Pe = window.gsap) && Pe.registerPlugin && Pe;
}, Cc = function(e) {
  return !!~G4.indexOf(e);
}, PE = function(e) {
  return (e === "Height" ? Y4 : dn["inner" + e]) || ia["client" + e] || Fn["client" + e];
}, IE = function(e) {
  return Zo(e, "getBoundingClientRect") || (Cc(e) ? function() {
    return h2.width = dn.innerWidth, h2.height = Y4, h2;
  } : function() {
    return Ks(e);
  });
}, m5t = function(e, r, i) {
  var s = i.d, c = i.d2, u = i.a;
  return (u = Zo(e, "getBoundingClientRect")) ? function() {
    return u()[s];
  } : function() {
    return (r ? PE(c) : e["client" + c]) || 0;
  };
}, y5t = function(e, r) {
  return !r || ~ks.indexOf(e) ? IE(e) : function() {
    return h2;
  };
}, ys = function(e, r) {
  var i = r.s, s = r.d2, c = r.d, u = r.a;
  return Math.max(0, (i = "scroll" + s) && (u = Zo(e, i)) ? u() - IE(e)()[c] : Cc(e) ? (ia[i] || Fn[i]) - PE(s) : e[i] - e["offset" + s]);
}, _d = function(e, r) {
  for (var i = 0; i < Cu.length; i += 3)
    (!r || ~r.indexOf(Cu[i + 1])) && e(Cu[i], Cu[i + 1], Cu[i + 2]);
}, ea = function(e) {
  return typeof e == "string";
}, si = function(e) {
  return typeof e == "function";
}, E1 = function(e) {
  return typeof e == "number";
}, Kl = function(e) {
  return typeof e == "object";
}, y1 = function(e, r, i) {
  return e && e.progress(r ? 0 : 1) && i && e.pause();
}, Km = function(e, r) {
  if (e.enabled) {
    var i = e._ctx ? e._ctx.add(function() {
      return r(e);
    }) : r(e);
    i && i.totalTime && (e.callbackAnimation = i);
  }
}, mu = Math.abs, FE = "left", RE = "top", Z4 = "right", J4 = "bottom", pc = "width", mc = "height", W1 = "Right", G1 = "Left", K1 = "Top", Y1 = "Bottom", wr = "padding", Ta = "margin", u0 = "Width", Q4 = "Height", Pr = "px", Ma = function(e) {
  return dn.getComputedStyle(e);
}, b5t = function(e) {
  var r = Ma(e).position;
  e.style.position = r === "absolute" || r === "fixed" ? r : "relative";
}, rC = function(e, r) {
  for (var i in r)
    i in e || (e[i] = r[i]);
  return e;
}, Ks = function(e, r) {
  var i = r && Ma(e)[w6] !== "matrix(1, 0, 0, 1, 0, 0)" && Pe.to(e, {
    x: 0,
    y: 0,
    xPercent: 0,
    yPercent: 0,
    rotation: 0,
    rotationX: 0,
    rotationY: 0,
    scale: 1,
    skewX: 0,
    skewY: 0
  }).progress(1), s = e.getBoundingClientRect();
  return i && i.progress(0).kill(), s;
}, Tg = function(e, r) {
  var i = r.d2;
  return e["offset" + i] || e["client" + i] || 0;
}, DE = function(e) {
  var r = [], i = e.labels, s = e.duration(), c;
  for (c in i)
    r.push(i[c] / s);
  return r;
}, v5t = function(e) {
  return function(r) {
    return Pe.utils.snap(DE(e), r);
  };
}, t8 = function(e) {
  var r = Pe.utils.snap(e), i = Array.isArray(e) && e.slice(0).sort(function(s, c) {
    return s - c;
  });
  return i ? function(s, c, u) {
    u === void 0 && (u = 1e-3);
    var l;
    if (!c)
      return r(s);
    if (c > 0) {
      for (s -= u, l = 0; l < i.length; l++)
        if (i[l] >= s)
          return i[l];
      return i[l - 1];
    } else
      for (l = i.length, s += u; l--; )
        if (i[l] <= s)
          return i[l];
    return i[0];
  } : function(s, c, u) {
    u === void 0 && (u = 1e-3);
    var l = r(s);
    return !c || Math.abs(l - s) < u || l - s < 0 == c < 0 ? l : r(c < 0 ? s - e : s + e);
  };
}, w5t = function(e) {
  return function(r, i) {
    return t8(DE(e))(r, i.direction);
  };
}, kd = function(e, r, i, s) {
  return i.split(",").forEach(function(c) {
    return e(r, c, s);
  });
}, Lr = function(e, r, i, s, c) {
  return e.addEventListener(r, i, {
    passive: !s,
    capture: !!c
  });
}, $r = function(e, r, i, s) {
  return e.removeEventListener(r, i, !!s);
}, Od = function(e, r, i) {
  i = i && i.wheelHandler, i && (e(r, "wheel", i), e(r, "touchmove", i));
}, iC = {
  startColor: "green",
  endColor: "red",
  indent: 0,
  fontSize: "16px",
  fontWeight: "normal"
}, Td = {
  toggleActions: "play",
  anticipatePin: 0
}, Mg = {
  top: 0,
  left: 0,
  center: 0.5,
  bottom: 1,
  right: 1
}, o2 = function(e, r) {
  if (ea(e)) {
    var i = e.indexOf("="), s = ~i ? +(e.charAt(i - 1) + 1) * parseFloat(e.substr(i + 1)) : 0;
    ~i && (e.indexOf("%") > i && (s *= r / 100), e = e.substr(0, i - 1)), e = s + (e in Mg ? Mg[e] * r : ~e.indexOf("%") ? parseFloat(e) * r / 100 : parseFloat(e) || 0);
  }
  return e;
}, Md = function(e, r, i, s, c, u, l, f) {
  var o = c.startColor, g = c.endColor, p = c.fontSize, n = c.indent, a = c.fontWeight, d = Xn.createElement("div"), m = Cc(i) || Zo(i, "pinType") === "fixed", b = e.indexOf("scroller") !== -1, w = m ? Fn : i, v = e.indexOf("start") !== -1, h = v ? o : g, x = "border-color:" + h + ";font-size:" + p + ";color:" + h + ";font-weight:" + a + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
  return x += "position:" + ((b || f) && m ? "fixed;" : "absolute;"), (b || f || !m) && (x += (s === Ir ? Z4 : J4) + ":" + (u + parseFloat(n)) + "px;"), l && (x += "box-sizing:border-box;text-align:left;width:" + l.offsetWidth + "px;"), d._isStart = v, d.setAttribute("class", "gsap-marker-" + e + (r ? " marker-" + r : "")), d.style.cssText = x, d.innerText = r || r === 0 ? e + "-" + r : e, w.children[0] ? w.insertBefore(d, w.children[0]) : w.appendChild(d), d._offset = d["offset" + s.op.d2], l2(d, 0, s, v), d;
}, l2 = function(e, r, i, s) {
  var c = {
    display: "block"
  }, u = i[s ? "os2" : "p2"], l = i[s ? "p2" : "os2"];
  e._isFlipped = s, c[i.a + "Percent"] = s ? -100 : 0, c[i.a] = s ? "1px" : 0, c["border" + u + u0] = 1, c["border" + l + u0] = 0, c[i.p] = r + "px", Pe.set(e, c);
}, hn = [], A6 = {}, Sh, aC = function() {
  return ii() - Ia > 34 && (Sh || (Sh = requestAnimationFrame(ao)));
}, yu = function() {
  (!Si || !Si.isPressed || Si.startX > Fn.clientWidth) && (gn.cache++, Si ? Sh || (Sh = requestAnimationFrame(ao)) : ao(), Ia || _c("scrollStart"), Ia = ii());
}, Ym = function() {
  TE = dn.innerWidth, OE = dn.innerHeight;
}, P1 = function(e) {
  gn.cache++, (e === !0 || !ei && !kE && !Xn.fullscreenElement && !Xn.webkitFullscreenElement && (!x6 || TE !== dn.innerWidth || Math.abs(dn.innerHeight - OE) > dn.innerHeight * 0.25)) && kg.restart(!0);
}, Ac = {}, x5t = [], $E = function t() {
  return $r(mn, "scrollEnd", t) || ac(!0);
}, _c = function(e) {
  return Ac[e] && Ac[e].map(function(r) {
    return r();
  }) || x5t;
}, ta = [], LE = function(e) {
  for (var r = 0; r < ta.length; r += 5)
    (!e || ta[r + 4] && ta[r + 4].query === e) && (ta[r].style.cssText = ta[r + 1], ta[r].getBBox && ta[r].setAttribute("transform", ta[r + 2] || ""), ta[r + 3].uncache = 1);
}, e8 = function(e, r) {
  var i;
  for (Ci = 0; Ci < hn.length; Ci++)
    i = hn[Ci], i && (!r || i._ctx === r) && (e ? i.kill(1) : i.revert(!0, !0));
  Og = !0, r && LE(r), r || _c("revert");
}, NE = function(e, r) {
  gn.cache++, (r || !Ai) && gn.forEach(function(i) {
    return si(i) && i.cacheID++ && (i.rec = 0);
  }), ea(e) && (dn.history.scrollRestoration = K4 = e);
}, Ai, yc = 0, sC, S5t = function() {
  if (sC !== yc) {
    var e = sC = yc;
    requestAnimationFrame(function() {
      return e === yc && ac(!0);
    });
  }
}, BE = function() {
  Fn.appendChild(ju), Y4 = !Si && ju.offsetHeight || dn.innerHeight, Fn.removeChild(ju);
}, oC = function(e) {
  return xh(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(r) {
    return r.style.display = e ? "none" : "block";
  });
}, ac = function(e, r) {
  if (ia = Xn.documentElement, Fn = Xn.body, G4 = [dn, Xn, ia, Fn], Ia && !e && !Og) {
    Lr(mn, "scrollEnd", $E);
    return;
  }
  BE(), Ai = mn.isRefreshing = !0, gn.forEach(function(s) {
    return si(s) && ++s.cacheID && (s.rec = s());
  });
  var i = _c("refreshInit");
  _E && mn.sort(), r || e8(), gn.forEach(function(s) {
    si(s) && (s.smooth && (s.target.style.scrollBehavior = "auto"), s(0));
  }), hn.slice(0).forEach(function(s) {
    return s.refresh();
  }), Og = !1, hn.forEach(function(s) {
    if (s._subPinOffset && s.pin) {
      var c = s.vars.horizontal ? "offsetWidth" : "offsetHeight", u = s.pin[c];
      s.revert(!0, 1), s.adjustPinSpacing(s.pin[c] - u), s.refresh();
    }
  }), C6 = 1, oC(!0), hn.forEach(function(s) {
    var c = ys(s.scroller, s._dir), u = s.vars.end === "max" || s._endClamp && s.end > c, l = s._startClamp && s.start >= c;
    (u || l) && s.setPositions(l ? c - 1 : s.start, u ? Math.max(l ? c : s.start + 1, c) : s.end, !0);
  }), oC(!1), C6 = 0, i.forEach(function(s) {
    return s && s.render && s.render(-1);
  }), gn.forEach(function(s) {
    si(s) && (s.smooth && requestAnimationFrame(function() {
      return s.target.style.scrollBehavior = "smooth";
    }), s.rec && s(s.rec));
  }), NE(K4, 1), kg.pause(), yc++, Ai = 2, ao(2), hn.forEach(function(s) {
    return si(s.vars.onRefresh) && s.vars.onRefresh(s);
  }), Ai = mn.isRefreshing = !1, _c("refresh");
}, _6 = 0, c2 = 1, Z1, ao = function(e) {
  if (e === 2 || !Ai && !Og) {
    mn.isUpdating = !0, Z1 && Z1.update(0);
    var r = hn.length, i = ii(), s = i - Gm >= 50, c = r && hn[0].scroll();
    if (c2 = _6 > c ? -1 : 1, Ai || (_6 = c), s && (Ia && !Pp && i - Ia > 200 && (Ia = 0, _c("scrollEnd")), O1 = Gm, Gm = i), c2 < 0) {
      for (Ci = r; Ci-- > 0; )
        hn[Ci] && hn[Ci].update(0, s);
      c2 = 1;
    } else
      for (Ci = 0; Ci < r; Ci++)
        hn[Ci] && hn[Ci].update(0, s);
    mn.isUpdating = !1;
  }
  Sh = 0;
}, k6 = [FE, RE, J4, Z4, Ta + Y1, Ta + W1, Ta + K1, Ta + G1, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"], u2 = k6.concat([pc, mc, "boxSizing", "max" + u0, "max" + Q4, "position", Ta, wr, wr + K1, wr + W1, wr + Y1, wr + G1]), C5t = function(e, r, i) {
  Uu(i);
  var s = e._gsap;
  if (s.spacerIsNative)
    Uu(s.spacerState);
  else if (e._gsap.swappedIn) {
    var c = r.parentNode;
    c && (c.insertBefore(e, r), c.removeChild(r));
  }
  e._gsap.swappedIn = !1;
}, Zm = function(e, r, i, s) {
  if (!e._gsap.swappedIn) {
    for (var c = k6.length, u = r.style, l = e.style, f; c--; )
      f = k6[c], u[f] = i[f];
    u.position = i.position === "absolute" ? "absolute" : "relative", i.display === "inline" && (u.display = "inline-block"), l[J4] = l[Z4] = "auto", u.flexBasis = i.flexBasis || "auto", u.overflow = "visible", u.boxSizing = "border-box", u[pc] = Tg(e, Oi) + Pr, u[mc] = Tg(e, Ir) + Pr, u[wr] = l[Ta] = l[RE] = l[FE] = "0", Uu(s), l[pc] = l["max" + u0] = i[pc], l[mc] = l["max" + Q4] = i[mc], l[wr] = i[wr], e.parentNode !== r && (e.parentNode.insertBefore(r, e), r.appendChild(e)), e._gsap.swappedIn = !0;
  }
}, A5t = /([A-Z])/g, Uu = function(e) {
  if (e) {
    var r = e.t.style, i = e.length, s = 0, c, u;
    for ((e.t._gsap || Pe.core.getCache(e.t)).uncache = 1; s < i; s += 2)
      u = e[s + 1], c = e[s], u ? r[c] = u : r[c] && r.removeProperty(c.replace(A5t, "-$1").toLowerCase());
  }
}, Ed = function(e) {
  for (var r = u2.length, i = e.style, s = [], c = 0; c < r; c++)
    s.push(u2[c], i[u2[c]]);
  return s.t = e, s;
}, _5t = function(e, r, i) {
  for (var s = [], c = e.length, u = i ? 8 : 0, l; u < c; u += 2)
    l = e[u], s.push(l, l in r ? r[l] : e[u + 1]);
  return s.t = e.t, s;
}, h2 = {
  left: 0,
  top: 0
}, lC = function(e, r, i, s, c, u, l, f, o, g, p, n, a, d) {
  si(e) && (e = e(f)), ea(e) && e.substr(0, 3) === "max" && (e = n + (e.charAt(4) === "=" ? o2("0" + e.substr(3), i) : 0));
  var m = a ? a.time() : 0, b, w, v;
  if (a && a.seek(0), isNaN(e) || (e = +e), E1(e))
    a && (e = Pe.utils.mapRange(a.scrollTrigger.start, a.scrollTrigger.end, 0, n, e)), l && l2(l, i, s, !0);
  else {
    si(r) && (r = r(f));
    var h = (e || "0").split(" "), x, _, M, O;
    v = Li(r, f) || Fn, x = Ks(v) || {}, (!x || !x.left && !x.top) && Ma(v).display === "none" && (O = v.style.display, v.style.display = "block", x = Ks(v), O ? v.style.display = O : v.style.removeProperty("display")), _ = o2(h[0], x[s.d]), M = o2(h[1] || "0", i), e = x[s.p] - o[s.p] - g + _ + c - M, l && l2(l, M, s, i - M < 20 || l._isStart && M > 20), i -= i - M;
  }
  if (d && (f[d] = e || -1e-3, e < 0 && (e = 0)), u) {
    var E = e + i, I = u._isStart;
    b = "scroll" + s.d2, l2(u, E, s, I && E > 20 || !I && (p ? Math.max(Fn[b], ia[b]) : u.parentNode[b]) <= E + 1), p && (o = Ks(l), p && (u.style[s.op.p] = o[s.op.p] - s.op.m - u._offset + Pr));
  }
  return a && v && (b = Ks(v), a.seek(n), w = Ks(v), a._caScrollDist = b[s.p] - w[s.p], e = e / a._caScrollDist * n), a && a.seek(m), a ? e : Math.round(e);
}, k5t = /(webkit|moz|length|cssText|inset)/i, cC = function(e, r, i, s) {
  if (e.parentNode !== r) {
    var c = e.style, u, l;
    if (r === Fn) {
      e._stOrig = c.cssText, l = Ma(e);
      for (u in l)
        !+u && !k5t.test(u) && l[u] && typeof c[u] == "string" && u !== "0" && (c[u] = l[u]);
      c.top = i, c.left = s;
    } else
      c.cssText = e._stOrig;
    Pe.core.getCache(e).uncache = 1, r.appendChild(e);
  }
}, jE = function(e, r, i) {
  var s = r, c = s;
  return function(u) {
    var l = Math.round(e());
    return l !== s && l !== c && Math.abs(l - s) > 3 && Math.abs(l - c) > 3 && (u = l, i && i()), c = s, s = Math.round(u), s;
  };
}, Pd = function(e, r, i) {
  var s = {};
  s[r.p] = "+=" + i, Pe.set(e, s);
}, uC = function(e, r) {
  var i = hl(e, r), s = "_scroll" + r.p2, c = function u(l, f, o, g, p) {
    var n = u.tween, a = f.onComplete, d = {};
    o = o || i();
    var m = jE(i, o, function() {
      n.kill(), u.tween = 0;
    });
    return p = g && p || 0, g = g || l - o, n && n.kill(), f[s] = l, f.inherit = !1, f.modifiers = d, d[s] = function() {
      return m(o + g * n.ratio + p * n.ratio * n.ratio);
    }, f.onUpdate = function() {
      gn.cache++, u.tween && ao();
    }, f.onComplete = function() {
      u.tween = 0, a && a.call(n);
    }, n = u.tween = Pe.to(e, f), n;
  };
  return e[s] = i, i.wheelHandler = function() {
    return c.tween && c.tween.kill() && (c.tween = 0);
  }, Lr(e, "wheel", i.wheelHandler), mn.isTouch && Lr(e, "touchmove", i.wheelHandler), c;
}, mn = /* @__PURE__ */ function() {
  function t(r, i) {
    Su || t.register(Pe) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), S6(this), this.init(r, i);
  }
  var e = t.prototype;
  return e.init = function(i, s) {
    if (this.progress = this.start = 0, this.vars && this.kill(!0, !0), !T1) {
      this.update = this.refresh = this.kill = hs;
      return;
    }
    i = rC(ea(i) || E1(i) || i.nodeType ? {
      trigger: i
    } : i, Td);
    var c = i, u = c.onUpdate, l = c.toggleClass, f = c.id, o = c.onToggle, g = c.onRefresh, p = c.scrub, n = c.trigger, a = c.pin, d = c.pinSpacing, m = c.invalidateOnRefresh, b = c.anticipatePin, w = c.onScrubComplete, v = c.onSnapComplete, h = c.once, x = c.snap, _ = c.pinReparent, M = c.pinSpacer, O = c.containerAnimation, E = c.fastScrollEnd, I = c.preventOverlaps, R = i.horizontal || i.containerAnimation && i.horizontal !== !1 ? Oi : Ir, W = !p && p !== 0, z = Li(i.scroller || dn), j = Pe.core.getCache(z), $ = Cc(z), B = ("pinType" in i ? i.pinType : Zo(z, "pinType") || $ && "fixed") === "fixed", C = [i.onEnter, i.onLeave, i.onEnterBack, i.onLeaveBack], T = W && i.toggleActions.split(" "), F = "markers" in i ? i.markers : Td.markers, S = $ ? 0 : parseFloat(Ma(z)["border" + R.p2 + u0]) || 0, A = this, U = i.onRefreshInit && function() {
      return i.onRefreshInit(A);
    }, K = m5t(z, $, R), X = y5t(z, $), L = 0, H = 0, Q = 0, N = hl(z, R), V, Y, Z, rt, st, mt, yt, at, nt, q, D, G, et, J, it, lt, ot, ut, ct, gt, dt, bt, vt, xt, St, Mt, Et, Ft, Wt, Kt, qt, It, re, le, Ce, ce, xe, ve, Oe;
    if (A._startClamp = A._endClamp = !1, A._dir = R, b *= 45, A.scroller = z, A.scroll = O ? O.time.bind(O) : N, rt = N(), A.vars = i, s = s || i.animation, "refreshPriority" in i && (_E = 1, i.refreshPriority === -9999 && (Z1 = A)), j.tweenScroll = j.tweenScroll || {
      top: uC(z, Ir),
      left: uC(z, Oi)
    }, A.tweenTo = V = j.tweenScroll[R.p], A.scrubDuration = function(Lt) {
      re = E1(Lt) && Lt, re ? It ? It.duration(Lt) : It = Pe.to(s, {
        ease: "expo",
        totalProgress: "+=0",
        inherit: !1,
        duration: re,
        paused: !0,
        onComplete: function() {
          return w && w(A);
        }
      }) : (It && It.progress(1).kill(), It = 0);
    }, s && (s.vars.lazy = !1, s._initted && !A.isReverted || s.vars.immediateRender !== !1 && i.immediateRender !== !1 && s.duration() && s.render(0, !0, !0), A.animation = s.pause(), s.scrollTrigger = A, A.scrubDuration(p), Kt = 0, f || (f = s.vars.id)), x && ((!Kl(x) || x.push) && (x = {
      snapTo: x
    }), "scrollBehavior" in Fn.style && Pe.set($ ? [Fn, ia] : z, {
      scrollBehavior: "auto"
    }), gn.forEach(function(Lt) {
      return si(Lt) && Lt.target === ($ ? Xn.scrollingElement || ia : z) && (Lt.smooth = !1);
    }), Z = si(x.snapTo) ? x.snapTo : x.snapTo === "labels" ? v5t(s) : x.snapTo === "labelsDirectional" ? w5t(s) : x.directional !== !1 ? function(Lt, Dt) {
      return t8(x.snapTo)(Lt, ii() - H < 500 ? 0 : Dt.direction);
    } : Pe.utils.snap(x.snapTo), le = x.duration || {
      min: 0.1,
      max: 2
    }, le = Kl(le) ? q1(le.min, le.max) : q1(le, le), Ce = Pe.delayedCall(x.delay || re / 2 || 0.1, function() {
      var Lt = N(), Dt = ii() - H < 500, jt = V.tween;
      if ((Dt || Math.abs(A.getVelocity()) < 10) && !jt && !Pp && L !== Lt) {
        var Ot = (Lt - mt) / J, Rt = s && !W ? s.totalProgress() : Ot, Tt = Dt ? 0 : (Rt - qt) / (ii() - O1) * 1e3 || 0, ee = Pe.utils.clamp(-Ot, 1 - Ot, mu(Tt / 2) * Tt / 0.185), te = Ot + (x.inertia === !1 ? 0 : ee), Jt, pe, ye = x, fe = ye.onStart, me = ye.onInterrupt, we = ye.onComplete;
        if (Jt = Z(te, A), E1(Jt) || (Jt = te), pe = Math.max(0, Math.round(mt + Jt * J)), Lt <= yt && Lt >= mt && pe !== Lt) {
          if (jt && !jt._initted && jt.data <= mu(pe - Lt))
            return;
          x.inertia === !1 && (ee = Jt - Ot), V(pe, {
            duration: le(mu(Math.max(mu(te - Rt), mu(Jt - Rt)) * 0.185 / Tt / 0.05 || 0)),
            ease: x.ease || "power3",
            data: mu(pe - Lt),
            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
            onInterrupt: function() {
              return Ce.restart(!0) && me && me(A);
            },
            onComplete: function() {
              A.update(), L = N(), s && !W && (It ? It.resetTo("totalProgress", Jt, s._tTime / s._tDur) : s.progress(Jt)), Kt = qt = s && !W ? s.totalProgress() : A.progress, v && v(A), we && we(A);
            }
          }, Lt, ee * J, pe - Lt - ee * J), fe && fe(A, V.tween);
        }
      } else A.isActive && L !== Lt && Ce.restart(!0);
    }).pause()), f && (A6[f] = A), n = A.trigger = Li(n || a !== !0 && a), Oe = n && n._gsap && n._gsap.stRevert, Oe && (Oe = Oe(A)), a = a === !0 ? n : Li(a), ea(l) && (l = {
      targets: n,
      className: l
    }), a && (d === !1 || d === Ta || (d = !d && a.parentNode && a.parentNode.style && Ma(a.parentNode).display === "flex" ? !1 : wr), A.pin = a, Y = Pe.core.getCache(a), Y.spacer ? it = Y.pinState : (M && (M = Li(M), M && !M.nodeType && (M = M.current || M.nativeElement), Y.spacerIsNative = !!M, M && (Y.spacerState = Ed(M))), Y.spacer = ut = M || Xn.createElement("div"), ut.classList.add("pin-spacer"), f && ut.classList.add("pin-spacer-" + f), Y.pinState = it = Ed(a)), i.force3D !== !1 && Pe.set(a, {
      force3D: !0
    }), A.spacer = ut = Y.spacer, Wt = Ma(a), xt = Wt[d + R.os2], gt = Pe.getProperty(a), dt = Pe.quickSetter(a, R.a, Pr), Zm(a, ut, Wt), ot = Ed(a)), F) {
      G = Kl(F) ? rC(F, iC) : iC, q = Md("scroller-start", f, z, R, G, 0), D = Md("scroller-end", f, z, R, G, 0, q), ct = q["offset" + R.op.d2];
      var He = Li(Zo(z, "content") || z);
      at = this.markerStart = Md("start", f, He, R, G, ct, 0, O), nt = this.markerEnd = Md("end", f, He, R, G, ct, 0, O), O && (ve = Pe.quickSetter([at, nt], R.a, Pr)), !B && !(ks.length && Zo(z, "fixedMarkers") === !0) && (b5t($ ? Fn : z), Pe.set([q, D], {
        force3D: !0
      }), Mt = Pe.quickSetter(q, R.a, Pr), Ft = Pe.quickSetter(D, R.a, Pr));
    }
    if (O) {
      var Zt = O.vars.onUpdate, Xt = O.vars.onUpdateParams;
      O.eventCallback("onUpdate", function() {
        A.update(0, 0, 1), Zt && Zt.apply(O, Xt || []);
      });
    }
    if (A.previous = function() {
      return hn[hn.indexOf(A) - 1];
    }, A.next = function() {
      return hn[hn.indexOf(A) + 1];
    }, A.revert = function(Lt, Dt) {
      if (!Dt)
        return A.kill(!0);
      var jt = Lt !== !1 || !A.enabled, Ot = ei;
      jt !== A.isReverted && (jt && (ce = Math.max(N(), A.scroll.rec || 0), Q = A.progress, xe = s && s.progress()), at && [at, nt, q, D].forEach(function(Rt) {
        return Rt.style.display = jt ? "none" : "block";
      }), jt && (ei = A, A.update(jt)), a && (!_ || !A.isActive) && (jt ? C5t(a, ut, it) : Zm(a, ut, Ma(a), St)), jt || A.update(jt), ei = Ot, A.isReverted = jt);
    }, A.refresh = function(Lt, Dt, jt, Ot) {
      if (!((ei || !A.enabled) && !Dt)) {
        if (a && Lt && Ia) {
          Lr(t, "scrollEnd", $E);
          return;
        }
        !Ai && U && U(A), ei = A, V.tween && !jt && (V.tween.kill(), V.tween = 0), It && It.pause(), m && s && s.revert({
          kill: !1
        }).invalidate(), A.isReverted || A.revert(!0, !0), A._subPinOffset = !1;
        var Rt = K(), Tt = X(), ee = O ? O.duration() : ys(z, R), te = J <= 0.01, Jt = 0, pe = Ot || 0, ye = Kl(jt) ? jt.end : i.end, fe = i.endTrigger || n, me = Kl(jt) ? jt.start : i.start || (i.start === 0 || !n ? 0 : a ? "0 0" : "0 100%"), we = A.pinnedContainer = i.pinnedContainer && Li(i.pinnedContainer, A), Fe = n && Math.max(0, hn.indexOf(A)) || 0, Re = Fe, ge, se, ue, Ae, he, de, _e, Qe, $n, zr, Jn, di, rs;
        for (F && Kl(jt) && (di = Pe.getProperty(q, R.p), rs = Pe.getProperty(D, R.p)); Re-- > 0; )
          de = hn[Re], de.end || de.refresh(0, 1) || (ei = A), _e = de.pin, _e && (_e === n || _e === a || _e === we) && !de.isReverted && (zr || (zr = []), zr.unshift(de), de.revert(!0, !0)), de !== hn[Re] && (Fe--, Re--);
        for (si(me) && (me = me(A)), me = QS(me, "start", A), mt = lC(me, n, Rt, R, N(), at, q, A, Tt, S, B, ee, O, A._startClamp && "_startClamp") || (a ? -1e-3 : 0), si(ye) && (ye = ye(A)), ea(ye) && !ye.indexOf("+=") && (~ye.indexOf(" ") ? ye = (ea(me) ? me.split(" ")[0] : "") + ye : (Jt = o2(ye.substr(2), Rt), ye = ea(me) ? me : (O ? Pe.utils.mapRange(0, O.duration(), O.scrollTrigger.start, O.scrollTrigger.end, mt) : mt) + Jt, fe = n)), ye = QS(ye, "end", A), yt = Math.max(mt, lC(ye || (fe ? "100% 0" : ee), fe, Rt, R, N() + Jt, nt, D, A, Tt, S, B, ee, O, A._endClamp && "_endClamp")) || -1e-3, Jt = 0, Re = Fe; Re--; )
          de = hn[Re], _e = de.pin, _e && de.start - de._pinPush <= mt && !O && de.end > 0 && (ge = de.end - (A._startClamp ? Math.max(0, de.start) : de.start), (_e === n && de.start - de._pinPush < mt || _e === we) && isNaN(me) && (Jt += ge * (1 - de.progress)), _e === a && (pe += ge));
        if (mt += Jt, yt += Jt, A._startClamp && (A._startClamp += Jt), A._endClamp && !Ai && (A._endClamp = yt || -1e-3, yt = Math.min(yt, ys(z, R))), J = yt - mt || (mt -= 0.01) && 1e-3, te && (Q = Pe.utils.clamp(0, 1, Pe.utils.normalize(mt, yt, ce))), A._pinPush = pe, at && Jt && (ge = {}, ge[R.a] = "+=" + Jt, we && (ge[R.p] = "-=" + N()), Pe.set([at, nt], ge)), a && !(C6 && A.end >= ys(z, R)))
          ge = Ma(a), Ae = R === Ir, ue = N(), bt = parseFloat(gt(R.a)) + pe, !ee && yt > 1 && (Jn = ($ ? Xn.scrollingElement || ia : z).style, Jn = {
            style: Jn,
            value: Jn["overflow" + R.a.toUpperCase()]
          }, $ && Ma(Fn)["overflow" + R.a.toUpperCase()] !== "scroll" && (Jn.style["overflow" + R.a.toUpperCase()] = "scroll")), Zm(a, ut, ge), ot = Ed(a), se = Ks(a, !0), Qe = B && hl(z, Ae ? Oi : Ir)(), d ? (St = [d + R.os2, J + pe + Pr], St.t = ut, Re = d === wr ? Tg(a, R) + J + pe : 0, Re && (St.push(R.d, Re + Pr), ut.style.flexBasis !== "auto" && (ut.style.flexBasis = Re + Pr)), Uu(St), we && hn.forEach(function(Ua) {
            Ua.pin === we && Ua.vars.pinSpacing !== !1 && (Ua._subPinOffset = !0);
          }), B && N(ce)) : (Re = Tg(a, R), Re && ut.style.flexBasis !== "auto" && (ut.style.flexBasis = Re + Pr)), B && (he = {
            top: se.top + (Ae ? ue - mt : Qe) + Pr,
            left: se.left + (Ae ? Qe : ue - mt) + Pr,
            boxSizing: "border-box",
            position: "fixed"
          }, he[pc] = he["max" + u0] = Math.ceil(se.width) + Pr, he[mc] = he["max" + Q4] = Math.ceil(se.height) + Pr, he[Ta] = he[Ta + K1] = he[Ta + W1] = he[Ta + Y1] = he[Ta + G1] = "0", he[wr] = ge[wr], he[wr + K1] = ge[wr + K1], he[wr + W1] = ge[wr + W1], he[wr + Y1] = ge[wr + Y1], he[wr + G1] = ge[wr + G1], lt = _5t(it, he, _), Ai && N(0)), s ? ($n = s._initted, qm(1), s.render(s.duration(), !0, !0), vt = gt(R.a) - bt + J + pe, Et = Math.abs(J - vt) > 1, B && Et && lt.splice(lt.length - 2, 2), s.render(0, !0, !0), $n || s.invalidate(!0), s.parent || s.totalTime(s.totalTime()), qm(0)) : vt = J, Jn && (Jn.value ? Jn.style["overflow" + R.a.toUpperCase()] = Jn.value : Jn.style.removeProperty("overflow-" + R.a));
        else if (n && N() && !O)
          for (se = n.parentNode; se && se !== Fn; )
            se._pinOffset && (mt -= se._pinOffset, yt -= se._pinOffset), se = se.parentNode;
        zr && zr.forEach(function(Ua) {
          return Ua.revert(!1, !0);
        }), A.start = mt, A.end = yt, rt = st = Ai ? ce : N(), !O && !Ai && (rt < ce && N(ce), A.scroll.rec = 0), A.revert(!1, !0), H = ii(), Ce && (L = -1, Ce.restart(!0)), ei = 0, s && W && (s._initted || xe) && s.progress() !== xe && s.progress(xe || 0, !0).render(s.time(), !0, !0), (te || Q !== A.progress || O || m || s && !s._initted) && (s && !W && s.totalProgress(O && mt < -1e-3 && !Q ? Pe.utils.normalize(mt, yt, 0) : Q, !0), A.progress = te || (rt - mt) / J === Q ? 0 : Q), a && d && (ut._pinOffset = Math.round(A.progress * vt)), It && It.invalidate(), isNaN(di) || (di -= Pe.getProperty(q, R.p), rs -= Pe.getProperty(D, R.p), Pd(q, R, di), Pd(at, R, di - (Ot || 0)), Pd(D, R, rs), Pd(nt, R, rs - (Ot || 0))), te && !Ai && A.update(), g && !Ai && !et && (et = !0, g(A), et = !1);
      }
    }, A.getVelocity = function() {
      return (N() - st) / (ii() - O1) * 1e3 || 0;
    }, A.endAnimation = function() {
      y1(A.callbackAnimation), s && (It ? It.progress(1) : s.paused() ? W || y1(s, A.direction < 0, 1) : y1(s, s.reversed()));
    }, A.labelToScroll = function(Lt) {
      return s && s.labels && (mt || A.refresh() || mt) + s.labels[Lt] / s.duration() * J || 0;
    }, A.getTrailing = function(Lt) {
      var Dt = hn.indexOf(A), jt = A.direction > 0 ? hn.slice(0, Dt).reverse() : hn.slice(Dt + 1);
      return (ea(Lt) ? jt.filter(function(Ot) {
        return Ot.vars.preventOverlaps === Lt;
      }) : jt).filter(function(Ot) {
        return A.direction > 0 ? Ot.end <= mt : Ot.start >= yt;
      });
    }, A.update = function(Lt, Dt, jt) {
      if (!(O && !jt && !Lt)) {
        var Ot = Ai === !0 ? ce : A.scroll(), Rt = Lt ? 0 : (Ot - mt) / J, Tt = Rt < 0 ? 0 : Rt > 1 ? 1 : Rt || 0, ee = A.progress, te, Jt, pe, ye, fe, me, we, Fe;
        if (Dt && (st = rt, rt = O ? N() : Ot, x && (qt = Kt, Kt = s && !W ? s.totalProgress() : Tt)), b && a && !ei && !Ad && Ia && (!Tt && mt < Ot + (Ot - st) / (ii() - O1) * b ? Tt = 1e-4 : Tt === 1 && yt > Ot + (Ot - st) / (ii() - O1) * b && (Tt = 0.9999)), Tt !== ee && A.enabled) {
          if (te = A.isActive = !!Tt && Tt < 1, Jt = !!ee && ee < 1, me = te !== Jt, fe = me || !!Tt != !!ee, A.direction = Tt > ee ? 1 : -1, A.progress = Tt, fe && !ei && (pe = Tt && !ee ? 0 : Tt === 1 ? 1 : ee === 1 ? 2 : 3, W && (ye = !me && T[pe + 1] !== "none" && T[pe + 1] || T[pe], Fe = s && (ye === "complete" || ye === "reset" || ye in s))), I && (me || Fe) && (Fe || p || !s) && (si(I) ? I(A) : A.getTrailing(I).forEach(function(ue) {
            return ue.endAnimation();
          })), W || (It && !ei && !Ad ? (It._dp._time - It._start !== It._time && It.render(It._dp._time - It._start), It.resetTo ? It.resetTo("totalProgress", Tt, s._tTime / s._tDur) : (It.vars.totalProgress = Tt, It.invalidate().restart())) : s && s.totalProgress(Tt, !!(ei && (H || Lt)))), a) {
            if (Lt && d && (ut.style[d + R.os2] = xt), !B)
              dt(M1(bt + vt * Tt));
            else if (fe) {
              if (we = !Lt && Tt > ee && yt + 1 > Ot && Ot + 1 >= ys(z, R), _)
                if (!Lt && (te || we)) {
                  var Re = Ks(a, !0), ge = Ot - mt;
                  cC(a, Fn, Re.top + (R === Ir ? ge : 0) + Pr, Re.left + (R === Ir ? 0 : ge) + Pr);
                } else
                  cC(a, ut);
              Uu(te || we ? lt : ot), Et && Tt < 1 && te || dt(bt + (Tt === 1 && !we ? vt : 0));
            }
          }
          x && !V.tween && !ei && !Ad && Ce.restart(!0), l && (me || h && Tt && (Tt < 1 || !Wm)) && xh(l.targets).forEach(function(ue) {
            return ue.classList[te || h ? "add" : "remove"](l.className);
          }), u && !W && !Lt && u(A), fe && !ei ? (W && (Fe && (ye === "complete" ? s.pause().totalProgress(1) : ye === "reset" ? s.restart(!0).pause() : ye === "restart" ? s.restart(!0) : s[ye]()), u && u(A)), (me || !Wm) && (o && me && Km(A, o), C[pe] && Km(A, C[pe]), h && (Tt === 1 ? A.kill(!1, 1) : C[pe] = 0), me || (pe = Tt === 1 ? 1 : 3, C[pe] && Km(A, C[pe]))), E && !te && Math.abs(A.getVelocity()) > (E1(E) ? E : 2500) && (y1(A.callbackAnimation), It ? It.progress(1) : y1(s, ye === "reverse" ? 1 : !Tt, 1))) : W && u && !ei && u(A);
        }
        if (Ft) {
          var se = O ? Ot / O.duration() * (O._caScrollDist || 0) : Ot;
          Mt(se + (q._isFlipped ? 1 : 0)), Ft(se);
        }
        ve && ve(-Ot / O.duration() * (O._caScrollDist || 0));
      }
    }, A.enable = function(Lt, Dt) {
      A.enabled || (A.enabled = !0, Lr(z, "resize", P1), $ || Lr(z, "scroll", yu), U && Lr(t, "refreshInit", U), Lt !== !1 && (A.progress = Q = 0, rt = st = L = N()), Dt !== !1 && A.refresh());
    }, A.getTween = function(Lt) {
      return Lt && V ? V.tween : It;
    }, A.setPositions = function(Lt, Dt, jt, Ot) {
      if (O) {
        var Rt = O.scrollTrigger, Tt = O.duration(), ee = Rt.end - Rt.start;
        Lt = Rt.start + ee * Lt / Tt, Dt = Rt.start + ee * Dt / Tt;
      }
      A.refresh(!1, !1, {
        start: tC(Lt, jt && !!A._startClamp),
        end: tC(Dt, jt && !!A._endClamp)
      }, Ot), A.update();
    }, A.adjustPinSpacing = function(Lt) {
      if (St && Lt) {
        var Dt = St.indexOf(R.d) + 1;
        St[Dt] = parseFloat(St[Dt]) + Lt + Pr, St[1] = parseFloat(St[1]) + Lt + Pr, Uu(St);
      }
    }, A.disable = function(Lt, Dt) {
      if (A.enabled && (Lt !== !1 && A.revert(!0, !0), A.enabled = A.isActive = !1, Dt || It && It.pause(), ce = 0, Y && (Y.uncache = 1), U && $r(t, "refreshInit", U), Ce && (Ce.pause(), V.tween && V.tween.kill() && (V.tween = 0)), !$)) {
        for (var jt = hn.length; jt--; )
          if (hn[jt].scroller === z && hn[jt] !== A)
            return;
        $r(z, "resize", P1), $ || $r(z, "scroll", yu);
      }
    }, A.kill = function(Lt, Dt) {
      A.disable(Lt, Dt), It && !Dt && It.kill(), f && delete A6[f];
      var jt = hn.indexOf(A);
      jt >= 0 && hn.splice(jt, 1), jt === Ci && c2 > 0 && Ci--, jt = 0, hn.forEach(function(Ot) {
        return Ot.scroller === A.scroller && (jt = 1);
      }), jt || Ai || (A.scroll.rec = 0), s && (s.scrollTrigger = null, Lt && s.revert({
        kill: !1
      }), Dt || s.kill()), at && [at, nt, q, D].forEach(function(Ot) {
        return Ot.parentNode && Ot.parentNode.removeChild(Ot);
      }), Z1 === A && (Z1 = 0), a && (Y && (Y.uncache = 1), jt = 0, hn.forEach(function(Ot) {
        return Ot.pin === a && jt++;
      }), jt || (Y.spacer = 0)), i.onKill && i.onKill(A);
    }, hn.push(A), A.enable(!1, !1), Oe && Oe(A), s && s.add && !J) {
      var Gt = A.update;
      A.update = function() {
        A.update = Gt, gn.cache++, mt || yt || A.refresh();
      }, Pe.delayedCall(0.01, A.update), J = 0.01, mt = yt = 0;
    } else
      A.refresh();
    a && S5t();
  }, t.register = function(i) {
    return Su || (Pe = i || EE(), ME() && window.document && t.enable(), Su = T1), Su;
  }, t.defaults = function(i) {
    if (i)
      for (var s in i)
        Td[s] = i[s];
    return Td;
  }, t.disable = function(i, s) {
    T1 = 0, hn.forEach(function(u) {
      return u[s ? "kill" : "disable"](i);
    }), $r(dn, "wheel", yu), $r(Xn, "scroll", yu), clearInterval(Cd), $r(Xn, "touchcancel", hs), $r(Fn, "touchstart", hs), kd($r, Xn, "pointerdown,touchstart,mousedown", eC), kd($r, Xn, "pointerup,touchend,mouseup", nC), kg.kill(), _d($r);
    for (var c = 0; c < gn.length; c += 3)
      Od($r, gn[c], gn[c + 1]), Od($r, gn[c], gn[c + 2]);
  }, t.enable = function() {
    if (dn = window, Xn = document, ia = Xn.documentElement, Fn = Xn.body, Pe && (xh = Pe.utils.toArray, q1 = Pe.utils.clamp, S6 = Pe.core.context || hs, qm = Pe.core.suppressOverwrites || hs, K4 = dn.history.scrollRestoration || "auto", _6 = dn.pageYOffset || 0, Pe.core.globals("ScrollTrigger", t), Fn)) {
      T1 = 1, ju = document.createElement("div"), ju.style.height = "100vh", ju.style.position = "absolute", BE(), p5t(), pr.register(Pe), t.isTouch = pr.isTouch, $o = pr.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent), x6 = pr.isTouch === 1, Lr(dn, "wheel", yu), G4 = [dn, Xn, ia, Fn], Pe.matchMedia ? (t.matchMedia = function(o) {
        var g = Pe.matchMedia(), p;
        for (p in o)
          g.add(p, o[p]);
        return g;
      }, Pe.addEventListener("matchMediaInit", function() {
        return e8();
      }), Pe.addEventListener("matchMediaRevert", function() {
        return LE();
      }), Pe.addEventListener("matchMedia", function() {
        ac(0, 1), _c("matchMedia");
      }), Pe.matchMedia().add("(orientation: portrait)", function() {
        return Ym(), Ym;
      })) : console.warn("Requires GSAP 3.11.0 or later"), Ym(), Lr(Xn, "scroll", yu);
      var i = Fn.hasAttribute("style"), s = Fn.style, c = s.borderTopStyle, u = Pe.core.Animation.prototype, l, f;
      for (u.revert || Object.defineProperty(u, "revert", {
        value: function() {
          return this.time(-0.01, !0);
        }
      }), s.borderTopStyle = "solid", l = Ks(Fn), Ir.m = Math.round(l.top + Ir.sc()) || 0, Oi.m = Math.round(l.left + Oi.sc()) || 0, c ? s.borderTopStyle = c : s.removeProperty("border-top-style"), i || (Fn.setAttribute("style", ""), Fn.removeAttribute("style")), Cd = setInterval(aC, 250), Pe.delayedCall(0.5, function() {
        return Ad = 0;
      }), Lr(Xn, "touchcancel", hs), Lr(Fn, "touchstart", hs), kd(Lr, Xn, "pointerdown,touchstart,mousedown", eC), kd(Lr, Xn, "pointerup,touchend,mouseup", nC), w6 = Pe.utils.checkPrefix("transform"), u2.push(w6), Su = ii(), kg = Pe.delayedCall(0.2, ac).pause(), Cu = [Xn, "visibilitychange", function() {
        var o = dn.innerWidth, g = dn.innerHeight;
        Xn.hidden ? (ZS = o, JS = g) : (ZS !== o || JS !== g) && P1();
      }, Xn, "DOMContentLoaded", ac, dn, "load", ac, dn, "resize", P1], _d(Lr), hn.forEach(function(o) {
        return o.enable(0, 1);
      }), f = 0; f < gn.length; f += 3)
        Od($r, gn[f], gn[f + 1]), Od($r, gn[f], gn[f + 2]);
    }
  }, t.config = function(i) {
    "limitCallbacks" in i && (Wm = !!i.limitCallbacks);
    var s = i.syncInterval;
    s && clearInterval(Cd) || (Cd = s) && setInterval(aC, s), "ignoreMobileResize" in i && (x6 = t.isTouch === 1 && i.ignoreMobileResize), "autoRefreshEvents" in i && (_d($r) || _d(Lr, i.autoRefreshEvents || "none"), kE = (i.autoRefreshEvents + "").indexOf("resize") === -1);
  }, t.scrollerProxy = function(i, s) {
    var c = Li(i), u = gn.indexOf(c), l = Cc(c);
    ~u && gn.splice(u, l ? 6 : 2), s && (l ? ks.unshift(dn, s, Fn, s, ia, s) : ks.unshift(c, s));
  }, t.clearMatchMedia = function(i) {
    hn.forEach(function(s) {
      return s._ctx && s._ctx.query === i && s._ctx.kill(!0, !0);
    });
  }, t.isInViewport = function(i, s, c) {
    var u = (ea(i) ? Li(i) : i).getBoundingClientRect(), l = u[c ? pc : mc] * s || 0;
    return c ? u.right - l > 0 && u.left + l < dn.innerWidth : u.bottom - l > 0 && u.top + l < dn.innerHeight;
  }, t.positionInViewport = function(i, s, c) {
    ea(i) && (i = Li(i));
    var u = i.getBoundingClientRect(), l = u[c ? pc : mc], f = s == null ? l / 2 : s in Mg ? Mg[s] * l : ~s.indexOf("%") ? parseFloat(s) * l / 100 : parseFloat(s) || 0;
    return c ? (u.left + f) / dn.innerWidth : (u.top + f) / dn.innerHeight;
  }, t.killAll = function(i) {
    if (hn.slice(0).forEach(function(c) {
      return c.vars.id !== "ScrollSmoother" && c.kill();
    }), i !== !0) {
      var s = Ac.killAll || [];
      Ac = {}, s.forEach(function(c) {
        return c();
      });
    }
  }, t;
}();
mn.version = "3.12.7";
mn.saveStyles = function(t) {
  return t ? xh(t).forEach(function(e) {
    if (e && e.style) {
      var r = ta.indexOf(e);
      r >= 0 && ta.splice(r, 5), ta.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), Pe.core.getCache(e), S6());
    }
  }) : ta;
};
mn.revert = function(t, e) {
  return e8(!t, e);
};
mn.create = function(t, e) {
  return new mn(t, e);
};
mn.refresh = function(t) {
  return t ? P1(!0) : (Su || mn.register()) && ac(!0);
};
mn.update = function(t) {
  return ++gn.cache && ao(t === !0 ? 2 : 0);
};
mn.clearScrollMemory = NE;
mn.maxScroll = function(t, e) {
  return ys(t, e ? Oi : Ir);
};
mn.getScrollFunc = function(t, e) {
  return hl(Li(t), e ? Oi : Ir);
};
mn.getById = function(t) {
  return A6[t];
};
mn.getAll = function() {
  return hn.filter(function(t) {
    return t.vars.id !== "ScrollSmoother";
  });
};
mn.isScrolling = function() {
  return !!Ia;
};
mn.snapDirectional = t8;
mn.addEventListener = function(t, e) {
  var r = Ac[t] || (Ac[t] = []);
  ~r.indexOf(e) || r.push(e);
};
mn.removeEventListener = function(t, e) {
  var r = Ac[t], i = r && r.indexOf(e);
  i >= 0 && r.splice(i, 1);
};
mn.batch = function(t, e) {
  var r = [], i = {}, s = e.interval || 0.016, c = e.batchMax || 1e9, u = function(o, g) {
    var p = [], n = [], a = Pe.delayedCall(s, function() {
      g(p, n), p = [], n = [];
    }).pause();
    return function(d) {
      p.length || a.restart(!0), p.push(d.trigger), n.push(d), c <= p.length && a.progress(1);
    };
  }, l;
  for (l in e)
    i[l] = l.substr(0, 2) === "on" && si(e[l]) && l !== "onRefreshInit" ? u(l, e[l]) : e[l];
  return si(c) && (c = c(), Lr(mn, "refresh", function() {
    return c = e.batchMax();
  })), xh(t).forEach(function(f) {
    var o = {};
    for (l in i)
      o[l] = i[l];
    o.trigger = f, r.push(mn.create(o));
  }), r;
};
var hC = function(e, r, i, s) {
  return r > s ? e(s) : r < 0 && e(0), i > s ? (s - r) / (i - r) : i < 0 ? r / (r - i) : 1;
}, Jm = function t(e, r) {
  r === !0 ? e.style.removeProperty("touch-action") : e.style.touchAction = r === !0 ? "auto" : r ? "pan-" + r + (pr.isTouch ? " pinch-zoom" : "") : "none", e === ia && t(Fn, r);
}, Id = {
  auto: 1,
  scroll: 1
}, O5t = function(e) {
  var r = e.event, i = e.target, s = e.axis, c = (r.changedTouches ? r.changedTouches[0] : r).target, u = c._gsap || Pe.core.getCache(c), l = ii(), f;
  if (!u._isScrollT || l - u._isScrollT > 2e3) {
    for (; c && c !== Fn && (c.scrollHeight <= c.clientHeight && c.scrollWidth <= c.clientWidth || !(Id[(f = Ma(c)).overflowY] || Id[f.overflowX])); )
      c = c.parentNode;
    u._isScroll = c && c !== i && !Cc(c) && (Id[(f = Ma(c)).overflowY] || Id[f.overflowX]), u._isScrollT = l;
  }
  (u._isScroll || s === "x") && (r.stopPropagation(), r._gsapAllow = !0);
}, UE = function(e, r, i, s) {
  return pr.create({
    target: e,
    capture: !0,
    debounce: !1,
    lockAxis: !0,
    type: r,
    onWheel: s = s && O5t,
    onPress: s,
    onDrag: s,
    onScroll: s,
    onEnable: function() {
      return i && Lr(Xn, pr.eventTypes[0], dC, !1, !0);
    },
    onDisable: function() {
      return $r(Xn, pr.eventTypes[0], dC, !0);
    }
  });
}, T5t = /(input|label|select|textarea)/i, fC, dC = function(e) {
  var r = T5t.test(e.target.tagName);
  (r || fC) && (e._gsapAllow = !0, fC = r);
}, M5t = function(e) {
  Kl(e) || (e = {}), e.preventDefault = e.isNormalizer = e.allowClicks = !0, e.type || (e.type = "wheel,touch"), e.debounce = !!e.debounce, e.id = e.id || "normalizer";
  var r = e, i = r.normalizeScrollX, s = r.momentum, c = r.allowNestedScroll, u = r.onRelease, l, f, o = Li(e.target) || ia, g = Pe.core.globals().ScrollSmoother, p = g && g.get(), n = $o && (e.content && Li(e.content) || p && e.content !== !1 && !p.smooth() && p.content()), a = hl(o, Ir), d = hl(o, Oi), m = 1, b = (pr.isTouch && dn.visualViewport ? dn.visualViewport.scale * dn.visualViewport.width : dn.outerWidth) / dn.innerWidth, w = 0, v = si(s) ? function() {
    return s(l);
  } : function() {
    return s || 2.8;
  }, h, x, _ = UE(o, e.type, !0, c), M = function() {
    return x = !1;
  }, O = hs, E = hs, I = function() {
    f = ys(o, Ir), E = q1($o ? 1 : 0, f), i && (O = q1(0, ys(o, Oi))), h = yc;
  }, R = function() {
    n._gsap.y = M1(parseFloat(n._gsap.y) + a.offset) + "px", n.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(n._gsap.y) + ", 0, 1)", a.offset = a.cacheID = 0;
  }, W = function() {
    if (x) {
      requestAnimationFrame(M);
      var F = M1(l.deltaY / 2), S = E(a.v - F);
      if (n && S !== a.v + a.offset) {
        a.offset = S - a.v;
        var A = M1((parseFloat(n && n._gsap.y) || 0) - a.offset);
        n.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + A + ", 0, 1)", n._gsap.y = A + "px", a.cacheID = gn.cache, ao();
      }
      return !0;
    }
    a.offset && R(), x = !0;
  }, z, j, $, B, C = function() {
    I(), z.isActive() && z.vars.scrollY > f && (a() > f ? z.progress(1) && a(f) : z.resetTo("scrollY", f));
  };
  return n && Pe.set(n, {
    y: "+=0"
  }), e.ignoreCheck = function(T) {
    return $o && T.type === "touchmove" && W() || m > 1.05 && T.type !== "touchstart" || l.isGesturing || T.touches && T.touches.length > 1;
  }, e.onPress = function() {
    x = !1;
    var T = m;
    m = M1((dn.visualViewport && dn.visualViewport.scale || 1) / b), z.pause(), T !== m && Jm(o, m > 1.01 ? !0 : i ? !1 : "x"), j = d(), $ = a(), I(), h = yc;
  }, e.onRelease = e.onGestureStart = function(T, F) {
    if (a.offset && R(), !F)
      B.restart(!0);
    else {
      gn.cache++;
      var S = v(), A, U;
      i && (A = d(), U = A + S * 0.05 * -T.velocityX / 0.227, S *= hC(d, A, U, ys(o, Oi)), z.vars.scrollX = O(U)), A = a(), U = A + S * 0.05 * -T.velocityY / 0.227, S *= hC(a, A, U, ys(o, Ir)), z.vars.scrollY = E(U), z.invalidate().duration(S).play(0.01), ($o && z.vars.scrollY >= f || A >= f - 1) && Pe.to({}, {
        onUpdate: C,
        duration: S
      });
    }
    u && u(T);
  }, e.onWheel = function() {
    z._ts && z.pause(), ii() - w > 1e3 && (h = 0, w = ii());
  }, e.onChange = function(T, F, S, A, U) {
    if (yc !== h && I(), F && i && d(O(A[2] === F ? j + (T.startX - T.x) : d() + F - A[1])), S) {
      a.offset && R();
      var K = U[2] === S, X = K ? $ + T.startY - T.y : a() + S - U[1], L = E(X);
      K && X !== L && ($ += L - X), a(L);
    }
    (S || F) && ao();
  }, e.onEnable = function() {
    Jm(o, i ? !1 : "x"), mn.addEventListener("refresh", C), Lr(dn, "resize", C), a.smooth && (a.target.style.scrollBehavior = "auto", a.smooth = d.smooth = !1), _.enable();
  }, e.onDisable = function() {
    Jm(o, !0), $r(dn, "resize", C), mn.removeEventListener("refresh", C), _.kill();
  }, e.lockAxis = e.lockAxis !== !1, l = new pr(e), l.iOS = $o, $o && !a() && a(1), $o && Pe.ticker.add(hs), B = l._dc, z = Pe.to(l, {
    ease: "power4",
    paused: !0,
    inherit: !1,
    scrollX: i ? "+=0.1" : "+=0",
    scrollY: "+=0.1",
    modifiers: {
      scrollY: jE(a, a(), function() {
        return z.pause();
      })
    },
    onUpdate: ao,
    onComplete: B.vars.onComplete
  }), l;
};
mn.sort = function(t) {
  if (si(t))
    return hn.sort(t);
  var e = dn.pageYOffset || 0;
  return mn.getAll().forEach(function(r) {
    return r._sortY = r.trigger ? e + r.trigger.getBoundingClientRect().top : r.start + dn.innerHeight;
  }), hn.sort(t || function(r, i) {
    return (r.vars.refreshPriority || 0) * -1e6 + (r.vars.containerAnimation ? 1e6 : r._sortY) - ((i.vars.containerAnimation ? 1e6 : i._sortY) + (i.vars.refreshPriority || 0) * -1e6);
  });
};
mn.observe = function(t) {
  return new pr(t);
};
mn.normalizeScroll = function(t) {
  if (typeof t > "u")
    return Si;
  if (t === !0 && Si)
    return Si.enable();
  if (t === !1) {
    Si && Si.kill(), Si = t;
    return;
  }
  var e = t instanceof pr ? t : M5t(t);
  return Si && Si.target === e.target && Si.kill(), Cc(e.target) && (Si = e), e;
};
mn.core = {
  // smaller file size way to leverage in ScrollSmoother and Observer
  _getVelocityProp: v6,
  _inputObserver: UE,
  _scrollers: gn,
  _proxies: ks,
  bridge: {
    // when normalizeScroll sets the scroll position (ss = setScroll)
    ss: function() {
      Ia || _c("scrollStart"), Ia = ii();
    },
    // a way to get the _refreshing value in Observer
    ref: function() {
      return ei;
    }
  }
};
EE() && Pe.registerPlugin(mn);
/*!
 * @gsap/react 2.1.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
let gC = typeof document < "u" ? Ug : Tn, pC = (t) => t && !Array.isArray(t) && typeof t == "object", Fd = [], E5t = {}, HE = M0;
const Zh = (t, e = Fd) => {
  let r = E5t;
  pC(t) ? (r = t, t = null, e = "dependencies" in r ? r.dependencies : Fd) : pC(e) && (r = e, e = "dependencies" in r ? r.dependencies : Fd), t && typeof t != "function" && console.warn("First parameter must be a function or config object");
  const { scope: i, revertOnUpdate: s } = r, c = Sn(!1), u = Sn(HE.context(() => {
  }, i)), l = Sn((o) => u.current.add(null, o)), f = e && e.length && !s;
  return f && gC(() => (c.current = !0, () => u.current.revert()), Fd), gC(() => {
    if (t && u.current.add(t, i), !f || !c.current)
      return () => u.current.revert();
  }, e), { context: u.current, contextSafe: l.current };
};
Zh.register = (t) => {
  HE = t;
};
Zh.headless = !0;
M0.registerPlugin(mn);
const P5t = ({
  pageNumber: t,
  width: e,
  parentRef: r,
  onIsActive: i,
  ...s
}) => {
  const c = Sn(null), [u, l] = cn(!1);
  return Zh(
    () => {
      u && M0.to(c.current, {
        scrollTrigger: {
          scroller: r.current,
          trigger: c.current,
          start: "top 20%",
          end: "bottom 40%",
          onToggle: () => i()
        }
      });
    },
    { scope: r, dependencies: [u] }
  ), /* @__PURE__ */ $t("div", { className: "shadow-sm", ref: c, ...s, children: /* @__PURE__ */ $t(jN, { pageNumber: t, width: e, onLoadSuccess: () => l(!0) }) });
}, I5t = ({ pdfUrl: t, pdfName: e }) => /* @__PURE__ */ $t("a", { className: "no-underline", href: t, tabIndex: -1, download: e, children: /* @__PURE__ */ Ve(
  "button",
  {
    type: "button",
    className: Ke(
      "flex h-10 items-center gap-2 border-2 border-grey-800 bg-grey-800 px-4 text-md text-sm text-white",
      "hover:border-grey-700 hover:bg-grey-700",
      "focus-visible:border-white focus-visible:outline-none"
    ),
    children: [
      /* @__PURE__ */ $t(hr, { className: "mt-0.5", iconName: "download", size: 20 }),
      F5t.label
    ]
  }
) }), F5t = {
  label: "Download"
};
/*!
 * ScrollToPlugin 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var oi, VE, so, bs, Jo, zE, Hu, Rd, XE = function() {
  return typeof window < "u";
}, qE = function() {
  return oi || XE() && (oi = window.gsap) && oi.registerPlugin && oi;
}, WE = function(e) {
  return typeof e == "string";
}, mC = function(e) {
  return typeof e == "function";
}, Ch = function(e, r) {
  var i = r === "x" ? "Width" : "Height", s = "scroll" + i, c = "client" + i;
  return e === so || e === bs || e === Jo ? Math.max(bs[s], Jo[s]) - (so["inner" + i] || bs[c] || Jo[c]) : e[s] - e["offset" + i];
}, Ah = function(e, r) {
  var i = "scroll" + (r === "x" ? "Left" : "Top");
  return e === so && (e.pageXOffset != null ? i = "page" + r.toUpperCase() + "Offset" : e = bs[i] != null ? bs : Jo), function() {
    return e[i];
  };
}, R5t = function(e, r, i, s) {
  if (mC(e) && (e = e(r, i, s)), typeof e != "object")
    return WE(e) && e !== "max" && e.charAt(1) !== "=" ? {
      x: e,
      y: e
    } : {
      y: e
    };
  if (e.nodeType)
    return {
      y: e,
      x: e
    };
  var c = {}, u;
  for (u in e)
    c[u] = u !== "onAutoKill" && mC(e[u]) ? e[u](r, i, s) : e[u];
  return c;
}, GE = function(e, r) {
  if (e = zE(e)[0], !e || !e.getBoundingClientRect)
    return console.warn("scrollTo target doesn't exist. Using 0") || {
      x: 0,
      y: 0
    };
  var i = e.getBoundingClientRect(), s = !r || r === so || r === Jo, c = s ? {
    top: bs.clientTop - (so.pageYOffset || bs.scrollTop || Jo.scrollTop || 0),
    left: bs.clientLeft - (so.pageXOffset || bs.scrollLeft || Jo.scrollLeft || 0)
  } : r.getBoundingClientRect(), u = {
    x: i.left - c.left,
    y: i.top - c.top
  };
  return !s && r && (u.x += Ah(r, "x")(), u.y += Ah(r, "y")()), u;
}, yC = function(e, r, i, s, c) {
  return !isNaN(e) && typeof e != "object" ? parseFloat(e) - c : WE(e) && e.charAt(1) === "=" ? parseFloat(e.substr(2)) * (e.charAt(0) === "-" ? -1 : 1) + s - c : e === "max" ? Ch(r, i) - c : Math.min(Ch(r, i), GE(e, r)[i] - c);
}, O6 = function() {
  oi = qE(), XE() && oi && typeof document < "u" && document.body && (so = window, Jo = document.body, bs = document.documentElement, zE = oi.utils.toArray, oi.config({
    autoKillThreshold: 7
  }), Hu = oi.config(), VE = 1);
}, E0 = {
  version: "3.12.7",
  name: "scrollTo",
  rawVars: 1,
  register: function(e) {
    oi = e, O6();
  },
  init: function(e, r, i, s, c) {
    VE || O6();
    var u = this, l = oi.getProperty(e, "scrollSnapType");
    u.isWin = e === so, u.target = e, u.tween = i, r = R5t(r, s, e, c), u.vars = r, u.autoKill = !!("autoKill" in r ? r : Hu).autoKill, u.getX = Ah(e, "x"), u.getY = Ah(e, "y"), u.x = u.xPrev = u.getX(), u.y = u.yPrev = u.getY(), Rd || (Rd = oi.core.globals().ScrollTrigger), oi.getProperty(e, "scrollBehavior") === "smooth" && oi.set(e, {
      scrollBehavior: "auto"
    }), l && l !== "none" && (u.snap = 1, u.snapInline = e.style.scrollSnapType, e.style.scrollSnapType = "none"), r.x != null ? (u.add(u, "x", u.x, yC(r.x, e, "x", u.x, r.offsetX || 0), s, c), u._props.push("scrollTo_x")) : u.skipX = 1, r.y != null ? (u.add(u, "y", u.y, yC(r.y, e, "y", u.y, r.offsetY || 0), s, c), u._props.push("scrollTo_y")) : u.skipY = 1;
  },
  render: function(e, r) {
    for (var i = r._pt, s = r.target, c = r.tween, u = r.autoKill, l = r.xPrev, f = r.yPrev, o = r.isWin, g = r.snap, p = r.snapInline, n, a, d, m, b; i; )
      i.r(e, i.d), i = i._next;
    n = o || !r.skipX ? r.getX() : l, a = o || !r.skipY ? r.getY() : f, d = a - f, m = n - l, b = Hu.autoKillThreshold, r.x < 0 && (r.x = 0), r.y < 0 && (r.y = 0), u && (!r.skipX && (m > b || m < -b) && n < Ch(s, "x") && (r.skipX = 1), !r.skipY && (d > b || d < -b) && a < Ch(s, "y") && (r.skipY = 1), r.skipX && r.skipY && (c.kill(), r.vars.onAutoKill && r.vars.onAutoKill.apply(c, r.vars.onAutoKillParams || []))), o ? so.scrollTo(r.skipX ? n : r.x, r.skipY ? a : r.y) : (r.skipY || (s.scrollTop = r.y), r.skipX || (s.scrollLeft = r.x)), g && (e === 1 || e === 0) && (a = s.scrollTop, n = s.scrollLeft, p ? s.style.scrollSnapType = p : s.style.removeProperty("scroll-snap-type"), s.scrollTop = a + 1, s.scrollLeft = n + 1, s.scrollTop = a, s.scrollLeft = n), r.xPrev = r.x, r.yPrev = r.y, Rd && Rd.update();
  },
  kill: function(e) {
    var r = e === "scrollTo", i = this._props.indexOf(e);
    return (r || e === "scrollTo_x") && (this.skipX = 1), (r || e === "scrollTo_y") && (this.skipY = 1), i > -1 && this._props.splice(i, 1), !this._props.length;
  }
};
E0.max = Ch;
E0.getOffset = GE;
E0.buildGetter = Ah;
E0.config = function(t) {
  Hu || O6() || (Hu = oi.config());
  for (var e in t)
    Hu[e] = t[e];
};
qE() && oi.registerPlugin(E0);
M0.registerPlugin(Zh, E0);
const D5t = ({ numberOfPages: t, containerRef: e, activePageNumberFromScroll: r }) => {
  const i = mr(), [s, c] = cn(1), [u, l] = cn(1);
  Tn(() => {
    r && c(r);
  }, [r]), Zh(
    () => {
      M0.to(e.current, { scrollTo: `#page_${u}`, duration: 0 });
    },
    { scope: e, dependencies: [u] }
  );
  const f = (a) => {
    let d;
    a < 1 ? d = 1 : a > t ? d = t : d = a, c(d), l(d);
  }, o = (a) => {
    c(a.currentTarget.valueAsNumber);
  }, g = (a) => {
    switch (a.key) {
      case "Enter":
        f(a.currentTarget.valueAsNumber);
        break;
      case "ArrowUp":
        f(a.currentTarget.valueAsNumber - 1);
        break;
      case "ArrowDown":
        f(a.currentTarget.valueAsNumber + 1);
        break;
    }
  }, p = (a) => {
    a.deltaY > 0 ? f(a.currentTarget.valueAsNumber - 1) : f(a.currentTarget.valueAsNumber + 1);
  }, n = (a) => {
    a.currentTarget.valueAsNumber === s && f(Number(a.currentTarget.value));
  };
  return /* @__PURE__ */ Ve("div", { className: "flex items-center justify-center gap-3 text-sm", children: [
    /* @__PURE__ */ Ve("div", { className: "flex content-center items-center", children: [
      /* @__PURE__ */ $t(
        "button",
        {
          className: "flex rounded-sm text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-white disabled:text-grey-400",
          onClick: () => f(s - 1),
          "aria-label": Dd.prevPageButtonLabel,
          disabled: s === 1,
          children: /* @__PURE__ */ $t(hr, { iconName: "chevron-up" })
        }
      ),
      /* @__PURE__ */ $t(
        "button",
        {
          onClick: () => f(s + 1),
          className: "flex rounded-sm text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-white disabled:text-grey-400",
          "aria-label": Dd.nextPageButtonLabel,
          disabled: s === t,
          children: /* @__PURE__ */ $t(hr, { iconName: "chevron-down" })
        }
      )
    ] }),
    /* @__PURE__ */ Ve("div", { className: "flex items-center gap-1.5 text-white", children: [
      /* @__PURE__ */ $t(
        "input",
        {
          className: Ke(
            "h-6 w-6 bg-grey-900 text-center text-sm text-white",
            "focus-visible:outline focus-visible:outline-2 focus-visible:outline-white",
            "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          ),
          id: i,
          type: "number",
          min: 1,
          max: t,
          value: s,
          onChange: o,
          onKeyDown: g,
          onWheel: p,
          onBlur: n,
          "aria-label": Dd.currentPageInputLabel
        }
      ),
      /* @__PURE__ */ $t("span", { children: "/" }),
      /* @__PURE__ */ $t("div", { className: "total-pages", "aria-label": Dd.totalPageCountLabel, children: t })
    ] })
  ] });
}, Dd = {
  prevPageButtonLabel: "Forrige side",
  nextPageButtonLabel: "Næste side",
  currentPageInputLabel: "Nuværende side",
  totalPageCountLabel: "Samlet antal sider"
};
function $5t(t, e, r) {
  Tn(() => {
    if (!t || !("ResizeObserver" in window))
      return;
    const i = new ResizeObserver(r);
    return i.observe(t, e), () => {
      i.disconnect();
    };
  }, [t, e, r]);
}
const L5t = {}, N5t = ({
  containerRef: t,
  documentMaxWidth: e,
  viewerPaddingInPx: r
}) => {
  const [i, s] = cn(), c = Js((l) => {
    const [f] = l;
    f && s(f.contentRect.width);
  }, []);
  return $5t(t.current, L5t, c), {
    pdfViewerPageWidth: en(() => i ? i > e + r ? e : i - r : e - r, [i, e, r])
  };
};
dA.GlobalWorkerOptions.workerSrc = Zgt;
const B5t = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/"
}, o8t = ({
  pdfFile: t,
  documentMaxWidth: e = 800,
  height: r = "100%",
  overridePdfName: i,
  loadingNode: s,
  onLoadingStarted: c,
  onLoadingFinished: u
}) => {
  const l = Sn(null), f = Sn(null), [o, g] = cn(0), [p, n] = cn(null), { pdfViewerPageWidth: a } = N5t({ containerRef: l, documentMaxWidth: e, viewerPaddingInPx: 32 }), d = en(() => i || (typeof t == "string" ? dA.getPdfFilenameFromUrl(t).replace(/\.pdf$/, "") : ""), [i, t]), m = ({ numPages: b }) => {
    u == null || u(), g(b);
  };
  return /* @__PURE__ */ Ve("div", { className: "h-full", ref: l, children: [
    /* @__PURE__ */ Ve("div", { className: "grid h-10 grid-cols-3 items-center justify-between gap-6 justify-self-stretch bg-grey-600", children: [
      /* @__PURE__ */ $t("div", { className: "ml-4 max-h-[80%] overflow-hidden whitespace-nowrap text-md text-white", children: d }),
      /* @__PURE__ */ $t(
        D5t,
        {
          numberOfPages: o,
          containerRef: f,
          activePageNumberFromScroll: p
        }
      ),
      /* @__PURE__ */ $t("div", { className: "flex justify-end", children: /* @__PURE__ */ $t(I5t, { pdfName: d, pdfUrl: (t == null ? void 0 : t.toString()) ?? "" }) })
    ] }),
    /* @__PURE__ */ $t(
      "div",
      {
        className: "grid justify-items-center overflow-y-scroll bg-grey-200 pb-4 pt-8 shadow-inner",
        tabIndex: 0,
        ref: f,
        style: { height: `calc(${r} - 2.5rem)` },
        children: /* @__PURE__ */ $t(
          UN,
          {
            className: "grid gap-8",
            file: t,
            onLoadSuccess: m,
            options: B5t,
            loading: s,
            onLoadStart: c,
            children: Array.from(new Array(o), (b, w) => /* @__PURE__ */ $t(
              P5t,
              {
                id: `page_${w + 1}`,
                pageNumber: w + 1,
                width: a,
                parentRef: f,
                onIsActive: () => n(w + 1)
              },
              `page_${w + 1}`
            ))
          }
        )
      }
    )
  ] });
};
var Eg = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Eg.exports;
(function(t, e) {
  (function() {
    var r, i = "4.17.21", s = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", l = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", o = 500, g = "__lodash_placeholder__", p = 1, n = 2, a = 4, d = 1, m = 2, b = 1, w = 2, v = 4, h = 8, x = 16, _ = 32, M = 64, O = 128, E = 256, I = 512, R = 30, W = "...", z = 800, j = 16, $ = 1, B = 2, C = 3, T = 1 / 0, F = 9007199254740991, S = 17976931348623157e292, A = NaN, U = 4294967295, K = U - 1, X = U >>> 1, L = [
      ["ary", O],
      ["bind", b],
      ["bindKey", w],
      ["curry", h],
      ["curryRight", x],
      ["flip", I],
      ["partial", _],
      ["partialRight", M],
      ["rearg", E]
    ], H = "[object Arguments]", Q = "[object Array]", N = "[object AsyncFunction]", V = "[object Boolean]", Y = "[object Date]", Z = "[object DOMException]", rt = "[object Error]", st = "[object Function]", mt = "[object GeneratorFunction]", yt = "[object Map]", at = "[object Number]", nt = "[object Null]", q = "[object Object]", D = "[object Promise]", G = "[object Proxy]", et = "[object RegExp]", J = "[object Set]", it = "[object String]", lt = "[object Symbol]", ot = "[object Undefined]", ut = "[object WeakMap]", ct = "[object WeakSet]", gt = "[object ArrayBuffer]", dt = "[object DataView]", bt = "[object Float32Array]", vt = "[object Float64Array]", xt = "[object Int8Array]", St = "[object Int16Array]", Mt = "[object Int32Array]", Et = "[object Uint8Array]", Ft = "[object Uint8ClampedArray]", Wt = "[object Uint16Array]", Kt = "[object Uint32Array]", qt = /\b__p \+= '';/g, It = /\b(__p \+=) '' \+/g, re = /(__e\(.*?\)|\b__t\)) \+\n'';/g, le = /&(?:amp|lt|gt|quot|#39);/g, Ce = /[&<>"']/g, ce = RegExp(le.source), xe = RegExp(Ce.source), ve = /<%-([\s\S]+?)%>/g, Oe = /<%([\s\S]+?)%>/g, He = /<%=([\s\S]+?)%>/g, Zt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Xt = /^\w*$/, Gt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Lt = /[\\^$.*+?()[\]{}|]/g, Dt = RegExp(Lt.source), jt = /^\s+/, Ot = /\s/, Rt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Tt = /\{\n\/\* \[wrapped with (.+)\] \*/, ee = /,? & /, te = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Jt = /[()=,{}\[\]\/\s]/, pe = /\\(\\)?/g, ye = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, fe = /\w*$/, me = /^[-+]0x[0-9a-f]+$/i, we = /^0b[01]+$/i, Fe = /^\[object .+?Constructor\]$/, Re = /^0o[0-7]+$/i, ge = /^(?:0|[1-9]\d*)$/, se = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ue = /($^)/, Ae = /['\n\r\u2028\u2029\\]/g, he = "\\ud800-\\udfff", de = "\\u0300-\\u036f", _e = "\\ufe20-\\ufe2f", Qe = "\\u20d0-\\u20ff", $n = de + _e + Qe, zr = "\\u2700-\\u27bf", Jn = "a-z\\xdf-\\xf6\\xf8-\\xff", di = "\\xac\\xb1\\xd7\\xf7", rs = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ua = "\\u2000-\\u206f", F0 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Bc = "A-Z\\xc0-\\xd6\\xd8-\\xde", jc = "\\ufe0e\\ufe0f", Uc = di + rs + Ua + F0, Cl = "['’]", R0 = "[" + he + "]", Al = "[" + Uc + "]", yo = "[" + $n + "]", Hc = "\\d+", Vc = "[" + zr + "]", zc = "[" + Jn + "]", Xc = "[^" + he + Uc + Hc + zr + Jn + Bc + "]", _l = "\\ud83c[\\udffb-\\udfff]", D0 = "(?:" + yo + "|" + _l + ")", qc = "[^" + he + "]", kl = "(?:\\ud83c[\\udde6-\\uddff]){2}", bo = "[\\ud800-\\udbff][\\udc00-\\udfff]", ya = "[" + Bc + "]", Wc = "\\u200d", Gc = "(?:" + zc + "|" + Xc + ")", $0 = "(?:" + ya + "|" + Xc + ")", vo = "(?:" + Cl + "(?:d|ll|m|re|s|t|ve))?", Ol = "(?:" + Cl + "(?:D|LL|M|RE|S|T|VE))?", Tl = D0 + "?", Kc = "[" + jc + "]?", L0 = "(?:" + Wc + "(?:" + [qc, kl, bo].join("|") + ")" + Kc + Tl + ")*", N0 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", B0 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Yc = Kc + Tl + L0, Ml = "(?:" + [Vc, kl, bo].join("|") + ")" + Yc, j0 = "(?:" + [qc + yo + "?", yo, kl, bo, R0].join("|") + ")", wo = RegExp(Cl, "g"), U0 = RegExp(yo, "g"), is = RegExp(_l + "(?=" + _l + ")|" + j0 + Yc, "g"), Ht = RegExp([
      ya + "?" + zc + "+" + vo + "(?=" + [Al, ya, "$"].join("|") + ")",
      $0 + "+" + Ol + "(?=" + [Al, ya + Gc, "$"].join("|") + ")",
      ya + "?" + Gc + "+" + vo,
      ya + "+" + Ol,
      B0,
      N0,
      Hc,
      Ml
    ].join("|"), "g"), P = RegExp("[" + Wc + he + $n + jc + "]"), At = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Vt = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], kt = -1, ht = {};
    ht[bt] = ht[vt] = ht[xt] = ht[St] = ht[Mt] = ht[Et] = ht[Ft] = ht[Wt] = ht[Kt] = !0, ht[H] = ht[Q] = ht[gt] = ht[V] = ht[dt] = ht[Y] = ht[rt] = ht[st] = ht[yt] = ht[at] = ht[q] = ht[et] = ht[J] = ht[it] = ht[ut] = !1;
    var Yt = {};
    Yt[H] = Yt[Q] = Yt[gt] = Yt[dt] = Yt[V] = Yt[Y] = Yt[bt] = Yt[vt] = Yt[xt] = Yt[St] = Yt[Mt] = Yt[yt] = Yt[at] = Yt[q] = Yt[et] = Yt[J] = Yt[it] = Yt[lt] = Yt[Et] = Yt[Ft] = Yt[Wt] = Yt[Kt] = !0, Yt[rt] = Yt[st] = Yt[ut] = !1;
    var be = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ke = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, je = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Ze = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, xn = parseFloat, An = parseInt, Ln = typeof ds == "object" && ds && ds.Object === Object && ds, Gn = typeof self == "object" && self && self.Object === Object && self, $e = Ln || Gn || Function("return this")(), yr = e && !e.nodeType && e, fn = yr && !0 && t && !t.nodeType && t, qi = fn && fn.exports === yr, Xr = qi && Ln.process, ze = function() {
      try {
        var Ut = fn && fn.require && fn.require("util").types;
        return Ut || Xr && Xr.binding && Xr.binding("util");
      } catch {
      }
    }(), Me = ze && ze.isArrayBuffer, Ei = ze && ze.isDate, gi = ze && ze.isMap, Ha = ze && ze.isRegExp, Wi = ze && ze.isSet, br = ze && ze.isTypedArray;
    function kr(Ut, ne, Qt) {
      switch (Qt.length) {
        case 0:
          return Ut.call(ne);
        case 1:
          return Ut.call(ne, Qt[0]);
        case 2:
          return Ut.call(ne, Qt[0], Qt[1]);
        case 3:
          return Ut.call(ne, Qt[0], Qt[1], Qt[2]);
      }
      return Ut.apply(ne, Qt);
    }
    function xo(Ut, ne, Qt, Ee) {
      for (var Je = -1, On = Ut == null ? 0 : Ut.length; ++Je < On; ) {
        var Or = Ut[Je];
        ne(Ee, Or, Qt(Or), Ut);
      }
      return Ee;
    }
    function Pi(Ut, ne) {
      for (var Qt = -1, Ee = Ut == null ? 0 : Ut.length; ++Qt < Ee && ne(Ut[Qt], Qt, Ut) !== !1; )
        ;
      return Ut;
    }
    function Zc(Ut, ne) {
      for (var Qt = Ut == null ? 0 : Ut.length; Qt-- && ne(Ut[Qt], Qt, Ut) !== !1; )
        ;
      return Ut;
    }
    function x8(Ut, ne) {
      for (var Qt = -1, Ee = Ut == null ? 0 : Ut.length; ++Qt < Ee; )
        if (!ne(Ut[Qt], Qt, Ut))
          return !1;
      return !0;
    }
    function So(Ut, ne) {
      for (var Qt = -1, Ee = Ut == null ? 0 : Ut.length, Je = 0, On = []; ++Qt < Ee; ) {
        var Or = Ut[Qt];
        ne(Or, Qt, Ut) && (On[Je++] = Or);
      }
      return On;
    }
    function lf(Ut, ne) {
      var Qt = Ut == null ? 0 : Ut.length;
      return !!Qt && Jc(Ut, ne, 0) > -1;
    }
    function Yp(Ut, ne, Qt) {
      for (var Ee = -1, Je = Ut == null ? 0 : Ut.length; ++Ee < Je; )
        if (Qt(ne, Ut[Ee]))
          return !0;
      return !1;
    }
    function Qn(Ut, ne) {
      for (var Qt = -1, Ee = Ut == null ? 0 : Ut.length, Je = Array(Ee); ++Qt < Ee; )
        Je[Qt] = ne(Ut[Qt], Qt, Ut);
      return Je;
    }
    function Co(Ut, ne) {
      for (var Qt = -1, Ee = ne.length, Je = Ut.length; ++Qt < Ee; )
        Ut[Je + Qt] = ne[Qt];
      return Ut;
    }
    function Zp(Ut, ne, Qt, Ee) {
      var Je = -1, On = Ut == null ? 0 : Ut.length;
      for (Ee && On && (Qt = Ut[++Je]); ++Je < On; )
        Qt = ne(Qt, Ut[Je], Je, Ut);
      return Qt;
    }
    function oI(Ut, ne, Qt, Ee) {
      var Je = Ut == null ? 0 : Ut.length;
      for (Ee && Je && (Qt = Ut[--Je]); Je--; )
        Qt = ne(Qt, Ut[Je], Je, Ut);
      return Qt;
    }
    function Jp(Ut, ne) {
      for (var Qt = -1, Ee = Ut == null ? 0 : Ut.length; ++Qt < Ee; )
        if (ne(Ut[Qt], Qt, Ut))
          return !0;
      return !1;
    }
    var lI = Qp("length");
    function cI(Ut) {
      return Ut.split("");
    }
    function uI(Ut) {
      return Ut.match(te) || [];
    }
    function S8(Ut, ne, Qt) {
      var Ee;
      return Qt(Ut, function(Je, On, Or) {
        if (ne(Je, On, Or))
          return Ee = On, !1;
      }), Ee;
    }
    function cf(Ut, ne, Qt, Ee) {
      for (var Je = Ut.length, On = Qt + (Ee ? 1 : -1); Ee ? On-- : ++On < Je; )
        if (ne(Ut[On], On, Ut))
          return On;
      return -1;
    }
    function Jc(Ut, ne, Qt) {
      return ne === ne ? SI(Ut, ne, Qt) : cf(Ut, C8, Qt);
    }
    function hI(Ut, ne, Qt, Ee) {
      for (var Je = Qt - 1, On = Ut.length; ++Je < On; )
        if (Ee(Ut[Je], ne))
          return Je;
      return -1;
    }
    function C8(Ut) {
      return Ut !== Ut;
    }
    function A8(Ut, ne) {
      var Qt = Ut == null ? 0 : Ut.length;
      return Qt ? e5(Ut, ne) / Qt : A;
    }
    function Qp(Ut) {
      return function(ne) {
        return ne == null ? r : ne[Ut];
      };
    }
    function t5(Ut) {
      return function(ne) {
        return Ut == null ? r : Ut[ne];
      };
    }
    function _8(Ut, ne, Qt, Ee, Je) {
      return Je(Ut, function(On, Or, Bn) {
        Qt = Ee ? (Ee = !1, On) : ne(Qt, On, Or, Bn);
      }), Qt;
    }
    function fI(Ut, ne) {
      var Qt = Ut.length;
      for (Ut.sort(ne); Qt--; )
        Ut[Qt] = Ut[Qt].value;
      return Ut;
    }
    function e5(Ut, ne) {
      for (var Qt, Ee = -1, Je = Ut.length; ++Ee < Je; ) {
        var On = ne(Ut[Ee]);
        On !== r && (Qt = Qt === r ? On : Qt + On);
      }
      return Qt;
    }
    function n5(Ut, ne) {
      for (var Qt = -1, Ee = Array(Ut); ++Qt < Ut; )
        Ee[Qt] = ne(Qt);
      return Ee;
    }
    function dI(Ut, ne) {
      return Qn(ne, function(Qt) {
        return [Qt, Ut[Qt]];
      });
    }
    function k8(Ut) {
      return Ut && Ut.slice(0, E8(Ut) + 1).replace(jt, "");
    }
    function Gi(Ut) {
      return function(ne) {
        return Ut(ne);
      };
    }
    function r5(Ut, ne) {
      return Qn(ne, function(Qt) {
        return Ut[Qt];
      });
    }
    function H0(Ut, ne) {
      return Ut.has(ne);
    }
    function O8(Ut, ne) {
      for (var Qt = -1, Ee = Ut.length; ++Qt < Ee && Jc(ne, Ut[Qt], 0) > -1; )
        ;
      return Qt;
    }
    function T8(Ut, ne) {
      for (var Qt = Ut.length; Qt-- && Jc(ne, Ut[Qt], 0) > -1; )
        ;
      return Qt;
    }
    function gI(Ut, ne) {
      for (var Qt = Ut.length, Ee = 0; Qt--; )
        Ut[Qt] === ne && ++Ee;
      return Ee;
    }
    var pI = t5(be), mI = t5(ke);
    function yI(Ut) {
      return "\\" + Ze[Ut];
    }
    function bI(Ut, ne) {
      return Ut == null ? r : Ut[ne];
    }
    function Qc(Ut) {
      return P.test(Ut);
    }
    function vI(Ut) {
      return At.test(Ut);
    }
    function wI(Ut) {
      for (var ne, Qt = []; !(ne = Ut.next()).done; )
        Qt.push(ne.value);
      return Qt;
    }
    function i5(Ut) {
      var ne = -1, Qt = Array(Ut.size);
      return Ut.forEach(function(Ee, Je) {
        Qt[++ne] = [Je, Ee];
      }), Qt;
    }
    function M8(Ut, ne) {
      return function(Qt) {
        return Ut(ne(Qt));
      };
    }
    function Ao(Ut, ne) {
      for (var Qt = -1, Ee = Ut.length, Je = 0, On = []; ++Qt < Ee; ) {
        var Or = Ut[Qt];
        (Or === ne || Or === g) && (Ut[Qt] = g, On[Je++] = Qt);
      }
      return On;
    }
    function uf(Ut) {
      var ne = -1, Qt = Array(Ut.size);
      return Ut.forEach(function(Ee) {
        Qt[++ne] = Ee;
      }), Qt;
    }
    function xI(Ut) {
      var ne = -1, Qt = Array(Ut.size);
      return Ut.forEach(function(Ee) {
        Qt[++ne] = [Ee, Ee];
      }), Qt;
    }
    function SI(Ut, ne, Qt) {
      for (var Ee = Qt - 1, Je = Ut.length; ++Ee < Je; )
        if (Ut[Ee] === ne)
          return Ee;
      return -1;
    }
    function CI(Ut, ne, Qt) {
      for (var Ee = Qt + 1; Ee--; )
        if (Ut[Ee] === ne)
          return Ee;
      return Ee;
    }
    function tu(Ut) {
      return Qc(Ut) ? _I(Ut) : lI(Ut);
    }
    function Va(Ut) {
      return Qc(Ut) ? kI(Ut) : cI(Ut);
    }
    function E8(Ut) {
      for (var ne = Ut.length; ne-- && Ot.test(Ut.charAt(ne)); )
        ;
      return ne;
    }
    var AI = t5(je);
    function _I(Ut) {
      for (var ne = is.lastIndex = 0; is.test(Ut); )
        ++ne;
      return ne;
    }
    function kI(Ut) {
      return Ut.match(is) || [];
    }
    function OI(Ut) {
      return Ut.match(Ht) || [];
    }
    var TI = function Ut(ne) {
      ne = ne == null ? $e : eu.defaults($e.Object(), ne, eu.pick($e, Vt));
      var Qt = ne.Array, Ee = ne.Date, Je = ne.Error, On = ne.Function, Or = ne.Math, Bn = ne.Object, a5 = ne.RegExp, MI = ne.String, ba = ne.TypeError, hf = Qt.prototype, EI = On.prototype, nu = Bn.prototype, ff = ne["__core-js_shared__"], df = EI.toString, Rn = nu.hasOwnProperty, PI = 0, P8 = function() {
        var y = /[^.]+$/.exec(ff && ff.keys && ff.keys.IE_PROTO || "");
        return y ? "Symbol(src)_1." + y : "";
      }(), gf = nu.toString, II = df.call(Bn), FI = $e._, RI = a5(
        "^" + df.call(Rn).replace(Lt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), pf = qi ? ne.Buffer : r, _o = ne.Symbol, mf = ne.Uint8Array, I8 = pf ? pf.allocUnsafe : r, yf = M8(Bn.getPrototypeOf, Bn), F8 = Bn.create, R8 = nu.propertyIsEnumerable, bf = hf.splice, D8 = _o ? _o.isConcatSpreadable : r, V0 = _o ? _o.iterator : r, El = _o ? _o.toStringTag : r, vf = function() {
        try {
          var y = Dl(Bn, "defineProperty");
          return y({}, "", {}), y;
        } catch {
        }
      }(), DI = ne.clearTimeout !== $e.clearTimeout && ne.clearTimeout, $I = Ee && Ee.now !== $e.Date.now && Ee.now, LI = ne.setTimeout !== $e.setTimeout && ne.setTimeout, wf = Or.ceil, xf = Or.floor, s5 = Bn.getOwnPropertySymbols, NI = pf ? pf.isBuffer : r, $8 = ne.isFinite, BI = hf.join, jI = M8(Bn.keys, Bn), Tr = Or.max, Jr = Or.min, UI = Ee.now, HI = ne.parseInt, L8 = Or.random, VI = hf.reverse, o5 = Dl(ne, "DataView"), z0 = Dl(ne, "Map"), l5 = Dl(ne, "Promise"), ru = Dl(ne, "Set"), X0 = Dl(ne, "WeakMap"), q0 = Dl(Bn, "create"), Sf = X0 && new X0(), iu = {}, zI = $l(o5), XI = $l(z0), qI = $l(l5), WI = $l(ru), GI = $l(X0), Cf = _o ? _o.prototype : r, W0 = Cf ? Cf.valueOf : r, N8 = Cf ? Cf.toString : r;
      function Ct(y) {
        if (sr(y) && !tn(y) && !(y instanceof yn)) {
          if (y instanceof va)
            return y;
          if (Rn.call(y, "__wrapped__"))
            return By(y);
        }
        return new va(y);
      }
      var au = /* @__PURE__ */ function() {
        function y() {
        }
        return function(k) {
          if (!nr(k))
            return {};
          if (F8)
            return F8(k);
          y.prototype = k;
          var tt = new y();
          return y.prototype = r, tt;
        };
      }();
      function Af() {
      }
      function va(y, k) {
        this.__wrapped__ = y, this.__actions__ = [], this.__chain__ = !!k, this.__index__ = 0, this.__values__ = r;
      }
      Ct.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: ve,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Oe,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: He,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Ct
        }
      }, Ct.prototype = Af.prototype, Ct.prototype.constructor = Ct, va.prototype = au(Af.prototype), va.prototype.constructor = va;
      function yn(y) {
        this.__wrapped__ = y, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = U, this.__views__ = [];
      }
      function KI() {
        var y = new yn(this.__wrapped__);
        return y.__actions__ = Ii(this.__actions__), y.__dir__ = this.__dir__, y.__filtered__ = this.__filtered__, y.__iteratees__ = Ii(this.__iteratees__), y.__takeCount__ = this.__takeCount__, y.__views__ = Ii(this.__views__), y;
      }
      function YI() {
        if (this.__filtered__) {
          var y = new yn(this);
          y.__dir__ = -1, y.__filtered__ = !0;
        } else
          y = this.clone(), y.__dir__ *= -1;
        return y;
      }
      function ZI() {
        var y = this.__wrapped__.value(), k = this.__dir__, tt = tn(y), ft = k < 0, wt = tt ? y.length : 0, _t = cR(0, wt, this.__views__), Pt = _t.start, Nt = _t.end, zt = Nt - Pt, ie = ft ? Nt : Pt - 1, ae = this.__iteratees__, oe = ae.length, Se = 0, Ne = Jr(zt, this.__takeCount__);
        if (!tt || !ft && wt == zt && Ne == zt)
          return ly(y, this.__actions__);
        var qe = [];
        t:
          for (; zt-- && Se < Ne; ) {
            ie += k;
            for (var sn = -1, We = y[ie]; ++sn < oe; ) {
              var pn = ae[sn], vn = pn.iteratee, Zi = pn.type, yi = vn(We);
              if (Zi == B)
                We = yi;
              else if (!yi) {
                if (Zi == $)
                  continue t;
                break t;
              }
            }
            qe[Se++] = We;
          }
        return qe;
      }
      yn.prototype = au(Af.prototype), yn.prototype.constructor = yn;
      function Pl(y) {
        var k = -1, tt = y == null ? 0 : y.length;
        for (this.clear(); ++k < tt; ) {
          var ft = y[k];
          this.set(ft[0], ft[1]);
        }
      }
      function JI() {
        this.__data__ = q0 ? q0(null) : {}, this.size = 0;
      }
      function QI(y) {
        var k = this.has(y) && delete this.__data__[y];
        return this.size -= k ? 1 : 0, k;
      }
      function tF(y) {
        var k = this.__data__;
        if (q0) {
          var tt = k[y];
          return tt === f ? r : tt;
        }
        return Rn.call(k, y) ? k[y] : r;
      }
      function eF(y) {
        var k = this.__data__;
        return q0 ? k[y] !== r : Rn.call(k, y);
      }
      function nF(y, k) {
        var tt = this.__data__;
        return this.size += this.has(y) ? 0 : 1, tt[y] = q0 && k === r ? f : k, this;
      }
      Pl.prototype.clear = JI, Pl.prototype.delete = QI, Pl.prototype.get = tF, Pl.prototype.has = eF, Pl.prototype.set = nF;
      function Ds(y) {
        var k = -1, tt = y == null ? 0 : y.length;
        for (this.clear(); ++k < tt; ) {
          var ft = y[k];
          this.set(ft[0], ft[1]);
        }
      }
      function rF() {
        this.__data__ = [], this.size = 0;
      }
      function iF(y) {
        var k = this.__data__, tt = _f(k, y);
        if (tt < 0)
          return !1;
        var ft = k.length - 1;
        return tt == ft ? k.pop() : bf.call(k, tt, 1), --this.size, !0;
      }
      function aF(y) {
        var k = this.__data__, tt = _f(k, y);
        return tt < 0 ? r : k[tt][1];
      }
      function sF(y) {
        return _f(this.__data__, y) > -1;
      }
      function oF(y, k) {
        var tt = this.__data__, ft = _f(tt, y);
        return ft < 0 ? (++this.size, tt.push([y, k])) : tt[ft][1] = k, this;
      }
      Ds.prototype.clear = rF, Ds.prototype.delete = iF, Ds.prototype.get = aF, Ds.prototype.has = sF, Ds.prototype.set = oF;
      function $s(y) {
        var k = -1, tt = y == null ? 0 : y.length;
        for (this.clear(); ++k < tt; ) {
          var ft = y[k];
          this.set(ft[0], ft[1]);
        }
      }
      function lF() {
        this.size = 0, this.__data__ = {
          hash: new Pl(),
          map: new (z0 || Ds)(),
          string: new Pl()
        };
      }
      function cF(y) {
        var k = Lf(this, y).delete(y);
        return this.size -= k ? 1 : 0, k;
      }
      function uF(y) {
        return Lf(this, y).get(y);
      }
      function hF(y) {
        return Lf(this, y).has(y);
      }
      function fF(y, k) {
        var tt = Lf(this, y), ft = tt.size;
        return tt.set(y, k), this.size += tt.size == ft ? 0 : 1, this;
      }
      $s.prototype.clear = lF, $s.prototype.delete = cF, $s.prototype.get = uF, $s.prototype.has = hF, $s.prototype.set = fF;
      function Il(y) {
        var k = -1, tt = y == null ? 0 : y.length;
        for (this.__data__ = new $s(); ++k < tt; )
          this.add(y[k]);
      }
      function dF(y) {
        return this.__data__.set(y, f), this;
      }
      function gF(y) {
        return this.__data__.has(y);
      }
      Il.prototype.add = Il.prototype.push = dF, Il.prototype.has = gF;
      function za(y) {
        var k = this.__data__ = new Ds(y);
        this.size = k.size;
      }
      function pF() {
        this.__data__ = new Ds(), this.size = 0;
      }
      function mF(y) {
        var k = this.__data__, tt = k.delete(y);
        return this.size = k.size, tt;
      }
      function yF(y) {
        return this.__data__.get(y);
      }
      function bF(y) {
        return this.__data__.has(y);
      }
      function vF(y, k) {
        var tt = this.__data__;
        if (tt instanceof Ds) {
          var ft = tt.__data__;
          if (!z0 || ft.length < s - 1)
            return ft.push([y, k]), this.size = ++tt.size, this;
          tt = this.__data__ = new $s(ft);
        }
        return tt.set(y, k), this.size = tt.size, this;
      }
      za.prototype.clear = pF, za.prototype.delete = mF, za.prototype.get = yF, za.prototype.has = bF, za.prototype.set = vF;
      function B8(y, k) {
        var tt = tn(y), ft = !tt && Ll(y), wt = !tt && !ft && Eo(y), _t = !tt && !ft && !wt && cu(y), Pt = tt || ft || wt || _t, Nt = Pt ? n5(y.length, MI) : [], zt = Nt.length;
        for (var ie in y)
          (k || Rn.call(y, ie)) && !(Pt && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ie == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          wt && (ie == "offset" || ie == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          _t && (ie == "buffer" || ie == "byteLength" || ie == "byteOffset") || // Skip index properties.
          js(ie, zt))) && Nt.push(ie);
        return Nt;
      }
      function j8(y) {
        var k = y.length;
        return k ? y[v5(0, k - 1)] : r;
      }
      function wF(y, k) {
        return Nf(Ii(y), Fl(k, 0, y.length));
      }
      function xF(y) {
        return Nf(Ii(y));
      }
      function c5(y, k, tt) {
        (tt !== r && !Xa(y[k], tt) || tt === r && !(k in y)) && Ls(y, k, tt);
      }
      function G0(y, k, tt) {
        var ft = y[k];
        (!(Rn.call(y, k) && Xa(ft, tt)) || tt === r && !(k in y)) && Ls(y, k, tt);
      }
      function _f(y, k) {
        for (var tt = y.length; tt--; )
          if (Xa(y[tt][0], k))
            return tt;
        return -1;
      }
      function SF(y, k, tt, ft) {
        return ko(y, function(wt, _t, Pt) {
          k(ft, wt, tt(wt), Pt);
        }), ft;
      }
      function U8(y, k) {
        return y && ss(k, Dr(k), y);
      }
      function CF(y, k) {
        return y && ss(k, Ri(k), y);
      }
      function Ls(y, k, tt) {
        k == "__proto__" && vf ? vf(y, k, {
          configurable: !0,
          enumerable: !0,
          value: tt,
          writable: !0
        }) : y[k] = tt;
      }
      function u5(y, k) {
        for (var tt = -1, ft = k.length, wt = Qt(ft), _t = y == null; ++tt < ft; )
          wt[tt] = _t ? r : z5(y, k[tt]);
        return wt;
      }
      function Fl(y, k, tt) {
        return y === y && (tt !== r && (y = y <= tt ? y : tt), k !== r && (y = y >= k ? y : k)), y;
      }
      function wa(y, k, tt, ft, wt, _t) {
        var Pt, Nt = k & p, zt = k & n, ie = k & a;
        if (tt && (Pt = wt ? tt(y, ft, wt, _t) : tt(y)), Pt !== r)
          return Pt;
        if (!nr(y))
          return y;
        var ae = tn(y);
        if (ae) {
          if (Pt = hR(y), !Nt)
            return Ii(y, Pt);
        } else {
          var oe = Qr(y), Se = oe == st || oe == mt;
          if (Eo(y))
            return hy(y, Nt);
          if (oe == q || oe == H || Se && !wt) {
            if (Pt = zt || Se ? {} : Ey(y), !Nt)
              return zt ? tR(y, CF(Pt, y)) : QF(y, U8(Pt, y));
          } else {
            if (!Yt[oe])
              return wt ? y : {};
            Pt = fR(y, oe, Nt);
          }
        }
        _t || (_t = new za());
        var Ne = _t.get(y);
        if (Ne)
          return Ne;
        _t.set(y, Pt), ab(y) ? y.forEach(function(We) {
          Pt.add(wa(We, k, tt, We, y, _t));
        }) : rb(y) && y.forEach(function(We, pn) {
          Pt.set(pn, wa(We, k, tt, pn, y, _t));
        });
        var qe = ie ? zt ? E5 : M5 : zt ? Ri : Dr, sn = ae ? r : qe(y);
        return Pi(sn || y, function(We, pn) {
          sn && (pn = We, We = y[pn]), G0(Pt, pn, wa(We, k, tt, pn, y, _t));
        }), Pt;
      }
      function AF(y) {
        var k = Dr(y);
        return function(tt) {
          return H8(tt, y, k);
        };
      }
      function H8(y, k, tt) {
        var ft = tt.length;
        if (y == null)
          return !ft;
        for (y = Bn(y); ft--; ) {
          var wt = tt[ft], _t = k[wt], Pt = y[wt];
          if (Pt === r && !(wt in y) || !_t(Pt))
            return !1;
        }
        return !0;
      }
      function V8(y, k, tt) {
        if (typeof y != "function")
          throw new ba(u);
        return e1(function() {
          y.apply(r, tt);
        }, k);
      }
      function K0(y, k, tt, ft) {
        var wt = -1, _t = lf, Pt = !0, Nt = y.length, zt = [], ie = k.length;
        if (!Nt)
          return zt;
        tt && (k = Qn(k, Gi(tt))), ft ? (_t = Yp, Pt = !1) : k.length >= s && (_t = H0, Pt = !1, k = new Il(k));
        t:
          for (; ++wt < Nt; ) {
            var ae = y[wt], oe = tt == null ? ae : tt(ae);
            if (ae = ft || ae !== 0 ? ae : 0, Pt && oe === oe) {
              for (var Se = ie; Se--; )
                if (k[Se] === oe)
                  continue t;
              zt.push(ae);
            } else _t(k, oe, ft) || zt.push(ae);
          }
        return zt;
      }
      var ko = my(as), z8 = my(f5, !0);
      function _F(y, k) {
        var tt = !0;
        return ko(y, function(ft, wt, _t) {
          return tt = !!k(ft, wt, _t), tt;
        }), tt;
      }
      function kf(y, k, tt) {
        for (var ft = -1, wt = y.length; ++ft < wt; ) {
          var _t = y[ft], Pt = k(_t);
          if (Pt != null && (Nt === r ? Pt === Pt && !Yi(Pt) : tt(Pt, Nt)))
            var Nt = Pt, zt = _t;
        }
        return zt;
      }
      function kF(y, k, tt, ft) {
        var wt = y.length;
        for (tt = nn(tt), tt < 0 && (tt = -tt > wt ? 0 : wt + tt), ft = ft === r || ft > wt ? wt : nn(ft), ft < 0 && (ft += wt), ft = tt > ft ? 0 : ob(ft); tt < ft; )
          y[tt++] = k;
        return y;
      }
      function X8(y, k) {
        var tt = [];
        return ko(y, function(ft, wt, _t) {
          k(ft, wt, _t) && tt.push(ft);
        }), tt;
      }
      function qr(y, k, tt, ft, wt) {
        var _t = -1, Pt = y.length;
        for (tt || (tt = gR), wt || (wt = []); ++_t < Pt; ) {
          var Nt = y[_t];
          k > 0 && tt(Nt) ? k > 1 ? qr(Nt, k - 1, tt, ft, wt) : Co(wt, Nt) : ft || (wt[wt.length] = Nt);
        }
        return wt;
      }
      var h5 = yy(), q8 = yy(!0);
      function as(y, k) {
        return y && h5(y, k, Dr);
      }
      function f5(y, k) {
        return y && q8(y, k, Dr);
      }
      function Of(y, k) {
        return So(k, function(tt) {
          return Us(y[tt]);
        });
      }
      function Rl(y, k) {
        k = To(k, y);
        for (var tt = 0, ft = k.length; y != null && tt < ft; )
          y = y[os(k[tt++])];
        return tt && tt == ft ? y : r;
      }
      function W8(y, k, tt) {
        var ft = k(y);
        return tn(y) ? ft : Co(ft, tt(y));
      }
      function pi(y) {
        return y == null ? y === r ? ot : nt : El && El in Bn(y) ? lR(y) : xR(y);
      }
      function d5(y, k) {
        return y > k;
      }
      function OF(y, k) {
        return y != null && Rn.call(y, k);
      }
      function TF(y, k) {
        return y != null && k in Bn(y);
      }
      function MF(y, k, tt) {
        return y >= Jr(k, tt) && y < Tr(k, tt);
      }
      function g5(y, k, tt) {
        for (var ft = tt ? Yp : lf, wt = y[0].length, _t = y.length, Pt = _t, Nt = Qt(_t), zt = 1 / 0, ie = []; Pt--; ) {
          var ae = y[Pt];
          Pt && k && (ae = Qn(ae, Gi(k))), zt = Jr(ae.length, zt), Nt[Pt] = !tt && (k || wt >= 120 && ae.length >= 120) ? new Il(Pt && ae) : r;
        }
        ae = y[0];
        var oe = -1, Se = Nt[0];
        t:
          for (; ++oe < wt && ie.length < zt; ) {
            var Ne = ae[oe], qe = k ? k(Ne) : Ne;
            if (Ne = tt || Ne !== 0 ? Ne : 0, !(Se ? H0(Se, qe) : ft(ie, qe, tt))) {
              for (Pt = _t; --Pt; ) {
                var sn = Nt[Pt];
                if (!(sn ? H0(sn, qe) : ft(y[Pt], qe, tt)))
                  continue t;
              }
              Se && Se.push(qe), ie.push(Ne);
            }
          }
        return ie;
      }
      function EF(y, k, tt, ft) {
        return as(y, function(wt, _t, Pt) {
          k(ft, tt(wt), _t, Pt);
        }), ft;
      }
      function Y0(y, k, tt) {
        k = To(k, y), y = Ry(y, k);
        var ft = y == null ? y : y[os(Sa(k))];
        return ft == null ? r : kr(ft, y, tt);
      }
      function G8(y) {
        return sr(y) && pi(y) == H;
      }
      function PF(y) {
        return sr(y) && pi(y) == gt;
      }
      function IF(y) {
        return sr(y) && pi(y) == Y;
      }
      function Z0(y, k, tt, ft, wt) {
        return y === k ? !0 : y == null || k == null || !sr(y) && !sr(k) ? y !== y && k !== k : FF(y, k, tt, ft, Z0, wt);
      }
      function FF(y, k, tt, ft, wt, _t) {
        var Pt = tn(y), Nt = tn(k), zt = Pt ? Q : Qr(y), ie = Nt ? Q : Qr(k);
        zt = zt == H ? q : zt, ie = ie == H ? q : ie;
        var ae = zt == q, oe = ie == q, Se = zt == ie;
        if (Se && Eo(y)) {
          if (!Eo(k))
            return !1;
          Pt = !0, ae = !1;
        }
        if (Se && !ae)
          return _t || (_t = new za()), Pt || cu(y) ? Oy(y, k, tt, ft, wt, _t) : sR(y, k, zt, tt, ft, wt, _t);
        if (!(tt & d)) {
          var Ne = ae && Rn.call(y, "__wrapped__"), qe = oe && Rn.call(k, "__wrapped__");
          if (Ne || qe) {
            var sn = Ne ? y.value() : y, We = qe ? k.value() : k;
            return _t || (_t = new za()), wt(sn, We, tt, ft, _t);
          }
        }
        return Se ? (_t || (_t = new za()), oR(y, k, tt, ft, wt, _t)) : !1;
      }
      function RF(y) {
        return sr(y) && Qr(y) == yt;
      }
      function p5(y, k, tt, ft) {
        var wt = tt.length, _t = wt, Pt = !ft;
        if (y == null)
          return !_t;
        for (y = Bn(y); wt--; ) {
          var Nt = tt[wt];
          if (Pt && Nt[2] ? Nt[1] !== y[Nt[0]] : !(Nt[0] in y))
            return !1;
        }
        for (; ++wt < _t; ) {
          Nt = tt[wt];
          var zt = Nt[0], ie = y[zt], ae = Nt[1];
          if (Pt && Nt[2]) {
            if (ie === r && !(zt in y))
              return !1;
          } else {
            var oe = new za();
            if (ft)
              var Se = ft(ie, ae, zt, y, k, oe);
            if (!(Se === r ? Z0(ae, ie, d | m, ft, oe) : Se))
              return !1;
          }
        }
        return !0;
      }
      function K8(y) {
        if (!nr(y) || mR(y))
          return !1;
        var k = Us(y) ? RI : Fe;
        return k.test($l(y));
      }
      function DF(y) {
        return sr(y) && pi(y) == et;
      }
      function $F(y) {
        return sr(y) && Qr(y) == J;
      }
      function LF(y) {
        return sr(y) && zf(y.length) && !!ht[pi(y)];
      }
      function Y8(y) {
        return typeof y == "function" ? y : y == null ? Di : typeof y == "object" ? tn(y) ? Q8(y[0], y[1]) : J8(y) : bb(y);
      }
      function m5(y) {
        if (!t1(y))
          return jI(y);
        var k = [];
        for (var tt in Bn(y))
          Rn.call(y, tt) && tt != "constructor" && k.push(tt);
        return k;
      }
      function NF(y) {
        if (!nr(y))
          return wR(y);
        var k = t1(y), tt = [];
        for (var ft in y)
          ft == "constructor" && (k || !Rn.call(y, ft)) || tt.push(ft);
        return tt;
      }
      function y5(y, k) {
        return y < k;
      }
      function Z8(y, k) {
        var tt = -1, ft = Fi(y) ? Qt(y.length) : [];
        return ko(y, function(wt, _t, Pt) {
          ft[++tt] = k(wt, _t, Pt);
        }), ft;
      }
      function J8(y) {
        var k = I5(y);
        return k.length == 1 && k[0][2] ? Iy(k[0][0], k[0][1]) : function(tt) {
          return tt === y || p5(tt, y, k);
        };
      }
      function Q8(y, k) {
        return R5(y) && Py(k) ? Iy(os(y), k) : function(tt) {
          var ft = z5(tt, y);
          return ft === r && ft === k ? X5(tt, y) : Z0(k, ft, d | m);
        };
      }
      function Tf(y, k, tt, ft, wt) {
        y !== k && h5(k, function(_t, Pt) {
          if (wt || (wt = new za()), nr(_t))
            BF(y, k, Pt, tt, Tf, ft, wt);
          else {
            var Nt = ft ? ft($5(y, Pt), _t, Pt + "", y, k, wt) : r;
            Nt === r && (Nt = _t), c5(y, Pt, Nt);
          }
        }, Ri);
      }
      function BF(y, k, tt, ft, wt, _t, Pt) {
        var Nt = $5(y, tt), zt = $5(k, tt), ie = Pt.get(zt);
        if (ie) {
          c5(y, tt, ie);
          return;
        }
        var ae = _t ? _t(Nt, zt, tt + "", y, k, Pt) : r, oe = ae === r;
        if (oe) {
          var Se = tn(zt), Ne = !Se && Eo(zt), qe = !Se && !Ne && cu(zt);
          ae = zt, Se || Ne || qe ? tn(Nt) ? ae = Nt : fr(Nt) ? ae = Ii(Nt) : Ne ? (oe = !1, ae = hy(zt, !0)) : qe ? (oe = !1, ae = fy(zt, !0)) : ae = [] : n1(zt) || Ll(zt) ? (ae = Nt, Ll(Nt) ? ae = lb(Nt) : (!nr(Nt) || Us(Nt)) && (ae = Ey(zt))) : oe = !1;
        }
        oe && (Pt.set(zt, ae), wt(ae, zt, ft, _t, Pt), Pt.delete(zt)), c5(y, tt, ae);
      }
      function ty(y, k) {
        var tt = y.length;
        if (tt)
          return k += k < 0 ? tt : 0, js(k, tt) ? y[k] : r;
      }
      function ey(y, k, tt) {
        k.length ? k = Qn(k, function(_t) {
          return tn(_t) ? function(Pt) {
            return Rl(Pt, _t.length === 1 ? _t[0] : _t);
          } : _t;
        }) : k = [Di];
        var ft = -1;
        k = Qn(k, Gi(Xe()));
        var wt = Z8(y, function(_t, Pt, Nt) {
          var zt = Qn(k, function(ie) {
            return ie(_t);
          });
          return { criteria: zt, index: ++ft, value: _t };
        });
        return fI(wt, function(_t, Pt) {
          return JF(_t, Pt, tt);
        });
      }
      function jF(y, k) {
        return ny(y, k, function(tt, ft) {
          return X5(y, ft);
        });
      }
      function ny(y, k, tt) {
        for (var ft = -1, wt = k.length, _t = {}; ++ft < wt; ) {
          var Pt = k[ft], Nt = Rl(y, Pt);
          tt(Nt, Pt) && J0(_t, To(Pt, y), Nt);
        }
        return _t;
      }
      function UF(y) {
        return function(k) {
          return Rl(k, y);
        };
      }
      function b5(y, k, tt, ft) {
        var wt = ft ? hI : Jc, _t = -1, Pt = k.length, Nt = y;
        for (y === k && (k = Ii(k)), tt && (Nt = Qn(y, Gi(tt))); ++_t < Pt; )
          for (var zt = 0, ie = k[_t], ae = tt ? tt(ie) : ie; (zt = wt(Nt, ae, zt, ft)) > -1; )
            Nt !== y && bf.call(Nt, zt, 1), bf.call(y, zt, 1);
        return y;
      }
      function ry(y, k) {
        for (var tt = y ? k.length : 0, ft = tt - 1; tt--; ) {
          var wt = k[tt];
          if (tt == ft || wt !== _t) {
            var _t = wt;
            js(wt) ? bf.call(y, wt, 1) : S5(y, wt);
          }
        }
        return y;
      }
      function v5(y, k) {
        return y + xf(L8() * (k - y + 1));
      }
      function HF(y, k, tt, ft) {
        for (var wt = -1, _t = Tr(wf((k - y) / (tt || 1)), 0), Pt = Qt(_t); _t--; )
          Pt[ft ? _t : ++wt] = y, y += tt;
        return Pt;
      }
      function w5(y, k) {
        var tt = "";
        if (!y || k < 1 || k > F)
          return tt;
        do
          k % 2 && (tt += y), k = xf(k / 2), k && (y += y);
        while (k);
        return tt;
      }
      function un(y, k) {
        return L5(Fy(y, k, Di), y + "");
      }
      function VF(y) {
        return j8(uu(y));
      }
      function zF(y, k) {
        var tt = uu(y);
        return Nf(tt, Fl(k, 0, tt.length));
      }
      function J0(y, k, tt, ft) {
        if (!nr(y))
          return y;
        k = To(k, y);
        for (var wt = -1, _t = k.length, Pt = _t - 1, Nt = y; Nt != null && ++wt < _t; ) {
          var zt = os(k[wt]), ie = tt;
          if (zt === "__proto__" || zt === "constructor" || zt === "prototype")
            return y;
          if (wt != Pt) {
            var ae = Nt[zt];
            ie = ft ? ft(ae, zt, Nt) : r, ie === r && (ie = nr(ae) ? ae : js(k[wt + 1]) ? [] : {});
          }
          G0(Nt, zt, ie), Nt = Nt[zt];
        }
        return y;
      }
      var iy = Sf ? function(y, k) {
        return Sf.set(y, k), y;
      } : Di, XF = vf ? function(y, k) {
        return vf(y, "toString", {
          configurable: !0,
          enumerable: !1,
          value: W5(k),
          writable: !0
        });
      } : Di;
      function qF(y) {
        return Nf(uu(y));
      }
      function xa(y, k, tt) {
        var ft = -1, wt = y.length;
        k < 0 && (k = -k > wt ? 0 : wt + k), tt = tt > wt ? wt : tt, tt < 0 && (tt += wt), wt = k > tt ? 0 : tt - k >>> 0, k >>>= 0;
        for (var _t = Qt(wt); ++ft < wt; )
          _t[ft] = y[ft + k];
        return _t;
      }
      function WF(y, k) {
        var tt;
        return ko(y, function(ft, wt, _t) {
          return tt = k(ft, wt, _t), !tt;
        }), !!tt;
      }
      function Mf(y, k, tt) {
        var ft = 0, wt = y == null ? ft : y.length;
        if (typeof k == "number" && k === k && wt <= X) {
          for (; ft < wt; ) {
            var _t = ft + wt >>> 1, Pt = y[_t];
            Pt !== null && !Yi(Pt) && (tt ? Pt <= k : Pt < k) ? ft = _t + 1 : wt = _t;
          }
          return wt;
        }
        return x5(y, k, Di, tt);
      }
      function x5(y, k, tt, ft) {
        var wt = 0, _t = y == null ? 0 : y.length;
        if (_t === 0)
          return 0;
        k = tt(k);
        for (var Pt = k !== k, Nt = k === null, zt = Yi(k), ie = k === r; wt < _t; ) {
          var ae = xf((wt + _t) / 2), oe = tt(y[ae]), Se = oe !== r, Ne = oe === null, qe = oe === oe, sn = Yi(oe);
          if (Pt)
            var We = ft || qe;
          else ie ? We = qe && (ft || Se) : Nt ? We = qe && Se && (ft || !Ne) : zt ? We = qe && Se && !Ne && (ft || !sn) : Ne || sn ? We = !1 : We = ft ? oe <= k : oe < k;
          We ? wt = ae + 1 : _t = ae;
        }
        return Jr(_t, K);
      }
      function ay(y, k) {
        for (var tt = -1, ft = y.length, wt = 0, _t = []; ++tt < ft; ) {
          var Pt = y[tt], Nt = k ? k(Pt) : Pt;
          if (!tt || !Xa(Nt, zt)) {
            var zt = Nt;
            _t[wt++] = Pt === 0 ? 0 : Pt;
          }
        }
        return _t;
      }
      function sy(y) {
        return typeof y == "number" ? y : Yi(y) ? A : +y;
      }
      function Ki(y) {
        if (typeof y == "string")
          return y;
        if (tn(y))
          return Qn(y, Ki) + "";
        if (Yi(y))
          return N8 ? N8.call(y) : "";
        var k = y + "";
        return k == "0" && 1 / y == -1 / 0 ? "-0" : k;
      }
      function Oo(y, k, tt) {
        var ft = -1, wt = lf, _t = y.length, Pt = !0, Nt = [], zt = Nt;
        if (tt)
          Pt = !1, wt = Yp;
        else if (_t >= s) {
          var ie = k ? null : iR(y);
          if (ie)
            return uf(ie);
          Pt = !1, wt = H0, zt = new Il();
        } else
          zt = k ? [] : Nt;
        t:
          for (; ++ft < _t; ) {
            var ae = y[ft], oe = k ? k(ae) : ae;
            if (ae = tt || ae !== 0 ? ae : 0, Pt && oe === oe) {
              for (var Se = zt.length; Se--; )
                if (zt[Se] === oe)
                  continue t;
              k && zt.push(oe), Nt.push(ae);
            } else wt(zt, oe, tt) || (zt !== Nt && zt.push(oe), Nt.push(ae));
          }
        return Nt;
      }
      function S5(y, k) {
        return k = To(k, y), y = Ry(y, k), y == null || delete y[os(Sa(k))];
      }
      function oy(y, k, tt, ft) {
        return J0(y, k, tt(Rl(y, k)), ft);
      }
      function Ef(y, k, tt, ft) {
        for (var wt = y.length, _t = ft ? wt : -1; (ft ? _t-- : ++_t < wt) && k(y[_t], _t, y); )
          ;
        return tt ? xa(y, ft ? 0 : _t, ft ? _t + 1 : wt) : xa(y, ft ? _t + 1 : 0, ft ? wt : _t);
      }
      function ly(y, k) {
        var tt = y;
        return tt instanceof yn && (tt = tt.value()), Zp(k, function(ft, wt) {
          return wt.func.apply(wt.thisArg, Co([ft], wt.args));
        }, tt);
      }
      function C5(y, k, tt) {
        var ft = y.length;
        if (ft < 2)
          return ft ? Oo(y[0]) : [];
        for (var wt = -1, _t = Qt(ft); ++wt < ft; )
          for (var Pt = y[wt], Nt = -1; ++Nt < ft; )
            Nt != wt && (_t[wt] = K0(_t[wt] || Pt, y[Nt], k, tt));
        return Oo(qr(_t, 1), k, tt);
      }
      function cy(y, k, tt) {
        for (var ft = -1, wt = y.length, _t = k.length, Pt = {}; ++ft < wt; ) {
          var Nt = ft < _t ? k[ft] : r;
          tt(Pt, y[ft], Nt);
        }
        return Pt;
      }
      function A5(y) {
        return fr(y) ? y : [];
      }
      function _5(y) {
        return typeof y == "function" ? y : Di;
      }
      function To(y, k) {
        return tn(y) ? y : R5(y, k) ? [y] : Ny(Mn(y));
      }
      var GF = un;
      function Mo(y, k, tt) {
        var ft = y.length;
        return tt = tt === r ? ft : tt, !k && tt >= ft ? y : xa(y, k, tt);
      }
      var uy = DI || function(y) {
        return $e.clearTimeout(y);
      };
      function hy(y, k) {
        if (k)
          return y.slice();
        var tt = y.length, ft = I8 ? I8(tt) : new y.constructor(tt);
        return y.copy(ft), ft;
      }
      function k5(y) {
        var k = new y.constructor(y.byteLength);
        return new mf(k).set(new mf(y)), k;
      }
      function KF(y, k) {
        var tt = k ? k5(y.buffer) : y.buffer;
        return new y.constructor(tt, y.byteOffset, y.byteLength);
      }
      function YF(y) {
        var k = new y.constructor(y.source, fe.exec(y));
        return k.lastIndex = y.lastIndex, k;
      }
      function ZF(y) {
        return W0 ? Bn(W0.call(y)) : {};
      }
      function fy(y, k) {
        var tt = k ? k5(y.buffer) : y.buffer;
        return new y.constructor(tt, y.byteOffset, y.length);
      }
      function dy(y, k) {
        if (y !== k) {
          var tt = y !== r, ft = y === null, wt = y === y, _t = Yi(y), Pt = k !== r, Nt = k === null, zt = k === k, ie = Yi(k);
          if (!Nt && !ie && !_t && y > k || _t && Pt && zt && !Nt && !ie || ft && Pt && zt || !tt && zt || !wt)
            return 1;
          if (!ft && !_t && !ie && y < k || ie && tt && wt && !ft && !_t || Nt && tt && wt || !Pt && wt || !zt)
            return -1;
        }
        return 0;
      }
      function JF(y, k, tt) {
        for (var ft = -1, wt = y.criteria, _t = k.criteria, Pt = wt.length, Nt = tt.length; ++ft < Pt; ) {
          var zt = dy(wt[ft], _t[ft]);
          if (zt) {
            if (ft >= Nt)
              return zt;
            var ie = tt[ft];
            return zt * (ie == "desc" ? -1 : 1);
          }
        }
        return y.index - k.index;
      }
      function gy(y, k, tt, ft) {
        for (var wt = -1, _t = y.length, Pt = tt.length, Nt = -1, zt = k.length, ie = Tr(_t - Pt, 0), ae = Qt(zt + ie), oe = !ft; ++Nt < zt; )
          ae[Nt] = k[Nt];
        for (; ++wt < Pt; )
          (oe || wt < _t) && (ae[tt[wt]] = y[wt]);
        for (; ie--; )
          ae[Nt++] = y[wt++];
        return ae;
      }
      function py(y, k, tt, ft) {
        for (var wt = -1, _t = y.length, Pt = -1, Nt = tt.length, zt = -1, ie = k.length, ae = Tr(_t - Nt, 0), oe = Qt(ae + ie), Se = !ft; ++wt < ae; )
          oe[wt] = y[wt];
        for (var Ne = wt; ++zt < ie; )
          oe[Ne + zt] = k[zt];
        for (; ++Pt < Nt; )
          (Se || wt < _t) && (oe[Ne + tt[Pt]] = y[wt++]);
        return oe;
      }
      function Ii(y, k) {
        var tt = -1, ft = y.length;
        for (k || (k = Qt(ft)); ++tt < ft; )
          k[tt] = y[tt];
        return k;
      }
      function ss(y, k, tt, ft) {
        var wt = !tt;
        tt || (tt = {});
        for (var _t = -1, Pt = k.length; ++_t < Pt; ) {
          var Nt = k[_t], zt = ft ? ft(tt[Nt], y[Nt], Nt, tt, y) : r;
          zt === r && (zt = y[Nt]), wt ? Ls(tt, Nt, zt) : G0(tt, Nt, zt);
        }
        return tt;
      }
      function QF(y, k) {
        return ss(y, F5(y), k);
      }
      function tR(y, k) {
        return ss(y, Ty(y), k);
      }
      function Pf(y, k) {
        return function(tt, ft) {
          var wt = tn(tt) ? xo : SF, _t = k ? k() : {};
          return wt(tt, y, Xe(ft, 2), _t);
        };
      }
      function su(y) {
        return un(function(k, tt) {
          var ft = -1, wt = tt.length, _t = wt > 1 ? tt[wt - 1] : r, Pt = wt > 2 ? tt[2] : r;
          for (_t = y.length > 3 && typeof _t == "function" ? (wt--, _t) : r, Pt && mi(tt[0], tt[1], Pt) && (_t = wt < 3 ? r : _t, wt = 1), k = Bn(k); ++ft < wt; ) {
            var Nt = tt[ft];
            Nt && y(k, Nt, ft, _t);
          }
          return k;
        });
      }
      function my(y, k) {
        return function(tt, ft) {
          if (tt == null)
            return tt;
          if (!Fi(tt))
            return y(tt, ft);
          for (var wt = tt.length, _t = k ? wt : -1, Pt = Bn(tt); (k ? _t-- : ++_t < wt) && ft(Pt[_t], _t, Pt) !== !1; )
            ;
          return tt;
        };
      }
      function yy(y) {
        return function(k, tt, ft) {
          for (var wt = -1, _t = Bn(k), Pt = ft(k), Nt = Pt.length; Nt--; ) {
            var zt = Pt[y ? Nt : ++wt];
            if (tt(_t[zt], zt, _t) === !1)
              break;
          }
          return k;
        };
      }
      function eR(y, k, tt) {
        var ft = k & b, wt = Q0(y);
        function _t() {
          var Pt = this && this !== $e && this instanceof _t ? wt : y;
          return Pt.apply(ft ? tt : this, arguments);
        }
        return _t;
      }
      function by(y) {
        return function(k) {
          k = Mn(k);
          var tt = Qc(k) ? Va(k) : r, ft = tt ? tt[0] : k.charAt(0), wt = tt ? Mo(tt, 1).join("") : k.slice(1);
          return ft[y]() + wt;
        };
      }
      function ou(y) {
        return function(k) {
          return Zp(mb(pb(k).replace(wo, "")), y, "");
        };
      }
      function Q0(y) {
        return function() {
          var k = arguments;
          switch (k.length) {
            case 0:
              return new y();
            case 1:
              return new y(k[0]);
            case 2:
              return new y(k[0], k[1]);
            case 3:
              return new y(k[0], k[1], k[2]);
            case 4:
              return new y(k[0], k[1], k[2], k[3]);
            case 5:
              return new y(k[0], k[1], k[2], k[3], k[4]);
            case 6:
              return new y(k[0], k[1], k[2], k[3], k[4], k[5]);
            case 7:
              return new y(k[0], k[1], k[2], k[3], k[4], k[5], k[6]);
          }
          var tt = au(y.prototype), ft = y.apply(tt, k);
          return nr(ft) ? ft : tt;
        };
      }
      function nR(y, k, tt) {
        var ft = Q0(y);
        function wt() {
          for (var _t = arguments.length, Pt = Qt(_t), Nt = _t, zt = lu(wt); Nt--; )
            Pt[Nt] = arguments[Nt];
          var ie = _t < 3 && Pt[0] !== zt && Pt[_t - 1] !== zt ? [] : Ao(Pt, zt);
          if (_t -= ie.length, _t < tt)
            return Cy(
              y,
              k,
              If,
              wt.placeholder,
              r,
              Pt,
              ie,
              r,
              r,
              tt - _t
            );
          var ae = this && this !== $e && this instanceof wt ? ft : y;
          return kr(ae, this, Pt);
        }
        return wt;
      }
      function vy(y) {
        return function(k, tt, ft) {
          var wt = Bn(k);
          if (!Fi(k)) {
            var _t = Xe(tt, 3);
            k = Dr(k), tt = function(Nt) {
              return _t(wt[Nt], Nt, wt);
            };
          }
          var Pt = y(k, tt, ft);
          return Pt > -1 ? wt[_t ? k[Pt] : Pt] : r;
        };
      }
      function wy(y) {
        return Bs(function(k) {
          var tt = k.length, ft = tt, wt = va.prototype.thru;
          for (y && k.reverse(); ft--; ) {
            var _t = k[ft];
            if (typeof _t != "function")
              throw new ba(u);
            if (wt && !Pt && $f(_t) == "wrapper")
              var Pt = new va([], !0);
          }
          for (ft = Pt ? ft : tt; ++ft < tt; ) {
            _t = k[ft];
            var Nt = $f(_t), zt = Nt == "wrapper" ? P5(_t) : r;
            zt && D5(zt[0]) && zt[1] == (O | h | _ | E) && !zt[4].length && zt[9] == 1 ? Pt = Pt[$f(zt[0])].apply(Pt, zt[3]) : Pt = _t.length == 1 && D5(_t) ? Pt[Nt]() : Pt.thru(_t);
          }
          return function() {
            var ie = arguments, ae = ie[0];
            if (Pt && ie.length == 1 && tn(ae))
              return Pt.plant(ae).value();
            for (var oe = 0, Se = tt ? k[oe].apply(this, ie) : ae; ++oe < tt; )
              Se = k[oe].call(this, Se);
            return Se;
          };
        });
      }
      function If(y, k, tt, ft, wt, _t, Pt, Nt, zt, ie) {
        var ae = k & O, oe = k & b, Se = k & w, Ne = k & (h | x), qe = k & I, sn = Se ? r : Q0(y);
        function We() {
          for (var pn = arguments.length, vn = Qt(pn), Zi = pn; Zi--; )
            vn[Zi] = arguments[Zi];
          if (Ne)
            var yi = lu(We), Ji = gI(vn, yi);
          if (ft && (vn = gy(vn, ft, wt, Ne)), _t && (vn = py(vn, _t, Pt, Ne)), pn -= Ji, Ne && pn < ie) {
            var dr = Ao(vn, yi);
            return Cy(
              y,
              k,
              If,
              We.placeholder,
              tt,
              vn,
              dr,
              Nt,
              zt,
              ie - pn
            );
          }
          var qa = oe ? tt : this, Vs = Se ? qa[y] : y;
          return pn = vn.length, Nt ? vn = SR(vn, Nt) : qe && pn > 1 && vn.reverse(), ae && zt < pn && (vn.length = zt), this && this !== $e && this instanceof We && (Vs = sn || Q0(Vs)), Vs.apply(qa, vn);
        }
        return We;
      }
      function xy(y, k) {
        return function(tt, ft) {
          return EF(tt, y, k(ft), {});
        };
      }
      function Ff(y, k) {
        return function(tt, ft) {
          var wt;
          if (tt === r && ft === r)
            return k;
          if (tt !== r && (wt = tt), ft !== r) {
            if (wt === r)
              return ft;
            typeof tt == "string" || typeof ft == "string" ? (tt = Ki(tt), ft = Ki(ft)) : (tt = sy(tt), ft = sy(ft)), wt = y(tt, ft);
          }
          return wt;
        };
      }
      function O5(y) {
        return Bs(function(k) {
          return k = Qn(k, Gi(Xe())), un(function(tt) {
            var ft = this;
            return y(k, function(wt) {
              return kr(wt, ft, tt);
            });
          });
        });
      }
      function Rf(y, k) {
        k = k === r ? " " : Ki(k);
        var tt = k.length;
        if (tt < 2)
          return tt ? w5(k, y) : k;
        var ft = w5(k, wf(y / tu(k)));
        return Qc(k) ? Mo(Va(ft), 0, y).join("") : ft.slice(0, y);
      }
      function rR(y, k, tt, ft) {
        var wt = k & b, _t = Q0(y);
        function Pt() {
          for (var Nt = -1, zt = arguments.length, ie = -1, ae = ft.length, oe = Qt(ae + zt), Se = this && this !== $e && this instanceof Pt ? _t : y; ++ie < ae; )
            oe[ie] = ft[ie];
          for (; zt--; )
            oe[ie++] = arguments[++Nt];
          return kr(Se, wt ? tt : this, oe);
        }
        return Pt;
      }
      function Sy(y) {
        return function(k, tt, ft) {
          return ft && typeof ft != "number" && mi(k, tt, ft) && (tt = ft = r), k = Hs(k), tt === r ? (tt = k, k = 0) : tt = Hs(tt), ft = ft === r ? k < tt ? 1 : -1 : Hs(ft), HF(k, tt, ft, y);
        };
      }
      function Df(y) {
        return function(k, tt) {
          return typeof k == "string" && typeof tt == "string" || (k = Ca(k), tt = Ca(tt)), y(k, tt);
        };
      }
      function Cy(y, k, tt, ft, wt, _t, Pt, Nt, zt, ie) {
        var ae = k & h, oe = ae ? Pt : r, Se = ae ? r : Pt, Ne = ae ? _t : r, qe = ae ? r : _t;
        k |= ae ? _ : M, k &= ~(ae ? M : _), k & v || (k &= -4);
        var sn = [
          y,
          k,
          wt,
          Ne,
          oe,
          qe,
          Se,
          Nt,
          zt,
          ie
        ], We = tt.apply(r, sn);
        return D5(y) && Dy(We, sn), We.placeholder = ft, $y(We, y, k);
      }
      function T5(y) {
        var k = Or[y];
        return function(tt, ft) {
          if (tt = Ca(tt), ft = ft == null ? 0 : Jr(nn(ft), 292), ft && $8(tt)) {
            var wt = (Mn(tt) + "e").split("e"), _t = k(wt[0] + "e" + (+wt[1] + ft));
            return wt = (Mn(_t) + "e").split("e"), +(wt[0] + "e" + (+wt[1] - ft));
          }
          return k(tt);
        };
      }
      var iR = ru && 1 / uf(new ru([, -0]))[1] == T ? function(y) {
        return new ru(y);
      } : Y5;
      function Ay(y) {
        return function(k) {
          var tt = Qr(k);
          return tt == yt ? i5(k) : tt == J ? xI(k) : dI(k, y(k));
        };
      }
      function Ns(y, k, tt, ft, wt, _t, Pt, Nt) {
        var zt = k & w;
        if (!zt && typeof y != "function")
          throw new ba(u);
        var ie = ft ? ft.length : 0;
        if (ie || (k &= -97, ft = wt = r), Pt = Pt === r ? Pt : Tr(nn(Pt), 0), Nt = Nt === r ? Nt : nn(Nt), ie -= wt ? wt.length : 0, k & M) {
          var ae = ft, oe = wt;
          ft = wt = r;
        }
        var Se = zt ? r : P5(y), Ne = [
          y,
          k,
          tt,
          ft,
          wt,
          ae,
          oe,
          _t,
          Pt,
          Nt
        ];
        if (Se && vR(Ne, Se), y = Ne[0], k = Ne[1], tt = Ne[2], ft = Ne[3], wt = Ne[4], Nt = Ne[9] = Ne[9] === r ? zt ? 0 : y.length : Tr(Ne[9] - ie, 0), !Nt && k & (h | x) && (k &= -25), !k || k == b)
          var qe = eR(y, k, tt);
        else k == h || k == x ? qe = nR(y, k, Nt) : (k == _ || k == (b | _)) && !wt.length ? qe = rR(y, k, tt, ft) : qe = If.apply(r, Ne);
        var sn = Se ? iy : Dy;
        return $y(sn(qe, Ne), y, k);
      }
      function _y(y, k, tt, ft) {
        return y === r || Xa(y, nu[tt]) && !Rn.call(ft, tt) ? k : y;
      }
      function ky(y, k, tt, ft, wt, _t) {
        return nr(y) && nr(k) && (_t.set(k, y), Tf(y, k, r, ky, _t), _t.delete(k)), y;
      }
      function aR(y) {
        return n1(y) ? r : y;
      }
      function Oy(y, k, tt, ft, wt, _t) {
        var Pt = tt & d, Nt = y.length, zt = k.length;
        if (Nt != zt && !(Pt && zt > Nt))
          return !1;
        var ie = _t.get(y), ae = _t.get(k);
        if (ie && ae)
          return ie == k && ae == y;
        var oe = -1, Se = !0, Ne = tt & m ? new Il() : r;
        for (_t.set(y, k), _t.set(k, y); ++oe < Nt; ) {
          var qe = y[oe], sn = k[oe];
          if (ft)
            var We = Pt ? ft(sn, qe, oe, k, y, _t) : ft(qe, sn, oe, y, k, _t);
          if (We !== r) {
            if (We)
              continue;
            Se = !1;
            break;
          }
          if (Ne) {
            if (!Jp(k, function(pn, vn) {
              if (!H0(Ne, vn) && (qe === pn || wt(qe, pn, tt, ft, _t)))
                return Ne.push(vn);
            })) {
              Se = !1;
              break;
            }
          } else if (!(qe === sn || wt(qe, sn, tt, ft, _t))) {
            Se = !1;
            break;
          }
        }
        return _t.delete(y), _t.delete(k), Se;
      }
      function sR(y, k, tt, ft, wt, _t, Pt) {
        switch (tt) {
          case dt:
            if (y.byteLength != k.byteLength || y.byteOffset != k.byteOffset)
              return !1;
            y = y.buffer, k = k.buffer;
          case gt:
            return !(y.byteLength != k.byteLength || !_t(new mf(y), new mf(k)));
          case V:
          case Y:
          case at:
            return Xa(+y, +k);
          case rt:
            return y.name == k.name && y.message == k.message;
          case et:
          case it:
            return y == k + "";
          case yt:
            var Nt = i5;
          case J:
            var zt = ft & d;
            if (Nt || (Nt = uf), y.size != k.size && !zt)
              return !1;
            var ie = Pt.get(y);
            if (ie)
              return ie == k;
            ft |= m, Pt.set(y, k);
            var ae = Oy(Nt(y), Nt(k), ft, wt, _t, Pt);
            return Pt.delete(y), ae;
          case lt:
            if (W0)
              return W0.call(y) == W0.call(k);
        }
        return !1;
      }
      function oR(y, k, tt, ft, wt, _t) {
        var Pt = tt & d, Nt = M5(y), zt = Nt.length, ie = M5(k), ae = ie.length;
        if (zt != ae && !Pt)
          return !1;
        for (var oe = zt; oe--; ) {
          var Se = Nt[oe];
          if (!(Pt ? Se in k : Rn.call(k, Se)))
            return !1;
        }
        var Ne = _t.get(y), qe = _t.get(k);
        if (Ne && qe)
          return Ne == k && qe == y;
        var sn = !0;
        _t.set(y, k), _t.set(k, y);
        for (var We = Pt; ++oe < zt; ) {
          Se = Nt[oe];
          var pn = y[Se], vn = k[Se];
          if (ft)
            var Zi = Pt ? ft(vn, pn, Se, k, y, _t) : ft(pn, vn, Se, y, k, _t);
          if (!(Zi === r ? pn === vn || wt(pn, vn, tt, ft, _t) : Zi)) {
            sn = !1;
            break;
          }
          We || (We = Se == "constructor");
        }
        if (sn && !We) {
          var yi = y.constructor, Ji = k.constructor;
          yi != Ji && "constructor" in y && "constructor" in k && !(typeof yi == "function" && yi instanceof yi && typeof Ji == "function" && Ji instanceof Ji) && (sn = !1);
        }
        return _t.delete(y), _t.delete(k), sn;
      }
      function Bs(y) {
        return L5(Fy(y, r, Hy), y + "");
      }
      function M5(y) {
        return W8(y, Dr, F5);
      }
      function E5(y) {
        return W8(y, Ri, Ty);
      }
      var P5 = Sf ? function(y) {
        return Sf.get(y);
      } : Y5;
      function $f(y) {
        for (var k = y.name + "", tt = iu[k], ft = Rn.call(iu, k) ? tt.length : 0; ft--; ) {
          var wt = tt[ft], _t = wt.func;
          if (_t == null || _t == y)
            return wt.name;
        }
        return k;
      }
      function lu(y) {
        var k = Rn.call(Ct, "placeholder") ? Ct : y;
        return k.placeholder;
      }
      function Xe() {
        var y = Ct.iteratee || G5;
        return y = y === G5 ? Y8 : y, arguments.length ? y(arguments[0], arguments[1]) : y;
      }
      function Lf(y, k) {
        var tt = y.__data__;
        return pR(k) ? tt[typeof k == "string" ? "string" : "hash"] : tt.map;
      }
      function I5(y) {
        for (var k = Dr(y), tt = k.length; tt--; ) {
          var ft = k[tt], wt = y[ft];
          k[tt] = [ft, wt, Py(wt)];
        }
        return k;
      }
      function Dl(y, k) {
        var tt = bI(y, k);
        return K8(tt) ? tt : r;
      }
      function lR(y) {
        var k = Rn.call(y, El), tt = y[El];
        try {
          y[El] = r;
          var ft = !0;
        } catch {
        }
        var wt = gf.call(y);
        return ft && (k ? y[El] = tt : delete y[El]), wt;
      }
      var F5 = s5 ? function(y) {
        return y == null ? [] : (y = Bn(y), So(s5(y), function(k) {
          return R8.call(y, k);
        }));
      } : Z5, Ty = s5 ? function(y) {
        for (var k = []; y; )
          Co(k, F5(y)), y = yf(y);
        return k;
      } : Z5, Qr = pi;
      (o5 && Qr(new o5(new ArrayBuffer(1))) != dt || z0 && Qr(new z0()) != yt || l5 && Qr(l5.resolve()) != D || ru && Qr(new ru()) != J || X0 && Qr(new X0()) != ut) && (Qr = function(y) {
        var k = pi(y), tt = k == q ? y.constructor : r, ft = tt ? $l(tt) : "";
        if (ft)
          switch (ft) {
            case zI:
              return dt;
            case XI:
              return yt;
            case qI:
              return D;
            case WI:
              return J;
            case GI:
              return ut;
          }
        return k;
      });
      function cR(y, k, tt) {
        for (var ft = -1, wt = tt.length; ++ft < wt; ) {
          var _t = tt[ft], Pt = _t.size;
          switch (_t.type) {
            case "drop":
              y += Pt;
              break;
            case "dropRight":
              k -= Pt;
              break;
            case "take":
              k = Jr(k, y + Pt);
              break;
            case "takeRight":
              y = Tr(y, k - Pt);
              break;
          }
        }
        return { start: y, end: k };
      }
      function uR(y) {
        var k = y.match(Tt);
        return k ? k[1].split(ee) : [];
      }
      function My(y, k, tt) {
        k = To(k, y);
        for (var ft = -1, wt = k.length, _t = !1; ++ft < wt; ) {
          var Pt = os(k[ft]);
          if (!(_t = y != null && tt(y, Pt)))
            break;
          y = y[Pt];
        }
        return _t || ++ft != wt ? _t : (wt = y == null ? 0 : y.length, !!wt && zf(wt) && js(Pt, wt) && (tn(y) || Ll(y)));
      }
      function hR(y) {
        var k = y.length, tt = new y.constructor(k);
        return k && typeof y[0] == "string" && Rn.call(y, "index") && (tt.index = y.index, tt.input = y.input), tt;
      }
      function Ey(y) {
        return typeof y.constructor == "function" && !t1(y) ? au(yf(y)) : {};
      }
      function fR(y, k, tt) {
        var ft = y.constructor;
        switch (k) {
          case gt:
            return k5(y);
          case V:
          case Y:
            return new ft(+y);
          case dt:
            return KF(y, tt);
          case bt:
          case vt:
          case xt:
          case St:
          case Mt:
          case Et:
          case Ft:
          case Wt:
          case Kt:
            return fy(y, tt);
          case yt:
            return new ft();
          case at:
          case it:
            return new ft(y);
          case et:
            return YF(y);
          case J:
            return new ft();
          case lt:
            return ZF(y);
        }
      }
      function dR(y, k) {
        var tt = k.length;
        if (!tt)
          return y;
        var ft = tt - 1;
        return k[ft] = (tt > 1 ? "& " : "") + k[ft], k = k.join(tt > 2 ? ", " : " "), y.replace(Rt, `{
/* [wrapped with ` + k + `] */
`);
      }
      function gR(y) {
        return tn(y) || Ll(y) || !!(D8 && y && y[D8]);
      }
      function js(y, k) {
        var tt = typeof y;
        return k = k ?? F, !!k && (tt == "number" || tt != "symbol" && ge.test(y)) && y > -1 && y % 1 == 0 && y < k;
      }
      function mi(y, k, tt) {
        if (!nr(tt))
          return !1;
        var ft = typeof k;
        return (ft == "number" ? Fi(tt) && js(k, tt.length) : ft == "string" && k in tt) ? Xa(tt[k], y) : !1;
      }
      function R5(y, k) {
        if (tn(y))
          return !1;
        var tt = typeof y;
        return tt == "number" || tt == "symbol" || tt == "boolean" || y == null || Yi(y) ? !0 : Xt.test(y) || !Zt.test(y) || k != null && y in Bn(k);
      }
      function pR(y) {
        var k = typeof y;
        return k == "string" || k == "number" || k == "symbol" || k == "boolean" ? y !== "__proto__" : y === null;
      }
      function D5(y) {
        var k = $f(y), tt = Ct[k];
        if (typeof tt != "function" || !(k in yn.prototype))
          return !1;
        if (y === tt)
          return !0;
        var ft = P5(tt);
        return !!ft && y === ft[0];
      }
      function mR(y) {
        return !!P8 && P8 in y;
      }
      var yR = ff ? Us : J5;
      function t1(y) {
        var k = y && y.constructor, tt = typeof k == "function" && k.prototype || nu;
        return y === tt;
      }
      function Py(y) {
        return y === y && !nr(y);
      }
      function Iy(y, k) {
        return function(tt) {
          return tt == null ? !1 : tt[y] === k && (k !== r || y in Bn(tt));
        };
      }
      function bR(y) {
        var k = Hf(y, function(ft) {
          return tt.size === o && tt.clear(), ft;
        }), tt = k.cache;
        return k;
      }
      function vR(y, k) {
        var tt = y[1], ft = k[1], wt = tt | ft, _t = wt < (b | w | O), Pt = ft == O && tt == h || ft == O && tt == E && y[7].length <= k[8] || ft == (O | E) && k[7].length <= k[8] && tt == h;
        if (!(_t || Pt))
          return y;
        ft & b && (y[2] = k[2], wt |= tt & b ? 0 : v);
        var Nt = k[3];
        if (Nt) {
          var zt = y[3];
          y[3] = zt ? gy(zt, Nt, k[4]) : Nt, y[4] = zt ? Ao(y[3], g) : k[4];
        }
        return Nt = k[5], Nt && (zt = y[5], y[5] = zt ? py(zt, Nt, k[6]) : Nt, y[6] = zt ? Ao(y[5], g) : k[6]), Nt = k[7], Nt && (y[7] = Nt), ft & O && (y[8] = y[8] == null ? k[8] : Jr(y[8], k[8])), y[9] == null && (y[9] = k[9]), y[0] = k[0], y[1] = wt, y;
      }
      function wR(y) {
        var k = [];
        if (y != null)
          for (var tt in Bn(y))
            k.push(tt);
        return k;
      }
      function xR(y) {
        return gf.call(y);
      }
      function Fy(y, k, tt) {
        return k = Tr(k === r ? y.length - 1 : k, 0), function() {
          for (var ft = arguments, wt = -1, _t = Tr(ft.length - k, 0), Pt = Qt(_t); ++wt < _t; )
            Pt[wt] = ft[k + wt];
          wt = -1;
          for (var Nt = Qt(k + 1); ++wt < k; )
            Nt[wt] = ft[wt];
          return Nt[k] = tt(Pt), kr(y, this, Nt);
        };
      }
      function Ry(y, k) {
        return k.length < 2 ? y : Rl(y, xa(k, 0, -1));
      }
      function SR(y, k) {
        for (var tt = y.length, ft = Jr(k.length, tt), wt = Ii(y); ft--; ) {
          var _t = k[ft];
          y[ft] = js(_t, tt) ? wt[_t] : r;
        }
        return y;
      }
      function $5(y, k) {
        if (!(k === "constructor" && typeof y[k] == "function") && k != "__proto__")
          return y[k];
      }
      var Dy = Ly(iy), e1 = LI || function(y, k) {
        return $e.setTimeout(y, k);
      }, L5 = Ly(XF);
      function $y(y, k, tt) {
        var ft = k + "";
        return L5(y, dR(ft, CR(uR(ft), tt)));
      }
      function Ly(y) {
        var k = 0, tt = 0;
        return function() {
          var ft = UI(), wt = j - (ft - tt);
          if (tt = ft, wt > 0) {
            if (++k >= z)
              return arguments[0];
          } else
            k = 0;
          return y.apply(r, arguments);
        };
      }
      function Nf(y, k) {
        var tt = -1, ft = y.length, wt = ft - 1;
        for (k = k === r ? ft : k; ++tt < k; ) {
          var _t = v5(tt, wt), Pt = y[_t];
          y[_t] = y[tt], y[tt] = Pt;
        }
        return y.length = k, y;
      }
      var Ny = bR(function(y) {
        var k = [];
        return y.charCodeAt(0) === 46 && k.push(""), y.replace(Gt, function(tt, ft, wt, _t) {
          k.push(wt ? _t.replace(pe, "$1") : ft || tt);
        }), k;
      });
      function os(y) {
        if (typeof y == "string" || Yi(y))
          return y;
        var k = y + "";
        return k == "0" && 1 / y == -1 / 0 ? "-0" : k;
      }
      function $l(y) {
        if (y != null) {
          try {
            return df.call(y);
          } catch {
          }
          try {
            return y + "";
          } catch {
          }
        }
        return "";
      }
      function CR(y, k) {
        return Pi(L, function(tt) {
          var ft = "_." + tt[0];
          k & tt[1] && !lf(y, ft) && y.push(ft);
        }), y.sort();
      }
      function By(y) {
        if (y instanceof yn)
          return y.clone();
        var k = new va(y.__wrapped__, y.__chain__);
        return k.__actions__ = Ii(y.__actions__), k.__index__ = y.__index__, k.__values__ = y.__values__, k;
      }
      function AR(y, k, tt) {
        (tt ? mi(y, k, tt) : k === r) ? k = 1 : k = Tr(nn(k), 0);
        var ft = y == null ? 0 : y.length;
        if (!ft || k < 1)
          return [];
        for (var wt = 0, _t = 0, Pt = Qt(wf(ft / k)); wt < ft; )
          Pt[_t++] = xa(y, wt, wt += k);
        return Pt;
      }
      function _R(y) {
        for (var k = -1, tt = y == null ? 0 : y.length, ft = 0, wt = []; ++k < tt; ) {
          var _t = y[k];
          _t && (wt[ft++] = _t);
        }
        return wt;
      }
      function kR() {
        var y = arguments.length;
        if (!y)
          return [];
        for (var k = Qt(y - 1), tt = arguments[0], ft = y; ft--; )
          k[ft - 1] = arguments[ft];
        return Co(tn(tt) ? Ii(tt) : [tt], qr(k, 1));
      }
      var OR = un(function(y, k) {
        return fr(y) ? K0(y, qr(k, 1, fr, !0)) : [];
      }), TR = un(function(y, k) {
        var tt = Sa(k);
        return fr(tt) && (tt = r), fr(y) ? K0(y, qr(k, 1, fr, !0), Xe(tt, 2)) : [];
      }), MR = un(function(y, k) {
        var tt = Sa(k);
        return fr(tt) && (tt = r), fr(y) ? K0(y, qr(k, 1, fr, !0), r, tt) : [];
      });
      function ER(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        return ft ? (k = tt || k === r ? 1 : nn(k), xa(y, k < 0 ? 0 : k, ft)) : [];
      }
      function PR(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        return ft ? (k = tt || k === r ? 1 : nn(k), k = ft - k, xa(y, 0, k < 0 ? 0 : k)) : [];
      }
      function IR(y, k) {
        return y && y.length ? Ef(y, Xe(k, 3), !0, !0) : [];
      }
      function FR(y, k) {
        return y && y.length ? Ef(y, Xe(k, 3), !0) : [];
      }
      function RR(y, k, tt, ft) {
        var wt = y == null ? 0 : y.length;
        return wt ? (tt && typeof tt != "number" && mi(y, k, tt) && (tt = 0, ft = wt), kF(y, k, tt, ft)) : [];
      }
      function jy(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        if (!ft)
          return -1;
        var wt = tt == null ? 0 : nn(tt);
        return wt < 0 && (wt = Tr(ft + wt, 0)), cf(y, Xe(k, 3), wt);
      }
      function Uy(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        if (!ft)
          return -1;
        var wt = ft - 1;
        return tt !== r && (wt = nn(tt), wt = tt < 0 ? Tr(ft + wt, 0) : Jr(wt, ft - 1)), cf(y, Xe(k, 3), wt, !0);
      }
      function Hy(y) {
        var k = y == null ? 0 : y.length;
        return k ? qr(y, 1) : [];
      }
      function DR(y) {
        var k = y == null ? 0 : y.length;
        return k ? qr(y, T) : [];
      }
      function $R(y, k) {
        var tt = y == null ? 0 : y.length;
        return tt ? (k = k === r ? 1 : nn(k), qr(y, k)) : [];
      }
      function LR(y) {
        for (var k = -1, tt = y == null ? 0 : y.length, ft = {}; ++k < tt; ) {
          var wt = y[k];
          ft[wt[0]] = wt[1];
        }
        return ft;
      }
      function Vy(y) {
        return y && y.length ? y[0] : r;
      }
      function NR(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        if (!ft)
          return -1;
        var wt = tt == null ? 0 : nn(tt);
        return wt < 0 && (wt = Tr(ft + wt, 0)), Jc(y, k, wt);
      }
      function BR(y) {
        var k = y == null ? 0 : y.length;
        return k ? xa(y, 0, -1) : [];
      }
      var jR = un(function(y) {
        var k = Qn(y, A5);
        return k.length && k[0] === y[0] ? g5(k) : [];
      }), UR = un(function(y) {
        var k = Sa(y), tt = Qn(y, A5);
        return k === Sa(tt) ? k = r : tt.pop(), tt.length && tt[0] === y[0] ? g5(tt, Xe(k, 2)) : [];
      }), HR = un(function(y) {
        var k = Sa(y), tt = Qn(y, A5);
        return k = typeof k == "function" ? k : r, k && tt.pop(), tt.length && tt[0] === y[0] ? g5(tt, r, k) : [];
      });
      function VR(y, k) {
        return y == null ? "" : BI.call(y, k);
      }
      function Sa(y) {
        var k = y == null ? 0 : y.length;
        return k ? y[k - 1] : r;
      }
      function zR(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        if (!ft)
          return -1;
        var wt = ft;
        return tt !== r && (wt = nn(tt), wt = wt < 0 ? Tr(ft + wt, 0) : Jr(wt, ft - 1)), k === k ? CI(y, k, wt) : cf(y, C8, wt, !0);
      }
      function XR(y, k) {
        return y && y.length ? ty(y, nn(k)) : r;
      }
      var qR = un(zy);
      function zy(y, k) {
        return y && y.length && k && k.length ? b5(y, k) : y;
      }
      function WR(y, k, tt) {
        return y && y.length && k && k.length ? b5(y, k, Xe(tt, 2)) : y;
      }
      function GR(y, k, tt) {
        return y && y.length && k && k.length ? b5(y, k, r, tt) : y;
      }
      var KR = Bs(function(y, k) {
        var tt = y == null ? 0 : y.length, ft = u5(y, k);
        return ry(y, Qn(k, function(wt) {
          return js(wt, tt) ? +wt : wt;
        }).sort(dy)), ft;
      });
      function YR(y, k) {
        var tt = [];
        if (!(y && y.length))
          return tt;
        var ft = -1, wt = [], _t = y.length;
        for (k = Xe(k, 3); ++ft < _t; ) {
          var Pt = y[ft];
          k(Pt, ft, y) && (tt.push(Pt), wt.push(ft));
        }
        return ry(y, wt), tt;
      }
      function N5(y) {
        return y == null ? y : VI.call(y);
      }
      function ZR(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        return ft ? (tt && typeof tt != "number" && mi(y, k, tt) ? (k = 0, tt = ft) : (k = k == null ? 0 : nn(k), tt = tt === r ? ft : nn(tt)), xa(y, k, tt)) : [];
      }
      function JR(y, k) {
        return Mf(y, k);
      }
      function QR(y, k, tt) {
        return x5(y, k, Xe(tt, 2));
      }
      function tD(y, k) {
        var tt = y == null ? 0 : y.length;
        if (tt) {
          var ft = Mf(y, k);
          if (ft < tt && Xa(y[ft], k))
            return ft;
        }
        return -1;
      }
      function eD(y, k) {
        return Mf(y, k, !0);
      }
      function nD(y, k, tt) {
        return x5(y, k, Xe(tt, 2), !0);
      }
      function rD(y, k) {
        var tt = y == null ? 0 : y.length;
        if (tt) {
          var ft = Mf(y, k, !0) - 1;
          if (Xa(y[ft], k))
            return ft;
        }
        return -1;
      }
      function iD(y) {
        return y && y.length ? ay(y) : [];
      }
      function aD(y, k) {
        return y && y.length ? ay(y, Xe(k, 2)) : [];
      }
      function sD(y) {
        var k = y == null ? 0 : y.length;
        return k ? xa(y, 1, k) : [];
      }
      function oD(y, k, tt) {
        return y && y.length ? (k = tt || k === r ? 1 : nn(k), xa(y, 0, k < 0 ? 0 : k)) : [];
      }
      function lD(y, k, tt) {
        var ft = y == null ? 0 : y.length;
        return ft ? (k = tt || k === r ? 1 : nn(k), k = ft - k, xa(y, k < 0 ? 0 : k, ft)) : [];
      }
      function cD(y, k) {
        return y && y.length ? Ef(y, Xe(k, 3), !1, !0) : [];
      }
      function uD(y, k) {
        return y && y.length ? Ef(y, Xe(k, 3)) : [];
      }
      var hD = un(function(y) {
        return Oo(qr(y, 1, fr, !0));
      }), fD = un(function(y) {
        var k = Sa(y);
        return fr(k) && (k = r), Oo(qr(y, 1, fr, !0), Xe(k, 2));
      }), dD = un(function(y) {
        var k = Sa(y);
        return k = typeof k == "function" ? k : r, Oo(qr(y, 1, fr, !0), r, k);
      });
      function gD(y) {
        return y && y.length ? Oo(y) : [];
      }
      function pD(y, k) {
        return y && y.length ? Oo(y, Xe(k, 2)) : [];
      }
      function mD(y, k) {
        return k = typeof k == "function" ? k : r, y && y.length ? Oo(y, r, k) : [];
      }
      function B5(y) {
        if (!(y && y.length))
          return [];
        var k = 0;
        return y = So(y, function(tt) {
          if (fr(tt))
            return k = Tr(tt.length, k), !0;
        }), n5(k, function(tt) {
          return Qn(y, Qp(tt));
        });
      }
      function Xy(y, k) {
        if (!(y && y.length))
          return [];
        var tt = B5(y);
        return k == null ? tt : Qn(tt, function(ft) {
          return kr(k, r, ft);
        });
      }
      var yD = un(function(y, k) {
        return fr(y) ? K0(y, k) : [];
      }), bD = un(function(y) {
        return C5(So(y, fr));
      }), vD = un(function(y) {
        var k = Sa(y);
        return fr(k) && (k = r), C5(So(y, fr), Xe(k, 2));
      }), wD = un(function(y) {
        var k = Sa(y);
        return k = typeof k == "function" ? k : r, C5(So(y, fr), r, k);
      }), xD = un(B5);
      function SD(y, k) {
        return cy(y || [], k || [], G0);
      }
      function CD(y, k) {
        return cy(y || [], k || [], J0);
      }
      var AD = un(function(y) {
        var k = y.length, tt = k > 1 ? y[k - 1] : r;
        return tt = typeof tt == "function" ? (y.pop(), tt) : r, Xy(y, tt);
      });
      function qy(y) {
        var k = Ct(y);
        return k.__chain__ = !0, k;
      }
      function _D(y, k) {
        return k(y), y;
      }
      function Bf(y, k) {
        return k(y);
      }
      var kD = Bs(function(y) {
        var k = y.length, tt = k ? y[0] : 0, ft = this.__wrapped__, wt = function(_t) {
          return u5(_t, y);
        };
        return k > 1 || this.__actions__.length || !(ft instanceof yn) || !js(tt) ? this.thru(wt) : (ft = ft.slice(tt, +tt + (k ? 1 : 0)), ft.__actions__.push({
          func: Bf,
          args: [wt],
          thisArg: r
        }), new va(ft, this.__chain__).thru(function(_t) {
          return k && !_t.length && _t.push(r), _t;
        }));
      });
      function OD() {
        return qy(this);
      }
      function TD() {
        return new va(this.value(), this.__chain__);
      }
      function MD() {
        this.__values__ === r && (this.__values__ = sb(this.value()));
        var y = this.__index__ >= this.__values__.length, k = y ? r : this.__values__[this.__index__++];
        return { done: y, value: k };
      }
      function ED() {
        return this;
      }
      function PD(y) {
        for (var k, tt = this; tt instanceof Af; ) {
          var ft = By(tt);
          ft.__index__ = 0, ft.__values__ = r, k ? wt.__wrapped__ = ft : k = ft;
          var wt = ft;
          tt = tt.__wrapped__;
        }
        return wt.__wrapped__ = y, k;
      }
      function ID() {
        var y = this.__wrapped__;
        if (y instanceof yn) {
          var k = y;
          return this.__actions__.length && (k = new yn(this)), k = k.reverse(), k.__actions__.push({
            func: Bf,
            args: [N5],
            thisArg: r
          }), new va(k, this.__chain__);
        }
        return this.thru(N5);
      }
      function FD() {
        return ly(this.__wrapped__, this.__actions__);
      }
      var RD = Pf(function(y, k, tt) {
        Rn.call(y, tt) ? ++y[tt] : Ls(y, tt, 1);
      });
      function DD(y, k, tt) {
        var ft = tn(y) ? x8 : _F;
        return tt && mi(y, k, tt) && (k = r), ft(y, Xe(k, 3));
      }
      function $D(y, k) {
        var tt = tn(y) ? So : X8;
        return tt(y, Xe(k, 3));
      }
      var LD = vy(jy), ND = vy(Uy);
      function BD(y, k) {
        return qr(jf(y, k), 1);
      }
      function jD(y, k) {
        return qr(jf(y, k), T);
      }
      function UD(y, k, tt) {
        return tt = tt === r ? 1 : nn(tt), qr(jf(y, k), tt);
      }
      function Wy(y, k) {
        var tt = tn(y) ? Pi : ko;
        return tt(y, Xe(k, 3));
      }
      function Gy(y, k) {
        var tt = tn(y) ? Zc : z8;
        return tt(y, Xe(k, 3));
      }
      var HD = Pf(function(y, k, tt) {
        Rn.call(y, tt) ? y[tt].push(k) : Ls(y, tt, [k]);
      });
      function VD(y, k, tt, ft) {
        y = Fi(y) ? y : uu(y), tt = tt && !ft ? nn(tt) : 0;
        var wt = y.length;
        return tt < 0 && (tt = Tr(wt + tt, 0)), Xf(y) ? tt <= wt && y.indexOf(k, tt) > -1 : !!wt && Jc(y, k, tt) > -1;
      }
      var zD = un(function(y, k, tt) {
        var ft = -1, wt = typeof k == "function", _t = Fi(y) ? Qt(y.length) : [];
        return ko(y, function(Pt) {
          _t[++ft] = wt ? kr(k, Pt, tt) : Y0(Pt, k, tt);
        }), _t;
      }), XD = Pf(function(y, k, tt) {
        Ls(y, tt, k);
      });
      function jf(y, k) {
        var tt = tn(y) ? Qn : Z8;
        return tt(y, Xe(k, 3));
      }
      function qD(y, k, tt, ft) {
        return y == null ? [] : (tn(k) || (k = k == null ? [] : [k]), tt = ft ? r : tt, tn(tt) || (tt = tt == null ? [] : [tt]), ey(y, k, tt));
      }
      var WD = Pf(function(y, k, tt) {
        y[tt ? 0 : 1].push(k);
      }, function() {
        return [[], []];
      });
      function GD(y, k, tt) {
        var ft = tn(y) ? Zp : _8, wt = arguments.length < 3;
        return ft(y, Xe(k, 4), tt, wt, ko);
      }
      function KD(y, k, tt) {
        var ft = tn(y) ? oI : _8, wt = arguments.length < 3;
        return ft(y, Xe(k, 4), tt, wt, z8);
      }
      function YD(y, k) {
        var tt = tn(y) ? So : X8;
        return tt(y, Vf(Xe(k, 3)));
      }
      function ZD(y) {
        var k = tn(y) ? j8 : VF;
        return k(y);
      }
      function JD(y, k, tt) {
        (tt ? mi(y, k, tt) : k === r) ? k = 1 : k = nn(k);
        var ft = tn(y) ? wF : zF;
        return ft(y, k);
      }
      function QD(y) {
        var k = tn(y) ? xF : qF;
        return k(y);
      }
      function t$(y) {
        if (y == null)
          return 0;
        if (Fi(y))
          return Xf(y) ? tu(y) : y.length;
        var k = Qr(y);
        return k == yt || k == J ? y.size : m5(y).length;
      }
      function e$(y, k, tt) {
        var ft = tn(y) ? Jp : WF;
        return tt && mi(y, k, tt) && (k = r), ft(y, Xe(k, 3));
      }
      var n$ = un(function(y, k) {
        if (y == null)
          return [];
        var tt = k.length;
        return tt > 1 && mi(y, k[0], k[1]) ? k = [] : tt > 2 && mi(k[0], k[1], k[2]) && (k = [k[0]]), ey(y, qr(k, 1), []);
      }), Uf = $I || function() {
        return $e.Date.now();
      };
      function r$(y, k) {
        if (typeof k != "function")
          throw new ba(u);
        return y = nn(y), function() {
          if (--y < 1)
            return k.apply(this, arguments);
        };
      }
      function Ky(y, k, tt) {
        return k = tt ? r : k, k = y && k == null ? y.length : k, Ns(y, O, r, r, r, r, k);
      }
      function Yy(y, k) {
        var tt;
        if (typeof k != "function")
          throw new ba(u);
        return y = nn(y), function() {
          return --y > 0 && (tt = k.apply(this, arguments)), y <= 1 && (k = r), tt;
        };
      }
      var j5 = un(function(y, k, tt) {
        var ft = b;
        if (tt.length) {
          var wt = Ao(tt, lu(j5));
          ft |= _;
        }
        return Ns(y, ft, k, tt, wt);
      }), Zy = un(function(y, k, tt) {
        var ft = b | w;
        if (tt.length) {
          var wt = Ao(tt, lu(Zy));
          ft |= _;
        }
        return Ns(k, ft, y, tt, wt);
      });
      function Jy(y, k, tt) {
        k = tt ? r : k;
        var ft = Ns(y, h, r, r, r, r, r, k);
        return ft.placeholder = Jy.placeholder, ft;
      }
      function Qy(y, k, tt) {
        k = tt ? r : k;
        var ft = Ns(y, x, r, r, r, r, r, k);
        return ft.placeholder = Qy.placeholder, ft;
      }
      function tb(y, k, tt) {
        var ft, wt, _t, Pt, Nt, zt, ie = 0, ae = !1, oe = !1, Se = !0;
        if (typeof y != "function")
          throw new ba(u);
        k = Ca(k) || 0, nr(tt) && (ae = !!tt.leading, oe = "maxWait" in tt, _t = oe ? Tr(Ca(tt.maxWait) || 0, k) : _t, Se = "trailing" in tt ? !!tt.trailing : Se);
        function Ne(dr) {
          var qa = ft, Vs = wt;
          return ft = wt = r, ie = dr, Pt = y.apply(Vs, qa), Pt;
        }
        function qe(dr) {
          return ie = dr, Nt = e1(pn, k), ae ? Ne(dr) : Pt;
        }
        function sn(dr) {
          var qa = dr - zt, Vs = dr - ie, vb = k - qa;
          return oe ? Jr(vb, _t - Vs) : vb;
        }
        function We(dr) {
          var qa = dr - zt, Vs = dr - ie;
          return zt === r || qa >= k || qa < 0 || oe && Vs >= _t;
        }
        function pn() {
          var dr = Uf();
          if (We(dr))
            return vn(dr);
          Nt = e1(pn, sn(dr));
        }
        function vn(dr) {
          return Nt = r, Se && ft ? Ne(dr) : (ft = wt = r, Pt);
        }
        function Zi() {
          Nt !== r && uy(Nt), ie = 0, ft = zt = wt = Nt = r;
        }
        function yi() {
          return Nt === r ? Pt : vn(Uf());
        }
        function Ji() {
          var dr = Uf(), qa = We(dr);
          if (ft = arguments, wt = this, zt = dr, qa) {
            if (Nt === r)
              return qe(zt);
            if (oe)
              return uy(Nt), Nt = e1(pn, k), Ne(zt);
          }
          return Nt === r && (Nt = e1(pn, k)), Pt;
        }
        return Ji.cancel = Zi, Ji.flush = yi, Ji;
      }
      var i$ = un(function(y, k) {
        return V8(y, 1, k);
      }), a$ = un(function(y, k, tt) {
        return V8(y, Ca(k) || 0, tt);
      });
      function s$(y) {
        return Ns(y, I);
      }
      function Hf(y, k) {
        if (typeof y != "function" || k != null && typeof k != "function")
          throw new ba(u);
        var tt = function() {
          var ft = arguments, wt = k ? k.apply(this, ft) : ft[0], _t = tt.cache;
          if (_t.has(wt))
            return _t.get(wt);
          var Pt = y.apply(this, ft);
          return tt.cache = _t.set(wt, Pt) || _t, Pt;
        };
        return tt.cache = new (Hf.Cache || $s)(), tt;
      }
      Hf.Cache = $s;
      function Vf(y) {
        if (typeof y != "function")
          throw new ba(u);
        return function() {
          var k = arguments;
          switch (k.length) {
            case 0:
              return !y.call(this);
            case 1:
              return !y.call(this, k[0]);
            case 2:
              return !y.call(this, k[0], k[1]);
            case 3:
              return !y.call(this, k[0], k[1], k[2]);
          }
          return !y.apply(this, k);
        };
      }
      function o$(y) {
        return Yy(2, y);
      }
      var l$ = GF(function(y, k) {
        k = k.length == 1 && tn(k[0]) ? Qn(k[0], Gi(Xe())) : Qn(qr(k, 1), Gi(Xe()));
        var tt = k.length;
        return un(function(ft) {
          for (var wt = -1, _t = Jr(ft.length, tt); ++wt < _t; )
            ft[wt] = k[wt].call(this, ft[wt]);
          return kr(y, this, ft);
        });
      }), U5 = un(function(y, k) {
        var tt = Ao(k, lu(U5));
        return Ns(y, _, r, k, tt);
      }), eb = un(function(y, k) {
        var tt = Ao(k, lu(eb));
        return Ns(y, M, r, k, tt);
      }), c$ = Bs(function(y, k) {
        return Ns(y, E, r, r, r, k);
      });
      function u$(y, k) {
        if (typeof y != "function")
          throw new ba(u);
        return k = k === r ? k : nn(k), un(y, k);
      }
      function h$(y, k) {
        if (typeof y != "function")
          throw new ba(u);
        return k = k == null ? 0 : Tr(nn(k), 0), un(function(tt) {
          var ft = tt[k], wt = Mo(tt, 0, k);
          return ft && Co(wt, ft), kr(y, this, wt);
        });
      }
      function f$(y, k, tt) {
        var ft = !0, wt = !0;
        if (typeof y != "function")
          throw new ba(u);
        return nr(tt) && (ft = "leading" in tt ? !!tt.leading : ft, wt = "trailing" in tt ? !!tt.trailing : wt), tb(y, k, {
          leading: ft,
          maxWait: k,
          trailing: wt
        });
      }
      function d$(y) {
        return Ky(y, 1);
      }
      function g$(y, k) {
        return U5(_5(k), y);
      }
      function p$() {
        if (!arguments.length)
          return [];
        var y = arguments[0];
        return tn(y) ? y : [y];
      }
      function m$(y) {
        return wa(y, a);
      }
      function y$(y, k) {
        return k = typeof k == "function" ? k : r, wa(y, a, k);
      }
      function b$(y) {
        return wa(y, p | a);
      }
      function v$(y, k) {
        return k = typeof k == "function" ? k : r, wa(y, p | a, k);
      }
      function w$(y, k) {
        return k == null || H8(y, k, Dr(k));
      }
      function Xa(y, k) {
        return y === k || y !== y && k !== k;
      }
      var x$ = Df(d5), S$ = Df(function(y, k) {
        return y >= k;
      }), Ll = G8(/* @__PURE__ */ function() {
        return arguments;
      }()) ? G8 : function(y) {
        return sr(y) && Rn.call(y, "callee") && !R8.call(y, "callee");
      }, tn = Qt.isArray, C$ = Me ? Gi(Me) : PF;
      function Fi(y) {
        return y != null && zf(y.length) && !Us(y);
      }
      function fr(y) {
        return sr(y) && Fi(y);
      }
      function A$(y) {
        return y === !0 || y === !1 || sr(y) && pi(y) == V;
      }
      var Eo = NI || J5, _$ = Ei ? Gi(Ei) : IF;
      function k$(y) {
        return sr(y) && y.nodeType === 1 && !n1(y);
      }
      function O$(y) {
        if (y == null)
          return !0;
        if (Fi(y) && (tn(y) || typeof y == "string" || typeof y.splice == "function" || Eo(y) || cu(y) || Ll(y)))
          return !y.length;
        var k = Qr(y);
        if (k == yt || k == J)
          return !y.size;
        if (t1(y))
          return !m5(y).length;
        for (var tt in y)
          if (Rn.call(y, tt))
            return !1;
        return !0;
      }
      function T$(y, k) {
        return Z0(y, k);
      }
      function M$(y, k, tt) {
        tt = typeof tt == "function" ? tt : r;
        var ft = tt ? tt(y, k) : r;
        return ft === r ? Z0(y, k, r, tt) : !!ft;
      }
      function H5(y) {
        if (!sr(y))
          return !1;
        var k = pi(y);
        return k == rt || k == Z || typeof y.message == "string" && typeof y.name == "string" && !n1(y);
      }
      function E$(y) {
        return typeof y == "number" && $8(y);
      }
      function Us(y) {
        if (!nr(y))
          return !1;
        var k = pi(y);
        return k == st || k == mt || k == N || k == G;
      }
      function nb(y) {
        return typeof y == "number" && y == nn(y);
      }
      function zf(y) {
        return typeof y == "number" && y > -1 && y % 1 == 0 && y <= F;
      }
      function nr(y) {
        var k = typeof y;
        return y != null && (k == "object" || k == "function");
      }
      function sr(y) {
        return y != null && typeof y == "object";
      }
      var rb = gi ? Gi(gi) : RF;
      function P$(y, k) {
        return y === k || p5(y, k, I5(k));
      }
      function I$(y, k, tt) {
        return tt = typeof tt == "function" ? tt : r, p5(y, k, I5(k), tt);
      }
      function F$(y) {
        return ib(y) && y != +y;
      }
      function R$(y) {
        if (yR(y))
          throw new Je(c);
        return K8(y);
      }
      function D$(y) {
        return y === null;
      }
      function $$(y) {
        return y == null;
      }
      function ib(y) {
        return typeof y == "number" || sr(y) && pi(y) == at;
      }
      function n1(y) {
        if (!sr(y) || pi(y) != q)
          return !1;
        var k = yf(y);
        if (k === null)
          return !0;
        var tt = Rn.call(k, "constructor") && k.constructor;
        return typeof tt == "function" && tt instanceof tt && df.call(tt) == II;
      }
      var V5 = Ha ? Gi(Ha) : DF;
      function L$(y) {
        return nb(y) && y >= -9007199254740991 && y <= F;
      }
      var ab = Wi ? Gi(Wi) : $F;
      function Xf(y) {
        return typeof y == "string" || !tn(y) && sr(y) && pi(y) == it;
      }
      function Yi(y) {
        return typeof y == "symbol" || sr(y) && pi(y) == lt;
      }
      var cu = br ? Gi(br) : LF;
      function N$(y) {
        return y === r;
      }
      function B$(y) {
        return sr(y) && Qr(y) == ut;
      }
      function j$(y) {
        return sr(y) && pi(y) == ct;
      }
      var U$ = Df(y5), H$ = Df(function(y, k) {
        return y <= k;
      });
      function sb(y) {
        if (!y)
          return [];
        if (Fi(y))
          return Xf(y) ? Va(y) : Ii(y);
        if (V0 && y[V0])
          return wI(y[V0]());
        var k = Qr(y), tt = k == yt ? i5 : k == J ? uf : uu;
        return tt(y);
      }
      function Hs(y) {
        if (!y)
          return y === 0 ? y : 0;
        if (y = Ca(y), y === T || y === -1 / 0) {
          var k = y < 0 ? -1 : 1;
          return k * S;
        }
        return y === y ? y : 0;
      }
      function nn(y) {
        var k = Hs(y), tt = k % 1;
        return k === k ? tt ? k - tt : k : 0;
      }
      function ob(y) {
        return y ? Fl(nn(y), 0, U) : 0;
      }
      function Ca(y) {
        if (typeof y == "number")
          return y;
        if (Yi(y))
          return A;
        if (nr(y)) {
          var k = typeof y.valueOf == "function" ? y.valueOf() : y;
          y = nr(k) ? k + "" : k;
        }
        if (typeof y != "string")
          return y === 0 ? y : +y;
        y = k8(y);
        var tt = we.test(y);
        return tt || Re.test(y) ? An(y.slice(2), tt ? 2 : 8) : me.test(y) ? A : +y;
      }
      function lb(y) {
        return ss(y, Ri(y));
      }
      function V$(y) {
        return y ? Fl(nn(y), -9007199254740991, F) : y === 0 ? y : 0;
      }
      function Mn(y) {
        return y == null ? "" : Ki(y);
      }
      var z$ = su(function(y, k) {
        if (t1(k) || Fi(k)) {
          ss(k, Dr(k), y);
          return;
        }
        for (var tt in k)
          Rn.call(k, tt) && G0(y, tt, k[tt]);
      }), cb = su(function(y, k) {
        ss(k, Ri(k), y);
      }), qf = su(function(y, k, tt, ft) {
        ss(k, Ri(k), y, ft);
      }), X$ = su(function(y, k, tt, ft) {
        ss(k, Dr(k), y, ft);
      }), q$ = Bs(u5);
      function W$(y, k) {
        var tt = au(y);
        return k == null ? tt : U8(tt, k);
      }
      var G$ = un(function(y, k) {
        y = Bn(y);
        var tt = -1, ft = k.length, wt = ft > 2 ? k[2] : r;
        for (wt && mi(k[0], k[1], wt) && (ft = 1); ++tt < ft; )
          for (var _t = k[tt], Pt = Ri(_t), Nt = -1, zt = Pt.length; ++Nt < zt; ) {
            var ie = Pt[Nt], ae = y[ie];
            (ae === r || Xa(ae, nu[ie]) && !Rn.call(y, ie)) && (y[ie] = _t[ie]);
          }
        return y;
      }), K$ = un(function(y) {
        return y.push(r, ky), kr(ub, r, y);
      });
      function Y$(y, k) {
        return S8(y, Xe(k, 3), as);
      }
      function Z$(y, k) {
        return S8(y, Xe(k, 3), f5);
      }
      function J$(y, k) {
        return y == null ? y : h5(y, Xe(k, 3), Ri);
      }
      function Q$(y, k) {
        return y == null ? y : q8(y, Xe(k, 3), Ri);
      }
      function tL(y, k) {
        return y && as(y, Xe(k, 3));
      }
      function eL(y, k) {
        return y && f5(y, Xe(k, 3));
      }
      function nL(y) {
        return y == null ? [] : Of(y, Dr(y));
      }
      function rL(y) {
        return y == null ? [] : Of(y, Ri(y));
      }
      function z5(y, k, tt) {
        var ft = y == null ? r : Rl(y, k);
        return ft === r ? tt : ft;
      }
      function iL(y, k) {
        return y != null && My(y, k, OF);
      }
      function X5(y, k) {
        return y != null && My(y, k, TF);
      }
      var aL = xy(function(y, k, tt) {
        k != null && typeof k.toString != "function" && (k = gf.call(k)), y[k] = tt;
      }, W5(Di)), sL = xy(function(y, k, tt) {
        k != null && typeof k.toString != "function" && (k = gf.call(k)), Rn.call(y, k) ? y[k].push(tt) : y[k] = [tt];
      }, Xe), oL = un(Y0);
      function Dr(y) {
        return Fi(y) ? B8(y) : m5(y);
      }
      function Ri(y) {
        return Fi(y) ? B8(y, !0) : NF(y);
      }
      function lL(y, k) {
        var tt = {};
        return k = Xe(k, 3), as(y, function(ft, wt, _t) {
          Ls(tt, k(ft, wt, _t), ft);
        }), tt;
      }
      function cL(y, k) {
        var tt = {};
        return k = Xe(k, 3), as(y, function(ft, wt, _t) {
          Ls(tt, wt, k(ft, wt, _t));
        }), tt;
      }
      var uL = su(function(y, k, tt) {
        Tf(y, k, tt);
      }), ub = su(function(y, k, tt, ft) {
        Tf(y, k, tt, ft);
      }), hL = Bs(function(y, k) {
        var tt = {};
        if (y == null)
          return tt;
        var ft = !1;
        k = Qn(k, function(_t) {
          return _t = To(_t, y), ft || (ft = _t.length > 1), _t;
        }), ss(y, E5(y), tt), ft && (tt = wa(tt, p | n | a, aR));
        for (var wt = k.length; wt--; )
          S5(tt, k[wt]);
        return tt;
      });
      function fL(y, k) {
        return hb(y, Vf(Xe(k)));
      }
      var dL = Bs(function(y, k) {
        return y == null ? {} : jF(y, k);
      });
      function hb(y, k) {
        if (y == null)
          return {};
        var tt = Qn(E5(y), function(ft) {
          return [ft];
        });
        return k = Xe(k), ny(y, tt, function(ft, wt) {
          return k(ft, wt[0]);
        });
      }
      function gL(y, k, tt) {
        k = To(k, y);
        var ft = -1, wt = k.length;
        for (wt || (wt = 1, y = r); ++ft < wt; ) {
          var _t = y == null ? r : y[os(k[ft])];
          _t === r && (ft = wt, _t = tt), y = Us(_t) ? _t.call(y) : _t;
        }
        return y;
      }
      function pL(y, k, tt) {
        return y == null ? y : J0(y, k, tt);
      }
      function mL(y, k, tt, ft) {
        return ft = typeof ft == "function" ? ft : r, y == null ? y : J0(y, k, tt, ft);
      }
      var fb = Ay(Dr), db = Ay(Ri);
      function yL(y, k, tt) {
        var ft = tn(y), wt = ft || Eo(y) || cu(y);
        if (k = Xe(k, 4), tt == null) {
          var _t = y && y.constructor;
          wt ? tt = ft ? new _t() : [] : nr(y) ? tt = Us(_t) ? au(yf(y)) : {} : tt = {};
        }
        return (wt ? Pi : as)(y, function(Pt, Nt, zt) {
          return k(tt, Pt, Nt, zt);
        }), tt;
      }
      function bL(y, k) {
        return y == null ? !0 : S5(y, k);
      }
      function vL(y, k, tt) {
        return y == null ? y : oy(y, k, _5(tt));
      }
      function wL(y, k, tt, ft) {
        return ft = typeof ft == "function" ? ft : r, y == null ? y : oy(y, k, _5(tt), ft);
      }
      function uu(y) {
        return y == null ? [] : r5(y, Dr(y));
      }
      function xL(y) {
        return y == null ? [] : r5(y, Ri(y));
      }
      function SL(y, k, tt) {
        return tt === r && (tt = k, k = r), tt !== r && (tt = Ca(tt), tt = tt === tt ? tt : 0), k !== r && (k = Ca(k), k = k === k ? k : 0), Fl(Ca(y), k, tt);
      }
      function CL(y, k, tt) {
        return k = Hs(k), tt === r ? (tt = k, k = 0) : tt = Hs(tt), y = Ca(y), MF(y, k, tt);
      }
      function AL(y, k, tt) {
        if (tt && typeof tt != "boolean" && mi(y, k, tt) && (k = tt = r), tt === r && (typeof k == "boolean" ? (tt = k, k = r) : typeof y == "boolean" && (tt = y, y = r)), y === r && k === r ? (y = 0, k = 1) : (y = Hs(y), k === r ? (k = y, y = 0) : k = Hs(k)), y > k) {
          var ft = y;
          y = k, k = ft;
        }
        if (tt || y % 1 || k % 1) {
          var wt = L8();
          return Jr(y + wt * (k - y + xn("1e-" + ((wt + "").length - 1))), k);
        }
        return v5(y, k);
      }
      var _L = ou(function(y, k, tt) {
        return k = k.toLowerCase(), y + (tt ? gb(k) : k);
      });
      function gb(y) {
        return q5(Mn(y).toLowerCase());
      }
      function pb(y) {
        return y = Mn(y), y && y.replace(se, pI).replace(U0, "");
      }
      function kL(y, k, tt) {
        y = Mn(y), k = Ki(k);
        var ft = y.length;
        tt = tt === r ? ft : Fl(nn(tt), 0, ft);
        var wt = tt;
        return tt -= k.length, tt >= 0 && y.slice(tt, wt) == k;
      }
      function OL(y) {
        return y = Mn(y), y && xe.test(y) ? y.replace(Ce, mI) : y;
      }
      function TL(y) {
        return y = Mn(y), y && Dt.test(y) ? y.replace(Lt, "\\$&") : y;
      }
      var ML = ou(function(y, k, tt) {
        return y + (tt ? "-" : "") + k.toLowerCase();
      }), EL = ou(function(y, k, tt) {
        return y + (tt ? " " : "") + k.toLowerCase();
      }), PL = by("toLowerCase");
      function IL(y, k, tt) {
        y = Mn(y), k = nn(k);
        var ft = k ? tu(y) : 0;
        if (!k || ft >= k)
          return y;
        var wt = (k - ft) / 2;
        return Rf(xf(wt), tt) + y + Rf(wf(wt), tt);
      }
      function FL(y, k, tt) {
        y = Mn(y), k = nn(k);
        var ft = k ? tu(y) : 0;
        return k && ft < k ? y + Rf(k - ft, tt) : y;
      }
      function RL(y, k, tt) {
        y = Mn(y), k = nn(k);
        var ft = k ? tu(y) : 0;
        return k && ft < k ? Rf(k - ft, tt) + y : y;
      }
      function DL(y, k, tt) {
        return tt || k == null ? k = 0 : k && (k = +k), HI(Mn(y).replace(jt, ""), k || 0);
      }
      function $L(y, k, tt) {
        return (tt ? mi(y, k, tt) : k === r) ? k = 1 : k = nn(k), w5(Mn(y), k);
      }
      function LL() {
        var y = arguments, k = Mn(y[0]);
        return y.length < 3 ? k : k.replace(y[1], y[2]);
      }
      var NL = ou(function(y, k, tt) {
        return y + (tt ? "_" : "") + k.toLowerCase();
      });
      function BL(y, k, tt) {
        return tt && typeof tt != "number" && mi(y, k, tt) && (k = tt = r), tt = tt === r ? U : tt >>> 0, tt ? (y = Mn(y), y && (typeof k == "string" || k != null && !V5(k)) && (k = Ki(k), !k && Qc(y)) ? Mo(Va(y), 0, tt) : y.split(k, tt)) : [];
      }
      var jL = ou(function(y, k, tt) {
        return y + (tt ? " " : "") + q5(k);
      });
      function UL(y, k, tt) {
        return y = Mn(y), tt = tt == null ? 0 : Fl(nn(tt), 0, y.length), k = Ki(k), y.slice(tt, tt + k.length) == k;
      }
      function HL(y, k, tt) {
        var ft = Ct.templateSettings;
        tt && mi(y, k, tt) && (k = r), y = Mn(y), k = qf({}, k, ft, _y);
        var wt = qf({}, k.imports, ft.imports, _y), _t = Dr(wt), Pt = r5(wt, _t), Nt, zt, ie = 0, ae = k.interpolate || ue, oe = "__p += '", Se = a5(
          (k.escape || ue).source + "|" + ae.source + "|" + (ae === He ? ye : ue).source + "|" + (k.evaluate || ue).source + "|$",
          "g"
        ), Ne = "//# sourceURL=" + (Rn.call(k, "sourceURL") ? (k.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++kt + "]") + `
`;
        y.replace(Se, function(We, pn, vn, Zi, yi, Ji) {
          return vn || (vn = Zi), oe += y.slice(ie, Ji).replace(Ae, yI), pn && (Nt = !0, oe += `' +
__e(` + pn + `) +
'`), yi && (zt = !0, oe += `';
` + yi + `;
__p += '`), vn && (oe += `' +
((__t = (` + vn + `)) == null ? '' : __t) +
'`), ie = Ji + We.length, We;
        }), oe += `';
`;
        var qe = Rn.call(k, "variable") && k.variable;
        if (!qe)
          oe = `with (obj) {
` + oe + `
}
`;
        else if (Jt.test(qe))
          throw new Je(l);
        oe = (zt ? oe.replace(qt, "") : oe).replace(It, "$1").replace(re, "$1;"), oe = "function(" + (qe || "obj") + `) {
` + (qe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Nt ? ", __e = _.escape" : "") + (zt ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + oe + `return __p
}`;
        var sn = yb(function() {
          return On(_t, Ne + "return " + oe).apply(r, Pt);
        });
        if (sn.source = oe, H5(sn))
          throw sn;
        return sn;
      }
      function VL(y) {
        return Mn(y).toLowerCase();
      }
      function zL(y) {
        return Mn(y).toUpperCase();
      }
      function XL(y, k, tt) {
        if (y = Mn(y), y && (tt || k === r))
          return k8(y);
        if (!y || !(k = Ki(k)))
          return y;
        var ft = Va(y), wt = Va(k), _t = O8(ft, wt), Pt = T8(ft, wt) + 1;
        return Mo(ft, _t, Pt).join("");
      }
      function qL(y, k, tt) {
        if (y = Mn(y), y && (tt || k === r))
          return y.slice(0, E8(y) + 1);
        if (!y || !(k = Ki(k)))
          return y;
        var ft = Va(y), wt = T8(ft, Va(k)) + 1;
        return Mo(ft, 0, wt).join("");
      }
      function WL(y, k, tt) {
        if (y = Mn(y), y && (tt || k === r))
          return y.replace(jt, "");
        if (!y || !(k = Ki(k)))
          return y;
        var ft = Va(y), wt = O8(ft, Va(k));
        return Mo(ft, wt).join("");
      }
      function GL(y, k) {
        var tt = R, ft = W;
        if (nr(k)) {
          var wt = "separator" in k ? k.separator : wt;
          tt = "length" in k ? nn(k.length) : tt, ft = "omission" in k ? Ki(k.omission) : ft;
        }
        y = Mn(y);
        var _t = y.length;
        if (Qc(y)) {
          var Pt = Va(y);
          _t = Pt.length;
        }
        if (tt >= _t)
          return y;
        var Nt = tt - tu(ft);
        if (Nt < 1)
          return ft;
        var zt = Pt ? Mo(Pt, 0, Nt).join("") : y.slice(0, Nt);
        if (wt === r)
          return zt + ft;
        if (Pt && (Nt += zt.length - Nt), V5(wt)) {
          if (y.slice(Nt).search(wt)) {
            var ie, ae = zt;
            for (wt.global || (wt = a5(wt.source, Mn(fe.exec(wt)) + "g")), wt.lastIndex = 0; ie = wt.exec(ae); )
              var oe = ie.index;
            zt = zt.slice(0, oe === r ? Nt : oe);
          }
        } else if (y.indexOf(Ki(wt), Nt) != Nt) {
          var Se = zt.lastIndexOf(wt);
          Se > -1 && (zt = zt.slice(0, Se));
        }
        return zt + ft;
      }
      function KL(y) {
        return y = Mn(y), y && ce.test(y) ? y.replace(le, AI) : y;
      }
      var YL = ou(function(y, k, tt) {
        return y + (tt ? " " : "") + k.toUpperCase();
      }), q5 = by("toUpperCase");
      function mb(y, k, tt) {
        return y = Mn(y), k = tt ? r : k, k === r ? vI(y) ? OI(y) : uI(y) : y.match(k) || [];
      }
      var yb = un(function(y, k) {
        try {
          return kr(y, r, k);
        } catch (tt) {
          return H5(tt) ? tt : new Je(tt);
        }
      }), ZL = Bs(function(y, k) {
        return Pi(k, function(tt) {
          tt = os(tt), Ls(y, tt, j5(y[tt], y));
        }), y;
      });
      function JL(y) {
        var k = y == null ? 0 : y.length, tt = Xe();
        return y = k ? Qn(y, function(ft) {
          if (typeof ft[1] != "function")
            throw new ba(u);
          return [tt(ft[0]), ft[1]];
        }) : [], un(function(ft) {
          for (var wt = -1; ++wt < k; ) {
            var _t = y[wt];
            if (kr(_t[0], this, ft))
              return kr(_t[1], this, ft);
          }
        });
      }
      function QL(y) {
        return AF(wa(y, p));
      }
      function W5(y) {
        return function() {
          return y;
        };
      }
      function tN(y, k) {
        return y == null || y !== y ? k : y;
      }
      var eN = wy(), nN = wy(!0);
      function Di(y) {
        return y;
      }
      function G5(y) {
        return Y8(typeof y == "function" ? y : wa(y, p));
      }
      function rN(y) {
        return J8(wa(y, p));
      }
      function iN(y, k) {
        return Q8(y, wa(k, p));
      }
      var aN = un(function(y, k) {
        return function(tt) {
          return Y0(tt, y, k);
        };
      }), sN = un(function(y, k) {
        return function(tt) {
          return Y0(y, tt, k);
        };
      });
      function K5(y, k, tt) {
        var ft = Dr(k), wt = Of(k, ft);
        tt == null && !(nr(k) && (wt.length || !ft.length)) && (tt = k, k = y, y = this, wt = Of(k, Dr(k)));
        var _t = !(nr(tt) && "chain" in tt) || !!tt.chain, Pt = Us(y);
        return Pi(wt, function(Nt) {
          var zt = k[Nt];
          y[Nt] = zt, Pt && (y.prototype[Nt] = function() {
            var ie = this.__chain__;
            if (_t || ie) {
              var ae = y(this.__wrapped__), oe = ae.__actions__ = Ii(this.__actions__);
              return oe.push({ func: zt, args: arguments, thisArg: y }), ae.__chain__ = ie, ae;
            }
            return zt.apply(y, Co([this.value()], arguments));
          });
        }), y;
      }
      function oN() {
        return $e._ === this && ($e._ = FI), this;
      }
      function Y5() {
      }
      function lN(y) {
        return y = nn(y), un(function(k) {
          return ty(k, y);
        });
      }
      var cN = O5(Qn), uN = O5(x8), hN = O5(Jp);
      function bb(y) {
        return R5(y) ? Qp(os(y)) : UF(y);
      }
      function fN(y) {
        return function(k) {
          return y == null ? r : Rl(y, k);
        };
      }
      var dN = Sy(), gN = Sy(!0);
      function Z5() {
        return [];
      }
      function J5() {
        return !1;
      }
      function pN() {
        return {};
      }
      function mN() {
        return "";
      }
      function yN() {
        return !0;
      }
      function bN(y, k) {
        if (y = nn(y), y < 1 || y > F)
          return [];
        var tt = U, ft = Jr(y, U);
        k = Xe(k), y -= U;
        for (var wt = n5(ft, k); ++tt < y; )
          k(tt);
        return wt;
      }
      function vN(y) {
        return tn(y) ? Qn(y, os) : Yi(y) ? [y] : Ii(Ny(Mn(y)));
      }
      function wN(y) {
        var k = ++PI;
        return Mn(y) + k;
      }
      var xN = Ff(function(y, k) {
        return y + k;
      }, 0), SN = T5("ceil"), CN = Ff(function(y, k) {
        return y / k;
      }, 1), AN = T5("floor");
      function _N(y) {
        return y && y.length ? kf(y, Di, d5) : r;
      }
      function kN(y, k) {
        return y && y.length ? kf(y, Xe(k, 2), d5) : r;
      }
      function ON(y) {
        return A8(y, Di);
      }
      function TN(y, k) {
        return A8(y, Xe(k, 2));
      }
      function MN(y) {
        return y && y.length ? kf(y, Di, y5) : r;
      }
      function EN(y, k) {
        return y && y.length ? kf(y, Xe(k, 2), y5) : r;
      }
      var PN = Ff(function(y, k) {
        return y * k;
      }, 1), IN = T5("round"), FN = Ff(function(y, k) {
        return y - k;
      }, 0);
      function RN(y) {
        return y && y.length ? e5(y, Di) : 0;
      }
      function DN(y, k) {
        return y && y.length ? e5(y, Xe(k, 2)) : 0;
      }
      return Ct.after = r$, Ct.ary = Ky, Ct.assign = z$, Ct.assignIn = cb, Ct.assignInWith = qf, Ct.assignWith = X$, Ct.at = q$, Ct.before = Yy, Ct.bind = j5, Ct.bindAll = ZL, Ct.bindKey = Zy, Ct.castArray = p$, Ct.chain = qy, Ct.chunk = AR, Ct.compact = _R, Ct.concat = kR, Ct.cond = JL, Ct.conforms = QL, Ct.constant = W5, Ct.countBy = RD, Ct.create = W$, Ct.curry = Jy, Ct.curryRight = Qy, Ct.debounce = tb, Ct.defaults = G$, Ct.defaultsDeep = K$, Ct.defer = i$, Ct.delay = a$, Ct.difference = OR, Ct.differenceBy = TR, Ct.differenceWith = MR, Ct.drop = ER, Ct.dropRight = PR, Ct.dropRightWhile = IR, Ct.dropWhile = FR, Ct.fill = RR, Ct.filter = $D, Ct.flatMap = BD, Ct.flatMapDeep = jD, Ct.flatMapDepth = UD, Ct.flatten = Hy, Ct.flattenDeep = DR, Ct.flattenDepth = $R, Ct.flip = s$, Ct.flow = eN, Ct.flowRight = nN, Ct.fromPairs = LR, Ct.functions = nL, Ct.functionsIn = rL, Ct.groupBy = HD, Ct.initial = BR, Ct.intersection = jR, Ct.intersectionBy = UR, Ct.intersectionWith = HR, Ct.invert = aL, Ct.invertBy = sL, Ct.invokeMap = zD, Ct.iteratee = G5, Ct.keyBy = XD, Ct.keys = Dr, Ct.keysIn = Ri, Ct.map = jf, Ct.mapKeys = lL, Ct.mapValues = cL, Ct.matches = rN, Ct.matchesProperty = iN, Ct.memoize = Hf, Ct.merge = uL, Ct.mergeWith = ub, Ct.method = aN, Ct.methodOf = sN, Ct.mixin = K5, Ct.negate = Vf, Ct.nthArg = lN, Ct.omit = hL, Ct.omitBy = fL, Ct.once = o$, Ct.orderBy = qD, Ct.over = cN, Ct.overArgs = l$, Ct.overEvery = uN, Ct.overSome = hN, Ct.partial = U5, Ct.partialRight = eb, Ct.partition = WD, Ct.pick = dL, Ct.pickBy = hb, Ct.property = bb, Ct.propertyOf = fN, Ct.pull = qR, Ct.pullAll = zy, Ct.pullAllBy = WR, Ct.pullAllWith = GR, Ct.pullAt = KR, Ct.range = dN, Ct.rangeRight = gN, Ct.rearg = c$, Ct.reject = YD, Ct.remove = YR, Ct.rest = u$, Ct.reverse = N5, Ct.sampleSize = JD, Ct.set = pL, Ct.setWith = mL, Ct.shuffle = QD, Ct.slice = ZR, Ct.sortBy = n$, Ct.sortedUniq = iD, Ct.sortedUniqBy = aD, Ct.split = BL, Ct.spread = h$, Ct.tail = sD, Ct.take = oD, Ct.takeRight = lD, Ct.takeRightWhile = cD, Ct.takeWhile = uD, Ct.tap = _D, Ct.throttle = f$, Ct.thru = Bf, Ct.toArray = sb, Ct.toPairs = fb, Ct.toPairsIn = db, Ct.toPath = vN, Ct.toPlainObject = lb, Ct.transform = yL, Ct.unary = d$, Ct.union = hD, Ct.unionBy = fD, Ct.unionWith = dD, Ct.uniq = gD, Ct.uniqBy = pD, Ct.uniqWith = mD, Ct.unset = bL, Ct.unzip = B5, Ct.unzipWith = Xy, Ct.update = vL, Ct.updateWith = wL, Ct.values = uu, Ct.valuesIn = xL, Ct.without = yD, Ct.words = mb, Ct.wrap = g$, Ct.xor = bD, Ct.xorBy = vD, Ct.xorWith = wD, Ct.zip = xD, Ct.zipObject = SD, Ct.zipObjectDeep = CD, Ct.zipWith = AD, Ct.entries = fb, Ct.entriesIn = db, Ct.extend = cb, Ct.extendWith = qf, K5(Ct, Ct), Ct.add = xN, Ct.attempt = yb, Ct.camelCase = _L, Ct.capitalize = gb, Ct.ceil = SN, Ct.clamp = SL, Ct.clone = m$, Ct.cloneDeep = b$, Ct.cloneDeepWith = v$, Ct.cloneWith = y$, Ct.conformsTo = w$, Ct.deburr = pb, Ct.defaultTo = tN, Ct.divide = CN, Ct.endsWith = kL, Ct.eq = Xa, Ct.escape = OL, Ct.escapeRegExp = TL, Ct.every = DD, Ct.find = LD, Ct.findIndex = jy, Ct.findKey = Y$, Ct.findLast = ND, Ct.findLastIndex = Uy, Ct.findLastKey = Z$, Ct.floor = AN, Ct.forEach = Wy, Ct.forEachRight = Gy, Ct.forIn = J$, Ct.forInRight = Q$, Ct.forOwn = tL, Ct.forOwnRight = eL, Ct.get = z5, Ct.gt = x$, Ct.gte = S$, Ct.has = iL, Ct.hasIn = X5, Ct.head = Vy, Ct.identity = Di, Ct.includes = VD, Ct.indexOf = NR, Ct.inRange = CL, Ct.invoke = oL, Ct.isArguments = Ll, Ct.isArray = tn, Ct.isArrayBuffer = C$, Ct.isArrayLike = Fi, Ct.isArrayLikeObject = fr, Ct.isBoolean = A$, Ct.isBuffer = Eo, Ct.isDate = _$, Ct.isElement = k$, Ct.isEmpty = O$, Ct.isEqual = T$, Ct.isEqualWith = M$, Ct.isError = H5, Ct.isFinite = E$, Ct.isFunction = Us, Ct.isInteger = nb, Ct.isLength = zf, Ct.isMap = rb, Ct.isMatch = P$, Ct.isMatchWith = I$, Ct.isNaN = F$, Ct.isNative = R$, Ct.isNil = $$, Ct.isNull = D$, Ct.isNumber = ib, Ct.isObject = nr, Ct.isObjectLike = sr, Ct.isPlainObject = n1, Ct.isRegExp = V5, Ct.isSafeInteger = L$, Ct.isSet = ab, Ct.isString = Xf, Ct.isSymbol = Yi, Ct.isTypedArray = cu, Ct.isUndefined = N$, Ct.isWeakMap = B$, Ct.isWeakSet = j$, Ct.join = VR, Ct.kebabCase = ML, Ct.last = Sa, Ct.lastIndexOf = zR, Ct.lowerCase = EL, Ct.lowerFirst = PL, Ct.lt = U$, Ct.lte = H$, Ct.max = _N, Ct.maxBy = kN, Ct.mean = ON, Ct.meanBy = TN, Ct.min = MN, Ct.minBy = EN, Ct.stubArray = Z5, Ct.stubFalse = J5, Ct.stubObject = pN, Ct.stubString = mN, Ct.stubTrue = yN, Ct.multiply = PN, Ct.nth = XR, Ct.noConflict = oN, Ct.noop = Y5, Ct.now = Uf, Ct.pad = IL, Ct.padEnd = FL, Ct.padStart = RL, Ct.parseInt = DL, Ct.random = AL, Ct.reduce = GD, Ct.reduceRight = KD, Ct.repeat = $L, Ct.replace = LL, Ct.result = gL, Ct.round = IN, Ct.runInContext = Ut, Ct.sample = ZD, Ct.size = t$, Ct.snakeCase = NL, Ct.some = e$, Ct.sortedIndex = JR, Ct.sortedIndexBy = QR, Ct.sortedIndexOf = tD, Ct.sortedLastIndex = eD, Ct.sortedLastIndexBy = nD, Ct.sortedLastIndexOf = rD, Ct.startCase = jL, Ct.startsWith = UL, Ct.subtract = FN, Ct.sum = RN, Ct.sumBy = DN, Ct.template = HL, Ct.times = bN, Ct.toFinite = Hs, Ct.toInteger = nn, Ct.toLength = ob, Ct.toLower = VL, Ct.toNumber = Ca, Ct.toSafeInteger = V$, Ct.toString = Mn, Ct.toUpper = zL, Ct.trim = XL, Ct.trimEnd = qL, Ct.trimStart = WL, Ct.truncate = GL, Ct.unescape = KL, Ct.uniqueId = wN, Ct.upperCase = YL, Ct.upperFirst = q5, Ct.each = Wy, Ct.eachRight = Gy, Ct.first = Vy, K5(Ct, function() {
        var y = {};
        return as(Ct, function(k, tt) {
          Rn.call(Ct.prototype, tt) || (y[tt] = k);
        }), y;
      }(), { chain: !1 }), Ct.VERSION = i, Pi(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(y) {
        Ct[y].placeholder = Ct;
      }), Pi(["drop", "take"], function(y, k) {
        yn.prototype[y] = function(tt) {
          tt = tt === r ? 1 : Tr(nn(tt), 0);
          var ft = this.__filtered__ && !k ? new yn(this) : this.clone();
          return ft.__filtered__ ? ft.__takeCount__ = Jr(tt, ft.__takeCount__) : ft.__views__.push({
            size: Jr(tt, U),
            type: y + (ft.__dir__ < 0 ? "Right" : "")
          }), ft;
        }, yn.prototype[y + "Right"] = function(tt) {
          return this.reverse()[y](tt).reverse();
        };
      }), Pi(["filter", "map", "takeWhile"], function(y, k) {
        var tt = k + 1, ft = tt == $ || tt == C;
        yn.prototype[y] = function(wt) {
          var _t = this.clone();
          return _t.__iteratees__.push({
            iteratee: Xe(wt, 3),
            type: tt
          }), _t.__filtered__ = _t.__filtered__ || ft, _t;
        };
      }), Pi(["head", "last"], function(y, k) {
        var tt = "take" + (k ? "Right" : "");
        yn.prototype[y] = function() {
          return this[tt](1).value()[0];
        };
      }), Pi(["initial", "tail"], function(y, k) {
        var tt = "drop" + (k ? "" : "Right");
        yn.prototype[y] = function() {
          return this.__filtered__ ? new yn(this) : this[tt](1);
        };
      }), yn.prototype.compact = function() {
        return this.filter(Di);
      }, yn.prototype.find = function(y) {
        return this.filter(y).head();
      }, yn.prototype.findLast = function(y) {
        return this.reverse().find(y);
      }, yn.prototype.invokeMap = un(function(y, k) {
        return typeof y == "function" ? new yn(this) : this.map(function(tt) {
          return Y0(tt, y, k);
        });
      }), yn.prototype.reject = function(y) {
        return this.filter(Vf(Xe(y)));
      }, yn.prototype.slice = function(y, k) {
        y = nn(y);
        var tt = this;
        return tt.__filtered__ && (y > 0 || k < 0) ? new yn(tt) : (y < 0 ? tt = tt.takeRight(-y) : y && (tt = tt.drop(y)), k !== r && (k = nn(k), tt = k < 0 ? tt.dropRight(-k) : tt.take(k - y)), tt);
      }, yn.prototype.takeRightWhile = function(y) {
        return this.reverse().takeWhile(y).reverse();
      }, yn.prototype.toArray = function() {
        return this.take(U);
      }, as(yn.prototype, function(y, k) {
        var tt = /^(?:filter|find|map|reject)|While$/.test(k), ft = /^(?:head|last)$/.test(k), wt = Ct[ft ? "take" + (k == "last" ? "Right" : "") : k], _t = ft || /^find/.test(k);
        wt && (Ct.prototype[k] = function() {
          var Pt = this.__wrapped__, Nt = ft ? [1] : arguments, zt = Pt instanceof yn, ie = Nt[0], ae = zt || tn(Pt), oe = function(pn) {
            var vn = wt.apply(Ct, Co([pn], Nt));
            return ft && Se ? vn[0] : vn;
          };
          ae && tt && typeof ie == "function" && ie.length != 1 && (zt = ae = !1);
          var Se = this.__chain__, Ne = !!this.__actions__.length, qe = _t && !Se, sn = zt && !Ne;
          if (!_t && ae) {
            Pt = sn ? Pt : new yn(this);
            var We = y.apply(Pt, Nt);
            return We.__actions__.push({ func: Bf, args: [oe], thisArg: r }), new va(We, Se);
          }
          return qe && sn ? y.apply(this, Nt) : (We = this.thru(oe), qe ? ft ? We.value()[0] : We.value() : We);
        });
      }), Pi(["pop", "push", "shift", "sort", "splice", "unshift"], function(y) {
        var k = hf[y], tt = /^(?:push|sort|unshift)$/.test(y) ? "tap" : "thru", ft = /^(?:pop|shift)$/.test(y);
        Ct.prototype[y] = function() {
          var wt = arguments;
          if (ft && !this.__chain__) {
            var _t = this.value();
            return k.apply(tn(_t) ? _t : [], wt);
          }
          return this[tt](function(Pt) {
            return k.apply(tn(Pt) ? Pt : [], wt);
          });
        };
      }), as(yn.prototype, function(y, k) {
        var tt = Ct[k];
        if (tt) {
          var ft = tt.name + "";
          Rn.call(iu, ft) || (iu[ft] = []), iu[ft].push({ name: k, func: tt });
        }
      }), iu[If(r, w).name] = [{
        name: "wrapper",
        func: r
      }], yn.prototype.clone = KI, yn.prototype.reverse = YI, yn.prototype.value = ZI, Ct.prototype.at = kD, Ct.prototype.chain = OD, Ct.prototype.commit = TD, Ct.prototype.next = MD, Ct.prototype.plant = PD, Ct.prototype.reverse = ID, Ct.prototype.toJSON = Ct.prototype.valueOf = Ct.prototype.value = FD, Ct.prototype.first = Ct.prototype.head, V0 && (Ct.prototype[V0] = ED), Ct;
    }, eu = TI();
    fn ? ((fn.exports = eu)._ = eu, yr._ = eu) : $e._ = eu;
  }).call(ds);
})(Eg, Eg.exports);
var KE = Eg.exports;
const j5t = /* @__PURE__ */ Dn(KE), U5t = (t, e) => {
  const [r, i] = cn({
    order: "asc",
    sortBy: null
  }), s = en(() => r.sortBy ? j5t.orderBy(
    t,
    [
      (u) => {
        const l = e.find((o) => o.key === r.sortBy);
        if (typeof (l == null ? void 0 : l.sorting) == "function") {
          const o = l == null ? void 0 : l.sorting(u);
          return typeof o == "string" ? o.toLowerCase() : o;
        }
        const f = l == null ? void 0 : l.render(u);
        return typeof f == "string" ? f.toLowerCase() : f;
      }
    ],
    r.order
  ) : t, [e, r.order, r.sortBy, t]);
  return {
    currentSort: r,
    sortedData: s,
    handleSort: (u) => {
      r.sortBy === u.key ? i((l) => ({ ...l, order: l.order === "asc" ? "desc" : "asc" })) : i({ order: "asc", sortBy: u.key });
    }
  };
}, H5t = ({ columns: t, onClickSort: e, currentSort: r }) => {
  const i = (s) => r.sortBy === s.key && r.order === "asc" ? {
    icon: "arrow-up",
    ariaSort: "ascending"
  } : r.sortBy === s.key && r.order === "desc" ? {
    icon: "arrow-down",
    ariaSort: "descending"
  } : {
    icon: "swap-vert",
    ariaSort: "none"
  };
  return /* @__PURE__ */ $t(Ra, { children: t.map((s, c) => /* @__PURE__ */ Ve(
    "div",
    {
      className: Ke("grid justify-stretch border-b-[1px] border-b-[#00000010] bg-white text-xs font-regular", {
        "justify-items-start px-5 py-2 text-start md:px-6": !s.sorting,
        "justify-items-center text-center": !s.sorting && s.justify === "center",
        "justify-items-end text-end": !s.sorting && s.justify === "end"
      }),
      role: "columnheader",
      "aria-rowindex": 1,
      "aria-colindex": c + 1,
      "aria-sort": i(s).ariaSort,
      children: [
        !s.sorting && s.title,
        s.sorting && /* @__PURE__ */ Ve(
          "button",
          {
            type: "button",
            className: Ke(
              "flex w-full items-center gap-1 bg-transparent p-1 px-5 py-2 outline-none hover:bg-primary-100 focus-visible:bg-primary-100",
              {
                "justify-start": s.justify === "start",
                "justify-center": s.justify === "center",
                "justify-end": s.justify === "end"
              }
            ),
            onClick: () => e(s),
            children: [
              /* @__PURE__ */ $t("span", { children: s.title }),
              /* @__PURE__ */ $t(hr, { "aria-hidden": !0, iconName: i(s).icon, size: "small" })
            ]
          }
        )
      ]
    },
    s.key
  )) });
}, V5t = ({ entry: t, show: e = !1, accordion: r = void 0 }) => /* @__PURE__ */ $t(Pc, { initial: !1, children: e && r && /* @__PURE__ */ Ve(bn.div, { initial: { height: 0 }, animate: { height: "auto" }, exit: { height: 0 }, className: "col-span-full", children: [
  /* @__PURE__ */ $t("hr", { className: "mx-6 h-[1px] w-[calc(100%-3rem)] border-none bg-grey-200" }),
  /* @__PURE__ */ $t(bn.section, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, children: r.render(t) })
] }) }, "accordion-tab"), z5t = ({
  entry: t,
  columns: e,
  rowIndex: r,
  accordion: i,
  showAccordion: s = !1,
  onToggleAccordion: c,
  size: u
}) => {
  const [l, f] = cn(!1), o = () => i && c(t);
  return /* @__PURE__ */ Ve(
    bn.div,
    {
      role: "row",
      animate: s ? "accordionOpen" : l && i ? "hovered" : "",
      initial: { boxShadow: "0", background: "var(--ssui-color-white)" },
      variants: {
        hovered: {
          transition: { duration: 0 },
          background: "var(--ssui-theme-color-primary-100)"
        },
        accordionOpen: {
          background: "var(--ssui-theme-color-primary-50)",
          boxShadow: "0 12px 8px -10px rgba(50,50,50,0.08) inset,0 -12px 8px -10px rgba(50,50,50,0.08) inset"
        }
      },
      className: Ke(
        "relative col-span-full grid grid-cols-subgrid border-b-[1px] border-b-[#00000010] bg-white last:border-b-0",
        {
          "bg-primary-100": l && i
        }
      ),
      layout: !0,
      children: [
        e.map((g, p) => /* @__PURE__ */ $t(
          "div",
          {
            onMouseEnter: () => f(!0),
            onMouseLeave: () => f(!1),
            onClick: o,
            role: "cell",
            className: Ke("relative grid items-center text-xs", {
              "px-5 py-[0.8125rem]": u === "small",
              "px-6 py-6 text-sm": u === "medium",
              "justify-items-start text-start": g.justify === "start",
              "justify-items-center text-center": g.justify === "center",
              "justify-items-end text-end": g.justify === "end",
              "tabular-nums": g.monospace,
              "cursor-pointer": i
            }),
            "aria-rowindex": r,
            "aria-colindex": p + 1,
            "data-testid": "table-cell",
            children: g.render(t)
          },
          g.key
        )),
        /* @__PURE__ */ $t(
          bn.div,
          {
            variants: {
              open: { width: "0.25rem" },
              closed: { width: "0" }
            },
            transition: { duration: 0.2 },
            initial: !1,
            animate: s ? "open" : "closed",
            className: "absolute h-full w-1 bg-primary-400"
          }
        ),
        /* @__PURE__ */ $t(V5t, { entry: t, show: s, accordion: i })
      ]
    }
  );
}, $d = ({ variant: t, onClick: e, disabled: r }) => {
  const i = t === "previous" ? bC.prevPageLabel : bC.nextPageLabel;
  return /* @__PURE__ */ Ve(
    "button",
    {
      disabled: r,
      onClick: e,
      "aria-label": i,
      className: Ke(
        "grid size-8 place-content-center rounded-full border-[1px] border-black text-black",
        "hover:bg-transparent-dark-100",
        "active:bg-transparent-dark-200",
        "disabled:border-transparent-dark-200 disabled:bg-transparent disabled:text-transparent-dark-200",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
      ),
      children: [
        t === "previous" && /* @__PURE__ */ $t(hr, { size: "small", iconName: "chevron-left", "aria-hidden": !0 }),
        t === "next" && /* @__PURE__ */ $t(hr, { size: "small", iconName: "chevron-right", "aria-hidden": !0 })
      ]
    }
  );
}, bC = {
  prevPageLabel: "Gå til forrige side",
  nextPageLabel: "Gå til næste side"
};
function Qo(t) {
  return typeof t == "string" || t instanceof String;
}
function vC(t) {
  var e;
  return typeof t == "object" && t != null && (t == null || (e = t.constructor) == null ? void 0 : e.name) === "Object";
}
function YE(t, e) {
  return Array.isArray(e) ? YE(t, (r, i) => e.includes(i)) : Object.entries(t).reduce((r, i) => {
    let [s, c] = i;
    return e(c, s) && (r[s] = c), r;
  }, {});
}
const Ue = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function X5t(t) {
  switch (t) {
    case Ue.LEFT:
      return Ue.FORCE_LEFT;
    case Ue.RIGHT:
      return Ue.FORCE_RIGHT;
    default:
      return t;
  }
}
function Qm(t) {
  return t.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function Pg(t, e) {
  if (e === t) return !0;
  const r = Array.isArray(e), i = Array.isArray(t);
  let s;
  if (r && i) {
    if (e.length != t.length) return !1;
    for (s = 0; s < e.length; s++) if (!Pg(e[s], t[s])) return !1;
    return !0;
  }
  if (r != i) return !1;
  if (e && t && typeof e == "object" && typeof t == "object") {
    const c = e instanceof Date, u = t instanceof Date;
    if (c && u) return e.getTime() == t.getTime();
    if (c != u) return !1;
    const l = e instanceof RegExp, f = t instanceof RegExp;
    if (l && f) return e.toString() == t.toString();
    if (l != f) return !1;
    const o = Object.keys(e);
    for (s = 0; s < o.length; s++) if (!Object.prototype.hasOwnProperty.call(t, o[s])) return !1;
    for (s = 0; s < o.length; s++) if (!Pg(t[o[s]], e[o[s]])) return !1;
    return !0;
  } else if (e && t && typeof e == "function" && typeof t == "function")
    return e.toString() === t.toString();
  return !1;
}
class q5t {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? Ue.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? Ue.RIGHT : Ue.LEFT;
  }
}
function Ye(t, e) {
  return new Ye.InputMask(t, e);
}
function ZE(t) {
  if (t == null) throw new Error("mask property should be defined");
  return t instanceof RegExp ? Ye.MaskedRegExp : Qo(t) ? Ye.MaskedPattern : t === Date ? Ye.MaskedDate : t === Number ? Ye.MaskedNumber : Array.isArray(t) || t === Array ? Ye.MaskedDynamic : Ye.Masked && t.prototype instanceof Ye.Masked ? t : Ye.Masked && t instanceof Ye.Masked ? t.constructor : t instanceof Function ? Ye.MaskedFunction : (console.warn("Mask not found for mask", t), Ye.Masked);
}
function _h(t) {
  if (!t) throw new Error("Options in not defined");
  if (Ye.Masked) {
    if (t.prototype instanceof Ye.Masked) return {
      mask: t
    };
    const {
      mask: e = void 0,
      ...r
    } = t instanceof Ye.Masked ? {
      mask: t
    } : vC(t) && t.mask instanceof Ye.Masked ? t : {};
    if (e) {
      const i = e.mask;
      return {
        ...YE(e, (s, c) => !c.startsWith("_")),
        mask: e.constructor,
        _mask: i,
        ...r
      };
    }
  }
  return vC(t) ? {
    ...t
  } : {
    mask: t
  };
}
function go(t) {
  if (Ye.Masked && t instanceof Ye.Masked) return t;
  const e = _h(t), r = ZE(e.mask);
  if (!r) throw new Error("Masked class is not found for provided mask " + e.mask + ", appropriate module needs to be imported manually before creating mask.");
  return e.mask === r && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new r(e);
}
Ye.createMask = go;
class n8 {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, r) {
    if (!(e == null || r == null || e === this.selectionStart && r === this.selectionEnd))
      try {
        this._unsafeSelect(e, r);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
Ye.MaskElement = n8;
const wC = 90, W5t = 89;
class Ip extends n8 {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var e, r, i;
    return (e = (r = (i = this.input).getRootNode) == null ? void 0 : r.call(i)) != null ? e : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(e) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", e.drop), this.input.addEventListener("click", e.click), this.input.addEventListener("focus", e.focus), this.input.addEventListener("blur", e.commit), this._handlers = e;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === wC && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === W5t && e.ctrlKey))
      return e.preventDefault(), this._handlers.redo(e);
    if (this._handlers.undo && e.keyCode === wC && (e.metaKey || e.ctrlKey))
      return e.preventDefault(), this._handlers.undo(e);
    e.isComposing || this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === "historyUndo" && this._handlers.undo)
      return e.preventDefault(), this._handlers.undo(e);
    if (e.inputType === "historyRedo" && this._handlers.redo)
      return e.preventDefault(), this._handlers.redo(e);
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    e.isComposing || this._handlers.input(e);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
Ye.HTMLMaskElement = Ip;
class G5t extends Ip {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, r) {
    this.input.setSelectionRange(e, r);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
Ye.HTMLMaskElement = Ip;
class JE extends Ip {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement, r = e.getSelection && e.getSelection(), i = r && r.anchorOffset, s = r && r.focusOffset;
    return s == null || i == null || i < s ? i : s;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement, r = e.getSelection && e.getSelection(), i = r && r.anchorOffset, s = r && r.focusOffset;
    return s == null || i == null || i > s ? i : s;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, r) {
    if (!this.rootElement.createRange) return;
    const i = this.rootElement.createRange();
    i.setStart(this.input.firstChild || this.input, e), i.setEnd(this.input.lastChild || this.input, r);
    const s = this.rootElement, c = s.getSelection && s.getSelection();
    c && (c.removeAllRanges(), c.addRange(i));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
Ye.HTMLContenteditableMaskElement = JE;
class Fp {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(e) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(e), this.states.length > Fp.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(e) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + e, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
Fp.MAX_LENGTH = 100;
class K5t {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, r) {
    this.el = e instanceof n8 ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new JE(e) : new G5t(e), this.masked = go(r), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new Fp(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var r;
    return e == null || ((r = this.masked) == null ? void 0 : r.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e)) return;
    if (!(e instanceof Ye.Masked) && this.masked.constructor === ZE(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const r = e instanceof Ye.Masked ? e : go({
      mask: e
    });
    r.unmaskedValue = this.masked.unmaskedValue, this.masked = r;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(e) {
    this.rawInputValue !== e && (this.masked.rawInputValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, r) {
    const i = this._listeners[e];
    i && i.forEach((s) => s(r));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(e) {
    const r = this.masked.unmaskedValue, i = this.masked.value, s = this.masked.rawInputValue, c = this.displayValue, u = this.unmaskedValue !== r || this.value !== i || this._rawInputValue !== s;
    this._unmaskedValue = r, this._value = i, this._rawInputValue = s, this.el.value !== c && (this.el.value = c), e === "auto" ? this.alignCursor() : e != null && (this.cursorPos = e), u && this._fireChangeEvents(), !this._historyChanging && (u || this.history.isEmpty) && this.history.push({
      unmaskedValue: r,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
      mask: r,
      ...i
    } = e, s = !this.maskEquals(r), c = this.masked.optionsIsChanged(i);
    s && (this.mask = r), c && this.masked.updateOptions(i), (s || c) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, Ue.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, r) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(r), this;
  }
  /** Removes custom event listener */
  off(e, r) {
    if (!this._listeners[e]) return this;
    if (!r)
      return delete this._listeners[e], this;
    const i = this._listeners[e].indexOf(r);
    return i >= 0 && this._listeners[e].splice(i, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e, this._abortUpdateCursor();
    const r = new q5t({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), i = this.masked.rawInputValue, s = this.masked.splice(r.startChangePos, r.removed.length, r.inserted, r.removeDirection, {
      input: !0,
      raw: !0
    }).offset, c = i === this.masked.rawInputValue ? r.removeDirection : Ue.NONE;
    let u = this.masked.nearestInputPos(r.startChangePos + s, c);
    c !== Ue.NONE && (u = this.masked.nearestInputPos(u, Ue.NONE)), this.updateControl(u), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(e) {
    e && (this._historyChanging = !0, this.unmaskedValue = e.unmaskedValue, this.el.select(e.selection.start, e.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
Ye.InputMask = K5t;
class ln {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new ln()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.inserted += e.inserted, this.rawInserted += e.rawInserted, this.tailShift += e.tailShift, this.skip = this.skip || e.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(e) {
    return this.inserted === e.inserted && this.tailShift === e.tailShift && this.rawInserted === e.rawInserted && this.skip === e.skip;
  }
}
Ye.ChangeDetails = ln;
class vs {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, r, i) {
    e === void 0 && (e = ""), r === void 0 && (r = 0), this.value = e, this.from = r, this.stop = i;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e) return "";
    const r = this.value[0];
    return this.value = this.value.slice(1), r;
  }
  shift() {
    if (!this.value.length) return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class ui {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ...ui.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    this.optionsIsChanged(e) && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, r) {
    r === void 0 && (r = {
      input: !0
    }), this.reset(), this.append(e, r, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, r) {
    return e;
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), Math.min(this.displayValue.length, r - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, r, i) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), this.displayValue.slice(e, r);
  }
  /** Extracts tail in range */
  extractTail(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), new vs(this.extractInput(e, r), e);
  }
  /** Appends tail */
  appendTail(e) {
    return Qo(e) && (e = new vs(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, r) {
    return e ? (this._value += e, new ln({
      inserted: e,
      rawInserted: e
    })) : new ln();
  }
  /** Appends char */
  _appendChar(e, r, i) {
    r === void 0 && (r = {});
    const s = this.state;
    let c;
    if ([e, c] = this.doPrepareChar(e, r), e && (c = c.aggregate(this._appendCharRaw(e, r)), !c.rawInserted && this.autofix === "pad")) {
      const u = this.state;
      this.state = s;
      let l = this.pad(r);
      const f = this._appendCharRaw(e, r);
      l = l.aggregate(f), f.rawInserted || l.equals(c) ? c = l : this.state = u;
    }
    if (c.inserted) {
      let u, l = this.doValidate(r) !== !1;
      if (l && i != null) {
        const f = this.state;
        if (this.overwrite === !0) {
          u = i.state;
          for (let g = 0; g < c.rawInserted.length; ++g)
            i.unshift(this.displayValue.length - c.tailShift);
        }
        let o = this.appendTail(i);
        if (l = o.rawInserted.length === i.toString().length, !(l && o.inserted) && this.overwrite === "shift") {
          this.state = f, u = i.state;
          for (let g = 0; g < c.rawInserted.length; ++g)
            i.shift();
          o = this.appendTail(i), l = o.rawInserted.length === i.toString().length;
        }
        l && o.inserted && (this.state = f);
      }
      l || (c = new ln(), this.state = s, i && u && (i.state = u));
    }
    return c;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new ln();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new ln();
  }
  /** Appends symbols considering flags */
  append(e, r, i) {
    if (!Qo(e)) throw new Error("value should be string");
    const s = Qo(i) ? new vs(String(i)) : i;
    r != null && r.tail && (r._beforeTailState = this.state);
    let c;
    [e, c] = this.doPrepare(e, r);
    for (let u = 0; u < e.length; ++u) {
      const l = this._appendChar(e[u], r, s);
      if (!l.rawInserted && !this.doSkipInvalid(e[u], r, s)) break;
      c.aggregate(l);
    }
    return (this.eager === !0 || this.eager === "append") && r != null && r.input && e && c.aggregate(this._appendEager()), s != null && (c.tailShift += this.appendTail(s).tailShift), c;
  }
  remove(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(r), new ln();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized) return e();
    this._refreshing = !0;
    const r = this.rawInputValue, i = this.value, s = e();
    return this.rawInputValue = r, this.value && this.value !== i && i.indexOf(this.value) === 0 && (this.append(i.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, s;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized) return e(this);
    this._isolated = !0;
    const r = this.state, i = e(this);
    return this.state = r, delete this._isolated, i;
  }
  doSkipInvalid(e, r, i) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, r) {
    return r === void 0 && (r = {}), ln.normalize(this.prepare ? this.prepare(e, this, r) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, r) {
    return r === void 0 && (r = {}), ln.normalize(this.prepareChar ? this.prepareChar(e, this, r) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, r, i, s, c) {
    i === void 0 && (i = ""), s === void 0 && (s = Ue.NONE), c === void 0 && (c = {
      input: !0
    });
    const u = e + r, l = this.extractTail(u), f = this.eager === !0 || this.eager === "remove";
    let o;
    f && (s = X5t(s), o = this.extractInput(0, u, {
      raw: !0
    }));
    let g = e;
    const p = new ln();
    if (s !== Ue.NONE && (g = this.nearestInputPos(e, r > 1 && e !== 0 && !f ? Ue.NONE : s), p.tailShift = g - e), p.aggregate(this.remove(g)), f && s !== Ue.NONE && o === this.rawInputValue)
      if (s === Ue.FORCE_LEFT) {
        let n;
        for (; o === this.rawInputValue && (n = this.displayValue.length); )
          p.aggregate(new ln({
            tailShift: -1
          })).aggregate(this.remove(n - 1));
      } else s === Ue.FORCE_RIGHT && l.unshift();
    return p.aggregate(this.append(i, c, l));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  optionsIsChanged(e) {
    return !Pg(this, e);
  }
  typedValueEquals(e) {
    const r = this.typedValue;
    return e === r || ui.EMPTY_VALUES.includes(e) && ui.EMPTY_VALUES.includes(r) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
  pad(e) {
    return new ln();
  }
}
ui.DEFAULTS = {
  skipInvalid: !0
};
ui.EMPTY_VALUES = [void 0, null, ""];
Ye.Masked = ui;
class sc {
  /** */
  constructor(e, r) {
    e === void 0 && (e = []), r === void 0 && (r = 0), this.chunks = e, this.from = r;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e)) return;
    e = Qo(e) ? new vs(String(e)) : e;
    const r = this.chunks[this.chunks.length - 1], i = r && // if stops are same or tail has no stop
    (r.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
    e.from === r.from + r.toString().length;
    if (e instanceof vs)
      i ? r.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof sc) {
      if (e.stop == null) {
        let s;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          s = e.chunks.shift(), s.from += e.from, this.extend(s);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof Ye.MaskedPattern))
      return new vs(this.toString()).appendTo(e);
    const r = new ln();
    for (let i = 0; i < this.chunks.length; ++i) {
      const s = this.chunks[i], c = e._mapPosToBlock(e.displayValue.length), u = s.stop;
      let l;
      if (u != null && // if block not found or stop is behind lastBlock
      (!c || c.index <= u) && ((s instanceof sc || // for continuous block also check if stop is exist
      e._stops.indexOf(u) >= 0) && r.aggregate(e._appendPlaceholder(u)), l = s instanceof sc && e._blocks[u]), l) {
        const f = l.appendTail(s);
        r.aggregate(f);
        const o = s.toString().slice(f.rawInserted.length);
        o && r.aggregate(e.append(o, {
          tail: !0
        }));
      } else
        r.aggregate(e.append(s.toString(), {
          tail: !0
        }));
    }
    return r;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: r,
      ...i
    } = e;
    Object.assign(this, i), this.chunks = r.map((s) => {
      const c = "chunks" in s ? new sc() : new vs();
      return c.state = s, c;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e) return "";
    const r = e != null ? e - this.from : e;
    let i = 0;
    for (; i < this.chunks.length; ) {
      const s = this.chunks[i], c = s.unshift(r);
      if (s.toString()) {
        if (!c) break;
        ++i;
      } else
        this.chunks.splice(i, 1);
      if (c) return c;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const r = this.chunks[e], i = r.shift();
      if (r.toString()) {
        if (!i) break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (i) return i;
    }
    return "";
  }
}
class Y5t {
  constructor(e, r) {
    this.masked = e, this._log = [];
    const {
      offset: i,
      index: s
    } = e._mapPosToBlock(r) || (r < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = i, this.index = s, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((r = this.block) == null ? void 0 : r.displayValue.length) || 0) {
      var r;
      if (e()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, Ue.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, Ue.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, Ue.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, Ue.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, Ue.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, Ue.NONE), !0;
    });
  }
}
class QE {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(r), this._value || (this._isRawInput = !1), new ln();
  }
  nearestInputPos(e, r) {
    r === void 0 && (r = Ue.NONE);
    const i = 0, s = this._value.length;
    switch (r) {
      case Ue.LEFT:
      case Ue.FORCE_LEFT:
        return i;
      case Ue.NONE:
      case Ue.RIGHT:
      case Ue.FORCE_RIGHT:
      default:
        return s;
    }
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this._value.length), this._isRawInput ? r - e : 0;
  }
  extractInput(e, r, i) {
    return e === void 0 && (e = 0), r === void 0 && (r = this._value.length), i === void 0 && (i = {}), i.raw && this._isRawInput && this._value.slice(e, r) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, r) {
    if (r === void 0 && (r = {}), this.isFilled) return new ln();
    const i = this.eager === !0 || this.eager === "append", c = this.char === e && (this.isUnmasking || r.input || r.raw) && (!r.raw || !i) && !r.tail, u = new ln({
      inserted: this.char,
      rawInserted: c ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = c && (r.raw || r.input), u;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new ln();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new vs("");
  }
  appendTail(e) {
    return Qo(e) && (e = new vs(String(e))), e.appendTo(this);
  }
  append(e, r, i) {
    const s = this._appendChar(e[0], r);
    return i != null && (s.tailShift += this.appendTail(i).tailShift), s;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
class Ig {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: r,
      isOptional: i,
      placeholderChar: s,
      displayChar: c,
      lazy: u,
      eager: l,
      ...f
    } = e;
    this.masked = go(f), Object.assign(this, {
      parent: r,
      isOptional: i,
      placeholderChar: s,
      displayChar: c,
      lazy: u,
      eager: l
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.value.length), e === 0 && r >= 1 ? (this.isFilled = !1, this.masked.remove(e, r)) : new ln();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, r) {
    if (r === void 0 && (r = {}), this.isFilled) return new ln();
    const i = this.masked.state;
    let s = this.masked._appendChar(e, this.currentMaskFlags(r));
    return s.inserted && this.doValidate(r) === !1 && (s = new ln(), this.masked.state = i), !s.inserted && !this.isOptional && !this.lazy && !r.input && (s.inserted = this.placeholderChar), s.skip = !s.inserted && !this.isOptional, this.isFilled = !!s.inserted, s;
  }
  append(e, r, i) {
    return this.masked.append(e, this.currentMaskFlags(r), i);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new ln() : (this.isFilled = !0, new ln({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new ln();
  }
  extractTail(e, r) {
    return this.masked.extractTail(e, r);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, r, i) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.value.length), this.masked.extractInput(e, r, i);
  }
  nearestInputPos(e, r) {
    r === void 0 && (r = Ue.NONE);
    const i = 0, s = this.value.length, c = Math.min(Math.max(e, i), s);
    switch (r) {
      case Ue.LEFT:
      case Ue.FORCE_LEFT:
        return this.isComplete ? c : i;
      case Ue.RIGHT:
      case Ue.FORCE_RIGHT:
        return this.isComplete ? c : s;
      case Ue.NONE:
      default:
        return c;
    }
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.value.length), this.value.slice(e, r).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var r;
    return {
      ...e,
      _beforeTailState: (e == null || (r = e._beforeTailState) == null ? void 0 : r.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
  pad(e) {
    return new ln();
  }
}
Ig.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class Z5t extends ui {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const r = e.mask;
    r && (e.validate = (i) => i.search(r) >= 0), super._update(e);
  }
}
Ye.MaskedRegExp = Z5t;
class hi extends ui {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...hi.DEFAULTS,
      ...e,
      definitions: Object.assign({}, Ig.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const r = this.mask;
    if (!r || !e) return;
    let i = !1, s = !1;
    for (let c = 0; c < r.length; ++c) {
      if (this.blocks) {
        const o = r.slice(c), g = Object.keys(this.blocks).filter((n) => o.indexOf(n) === 0);
        g.sort((n, a) => a.length - n.length);
        const p = g[0];
        if (p) {
          const {
            expose: n,
            repeat: a,
            ...d
          } = _h(this.blocks[p]), m = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...d,
            repeat: a,
            parent: this
          }, b = a != null ? new Ye.RepeatBlock(
            m
            /* TODO */
          ) : go(m);
          b && (this._blocks.push(b), n && (this.exposeBlock = b), this._maskedBlocks[p] || (this._maskedBlocks[p] = []), this._maskedBlocks[p].push(this._blocks.length - 1)), c += p.length - 1;
          continue;
        }
      }
      let u = r[c], l = u in e;
      if (u === hi.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (u === "{" || u === "}") {
        i = !i;
        continue;
      }
      if (u === "[" || u === "]") {
        s = !s;
        continue;
      }
      if (u === hi.ESCAPE_CHAR) {
        if (++c, u = r[c], !u) break;
        l = !1;
      }
      const f = l ? new Ig({
        isOptional: s,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ..._h(e[u]),
        parent: this
      }) : new QE({
        char: u,
        eager: this.eager,
        isUnmasking: i
      });
      this._blocks.push(f);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((e) => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: r,
      ...i
    } = e;
    this._blocks.forEach((s, c) => s.state = r[c]), super.state = i;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, r) => e += r.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const r = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(r), this.doCommit();
    } else super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((e, r) => e += r.value, "")
    );
  }
  set value(e) {
    if (this.exposeBlock) {
      const r = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(r), this.doCommit();
    } else super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const r = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(r), this.doCommit();
    } else super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, r) => e += r.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const r = new ln();
    let i = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (i == null) return r;
    this._blocks[i].isFilled && ++i;
    for (let s = i; s < this._blocks.length; ++s) {
      const c = this._blocks[s]._appendEager();
      if (!c.inserted) break;
      r.aggregate(c);
    }
    return r;
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const i = this._mapPosToBlock(this.displayValue.length), s = new ln();
    if (!i) return s;
    for (let u = i.index, l; l = this._blocks[u]; ++u) {
      var c;
      const f = l._appendChar(e, {
        ...r,
        _beforeTailState: (c = r._beforeTailState) == null || (c = c._blocks) == null ? void 0 : c[u]
      });
      if (s.aggregate(f), f.consumed) break;
    }
    return s;
  }
  extractTail(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    const i = new sc();
    return e === r || this._forEachBlocksInRange(e, r, (s, c, u, l) => {
      const f = s.extractTail(u, l);
      f.stop = this._findStopBefore(c), f.from = this._blockStartPos(c), f instanceof sc && (f.blockIndex = c), i.extend(f);
    }), i;
  }
  extractInput(e, r, i) {
    if (e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), i === void 0 && (i = {}), e === r) return "";
    let s = "";
    return this._forEachBlocksInRange(e, r, (c, u, l, f) => {
      s += c.extractInput(l, f, i);
    }), s;
  }
  _findStopBefore(e) {
    let r;
    for (let i = 0; i < this._stops.length; ++i) {
      const s = this._stops[i];
      if (s <= e) r = s;
      else break;
    }
    return r;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const r = new ln();
    if (this.lazy && e == null) return r;
    const i = this._mapPosToBlock(this.displayValue.length);
    if (!i) return r;
    const s = i.index, c = e ?? this._blocks.length;
    return this._blocks.slice(s, c).forEach((u) => {
      if (!u.lazy || e != null) {
        var l;
        r.aggregate(u._appendPlaceholder((l = u._blocks) == null ? void 0 : l.length));
      }
    }), r;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let r = "";
    for (let i = 0; i < this._blocks.length; ++i) {
      const s = this._blocks[i], c = r.length;
      if (r += s.displayValue, e <= r.length)
        return {
          index: i,
          offset: e - c
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((r, i) => r += i.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, r, i) {
    r === void 0 && (r = this.displayValue.length);
    const s = this._mapPosToBlock(e);
    if (s) {
      const c = this._mapPosToBlock(r), u = c && s.index === c.index, l = s.offset, f = c && u ? c.offset : this._blocks[s.index].displayValue.length;
      if (i(this._blocks[s.index], s.index, l, f), c && !u) {
        for (let o = s.index + 1; o < c.index; ++o)
          i(this._blocks[o], o, 0, this._blocks[o].displayValue.length);
        i(this._blocks[c.index], c.index, 0, c.offset);
      }
    }
  }
  remove(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    const i = super.remove(e, r);
    return this._forEachBlocksInRange(e, r, (s, c, u, l) => {
      i.aggregate(s.remove(u, l));
    }), i;
  }
  nearestInputPos(e, r) {
    if (r === void 0 && (r = Ue.NONE), !this._blocks.length) return 0;
    const i = new Y5t(this, e);
    if (r === Ue.NONE)
      return i.pushRightBeforeInput() || (i.popState(), i.pushLeftBeforeInput()) ? i.pos : this.displayValue.length;
    if (r === Ue.LEFT || r === Ue.FORCE_LEFT) {
      if (r === Ue.LEFT) {
        if (i.pushRightBeforeFilled(), i.ok && i.pos === e) return e;
        i.popState();
      }
      if (i.pushLeftBeforeInput(), i.pushLeftBeforeRequired(), i.pushLeftBeforeFilled(), r === Ue.LEFT) {
        if (i.pushRightBeforeInput(), i.pushRightBeforeRequired(), i.ok && i.pos <= e || (i.popState(), i.ok && i.pos <= e)) return i.pos;
        i.popState();
      }
      return i.ok ? i.pos : r === Ue.FORCE_LEFT ? 0 : (i.popState(), i.ok || (i.popState(), i.ok) ? i.pos : 0);
    }
    return r === Ue.RIGHT || r === Ue.FORCE_RIGHT ? (i.pushRightBeforeInput(), i.pushRightBeforeRequired(), i.pushRightBeforeFilled() ? i.pos : r === Ue.FORCE_RIGHT ? this.displayValue.length : (i.popState(), i.ok || (i.popState(), i.ok) ? i.pos : this.nearestInputPos(e, Ue.LEFT))) : e;
  }
  totalInputPositions(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    let i = 0;
    return this._forEachBlocksInRange(e, r, (s, c, u, l) => {
      i += s.totalInputPositions(u, l);
    }), i;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const r = this._maskedBlocks[e];
    return r ? r.map((i) => this._blocks[i]) : [];
  }
  pad(e) {
    const r = new ln();
    return this._forEachBlocksInRange(0, this.displayValue.length, (i) => r.aggregate(i.pad(e))), r;
  }
}
hi.DEFAULTS = {
  ...ui.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
hi.STOP_CHAR = "`";
hi.ESCAPE_CHAR = "\\";
hi.InputDefinition = Ig;
hi.FixedDefinition = QE;
Ye.MaskedPattern = hi;
class f2 extends hi {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: r = this.to || 0,
      from: i = this.from || 0,
      maxLength: s = this.maxLength || 0,
      autofix: c = this.autofix,
      ...u
    } = e;
    this.to = r, this.from = i, this.maxLength = Math.max(String(r).length, s), this.autofix = c;
    const l = String(this.from).padStart(this.maxLength, "0"), f = String(this.to).padStart(this.maxLength, "0");
    let o = 0;
    for (; o < f.length && f[o] === l[o]; ) ++o;
    u.mask = f.slice(0, o).replace(/0/g, "\\0") + "0".repeat(this.maxLength - o), super._update(u);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let r = "", i = "";
    const [, s, c] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return c && (r = "0".repeat(s.length) + c, i = "9".repeat(s.length) + c), r = r.padEnd(this.maxLength, "0"), i = i.padEnd(this.maxLength, "9"), [r, i];
  }
  doPrepareChar(e, r) {
    r === void 0 && (r = {});
    let i;
    return [e, i] = super.doPrepareChar(e.replace(/\D/g, ""), r), e || (i.skip = !this.isComplete), [e, i];
  }
  _appendCharRaw(e, r) {
    if (r === void 0 && (r = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(e, r);
    const i = String(this.from).padStart(this.maxLength, "0"), s = String(this.to).padStart(this.maxLength, "0"), [c, u] = this.boundaries(this.value + e);
    return Number(u) < this.from ? super._appendCharRaw(i[this.value.length], r) : Number(c) > this.to ? !r.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(i[this.value.length], r).aggregate(this._appendCharRaw(e, r)) : super._appendCharRaw(s[this.value.length], r) : super._appendCharRaw(e, r);
  }
  doValidate(e) {
    const r = this.value;
    if (r.search(/[^0]/) === -1 && r.length <= this._matchFrom) return !0;
    const [s, c] = this.boundaries(r);
    return this.from <= Number(c) && Number(s) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const r = new ln();
    if (this.value.length === this.maxLength) return r;
    const i = this.value, s = this.maxLength - this.value.length;
    if (s) {
      this.reset();
      for (let c = 0; c < s; ++c)
        r.aggregate(super._appendCharRaw("0", e));
      i.split("").forEach((c) => this._appendCharRaw(c));
    }
    return r;
  }
}
Ye.MaskedRange = f2;
const J5t = "d{.}`m{.}`Y";
class Ys extends hi {
  static extractPatternOptions(e) {
    const {
      mask: r,
      pattern: i,
      ...s
    } = e;
    return {
      ...s,
      mask: Qo(r) ? r : i
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super(Ys.extractPatternOptions({
      ...Ys.DEFAULTS,
      ...e
    }));
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      mask: r,
      pattern: i,
      blocks: s,
      ...c
    } = {
      ...Ys.DEFAULTS,
      ...e
    }, u = Object.assign({}, Ys.GET_DEFAULT_BLOCKS());
    e.min && (u.Y.from = e.min.getFullYear()), e.max && (u.Y.to = e.max.getFullYear()), e.min && e.max && u.Y.from === u.Y.to && (u.m.from = e.min.getMonth() + 1, u.m.to = e.max.getMonth() + 1, u.m.from === u.m.to && (u.d.from = e.min.getDate(), u.d.to = e.max.getDate())), Object.assign(u, this.blocks, s), super._update({
      ...c,
      mask: Qo(r) ? r : i,
      blocks: u
    });
  }
  doValidate(e) {
    const r = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && r != null && (this.min == null || this.min <= r) && (this.max == null || r <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
  optionsIsChanged(e) {
    return super.optionsIsChanged(Ys.extractPatternOptions(e));
  }
}
Ys.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: f2,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: f2,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: f2,
    from: 1900,
    to: 9999
  }
});
Ys.DEFAULTS = {
  ...hi.DEFAULTS,
  mask: Date,
  pattern: J5t,
  format: (t, e) => {
    if (!t) return "";
    const r = String(t.getDate()).padStart(2, "0"), i = String(t.getMonth() + 1).padStart(2, "0"), s = t.getFullYear();
    return [r, i, s].join(".");
  },
  parse: (t, e) => {
    const [r, i, s] = t.split(".").map(Number);
    return new Date(s, i - 1, r);
  }
};
Ye.MaskedDate = Ys;
class Rp extends ui {
  constructor(e) {
    super({
      ...Rp.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((r) => {
      const {
        expose: i,
        ...s
      } = _h(r), c = go({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...s
      });
      return i && (this.exposeMask = c), c;
    }) : []);
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const i = this._applyDispatch(e, r);
    return this.currentMask && i.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(r))), i;
  }
  _applyDispatch(e, r, i) {
    e === void 0 && (e = ""), r === void 0 && (r = {}), i === void 0 && (i = "");
    const s = r.tail && r._beforeTailState != null ? r._beforeTailState._value : this.value, c = this.rawInputValue, u = r.tail && r._beforeTailState != null ? r._beforeTailState._rawInputValue : c, l = c.slice(u.length), f = this.currentMask, o = new ln(), g = f == null ? void 0 : f.state;
    return this.currentMask = this.doDispatch(e, {
      ...r
    }, i), this.currentMask && (this.currentMask !== f ? (this.currentMask.reset(), u && (this.currentMask.append(u, {
      raw: !0
    }), o.tailShift = this.currentMask.value.length - s.length), l && (o.tailShift += this.currentMask.append(l, {
      raw: !0,
      tail: !0
    }).tailShift)) : g && (this.currentMask.state = g)), o;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const r = new ln();
    return e && r.aggregate(this._applyDispatch("", {}, e)), r.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var r, i;
    return {
      ...e,
      _beforeTailState: ((r = e._beforeTailState) == null ? void 0 : r.currentMaskRef) === this.currentMask && ((i = e._beforeTailState) == null ? void 0 : i.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, r, i) {
    return r === void 0 && (r = {}), i === void 0 && (i = ""), this.dispatch(e, this, r, i);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, r) {
    r === void 0 && (r = {});
    let [i, s] = super.doPrepare(e, r);
    if (this.currentMask) {
      let c;
      [i, c] = super.doPrepare(i, this.currentMaskFlags(r)), s = s.aggregate(c);
    }
    return [i, s];
  }
  doPrepareChar(e, r) {
    r === void 0 && (r = {});
    let [i, s] = super.doPrepareChar(e, r);
    if (this.currentMask) {
      let c;
      [i, c] = super.doPrepareChar(i, this.currentMaskFlags(r)), s = s.aggregate(c);
    }
    return [i, s];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach((r) => r.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let r = String(e);
    this.currentMask && (this.currentMask.typedValue = e, r = this.currentMask.unmaskedValue), this.unmaskedValue = r;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, r) {
    const i = new ln();
    return this.currentMask && i.aggregate(this.currentMask.remove(e, r)).aggregate(this._applyDispatch()), i;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((r) => r.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: r,
      currentMaskRef: i,
      currentMask: s,
      ...c
    } = e;
    r && this.compiledMasks.forEach((u, l) => u.state = r[l]), i != null && (this.currentMask = i, this.currentMask.state = s), super.state = c;
  }
  extractInput(e, r, i) {
    return this.currentMask ? this.currentMask.extractInput(e, r, i) : "";
  }
  extractTail(e, r) {
    return this.currentMask ? this.currentMask.extractTail(e, r) : super.extractTail(e, r);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, r) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, r) : super.nearestInputPos(e, r);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(e) {
    this._autofix = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((r, i) => {
      if (!e[i]) return;
      const {
        mask: s,
        ...c
      } = e[i];
      return Pg(r, c) && r.maskEquals(s);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var r;
    return !!((r = this.currentMask) != null && r.typedValueEquals(e));
  }
}
Rp.DEFAULTS = {
  ...ui.DEFAULTS,
  dispatch: (t, e, r, i) => {
    if (!e.compiledMasks.length) return;
    const s = e.rawInputValue, c = e.compiledMasks.map((u, l) => {
      const f = e.currentMask === u, o = f ? u.displayValue.length : u.nearestInputPos(u.displayValue.length, Ue.FORCE_LEFT);
      return u.rawInputValue !== s ? (u.reset(), u.append(s, {
        raw: !0
      })) : f || u.remove(o), u.append(t, e.currentMaskFlags(r)), u.appendTail(i), {
        index: l,
        weight: u.rawInputValue.length,
        totalInputPositions: u.totalInputPositions(0, Math.max(o, u.nearestInputPos(u.displayValue.length, Ue.FORCE_LEFT)))
      };
    });
    return c.sort((u, l) => l.weight - u.weight || l.totalInputPositions - u.totalInputPositions), e.compiledMasks[c[0].index];
  }
};
Ye.MaskedDynamic = Rp;
class Dp extends hi {
  constructor(e) {
    super({
      ...Dp.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: r,
      ...i
    } = e;
    if (r) {
      const s = r.map((l) => l.length), c = Math.min(...s), u = Math.max(...s) - c;
      i.mask = "*".repeat(c), u && (i.mask += "[" + "*".repeat(u) + "]"), this.enum = r;
    }
    super._update(i);
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const i = Math.min(this.nearestInputPos(0, Ue.FORCE_RIGHT), this.value.length), s = this.enum.filter((c) => this.matchValue(c, this.unmaskedValue + e, i));
    if (s.length) {
      s.length === 1 && this._forEachBlocksInRange(0, this.value.length, (u, l) => {
        const f = s[0][l];
        l >= this.value.length || f === u.value || (u.reset(), u._appendChar(f, r));
      });
      const c = super._appendCharRaw(s[0][this.value.length], r);
      return s.length === 1 && s[0].slice(this.unmaskedValue.length).split("").forEach((u) => c.aggregate(super._appendCharRaw(u))), c;
    }
    return new ln({
      skip: !this.isComplete
    });
  }
  extractTail(e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), new vs("", e);
  }
  remove(e, r) {
    if (e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), e === r) return new ln();
    const i = Math.min(super.nearestInputPos(0, Ue.FORCE_RIGHT), this.value.length);
    let s;
    for (s = e; s >= 0 && !(this.enum.filter((l) => this.matchValue(l, this.value.slice(i, s), i)).length > 1); --s)
      ;
    const c = super.remove(s, r);
    return c.tailShift += s - e, c;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
Dp.DEFAULTS = {
  ...hi.DEFAULTS,
  matchValue: (t, e, r) => t.indexOf(e, r) === r
};
Ye.MaskedEnum = Dp;
class Q5t extends ui {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
Ye.MaskedFunction = Q5t;
var tP;
class ra extends ui {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...ra.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), r = "\\d*", i = (this.scale ? "(" + Qm(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + r + i), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(Qm).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(Qm(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const r = e.split(this.radix);
    return r[0] = r[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), r.join(this.radix);
  }
  doPrepareChar(e, r) {
    r === void 0 && (r = {});
    const [i, s] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (r.input && r.raw || !r.input && !r.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), r);
    return e && !i && (s.skip = !0), i && !this.allowPositive && !this.value && i !== "-" && s.aggregate(this._appendChar("-")), [i, s];
  }
  _separatorsCount(e, r) {
    r === void 0 && (r = !1);
    let i = 0;
    for (let s = 0; s < e; ++s)
      this._value.indexOf(this.thousandsSeparator, s) === s && (++i, r && (e += this.thousandsSeparator.length));
    return i;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, r, i) {
    return e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), [e, r] = this._adjustRangeWithSeparators(e, r), this._removeThousandsSeparators(super.extractInput(e, r, i));
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const i = r.tail && r._beforeTailState ? r._beforeTailState._value : this._value, s = this._separatorsCountFromSlice(i);
    this._value = this._removeThousandsSeparators(this.value);
    const c = this._value;
    this._value += e;
    const u = this.number;
    let l = !isNaN(u), f = !1;
    if (l) {
      let n;
      this.min != null && this.min < 0 && this.number < this.min && (n = this.min), this.max != null && this.max > 0 && this.number > this.max && (n = this.max), n != null && (this.autofix ? (this._value = this.format(n, this).replace(ra.UNMASKED_RADIX, this.radix), f || (f = c === this._value && !r.tail)) : l = !1), l && (l = !!this._value.match(this._numberRegExp));
    }
    let o;
    l ? o = new ln({
      inserted: this._value.slice(c.length),
      rawInserted: f ? "" : e,
      skip: f
    }) : (this._value = c, o = new ln()), this._value = this._insertThousandsSeparators(this._value);
    const g = r.tail && r._beforeTailState ? r._beforeTailState._value : this._value, p = this._separatorsCountFromSlice(g);
    return o.tailShift += (p - s) * this.thousandsSeparator.length, o;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const r = e - this.thousandsSeparator.length + 1, i = this.value.indexOf(this.thousandsSeparator, r);
      if (i <= e) return i;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, r) {
    const i = this._findSeparatorAround(e);
    i >= 0 && (e = i);
    const s = this._findSeparatorAround(r);
    return s >= 0 && (r = s + this.thousandsSeparator.length), [e, r];
  }
  remove(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length), [e, r] = this._adjustRangeWithSeparators(e, r);
    const i = this.value.slice(0, e), s = this.value.slice(r), c = this._separatorsCount(i.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(i + s));
    const u = this._separatorsCountFromSlice(i);
    return new ln({
      tailShift: (u - c) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, r) {
    if (!this.thousandsSeparator) return e;
    switch (r) {
      case Ue.NONE:
      case Ue.LEFT:
      case Ue.FORCE_LEFT: {
        const i = this._findSeparatorAround(e - 1);
        if (i >= 0) {
          const s = i + this.thousandsSeparator.length;
          if (e < s || this.value.length <= s || r === Ue.FORCE_LEFT)
            return i;
        }
        break;
      }
      case Ue.RIGHT:
      case Ue.FORCE_RIGHT: {
        const i = this._findSeparatorAround(e);
        if (i >= 0)
          return i + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let r = e;
      this.min != null && (r = Math.max(r, this.min)), this.max != null && (r = Math.min(r, this.max)), r !== e && (this.unmaskedValue = this.format(r, this));
      let i = this.value;
      this.normalizeZeros && (i = this._normalizeZeros(i)), this.padFractionalZeros && this.scale > 0 && (i = this._padFractionalZeros(i)), this._value = i;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const r = this._removeThousandsSeparators(e).split(this.radix);
    return r[0] = r[0].replace(/^(\D*)(0*)(\d*)/, (i, s, c, u) => s + u), e.length && !/\d$/.test(r[0]) && (r[0] = r[0] + "0"), r.length > 1 && (r[1] = r[1].replace(/0*$/, ""), r[1].length || (r.length = 1)), this._insertThousandsSeparators(r.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e) return e;
    const r = e.split(this.radix);
    return r.length < 2 && r.push(""), r[1] = r[1].padEnd(this.scale, "0"), r.join(this.radix);
  }
  doSkipInvalid(e, r, i) {
    r === void 0 && (r = {});
    const s = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === ra.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, r, i) && !s;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, ra.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(ra.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || ra.EMPTY_VALUES.includes(e) && ra.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
tP = ra;
ra.UNMASKED_RADIX = ".";
ra.EMPTY_VALUES = [...ui.EMPTY_VALUES, 0];
ra.DEFAULTS = {
  ...ui.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [tP.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (t) => t.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
Ye.MaskedNumber = ra;
const T6 = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function eP(t, e, r) {
  e === void 0 && (e = T6.MASKED), r === void 0 && (r = T6.MASKED);
  const i = go(t);
  return (s) => i.runIsolated((c) => (c[e] = s, c[r]));
}
function tmt(t, e, r, i) {
  return eP(e, r, i)(t);
}
Ye.PIPE_TYPE = T6;
Ye.createPipe = eP;
Ye.pipe = tmt;
class emt extends hi {
  get repeatFrom() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? e : 0;
  }
  get repeatTo() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? e : 1 / 0;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    var r, i, s;
    const {
      repeat: c,
      ...u
    } = _h(e);
    this._blockOpts = Object.assign({}, this._blockOpts, u);
    const l = go(this._blockOpts);
    this.repeat = (r = (i = c ?? l.repeat) != null ? i : this.repeat) != null ? r : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((s = this._blocks) == null ? void 0 : s.length) || 0, this.repeatFrom)),
      blocks: {
        m: l
      },
      eager: l.eager,
      overwrite: l.overwrite,
      skipInvalid: l.skipInvalid,
      lazy: l.lazy,
      placeholderChar: l.placeholderChar,
      displayChar: l.displayChar
    });
  }
  _allocateBlock(e) {
    if (e < this._blocks.length) return this._blocks[e];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(go(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(e, r) {
    r === void 0 && (r = {});
    const i = new ln();
    for (
      let f = (s = (c = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : c.index) != null ? s : Math.max(this._blocks.length - 1, 0), o, g;
      // try to get a block or
      // try to allocate a new block if not allocated already
      o = (u = this._blocks[f]) != null ? u : g = !g && this._allocateBlock(f);
      ++f
    ) {
      var s, c, u, l;
      const p = o._appendChar(e, {
        ...r,
        _beforeTailState: (l = r._beforeTailState) == null || (l = l._blocks) == null ? void 0 : l[f]
      });
      if (p.skip && g) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (i.aggregate(p), p.consumed) break;
    }
    return i;
  }
  _trimEmptyTail(e, r) {
    var i, s;
    e === void 0 && (e = 0);
    const c = Math.max(((i = this._mapPosToBlock(e)) == null ? void 0 : i.index) || 0, this.repeatFrom, 0);
    let u;
    r != null && (u = (s = this._mapPosToBlock(r)) == null ? void 0 : s.index), u == null && (u = this._blocks.length - 1);
    let l = 0;
    for (let f = u; c <= f && !this._blocks[f].unmaskedValue; --f, ++l)
      ;
    l && (this._blocks.splice(u - l + 1, l), this.mask = this.mask.slice(l));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(e, r) {
    e === void 0 && (e = 0), r === void 0 && (r = this.displayValue.length);
    const i = super.remove(e, r);
    return this._trimEmptyTail(e, r), i;
  }
  totalInputPositions(e, r) {
    return e === void 0 && (e = 0), r == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(e, r);
  }
  get state() {
    return super.state;
  }
  set state(e) {
    this._blocks.length = e._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = e;
  }
}
Ye.RepeatBlock = emt;
try {
  globalThis.IMask = Ye;
} catch {
}
var M6 = { exports: {} }, Ld = { exports: {} }, En = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xC;
function nmt() {
  if (xC) return En;
  xC = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, c = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, l = t ? Symbol.for("react.context") : 60110, f = t ? Symbol.for("react.async_mode") : 60111, o = t ? Symbol.for("react.concurrent_mode") : 60111, g = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, n = t ? Symbol.for("react.suspense_list") : 60120, a = t ? Symbol.for("react.memo") : 60115, d = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, w = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function h(_) {
    if (typeof _ == "object" && _ !== null) {
      var M = _.$$typeof;
      switch (M) {
        case e:
          switch (_ = _.type, _) {
            case f:
            case o:
            case i:
            case c:
            case s:
            case p:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case l:
                case g:
                case d:
                case a:
                case u:
                  return _;
                default:
                  return M;
              }
          }
        case r:
          return M;
      }
    }
  }
  function x(_) {
    return h(_) === o;
  }
  return En.AsyncMode = f, En.ConcurrentMode = o, En.ContextConsumer = l, En.ContextProvider = u, En.Element = e, En.ForwardRef = g, En.Fragment = i, En.Lazy = d, En.Memo = a, En.Portal = r, En.Profiler = c, En.StrictMode = s, En.Suspense = p, En.isAsyncMode = function(_) {
    return x(_) || h(_) === f;
  }, En.isConcurrentMode = x, En.isContextConsumer = function(_) {
    return h(_) === l;
  }, En.isContextProvider = function(_) {
    return h(_) === u;
  }, En.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === e;
  }, En.isForwardRef = function(_) {
    return h(_) === g;
  }, En.isFragment = function(_) {
    return h(_) === i;
  }, En.isLazy = function(_) {
    return h(_) === d;
  }, En.isMemo = function(_) {
    return h(_) === a;
  }, En.isPortal = function(_) {
    return h(_) === r;
  }, En.isProfiler = function(_) {
    return h(_) === c;
  }, En.isStrictMode = function(_) {
    return h(_) === s;
  }, En.isSuspense = function(_) {
    return h(_) === p;
  }, En.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === i || _ === o || _ === c || _ === s || _ === p || _ === n || typeof _ == "object" && _ !== null && (_.$$typeof === d || _.$$typeof === a || _.$$typeof === u || _.$$typeof === l || _.$$typeof === g || _.$$typeof === b || _.$$typeof === w || _.$$typeof === v || _.$$typeof === m);
  }, En.typeOf = h, En;
}
var Pn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SC;
function rmt() {
  return SC || (SC = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, c = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, l = t ? Symbol.for("react.context") : 60110, f = t ? Symbol.for("react.async_mode") : 60111, o = t ? Symbol.for("react.concurrent_mode") : 60111, g = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, n = t ? Symbol.for("react.suspense_list") : 60120, a = t ? Symbol.for("react.memo") : 60115, d = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, w = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function h(st) {
      return typeof st == "string" || typeof st == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      st === i || st === o || st === c || st === s || st === p || st === n || typeof st == "object" && st !== null && (st.$$typeof === d || st.$$typeof === a || st.$$typeof === u || st.$$typeof === l || st.$$typeof === g || st.$$typeof === b || st.$$typeof === w || st.$$typeof === v || st.$$typeof === m);
    }
    function x(st) {
      if (typeof st == "object" && st !== null) {
        var mt = st.$$typeof;
        switch (mt) {
          case e:
            var yt = st.type;
            switch (yt) {
              case f:
              case o:
              case i:
              case c:
              case s:
              case p:
                return yt;
              default:
                var at = yt && yt.$$typeof;
                switch (at) {
                  case l:
                  case g:
                  case d:
                  case a:
                  case u:
                    return at;
                  default:
                    return mt;
                }
            }
          case r:
            return mt;
        }
      }
    }
    var _ = f, M = o, O = l, E = u, I = e, R = g, W = i, z = d, j = a, $ = r, B = c, C = s, T = p, F = !1;
    function S(st) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(st) || x(st) === f;
    }
    function A(st) {
      return x(st) === o;
    }
    function U(st) {
      return x(st) === l;
    }
    function K(st) {
      return x(st) === u;
    }
    function X(st) {
      return typeof st == "object" && st !== null && st.$$typeof === e;
    }
    function L(st) {
      return x(st) === g;
    }
    function H(st) {
      return x(st) === i;
    }
    function Q(st) {
      return x(st) === d;
    }
    function N(st) {
      return x(st) === a;
    }
    function V(st) {
      return x(st) === r;
    }
    function Y(st) {
      return x(st) === c;
    }
    function Z(st) {
      return x(st) === s;
    }
    function rt(st) {
      return x(st) === p;
    }
    Pn.AsyncMode = _, Pn.ConcurrentMode = M, Pn.ContextConsumer = O, Pn.ContextProvider = E, Pn.Element = I, Pn.ForwardRef = R, Pn.Fragment = W, Pn.Lazy = z, Pn.Memo = j, Pn.Portal = $, Pn.Profiler = B, Pn.StrictMode = C, Pn.Suspense = T, Pn.isAsyncMode = S, Pn.isConcurrentMode = A, Pn.isContextConsumer = U, Pn.isContextProvider = K, Pn.isElement = X, Pn.isForwardRef = L, Pn.isFragment = H, Pn.isLazy = Q, Pn.isMemo = N, Pn.isPortal = V, Pn.isProfiler = Y, Pn.isStrictMode = Z, Pn.isSuspense = rt, Pn.isValidElementType = h, Pn.typeOf = x;
  }()), Pn;
}
var CC;
function nP() {
  return CC || (CC = 1, process.env.NODE_ENV === "production" ? Ld.exports = nmt() : Ld.exports = rmt()), Ld.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var t3, AC;
function imt() {
  if (AC) return t3;
  AC = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(c) {
    if (c == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(c);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var c = new String("abc");
      if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
        return !1;
      for (var u = {}, l = 0; l < 10; l++)
        u["_" + String.fromCharCode(l)] = l;
      var f = Object.getOwnPropertyNames(u).map(function(g) {
        return u[g];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(g) {
        o[g] = g;
      }), Object.keys(Object.assign({}, o)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return t3 = s() ? Object.assign : function(c, u) {
    for (var l, f = i(c), o, g = 1; g < arguments.length; g++) {
      l = Object(arguments[g]);
      for (var p in l)
        e.call(l, p) && (f[p] = l[p]);
      if (t) {
        o = t(l);
        for (var n = 0; n < o.length; n++)
          r.call(l, o[n]) && (f[o[n]] = l[o[n]]);
      }
    }
    return f;
  }, t3;
}
var e3, _C;
function r8() {
  if (_C) return e3;
  _C = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return e3 = t, e3;
}
var n3, kC;
function rP() {
  return kC || (kC = 1, n3 = Function.call.bind(Object.prototype.hasOwnProperty)), n3;
}
var r3, OC;
function amt() {
  if (OC) return r3;
  OC = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = r8(), r = {}, i = rP();
    t = function(c) {
      var u = "Warning: " + c;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function s(c, u, l, f, o) {
    if (process.env.NODE_ENV !== "production") {
      for (var g in c)
        if (i(c, g)) {
          var p;
          try {
            if (typeof c[g] != "function") {
              var n = Error(
                (f || "React class") + ": " + l + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw n.name = "Invariant Violation", n;
            }
            p = c[g](u, g, f, l, null, e);
          } catch (d) {
            p = d;
          }
          if (p && !(p instanceof Error) && t(
            (f || "React class") + ": type specification of " + l + " `" + g + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in r)) {
            r[p.message] = !0;
            var a = o ? o() : "";
            t(
              "Failed " + l + " type: " + p.message + (a ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, r3 = s, r3;
}
var i3, TC;
function smt() {
  if (TC) return i3;
  TC = 1;
  var t = nP(), e = imt(), r = r8(), i = rP(), s = amt(), c = function() {
  };
  process.env.NODE_ENV !== "production" && (c = function(l) {
    var f = "Warning: " + l;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return i3 = function(l, f) {
    var o = typeof Symbol == "function" && Symbol.iterator, g = "@@iterator";
    function p(A) {
      var U = A && (o && A[o] || A[g]);
      if (typeof U == "function")
        return U;
    }
    var n = "<<anonymous>>", a = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: v(),
      arrayOf: h,
      element: x(),
      elementType: _(),
      instanceOf: M,
      node: R(),
      objectOf: E,
      oneOf: O,
      oneOfType: I,
      shape: z,
      exact: j
    };
    function d(A, U) {
      return A === U ? A !== 0 || 1 / A === 1 / U : A !== A && U !== U;
    }
    function m(A, U) {
      this.message = A, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(A) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, K = 0;
      function X(H, Q, N, V, Y, Z, rt) {
        if (V = V || n, Z = Z || N, rt !== r) {
          if (f) {
            var st = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw st.name = "Invariant Violation", st;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var mt = V + ":" + N;
            !U[mt] && // Avoid spamming the console because they are often not actionable except for lib authors
            K < 3 && (c(
              "You are manually calling a React.PropTypes validation function for the `" + Z + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[mt] = !0, K++);
          }
        }
        return Q[N] == null ? H ? Q[N] === null ? new m("The " + Y + " `" + Z + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new m("The " + Y + " `" + Z + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : A(Q, N, V, Y, Z);
      }
      var L = X.bind(null, !1);
      return L.isRequired = X.bind(null, !0), L;
    }
    function w(A) {
      function U(K, X, L, H, Q, N) {
        var V = K[X], Y = C(V);
        if (Y !== A) {
          var Z = T(V);
          return new m(
            "Invalid " + H + " `" + Q + "` of type " + ("`" + Z + "` supplied to `" + L + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return b(U);
    }
    function v() {
      return b(u);
    }
    function h(A) {
      function U(K, X, L, H, Q) {
        if (typeof A != "function")
          return new m("Property `" + Q + "` of component `" + L + "` has invalid PropType notation inside arrayOf.");
        var N = K[X];
        if (!Array.isArray(N)) {
          var V = C(N);
          return new m("Invalid " + H + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected an array."));
        }
        for (var Y = 0; Y < N.length; Y++) {
          var Z = A(N, Y, L, H, Q + "[" + Y + "]", r);
          if (Z instanceof Error)
            return Z;
        }
        return null;
      }
      return b(U);
    }
    function x() {
      function A(U, K, X, L, H) {
        var Q = U[K];
        if (!l(Q)) {
          var N = C(Q);
          return new m("Invalid " + L + " `" + H + "` of type " + ("`" + N + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(A);
    }
    function _() {
      function A(U, K, X, L, H) {
        var Q = U[K];
        if (!t.isValidElementType(Q)) {
          var N = C(Q);
          return new m("Invalid " + L + " `" + H + "` of type " + ("`" + N + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(A);
    }
    function M(A) {
      function U(K, X, L, H, Q) {
        if (!(K[X] instanceof A)) {
          var N = A.name || n, V = S(K[X]);
          return new m("Invalid " + H + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected ") + ("instance of `" + N + "`."));
        }
        return null;
      }
      return b(U);
    }
    function O(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? c(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : c("Invalid argument supplied to oneOf, expected an array.")), u;
      function U(K, X, L, H, Q) {
        for (var N = K[X], V = 0; V < A.length; V++)
          if (d(N, A[V]))
            return null;
        var Y = JSON.stringify(A, function(rt, st) {
          var mt = T(st);
          return mt === "symbol" ? String(st) : st;
        });
        return new m("Invalid " + H + " `" + Q + "` of value `" + String(N) + "` " + ("supplied to `" + L + "`, expected one of " + Y + "."));
      }
      return b(U);
    }
    function E(A) {
      function U(K, X, L, H, Q) {
        if (typeof A != "function")
          return new m("Property `" + Q + "` of component `" + L + "` has invalid PropType notation inside objectOf.");
        var N = K[X], V = C(N);
        if (V !== "object")
          return new m("Invalid " + H + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected an object."));
        for (var Y in N)
          if (i(N, Y)) {
            var Z = A(N, Y, L, H, Q + "." + Y, r);
            if (Z instanceof Error)
              return Z;
          }
        return null;
      }
      return b(U);
    }
    function I(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && c("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var U = 0; U < A.length; U++) {
        var K = A[U];
        if (typeof K != "function")
          return c(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(K) + " at index " + U + "."
          ), u;
      }
      function X(L, H, Q, N, V) {
        for (var Y = [], Z = 0; Z < A.length; Z++) {
          var rt = A[Z], st = rt(L, H, Q, N, V, r);
          if (st == null)
            return null;
          st.data && i(st.data, "expectedType") && Y.push(st.data.expectedType);
        }
        var mt = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new m("Invalid " + N + " `" + V + "` supplied to " + ("`" + Q + "`" + mt + "."));
      }
      return b(X);
    }
    function R() {
      function A(U, K, X, L, H) {
        return $(U[K]) ? null : new m("Invalid " + L + " `" + H + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return b(A);
    }
    function W(A, U, K, X, L) {
      return new m(
        (A || "React class") + ": " + U + " type `" + K + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + L + "`."
      );
    }
    function z(A) {
      function U(K, X, L, H, Q) {
        var N = K[X], V = C(N);
        if (V !== "object")
          return new m("Invalid " + H + " `" + Q + "` of type `" + V + "` " + ("supplied to `" + L + "`, expected `object`."));
        for (var Y in A) {
          var Z = A[Y];
          if (typeof Z != "function")
            return W(L, H, Q, Y, T(Z));
          var rt = Z(N, Y, L, H, Q + "." + Y, r);
          if (rt)
            return rt;
        }
        return null;
      }
      return b(U);
    }
    function j(A) {
      function U(K, X, L, H, Q) {
        var N = K[X], V = C(N);
        if (V !== "object")
          return new m("Invalid " + H + " `" + Q + "` of type `" + V + "` " + ("supplied to `" + L + "`, expected `object`."));
        var Y = e({}, K[X], A);
        for (var Z in Y) {
          var rt = A[Z];
          if (i(A, Z) && typeof rt != "function")
            return W(L, H, Q, Z, T(rt));
          if (!rt)
            return new m(
              "Invalid " + H + " `" + Q + "` key `" + Z + "` supplied to `" + L + "`.\nBad object: " + JSON.stringify(K[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var st = rt(N, Z, L, H, Q + "." + Z, r);
          if (st)
            return st;
        }
        return null;
      }
      return b(U);
    }
    function $(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every($);
          if (A === null || l(A))
            return !0;
          var U = p(A);
          if (U) {
            var K = U.call(A), X;
            if (U !== A.entries) {
              for (; !(X = K.next()).done; )
                if (!$(X.value))
                  return !1;
            } else
              for (; !(X = K.next()).done; ) {
                var L = X.value;
                if (L && !$(L[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function B(A, U) {
      return A === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function C(A) {
      var U = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : B(U, A) ? "symbol" : U;
    }
    function T(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var U = C(A);
      if (U === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function F(A) {
      var U = T(A);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function S(A) {
      return !A.constructor || !A.constructor.name ? n : A.constructor.name;
    }
    return a.checkPropTypes = s, a.resetWarningCache = s.resetWarningCache, a.PropTypes = a, a;
  }, i3;
}
var a3, MC;
function omt() {
  if (MC) return a3;
  MC = 1;
  var t = r8();
  function e() {
  }
  function r() {
  }
  return r.resetWarningCache = e, a3 = function() {
    function i(u, l, f, o, g, p) {
      if (p !== t) {
        var n = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw n.name = "Invariant Violation", n;
      }
    }
    i.isRequired = i;
    function s() {
      return i;
    }
    var c = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: s,
      element: i,
      elementType: i,
      instanceOf: s,
      node: i,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: r,
      resetWarningCache: e
    };
    return c.PropTypes = c, c;
  }, a3;
}
if (process.env.NODE_ENV !== "production") {
  var lmt = nP(), cmt = !0;
  M6.exports = smt()(lmt.isElement, cmt);
} else
  M6.exports = omt()();
var umt = M6.exports;
const Be = /* @__PURE__ */ Dn(umt), iP = {
  // common
  mask: Be.oneOfType([Be.array, Be.func, Be.string, Be.instanceOf(RegExp), Be.oneOf([Date, Number, Ye.Masked]), Be.instanceOf(Ye.Masked)]),
  value: Be.any,
  unmask: Be.oneOfType([Be.bool, Be.oneOf(["typed"])]),
  prepare: Be.func,
  prepareChar: Be.func,
  validate: Be.func,
  commit: Be.func,
  overwrite: Be.oneOfType([Be.bool, Be.oneOf(["shift"])]),
  eager: Be.oneOfType([Be.bool, Be.oneOf(["append", "remove"])]),
  skipInvalid: Be.bool,
  // events
  onAccept: Be.func,
  onComplete: Be.func,
  // pattern
  placeholderChar: Be.string,
  displayChar: Be.string,
  lazy: Be.bool,
  definitions: Be.object,
  blocks: Be.object,
  // enum
  enum: Be.arrayOf(Be.string),
  // range
  maxLength: Be.number,
  from: Be.number,
  to: Be.number,
  // date
  pattern: Be.string,
  format: Be.func,
  parse: Be.func,
  autofix: Be.oneOfType([Be.bool, Be.oneOf(["pad"])]),
  // number
  radix: Be.string,
  thousandsSeparator: Be.string,
  mapToRadix: Be.arrayOf(Be.string),
  scale: Be.number,
  normalizeZeros: Be.bool,
  padFractionalZeros: Be.bool,
  min: Be.oneOfType([Be.number, Be.instanceOf(Date)]),
  max: Be.oneOfType([Be.number, Be.instanceOf(Date)]),
  // dynamic
  dispatch: Be.func,
  // ref
  inputRef: Be.oneOfType([Be.func, Be.shape({
    current: Be.object
  })])
}, aP = Object.keys(iP).filter((t) => t !== "value"), hmt = ["value", "unmask", "onAccept", "onComplete", "inputRef"], fmt = aP.filter((t) => hmt.indexOf(t) < 0);
function dmt(t) {
  var e;
  const r = (e = class extends Bt.Component {
    constructor(c) {
      super(c), this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      this.props.mask && this.initMask();
    }
    componentDidUpdate() {
      const c = this.props, u = this._extractMaskOptionsFromProps(c);
      if (u.mask)
        this.maskRef ? (this.maskRef.updateOptions(u), "value" in c && c.value !== void 0 && (this.maskValue = c.value)) : this.initMask(u);
      else if (this.destroyMask(), "value" in c && c.value !== void 0) {
        var l;
        (l = this.element) != null && l.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA" ? this.element.textContent = c.value : this.element.value = c.value;
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(c) {
      this.element = c, this.props.inputRef && (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current") ? this.props.inputRef.current = c : this.props.inputRef(c));
    }
    initMask(c) {
      c === void 0 && (c = this._extractMaskOptionsFromProps(this.props)), this.maskRef = Ye(this.element, c).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this)), "value" in this.props && this.props.value !== void 0 && (this.maskValue = this.props.value);
    }
    destroyMask() {
      this.maskRef && (this.maskRef.destroy(), delete this.maskRef);
    }
    _extractMaskOptionsFromProps(c) {
      const {
        ...u
      } = c;
      return Object.keys(u).filter((l) => fmt.indexOf(l) < 0).forEach((l) => {
        delete u[l];
      }), u;
    }
    _extractNonMaskProps(c) {
      const {
        ...u
      } = c;
      return aP.forEach((l) => {
        l !== "maxLength" && delete u[l];
      }), "defaultValue" in u || (u.defaultValue = c.mask ? "" : u.value), delete u.value, u;
    }
    get maskValue() {
      return this.maskRef ? this.props.unmask === "typed" ? this.maskRef.typedValue : this.props.unmask ? this.maskRef.unmaskedValue : this.maskRef.value : "";
    }
    set maskValue(c) {
      this.maskRef && (c = c == null && this.props.unmask !== "typed" ? "" : c, this.props.unmask === "typed" ? this.maskRef.typedValue = c : this.props.unmask ? this.maskRef.unmaskedValue = c : this.maskRef.value = c);
    }
    _onAccept(c) {
      this.props.onAccept && this.maskRef && this.props.onAccept(this.maskValue, this.maskRef, c);
    }
    _onComplete(c) {
      this.props.onComplete && this.maskRef && this.props.onComplete(this.maskValue, this.maskRef, c);
    }
    render() {
      return Bt.createElement(t, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, e.displayName = void 0, e.propTypes = void 0, e), i = t.displayName || t.name || "Component";
  return r.displayName = "IMask(" + i + ")", r.propTypes = iP, Bt.forwardRef((s, c) => Bt.createElement(r, {
    ...s,
    ref: c
  }));
}
const gmt = dmt((t) => {
  let {
    inputRef: e,
    ...r
  } = t;
  return Bt.createElement("input", {
    ...r,
    ref: e
  });
}), pmt = (t, e) => Bt.createElement(gmt, {
  ...t,
  ref: e
});
Bt.forwardRef(pmt);
function sP(t, e) {
  let {
    onAccept: r,
    onComplete: i,
    ref: s = Sn(null),
    defaultValue: c,
    defaultUnmaskedValue: u,
    defaultTypedValue: l
  } = e === void 0 ? {} : e;
  const f = Sn(null), [o, g] = cn({}), [p, n] = cn(""), [a, d] = cn(""), [m, b] = cn(), w = Js(() => {
    var _;
    (_ = f.current) == null || _.destroy(), f.current = null;
  }, []), v = Js(() => {
    const _ = f.current;
    _ && (g({
      value: _.value,
      unmaskedValue: _.unmaskedValue,
      typedValue: _.typedValue
    }), b(_.typedValue), d(_.unmaskedValue), n(_.value));
  }, []), h = Js((_) => {
    const M = f.current;
    M && (v(), r == null || r(M.value, M, _));
  }, [r]), x = Js((_) => f.current && (i == null ? void 0 : i(f.current.value, f.current, _)), [i]);
  return Tn(() => {
    const {
      value: _,
      ...M
    } = o, O = f.current;
    !O || p === void 0 || (_ !== p && (O.value = p, O.value !== p && h()), g(M));
  }, [p]), Tn(() => {
    const {
      unmaskedValue: _,
      ...M
    } = o, O = f.current;
    !O || a === void 0 || (_ !== a && (O.unmaskedValue = a, O.unmaskedValue !== a && h()), g(M));
  }, [a]), Tn(() => {
    const {
      typedValue: _,
      ...M
    } = o, O = f.current;
    !O || m === void 0 || (_ !== m && (O.typedValue = m, O.masked.typedValueEquals(m) || h()), g(M));
  }, [m]), Tn(() => {
    const _ = s.current;
    if (!_ || !(t != null && t.mask)) return w();
    const M = f.current;
    M ? M == null || M.updateOptions(t) : _ && t != null && t.mask && (f.current = Ye(_, t), v(), c !== void 0 && n(c), u !== void 0 && d(u), l !== void 0 && b(l));
  }, [t, w, h]), Tn(() => {
    if (!f.current) return;
    const _ = f.current;
    return _.on("accept", h), _.on("complete", x), () => {
      _.off("accept", h), _.off("complete", x);
    };
  }, [h, x]), Tn(() => w, [w]), {
    ref: s,
    maskRef: f,
    value: p,
    setValue: n,
    unmaskedValue: a,
    setUnmaskedValue: d,
    typedValue: m,
    setTypedValue: b
  };
}
const mmt = ({ value: t, onChange: e, totalPages: r }) => {
  const i = mr(), {
    ref: s,
    value: c,
    setValue: u
  } = sP(
    {
      mask: Number,
      min: 1,
      max: r,
      scale: 0
    },
    {
      defaultValue: t.toString()
    }
  );
  Tn(() => {
    t.toString() !== c && document.activeElement !== s.current && u(t.toString());
  }, [c, s, u, t]);
  const l = () => {
    t - 1 < 1 ? (e(1), u("1")) : (e(t - 1), u((t - 1).toString()));
  }, f = () => {
    t + 1 > r ? (e(r), u(r.toString())) : (e(t + 1), u((t + 1).toString()));
  }, o = (g) => {
    g.key === "ArrowDown" ? (g.preventDefault(), l()) : g.key === "ArrowUp" && (g.preventDefault(), f());
  };
  return /* @__PURE__ */ Ve("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ $t("label", { htmlFor: i, children: EC.label }),
    /* @__PURE__ */ $t(
      "input",
      {
        type: "text",
        ref: s,
        id: i,
        className: Ke(
          "inline-flex h-8 w-12 rounded-full border border-grey-300 px-2 text-center",
          "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400",
          "selection:bg-blue-400 selection:text-white"
        ),
        value: c,
        onChange: (g) => e(Number(g.target.value)),
        onKeyDown: (g) => o(g),
        onBlur: () => u(t.toString())
      }
    ),
    /* @__PURE__ */ $t("span", { children: EC.labelPostfix(r) })
  ] });
}, EC = {
  label: "Side",
  labelPostfix: (t) => `af ${t}`
};
function $p() {
  return typeof window < "u";
}
function Sl(t) {
  return oP(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Mi(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Rs(t) {
  var e;
  return (e = (oP(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function oP(t) {
  return $p() ? t instanceof Node || t instanceof Mi(t).Node : !1;
}
function Vn(t) {
  return $p() ? t instanceof Element || t instanceof Mi(t).Element : !1;
}
function Ar(t) {
  return $p() ? t instanceof HTMLElement || t instanceof Mi(t).HTMLElement : !1;
}
function E6(t) {
  return !$p() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Mi(t).ShadowRoot;
}
function Jh(t) {
  const {
    overflow: e,
    overflowX: r,
    overflowY: i,
    display: s
  } = ma(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + r) && !["inline", "contents"].includes(s);
}
function ymt(t) {
  return ["table", "td", "th"].includes(Sl(t));
}
function Lp(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function i8(t) {
  const e = Np(), r = Vn(t) ? ma(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((i) => r[i] ? r[i] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !e && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !e && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((i) => (r.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (r.contain || "").includes(i));
}
function bmt(t) {
  let e = po(t);
  for (; Ar(e) && !fl(e); ) {
    if (i8(e))
      return e;
    if (Lp(e))
      return null;
    e = po(e);
  }
  return null;
}
function Np() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function fl(t) {
  return ["html", "body", "#document"].includes(Sl(t));
}
function ma(t) {
  return Mi(t).getComputedStyle(t);
}
function Bp(t) {
  return Vn(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function po(t) {
  if (Sl(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    E6(t) && t.host || // Fallback.
    Rs(t)
  );
  return E6(e) ? e.host : e;
}
function lP(t) {
  const e = po(t);
  return fl(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Ar(e) && Jh(e) ? e : lP(e);
}
function tl(t, e, r) {
  var i;
  e === void 0 && (e = []), r === void 0 && (r = !0);
  const s = lP(t), c = s === ((i = t.ownerDocument) == null ? void 0 : i.body), u = Mi(s);
  if (c) {
    const l = P6(u);
    return e.concat(u, u.visualViewport || [], Jh(s) ? s : [], l && r ? tl(l) : []);
  }
  return e.concat(s, tl(s, [], r));
}
function P6(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Ga(t) {
  let e = t.activeElement;
  for (; ((r = e) == null || (r = r.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var r;
    e = e.shadowRoot.activeElement;
  }
  return e;
}
function Nr(t, e) {
  if (!t || !e)
    return !1;
  const r = e.getRootNode == null ? void 0 : e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && E6(r)) {
    let i = e;
    for (; i; ) {
      if (t === i)
        return !0;
      i = i.parentNode || i.host;
    }
  }
  return !1;
}
function cP() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function uP() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((e) => {
    let {
      brand: r,
      version: i
    } = e;
    return r + "/" + i;
  }).join(" ") : navigator.userAgent;
}
function hP(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : I6() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function a8(t) {
  return vmt() ? !1 : !I6() && t.width === 0 && t.height === 0 || I6() && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function s8() {
  return /apple/i.test(navigator.vendor);
}
function I6() {
  const t = /android/i;
  return t.test(cP()) || t.test(uP());
}
function fP() {
  return cP().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function vmt() {
  return uP().includes("jsdom/");
}
function h0(t, e) {
  const r = ["mouse", "pen"];
  return e || r.push("", void 0), r.includes(t);
}
function wmt(t) {
  return "nativeEvent" in t;
}
function xmt(t) {
  return t.matches("html,body");
}
function Gr(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function s3(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const r = t;
  return r.target != null && e.contains(r.target);
}
function Zs(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
const Smt = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function o8(t) {
  return Ar(t) && t.matches(Smt);
}
function Wr(t) {
  t.preventDefault(), t.stopPropagation();
}
function F6(t) {
  return t ? t.getAttribute("role") === "combobox" && o8(t) : !1;
}
const dl = Math.min, aa = Math.max, Fg = Math.round, Fu = Math.floor, Os = (t) => ({
  x: t,
  y: t
}), Cmt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Amt = {
  start: "end",
  end: "start"
};
function R6(t, e, r) {
  return aa(t, dl(e, r));
}
function P0(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function gl(t) {
  return t.split("-")[0];
}
function I0(t) {
  return t.split("-")[1];
}
function dP(t) {
  return t === "x" ? "y" : "x";
}
function l8(t) {
  return t === "y" ? "height" : "width";
}
function kc(t) {
  return ["top", "bottom"].includes(gl(t)) ? "y" : "x";
}
function c8(t) {
  return dP(kc(t));
}
function _mt(t, e, r) {
  r === void 0 && (r = !1);
  const i = I0(t), s = c8(t), c = l8(s);
  let u = s === "x" ? i === (r ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[c] > e.floating[c] && (u = Rg(u)), [u, Rg(u)];
}
function kmt(t) {
  const e = Rg(t);
  return [D6(t), e, D6(e)];
}
function D6(t) {
  return t.replace(/start|end/g, (e) => Amt[e]);
}
function Omt(t, e, r) {
  const i = ["left", "right"], s = ["right", "left"], c = ["top", "bottom"], u = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return r ? e ? s : i : e ? i : s;
    case "left":
    case "right":
      return e ? c : u;
    default:
      return [];
  }
}
function Tmt(t, e, r, i) {
  const s = I0(t);
  let c = Omt(gl(t), r === "start", i);
  return s && (c = c.map((u) => u + "-" + s), e && (c = c.concat(c.map(D6)))), c;
}
function Rg(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Cmt[e]);
}
function Mmt(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function gP(t) {
  return typeof t != "number" ? Mmt(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Dg(t) {
  const {
    x: e,
    y: r,
    width: i,
    height: s
  } = t;
  return {
    width: i,
    height: s,
    top: r,
    left: e,
    right: e + i,
    bottom: r + s,
    x: e,
    y: r
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Emt = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], $g = /* @__PURE__ */ Emt.join(","), pP = typeof Element > "u", f0 = pP ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Lg = !pP && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, Ng = function t(e, r) {
  var i;
  r === void 0 && (r = !0);
  var s = e == null || (i = e.getAttribute) === null || i === void 0 ? void 0 : i.call(e, "inert"), c = s === "" || s === "true", u = c || r && e && t(e.parentNode);
  return u;
}, Pmt = function(e) {
  var r, i = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "contenteditable");
  return i === "" || i === "true";
}, Imt = function(e, r, i) {
  if (Ng(e))
    return [];
  var s = Array.prototype.slice.apply(e.querySelectorAll($g));
  return r && f0.call(e, $g) && s.unshift(e), s = s.filter(i), s;
}, Fmt = function t(e, r, i) {
  for (var s = [], c = Array.from(e); c.length; ) {
    var u = c.shift();
    if (!Ng(u, !1))
      if (u.tagName === "SLOT") {
        var l = u.assignedElements(), f = l.length ? l : u.children, o = t(f, !0, i);
        i.flatten ? s.push.apply(s, o) : s.push({
          scopeParent: u,
          candidates: o
        });
      } else {
        var g = f0.call(u, $g);
        g && i.filter(u) && (r || !e.includes(u)) && s.push(u);
        var p = u.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(u), n = !Ng(p, !1) && (!i.shadowRootFilter || i.shadowRootFilter(u));
        if (p && n) {
          var a = t(p === !0 ? u.children : p.children, !0, i);
          i.flatten ? s.push.apply(s, a) : s.push({
            scopeParent: u,
            candidates: a
          });
        } else
          c.unshift.apply(c, u.children);
      }
  }
  return s;
}, mP = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, yP = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || Pmt(e)) && !mP(e) ? 0 : e.tabIndex;
}, Rmt = function(e, r) {
  var i = yP(e);
  return i < 0 && r && !mP(e) ? 0 : i;
}, Dmt = function(e, r) {
  return e.tabIndex === r.tabIndex ? e.documentOrder - r.documentOrder : e.tabIndex - r.tabIndex;
}, bP = function(e) {
  return e.tagName === "INPUT";
}, $mt = function(e) {
  return bP(e) && e.type === "hidden";
}, Lmt = function(e) {
  var r = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
  return r;
}, Nmt = function(e, r) {
  for (var i = 0; i < e.length; i++)
    if (e[i].checked && e[i].form === r)
      return e[i];
}, Bmt = function(e) {
  if (!e.name)
    return !0;
  var r = e.form || Lg(e), i = function(l) {
    return r.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = i(window.CSS.escape(e.name));
  else
    try {
      s = i(e.name);
    } catch (u) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", u.message), !1;
    }
  var c = Nmt(s, e.form);
  return !c || c === e;
}, jmt = function(e) {
  return bP(e) && e.type === "radio";
}, Umt = function(e) {
  return jmt(e) && !Bmt(e);
}, Hmt = function(e) {
  var r, i = e && Lg(e), s = (r = i) === null || r === void 0 ? void 0 : r.host, c = !1;
  if (i && i !== e) {
    var u, l, f;
    for (c = !!((u = s) !== null && u !== void 0 && (l = u.ownerDocument) !== null && l !== void 0 && l.contains(s) || e != null && (f = e.ownerDocument) !== null && f !== void 0 && f.contains(e)); !c && s; ) {
      var o, g, p;
      i = Lg(s), s = (o = i) === null || o === void 0 ? void 0 : o.host, c = !!((g = s) !== null && g !== void 0 && (p = g.ownerDocument) !== null && p !== void 0 && p.contains(s));
    }
  }
  return c;
}, PC = function(e) {
  var r = e.getBoundingClientRect(), i = r.width, s = r.height;
  return i === 0 && s === 0;
}, Vmt = function(e, r) {
  var i = r.displayCheck, s = r.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var c = f0.call(e, "details>summary:first-of-type"), u = c ? e.parentElement : e;
  if (f0.call(u, "details:not([open]) *"))
    return !0;
  if (!i || i === "full" || i === "legacy-full") {
    if (typeof s == "function") {
      for (var l = e; e; ) {
        var f = e.parentElement, o = Lg(e);
        if (f && !f.shadowRoot && s(f) === !0)
          return PC(e);
        e.assignedSlot ? e = e.assignedSlot : !f && o !== e.ownerDocument ? e = o.host : e = f;
      }
      e = l;
    }
    if (Hmt(e))
      return !e.getClientRects().length;
    if (i !== "legacy-full")
      return !0;
  } else if (i === "non-zero-area")
    return PC(e);
  return !1;
}, zmt = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var r = e.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var i = 0; i < r.children.length; i++) {
          var s = r.children.item(i);
          if (s.tagName === "LEGEND")
            return f0.call(r, "fieldset[disabled] *") ? !0 : !s.contains(e);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, Xmt = function(e, r) {
  return !(r.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Ng(r) || $mt(r) || Vmt(r, e) || // For a details element with a summary, the summary element gets the focus
  Lmt(r) || zmt(r));
}, $6 = function(e, r) {
  return !(Umt(r) || yP(r) < 0 || !Xmt(e, r));
}, qmt = function(e) {
  var r = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, Wmt = function t(e) {
  var r = [], i = [];
  return e.forEach(function(s, c) {
    var u = !!s.scopeParent, l = u ? s.scopeParent : s, f = Rmt(l, u), o = u ? t(s.candidates) : l;
    f === 0 ? u ? r.push.apply(r, o) : r.push(l) : i.push({
      documentOrder: c,
      tabIndex: f,
      item: s,
      isScope: u,
      content: o
    });
  }), i.sort(Dmt).reduce(function(s, c) {
    return c.isScope ? s.push.apply(s, c.content) : s.push(c.content), s;
  }, []).concat(r);
}, jp = function(e, r) {
  r = r || {};
  var i;
  return r.getShadowRoot ? i = Fmt([e], r.includeContainer, {
    filter: $6.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: qmt
  }) : i = Imt(e, r.includeContainer, $6.bind(null, r)), Wmt(i);
}, Gmt = function(e, r) {
  if (r = r || {}, !e)
    throw new Error("No node provided");
  return f0.call(e, $g) === !1 ? !1 : $6(r, e);
};
function IC(t, e, r) {
  let {
    reference: i,
    floating: s
  } = t;
  const c = kc(e), u = c8(e), l = l8(u), f = gl(e), o = c === "y", g = i.x + i.width / 2 - s.width / 2, p = i.y + i.height / 2 - s.height / 2, n = i[l] / 2 - s[l] / 2;
  let a;
  switch (f) {
    case "top":
      a = {
        x: g,
        y: i.y - s.height
      };
      break;
    case "bottom":
      a = {
        x: g,
        y: i.y + i.height
      };
      break;
    case "right":
      a = {
        x: i.x + i.width,
        y: p
      };
      break;
    case "left":
      a = {
        x: i.x - s.width,
        y: p
      };
      break;
    default:
      a = {
        x: i.x,
        y: i.y
      };
  }
  switch (I0(e)) {
    case "start":
      a[u] -= n * (r && o ? -1 : 1);
      break;
    case "end":
      a[u] += n * (r && o ? -1 : 1);
      break;
  }
  return a;
}
const Kmt = async (t, e, r) => {
  const {
    placement: i = "bottom",
    strategy: s = "absolute",
    middleware: c = [],
    platform: u
  } = r, l = c.filter(Boolean), f = await (u.isRTL == null ? void 0 : u.isRTL(e));
  let o = await u.getElementRects({
    reference: t,
    floating: e,
    strategy: s
  }), {
    x: g,
    y: p
  } = IC(o, i, f), n = i, a = {}, d = 0;
  for (let m = 0; m < l.length; m++) {
    const {
      name: b,
      fn: w
    } = l[m], {
      x: v,
      y: h,
      data: x,
      reset: _
    } = await w({
      x: g,
      y: p,
      initialPlacement: i,
      placement: n,
      strategy: s,
      middlewareData: a,
      rects: o,
      platform: u,
      elements: {
        reference: t,
        floating: e
      }
    });
    g = v ?? g, p = h ?? p, a = {
      ...a,
      [b]: {
        ...a[b],
        ...x
      }
    }, _ && d <= 50 && (d++, typeof _ == "object" && (_.placement && (n = _.placement), _.rects && (o = _.rects === !0 ? await u.getElementRects({
      reference: t,
      floating: e,
      strategy: s
    }) : _.rects), {
      x: g,
      y: p
    } = IC(o, n, f)), m = -1);
  }
  return {
    x: g,
    y: p,
    placement: n,
    strategy: s,
    middlewareData: a
  };
};
async function u8(t, e) {
  var r;
  e === void 0 && (e = {});
  const {
    x: i,
    y: s,
    platform: c,
    rects: u,
    elements: l,
    strategy: f
  } = t, {
    boundary: o = "clippingAncestors",
    rootBoundary: g = "viewport",
    elementContext: p = "floating",
    altBoundary: n = !1,
    padding: a = 0
  } = P0(e, t), d = gP(a), b = l[n ? p === "floating" ? "reference" : "floating" : p], w = Dg(await c.getClippingRect({
    element: (r = await (c.isElement == null ? void 0 : c.isElement(b))) == null || r ? b : b.contextElement || await (c.getDocumentElement == null ? void 0 : c.getDocumentElement(l.floating)),
    boundary: o,
    rootBoundary: g,
    strategy: f
  })), v = p === "floating" ? {
    x: i,
    y: s,
    width: u.floating.width,
    height: u.floating.height
  } : u.reference, h = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(l.floating)), x = await (c.isElement == null ? void 0 : c.isElement(h)) ? await (c.getScale == null ? void 0 : c.getScale(h)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = Dg(c.convertOffsetParentRelativeRectToViewportRelativeRect ? await c.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: v,
    offsetParent: h,
    strategy: f
  }) : v);
  return {
    top: (w.top - _.top + d.top) / x.y,
    bottom: (_.bottom - w.bottom + d.bottom) / x.y,
    left: (w.left - _.left + d.left) / x.x,
    right: (_.right - w.right + d.right) / x.x
  };
}
const Ymt = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: r,
      y: i,
      placement: s,
      rects: c,
      platform: u,
      elements: l,
      middlewareData: f
    } = e, {
      element: o,
      padding: g = 0
    } = P0(t, e) || {};
    if (o == null)
      return {};
    const p = gP(g), n = {
      x: r,
      y: i
    }, a = c8(s), d = l8(a), m = await u.getDimensions(o), b = a === "y", w = b ? "top" : "left", v = b ? "bottom" : "right", h = b ? "clientHeight" : "clientWidth", x = c.reference[d] + c.reference[a] - n[a] - c.floating[d], _ = n[a] - c.reference[a], M = await (u.getOffsetParent == null ? void 0 : u.getOffsetParent(o));
    let O = M ? M[h] : 0;
    (!O || !await (u.isElement == null ? void 0 : u.isElement(M))) && (O = l.floating[h] || c.floating[d]);
    const E = x / 2 - _ / 2, I = O / 2 - m[d] / 2 - 1, R = dl(p[w], I), W = dl(p[v], I), z = R, j = O - m[d] - W, $ = O / 2 - m[d] / 2 + E, B = R6(z, $, j), C = !f.arrow && I0(s) != null && $ !== B && c.reference[d] / 2 - ($ < z ? R : W) - m[d] / 2 < 0, T = C ? $ < z ? $ - z : $ - j : 0;
    return {
      [a]: n[a] + T,
      data: {
        [a]: B,
        centerOffset: $ - B - T,
        ...C && {
          alignmentOffset: T
        }
      },
      reset: C
    };
  }
}), Zmt = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var r, i;
      const {
        placement: s,
        middlewareData: c,
        rects: u,
        initialPlacement: l,
        platform: f,
        elements: o
      } = e, {
        mainAxis: g = !0,
        crossAxis: p = !0,
        fallbackPlacements: n,
        fallbackStrategy: a = "bestFit",
        fallbackAxisSideDirection: d = "none",
        flipAlignment: m = !0,
        ...b
      } = P0(t, e);
      if ((r = c.arrow) != null && r.alignmentOffset)
        return {};
      const w = gl(s), v = kc(l), h = gl(l) === l, x = await (f.isRTL == null ? void 0 : f.isRTL(o.floating)), _ = n || (h || !m ? [Rg(l)] : kmt(l)), M = d !== "none";
      !n && M && _.push(...Tmt(l, m, d, x));
      const O = [l, ..._], E = await u8(e, b), I = [];
      let R = ((i = c.flip) == null ? void 0 : i.overflows) || [];
      if (g && I.push(E[w]), p) {
        const $ = _mt(s, u, x);
        I.push(E[$[0]], E[$[1]]);
      }
      if (R = [...R, {
        placement: s,
        overflows: I
      }], !I.every(($) => $ <= 0)) {
        var W, z;
        const $ = (((W = c.flip) == null ? void 0 : W.index) || 0) + 1, B = O[$];
        if (B)
          return {
            data: {
              index: $,
              overflows: R
            },
            reset: {
              placement: B
            }
          };
        let C = (z = R.filter((T) => T.overflows[0] <= 0).sort((T, F) => T.overflows[1] - F.overflows[1])[0]) == null ? void 0 : z.placement;
        if (!C)
          switch (a) {
            case "bestFit": {
              var j;
              const T = (j = R.filter((F) => {
                if (M) {
                  const S = kc(F.placement);
                  return S === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  S === "y";
                }
                return !0;
              }).map((F) => [F.placement, F.overflows.filter((S) => S > 0).reduce((S, A) => S + A, 0)]).sort((F, S) => F[1] - S[1])[0]) == null ? void 0 : j[0];
              T && (C = T);
              break;
            }
            case "initialPlacement":
              C = l;
              break;
          }
        if (s !== C)
          return {
            reset: {
              placement: C
            }
          };
      }
      return {};
    }
  };
};
async function Jmt(t, e) {
  const {
    placement: r,
    platform: i,
    elements: s
  } = t, c = await (i.isRTL == null ? void 0 : i.isRTL(s.floating)), u = gl(r), l = I0(r), f = kc(r) === "y", o = ["left", "top"].includes(u) ? -1 : 1, g = c && f ? -1 : 1, p = P0(e, t);
  let {
    mainAxis: n,
    crossAxis: a,
    alignmentAxis: d
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return l && typeof d == "number" && (a = l === "end" ? d * -1 : d), f ? {
    x: a * g,
    y: n * o
  } : {
    x: n * o,
    y: a * g
  };
}
const Qmt = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var r, i;
      const {
        x: s,
        y: c,
        placement: u,
        middlewareData: l
      } = e, f = await Jmt(e, t);
      return u === ((r = l.offset) == null ? void 0 : r.placement) && (i = l.arrow) != null && i.alignmentOffset ? {} : {
        x: s + f.x,
        y: c + f.y,
        data: {
          ...f,
          placement: u
        }
      };
    }
  };
}, t3t = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: r,
        y: i,
        placement: s
      } = e, {
        mainAxis: c = !0,
        crossAxis: u = !1,
        limiter: l = {
          fn: (b) => {
            let {
              x: w,
              y: v
            } = b;
            return {
              x: w,
              y: v
            };
          }
        },
        ...f
      } = P0(t, e), o = {
        x: r,
        y: i
      }, g = await u8(e, f), p = kc(gl(s)), n = dP(p);
      let a = o[n], d = o[p];
      if (c) {
        const b = n === "y" ? "top" : "left", w = n === "y" ? "bottom" : "right", v = a + g[b], h = a - g[w];
        a = R6(v, a, h);
      }
      if (u) {
        const b = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", v = d + g[b], h = d - g[w];
        d = R6(v, d, h);
      }
      const m = l.fn({
        ...e,
        [n]: a,
        [p]: d
      });
      return {
        ...m,
        data: {
          x: m.x - r,
          y: m.y - i,
          enabled: {
            [n]: c,
            [p]: u
          }
        }
      };
    }
  };
}, e3t = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var r, i;
      const {
        placement: s,
        rects: c,
        platform: u,
        elements: l
      } = e, {
        apply: f = () => {
        },
        ...o
      } = P0(t, e), g = await u8(e, o), p = gl(s), n = I0(s), a = kc(s) === "y", {
        width: d,
        height: m
      } = c.floating;
      let b, w;
      p === "top" || p === "bottom" ? (b = p, w = n === (await (u.isRTL == null ? void 0 : u.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (w = p, b = n === "end" ? "top" : "bottom");
      const v = m - g.top - g.bottom, h = d - g.left - g.right, x = dl(m - g[b], v), _ = dl(d - g[w], h), M = !e.middlewareData.shift;
      let O = x, E = _;
      if ((r = e.middlewareData.shift) != null && r.enabled.x && (E = h), (i = e.middlewareData.shift) != null && i.enabled.y && (O = v), M && !n) {
        const R = aa(g.left, 0), W = aa(g.right, 0), z = aa(g.top, 0), j = aa(g.bottom, 0);
        a ? E = d - 2 * (R !== 0 || W !== 0 ? R + W : aa(g.left, g.right)) : O = m - 2 * (z !== 0 || j !== 0 ? z + j : aa(g.top, g.bottom));
      }
      await f({
        ...e,
        availableWidth: E,
        availableHeight: O
      });
      const I = await u.getDimensions(l.floating);
      return d !== I.width || m !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function vP(t) {
  const e = ma(t);
  let r = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const s = Ar(t), c = s ? t.offsetWidth : r, u = s ? t.offsetHeight : i, l = Fg(r) !== c || Fg(i) !== u;
  return l && (r = c, i = u), {
    width: r,
    height: i,
    $: l
  };
}
function h8(t) {
  return Vn(t) ? t : t.contextElement;
}
function Vu(t) {
  const e = h8(t);
  if (!Ar(e))
    return Os(1);
  const r = e.getBoundingClientRect(), {
    width: i,
    height: s,
    $: c
  } = vP(e);
  let u = (c ? Fg(r.width) : r.width) / i, l = (c ? Fg(r.height) : r.height) / s;
  return (!u || !Number.isFinite(u)) && (u = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: u,
    y: l
  };
}
const n3t = /* @__PURE__ */ Os(0);
function wP(t) {
  const e = Mi(t);
  return !Np() || !e.visualViewport ? n3t : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function r3t(t, e, r) {
  return e === void 0 && (e = !1), !r || e && r !== Mi(t) ? !1 : e;
}
function Oc(t, e, r, i) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  const s = t.getBoundingClientRect(), c = h8(t);
  let u = Os(1);
  e && (i ? Vn(i) && (u = Vu(i)) : u = Vu(t));
  const l = r3t(c, r, i) ? wP(c) : Os(0);
  let f = (s.left + l.x) / u.x, o = (s.top + l.y) / u.y, g = s.width / u.x, p = s.height / u.y;
  if (c) {
    const n = Mi(c), a = i && Vn(i) ? Mi(i) : i;
    let d = n, m = P6(d);
    for (; m && i && a !== d; ) {
      const b = Vu(m), w = m.getBoundingClientRect(), v = ma(m), h = w.left + (m.clientLeft + parseFloat(v.paddingLeft)) * b.x, x = w.top + (m.clientTop + parseFloat(v.paddingTop)) * b.y;
      f *= b.x, o *= b.y, g *= b.x, p *= b.y, f += h, o += x, d = Mi(m), m = P6(d);
    }
  }
  return Dg({
    width: g,
    height: p,
    x: f,
    y: o
  });
}
function f8(t, e) {
  const r = Bp(t).scrollLeft;
  return e ? e.left + r : Oc(Rs(t)).left + r;
}
function xP(t, e, r) {
  r === void 0 && (r = !1);
  const i = t.getBoundingClientRect(), s = i.left + e.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    f8(t, i)
  )), c = i.top + e.scrollTop;
  return {
    x: s,
    y: c
  };
}
function i3t(t) {
  let {
    elements: e,
    rect: r,
    offsetParent: i,
    strategy: s
  } = t;
  const c = s === "fixed", u = Rs(i), l = e ? Lp(e.floating) : !1;
  if (i === u || l && c)
    return r;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = Os(1);
  const g = Os(0), p = Ar(i);
  if ((p || !p && !c) && ((Sl(i) !== "body" || Jh(u)) && (f = Bp(i)), Ar(i))) {
    const a = Oc(i);
    o = Vu(i), g.x = a.x + i.clientLeft, g.y = a.y + i.clientTop;
  }
  const n = u && !p && !c ? xP(u, f, !0) : Os(0);
  return {
    width: r.width * o.x,
    height: r.height * o.y,
    x: r.x * o.x - f.scrollLeft * o.x + g.x + n.x,
    y: r.y * o.y - f.scrollTop * o.y + g.y + n.y
  };
}
function a3t(t) {
  return Array.from(t.getClientRects());
}
function s3t(t) {
  const e = Rs(t), r = Bp(t), i = t.ownerDocument.body, s = aa(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), c = aa(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let u = -r.scrollLeft + f8(t);
  const l = -r.scrollTop;
  return ma(i).direction === "rtl" && (u += aa(e.clientWidth, i.clientWidth) - s), {
    width: s,
    height: c,
    x: u,
    y: l
  };
}
function o3t(t, e) {
  const r = Mi(t), i = Rs(t), s = r.visualViewport;
  let c = i.clientWidth, u = i.clientHeight, l = 0, f = 0;
  if (s) {
    c = s.width, u = s.height;
    const o = Np();
    (!o || o && e === "fixed") && (l = s.offsetLeft, f = s.offsetTop);
  }
  return {
    width: c,
    height: u,
    x: l,
    y: f
  };
}
function l3t(t, e) {
  const r = Oc(t, !0, e === "fixed"), i = r.top + t.clientTop, s = r.left + t.clientLeft, c = Ar(t) ? Vu(t) : Os(1), u = t.clientWidth * c.x, l = t.clientHeight * c.y, f = s * c.x, o = i * c.y;
  return {
    width: u,
    height: l,
    x: f,
    y: o
  };
}
function FC(t, e, r) {
  let i;
  if (e === "viewport")
    i = o3t(t, r);
  else if (e === "document")
    i = s3t(Rs(t));
  else if (Vn(e))
    i = l3t(e, r);
  else {
    const s = wP(t);
    i = {
      x: e.x - s.x,
      y: e.y - s.y,
      width: e.width,
      height: e.height
    };
  }
  return Dg(i);
}
function SP(t, e) {
  const r = po(t);
  return r === e || !Vn(r) || fl(r) ? !1 : ma(r).position === "fixed" || SP(r, e);
}
function c3t(t, e) {
  const r = e.get(t);
  if (r)
    return r;
  let i = tl(t, [], !1).filter((l) => Vn(l) && Sl(l) !== "body"), s = null;
  const c = ma(t).position === "fixed";
  let u = c ? po(t) : t;
  for (; Vn(u) && !fl(u); ) {
    const l = ma(u), f = i8(u);
    !f && l.position === "fixed" && (s = null), (c ? !f && !s : !f && l.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Jh(u) && !f && SP(t, u)) ? i = i.filter((g) => g !== u) : s = l, u = po(u);
  }
  return e.set(t, i), i;
}
function u3t(t) {
  let {
    element: e,
    boundary: r,
    rootBoundary: i,
    strategy: s
  } = t;
  const u = [...r === "clippingAncestors" ? Lp(e) ? [] : c3t(e, this._c) : [].concat(r), i], l = u[0], f = u.reduce((o, g) => {
    const p = FC(e, g, s);
    return o.top = aa(p.top, o.top), o.right = dl(p.right, o.right), o.bottom = dl(p.bottom, o.bottom), o.left = aa(p.left, o.left), o;
  }, FC(e, l, s));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function h3t(t) {
  const {
    width: e,
    height: r
  } = vP(t);
  return {
    width: e,
    height: r
  };
}
function f3t(t, e, r) {
  const i = Ar(e), s = Rs(e), c = r === "fixed", u = Oc(t, !0, c, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = Os(0);
  if (i || !i && !c)
    if ((Sl(e) !== "body" || Jh(s)) && (l = Bp(e)), i) {
      const n = Oc(e, !0, c, e);
      f.x = n.x + e.clientLeft, f.y = n.y + e.clientTop;
    } else s && (f.x = f8(s));
  const o = s && !i && !c ? xP(s, l) : Os(0), g = u.left + l.scrollLeft - f.x - o.x, p = u.top + l.scrollTop - f.y - o.y;
  return {
    x: g,
    y: p,
    width: u.width,
    height: u.height
  };
}
function o3(t) {
  return ma(t).position === "static";
}
function RC(t, e) {
  if (!Ar(t) || ma(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let r = t.offsetParent;
  return Rs(t) === r && (r = r.ownerDocument.body), r;
}
function CP(t, e) {
  const r = Mi(t);
  if (Lp(t))
    return r;
  if (!Ar(t)) {
    let s = po(t);
    for (; s && !fl(s); ) {
      if (Vn(s) && !o3(s))
        return s;
      s = po(s);
    }
    return r;
  }
  let i = RC(t, e);
  for (; i && ymt(i) && o3(i); )
    i = RC(i, e);
  return i && fl(i) && o3(i) && !i8(i) ? r : i || bmt(t) || r;
}
const d3t = async function(t) {
  const e = this.getOffsetParent || CP, r = this.getDimensions, i = await r(t.floating);
  return {
    reference: f3t(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function g3t(t) {
  return ma(t).direction === "rtl";
}
const p3t = {
  convertOffsetParentRelativeRectToViewportRelativeRect: i3t,
  getDocumentElement: Rs,
  getClippingRect: u3t,
  getOffsetParent: CP,
  getElementRects: d3t,
  getClientRects: a3t,
  getDimensions: h3t,
  getScale: Vu,
  isElement: Vn,
  isRTL: g3t
};
function AP(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function m3t(t, e) {
  let r = null, i;
  const s = Rs(t);
  function c() {
    var l;
    clearTimeout(i), (l = r) == null || l.disconnect(), r = null;
  }
  function u(l, f) {
    l === void 0 && (l = !1), f === void 0 && (f = 1), c();
    const o = t.getBoundingClientRect(), {
      left: g,
      top: p,
      width: n,
      height: a
    } = o;
    if (l || e(), !n || !a)
      return;
    const d = Fu(p), m = Fu(s.clientWidth - (g + n)), b = Fu(s.clientHeight - (p + a)), w = Fu(g), h = {
      rootMargin: -d + "px " + -m + "px " + -b + "px " + -w + "px",
      threshold: aa(0, dl(1, f)) || 1
    };
    let x = !0;
    function _(M) {
      const O = M[0].intersectionRatio;
      if (O !== f) {
        if (!x)
          return u();
        O ? u(!1, O) : i = setTimeout(() => {
          u(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !AP(o, t.getBoundingClientRect()) && u(), x = !1;
    }
    try {
      r = new IntersectionObserver(_, {
        ...h,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(_, h);
    }
    r.observe(t);
  }
  return u(!0), c;
}
function Qh(t, e, r, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: c = !0,
    elementResize: u = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = i, o = h8(t), g = s || c ? [...o ? tl(o) : [], ...tl(e)] : [];
  g.forEach((w) => {
    s && w.addEventListener("scroll", r, {
      passive: !0
    }), c && w.addEventListener("resize", r);
  });
  const p = o && l ? m3t(o, r) : null;
  let n = -1, a = null;
  u && (a = new ResizeObserver((w) => {
    let [v] = w;
    v && v.target === o && a && (a.unobserve(e), cancelAnimationFrame(n), n = requestAnimationFrame(() => {
      var h;
      (h = a) == null || h.observe(e);
    })), r();
  }), o && !f && a.observe(o), a.observe(e));
  let d, m = f ? Oc(t) : null;
  f && b();
  function b() {
    const w = Oc(t);
    m && !AP(m, w) && r(), m = w, d = requestAnimationFrame(b);
  }
  return r(), () => {
    var w;
    g.forEach((v) => {
      s && v.removeEventListener("scroll", r), c && v.removeEventListener("resize", r);
    }), p == null || p(), (w = a) == null || w.disconnect(), a = null, f && cancelAnimationFrame(d);
  };
}
const y3t = Qmt, b3t = t3t, v3t = Zmt, w3t = e3t, DC = Ymt, x3t = (t, e, r) => {
  const i = /* @__PURE__ */ new Map(), s = {
    platform: p3t,
    ...r
  }, c = {
    ...s.platform,
    _c: i
  };
  return Kmt(t, e, {
    ...s,
    platform: c
  });
};
var d2 = typeof document < "u" ? Ug : Tn;
function Bg(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let r, i, s;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (r = t.length, r !== e.length) return !1;
      for (i = r; i-- !== 0; )
        if (!Bg(t[i], e[i]))
          return !1;
      return !0;
    }
    if (s = Object.keys(t), r = s.length, r !== Object.keys(e).length)
      return !1;
    for (i = r; i-- !== 0; )
      if (!{}.hasOwnProperty.call(e, s[i]))
        return !1;
    for (i = r; i-- !== 0; ) {
      const c = s[i];
      if (!(c === "_owner" && t.$$typeof) && !Bg(t[c], e[c]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function _P(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function $C(t, e) {
  const r = _P(t);
  return Math.round(e * r) / r;
}
function l3(t) {
  const e = pt.useRef(t);
  return d2(() => {
    e.current = t;
  }), e;
}
function S3t(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s,
    elements: {
      reference: c,
      floating: u
    } = {},
    transform: l = !0,
    whileElementsMounted: f,
    open: o
  } = t, [g, p] = pt.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [n, a] = pt.useState(i);
  Bg(n, i) || a(i);
  const [d, m] = pt.useState(null), [b, w] = pt.useState(null), v = pt.useCallback((F) => {
    F !== M.current && (M.current = F, m(F));
  }, []), h = pt.useCallback((F) => {
    F !== O.current && (O.current = F, w(F));
  }, []), x = c || d, _ = u || b, M = pt.useRef(null), O = pt.useRef(null), E = pt.useRef(g), I = f != null, R = l3(f), W = l3(s), z = l3(o), j = pt.useCallback(() => {
    if (!M.current || !O.current)
      return;
    const F = {
      placement: e,
      strategy: r,
      middleware: n
    };
    W.current && (F.platform = W.current), x3t(M.current, O.current, F).then((S) => {
      const A = {
        ...S,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: z.current !== !1
      };
      $.current && !Bg(E.current, A) && (E.current = A, gA.flushSync(() => {
        p(A);
      }));
    });
  }, [n, e, r, W, z]);
  d2(() => {
    o === !1 && E.current.isPositioned && (E.current.isPositioned = !1, p((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [o]);
  const $ = pt.useRef(!1);
  d2(() => ($.current = !0, () => {
    $.current = !1;
  }), []), d2(() => {
    if (x && (M.current = x), _ && (O.current = _), x && _) {
      if (R.current)
        return R.current(x, _, j);
      j();
    }
  }, [x, _, j, R, I]);
  const B = pt.useMemo(() => ({
    reference: M,
    floating: O,
    setReference: v,
    setFloating: h
  }), [v, h]), C = pt.useMemo(() => ({
    reference: x,
    floating: _
  }), [x, _]), T = pt.useMemo(() => {
    const F = {
      position: r,
      left: 0,
      top: 0
    };
    if (!C.floating)
      return F;
    const S = $C(C.floating, g.x), A = $C(C.floating, g.y);
    return l ? {
      ...F,
      transform: "translate(" + S + "px, " + A + "px)",
      ..._P(C.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: S,
      top: A
    };
  }, [r, l, C.floating, g.x, g.y]);
  return pt.useMemo(() => ({
    ...g,
    update: j,
    refs: B,
    elements: C,
    floatingStyles: T
  }), [g, j, B, C, T]);
}
const C3t = (t) => {
  function e(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(r) {
      const {
        element: i,
        padding: s
      } = typeof t == "function" ? t(r) : t;
      return i && e(i) ? i.current != null ? DC({
        element: i.current,
        padding: s
      }).fn(r) : {} : i ? DC({
        element: i,
        padding: s
      }).fn(r) : {};
    }
  };
}, tf = (t, e) => ({
  ...y3t(t),
  options: [t, e]
}), kP = (t, e) => ({
  ...b3t(t),
  options: [t, e]
}), ef = (t, e) => ({
  ...v3t(t),
  options: [t, e]
}), d8 = (t, e) => ({
  ...w3t(t),
  options: [t, e]
}), A3t = (t, e) => ({
  ...C3t(t),
  options: [t, e]
}), OP = {
  ...pt
}, _3t = OP.useInsertionEffect, k3t = _3t || ((t) => t());
function _r(t) {
  const e = pt.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return k3t(() => {
    e.current = t;
  }), pt.useCallback(function() {
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    return e.current == null ? void 0 : e.current(...i);
  }, []);
}
const g8 = "ArrowUp", nf = "ArrowDown", el = "ArrowLeft", nl = "ArrowRight";
function Nd(t, e, r) {
  return Math.floor(t / e) !== r;
}
function J1(t, e) {
  return e < 0 || e >= t.current.length;
}
function c3(t, e) {
  return ri(t, {
    disabledIndices: e
  });
}
function LC(t, e) {
  return ri(t, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function ri(t, e) {
  let {
    startingIndex: r = -1,
    decrement: i = !1,
    disabledIndices: s,
    amount: c = 1
  } = e === void 0 ? {} : e;
  const u = t.current;
  let l = r;
  do
    l += i ? -c : c;
  while (l >= 0 && l <= u.length - 1 && g2(u, l, s));
  return l;
}
function O3t(t, e) {
  let {
    event: r,
    orientation: i,
    loop: s,
    rtl: c,
    cols: u,
    disabledIndices: l,
    minIndex: f,
    maxIndex: o,
    prevIndex: g,
    stopEvent: p = !1
  } = e, n = g;
  if (r.key === g8) {
    if (p && Wr(r), g === -1)
      n = o;
    else if (n = ri(t, {
      startingIndex: n,
      amount: u,
      decrement: !0,
      disabledIndices: l
    }), s && (g - u < f || n < 0)) {
      const a = g % u, d = o % u, m = o - (d - a);
      d === a ? n = o : n = d > a ? m : m - u;
    }
    J1(t, n) && (n = g);
  }
  if (r.key === nf && (p && Wr(r), g === -1 ? n = f : (n = ri(t, {
    startingIndex: g,
    amount: u,
    disabledIndices: l
  }), s && g + u > o && (n = ri(t, {
    startingIndex: g % u - u,
    amount: u,
    disabledIndices: l
  }))), J1(t, n) && (n = g)), i === "both") {
    const a = Fu(g / u);
    r.key === (c ? el : nl) && (p && Wr(r), g % u !== u - 1 ? (n = ri(t, {
      startingIndex: g,
      disabledIndices: l
    }), s && Nd(n, u, a) && (n = ri(t, {
      startingIndex: g - g % u - 1,
      disabledIndices: l
    }))) : s && (n = ri(t, {
      startingIndex: g - g % u - 1,
      disabledIndices: l
    })), Nd(n, u, a) && (n = g)), r.key === (c ? nl : el) && (p && Wr(r), g % u !== 0 ? (n = ri(t, {
      startingIndex: g,
      decrement: !0,
      disabledIndices: l
    }), s && Nd(n, u, a) && (n = ri(t, {
      startingIndex: g + (u - g % u),
      decrement: !0,
      disabledIndices: l
    }))) : s && (n = ri(t, {
      startingIndex: g + (u - g % u),
      decrement: !0,
      disabledIndices: l
    })), Nd(n, u, a) && (n = g));
    const d = Fu(o / u) === a;
    J1(t, n) && (s && d ? n = r.key === (c ? nl : el) ? o : ri(t, {
      startingIndex: g - g % u - 1,
      disabledIndices: l
    }) : n = g);
  }
  return n;
}
function T3t(t, e, r) {
  const i = [];
  let s = 0;
  return t.forEach((c, u) => {
    let {
      width: l,
      height: f
    } = c;
    if (l > e && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + u + " is greater than grid columns");
    let o = !1;
    for (r && (s = 0); !o; ) {
      const g = [];
      for (let p = 0; p < l; p++)
        for (let n = 0; n < f; n++)
          g.push(s + p + n * e);
      s % e + l <= e && g.every((p) => i[p] == null) ? (g.forEach((p) => {
        i[p] = u;
      }), o = !0) : s++;
    }
  }), [...i];
}
function M3t(t, e, r, i, s) {
  if (t === -1) return -1;
  const c = r.indexOf(t), u = e[t];
  switch (s) {
    case "tl":
      return c;
    case "tr":
      return u ? c + u.width - 1 : c;
    case "bl":
      return u ? c + (u.height - 1) * i : c;
    case "br":
      return r.lastIndexOf(t);
  }
}
function E3t(t, e) {
  return e.flatMap((r, i) => t.includes(r) ? [i] : []);
}
function g2(t, e, r) {
  if (r)
    return r.includes(e);
  const i = t[e];
  return i == null || i.hasAttribute("disabled") || i.getAttribute("aria-disabled") === "true";
}
var qn = typeof document < "u" ? Ug : Tn;
function kh() {
  return kh = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, kh.apply(this, arguments);
}
let NC = !1, P3t = 0;
const BC = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + P3t++
);
function I3t() {
  const [t, e] = pt.useState(() => NC ? BC() : void 0);
  return qn(() => {
    t == null && e(BC());
  }, []), pt.useEffect(() => {
    NC = !0;
  }, []), t;
}
const F3t = OP.useId, Fa = F3t || I3t;
let Oh;
process.env.NODE_ENV !== "production" && (Oh = /* @__PURE__ */ new Set());
function p2() {
  for (var t, e = arguments.length, r = new Array(e), i = 0; i < e; i++)
    r[i] = arguments[i];
  const s = "Floating UI: " + r.join(" ");
  if (!((t = Oh) != null && t.has(s))) {
    var c;
    (c = Oh) == null || c.add(s), console.warn(s);
  }
}
function R3t() {
  for (var t, e = arguments.length, r = new Array(e), i = 0; i < e; i++)
    r[i] = arguments[i];
  const s = "Floating UI: " + r.join(" ");
  if (!((t = Oh) != null && t.has(s))) {
    var c;
    (c = Oh) == null || c.add(s), console.error(s);
  }
}
const D3t = /* @__PURE__ */ pt.forwardRef(function(e, r) {
  const {
    context: {
      placement: i,
      elements: {
        floating: s
      },
      middlewareData: {
        arrow: c,
        shift: u
      }
    },
    width: l = 14,
    height: f = 7,
    tipRadius: o = 0,
    strokeWidth: g = 0,
    staticOffset: p,
    stroke: n,
    d: a,
    style: {
      transform: d,
      ...m
    } = {},
    ...b
  } = e;
  process.env.NODE_ENV !== "production" && (r || p2("The `ref` prop is required for `FloatingArrow`."));
  const w = Fa(), [v, h] = pt.useState(!1);
  if (qn(() => {
    if (!s) return;
    ma(s).direction === "rtl" && h(!0);
  }, [s]), !s)
    return null;
  const [x, _] = i.split("-"), M = x === "top" || x === "bottom";
  let O = p;
  (M && u != null && u.x || !M && u != null && u.y) && (O = null);
  const E = g * 2, I = E / 2, R = l / 2 * (o / -8 + 1), W = f / 2 * o / 4, z = !!a, j = O && _ === "end" ? "bottom" : "top";
  let $ = O && _ === "end" ? "right" : "left";
  O && v && ($ = _ === "end" ? "left" : "right");
  const B = (c == null ? void 0 : c.x) != null ? O || c.x : "", C = (c == null ? void 0 : c.y) != null ? O || c.y : "", T = a || "M0,0" + (" H" + l) + (" L" + (l - R) + "," + (f - W)) + (" Q" + l / 2 + "," + f + " " + R + "," + (f - W)) + " Z", F = {
    top: z ? "rotate(180deg)" : "",
    left: z ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: z ? "" : "rotate(180deg)",
    right: z ? "rotate(-90deg)" : "rotate(90deg)"
  }[x];
  return /* @__PURE__ */ pt.createElement("svg", kh({}, b, {
    "aria-hidden": !0,
    ref: r,
    width: z ? l : l + E,
    height: l,
    viewBox: "0 0 " + l + " " + (f > l ? f : l),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [$]: B,
      [j]: C,
      [x]: M || z ? "100%" : "calc(100% - " + E / 2 + "px)",
      transform: [F, d].filter((S) => !!S).join(" "),
      ...m
    }
  }), E > 0 && /* @__PURE__ */ pt.createElement("path", {
    clipPath: "url(#" + w + ")",
    fill: "none",
    stroke: n,
    strokeWidth: E + (a ? 0 : 1),
    d: T
  }), /* @__PURE__ */ pt.createElement("path", {
    stroke: E && !a ? b.fill : "none",
    d: T
  }), /* @__PURE__ */ pt.createElement("clipPath", {
    id: w
  }, /* @__PURE__ */ pt.createElement("rect", {
    x: -I,
    y: I * (z ? -1 : 1),
    width: l + E,
    height: l
  })));
});
function $3t() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, r) {
      var i;
      (i = t.get(e)) == null || i.forEach((s) => s(r));
    },
    on(e, r) {
      t.set(e, [...t.get(e) || [], r]);
    },
    off(e, r) {
      var i;
      t.set(e, ((i = t.get(e)) == null ? void 0 : i.filter((s) => s !== r)) || []);
    }
  };
}
const L3t = /* @__PURE__ */ pt.createContext(null), N3t = /* @__PURE__ */ pt.createContext(null), Up = () => {
  var t;
  return ((t = pt.useContext(L3t)) == null ? void 0 : t.id) || null;
}, rf = () => pt.useContext(N3t);
function Tc(t) {
  return "data-floating-ui-" + t;
}
function la(t) {
  const e = Sn(t);
  return qn(() => {
    e.current = t;
  }), e;
}
const jC = /* @__PURE__ */ Tc("safe-polygon");
function u3(t, e, r) {
  return r && !h0(r) ? 0 : typeof t == "number" ? t : t == null ? void 0 : t[e];
}
function B3t(t, e) {
  e === void 0 && (e = {});
  const {
    open: r,
    onOpenChange: i,
    dataRef: s,
    events: c,
    elements: u
  } = t, {
    enabled: l = !0,
    delay: f = 0,
    handleClose: o = null,
    mouseOnly: g = !1,
    restMs: p = 0,
    move: n = !0
  } = e, a = rf(), d = Up(), m = la(o), b = la(f), w = la(r), v = pt.useRef(), h = pt.useRef(-1), x = pt.useRef(), _ = pt.useRef(-1), M = pt.useRef(!0), O = pt.useRef(!1), E = pt.useRef(() => {
  }), I = pt.useRef(!1), R = pt.useCallback(() => {
    var T;
    const F = (T = s.current.openEvent) == null ? void 0 : T.type;
    return (F == null ? void 0 : F.includes("mouse")) && F !== "mousedown";
  }, [s]);
  pt.useEffect(() => {
    if (!l) return;
    function T(F) {
      let {
        open: S
      } = F;
      S || (clearTimeout(h.current), clearTimeout(_.current), M.current = !0, I.current = !1);
    }
    return c.on("openchange", T), () => {
      c.off("openchange", T);
    };
  }, [l, c]), pt.useEffect(() => {
    if (!l || !m.current || !r) return;
    function T(S) {
      R() && i(!1, S, "hover");
    }
    const F = Gr(u.floating).documentElement;
    return F.addEventListener("mouseleave", T), () => {
      F.removeEventListener("mouseleave", T);
    };
  }, [u.floating, r, i, l, m, R]);
  const W = pt.useCallback(function(T, F, S) {
    F === void 0 && (F = !0), S === void 0 && (S = "hover");
    const A = u3(b.current, "close", v.current);
    A && !x.current ? (clearTimeout(h.current), h.current = window.setTimeout(() => i(!1, T, S), A)) : F && (clearTimeout(h.current), i(!1, T, S));
  }, [b, i]), z = _r(() => {
    E.current(), x.current = void 0;
  }), j = _r(() => {
    if (O.current) {
      const T = Gr(u.floating).body;
      T.style.pointerEvents = "", T.removeAttribute(jC), O.current = !1;
    }
  }), $ = _r(() => s.current.openEvent ? ["click", "mousedown"].includes(s.current.openEvent.type) : !1);
  pt.useEffect(() => {
    if (!l) return;
    function T(U) {
      if (clearTimeout(h.current), M.current = !1, g && !h0(v.current) || p > 0 && !u3(b.current, "open"))
        return;
      const K = u3(b.current, "open", v.current);
      K ? h.current = window.setTimeout(() => {
        w.current || i(!0, U, "hover");
      }, K) : r || i(!0, U, "hover");
    }
    function F(U) {
      if ($()) return;
      E.current();
      const K = Gr(u.floating);
      if (clearTimeout(_.current), I.current = !1, m.current && s.current.floatingContext) {
        r || clearTimeout(h.current), x.current = m.current({
          ...s.current.floatingContext,
          tree: a,
          x: U.clientX,
          y: U.clientY,
          onClose() {
            j(), z(), $() || W(U, !0, "safe-polygon");
          }
        });
        const L = x.current;
        K.addEventListener("mousemove", L), E.current = () => {
          K.removeEventListener("mousemove", L);
        };
        return;
      }
      (v.current === "touch" ? !Nr(u.floating, U.relatedTarget) : !0) && W(U);
    }
    function S(U) {
      $() || s.current.floatingContext && (m.current == null || m.current({
        ...s.current.floatingContext,
        tree: a,
        x: U.clientX,
        y: U.clientY,
        onClose() {
          j(), z(), $() || W(U);
        }
      })(U));
    }
    if (Vn(u.domReference)) {
      var A;
      const U = u.domReference;
      return r && U.addEventListener("mouseleave", S), (A = u.floating) == null || A.addEventListener("mouseleave", S), n && U.addEventListener("mousemove", T, {
        once: !0
      }), U.addEventListener("mouseenter", T), U.addEventListener("mouseleave", F), () => {
        var K;
        r && U.removeEventListener("mouseleave", S), (K = u.floating) == null || K.removeEventListener("mouseleave", S), n && U.removeEventListener("mousemove", T), U.removeEventListener("mouseenter", T), U.removeEventListener("mouseleave", F);
      };
    }
  }, [u, l, t, g, p, n, W, z, j, i, r, w, a, b, m, s, $]), qn(() => {
    var T;
    if (l && r && (T = m.current) != null && T.__options.blockPointerEvents && R()) {
      O.current = !0;
      const S = u.floating;
      if (Vn(u.domReference) && S) {
        var F;
        const A = Gr(u.floating).body;
        A.setAttribute(jC, "");
        const U = u.domReference, K = a == null || (F = a.nodesRef.current.find((X) => X.id === d)) == null || (F = F.context) == null ? void 0 : F.elements.floating;
        return K && (K.style.pointerEvents = ""), A.style.pointerEvents = "none", U.style.pointerEvents = "auto", S.style.pointerEvents = "auto", () => {
          A.style.pointerEvents = "", U.style.pointerEvents = "", S.style.pointerEvents = "";
        };
      }
    }
  }, [l, r, d, u, a, m, R]), qn(() => {
    r || (v.current = void 0, I.current = !1, z(), j());
  }, [r, z, j]), pt.useEffect(() => () => {
    z(), clearTimeout(h.current), clearTimeout(_.current), j();
  }, [l, u.domReference, z, j]);
  const B = pt.useMemo(() => {
    function T(F) {
      v.current = F.pointerType;
    }
    return {
      onPointerDown: T,
      onPointerEnter: T,
      onMouseMove(F) {
        const {
          nativeEvent: S
        } = F;
        function A() {
          !M.current && !w.current && i(!0, S, "hover");
        }
        g && !h0(v.current) || r || p === 0 || I.current && F.movementX ** 2 + F.movementY ** 2 < 2 || (clearTimeout(_.current), v.current === "touch" ? A() : (I.current = !0, _.current = window.setTimeout(A, p)));
      }
    };
  }, [g, i, r, w, p]), C = pt.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(h.current);
    },
    onMouseLeave(T) {
      $() || W(T.nativeEvent, !1);
    }
  }), [W, $]);
  return pt.useMemo(() => l ? {
    reference: B,
    floating: C
  } : {}, [l, B, C]);
}
let UC = 0;
function No(t, e) {
  e === void 0 && (e = {});
  const {
    preventScroll: r = !1,
    cancelPrevious: i = !0,
    sync: s = !1
  } = e;
  i && cancelAnimationFrame(UC);
  const c = () => t == null ? void 0 : t.focus({
    preventScroll: r
  });
  s ? c() : UC = requestAnimationFrame(c);
}
function j3t(t, e) {
  var r;
  let i = [], s = (r = t.find((c) => c.id === e)) == null ? void 0 : r.parentId;
  for (; s; ) {
    const c = t.find((u) => u.id === s);
    s = c == null ? void 0 : c.parentId, c && (i = i.concat(c));
  }
  return i;
}
function zu(t, e) {
  let r = t.filter((s) => {
    var c;
    return s.parentId === e && ((c = s.context) == null ? void 0 : c.open);
  }), i = r;
  for (; i.length; )
    i = t.filter((s) => {
      var c;
      return (c = i) == null ? void 0 : c.some((u) => {
        var l;
        return s.parentId === u.id && ((l = s.context) == null ? void 0 : l.open);
      });
    }), r = r.concat(i);
  return r;
}
function U3t(t, e) {
  let r, i = -1;
  function s(c, u) {
    u > i && (r = c, i = u), zu(t, c).forEach((f) => {
      s(f.id, u + 1);
    });
  }
  return s(e, 0), t.find((c) => c.id === r);
}
let bu = /* @__PURE__ */ new WeakMap(), Bd = /* @__PURE__ */ new WeakSet(), jd = {}, h3 = 0;
const H3t = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, TP = (t) => t && (t.host || TP(t.parentNode)), V3t = (t, e) => e.map((r) => {
  if (t.contains(r))
    return r;
  const i = TP(r);
  return t.contains(i) ? i : null;
}).filter((r) => r != null);
function z3t(t, e, r, i) {
  const s = "data-floating-ui-inert", c = i ? "inert" : r ? "aria-hidden" : null, u = V3t(e, t), l = /* @__PURE__ */ new Set(), f = new Set(u), o = [];
  jd[s] || (jd[s] = /* @__PURE__ */ new WeakMap());
  const g = jd[s];
  u.forEach(p), n(e), l.clear();
  function p(a) {
    !a || l.has(a) || (l.add(a), a.parentNode && p(a.parentNode));
  }
  function n(a) {
    !a || f.has(a) || [].forEach.call(a.children, (d) => {
      if (Sl(d) !== "script")
        if (l.has(d))
          n(d);
        else {
          const m = c ? d.getAttribute(c) : null, b = m !== null && m !== "false", w = (bu.get(d) || 0) + 1, v = (g.get(d) || 0) + 1;
          bu.set(d, w), g.set(d, v), o.push(d), w === 1 && b && Bd.add(d), v === 1 && d.setAttribute(s, ""), !b && c && d.setAttribute(c, "true");
        }
    });
  }
  return h3++, () => {
    o.forEach((a) => {
      const d = (bu.get(a) || 0) - 1, m = (g.get(a) || 0) - 1;
      bu.set(a, d), g.set(a, m), d || (!Bd.has(a) && c && a.removeAttribute(c), Bd.delete(a)), m || a.removeAttribute(s);
    }), h3--, h3 || (bu = /* @__PURE__ */ new WeakMap(), bu = /* @__PURE__ */ new WeakMap(), Bd = /* @__PURE__ */ new WeakSet(), jd = {});
  };
}
function HC(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  const i = Gr(t[0]).body;
  return z3t(t.concat(Array.from(i.querySelectorAll("[aria-live]"))), i, e, r);
}
const Th = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function MP(t, e) {
  const r = jp(t, Th());
  e === "prev" && r.reverse();
  const i = r.indexOf(Ga(Gr(t)));
  return r.slice(i + 1)[0];
}
function EP() {
  return MP(document.body, "next");
}
function PP() {
  return MP(document.body, "prev");
}
function Q1(t, e) {
  const r = e || t.currentTarget, i = t.relatedTarget;
  return !i || !Nr(r, i);
}
function X3t(t) {
  jp(t, Th()).forEach((r) => {
    r.dataset.tabindex = r.getAttribute("tabindex") || "", r.setAttribute("tabindex", "-1");
  });
}
function VC(t) {
  t.querySelectorAll("[data-tabindex]").forEach((r) => {
    const i = r.dataset.tabindex;
    delete r.dataset.tabindex, i ? r.setAttribute("tabindex", i) : r.removeAttribute("tabindex");
  });
}
const Hp = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let q3t;
function zC(t) {
  t.key === "Tab" && (t.target, clearTimeout(q3t));
}
const jg = /* @__PURE__ */ pt.forwardRef(function(e, r) {
  const [i, s] = pt.useState();
  qn(() => (s8() && s("button"), document.addEventListener("keydown", zC), () => {
    document.removeEventListener("keydown", zC);
  }), []);
  const c = {
    ref: r,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: i,
    "aria-hidden": i ? void 0 : !0,
    [Tc("focus-guard")]: "",
    style: Hp
  };
  return /* @__PURE__ */ pt.createElement("span", kh({}, e, c));
}), IP = /* @__PURE__ */ pt.createContext(null), XC = /* @__PURE__ */ Tc("portal");
function W3t(t) {
  t === void 0 && (t = {});
  const {
    id: e,
    root: r
  } = t, i = Fa(), s = FP(), [c, u] = pt.useState(null), l = pt.useRef(null);
  return qn(() => () => {
    c == null || c.remove(), queueMicrotask(() => {
      l.current = null;
    });
  }, [c]), qn(() => {
    if (!i || l.current) return;
    const f = e ? document.getElementById(e) : null;
    if (!f) return;
    const o = document.createElement("div");
    o.id = i, o.setAttribute(XC, ""), f.appendChild(o), l.current = o, u(o);
  }, [e, i]), qn(() => {
    if (r === null || !i || l.current) return;
    let f = r || (s == null ? void 0 : s.portalNode);
    f && !Vn(f) && (f = f.current), f = f || document.body;
    let o = null;
    e && (o = document.createElement("div"), o.id = e, f.appendChild(o));
    const g = document.createElement("div");
    g.id = i, g.setAttribute(XC, ""), f = o || f, f.appendChild(g), l.current = g, u(g);
  }, [e, r, i, s]), c;
}
function af(t) {
  const {
    children: e,
    id: r,
    root: i,
    preserveTabOrder: s = !0
  } = t, c = W3t({
    id: r,
    root: i
  }), [u, l] = pt.useState(null), f = pt.useRef(null), o = pt.useRef(null), g = pt.useRef(null), p = pt.useRef(null), n = u == null ? void 0 : u.modal, a = u == null ? void 0 : u.open, d = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!u && // Guards are only for non-modal focus management.
    !u.modal && // Don't render if unmount is transitioning.
    u.open && s && !!(i || c)
  );
  return pt.useEffect(() => {
    if (!c || !s || n)
      return;
    function m(b) {
      c && Q1(b) && (b.type === "focusin" ? VC : X3t)(c);
    }
    return c.addEventListener("focusin", m, !0), c.addEventListener("focusout", m, !0), () => {
      c.removeEventListener("focusin", m, !0), c.removeEventListener("focusout", m, !0);
    };
  }, [c, s, n]), pt.useEffect(() => {
    c && (a || VC(c));
  }, [a, c]), /* @__PURE__ */ pt.createElement(IP.Provider, {
    value: pt.useMemo(() => ({
      preserveTabOrder: s,
      beforeOutsideRef: f,
      afterOutsideRef: o,
      beforeInsideRef: g,
      afterInsideRef: p,
      portalNode: c,
      setFocusManagerState: l
    }), [s, c])
  }, d && c && /* @__PURE__ */ pt.createElement(jg, {
    "data-type": "outside",
    ref: f,
    onFocus: (m) => {
      if (Q1(m, c)) {
        var b;
        (b = g.current) == null || b.focus();
      } else {
        const w = PP() || (u == null ? void 0 : u.refs.domReference.current);
        w == null || w.focus();
      }
    }
  }), d && c && /* @__PURE__ */ pt.createElement("span", {
    "aria-owns": c.id,
    style: Hp
  }), c && /* @__PURE__ */ gA.createPortal(e, c), d && c && /* @__PURE__ */ pt.createElement(jg, {
    "data-type": "outside",
    ref: o,
    onFocus: (m) => {
      if (Q1(m, c)) {
        var b;
        (b = p.current) == null || b.focus();
      } else {
        const w = EP() || (u == null ? void 0 : u.refs.domReference.current);
        w == null || w.focus(), u != null && u.closeOnFocusOut && (u == null || u.onOpenChange(!1, m.nativeEvent, "focus-out"));
      }
    }
  }));
}
const FP = () => pt.useContext(IP), L6 = "data-floating-ui-focusable";
function RP(t) {
  return t ? t.hasAttribute(L6) ? t : t.querySelector("[" + L6 + "]") || t : null;
}
const G3t = 20;
let Yl = [];
function f3(t) {
  Yl = Yl.filter((r) => r.isConnected);
  let e = t;
  if (!(!e || Sl(e) === "body")) {
    if (!Gmt(e, Th())) {
      const r = jp(e, Th())[0];
      r && (e = r);
    }
    Yl.push(e), Yl.length > G3t && (Yl = Yl.slice(-20));
  }
}
function qC() {
  return Yl.slice().reverse().find((t) => t.isConnected);
}
const K3t = /* @__PURE__ */ pt.forwardRef(function(e, r) {
  return /* @__PURE__ */ pt.createElement("button", kh({}, e, {
    type: "button",
    ref: r,
    tabIndex: -1,
    style: Hp
  }));
});
function Vp(t) {
  const {
    context: e,
    children: r,
    disabled: i = !1,
    order: s = ["content"],
    guards: c = !0,
    initialFocus: u = 0,
    returnFocus: l = !0,
    restoreFocus: f = !1,
    modal: o = !0,
    visuallyHiddenDismiss: g = !1,
    closeOnFocusOut: p = !0
  } = t, {
    open: n,
    refs: a,
    nodeId: d,
    onOpenChange: m,
    events: b,
    dataRef: w,
    floatingId: v,
    elements: {
      domReference: h,
      floating: x
    }
  } = e, _ = typeof u == "number" && u < 0, M = F6(h) && _, O = H3t() ? c : !0, E = la(s), I = la(u), R = la(l), W = rf(), z = FP(), j = pt.useRef(null), $ = pt.useRef(null), B = pt.useRef(!1), C = pt.useRef(!1), T = pt.useRef(-1), F = z != null, S = RP(x), A = _r(function(L) {
    return L === void 0 && (L = S), L ? jp(L, Th()) : [];
  }), U = _r((L) => {
    const H = A(L);
    return E.current.map((Q) => h && Q === "reference" ? h : S && Q === "floating" ? S : H).filter(Boolean).flat();
  });
  pt.useEffect(() => {
    if (i || !o) return;
    function L(Q) {
      if (Q.key === "Tab") {
        Nr(S, Ga(Gr(S))) && A().length === 0 && !M && Wr(Q);
        const N = U(), V = Zs(Q);
        E.current[0] === "reference" && V === h && (Wr(Q), Q.shiftKey ? No(N[N.length - 1]) : No(N[1])), E.current[1] === "floating" && V === S && Q.shiftKey && (Wr(Q), No(N[0]));
      }
    }
    const H = Gr(S);
    return H.addEventListener("keydown", L), () => {
      H.removeEventListener("keydown", L);
    };
  }, [i, h, S, o, E, M, A, U]), pt.useEffect(() => {
    if (i || !x) return;
    function L(H) {
      const Q = Zs(H), V = A().indexOf(Q);
      V !== -1 && (T.current = V);
    }
    return x.addEventListener("focusin", L), () => {
      x.removeEventListener("focusin", L);
    };
  }, [i, x, A]), pt.useEffect(() => {
    if (i || !p) return;
    function L() {
      C.current = !0, setTimeout(() => {
        C.current = !1;
      });
    }
    function H(Q) {
      const N = Q.relatedTarget;
      queueMicrotask(() => {
        const V = !(Nr(h, N) || Nr(x, N) || Nr(N, x) || Nr(z == null ? void 0 : z.portalNode, N) || N != null && N.hasAttribute(Tc("focus-guard")) || W && (zu(W.nodesRef.current, d).find((Y) => {
          var Z, rt;
          return Nr((Z = Y.context) == null ? void 0 : Z.elements.floating, N) || Nr((rt = Y.context) == null ? void 0 : rt.elements.domReference, N);
        }) || j3t(W.nodesRef.current, d).find((Y) => {
          var Z, rt;
          return ((Z = Y.context) == null ? void 0 : Z.elements.floating) === N || ((rt = Y.context) == null ? void 0 : rt.elements.domReference) === N;
        })));
        if (f && V && Ga(Gr(S)) === Gr(S).body) {
          Ar(S) && S.focus();
          const Y = T.current, Z = A(), rt = Z[Y] || Z[Z.length - 1] || S;
          Ar(rt) && rt.focus();
        }
        (M || !o) && N && V && !C.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        N !== qC() && (B.current = !0, m(!1, Q, "focus-out"));
      });
    }
    if (x && Ar(h))
      return h.addEventListener("focusout", H), h.addEventListener("pointerdown", L), x.addEventListener("focusout", H), () => {
        h.removeEventListener("focusout", H), h.removeEventListener("pointerdown", L), x.removeEventListener("focusout", H);
      };
  }, [i, h, x, S, o, d, W, z, m, p, f, A, M]), pt.useEffect(() => {
    var L;
    if (i) return;
    const H = Array.from((z == null || (L = z.portalNode) == null ? void 0 : L.querySelectorAll("[" + Tc("portal") + "]")) || []);
    if (x) {
      const Q = [x, ...H, j.current, $.current, E.current.includes("reference") || M ? h : null].filter((V) => V != null), N = o || M ? HC(Q, O, !O) : HC(Q);
      return () => {
        N();
      };
    }
  }, [i, h, x, o, E, z, M, O]), qn(() => {
    if (i || !Ar(S)) return;
    const L = Gr(S), H = Ga(L);
    queueMicrotask(() => {
      const Q = U(S), N = I.current, V = (typeof N == "number" ? Q[N] : N.current) || S, Y = Nr(S, H);
      !_ && !Y && n && No(V, {
        preventScroll: V === S
      });
    });
  }, [i, n, S, _, U, I]), qn(() => {
    if (i || !S) return;
    let L = !1;
    const H = Gr(S), Q = Ga(H);
    let V = w.current.openEvent;
    f3(Q);
    function Y(st) {
      let {
        open: mt,
        reason: yt,
        event: at,
        nested: nt
      } = st;
      mt && (V = at), yt === "escape-key" && a.domReference.current && f3(a.domReference.current), yt === "hover" && at.type === "mouseleave" && (B.current = !0), yt === "outside-press" && (nt ? (B.current = !1, L = !0) : B.current = !(hP(at) || a8(at)));
    }
    b.on("openchange", Y);
    const Z = H.createElement("span");
    Z.setAttribute("tabindex", "-1"), Z.setAttribute("aria-hidden", "true"), Object.assign(Z.style, Hp), F && h && h.insertAdjacentElement("afterend", Z);
    function rt() {
      return typeof R.current == "boolean" ? qC() || Z : R.current.current || Z;
    }
    return () => {
      b.off("openchange", Y);
      const st = Ga(H), mt = Nr(x, st) || W && zu(W.nodesRef.current, d).some((nt) => {
        var q;
        return Nr((q = nt.context) == null ? void 0 : q.elements.floating, st);
      });
      (mt || V && ["click", "mousedown"].includes(V.type)) && a.domReference.current && f3(a.domReference.current);
      const at = rt();
      queueMicrotask(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        R.current && !B.current && Ar(at) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(at !== st && st !== H.body) || mt) && at.focus({
          preventScroll: L
        }), Z.remove();
      });
    };
  }, [i, x, S, R, w, a, b, W, d, F, h]), pt.useEffect(() => {
    queueMicrotask(() => {
      B.current = !1;
    });
  }, [i]), qn(() => {
    if (!i && z)
      return z.setFocusManagerState({
        modal: o,
        closeOnFocusOut: p,
        open: n,
        onOpenChange: m,
        refs: a
      }), () => {
        z.setFocusManagerState(null);
      };
  }, [i, z, o, n, m, a, p]), qn(() => {
    if (i || !S || typeof MutationObserver != "function" || _) return;
    const L = () => {
      const Q = S.getAttribute("tabindex"), N = A(), V = Ga(Gr(x)), Y = N.indexOf(V);
      Y !== -1 && (T.current = Y), E.current.includes("floating") || V !== a.domReference.current && N.length === 0 ? Q !== "0" && S.setAttribute("tabindex", "0") : Q !== "-1" && S.setAttribute("tabindex", "-1");
    };
    L();
    const H = new MutationObserver(L);
    return H.observe(S, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      H.disconnect();
    };
  }, [i, x, S, a, E, A, _]);
  function K(L) {
    return i || !g || !o ? null : /* @__PURE__ */ pt.createElement(K3t, {
      ref: L === "start" ? j : $,
      onClick: (H) => m(!1, H.nativeEvent)
    }, typeof g == "string" ? g : "Dismiss");
  }
  const X = !i && O && (o ? !M : !0) && (F || o);
  return /* @__PURE__ */ pt.createElement(pt.Fragment, null, X && /* @__PURE__ */ pt.createElement(jg, {
    "data-type": "inside",
    ref: z == null ? void 0 : z.beforeInsideRef,
    onFocus: (L) => {
      if (o) {
        const Q = U();
        No(s[0] === "reference" ? Q[0] : Q[Q.length - 1]);
      } else if (z != null && z.preserveTabOrder && z.portalNode)
        if (B.current = !1, Q1(L, z.portalNode)) {
          const Q = EP() || h;
          Q == null || Q.focus();
        } else {
          var H;
          (H = z.beforeOutsideRef.current) == null || H.focus();
        }
    }
  }), !M && K("start"), r, K("end"), X && /* @__PURE__ */ pt.createElement(jg, {
    "data-type": "inside",
    ref: z == null ? void 0 : z.afterInsideRef,
    onFocus: (L) => {
      if (o)
        No(U()[0]);
      else if (z != null && z.preserveTabOrder && z.portalNode)
        if (p && (B.current = !0), Q1(L, z.portalNode)) {
          const Q = PP() || h;
          Q == null || Q.focus();
        } else {
          var H;
          (H = z.afterOutsideRef.current) == null || H.focus();
        }
    }
  }));
}
function WC(t) {
  return Ar(t.target) && t.target.tagName === "BUTTON";
}
function GC(t) {
  return o8(t);
}
function zp(t, e) {
  e === void 0 && (e = {});
  const {
    open: r,
    onOpenChange: i,
    dataRef: s,
    elements: {
      domReference: c
    }
  } = t, {
    enabled: u = !0,
    event: l = "click",
    toggle: f = !0,
    ignoreMouse: o = !1,
    keyboardHandlers: g = !0,
    stickIfOpen: p = !0
  } = e, n = pt.useRef(), a = pt.useRef(!1), d = pt.useMemo(() => ({
    onPointerDown(m) {
      n.current = m.pointerType;
    },
    onMouseDown(m) {
      const b = n.current;
      m.button === 0 && l !== "click" && (h0(b, !0) && o || (r && f && (!(s.current.openEvent && p) || s.current.openEvent.type === "mousedown") ? i(!1, m.nativeEvent, "click") : (m.preventDefault(), i(!0, m.nativeEvent, "click"))));
    },
    onClick(m) {
      const b = n.current;
      if (l === "mousedown" && n.current) {
        n.current = void 0;
        return;
      }
      h0(b, !0) && o || (r && f && (!(s.current.openEvent && p) || s.current.openEvent.type === "click") ? i(!1, m.nativeEvent, "click") : i(!0, m.nativeEvent, "click"));
    },
    onKeyDown(m) {
      n.current = void 0, !(m.defaultPrevented || !g || WC(m)) && (m.key === " " && !GC(c) && (m.preventDefault(), a.current = !0), m.key === "Enter" && i(!(r && f), m.nativeEvent, "click"));
    },
    onKeyUp(m) {
      m.defaultPrevented || !g || WC(m) || GC(c) || m.key === " " && a.current && (a.current = !1, i(!(r && f), m.nativeEvent, "click"));
    }
  }), [s, c, l, o, g, i, r, p, f]);
  return pt.useMemo(() => u ? {
    reference: d
  } : {}, [u, d]);
}
function Y3t(t, e) {
  let r = null, i = null, s = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      var c;
      const u = (t == null ? void 0 : t.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, l = e.axis === "x" || e.axis === "both", f = e.axis === "y" || e.axis === "both", o = ["mouseenter", "mousemove"].includes(((c = e.dataRef.current.openEvent) == null ? void 0 : c.type) || "") && e.pointerType !== "touch";
      let g = u.width, p = u.height, n = u.x, a = u.y;
      return r == null && e.x && l && (r = u.x - e.x), i == null && e.y && f && (i = u.y - e.y), n -= r || 0, a -= i || 0, g = 0, p = 0, !s || o ? (g = e.axis === "y" ? u.width : 0, p = e.axis === "x" ? u.height : 0, n = l && e.x != null ? e.x : n, a = f && e.y != null ? e.y : a) : s && !o && (p = e.axis === "x" ? u.height : p, g = e.axis === "y" ? u.width : g), s = !0, {
        width: g,
        height: p,
        x: n,
        y: a,
        top: a,
        right: n + g,
        bottom: a + p,
        left: n
      };
    }
  };
}
function KC(t) {
  return t != null && t.clientX != null;
}
function Z3t(t, e) {
  e === void 0 && (e = {});
  const {
    open: r,
    dataRef: i,
    elements: {
      floating: s,
      domReference: c
    },
    refs: u
  } = t, {
    enabled: l = !0,
    axis: f = "both",
    x: o = null,
    y: g = null
  } = e, p = pt.useRef(!1), n = pt.useRef(null), [a, d] = pt.useState(), [m, b] = pt.useState([]), w = _r((M, O) => {
    p.current || i.current.openEvent && !KC(i.current.openEvent) || u.setPositionReference(Y3t(c, {
      x: M,
      y: O,
      axis: f,
      dataRef: i,
      pointerType: a
    }));
  }), v = _r((M) => {
    o != null || g != null || (r ? n.current || b([]) : w(M.clientX, M.clientY));
  }), h = h0(a) ? s : r, x = pt.useCallback(() => {
    if (!h || !l || o != null || g != null) return;
    const M = Mi(s);
    function O(E) {
      const I = Zs(E);
      Nr(s, I) ? (M.removeEventListener("mousemove", O), n.current = null) : w(E.clientX, E.clientY);
    }
    if (!i.current.openEvent || KC(i.current.openEvent)) {
      M.addEventListener("mousemove", O);
      const E = () => {
        M.removeEventListener("mousemove", O), n.current = null;
      };
      return n.current = E, E;
    }
    u.setPositionReference(c);
  }, [h, l, o, g, s, i, u, c, w]);
  pt.useEffect(() => x(), [x, m]), pt.useEffect(() => {
    l && !s && (p.current = !1);
  }, [l, s]), pt.useEffect(() => {
    !l && r && (p.current = !0);
  }, [l, r]), qn(() => {
    l && (o != null || g != null) && (p.current = !1, w(o, g));
  }, [l, o, g, w]);
  const _ = pt.useMemo(() => {
    function M(O) {
      let {
        pointerType: E
      } = O;
      d(E);
    }
    return {
      onPointerDown: M,
      onPointerEnter: M,
      onMouseMove: v,
      onMouseEnter: v
    };
  }, [v]);
  return pt.useMemo(() => l ? {
    reference: _
  } : {}, [l, _]);
}
const J3t = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, Q3t = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, YC = (t) => {
  var e, r;
  return {
    escapeKey: typeof t == "boolean" ? t : (e = t == null ? void 0 : t.escapeKey) != null ? e : !1,
    outsidePress: typeof t == "boolean" ? t : (r = t == null ? void 0 : t.outsidePress) != null ? r : !0
  };
};
function sf(t, e) {
  e === void 0 && (e = {});
  const {
    open: r,
    onOpenChange: i,
    elements: s,
    dataRef: c
  } = t, {
    enabled: u = !0,
    escapeKey: l = !0,
    outsidePress: f = !0,
    outsidePressEvent: o = "pointerdown",
    referencePress: g = !1,
    referencePressEvent: p = "pointerdown",
    ancestorScroll: n = !1,
    bubbles: a,
    capture: d
  } = e, m = rf(), b = _r(typeof f == "function" ? f : () => !1), w = typeof f == "function" ? b : f, v = pt.useRef(!1), h = pt.useRef(!1), {
    escapeKey: x,
    outsidePress: _
  } = YC(a), {
    escapeKey: M,
    outsidePress: O
  } = YC(d), E = pt.useRef(!1), I = _r((B) => {
    var C;
    if (!r || !u || !l || B.key !== "Escape" || E.current)
      return;
    const T = (C = c.current.floatingContext) == null ? void 0 : C.nodeId, F = m ? zu(m.nodesRef.current, T) : [];
    if (!x && (B.stopPropagation(), F.length > 0)) {
      let S = !0;
      if (F.forEach((A) => {
        var U;
        if ((U = A.context) != null && U.open && !A.context.dataRef.current.__escapeKeyBubbles) {
          S = !1;
          return;
        }
      }), !S)
        return;
    }
    i(!1, wmt(B) ? B.nativeEvent : B, "escape-key");
  }), R = _r((B) => {
    var C;
    const T = () => {
      var F;
      I(B), (F = Zs(B)) == null || F.removeEventListener("keydown", T);
    };
    (C = Zs(B)) == null || C.addEventListener("keydown", T);
  }), W = _r((B) => {
    var C;
    const T = v.current;
    v.current = !1;
    const F = h.current;
    if (h.current = !1, o === "click" && F || T || typeof w == "function" && !w(B))
      return;
    const S = Zs(B), A = "[" + Tc("inert") + "]", U = Gr(s.floating).querySelectorAll(A);
    let K = Vn(S) ? S : null;
    for (; K && !fl(K); ) {
      const Q = po(K);
      if (fl(Q) || !Vn(Q))
        break;
      K = Q;
    }
    if (U.length && Vn(S) && !xmt(S) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Nr(S, s.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(U).every((Q) => !Nr(K, Q)))
      return;
    if (Ar(S) && $) {
      const Q = S.clientWidth > 0 && S.scrollWidth > S.clientWidth, N = S.clientHeight > 0 && S.scrollHeight > S.clientHeight;
      let V = N && B.offsetX > S.clientWidth;
      if (N && ma(S).direction === "rtl" && (V = B.offsetX <= S.offsetWidth - S.clientWidth), V || Q && B.offsetY > S.clientHeight)
        return;
    }
    const X = (C = c.current.floatingContext) == null ? void 0 : C.nodeId, L = m && zu(m.nodesRef.current, X).some((Q) => {
      var N;
      return s3(B, (N = Q.context) == null ? void 0 : N.elements.floating);
    });
    if (s3(B, s.floating) || s3(B, s.domReference) || L)
      return;
    const H = m ? zu(m.nodesRef.current, X) : [];
    if (H.length > 0) {
      let Q = !0;
      if (H.forEach((N) => {
        var V;
        if ((V = N.context) != null && V.open && !N.context.dataRef.current.__outsidePressBubbles) {
          Q = !1;
          return;
        }
      }), !Q)
        return;
    }
    i(!1, B, "outside-press");
  }), z = _r((B) => {
    var C;
    const T = () => {
      var F;
      W(B), (F = Zs(B)) == null || F.removeEventListener(o, T);
    };
    (C = Zs(B)) == null || C.addEventListener(o, T);
  });
  pt.useEffect(() => {
    if (!r || !u)
      return;
    c.current.__escapeKeyBubbles = x, c.current.__outsidePressBubbles = _;
    let B = -1;
    function C(U) {
      i(!1, U, "ancestor-scroll");
    }
    function T() {
      window.clearTimeout(B), E.current = !0;
    }
    function F() {
      B = window.setTimeout(
        () => {
          E.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Np() ? 5 : 0
      );
    }
    const S = Gr(s.floating);
    l && (S.addEventListener("keydown", M ? R : I, M), S.addEventListener("compositionstart", T), S.addEventListener("compositionend", F)), w && S.addEventListener(o, O ? z : W, O);
    let A = [];
    return n && (Vn(s.domReference) && (A = tl(s.domReference)), Vn(s.floating) && (A = A.concat(tl(s.floating))), !Vn(s.reference) && s.reference && s.reference.contextElement && (A = A.concat(tl(s.reference.contextElement)))), A = A.filter((U) => {
      var K;
      return U !== ((K = S.defaultView) == null ? void 0 : K.visualViewport);
    }), A.forEach((U) => {
      U.addEventListener("scroll", C, {
        passive: !0
      });
    }), () => {
      l && (S.removeEventListener("keydown", M ? R : I, M), S.removeEventListener("compositionstart", T), S.removeEventListener("compositionend", F)), w && S.removeEventListener(o, O ? z : W, O), A.forEach((U) => {
        U.removeEventListener("scroll", C);
      }), window.clearTimeout(B);
    };
  }, [c, s, l, w, o, r, i, n, u, x, _, I, M, R, W, O, z]), pt.useEffect(() => {
    v.current = !1;
  }, [w, o]);
  const j = pt.useMemo(() => ({
    onKeyDown: I,
    [J3t[p]]: (B) => {
      g && i(!1, B.nativeEvent, "reference-press");
    }
  }), [I, i, g, p]), $ = pt.useMemo(() => ({
    onKeyDown: I,
    onMouseDown() {
      h.current = !0;
    },
    onMouseUp() {
      h.current = !0;
    },
    [Q3t[o]]: () => {
      v.current = !0;
    }
  }), [I, o]);
  return pt.useMemo(() => u ? {
    reference: j,
    floating: $
  } : {}, [u, j, $]);
}
function t9t(t) {
  const {
    open: e = !1,
    onOpenChange: r,
    elements: i
  } = t, s = Fa(), c = pt.useRef({}), [u] = pt.useState(() => $3t()), l = Up() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = i.reference;
    a && !Vn(a) && R3t("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [f, o] = pt.useState(i.reference), g = _r((a, d, m) => {
    c.current.openEvent = a ? d : void 0, u.emit("openchange", {
      open: a,
      event: d,
      reason: m,
      nested: l
    }), r == null || r(a, d, m);
  }), p = pt.useMemo(() => ({
    setPositionReference: o
  }), []), n = pt.useMemo(() => ({
    reference: f || i.reference || null,
    floating: i.floating || null,
    domReference: i.reference
  }), [f, i.reference, i.floating]);
  return pt.useMemo(() => ({
    dataRef: c,
    open: e,
    onOpenChange: g,
    elements: n,
    events: u,
    floatingId: s,
    refs: p
  }), [e, g, n, u, s, p]);
}
function Nc(t) {
  t === void 0 && (t = {});
  const {
    nodeId: e
  } = t, r = t9t({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), i = t.rootContext || r, s = i.elements, [c, u] = pt.useState(null), [l, f] = pt.useState(null), g = (s == null ? void 0 : s.domReference) || c, p = pt.useRef(null), n = rf();
  qn(() => {
    g && (p.current = g);
  }, [g]);
  const a = S3t({
    ...t,
    elements: {
      ...s,
      ...l && {
        reference: l
      }
    }
  }), d = pt.useCallback((h) => {
    const x = Vn(h) ? {
      getBoundingClientRect: () => h.getBoundingClientRect(),
      contextElement: h
    } : h;
    f(x), a.refs.setReference(x);
  }, [a.refs]), m = pt.useCallback((h) => {
    (Vn(h) || h === null) && (p.current = h, u(h)), (Vn(a.refs.reference.current) || a.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    h !== null && !Vn(h)) && a.refs.setReference(h);
  }, [a.refs]), b = pt.useMemo(() => ({
    ...a.refs,
    setReference: m,
    setPositionReference: d,
    domReference: p
  }), [a.refs, m, d]), w = pt.useMemo(() => ({
    ...a.elements,
    domReference: g
  }), [a.elements, g]), v = pt.useMemo(() => ({
    ...a,
    ...i,
    refs: b,
    elements: w,
    nodeId: e
  }), [a, b, w, e, i]);
  return qn(() => {
    i.dataRef.current.floatingContext = v;
    const h = n == null ? void 0 : n.nodesRef.current.find((x) => x.id === e);
    h && (h.context = v);
  }), pt.useMemo(() => ({
    ...a,
    context: v,
    refs: b,
    elements: w
  }), [a, b, w, v]);
}
function e9t(t, e) {
  e === void 0 && (e = {});
  const {
    open: r,
    onOpenChange: i,
    events: s,
    dataRef: c,
    elements: u
  } = t, {
    enabled: l = !0,
    visibleOnly: f = !0
  } = e, o = pt.useRef(!1), g = pt.useRef(), p = pt.useRef(!0);
  pt.useEffect(() => {
    if (!l) return;
    const a = Mi(u.domReference);
    function d() {
      !r && Ar(u.domReference) && u.domReference === Ga(Gr(u.domReference)) && (o.current = !0);
    }
    function m() {
      p.current = !0;
    }
    return a.addEventListener("blur", d), a.addEventListener("keydown", m, !0), () => {
      a.removeEventListener("blur", d), a.removeEventListener("keydown", m, !0);
    };
  }, [u.domReference, r, l]), pt.useEffect(() => {
    if (!l) return;
    function a(d) {
      let {
        reason: m
      } = d;
      (m === "reference-press" || m === "escape-key") && (o.current = !0);
    }
    return s.on("openchange", a), () => {
      s.off("openchange", a);
    };
  }, [s, l]), pt.useEffect(() => () => {
    clearTimeout(g.current);
  }, []);
  const n = pt.useMemo(() => ({
    onPointerDown(a) {
      a8(a.nativeEvent) || (p.current = !1);
    },
    onMouseLeave() {
      o.current = !1;
    },
    onFocus(a) {
      if (o.current) return;
      const d = Zs(a.nativeEvent);
      if (f && Vn(d))
        try {
          if (s8() && fP()) throw Error();
          if (!d.matches(":focus-visible")) return;
        } catch {
          if (!p.current && !o8(d))
            return;
        }
      i(!0, a.nativeEvent, "focus");
    },
    onBlur(a) {
      o.current = !1;
      const d = a.relatedTarget, m = a.nativeEvent, b = Vn(d) && d.hasAttribute(Tc("focus-guard")) && d.getAttribute("data-type") === "outside";
      g.current = window.setTimeout(() => {
        var w;
        const v = Ga(u.domReference ? u.domReference.ownerDocument : document);
        !d && v === u.domReference || Nr((w = c.current.floatingContext) == null ? void 0 : w.refs.floating.current, v) || Nr(u.domReference, v) || b || i(!1, m, "focus");
      });
    }
  }), [c, u.domReference, i, f]);
  return pt.useMemo(() => l ? {
    reference: n
  } : {}, [l, n]);
}
const ZC = "active", JC = "selected";
function d3(t, e, r) {
  const i = /* @__PURE__ */ new Map(), s = r === "item";
  let c = t;
  if (s && t) {
    const {
      [ZC]: u,
      [JC]: l,
      ...f
    } = t;
    c = f;
  }
  return {
    ...r === "floating" && {
      tabIndex: -1,
      [L6]: ""
    },
    ...c,
    ...e.map((u) => {
      const l = u ? u[r] : null;
      return typeof l == "function" ? t ? l(t) : null : l;
    }).concat(t).reduce((u, l) => (l && Object.entries(l).forEach((f) => {
      let [o, g] = f;
      if (!(s && [ZC, JC].includes(o)))
        if (o.indexOf("on") === 0) {
          if (i.has(o) || i.set(o, []), typeof g == "function") {
            var p;
            (p = i.get(o)) == null || p.push(g), u[o] = function() {
              for (var n, a = arguments.length, d = new Array(a), m = 0; m < a; m++)
                d[m] = arguments[m];
              return (n = i.get(o)) == null ? void 0 : n.map((b) => b(...d)).find((b) => b !== void 0);
            };
          }
        } else
          u[o] = g;
    }), u), {})
  };
}
function of(t) {
  t === void 0 && (t = []);
  const e = t.map((l) => l == null ? void 0 : l.reference), r = t.map((l) => l == null ? void 0 : l.floating), i = t.map((l) => l == null ? void 0 : l.item), s = pt.useCallback(
    (l) => d3(l, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), c = pt.useCallback(
    (l) => d3(l, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), u = pt.useCallback(
    (l) => d3(l, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    i
  );
  return pt.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: c,
    getItemProps: u
  }), [s, c, u]);
}
let QC = !1;
function Xp(t, e, r) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return r;
    default:
      return e || r;
  }
}
function tA(t, e) {
  return Xp(e, t === g8 || t === nf, t === el || t === nl);
}
function g3(t, e, r) {
  return Xp(e, t === nf, r ? t === el : t === nl) || t === "Enter" || t === " " || t === "";
}
function n9t(t, e, r) {
  return Xp(e, r ? t === el : t === nl, t === nf);
}
function eA(t, e, r) {
  return Xp(e, r ? t === nl : t === el, t === g8);
}
function p8(t, e) {
  const {
    open: r,
    onOpenChange: i,
    elements: s
  } = t, {
    listRef: c,
    activeIndex: u,
    onNavigate: l = () => {
    },
    enabled: f = !0,
    selectedIndex: o = null,
    allowEscape: g = !1,
    loop: p = !1,
    nested: n = !1,
    rtl: a = !1,
    virtual: d = !1,
    focusItemOnOpen: m = "auto",
    focusItemOnHover: b = !0,
    openOnArrowKeyDown: w = !0,
    disabledIndices: v = void 0,
    orientation: h = "vertical",
    cols: x = 1,
    scrollItemIntoView: _ = !0,
    virtualItemRef: M,
    itemSizes: O,
    dense: E = !1
  } = e;
  process.env.NODE_ENV !== "production" && (g && (p || p2("`useListNavigation` looping must be enabled to allow escaping."), d || p2("`useListNavigation` must be virtual to allow escaping.")), h === "vertical" && x > 1 && p2("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const I = RP(s.floating), R = la(I), W = Up(), z = rf(), j = _r(l), $ = F6(s.domReference), B = pt.useRef(m), C = pt.useRef(o ?? -1), T = pt.useRef(null), F = pt.useRef(!0), S = pt.useRef(j), A = pt.useRef(!!s.floating), U = pt.useRef(r), K = pt.useRef(!1), X = pt.useRef(!1), L = la(v), H = la(r), Q = la(_), N = la(o), [V, Y] = pt.useState(), [Z, rt] = pt.useState(), st = _r(function(G, et, J) {
    J === void 0 && (J = !1);
    function it(ot) {
      d ? (Y(ot.id), z == null || z.events.emit("virtualfocus", ot), M && (M.current = ot)) : No(ot, {
        preventScroll: !0,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: fP() && s8() ? QC || K.current : !1
      });
    }
    const lt = G.current[et.current];
    lt && it(lt), requestAnimationFrame(() => {
      const ot = G.current[et.current] || lt;
      if (!ot) return;
      lt || it(ot);
      const ut = Q.current;
      ut && yt && (J || !F.current) && (ot.scrollIntoView == null || ot.scrollIntoView(typeof ut == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : ut));
    });
  });
  qn(() => {
    document.createElement("div").focus({
      get preventScroll() {
        return QC = !0, !1;
      }
    });
  }, []), qn(() => {
    f && (r && s.floating ? B.current && o != null && (X.current = !0, C.current = o, j(o)) : A.current && (C.current = -1, S.current(null)));
  }, [f, r, s.floating, o, j]), qn(() => {
    if (f && r && s.floating)
      if (u == null) {
        if (K.current = !1, N.current != null)
          return;
        if (A.current && (C.current = -1, st(c, C)), (!U.current || !A.current) && B.current && (T.current != null || B.current === !0 && T.current == null)) {
          let G = 0;
          const et = () => {
            c.current[0] == null ? (G < 2 && (G ? requestAnimationFrame : queueMicrotask)(et), G++) : (C.current = T.current == null || g3(T.current, h, a) || n ? c3(c, L.current) : LC(c, L.current), T.current = null, j(C.current));
          };
          et();
        }
      } else J1(c, u) || (C.current = u, st(c, C, X.current), X.current = !1);
  }, [f, r, s.floating, u, N, n, c, h, a, j, st, L]), qn(() => {
    var G;
    if (!f || s.floating || !z || d || !A.current)
      return;
    const et = z.nodesRef.current, J = (G = et.find((ot) => ot.id === W)) == null || (G = G.context) == null ? void 0 : G.elements.floating, it = Ga(Gr(s.floating)), lt = et.some((ot) => ot.context && Nr(ot.context.elements.floating, it));
    J && !lt && F.current && J.focus({
      preventScroll: !0
    });
  }, [f, s.floating, z, W, d]), qn(() => {
    if (!f || !z || !d || W) return;
    function G(et) {
      rt(et.id), M && (M.current = et);
    }
    return z.events.on("virtualfocus", G), () => {
      z.events.off("virtualfocus", G);
    };
  }, [f, z, d, W, M]), qn(() => {
    S.current = j, A.current = !!s.floating;
  }), qn(() => {
    r || (T.current = null);
  }, [r]), qn(() => {
    U.current = r;
  }, [r]);
  const mt = u != null, yt = pt.useMemo(() => {
    function G(J) {
      if (!r) return;
      const it = c.current.indexOf(J);
      it !== -1 && j(it);
    }
    return {
      onFocus(J) {
        let {
          currentTarget: it
        } = J;
        G(it);
      },
      onClick: (J) => {
        let {
          currentTarget: it
        } = J;
        return it.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...b && {
        onMouseMove(J) {
          let {
            currentTarget: it
          } = J;
          G(it);
        },
        onPointerLeave(J) {
          let {
            pointerType: it
          } = J;
          !F.current || it === "touch" || (C.current = -1, st(c, C), j(null), d || No(R.current, {
            preventScroll: !0
          }));
        }
      }
    };
  }, [r, R, st, b, c, j, d]), at = _r((G) => {
    if (F.current = !1, K.current = !0, G.which === 229 || !H.current && G.currentTarget === R.current)
      return;
    if (n && eA(G.key, h, a)) {
      Wr(G), i(!1, G.nativeEvent, "list-navigation"), Ar(s.domReference) && (d ? z == null || z.events.emit("virtualfocus", s.domReference) : s.domReference.focus());
      return;
    }
    const et = C.current, J = c3(c, v), it = LC(c, v);
    if ($ || (G.key === "Home" && (Wr(G), C.current = J, j(C.current)), G.key === "End" && (Wr(G), C.current = it, j(C.current))), x > 1) {
      const lt = O || Array.from({
        length: c.current.length
      }, () => ({
        width: 1,
        height: 1
      })), ot = T3t(lt, x, E), ut = ot.findIndex((dt) => dt != null && !g2(c.current, dt, v)), ct = ot.reduce((dt, bt, vt) => bt != null && !g2(c.current, bt, v) ? vt : dt, -1), gt = ot[O3t({
        current: ot.map((dt) => dt != null ? c.current[dt] : null)
      }, {
        event: G,
        orientation: h,
        loop: p,
        rtl: a,
        cols: x,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: E3t([...v || c.current.map((dt, bt) => g2(c.current, bt) ? bt : void 0), void 0], ot),
        minIndex: ut,
        maxIndex: ct,
        prevIndex: M3t(
          C.current > it ? J : C.current,
          lt,
          ot,
          x,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          G.key === nf ? "bl" : G.key === (a ? el : nl) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (gt != null && (C.current = gt, j(C.current)), h === "both")
        return;
    }
    if (tA(G.key, h)) {
      if (Wr(G), r && !d && Ga(G.currentTarget.ownerDocument) === G.currentTarget) {
        C.current = g3(G.key, h, a) ? J : it, j(C.current);
        return;
      }
      g3(G.key, h, a) ? p ? C.current = et >= it ? g && et !== c.current.length ? -1 : J : ri(c, {
        startingIndex: et,
        disabledIndices: v
      }) : C.current = Math.min(it, ri(c, {
        startingIndex: et,
        disabledIndices: v
      })) : p ? C.current = et <= J ? g && et !== -1 ? c.current.length : it : ri(c, {
        startingIndex: et,
        decrement: !0,
        disabledIndices: v
      }) : C.current = Math.max(J, ri(c, {
        startingIndex: et,
        decrement: !0,
        disabledIndices: v
      })), J1(c, C.current) ? j(null) : j(C.current);
    }
  }), nt = pt.useMemo(() => d && r && mt && {
    "aria-activedescendant": Z || V
  }, [d, r, mt, Z, V]), q = pt.useMemo(() => ({
    "aria-orientation": h === "both" ? void 0 : h,
    ...!F6(s.domReference) && nt,
    onKeyDown: at,
    onPointerMove() {
      F.current = !0;
    }
  }), [nt, at, s.domReference, h]), D = pt.useMemo(() => {
    function G(J) {
      m === "auto" && hP(J.nativeEvent) && (B.current = !0);
    }
    function et(J) {
      B.current = m, m === "auto" && a8(J.nativeEvent) && (B.current = !0);
    }
    return {
      ...nt,
      onKeyDown(J) {
        F.current = !1;
        const it = J.key.startsWith("Arrow"), lt = ["Home", "End"].includes(J.key), ot = it || lt, ut = n9t(J.key, h, a), ct = eA(J.key, h, a), gt = tA(J.key, h), dt = (n ? ut : gt) || J.key === "Enter" || J.key.trim() === "";
        if (d && r) {
          const St = z == null ? void 0 : z.nodesRef.current.find((Et) => Et.parentId == null), Mt = z && St ? U3t(z.nodesRef.current, St.id) : null;
          if (ot && Mt && M) {
            const Et = new KeyboardEvent("keydown", {
              key: J.key,
              bubbles: !0
            });
            if (ut || ct) {
              var bt, vt;
              const Ft = ((bt = Mt.context) == null ? void 0 : bt.elements.domReference) === J.currentTarget, Wt = ct && !Ft ? (vt = Mt.context) == null ? void 0 : vt.elements.domReference : ut ? c.current.find((Kt) => (Kt == null ? void 0 : Kt.id) === V) : null;
              Wt && (Wr(J), Wt.dispatchEvent(Et), rt(void 0));
            }
            if ((gt || lt) && Mt.context && Mt.context.open && Mt.parentId && J.currentTarget !== Mt.context.elements.domReference) {
              var xt;
              Wr(J), (xt = Mt.context.elements.domReference) == null || xt.dispatchEvent(Et);
              return;
            }
          }
          return at(J);
        }
        if (!(!r && !w && it)) {
          if (dt && (T.current = n && gt ? null : J.key), n) {
            ut && (Wr(J), r ? (C.current = c3(c, L.current), j(C.current)) : i(!0, J.nativeEvent, "list-navigation"));
            return;
          }
          gt && (o != null && (C.current = o), Wr(J), !r && w ? i(!0, J.nativeEvent, "list-navigation") : at(J), r && j(C.current));
        }
      },
      onFocus() {
        r && !d && j(null);
      },
      onPointerDown: et,
      onMouseDown: G,
      onClick: G
    };
  }, [V, nt, at, L, m, c, n, j, i, r, w, h, a, o, z, d, M]);
  return pt.useMemo(() => f ? {
    reference: D,
    floating: q,
    item: yt
  } : {}, [f, D, q, yt]);
}
const r9t = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function qp(t, e) {
  var r;
  e === void 0 && (e = {});
  const {
    open: i,
    floatingId: s
  } = t, {
    enabled: c = !0,
    role: u = "dialog"
  } = e, l = (r = r9t.get(u)) != null ? r : u, f = Fa(), g = Up() != null, p = pt.useMemo(() => l === "tooltip" || u === "label" ? {
    ["aria-" + (u === "label" ? "labelledby" : "describedby")]: i ? s : void 0
  } : {
    "aria-expanded": i ? "true" : "false",
    "aria-haspopup": l === "alertdialog" ? "dialog" : l,
    "aria-controls": i ? s : void 0,
    ...l === "listbox" && {
      role: "combobox"
    },
    ...l === "menu" && {
      id: f
    },
    ...l === "menu" && g && {
      role: "menuitem"
    },
    ...u === "select" && {
      "aria-autocomplete": "none"
    },
    ...u === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [l, s, g, i, f, u]), n = pt.useMemo(() => {
    const d = {
      id: s,
      ...l && {
        role: l
      }
    };
    return l === "tooltip" || u === "label" ? d : {
      ...d,
      ...l === "menu" && {
        "aria-labelledby": f
      }
    };
  }, [l, s, f, u]), a = pt.useCallback((d) => {
    let {
      active: m,
      selected: b
    } = d;
    const w = {
      role: "option",
      ...m && {
        id: s + "-option"
      }
    };
    switch (u) {
      case "select":
        return {
          ...w,
          "aria-selected": m && b
        };
      case "combobox":
        return {
          ...w,
          ...m && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [s, u]);
  return pt.useMemo(() => c ? {
    reference: p,
    floating: n,
    item: a
  } : {}, [c, p, n, a]);
}
function DP(t, e) {
  var r;
  const {
    open: i,
    dataRef: s
  } = t, {
    listRef: c,
    activeIndex: u,
    onMatch: l,
    onTypingChange: f,
    enabled: o = !0,
    findMatch: g = null,
    resetMs: p = 750,
    ignoreKeys: n = [],
    selectedIndex: a = null
  } = e, d = pt.useRef(), m = pt.useRef(""), b = pt.useRef((r = a ?? u) != null ? r : -1), w = pt.useRef(null), v = _r(l), h = _r(f), x = la(g), _ = la(n);
  qn(() => {
    i && (clearTimeout(d.current), w.current = null, m.current = "");
  }, [i]), qn(() => {
    if (i && m.current === "") {
      var R;
      b.current = (R = a ?? u) != null ? R : -1;
    }
  }, [i, a, u]);
  const M = _r((R) => {
    R ? s.current.typing || (s.current.typing = R, h(R)) : s.current.typing && (s.current.typing = R, h(R));
  }), O = _r((R) => {
    function W(C, T, F) {
      const S = x.current ? x.current(T, F) : T.find((A) => (A == null ? void 0 : A.toLocaleLowerCase().indexOf(F.toLocaleLowerCase())) === 0);
      return S ? C.indexOf(S) : -1;
    }
    const z = c.current;
    if (m.current.length > 0 && m.current[0] !== " " && (W(z, z, m.current) === -1 ? M(!1) : R.key === " " && Wr(R)), z == null || _.current.includes(R.key) || // Character key.
    R.key.length !== 1 || // Modifier key.
    R.ctrlKey || R.metaKey || R.altKey)
      return;
    i && R.key !== " " && (Wr(R), M(!0)), z.every((C) => {
      var T, F;
      return C ? ((T = C[0]) == null ? void 0 : T.toLocaleLowerCase()) !== ((F = C[1]) == null ? void 0 : F.toLocaleLowerCase()) : !0;
    }) && m.current === R.key && (m.current = "", b.current = w.current), m.current += R.key, clearTimeout(d.current), d.current = setTimeout(() => {
      m.current = "", b.current = w.current, M(!1);
    }, p);
    const $ = b.current, B = W(z, [...z.slice(($ || 0) + 1), ...z.slice(0, ($ || 0) + 1)], m.current);
    B !== -1 ? (v(B), w.current = B) : R.key !== " " && (m.current = "", M(!1));
  }), E = pt.useMemo(() => ({
    onKeyDown: O
  }), [O]), I = pt.useMemo(() => ({
    onKeyDown: O,
    onKeyUp(R) {
      R.key === " " && M(!1);
    }
  }), [O, M]);
  return pt.useMemo(() => o ? {
    reference: E,
    floating: I
  } : {}, [o, E, I]);
}
const i9t = ({ value: t, onChange: e, totalPages: r }) => {
  const i = mr(), s = mr(), c = mr(), [u, l] = cn(!1), [f, o] = cn(0), g = en(() => {
    const T = [];
    for (let F = 1; F <= r; F++)
      T.push({ label: F.toString(), value: F.toString() });
    return T;
  }, [r]), p = en(() => g.findIndex((T) => T.value === t.toString()), [g, t]), n = (T) => {
    e == null || e(Number(g[T].value)), u && l(!1);
  }, a = Sn([]), d = Sn(g.map((T) => T.label)), m = Sn(!1), { refs: b, floatingStyles: w, context: v } = Nc({
    whileElementsMounted: Qh,
    open: u,
    onOpenChange: l,
    middleware: [
      ef({ padding: 50 }),
      d8({
        apply({ rects: T, availableHeight: F, elements: S }) {
          Object.assign(S.floating.style, {
            width: `${T.reference.width}px`,
            maxHeight: `${F}px`
          });
        },
        padding: 32
      }),
      tf(2)
    ]
  }), h = (T) => T === p && T === f ? "active-selected" : T !== p && T === f ? "active" : T === p ? "selected" : "default", x = () => {
    o((T) => T === null || T - 10 < 0 ? 0 : T - 10);
  }, _ = () => {
    o((T) => T === null ? 0 : T + 10 >= g.length ? g.length - 1 : T + 10);
  }, M = zp(v, { event: "mousedown" }), O = qp(v, { role: "listbox" }), E = sf(v), I = p8(v, {
    listRef: a,
    activeIndex: f,
    selectedIndex: p,
    onNavigate: o,
    virtual: !0,
    loop: !0
  }), R = DP(v, {
    listRef: d,
    activeIndex: f,
    selectedIndex: p,
    onMatch: u ? o : n,
    onTypingChange(T) {
      m.current = T;
    }
  }), { getReferenceProps: W, getFloatingProps: z, getItemProps: j } = of([
    M,
    O,
    E,
    I,
    R
  ]), $ = (T) => {
    T.stopPropagation(), u && T.key === "PageUp" ? (T.preventDefault(), x()) : u && T.key === "PageDown" ? (T.preventDefault(), _()) : u && f !== null && T.key === "Enter" && (T.preventDefault(), n(f));
  }, B = (T) => {
    T.key === " " && !m.current && (u && f !== null ? (T.preventDefault(), n(f)) : l(!0));
  }, C = () => {
    f !== null && f !== p && n(f), l(!1);
  };
  return /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ Ve("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ $t("label", { id: i, htmlFor: s, onClick: () => {
        var T;
        return (T = b.domReference.current) == null ? void 0 : T.focus();
      }, children: nA.label }),
      /* @__PURE__ */ Ve(
        "div",
        {
          role: "combobox",
          tabIndex: 0,
          id: s,
          "aria-controls": c,
          "aria-expanded": u,
          "aria-labelledby": i,
          "aria-activedescendant": f ? `${c}-${g[f].value}` : "",
          "aria-autocomplete": "none",
          className: Ke(
            "grid h-8 min-w-16 cursor-pointer grid-cols-[1fr_auto] items-center justify-between gap-2 rounded border-[1px] border-transparent-dark-200 bg-white pl-4 pr-2 text-black",
            "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
          ),
          ref: b.setReference,
          ...W({
            onKeyDown: (T) => $(T),
            onKeyUp: (T) => B(T),
            onBlur: C
          }),
          children: [
            /* @__PURE__ */ $t("span", { children: t }),
            /* @__PURE__ */ $t(hr, { iconName: u ? "chevron-up" : "chevron-down", size: "small", role: "presentation", "aria-hidden": "true" })
          ]
        }
      ),
      /* @__PURE__ */ $t("span", { className: "text-nowrap", children: nA.inputPostfix(r) })
    ] }),
    u && /* @__PURE__ */ $t(af, { children: /* @__PURE__ */ $t(
      "div",
      {
        role: "listbox",
        id: c,
        className: "origin-top overflow-y-auto rounded-[4px] border-[1px] border-transparent-dark-200 bg-white text-grey-900",
        ref: b.setFloating,
        style: w,
        ...z(),
        tabIndex: -1,
        children: g.map((T, F) => /* @__PURE__ */ $t(
          "li",
          {
            ref: (S) => {
              a.current[F] = S;
            },
            role: "option",
            "aria-selected": F === p,
            id: `${c}-${T.value}`,
            className: Ke("grid min-h-8 cursor-pointer select-none items-center px-4", {
              "bg-grey-100": h(F) === "active",
              "bg-grey-200 font-bold": h(F) === "selected" || h(F) === "active-selected"
            }),
            ...j({
              onClick: () => n(F)
            }),
            children: T.label
          },
          T.value
        ))
      }
    ) })
  ] });
}, nA = {
  label: "Side",
  inputPostfix: (t) => `af ${t}`
}, a9t = ({
  variant: t,
  isFirstPage: e,
  isLastPage: r,
  firstItemOnCurrentPage: i,
  lastItemOnCurrentPage: s,
  totalItems: c,
  totalPages: u,
  currentPage: l,
  goToNextPage: f,
  goToPrevPage: o,
  goToPage: g
}) => /* @__PURE__ */ Ve("nav", { "aria-label": rA.ariaLabel, className: "grid grid-cols-3 items-center gap-4 px-2", children: [
  t === "full" && /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ $t("div", { className: "justify-self-start", children: rA.currentItems({
      firstItemOnCurrentPage: i + 1,
      lastItemOnCurrentPage: s,
      totalItems: c
    }) }),
    /* @__PURE__ */ $t("div", { className: "justify-self-center", children: /* @__PURE__ */ $t(mmt, { value: l, onChange: (p) => g(p), totalPages: u }) }),
    /* @__PURE__ */ Ve("div", { className: "flex gap-2 justify-self-end", children: [
      /* @__PURE__ */ $t($d, { variant: "previous", onClick: o, disabled: e }),
      /* @__PURE__ */ $t($d, { variant: "next", onClick: f, disabled: r })
    ] })
  ] }),
  t === "minimal" && /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ $t("div", { className: "justify-self-start", children: /* @__PURE__ */ $t($d, { variant: "previous", onClick: o, disabled: e }) }),
    /* @__PURE__ */ $t("div", { className: "justify-self-center", children: /* @__PURE__ */ $t(i9t, { value: l, onChange: (p) => g(p), totalPages: u }) }),
    /* @__PURE__ */ $t("div", { className: "justify-self-end", children: /* @__PURE__ */ $t($d, { variant: "next", onClick: f, disabled: r }) })
  ] })
] }), rA = {
  ariaLabel: "Paginering",
  currentItems: ({
    firstItemOnCurrentPage: t,
    lastItemOnCurrentPage: e,
    totalItems: r
  }) => `Viser ${t} - ${e} ud af ${r}`
}, s9t = (t, { allowMultipleAccordions: e = !1, initialOpenAccordions: r = [] }) => {
  const i = () => e ? r : r.length > 0 ? [r[0]] : r, [s, c] = cn(i()), u = (g) => {
    e ? f(g) : l(g);
  }, l = (g) => {
    if (s.length === 1 && t(s[0]) === t(g)) {
      c([]);
      return;
    }
    c([g]);
  }, f = (g) => {
    const p = s.some((n) => t(n) === t(g));
    c(p ? s.filter((n) => t(n) !== t(g)) : [...s, g]);
  };
  return {
    isAccordionOpen: (g) => s.some((p) => t(p) === t(g)),
    handleToggleAccordion: u
  };
}, o9t = ({ open: t, onClick: e, ariaLabel: r }) => /* @__PURE__ */ $t(
  "button",
  {
    className: "rounded text-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-400",
    type: "button",
    onClick: e,
    "aria-label": r,
    "aria-expanded": t,
    children: /* @__PURE__ */ $t(hr, { "aria-hidden": !0, iconName: "chevron-down", className: Ke("transition", { "rotate-180": t }) })
  }
), l9t = ({
  columns: t,
  isOpenFn: e,
  onToggleAccordion: r,
  accordionColId: i,
  accordion: s
}) => en(() => {
  if (!s) return t;
  const c = (l) => {
    var f;
    return s.toggleButtonAriaLabel ? KE.isString(s.toggleButtonAriaLabel) ? s.toggleButtonAriaLabel : (f = s.toggleButtonAriaLabel) == null ? void 0 : f.call(s, l) : e(l) ? "show less" : "show more";
  }, u = {
    key: i,
    justify: "end",
    render: (l) => /* @__PURE__ */ $t(
      o9t,
      {
        open: e(l),
        onClick: () => r(l),
        ariaLabel: c(l)
      }
    )
  };
  return [...t, u];
}, [s, i, t, e, r]), c9t = (t, e) => en(() => t.map(
  (i) => i.key === e ? "0fr" : i.width ?? "auto"
).toString().replaceAll(",", " "), [e, t]), u9t = (t, { itemsPrPage: e }) => {
  const [r, i] = cn(1), s = en(() => Math.ceil(t.length / e), [t.length, e]), c = t.length, u = r === 1, l = r === s, f = en(() => (r - 1) * e, [r, e]), o = en(() => f + e > c ? c : f + e, [f, e, c]);
  return {
    paginatedData: en(() => t.slice(f, o), [t, f, o]),
    isFirstPage: u,
    isLastPage: l,
    firstItemOnCurrentPage: f,
    lastItemOnCurrentPage: o,
    totalItems: c,
    totalPages: s,
    currentPage: r,
    itemsPrPage: e,
    goToNextPage: () => {
      r < s && i((d) => d + 1);
    },
    goToPrevPage: () => {
      r > 1 && i((d) => d - 1);
    },
    goToPage: (d) => {
      d < 1 ? i(1) : d > s ? i(s) : i(d);
    }
  };
}, c8t = ({
  data: t,
  columns: e,
  keyFn: r,
  hideTableHead: i = !1,
  accordion: s = void 0,
  className: c = void 0,
  size: u = "small",
  pagination: l
}) => {
  const f = "accordion-col-" + mr(), { isAccordionOpen: o, handleToggleAccordion: g } = s9t(r, {
    allowMultipleAccordions: s == null ? void 0 : s.allowMultipleOpenAccordions,
    initialOpenAccordions: s == null ? void 0 : s.initialOpenAccordions
  }), p = l9t({
    accordion: s,
    accordionColId: f,
    columns: e,
    onToggleAccordion: g,
    isOpenFn: o
  }), n = c9t(p, f), { sortedData: a, handleSort: d, currentSort: m } = U5t(t, e), {
    paginatedData: b,
    isFirstPage: w,
    isLastPage: v,
    firstItemOnCurrentPage: h,
    lastItemOnCurrentPage: x,
    totalItems: _,
    totalPages: M,
    currentPage: O,
    goToNextPage: E,
    goToPrevPage: I,
    goToPage: R
  } = u9t(a, { itemsPrPage: 10 });
  return /* @__PURE__ */ Ve("div", { className: "grid gap-8", children: [
    /* @__PURE__ */ Ve(
      "div",
      {
        className: Ke("z-0 grid min-w-fit content-start overflow-hidden rounded-lg shadow", c),
        role: "table",
        "aria-colcount": e.length,
        "aria-rowcount": b.length,
        style: { gridTemplateColumns: n },
        children: [
          !i && /* @__PURE__ */ $t(H5t, { onClickSort: d, columns: p, currentSort: m }),
          b.map((W, z) => /* @__PURE__ */ $t(
            z5t,
            {
              entry: W,
              columns: p,
              rowIndex: z + 1 + (i ? 0 : 1),
              accordion: s,
              showAccordion: o(W),
              onToggleAccordion: g,
              size: u
            },
            r(W)
          ))
        ]
      }
    ),
    l && /* @__PURE__ */ $t(
      a9t,
      {
        variant: l,
        isFirstPage: w,
        isLastPage: v,
        firstItemOnCurrentPage: h,
        lastItemOnCurrentPage: x,
        totalItems: _,
        totalPages: M,
        currentPage: O,
        goToNextPage: E,
        goToPrevPage: I,
        goToPage: R
      }
    )
  ] });
}, iA = 16, h9t = ({ text: t, children: e, lockPosition: r = !1, showTextDecoration: i = !1, className: s }) => {
  const [c, u] = cn(!1), l = Sn(null), f = {
    height: 15,
    width: 24
  }, { refs: o, floatingStyles: g, context: p } = Nc({
    placement: "top",
    open: c,
    onOpenChange: (_, M) => {
      (M == null ? void 0 : M.type) === "click" && (M == null ? void 0 : M.target) !== document.activeElement || u(_);
    },
    middleware: [
      tf(f.height + 10),
      ef({ padding: iA }),
      kP({ padding: iA }),
      A3t({ element: l, padding: 8 })
    ],
    whileElementsMounted: Qh
  }), n = zp(p, { ignoreMouse: !0 }), a = Z3t(p, {
    enabled: !r
  }), d = B3t(p, { move: !0 }), m = e9t(p), b = sf(p), w = qp(p, { role: "tooltip" }), v = Fa(), { getReferenceProps: h, getFloatingProps: x } = of([n, a, d, m, b, w]);
  return /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ $t(
      "span",
      {
        className: Ke(
          "inline-block w-fit",
          { "underline decoration-primary-400 decoration-dotted": i },
          s
        ),
        ref: o.setReference,
        "aria-describedby": v,
        ...h(),
        children: e
      }
    ),
    c && /* @__PURE__ */ $t(af, { children: /* @__PURE__ */ Ve(
      "div",
      {
        className: "max-w-[calc(100dvw-5rem)] rounded-lg bg-white p-4 shadow-lg",
        ref: o.setFloating,
        style: g,
        id: v,
        ...x(),
        children: [
          /* @__PURE__ */ $t(
            D3t,
            {
              className: "fill-white",
              ref: l,
              context: p,
              height: f.height,
              width: f.width
            }
          ),
          /* @__PURE__ */ $t("div", { className: "overflow max-w-[20rem] break-words text-sm text-grey-900", children: t })
        ]
      }
    ) })
  ] });
}, $P = kn(
  ({ text: t, variant: e = "spot", ...r }, i) => /* @__PURE__ */ $t(h9t, { text: t, lockPosition: !0, children: /* @__PURE__ */ $t(
    "button",
    {
      type: "button",
      ref: i,
      className: Ke(
        "inline-flex aspect-square h-4 w-4 cursor-help place-content-center place-items-center overflow-clip rounded-full",
        {
          "bg-green-200 text-grey-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-200": e === "spot"
        }
      ),
      ...r,
      children: /* @__PURE__ */ $t(hr, { iconName: "info", size: 12 })
    }
  ) })
), u8t = kn(
  ({
    children: t,
    severity: e = "info",
    showCloseButton: r = !1,
    title: i,
    onClose: s,
    errorCode: c,
    errorCodeLabel: u = f9t.errorCodeLabel,
    className: l,
    ...f
  }, o) => {
    const g = en(() => {
      switch (e) {
        case "info":
          return "info-circle";
        case "success":
          return "checkmark-outlined";
        case "error":
          return "alert";
        case "warning":
          return "alert-circle";
        default:
          return "info-circle";
      }
    }, [e]);
    return /* @__PURE__ */ Ve(
      "div",
      {
        ref: o,
        role: "alert",
        ...f,
        className: Ke(
          "relative grid grid-cols-[auto_1fr] items-center gap-x-[0.9rem] rounded border border-solid p-4 text-grey-900",
          {
            "border-blue-300 bg-blue-100": e === "info",
            "border-green-300 bg-green-100": e === "success",
            "border-red-300 bg-red-100": e === "error",
            "border-yellow-300 bg-yellow-100": e === "warning"
          },
          l
        ),
        children: [
          /* @__PURE__ */ $t(hr, { className: i ? "" : "self-start", iconName: g, size: "medium" }),
          i && /* @__PURE__ */ $t("p", { className: "font-semi-bold", children: i }),
          /* @__PURE__ */ Ve("div", { className: "col-start-2 col-end-3", children: [
            t,
            e === "error" && c && /* @__PURE__ */ $t("p", { className: "-mb-2.5 -mr-2 mt-1 skew-x-[-10deg] text-end text-xs opacity-70", children: u + c })
          ] }),
          r && /* @__PURE__ */ $t(
            "button",
            {
              className: Ke(
                "pointer absolute right-2 top-2 flex rounded border-none bg-none p-0.5 text-[inherit]",
                "focus-visible:outline focus-visible:outline-2",
                {
                  "focus-visible:outline-red-600": e === "error",
                  "focus-visible:outline-green-800": e === "success",
                  "focus-visible:outline-blue-600": e === "info",
                  "focus-visible:outline-yellow-700": e === "warning"
                }
              ),
              type: "button",
              onClick: (p) => s == null ? void 0 : s(p),
              children: /* @__PURE__ */ $t(hr, { iconName: "close" })
            }
          )
        ]
      }
    );
  }
), f9t = {
  errorCodeLabel: "Fejlkode: "
}, h8t = kn(
  ({
    show: t = !1,
    onClose: e,
    children: r,
    ariaLabel: i,
    ariaLabelledby: s,
    showCloseButton: c = !1,
    ariaLabelCloseButton: u = d9t.closeButtonAriaLabel,
    invertCloseButtonColor: l = !1,
    initialFocus: f = 0
  }, o) => {
    Tn(() => {
      const a = (d) => {
        t && d.key === "Escape" && (d.preventDefault(), e());
      };
      return window.addEventListener("keydown", a), () => window.removeEventListener("keydown", a);
    }, [e, t]), Tn(() => (t && (document.body.style.overflow = "hidden"), () => {
      document.body.style.removeProperty("overflow"), document.body.style.length === 0 && document.body.removeAttribute("style");
    }), [t]);
    const g = {
      initial: { opacity: 0, y: 300, scale: 0.5 },
      animate: { opacity: 1, y: 0, scale: 1 },
      exit: { opacity: 0, y: 300, scale: 0.5 },
      transition: {
        type: "spring",
        bounce: 0.1,
        duration: 0.4
      }
    }, { refs: p, context: n } = Nc({
      open: t,
      onOpenChange: e
    });
    return pA(
      /* @__PURE__ */ $t(Pc, { children: t && /* @__PURE__ */ Ve(Ra, { children: [
        /* @__PURE__ */ $t(
          bn.div,
          {
            "aria-hidden": "true",
            onClick: (a) => {
              a.stopPropagation(), e == null || e();
            },
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
            className: "fixed left-0 top-0 grid h-dvh w-dvw bg-[#000]/45 backdrop-blur-[1.4px] backdrop-grayscale-[0.8]"
          }
        ),
        /* @__PURE__ */ $t(Vp, { context: n, modal: !0, initialFocus: f, children: /* @__PURE__ */ $t(
          "div",
          {
            className: "pointer-events-none fixed left-0 top-0 grid h-dvh w-dvw items-center justify-center",
            ref: p.setFloating,
            children: /* @__PURE__ */ Ve(
              bn.div,
              {
                className: "pointer-events-auto relative max-h-[90dvh] max-w-[min(calc(100dvw-2rem),90dvw)] overflow-auto rounded-lg bg-white shadow-lg",
                ref: o,
                onClick: (a) => a.stopPropagation(),
                role: "dialog",
                "aria-modal": "true",
                "aria-label": i,
                "aria-labelledby": s,
                initial: g.initial,
                animate: g.animate,
                exit: g.exit,
                transition: g.transition,
                children: [
                  r,
                  c && /* @__PURE__ */ $t(
                    bn.button,
                    {
                      className: Ke(
                        "focus-visible:outline-inherit absolute right-4 top-4 flex rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
                        { "text-white": l }
                      ),
                      onClick: e,
                      whileTap: { scale: 0.9 },
                      "aria-label": u,
                      type: "button",
                      children: /* @__PURE__ */ $t(hr, { iconName: "close" })
                    }
                  )
                ]
              }
            )
          }
        ) })
      ] }) }),
      document.body
    );
  }
), d9t = {
  closeButtonAriaLabel: "Luk dialog"
}, g9t = (t) => /* @__PURE__ */ pt.createElement("svg", { viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("path", { id: "path1", d: "M12.126 4.56001C12.7745 4.5597 13.3765 4.62215 14.0057 4.78407C15.7431 5.23131 17.1078 6.85226 17.2062 8.79091C17.3187 10.9869 17.3257 11.2451 17.208 13.1645C17.0876 15.1154 15.722 16.7564 13.9943 17.1949C13.2666 17.3796 12.911 17.4401 12.126 17.44" }), /* @__PURE__ */ pt.createElement("path", { id: "path1b", d: "M12.126 4.56001C12.7745 4.5597 13.3765 4.62215 14.0057 4.78407C15.7431 5.23131 17.1078 6.85226 17.2062 8.79091C17.3187 10.9869 17.3257 11.2451 17.208 13.1645C17.0876 15.1154 15.722 16.7564 13.9943 17.1949C13.2666 17.3796 12.911 17.4401 12.126 17.44" }), /* @__PURE__ */ pt.createElement("path", { id: "path2", d: "M9.87402 4.56001C9.22554 4.5597 8.62351 4.62215 7.9943 4.78407C6.25694 5.23131 4.89219 6.85226 4.79377 8.79091C4.68128 10.9869 4.67425 11.2451 4.79201 13.1645C4.9124 15.1154 6.27803 16.7564 8.00573 17.1949C8.73336 17.3796 9.089 17.4401 9.87402 17.44" }), /* @__PURE__ */ pt.createElement("path", { id: "path2b", d: "M9.87402 4.56001C9.22554 4.5597 8.62351 4.62215 7.9943 4.78407C6.25694 5.23131 4.89219 6.85226 4.79377 8.79091C4.68128 10.9869 4.67425 11.2451 4.79201 13.1645C4.9124 15.1154 6.27803 16.7564 8.00573 17.1949C8.73336 17.3796 9.089 17.4401 9.87402 17.44" })), p9t = ({ size: t, colorScheme: e = "brand", ...r }) => /* @__PURE__ */ $t(
  "div",
  {
    className: Ke(
      "flex flex-col items-center",
      "[&>svg>path]:fill-none [&>svg>path]:stroke-[3.5]",
      "[&>svg>#path1]:animate-[progressiveStroke_2s_ease-in-out_infinite] [&>svg>#path1]:[stroke-dasharray:100_100] [&>svg>#path1]:[stroke-dashoffset:100]",
      "[&>svg>#path1b]:animate-[progressiveStroke_2s_ease-in-out_infinite_0.1s] [&>svg>#path1b]:[stroke-dasharray:100_100] [&>svg>#path1b]:[stroke-dashoffset:100]",
      "[&>svg>#path2]:animate-[progressiveStroke_2s_ease-in-out_infinite] [&>svg>#path2]:[stroke-dasharray:100_100] [&>svg>#path2]:[stroke-dashoffset:100] [&>svg>#path2]:[transform-origin:center_center] [&>svg>#path2]:[transform:scaleY(-1)]",
      "[&>svg>#path2b]:animate-[progressiveStroke_2s_ease-in-out_infinite_0.1s] [&>svg>#path2b]:[stroke-dasharray:100_100] [&>svg>#path2b]:[stroke-dashoffset:100] [&>svg>#path2b]:[transform-origin:center_center] [&>svg>#path2b]:[transform:scaleY(-1)]",
      {
        "[&>svg>#path1]:stroke-red-200 [&>svg>#path1b]:stroke-red-500 [&>svg>#path2]:stroke-red-200 [&>svg>#path2b]:stroke-red-500": e === "brand",
        "[&>svg>#path1]:stroke-primary-200 [&>svg>#path1b]:stroke-primary-500 [&>svg>#path2]:stroke-primary-200 [&>svg>#path2b]:stroke-primary-500": e === "theme"
      }
    ),
    children: /* @__PURE__ */ $t(g9t, { width: t, height: t, title: m9t.spinnerTitle, ...r })
  }
), m9t = {
  spinnerTitle: "Norlys load spinner"
}, f8t = kn(
  ({ colorScheme: t = "brand", size: e = 100, ...r }, i) => {
    const s = en(() => {
      switch (e) {
        case "small":
          return 16;
        case "medium":
          return 24;
        case "large":
          return 32;
        default:
          return e;
      }
    }, [e]);
    return /* @__PURE__ */ $t(p9t, { ref: i, colorScheme: t, size: s, ...r });
  }
), Mh = kn(
  ({ invertColor: t = !1, className: e, ...r }, i) => /* @__PURE__ */ $t(
    "div",
    {
      ...r,
      className: Ke(
        "animate-[1.5s_ease-in-out_0.5s_infinite_normal_none_running_opacity-fade-in-out_] bg-[rgba(0,0,0,0.11)]",
        { "bg-[rgba(255,255,255,0.25)]": t },
        e
      ),
      ref: i
    }
  )
), d8t = kn(
  ({
    textSize: t = "base",
    typography: e,
    width: r = "100%",
    lastLineWidth: i = void 0,
    lines: s = 1,
    invertColor: c = !1,
    justifyText: u = "start",
    className: l,
    ...f
  }, o) => {
    const g = en(() => {
      const n = [];
      for (let a = 0; a < s; a++)
        n.push({ key: "skeleton-text" + a });
      return n;
    }, [s]), p = (n) => n && i ? i : r;
    return /* @__PURE__ */ $t(Ra, { children: e ? /* @__PURE__ */ $t("div", { ...f, className: Ke("grid w-full", l), ref: o, children: g.map((n, a) => /* @__PURE__ */ $t(
      Mh,
      {
        invertColor: c,
        className: Ke("[transform-origin:0_65%_0] [transform:scale(1,0.7)]", {
          "justify-self-start": u === "start",
          "justify-self-center": u === "center",
          "justify-self-end": u === "end",
          "my-[calc((2.625rem-2.25rem)/2)] h-[2.25rem] rounded-[calc(2.25rem/3)/calc(2.25rem/2)] md:my-[calc((4rem-3.5rem)/2)] md:h-14 md:rounded-[calc(3.5rem/3)/calc(3.5rem/2)]": e === "h1",
          "my-[calc((2rem-1.625rem)/2)] h-[1.625rem] rounded-[calc(1.625rem/3)/calc(1.625rem/2)] md:my-[calc((2.875rem-2.5rem)/2)] md:h-10 md:rounded-[calc(2.5rem/3)/calc(2.5rem/2)]": e === "h2",
          "my-[calc((1.75rem-1.25rem)/2)] h-5 rounded-[calc(1.25rem/3)/calc(1.25rem/2)] md:my-[calc((2.25rem-1.625rem)/2)] md:h-[1.625rem] md:rounded-[calc(1.625rem/3)/calc(1.625rem/2)]": e === "h3",
          "my-[calc((1.75rem-1.25rem)/2)] h-5 rounded-[calc(1.25rem/3)/calc(1.25rem/2)] md:my-[calc((2.5rem-2rem)/2)] md:h-8 md:rounded-[calc(2rem/3)/calc(2rem/2)]": e === "h4",
          "my-[calc((1.625rem-1.125rem)/2)] h-[1.125rem] rounded-[calc(1.125rem/3)/calc(1.125rem/2)] md:my-[calc((2rem-1.5rem)/2)] md:h-6 md:rounded-[calc(1.5rem/3)/calc(1.5rem/2)]": e === "h5",
          "my-[calc((1.375rem-1rem)/2)] h-4 rounded-[calc(1rem/3)/calc(1rem/2)] md:my-[calc((1.625rem-1.125rem)/2)] md:h-[1.125rem] md:rounded-[calc(1.125rem/3)/calc(1.125rem/2)]": e === "st1",
          "my-[calc((1.125rem-0.875rem)/2)] h-[0.875rem] rounded-[calc(0.875rem/3)/calc(0.875rem/2)] md:my-[calc((1.375rem-1rem)/2)] md:h-4 md:rounded-[calc(1rem/3)/calc(1rem/2)]": e === "st2" || e === "body2",
          "my-[calc((1rem-0.75rem)/2)] h-3 rounded-[calc(0.75rem/3)/calc(0.75rem/2)] md:my-[calc((1.125rem-0.90625rem)/2)] md:h-[0.90625rem] md:rounded-[calc(0.90625rem/3)/calc(0.90625rem/2)]": e === "st3",
          "my-[calc((1.375rem-1rem)/2)] h-4 rounded-[calc(1rem/3)/calc(1rem/2)] md:my-[calc((1.625rem-1.125rem)/2)] md:h-[1.125rem] md:rounded-[calc(1.25rem/3)/calc(1.25rem/2)]": e === "body1",
          "my-[calc((1rem-0.75rem)/2)] h-3 rounded-[calc(0.75rem/3)/calc(0.75rem/2)] md:my-[calc((1.125rem-0.875rem)/2)] md:h-[0.875rem] md:rounded-[calc(0.875rem/3)/calc(0.875rem/2)]": e === "body3",
          "my-[calc((1rem-0.75rem)/2)] h-3 rounded-[calc(0.75rem/3)/calc(0.75rem/2)]": e === "detail",
          "my-[calc((0.875rem-0.625rem)/2)] h-[0.625rem] rounded-[calc(0.625rem/3)/calc(0.625rem/2)] md:my-[calc((1rem-0.75rem)/2)] md:h-3 md:rounded-[calc(0.75rem/3)/calc(0.75rem/2)]": e === "petit"
        }),
        style: { width: p(a + 1 === g.length) }
      },
      n.key
    )) }) : /* @__PURE__ */ $t("div", { ...f, className: Ke("grid w-full items-center", l), children: g.map((n, a) => /* @__PURE__ */ $t(
      Mh,
      {
        invertColor: c,
        className: Ke(
          "origin-[0_65%_0] scale-y-[0.7]",
          { "justify-self-start": u === "start" },
          { "justify-self-center": u === "center" },
          { "justify-self-end": u === "end" },
          {
            "my-[calc((1rem-0.75rem)/2)] h-[0.75rem] rounded-[calc(0.75rem/3)/calc(0.75rem/2)]": t === "xs"
          },
          {
            "my-[calc((1.25rem-0.875rem)/2)] h-[0.875rem] rounded-[calc(0.875rem/3)/calc(0.875rem/2)]": t === "sm"
          },
          { "my-[calc((1.5rem-1rem)/2)] h-[1rem] rounded-[calc(1rem/3)/calc(1rem/2)]": t === "base" },
          {
            "my-[calc((1.75rem-1.125rem)/2)] h-[1.1125rem] rounded-[calc(1.1125rem/3)/calc(1.1125rem/2)]": t === "lg"
          },
          {
            "my-[calc((1.75rem-1.25rem)/2)] h-[1.25rem] rounded-[calc(1.25rem/3)/calc(1.25rem/2)]": t === "xl"
          },
          {
            "my-[calc((2rem-1.5rem)/2)] h-[1.5rem] rounded-[calc(1.5rem/3)/calc(1.5rem/2)]": t === "2xl"
          },
          {
            "my-[calc((2.25rem-1.875rem)/2)] h-[1.875rem] rounded-[calc(1.875rem/3)/calc(1.875rem/2)]": t === "3xl"
          },
          {
            "my-[calc((2.5rem-2.25rem)/2)] h-[2.25rem] rounded-[calc(2.25rem/3)/calc(2.25rem/2)]": t === "4xl"
          },
          { "h-[3rem] rounded-[calc(3rem/3)/calc(3rem/2)]": t === "5xl" },
          {
            "h-[3.75rem] rounded-[calc(3.75rem/3)/calc(3.75rem/2)]": t === "6xl"
          }
        ),
        style: { width: p(a + 1 === g.length) }
      },
      n.key
    )) }) });
  }
), g8t = kn(
  ({
    width: t = "100%",
    height: e = "2rem",
    invertColor: r = !1,
    ...i
  }, s) => /* @__PURE__ */ $t(Mh, { invertColor: r, style: { width: t, height: e }, ...i, ref: s })
), p8t = kn(
  ({
    width: t = "2rem",
    height: e = "2rem",
    invertColor: r = !1,
    className: i,
    ...s
  }, c) => /* @__PURE__ */ $t(
    Mh,
    {
      invertColor: r,
      style: { width: t, height: e },
      ...s,
      ref: c,
      className: Ke("rounded-[50%]", i)
    }
  )
), m8t = kn(
  ({
    width: t = "2rem",
    height: e = "2rem",
    invertColor: r = !1,
    className: i,
    ...s
  }, c) => /* @__PURE__ */ $t(
    Mh,
    {
      invertColor: r,
      style: { width: t, height: e },
      ...s,
      ref: c,
      className: Ke("rounded", i)
    }
  )
), y9t = (t) => /* @__PURE__ */ pt.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ pt.createElement("g", { className: "spinner_V8m1" }, /* @__PURE__ */ pt.createElement("circle", { cx: 12, cy: 12, r: 9.5, fill: "none", strokeWidth: 3 }))), b9t = "_spinner_1oh33_1", v9t = {
  spinner: b9t
}, w9t = kn(
  ({ size: t = "medium", ...e }, r) => {
    const i = en(() => {
      switch (t) {
        case "small":
          return 16;
        case "medium":
          return 24;
        case "large":
          return 32;
        default:
          return t;
      }
    }, [t]);
    return /* @__PURE__ */ $t(
      y9t,
      {
        ref: r,
        ...e,
        width: i,
        height: i,
        className: [v9t.spinner, { ...e }.className].join(" ")
      }
    );
  }
), p3 = {
  ball: {
    "completed-step": {
      background: "linear-gradient(90deg, var(--ssui-theme-color-primary-400) 100%, var(--ssui-color-grey-400) 100%)",
      border: "1px solid var(--ssui-theme-color-primary-400)",
      boxShadow: "inset 0 0 0 var(--_stepper-inset-border-size) var(--ssui-theme-color-primary-400)"
    },
    "active-step": {
      background: "linear-gradient(90deg, var(--ssui-theme-color-primary-400) 100%, var(--ssui-color-grey-400) 100%)",
      border: "1px solid var(--ssui-theme-color-primary-400)",
      boxShadow: "inset 0 0 0 var(--_stepper-inset-border-size) var(--ssui-color-white)"
    },
    "incomplete-step": {
      background: "linear-gradient(90deg, var(--ssui-theme-color-primary-400) 0%, var(--ssui-color-grey-400) 0%)",
      border: "1px solid var(--ssui-color-grey-400)",
      boxShadow: "inset 0 0 0 var(--_stepper-inset-border-size) var(--ssui-color-grey-400)"
    }
  },
  label: {
    "completed-step": {
      fontWeight: 400
    },
    "active-step": {
      fontWeight: 600
    },
    "incomplete-step": {
      fontWeight: 400
    }
  },
  completedIcon: {
    "completed-step": {
      opacity: 1
    },
    "active-step": {
      opacity: 0
    },
    "incomplete-step": {
      opacity: 0
    }
  }
}, x9t = {
  default: ({ currentStepIndex: t, stepsLength: e }) => {
    const r = (t + 1) / e * 100;
    return {
      background: `linear-gradient(90deg, var(--ssui-theme-color-primary-400) ${r}%, var(--ssui-color-grey-400) ${r}%)`
    };
  }
}, y8t = kn(
  ({ currentStepIndex: t, steps: e, size: r = "md", completedStepIcon: i = "check", ...s }, c) => {
    const u = (l) => l === t ? "active-step" : l < t ? "completed-step" : "incomplete-step";
    return /* @__PURE__ */ Ve(S9t, { role: "presentation", ...s, className: `size-${r} ${s.className}`, ref: c, children: [
      /* @__PURE__ */ $t(
        bn.div,
        {
          className: "steps-line",
          custom: { currentStepIndex: t, stepsLength: e.length },
          variants: x9t,
          animate: "default",
          initial: "default",
          transition: {
            type: "spring",
            damping: 20,
            stiffness: 100
          }
        }
      ),
      e.map((l, f) => /* @__PURE__ */ Ve("div", { className: `step-container ${u(f)}`, children: [
        /* @__PURE__ */ $t(
          bn.div,
          {
            className: "step-ball",
            animate: u(f),
            initial: u(f),
            variants: p3.ball,
            transition: {
              damping: 15,
              stiffness: 100,
              delay: 0.05
            },
            children: /* @__PURE__ */ $t(
              bn.div,
              {
                animate: u(f),
                initial: u(f),
                variants: p3.completedIcon,
                className: "step-icon-wrapper",
                transition: {
                  type: "spring",
                  damping: 15,
                  stiffness: 100,
                  delay: 0.05
                },
                children: /* @__PURE__ */ $t(hr, { iconName: i, size: r === "md" ? "small" : 12, className: "step-icon" })
              }
            )
          }
        ),
        /* @__PURE__ */ $t(
          bn.span,
          {
            className: "step-label",
            animate: u(f),
            initial: u(f),
            variants: p3.label,
            children: l.label
          }
        )
      ] }, f))
    ] });
  }
), S9t = Wn.div`
  display: flex;
  position: relative;

  &.size-sm {
    --_stepper-ball-size: 1rem;
    --_stepper-line-size-offset: 7px;
    --_stepper-label-size: 10px;
    --_stepper-column-gap: 1px;
    --_stepper-inset-border-size: 2px;
  }

  &.size-md {
    --_stepper-ball-size: 1.5rem;
    --_stepper-line-size-offset: 11px;
    --_stepper-label-size: 14px;
    --_stepper-column-gap: 4px;
    --_stepper-inset-border-size: 3px;
  }

  > .steps-line {
    height: 2px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin-top: var(--_stepper-line-size-offset);
  }

  > .step-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: var(--_stepper-column-gap);
    width: 100%;
    position: relative;
    min-width: 0;

    > .step-ball {
      border-radius: 100%;
      height: var(--_stepper-ball-size);
      width: var(--_stepper-ball-size);
      display: flex;
      justify-content: center;
      align-items: center;

      > .step-icon-wrapper {
        display: flex;

        > .step-icon {
          color: var(--ssui-color-white);
        }
      }
    }

    > .step-label {
      font-size: var(--_stepper-label-size);
      text-align: center;
    }
  }
`, m3 = {
  ball: {
    "completed-point": {
      background: "linear-gradient(180deg, var(--ssui-theme-color-primary-400) 100%, var(--ssui-color-grey-400) 100%)",
      border: "1px solid var(--ssui-theme-color-primary-400)",
      boxShadow: "inset 0 0 0 var(--_timeline-inset-border-size) var(--ssui-theme-color-primary-400)"
    },
    "active-point": {
      background: "linear-gradient(180deg, var(--ssui-theme-color-primary-400) 100%, var(--ssui-color-grey-400) 100%)",
      border: "1px solid var(--ssui-theme-color-primary-400)",
      boxShadow: "inset 0 0 0 var(--_timeline-inset-border-size) var(--ssui-color-white)"
    },
    "incomplete-point": {
      background: "linear-gradient(180deg, var(--ssui-theme-color-primary-400) 0%, var(--ssui-color-grey-400) 0%)",
      border: "1px solid var(--ssui-color-grey-400)",
      boxShadow: "inset 0 0 0 var(--_timeline-inset-border-size) var(--ssui-color-grey-400)"
    }
  },
  label: {
    "completed-point": {
      fontWeight: 400
    },
    "active-point": {
      fontWeight: 600
    },
    "incomplete-point": {
      fontWeight: 400
    }
  },
  completedIcon: {
    "completed-point": {
      opacity: 1
    },
    "active-point": {
      opacity: 0
    },
    "incomplete-point": {
      opacity: 0
    }
  }
}, C9t = {
  default: ({ currentPointIndex: t, pointsLength: e }) => {
    const r = (t + 1) / e * 100;
    return {
      background: `linear-gradient(180deg, var(--ssui-theme-color-primary-400) ${r}%, var(--ssui-color-grey-400) ${r}%)`
    };
  }
}, b8t = kn(
  ({ currentPointIndex: t, timelinePoints: e, size: r = "md", completedPointIcon: i = "check", ...s }, c) => {
    const u = (l) => l === t ? "active-point" : l < t ? "completed-point" : "incomplete-point";
    return /* @__PURE__ */ Ve(A9t, { ...s, className: `size-${r} ${s.className}`, ref: c, children: [
      /* @__PURE__ */ $t(
        bn.div,
        {
          role: "presentation",
          className: "points-line",
          custom: { currentPointIndex: t, pointsLength: e.length },
          variants: C9t,
          animate: "default",
          initial: "default",
          transition: {
            type: "spring",
            damping: 20,
            stiffness: 100
          }
        }
      ),
      e.map((l, f) => /* @__PURE__ */ Ve("div", { className: `point-container ${u(f)}`, children: [
        /* @__PURE__ */ $t(
          bn.div,
          {
            role: "presentation",
            className: "point-ball",
            animate: u(f),
            initial: u(f),
            variants: m3.ball,
            transition: {
              damping: 15,
              stiffness: 100,
              delay: 0.05
            },
            children: /* @__PURE__ */ $t(
              bn.div,
              {
                animate: u(f),
                initial: u(f),
                variants: m3.completedIcon,
                className: "point-icon-wrapper",
                transition: {
                  type: "spring",
                  damping: 15,
                  stiffness: 100,
                  delay: 0.05
                },
                children: /* @__PURE__ */ $t(hr, { iconName: i, size: r === "md" ? "small" : 12, className: "point-icon" })
              }
            )
          }
        ),
        /* @__PURE__ */ $t(
          bn.div,
          {
            className: "point-label",
            animate: u(f),
            initial: u(f),
            variants: m3.label,
            children: l
          }
        )
      ] }, f))
    ] });
  }
), A9t = Wn.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  justify-content: space-around;

  &.size-sm {
    --_timeline-ball-size: 1rem;
    --_timeline-line-size-offset: 0.4375rem;
    --_timeline-label-size: 14px;
    --_timeline-label-padding-top: 0;
    --_timeline-column-gap: 0.5rem;
    --_timeline-inset-border-size: 2px;
  }

  &.size-md {
    --_timeline-ball-size: 1.5rem;
    --_timeline-line-size-offset: 0.6875rem;
    --_timeline-label-size: 16px;
    --_timeline-label-padding-top: 0.125rem;
    --_timeline-column-gap: 0.75rem;
    --_timeline-inset-border-size: 3px;
  }

  > .points-line {
    width: 2px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin-left: var(--_timeline-line-size-offset);
  }

  > .point-container {
    display: flex;
    align-items: start;
    column-gap: var(--_timeline-column-gap);
    width: 100%;
    position: relative;
    min-width: 0;

    > .point-ball {
      border-radius: 100%;
      height: var(--_timeline-ball-size);
      min-width: var(--_timeline-ball-size);
      display: flex;
      justify-content: center;
      align-items: center;

      > .point-icon-wrapper {
        display: flex;

        > .point-icon {
          color: var(--ssui-color-white);
        }
      }
    }

    > .point-label {
      font-size: var(--_timeline-label-size);
      text-align: start;
      padding-top: var(--_timeline-label-padding-top);
    }
  }
`, _9t = (t) => t == null, k9t = (t) => !_9t(t) && typeof t == "string", O9t = (t) => k9t(t) && t.length > 0, LP = kn(
  ({
    label: t,
    placeholder: e,
    error: r,
    id: i,
    helperText: s,
    onChange: c,
    tooltip: u,
    icon: l,
    customInputNode: f,
    inputContainerRef: o,
    ...g
  }, p) => {
    const [n, a] = cn(""), d = mr(), m = i ?? d, b = O9t(r), w = mr(), v = mr(), h = (_) => {
      const M = _.target.value;
      a(M), c == null || c(_);
    }, x = () => {
      if (r) return w;
      if (s) return v;
    };
    return /* @__PURE__ */ Ve("div", { className: Ke("grid grid-cols-[auto_1fr] gap-2", g.className), children: [
      t && /* @__PURE__ */ $t(
        "label",
        {
          htmlFor: m,
          className: Ke("flex text-md", {
            "text-red-600": b
          }),
          children: t
        }
      ),
      u && /* @__PURE__ */ $t("div", { className: "flex items-center", children: /* @__PURE__ */ $t($P, { text: u }) }),
      s && /* @__PURE__ */ $t("p", { className: "col-span-full -mt-2 text-xs text-grey-600", id: v, children: s }),
      /* @__PURE__ */ Ve("div", { className: "relative col-span-full grid", ref: o, children: [
        /* @__PURE__ */ $t(
          "input",
          {
            id: m,
            onChange: h,
            value: n,
            placeholder: e,
            "aria-invalid": b,
            "aria-describedby": x(),
            type: "text",
            role: "textbox",
            ...g,
            ref: p,
            className: Ke(
              "col-start-1 col-end-1 row-start-1 row-end-1 h-[2.875rem] w-full rounded-lg border-[1px] border-grey-400 bg-white px-[1.125rem] py-2.5",
              "focus-visible:border-primary-500 focus-visible:outline focus-visible:outline-1 focus-visible:outline-primary-500",
              {
                "border-red-600 focus-visible:border-red-600 focus-visible:outline-red-600": b,
                "pr-9": l
              }
            )
          }
        ),
        l && /* @__PURE__ */ $t(
          hr,
          {
            className: "pointer-events-none col-start-1 col-end-1 row-start-1 row-end-1 mr-4 self-center justify-self-end",
            iconName: l
          }
        ),
        f
      ] }),
      b && /* @__PURE__ */ $t("span", { className: "col-span-full text-xs text-red-600", id: w, children: r })
    ] });
  }
), T9t = kn(
  ({ children: t, active: e, ...r }, i) => {
    const s = Fa();
    return /* @__PURE__ */ $t(
      "li",
      {
        ref: i,
        role: "option",
        id: s,
        "aria-selected": e,
        className: Ke("flex min-h-10 cursor-pointer items-center px-3 py-2", {
          "bg-grey-100": e
        }),
        ...r,
        children: t
      }
    );
  }
), v8t = ({
  options: t = [],
  label: e,
  placeholder: r,
  noOptionsText: i = "No options",
  error: s,
  id: c,
  value: u,
  inputValue: l,
  onBlur: f,
  onFocus: o,
  onChange: g,
  onInputChange: p,
  disableInternalSearch: n = !1,
  tooltip: a,
  icon: d,
  optionListMaxHeight: m
}) => {
  const [b, w] = cn(!1), [v, h] = cn(null), x = en(() => u ?? v, [v, u]), [_, M] = cn(""), O = en(() => l ?? _, [l, _]), [E, I] = cn(null), R = Sn([]), W = Fa(), z = c ?? W, { refs: j, floatingStyles: $, context: B } = Nc({
    whileElementsMounted: Qh,
    open: b,
    onOpenChange: w,
    middleware: [
      ef({ padding: 50 }),
      d8({
        apply({ rects: N, availableHeight: V, elements: Y }) {
          Object.assign(Y.floating.style, {
            width: `${N.reference.width}px`,
            maxHeight: m || `${V}px`
          });
        },
        padding: 10
      }),
      tf(1)
    ]
  }), C = qp(B, { role: "listbox" }), T = sf(B), F = p8(B, {
    listRef: R,
    activeIndex: E,
    onNavigate: I,
    virtual: !0,
    loop: !0
  }), { getReferenceProps: S, getFloatingProps: A, getItemProps: U } = of([C, T, F]), K = (N) => {
    const V = N.target.value;
    M(V), p && p(V), V ? (w(!0), I(0)) : w(!1);
  }, X = (N) => {
    b && N.preventDefault(), E !== null && Q[E] && (g && g(Q[E]), l || M(Q[E].label), u || h(Q[E]), I(null), w(!1));
  }, L = (N) => {
    var V;
    g && g(N), h(N), M(N.label), w(!1), (V = j.domReference.current) == null || V.focus();
  }, H = (N) => {
    O === "" ? (h(null), g && g(null)) : M((x == null ? void 0 : x.label) ?? ""), I(null), w(!1), f == null || f(N);
  }, Q = en(() => n ? t : l ? t.filter((N) => N.label.toLowerCase().startsWith(l.toLowerCase())) : _ ? t.filter((N) => N.label.toLowerCase().startsWith(_.toLowerCase())) : t, [n, l, _, t]);
  return /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ $t(
      LP,
      {
        icon: d,
        id: z,
        label: e,
        error: s,
        tooltip: a,
        autoComplete: "off",
        "data-value": (u == null ? void 0 : u.value) ?? (v == null ? void 0 : v.value),
        ...S({
          ref: j.setReference,
          onChange: K,
          value: O,
          placeholder: r,
          "aria-autocomplete": "list",
          onKeyDown: (N) => {
            switch (N.key) {
              case "Enter":
                X(N);
                break;
              case "Escape":
                H();
                break;
            }
          },
          onBlur: H,
          onFocus: o
        })
      }
    ),
    /* @__PURE__ */ $t(af, { children: b && /* @__PURE__ */ $t(Vp, { context: B, initialFocus: -1, visuallyHiddenDismiss: !0, children: /* @__PURE__ */ Ve(
      "ul",
      {
        className: "overflow-y-auto rounded-lg bg-white py-2 shadow",
        tabIndex: -1,
        ...A({
          ref: j.setFloating,
          style: {
            ...$
          }
        }),
        children: [
          Q.length === 0 && /* @__PURE__ */ $t("div", { className: "flex min-h-10 items-center p-3 text-grey-700", children: i }),
          Q.map((N, V) => /* @__PURE__ */ $t(
            T9t,
            {
              ...U({
                key: N.value,
                ref: (Y) => {
                  R.current[V] = Y;
                },
                onMouseDown: (Y) => {
                  Y.preventDefault();
                },
                onClick: () => L(N)
              }),
              active: E === V,
              children: N.label
            }
          ))
        ]
      }
    ) }) })
  ] });
}, N6 = {
  container: {
    uncheckedHover: {
      borderColor: "var(--ssui-color-black)",
      backgroundColor: "var(--ssui-color-white)"
    },
    errorHover: {
      borderColor: "var(--ssui-color-red-700)",
      backgroundColor: "var(--ssui-color-white)"
    },
    unchecked: {
      borderColor: "var(--ssui-color-grey-400)",
      backgroundColor: "var(--ssui-color-white)"
    },
    checked: {
      borderColor: "var(--ssui-color-black)",
      backgroundColor: "var(--ssui-color-black)"
    },
    error: {
      borderColor: "var(--ssui-color-red-600)",
      backgroundColor: "var(--ssui-color-white)"
    },
    disabled: {
      borderColor: "var(--ssui-color-grey-400)",
      backgroundColor: "var(--ssui-color-grey-200)"
    }
  },
  checkmark: {
    checked: {
      color: "var(--ssui-color-white)",
      opacity: 1
    },
    errorHover: {
      color: "var(--ssui-color-red-600)",
      opacity: 1
    },
    error: {
      color: "var(--ssui-color-red-600)",
      opacity: 1
    },
    disabled: {
      color: "var(--ssui-color-grey-400)",
      opacity: 1
    },
    unchecked: {
      opacity: 0
    }
  },
  errorLabel: {
    open: { opacity: 1, height: "auto" },
    collapsed: { opacity: 0, height: 0 }
  }
}, M9t = ({ error: t, className: e, id: r }) => /* @__PURE__ */ $t(Pc, { initial: !1, children: /* @__PURE__ */ Ve(
  bn.div,
  {
    id: r,
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: N6.errorLabel,
    transition: E9t,
    className: Ke("flex items-center gap-1 text-xs text-red-600", e),
    children: [
      /* @__PURE__ */ $t(hr, { iconName: "alert", size: 14 }),
      t
    ]
  }
) }), E9t = {
  ease: "linear",
  duration: 0.1
}, P9t = ({ id: t, disabled: e, children: r, error: i, className: s }) => /* @__PURE__ */ $t(
  "label",
  {
    htmlFor: t,
    className: Ke(
      "text-md",
      {
        "text-red-600": i,
        "text-grey-700": e
      },
      s
    ),
    children: r
  }
), w8t = kn(
  ({ checked: t, disabled: e, error: r, onChange: i, children: s, id: c, onClick: u, helpText: l, ...f }, o) => {
    const [g, p] = cn(!1), [n, a] = cn(!1), d = Fa(), m = Fa(), b = Fa(), w = c ?? d, v = en(() => t ?? g, [t, g]), h = (M) => {
      i && i(M), p((O) => !O);
    }, x = en(() => e ? "disabled" : r ? n ? "errorHover" : "error" : v ? "checked" : n ? "uncheckedHover" : "unchecked", [n, e, r, v]), _ = () => {
      if (r) return b;
      if (l) return m;
    };
    return /* @__PURE__ */ Ve("div", { className: Ke("grid grid-cols-[auto_1fr] justify-start gap-x-2 gap-y-1", f.className), onClick: u, children: [
      /* @__PURE__ */ $t(
        "input",
        {
          id: w,
          type: "checkbox",
          defaultChecked: v,
          onChange: (M) => h(M),
          onMouseOver: () => a(!0),
          onMouseLeave: () => a(!1),
          disabled: e,
          "aria-checked": v,
          "aria-invalid": !!r,
          "aria-describedby": _(),
          ...f,
          className: "peer col-start-1 col-end-2 row-start-1 row-end-2 size-5 cursor-pointer opacity-0 disabled:cursor-auto",
          ref: o
        }
      ),
      /* @__PURE__ */ $t(
        bn.div,
        {
          className: Ke(
            "pointer-events-none col-start-1 col-end-2 row-start-1 row-end-2 flex size-5 items-center justify-center rounded border-[1px]",
            "peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-blue-400",
            {
              "peer-focus-visible:outline-red-600": r
            }
          ),
          initial: x,
          animate: x,
          transition: I9t,
          variants: N6.container,
          children: /* @__PURE__ */ $t(Pc, { initial: !1, children: v && /* @__PURE__ */ $t(
            bn.div,
            {
              animate: x,
              initial: "unchecked",
              exit: "unchecked",
              transition: F9t,
              variants: N6.checkmark,
              className: "checkmark",
              children: /* @__PURE__ */ $t(hr, { iconName: "check-bold", size: 20 })
            }
          ) })
        }
      ),
      s && /* @__PURE__ */ $t(P9t, { id: w, disabled: !!e, error: !!r, children: s }),
      r && /* @__PURE__ */ $t(M9t, { id: b, error: r, className: "col-span-full" }),
      l && /* @__PURE__ */ $t("p", { id: m, className: "col-span-full whitespace-break-spaces text-xs text-grey-600", children: l })
    ] });
  }
), I9t = {
  type: "spring",
  duration: 0.2
}, F9t = {
  ease: "linear",
  duration: 0.1
}, R9t = kn(
  ({ disabled: t, ariaLabel: e = "Vælg dato", ...r }, i) => /* @__PURE__ */ $t(
    "button",
    {
      className: Ke(
        "absolute bottom-[0.3125rem] right-[0.3125rem] grid h-9 w-9 cursor-pointer place-items-center rounded text-primary-500",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-400",
        "hover:bg-primary-150",
        "disabled:cursor-auto disabled:hover:bg-transparent"
      ),
      "aria-label": e,
      disabled: t,
      ...r,
      ref: i,
      type: "button",
      children: /* @__PURE__ */ $t(hr, { iconName: "calendar", "aria-hidden": !0 })
    }
  )
), aA = (t) => {
  if (!t) return "";
  const e = t.getDate().toString().padStart(2, "0"), r = (t.getMonth() + 1).toString().padStart(2, "0"), i = t.getFullYear();
  return [e, r, i].join("/");
}, sA = (t) => {
  const [e, r, i] = t.split("/"), s = parseInt(e, 10), c = parseInt(r, 10), u = parseInt(i, 10);
  return new Date(u, c - 1, s);
}, D9t = kn(
  ({
    value: t,
    onClick: e,
    error: r,
    onChange: i,
    label: s,
    placeholder: c = "dd/mm/åååå",
    tooltip: u,
    disabled: l,
    onBlur: f,
    onFocus: o,
    form: g,
    id: p,
    onKeyDown: n,
    autoFix: a,
    onChangeDateInput: d,
    ...m
  }, b) => {
    const w = mr(), v = p ?? w, {
      ref: h,
      value: x,
      setValue: _
    } = sP(
      {
        mask: Date,
        pattern: "d{/}`m{/}`Y",
        format: aA,
        parse: sA,
        autofix: a ?? !1
      },
      {
        // ? is there a workaround to this?
        ref: b ?? void 0,
        onComplete: (M) => d(sA(M)),
        onAccept: () => d(void 0)
      }
    );
    return Tn(() => {
      document.activeElement !== h.current && _(t ? aA(t) : "");
    }, [h, _, t]), /* @__PURE__ */ $t(
      LP,
      {
        autoComplete: "off",
        id: v,
        onClick: e,
        ref: h,
        value: x,
        error: r,
        onChange: i,
        label: s,
        placeholder: c,
        tooltip: u,
        onKeyDown: n,
        disabled: l,
        onBlur: f,
        onFocus: o,
        form: g,
        ...m
      }
    );
  }
);
function d0(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function $9t(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function oA(t, e) {
  const r = d0(t);
  return isNaN(e) ? $9t(t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
const NP = Math.pow(10, 8) * 24 * 60 * 60 * 1e3, L9t = -NP;
function y3(t) {
  return (e = {}) => {
    const r = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[r] || t.formats[t.defaultWidth];
  };
}
function b1(t) {
  return (e, r) => {
    const i = r != null && r.context ? String(r.context) : "standalone";
    let s;
    if (i === "formatting" && t.formattingValues) {
      const u = t.defaultFormattingWidth || t.defaultWidth, l = r != null && r.width ? String(r.width) : u;
      s = t.formattingValues[l] || t.formattingValues[u];
    } else {
      const u = t.defaultWidth, l = r != null && r.width ? String(r.width) : t.defaultWidth;
      s = t.values[l] || t.values[u];
    }
    const c = t.argumentCallback ? t.argumentCallback(e) : e;
    return s[c];
  };
}
function v1(t) {
  return (e, r = {}) => {
    const i = r.width, s = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], c = e.match(s);
    if (!c)
      return null;
    const u = c[0], l = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth], f = Array.isArray(l) ? B9t(l, (p) => p.test(u)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      N9t(l, (p) => p.test(u))
    );
    let o;
    o = t.valueCallback ? t.valueCallback(f) : f, o = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(o)
    ) : o;
    const g = e.slice(u.length);
    return { value: o, rest: g };
  };
}
function N9t(t, e) {
  for (const r in t)
    if (Object.prototype.hasOwnProperty.call(t, r) && e(t[r]))
      return r;
}
function B9t(t, e) {
  for (let r = 0; r < t.length; r++)
    if (e(t[r]))
      return r;
}
function j9t(t) {
  return (e, r = {}) => {
    const i = e.match(t.matchPattern);
    if (!i) return null;
    const s = i[0], c = e.match(t.parsePattern);
    if (!c) return null;
    let u = t.valueCallback ? t.valueCallback(c[0]) : c[0];
    u = r.valueCallback ? r.valueCallback(u) : u;
    const l = e.slice(s.length);
    return { value: u, rest: l };
  };
}
const U9t = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, H9t = (t, e, r) => {
  let i;
  const s = U9t[t];
  return typeof s == "string" ? i = s : e === 1 ? i = s.one : i = s.other.replace("{{count}}", String(e)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + i : i + " siden" : i;
}, V9t = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, z9t = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, X9t = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, q9t = {
  date: y3({
    formats: V9t,
    defaultWidth: "full"
  }),
  time: y3({
    formats: z9t,
    defaultWidth: "full"
  }),
  dateTime: y3({
    formats: X9t,
    defaultWidth: "full"
  })
}, W9t = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, G9t = (t, e, r, i) => W9t[t], K9t = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Y9t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Z9t = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, J9t = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, Q9t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, t6t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, e6t = (t, e) => Number(t) + ".", n6t = {
  ordinalNumber: e6t,
  era: b1({
    values: K9t,
    defaultWidth: "wide"
  }),
  quarter: b1({
    values: Y9t,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: b1({
    values: Z9t,
    defaultWidth: "wide"
  }),
  day: b1({
    values: J9t,
    defaultWidth: "wide"
  }),
  dayPeriod: b1({
    values: Q9t,
    defaultWidth: "wide",
    formattingValues: t6t,
    defaultFormattingWidth: "wide"
  })
}, r6t = /^(\d+)(\.)?/i, i6t = /\d+/i, a6t = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, s6t = {
  any: [/^f/i, /^(v|e)/i]
}, o6t = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, l6t = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c6t = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, u6t = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, h6t = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, f6t = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, d6t = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, g6t = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, p6t = {
  ordinalNumber: j9t({
    matchPattern: r6t,
    parsePattern: i6t,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: v1({
    matchPatterns: a6t,
    defaultMatchWidth: "wide",
    parsePatterns: s6t,
    defaultParseWidth: "any"
  }),
  quarter: v1({
    matchPatterns: o6t,
    defaultMatchWidth: "wide",
    parsePatterns: l6t,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: v1({
    matchPatterns: c6t,
    defaultMatchWidth: "wide",
    parsePatterns: u6t,
    defaultParseWidth: "any"
  }),
  day: v1({
    matchPatterns: h6t,
    defaultMatchWidth: "wide",
    parsePatterns: f6t,
    defaultParseWidth: "any"
  }),
  dayPeriod: v1({
    matchPatterns: d6t,
    defaultMatchWidth: "any",
    parsePatterns: g6t,
    defaultParseWidth: "any"
  })
}, m6t = {
  code: "da",
  formatDistance: H9t,
  formatLong: q9t,
  formatRelative: G9t,
  localize: n6t,
  match: p6t,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, y6t = "_root_2a8vt_1", b6t = "_vhidden_2a8vt_16", v6t = "_button_reset_2a8vt_36", w6t = "_button_2a8vt_36", x6t = "_day_selected_2a8vt_59", S6t = "_months_2a8vt_77", C6t = "_month_2a8vt_77", A6t = "_table_2a8vt_93", _6t = "_with_weeknumber_2a8vt_99", k6t = "_caption_2a8vt_104", O6t = "_multiple_months_2a8vt_112", T6t = "_caption_dropdowns_2a8vt_118", M6t = "_caption_label_2a8vt_123", E6t = "_nav_2a8vt_139", P6t = "_caption_start_2a8vt_143", I6t = "_caption_end_2a8vt_150", F6t = "_nav_button_2a8vt_157", R6t = "_dropdown_year_2a8vt_171", D6t = "_dropdown_month_2a8vt_172", $6t = "_dropdown_2a8vt_171", L6t = "_dropdown_icon_2a8vt_208", N6t = "_head_2a8vt_212", B6t = "_head_row_2a8vt_216", j6t = "_row_2a8vt_217", U6t = "_head_cell_2a8vt_221", H6t = "_tbody_2a8vt_232", V6t = "_tfoot_2a8vt_236", z6t = "_cell_2a8vt_240", X6t = "_weeknumber_2a8vt_248", q6t = "_day_2a8vt_59", W6t = "_day_today_2a8vt_267", G6t = "_day_outside_2a8vt_267", K6t = "_day_range_start_2a8vt_290", Y6t = "_day_range_end_2a8vt_290", Z6t = "_day_range_middle_2a8vt_314", J6t = {
  root: y6t,
  vhidden: b6t,
  button_reset: v6t,
  button: w6t,
  day_selected: x6t,
  months: S6t,
  month: C6t,
  table: A6t,
  with_weeknumber: _6t,
  caption: k6t,
  multiple_months: O6t,
  caption_dropdowns: T6t,
  caption_label: M6t,
  nav: E6t,
  caption_start: P6t,
  caption_end: I6t,
  nav_button: F6t,
  dropdown_year: R6t,
  dropdown_month: D6t,
  dropdown: $6t,
  dropdown_icon: L6t,
  head: N6t,
  head_row: B6t,
  row: j6t,
  head_cell: U6t,
  tbody: H6t,
  tfoot: V6t,
  cell: z6t,
  weeknumber: X6t,
  day: q6t,
  day_today: W6t,
  day_outside: G6t,
  day_range_start: K6t,
  day_range_end: Y6t,
  day_range_middle: Z6t
}, Q6t = kn(
  ({ onSelectDate: t, selectedDate: e, minDate: r, maxDate: i, ...s }, c) => {
    const [u, l] = cn(e);
    Tn(() => {
      e && l(e);
    }, [e]);
    const f = en(() => {
      const g = [];
      if (r) {
        const p = { from: new Date(L9t / 2), to: oA(r, -1) };
        g.push(p);
      }
      if (i) {
        const p = { from: oA(i, 1), to: new Date(NP) };
        g.push(p);
      }
      return g;
    }, [r, i]), o = en(() => e ?? r, [e, r]);
    return /* @__PURE__ */ $t(
      "div",
      {
        className: "grid w-[20.875rem] rounded-lg border-[1px] border-grey-900 bg-white pb-2 pt-1",
        ...s,
        ref: c,
        children: /* @__PURE__ */ $t(
          HN,
          {
            classNames: J6t,
            className: "_date_picker_grid_2f9aa1a",
            showOutsideDays: !0,
            defaultMonth: o,
            disabled: f,
            mode: "single",
            selected: e,
            onSelect: (g) => t == null ? void 0 : t(g),
            locale: m6t,
            onMonthChange: (g) => l(g),
            month: u
          }
        )
      }
    );
  }
), t7t = kn(
  ({ onSelectDate: t, selectedDate: e, minDate: r, maxDate: i, context: s, show: c, ...u }, l) => {
    const f = {
      initial: { opacity: 0, scale: 0.6 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.6 }
    }, o = en(() => {
      switch (s.placement) {
        case "top-start":
          return "bottom left";
        case "top-end":
          return "bottom right";
        case "bottom-start":
          return "top left";
        case "bottom-end":
          return "top right";
      }
    }, [s.placement]);
    return /* @__PURE__ */ $t(Pc, { children: c && /* @__PURE__ */ $t(af, { children: /* @__PURE__ */ $t(Vp, { context: s, modal: !0, initialFocus: 2, children: /* @__PURE__ */ $t("div", { ...u, ref: l, children: /* @__PURE__ */ $t(
      bn.div,
      {
        style: { transformOrigin: o },
        initial: f.initial,
        animate: f.animate,
        exit: f.exit,
        children: /* @__PURE__ */ $t(
          Q6t,
          {
            onSelectDate: (g) => t == null ? void 0 : t(g),
            selectedDate: e,
            minDate: r,
            maxDate: i,
            role: "dialog",
            "aria-modal": "true"
          }
        )
      }
    ) }) }) }) });
  }
);
function e7t(t, e) {
  const r = d0(t), i = d0(e);
  return +r < +i;
}
function n7t(t, e) {
  const r = d0(t), i = d0(e);
  return r.getTime() > i.getTime();
}
function lA(t) {
  const e = d0(t);
  return e.setHours(0, 0, 0, 0), e;
}
function BP(t, e) {
  const r = lA(t), i = lA(e);
  return +r == +i;
}
function r7t(t, e) {
  if (BP(t, e))
    return !1;
  if (e7t(t, e)) return !0;
}
function i7t(t, e) {
  if (BP(t, e))
    return !1;
  if (n7t(t, e)) return !0;
}
const a7t = (t, { minDate: e, maxDate: r }) => {
  const [i, s] = cn(!0), [c, u] = cn(void 0);
  return Tn(() => {
    if (!t) {
      s(!1), u("NotAValidDate");
      return;
    }
    if (e && r7t(t, e)) {
      s(!1), u("DateIsBeforeMinDate");
      return;
    }
    if (r && i7t(t, r)) {
      s(!1), u("DateIsAfterMaxDate");
      return;
    }
    s(!0), u(void 0);
  }, [t, r, e]), {
    isDateValid: i,
    dateValidationError: c
  };
}, x8t = ({
  label: t,
  placeholder: e,
  error: r,
  id: i,
  value: s,
  onChange: c,
  onBlur: u,
  onFocus: l,
  tooltip: f,
  disabled: o,
  minDate: g,
  maxDate: p,
  onInvalidDate: n,
  className: a
}) => {
  const [d, m] = cn(s), [b, w] = cn(!1), v = Sn(!1), h = Sn(null);
  Tn(() => {
    var F;
    b && (v.current = !0), v.current && !b && ((F = h.current) == null || F.focus());
  }, [b]);
  const x = (F, S, A) => {
    const U = ["outside-press", "escape-key"];
    w(F ?? !1), u && F === !1 && A && U.includes(A) && u();
  }, _ = en(() => {
    const F = s ?? d;
    return F === null ? void 0 : F;
  }, [s, d]), M = (F) => {
    if (c == null || c(F), !F) {
      m(void 0);
      return;
    }
    m(F);
  }, O = (F) => {
    F !== void 0 ? (c == null || c(F), m(F)) : x(!1);
  }, { dateValidationError: E } = a7t(s, { minDate: g, maxDate: p });
  Tn(() => {
    n == null || n(E);
  }, [E, n]);
  const I = 8, { refs: R, floatingStyles: W, context: z } = Nc({
    whileElementsMounted: Qh,
    placement: "bottom-end",
    open: b,
    onOpenChange: x,
    middleware: [
      ef(),
      kP(),
      tf({
        mainAxis: I
      })
    ]
  }), j = zp(z), $ = sf(z), { getReferenceProps: B, getFloatingProps: C } = of([j, $]), T = en(() => {
    const F = `Skift dato, nuværende dato er ${s == null ? void 0 : s.toLocaleDateString("da-DK", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    })}`;
    return s ? F : "Vælg dato";
  }, [s]);
  return /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ $t(
      D9t,
      {
        className: a,
        id: i,
        onChangeDateInput: (F) => M(F),
        onBlur: u,
        onFocus: l,
        value: _,
        label: t,
        error: r,
        tooltip: f,
        disabled: o,
        placeholder: e,
        inputContainerRef: R.setReference,
        customInputNode: /* @__PURE__ */ $t(
          R9t,
          {
            disabled: o,
            ariaLabel: T,
            ref: h,
            ...B()
          }
        )
      }
    ),
    /* @__PURE__ */ $t(
      t7t,
      {
        show: b,
        minDate: g,
        maxDate: p,
        onSelectDate: (F) => O(F),
        selectedDate: _,
        context: z,
        ref: R.setFloating,
        style: W,
        ...C()
      }
    )
  ] });
}, S8t = ({
  options: t,
  value: e,
  placeholder: r,
  label: i,
  onChange: s,
  onBlur: c,
  onFocus: u,
  optionListMaxHeight: l,
  optionRenderFn: f,
  className: o
}) => {
  const g = mr(), p = mr(), n = mr(), [a, d] = cn(!1), [m, b] = cn(null), [w, v] = cn(null), h = en(() => e ? t.findIndex((X) => X.value === e.value) : w, [t, w, e]), x = Js(() => {
    e || (v(null), b(null));
  }, [e]);
  Tn(() => {
    x();
  }, [x]);
  const _ = (X) => {
    v(X), s == null || s(t[X]), a && d(!1);
  }, M = Sn([]), O = Sn(t.map((X) => X.label)), E = Sn(!1), { refs: I, floatingStyles: R, context: W } = Nc({
    whileElementsMounted: Qh,
    open: a,
    onOpenChange: d,
    middleware: [
      ef({ padding: 50 }),
      d8({
        apply({ rects: X, availableHeight: L, elements: H }) {
          Object.assign(H.floating.style, {
            width: `${X.reference.width}px`,
            maxHeight: l || `${L}px`
          });
        },
        padding: 10
      }),
      tf(4)
    ]
  }), z = (X) => X === h && X === m ? "active-selected" : X !== h && X === m ? "active" : X === h ? "selected" : "default", j = () => {
    b((X) => X === null || X - 10 < 0 ? 0 : X - 10);
  }, $ = () => {
    b((X) => X === null ? 0 : X + 10 >= t.length ? t.length - 1 : X + 10);
  }, B = zp(W, { event: "mousedown" }), C = qp(W, { role: "listbox" }), T = sf(W), F = p8(W, {
    listRef: M,
    activeIndex: m,
    selectedIndex: h,
    onNavigate: b,
    virtual: !0,
    loop: !0
  }), S = DP(W, {
    listRef: O,
    activeIndex: m,
    selectedIndex: h,
    onMatch: a ? b : _,
    onTypingChange(X) {
      E.current = X;
    }
  }), { getReferenceProps: A, getFloatingProps: U, getItemProps: K } = of([
    B,
    C,
    T,
    F,
    S
  ]);
  return /* @__PURE__ */ Ve(Ra, { children: [
    /* @__PURE__ */ Ve("div", { className: Ke("grid gap-1", o), children: [
      /* @__PURE__ */ $t("label", { id: g, htmlFor: p, onClick: () => {
        var X;
        return (X = I.domReference.current) == null ? void 0 : X.focus();
      }, children: i }),
      /* @__PURE__ */ Ve(
        "div",
        {
          role: "combobox",
          tabIndex: 0,
          id: p,
          "aria-controls": n,
          "aria-expanded": a,
          "aria-labelledby": g,
          "aria-activedescendant": m ? `${n}-${t[m].value}` : "",
          "aria-autocomplete": "none",
          className: "flex h-12 cursor-pointer items-center justify-between rounded-lg border-[1px] border-grey-400 bg-white px-3 text-grey-900 focus-visible:border-primary-400 focus-visible:outline focus-visible:outline-1 focus-visible:outline-primary-400",
          ref: I.setReference,
          ...A({
            onKeyDown: (X) => {
              X.stopPropagation(), a && X.key === "PageUp" ? (X.preventDefault(), j()) : a && X.key === "PageDown" ? (X.preventDefault(), $()) : a && m !== null && X.key === "Enter" && (X.preventDefault(), _(m));
            },
            onKeyUp: (X) => {
              X.key === " " && !E.current && (a && m !== null ? (X.preventDefault(), _(m)) : d(!0));
            },
            onFocus: (X) => {
              u == null || u(X);
            },
            onBlur: (X) => {
              m !== null && m !== h && _(m), c == null || c(X), d(!1);
            }
          }),
          children: [
            h !== null ? /* @__PURE__ */ $t("span", { children: t[h].label }) : /* @__PURE__ */ $t("span", { className: "text-grey-600", children: r }),
            /* @__PURE__ */ $t(hr, { iconName: "unfold-more", role: "presentation", "aria-hidden": "true" })
          ]
        }
      )
    ] }),
    a && /* @__PURE__ */ $t(af, { children: /* @__PURE__ */ $t(
      "div",
      {
        role: "listbox",
        id: n,
        className: "origin-top overflow-y-auto rounded-lg border-[1px] border-grey-400 bg-white py-2 text-grey-900 shadow",
        ref: I.setFloating,
        style: R,
        ...U(),
        tabIndex: -1,
        children: t.map((X, L) => /* @__PURE__ */ $t(
          "li",
          {
            ref: (H) => {
              M.current[L] = H;
            },
            role: "option",
            "aria-selected": L === h,
            id: `${n}-${X.value}`,
            className: Ke("grid min-h-10 cursor-pointer select-none", {
              "items-center p-3": !f,
              "bg-grey-100": !f && z(L) === "active",
              "bg-purple-100 font-semi-bold text-purple-500": !f && z(L) === "selected",
              "bg-purple-150 font-semi-bold text-purple-500": !f && z(L) === "active-selected"
            }),
            ...K({
              onClick: () => _(L)
            }),
            children: f ? f({
              label: X.label,
              customRenderData: X.customRenderData,
              state: z(L)
            }) : X.label
          },
          X.value
        ))
      }
    ) })
  ] });
};
var jP = {}, UP = {}, m8 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    if (r = `${r}`, r === "0")
      return "0";
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(r))
      return r.replace(/^[+-]?/, (s) => s === "-" ? "" : "-");
    let i = [
      "var",
      "calc",
      "min",
      "max",
      "clamp"
    ];
    for (const s of i)
      if (r.includes(`${s}(`))
        return `calc(${r} * -1)`;
  }
})(m8);
var HP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  const e = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "size",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "textWrap",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "contain",
    "content",
    "forcedColorAdjust"
  ];
})(HP);
var VP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r, i) {
    return r === void 0 ? i : Array.isArray(r) ? r : [
      ...new Set(i.filter((c) => r !== !1 && r[c] !== !1).concat(Object.keys(r).filter((c) => r[c] !== !1)))
    ];
  }
})(VP);
var zP = {}, Wp = {}, y8 = { exports: {} }, an = String, XP = function() {
  return { isColorSupported: !1, reset: an, bold: an, dim: an, italic: an, underline: an, inverse: an, hidden: an, strikethrough: an, black: an, red: an, green: an, yellow: an, blue: an, magenta: an, cyan: an, white: an, gray: an, bgBlack: an, bgRed: an, bgGreen: an, bgYellow: an, bgBlue: an, bgMagenta: an, bgCyan: an, bgWhite: an, blackBright: an, redBright: an, greenBright: an, yellowBright: an, blueBright: an, magentaBright: an, cyanBright: an, whiteBright: an, bgBlackBright: an, bgRedBright: an, bgGreenBright: an, bgYellowBright: an, bgBlueBright: an, bgMagentaBright: an, bgCyanBright: an, bgWhiteBright: an };
};
y8.exports = XP();
y8.exports.createColors = XP;
var qP = y8.exports;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(f, o) {
    for (var g in o) Object.defineProperty(f, g, {
      enumerable: !0,
      get: o[g]
    });
  }
  e(t, {
    dim: function() {
      return u;
    },
    default: function() {
      return l;
    }
  });
  const r = /* @__PURE__ */ i(qP);
  function i(f) {
    return f && f.__esModule ? f : {
      default: f
    };
  }
  let s = /* @__PURE__ */ new Set();
  function c(f, o, g) {
    typeof process < "u" && process.env.JEST_WORKER_ID || g && s.has(g) || (g && s.add(g), console.warn(""), o.forEach((p) => console.warn(f, "-", p)));
  }
  function u(f) {
    return r.default.dim(f);
  }
  const l = {
    info(f, o) {
      c(r.default.bold(r.default.cyan("info")), ...Array.isArray(f) ? [
        f
      ] : [
        o,
        f
      ]);
    },
    warn(f, o) {
      c(r.default.bold(r.default.yellow("warn")), ...Array.isArray(f) ? [
        f
      ] : [
        o,
        f
      ]);
    },
    risk(f, o) {
      c(r.default.bold(r.default.magenta("risk")), ...Array.isArray(f) ? [
        f
      ] : [
        o,
        f
      ]);
    }
  };
})(Wp);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  const e = /* @__PURE__ */ r(Wp);
  function r(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  function i({ version: c, from: u, to: l }) {
    e.default.warn(`${u}-color-renamed`, [
      `As of Tailwind CSS ${c}, \`${u}\` has been renamed to \`${l}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const s = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return i({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return i({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return i({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return i({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return i({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(zP);
var WP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "defaults", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r, ...i) {
    for (let u of i) {
      for (let l in u) {
        var s;
        !(r == null || (s = r.hasOwnProperty) === null || s === void 0) && s.call(r, l) || (r[l] = u[l]);
      }
      for (let l of Object.getOwnPropertySymbols(u)) {
        var c;
        !(r == null || (c = r.hasOwnProperty) === null || c === void 0) && c.call(r, l) || (r[l] = u[l]);
      }
    }
    return r;
  }
})(WP);
var GP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "toPath", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    if (Array.isArray(r)) return r;
    let i = r.split("[").length - 1, s = r.split("]").length - 1;
    if (i !== s)
      throw new Error(`Path is invalid. Has unbalanced brackets: ${r}`);
    return r.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
  }
})(GP);
var KP = {}, Gp = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(p, n) {
    for (var a in n) Object.defineProperty(p, a, {
      enumerable: !0,
      get: n[a]
    });
  }
  e(t, {
    flagEnabled: function() {
      return l;
    },
    issueFlagNotices: function() {
      return o;
    },
    default: function() {
      return g;
    }
  });
  const r = /* @__PURE__ */ s(qP), i = /* @__PURE__ */ s(Wp);
  function s(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  let c = {
    optimizeUniversalDefaults: !1,
    generalizedModifiers: !0,
    disableColorOpacityUtilitiesByDefault: !1,
    relativeContentPathsByDefault: !1
  }, u = {
    future: [
      "hoverOnlyWhenSupported",
      "respectDefaultRingColorOpacity",
      "disableColorOpacityUtilitiesByDefault",
      "relativeContentPathsByDefault"
    ],
    experimental: [
      "optimizeUniversalDefaults",
      "generalizedModifiers"
    ]
  };
  function l(p, n) {
    if (u.future.includes(n)) {
      var a, d, m;
      return p.future === "all" || ((m = (d = p == null || (a = p.future) === null || a === void 0 ? void 0 : a[n]) !== null && d !== void 0 ? d : c[n]) !== null && m !== void 0 ? m : !1);
    }
    if (u.experimental.includes(n)) {
      var b, w, v;
      return p.experimental === "all" || ((v = (w = p == null || (b = p.experimental) === null || b === void 0 ? void 0 : b[n]) !== null && w !== void 0 ? w : c[n]) !== null && v !== void 0 ? v : !1);
    }
    return !1;
  }
  function f(p) {
    if (p.experimental === "all")
      return u.experimental;
    var n;
    return Object.keys((n = p == null ? void 0 : p.experimental) !== null && n !== void 0 ? n : {}).filter((a) => u.experimental.includes(a) && p.experimental[a]);
  }
  function o(p) {
    if (process.env.JEST_WORKER_ID === void 0 && f(p).length > 0) {
      let n = f(p).map((a) => r.default.yellow(a)).join(", ");
      i.default.warn("experimental-flags-enabled", [
        `You have enabled experimental features: ${n}`,
        "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
      ]);
    }
  }
  const g = u;
})(Gp);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "normalizeConfig", {
    enumerable: !0,
    get: function() {
      return c;
    }
  });
  const e = Gp, r = /* @__PURE__ */ s(Wp);
  function i(u) {
    if (typeof WeakMap != "function") return null;
    var l = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (i = function(o) {
      return o ? f : l;
    })(u);
  }
  function s(u, l) {
    if (u && u.__esModule)
      return u;
    if (u === null || typeof u != "object" && typeof u != "function")
      return {
        default: u
      };
    var f = i(l);
    if (f && f.has(u))
      return f.get(u);
    var o = {}, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in u)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(u, p)) {
        var n = g ? Object.getOwnPropertyDescriptor(u, p) : null;
        n && (n.get || n.set) ? Object.defineProperty(o, p, n) : o[p] = u[p];
      }
    return o.default = u, f && f.set(u, o), o;
  }
  function c(u) {
    if ((() => {
      if (u.purge || !u.content || !Array.isArray(u.content) && !(typeof u.content == "object" && u.content !== null))
        return !1;
      if (Array.isArray(u.content))
        return u.content.every((o) => typeof o == "string" ? !0 : !(typeof (o == null ? void 0 : o.raw) != "string" || o != null && o.extension && typeof (o == null ? void 0 : o.extension) != "string"));
      if (typeof u.content == "object" && u.content !== null) {
        if (Object.keys(u.content).some((o) => ![
          "files",
          "relative",
          "extract",
          "transform"
        ].includes(o)))
          return !1;
        if (Array.isArray(u.content.files)) {
          if (!u.content.files.every((o) => typeof o == "string" ? !0 : !(typeof (o == null ? void 0 : o.raw) != "string" || o != null && o.extension && typeof (o == null ? void 0 : o.extension) != "string")))
            return !1;
          if (typeof u.content.extract == "object") {
            for (let o of Object.values(u.content.extract))
              if (typeof o != "function")
                return !1;
          } else if (!(u.content.extract === void 0 || typeof u.content.extract == "function"))
            return !1;
          if (typeof u.content.transform == "object") {
            for (let o of Object.values(u.content.transform))
              if (typeof o != "function")
                return !1;
          } else if (!(u.content.transform === void 0 || typeof u.content.transform == "function"))
            return !1;
          if (typeof u.content.relative != "boolean" && typeof u.content.relative < "u")
            return !1;
        }
        return !0;
      }
      return !1;
    })() || r.default.warn("purge-deprecation", [
      "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
      "Update your configuration file to eliminate this warning.",
      "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]), u.safelist = (() => {
      var o;
      let { content: g, purge: p, safelist: n } = u;
      return Array.isArray(n) ? n : Array.isArray(g == null ? void 0 : g.safelist) ? g.safelist : Array.isArray(p == null ? void 0 : p.safelist) ? p.safelist : Array.isArray(p == null || (o = p.options) === null || o === void 0 ? void 0 : o.safelist) ? p.options.safelist : [];
    })(), u.blocklist = (() => {
      let { blocklist: o } = u;
      if (Array.isArray(o)) {
        if (o.every((g) => typeof g == "string"))
          return o;
        r.default.warn("blocklist-invalid", [
          "The `blocklist` option must be an array of strings.",
          "https://tailwindcss.com/docs/content-configuration#discarding-classes"
        ]);
      }
      return [];
    })(), typeof u.prefix == "function")
      r.default.warn("prefix-function", [
        "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
        "Update `prefix` in your configuration to be a string to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
      ]), u.prefix = "";
    else {
      var f;
      u.prefix = (f = u.prefix) !== null && f !== void 0 ? f : "";
    }
    u.content = {
      relative: (() => {
        let { content: o } = u;
        return o != null && o.relative ? o.relative : (0, e.flagEnabled)(u, "relativeContentPathsByDefault");
      })(),
      files: (() => {
        let { content: o, purge: g } = u;
        return Array.isArray(g) ? g : Array.isArray(g == null ? void 0 : g.content) ? g.content : Array.isArray(o) ? o : Array.isArray(o == null ? void 0 : o.content) ? o.content : Array.isArray(o == null ? void 0 : o.files) ? o.files : [];
      })(),
      extract: (() => {
        let o = (() => {
          var n, a, d, m, b, w, v, h, x, _;
          return !((n = u.purge) === null || n === void 0) && n.extract ? u.purge.extract : !((a = u.content) === null || a === void 0) && a.extract ? u.content.extract : !((d = u.purge) === null || d === void 0 || (m = d.extract) === null || m === void 0) && m.DEFAULT ? u.purge.extract.DEFAULT : !((b = u.content) === null || b === void 0 || (w = b.extract) === null || w === void 0) && w.DEFAULT ? u.content.extract.DEFAULT : !((v = u.purge) === null || v === void 0 || (h = v.options) === null || h === void 0) && h.extractors ? u.purge.options.extractors : !((x = u.content) === null || x === void 0 || (_ = x.options) === null || _ === void 0) && _.extractors ? u.content.options.extractors : {};
        })(), g = {}, p = (() => {
          var n, a, d, m;
          if (!((n = u.purge) === null || n === void 0 || (a = n.options) === null || a === void 0) && a.defaultExtractor)
            return u.purge.options.defaultExtractor;
          if (!((d = u.content) === null || d === void 0 || (m = d.options) === null || m === void 0) && m.defaultExtractor)
            return u.content.options.defaultExtractor;
        })();
        if (p !== void 0 && (g.DEFAULT = p), typeof o == "function")
          g.DEFAULT = o;
        else if (Array.isArray(o))
          for (let { extensions: n, extractor: a } of o ?? [])
            for (let d of n)
              g[d] = a;
        else typeof o == "object" && o !== null && Object.assign(g, o);
        return g;
      })(),
      transform: (() => {
        let o = (() => {
          var p, n, a, d, m, b;
          return !((p = u.purge) === null || p === void 0) && p.transform ? u.purge.transform : !((n = u.content) === null || n === void 0) && n.transform ? u.content.transform : !((a = u.purge) === null || a === void 0 || (d = a.transform) === null || d === void 0) && d.DEFAULT ? u.purge.transform.DEFAULT : !((m = u.content) === null || m === void 0 || (b = m.transform) === null || b === void 0) && b.DEFAULT ? u.content.transform.DEFAULT : {};
        })(), g = {};
        return typeof o == "function" ? g.DEFAULT = o : typeof o == "object" && o !== null && Object.assign(g, o), g;
      })()
    };
    for (let o of u.content.files)
      if (typeof o == "string" && /{([^,]*?)}/g.test(o)) {
        r.default.warn("invalid-glob-braces", [
          `The glob pattern ${(0, r.dim)(o)} in your Tailwind CSS configuration is invalid.`,
          `Update it to ${(0, r.dim)(o.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
      }
    return u;
  }
})(KP);
var YP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    if (Object.prototype.toString.call(r) !== "[object Object]")
      return !1;
    const i = Object.getPrototypeOf(r);
    return i === null || Object.getPrototypeOf(i) === null;
  }
})(YP);
var ZP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    return Array.isArray(r) ? r.map((i) => e(i)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([i, s]) => [
      i,
      e(s)
    ])) : r;
  }
})(ZP);
var JP = {}, QP = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    return r.replace(/\\,/g, "\\2c ");
  }
})(QP);
var b8 = {}, v8 = {}, tI = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  const e = {
    aliceblue: [
      240,
      248,
      255
    ],
    antiquewhite: [
      250,
      235,
      215
    ],
    aqua: [
      0,
      255,
      255
    ],
    aquamarine: [
      127,
      255,
      212
    ],
    azure: [
      240,
      255,
      255
    ],
    beige: [
      245,
      245,
      220
    ],
    bisque: [
      255,
      228,
      196
    ],
    black: [
      0,
      0,
      0
    ],
    blanchedalmond: [
      255,
      235,
      205
    ],
    blue: [
      0,
      0,
      255
    ],
    blueviolet: [
      138,
      43,
      226
    ],
    brown: [
      165,
      42,
      42
    ],
    burlywood: [
      222,
      184,
      135
    ],
    cadetblue: [
      95,
      158,
      160
    ],
    chartreuse: [
      127,
      255,
      0
    ],
    chocolate: [
      210,
      105,
      30
    ],
    coral: [
      255,
      127,
      80
    ],
    cornflowerblue: [
      100,
      149,
      237
    ],
    cornsilk: [
      255,
      248,
      220
    ],
    crimson: [
      220,
      20,
      60
    ],
    cyan: [
      0,
      255,
      255
    ],
    darkblue: [
      0,
      0,
      139
    ],
    darkcyan: [
      0,
      139,
      139
    ],
    darkgoldenrod: [
      184,
      134,
      11
    ],
    darkgray: [
      169,
      169,
      169
    ],
    darkgreen: [
      0,
      100,
      0
    ],
    darkgrey: [
      169,
      169,
      169
    ],
    darkkhaki: [
      189,
      183,
      107
    ],
    darkmagenta: [
      139,
      0,
      139
    ],
    darkolivegreen: [
      85,
      107,
      47
    ],
    darkorange: [
      255,
      140,
      0
    ],
    darkorchid: [
      153,
      50,
      204
    ],
    darkred: [
      139,
      0,
      0
    ],
    darksalmon: [
      233,
      150,
      122
    ],
    darkseagreen: [
      143,
      188,
      143
    ],
    darkslateblue: [
      72,
      61,
      139
    ],
    darkslategray: [
      47,
      79,
      79
    ],
    darkslategrey: [
      47,
      79,
      79
    ],
    darkturquoise: [
      0,
      206,
      209
    ],
    darkviolet: [
      148,
      0,
      211
    ],
    deeppink: [
      255,
      20,
      147
    ],
    deepskyblue: [
      0,
      191,
      255
    ],
    dimgray: [
      105,
      105,
      105
    ],
    dimgrey: [
      105,
      105,
      105
    ],
    dodgerblue: [
      30,
      144,
      255
    ],
    firebrick: [
      178,
      34,
      34
    ],
    floralwhite: [
      255,
      250,
      240
    ],
    forestgreen: [
      34,
      139,
      34
    ],
    fuchsia: [
      255,
      0,
      255
    ],
    gainsboro: [
      220,
      220,
      220
    ],
    ghostwhite: [
      248,
      248,
      255
    ],
    gold: [
      255,
      215,
      0
    ],
    goldenrod: [
      218,
      165,
      32
    ],
    gray: [
      128,
      128,
      128
    ],
    green: [
      0,
      128,
      0
    ],
    greenyellow: [
      173,
      255,
      47
    ],
    grey: [
      128,
      128,
      128
    ],
    honeydew: [
      240,
      255,
      240
    ],
    hotpink: [
      255,
      105,
      180
    ],
    indianred: [
      205,
      92,
      92
    ],
    indigo: [
      75,
      0,
      130
    ],
    ivory: [
      255,
      255,
      240
    ],
    khaki: [
      240,
      230,
      140
    ],
    lavender: [
      230,
      230,
      250
    ],
    lavenderblush: [
      255,
      240,
      245
    ],
    lawngreen: [
      124,
      252,
      0
    ],
    lemonchiffon: [
      255,
      250,
      205
    ],
    lightblue: [
      173,
      216,
      230
    ],
    lightcoral: [
      240,
      128,
      128
    ],
    lightcyan: [
      224,
      255,
      255
    ],
    lightgoldenrodyellow: [
      250,
      250,
      210
    ],
    lightgray: [
      211,
      211,
      211
    ],
    lightgreen: [
      144,
      238,
      144
    ],
    lightgrey: [
      211,
      211,
      211
    ],
    lightpink: [
      255,
      182,
      193
    ],
    lightsalmon: [
      255,
      160,
      122
    ],
    lightseagreen: [
      32,
      178,
      170
    ],
    lightskyblue: [
      135,
      206,
      250
    ],
    lightslategray: [
      119,
      136,
      153
    ],
    lightslategrey: [
      119,
      136,
      153
    ],
    lightsteelblue: [
      176,
      196,
      222
    ],
    lightyellow: [
      255,
      255,
      224
    ],
    lime: [
      0,
      255,
      0
    ],
    limegreen: [
      50,
      205,
      50
    ],
    linen: [
      250,
      240,
      230
    ],
    magenta: [
      255,
      0,
      255
    ],
    maroon: [
      128,
      0,
      0
    ],
    mediumaquamarine: [
      102,
      205,
      170
    ],
    mediumblue: [
      0,
      0,
      205
    ],
    mediumorchid: [
      186,
      85,
      211
    ],
    mediumpurple: [
      147,
      112,
      219
    ],
    mediumseagreen: [
      60,
      179,
      113
    ],
    mediumslateblue: [
      123,
      104,
      238
    ],
    mediumspringgreen: [
      0,
      250,
      154
    ],
    mediumturquoise: [
      72,
      209,
      204
    ],
    mediumvioletred: [
      199,
      21,
      133
    ],
    midnightblue: [
      25,
      25,
      112
    ],
    mintcream: [
      245,
      255,
      250
    ],
    mistyrose: [
      255,
      228,
      225
    ],
    moccasin: [
      255,
      228,
      181
    ],
    navajowhite: [
      255,
      222,
      173
    ],
    navy: [
      0,
      0,
      128
    ],
    oldlace: [
      253,
      245,
      230
    ],
    olive: [
      128,
      128,
      0
    ],
    olivedrab: [
      107,
      142,
      35
    ],
    orange: [
      255,
      165,
      0
    ],
    orangered: [
      255,
      69,
      0
    ],
    orchid: [
      218,
      112,
      214
    ],
    palegoldenrod: [
      238,
      232,
      170
    ],
    palegreen: [
      152,
      251,
      152
    ],
    paleturquoise: [
      175,
      238,
      238
    ],
    palevioletred: [
      219,
      112,
      147
    ],
    papayawhip: [
      255,
      239,
      213
    ],
    peachpuff: [
      255,
      218,
      185
    ],
    peru: [
      205,
      133,
      63
    ],
    pink: [
      255,
      192,
      203
    ],
    plum: [
      221,
      160,
      221
    ],
    powderblue: [
      176,
      224,
      230
    ],
    purple: [
      128,
      0,
      128
    ],
    rebeccapurple: [
      102,
      51,
      153
    ],
    red: [
      255,
      0,
      0
    ],
    rosybrown: [
      188,
      143,
      143
    ],
    royalblue: [
      65,
      105,
      225
    ],
    saddlebrown: [
      139,
      69,
      19
    ],
    salmon: [
      250,
      128,
      114
    ],
    sandybrown: [
      244,
      164,
      96
    ],
    seagreen: [
      46,
      139,
      87
    ],
    seashell: [
      255,
      245,
      238
    ],
    sienna: [
      160,
      82,
      45
    ],
    silver: [
      192,
      192,
      192
    ],
    skyblue: [
      135,
      206,
      235
    ],
    slateblue: [
      106,
      90,
      205
    ],
    slategray: [
      112,
      128,
      144
    ],
    slategrey: [
      112,
      128,
      144
    ],
    snow: [
      255,
      250,
      250
    ],
    springgreen: [
      0,
      255,
      127
    ],
    steelblue: [
      70,
      130,
      180
    ],
    tan: [
      210,
      180,
      140
    ],
    teal: [
      0,
      128,
      128
    ],
    thistle: [
      216,
      191,
      216
    ],
    tomato: [
      255,
      99,
      71
    ],
    turquoise: [
      64,
      224,
      208
    ],
    violet: [
      238,
      130,
      238
    ],
    wheat: [
      245,
      222,
      179
    ],
    white: [
      255,
      255,
      255
    ],
    whitesmoke: [
      245,
      245,
      245
    ],
    yellow: [
      255,
      255,
      0
    ],
    yellowgreen: [
      154,
      205,
      50
    ]
  };
})(tI);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(d, m) {
    for (var b in m) Object.defineProperty(d, b, {
      enumerable: !0,
      get: m[b]
    });
  }
  e(t, {
    parseColor: function() {
      return n;
    },
    formatColor: function() {
      return a;
    }
  });
  const r = /* @__PURE__ */ i(tI);
  function i(d) {
    return d && d.__esModule ? d : {
      default: d
    };
  }
  let s = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, c = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, u = /(?:\d+|\d*\.\d+)%?/, l = /(?:\s*,\s*|\s+)/, f = /\s*[,/]\s*/, o = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, g = new RegExp(`^(rgba?)\\(\\s*(${u.source}|${o.source})(?:${l.source}(${u.source}|${o.source}))?(?:${l.source}(${u.source}|${o.source}))?(?:${f.source}(${u.source}|${o.source}))?\\s*\\)$`), p = new RegExp(`^(hsla?)\\(\\s*((?:${u.source})(?:deg|rad|grad|turn)?|${o.source})(?:${l.source}(${u.source}|${o.source}))?(?:${l.source}(${u.source}|${o.source}))?(?:${f.source}(${u.source}|${o.source}))?\\s*\\)$`);
  function n(d, { loose: m = !1 } = {}) {
    var b, w;
    if (typeof d != "string")
      return null;
    if (d = d.trim(), d === "transparent")
      return {
        mode: "rgb",
        color: [
          "0",
          "0",
          "0"
        ],
        alpha: "0"
      };
    if (d in r.default)
      return {
        mode: "rgb",
        color: r.default[d].map((M) => M.toString())
      };
    let v = d.replace(c, (M, O, E, I, R) => [
      "#",
      O,
      O,
      E,
      E,
      I,
      I,
      R ? R + R : ""
    ].join("")).match(s);
    if (v !== null)
      return {
        mode: "rgb",
        color: [
          parseInt(v[1], 16),
          parseInt(v[2], 16),
          parseInt(v[3], 16)
        ].map((M) => M.toString()),
        alpha: v[4] ? (parseInt(v[4], 16) / 255).toString() : void 0
      };
    var h;
    let x = (h = d.match(g)) !== null && h !== void 0 ? h : d.match(p);
    if (x === null)
      return null;
    let _ = [
      x[2],
      x[3],
      x[4]
    ].filter(Boolean).map((M) => M.toString());
    return _.length === 2 && _[0].startsWith("var(") ? {
      mode: x[1],
      color: [
        _[0]
      ],
      alpha: _[1]
    } : !m && _.length !== 3 || _.length < 3 && !_.some((M) => /^var\(.*?\)$/.test(M)) ? null : {
      mode: x[1],
      color: _,
      alpha: (b = x[5]) === null || b === void 0 || (w = b.toString) === null || w === void 0 ? void 0 : w.call(b)
    };
  }
  function a({ mode: d, color: m, alpha: b }) {
    let w = b !== void 0;
    return d === "rgba" || d === "hsla" ? `${d}(${m.join(", ")}${w ? `, ${b}` : ""})` : `${d}(${m.join(" ")}${w ? ` / ${b}` : ""})`;
  }
})(v8);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(c, u) {
    for (var l in u) Object.defineProperty(c, l, {
      enumerable: !0,
      get: u[l]
    });
  }
  e(t, {
    withAlphaValue: function() {
      return i;
    },
    default: function() {
      return s;
    }
  });
  const r = v8;
  function i(c, u, l) {
    if (typeof c == "function")
      return c({
        opacityValue: u
      });
    let f = (0, r.parseColor)(c, {
      loose: !0
    });
    return f === null ? l : (0, r.formatColor)({
      ...f,
      alpha: u
    });
  }
  function s({ color: c, property: u, variable: l }) {
    let f = [].concat(u);
    if (typeof c == "function")
      return {
        [l]: "1",
        ...Object.fromEntries(f.map((g) => [
          g,
          c({
            opacityVariable: l,
            opacityValue: `var(${l}, 1)`
          })
        ]))
      };
    const o = (0, r.parseColor)(c);
    return o === null ? Object.fromEntries(f.map((g) => [
      g,
      c
    ])) : o.alpha !== void 0 ? Object.fromEntries(f.map((g) => [
      g,
      c
    ])) : {
      [l]: "1",
      ...Object.fromEntries(f.map((g) => [
        g,
        (0, r.formatColor)({
          ...o,
          alpha: `var(${l}, 1)`
        })
      ]))
    };
  }
})(b8);
var w8 = {}, eI = {}, Kp = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "splitAtTopLevelOnly", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r, i) {
    let s = [], c = [], u = 0, l = !1;
    for (let f = 0; f < r.length; f++) {
      let o = r[f];
      s.length === 0 && o === i[0] && !l && (i.length === 1 || r.slice(f, f + i.length) === i) && (c.push(r.slice(u, f)), u = f + i.length), l = l ? !1 : o === "\\", o === "(" || o === "[" || o === "{" ? s.push(o) : (o === ")" && s[s.length - 1] === "(" || o === "]" && s[s.length - 1] === "[" || o === "}" && s[s.length - 1] === "{") && s.pop();
    }
    return c.push(r.slice(u)), c;
  }
})(Kp);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(f, o) {
    for (var g in o) Object.defineProperty(f, g, {
      enumerable: !0,
      get: o[g]
    });
  }
  e(t, {
    parseBoxShadowValue: function() {
      return u;
    },
    formatBoxShadowValue: function() {
      return l;
    }
  });
  const r = Kp;
  let i = /* @__PURE__ */ new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]), s = /\ +(?![^(]*\))/g, c = /^-?(\d+|\.\d+)(.*?)$/g;
  function u(f) {
    return (0, r.splitAtTopLevelOnly)(f, ",").map((g) => {
      let p = g.trim(), n = {
        raw: p
      }, a = p.split(s), d = /* @__PURE__ */ new Set();
      for (let m of a)
        c.lastIndex = 0, !d.has("KEYWORD") && i.has(m) ? (n.keyword = m, d.add("KEYWORD")) : c.test(m) ? d.has("X") ? d.has("Y") ? d.has("BLUR") ? d.has("SPREAD") || (n.spread = m, d.add("SPREAD")) : (n.blur = m, d.add("BLUR")) : (n.y = m, d.add("Y")) : (n.x = m, d.add("X")) : n.color ? (n.unknown || (n.unknown = []), n.unknown.push(m)) : n.color = m;
      return n.valid = n.x !== void 0 && n.y !== void 0, n;
    });
  }
  function l(f) {
    return f.map((o) => o.valid ? [
      o.keyword,
      o.x,
      o.y,
      o.blur,
      o.spread,
      o.color
    ].filter(Boolean).join(" ") : o.raw).join(", ");
  }
})(eI);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(T, F) {
    for (var S in F) Object.defineProperty(T, S, {
      enumerable: !0,
      get: F[S]
    });
  }
  e(t, {
    normalize: function() {
      return f;
    },
    normalizeAttributeSelectors: function() {
      return o;
    },
    url: function() {
      return p;
    },
    number: function() {
      return n;
    },
    percentage: function() {
      return a;
    },
    length: function() {
      return b;
    },
    lineWidth: function() {
      return v;
    },
    shadow: function() {
      return h;
    },
    color: function() {
      return x;
    },
    image: function() {
      return _;
    },
    gradient: function() {
      return O;
    },
    position: function() {
      return I;
    },
    familyName: function() {
      return R;
    },
    genericName: function() {
      return z;
    },
    absoluteSize: function() {
      return $;
    },
    relativeSize: function() {
      return C;
    }
  });
  const r = v8, i = eI, s = Kp;
  let c = [
    "min",
    "max",
    "clamp",
    "calc"
  ];
  function u(T) {
    return c.some((F) => new RegExp(`^${F}\\(.*\\)`).test(T));
  }
  const l = /* @__PURE__ */ new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    "anchor-name",
    "anchor-scope",
    "position-anchor",
    "position-try-options",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline",
    "position-try"
  ]);
  function f(T, F = null, S = !0) {
    let A = F && l.has(F.property);
    return T.startsWith("--") && !A ? `var(${T})` : T.includes("url(") ? T.split(/(url\(.*?\))/g).filter(Boolean).map((U) => /^url\(.*?\)$/.test(U) ? U : f(U, F, !1)).join("") : (T = T.replace(/([^\\])_+/g, (U, K) => K + " ".repeat(U.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), S && (T = T.trim()), T = g(T), T);
  }
  function o(T) {
    return T.includes("=") && (T = T.replace(/(=.*)/g, (F, S) => {
      if (S[1] === "'" || S[1] === '"')
        return S;
      if (S.length > 2) {
        let A = S[S.length - 1];
        if (S[S.length - 2] === " " && (A === "i" || A === "I" || A === "s" || A === "S"))
          return `="${S.slice(1, -2)}" ${S[S.length - 1]}`;
      }
      return `="${S.slice(1)}"`;
    })), T;
  }
  function g(T) {
    let F = [
      "theme"
    ], S = [
      "min-content",
      "max-content",
      "fit-content",
      // Env
      "safe-area-inset-top",
      "safe-area-inset-right",
      "safe-area-inset-bottom",
      "safe-area-inset-left",
      "titlebar-area-x",
      "titlebar-area-y",
      "titlebar-area-width",
      "titlebar-area-height",
      "keyboard-inset-top",
      "keyboard-inset-right",
      "keyboard-inset-bottom",
      "keyboard-inset-left",
      "keyboard-inset-width",
      "keyboard-inset-height",
      "radial-gradient",
      "linear-gradient",
      "conic-gradient",
      "repeating-radial-gradient",
      "repeating-linear-gradient",
      "repeating-conic-gradient",
      "anchor-size"
    ];
    return T.replace(/(calc|min|max|clamp)\(.+\)/g, (A) => {
      let U = "";
      function K() {
        let X = U.trimEnd();
        return X[X.length - 1];
      }
      for (let X = 0; X < A.length; X++) {
        let L = function(N) {
          return N.split("").every((V, Y) => A[X + Y] === V);
        }, H = function(N) {
          let V = 1 / 0;
          for (let Z of N) {
            let rt = A.indexOf(Z, X);
            rt !== -1 && rt < V && (V = rt);
          }
          let Y = A.slice(X, V);
          return X += Y.length - 1, Y;
        }, Q = A[X];
        if (L("var"))
          U += H([
            ")",
            ","
          ]);
        else if (S.some((N) => L(N))) {
          let N = S.find((V) => L(V));
          U += N, X += N.length - 1;
        } else F.some((N) => L(N)) ? U += H([
          ")"
        ]) : L("[") ? U += H([
          "]"
        ]) : [
          "+",
          "-",
          "*",
          "/"
        ].includes(Q) && ![
          "(",
          "+",
          "-",
          "*",
          "/",
          ","
        ].includes(K()) ? U += ` ${Q} ` : U += Q;
      }
      return U.replace(/\s+/g, " ");
    });
  }
  function p(T) {
    return T.startsWith("url(");
  }
  function n(T) {
    return !isNaN(Number(T)) || u(T);
  }
  function a(T) {
    return T.endsWith("%") && n(T.slice(0, -1)) || u(T);
  }
  let m = `(?:${[
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
  ].join("|")})`;
  function b(T) {
    return T === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${m}$`).test(T) || u(T);
  }
  let w = /* @__PURE__ */ new Set([
    "thin",
    "medium",
    "thick"
  ]);
  function v(T) {
    return w.has(T);
  }
  function h(T) {
    let F = (0, i.parseBoxShadowValue)(f(T));
    for (let S of F)
      if (!S.valid)
        return !1;
    return !0;
  }
  function x(T) {
    let F = 0;
    return (0, s.splitAtTopLevelOnly)(T, "_").every((A) => (A = f(A), A.startsWith("var(") ? !0 : (0, r.parseColor)(A, {
      loose: !0
    }) !== null ? (F++, !0) : !1)) ? F > 0 : !1;
  }
  function _(T) {
    let F = 0;
    return (0, s.splitAtTopLevelOnly)(T, ",").every((A) => (A = f(A), A.startsWith("var(") ? !0 : p(A) || O(A) || [
      "element(",
      "image(",
      "cross-fade(",
      "image-set("
    ].some((U) => A.startsWith(U)) ? (F++, !0) : !1)) ? F > 0 : !1;
  }
  let M = /* @__PURE__ */ new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
  ]);
  function O(T) {
    T = f(T);
    for (let F of M)
      if (T.startsWith(`${F}(`))
        return !0;
    return !1;
  }
  let E = /* @__PURE__ */ new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
  ]);
  function I(T) {
    let F = 0;
    return (0, s.splitAtTopLevelOnly)(T, "_").every((A) => (A = f(A), A.startsWith("var(") ? !0 : E.has(A) || b(A) || a(A) ? (F++, !0) : !1)) ? F > 0 : !1;
  }
  function R(T) {
    let F = 0;
    return (0, s.splitAtTopLevelOnly)(T, ",").every((A) => (A = f(A), A.startsWith("var(") ? !0 : A.includes(" ") && !/(['"])([^"']+)\1/g.test(A) || /^\d/g.test(A) ? !1 : (F++, !0))) ? F > 0 : !1;
  }
  let W = /* @__PURE__ */ new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
  ]);
  function z(T) {
    return W.has(T);
  }
  let j = /* @__PURE__ */ new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large"
  ]);
  function $(T) {
    return j.has(T);
  }
  let B = /* @__PURE__ */ new Set([
    "larger",
    "smaller"
  ]);
  function C(T) {
    return B.has(T);
  }
})(w8);
var nI = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "backgroundSize", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const e = w8, r = Kp;
  function i(s) {
    let c = [
      "cover",
      "contain"
    ];
    return (0, r.splitAtTopLevelOnly)(s, ",").every((u) => {
      let l = (0, r.splitAtTopLevelOnly)(u, "_").filter(Boolean);
      return l.length === 1 && c.includes(l[0]) ? !0 : l.length !== 1 && l.length !== 2 ? !1 : l.every((f) => (0, e.length)(f) || (0, e.percentage)(f) || f === "auto");
    });
  }
})(nI);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(I, R) {
    for (var W in R) Object.defineProperty(I, W, {
      enumerable: !0,
      get: R[W]
    });
  }
  e(t, {
    updateAllClasses: function() {
      return o;
    },
    asValue: function() {
      return n;
    },
    parseColorFormat: function() {
      return m;
    },
    asColor: function() {
      return w;
    },
    asLookupValue: function() {
      return v;
    },
    typeMap: function() {
      return x;
    },
    coerceValue: function() {
      return O;
    },
    getMatchingTypes: function() {
      return E;
    }
  });
  const r = /* @__PURE__ */ f(QP), i = b8, s = w8, c = /* @__PURE__ */ f(m8), u = nI, l = Gp;
  function f(I) {
    return I && I.__esModule ? I : {
      default: I
    };
  }
  function o(I, R) {
    I.walkClasses((W) => {
      W.value = R(W.value), W.raws && W.raws.value && (W.raws.value = (0, r.default)(W.raws.value));
    });
  }
  function g(I, R) {
    if (!a(I))
      return;
    let W = I.slice(1, -1);
    if (R(W))
      return (0, s.normalize)(W);
  }
  function p(I, R = {}, W) {
    let z = R[I];
    if (z !== void 0)
      return (0, c.default)(z);
    if (a(I)) {
      let j = g(I, W);
      return j === void 0 ? void 0 : (0, c.default)(j);
    }
  }
  function n(I, R = {}, { validate: W = () => !0 } = {}) {
    var z;
    let j = (z = R.values) === null || z === void 0 ? void 0 : z[I];
    return j !== void 0 ? j : R.supportsNegativeValues && I.startsWith("-") ? p(I.slice(1), R.values, W) : g(I, W);
  }
  function a(I) {
    return I.startsWith("[") && I.endsWith("]");
  }
  function d(I) {
    let R = I.lastIndexOf("/"), W = I.lastIndexOf("[", R), z = I.indexOf("]", R);
    return I[R - 1] === "]" || I[R + 1] === "[" || W !== -1 && z !== -1 && W < R && R < z && (R = I.lastIndexOf("/", W)), R === -1 || R === I.length - 1 ? [
      I,
      void 0
    ] : a(I) && !I.includes("]/[") ? [
      I,
      void 0
    ] : [
      I.slice(0, R),
      I.slice(R + 1)
    ];
  }
  function m(I) {
    if (typeof I == "string" && I.includes("<alpha-value>")) {
      let R = I;
      return ({ opacityValue: W = 1 }) => R.replace(/<alpha-value>/g, W);
    }
    return I;
  }
  function b(I) {
    return (0, s.normalize)(I.slice(1, -1));
  }
  function w(I, R = {}, { tailwindConfig: W = {} } = {}) {
    var z;
    if (((z = R.values) === null || z === void 0 ? void 0 : z[I]) !== void 0) {
      var j;
      return m((j = R.values) === null || j === void 0 ? void 0 : j[I]);
    }
    let [$, B] = d(I);
    if (B !== void 0) {
      var C, T, F, S;
      let A = (S = (C = R.values) === null || C === void 0 ? void 0 : C[$]) !== null && S !== void 0 ? S : a($) ? $.slice(1, -1) : void 0;
      return A === void 0 ? void 0 : (A = m(A), a(B) ? (0, i.withAlphaValue)(A, b(B)) : ((T = W.theme) === null || T === void 0 || (F = T.opacity) === null || F === void 0 ? void 0 : F[B]) === void 0 ? void 0 : (0, i.withAlphaValue)(A, W.theme.opacity[B]));
    }
    return n(I, R, {
      validate: s.color
    });
  }
  function v(I, R = {}) {
    var W;
    return (W = R.values) === null || W === void 0 ? void 0 : W[I];
  }
  function h(I) {
    return (R, W) => n(R, W, {
      validate: I
    });
  }
  let x = {
    any: n,
    color: w,
    url: h(s.url),
    image: h(s.image),
    length: h(s.length),
    percentage: h(s.percentage),
    position: h(s.position),
    lookup: v,
    "generic-name": h(s.genericName),
    "family-name": h(s.familyName),
    number: h(s.number),
    "line-width": h(s.lineWidth),
    "absolute-size": h(s.absoluteSize),
    "relative-size": h(s.relativeSize),
    shadow: h(s.shadow),
    size: h(u.backgroundSize)
  }, _ = Object.keys(x);
  function M(I, R) {
    let W = I.indexOf(R);
    return W === -1 ? [
      void 0,
      I
    ] : [
      I.slice(0, W),
      I.slice(W + 1)
    ];
  }
  function O(I, R, W, z) {
    if (W.values && R in W.values)
      for (let { type: $ } of I ?? []) {
        let B = x[$](R, W, {
          tailwindConfig: z
        });
        if (B !== void 0)
          return [
            B,
            $,
            null
          ];
      }
    if (a(R)) {
      let $ = R.slice(1, -1), [B, C] = M($, ":");
      if (!/^[\w-_]+$/g.test(B))
        C = $;
      else if (B !== void 0 && !_.includes(B))
        return [];
      if (C.length > 0 && _.includes(B))
        return [
          n(`[${C}]`, W),
          B,
          null
        ];
    }
    let j = E(I, R, W, z);
    for (let $ of j)
      return $;
    return [];
  }
  function* E(I, R, W, z) {
    let j = (0, l.flagEnabled)(z, "generalizedModifiers"), [$, B] = d(R);
    if (j && W.modifiers != null && (W.modifiers === "any" || typeof W.modifiers == "object" && (B && a(B) || B in W.modifiers)) || ($ = R, B = void 0), B !== void 0 && $ === "" && ($ = "DEFAULT"), B !== void 0 && typeof W.modifiers == "object") {
      var T, F;
      let S = (F = (T = W.modifiers) === null || T === void 0 ? void 0 : T[B]) !== null && F !== void 0 ? F : null;
      S !== null ? B = S : a(B) && (B = b(B));
    }
    for (let { type: S } of I ?? []) {
      let A = x[S]($, W, {
        tailwindConfig: z
      });
      A !== void 0 && (yield [
        A,
        S,
        B ?? null
      ]);
    }
  }
})(JP);
var rI = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    return typeof r == "function" ? r({}) : r;
  }
})(rI);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return W;
    }
  });
  const e = /* @__PURE__ */ a(m8), r = /* @__PURE__ */ a(HP), i = /* @__PURE__ */ a(VP), s = /* @__PURE__ */ a(zP), c = WP, u = GP, l = KP, f = /* @__PURE__ */ a(YP), o = ZP, g = JP, p = b8, n = /* @__PURE__ */ a(rI);
  function a(z) {
    return z && z.__esModule ? z : {
      default: z
    };
  }
  function d(z) {
    return typeof z == "function";
  }
  function m(z, ...j) {
    let $ = j.pop();
    for (let B of j)
      for (let C in B) {
        let T = $(z[C], B[C]);
        T === void 0 ? (0, f.default)(z[C]) && (0, f.default)(B[C]) ? z[C] = m({}, z[C], B[C], $) : z[C] = B[C] : z[C] = T;
      }
    return z;
  }
  const b = {
    colors: s.default,
    negative(z) {
      return Object.keys(z).filter((j) => z[j] !== "0").reduce((j, $) => {
        let B = (0, e.default)(z[$]);
        return B !== void 0 && (j[`-${$}`] = B), j;
      }, {});
    },
    breakpoints(z) {
      return Object.keys(z).filter((j) => typeof z[j] == "string").reduce((j, $) => ({
        ...j,
        [`screen-${$}`]: z[$]
      }), {});
    }
  };
  function w(z, ...j) {
    return d(z) ? z(...j) : z;
  }
  function v(z) {
    return z.reduce((j, { extend: $ }) => m(j, $, (B, C) => B === void 0 ? [
      C
    ] : Array.isArray(B) ? [
      C,
      ...B
    ] : [
      C,
      B
    ]), {});
  }
  function h(z) {
    return {
      ...z.reduce((j, $) => (0, c.defaults)(j, $), {}),
      // In order to resolve n config objects, we combine all of their `extend` properties
      // into arrays instead of objects so they aren't overridden.
      extend: v(z)
    };
  }
  function x(z, j) {
    if (Array.isArray(z) && (0, f.default)(z[0]))
      return z.concat(j);
    if (Array.isArray(j) && (0, f.default)(j[0]) && (0, f.default)(z))
      return [
        z,
        ...j
      ];
    if (Array.isArray(j))
      return j;
  }
  function _({ extend: z, ...j }) {
    return m(j, z, ($, B) => !d($) && !B.some(d) ? m({}, $, ...B, x) : (C, T) => m({}, ...[
      $,
      ...B
    ].map((F) => w(F, C, T)), x));
  }
  function* M(z) {
    let j = (0, u.toPath)(z);
    if (j.length === 0 || (yield j, Array.isArray(z)))
      return;
    let $ = /^(.*?)\s*\/\s*([^/]+)$/, B = z.match($);
    if (B !== null) {
      let [, C, T] = B, F = (0, u.toPath)(C);
      F.alpha = T, yield F;
    }
  }
  function O(z) {
    const j = ($, B) => {
      for (const C of M($)) {
        let T = 0, F = z;
        for (; F != null && T < C.length; )
          F = F[C[T++]], F = d(F) && (C.alpha === void 0 || T <= C.length - 1) ? F(j, b) : F;
        if (F !== void 0) {
          if (C.alpha !== void 0) {
            let S = (0, g.parseColorFormat)(F);
            return (0, p.withAlphaValue)(S, C.alpha, (0, n.default)(S));
          }
          return (0, f.default)(F) ? (0, o.cloneDeep)(F) : F;
        }
      }
      return B;
    };
    return Object.assign(j, {
      theme: j,
      ...b
    }), Object.keys(z).reduce(($, B) => ($[B] = d(z[B]) ? z[B](j, b) : z[B], $), {});
  }
  function E(z) {
    let j = [];
    return z.forEach(($) => {
      j = [
        ...j,
        $
      ];
      var B;
      const C = (B = $ == null ? void 0 : $.plugins) !== null && B !== void 0 ? B : [];
      C.length !== 0 && C.forEach((T) => {
        T.__isOptionsFunction && (T = T());
        var F;
        j = [
          ...j,
          ...E([
            (F = T == null ? void 0 : T.config) !== null && F !== void 0 ? F : {}
          ])
        ];
      });
    }), j;
  }
  function I(z) {
    return [
      ...z
    ].reduceRight(($, B) => d(B) ? B({
      corePlugins: $
    }) : (0, i.default)(B, $), r.default);
  }
  function R(z) {
    return [
      ...z
    ].reduceRight(($, B) => [
      ...$,
      ...B
    ], []);
  }
  function W(z) {
    let j = [
      ...E(z),
      {
        prefix: "",
        important: !1,
        separator: ":"
      }
    ];
    var $, B;
    return (0, l.normalizeConfig)((0, c.defaults)({
      theme: O(_(h(j.map((C) => ($ = C == null ? void 0 : C.theme) !== null && $ !== void 0 ? $ : {})))),
      corePlugins: I(j.map((C) => C.corePlugins)),
      plugins: R(z.map((C) => (B = C == null ? void 0 : C.plugins) !== null && B !== void 0 ? B : []))
    }, ...j));
  }
})(UP);
var iI = {}, s7t = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: t }) => ({
      ...t("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: t }) => t("blur"),
    backdropBrightness: ({ theme: t }) => t("brightness"),
    backdropContrast: ({ theme: t }) => t("contrast"),
    backdropGrayscale: ({ theme: t }) => t("grayscale"),
    backdropHueRotate: ({ theme: t }) => t("hueRotate"),
    backdropInvert: ({ theme: t }) => t("invert"),
    backdropOpacity: ({ theme: t }) => t("opacity"),
    backdropSaturate: ({ theme: t }) => t("saturate"),
    backdropSepia: ({ theme: t }) => t("sepia"),
    backgroundColor: ({ theme: t }) => t("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: t }) => t("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: t }) => ({
      ...t("colors"),
      DEFAULT: t("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: t }) => t("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: t }) => ({
      ...t("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: t }) => t("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: t }) => t("colors"),
    colors: ({ colors: t }) => ({
      inherit: t.inherit,
      current: t.current,
      transparent: t.transparent,
      black: t.black,
      white: t.white,
      slate: t.slate,
      gray: t.gray,
      zinc: t.zinc,
      neutral: t.neutral,
      stone: t.stone,
      red: t.red,
      orange: t.orange,
      amber: t.amber,
      yellow: t.yellow,
      lime: t.lime,
      green: t.green,
      emerald: t.emerald,
      teal: t.teal,
      cyan: t.cyan,
      sky: t.sky,
      blue: t.blue,
      indigo: t.indigo,
      violet: t.violet,
      purple: t.purple,
      fuchsia: t.fuchsia,
      pink: t.pink,
      rose: t.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: t }) => t("borderColor"),
    divideOpacity: ({ theme: t }) => t("borderOpacity"),
    divideWidth: ({ theme: t }) => t("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: t }) => t("spacing"),
    gradientColorStops: ({ theme: t }) => t("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: t }) => ({
      ...t("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: t, breakpoints: e }) => ({
      ...t("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...e(t("screens"))
    }),
    minHeight: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: t }) => t("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: t }) => t("spacing"),
    placeholderColor: ({ theme: t }) => t("colors"),
    placeholderOpacity: ({ theme: t }) => t("opacity"),
    ringColor: ({ theme: t }) => ({
      DEFAULT: t("colors.blue.500", "#3b82f6"),
      ...t("colors")
    }),
    ringOffsetColor: ({ theme: t }) => t("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: t }) => ({
      DEFAULT: "0.5",
      ...t("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: t }) => ({
      ...t("spacing")
    }),
    scrollPadding: ({ theme: t }) => t("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: t }) => ({
      ...t("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: t }) => t("colors"),
    textDecorationColor: ({ theme: t }) => t("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: t }) => ({
      ...t("spacing")
    }),
    textOpacity: ({ theme: t }) => t("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: t }) => ({
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  const e = /* @__PURE__ */ i(s7t), r = Gp;
  function i(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  function s(c) {
    var u;
    const l = ((u = c == null ? void 0 : c.presets) !== null && u !== void 0 ? u : [
      e.default
    ]).slice().reverse().flatMap((g) => s(g instanceof Function ? g() : g)), f = {
      // Add experimental configs here...
      respectDefaultRingColorOpacity: {
        theme: {
          ringColor: ({ theme: g }) => ({
            DEFAULT: "#3b82f67f",
            ...g("colors")
          })
        }
      },
      disableColorOpacityUtilitiesByDefault: {
        corePlugins: {
          backgroundOpacity: !1,
          borderOpacity: !1,
          divideOpacity: !1,
          placeholderOpacity: !1,
          ringOpacity: !1,
          textOpacity: !1
        }
      }
    }, o = Object.keys(f).filter((g) => (0, r.flagEnabled)(c, g)).map((g) => f[g]);
    return [
      c,
      ...o,
      ...l
    ];
  }
})(iI);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  const e = /* @__PURE__ */ i(UP), r = /* @__PURE__ */ i(iI);
  function i(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  function s(...c) {
    let [, ...u] = (0, r.default)(c[0]);
    return (0, e.default)([
      ...c,
      ...u
    ]);
  }
})(jP);
let b3 = jP;
var o7t = (b3.__esModule ? b3 : { default: b3 }).default;
const l7t = /* @__PURE__ */ Dn(o7t);
var aI = {}, sI = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  function e(i, s) {
    return {
      handler: i,
      config: s
    };
  }
  e.withOptions = function(i, s = () => ({})) {
    const c = function(u) {
      return {
        __options: u,
        handler: i(u),
        config: s(u)
      };
    };
    return c.__isOptionsFunction = !0, c.__pluginFunction = i, c.__configFunction = s, c;
  };
  const r = e;
})(sI);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const e = /* @__PURE__ */ r(sI);
  function r(s) {
    return s && s.__esModule ? s : {
      default: s
    };
  }
  const i = e.default;
})(aI);
let v3 = aI;
var c7t = (v3.__esModule ? v3 : { default: v3 }).default, u7t = /* @__PURE__ */ h7t(c7t);
function h7t(t) {
  return t && t.__esModule ? t : {
    default: t
  };
}
var f7t = (0, u7t.default)(function(e) {
  var r = e.matchUtilities, i = e.matchVariant, s = e.theme, c = function(o) {
    var g, p, n = (p = (g = o.match(/^(\d+\.\d+|\d+|\.\d+)\D+/)) === null || g === void 0 ? void 0 : g[1]) !== null && p !== void 0 ? p : null;
    return n === null ? null : parseFloat(o);
  }, u, l = (u = s("containers")) !== null && u !== void 0 ? u : {};
  r({
    "@container": function(f, o) {
      var g = o.modifier;
      return {
        "container-type": f,
        "container-name": g
      };
    }
  }, {
    values: {
      DEFAULT: "inline-size",
      normal: "normal"
    },
    modifiers: "any"
  }), i("@", function() {
    var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = (arguments.length > 1 ? arguments[1] : void 0).modifier, g = c(f);
    return g !== null ? "@container ".concat(o ?? "", " (min-width: ").concat(f, ")") : [];
  }, {
    values: l,
    sort: function(o, g) {
      var p = parseFloat(o.value), n = parseFloat(g.value);
      if (p === null || n === null) return 0;
      if (p - n !== 0) return p - n;
      var a, d = (a = o.modifier) !== null && a !== void 0 ? a : "", m, b = (m = g.modifier) !== null && m !== void 0 ? m : "";
      return d === "" && b !== "" ? 1 : d !== "" && b === "" ? -1 : d.localeCompare(b, "en", {
        numeric: !0
      });
    }
  });
}, {
  theme: {
    containers: {
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    }
  }
});
const d7t = /* @__PURE__ */ Dn(f7t), g7t = {
  content: ["./lib/**/*.{js,ts,jsx,tsx}"],
  theme: {
    screens: {
      xs: "0px",
      sm: "600px",
      md: "990px",
      lg: "1340px",
      xl: "1920px"
    },
    fontFamily: {
      "norlys-headline": ["Norlys Headline UI", "sans-serif"],
      "norlys-text": ["Norlys Text UI", "sans-serif"]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "0.75rem" }],
      sm: ["0.875rem", { lineHeight: "1rem" }],
      base: ["1rem", { lineHeight: "1.25rem" }],
      md: ["1rem", { lineHeight: "1.25rem" }],
      lg: ["1.125rem", { lineHeight: "1.25rem" }],
      xl: ["1.25rem", { lineHeight: "1.5rem" }],
      "2xl": ["1.375rem", { lineHeight: "1.75rem" }],
      "3xl": ["1.75rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.75rem" }],
      "5xl": ["2.5rem", { lineHeight: "3rem" }],
      "6xl": ["3rem", { lineHeight: "3.5rem" }]
    },
    fontWeight: {
      light: "300",
      regular: "400",
      "semi-bold": "500",
      bold: "640"
    },
    colors: {
      transparent: "transparent",
      white: "var(--ssui-color-white)",
      grey: {
        100: "var(--ssui-color-grey-100)",
        200: "var(--ssui-color-grey-200)",
        300: "var(--ssui-color-grey-300)",
        400: "var(--ssui-color-grey-400)",
        500: "var(--ssui-color-grey-500)",
        600: "var(--ssui-color-grey-600)",
        700: "var(--ssui-color-grey-700)",
        800: "var(--ssui-color-grey-800)",
        850: "var(--ssui-color-grey-850)",
        900: "var(--ssui-color-grey-900)"
      },
      black: "var(--ssui-color-black)",
      "transparent-dark": {
        50: "var(--ssui-color-transparent-dark-50)",
        100: "var(--ssui-color-transparent-dark-100)",
        200: "var(--ssui-color-transparent-dark-200)",
        300: "var(--ssui-color-transparent-dark-300)",
        400: "var(--ssui-color-transparent-dark-400)",
        500: "var(--ssui-color-transparent-dark-500)",
        600: "var(--ssui-color-transparent-dark-600)",
        700: "var(--ssui-color-transparent-dark-700)",
        800: "var(--ssui-color-transparent-dark-800)",
        850: "var(--ssui-color-transparent-dark-850)",
        900: "var(--ssui-color-transparent-dark-900)",
        950: "var(--ssui-color-transparent-dark-950)"
      },
      primary: {
        50: "var(--ssui-theme-color-primary-50)",
        100: "var(--ssui-theme-color-primary-100)",
        150: "var(--ssui-theme-color-primary-150)",
        200: "var(--ssui-theme-color-primary-200)",
        250: "var(--ssui-theme-color-primary-250)",
        300: "var(--ssui-theme-color-primary-300)",
        400: "var(--ssui-theme-color-primary-400)",
        500: "var(--ssui-theme-color-primary-500)",
        600: "var(--ssui-theme-color-primary-600)",
        700: "var(--ssui-theme-color-primary-700)",
        800: "var(--ssui-theme-color-primary-800)"
      },
      purple: {
        50: "var(--ssui-color-purple-50)",
        100: "var(--ssui-color-purple-100)",
        150: "var(--ssui-color-purple-150)",
        200: "var(--ssui-color-purple-200)",
        250: "var(--ssui-color-purple-250)",
        300: "var(--ssui-color-purple-300)",
        400: "var(--ssui-color-purple-400)",
        500: "var(--ssui-color-purple-500)",
        600: "var(--ssui-color-purple-600)",
        700: "var(--ssui-color-purple-700)",
        800: "var(--ssui-color-purple-800)"
      },
      red: {
        100: "var(--ssui-color-red-100)",
        200: "var(--ssui-color-red-200)",
        300: "var(--ssui-color-red-300)",
        400: "var(--ssui-color-red-400)",
        500: "var(--ssui-color-red-500)",
        600: "var(--ssui-color-red-600)",
        700: "var(--ssui-color-red-700)",
        800: "var(--ssui-color-red-800)",
        850: "var(--ssui-color-red-850)",
        900: "var(--ssui-color-red-900)"
      },
      yellow: {
        100: "var(--ssui-color-yellow-100)",
        200: "var(--ssui-color-yellow-200)",
        300: "var(--ssui-color-yellow-300)",
        400: "var(--ssui-color-yellow-400)",
        500: "var(--ssui-color-yellow-500)",
        600: "var(--ssui-color-yellow-600)",
        700: "var(--ssui-color-yellow-700)",
        800: "var(--ssui-color-yellow-800)",
        850: "var(--ssui-color-yellow-850)",
        900: "var(--ssui-color-yellow-900)"
      },
      green: {
        100: "var(--ssui-color-green-100)",
        200: "var(--ssui-color-green-200)",
        300: "var(--ssui-color-green-300)",
        400: "var(--ssui-color-green-400)",
        500: "var(--ssui-color-green-500)",
        600: "var(--ssui-color-green-600)",
        700: "var(--ssui-color-green-700)",
        800: "var(--ssui-color-green-800)",
        850: "var(--ssui-color-green-850)",
        900: "var(--ssui-color-green-900)"
      },
      blue: {
        100: "var(--ssui-color-blue-100)",
        200: "var(--ssui-color-blue-200)",
        300: "var(--ssui-color-blue-300)",
        400: "var(--ssui-color-blue-400)",
        500: "var(--ssui-color-blue-500)",
        600: "var(--ssui-color-blue-600)",
        700: "var(--ssui-color-blue-700)",
        800: "var(--ssui-color-blue-800)",
        850: "var(--ssui-color-blue-850)",
        900: "var(--ssui-color-blue-900)"
      }
    },
    // Use the extend property if you want to add new styles in addition to the default Tailwind styles, else use the theme property to override.
    extend: {
      keyframes: {
        progressiveStroke: {
          "0%": {
            "stroke-dashoffset": "-20"
          },
          "49%": {
            "stroke-dashoffset": "0"
          },
          "50%": {
            "stroke-dashoffset": "80"
          },
          "100%": {
            "stroke-dashoffset": "100"
          }
        },
        "opacity-fade-in-out": {
          "0%": {
            opacity: "1"
          },
          "50%": {
            opacity: "0.5"
          },
          "100%": {
            opacity: "1"
          }
        }
      }
    }
  },
  // Tailwind's official plugins: https://tailwindcss.com/docs/plugins.
  // Container Queries Plugin: https://github.com/tailwindlabs/tailwindcss-container-queries.
  plugins: [d7t]
}, w3 = l7t(g7t), C8t = ({
  label: t,
  options: e,
  selected: r,
  disabled: i,
  onChange: s,
  onBlur: c,
  onFocus: u,
  tooltip: l,
  className: f
}) => {
  const o = mr(), g = mr(), p = mr(), [n, a] = cn(r ?? e[0]), d = en(() => r ?? n, [n, r]), m = (h) => {
    i || (r || a(h), s == null || s(h));
  }, b = (h) => {
    if (h.key === "ArrowDown" || h.key === "ArrowRight") {
      h.preventDefault();
      const x = e.findIndex((_) => _.value === d.value);
      x < e.length - 1 ? m(e[x + 1]) : m(e[0]);
    }
    if (h.key === "ArrowUp" || h.key === "ArrowLeft") {
      h.preventDefault();
      const x = e.findIndex((_) => _.value === d.value);
      x > 0 ? m(e[x - 1]) : m(e[e.length - 1]);
    }
  }, w = (h) => i ? w3.theme.colors.grey[700] : h.value === d.value ? w3.theme.colors.grey[900] : w3.theme.colors.grey[700], v = {
    type: "spring",
    stiffness: 500,
    damping: 40
  };
  return /* @__PURE__ */ Ve("div", { className: Ke("grid grid-cols-[auto_1fr] gap-x-2 gap-y-1", f), children: [
    t && /* @__PURE__ */ $t("label", { id: o, htmlFor: g, className: "text-base text-grey-900", children: t }),
    l && /* @__PURE__ */ $t($P, { text: l }),
    /* @__PURE__ */ $t(
      "ul",
      {
        id: g,
        className: `relative z-0 col-span-2 flex h-10 min-w-min gap-1 rounded-lg bg-grey-200 p-1 shadow-inner focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-400 ${i ? "pointer-events-none" : ""}`,
        tabIndex: i ? -1 : 0,
        onKeyDown: b,
        role: "radiogroup",
        onFocus: u,
        onBlur: c,
        "aria-activedescendant": `${g}-${d.value}`,
        "aria-labelledby": o,
        "aria-disabled": i,
        children: e.map((h) => /* @__PURE__ */ Ve(
          "li",
          {
            id: `${g}-${h.value}`,
            className: "relative flex flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded px-3",
            onClick: () => m(h),
            role: "radio",
            "aria-checked": d.value === h.value,
            children: [
              h.value === d.value && /* @__PURE__ */ $t(
                bn.span,
                {
                  layoutId: p,
                  transition: v,
                  className: `absolute h-full w-full rounded bg-white shadow ${i ? "bg-grey-300 shadow-none" : ""}`
                }
              ),
              /* @__PURE__ */ $t(
                bn.span,
                {
                  animate: {
                    color: w(h)
                  },
                  transition: v,
                  className: "z-10 select-none text-base",
                  children: h.label
                }
              )
            ]
          },
          h.value
        ))
      }
    )
  ] });
}, A8t = ({
  checked: t,
  onChange: e,
  onClick: r,
  children: i,
  ariaLabel: s,
  id: c,
  className: u,
  labelOn: l = "Til",
  labelOff: f = "Fra"
}) => {
  const o = Fa(), g = c ?? o, p = Fa(), [n, a] = cn(!!t), d = en(() => t ?? n, [t, n]), m = (h) => {
    e ? e(h) : a((x) => !x);
  }, b = (h) => {
    h.key === "Enter" && h.currentTarget.click();
  }, w = l ?? "Til", v = f ?? "Fra";
  return /* @__PURE__ */ Ve(
    "div",
    {
      className: Ke(
        "grid grid-cols-[auto] items-start justify-start gap-2",
        {
          "grid-cols-[auto_auto]": i
        },
        u
      ),
      onClick: (h) => r == null ? void 0 : r(h),
      children: [
        /* @__PURE__ */ $t(
          "input",
          {
            id: g,
            "aria-label": s,
            className: Ke(
              "peer col-start-1 col-end-2 row-span-full h-[1.625rem] w-[3.75rem] cursor-pointer rounded-full opacity-0"
            ),
            type: "checkbox",
            role: "switch",
            checked: d,
            "aria-checked": d,
            onChange: m,
            onKeyDown: b,
            "aria-labelledby": p
          }
        ),
        /* @__PURE__ */ $t(
          bn.div,
          {
            className: Ke(
              "pointer-events-none relative col-start-1 col-end-2 row-span-full mt-[1px] flex h-[1.625rem] w-[3.75rem] select-none items-center justify-start gap-2 overflow-hidden rounded-full border-[1px] border-grey-800 bg-grey-100 p-1",
              "peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-primary-500"
            ),
            animate: d ? "on" : "off",
            transition: cA,
            variants: {
              on: Ud.container.on,
              off: Ud.container.off
            },
            children: /* @__PURE__ */ Ve(
              bn.div,
              {
                className: "absolute flex aspect-square h-4 content-center items-center rounded-full bg-grey-800",
                transition: cA,
                variants: {
                  on: Ud.bullet.on,
                  off: Ud.bullet.off
                },
                children: [
                  /* @__PURE__ */ $t(
                    "span",
                    {
                      "aria-hidden": !0,
                      className: "absolute right-4 grid h-4 w-9 content-center justify-items-center text-center text-sm",
                      children: w
                    }
                  ),
                  /* @__PURE__ */ $t(
                    "span",
                    {
                      "aria-hidden": !0,
                      className: "absolute left-4 grid h-4 w-9 content-center justify-items-center text-center text-sm",
                      children: v
                    }
                  )
                ]
              }
            )
          }
        ),
        i && /* @__PURE__ */ $t("label", { id: p, htmlFor: g, className: "pt-0.5 text-md", children: i })
      ]
    }
  );
}, cA = {
  type: "spring",
  duration: 0.2
}, Ud = {
  container: {
    on: {
      backgroundColor: "var(--ssui-theme-color-primary-500)",
      borderColor: "var(--ssui-theme-color-primary-500)",
      color: "var(--ssui-color-white)"
    },
    off: {
      backgroundColor: "var(--ssui-color-grey-100)",
      borderColor: "var(--ssui-color-grey-300)",
      color: "var(--ssui-color-grey-900)"
    }
  },
  bullet: {
    on: {
      backgroundColor: "var(--ssui-color-white)",
      right: "0.25rem",
      left: "auto"
    },
    off: {
      backgroundColor: "var(--ssui-color-grey-600)",
      left: "0.25rem",
      right: "auto"
    }
  }
}, _8t = kn(({ variant: t, children: e, ...r }, i) => {
  switch (t) {
    case "h1":
      return /* @__PURE__ */ $t(p7t, { ref: i, ...r, children: e });
    case "h2":
      return /* @__PURE__ */ $t(m7t, { ref: i, ...r, children: e });
    case "h3":
      return /* @__PURE__ */ $t(y7t, { ref: i, ...r, children: e });
    case "h4":
      return /* @__PURE__ */ $t(b7t, { ref: i, ...r, children: e });
    case "h4l":
      return /* @__PURE__ */ $t(v7t, { ref: i, ...r, children: e });
    case "h5":
      return /* @__PURE__ */ $t(w7t, { ref: i, ...r, children: e });
    case "h5l":
      return /* @__PURE__ */ $t(x7t, { ref: i, ...r, children: e });
    case "st1":
      return /* @__PURE__ */ $t(S7t, { ref: i, ...r, children: e });
    case "st2":
      return /* @__PURE__ */ $t(C7t, { ref: i, ...r, children: e });
    case "st3":
      return /* @__PURE__ */ $t(A7t, { ref: i, ...r, children: e });
    case "body1":
      return /* @__PURE__ */ $t(_7t, { ref: i, ...r, children: e });
    case "body1Bold":
      return /* @__PURE__ */ $t(k7t, { ref: i, ...r, children: e });
    case "body2":
      return /* @__PURE__ */ $t(O7t, { ref: i, ...r, children: e });
    case "body3":
      return /* @__PURE__ */ $t(T7t, { ref: i, ...r, children: e });
    case "detail":
      return /* @__PURE__ */ $t(M7t, { ref: i, ...r, children: e });
    case "detailBold":
      return /* @__PURE__ */ $t(E7t, { ref: i, ...r, children: e });
    case "petit":
      return /* @__PURE__ */ $t(P7t, { ref: i, ...r, children: e });
    case "petitBold":
      return /* @__PURE__ */ $t(I7t, { ref: i, ...r, children: e });
    case "numbers1":
      return /* @__PURE__ */ $t(F7t, { ref: i, ...r, children: e });
    case "numbers2":
      return /* @__PURE__ */ $t(R7t, { ref: i, ...r, children: e });
  }
}), p7t = Wn.h1`
  ${Hn.mixins.fonts.h1};
`, m7t = Wn.h2`
  ${Hn.mixins.fonts.h2};
`, y7t = Wn.h3`
  ${Hn.mixins.fonts.h3};
`, b7t = Wn.h4`
  ${Hn.mixins.fonts.h4};
`, v7t = Wn.h4`
  ${Hn.mixins.fonts.h4l};
`, w7t = Wn.h5`
  ${Hn.mixins.fonts.h5};
`, x7t = Wn.h5`
  ${Hn.mixins.fonts.h5l};
`, S7t = Wn.h6`
  ${Hn.mixins.fonts.st1};
`, C7t = Wn.h6`
  ${Hn.mixins.fonts.st2};
`, A7t = Wn.h6`
  ${Hn.mixins.fonts.st3};
`, _7t = Wn.p`
  ${Hn.mixins.fonts.body1};
`, k7t = Wn.p`
  ${Hn.mixins.fonts.body1Bold};
`, O7t = Wn.p`
  ${Hn.mixins.fonts.body2};
`, T7t = Wn.p`
  ${Hn.mixins.fonts.body3};
`, M7t = Wn.p`
  ${Hn.mixins.fonts.detail};
`, E7t = Wn.p`
  ${Hn.mixins.fonts.detailBold};
`, P7t = Wn.p`
  ${Hn.mixins.fonts.petit};
`, I7t = Wn.p`
  ${Hn.mixins.fonts.petitBold};
`, F7t = Wn.p`
  ${Hn.mixins.fonts.numbers1};
`, R7t = Wn.p`
  ${Hn.mixins.fonts.numbers2};
`, k8t = kn(
  ({ children: t, show: e, className: r, ...i }, s) => /* @__PURE__ */ $t(Pc, { mode: "popLayout", children: e && /* @__PURE__ */ $t(
    bn.div,
    {
      layout: !0,
      transition: { type: "spring", duration: 0.5 },
      initial: { opacity: 0, scale: 0.8 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.8 },
      ...i,
      className: r,
      ref: s,
      children: t
    }
  ) })
), O8t = ({ value: t, fractionDigits: e = 2, className: r }) => {
  const i = mk(0), s = (u) => new Intl.NumberFormat("da-DK", {
    maximumFractionDigits: e,
    minimumFractionDigits: e
  }).format(u), c = Bz(i, (u) => s(u));
  return aX(i, t), /* @__PURE__ */ $t(bn.span, { className: r, children: c });
}, T8t = ({ headingLevel: t, children: e, ...r }) => /* @__PURE__ */ Ve(Ra, { children: [
  t === "h1" && /* @__PURE__ */ $t("h1", { ...r, children: e }),
  t === "h2" && /* @__PURE__ */ $t("h2", { ...r, children: e }),
  t === "h3" && /* @__PURE__ */ $t("h3", { ...r, children: e }),
  t === "h4" && /* @__PURE__ */ $t("h4", { ...r, children: e }),
  t === "h5" && /* @__PURE__ */ $t("h5", { ...r, children: e }),
  t === "h6" && /* @__PURE__ */ $t("h6", { ...r, children: e })
] }), D7t = (t) => {
  const e = en(() => window.matchMedia(t.toString().replaceAll(",", "")), [t]), [r, i] = cn(e.matches);
  return Tn(() => {
    e.onchange = (s) => {
      i(s.matches);
    };
  }, [e]), r;
}, M8t = kn(
  ({
    show: t = !1,
    onClose: e,
    children: r,
    hideCloseButton: i = !1,
    invertCloseButtonColor: s = !1,
    enableScroll: c = !1,
    initialFocus: u = 9999
  }, l) => {
    const f = D7t(zn.min.sm);
    Tn(() => {
      const a = (d) => {
        t && d.key === "Escape" && (d.preventDefault(), e());
      };
      return window.addEventListener("keydown", a), () => window.removeEventListener("keydown", a);
    }, [e, t]), Tn(() => (t && (document.body.style.overflow = "hidden"), () => {
      document.body.style.removeProperty("overflow"), document.body.style.length === 0 && document.body.removeAttribute("style");
    }), [t]), Tn(() => (t && (document.body.style.overscrollBehavior = "none"), t && (document.documentElement.style.overscrollBehavior = "none"), () => {
      document.body.style.removeProperty("overscroll-behavior"), document.documentElement.style.removeProperty("overscroll-behavior"), document.body.style.length === 0 && document.body.removeAttribute("style"), document.documentElement.style.length === 0 && document.documentElement.removeAttribute("style");
    }), [t]);
    const o = (a, d) => {
      d.offset.y > 75 && e();
    }, g = en(() => f ? {
      initial: { opacity: 0, y: 300, scale: 0.5 },
      animate: { opacity: 1, y: 0, scale: 1 },
      exit: { opacity: 0, y: 300, scale: 0.5 },
      transition: {
        type: "spring",
        bounce: 0.1,
        duration: 0.4
      }
    } : {
      initial: { y: "85%" },
      animate: { y: 0 },
      exit: { y: "85%" },
      transition: {
        type: "spring",
        bounce: 0.1,
        duration: 0.6
      }
    }, [f]), { refs: p, context: n } = Nc({
      open: t,
      onOpenChange: e
    });
    return pA(
      /* @__PURE__ */ $t(Pc, { children: t && /* @__PURE__ */ Ve(Ra, { children: [
        /* @__PURE__ */ $t(
          $7t,
          {
            "aria-hidden": "true",
            onClick: (a) => {
              a.stopPropagation(), e == null || e();
            },
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 }
          }
        ),
        /* @__PURE__ */ $t(Vp, { context: n, modal: !0, initialFocus: u, children: /* @__PURE__ */ $t(L7t, { ref: p.setFloating, children: /* @__PURE__ */ Ve(
          N7t,
          {
            ref: l,
            onClick: (a) => a.stopPropagation(),
            role: "dialog",
            "aria-modal": "true",
            initial: g.initial,
            animate: g.animate,
            exit: g.exit,
            transition: g.transition,
            drag: f ? !1 : "y",
            dragConstraints: { top: 0, bottom: 200 },
            dragElastic: 0.1,
            dragSnapToOrigin: !0,
            onDragEnd: (a, d) => o(a, d),
            children: [
              /* @__PURE__ */ $t(
                "div",
                {
                  className: c ? "mt-14 max-h-[calc(85svh-3.5rem)] overflow-y-auto sm:mt-0 sm:max-h-[85svh]" : "",
                  children: r
                }
              ),
              !i && /* @__PURE__ */ $t(
                bn.button,
                {
                  className: "close-button",
                  onClick: e,
                  whileTap: { scale: 0.9 },
                  "aria-label": "Close",
                  children: /* @__PURE__ */ $t(hr, { iconName: "close", color: `${s && "var(--ssui-color-white)"}` })
                }
              )
            ]
          }
        ) }) })
      ] }) }),
      document.getElementById("drawer-root") ?? document.body
    );
  }
), $7t = Wn(bn.div)`
  position: fixed;
  height: 100dvh;
  width: 100dvw;
  top: 0;
  left: 0;
  display: grid;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(1.4px) grayscale(0.8);
`, L7t = Wn.div`
  position: fixed;
  height: 100dvh;
  width: 100dvw;
  top: 0;
  left: 0;
  display: grid;
  pointer-events: none;
`, N7t = Wn(bn.div)`
  --_drag-overflow-aesthetic-height: 20rem;

  position: fixed;
  bottom: calc(var(--_drag-overflow-aesthetic-height) * -1);
  left: 0;
  right: 0;
  overflow: hidden;
  justify-self: stretch;
  align-self: end;
  max-height: calc(85svh + var(--_drag-overflow-aesthetic-height));
  border-radius: 0.5rem 0.5rem 0 0;
  background: var(--ssui-color-white);
  box-shadow: var(--ssui-shadow-lg);

  pointer-events: all;

  // Drag animation overflow aesthetic
  padding-bottom: var(--_drag-overflow-aesthetic-height);

  @media screen and (${zn.min.sm}) {
    position: relative;
    left: unset;
    right: unset;
    bottom: unset;
    max-width: 80dvw;
    max-height: 90dvh;
    border-radius: 0.5rem;
    justify-self: center;
    align-self: center;
    padding-bottom: 0;
  }

  .close-button {
    display: flex;
    position: absolute;
    top: 1rem;
    right: 1rem;
    border: none;
    background: none;
    cursor: pointer;
  }
`;
export {
  q7t as AddProductButton,
  u8t as Alert,
  O8t as AnimateNumber,
  k8t as AnimatedContainerFadeInFromCenter,
  v8t as Autocomplete,
  K7t as BarChart,
  W7t as Button,
  w8t as Checkbox,
  x8t as DatePicker,
  h8t as Dialog,
  T8t as Heading,
  hr as Icon,
  f8t as LogoSpinner,
  M8t as Modal,
  G7t as NavigationButton,
  o8t as PdfViewer,
  S8t as Select,
  C8t as SelectButton,
  p8t as SkeletonCircle,
  g8t as SkeletonRectangle,
  m8t as SkeletonRounded,
  d8t as SkeletonText,
  w9t as Spinner,
  y8t as Stepper,
  A8t as Switch,
  c8t as Table,
  LP as TextInput,
  b8t as Timeline,
  h9t as Tooltip,
  $P as TooltipInfoButton,
  _8t as Typography
};
